(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["dq"] = factory(require("d3"), require("lodash"));
	else
		root["dq"] = factory(root["d3"], root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__3893__, __WEBPACK_EXTERNAL_MODULE__6252__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 3387:
/***/ (function(module) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 8184:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(7574)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(3341)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 8828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(1212)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ 6440:
/***/ (function(module) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ 4228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3305);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 5564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(8270);
var toAbsoluteIndex = __webpack_require__(157);
var toLength = __webpack_require__(1485);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ 1464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(7221);
var toLength = __webpack_require__(1485);
var toAbsoluteIndex = __webpack_require__(157);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 6179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(5052);
var IObject = __webpack_require__(1249);
var toObject = __webpack_require__(8270);
var toLength = __webpack_require__(1485);
var asc = __webpack_require__(5572);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 3606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3305);
var isArray = __webpack_require__(7981);
var SPECIES = __webpack_require__(7574)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 5572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(3606);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 5538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(3387);
var isObject = __webpack_require__(3305);
var invoke = __webpack_require__(4877);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ 4848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(5089);
var TAG = __webpack_require__(7574)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 5089:
/***/ (function(module) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 6197:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var dP = (__webpack_require__(7967).f);
var create = __webpack_require__(4719);
var redefineAll = __webpack_require__(6065);
var ctx = __webpack_require__(5052);
var anInstance = __webpack_require__(6440);
var forOf = __webpack_require__(8790);
var $iterDefine = __webpack_require__(8175);
var step = __webpack_require__(4970);
var setSpecies = __webpack_require__(5762);
var DESCRIPTORS = __webpack_require__(1763);
var fastKey = (__webpack_require__(2988).fastKey);
var validate = __webpack_require__(2888);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 8933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7526);
var $export = __webpack_require__(2127);
var redefine = __webpack_require__(8859);
var redefineAll = __webpack_require__(6065);
var meta = __webpack_require__(2988);
var forOf = __webpack_require__(8790);
var anInstance = __webpack_require__(6440);
var isObject = __webpack_require__(3305);
var fails = __webpack_require__(9448);
var $iterDetect = __webpack_require__(8931);
var setToStringTag = __webpack_require__(3844);
var inheritIfRequired = __webpack_require__(8880);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 6094:
/***/ (function(module) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 7227:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(7967);
var createDesc = __webpack_require__(1996);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 5052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(3387);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 3344:
/***/ (function(module) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 1763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(9448)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 6034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3305);
var document = (__webpack_require__(7526).document);
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 6140:
/***/ (function(module) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 5969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(1311);
var gOPS = __webpack_require__(1060);
var pIE = __webpack_require__(8449);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 2127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7526);
var core = __webpack_require__(6094);
var hide = __webpack_require__(3341);
var redefine = __webpack_require__(8859);
var ctx = __webpack_require__(5052);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 5203:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MATCH = __webpack_require__(7574)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ 9448:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 9228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

__webpack_require__(4116);
var redefine = __webpack_require__(8859);
var hide = __webpack_require__(3341);
var fails = __webpack_require__(9448);
var defined = __webpack_require__(3344);
var wks = __webpack_require__(7574);
var regexpExec = __webpack_require__(9600);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ 1158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4228);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 8790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ctx = __webpack_require__(5052);
var call = __webpack_require__(7368);
var isArrayIter = __webpack_require__(1508);
var anObject = __webpack_require__(4228);
var toLength = __webpack_require__(1485);
var getIterFn = __webpack_require__(762);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ 9461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4556)('native-function-to-string', Function.toString);


/***/ }),

/***/ 7526:
/***/ (function(module) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 7917:
/***/ (function(module) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 3341:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var dP = __webpack_require__(7967);
var createDesc = __webpack_require__(1996);
module.exports = __webpack_require__(1763) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 1308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var document = (__webpack_require__(7526).document);
module.exports = document && document.documentElement;


/***/ }),

/***/ 2956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = !__webpack_require__(1763) && !__webpack_require__(9448)(function () {
  return Object.defineProperty(__webpack_require__(6034)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3305);
var setPrototypeOf = (__webpack_require__(5170).set);
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ 4877:
/***/ (function(module) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ 1249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(5089);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 1508:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(906);
var ITERATOR = __webpack_require__(7574)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ 7981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(5089);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 3305:
/***/ (function(module) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 5411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(3305);
var cof = __webpack_require__(5089);
var MATCH = __webpack_require__(7574)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ 7368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4228);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ 6032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(4719);
var descriptor = __webpack_require__(1996);
var setToStringTag = __webpack_require__(3844);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(3341)(IteratorPrototype, __webpack_require__(7574)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 8175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(2750);
var $export = __webpack_require__(2127);
var redefine = __webpack_require__(8859);
var hide = __webpack_require__(3341);
var Iterators = __webpack_require__(906);
var $iterCreate = __webpack_require__(6032);
var setToStringTag = __webpack_require__(3844);
var getPrototypeOf = __webpack_require__(627);
var ITERATOR = __webpack_require__(7574)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 8931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ITERATOR = __webpack_require__(7574)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ 4970:
/***/ (function(module) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 906:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 2750:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 2988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var META = __webpack_require__(4415)('meta');
var isObject = __webpack_require__(3305);
var has = __webpack_require__(7917);
var setDesc = (__webpack_require__(7967).f);
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(9448)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7526);
var macrotask = (__webpack_require__(2780).set);
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(5089)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ 4258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(3387);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 8206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(1763);
var getKeys = __webpack_require__(1311);
var gOPS = __webpack_require__(1060);
var pIE = __webpack_require__(8449);
var toObject = __webpack_require__(8270);
var IObject = __webpack_require__(1249);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(9448)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 4719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4228);
var dPs = __webpack_require__(1626);
var enumBugKeys = __webpack_require__(6140);
var IE_PROTO = __webpack_require__(766)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(6034)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  (__webpack_require__(1308).appendChild)(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 7967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var anObject = __webpack_require__(4228);
var IE8_DOM_DEFINE = __webpack_require__(2956);
var toPrimitive = __webpack_require__(3048);
var dP = Object.defineProperty;

exports.f = __webpack_require__(1763) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var dP = __webpack_require__(7967);
var anObject = __webpack_require__(4228);
var getKeys = __webpack_require__(1311);

module.exports = __webpack_require__(1763) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 8641:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var pIE = __webpack_require__(8449);
var createDesc = __webpack_require__(1996);
var toIObject = __webpack_require__(7221);
var toPrimitive = __webpack_require__(3048);
var has = __webpack_require__(7917);
var IE8_DOM_DEFINE = __webpack_require__(2956);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(1763) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 4765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(7221);
var gOPN = (__webpack_require__(9415).f);
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 9415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(4561);
var hiddenKeys = (__webpack_require__(6140).concat)('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1060:
/***/ (function(__unused_webpack_module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(7917);
var toObject = __webpack_require__(8270);
var IE_PROTO = __webpack_require__(766)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 4561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(7917);
var toIObject = __webpack_require__(7221);
var arrayIndexOf = __webpack_require__(1464)(false);
var IE_PROTO = __webpack_require__(766)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 1311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(4561);
var enumBugKeys = __webpack_require__(6140);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 8449:
/***/ (function(__unused_webpack_module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2127);
var core = __webpack_require__(6094);
var fails = __webpack_require__(9448);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 3854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(1763);
var getKeys = __webpack_require__(1311);
var toIObject = __webpack_require__(7221);
var isEnum = (__webpack_require__(8449).f);
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 6222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(9415);
var gOPS = __webpack_require__(1060);
var anObject = __webpack_require__(4228);
var Reflect = (__webpack_require__(7526).Reflect);
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ 128:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ 5957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(4228);
var isObject = __webpack_require__(3305);
var newPromiseCapability = __webpack_require__(4258);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 1996:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 6065:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var redefine = __webpack_require__(8859);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ 8859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7526);
var hide = __webpack_require__(3341);
var has = __webpack_require__(7917);
var SRC = __webpack_require__(4415)('src');
var $toString = __webpack_require__(9461);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

(__webpack_require__(6094).inspectSource) = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ 2535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(4848);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ 9600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(1158);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 5170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(3305);
var anObject = __webpack_require__(4228);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(5052)(Function.call, (__webpack_require__(8641).f)(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 5762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7526);
var dP = __webpack_require__(7967);
var DESCRIPTORS = __webpack_require__(1763);
var SPECIES = __webpack_require__(7574)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ 3844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var def = (__webpack_require__(7967).f);
var has = __webpack_require__(7917);
var TAG = __webpack_require__(7574)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 766:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(4556)('keys');
var uid = __webpack_require__(4415);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 4556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var core = __webpack_require__(6094);
var global = __webpack_require__(7526);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(2750) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 9190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4228);
var aFunction = __webpack_require__(3387);
var SPECIES = __webpack_require__(7574)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ 6884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9448);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ 1212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(7087);
var defined = __webpack_require__(3344);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 8942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(5411);
var defined = __webpack_require__(3344);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ 2468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(2127);
var fails = __webpack_require__(9448);
var defined = __webpack_require__(3344);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),

/***/ 629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $export = __webpack_require__(2127);
var defined = __webpack_require__(3344);
var fails = __webpack_require__(9448);
var spaces = __webpack_require__(8451);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ 8451:
/***/ (function(module) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 2780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ctx = __webpack_require__(5052);
var invoke = __webpack_require__(4877);
var html = __webpack_require__(1308);
var cel = __webpack_require__(6034);
var global = __webpack_require__(7526);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(5089)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ 157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(7087);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 7087:
/***/ (function(module) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 7221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(1249);
var defined = __webpack_require__(3344);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 1485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(7087);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 8270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(3344);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 3048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(3305);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 4415:
/***/ (function(module) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 4514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7526);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ 2888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3305);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 5392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7526);
var core = __webpack_require__(6094);
var LIBRARY = __webpack_require__(2750);
var wksExt = __webpack_require__(7960);
var defineProperty = (__webpack_require__(7967).f);
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 7960:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

exports.f = __webpack_require__(7574);


/***/ }),

/***/ 7574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var store = __webpack_require__(4556)('wks');
var uid = __webpack_require__(4415);
var Symbol = (__webpack_require__(7526).Symbol);
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(4848);
var ITERATOR = __webpack_require__(7574)('iterator');
var Iterators = __webpack_require__(906);
module.exports = (__webpack_require__(6094).getIteratorMethod) = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 7762:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2127);

$export($export.P, 'Array', { fill: __webpack_require__(5564) });

__webpack_require__(8184)('fill');


/***/ }),

/***/ 5369:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2127);
var $find = __webpack_require__(6179)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(8184)(KEY);


/***/ }),

/***/ 5144:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2127);
var $find = __webpack_require__(6179)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(8184)(KEY);


/***/ }),

/***/ 3863:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(5052);
var $export = __webpack_require__(2127);
var toObject = __webpack_require__(8270);
var call = __webpack_require__(7368);
var isArrayIter = __webpack_require__(1508);
var toLength = __webpack_require__(1485);
var createProperty = __webpack_require__(7227);
var getIterFn = __webpack_require__(762);

$export($export.S + $export.F * !__webpack_require__(8931)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 5165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(8184);
var step = __webpack_require__(4970);
var Iterators = __webpack_require__(906);
var toIObject = __webpack_require__(7221);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(8175)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 7075:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2127);
var aFunction = __webpack_require__(3387);
var toObject = __webpack_require__(8270);
var fails = __webpack_require__(9448);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(6884)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ 489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var dP = (__webpack_require__(7967).f);
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(1763) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ 3386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(6197);
var validate = __webpack_require__(2888);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(8933)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ 4509:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7526);
var has = __webpack_require__(7917);
var cof = __webpack_require__(5089);
var inheritIfRequired = __webpack_require__(8880);
var toPrimitive = __webpack_require__(3048);
var fails = __webpack_require__(9448);
var gOPN = (__webpack_require__(9415).f);
var gOPD = (__webpack_require__(8641).f);
var dP = (__webpack_require__(7967).f);
var $trim = (__webpack_require__(629).trim);
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(4719)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(1763) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(8859)(global, NUMBER, $Number);
}


/***/ }),

/***/ 4419:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2127);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ 1430:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2127);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(8206) });


/***/ }),

/***/ 8236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(3305);
var meta = (__webpack_require__(2988).onFreeze);

__webpack_require__(923)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ 8647:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(8270);
var $keys = __webpack_require__(1311);

__webpack_require__(923)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 8132:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2127);
$export($export.S, 'Object', { setPrototypeOf: (__webpack_require__(5170).set) });


/***/ }),

/***/ 6517:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(2750);
var global = __webpack_require__(7526);
var ctx = __webpack_require__(5052);
var classof = __webpack_require__(4848);
var $export = __webpack_require__(2127);
var isObject = __webpack_require__(3305);
var aFunction = __webpack_require__(3387);
var anInstance = __webpack_require__(6440);
var forOf = __webpack_require__(8790);
var speciesConstructor = __webpack_require__(9190);
var task = (__webpack_require__(2780).set);
var microtask = __webpack_require__(1384)();
var newPromiseCapabilityModule = __webpack_require__(4258);
var perform = __webpack_require__(128);
var userAgent = __webpack_require__(4514);
var promiseResolve = __webpack_require__(5957);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(7574)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(6065)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(3844)($Promise, PROMISE);
__webpack_require__(5762)(PROMISE);
Wrapper = __webpack_require__(6094)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(8931)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ 2586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2127);
var create = __webpack_require__(4719);
var aFunction = __webpack_require__(3387);
var anObject = __webpack_require__(4228);
var isObject = __webpack_require__(3305);
var fails = __webpack_require__(9448);
var bind = __webpack_require__(5538);
var rConstruct = ((__webpack_require__(7526).Reflect) || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 4116:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(9600);
__webpack_require__(2127)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ 9638:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(1763) && /./g.flags != 'g') (__webpack_require__(7967).f)(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(1158)
});


/***/ }),

/***/ 4040:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4228);
var toLength = __webpack_require__(1485);
var advanceStringIndex = __webpack_require__(8828);
var regExpExec = __webpack_require__(2535);

// @@match logic
__webpack_require__(9228)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 8305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4228);
var toObject = __webpack_require__(8270);
var toLength = __webpack_require__(1485);
var toInteger = __webpack_require__(7087);
var advanceStringIndex = __webpack_require__(8828);
var regExpExec = __webpack_require__(2535);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(9228)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ 341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(5411);
var anObject = __webpack_require__(4228);
var speciesConstructor = __webpack_require__(9190);
var advanceStringIndex = __webpack_require__(8828);
var toLength = __webpack_require__(1485);
var callRegExpExec = __webpack_require__(2535);
var regexpExec = __webpack_require__(9600);
var fails = __webpack_require__(9448);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(9228)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ 8604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

__webpack_require__(9638);
var anObject = __webpack_require__(4228);
var $flags = __webpack_require__(1158);
var DESCRIPTORS = __webpack_require__(1763);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(8859)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(9448)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ 1632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(6197);
var validate = __webpack_require__(2888);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(8933)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 7360:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(2468)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),

/***/ 7083:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(2468)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),

/***/ 8872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2127);
var context = __webpack_require__(8942);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(5203)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 2975:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1212)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(8175)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 9650:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(7526);
var has = __webpack_require__(7917);
var DESCRIPTORS = __webpack_require__(1763);
var $export = __webpack_require__(2127);
var redefine = __webpack_require__(8859);
var META = (__webpack_require__(2988).KEY);
var $fails = __webpack_require__(9448);
var shared = __webpack_require__(4556);
var setToStringTag = __webpack_require__(3844);
var uid = __webpack_require__(4415);
var wks = __webpack_require__(7574);
var wksExt = __webpack_require__(7960);
var wksDefine = __webpack_require__(5392);
var enumKeys = __webpack_require__(5969);
var isArray = __webpack_require__(7981);
var anObject = __webpack_require__(4228);
var isObject = __webpack_require__(3305);
var toObject = __webpack_require__(8270);
var toIObject = __webpack_require__(7221);
var toPrimitive = __webpack_require__(3048);
var createDesc = __webpack_require__(1996);
var _create = __webpack_require__(4719);
var gOPNExt = __webpack_require__(4765);
var $GOPD = __webpack_require__(8641);
var $GOPS = __webpack_require__(1060);
var $DP = __webpack_require__(7967);
var $keys = __webpack_require__(1311);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  (__webpack_require__(9415).f) = gOPNExt.f = $getOwnPropertyNames;
  (__webpack_require__(8449).f) = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(2750)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(3341)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 9087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2127);
var $includes = __webpack_require__(1464)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(8184)('includes');


/***/ }),

/***/ 4614:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2127);
var ownKeys = __webpack_require__(6222);
var toIObject = __webpack_require__(7221);
var gOPD = __webpack_require__(8641);
var createProperty = __webpack_require__(7227);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ 7594:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2127);
var $values = __webpack_require__(3854)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 2820:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(5392)('asyncIterator');


/***/ }),

/***/ 5890:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $iterators = __webpack_require__(5165);
var getKeys = __webpack_require__(1311);
var redefine = __webpack_require__(8859);
var global = __webpack_require__(7526);
var hide = __webpack_require__(3341);
var Iterators = __webpack_require__(906);
var wks = __webpack_require__(7574);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ 2130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.countryToAlpha3 = exports.countryToAlpha2 = void 0;
const latinize_1 = __webpack_require__(1200);
const strings_1 = __webpack_require__(2328);
const alpha2s = __webpack_require__(3702);
const alpha3s = __webpack_require__(1345);
const alpha23s = __webpack_require__(2776);
const names = __webpack_require__(6269);
/**
 * Convert almost anything to an ISO 3166-1 alpha-2 code.
 * @param str String to convert. Note: any is used so we can test non-string values returning null for CommonJS version.
 */
const countryToAlpha2 = (str) => {
    // Check it's a string at least 2 chars long
    if (typeof str !== "string" || str.length < 2) {
        return null;
    }
    const country = (0, strings_1.removeSpaces)((0, strings_1.normalize)((0, latinize_1.latinize)(str)));
    // Too short
    if (country.length < 2) {
        return null;
    }
    // Already ISO 3166 alpha 2
    if (country.length === 2 && alpha2s.includes(country)) {
        return country;
    }
    // Is ISO 3166 alpha 3
    if (country.length === 3 && alpha3s[country]) {
        return alpha3s[country];
    }
    // Exact match
    if (names[country]) {
        return names[country];
    }
    return null;
};
exports.countryToAlpha2 = countryToAlpha2;
/**
 * Convert almost anything to an ISO 3166-1 alpha-3 code.
 * @param str String to convert. Note: any is used so we can test non-string values returning null for CommonJS version.
 */
const countryToAlpha3 = (str) => {
    const alpha2 = (0, exports.countryToAlpha2)(str);
    if (alpha2) {
        return alpha23s[alpha2];
    }
    return null;
};
exports.countryToAlpha3 = countryToAlpha3;


/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.o8 = void 0;
const country_to_code_1 = __webpack_require__(2130);
Object.defineProperty(exports, "o8", ({ enumerable: true, get: function () { return country_to_code_1.countryToAlpha2; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return country_to_code_1.countryToAlpha3; } });


/***/ }),

/***/ 1200:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.latinize = void 0;
const charMap = {
    'Á': 'A',
    'Ă': 'A',
    'Ắ': 'A',
    'Ặ': 'A',
    'Ằ': 'A',
    'Ẳ': 'A',
    'Ẵ': 'A',
    'Ǎ': 'A',
    'Â': 'A',
    'Ấ': 'A',
    'Ậ': 'A',
    'Ầ': 'A',
    'Ẩ': 'A',
    'Ẫ': 'A',
    'Ä': 'A',
    'Ǟ': 'A',
    'Ȧ': 'A',
    'Ǡ': 'A',
    'Ạ': 'A',
    'Ȁ': 'A',
    'À': 'A',
    'Ả': 'A',
    'Ȃ': 'A',
    'Ā': 'A',
    'Ą': 'A',
    'Å': 'A',
    'Ǻ': 'A',
    'Ḁ': 'A',
    'Ⱥ': 'A',
    'Ã': 'A',
    'Ꜳ': 'AA',
    'Æ': 'AE',
    'Ǽ': 'AE',
    'Ǣ': 'AE',
    'Ꜵ': 'AO',
    'Ꜷ': 'AU',
    'Ꜹ': 'AV',
    'Ꜻ': 'AV',
    'Ꜽ': 'AY',
    'Ḃ': 'B',
    'Ḅ': 'B',
    'Ɓ': 'B',
    'Ḇ': 'B',
    'Ƀ': 'B',
    'Ƃ': 'B',
    'Ć': 'C',
    'Č': 'C',
    'Ç': 'C',
    'Ḉ': 'C',
    'Ĉ': 'C',
    'Ċ': 'C',
    'Ƈ': 'C',
    'Ȼ': 'C',
    'Ď': 'D',
    'Ḑ': 'D',
    'Ḓ': 'D',
    'Ḋ': 'D',
    'Ḍ': 'D',
    'Ɗ': 'D',
    'Ḏ': 'D',
    'ǲ': 'D',
    'ǅ': 'D',
    'Đ': 'D',
    'Ð': 'D',
    'Ƌ': 'D',
    'Ǳ': 'DZ',
    'Ǆ': 'DZ',
    'É': 'E',
    'Ĕ': 'E',
    'Ě': 'E',
    'Ȩ': 'E',
    'Ḝ': 'E',
    'Ê': 'E',
    'Ế': 'E',
    'Ệ': 'E',
    'Ề': 'E',
    'Ể': 'E',
    'Ễ': 'E',
    'Ḙ': 'E',
    'Ë': 'E',
    'Ė': 'E',
    'Ẹ': 'E',
    'Ȅ': 'E',
    'È': 'E',
    'Ẻ': 'E',
    'Ȇ': 'E',
    'Ē': 'E',
    'Ḗ': 'E',
    'Ḕ': 'E',
    'Ę': 'E',
    'Ɇ': 'E',
    'Ẽ': 'E',
    'Ḛ': 'E',
    'Ꝫ': 'ET',
    'Ḟ': 'F',
    'Ƒ': 'F',
    'Ǵ': 'G',
    'Ğ': 'G',
    'Ǧ': 'G',
    'Ģ': 'G',
    'Ĝ': 'G',
    'Ġ': 'G',
    'Ɠ': 'G',
    'Ḡ': 'G',
    'Ǥ': 'G',
    'Ḫ': 'H',
    'Ȟ': 'H',
    'Ḩ': 'H',
    'Ĥ': 'H',
    'Ⱨ': 'H',
    'Ḧ': 'H',
    'Ḣ': 'H',
    'Ḥ': 'H',
    'Ħ': 'H',
    'Í': 'I',
    'Ĭ': 'I',
    'Ǐ': 'I',
    'Î': 'I',
    'Ï': 'I',
    'Ḯ': 'I',
    'İ': 'I',
    'Ị': 'I',
    'Ȉ': 'I',
    'Ì': 'I',
    'Ỉ': 'I',
    'Ȋ': 'I',
    'Ī': 'I',
    'Į': 'I',
    'Ɨ': 'I',
    'Ĩ': 'I',
    'Ḭ': 'I',
    'І': 'I',
    'Ꝺ': 'D',
    'Ꝼ': 'F',
    'Ᵹ': 'G',
    'Ꞃ': 'R',
    'Ꞅ': 'S',
    'Ꞇ': 'T',
    'Ꝭ': 'IS',
    'Ĵ': 'J',
    'Ɉ': 'J',
    'Ḱ': 'K',
    'Ǩ': 'K',
    'Ķ': 'K',
    'Ⱪ': 'K',
    'Ꝃ': 'K',
    'Ḳ': 'K',
    'Ƙ': 'K',
    'Ḵ': 'K',
    'Ꝁ': 'K',
    'Ꝅ': 'K',
    'Ĺ': 'L',
    'Ƚ': 'L',
    'Ľ': 'L',
    'Ļ': 'L',
    'Ḽ': 'L',
    'Ḷ': 'L',
    'Ḹ': 'L',
    'Ⱡ': 'L',
    'Ꝉ': 'L',
    'Ḻ': 'L',
    'Ŀ': 'L',
    'Ɫ': 'L',
    'ǈ': 'L',
    'Ł': 'L',
    'Ǉ': 'LJ',
    'Ḿ': 'M',
    'Ṁ': 'M',
    'Ṃ': 'M',
    'Ɱ': 'M',
    'Ń': 'N',
    'Ň': 'N',
    'Ņ': 'N',
    'Ṋ': 'N',
    'Ṅ': 'N',
    'Ṇ': 'N',
    'Ǹ': 'N',
    'Ɲ': 'N',
    'Ṉ': 'N',
    'Ƞ': 'N',
    'ǋ': 'N',
    'Ñ': 'N',
    'Ǌ': 'NJ',
    'Ó': 'O',
    'Ŏ': 'O',
    'Ǒ': 'O',
    'Ô': 'O',
    'Ố': 'O',
    'Ộ': 'O',
    'Ồ': 'O',
    'Ổ': 'O',
    'Ỗ': 'O',
    'Ö': 'O',
    'Ȫ': 'O',
    'Ȯ': 'O',
    'Ȱ': 'O',
    'Ọ': 'O',
    'Ő': 'O',
    'Ȍ': 'O',
    'Ò': 'O',
    'Ỏ': 'O',
    'Ơ': 'O',
    'Ớ': 'O',
    'Ợ': 'O',
    'Ờ': 'O',
    'Ở': 'O',
    'Ỡ': 'O',
    'Ȏ': 'O',
    'Ꝋ': 'O',
    'Ꝍ': 'O',
    'Ō': 'O',
    'Ṓ': 'O',
    'Ṑ': 'O',
    'Ɵ': 'O',
    'Ǫ': 'O',
    'Ǭ': 'O',
    'Ø': 'O',
    'Ǿ': 'O',
    'Õ': 'O',
    'Ṍ': 'O',
    'Ṏ': 'O',
    'Ȭ': 'O',
    'Ƣ': 'OI',
    'Ꝏ': 'OO',
    'Ɛ': 'E',
    'Ɔ': 'O',
    'Ȣ': 'OU',
    'Ṕ': 'P',
    'Ṗ': 'P',
    'Ꝓ': 'P',
    'Ƥ': 'P',
    'Ꝕ': 'P',
    'Ᵽ': 'P',
    'Ꝑ': 'P',
    'Ꝙ': 'Q',
    'Ꝗ': 'Q',
    'Ŕ': 'R',
    'Ř': 'R',
    'Ŗ': 'R',
    'Ṙ': 'R',
    'Ṛ': 'R',
    'Ṝ': 'R',
    'Ȑ': 'R',
    'Ȓ': 'R',
    'Ṟ': 'R',
    'Ɍ': 'R',
    'Ɽ': 'R',
    'Ꜿ': 'C',
    'Ǝ': 'E',
    'Ś': 'S',
    'Ṥ': 'S',
    'Š': 'S',
    'Ṧ': 'S',
    'Ş': 'S',
    'Ŝ': 'S',
    'Ș': 'S',
    'Ṡ': 'S',
    'Ṣ': 'S',
    'Ṩ': 'S',
    'ß': 'ss',
    'Ť': 'T',
    'Ţ': 'T',
    'Ṱ': 'T',
    'Ț': 'T',
    'Ⱦ': 'T',
    'Ṫ': 'T',
    'Ṭ': 'T',
    'Ƭ': 'T',
    'Ṯ': 'T',
    'Ʈ': 'T',
    'Ŧ': 'T',
    'Ɐ': 'A',
    'Ꞁ': 'L',
    'Ɯ': 'M',
    'Ʌ': 'V',
    'Ꜩ': 'TZ',
    'Ú': 'U',
    'Ŭ': 'U',
    'Ǔ': 'U',
    'Û': 'U',
    'Ṷ': 'U',
    'Ü': 'U',
    'Ǘ': 'U',
    'Ǚ': 'U',
    'Ǜ': 'U',
    'Ǖ': 'U',
    'Ṳ': 'U',
    'Ụ': 'U',
    'Ű': 'U',
    'Ȕ': 'U',
    'Ù': 'U',
    'Ủ': 'U',
    'Ư': 'U',
    'Ứ': 'U',
    'Ự': 'U',
    'Ừ': 'U',
    'Ử': 'U',
    'Ữ': 'U',
    'Ȗ': 'U',
    'Ū': 'U',
    'Ṻ': 'U',
    'Ų': 'U',
    'Ů': 'U',
    'Ũ': 'U',
    'Ṹ': 'U',
    'Ṵ': 'U',
    'Ꝟ': 'V',
    'Ṿ': 'V',
    'Ʋ': 'V',
    'Ṽ': 'V',
    'Ꝡ': 'VY',
    'Ẃ': 'W',
    'Ŵ': 'W',
    'Ẅ': 'W',
    'Ẇ': 'W',
    'Ẉ': 'W',
    'Ẁ': 'W',
    'Ⱳ': 'W',
    'Ẍ': 'X',
    'Ẋ': 'X',
    'Ý': 'Y',
    'Ŷ': 'Y',
    'Ÿ': 'Y',
    'Ẏ': 'Y',
    'Ỵ': 'Y',
    'Ỳ': 'Y',
    'Ƴ': 'Y',
    'Ỷ': 'Y',
    'Ỿ': 'Y',
    'Ȳ': 'Y',
    'Ɏ': 'Y',
    'Ỹ': 'Y',
    'Ї': 'YI',
    'Ź': 'Z',
    'Ž': 'Z',
    'Ẑ': 'Z',
    'Ⱬ': 'Z',
    'Ż': 'Z',
    'Ẓ': 'Z',
    'Ȥ': 'Z',
    'Ẕ': 'Z',
    'Ƶ': 'Z',
    'Þ': 'TH',
    'Ĳ': 'IJ',
    'Œ': 'OE',
    'ᴀ': 'A',
    'ᴁ': 'AE',
    'ʙ': 'B',
    'ᴃ': 'B',
    'ᴄ': 'C',
    'ᴅ': 'D',
    'ᴇ': 'E',
    'ꜰ': 'F',
    'ɢ': 'G',
    'ʛ': 'G',
    'ʜ': 'H',
    'ɪ': 'I',
    'ʁ': 'R',
    'ᴊ': 'J',
    'ᴋ': 'K',
    'ʟ': 'L',
    'ᴌ': 'L',
    'ᴍ': 'M',
    'ɴ': 'N',
    'ᴏ': 'O',
    'ɶ': 'OE',
    'ᴐ': 'O',
    'ᴕ': 'OU',
    'ᴘ': 'P',
    'ʀ': 'R',
    'ᴎ': 'N',
    'ᴙ': 'R',
    'ꜱ': 'S',
    'ᴛ': 'T',
    'ⱻ': 'E',
    'ᴚ': 'R',
    'ᴜ': 'U',
    'ᴠ': 'V',
    'ᴡ': 'W',
    'ʏ': 'Y',
    'ᴢ': 'Z',
    'á': 'a',
    'ă': 'a',
    'ắ': 'a',
    'ặ': 'a',
    'ằ': 'a',
    'ẳ': 'a',
    'ẵ': 'a',
    'ǎ': 'a',
    'â': 'a',
    'ấ': 'a',
    'ậ': 'a',
    'ầ': 'a',
    'ẩ': 'a',
    'ẫ': 'a',
    'ä': 'a',
    'ǟ': 'a',
    'ȧ': 'a',
    'ǡ': 'a',
    'ạ': 'a',
    'ȁ': 'a',
    'à': 'a',
    'ả': 'a',
    'ȃ': 'a',
    'ā': 'a',
    'ą': 'a',
    'ᶏ': 'a',
    'ẚ': 'a',
    'å': 'a',
    'ǻ': 'a',
    'ḁ': 'a',
    'ⱥ': 'a',
    'ã': 'a',
    'ꜳ': 'aa',
    'æ': 'ae',
    'ǽ': 'ae',
    'ǣ': 'ae',
    'ꜵ': 'ao',
    'ꜷ': 'au',
    'ꜹ': 'av',
    'ꜻ': 'av',
    'ꜽ': 'ay',
    'ḃ': 'b',
    'ḅ': 'b',
    'ɓ': 'b',
    'ḇ': 'b',
    'ᵬ': 'b',
    'ᶀ': 'b',
    'ƀ': 'b',
    'ƃ': 'b',
    'ɵ': 'o',
    'ć': 'c',
    'č': 'c',
    'ç': 'c',
    'ḉ': 'c',
    'ĉ': 'c',
    'ɕ': 'c',
    'ċ': 'c',
    'ƈ': 'c',
    'ȼ': 'c',
    'ď': 'd',
    'ḑ': 'd',
    'ḓ': 'd',
    'ȡ': 'd',
    'ḋ': 'd',
    'ḍ': 'd',
    'ɗ': 'd',
    'ᶑ': 'd',
    'ḏ': 'd',
    'ᵭ': 'd',
    'ᶁ': 'd',
    'đ': 'd',
    'ɖ': 'd',
    'ƌ': 'd',
    'ð': 'd',
    'ı': 'i',
    'ȷ': 'j',
    'ɟ': 'j',
    'ʄ': 'j',
    'ǳ': 'dz',
    'ǆ': 'dz',
    'é': 'e',
    'ĕ': 'e',
    'ě': 'e',
    'ȩ': 'e',
    'ḝ': 'e',
    'ê': 'e',
    'ế': 'e',
    'ệ': 'e',
    'ề': 'e',
    'ể': 'e',
    'ễ': 'e',
    'ḙ': 'e',
    'ë': 'e',
    'ė': 'e',
    'ẹ': 'e',
    'ȅ': 'e',
    'è': 'e',
    'ẻ': 'e',
    'ȇ': 'e',
    'ē': 'e',
    'ḗ': 'e',
    'ḕ': 'e',
    'ⱸ': 'e',
    'ę': 'e',
    'ᶒ': 'e',
    'ɇ': 'e',
    'ẽ': 'e',
    'ḛ': 'e',
    'ꝫ': 'et',
    'ḟ': 'f',
    'ƒ': 'f',
    'ᵮ': 'f',
    'ᶂ': 'f',
    'ǵ': 'g',
    'ğ': 'g',
    'ǧ': 'g',
    'ģ': 'g',
    'ĝ': 'g',
    'ġ': 'g',
    'ɠ': 'g',
    'ḡ': 'g',
    'ᶃ': 'g',
    'ǥ': 'g',
    'ḫ': 'h',
    'ȟ': 'h',
    'ḩ': 'h',
    'ĥ': 'h',
    'ⱨ': 'h',
    'ḧ': 'h',
    'ḣ': 'h',
    'ḥ': 'h',
    'ɦ': 'h',
    'ẖ': 'h',
    'ħ': 'h',
    'ƕ': 'hv',
    'í': 'i',
    'ĭ': 'i',
    'ǐ': 'i',
    'î': 'i',
    'ï': 'i',
    'ḯ': 'i',
    'ị': 'i',
    'ȉ': 'i',
    'ì': 'i',
    'ỉ': 'i',
    'ȋ': 'i',
    'ī': 'i',
    'į': 'i',
    'ᶖ': 'i',
    'ɨ': 'i',
    'ĩ': 'i',
    'ḭ': 'i',
    'і': 'i',
    'ꝺ': 'd',
    'ꝼ': 'f',
    'ᵹ': 'g',
    'ꞃ': 'r',
    'ꞅ': 's',
    'ꞇ': 't',
    'ꝭ': 'is',
    'ǰ': 'j',
    'ĵ': 'j',
    'ʝ': 'j',
    'ɉ': 'j',
    'ḱ': 'k',
    'ǩ': 'k',
    'ķ': 'k',
    'ⱪ': 'k',
    'ꝃ': 'k',
    'ḳ': 'k',
    'ƙ': 'k',
    'ḵ': 'k',
    'ᶄ': 'k',
    'ꝁ': 'k',
    'ꝅ': 'k',
    'ĺ': 'l',
    'ƚ': 'l',
    'ɬ': 'l',
    'ľ': 'l',
    'ļ': 'l',
    'ḽ': 'l',
    'ȴ': 'l',
    'ḷ': 'l',
    'ḹ': 'l',
    'ⱡ': 'l',
    'ꝉ': 'l',
    'ḻ': 'l',
    'ŀ': 'l',
    'ɫ': 'l',
    'ᶅ': 'l',
    'ɭ': 'l',
    'ł': 'l',
    'ǉ': 'lj',
    'ſ': 's',
    'ẜ': 's',
    'ẛ': 's',
    'ẝ': 's',
    'ḿ': 'm',
    'ṁ': 'm',
    'ṃ': 'm',
    'ɱ': 'm',
    'ᵯ': 'm',
    'ᶆ': 'm',
    'ń': 'n',
    'ň': 'n',
    'ņ': 'n',
    'ṋ': 'n',
    'ȵ': 'n',
    'ṅ': 'n',
    'ṇ': 'n',
    'ǹ': 'n',
    'ɲ': 'n',
    'ṉ': 'n',
    'ƞ': 'n',
    'ᵰ': 'n',
    'ᶇ': 'n',
    'ɳ': 'n',
    'ñ': 'n',
    'ǌ': 'nj',
    'ó': 'o',
    'ŏ': 'o',
    'ǒ': 'o',
    'ô': 'o',
    'ố': 'o',
    'ộ': 'o',
    'ồ': 'o',
    'ổ': 'o',
    'ỗ': 'o',
    'ö': 'o',
    'ȫ': 'o',
    'ȯ': 'o',
    'ȱ': 'o',
    'ọ': 'o',
    'ő': 'o',
    'ȍ': 'o',
    'ò': 'o',
    'ỏ': 'o',
    'ơ': 'o',
    'ớ': 'o',
    'ợ': 'o',
    'ờ': 'o',
    'ở': 'o',
    'ỡ': 'o',
    'ȏ': 'o',
    'ꝋ': 'o',
    'ꝍ': 'o',
    'ⱺ': 'o',
    'ō': 'o',
    'ṓ': 'o',
    'ṑ': 'o',
    'ǫ': 'o',
    'ǭ': 'o',
    'ø': 'o',
    'ǿ': 'o',
    'õ': 'o',
    'ṍ': 'o',
    'ṏ': 'o',
    'ȭ': 'o',
    'ƣ': 'oi',
    'ꝏ': 'oo',
    'ɛ': 'e',
    'ᶓ': 'e',
    'ɔ': 'o',
    'ᶗ': 'o',
    'ȣ': 'ou',
    'ṕ': 'p',
    'ṗ': 'p',
    'ꝓ': 'p',
    'ƥ': 'p',
    'ᵱ': 'p',
    'ᶈ': 'p',
    'ꝕ': 'p',
    'ᵽ': 'p',
    'ꝑ': 'p',
    'ꝙ': 'q',
    'ʠ': 'q',
    'ɋ': 'q',
    'ꝗ': 'q',
    'ŕ': 'r',
    'ř': 'r',
    'ŗ': 'r',
    'ṙ': 'r',
    'ṛ': 'r',
    'ṝ': 'r',
    'ȑ': 'r',
    'ɾ': 'r',
    'ᵳ': 'r',
    'ȓ': 'r',
    'ṟ': 'r',
    'ɼ': 'r',
    'ᵲ': 'r',
    'ᶉ': 'r',
    'ɍ': 'r',
    'ɽ': 'r',
    'ↄ': 'c',
    'ꜿ': 'c',
    'ɘ': 'e',
    'ɿ': 'r',
    'ś': 's',
    'ṥ': 's',
    'š': 's',
    'ṧ': 's',
    'ş': 's',
    'ŝ': 's',
    'ș': 's',
    'ṡ': 's',
    'ṣ': 's',
    'ṩ': 's',
    'ʂ': 's',
    'ᵴ': 's',
    'ᶊ': 's',
    'ȿ': 's',
    'ɡ': 'g',
    'ᴑ': 'o',
    'ᴓ': 'o',
    'ᴝ': 'u',
    'ť': 't',
    'ţ': 't',
    'ṱ': 't',
    'ț': 't',
    'ȶ': 't',
    'ẗ': 't',
    'ⱦ': 't',
    'ṫ': 't',
    'ṭ': 't',
    'ƭ': 't',
    'ṯ': 't',
    'ᵵ': 't',
    'ƫ': 't',
    'ʈ': 't',
    'ŧ': 't',
    'ᵺ': 'th',
    'ɐ': 'a',
    'ᴂ': 'ae',
    'ǝ': 'e',
    'ᵷ': 'g',
    'ɥ': 'h',
    'ʮ': 'h',
    'ʯ': 'h',
    'ᴉ': 'i',
    'ʞ': 'k',
    'ꞁ': 'l',
    'ɯ': 'm',
    'ɰ': 'm',
    'ᴔ': 'oe',
    'ɹ': 'r',
    'ɻ': 'r',
    'ɺ': 'r',
    'ⱹ': 'r',
    'ʇ': 't',
    'ʌ': 'v',
    'ʍ': 'w',
    'ʎ': 'y',
    'ꜩ': 'tz',
    'ú': 'u',
    'ŭ': 'u',
    'ǔ': 'u',
    'û': 'u',
    'ṷ': 'u',
    'ü': 'u',
    'ǘ': 'u',
    'ǚ': 'u',
    'ǜ': 'u',
    'ǖ': 'u',
    'ṳ': 'u',
    'ụ': 'u',
    'ű': 'u',
    'ȕ': 'u',
    'ù': 'u',
    'ủ': 'u',
    'ư': 'u',
    'ứ': 'u',
    'ự': 'u',
    'ừ': 'u',
    'ử': 'u',
    'ữ': 'u',
    'ȗ': 'u',
    'ū': 'u',
    'ṻ': 'u',
    'ų': 'u',
    'ᶙ': 'u',
    'ů': 'u',
    'ũ': 'u',
    'ṹ': 'u',
    'ṵ': 'u',
    'ᵫ': 'ue',
    'ꝸ': 'um',
    'ⱴ': 'v',
    'ꝟ': 'v',
    'ṿ': 'v',
    'ʋ': 'v',
    'ᶌ': 'v',
    'ⱱ': 'v',
    'ṽ': 'v',
    'ꝡ': 'vy',
    'ẃ': 'w',
    'ŵ': 'w',
    'ẅ': 'w',
    'ẇ': 'w',
    'ẉ': 'w',
    'ẁ': 'w',
    'ⱳ': 'w',
    'ẘ': 'w',
    'ẍ': 'x',
    'ẋ': 'x',
    'ᶍ': 'x',
    'ý': 'y',
    'ŷ': 'y',
    'ÿ': 'y',
    'ẏ': 'y',
    'ỵ': 'y',
    'ỳ': 'y',
    'ƴ': 'y',
    'ỷ': 'y',
    'ỿ': 'y',
    'ȳ': 'y',
    'ẙ': 'y',
    'ɏ': 'y',
    'ỹ': 'y',
    'ї': 'yi',
    'ź': 'z',
    'ž': 'z',
    'ẑ': 'z',
    'ʑ': 'z',
    'ⱬ': 'z',
    'ż': 'z',
    'ẓ': 'z',
    'ȥ': 'z',
    'ẕ': 'z',
    'ᵶ': 'z',
    'ᶎ': 'z',
    'ʐ': 'z',
    'ƶ': 'z',
    'ɀ': 'z',
    'þ': 'th',
    'ﬀ': 'ff',
    'ﬃ': 'ffi',
    'ﬄ': 'ffl',
    'ﬁ': 'fi',
    'ﬂ': 'fl',
    'ĳ': 'ij',
    'œ': 'oe',
    'ﬆ': 'st',
    'ₐ': 'a',
    'ₑ': 'e',
    'ᵢ': 'i',
    'ⱼ': 'j',
    'ₒ': 'o',
    'ᵣ': 'r',
    'ᵤ': 'u',
    'ᵥ': 'v',
    'ₓ': 'x',
    'Ё': 'YO',
    'Й': 'I',
    'Ц': 'TS',
    'У': 'U',
    'К': 'K',
    'Е': 'E',
    'Н': 'N',
    'Г': 'G',
    'Ґ': 'G',
    'Ш': 'SH',
    'Щ': 'SCH',
    'З': 'Z',
    'Х': 'H',
    'Ъ': "'",
    'ё': 'yo',
    'й': 'i',
    'ц': 'ts',
    'у': 'u',
    'к': 'k',
    'е': 'e',
    'н': 'n',
    'г': 'g',
    'ґ': 'g',
    'ш': 'sh',
    'щ': 'sch',
    'з': 'z',
    'х': 'h',
    'ъ': "'",
    'Ф': 'F',
    'Ы': 'I',
    'В': 'V',
    'А': 'a',
    'П': 'P',
    'Р': 'R',
    'О': 'O',
    'Л': 'L',
    'Д': 'D',
    'Ж': 'ZH',
    'Э': 'E',
    'ф': 'f',
    'ы': 'i',
    'в': 'v',
    'а': 'a',
    'п': 'p',
    'р': 'r',
    'о': 'o',
    'л': 'l',
    'д': 'd',
    'ж': 'zh',
    'э': 'e',
    'Я': 'Ya',
    'Ч': 'CH',
    'С': 'S',
    'М': 'M',
    'И': 'I',
    'Т': 'T',
    'Ь': "'",
    'Б': 'B',
    'Ю': 'YU',
    'я': 'ya',
    'ч': 'ch',
    'с': 's',
    'м': 'm',
    'и': 'i',
    'т': 't',
    'ь': "'",
    'б': 'b',
    'ю': 'yu'
};
const latinize = function (str) {
    if (typeof str === 'string') {
        return str.replace(/[^A-Za-z0-9]/g, (x) => charMap[x] || x);
    }
    return str;
};
exports.latinize = latinize;


/***/ }),

/***/ 2328:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.removeSpaces = exports.normalize = void 0;
const normalize = function (str) {
    return str.toLocaleUpperCase()
        .replace(/[,\.\(\)]/g, " ")
        // Remove punctuation
        .replace(/['\-]/g, "")
        // Remove unimportant words
        .replace(/(^|\s)OF(\s|$)/gi, " ")
        .replace(/(^|\s)AND(\s|$)/gi, " ")
        .replace(/(^|\s)THE(\s|$)/gi, " ")
        .replace(/(^|\s)&AMP;(\s|$)/gi, " ")
        .replace(/(^|\s)&(\s|$)/gi, " ")
        // Remove excess
        .replace(/\s+/g, " ")
        .trim();
};
exports.normalize = normalize;
const removeSpaces = function (str) {
    return str.replace(/\s/g, "");
};
exports.removeSpaces = removeSpaces;


/***/ }),

/***/ 8259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = __webpack_require__(1354);
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(6314);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index__dq_L2HzA {\n  /* boxplot CSS */\n  /* bullet */\n  /* Hide the points in line chart */\n  /********************\n * SVG CSS\n */\n  /********************\n  Default CSS for an svg element nvd3 used\n*/\n  /********************\n  Box shadow and border radius styling\n*/\n  /**********\n*  Brush\n*/\n  /**********\n*  Legend\n*/\n  /* focus */\n  /* scatter */\n  /* sparkline */\n  /* stacked area */\n  /*\n * this guy needs to go on all dq but not under `*` becuase `*` takes precedence\n * over `inherit` styles that many <text> elements rely on in the charts.\n */\n  /* Hide grid lines in chart */\n  /* Legend Css */\n  /****\nInteractive Layer\n*/\n  /* scatter */\n}\n.index__dq_L2HzA .nvd3 .nv-axis {\n  pointer-events: none;\n  opacity: 1;\n}\n.index__dq_L2HzA .nvd3 .nv-axis path {\n  fill: none;\n  stroke: none;\n  stroke-opacity: 0.75;\n  shape-rendering: crispEdges;\n}\n.index__dq_L2HzA .nvd3 .nv-axis path.domain {\n  stroke-opacity: 0.75;\n}\n.index__dq_L2HzA .nvd3 .nv-axis.nv-x path.domain {\n  stroke-opacity: 0;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-axis .nv-zeroLine,\n.index__dq_L2HzA .nvd3.multiChart .nv-axis .nv-zeroLine,\n.index__dq_L2HzA .nvd3.multiChart .nv-zeroLine .nv-zeroLine,\n.index__dq_L2HzA .nvd3.nv-multiBarHorizontalChart .nv-axis .nv-zeroLine,\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-axis line,\n.index__dq_L2HzA .nvd3.multiChart .nv-axis line,\n.index__dq_L2HzA .nvd3.multiChart .nv-zeroLine line,\n.index__dq_L2HzA .nvd3.nv-multiBarHorizontalChart .nv-axis line {\n  fill: none;\n  shape-rendering: crispEdges;\n  stroke-dasharray: 2, 3;\n  stroke-width: 2px;\n  stroke-linecap: butt;\n}\n.index__dq_L2HzA .nvd3.multiChart .nv-y2:not(.split-axis) .nv-axis .tick line {\n  stroke: #89919A;\n  stroke-opacity: 1;\n  stroke-dasharray: 16, 0;\n  stroke-linecap: round;\n  shape-rendering: auto;\n}\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .index__dq_L2HzA .nvd3 .nv-axis line,\n  .index__dq_L2HzA .nv-zeroLine {\n    shape-rendering: auto;\n    stroke-dasharray: 0, 5;\n    stroke-linecap: round;\n  }\n}\n.index__dq_L2HzA .nv-axis .nv-axislabel,\n.index__dq_L2HzA .nv-axis .nv-axislabel tspan {\n  font-weight: bold;\n  font-size: 14px;\n  fill: #74777A;\n}\n.index__dq_L2HzA .nv-secondaryaxislabel {\n  font-weight: 400;\n  fill: #74777A;\n}\n.index__dq_L2HzA .nvd3.multiChart .nv-y2:not(.split-axis) .nv-axis line {\n  stroke: #272727;\n  stroke-width: 3px;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-y .nv-axis .tick text,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y1 .nv-axis .tick text,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y2 .nv-axis .tick text {\n  align-items: baseline;\n  text-anchor: start !important;\n  fill: #74777A;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-y .nv-axis .tick text,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y1 .nv-axis .tick text,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y2 .nv-axis .tick text,\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-y .nv-axis .tick rect,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y1 .nv-axis .tick rect,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y2 .nv-axis .tick rect {\n  transform: translate(2px, 12px);\n}\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y2:not(.split-axis) .nv-axis .tick text {\n  text-anchor: end !important;\n}\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y2:not(.split-axis) .nv-axis .tick text,\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y2:not(.split-axis) .nv-axis .tick rect {\n  transform: translate(3px, 13px);\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-y .nv-axis .tick:first-child text {\n  display: none;\n}\n.index__dq_L2HzA .nv-tickLabel-y1 .nv-axis .tick:first-of-type,\n.index__dq_L2HzA .nv-tickLabel-y2.split-axis .nv-axis .tick:first-of-type {\n  display: none;\n}\n.index__dq_L2HzA .nvd3 .nv-tickLabel-y1 .nv-axis .tick rect {\n  fill: #FFFFFF;\n  fill-opacity: 0.7;\n}\n.index__dq_L2HzA .nvd3 .nv-axis .nv-axisMaxMin text {\n  font-weight: bold;\n}\n.index__dq_L2HzA .nvd3 .x .nv-axis .nv-axisMaxMin text,\n.index__dq_L2HzA .nvd3 .x2 .nv-axis .nv-axisMaxMin text,\n.index__dq_L2HzA .nvd3 .x3 .nv-axis .nv-axisMaxMin text {\n  text-anchor: middle;\n}\n.index__dq_L2HzA .nvd3 .nv-axis.nv-disabled {\n  opacity: 0;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.subtle-grid .nv-x .nv-axis text,\n.index__dq_L2HzA .nvd3.multiChart .nv-x .nv-axis text,\n.index__dq_L2HzA .nv-multiBarHorizontalChart .nv-x .nv-axis text,\n.index__dq_L2HzA .nv-multiBarHorizontalChart .nv-y .nv-axis text {\n  fill: #74777A;\n}\n.index__dq_L2HzA .nvd3.multiChart .nv-x.alternate-labels .nv-axis .tick:nth-child(even) text {\n  visibility: hidden;\n}\n.index__dq_L2HzA .nvd3 .nv-bars path {\n  fill-opacity: 1;\n  transition: fill-opacity 250ms linear;\n  -moz-transition: fill-opacity 250ms linear;\n  -webkit-transition: fill-opacity 250ms linear;\n}\n.index__dq_L2HzA .nvd3 .nv-bars path.hover {\n  fill-opacity: 0.75;\n}\n.index__dq_L2HzA .nvd3 .nv-bars .hover path {\n  fill: lightblue;\n}\n.index__dq_L2HzA .nvd3 .nv-bars text {\n  fill: rgba(0, 0, 0, 0);\n}\n.index__dq_L2HzA .nvd3 .nv-bars .hover text {\n  fill: #000000;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups path,\n.index__dq_L2HzA .nvd3 .nv-discretebar .nv-groups rect {\n  opacity: 1;\n  fill-opacity: 1;\n  stroke-opacity: 1;\n  transition: opacity 150ms linear;\n  -moz-transition: opacity 150ms linear;\n  -webkit-transition: opacity 150ms linear;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar.interactive .nv-groups:hover path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal.interactive .nv-groups:hover path {\n  opacity: 0.25;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar.interactive .nv-group:not(:only-of-type):hover path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal.interactive .nv-group:not(:only-of-type):hover path,\n.index__dq_L2HzA .nvd3 .nv-multibar.interactive .nv-group:hover path:hover,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal.interactive .nv-group:hover path:hover {\n  opacity: 1;\n}\n.index__dq_L2HzA .nvd3.multiChart .nv-multibar .nv-bar.null {\n  opacity: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group.selected-group .nv-bar,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group.selected-group .nv-bar,\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group.hovered-group .nv-bar,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group.hovered-group .nv-bar {\n  opacity: 0.25;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group.selected-group .nv-bar path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group.selected-group .nv-bar path,\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group.hovered-group .nv-bar path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group.hovered-group .nv-bar path {\n  stroke-width: 2;\n  stroke-opacity: 1;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group .nv-bar.selected-bar,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group .nv-bar.selected-bar,\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group .nv-bar.hovered-bar,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group .nv-bar.hovered-bar {\n  opacity: 1;\n}\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group .nv-bar.selected-bar path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group .nv-bar.selected-bar path,\n.index__dq_L2HzA .nvd3 .nv-multibar .nv-groups .nv-group .nv-bar.hovered-bar path,\n.index__dq_L2HzA .nvd3 .nv-multibarHorizontal .nv-groups .nv-group .nv-bar.hovered-bar path {\n  stroke-width: 6px;\n  stroke-opacity: 0.25;\n}\n.index__dq_L2HzA .bar-text {\n  fill: #74777A;\n  fill-opacity: 1;\n  opacity: 1;\n  stroke-width: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-boxplot circle {\n  fill-opacity: 0.5;\n}\n.index__dq_L2HzA .nvd3 .nv-boxplot circle:hover {\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nvd3 .nv-boxplot rect:hover {\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nvd3 line.nv-boxplot-median {\n  stroke: black;\n}\n.index__dq_L2HzA .nv-boxplot-tick:hover {\n  stroke-width: 2.5px;\n}\n.index__dq_L2HzA .nvd3.nv-bullet {\n  font: 10px sans-serif;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-measure {\n  fill-opacity: 0.8;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-measure:hover {\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-marker {\n  stroke: #000;\n  stroke-width: 2px;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-markerTriangle {\n  stroke: #000;\n  fill: #fff;\n  stroke-width: 1.5px;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-tick line {\n  stroke: #666;\n  stroke-width: 0.5px;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-range.nv-s0 {\n  fill: #eee;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-range.nv-s1 {\n  fill: #ddd;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-range.nv-s2 {\n  fill: #ccc;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-title {\n  font-size: 14px;\n  font-weight: bold;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-subtitle {\n  fill: #999;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-range {\n  fill: #bababa;\n  fill-opacity: 0.4;\n}\n.index__dq_L2HzA .nvd3.nv-bullet .nv-range:hover {\n  fill-opacity: 0.7;\n}\n.index__dq_L2HzA .nvd3 .nv-groups path.nv-line {\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.index__dq_L2HzA .nvd3 .nv-groups path.nv-area {\n  stroke: none;\n}\n.index__dq_L2HzA .nvd3.nv-line .nvd3.nv-scatter .nv-groups .nv-point {\n  stroke-width: 5px;\n  fill-opacity: 0;\n  stroke-opacity: 0;\n  paint-order: stroke;\n}\n.index__dq_L2HzA .nvd3.nv-scatter.nv-single-point .nv-groups .nv-point {\n  fill-opacity: 0.5;\n  stroke-opacity: 0.5;\n}\n.index__dq_L2HzA .with-transitions .nvd3 .nv-groups .nv-point {\n  transition: stroke-width 250ms linear, stroke-opacity 250ms linear;\n  -moz-transition: stroke-width 250ms linear, stroke-opacity 250ms linear;\n  -webkit-transition: stroke-width 250ms linear, stroke-opacity 250ms linear;\n}\n.index__dq_L2HzA .nvd3 .nv-line .nv-scatter .nv-groups .nv-point.always-visible,\n.index__dq_L2HzA .nvd3 .nv-line .nv-groups .nv-point.always-visible {\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nvd3 .nv-line .nv-scatter .nv-groups .nv-point.hover,\n.index__dq_L2HzA .nvd3 .nv-line .nv-scatter .nv-groups .nv-point.selected,\n.index__dq_L2HzA .nvd3 .nv-line .nv-groups .nv-point.hover {\n  fill-opacity: 1;\n  stroke-opacity: 0.25;\n}\n.index__dq_L2HzA .nvd3 .nv-point-paths path {\n  stroke: #aaa;\n  stroke-opacity: 0;\n  fill: #eee;\n  fill-opacity: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-indexLine {\n  cursor: ew-resize;\n}\n.index__dq_L2HzA .nvd3 .nv-line text.data-points {\n  fill: grey;\n  fill-opacity: 1;\n  stroke: none;\n  font-size: 12px;\n}\n.index__dq_L2HzA .nvd3 .nv-line-label text {\n  fill: #32363A;\n  fill-opacity: 1;\n  stroke-width: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-line-label rect {\n  fill: white;\n  fill-opacity: 0.7;\n}\n.index__dq_L2HzA svg.nvd3-svg {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.index__dq_L2HzA .nvtooltip.with-3d-shadow,\n.index__dq_L2HzA .with-3d-shadow .nvtooltip {\n  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n.index__dq_L2HzA .nvd3 text,\n.index__dq_L2HzA .nvd3 text tspan {\n  font-weight: normal;\n}\n.index__dq_L2HzA .nvd3 .title {\n  font: bold 14px Arial;\n}\n.index__dq_L2HzA .nvd3 .nv-background {\n  fill: white;\n  fill-opacity: 0;\n}\n.index__dq_L2HzA .nvd3.nv-noData {\n  font-size: 18px;\n  font-weight: bold;\n}\n.index__dq_L2HzA .nv-brush .extent {\n  fill-opacity: 0.125;\n  shape-rendering: crispEdges;\n}\n.index__dq_L2HzA .nv-brush .resize path {\n  fill: #eee;\n  stroke: #666;\n}\n.index__dq_L2HzA .nvd3 .nv-legend .nv-series {\n  cursor: pointer;\n}\n.index__dq_L2HzA .nvd3 .nv-legend .nv-disabled circle {\n  fill-opacity: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-brush .extent {\n  fill-opacity: 0 !important;\n}\n.index__dq_L2HzA .nvd3 .nv-brushBackground rect {\n  stroke: #000;\n  stroke-width: 0.4;\n  fill: #fff;\n  fill-opacity: 0.7;\n}\n.index__dq_L2HzA .nvd3 .nv-groups .nv-point.hover {\n  stroke-width: 20px;\n  stroke-opacity: 0.5;\n}\n.index__dq_L2HzA .nvd3 .nv-scatter .nv-point.hover {\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nv-noninteractive {\n  pointer-events: none;\n}\n.index__dq_L2HzA .nv-distx,\n.index__dq_L2HzA .nv-disty {\n  pointer-events: none;\n}\n.index__dq_L2HzA .nvd3 .nv-scatter g.data-points text {\n  fill: #a4a4a4;\n  stroke: none;\n  font-size: 14px;\n}\n.index__dq_L2HzA .nvd3 .nv-scatter g.data-points text.hover {\n  fill: #222222;\n  opacity: 1;\n}\n.index__dq_L2HzA #dataPointSymbol {\n  font-family: Qualtrics Icons, sans-serif;\n}\n.index__dq_L2HzA .nv-scatterChart .nv-axis path {\n  fill: #272727;\n  stroke: #272727;\n}\n.index__dq_L2HzA .nvd3 .nv-scatter g.data-points rect {\n  stroke: none;\n  fill: white;\n  opacity: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-line .nv-scatter g.data-points text {\n  fill: #808080;\n  font-size: 12px;\n  fill: grey;\n  fill-opacity: 1;\n  stroke: none;\n}\n.index__dq_L2HzA .nvd3 .nv-line .nv-scatter g.data-points rect {\n  fill-opacity: 1;\n  opacity: 0.7;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-axis.nv-x path.domain {\n  stroke-opacity: 0.75;\n}\n.index__dq_L2HzA .nvd3 .nv-scatterWrap .nv-scatter .nv-groups .nv-group.hovered-group .nv-point {\n  stroke-width: 0;\n  stroke-opacity: 0;\n}\n.index__dq_L2HzA .nvd3 .nv-scatterWrap .nv-scatter .nv-groups .nv-group .nv-point.hovered-data {\n  stroke-width: 4px;\n  stroke-opacity: 0.24;\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nvd3.nv-sparkline path {\n  fill: none;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus g.nv-hoverValue {\n  pointer-events: none;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-hoverValue line {\n  stroke: #333;\n  stroke-width: 1.5px;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus,\n.index__dq_L2HzA .nvd3.nv-sparklineplus g {\n  pointer-events: all;\n}\n.index__dq_L2HzA .nvd3 .nv-hoverArea {\n  fill-opacity: 0;\n  stroke-opacity: 0;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-xValue,\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-yValue {\n  stroke-width: 0;\n  font-size: 0.9em;\n  font-weight: normal;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-yValue {\n  stroke: #f66;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-maxValue {\n  stroke: #2ca02c;\n  fill: #2ca02c;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-minValue {\n  stroke: #d62728;\n  fill: #d62728;\n}\n.index__dq_L2HzA .nvd3.nv-sparklineplus .nv-currentValue {\n  font-weight: bold;\n  font-size: 1.1em;\n}\n.index__dq_L2HzA .nvd3.nv-stackedarea path.nv-area {\n  fill-opacity: 0.75;\n  stroke-opacity: 0;\n  transition: fill-opacity 250ms linear, stroke-opacity 250ms linear;\n  -moz-transition: fill-opacity 250ms linear, stroke-opacity 250ms linear;\n  -webkit-transition: fill-opacity 250ms linear, stroke-opacity 250ms linear;\n}\n.index__dq_L2HzA .nvd3.nv-stackedarea path.nv-line {\n  fill: none;\n  stroke-opacity: 1;\n}\n.index__dq_L2HzA .nvd3.nv-stackedarea .nv-groups .nv-point:not(.hover) {\n  fill: white;\n}\n.index__dq_L2HzA .nvd3.nv-stackedarea path.nv-area.hover {\n  fill-opacity: 0.6;\n}\n.index__dq_L2HzA .nvd3.nv-stackedarea .nv-groups .nv-point {\n  stroke-opacity: 1;\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .nvd3 .nv-line .nv-line-label {\n  transition: all 0.15s;\n}\n.index__dq_L2HzA .nvd3 .nv-line .nv-group {\n  transition: all 0.15s;\n}\n.index__dq_L2HzA .nv-line-label {\n  cursor: pointer;\n}\n.index__dq_L2HzA .line-focused .nv-group:not(.focused) {\n  opacity: 0.2;\n  stroke-opacity: 0.2;\n  fill-opacity: 0.2;\n}\n.index__dq_L2HzA .line-selected > .nv-groups .nv-group {\n  opacity: 0.2;\n  stroke-opacity: 0.2;\n  fill-opacity: 0.2;\n}\n.index__dq_L2HzA .line-focused .nv-line-label:not(.focused),\n.index__dq_L2HzA .line-selected .nv-line-label:not(.selected) {\n  opacity: 0.2;\n  stroke-opacity: 0.2;\n  fill-opacity: 0.2;\n}\n.index__dq_L2HzA .line-selected .nv-line-label.selected .nv-background,\n.index__dq_L2HzA .line-focused .nv-line-label.focused .nv-background {\n  fill-opacity: 1;\n  fill: inherit;\n}\n.index__dq_L2HzA .line-selected .nv-line-label.selected .label-text,\n.index__dq_L2HzA .line-focused .nv-line-label.focused .label-text {\n  fill: #FFF;\n}\n.index__dq_L2HzA .bar-container {\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.index__dq_L2HzA .bar {\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  top: 50%;\n  position: absolute;\n  overflow: visible;\n  width: 100%;\n  height: 24px;\n}\n.index__dq_L2HzA .bar.responsive {\n  top: 50%;\n}\n.index__dq_L2HzA .bar.horizontal {\n  white-space: nowrap;\n}\n.index__dq_L2HzA .bar.horizontal.responsive {\n  height: calc(100% * (2 / 3));\n  max-height: 800px;\n}\n.index__dq_L2HzA .bar.vertical {\n  transform: translateX(-50%);\n  -webkit-transform: translateX(-50%);\n  top: 0;\n  left: 50%;\n  overflow: visible;\n  width: 24px;\n  height: 100%;\n}\n.index__dq_L2HzA .bar.vertical.responsive {\n  width: calc(100% * (2 / 3));\n  max-width: 800px;\n}\n.index__dq_L2HzA .bar.horizontal.responsive-full {\n  height: 100%;\n}\n.index__dq_L2HzA .bar.vertical.responsive-full {\n  width: 100%;\n}\n.index__dq_L2HzA .bar-section {\n  display: inline-block;\n  position: relative;\n  outline: none;\n  border-right: solid 1px white;\n}\n.index__dq_L2HzA .bar-section:first-child {\n  border-radius: 2px 0 0 2px;\n}\n.index__dq_L2HzA .bar-section:last-child {\n  border-radius: 0 2px 2px 0;\n  border-right: none;\n}\n.index__dq_L2HzA .bar-section:first-child:last-child {\n  border-radius: 2px;\n}\n.index__dq_L2HzA .vertical .bar-section {\n  display: block;\n  border-bottom: solid 1px white;\n}\n.index__dq_L2HzA .vertical .bar-section:first-child {\n  border-radius: 2px 2px 0 0;\n}\n.index__dq_L2HzA .vertical .bar-section:last-child {\n  border-radius: 0 0 2px 2px;\n  border-bottom: none;\n}\n.index__dq_L2HzA .legend-container {\n  transition: height 0.1s ease-out;\n  overflow: visible;\n  width: 100%;\n}\n.index__dq_L2HzA .legend-container.disable-animation {\n  transition: height 0s;\n}\n.index__dq_L2HzA .legend-container text {\n  fill: #707070;\n}\n.index__dq_L2HzA .legend-container.disabled {\n  display: none;\n}\n.index__dq_L2HzA .bar-label {\n  padding-left: 8px;\n  padding-right: 8px;\n  transition: opacity 0.1s ease-out;\n  font-weight: 400;\n  font-size: 12px;\n  white-space: nowrap;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -34px);\n  -webkit-transform: translate(-50%, -34px);\n  position: absolute;\n  color: #707070;\n}\n.index__dq_L2HzA .vertical .bar-label {\n  position: absolute;\n  padding: 0;\n  color: #707070;\n  text-shadow: none;\n  margin-left: 16px;\n  top: 50%;\n  left: 100% !important;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n}\n.index__dq_L2HzA .horizontal.responsive-full .bar-label {\n  color: #000;\n}\n.index__dq_L2HzA .vertical.responsive-full .bar-label {\n  left: 50% !important;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  color: #000;\n}\n.index__dq_L2HzA .vertical.responsive-full .dark-fill .bar-label,\n.index__dq_L2HzA .horizontal.responsive-full .dark-fill .bar-label {\n  color: #fff;\n}\n.index__dq_L2HzA {\n  font-size: 12px;\n  font-family: arial;\n}\n.index__dq_L2HzA .nvd3.nv-pieChart .nv-legend .nv-series {\n  cursor: default;\n}\n.index__dq_L2HzA .hidden-grid-line .nvd3 .nv-axis line {\n  stroke: none;\n  fill: none;\n}\n.index__dq_L2HzA .nvd3 .nv-axis line,\n.index__dq_L2HzA .nvd3 .nv-zeroLine line {\n  stroke: #000;\n  stroke-opacity: 0.09;\n}\n.index__dq_L2HzA .dq-legend g {\n  pointer-events: all;\n  cursor: pointer;\n  opacity: 1;\n}\n.index__dq_L2HzA .dq-legend g.disabled rect {\n  fill-opacity: 0;\n}\n.index__dq_L2HzA .dq-legend g.disabled circle {\n  fill-opacity: 0;\n}\n.index__dq_L2HzA .dq-legend .click-disabled {\n  cursor: auto;\n  pointer-events: none;\n}\n.index__dq_L2HzA .dq-legend text {\n  font-weight: normal;\n  font-size: 12px;\n}\n.index__dq_L2HzA .dq-legend .dq-legend-title text {\n  font-weight: 600;\n  font-size: 14px;\n}\n.index__dq_L2HzA .dq-legend .dq-legend-element:focus {\n  outline-offset: 5px;\n}\n.index__dq_L2HzA .dq-line path {\n  stroke-width: 1.5px;\n  fill: none;\n}\n.index__dq_L2HzA .smart-labels {\n  fill: #272727;\n}\n.index__dq_L2HzA .smart-labels.light-label-color {\n  fill: #ffffff;\n}\n.index__dq_L2HzA .smart-labels .main-label {\n  fill: #32363A;\n  font-weight: bold;\n}\n.index__dq_L2HzA .smart-labels .numerical-label {\n  fill: #74777a;\n  font-weight: normal;\n}\n.index__dq_L2HzA .nvd3 .nv-interactiveGuideLine {\n  pointer-events: none;\n}\n.index__dq_L2HzA .nvd3 line.nv-guideline {\n  stroke: #222222;\n  stroke-opacity: 1;\n  stroke-dasharray: 0, 5;\n  stroke-width: 2;\n  stroke-linecap: round;\n  shape-rendering: auto;\n}\n.index__dq_L2HzA .hidden {\n  visibility: hidden;\n}\n.index__dq_L2HzA .no-display {\n  display: none;\n}\n.index__dq_L2HzA .nv-line text.data-points.hide-text {\n  fill: transparent;\n}\n.index__dq_L2HzA .focusable-comparison {\n  cursor: pointer;\n}\n.index__dq_L2HzA .focusable-comparison:focus:not(:focus-visible) {\n  outline: none;\n}\n.index__dq_L2HzA .gauge text {\n  text-anchor: middle;\n  font-weight: 300;\n  transition: opacity 0.1s ease-out;\n}\n.index__dq_L2HzA .round-gauge text.round-gauge-number {\n  font-weight: 300;\n  fill: #32363a;\n}\n.index__dq_L2HzA .round-gauge text.round-gauge-field-label {\n  font-weight: 700;\n  fill: #74777a;\n}\n.index__dq_L2HzA .round-gauge text.round-gauge-threshold-label {\n  font-weight: 400;\n  fill: #74777a;\n}\n.index__dq_L2HzA .round-gauge text.round-gauge-minimum-threshold-label {\n  font-weight: 400;\n  fill: #74777a;\n}\n.index__dq_L2HzA .pieContainer .sliceContainer path.arc {\n  -webkit-transition: fill-opacity 250ms linear, stroke-width 250ms linear, stroke-opacity 250ms linear;\n  transition: fill-opacity 250ms linear, stroke-width 250ms linear, stroke-opacity 250ms linear;\n  stroke-width: 1px;\n  stroke-opacity: 1;\n}\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer:hover path.arc,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.selected path.arc,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.group-hover path.arc {\n  fill-opacity: 0.25;\n}\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer:hover path.arc:hover,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.selected path.arc:hover,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.group-hover path.arc:hover,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer:hover path.arc.selected,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.selected path.arc.selected,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.group-hover path.arc.selected,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer:hover path.arc.group-hover,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.selected path.arc.group-hover,\n.index__dq_L2HzA .pieContainer.interactive .sliceContainer.group-hover path.arc.group-hover {\n  fill-opacity: 1;\n}\n.index__dq_L2HzA .pieContainer polyline.labelLines {\n  stroke: #000000;\n  stroke-width: 1px;\n  fill: none;\n}\n.index__dq_L2HzA .dq-reference-line-container .reference-line {\n  shape-rendering: crispEdges;\n}\n.index__dq_L2HzA .quadrant-label {\n  font-size: 14px;\n  fill: #32363A;\n  font-weight: bold;\n}\n.index__dq_L2HzA .quadrant-label tspan {\n  font-family: '72';\n  font-weight: bold;\n}\n.index__dq_L2HzA .axis-label tspan {\n  font-family: '72';\n  font-size: 12px;\n  font-weight: semibold;\n  fill: #6A6D70;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.nv-scatter .nv-point,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-scatter .nv-point,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-groups .nv-point {\n  stroke-width: 0;\n  stroke-opacity: 0 !important;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.nv-scatter .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-scatter .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-groups .nv-point.hover {\n  stroke-width: 8px;\n  stroke-opacity: 0.24 !important;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.nv-scatter.bubble .nv-point,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-scatter.bubble .nv-point,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-groups.bubble .nv-point {\n  fill-opacity: 0.5;\n  stroke-width: 2px;\n  stroke-opacity: 1 !important;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.nv-scatter.bubble:hover .nv-point,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-scatter.bubble:hover .nv-point,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-groups.bubble:hover .nv-point {\n  opacity: 0.5;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart.nv-scatter.bubble:hover .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-scatter.bubble:hover .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-groups.bubble:hover .nv-point.hover {\n  stroke-width: 5px;\n  stroke-opacity: 1 !important;\n  opacity: 1;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-sectionLabels {\n  pointer-events: none;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-sectionLabels text {\n  fill: #74777A;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-sectionLabels .nv-sectionLabel {\n  fill-opacity: 0.6;\n  fill: white;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart .nv-sectionBorders {\n  stroke: #74777A;\n  stroke-width: 2px;\n  stroke-dasharray: 2,3;\n}\n.index__dq_L2HzA .nvd3.nv-scatterChart #dataPointText.outline-text {\n  stroke: white;\n  stroke-width: 2px;\n  paint-order: stroke;\n  stroke-opacity: 0.8;\n}\n.index__dq_L2HzA .nvd3.nv-line.nv-scatter .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-stackedarea.nv-scatter .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-line .nv-scatter .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-stackedarea .nv-scatter .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-line .nv-groups .nv-point.hover,\n.index__dq_L2HzA .nvd3.nv-stackedarea .nv-groups .nv-point.hover {\n  stroke-width: 8px;\n  stroke-opacity: 0.24 !important;\n}\n.index__dq_L2HzA #dataPointText {\n  fill: #74777a;\n}\n.index__dq_L2HzA.infinite-horizontal-grid .dq-reference-line-container .horizontal-reference-line,\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-y1.nv-axis line,\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-y.nv-axis line {\n  transform: translateX(-100%) scaleX(10);\n  stroke-dasharray: 0.2, 0.3;\n}\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-y1.nv-axis text,\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-y2.nv-axis text,\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-y.nv-axis text {\n  text-shadow: 0px 5px 0px #fff, 0px -5px 0px #fff, 5px 0px 0px #fff, -5px 0px 0px #fff, 0px 4px 0px #fff, 0px -4px 0px #fff, 4px 0px 0px #fff, -4px 0px 0px #fff, 0px 3px 0px #fff, 0px -3px 0px #fff, 3px 0px 0px #fff, -3px 0px 0px #fff, 0px 3px 0px #fff, 0px -3px 0px #fff, 3px 0px 0px #fff, -3px 0px 0px #fff, 0px 2px 0px #fff, 0px -2px 0px #fff, 2px 0px 0px #fff, -2px 0px 0px #fff, 0px 1px 0px #fff, 0px -1px 0px #fff, 1px 0px 0px #fff, -1px 0px 0px #fff;\n}\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-x1.nv-axis path.domain,\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-x2.nv-axis path.domain,\n.index__dq_L2HzA.infinite-horizontal-grid .nvd3 .nv-axis.nv-x path.domain {\n  stroke-opacity: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.8);\n  color: #000000;\n  padding: 1px;\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  z-index: 10000;\n  display: block;\n  font-family: Arial;\n  font-size: 13px;\n  text-align: left;\n  pointer-events: none;\n  white-space: nowrap;\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.width-transitions {\n  transition: opacity 50ms linear;\n  transition-delay: 200ms;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.x-nvtooltip,\n.index__dqTooltip_WQ9o0.nvtooltip.y-nvtooltip {\n  padding: 8px;\n}\n.index__dqTooltip_WQ9o0.nvtooltip h3 {\n  margin: 0;\n  padding: 4px 14px;\n  line-height: 18px;\n  font-weight: normal;\n  background-color: rgba(247, 247, 247, 0.75);\n  color: #000000;\n  text-align: center;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip p {\n  margin: 0;\n  padding: 5px 14px;\n  text-align: center;\n}\n.index__dqTooltip_WQ9o0.nvtooltip span {\n  display: inline-block;\n  margin: 2px 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table {\n  margin: 6px;\n  border-spacing: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table td {\n  padding: 2px 9px 2px 0;\n  vertical-align: middle;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table td.key {\n  font-weight: normal;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table td.key.total {\n  font-weight: bold;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table td.value {\n  text-align: right;\n  font-weight: bold;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table tr.highlight td {\n  padding: 1px 9px 1px 0;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table td.legend-color-guide div {\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n}\n.index__dqTooltip_WQ9o0.nvtooltip table td.legend-color-guide div {\n  width: 12px;\n  height: 12px;\n  border: 1px solid #999;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .footer {\n  padding: 3px;\n  text-align: center;\n}\n.index__dqTooltip_WQ9o0.nvtooltip-pending-removal {\n  pointer-events: none;\n  display: none;\n}\n.index__dqTooltip_WQ9o0.nvtooltip {\n  background: transparent;\n  border: none;\n  padding: 0;\n  /* tooltip is on left or right of mouse, worst-case scenario has < 50% of screen */\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog {\n  background: rgba(0, 0, 0, 0.8);\n  margin: 0;\n  padding: 16px;\n  border-radius: 3px;\n  color: #fff;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog .tooltip-label {\n  line-height: 12px;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog::after {\n  content: '';\n  position: absolute;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table {\n  margin: 0;\n  min-width: 100%;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr th,\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr td {\n  color: #fff;\n  padding: 0 8px 8px 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr:last-child th,\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr:last-child td {\n  padding-bottom: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr td:last-child,\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr th:last-child {\n  padding-right: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr.tooltip-data th {\n  font-weight: 200;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr.tooltip-data td {\n  font-weight: 400;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .dark-dialog table tr.tooltip-data th + td:last-child {\n  text-align: right;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .color-icon {\n  position: relative;\n  top: 4px;\n  width: 15px;\n  height: 15px;\n  border: 1px solid #fff;\n  margin-right: 5px;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .tooltip-data em {\n  opacity: 0.7;\n}\n.index__dqTooltip_WQ9o0.nvtooltip .active.tooltip-data em {\n  opacity: 1;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-s,\n.index__dqTooltip_WQ9o0.nvtooltip.nv-n,\n.index__dqTooltip_WQ9o0.nvtooltip.nv-e,\n.index__dqTooltip_WQ9o0.nvtooltip.nv-w {\n  max-width: 45%;\n  white-space: normal;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-w .dark-dialog::after,\n.index__dqTooltip_WQ9o0.nvtooltip.nv-e .dark-dialog::after {\n  top: calc(50%);\n  border-color: transparent rgba(0, 0, 0, 0.8);\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-n .dark-dialog::after,\n.index__dqTooltip_WQ9o0.nvtooltip.nv-s .dark-dialog::after {\n  left: calc(50%);\n  border-color: rgba(0, 0, 0, 0.8) transparent;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-w .dark-dialog::after {\n  left: -6px;\n  border-left-width: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-e .dark-dialog::after {\n  right: -6px;\n  border-right-width: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-n .dark-dialog::after {\n  top: -6px;\n  border-top-width: 0;\n}\n.index__dqTooltip_WQ9o0.nvtooltip.nv-s .dark-dialog::after {\n  bottom: -6px;\n  border-bottom-width: 0;\n}\n.index__dqMap_UDVdx .map-container {\n  position: relative;\n}\n.index__dqMap_UDVdx .mapboxgl-map {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n}\n.index__dqMap_UDVdx .legend-container-inside {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  background-color: #fff;\n  padding: 10px;\n  margin: 0;\n  box-sizing: border-box;\n}\n.index__dqMap_UDVdx .home-button-container {\n  background-color: #fff;\n}\n.index__dqMap_UDVdx .home-button {\n  height: 29px;\n  width: 29px;\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n  border: 0;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  outline: none;\n  overflow: hidden;\n  border-radius: 4px;\n  padding: 0;\n  background: transparent;\n}\n.index__dqMap_UDVdx .home-button:hover {\n  background-color: #000000;\n}\n", "",{"version":3,"sources":["webpack://./src/less/index.less","webpack://./src/less/nv/axis.less","webpack://./src/less/nv/bars.less","webpack://./src/less/nv/boxplot.less","webpack://./src/less/nv/bullet.less","webpack://./src/less/nv/lines.less","webpack://./src/less/nv/main.less","webpack://./src/less/nv/scatter.less","webpack://./src/less/nv/sparkline.less","webpack://./src/less/nv/stackedarea.less","webpack://./src/less/nv/lineHighlighter.less","webpack://./src/less/breakdownbar.less","webpack://./src/less/common.less","webpack://./src/less/comparisons.less","webpack://./src/less/gauge.less","webpack://./src/less/round-gauge.less","webpack://./src/less/pie.less","webpack://./src/less/reference-line.less","webpack://./src/less/quadrant-label.less","webpack://./src/less/axis-labels.less","webpack://./src/less/scatter-chart.less","webpack://./src/less/infinite-grid.less","webpack://./src/less/nv/tooltip.less","webpack://./src/less/dark_dialog.less","webpack://./src/less/map.less"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC;;EAEA;EACA;;CAED;EACC;;CAED;EACC;;CAED;EACC;;CAED;EACC,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB;;;EAGA;EACA,6BAA6B;EAC7B,eAAe;EACf;;CAED;EACC,YAAY;AACd;AAjCA;ECGC,oBAAA;EACA,UAAA;ADiCD;AArCA;ECQC,UAAA;EACA,YAAA;EACA,oBAAA;EACA,2BAAA;ADgCD;AA3CA;ECeC,oBAAA;AD+BD;AA9CA;ECmBC,iBAAA;AD8BD;AAjDA;;;;;;;;EC6BE,UAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;AD8BF;AA/DA;ECsCC,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;AD4BD;ACvBA;EAAA;;IAKE,qBAAA;IACA,sBAAA;IACA,qBAAA;EDuBA;AACF;AA9EA;;EC4DC,iBAAA;EACA,eAAA;EACA,aAAA;ADsBD;AApFA;ECkEC,gBAAA;EACA,aAAA;ADqBD;AAxFA;ECuEC,eAAA;EACA,iBAAA;ADoBD;AA5FA;;;ECgFG,qBAAA;EACA,6BAAA;EACA,aAAA;ADiBH;AAnGA;;;;;;ECuFO,+BAAA;ADoBP;AA3GA;EC6FE,2BAAA;ADiBF;AA9GA;;ECkGE,+BAAA;ADgBF;AAlHA;ECyGE,aAAA;ADYF;AArHA;;ECiHE,aAAA;ADQF;AAzHA;ECsHC,aAAA;EACA,iBAAA;ADMD;AA7HA;EC2HC,iBAAA;ADKD;AAhIA;;;ECiIC,mBAAA;ADID;AArIA;ECqIC,UAAA;ADGD;AAxIA;;;;EC4IC,aAAA;ADED;AA9IA;ECgJC,kBAAA;ADCD;AAjJA;EEGC,eAAA;EAEA,qCAAA;EACA,0CAAA;EACA,6CAAA;AFgJD;AAvJA;EEWC,kBAAA;AF+ID;AA1JA;EEeC,eAAA;AF8ID;AA7JA;EEmBC,sBAAA;AF6ID;AAhKA;EEuBC,aAAA;AF4ID;AAnKA;;;EE6BC,UAAA;EACA,eAAA;EACA,iBAAA;EAEA,gCAAA;EACA,qCAAA;EACA,wCAAA;AF0ID;AA7KA;;EE0CE,aAAA;AFuIF;AAjLA;;;;EE+CE,UAAA;AFwIF;AAvLA;EEoDC,UAAA;AFsID;AA1LA;;;;EE2DC,aAAA;AFqID;AAhMA;;;;EE8DE,eAAA;EACA,iBAAA;AFwIF;AAvMA;;;;EEuEC,UAAA;AFsID;AA7MA;;;;EE0EE,iBAAA;EACA,oBAAA;AFyIF;AApNA;EEiFC,aAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AFsID;AA1NA;EGEC,iBAAA;AH2ND;AA7NA;EGMC,eAAA;AH0ND;AAhOA;EGUC,eAAA;AHyND;AAnOA;EGcC,aAAA;AHwND;AAtOA;EGkBC,mBAAA;AHuND;AAzOA;EIEC,qBAAA;AJ0OD;AA5OA;EIKC,iBAAA;AJ0OD;AA/OA;EIQC,eAAA;AJ0OD;AAlPA;EIWC,YAAA;EACA,iBAAA;AJ0OD;AAtPA;EIeC,YAAA;EACA,UAAA;EACA,mBAAA;AJ0OD;AA3PA;EIoBC,YAAA;EACA,mBAAA;AJ0OD;AA/PA;EIwBC,UAAA;AJ0OD;AAlQA;EI2BC,UAAA;AJ0OD;AArQA;EI8BC,UAAA;AJ0OD;AAxQA;EIiCC,eAAA;EACA,iBAAA;AJ0OD;AA5QA;EIqCC,UAAA;AJ0OD;AA/QA;EIyCC,aAAA;EACA,iBAAA;AJyOD;AAnRA;EI6CC,iBAAA;AJyOD;AAtRA;EKGC,UAAA;EACA,qBAAA;EACA,sBAAA;ALsRD;AA3RA;EKSC,YAAA;ALqRD;AA9RA;EKcC,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ALmRD;AApSA;EKqBC,iBAAA;EACA,mBAAA;ALkRD;AAxSA;EK0BC,kEAAA;EACA,uEAAA;EACA,0EAAA;ALiRD;AA7SA;;EKiCC,eAAA;ALgRD;AAjTA;;;EKuCC,eAAA;EACA,oBAAA;AL+QD;AAvTA;EK4CC,YAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;AL8QD;AA7TA;EKmDC,iBAAA;AL6QD;AAhUA;EKuDC,UAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AL4QD;AAtUA;EK8DC,aAAA;EACA,eAAA;EACA,eAAA;AL2QD;AA3UA;EKoEC,WAAA;EACA,iBAAA;AL0QD;AA/UA;EMQC,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AN0UD;AA1VA;;EMwBC,8CAAA;EACA,iDAAA;EACA,yCAAA;EAEA,0BAAA;EACA,uBAAA;EACA,kBAAA;ANqUD;AAnWA;;EMmCC,mBAAA;ANoUD;AAvWA;EMuCC,qBAAA;ANmUD;AA1WA;EM2CC,WAAA;EACA,eAAA;ANkUD;AA9WA;EMgDC,eAAA;EACA,iBAAA;ANiUD;AAlXA;EMyDC,mBAAA;EACA,2BAAA;AN4TD;AAtXA;EM8DC,UAAA;EACA,YAAA;AN2TD;AA1XA;EMuEC,eAAA;ANsTD;AA7XA;EM2EC,eAAA;ANqTD;AAhYA;EMgFC,0BAAA;ANmTD;AAnYA;EMoFC,YAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;ANkTD;AAzYA;EOEC,kBAAA;EACA,mBAAA;AP0YD;AA7YA;EOOC,eAAA;APyYD;AAhZA;EOUC,oBAAA;APyYD;AAnZA;;EOeC,oBAAA;APwYD;AAvZA;EOkBC,aAAA;EACA,YAAA;EACA,eAAA;APwYD;AA5ZA;EOwBC,aAAA;EACA,UAAA;APuYD;AAhaA;EO6BC,wCAAA;APsYD;AAnaA;EOgCC,aAAA;EACA,eAAA;APsYD;AAvaA;EOoCC,YAAA;EACA,WAAA;EACA,UAAA;APsYD;AA5aA;EOyCC,aAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;APsYD;AAnbA;EOgDC,eAAA;EACA,YAAA;APsYD;AAvbA;EOqDC,oBAAA;APqYD;AA1bA;EOyDC,eAAA;EACA,iBAAA;APoYD;AA9bA;EO8DC,iBAAA;EACA,oBAAA;EACA,eAAA;APmYD;AAncA;EQEC,UAAA;ARocD;AAtcA;EQMC,oBAAA;ARmcD;AAzcA;EQUC,YAAA;EACA,mBAAA;ARkcD;AA7cA;;EQgBC,mBAAA;ARicD;AAjdA;EQoBC,eAAA;EACA,iBAAA;ARgcD;AArdA;;EQ0BC,eAAA;EACA,gBAAA;EACA,mBAAA;AR+bD;AA3dA;EQgCC,YAAA;AR8bD;AA9dA;EQoCC,eAAA;EACA,aAAA;AR6bD;AAleA;EQyCC,eAAA;EACA,aAAA;AR4bD;AAteA;EQ8CC,iBAAA;EACA,gBAAA;AR2bD;AA1eA;ESEC,kBAAA;EACA,iBAAA;EACA,kEAAA;EACA,uEAAA;EACA,0EAAA;AT2eD;AAjfA;ESUC,UAAA;EACA,iBAAA;AT0eD;AArfA;ESeC,WAAA;ATyeD;AAxfA;ESmBC,iBAAA;ATweD;AA3fA;ESuBC,iBAAA;EACA,eAAA;ATueD;AA/fA;EUGE,qBAAA;AV+fF;AAlgBA;EUME,qBAAA;AV+fF;AArgBA;EUSE,eAAA;AV+fF;AAxgBA;EUYE,YAAA;EACA,mBAAA;EACA,iBAAA;AV+fF;AA7gBA;EUiBE,YAAA;EACA,mBAAA;EACA,iBAAA;AV+fF;AAlhBA;;EUuBE,YAAA;EACA,mBAAA;EACA,iBAAA;AV+fF;AAxhBA;;EU8BI,eAAA;EACA,aAAA;AV8fJ;AA7hBA;;EUkCI,UAAA;AV+fJ;AAjiBA;EWOC,YAAA;EACA,kBAAA;EACA,gBAAA;AX6hBD;AAtiBA;EWaC,2BAAA;EACA,mCAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AX4hBD;AW1hBC;EACC,QAAA;AX4hBF;AWzhBC;EAEC,mBAAA;AX0hBF;AWvhBC;EACC,4BAAA;EACA,iBAAA;AXyhBF;AWthBC;EACC,2BAAA;EACA,mCAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AXwhBF;AWvhBE;EACC,2BAAA;EACA,gBAAA;AXyhBH;AWrhBC;EACC,YAAA;AXuhBF;AWrhBC;EACC,WAAA;AXuhBF;AA5kBA;EW0DC,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;AXqhBD;AWnhBC;EACC,0BAAA;AXqhBF;AWlhBC;EACC,0BAAA;EACA,kBAAA;AXohBF;AWjhBC;EACC,kBAAA;AXmhBF;AA5lBA;EW8EC,cAAA;EACA,8BAAA;AXihBD;AW/gBC;EACC,0BAAA;AXihBF;AW9gBC;EACC,0BAAA;EACA,mBAAA;AXghBF;AAvmBA;EW4FC,gCAAA;EACA,iBAAA;EAIA,WAAA;AX2gBD;AW9gBC;EACC,qBAAA;AXghBF;AA/mBA;EWmGE,aAAA;AX+gBF;AW7gBC;EACC,aAAA;AX+gBF;AArnBA;EW2GC,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;AX6gBD;AAnoBA;EW0HC,kBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,QAAA;EACA,qBAAA;EACA,2BAAA;EACA,mCAAA;AX4gBD;AA9oBA;EWsIC,WAAA;AX2gBD;AAjpBA;EW0IC,oBAAA;EACA,gCAAA;EACA,wCAAA;EACA,WAAA;AX0gBD;AAvpBA;;EWiJC,WAAA;AX0gBD;AA3pBA;EYOC,eAAA;EACA,kBAAA;AZupBD;AA/pBA;EYYC,eAAA;AZspBD;AAlqBA;EYiBC,YAAA;EACA,UAAA;AZopBD;AAtqBA;;EYuBC,YAAA;EACA,oBAAA;AZmpBD;AA3qBA;EY6BC,mBAAA;EACA,eAAA;EACA,UAAA;AZipBD;AAhrBA;EYkCC,eAAA;AZipBD;AAnrBA;EYqCC,eAAA;AZipBD;AAtrBA;EYwCC,YAAA;EACA,oBAAA;AZipBD;AA1rBA;EY8CE,mBAAA;EACA,eAAA;AZ+oBF;AA9rBA;EYkDE,gBAAA;EACA,eAAA;AZ+oBF;AAlsBA;EYsDE,mBAAA;AZ+oBF;AArsBA;EY2DC,mBAAA;EACA,UAAA;AZ6oBD;AAzsBA;EYgEC,aAAA;AZ4oBD;AY3oBC;EACC,aAAA;AZ6oBF;AA/sBA;EYqEE,aAAA;EACA,iBAAA;AZ6oBF;AAntBA;EYyEE,aAAA;EACA,mBAAA;AZ6oBF;AAvtBA;EYkFC,oBAAA;AZwoBD;AA1tBA;EYqFC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;AZwoBD;AAluBA;EY8FC,kBAAA;AZuoBD;AAruBA;EYkGC,aAAA;AZsoBD;AAxuBA;EYsGC,iBAAA;AZqoBD;AA3uBA;EaCC,eAAA;Ab6uBD;Aa3uBC;EACC,aAAA;Ab6uBF;AAjvBA;EcEE,mBAAA;EACA,gBAAA;EACA,iCAAA;AdkvBF;AAtvBA;EeKE,gBAAA;EACA,aAAA;AfovBF;AA1vBA;EeUE,gBAAA;EACA,aAAA;AfmvBF;AA9vBA;EeeE,gBAAA;EACA,aAAA;AfkvBF;AAlwBA;EeoBE,gBAAA;EACA,aAAA;AfivBF;AAtwBA;EgBCC,qGAAA;EACA,6FAAA;EACA,iBAAA;EACA,iBAAA;AhBwwBD;AA5wBA;;;EgBWE,kBAAA;AhBswBF;AAjxBA;;;;;;;;;EgBcE,eAAA;AhB8wBF;AA5xBA;EgBmBC,eAAA;EACA,iBAAA;EACA,UAAA;AhB4wBD;AAjyBA;EiBCC,2BAAA;AjBmyBD;AApyBA;EkBCE,eAAA;EACA,aAAA;EACA,iBAAA;AlBsyBF;AAzyBA;EkBOE,iBAAA;EACA,iBAAA;AlBqyBF;AA7yBA;EmBCE,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;AnB+yBF;AoB/yBC;;;EAIE,eAAA;EACA,4BAAA;ApBgzBH;AoB9yBG;;;EACC,iBAAA;EACA,+BAAA;ApBkzBJ;AoB7yBC;;;EAIE,iBAAA;EACA,iBAAA;EACA,4BAAA;ApB8yBH;AoB3yBE;;;EAEE,YAAA;ApB8yBJ;AoB5yBI;;;EACC,iBAAA;EACA,4BAAA;EACA,UAAA;ApBgzBL;AAl1BA;EoByCE,oBAAA;ApB4yBF;AAr1BA;EoB4CG,aAAA;ApB4yBH;AAx1BA;EoBgDG,iBAAA;EACA,WAAA;ApB2yBH;AA51BA;EoBsDE,eAAA;EACA,iBAAA;EACA,qBAAA;ApByyBF;AAj2BA;EoB4DE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;ApBwyBF;AoB9xBG;;;;;;EACC,iBAAA;EACA,+BAAA;ApBqyBJ;AAh3BA;EoBkFC,aAAA;ApBiyBD;AqBn3BA;;;EAIE,uCAAA;EACA,0BAAA;ArBo3BF;AqBz3BA;;;EAaE,ucAAA;ArBi3BF;AqB93BA;;;EAmBE,iBAAA;ArBg3BF;AsBn4BA;EACC,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EAEA,mBAAA;EAEA,2BAAA;EACA,iBAAA;AtBk4BD;AsBh4BC;EACC,+BAAA;EACA,uBAAA;AtBk4BF;AsB/3BC;;EAEC,YAAA;AtBi4BF;AsB55BA;EAgCG,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EAEA,gCAAA;EACA,0BAAA;AtB83BH;AsBv6BA;EA6CG,SAAA;EACA,iBAAA;EACA,kBAAA;AtB63BH;AsB56BA;EAmDG,qBAAA;EACA,aAAA;AtB43BH;AsBh7BA;EAwDG,WAAA;EACA,iBAAA;AtB23BH;AsBp7BA;EA6DG,sBAAA;EACA,sBAAA;AtB03BH;AsBx7BA;EAkEG,mBAAA;AtBy3BH;AsB37BA;EAqEG,iBAAA;AtBy3BH;AsB97BA;EAwEG,iBAAA;EACA,iBAAA;AtBy3BH;AsBl8BA;EA6EG,sBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;AtBw3BH;AsBz8BA;EAqFG,UAAA;EACA,WAAA;EACA,sBAAA;AtBu3BH;AsB98BA;EA2FG,WAAA;EACA,YAAA;EACA,sBAAA;AtBs3BH;AsBn9BA;EAiGG,YAAA;EACA,kBAAA;AtBq3BH;AsBh3BA;EACC,oBAAA;EACA,aAAA;AtBk3BD;AuBt9BA;EACC,uBAAA;EACA,YAAA;EACA,UAAA;EvBw9BC,kFAAkF;AACpF;AuB59BA;EAOG,8BAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AvBw9BH;AuBn+BA;EAcI,iBAAA;AvBw9BJ;AuBt+BA;EAmBG,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AvBs9BH;AuB7+BA;EA2BG,SAAA;EACA,eAAA;AvBq9BH;AuBj/BA;;EAgCI,WAAA;EACA,oBAAA;AvBq9BJ;AuBt/BA;;EAqCI,iBAAA;AvBq9BJ;AuB1/BA;;EAyCI,gBAAA;AvBq9BJ;AuB9/BA;EA8CK,gBAAA;AvBm9BL;AuBjgCA;EAiDK,gBAAA;AvBm9BL;AuBpgCA;EAoDK,iBAAA;AvBm9BL;AuBvgCA;EA0DG,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AvBg9BH;AuB/gCA;EAoEI,YAAA;AvB88BJ;AuBlhCA;EA0EI,UAAA;AvB28BJ;AuBr8BC;;;;EAIC,cAAA;EACA,mBAAA;AvBu8BF;AuBp8BC;;EAEC,cAAA;EACA,4CAAA;AvBs8BF;AuBn8BC;;EAEC,eAAA;EACA,4CAAA;AvBq8BF;AuBn8BC;EACC,UAAA;EACA,oBAAA;AvBq8BF;AuBn8BC;EACC,WAAA;EACA,qBAAA;AvBq8BF;AuBn8BC;EACC,SAAA;EACA,mBAAA;AvBq8BF;AuBn8BC;EACC,YAAA;EACA,sBAAA;AvBq8BF;AA3hCA;EwB/BC,kBAAA;AxB6jCD;AA9hCA;EwB3BC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AxB4jCD;AAriCA;EwBnBC,wCAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AxB2jCD;AA7iCA;EwBVC,sBAAA;AxB0jCD;AAhjCA;EwBNC,YAAA;EACA,WAAA;EACA,wCAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AxByjCD;AA9jCA;EwBSC,yBAAA;AxBwjCD","sourcesContent":[".dq {\n\t:global {\n\t\t@import './nv/axis.less';\n\t\t@import './nv/bars.less';\n\t\t@import './nv/boxplot.less';\n\t\t@import './nv/bullet.less';\n\t\t@import './nv/lines.less';\n\t\t@import './nv/main.less';\n\t\t@import './nv/scatter.less';\n\t\t@import './nv/sparkline.less';\n\t\t@import './nv/stackedarea.less';\n\t\t@import './nv/lineHighlighter.less';\n\t\t@import 'breakdownbar.less';\n\t\t@import 'common.less';\n\t\t@import 'comparisons.less';\n\t\t@import 'gauge.less';\n\t\t@import 'round-gauge.less';\n\t\t@import 'pie.less';\n\t\t@import 'reference-line.less';\n\t\t@import 'quadrant-label.less';\n\t\t@import 'axis-labels.less';\n\t\t@import 'scatter-chart.less';\n\t}\n\n\t@import 'infinite-grid.less';\n}\n\n.dqTooltip {\n\t@import './nv/tooltip.less';\n\t@import 'dark_dialog.less';\n}\n\n.dqMap {\n\t:global {\n\t\t@import 'map.less';\n\t}\n}\n","@import (reference) '../colors.less';\n\n.nvd3 .nv-axis {\n\tpointer-events: none;\n\topacity: 1;\n}\n\n.nvd3 .nv-axis path {\n\tfill: none;\n\tstroke: none;\n\tstroke-opacity: 0.75;\n\tshape-rendering: crispEdges;\n}\n\n.nvd3 .nv-axis path.domain {\n\tstroke-opacity: 0.75;\n}\n\n.nvd3 .nv-axis.nv-x path.domain {\n\tstroke-opacity: 0;\n}\n\n.nvd3.nv-scatterChart.subtle-grid .nv-axis,\n.nvd3.multiChart .nv-axis,\n.nvd3.multiChart .nv-zeroLine,\n.nvd3.nv-multiBarHorizontalChart .nv-axis\n{\n\t.nv-zeroLine,\n\tline {\n\t\tfill: none;\n\t\tshape-rendering: crispEdges;\n\t\tstroke-dasharray: 2, 3;\n\t\tstroke-width: 2px;\n\t\tstroke-linecap: butt;\n\t}\n}\n\n.nvd3.multiChart .nv-y2:not(.split-axis) .nv-axis .tick line {\n\tstroke: @darker-gray;\n\tstroke-opacity: 1;\n\tstroke-dasharray: 16, 0;\n\tstroke-linecap: round;\n\tshape-rendering: auto;\n}\n\n// When a user is viewing the chart on a retina screen, round grid marks are shown.\n// Otherwise, square grid marks are rendered.\n@media\n(-webkit-min-device-pixel-ratio: 2),\n(min-resolution: 192dpi) {\n\t.nvd3 .nv-axis line,\n\t.nv-zeroLine {\n\t\tshape-rendering: auto;\n\t\tstroke-dasharray: 0, 5;\n\t\tstroke-linecap: round;\n\t}\n}\n\n.nv-axis .nv-axislabel,\n.nv-axis .nv-axislabel tspan {\n\tfont-weight: bold;\n\tfont-size: 14px;\n\tfill: @medium-gray;\n}\n\n.nv-secondaryaxislabel {\n\tfont-weight: 400;\n\tfill: @medium-gray;\n}\n\n.nvd3.multiChart .nv-y2:not(.split-axis) .nv-axis line {\n\tstroke: #272727;\n\tstroke-width: 3px;\n}\n\n.nvd3.nv-scatterChart.subtle-grid .nv-y,\n.nvd3 .nv-tickLabel-y1,\n.nvd3 .nv-tickLabel-y2 {\n\t.nv-axis .tick {\n\t\ttext {\n\t\t\talign-items: baseline;\n\t\t\ttext-anchor: start !important;\n\t\t\tfill: @medium-gray;\n\t\t}\n\n\t\ttext,\n\t\trect {\n\t    \t\ttransform: translate(2px, 12px);\n\t\t}\n\t}\n}\n.nvd3 .nv-tickLabel-y2:not(.split-axis) .nv-axis .tick {\n\ttext {\n\t\ttext-anchor: end !important;\n\t}\n\n\ttext,\n\trect {\n\t\ttransform: translate(3px, 13px);\n\t}\n}\n\n// Hide the first tick text label (it may not be zero so we can't use .zero)\n.nvd3.nv-scatterChart.subtle-grid .nv-y {\n\t.nv-axis .tick:first-child text {\n\t\tdisplay: none;\n\t}\n}\n\n// Hide the first tick label (it may not be zero so we can't use .zero)\n.nv-tickLabel-y1,\n.nv-tickLabel-y2.split-axis {\n\t .nv-axis .tick:first-of-type {\n\t\tdisplay: none;\n\t}\n}\n\n.nvd3 .nv-tickLabel-y1 .nv-axis .tick rect {\n\tfill: #FFFFFF;\n\tfill-opacity: 0.7;\n}\n\n.nvd3 .nv-axis .nv-axisMaxMin text {\n\tfont-weight: bold;\n}\n\n.nvd3 .x .nv-axis .nv-axisMaxMin text,\n.nvd3 .x2 .nv-axis .nv-axisMaxMin text,\n.nvd3 .x3 .nv-axis .nv-axisMaxMin text {\n\ttext-anchor: middle;\n}\n\n.nvd3 .nv-axis.nv-disabled {\n\topacity: 0;\n}\n\n.nvd3.nv-scatterChart.subtle-grid .nv-x .nv-axis text,\n.nvd3.multiChart .nv-x .nv-axis text,\n.nv-multiBarHorizontalChart .nv-x .nv-axis text,\n.nv-multiBarHorizontalChart .nv-y .nv-axis text {\n\tfill: @medium-gray;\n}\n\n.nvd3.multiChart .nv-x.alternate-labels .nv-axis .tick:nth-child(even) text {\n\tvisibility: hidden;\n}\n","@import (reference) '../colors.less';\n\n.nvd3 .nv-bars path {\n\tfill-opacity: 1;\n\n\ttransition: fill-opacity 250ms linear;\n\t-moz-transition: fill-opacity 250ms linear;\n\t-webkit-transition: fill-opacity 250ms linear;\n}\n\n.nvd3 .nv-bars path.hover {\n\tfill-opacity: 0.75;\n}\n\n.nvd3 .nv-bars .hover path {\n\tfill: lightblue;\n}\n\n.nvd3 .nv-bars text {\n\tfill: rgba(0, 0, 0, 0);\n}\n\n.nvd3 .nv-bars .hover text {\n\tfill: rgba(0, 0, 0, 1);\n}\n\n.nvd3 .nv-multibar .nv-groups path,\n.nvd3 .nv-multibarHorizontal .nv-groups path,\n.nvd3 .nv-discretebar .nv-groups rect {\n\topacity: 1;\n\tfill-opacity: 1;\n\tstroke-opacity: 1;\n\n\ttransition: opacity 150ms linear;\n\t-moz-transition: opacity 150ms linear;\n\t-webkit-transition: opacity 150ms linear;\n}\n\n\n.nvd3 .nv-multibar.interactive,\n.nvd3 .nv-multibarHorizontal.interactive {\n\t.nv-groups:hover path {\n\t\topacity: 0.25;\n\t}\n\n \t.nv-group:not(:only-of-type):hover path,\t\n\t.nv-group:hover path:hover {\n\t\topacity: 1;\n\t}\n}\n\n.nvd3.multiChart .nv-multibar .nv-bar.null {\n\topacity: 0;\n}\n\n.nvd3 .nv-multibar .nv-groups .nv-group.selected-group .nv-bar,\n.nvd3 .nv-multibarHorizontal .nv-groups .nv-group.selected-group .nv-bar,\n.nvd3 .nv-multibar .nv-groups .nv-group.hovered-group .nv-bar,\n.nvd3 .nv-multibarHorizontal .nv-groups .nv-group.hovered-group .nv-bar {\n\topacity: 0.25;\n\n\tpath {\n\t\tstroke-width: 2;\n\t\tstroke-opacity: 1;\n\t}\n}\n\n.nvd3 .nv-multibar .nv-groups .nv-group .nv-bar.selected-bar,\n.nvd3 .nv-multibarHorizontal .nv-groups .nv-group .nv-bar.selected-bar,\n.nvd3 .nv-multibar .nv-groups .nv-group .nv-bar.hovered-bar,\n.nvd3 .nv-multibarHorizontal .nv-groups .nv-group .nv-bar.hovered-bar {\n\topacity: 1;\n\t\n\tpath {\n\t\tstroke-width: 6px;\n\t\tstroke-opacity: 0.25;\n\t}\n}\n\n.bar-text {\n\t// override whatever colors and settings were set on the bar group\n\tfill: @medium-gray;\n\tfill-opacity: 1;\n\topacity: 1;\n\tstroke-width: 0;\n}\n","/* boxplot CSS */\n.nvd3 .nv-boxplot circle {\n\tfill-opacity: 0.5;\n}\n\n.nvd3 .nv-boxplot circle:hover {\n\tfill-opacity: 1;\n}\n\n.nvd3 .nv-boxplot rect:hover {\n\tfill-opacity: 1;\n}\n\n.nvd3 line.nv-boxplot-median {\n\tstroke: black;\n}\n\n.nv-boxplot-tick:hover {\n\tstroke-width: 2.5px;\n}\n","/* bullet */\n.nvd3.nv-bullet {\n\tfont: 10px sans-serif;\n}\n.nvd3.nv-bullet .nv-measure {\n\tfill-opacity: 0.8;\n}\n.nvd3.nv-bullet .nv-measure:hover {\n\tfill-opacity: 1;\n}\n.nvd3.nv-bullet .nv-marker {\n\tstroke: #000;\n\tstroke-width: 2px;\n}\n.nvd3.nv-bullet .nv-markerTriangle {\n\tstroke: #000;\n\tfill: #fff;\n\tstroke-width: 1.5px;\n}\n.nvd3.nv-bullet .nv-tick line {\n\tstroke: #666;\n\tstroke-width: 0.5px;\n}\n.nvd3.nv-bullet .nv-range.nv-s0 {\n\tfill: #eee;\n}\n.nvd3.nv-bullet .nv-range.nv-s1 {\n\tfill: #ddd;\n}\n.nvd3.nv-bullet .nv-range.nv-s2 {\n\tfill: #ccc;\n}\n.nvd3.nv-bullet .nv-title {\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n.nvd3.nv-bullet .nv-subtitle {\n\tfill: #999;\n}\n\n.nvd3.nv-bullet .nv-range {\n\tfill: #bababa;\n\tfill-opacity: 0.4;\n}\n.nvd3.nv-bullet .nv-range:hover {\n\tfill-opacity: 0.7;\n}\n","@import (reference) '../colors.less';\n\n.nvd3 .nv-groups path.nv-line {\n\tfill: none;\n\tstroke-linecap: round;\n\tstroke-linejoin: round;\n}\n\n.nvd3 .nv-groups path.nv-area {\n\tstroke: none;\n}\n\n/* Hide the points in line chart */\n.nvd3.nv-line .nvd3.nv-scatter .nv-groups .nv-point {\n\tstroke-width: 5px;\n\tfill-opacity: 0;\n\tstroke-opacity: 0;\n\tpaint-order: stroke;\n}\n\n.nvd3.nv-scatter.nv-single-point .nv-groups .nv-point {\n\tfill-opacity: 0.5;\n\tstroke-opacity: 0.5;\n}\n\n.with-transitions .nvd3 .nv-groups .nv-point {\n\ttransition: stroke-width 250ms linear, stroke-opacity 250ms linear;\n\t-moz-transition: stroke-width 250ms linear, stroke-opacity 250ms linear;\n\t-webkit-transition: stroke-width 250ms linear, stroke-opacity 250ms linear;\n}\n\n.nvd3 .nv-line .nv-scatter .nv-groups .nv-point.always-visible,\n.nvd3 .nv-line .nv-groups .nv-point.always-visible {\n\tfill-opacity: 1;\n}\n\n.nvd3 .nv-line .nv-scatter .nv-groups .nv-point.hover,\n.nvd3 .nv-line .nv-scatter .nv-groups .nv-point.selected,\n.nvd3 .nv-line .nv-groups .nv-point.hover {\n\tfill-opacity: 1;\n\tstroke-opacity: 0.25;\n}\n\n.nvd3 .nv-point-paths path {\n\tstroke: #aaa;\n\tstroke-opacity: 0;\n\tfill: #eee;\n\tfill-opacity: 0;\n}\n\n.nvd3 .nv-indexLine {\n\tcursor: ew-resize;\n}\n\n.nvd3 .nv-line text.data-points {\n\tfill: grey;\n\tfill-opacity: 1;\n\tstroke: none;\n\tfont-size: 12px;\n}\n\n.nvd3 .nv-line-label text {\n\tfill: @dark-gray;\n\tfill-opacity: 1;\n\tstroke-width: 0;\n}\n\n.nvd3 .nv-line-label rect {\n\tfill: white;\n\tfill-opacity: 0.7;\n}\n","/********************\n * SVG CSS\n */\n\n/********************\n  Default CSS for an svg element nvd3 used\n*/\nsvg.nvd3-svg {\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-ms-user-select: none;\n\t-moz-user-select: none;\n\tuser-select: none;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n}\n\n/********************\n  Box shadow and border radius styling\n*/\n.nvtooltip.with-3d-shadow,\n.with-3d-shadow .nvtooltip {\n\t-moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n\t-webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n\tbox-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n\n\t-webkit-border-radius: 5px;\n\t-moz-border-radius: 5px;\n\tborder-radius: 5px;\n}\n\n.nvd3 text,\n.nvd3 text tspan {\n\tfont-weight: normal;\n}\n\n.nvd3 .title {\n\tfont: bold 14px Arial;\n}\n\n.nvd3 .nv-background {\n\tfill: white;\n\tfill-opacity: 0;\n}\n\n.nvd3.nv-noData {\n\tfont-size: 18px;\n\tfont-weight: bold;\n}\n\n/**********\n*  Brush\n*/\n\n.nv-brush .extent {\n\tfill-opacity: 0.125;\n\tshape-rendering: crispEdges;\n}\n\n.nv-brush .resize path {\n\tfill: #eee;\n\tstroke: #666;\n}\n\n/**********\n*  Legend\n*/\n\n.nvd3 .nv-legend .nv-series {\n\tcursor: pointer;\n}\n\n.nvd3 .nv-legend .nv-disabled circle {\n\tfill-opacity: 0;\n}\n\n/* focus */\n.nvd3 .nv-brush .extent {\n\tfill-opacity: 0 !important;\n}\n\n.nvd3 .nv-brushBackground rect {\n\tstroke: #000;\n\tstroke-width: 0.4;\n\tfill: #fff;\n\tfill-opacity: 0.7;\n}\n","/* scatter */\n.nvd3 .nv-groups .nv-point.hover {\n\tstroke-width: 20px;\n\tstroke-opacity: 0.5;\n}\n\n.nvd3 .nv-scatter .nv-point.hover {\n\tfill-opacity: 1;\n}\n.nv-noninteractive {\n\tpointer-events: none;\n}\n\n.nv-distx,\n.nv-disty {\n\tpointer-events: none;\n}\n.nvd3 .nv-scatter g.data-points text {\n\tfill: #a4a4a4;\n\tstroke: none;\n\tfont-size: 14px;\n}\n\n.nvd3 .nv-scatter g.data-points text.hover {\n\tfill: #222222;\n\topacity: 1;\n}\n\n#dataPointSymbol {\n\tfont-family: Qualtrics Icons, sans-serif;\n}\n.nv-scatterChart .nv-axis path {\n\tfill: #272727;\n\tstroke: #272727;\n}\n.nvd3 .nv-scatter g.data-points rect {\n\tstroke: none;\n\tfill: white;\n\topacity: 0;\n}\n.nvd3 .nv-line .nv-scatter g.data-points text {\n\tfill: #808080;\n\tfont-size: 12px;\n\tfill: grey;\n\tfill-opacity: 1;\n\tstroke: none;\n}\n.nvd3 .nv-line .nv-scatter g.data-points rect {\n\tfill-opacity: 1;\n\topacity: 0.7;\n}\n\n.nvd3.nv-scatterChart .nv-axis.nv-x path.domain {\n\tstroke-opacity: 0.75;\n}\n\n.nvd3 .nv-scatterWrap .nv-scatter .nv-groups .nv-group.hovered-group .nv-point {\n\tstroke-width: 0;\n\tstroke-opacity: 0;\n}\n\n.nvd3 .nv-scatterWrap .nv-scatter .nv-groups .nv-group .nv-point.hovered-data {\n\tstroke-width: 4px;\n\tstroke-opacity: 0.24;\n\tfill-opacity: 1;\n}\n","/* sparkline */\n.nvd3.nv-sparkline path {\n\tfill: none;\n}\n\n.nvd3.nv-sparklineplus g.nv-hoverValue {\n\tpointer-events: none;\n}\n\n.nvd3.nv-sparklineplus .nv-hoverValue line {\n\tstroke: #333;\n\tstroke-width: 1.5px;\n}\n\n.nvd3.nv-sparklineplus,\n.nvd3.nv-sparklineplus g {\n\tpointer-events: all;\n}\n\n.nvd3 .nv-hoverArea {\n\tfill-opacity: 0;\n\tstroke-opacity: 0;\n}\n\n.nvd3.nv-sparklineplus .nv-xValue,\n.nvd3.nv-sparklineplus .nv-yValue {\n\tstroke-width: 0;\n\tfont-size: 0.9em;\n\tfont-weight: normal;\n}\n\n.nvd3.nv-sparklineplus .nv-yValue {\n\tstroke: #f66;\n}\n\n.nvd3.nv-sparklineplus .nv-maxValue {\n\tstroke: #2ca02c;\n\tfill: #2ca02c;\n}\n\n.nvd3.nv-sparklineplus .nv-minValue {\n\tstroke: #d62728;\n\tfill: #d62728;\n}\n\n.nvd3.nv-sparklineplus .nv-currentValue {\n\tfont-weight: bold;\n\tfont-size: 1.1em;\n}\n","/* stacked area */\n.nvd3.nv-stackedarea path.nv-area {\n\tfill-opacity: 0.75;\n\tstroke-opacity: 0;\n\ttransition: fill-opacity 250ms linear, stroke-opacity 250ms linear;\n\t-moz-transition: fill-opacity 250ms linear, stroke-opacity 250ms linear;\n\t-webkit-transition: fill-opacity 250ms linear, stroke-opacity 250ms linear;\n}\n\n.nvd3.nv-stackedarea path.nv-line {\n\tfill: none;\n\tstroke-opacity: 1;\n}\n\n.nvd3.nv-stackedarea .nv-groups .nv-point:not(.hover) {\n\tfill: white;\n}\n\n.nvd3.nv-stackedarea path.nv-area.hover {\n\tfill-opacity: 0.6;\n}\n\n.nvd3.nv-stackedarea .nv-groups .nv-point {\n\tstroke-opacity: 1;\n\tfill-opacity: 1;\n}\n","@import (reference) '../colors.less';\n\n.nvd3 .nv-line .nv-line-label {\n  transition: all 0.15s;\n}\n.nvd3 .nv-line .nv-group {\n  transition: all 0.15s;\n}\n.nv-line-label {\n  cursor: pointer;\n}\n.line-focused .nv-group:not(.focused) {\n  opacity: 0.2;\n  stroke-opacity: 0.2;\n  fill-opacity: 0.2;\n}\n.line-selected > .nv-groups .nv-group {\n  opacity: 0.2;\n  stroke-opacity: 0.2;\n  fill-opacity: 0.2;\n}\n.line-focused .nv-line-label:not(.focused),\n.line-selected .nv-line-label:not(.selected) {\n  opacity: 0.2;\n  stroke-opacity: 0.2;\n  fill-opacity: 0.2;\n}\n.line-selected .nv-line-label.selected,\n.line-focused .nv-line-label.focused {\n  .nv-background {\n    fill-opacity: 1;\n    fill: inherit;\n  }\n  .label-text {\n    fill: #FFF;\n  }\n}\n","// TODO: Move to mixins file after dq build is updated to use postcsss\n@white: #fff;\n@grey: #707070;\n@black: #000;\n@bar-label-offset: 34px;\n\n.bar-container {\n\theight: 100%;\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.bar {\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n\ttop: 50%;\n\tposition: absolute;\n\toverflow: visible;\n\twidth: 100%;\n\theight: 24px;\n\n\t&.responsive {\n\t\ttop: 50%;\n\t}\n\n\t&.horizontal {\n\t\t// Ensures bars do not wrap to new lines due to minor size discrepancies\n\t\twhite-space: nowrap;\n\t}\n\n\t&.horizontal.responsive {\n\t\theight: calc(100% * (2 / 3));\n\t\tmax-height: 800px;\n\t}\n\n\t&.vertical {\n\t\ttransform: translateX(-50%);\n\t\t-webkit-transform: translateX(-50%);\n\t\ttop: 0;\n\t\tleft: 50%;\n\t\toverflow: visible;\n\t\twidth: 24px;\n\t\theight: 100%;\n\t\t&.responsive {\n\t\t\twidth: calc(100% * (2 / 3));\n\t\t\tmax-width: 800px;\n\t\t}\n\t}\n\n\t&.horizontal.responsive-full {\n\t\theight: 100%;\n\t}\n\t&.vertical.responsive-full {\n\t\twidth: 100%;\n\t}\n}\n\n.bar-section {\n\tdisplay: inline-block;\n\tposition: relative;\n\toutline: none;\n\tborder-right: solid 1px white;\n\n\t&:first-child {\n\t\tborder-radius: 2px 0 0 2px;\n\t}\n\n\t&:last-child {\n\t\tborder-radius: 0 2px 2px 0;\n\t\tborder-right: none;\n\t}\n\n\t&:first-child:last-child {\n\t\tborder-radius: 2px;\n\t}\n}\n\n.vertical .bar-section {\n\tdisplay: block;\n\tborder-bottom: solid 1px white;\n\n\t&:first-child {\n\t\tborder-radius: 2px 2px 0 0;\n\t}\n\n\t&:last-child {\n\t\tborder-radius: 0 0 2px 2px;\n\t\tborder-bottom: none;\n\t}\n}\n\n.legend-container {\n\ttransition: height 0.1s ease-out;\n\toverflow: visible;\n\t&.disable-animation {\n\t\ttransition: height 0s;\n\t}\n\twidth: 100%;\n\ttext {\n\t\tfill: @grey;\n\t}\n\t&.disabled {\n\t\tdisplay: none;\n\t}\n}\n\n.bar-label {\n\tpadding-left: 8px;\n\tpadding-right: 8px;\n\ttransition: opacity 0.1s ease-out;\n\tfont-weight: 400;\n\tfont-size: 12px;\n\twhite-space: nowrap;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -@bar-label-offset);\n\t-webkit-transform: translate(-50%, -@bar-label-offset);\n\tposition: absolute;\n\tcolor: @grey;\n}\n\n.vertical .bar-label {\n\tposition: absolute;\n\tpadding: 0;\n\tcolor: @grey;\n\ttext-shadow: none;\n\tmargin-left: 16px;\n\ttop: 50%;\n\tleft: 100% !important;\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n}\n\n.horizontal.responsive-full .bar-label {\n\tcolor: @black;\n}\n\n.vertical.responsive-full .bar-label {\n\tleft: 50% !important;\n\ttransform: translate(-50%, -50%);\n\t-webkit-transform: translate(-50%, -50%);\n\tcolor: @black;\n}\n.vertical.responsive-full .dark-fill .bar-label, \n.horizontal.responsive-full .dark-fill .bar-label {\n\tcolor: @white;\n}\n","// default all DQ charts to arial, users of DQ can override this\n\n/*\n * this guy needs to go on all dq but not under `*` becuase `*` takes precedence\n * over `inherit` styles that many <text> elements rely on in the charts.\n */\n:local {\n\tfont-size: 12px;\n\tfont-family: arial;\n}\n\n.nvd3.nv-pieChart .nv-legend .nv-series {\n\tcursor: default;\n}\n\n/* Hide grid lines in chart */\n.hidden-grid-line .nvd3 .nv-axis line {\n\tstroke: none;\n\tfill: none;\n}\n\n.nvd3 .nv-axis line,\n.nvd3 .nv-zeroLine line {\n\tstroke: #000;\n\tstroke-opacity: 0.09;\n}\n\n/* Legend Css */\n.dq-legend g {\n\tpointer-events: all;\n\tcursor: pointer;\n\topacity: 1;\n}\n.dq-legend g.disabled rect {\n\tfill-opacity: 0;\n}\n.dq-legend g.disabled circle {\n\tfill-opacity: 0;\n}\n.dq-legend .click-disabled {\n\tcursor: auto;\n\tpointer-events: none;\n}\n\n.dq-legend {\n\ttext {\n\t\tfont-weight: normal;\n\t\tfont-size: 12px;\n\t}\n\t.dq-legend-title text {\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t}\n\t.dq-legend-element:focus {\n\t\toutline-offset: 5px;\n\t}\n}\n\n.dq-line path {\n\tstroke-width: 1.5px;\n\tfill: none;\n}\n\n.smart-labels {\n\tfill: #272727;\n\t&.light-label-color {\n\t\tfill: #ffffff;\n\t}\n\t.main-label {\n\t\tfill: #32363A;\n\t\tfont-weight: bold;\n\t}\n\t.numerical-label{\n\t\tfill: #74777a;\n\t\tfont-weight: normal;\n\t}\n}\n\n/****\nInteractive Layer\n*/\n.nvd3 .nv-interactiveGuideLine {\n\tpointer-events: none;\n}\n.nvd3 line.nv-guideline {\n\tstroke: #222222;\n\tstroke-opacity: 1;\n\tstroke-dasharray: 0, 5;\n\tstroke-width: 2;\n\tstroke-linecap: round;\n\tshape-rendering: auto;\n}\n\n.hidden {\n\tvisibility: hidden;\n}\n\n.no-display {\n\tdisplay: none;\n}\n\n.nv-line text.data-points.hide-text {\n\tfill: transparent;\n}\n",".focusable-comparison {\n\tcursor: pointer;\n\n\t&:focus:not(:focus-visible) {\n\t\toutline: none;\n\t}\n}\n",".gauge {\n\ttext {\n\t\ttext-anchor: middle;\n\t\tfont-weight: 300;\n\t\ttransition: opacity 0.1s ease-out;\n\t}\n}\n","@round-gauge-contrast-gray: #32363a;\n@round-gauge-dark-gray: #74777a;\n\n.round-gauge {\n\ttext.round-gauge-number {\n\t\tfont-weight: 300;\n\t\tfill: @round-gauge-contrast-gray;\n\t}\n\n\ttext.round-gauge-field-label {\n\t\tfont-weight: 700;\n\t\tfill: @round-gauge-dark-gray;\n\t}\n\n\ttext.round-gauge-threshold-label {\n\t\tfont-weight: 400;\n\t\tfill: @round-gauge-dark-gray;\n\t}\n\n\ttext.round-gauge-minimum-threshold-label {\n\t\tfont-weight: 400;\n\t\tfill: @round-gauge-dark-gray;\n\t}\n}\n",".pieContainer .sliceContainer path.arc {\n\t-webkit-transition: fill-opacity 250ms linear, stroke-width 250ms linear, stroke-opacity 250ms linear;\n\ttransition: fill-opacity 250ms linear, stroke-width 250ms linear, stroke-opacity 250ms linear;\n\tstroke-width: 1px;\n\tstroke-opacity: 1;\n}\n\n.pieContainer.interactive .sliceContainer:hover,\n.pieContainer.interactive .sliceContainer.selected,\n.pieContainer.interactive .sliceContainer.group-hover {\n\tpath.arc {\n\t\tfill-opacity: 0.25;\n\t}\n\tpath.arc:hover, path.arc.selected, path.arc.group-hover {\n\t\tfill-opacity: 1;\n\t}\n}\n\n.pieContainer polyline.labelLines {\n\tstroke: #000000;\n\tstroke-width: 1px;\n\tfill: none;\n}\n",".dq-reference-line-container .reference-line {\n\tshape-rendering: crispEdges;\n}\n",".quadrant-label {\n  font-size: 14px;\n  fill: #32363A;\n  font-weight: bold;\n}\n\n.quadrant-label tspan {\n  font-family: '72';\n  font-weight: bold;\n}",".axis-label tspan {\n  font-family: '72';\n  font-size: 12px;\n  font-weight: semibold;\n  fill: #6A6D70;\n}","@import (reference) './colors.less';\n\n/* scatter */\n.nvd3.nv-scatterChart {\n\t&.nv-scatter,\n\t.nv-scatter,\n\t.nv-groups {\n\t\t.nv-point {\n\t\t\tstroke-width: 0;\n\t\t\tstroke-opacity: 0 !important;\n\n\t\t\t&.hover {\n\t\t\t\tstroke-width: 8px;\n\t\t\t\tstroke-opacity: 0.24 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.nv-scatter.bubble,\n\t.nv-scatter.bubble,\n\t.nv-groups.bubble {\n\t\t.nv-point {\n\t\t\tfill-opacity: 0.5;\n\t\t\tstroke-width: 2px;\n\t\t\tstroke-opacity: 1 !important;\n\t\t}\n\n\t\t&:hover {\n\t\t\t.nv-point {\n\t\t\t\topacity: 0.5;\n\n\t\t\t\t&.hover {\n\t\t\t\t\tstroke-width: 5px;\n\t\t\t\t\tstroke-opacity: 1 !important;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.nv-sectionLabels {\n\t\tpointer-events: none;\n\t\t\n\t\ttext {\n\t\t\tfill: @medium-gray;\n\t\t}\n\t\t\n\t\t.nv-sectionLabel {\n\t\t\tfill-opacity: 0.6;\n\t\t\tfill: white;\n\t\t}\n\t}\n\n\t.nv-sectionBorders {\n\t\tstroke: @medium-gray;\n\t\tstroke-width: 2px;\n\t\tstroke-dasharray:  2,3;\n\t}\n\n\t#dataPointText.outline-text {\n\t\tstroke: white;\n\t\tstroke-width: 2px;\n\t\tpaint-order: stroke;\n\t\tstroke-opacity: 0.8;\n\t}\n}\n\n.nvd3.nv-line,\n.nvd3.nv-stackedarea {\n\t&.nv-scatter,\n\t.nv-scatter,\n\t.nv-groups {\n\t\t.nv-point {\n\t\t\t&.hover {\n\t\t\t\tstroke-width: 8px;\n\t\t\t\tstroke-opacity: 0.24 !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n#dataPointText {\n\tfill: #74777a;\n}\n","&:global(.infinite-horizontal-grid) :global {\n\t.dq-reference-line-container .horizontal-reference-line,\n\t.nvd3 .nv-y1.nv-axis line,\n\t.nvd3 .nv-y.nv-axis line {\n\t\ttransform: translateX(-100%) scaleX(10);\n\t\tstroke-dasharray: 0.2, 0.3;\n\t}\n\n\t.nvd3 .nv-y1.nv-axis text,\n\t.nvd3 .nv-y2.nv-axis text,\n\t.nvd3 .nv-y.nv-axis text {\n\t\t// super hack that overloads multiple text shadows of white so the line doesn't come through\n\t\t.white-text-shadow();\n\t\ttext-shadow: @shadow;\n\t}\n\n\t.nvd3 .nv-x1.nv-axis path.domain,\n\t.nvd3 .nv-x2.nv-axis path.domain,\n\t.nvd3 .nv-axis.nv-x path.domain {\n\t\tstroke-opacity: 0;\n\t}\n}\n\n.white-text-shadow() {\n\t@shadow: 0px 5px 0px #fff, 0px -5px 0px #fff, 5px 0px 0px #fff, -5px 0px 0px #fff, 0px 4px 0px #fff, 0px -4px 0px #fff,\n\t\t4px 0px 0px #fff, -4px 0px 0px #fff, 0px 3px 0px #fff, 0px -3px 0px #fff, 3px 0px 0px #fff, -3px 0px 0px #fff,\n\t\t0px 3px 0px #fff, 0px -3px 0px #fff, 3px 0px 0px #fff, -3px 0px 0px #fff, 0px 2px 0px #fff, 0px -2px 0px #fff,\n\t\t2px 0px 0px #fff, -2px 0px 0px #fff, 0px 1px 0px #fff, 0px -1px 0px #fff, 1px 0px 0px #fff, -1px 0px 0px #fff;\n}\n","&:global(.nvtooltip) {\n\tposition: absolute;\n\tbackground: rgba(255, 255, 255, 0.8);\n\tcolor: rgba(0, 0, 0, 1);\n\tpadding: 1px;\n\tborder: 1px solid rgba(0, 0, 0, 0.5);\n\tborder-radius: 4px;\n\tz-index: 10000;\n\tdisplay: block;\n\n\tfont-family: Arial;\n\tfont-size: 13px;\n\ttext-align: left;\n\tpointer-events: none;\n\n\twhite-space: nowrap;\n\n\t-webkit-touch-callout: none;\n\tuser-select: none;\n\n\t&:global(.width-transitions) {\n\t\ttransition: opacity 50ms linear;\n\t\ttransition-delay: 200ms;\n\t}\n\n\t&:global(.x-nvtooltip),\n\t&:global(.y-nvtooltip) {\n\t\tpadding: 8px;\n\t}\n\n\t:global {\n\t\th3 {\n\t\t\tmargin: 0;\n\t\t\tpadding: 4px 14px;\n\t\t\tline-height: 18px;\n\t\t\tfont-weight: normal;\n\t\t\tbackground-color: rgba(247, 247, 247, 0.75);\n\t\t\tcolor: rgba(0, 0, 0, 1);\n\t\t\ttext-align: center;\n\n\t\t\tborder-bottom: 1px solid #ebebeb;\n\t\t\tborder-radius: 5px 5px 0 0;\n\t\t}\n\n\t\tp {\n\t\t\tmargin: 0;\n\t\t\tpadding: 5px 14px;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin: 2px 0;\n\t\t}\n\n\t\ttable {\n\t\t\tmargin: 6px;\n\t\t\tborder-spacing: 0;\n\t\t}\n\n\t\ttable td {\n\t\t\tpadding: 2px 9px 2px 0;\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\ttable td.key {\n\t\t\tfont-weight: normal;\n\t\t}\n\t\ttable td.key.total {\n\t\t\tfont-weight: bold;\n\t\t}\n\t\ttable td.value {\n\t\t\ttext-align: right;\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\ttable tr.highlight td {\n\t\t\tpadding: 1px 9px 1px 0;\n\t\t\tborder-bottom-style: solid;\n\t\t\tborder-bottom-width: 1px;\n\t\t\tborder-top-style: solid;\n\t\t\tborder-top-width: 1px;\n\t\t}\n\n\t\ttable td.legend-color-guide div {\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\ttable td.legend-color-guide div {\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t\tborder: 1px solid #999;\n\t\t}\n\n\t\t.footer {\n\t\t\tpadding: 3px;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n}\n\n&:global(.nvtooltip-pending-removal) {\n\tpointer-events: none;\n\tdisplay: none;\n}\n","@dark-tooltip-background: rgba(0, 0, 0, 0.8);\n@dark-tooltip-color: #fff;\n@dark-tooltip-border-radius: 3px;\n@dark-tooltip-padding: 16px;\n\n&:global(.nvtooltip) {\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 0;\n\n\t:global {\n\t\t.dark-dialog {\n\t\t\tbackground: @dark-tooltip-background;\n\t\t\tmargin: 0;\n\t\t\tpadding: @dark-tooltip-padding;\n\t\t\tborder-radius: @dark-tooltip-border-radius;\n\t\t\tcolor: @dark-tooltip-color;\n\n\t\t\t.tooltip-label {\n\t\t\t\tline-height: 12px;\n\t\t\t}\n\t\t}\n\n\t\t.dark-dialog::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\tborder-style: solid;\n\t\t\tborder-width: 6px;\n\t\t\tborder-color: transparent;\n\t\t}\n\n\t\t.dark-dialog table {\n\t\t\tmargin: 0;\n\t\t\tmin-width: 100%;\n\n\t\t\ttr th,\n\t\t\ttr td {\n\t\t\t\tcolor: @dark-tooltip-color;\n\t\t\t\tpadding: 0 8px 8px 0;\n\t\t\t}\n\t\t\ttr:last-child th,\n\t\t\ttr:last-child td {\n\t\t\t\tpadding-bottom: 0;\n\t\t\t}\n\t\t\ttr td:last-child,\n\t\t\ttr th:last-child {\n\t\t\t\tpadding-right: 0;\n\t\t\t}\n\n\t\t\ttr.tooltip-data {\n\t\t\t\tth {\n\t\t\t\t\tfont-weight: 200;\n\t\t\t\t}\n\t\t\t\ttd {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t}\n\t\t\t\tth + td:last-child {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.color-icon {\n\t\t\tposition: relative;\n\t\t\ttop: 4px;\n\t\t\twidth: 15px;\n\t\t\theight: 15px;\n\t\t\tborder: 1px solid @dark-tooltip-color;\n\t\t\tmargin-right: 5px;\n\t\t}\n\n\t\t.tooltip-data {\n\t\t\tem {\n\t\t\t\topacity: 0.7;\n\t\t\t}\n\t\t}\n\n\t\t.active.tooltip-data {\n\t\t\tem {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* tooltip is on left or right of mouse, worst-case scenario has < 50% of screen */\n\t&:global(.nv-s),\n\t&:global(.nv-n),\n\t&:global(.nv-e),\n\t&:global(.nv-w) {\n\t\tmax-width: 45%;\n\t\twhite-space: normal;\n\t}\n\n\t&:global(.nv-w .dark-dialog)::after,\n\t&:global(.nv-e .dark-dialog)::after {\n\t\ttop: ~'calc(50%)';\n\t\tborder-color: transparent @dark-tooltip-background;\n\t}\n\n\t&:global(.nv-n .dark-dialog)::after,\n\t&:global(.nv-s .dark-dialog)::after {\n\t\tleft: ~'calc(50%)';\n\t\tborder-color: @dark-tooltip-background transparent;\n\t}\n\t&:global(.nv-w .dark-dialog)::after {\n\t\tleft: -6px;\n\t\tborder-left-width: 0;\n\t}\n\t&:global(.nv-e .dark-dialog)::after {\n\t\tright: -6px;\n\t\tborder-right-width: 0;\n\t}\n\t&:global(.nv-n .dark-dialog)::after {\n\t\ttop: -6px;\n\t\tborder-top-width: 0;\n\t}\n\t&:global(.nv-s .dark-dialog)::after {\n\t\tbottom: -6px;\n\t\tborder-bottom-width: 0;\n\t}\n}\n",".map-container {\n\tposition: relative;\n}\n\n.mapboxgl-map {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\t\n\twidth: 100%;\n\theight: 100%;\n}\n\n.legend-container-inside {\n\tbox-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tbackground-color: #fff;\n\tpadding: 10px;\n\tmargin: 0;\n\tbox-sizing: border-box;\n}\n\n.home-button-container {\n\tbackground-color: #fff;\n}\n\n.home-button {\n\theight: 29px;\n\twidth: 29px;\n\tbox-shadow: 0 0 0 2px rgba(0, 0 ,0, 0.1);\n\tborder: 0;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: block;\n\toutline: none;\n\toverflow: hidden;\n\tborder-radius: 4px;\n\tpadding: 0;\n\tbackground: transparent\n}\n\n.home-button:hover{\n\tbackground-color: rgb(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dq": "index__dq_L2HzA",
	"dqTooltip": "index__dqTooltip_WQ9o0",
	"dqMap": "index__dqMap_UDVdx"
};
module.exports = ___CSS_LOADER_EXPORT___;


/***/ }),

/***/ 6314:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 1354:
/***/ (function(module) {

"use strict";


module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ }),

/***/ 842:
/***/ (function(module) {

/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */
(function (global, factory) {
 true ? module.exports = factory() :
0;
})(this, (function () { 'use strict';

/* eslint-disable */

var shared, worker, mapboxgl;
// define gets called three times: one for each chunk. we rely on the order
// they're imported to know which is which
function define(_, chunk) {
if (!shared) {
    shared = chunk;
} else if (!worker) {
    worker = chunk;
} else {
    var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;"

    var sharedChunk = {};
    shared(sharedChunk);
    mapboxgl = chunk(sharedChunk);
    if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) {
        mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
    }
}
}


define(["exports"],(function(t){"use strict";var e="undefined"!=typeof self?self:{},r="2.15.0";let n;const i={API_URL:"https://api.mapbox.com",get API_URL_REGEX(){if(null==n){const t=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;try{n=null!=process.env.API_URL_REGEX?new RegExp(process.env.API_URL_REGEX):t;}catch(e){n=t;}}return n},get API_TILEJSON_REGEX(){return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i},get API_SPRITE_REGEX(){return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i},get API_FONTS_REGEX(){return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i},get API_STYLE_REGEX(){return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i},get API_CDN_URL_REGEX(){return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i},get EVENTS_URL(){if(!i.API_URL)return null;try{const t=new URL(i.API_URL);return "api.mapbox.cn"===t.hostname?"https://events.mapbox.cn/events/v2":"api.mapbox.com"===t.hostname?"https://events.mapbox.com/events/v2":null}catch(t){return null}},SESSION_PATH:"/map-sessions/v1",FEEDBACK_URL:"https://apps.mapbox.com/feedback",TILE_URL_VERSION:"v4",RASTER_URL_PREFIX:"raster/v1",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},s={supported:!1,testSupport:function(t){!l&&o&&(u?c(t):a=t);}};let a,o,l=!1,u=!1;function c(t){const e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,o),t.isContextLost())return;s.supported=!0;}catch(t){}t.deleteTexture(e),l=!0;}e.document&&(o=e.document.createElement("img"),o.onload=function(){a&&c(a),a=null,u=!0;},o.onerror=function(){l=!0,a=null;},o.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");const h="01";function p(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}var d=f;function f(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=e,this.p2x=r,this.p2y=n;}f.prototype={sampleCurveX:function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},sampleCurveY:function(t){return ((this.ay*t+this.by)*t+this.cy)*t},sampleCurveDerivativeX:function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},solveCurveX:function(t,e){if(void 0===e&&(e=1e-6),t<0)return 0;if(t>1)return 1;for(var r=t,n=0;n<8;n++){var i=this.sampleCurveX(r)-t;if(Math.abs(i)<e)return r;var s=this.sampleCurveDerivativeX(r);if(Math.abs(s)<1e-6)break;r-=i/s;}var a=0,o=1;for(r=t,n=0;n<20&&(i=this.sampleCurveX(r),!(Math.abs(i-t)<e));n++)t>i?a=r:o=r,r=.5*(o-a)+a;return r},solve:function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))}};var y=p(d),m=g;function g(t,e){this.x=t,this.y=e;}g.prototype={clone:function(){return new g(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[2]*this.x+t[3]*this.y;return this.x=t[0]*this.x+t[1]*this.y,this.y=e,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=r*this.x+e*this.y;return this.x=e*this.x-r*this.y,this.y=n,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=e.x+r*(this.x-e.x)-n*(this.y-e.y),this.y=i,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},g.convert=function(t){return t instanceof g?t:Array.isArray(t)?new g(t[0],t[1]):t};var x=p(m);const v=Math.PI/180,b=180/Math.PI;function w(t){return t*v}function _(t){return t*b}const A=[[0,0],[1,0],[1,1],[0,1]];function S(t){if(t<=0)return 0;if(t>=1)return 1;const e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}function k(t,e,r,n){const i=new y(t,e,r,n);return function(t){return i.solve(t)}}const I=k(.25,.1,.25,1);function M(t,e,r){return Math.min(r,Math.max(e,t))}function T(t,e,r){return (r=M((r-t)/(e-t),0,1))*r*(3-2*r)}function z(t,e,r){const n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i}function B(t,e,r){if(!t.length)return r(null,[]);let n=t.length;const i=new Array(t.length);let s=null;t.forEach(((t,a)=>{e(t,((t,e)=>{t&&(s=t),i[a]=e,0==--n&&r(s,i);}));}));}function E(t){const e=[];for(const r in t)e.push(t[r]);return e}function C(t,...e){for(const r of e)for(const e in r)t[e]=r[e];return t}let P=1;function D(){return P++}function V(){return function t(e){return e?(e^Math.random()*(16>>e/4)).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function L(t){return t<=1?1:Math.pow(2,Math.ceil(Math.log(t)/Math.LN2))}function F(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function R(t,e){t.forEach((t=>{e[t]&&(e[t]=e[t].bind(e));}));}function U(t,e){return -1!==t.indexOf(e,t.length-e.length)}function $(t,e,r){const n={};for(const i in t)n[i]=e.call(r||this,t[i],i,t);return n}function j(t,e,r){const n={};for(const i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function O(t){return Array.isArray(t)?t.map(O):"object"==typeof t&&t?$(t,O):t}const q={};function N(t){q[t]||("undefined"!=typeof console&&console.warn(t),q[t]=!0);}function G(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function Z(t){let e=0;for(let r,n,i=0,s=t.length,a=s-1;i<s;a=i++)r=t[i],n=t[a],e+=(n.x-r.x)*(r.y+n.y);return e}function K(){return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}function X(t){const e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,((t,r,n,i)=>{const s=n||i;return e[r]=!s||s.toLowerCase(),""})),e["max-age"]){const t=parseInt(e["max-age"],10);isNaN(t)?delete e["max-age"]:e["max-age"]=t;}return e}let J=null;function H(t){if(null==J){const e=t.navigator?t.navigator.userAgent:null;J=!!t.safari||!(!e||!(/\b(iPad|iPhone|iPod)\b/.test(e)||e.match("Safari")&&!e.match("Chrome")));}return J}function Y(t){try{const r=e[t];return r.setItem("_mapbox_test_",1),r.removeItem("_mapbox_test_"),!0}catch(t){return !1}}function W(t,e){return [t[4*e],t[4*e+1],t[4*e+2],t[4*e+3]]}const Q="mapbox-tiles";let tt=500,et=50;let rt,nt;function it(){try{return e.caches}catch(t){}}function st(){it()&&!rt&&(rt=e.caches.open(Q));}function at(t){const e=t.indexOf("?");if(e<0)return t;const r=function(t){const e=t.indexOf("?");return e>0?t.slice(e+1).split("&"):[]}(t),n=r.filter((t=>{const e=t.split("=");return "language"===e[0]||"worldview"===e[0]}));return n.length?`${t.slice(0,e)}?${n.join("&")}`:t.slice(0,e)}let ot=1/0;const lt={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(lt);class ut extends Error{constructor(t,e,r){401===e&&bt(r)&&(t+=": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"),super(t),this.status=e,this.url=r;}toString(){return `${this.name}: ${this.message} (${this.status}): ${this.url}`}}const ct=K()?()=>self.worker&&self.worker.referrer:()=>("blob:"===e.location.protocol?e.parent:e).location.href;const ht=function(t,r){if(!(/^file:/.test(n=t.url)||/^file:/.test(ct())&&!/^\w+:/.test(n))){if(e.fetch&&e.Request&&e.AbortController&&e.Request.prototype.hasOwnProperty("signal"))return function(t,r){const n=new e.AbortController,i=new e.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:ct(),referrerPolicy:t.referrerPolicy,signal:n.signal});let s=!1,a=!1;const o=(l=i.url).indexOf("sku=")>0&&bt(l);var l;"json"===t.type&&i.headers.set("Accept","application/json");const u=(n,s,l)=>{if(a)return;if(n&&"SecurityError"!==n.message&&N(n.toString()),s&&l)return c(s);const u=Date.now();e.fetch(i).then((e=>{if(e.ok){const t=o?e.clone():null;return c(e,t,u)}return r(new ut(e.statusText,e.status,t.url))})).catch((e=>{"AbortError"!==e.name&&r(new Error(`${e.message} ${t.url}`));}));},c=(n,o,l)=>{("arrayBuffer"===t.type?n.arrayBuffer():"json"===t.type?n.json():n.text()).then((t=>{a||(o&&l&&function(t,r,n){if(st(),!rt)return;const i={status:r.status,statusText:r.statusText,headers:new e.Headers};r.headers.forEach(((t,e)=>i.headers.set(e,t)));const s=X(r.headers.get("Cache-Control")||"");if(s["no-store"])return;s["max-age"]&&i.headers.set("Expires",new Date(n+1e3*s["max-age"]).toUTCString());const a=i.headers.get("Expires");a&&(new Date(a).getTime()-n<42e4||function(t,e){if(void 0===nt)try{new Response(new ReadableStream),nt=!0;}catch(t){nt=!1;}nt?e(t.body):t.blob().then(e);}(r,(r=>{const n=new e.Response(r,i);st(),rt&&rt.then((e=>e.put(at(t.url),n))).catch((t=>N(t.message)));})));}(i,o,l),s=!0,r(null,t,n.headers.get("Cache-Control"),n.headers.get("Expires")));})).catch((t=>{a||r(new Error(t.message));}));};return o?function(t,e){if(st(),!rt)return e(null);const r=at(t.url);rt.then((t=>{t.match(r).then((n=>{const i=function(t){if(!t)return !1;const e=new Date(t.headers.get("Expires")||0),r=X(t.headers.get("Cache-Control")||"");return e>Date.now()&&!r["no-cache"]}(n);t.delete(r),i&&t.put(r,n.clone()),e(null,n,i);})).catch(e);})).catch(e);}(i,u):u(null,null),{cancel:()=>{a=!0,s||n.abort();}}}(t,r);if(K()&&self.worker&&self.worker.actor)return self.worker.actor.send("getResource",t,r,void 0,!0)}var n;return function(t,r){const n=new e.XMLHttpRequest;n.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(n.responseType="arraybuffer");for(const e in t.headers)n.setRequestHeader(e,t.headers[e]);return "json"===t.type&&(n.responseType="text",n.setRequestHeader("Accept","application/json")),n.withCredentials="include"===t.credentials,n.onerror=()=>{r(new Error(n.statusText));},n.onload=()=>{if((n.status>=200&&n.status<300||0===n.status)&&null!==n.response){let e=n.response;if("json"===t.type)try{e=JSON.parse(n.response);}catch(t){return r(t)}r(null,e,n.getResponseHeader("Cache-Control"),n.getResponseHeader("Expires"));}else r(new ut(n.statusText,n.status,t.url));},n.send(t.body),{cancel:()=>n.abort()}}(t,r)},pt=function(t,e){return ht(C(t,{type:"arrayBuffer"}),e)};function dt(t){const r=e.document.createElement("a");return r.href=t,r.protocol===e.document.location.protocol&&r.host===e.document.location.host}const ft="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";let yt,mt;yt=[],mt=0;const gt=function(t,r){if(s.supported&&(t.headers||(t.headers={}),t.headers.accept="image/webp,*/*"),mt>=i.MAX_PARALLEL_IMAGE_REQUESTS){const e={requestParameters:t,callback:r,cancelled:!1,cancel(){this.cancelled=!0;}};return yt.push(e),e}mt++;let n=!1;const a=()=>{if(!n)for(n=!0,mt--;yt.length&&mt<i.MAX_PARALLEL_IMAGE_REQUESTS;){const t=yt.shift(),{requestParameters:e,callback:r,cancelled:n}=t;n||(t.cancel=gt(e,r).cancel);}},o=pt(t,((t,n,i,s)=>{a(),t?r(t):n&&(e.createImageBitmap?function(t,r){const n=new e.Blob([new Uint8Array(t)],{type:"image/png"});e.createImageBitmap(n).then((t=>{r(null,t);})).catch((t=>{r(new Error(`Could not load image because of ${t.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));}));}(n,((t,e)=>r(t,e,i,s))):function(t,r){const n=new e.Image,i=e.URL;n.onload=()=>{r(null,n),i.revokeObjectURL(n.src),n.onload=null,e.requestAnimationFrame((()=>{n.src=ft;}));},n.onerror=()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));const s=new e.Blob([new Uint8Array(t)],{type:"image/png"});n.src=t.byteLength?i.createObjectURL(s):ft;}(n,((t,e)=>r(t,e,i,s))));}));return {cancel:()=>{o.cancel(),a();}}},xt="NO_ACCESS_TOKEN";function vt(t){return 0===t.indexOf("mapbox:")}function bt(t){return i.API_URL_REGEX.test(t)}function wt(t){return i.API_CDN_URL_REGEX.test(t)}function _t(t){return i.API_STYLE_REGEX.test(t)&&!At(t)}function At(t){return i.API_SPRITE_REGEX.test(t)}const St=/^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;function kt(t){const e=t.match(St);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function It(t){const e=t.params.length?`?${t.params.join("&")}`:"";return `${t.protocol}://${t.authority}${t.path}${e}`}const Mt="mapbox.eventData";function Tt(t){if(!t)return null;const r=t.split(".");if(!r||3!==r.length)return null;try{return JSON.parse(decodeURIComponent(e.atob(r[1]).split("").map((t=>"%"+("00"+t.charCodeAt(0).toString(16)).slice(-2))).join("")))}catch(t){return null}}class zt{constructor(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null;}getStorageKey(t){const r=Tt(i.ACCESS_TOKEN);let n="";return n=r&&r.u?e.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g,((t,e)=>String.fromCharCode(Number("0x"+e))))):i.ACCESS_TOKEN||"",t?`${Mt}.${t}:${n}`:`${Mt}:${n}`}fetchEventData(){const t=Y("localStorage"),r=this.getStorageKey(),n=this.getStorageKey("uuid");if(t)try{const t=e.localStorage.getItem(r);t&&(this.eventData=JSON.parse(t));const i=e.localStorage.getItem(n);i&&(this.anonId=i);}catch(t){N("Unable to read from LocalStorage");}}saveEventData(){const t=Y("localStorage"),r=this.getStorageKey(),n=this.getStorageKey("uuid");if(t)try{e.localStorage.setItem(n,this.anonId),Object.keys(this.eventData).length>=1&&e.localStorage.setItem(r,JSON.stringify(this.eventData));}catch(t){N("Unable to write to LocalStorage");}}processRequests(t){}postEvent(t,e,r,n){if(!i.EVENTS_URL)return;const s=kt(i.EVENTS_URL);s.params.push(`access_token=${n||i.ACCESS_TOKEN||""}`);const a={event:this.type,created:new Date(t).toISOString()},o=e?C(a,e):a,l={url:It(s),headers:{"Content-Type":"text/plain"},body:JSON.stringify([o])};this.pendingRequest=function(t,e){return ht(C(t,{method:"POST"}),e)}(l,(t=>{this.pendingRequest=null,r(t),this.saveEventData(),this.processRequests(n);}));}queueRequest(t,e){this.queue.push(t),this.processRequests(e);}}const Bt=new class extends zt{constructor(t){super("appUserTurnstile"),this._customAccessToken=t;}postTurnstileEvent(t,e){i.EVENTS_URL&&i.ACCESS_TOKEN&&Array.isArray(t)&&t.some((t=>vt(t)||bt(t)))&&this.queueRequest(Date.now(),e);}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();const e=Tt(i.ACCESS_TOKEN),n=e?e.u:i.ACCESS_TOKEN;let s=n!==this.eventData.tokenU;F(this.anonId)||(this.anonId=V(),s=!0);const a=this.queue.shift();if(this.eventData.lastSuccess){const t=new Date(this.eventData.lastSuccess),e=new Date(a),r=(a-this.eventData.lastSuccess)/864e5;s=s||r>=1||r<-1||t.getDate()!==e.getDate();}else s=!0;s?this.postEvent(a,{sdkIdentifier:"mapbox-gl-js",sdkVersion:r,skuId:h,"enabled.telemetry":!1,userId:this.anonId},(t=>{t||(this.eventData.lastSuccess=a,this.eventData.tokenU=n);}),t):this.processRequests();}},Et=Bt.postTurnstileEvent.bind(Bt),Ct=new class extends zt{constructor(){super("map.load"),this.success={},this.skuToken="";}postMapLoadEvent(t,e,r,n){this.skuToken=e,this.errorCb=n,i.EVENTS_URL&&(r||i.ACCESS_TOKEN?this.queueRequest({id:t,timestamp:Date.now()},r):this.errorCb(new Error(xt)));}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;const{id:e,timestamp:n}=this.queue.shift();e&&this.success[e]||(this.anonId||this.fetchEventData(),F(this.anonId)||(this.anonId=V()),this.postEvent(n,{sdkIdentifier:"mapbox-gl-js",sdkVersion:r,skuId:h,skuToken:this.skuToken,userId:this.anonId},(t=>{t?this.errorCb(t):e&&(this.success[e]=!0);}),t));}},Pt=Ct.postMapLoadEvent.bind(Ct),Dt=new class extends zt{constructor(){super("gljs.performance");}postPerformanceEvent(t,e){i.EVENTS_URL&&(t||i.ACCESS_TOKEN)&&this.queueRequest({timestamp:Date.now(),performanceData:e},t);}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;const{timestamp:n,performanceData:i}=this.queue.shift(),s=function(t){const n=e.performance.getEntriesByType("resource"),i=e.performance.getEntriesByType("mark"),s=function(t){const e={};if(t)for(const r in t)if("other"!==r)for(const n of t[r]){const t=`${r}ResolveRangeMin`,i=`${r}ResolveRangeMax`,s=`${r}RequestCount`,a=`${r}RequestCachedCount`;e[t]=Math.min(e[t]||1/0,n.startTime),e[i]=Math.max(e[i]||-1/0,n.responseEnd);const o=t=>{void 0===e[t]&&(e[t]=0),++e[t];};void 0!==n.transferSize&&0===n.transferSize&&o(a),o(s);}return e}(function(t,e){const r={};if(t)for(const n of t){const t=e(n);void 0===r[t]&&(r[t]=[]),r[t].push(n);}return r}(n,jt)),a=e.devicePixelRatio,o=e.navigator.connection||e.navigator.mozConnection||e.navigator.webkitConnection,l={counters:[],metadata:[],attributes:[]},u=(t,e,r)=>{null!=r&&t.push({name:e,value:r.toString()});};for(const t in s)u(l.counters,t,s[t]);if(t.interactionRange[0]!==1/0&&t.interactionRange[1]!==-1/0&&(u(l.counters,"interactionRangeMin",t.interactionRange[0]),u(l.counters,"interactionRangeMax",t.interactionRange[1])),i)for(const t of Object.keys(Ut)){const e=Ut[t],r=i.find((t=>t.name===e));r&&u(l.counters,e,r.startTime);}return u(l.counters,"visibilityHidden",t.visibilityHidden),u(l.attributes,"style",function(t){if(t)for(const e of t){const t=e.name.split("?")[0];if(_t(t)){const e=t.split("/").slice(-2);if(2===e.length)return `mapbox://styles/${e[0]}/${e[1]}`}}}(n)),u(l.attributes,"terrainEnabled",t.terrainEnabled?"true":"false"),u(l.attributes,"fogEnabled",t.fogEnabled?"true":"false"),u(l.attributes,"projection",t.projection),u(l.attributes,"zoom",t.zoom),u(l.metadata,"devicePixelRatio",a),u(l.metadata,"connectionEffectiveType",o?o.effectiveType:void 0),u(l.metadata,"navigatorUserAgent",e.navigator.userAgent),u(l.metadata,"screenWidth",e.screen.width),u(l.metadata,"screenHeight",e.screen.height),u(l.metadata,"windowWidth",e.innerWidth),u(l.metadata,"windowHeight",e.innerHeight),u(l.metadata,"mapWidth",t.width/a),u(l.metadata,"mapHeight",t.height/a),u(l.metadata,"webglRenderer",t.renderer),u(l.metadata,"webglVendor",t.vendor),u(l.metadata,"sdkVersion",r),u(l.metadata,"sdkIdentifier","mapbox-gl-js"),l}(i);for(const t of s.metadata);for(const t of s.counters);for(const t of s.attributes);this.postEvent(n,s,(()=>{}),t);}},Vt=Dt.postPerformanceEvent.bind(Dt),Lt=new class extends zt{constructor(){super("map.auth"),this.success={},this.skuToken="";}getSession(t,e,r,n){if(!i.API_URL||!i.SESSION_PATH)return;const s=kt(i.API_URL+i.SESSION_PATH);s.params.push(`sku=${e||""}`),s.params.push(`access_token=${n||i.ACCESS_TOKEN||""}`);const a={url:It(s),headers:{"Content-Type":"text/plain"}};this.pendingRequest=function(t,e){return ht(C(t,{method:"GET"}),e)}(a,(t=>{this.pendingRequest=null,r(t),this.saveEventData(),this.processRequests(n);}));}getSessionAPI(t,e,r,n){this.skuToken=e,this.errorCb=n,i.SESSION_PATH&&i.API_URL&&(r||i.ACCESS_TOKEN?this.queueRequest({id:t,timestamp:Date.now()},r):this.errorCb(new Error(xt)));}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;const{id:e,timestamp:r}=this.queue.shift();e&&this.success[e]||this.getSession(r,this.skuToken,(t=>{t?this.errorCb(t):e&&(this.success[e]=!0);}),t);}},Ft=Lt.getSessionAPI.bind(Lt),Rt=new Set,Ut={create:"create",load:"load",fullLoad:"fullLoad"},$t={mark(t){e.performance.mark(t);},measure(t,r,n){e.performance.measure(t,r,n);}};function jt(t){const e=t.name.split("?")[0];return wt(e)&&e.includes("mapbox-gl.js")?"javascript":wt(e)&&e.includes("mapbox-gl.css")?"css":function(t){return i.API_FONTS_REGEX.test(t)}(e)?"fontRange":At(e)?"sprite":_t(e)?"style":function(t){return i.API_TILEJSON_REGEX.test(t)}(e)?"tilejson":"other"}const Ot=e.performance;function qt(t){const e=t?t.url.toString():void 0;return Ot.getEntriesByName(e)}let Nt,Gt,Zt,Kt;const Xt={now:()=>void 0!==Zt?Zt:e.performance.now(),setNow(t){Zt=t;},restoreNow(){Zt=void 0;},frame(t){const r=e.requestAnimationFrame(t);return {cancel:()=>e.cancelAnimationFrame(r)}},getImageData(t,r=0){const{width:n,height:i}=t;Kt||(Kt=e.document.createElement("canvas"));const s=Kt.getContext("2d",{willReadFrequently:!0});if(!s)throw new Error("failed to create canvas 2d context");return (n>Kt.width||i>Kt.height)&&(Kt.width=n,Kt.height=i),s.clearRect(-r,-r,n+2*r,i+2*r),s.drawImage(t,0,0,n,i),s.getImageData(-r,-r,n+2*r,i+2*r)},resolveURL:t=>(Nt||(Nt=e.document.createElement("a")),Nt.href=t,Nt.href),get devicePixelRatio(){return e.devicePixelRatio},get prefersReducedMotion(){return !!e.matchMedia&&(null==Gt&&(Gt=e.matchMedia("(prefers-reduced-motion: reduce)")),Gt.matches)}};function Jt(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function Ht(t,e,r){if(r&&r[t]){const n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}class Yt{constructor(t,e={}){C(this,e),this.type=t;}}class Wt extends Yt{constructor(t,e={}){super("error",C({error:t},e));}}class Qt{on(t,e){return this._listeners=this._listeners||{},Jt(t,e,this._listeners),this}off(t,e){return Ht(t,e,this._listeners),Ht(t,e,this._oneTimeListeners),this}once(t,e){return e?(this._oneTimeListeners=this._oneTimeListeners||{},Jt(t,e,this._oneTimeListeners),this):new Promise((e=>this.once(t,e)))}fire(t,e){"string"==typeof t&&(t=new Yt(t,e||{}));const r=t.type;if(this.listens(r)){t.target=this;const e=this._listeners&&this._listeners[r]?this._listeners[r].slice():[];for(const r of e)r.call(this,t);const n=this._oneTimeListeners&&this._oneTimeListeners[r]?this._oneTimeListeners[r].slice():[];for(const e of n)Ht(r,e,this._oneTimeListeners),e.call(this,t);const i=this._eventedParent;i&&(C(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),i.fire(t));}else t instanceof Wt&&console.error(t.error);return this}listens(t){return !!(this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t))}setEventedParent(t,e){return this._eventedParent=t,this._eventedParentData=e,this}}var te=JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"terrain":{"type":"terrain"},"fog":{"type":"fog"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":{},"mapbox":{}},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"background":{},"sky":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky"],"layout_background":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","private":true,"default":0,"minimum":0,"maximum":1,"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":{},"round":{},"square":{}},"default":"butt","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":{},"round":{},"miter":{}},"default":"miter","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"requires":[{"line-join":"miter"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"requires":[{"line-join":"round"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":{},"line":{},"line-center":{}},"default":"point","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"units":"pixels","requires":[{"symbol-placement":"line"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":{},"viewport-y":{},"source":{}},"default":"auto","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"units":"factor of the original icon size","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":{},"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","units":"ems","default":0,"requires":["text-field"],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field",{"!":"text-variable-anchor"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"units":"degrees","requires":["text-field",{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":{},"vertical":{}},"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","units":"ems","length":2,"default":[0,0],"requires":["text-field",{"!":"text-radial-offset"}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"requires":["text-field","icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{},"within":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"property-type":"data-constant","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":{},"equalEarth":{},"equirectangular":{},"lambertConformalConic":{},"mercator":{},"naturalEarth":{},"winkelTripel":{},"globe":{}},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"requires":["source"]}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-extrusion-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"requires":["fill-extrusion-height"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"requires":["fill-extrusion-edge-radius"]},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"requires":["fill-extrusion-edge-radius"],"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"line-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"transition":false,"units":"line widths","requires":[{"!":"line-pattern"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","transition":false,"requires":[{"!":"line-pattern"},{"source":"geojson","has":{"lineMetrics":true}}],"expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"transition":false,"requires":[{"source":"geojson","has":{"lineMetrics":true}}],"property-type":"constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"transition":false,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"transition":false,"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"units":"degrees","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":{},"nearest":{}},"default":"linear","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"transition":false,"units":"milliseconds","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"transition":false,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"background-pattern"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":{},"atmosphere":{}},"default":"atmosphere","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"requires":[{"sky-type":"atmosphere"}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","requires":[{"sky-type":"atmosphere"}],"default":10,"minimum":0,"maximum":100,"transition":false,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","requires":[{"sky-type":"gradient"}],"value":"number","default":[0,0],"length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","requires":[{"sky-type":"gradient"}],"default":90,"minimum":0,"maximum":180,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"transition":false,"requires":[{"sky-type":"gradient"}],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');function ee(t,...e){for(const r of e)for(const e in r)t[e]=r[e];return t}function re(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function ne(t){if(Array.isArray(t))return t.map(ne);if(t instanceof Object&&!(t instanceof Number||t instanceof String||t instanceof Boolean)){const e={};for(const r in t)e[r]=ne(t[r]);return e}return re(t)}class ie extends Error{constructor(t,e){super(e),this.message=e,this.key=t;}}var se=ie;class ae{constructor(t,e=[]){this.parent=t,this.bindings={};for(const[t,r]of e)this.bindings[t]=r;}concat(t){return new ae(this,t)}get(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(`${t} not found in scope.`)}has(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)}}var oe=ae;const le={kind:"null"},ue={kind:"number"},ce={kind:"string"},he={kind:"boolean"},pe={kind:"color"},de={kind:"object"},fe={kind:"value"},ye={kind:"collator"},me={kind:"formatted"},ge={kind:"resolvedImage"};function xe(t,e){return {kind:"array",itemType:t,N:e}}function ve(t){if("array"===t.kind){const e=ve(t.itemType);return "number"==typeof t.N?`array<${e}, ${t.N}>`:"value"===t.itemType.kind?"array":`array<${e}>`}return t.kind}const be=[le,ue,ce,he,pe,me,de,xe(fe),ge];function we(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!we(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else {if(t.kind===e.kind)return null;if("value"===t.kind)for(const t of be)if(!we(t,e))return null}return `Expected ${ve(t)} but found ${ve(e)} instead.`}function _e(t,e){return e.some((e=>e.kind===t.kind))}function Ae(t,e){return e.some((e=>"null"===e?null===t:"array"===e?Array.isArray(t):"object"===e?t&&!Array.isArray(t)&&"object"==typeof t:e===typeof t))}var Se,ke={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function Ie(t){return (t=Math.round(t))<0?0:t>255?255:t}function Me(t){return Ie("%"===t[t.length-1]?parseFloat(t)/100*255:parseInt(t))}function Te(t){return (e="%"===t[t.length-1]?parseFloat(t)/100:parseFloat(t))<0?0:e>1?1:e;var e;}function ze(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{Se={}.parseCSSColor=function(t){var e,r=t.replace(/ /g,"").toLowerCase();if(r in ke)return ke[r].slice();if("#"===r[0])return 4===r.length?(e=parseInt(r.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===r.length&&(e=parseInt(r.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var n=r.indexOf("("),i=r.indexOf(")");if(-1!==n&&i+1===r.length){var s=r.substr(0,n),a=r.substr(n+1,i-(n+1)).split(","),o=1;switch(s){case"rgba":if(4!==a.length)return null;o=Te(a.pop());case"rgb":return 3!==a.length?null:[Me(a[0]),Me(a[1]),Me(a[2]),o];case"hsla":if(4!==a.length)return null;o=Te(a.pop());case"hsl":if(3!==a.length)return null;var l=(parseFloat(a[0])%360+360)%360/360,u=Te(a[1]),c=Te(a[2]),h=c<=.5?c*(u+1):c+u-c*u,p=2*c-h;return [Ie(255*ze(p,h,l+1/3)),Ie(255*ze(p,h,l)),Ie(255*ze(p,h,l-1/3)),o];default:return null}}return null};}catch(t){}class Be{constructor(t,e,r,n=1){this.r=t,this.g=e,this.b=r,this.a=n;}static parse(t){if(!t)return;if(t instanceof Be)return t;if("string"!=typeof t)return;const e=Se(t);return e?new Be(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3]):void 0}toString(){const[t,e,r,n]=this.toArray();return `rgba(${Math.round(t)},${Math.round(e)},${Math.round(r)},${n})`}toArray(){const{r:t,g:e,b:r,a:n}=this;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]}toArray01(){const{r:t,g:e,b:r,a:n}=this;return 0===n?[0,0,0,0]:[t/n,e/n,r/n,n]}toArray01PremultipliedAlpha(){const{r:t,g:e,b:r,a:n}=this;return [t,e,r,n]}}Be.black=new Be(0,0,0,1),Be.white=new Be(1,1,1,1),Be.transparent=new Be(0,0,0,0),Be.red=new Be(1,0,0,1),Be.blue=new Be(0,0,1,1);var Ee=Be;class Ce{constructor(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});}compare(t,e){return this.collator.compare(t,e)}resolvedLocale(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale}}class Pe{constructor(t,e,r,n,i){this.text=t.normalize?t.normalize():t,this.image=e,this.scale=r,this.fontStack=n,this.textColor=i;}}class De{constructor(t){this.sections=t;}static fromString(t){return new De([new Pe(t,null,null,null,null)])}isEmpty(){return 0===this.sections.length||!this.sections.some((t=>0!==t.text.length||t.image&&0!==t.image.name.length))}static factory(t){return t instanceof De?t:De.fromString(t)}toString(){return 0===this.sections.length?"":this.sections.map((t=>t.text)).join("")}serialize(){const t=["format"];for(const e of this.sections){if(e.image){t.push(["image",e.image.name]);continue}t.push(e.text);const r={};e.fontStack&&(r["text-font"]=["literal",e.fontStack.split(",")]),e.scale&&(r["font-scale"]=e.scale),e.textColor&&(r["text-color"]=["rgba"].concat(e.textColor.toArray())),t.push(r);}return t}}class Ve{constructor(t){this.name=t.name,this.available=t.available;}toString(){return this.name}static fromString(t){return t?new Ve({name:t,available:!1}):null}serialize(){return ["image",this.name]}}function Le(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:`Invalid rgba value [${[t,e,r,n].join(", ")}]: 'a' must be between 0 and 1.`:`Invalid rgba value [${("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`}function Fe(t){if(null===t)return !0;if("string"==typeof t)return !0;if("boolean"==typeof t)return !0;if("number"==typeof t)return !0;if(t instanceof Ee)return !0;if(t instanceof Ce)return !0;if(t instanceof De)return !0;if(t instanceof Ve)return !0;if(Array.isArray(t)){for(const e of t)if(!Fe(e))return !1;return !0}if("object"==typeof t){for(const e in t)if(!Fe(t[e]))return !1;return !0}return !1}function Re(t){if(null===t)return le;if("string"==typeof t)return ce;if("boolean"==typeof t)return he;if("number"==typeof t)return ue;if(t instanceof Ee)return pe;if(t instanceof Ce)return ye;if(t instanceof De)return me;if(t instanceof Ve)return ge;if(Array.isArray(t)){const e=t.length;let r;for(const e of t){const t=Re(e);if(r){if(r===t)continue;r=fe;break}r=t;}return xe(r||fe,e)}return de}function Ue(t){const e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof Ee||t instanceof De||t instanceof Ve?t.toString():JSON.stringify(t)}class $e{constructor(t,e){this.type=t,this.value=e;}static parse(t,e){if(2!==t.length)return e.error(`'literal' expression requires exactly one argument, but found ${t.length-1} instead.`);if(!Fe(t[1]))return e.error("invalid value");const r=t[1];let n=Re(r);const i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new $e(n,r)}evaluate(){return this.value}eachChild(){}outputDefined(){return !0}serialize(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof Ee?["rgba"].concat(this.value.toArray()):this.value instanceof De?this.value.serialize():this.value}}var je=$e,Oe=class{constructor(t){this.name="ExpressionEvaluationError",this.message=t;}toJSON(){return this.message}};const qe={string:ce,number:ue,boolean:he,object:de};class Ne{constructor(t,e){this.type=t,this.args=e;}static parse(t,e){if(t.length<2)return e.error("Expected at least one argument.");let r,n=1;const i=t[0];if("array"===i){let i,s;if(t.length>2){const r=t[1];if("string"!=typeof r||!(r in qe)||"object"===r)return e.error('The item type argument of "array" must be one of string, number, boolean',1);i=qe[r],n++;}else i=fe;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);s=t[2],n++;}r=xe(i,s);}else r=qe[i];const s=[];for(;n<t.length;n++){const r=e.parse(t[n],n,fe);if(!r)return null;s.push(r);}return new Ne(r,s)}evaluate(t){for(let e=0;e<this.args.length;e++){const r=this.args[e].evaluate(t);if(!we(this.type,Re(r)))return r;if(e===this.args.length-1)throw new Oe(`Expected value to be of type ${ve(this.type)}, but found ${ve(Re(r))} instead.`)}return null}eachChild(t){this.args.forEach(t);}outputDefined(){return this.args.every((t=>t.outputDefined()))}serialize(){const t=this.type,e=[t.kind];if("array"===t.kind){const r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);const n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n);}}return e.concat(this.args.map((t=>t.serialize())))}}var Ge=Ne;class Ze{constructor(t){this.type=me,this.sections=t;}static parse(t,e){if(t.length<2)return e.error("Expected at least one argument.");const r=t[1];if(!Array.isArray(r)&&"object"==typeof r)return e.error("First argument must be an image or text section.");const n=[];let i=!1;for(let r=1;r<=t.length-1;++r){const s=t[r];if(i&&"object"==typeof s&&!Array.isArray(s)){i=!1;let t=null;if(s["font-scale"]&&(t=e.parse(s["font-scale"],1,ue),!t))return null;let r=null;if(s["text-font"]&&(r=e.parse(s["text-font"],1,xe(ce)),!r))return null;let a=null;if(s["text-color"]&&(a=e.parse(s["text-color"],1,pe),!a))return null;const o=n[n.length-1];o.scale=t,o.font=r,o.textColor=a;}else {const s=e.parse(t[r],1,fe);if(!s)return null;const a=s.type.kind;if("string"!==a&&"value"!==a&&"null"!==a&&"resolvedImage"!==a)return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");i=!0,n.push({content:s,scale:null,font:null,textColor:null});}}return new Ze(n)}evaluate(t){return new De(this.sections.map((e=>{const r=e.content.evaluate(t);return Re(r)===ge?new Pe("",r,null,null,null):new Pe(Ue(r),null,e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)})))}eachChild(t){for(const e of this.sections)t(e.content),e.scale&&t(e.scale),e.font&&t(e.font),e.textColor&&t(e.textColor);}outputDefined(){return !1}serialize(){const t=["format"];for(const e of this.sections){t.push(e.content.serialize());const r={};e.scale&&(r["font-scale"]=e.scale.serialize()),e.font&&(r["text-font"]=e.font.serialize()),e.textColor&&(r["text-color"]=e.textColor.serialize()),t.push(r);}return t}}class Ke{constructor(t){this.type=ge,this.input=t;}static parse(t,e){if(2!==t.length)return e.error("Expected two arguments.");const r=e.parse(t[1],1,ce);return r?new Ke(r):e.error("No image name provided.")}evaluate(t){const e=this.input.evaluate(t),r=Ve.fromString(e);return r&&t.availableImages&&(r.available=t.availableImages.indexOf(e)>-1),r}eachChild(t){t(this.input);}outputDefined(){return !1}serialize(){return ["image",this.input.serialize()]}}const Xe={"to-boolean":he,"to-color":pe,"to-number":ue,"to-string":ce};class Je{constructor(t,e){this.type=t,this.args=e;}static parse(t,e){if(t.length<2)return e.error("Expected at least one argument.");const r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");const n=Xe[r],i=[];for(let r=1;r<t.length;r++){const n=e.parse(t[r],r,fe);if(!n)return null;i.push(n);}return new Je(n,i)}evaluate(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){let e,r;for(const n of this.args){if(e=n.evaluate(t),r=null,e instanceof Ee)return e;if("string"==typeof e){const r=t.parseColor(e);if(r)return r}else if(Array.isArray(e)&&(r=e.length<3||e.length>4?`Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.`:Le(e[0],e[1],e[2],e[3]),!r))return new Ee(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new Oe(r||`Could not parse color from value '${"string"==typeof e?e:String(JSON.stringify(e))}'`)}if("number"===this.type.kind){let e=null;for(const r of this.args){if(e=r.evaluate(t),null===e)return 0;const n=Number(e);if(!isNaN(n))return n}throw new Oe(`Could not convert ${JSON.stringify(e)} to number.`)}return "formatted"===this.type.kind?De.fromString(Ue(this.args[0].evaluate(t))):"resolvedImage"===this.type.kind?Ve.fromString(Ue(this.args[0].evaluate(t))):Ue(this.args[0].evaluate(t))}eachChild(t){this.args.forEach(t);}outputDefined(){return this.args.every((t=>t.outputDefined()))}serialize(){if("formatted"===this.type.kind)return new Ze([{content:this.args[0],scale:null,font:null,textColor:null}]).serialize();if("resolvedImage"===this.type.kind)return new Ke(this.args[0]).serialize();const t=[`to-${this.type.kind}`];return this.eachChild((e=>{t.push(e.serialize());})),t}}var He=Je;const Ye=["Unknown","Point","LineString","Polygon"];var We=class{constructor(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={},this.availableImages=null,this.canonical=null,this.featureTileCoord=null,this.featureDistanceData=null;}id(){return this.feature&&void 0!==this.feature.id?this.feature.id:null}geometryType(){return this.feature?"number"==typeof this.feature.type?Ye[this.feature.type]:this.feature.type:null}geometry(){return this.feature&&"geometry"in this.feature?this.feature.geometry:null}canonicalID(){return this.canonical}properties(){return this.feature&&this.feature.properties||{}}distanceFromCenter(){if(this.featureTileCoord&&this.featureDistanceData){const t=this.featureDistanceData.center,e=this.featureDistanceData.scale,{x:r,y:n}=this.featureTileCoord;return this.featureDistanceData.bearing[0]*(r*e-t[0])+this.featureDistanceData.bearing[1]*(n*e-t[1])}return 0}parseColor(t){let e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=Ee.parse(t)),e}};class Qe{constructor(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;}evaluate(t){return this._evaluate(t,this.args)}eachChild(t){this.args.forEach(t);}outputDefined(){return !1}serialize(){return [this.name].concat(this.args.map((t=>t.serialize())))}static parse(t,e){const r=t[0],n=Qe.definitions[r];if(!n)return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`,0);const i=Array.isArray(n)?n[0]:n.type,s=Array.isArray(n)?[[n[1],n[2]]]:n.overloads,a=s.filter((([e])=>!Array.isArray(e)||e.length===t.length-1));let o=null;for(const[n,s]of a){o=new Ir(e.registry,e.path,null,e.scope);const a=[];let l=!1;for(let e=1;e<t.length;e++){const r=t[e],i=Array.isArray(n)?n[e-1]:n.type,s=o.parse(r,1+a.length,i);if(!s){l=!0;break}a.push(s);}if(!l)if(Array.isArray(n)&&n.length!==a.length)o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);else {for(let t=0;t<a.length;t++){const e=Array.isArray(n)?n[t]:n.type,r=a[t];o.concat(t+1).checkSubtype(e,r.type);}if(0===o.errors.length)return new Qe(r,i,s,a)}}if(1===a.length)e.errors.push(...o.errors);else {const r=(a.length?a:s).map((([t])=>{return e=t,Array.isArray(e)?`(${e.map(ve).join(", ")})`:`(${ve(e.type)}...)`;var e;})).join(" | "),n=[];for(let r=1;r<t.length;r++){const i=e.parse(t[r],1+n.length);if(!i)return null;n.push(ve(i.type));}e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);}return null}static register(t,e){Qe.definitions=e;for(const r in e)t[r]=Qe;}}var tr=Qe;class er{constructor(t,e,r){this.type=ye,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;}static parse(t,e){if(2!==t.length)return e.error("Expected one argument.");const r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");const n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,he);if(!n)return null;const i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,he);if(!i)return null;let s=null;return r.locale&&(s=e.parse(r.locale,1,ce),!s)?null:new er(n,i,s)}evaluate(t){return new Ce(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)}eachChild(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);}outputDefined(){return !1}serialize(){const t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]}}const rr=8192;function nr(t,e){t[0]=Math.min(t[0],e[0]),t[1]=Math.min(t[1],e[1]),t[2]=Math.max(t[2],e[0]),t[3]=Math.max(t[3],e[1]);}function ir(t,e){return !(t[0]<=e[0]||t[2]>=e[2]||t[1]<=e[1]||t[3]>=e[3])}function sr(t,e){const r=(180+t[0])/360,n=(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t[1]*Math.PI/360)))/360,i=Math.pow(2,e.z);return [Math.round(r*i*rr),Math.round(n*i*rr)]}function ar(t,e,r){const n=t[0]-e[0],i=t[1]-e[1],s=t[0]-r[0],a=t[1]-r[1];return n*a-s*i==0&&n*s<=0&&i*a<=0}function or(t,e){let r=!1;for(let a=0,o=e.length;a<o;a++){const o=e[a];for(let e=0,a=o.length;e<a-1;e++){if(ar(t,o[e],o[e+1]))return !1;(i=o[e])[1]>(n=t)[1]!=(s=o[e+1])[1]>n[1]&&n[0]<(s[0]-i[0])*(n[1]-i[1])/(s[1]-i[1])+i[0]&&(r=!r);}}var n,i,s;return r}function lr(t,e){for(let r=0;r<e.length;r++)if(or(t,e[r]))return !0;return !1}function ur(t,e,r,n){const i=n[0]-r[0],s=n[1]-r[1],a=(t[0]-r[0])*s-i*(t[1]-r[1]),o=(e[0]-r[0])*s-i*(e[1]-r[1]);return a>0&&o<0||a<0&&o>0}function cr(t,e,r){for(const u of r)for(let r=0;r<u.length-1;++r)if(0!=(o=[(a=u[r+1])[0]-(s=u[r])[0],a[1]-s[1]])[0]*(l=[(i=e)[0]-(n=t)[0],i[1]-n[1]])[1]-o[1]*l[0]&&ur(n,i,s,a)&&ur(s,a,n,i))return !0;var n,i,s,a,o,l;return !1}function hr(t,e){for(let r=0;r<t.length;++r)if(!or(t[r],e))return !1;for(let r=0;r<t.length-1;++r)if(cr(t[r],t[r+1],e))return !1;return !0}function pr(t,e){for(let r=0;r<e.length;r++)if(hr(t,e[r]))return !0;return !1}function dr(t,e,r){const n=[];for(let i=0;i<t.length;i++){const s=[];for(let n=0;n<t[i].length;n++){const a=sr(t[i][n],r);nr(e,a),s.push(a);}n.push(s);}return n}function fr(t,e,r){const n=[];for(let i=0;i<t.length;i++){const s=dr(t[i],e,r);n.push(s);}return n}function yr(t,e,r,n){if(t[0]<r[0]||t[0]>r[2]){const e=.5*n;let i=t[0]-r[0]>e?-n:r[0]-t[0]>e?n:0;0===i&&(i=t[0]-r[2]>e?-n:r[2]-t[0]>e?n:0),t[0]+=i;}nr(e,t);}function mr(t,e,r,n){const i=Math.pow(2,n.z)*rr,s=[n.x*rr,n.y*rr],a=[];if(!t)return a;for(const n of t)for(const t of n){const n=[t.x+s[0],t.y+s[1]];yr(n,e,r,i),a.push(n);}return a}function gr(t,e,r,n){const i=Math.pow(2,n.z)*rr,s=[n.x*rr,n.y*rr],a=[];if(!t)return a;for(const r of t){const t=[];for(const n of r){const r=[n.x+s[0],n.y+s[1]];nr(e,r),t.push(r);}a.push(t);}if(e[2]-e[0]<=i/2){(o=e)[0]=o[1]=1/0,o[2]=o[3]=-1/0;for(const t of a)for(const n of t)yr(n,e,r,i);}var o;return a}class xr{constructor(t,e){this.type=he,this.geojson=t,this.geometries=e;}static parse(t,e){if(2!==t.length)return e.error(`'within' expression requires exactly one argument, but found ${t.length-1} instead.`);if(Fe(t[1])){const e=t[1];if("FeatureCollection"===e.type)for(let t=0;t<e.features.length;++t){const r=e.features[t].geometry.type;if("Polygon"===r||"MultiPolygon"===r)return new xr(e,e.features[t].geometry)}else if("Feature"===e.type){const t=e.geometry.type;if("Polygon"===t||"MultiPolygon"===t)return new xr(e,e.geometry)}else if("Polygon"===e.type||"MultiPolygon"===e.type)return new xr(e,e)}return e.error("'within' expression requires valid geojson object that contains polygon geometry type.")}evaluate(t){if(null!=t.geometry()&&null!=t.canonicalID()){if("Point"===t.geometryType())return function(t,e){const r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if(!i)return !1;if("Polygon"===e.type){const s=dr(e.coordinates,n,i),a=mr(t.geometry(),r,n,i);if(!ir(r,n))return !1;for(const t of a)if(!or(t,s))return !1}if("MultiPolygon"===e.type){const s=fr(e.coordinates,n,i),a=mr(t.geometry(),r,n,i);if(!ir(r,n))return !1;for(const t of a)if(!lr(t,s))return !1}return !0}(t,this.geometries);if("LineString"===t.geometryType())return function(t,e){const r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if(!i)return !1;if("Polygon"===e.type){const s=dr(e.coordinates,n,i),a=gr(t.geometry(),r,n,i);if(!ir(r,n))return !1;for(const t of a)if(!hr(t,s))return !1}if("MultiPolygon"===e.type){const s=fr(e.coordinates,n,i),a=gr(t.geometry(),r,n,i);if(!ir(r,n))return !1;for(const t of a)if(!pr(t,s))return !1}return !0}(t,this.geometries)}return !1}eachChild(){}outputDefined(){return !0}serialize(){return ["within",this.geojson]}}var vr=xr;function br(t){if(t instanceof tr){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}if(t instanceof vr)return !1;let e=!0;return t.eachChild((t=>{e&&!br(t)&&(e=!1);})),e}function wr(t){if(t instanceof tr&&"feature-state"===t.name)return !1;let e=!0;return t.eachChild((t=>{e&&!wr(t)&&(e=!1);})),e}function _r(t,e){if(t instanceof tr&&e.indexOf(t.name)>=0)return !1;let r=!0;return t.eachChild((t=>{r&&!_r(t,e)&&(r=!1);})),r}class Ar{constructor(t,e){this.type=e.type,this.name=t,this.boundExpression=e;}static parse(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");const r=t[1];return e.scope.has(r)?new Ar(r,e.scope.get(r)):e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`,1)}evaluate(t){return this.boundExpression.evaluate(t)}eachChild(){}outputDefined(){return !1}serialize(){return ["var",this.name]}}var Sr=Ar;class kr{constructor(t,e=[],r,n=new oe,i=[]){this.registry=t,this.path=e,this.key=e.map((t=>`[${t}]`)).join(""),this.scope=n,this.errors=i,this.expectedType=r;}parse(t,e,r,n,i={}){return e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)}_parse(t,e){function r(t,e,r){return "assert"===r?new Ge(e,[t]):"coerce"===r?new He(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');const n=t[0];if("string"!=typeof n)return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`,0),null;const i=this.registry[n];if(i){let n=i.parse(t,this);if(!n)return null;if(this.expectedType){const t=this.expectedType,i=n.type;if("string"!==t.kind&&"number"!==t.kind&&"boolean"!==t.kind&&"object"!==t.kind&&"array"!==t.kind||"value"!==i.kind)if("color"!==t.kind&&"formatted"!==t.kind&&"resolvedImage"!==t.kind||"value"!==i.kind&&"string"!==i.kind){if(this.checkSubtype(t,i))return null}else n=r(n,t,e.typeAnnotation||"coerce");else n=r(n,t,e.typeAnnotation||"assert");}if(!(n instanceof je)&&"resolvedImage"!==n.type.kind&&Mr(n)){const t=new We;try{n=new je(n.type,n.evaluate(t));}catch(t){return this.error(t.message),null}}return n}return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`,0)}return this.error(void 0===t?"'undefined' value invalid. Use null instead.":"object"==typeof t?'Bare objects invalid. Use ["literal", {...}] instead.':`Expected an array, but found ${typeof t} instead.`)}concat(t,e,r){const n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new kr(this.registry,n,e||null,i,this.errors)}error(t,...e){const r=`${this.key}${e.map((t=>`[${t}]`)).join("")}`;this.errors.push(new se(r,t));}checkSubtype(t,e){const r=we(t,e);return r&&this.error(r),r}}var Ir=kr;function Mr(t){if(t instanceof Sr)return Mr(t.boundExpression);if(t instanceof tr&&"error"===t.name)return !1;if(t instanceof er)return !1;if(t instanceof vr)return !1;const e=t instanceof He||t instanceof Ge;let r=!0;return t.eachChild((t=>{r=e?r&&Mr(t):r&&t instanceof je;})),!!r&&br(t)&&_r(t,["zoom","heatmap-density","line-progress","sky-radial-progress","accumulated","is-supported-script","pitch","distance-from-center"])}function Tr(t,e){const r=t.length-1;let n,i,s=0,a=r,o=0;for(;s<=a;)if(o=Math.floor((s+a)/2),n=t[o],i=t[o+1],n<=e){if(o===r||e<i)return o;s=o+1;}else {if(!(n>e))throw new Oe("Input is not a number.");a=o-1;}return 0}class zr{constructor(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(const[t,e]of r)this.labels.push(t),this.outputs.push(e);}static parse(t,e){if(t.length-1<4)return e.error(`Expected at least 4 arguments, but found only ${t.length-1}.`);if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");const r=e.parse(t[1],1,ue);if(!r)return null;const n=[];let i=null;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(let r=1;r<t.length;r+=2){const s=1===r?-1/0:t[r],a=t[r+1],o=r,l=r+1;if("number"!=typeof s)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',o);if(n.length&&n[n.length-1][0]>=s)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',o);const u=e.parse(a,l,i);if(!u)return null;i=i||u.type,n.push([s,u]);}return new zr(i,r,n)}evaluate(t){const e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);const n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);const i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[Tr(e,n)].evaluate(t)}eachChild(t){t(this.input);for(const e of this.outputs)t(e);}outputDefined(){return this.outputs.every((t=>t.outputDefined()))}serialize(){const t=["step",this.input.serialize()];for(let e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t}}var Br=zr;function Er(t,e,r){return t*(1-r)+e*r}var Cr=Object.freeze({__proto__:null,array:function(t,e,r){return t.map(((t,n)=>Er(t,e[n],r)))},color:function(t,e,r){return new Ee(Er(t.r,e.r,r),Er(t.g,e.g,r),Er(t.b,e.b,r),Er(t.a,e.a,r))},number:Er});const Pr=.95047,Dr=1.08883,Vr=4/29,Lr=6/29,Fr=3*Lr*Lr,Rr=Lr*Lr*Lr,Ur=Math.PI/180,$r=180/Math.PI;function jr(t){return t>Rr?Math.pow(t,1/3):t/Fr+Vr}function Or(t){return t>Lr?t*t*t:Fr*(t-Vr)}function qr(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function Nr(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function Gr(t){const e=Nr(t.r),r=Nr(t.g),n=Nr(t.b),i=jr((.4124564*e+.3575761*r+.1804375*n)/Pr),s=jr((.2126729*e+.7151522*r+.072175*n)/1);return {l:116*s-16,a:500*(i-s),b:200*(s-jr((.0193339*e+.119192*r+.9503041*n)/Dr)),alpha:t.a}}function Zr(t){let e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=1*Or(e),r=Pr*Or(r),n=Dr*Or(n),new Ee(qr(3.2404542*r-1.5371385*e-.4985314*n),qr(-.969266*r+1.8760108*e+.041556*n),qr(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function Kr(t,e,r){const n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}const Xr={forward:Gr,reverse:Zr,interpolate:function(t,e,r){return {l:Er(t.l,e.l,r),a:Er(t.a,e.a,r),b:Er(t.b,e.b,r),alpha:Er(t.alpha,e.alpha,r)}}},Jr={forward:function(t){const{l:e,a:r,b:n}=Gr(t),i=Math.atan2(n,r)*$r;return {h:i<0?i+360:i,c:Math.sqrt(r*r+n*n),l:e,alpha:t.a}},reverse:function(t){const e=t.h*Ur,r=t.c;return Zr({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:Kr(t.h,e.h,r),c:Er(t.c,e.c,r),l:Er(t.l,e.l,r),alpha:Er(t.alpha,e.alpha,r)}}};var Hr=Object.freeze({__proto__:null,hcl:Jr,lab:Xr});class Yr{constructor(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(const[t,e]of i)this.labels.push(t),this.outputs.push(e);}static interpolationFactor(t,e,r,n){let i=0;if("exponential"===t.name)i=Wr(e,t.base,r,n);else if("linear"===t.name)i=Wr(e,1,r,n);else if("cubic-bezier"===t.name){const s=t.controlPoints;i=new y(s[0],s[1],s[2],s[3]).solve(Wr(e,1,r,n));}return i}static parse(t,e){let[r,n,i,...s]=t;if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){const t=n[1];if("number"!=typeof t)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:t};}else {if("cubic-bezier"!==n[0])return e.error(`Unknown interpolation type ${String(n[0])}`,1,0);{const t=n.slice(1);if(4!==t.length||t.some((t=>"number"!=typeof t||t<0||t>1)))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:t};}}if(t.length-1<4)return e.error(`Expected at least 4 arguments, but found only ${t.length-1}.`);if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(i=e.parse(i,2,ue),!i)return null;const a=[];let o=null;"interpolate-hcl"===r||"interpolate-lab"===r?o=pe:e.expectedType&&"value"!==e.expectedType.kind&&(o=e.expectedType);for(let t=0;t<s.length;t+=2){const r=s[t],n=s[t+1],i=t+3,l=t+4;if("number"!=typeof r)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',i);if(a.length&&a[a.length-1][0]>=r)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',i);const u=e.parse(n,l,o);if(!u)return null;o=o||u.type,a.push([r,u]);}return "number"===o.kind||"color"===o.kind||"array"===o.kind&&"number"===o.itemType.kind&&"number"==typeof o.N?new Yr(o,r,n,i,a):e.error(`Type ${ve(o)} is not interpolatable.`)}evaluate(t){const e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);const n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);const i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);const s=Tr(e,n),a=Yr.interpolationFactor(this.interpolation,n,e[s],e[s+1]),o=r[s].evaluate(t),l=r[s+1].evaluate(t);return "interpolate"===this.operator?Cr[this.type.kind.toLowerCase()](o,l,a):"interpolate-hcl"===this.operator?Jr.reverse(Jr.interpolate(Jr.forward(o),Jr.forward(l),a)):Xr.reverse(Xr.interpolate(Xr.forward(o),Xr.forward(l),a))}eachChild(t){t(this.input);for(const e of this.outputs)t(e);}outputDefined(){return this.outputs.every((t=>t.outputDefined()))}serialize(){let t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);const e=[this.operator,t,this.input.serialize()];for(let t=0;t<this.labels.length;t++)e.push(this.labels[t],this.outputs[t].serialize());return e}}function Wr(t,e,r,n){const i=n-r,s=t-r;return 0===i?0:1===e?s/i:(Math.pow(e,s)-1)/(Math.pow(e,i)-1)}var Qr=Yr;class tn{constructor(t,e){this.type=t,this.args=e;}static parse(t,e){if(t.length<2)return e.error("Expectected at least one argument.");let r=null;const n=e.expectedType;n&&"value"!==n.kind&&(r=n);const i=[];for(const n of t.slice(1)){const t=e.parse(n,1+i.length,r,void 0,{typeAnnotation:"omit"});if(!t)return null;r=r||t.type,i.push(t);}const s=n&&i.some((t=>we(n,t.type)));return new tn(s?fe:r,i)}evaluate(t){let e,r=null,n=0;for(const i of this.args){if(n++,r=i.evaluate(t),r&&r instanceof Ve&&!r.available&&(e||(e=r),r=null,n===this.args.length))return e;if(null!==r)break}return r}eachChild(t){this.args.forEach(t);}outputDefined(){return this.args.every((t=>t.outputDefined()))}serialize(){const t=["coalesce"];return this.eachChild((e=>{t.push(e.serialize());})),t}}var en=tn;class rn{constructor(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;}evaluate(t){return this.result.evaluate(t)}eachChild(t){for(const e of this.bindings)t(e[1]);t(this.result);}static parse(t,e){if(t.length<4)return e.error(`Expected at least 3 arguments, but found ${t.length-1} instead.`);const r=[];for(let n=1;n<t.length-1;n+=2){const i=t[n];if("string"!=typeof i)return e.error(`Expected string, but found ${typeof i} instead.`,n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);const s=e.parse(t[n+1],n+1);if(!s)return null;r.push([i,s]);}const n=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return n?new rn(r,n):null}outputDefined(){return this.result.outputDefined()}serialize(){const t=["let"];for(const[e,r]of this.bindings)t.push(e,r.serialize());return t.push(this.result.serialize()),t}}var nn=rn;class sn{constructor(t,e,r){this.type=t,this.index=e,this.input=r;}static parse(t,e){if(3!==t.length)return e.error(`Expected 2 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,ue),n=e.parse(t[2],2,xe(e.expectedType||fe));return r&&n?new sn(n.type.itemType,r,n):null}evaluate(t){const e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new Oe(`Array index out of bounds: ${e} < 0.`);if(e>=r.length)throw new Oe(`Array index out of bounds: ${e} > ${r.length-1}.`);if(e!==Math.floor(e))throw new Oe(`Array index must be an integer, but found ${e} instead.`);return r[e]}eachChild(t){t(this.index),t(this.input);}outputDefined(){return !1}serialize(){return ["at",this.index.serialize(),this.input.serialize()]}}var an=sn;class on{constructor(t,e){this.type=he,this.needle=t,this.haystack=e;}static parse(t,e){if(3!==t.length)return e.error(`Expected 2 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,fe),n=e.parse(t[2],2,fe);return r&&n?_e(r.type,[he,ce,ue,le,fe])?new on(r,n):e.error(`Expected first argument to be of type boolean, string, number or null, but found ${ve(r.type)} instead`):null}evaluate(t){const e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(null==r)return !1;if(!Ae(e,["boolean","string","number","null"]))throw new Oe(`Expected first argument to be of type boolean, string, number or null, but found ${ve(Re(e))} instead.`);if(!Ae(r,["string","array"]))throw new Oe(`Expected second argument to be of type array or string, but found ${ve(Re(r))} instead.`);return r.indexOf(e)>=0}eachChild(t){t(this.needle),t(this.haystack);}outputDefined(){return !0}serialize(){return ["in",this.needle.serialize(),this.haystack.serialize()]}}var ln=on;class un{constructor(t,e,r){this.type=ue,this.needle=t,this.haystack=e,this.fromIndex=r;}static parse(t,e){if(t.length<=2||t.length>=5)return e.error(`Expected 3 or 4 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,fe),n=e.parse(t[2],2,fe);if(!r||!n)return null;if(!_e(r.type,[he,ce,ue,le,fe]))return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${ve(r.type)} instead`);if(4===t.length){const i=e.parse(t[3],3,ue);return i?new un(r,n,i):null}return new un(r,n)}evaluate(t){const e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!Ae(e,["boolean","string","number","null"]))throw new Oe(`Expected first argument to be of type boolean, string, number or null, but found ${ve(Re(e))} instead.`);if(!Ae(r,["string","array"]))throw new Oe(`Expected second argument to be of type array or string, but found ${ve(Re(r))} instead.`);if(this.fromIndex){const n=this.fromIndex.evaluate(t);return r.indexOf(e,n)}return r.indexOf(e)}eachChild(t){t(this.needle),t(this.haystack),this.fromIndex&&t(this.fromIndex);}outputDefined(){return !1}serialize(){if(null!=this.fromIndex&&void 0!==this.fromIndex){const t=this.fromIndex.serialize();return ["index-of",this.needle.serialize(),this.haystack.serialize(),t]}return ["index-of",this.needle.serialize(),this.haystack.serialize()]}}var cn=un;class hn{constructor(t,e,r,n,i,s){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=s;}static parse(t,e){if(t.length<5)return e.error(`Expected at least 4 arguments, but found only ${t.length-1}.`);if(t.length%2!=1)return e.error("Expected an even number of arguments.");let r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);const i={},s=[];for(let a=2;a<t.length-1;a+=2){let o=t[a];const l=t[a+1];Array.isArray(o)||(o=[o]);const u=e.concat(a);if(0===o.length)return u.error("Expected at least one branch label.");for(const t of o){if("number"!=typeof t&&"string"!=typeof t)return u.error("Branch labels must be numbers or strings.");if("number"==typeof t&&Math.abs(t)>Number.MAX_SAFE_INTEGER)return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);if("number"==typeof t&&Math.floor(t)!==t)return u.error("Numeric branch labels must be integer values.");if(r){if(u.checkSubtype(r,Re(t)))return null}else r=Re(t);if(void 0!==i[String(t)])return u.error("Branch labels must be unique.");i[String(t)]=s.length;}const c=e.parse(l,a,n);if(!c)return null;n=n||c.type,s.push(c);}const a=e.parse(t[1],1,fe);if(!a)return null;const o=e.parse(t[t.length-1],t.length-1,n);return o?"value"!==a.type.kind&&e.concat(1).checkSubtype(r,a.type)?null:new hn(r,n,a,i,s,o):null}evaluate(t){const e=this.input.evaluate(t);return (Re(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)}eachChild(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);}outputDefined(){return this.outputs.every((t=>t.outputDefined()))&&this.otherwise.outputDefined()}serialize(){const t=["match",this.input.serialize()],e=Object.keys(this.cases).sort(),r=[],n={};for(const t of e){const e=n[this.cases[t]];void 0===e?(n[this.cases[t]]=r.length,r.push([this.cases[t],[t]])):r[e][1].push(t);}const i=t=>"number"===this.inputType.kind?Number(t):t;for(const[e,n]of r)t.push(1===n.length?i(n[0]):n.map(i)),t.push(this.outputs[e].serialize());return t.push(this.otherwise.serialize()),t}}var pn=hn;class dn{constructor(t,e,r){this.type=t,this.branches=e,this.otherwise=r;}static parse(t,e){if(t.length<4)return e.error(`Expected at least 3 arguments, but found only ${t.length-1}.`);if(t.length%2!=0)return e.error("Expected an odd number of arguments.");let r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);const n=[];for(let i=1;i<t.length-1;i+=2){const s=e.parse(t[i],i,he);if(!s)return null;const a=e.parse(t[i+1],i+1,r);if(!a)return null;n.push([s,a]),r=r||a.type;}const i=e.parse(t[t.length-1],t.length-1,r);return i?new dn(r,n,i):null}evaluate(t){for(const[e,r]of this.branches)if(e.evaluate(t))return r.evaluate(t);return this.otherwise.evaluate(t)}eachChild(t){for(const[e,r]of this.branches)t(e),t(r);t(this.otherwise);}outputDefined(){return this.branches.every((([t,e])=>e.outputDefined()))&&this.otherwise.outputDefined()}serialize(){const t=["case"];return this.eachChild((e=>{t.push(e.serialize());})),t}}var fn=dn;class yn{constructor(t,e,r,n){this.type=t,this.input=e,this.beginIndex=r,this.endIndex=n;}static parse(t,e){if(t.length<=2||t.length>=5)return e.error(`Expected 3 or 4 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,fe),n=e.parse(t[2],2,ue);if(!r||!n)return null;if(!_e(r.type,[xe(fe),ce,fe]))return e.error(`Expected first argument to be of type array or string, but found ${ve(r.type)} instead`);if(4===t.length){const i=e.parse(t[3],3,ue);return i?new yn(r.type,r,n,i):null}return new yn(r.type,r,n)}evaluate(t){const e=this.input.evaluate(t),r=this.beginIndex.evaluate(t);if(!Ae(e,["string","array"]))throw new Oe(`Expected first argument to be of type array or string, but found ${ve(Re(e))} instead.`);if(this.endIndex){const n=this.endIndex.evaluate(t);return e.slice(r,n)}return e.slice(r)}eachChild(t){t(this.input),t(this.beginIndex),this.endIndex&&t(this.endIndex);}outputDefined(){return !1}serialize(){if(null!=this.endIndex&&void 0!==this.endIndex){const t=this.endIndex.serialize();return ["slice",this.input.serialize(),this.beginIndex.serialize(),t]}return ["slice",this.input.serialize(),this.beginIndex.serialize()]}}var mn=yn;function gn(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function xn(t,e,r,n){return 0===n.compare(e,r)}function vn(t,e,r){const n="=="!==t&&"!="!==t;return class i{constructor(t,e,r){this.type=he,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}static parse(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");const r=t[0];let s=e.parse(t[1],1,fe);if(!s)return null;if(!gn(r,s.type))return e.concat(1).error(`"${r}" comparisons are not supported for type '${ve(s.type)}'.`);let a=e.parse(t[2],2,fe);if(!a)return null;if(!gn(r,a.type))return e.concat(2).error(`"${r}" comparisons are not supported for type '${ve(a.type)}'.`);if(s.type.kind!==a.type.kind&&"value"!==s.type.kind&&"value"!==a.type.kind)return e.error(`Cannot compare types '${ve(s.type)}' and '${ve(a.type)}'.`);n&&("value"===s.type.kind&&"value"!==a.type.kind?s=new Ge(a.type,[s]):"value"!==s.type.kind&&"value"===a.type.kind&&(a=new Ge(s.type,[a])));let o=null;if(4===t.length){if("string"!==s.type.kind&&"string"!==a.type.kind&&"value"!==s.type.kind&&"value"!==a.type.kind)return e.error("Cannot use collator to compare non-string types.");if(o=e.parse(t[3],3,ye),!o)return null}return new i(s,a,o)}evaluate(i){const s=this.lhs.evaluate(i),a=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){const e=Re(s),r=Re(a);if(e.kind!==r.kind||"string"!==e.kind&&"number"!==e.kind)throw new Oe(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`)}if(this.collator&&!n&&this.hasUntypedArgument){const t=Re(s),r=Re(a);if("string"!==t.kind||"string"!==r.kind)return e(i,s,a)}return this.collator?r(i,s,a,this.collator.evaluate(i)):e(i,s,a)}eachChild(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);}outputDefined(){return !0}serialize(){const e=[t];return this.eachChild((t=>{e.push(t.serialize());})),e}}}const bn=vn("==",(function(t,e,r){return e===r}),xn),wn=vn("!=",(function(t,e,r){return e!==r}),(function(t,e,r,n){return !xn(0,e,r,n)})),_n=vn("<",(function(t,e,r){return e<r}),(function(t,e,r,n){return n.compare(e,r)<0})),An=vn(">",(function(t,e,r){return e>r}),(function(t,e,r,n){return n.compare(e,r)>0})),Sn=vn("<=",(function(t,e,r){return e<=r}),(function(t,e,r,n){return n.compare(e,r)<=0})),kn=vn(">=",(function(t,e,r){return e>=r}),(function(t,e,r,n){return n.compare(e,r)>=0}));class In{constructor(t,e,r,n,i,s){this.type=ce,this.number=t,this.locale=e,this.currency=r,this.unit=n,this.minFractionDigits=i,this.maxFractionDigits=s;}static parse(t,e){if(3!==t.length)return e.error("Expected two arguments.");const r=e.parse(t[1],1,ue);if(!r)return null;const n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");let i=null;if(n.locale&&(i=e.parse(n.locale,1,ce),!i))return null;let s=null;if(n.currency&&(s=e.parse(n.currency,1,ce),!s))return null;let a=null;if(n.unit&&(a=e.parse(n.unit,1,ce),!a))return null;let o=null;if(n["min-fraction-digits"]&&(o=e.parse(n["min-fraction-digits"],1,ue),!o))return null;let l=null;return n["max-fraction-digits"]&&(l=e.parse(n["max-fraction-digits"],1,ue),!l)?null:new In(r,i,s,a,o,l)}evaluate(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:(this.currency?"currency":this.unit&&"unit")||"decimal",currency:this.currency?this.currency.evaluate(t):void 0,unit:this.unit?this.unit.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))}eachChild(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.unit&&t(this.unit),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits);}outputDefined(){return !1}serialize(){const t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.unit&&(t.unit=this.unit.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]}}class Mn{constructor(t){this.type=ue,this.input=t;}static parse(t,e){if(2!==t.length)return e.error(`Expected 1 argument, but found ${t.length-1} instead.`);const r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error(`Expected argument of type string or array, but found ${ve(r.type)} instead.`):new Mn(r):null}evaluate(t){const e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new Oe(`Expected value to be of type string or array, but found ${ve(Re(e))} instead.`)}eachChild(t){t(this.input);}outputDefined(){return !1}serialize(){const t=["length"];return this.eachChild((e=>{t.push(e.serialize());})),t}}const Tn={"==":bn,"!=":wn,">":An,"<":_n,">=":kn,"<=":Sn,array:Ge,at:an,boolean:Ge,case:fn,coalesce:en,collator:er,format:Ze,image:Ke,in:ln,"index-of":cn,interpolate:Qr,"interpolate-hcl":Qr,"interpolate-lab":Qr,length:Mn,let:nn,literal:je,match:pn,number:Ge,"number-format":In,object:Ge,slice:mn,step:Br,string:Ge,"to-boolean":He,"to-color":He,"to-number":He,"to-string":He,var:Sr,within:vr};function zn(t,[e,r,n,i]){e=e.evaluate(t),r=r.evaluate(t),n=n.evaluate(t);const s=i?i.evaluate(t):1,a=Le(e,r,n,s);if(a)throw new Oe(a);return new Ee(e/255*s,r/255*s,n/255*s,s)}function Bn(t,e){return t in e}function En(t,e){const r=e[t];return void 0===r?null:r}function Cn(t){return {type:t}}tr.register(Tn,{error:[{kind:"error"},[ce],(t,[e])=>{throw new Oe(e.evaluate(t))}],typeof:[ce,[fe],(t,[e])=>ve(Re(e.evaluate(t)))],"to-rgba":[xe(ue,4),[pe],(t,[e])=>e.evaluate(t).toArray()],rgb:[pe,[ue,ue,ue],zn],rgba:[pe,[ue,ue,ue,ue],zn],has:{type:he,overloads:[[[ce],(t,[e])=>Bn(e.evaluate(t),t.properties())],[[ce,de],(t,[e,r])=>Bn(e.evaluate(t),r.evaluate(t))]]},get:{type:fe,overloads:[[[ce],(t,[e])=>En(e.evaluate(t),t.properties())],[[ce,de],(t,[e,r])=>En(e.evaluate(t),r.evaluate(t))]]},"feature-state":[fe,[ce],(t,[e])=>En(e.evaluate(t),t.featureState||{})],properties:[de,[],t=>t.properties()],"geometry-type":[ce,[],t=>t.geometryType()],id:[fe,[],t=>t.id()],zoom:[ue,[],t=>t.globals.zoom],pitch:[ue,[],t=>t.globals.pitch||0],"distance-from-center":[ue,[],t=>t.distanceFromCenter()],"heatmap-density":[ue,[],t=>t.globals.heatmapDensity||0],"line-progress":[ue,[],t=>t.globals.lineProgress||0],"sky-radial-progress":[ue,[],t=>t.globals.skyRadialProgress||0],accumulated:[fe,[],t=>void 0===t.globals.accumulated?null:t.globals.accumulated],"+":[ue,Cn(ue),(t,e)=>{let r=0;for(const n of e)r+=n.evaluate(t);return r}],"*":[ue,Cn(ue),(t,e)=>{let r=1;for(const n of e)r*=n.evaluate(t);return r}],"-":{type:ue,overloads:[[[ue,ue],(t,[e,r])=>e.evaluate(t)-r.evaluate(t)],[[ue],(t,[e])=>-e.evaluate(t)]]},"/":[ue,[ue,ue],(t,[e,r])=>e.evaluate(t)/r.evaluate(t)],"%":[ue,[ue,ue],(t,[e,r])=>e.evaluate(t)%r.evaluate(t)],ln2:[ue,[],()=>Math.LN2],pi:[ue,[],()=>Math.PI],e:[ue,[],()=>Math.E],"^":[ue,[ue,ue],(t,[e,r])=>Math.pow(e.evaluate(t),r.evaluate(t))],sqrt:[ue,[ue],(t,[e])=>Math.sqrt(e.evaluate(t))],log10:[ue,[ue],(t,[e])=>Math.log(e.evaluate(t))/Math.LN10],ln:[ue,[ue],(t,[e])=>Math.log(e.evaluate(t))],log2:[ue,[ue],(t,[e])=>Math.log(e.evaluate(t))/Math.LN2],sin:[ue,[ue],(t,[e])=>Math.sin(e.evaluate(t))],cos:[ue,[ue],(t,[e])=>Math.cos(e.evaluate(t))],tan:[ue,[ue],(t,[e])=>Math.tan(e.evaluate(t))],asin:[ue,[ue],(t,[e])=>Math.asin(e.evaluate(t))],acos:[ue,[ue],(t,[e])=>Math.acos(e.evaluate(t))],atan:[ue,[ue],(t,[e])=>Math.atan(e.evaluate(t))],min:[ue,Cn(ue),(t,e)=>Math.min(...e.map((e=>e.evaluate(t))))],max:[ue,Cn(ue),(t,e)=>Math.max(...e.map((e=>e.evaluate(t))))],abs:[ue,[ue],(t,[e])=>Math.abs(e.evaluate(t))],round:[ue,[ue],(t,[e])=>{const r=e.evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[ue,[ue],(t,[e])=>Math.floor(e.evaluate(t))],ceil:[ue,[ue],(t,[e])=>Math.ceil(e.evaluate(t))],"filter-==":[he,[ce,fe],(t,[e,r])=>t.properties()[e.value]===r.value],"filter-id-==":[he,[fe],(t,[e])=>t.id()===e.value],"filter-type-==":[he,[ce],(t,[e])=>t.geometryType()===e.value],"filter-<":[he,[ce,fe],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n<i}],"filter-id-<":[he,[fe],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r<n}],"filter->":[he,[ce,fe],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n>i}],"filter-id->":[he,[fe],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r>n}],"filter-<=":[he,[ce,fe],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n<=i}],"filter-id-<=":[he,[fe],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r<=n}],"filter->=":[he,[ce,fe],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n>=i}],"filter-id->=":[he,[fe],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r>=n}],"filter-has":[he,[fe],(t,[e])=>e.value in t.properties()],"filter-has-id":[he,[],t=>null!==t.id()&&void 0!==t.id()],"filter-type-in":[he,[xe(ce)],(t,[e])=>e.value.indexOf(t.geometryType())>=0],"filter-id-in":[he,[xe(fe)],(t,[e])=>e.value.indexOf(t.id())>=0],"filter-in-small":[he,[ce,xe(fe)],(t,[e,r])=>r.value.indexOf(t.properties()[e.value])>=0],"filter-in-large":[he,[ce,xe(fe)],(t,[e,r])=>function(t,e,r,n){for(;r<=n;){const i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[e.value],r.value,0,r.value.length-1)],all:{type:he,overloads:[[[he,he],(t,[e,r])=>e.evaluate(t)&&r.evaluate(t)],[Cn(he),(t,e)=>{for(const r of e)if(!r.evaluate(t))return !1;return !0}]]},any:{type:he,overloads:[[[he,he],(t,[e,r])=>e.evaluate(t)||r.evaluate(t)],[Cn(he),(t,e)=>{for(const r of e)if(r.evaluate(t))return !0;return !1}]]},"!":[he,[he],(t,[e])=>!e.evaluate(t)],"is-supported-script":[he,[ce],(t,[e])=>{const r=t.globals&&t.globals.isSupportedScript;return !r||r(e.evaluate(t))}],upcase:[ce,[ce],(t,[e])=>e.evaluate(t).toUpperCase()],downcase:[ce,[ce],(t,[e])=>e.evaluate(t).toLowerCase()],concat:[ce,Cn(fe),(t,e)=>e.map((e=>Ue(e.evaluate(t)))).join("")],"resolved-locale":[ce,[ye],(t,[e])=>e.evaluate(t).resolvedLocale()]});var Pn=Tn;function Dn(t){return {result:"success",value:t}}function Vn(t){return {result:"error",value:t}}function Ln(t){return "data-driven"===t["property-type"]}function Fn(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function Rn(t){return !!t.expression&&t.expression.interpolated}function Un(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function $n(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function jn(t){return t}function On(t,e){const r="color"===e.type,n=t.stops&&"object"==typeof t.stops[0][0],i=n||!(n||void 0!==t.property),s=t.type||(Rn(e)?"exponential":"interval");if(r&&((t=ee({},t)).stops&&(t.stops=t.stops.map((t=>[t[0],Ee.parse(t[1])]))),t.default=Ee.parse(t.default?t.default:e.default)),t.colorSpace&&"rgb"!==t.colorSpace&&!Hr[t.colorSpace])throw new Error(`Unknown color space: ${t.colorSpace}`);let a,o,l;if("exponential"===s)a=Zn;else if("interval"===s)a=Gn;else if("categorical"===s){a=Nn,o=Object.create(null);for(const e of t.stops)o[e[0]]=e[1];l=typeof t.stops[0][0];}else {if("identity"!==s)throw new Error(`Unknown function type "${s}"`);a=Kn;}if(n){const r={},n=[];for(let e=0;e<t.stops.length;e++){const i=t.stops[e],s=i[0].zoom;void 0===r[s]&&(r[s]={zoom:s,type:t.type,property:t.property,default:t.default,stops:[]},n.push(s)),r[s].stops.push([i[0].value,i[1]]);}const i=[];for(const t of n)i.push([r[t].zoom,On(r[t],e)]);const s={name:"linear"};return {kind:"composite",interpolationType:s,interpolationFactor:Qr.interpolationFactor.bind(void 0,s),zoomStops:i.map((t=>t[0])),evaluate:({zoom:r},n)=>Zn({stops:i,base:t.base},e,r).evaluate(r,n)}}if(i){const r="exponential"===s?{name:"exponential",base:void 0!==t.base?t.base:1}:null;return {kind:"camera",interpolationType:r,interpolationFactor:Qr.interpolationFactor.bind(void 0,r),zoomStops:t.stops.map((t=>t[0])),evaluate:({zoom:r})=>a(t,e,r,o,l)}}return {kind:"source",evaluate(r,n){const i=n&&n.properties?n.properties[t.property]:void 0;return void 0===i?qn(t.default,e.default):a(t,e,i,o,l)}}}function qn(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function Nn(t,e,r,n,i){return qn(typeof r===i?n[r]:void 0,t.default,e.default)}function Gn(t,e,r){if("number"!==Un(r))return qn(t.default,e.default);const n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];const i=Tr(t.stops.map((t=>t[0])),r);return t.stops[i][1]}function Zn(t,e,r){const n=void 0!==t.base?t.base:1;if("number"!==Un(r))return qn(t.default,e.default);const i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];const s=Tr(t.stops.map((t=>t[0])),r),a=function(t,e,r,n){const i=n-r,s=t-r;return 0===i?0:1===e?s/i:(Math.pow(e,s)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[s][0],t.stops[s+1][0]),o=t.stops[s][1],l=t.stops[s+1][1];let u=Cr[e.type]||jn;if(t.colorSpace&&"rgb"!==t.colorSpace){const e=Hr[t.colorSpace];u=(t,r)=>e.reverse(e.interpolate(e.forward(t),e.forward(r),a));}return "function"==typeof o.evaluate?{evaluate(...t){const e=o.evaluate.apply(void 0,t),r=l.evaluate.apply(void 0,t);if(void 0!==e&&void 0!==r)return u(e,r,a)}}:u(o,l,a)}function Kn(t,e,r){return "color"===e.type?r=Ee.parse(r):"formatted"===e.type?r=De.fromString(r.toString()):"resolvedImage"===e.type?r=Ve.fromString(r.toString()):Un(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),qn(r,t.default,e.default)}class Xn{constructor(t,e){this.expression=t,this._warningHistory={},this._evaluator=new We,this._defaultValue=e?function(t){return "color"===t.type&&($n(t.default)||Array.isArray(t.default))?new Ee(0,0,0,0):"color"===t.type?Ee.parse(t.default)||null:void 0===t.default?null:t.default}(e):null,this._enumValues=e&&"enum"===e.type?e.values:null;}evaluateWithoutErrorHandling(t,e,r,n,i,s,a,o){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this._evaluator.canonical=n||null,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=s,this._evaluator.featureTileCoord=a||null,this._evaluator.featureDistanceData=o||null,this.expression.evaluate(this._evaluator)}evaluate(t,e,r,n,i,s,a,o){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null,this._evaluator.canonical=n||null,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=s||null,this._evaluator.featureTileCoord=a||null,this._evaluator.featureDistanceData=o||null;try{const t=this.expression.evaluate(this._evaluator);if(null==t||"number"==typeof t&&t!=t)return this._defaultValue;if(this._enumValues&&!(t in this._enumValues))throw new Oe(`Expected value to be one of ${Object.keys(this._enumValues).map((t=>JSON.stringify(t))).join(", ")}, but found ${JSON.stringify(t)} instead.`);return t}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}}}function Jn(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in Pn}function Hn(t,e){const r=new Ir(Pn,[],e?function(t){const e={color:pe,string:ce,number:ue,enum:ce,boolean:he,formatted:me,resolvedImage:ge};return "array"===t.type?xe(e[t.value]||fe,t.length):e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?Dn(new Xn(n,e)):Vn(r.errors)}class Yn{constructor(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!wr(e.expression);}evaluateWithoutErrorHandling(t,e,r,n,i,s){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,s)}evaluate(t,e,r,n,i,s){return this._styleExpression.evaluate(t,e,r,n,i,s)}}class Wn{constructor(t,e,r,n){this.kind=t,this.zoomStops=r,this._styleExpression=e,this.isStateDependent="camera"!==t&&!wr(e.expression),this.interpolationType=n;}evaluateWithoutErrorHandling(t,e,r,n,i,s){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,s)}evaluate(t,e,r,n,i,s){return this._styleExpression.evaluate(t,e,r,n,i,s)}interpolationFactor(t,e,r){return this.interpolationType?Qr.interpolationFactor(this.interpolationType,t,e,r):0}}function Qn(t,e){if("error"===(t=Hn(t,e)).result)return t;const r=t.value.expression,n=br(r);if(!n&&!Ln(e))return Vn([new se("","data expressions not supported")]);const i=_r(r,["zoom","pitch","distance-from-center"]);if(!i&&!Fn(e))return Vn([new se("","zoom expressions not supported")]);const s=ei(r);return s||i?s instanceof se?Vn([s]):s instanceof Qr&&!Rn(e)?Vn([new se("",'"interpolate" expressions cannot be used with this property')]):Dn(s?new Wn(n?"camera":"composite",t.value,s.labels,s instanceof Qr?s.interpolation:void 0):new Yn(n?"constant":"source",t.value)):Vn([new se("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])}class ti{constructor(t,e){this._parameters=t,this._specification=e,ee(this,On(this._parameters,this._specification));}static deserialize(t){return new ti(t._parameters,t._specification)}static serialize(t){return {_parameters:t._parameters,_specification:t._specification}}}function ei(t){let e=null;if(t instanceof nn)e=ei(t.result);else if(t instanceof en){for(const r of t.args)if(e=ei(r),e)break}else (t instanceof Br||t instanceof Qr)&&t.input instanceof tr&&"zoom"===t.input.name&&(e=t);return e instanceof se||t.eachChild((t=>{const r=ei(t);r instanceof se?e=r:!e&&r?e=new se("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):e&&r&&e!==r&&(e=new se("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));})),e}class ri{constructor(t,e,r,n){this.message=(t?`${t}: `:"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);}}function ni(t){const e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},s=t.style,a=t.styleSpec;let o=[];const l=Un(r);if("object"!==l)return [new ri(e,r,`object expected, ${l} found`)];for(const t in r){const l=t.split(".")[0];let u;i[l]?u=i[l]:n[l]?u=Fi:i["*"]?u=i["*"]:n["*"]&&(u=Fi),u?o=o.concat(u({key:(e?`${e}.`:e)+t,value:r[t],valueSpec:n[l]||n["*"],style:s,styleSpec:a,object:r,objectKey:t},r)):o.push(new ri(e,r[t],`unknown property "${t}"`));}for(const t in n)i[t]||n[t].required&&void 0===n[t].default&&void 0===r[t]&&o.push(new ri(e,r,`missing required property "${t}"`));return o}function ii(t){const e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,s=t.key,a=t.arrayElementValidator||Fi;if("array"!==Un(e))return [new ri(s,e,`array expected, ${Un(e)} found`)];if(r.length&&e.length!==r.length)return [new ri(s,e,`array length ${r.length} expected, length ${e.length} found`)];if(r["min-length"]&&e.length<r["min-length"])return [new ri(s,e,`array length at least ${r["min-length"]} expected, length ${e.length} found`)];let o={type:r.value,values:r.values,minimum:r.minimum,maximum:r.maximum,function:void 0};i.$version<7&&(o.function=r.function),"object"===Un(r.value)&&(o=r.value);let l=[];for(let t=0;t<e.length;t++)l=l.concat(a({array:e,arrayIndex:t,value:e[t],valueSpec:o,style:n,styleSpec:i,key:`${s}[${t}]`}));return l}function si(t){const e=t.key,r=t.value,n=t.valueSpec;let i=Un(r);if("number"===i&&r!=r&&(i="NaN"),"number"!==i)return [new ri(e,r,`number expected, ${i} found`)];if("minimum"in n){let i=n.minimum;if("array"===Un(n.minimum)&&(i=n.minimum[t.arrayIndex]),r<i)return [new ri(e,r,`${r} is less than the minimum value ${i}`)]}if("maximum"in n){let i=n.maximum;if("array"===Un(n.maximum)&&(i=n.maximum[t.arrayIndex]),r>i)return [new ri(e,r,`${r} is greater than the maximum value ${i}`)]}return []}function ai(t){const e=t.valueSpec,r=re(t.value.type);let n,i,s,a={};const o="categorical"!==r&&void 0===t.value.property,l=!o,u="array"===Un(t.value.stops)&&"array"===Un(t.value.stops[0])&&"object"===Un(t.value.stops[0][0]),c=ni({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===r)return [new ri(t.key,t.value,'identity function may not have a "stops" property')];let e=[];const n=t.value;return e=e.concat(ii({key:t.key,value:n,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:h})),"array"===Un(n)&&0===n.length&&e.push(new ri(t.key,n,"array must have at least one stop")),e},default:function(t){return Fi({key:t.key,value:t.value,valueSpec:e,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===r&&o&&c.push(new ri(t.key,t.value,'missing required property "property"')),"identity"===r||t.value.stops||c.push(new ri(t.key,t.value,'missing required property "stops"')),"exponential"===r&&t.valueSpec.expression&&!Rn(t.valueSpec)&&c.push(new ri(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(l&&!Ln(t.valueSpec)?c.push(new ri(t.key,t.value,"property functions not supported")):o&&!Fn(t.valueSpec)&&c.push(new ri(t.key,t.value,"zoom functions not supported"))),"categorical"!==r&&!u||void 0!==t.value.property||c.push(new ri(t.key,t.value,'"property" property is required')),c;function h(t){let r=[];const n=t.value,o=t.key;if("array"!==Un(n))return [new ri(o,n,`array expected, ${Un(n)} found`)];if(2!==n.length)return [new ri(o,n,`array length 2 expected, length ${n.length} found`)];if(u){if("object"!==Un(n[0]))return [new ri(o,n,`object expected, ${Un(n[0])} found`)];if(void 0===n[0].zoom)return [new ri(o,n,"object stop key must have zoom")];if(void 0===n[0].value)return [new ri(o,n,"object stop key must have value")];const e=re(n[0].zoom);if("number"!=typeof e)return [new ri(o,n[0].zoom,"stop zoom values must be numbers")];if(s&&s>e)return [new ri(o,n[0].zoom,"stop zoom values must appear in ascending order")];e!==s&&(s=e,i=void 0,a={}),r=r.concat(ni({key:`${o}[0]`,value:n[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:si,value:p}}));}else r=r.concat(p({key:`${o}[0]`,value:n[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},n));return Jn(ne(n[1]))?r.concat([new ri(`${o}[1]`,n[1],"expressions are not allowed in function stops.")]):r.concat(Fi({key:`${o}[1]`,value:n[1],valueSpec:e,style:t.style,styleSpec:t.styleSpec}))}function p(t,s){const o=Un(t.value),l=re(t.value),u=null!==t.value?t.value:s;if(n){if(o!==n)return [new ri(t.key,u,`${o} stop domain type must match previous stop domain type ${n}`)]}else n=o;if("number"!==o&&"string"!==o&&"boolean"!==o&&"number"!=typeof l&&"string"!=typeof l&&"boolean"!=typeof l)return [new ri(t.key,u,"stop domain value must be a number, string, or boolean")];if("number"!==o&&"categorical"!==r){let n=`number expected, ${o} found`;return Ln(e)&&void 0===r&&(n+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new ri(t.key,u,n)]}return "categorical"!==r||"number"!==o||"number"==typeof l&&isFinite(l)&&Math.floor(l)===l?"categorical"!==r&&"number"===o&&"number"==typeof l&&"number"==typeof i&&void 0!==i&&l<i?[new ri(t.key,u,"stop domain values must appear in ascending order")]:(i=l,"categorical"===r&&l in a?[new ri(t.key,u,"stop domain values must be unique")]:(a[l]=!0,[])):[new ri(t.key,u,`integer expected, found ${String(l)}`)]}}function oi(t){const e=("property"===t.expressionContext?Qn:Hn)(ne(t.value),t.valueSpec);if("error"===e.result)return e.value.map((e=>new ri(`${t.key}${e.key}`,t.value,e.message)));const r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&!r.outputDefined())return [new ri(t.key,t.value,`Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)];if("property"===t.expressionContext&&"layout"===t.propertyType&&!wr(r))return [new ri(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext)return li(r,t);if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!_r(r,["zoom","feature-state"]))return [new ri(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!br(r))return [new ri(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return []}function li(t,e){const r=new Set(["zoom","feature-state","pitch","distance-from-center"]);if(e.valueSpec&&e.valueSpec.expression)for(const t of e.valueSpec.expression.parameters)r.delete(t);if(0===r.size)return [];const n=[];return t instanceof tr&&r.has(t.name)?[new ri(e.key,e.value,`["${t.name}"] expression is not supported in a filter for a ${e.object.type} layer with id: ${e.object.id}`)]:(t.eachChild((t=>{n.push(...li(t,e));})),n)}function ui(t){const e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(re(r))&&i.push(new ri(e,r,`expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)):-1===Object.keys(n.values).indexOf(re(r))&&i.push(new ri(e,r,`expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)),i}function ci(t){if(!0===t||!1===t)return !0;if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":return t.length>=3&&("string"!=typeof t[1]||Array.isArray(t[2]));case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(const e of t.slice(1))if(!ci(e)&&"boolean"!=typeof e)return !1;return !0;default:return !0}}function hi(t,e="fill"){if(null==t)return {filter:()=>!0,needGeometry:!1,needFeature:!1};ci(t)||(t=xi(t));const r=t;let n=!0;try{n=function(t){if(!fi(t))return t;let e=ne(t);return di(e),e=pi(e),e}(r);}catch(t){console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(r,null,2)}\n        `);}const i=te[`filter_${e}`],s=Hn(n,i);let a=null;if("error"===s.result)throw new Error(s.value.map((t=>`${t.key}: ${t.message}`)).join(", "));a=(t,e,r)=>s.value.evaluate(t,e,{},r);let o=null,l=null;if(n!==r){const t=Hn(r,i);if("error"===t.result)throw new Error(t.value.map((t=>`${t.key}: ${t.message}`)).join(", "));o=(e,r,n,i,s)=>t.value.evaluate(e,r,{},n,void 0,void 0,i,s),l=!br(t.value.expression);}return {filter:a,dynamicFilter:o||void 0,needGeometry:gi(n),needFeature:!!l}}function pi(t){if(!Array.isArray(t))return t;const e=function(t){if(yi.has(t[0]))for(let e=1;e<t.length;e++)if(fi(t[e]))return !0;return t}(t);return !0===e?e:e.map((t=>pi(t)))}function di(t){let e=!1;const r=[];if("case"===t[0]){for(let n=1;n<t.length-1;n+=2)e=e||fi(t[n]),r.push(t[n+1]);r.push(t[t.length-1]);}else if("match"===t[0]){e=e||fi(t[1]);for(let e=2;e<t.length-1;e+=2)r.push(t[e+1]);r.push(t[t.length-1]);}else if("step"===t[0]){e=e||fi(t[1]);for(let e=1;e<t.length-1;e+=2)r.push(t[e+1]);}e&&(t.length=0,t.push("any",...r));for(let e=1;e<t.length;e++)di(t[e]);}function fi(t){if(!Array.isArray(t))return !1;if("pitch"===(e=t[0])||"distance-from-center"===e)return !0;var e;for(let e=1;e<t.length;e++)if(fi(t[e]))return !0;return !1}const yi=new Set(["in","==","!=",">",">=","<","<=","to-boolean"]);function mi(t,e){return t<e?-1:t>e?1:0}function gi(t){if(!Array.isArray(t))return !1;if("within"===t[0])return !0;for(let e=1;e<t.length;e++)if(gi(t[e]))return !0;return !1}function xi(t){if(!t)return !0;const e=t[0];return t.length<=1?"any"!==e:"=="===e?vi(t[1],t[2],"=="):"!="===e?_i(vi(t[1],t[2],"==")):"<"===e||">"===e||"<="===e||">="===e?vi(t[1],t[2],e):"any"===e?(r=t.slice(1),["any"].concat(r.map(xi))):"all"===e?["all"].concat(t.slice(1).map(xi)):"none"===e?["all"].concat(t.slice(1).map(xi).map(_i)):"in"===e?bi(t[1],t.slice(2)):"!in"===e?_i(bi(t[1],t.slice(2))):"has"===e?wi(t[1]):"!has"===e?_i(wi(t[1])):"within"!==e||t;var r;}function vi(t,e,r){switch(t){case"$type":return [`filter-type-${r}`,e];case"$id":return [`filter-id-${r}`,e];default:return [`filter-${r}`,t,e]}}function bi(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some((t=>typeof t!=typeof e[0]))?["filter-in-large",t,["literal",e.sort(mi)]]:["filter-in-small",t,["literal",e]]}}function wi(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function _i(t){return ["!",t]}function Ai(t){return ci(ne(t.value))?oi(ee({},t,{expressionContext:"filter",valueSpec:t.styleSpec[`filter_${t.layerType||"fill"}`]})):Si(t)}function Si(t){const e=t.value,r=t.key;if("array"!==Un(e))return [new ri(r,e,`array expected, ${Un(e)} found`)];const n=t.styleSpec;let i,s=[];if(e.length<1)return [new ri(r,e,"filter array must have at least 1 element")];switch(s=s.concat(ui({key:`${r}[0]`,value:e[0],valueSpec:n.filter_operator,style:t.style,styleSpec:t.styleSpec})),re(e[0])){case"<":case"<=":case">":case">=":e.length>=2&&"$type"===re(e[1])&&s.push(new ri(r,e,`"$type" cannot be use with operator "${e[0]}"`));case"==":case"!=":3!==e.length&&s.push(new ri(r,e,`filter array for operator "${e[0]}" must have 3 elements`));case"in":case"!in":e.length>=2&&(i=Un(e[1]),"string"!==i&&s.push(new ri(`${r}[1]`,e[1],`string expected, ${i} found`)));for(let a=2;a<e.length;a++)i=Un(e[a]),"$type"===re(e[1])?s=s.concat(ui({key:`${r}[${a}]`,value:e[a],valueSpec:n.geometry_type,style:t.style,styleSpec:t.styleSpec})):"string"!==i&&"number"!==i&&"boolean"!==i&&s.push(new ri(`${r}[${a}]`,e[a],`string, number, or boolean expected, ${i} found`));break;case"any":case"all":case"none":for(let n=1;n<e.length;n++)s=s.concat(Si({key:`${r}[${n}]`,value:e[n],style:t.style,styleSpec:t.styleSpec}));break;case"has":case"!has":i=Un(e[1]),2!==e.length?s.push(new ri(r,e,`filter array for "${e[0]}" operator must have 2 elements`)):"string"!==i&&s.push(new ri(`${r}[1]`,e[1],`string expected, ${i} found`));break;case"within":i=Un(e[1]),2!==e.length?s.push(new ri(r,e,`filter array for "${e[0]}" operator must have 2 elements`)):"object"!==i&&s.push(new ri(`${r}[1]`,e[1],`object expected, ${i} found`));}return s}function ki(t,e){const r=t.key,n=t.style,i=t.styleSpec,s=t.value,a=t.objectKey,o=i[`${e}_${t.layerType}`];if(!o)return [];const l=a.match(/^(.*)-transition$/);if("paint"===e&&l&&o[l[1]]&&o[l[1]].transition)return Fi({key:r,value:s,valueSpec:i.transition,style:n,styleSpec:i});const u=t.valueSpec||o[a];if(!u)return [new ri(r,s,`unknown property "${a}"`)];let c;if("string"===Un(s)&&Ln(u)&&!u.tokens&&(c=/^{([^}]+)}$/.exec(s))){const t=`\`{ "type": "identity", "property": ${c?JSON.stringify(c[1]):'"_"'} }\``;return [new ri(r,s,`"${a}" does not support interpolation syntax\nUse an identity property function instead: ${t}.`)]}const h=[];return "symbol"===t.layerType&&("text-field"===a&&n&&!n.glyphs&&h.push(new ri(r,s,'use of "text-field" requires a style "glyphs" property')),"text-font"===a&&$n(ne(s))&&"identity"===re(s.type)&&h.push(new ri(r,s,'"text-font" does not support identity functions'))),h.concat(Fi({key:t.key,value:s,valueSpec:u,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:a}))}function Ii(t){return ki(t,"paint")}function Mi(t){return ki(t,"layout")}function Ti(t){let e=[];const r=t.value,n=t.key,i=t.style,s=t.styleSpec;r.type||r.ref||e.push(new ri(n,r,'either "type" or "ref" is required'));let a=re(r.type);const o=re(r.ref);if(r.id){const s=re(r.id);for(let a=0;a<t.arrayIndex;a++){const t=i.layers[a];re(t.id)===s&&e.push(new ri(n,r.id,`duplicate layer id "${r.id}", previously used at line ${t.id.__line__}`));}}if("ref"in r){let t;["type","source","source-layer","filter","layout"].forEach((t=>{t in r&&e.push(new ri(n,r[t],`"${t}" is prohibited for ref layers`));})),i.layers.forEach((e=>{re(e.id)===o&&(t=e);})),t?t.ref?e.push(new ri(n,r.ref,"ref cannot reference another ref layer")):a=re(t.type):"string"==typeof o&&e.push(new ri(n,r.ref,`ref layer "${o}" not found`));}else if("background"!==a&&"sky"!==a)if(r.source){const t=i.sources&&i.sources[r.source],s=t&&re(t.type);t?"vector"===s&&"raster"===a?e.push(new ri(n,r.source,`layer "${r.id}" requires a raster source`)):"raster"===s&&"raster"!==a?e.push(new ri(n,r.source,`layer "${r.id}" requires a vector source`)):"vector"!==s||r["source-layer"]?"raster-dem"===s&&"hillshade"!==a?e.push(new ri(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==a||!r.paint||!r.paint["line-gradient"]&&!r.paint["line-trim-offset"]||"geojson"===s&&t.lineMetrics||e.push(new ri(n,r,`layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)):e.push(new ri(n,r,`layer "${r.id}" must specify a "source-layer"`)):e.push(new ri(n,r.source,`source "${r.source}" not found`));}else e.push(new ri(n,r,'missing required property "source"'));return e=e.concat(ni({key:n,value:r,valueSpec:s.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":()=>[],type:()=>Fi({key:`${n}.type`,value:r.type,valueSpec:s.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"}),filter:t=>Ai(ee({layerType:a},t)),layout:t=>ni({layer:r,key:t.key,value:t.value,valueSpec:{},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":t=>Mi(ee({layerType:a},t))}}),paint:t=>ni({layer:r,key:t.key,value:t.value,valueSpec:{},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":t=>Ii(ee({layerType:a},t))}})}})),e}function zi(t){const e=t.value,r=t.key,n=Un(e);return "string"!==n?[new ri(r,e,`string expected, ${n} found`)]:[]}const Bi={promoteId:function({key:t,value:e}){if("string"===Un(e))return zi({key:t,value:e});{const r=[];for(const n in e)r.push(...zi({key:`${t}.${n}`,value:e[n]}));return r}}};function Ei(t){const e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new ri(r,e,'"type" is required')];const s=re(e.type);let a;switch(s){case"vector":case"raster":case"raster-dem":return a=ni({key:r,value:e,valueSpec:n[`source_${s.replace("-","_")}`],style:t.style,styleSpec:n,objectElementValidators:Bi}),a;case"geojson":if(a=ni({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n,objectElementValidators:Bi}),e.cluster)for(const t in e.clusterProperties){const[n,i]=e.clusterProperties[t],s="string"==typeof n?[n,["accumulated"],["get",t]]:n;a.push(...oi({key:`${r}.${t}.map`,value:i,expressionContext:"cluster-map"})),a.push(...oi({key:`${r}.${t}.reduce`,value:s,expressionContext:"cluster-reduce"}));}return a;case"video":return ni({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return ni({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return [new ri(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return ui({key:`${r}.type`,value:e.type,valueSpec:{values:Ci(n)},style:i,styleSpec:n})}}function Ci(t){return t.source.reduce(((e,r)=>{const n=t[r];return "enum"===n.type.type&&(e=e.concat(Object.keys(n.type.values))),e}),[])}function Pi(t){const e=t.value,r=t.styleSpec,n=r.light,i=t.style;let s=[];const a=Un(e);if(void 0===e)return s;if("object"!==a)return s=s.concat([new ri("light",e,`object expected, ${a} found`)]),s;for(const t in e){const a=t.match(/^(.*)-transition$/);s=s.concat(a&&n[a[1]]&&n[a[1]].transition?Fi({key:t,value:e[t],valueSpec:r.transition,style:i,styleSpec:r}):n[t]?Fi({key:t,value:e[t],valueSpec:n[t],style:i,styleSpec:r}):[new ri(t,e[t],`unknown property "${t}"`)]);}return s}function Di(t){const e=t.value,r=t.key,n=t.style,i=t.styleSpec,s=i.terrain;let a=[];const o=Un(e);if(void 0===e)return a;if("object"!==o)return a=a.concat([new ri("terrain",e,`object expected, ${o} found`)]),a;for(const t in e){const r=t.match(/^(.*)-transition$/);a=a.concat(r&&s[r[1]]&&s[r[1]].transition?Fi({key:t,value:e[t],valueSpec:i.transition,style:n,styleSpec:i}):s[t]?Fi({key:t,value:e[t],valueSpec:s[t],style:n,styleSpec:i}):[new ri(t,e[t],`unknown property "${t}"`)]);}if(e.source){const t=n.sources&&n.sources[e.source],i=t&&re(t.type);t?"raster-dem"!==i&&a.push(new ri(r,e.source,`terrain cannot be used with a source of type ${String(i)}, it only be used with a "raster-dem" source type`)):a.push(new ri(r,e.source,`source "${e.source}" not found`));}else a.push(new ri(r,e,'terrain is missing required property "source"'));return a}function Vi(t){const e=t.value,r=t.style,n=t.styleSpec,i=n.fog;let s=[];const a=Un(e);if(void 0===e)return s;if("object"!==a)return s=s.concat([new ri("fog",e,`object expected, ${a} found`)]),s;for(const t in e){const a=t.match(/^(.*)-transition$/);s=s.concat(a&&i[a[1]]&&i[a[1]].transition?Fi({key:t,value:e[t],valueSpec:n.transition,style:r,styleSpec:n}):i[t]?Fi({key:t,value:e[t],valueSpec:i[t],style:r,styleSpec:n}):[new ri(t,e[t],`unknown property "${t}"`)]);}return s}const Li={"*":()=>[],array:ii,boolean:function(t){const e=t.value,r=t.key,n=Un(e);return "boolean"!==n?[new ri(r,e,`boolean expected, ${n} found`)]:[]},number:si,color:function(t){const e=t.key,r=t.value,n=Un(r);return "string"!==n?[new ri(e,r,`color expected, ${n} found`)]:null===Se(r)?[new ri(e,r,`color expected, "${r}" found`)]:[]},enum:ui,filter:Ai,function:ai,layer:Ti,object:ni,source:Ei,light:Pi,terrain:Di,fog:Vi,string:zi,formatted:function(t){return 0===zi(t).length?[]:oi(t)},resolvedImage:function(t){return 0===zi(t).length?[]:oi(t)},projection:function(t){const e=t.value,r=t.styleSpec,n=r.projection,i=t.style;let s=[];const a=Un(e);if("object"===a)for(const t in e)s=s.concat(Fi({key:t,value:e[t],valueSpec:n[t],style:i,styleSpec:r}));else "string"!==a&&(s=s.concat([new ri("projection",e,`object or string expected, ${a} found`)]));return s}};function Fi(t){const e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&$n(re(e))?ai(t):r.expression&&Jn(ne(e))?oi(t):r.type&&Li[r.type]?Li[r.type](t):ni(ee({},t,{valueSpec:r.type?n[r.type]:r}))}function Ri(t){const e=t.value,r=t.key,n=zi(t);return n.length||(-1===e.indexOf("{fontstack}")&&n.push(new ri(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new ri(r,e,'"glyphs" url must include a "{range}" token'))),n}function Ui(t,e=te){return Oi(Fi({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:Ri,"*":()=>[]}}))}const $i=t=>Oi(Ii(t)),ji=t=>Oi(Mi(t));function Oi(t){return t.slice().sort(((t,e)=>t.line&&e.line?t.line-e.line:0))}function qi(t,e){let r=!1;if(e&&e.length)for(const n of e)t.fire(new Wt(new Error(n.message))),r=!0;return r}var Ni=Zi,Gi=3;function Zi(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],this.d=(e=i[1])+2*(r=i[2]);for(var s=0;s<this.d*this.d;s++){var a=i[Gi+s],o=i[Gi+s+1];n.push(a===o?null:i.subarray(a,o));}var l=i[Gi+n.length+1];this.keys=i.subarray(i[Gi+n.length],l),this.bboxes=i.subarray(l),this.insert=this._insertReadonly;}else {this.d=e+2*r;for(var u=0;u<this.d*this.d;u++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var c=r/e*t;this.min=-c,this.max=t+c;}Zi.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},Zi.prototype._insertReadonly=function(){throw "Cannot insert into a GridIndex created from an ArrayBuffer."},Zi.prototype._insertCell=function(t,e,r,n,i,s){this.cells[i].push(s);},Zi.prototype.query=function(t,e,r,n,i){var s=this.min,a=this.max;if(t<=s&&e<=s&&a<=r&&a<=n&&!i)return Array.prototype.slice.call(this.keys);var o=[];return this._forEachCell(t,e,r,n,this._queryCell,o,{},i),o},Zi.prototype._queryCell=function(t,e,r,n,i,s,a,o){var l=this.cells[i];if(null!==l)for(var u=this.keys,c=this.bboxes,h=0;h<l.length;h++){var p=l[h];if(void 0===a[p]){var d=4*p;(o?o(c[d+0],c[d+1],c[d+2],c[d+3]):t<=c[d+2]&&e<=c[d+3]&&r>=c[d+0]&&n>=c[d+1])?(a[p]=!0,s.push(u[p])):a[p]=!1;}}},Zi.prototype._forEachCell=function(t,e,r,n,i,s,a,o){for(var l=this._convertToCellCoord(t),u=this._convertToCellCoord(e),c=this._convertToCellCoord(r),h=this._convertToCellCoord(n),p=l;p<=c;p++)for(var d=u;d<=h;d++){var f=this.d*d+p;if((!o||o(this._convertFromCellCoord(p),this._convertFromCellCoord(d),this._convertFromCellCoord(p+1),this._convertFromCellCoord(d+1)))&&i.call(this,t,e,r,n,f,s,a,o))return}},Zi.prototype._convertFromCellCoord=function(t){return (t-this.padding)/this.scale},Zi.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},Zi.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=Gi+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var s=e,a=0;a<t.length;a++){var o=t[a];i[Gi+a]=s,i.set(o,s),s+=o.length;}return i[Gi+t.length]=s,i.set(this.keys,s),i[Gi+t.length+1]=s+=this.keys.length,i.set(this.bboxes,s),s+=this.bboxes.length,i.buffer};var Ki=p(Ni);const Xi={};function Ji(t,e,r={}){Object.defineProperty(t,"_classRegistryKey",{value:e,writeable:!1}),Xi[e]={klass:t,omit:r.omit||[]};}Ji(Object,"Object"),Ki.serialize=function(t,e){const r=t.toArrayBuffer();return e&&e.push(r),{buffer:r}},Ki.deserialize=function(t){return new Ki(t.buffer)},Object.defineProperty(Ki,"name",{value:"Grid"}),Ji(Ki,"Grid"),Ji(Ee,"Color"),Ji(Error,"Error"),Ji(ut,"AJAXError"),Ji(Ve,"ResolvedImage"),Ji(ti,"StylePropertyFunction"),Ji(Xn,"StyleExpression",{omit:["_evaluator"]}),Ji(Wn,"ZoomDependentExpression"),Ji(Yn,"ZoomConstantExpression"),Ji(tr,"CompoundExpression",{omit:["_evaluate"]});for(const t in Pn)Xi[Pn[t]._classRegistryKey]||Ji(Pn[t],`Expression${t}`);function Hi(t){return t&&"undefined"!=typeof ArrayBuffer&&(t instanceof ArrayBuffer||t.constructor&&"ArrayBuffer"===t.constructor.name)}function Yi(t){return e.ImageBitmap&&t instanceof e.ImageBitmap}function Wi(t,r){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(Hi(t)||Yi(t))return r&&r.push(t),t;if(ArrayBuffer.isView(t)){const e=t;return r&&r.push(e.buffer),e}if(t instanceof e.ImageData)return r&&r.push(t.data.buffer),t;if(Array.isArray(t)){const e=[];for(const n of t)e.push(Wi(n,r));return e}if("object"==typeof t){const e=t.constructor,n=e._classRegistryKey;if(!n)throw new Error(`can't serialize object of unregistered class ${n}`);const i=e.serialize?e.serialize(t,r):{};if(!e.serialize){for(const e in t)t.hasOwnProperty(e)&&(Xi[n].omit.indexOf(e)>=0||(i[e]=Wi(t[e],r)));t instanceof Error&&(i.message=t.message);}if(i.$name)throw new Error("$name property is reserved for worker serialization logic.");return "Object"!==n&&(i.$name=n),i}throw new Error("can't serialize object of type "+typeof t)}function Qi(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||Hi(t)||Yi(t)||ArrayBuffer.isView(t)||t instanceof e.ImageData)return t;if(Array.isArray(t))return t.map(Qi);if("object"==typeof t){const e=t.$name||"Object",{klass:r}=Xi[e];if(!r)throw new Error(`can't deserialize unregistered class ${e}`);if(r.deserialize)return r.deserialize(t);const n=Object.create(r.prototype);for(const e of Object.keys(t))"$name"!==e&&(n[e]=Qi(t[e]));return n}throw new Error("can't deserialize object of type "+typeof t)}const ts={"Latin-1 Supplement":t=>t>=128&&t<=255,Arabic:t=>t>=1536&&t<=1791,"Arabic Supplement":t=>t>=1872&&t<=1919,"Arabic Extended-A":t=>t>=2208&&t<=2303,"Hangul Jamo":t=>t>=4352&&t<=4607,"Unified Canadian Aboriginal Syllabics":t=>t>=5120&&t<=5759,Khmer:t=>t>=6016&&t<=6143,"Unified Canadian Aboriginal Syllabics Extended":t=>t>=6320&&t<=6399,"General Punctuation":t=>t>=8192&&t<=8303,"Letterlike Symbols":t=>t>=8448&&t<=8527,"Number Forms":t=>t>=8528&&t<=8591,"Miscellaneous Technical":t=>t>=8960&&t<=9215,"Control Pictures":t=>t>=9216&&t<=9279,"Optical Character Recognition":t=>t>=9280&&t<=9311,"Enclosed Alphanumerics":t=>t>=9312&&t<=9471,"Geometric Shapes":t=>t>=9632&&t<=9727,"Miscellaneous Symbols":t=>t>=9728&&t<=9983,"Miscellaneous Symbols and Arrows":t=>t>=11008&&t<=11263,"CJK Radicals Supplement":t=>t>=11904&&t<=12031,"Kangxi Radicals":t=>t>=12032&&t<=12255,"Ideographic Description Characters":t=>t>=12272&&t<=12287,"CJK Symbols and Punctuation":t=>t>=12288&&t<=12351,Hiragana:t=>t>=12352&&t<=12447,Katakana:t=>t>=12448&&t<=12543,Bopomofo:t=>t>=12544&&t<=12591,"Hangul Compatibility Jamo":t=>t>=12592&&t<=12687,Kanbun:t=>t>=12688&&t<=12703,"Bopomofo Extended":t=>t>=12704&&t<=12735,"CJK Strokes":t=>t>=12736&&t<=12783,"Katakana Phonetic Extensions":t=>t>=12784&&t<=12799,"Enclosed CJK Letters and Months":t=>t>=12800&&t<=13055,"CJK Compatibility":t=>t>=13056&&t<=13311,"CJK Unified Ideographs Extension A":t=>t>=13312&&t<=19903,"Yijing Hexagram Symbols":t=>t>=19904&&t<=19967,"CJK Unified Ideographs":t=>t>=19968&&t<=40959,"Yi Syllables":t=>t>=40960&&t<=42127,"Yi Radicals":t=>t>=42128&&t<=42191,"Hangul Jamo Extended-A":t=>t>=43360&&t<=43391,"Hangul Syllables":t=>t>=44032&&t<=55215,"Hangul Jamo Extended-B":t=>t>=55216&&t<=55295,"Private Use Area":t=>t>=57344&&t<=63743,"CJK Compatibility Ideographs":t=>t>=63744&&t<=64255,"Arabic Presentation Forms-A":t=>t>=64336&&t<=65023,"Vertical Forms":t=>t>=65040&&t<=65055,"CJK Compatibility Forms":t=>t>=65072&&t<=65103,"Small Form Variants":t=>t>=65104&&t<=65135,"Arabic Presentation Forms-B":t=>t>=65136&&t<=65279,"Halfwidth and Fullwidth Forms":t=>t>=65280&&t<=65519};function es(t){for(const e of t)if(is(e.charCodeAt(0)))return !0;return !1}function rs(t){for(const e of t)if(!ns(e.charCodeAt(0)))return !1;return !0}function ns(t){return !(ts.Arabic(t)||ts["Arabic Supplement"](t)||ts["Arabic Extended-A"](t)||ts["Arabic Presentation Forms-A"](t)||ts["Arabic Presentation Forms-B"](t))}function is(t){return !(746!==t&&747!==t&&(t<4352||!(ts["Bopomofo Extended"](t)||ts.Bopomofo(t)||ts["CJK Compatibility Forms"](t)&&!(t>=65097&&t<=65103)||ts["CJK Compatibility Ideographs"](t)||ts["CJK Compatibility"](t)||ts["CJK Radicals Supplement"](t)||ts["CJK Strokes"](t)||!(!ts["CJK Symbols and Punctuation"](t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||ts["CJK Unified Ideographs Extension A"](t)||ts["CJK Unified Ideographs"](t)||ts["Enclosed CJK Letters and Months"](t)||ts["Hangul Compatibility Jamo"](t)||ts["Hangul Jamo Extended-A"](t)||ts["Hangul Jamo Extended-B"](t)||ts["Hangul Jamo"](t)||ts["Hangul Syllables"](t)||ts.Hiragana(t)||ts["Ideographic Description Characters"](t)||ts.Kanbun(t)||ts["Kangxi Radicals"](t)||ts["Katakana Phonetic Extensions"](t)||ts.Katakana(t)&&12540!==t||!(!ts["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||!(!ts["Small Form Variants"](t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||ts["Unified Canadian Aboriginal Syllabics"](t)||ts["Unified Canadian Aboriginal Syllabics Extended"](t)||ts["Vertical Forms"](t)||ts["Yijing Hexagram Symbols"](t)||ts["Yi Syllables"](t)||ts["Yi Radicals"](t))))}function ss(t){return !(is(t)||function(t){return !!(ts["Latin-1 Supplement"](t)&&(167===t||169===t||174===t||177===t||188===t||189===t||190===t||215===t||247===t)||ts["General Punctuation"](t)&&(8214===t||8224===t||8225===t||8240===t||8241===t||8251===t||8252===t||8258===t||8263===t||8264===t||8265===t||8273===t)||ts["Letterlike Symbols"](t)||ts["Number Forms"](t)||ts["Miscellaneous Technical"](t)&&(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215)||ts["Control Pictures"](t)&&9251!==t||ts["Optical Character Recognition"](t)||ts["Enclosed Alphanumerics"](t)||ts["Geometric Shapes"](t)||ts["Miscellaneous Symbols"](t)&&!(t>=9754&&t<=9759)||ts["Miscellaneous Symbols and Arrows"](t)&&(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243)||ts["CJK Symbols and Punctuation"](t)||ts.Katakana(t)||ts["Private Use Area"](t)||ts["CJK Compatibility Forms"](t)||ts["Small Form Variants"](t)||ts["Halfwidth and Fullwidth Forms"](t)||8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)}(t))}function as(t){return t>=1424&&t<=2303||ts["Arabic Presentation Forms-A"](t)||ts["Arabic Presentation Forms-B"](t)}function os(t,e){return !(!e&&as(t)||t>=2304&&t<=3583||t>=3840&&t<=4255||ts.Khmer(t))}function ls(t){for(const e of t)if(as(e.charCodeAt(0)))return !0;return !1}const us="deferred",cs="loading",hs="loaded";let ps=null,ds="unavailable",fs=null;const ys=function(t){t&&"string"==typeof t&&t.indexOf("NetworkError")>-1&&(ds="error"),ps&&ps(t);};function ms(){gs.fire(new Yt("pluginStateChange",{pluginStatus:ds,pluginURL:fs}));}const gs=new Qt,xs=function(){return ds},vs=function(){if(ds!==us||!fs)throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");ds=cs,ms(),fs&&pt({url:fs},(t=>{t?ys(t):(ds=hs,ms());}));},bs={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:()=>ds===hs||null!=bs.applyArabicShaping,isLoading:()=>ds===cs,setState(t){ds=t.pluginStatus,fs=t.pluginURL;},isParsed:()=>null!=bs.applyArabicShaping&&null!=bs.processBidirectionalText&&null!=bs.processStyledBidirectionalText,getPluginURL:()=>fs};class ws{constructor(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.transition=e.transition,this.pitch=e.pitch):(this.now=0,this.fadeDuration=0,this.transition={},this.pitch=0);}isSupportedScript(t){return function(t,e){for(const r of t)if(!os(r.charCodeAt(0),e))return !1;return !0}(t,bs.isLoaded())}}class _s{constructor(t,e){this.property=t,this.value=e,this.expression=function(t,e){if($n(t))return new ti(t,e);if(Jn(t)){const r=Qn(t,e);if("error"===r.result)throw new Error(r.value.map((t=>`${t.key}: ${t.message}`)).join(", "));return r.value}{let r=t;return "string"==typeof t&&"color"===e.type&&(r=Ee.parse(t)),{kind:"constant",evaluate:()=>r}}}(void 0===e?t.specification.default:e,t.specification);}isDataDriven(){return "source"===this.expression.kind||"composite"===this.expression.kind}possiblyEvaluate(t,e,r){return this.property.possiblyEvaluate(this,t,e,r)}}class As{constructor(t){this.property=t,this.value=new _s(t,void 0);}transitioned(t,e){return new ks(this.property,this.value,e,C({},t.transition,this.transition),t.now)}untransitioned(){return new ks(this.property,this.value,null,{},0)}}class Ss{constructor(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);}getValue(t){return O(this._values[t].value.value)}setValue(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new As(this._values[t].property)),this._values[t].value=new _s(this._values[t].property,null===e?void 0:O(e));}getTransition(t){return O(this._values[t].transition)}setTransition(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new As(this._values[t].property)),this._values[t].transition=O(e)||void 0;}serialize(){const t={};for(const e of Object.keys(this._values)){const r=this.getValue(e);void 0!==r&&(t[e]=r);const n=this.getTransition(e);void 0!==n&&(t[`${e}-transition`]=n);}return t}transitioned(t,e){const r=new Is(this._properties);for(const n of Object.keys(this._values))r._values[n]=this._values[n].transitioned(t,e._values[n]);return r}untransitioned(){const t=new Is(this._properties);for(const e of Object.keys(this._values))t._values[e]=this._values[e].untransitioned();return t}}class ks{constructor(t,e,r,n,i){const s=n.delay||0,a=n.duration||0;i=i||0,this.property=t,this.value=e,this.begin=i+s,this.end=this.begin+a,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);}possiblyEvaluate(t,e,r){const n=t.now||0,i=this.value.possiblyEvaluate(t,e,r),s=this.prior;if(s){if(n>this.end)return this.prior=null,i;if(this.value.isDataDriven())return this.prior=null,i;if(n<this.begin)return s.possiblyEvaluate(t,e,r);{const a=(n-this.begin)/(this.end-this.begin);return this.property.interpolate(s.possiblyEvaluate(t,e,r),i,S(a))}}return i}}class Is{constructor(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);}possiblyEvaluate(t,e,r){const n=new zs(this._properties);for(const i of Object.keys(this._values))n._values[i]=this._values[i].possiblyEvaluate(t,e,r);return n}hasTransition(){for(const t of Object.keys(this._values))if(this._values[t].prior)return !0;return !1}}class Ms{constructor(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);}getValue(t){return O(this._values[t].value)}setValue(t,e){this._values[t]=new _s(this._values[t].property,null===e?void 0:O(e));}serialize(){const t={};for(const e of Object.keys(this._values)){const r=this.getValue(e);void 0!==r&&(t[e]=r);}return t}possiblyEvaluate(t,e,r){const n=new zs(this._properties);for(const i of Object.keys(this._values))n._values[i]=this._values[i].possiblyEvaluate(t,e,r);return n}}class Ts{constructor(t,e,r){this.property=t,this.value=e,this.parameters=r;}isConstant(){return "constant"===this.value.kind}constantOr(t){return "constant"===this.value.kind?this.value.value:t}evaluate(t,e,r,n){return this.property.evaluate(this.value,this.parameters,t,e,r,n)}}class zs{constructor(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);}get(t){return this._values[t]}}class Bs{constructor(t){this.specification=t;}possiblyEvaluate(t,e){return t.expression.evaluate(e)}interpolate(t,e,r){const n=Cr[this.specification.type];return n?n(t,e,r):t}}class Es{constructor(t,e){this.specification=t,this.overrides=e;}possiblyEvaluate(t,e,r,n){return new Ts(this,"constant"===t.expression.kind||"camera"===t.expression.kind?{kind:"constant",value:t.expression.evaluate(e,null,{},r,n)}:t.expression,e)}interpolate(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new Ts(this,{kind:"constant",value:void 0},t.parameters);const n=Cr[this.specification.type];return n?new Ts(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.parameters):t}evaluate(t,e,r,n,i,s){return "constant"===t.kind?t.value:t.evaluate(e,r,n,i,s)}}class Cs{constructor(t){this.specification=t;}possiblyEvaluate(t,e,r,n){return !!t.expression.evaluate(e,null,{},r,n)}interpolate(){return !1}}class Ps{constructor(t){this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},this.overridableProperties=[];const e=new ws(0,{});for(const r in t){const n=t[r];n.specification.overridable&&this.overridableProperties.push(r);const i=this.defaultPropertyValues[r]=new _s(n,void 0),s=this.defaultTransitionablePropertyValues[r]=new As(n);this.defaultTransitioningPropertyValues[r]=s.untransitioned(),this.defaultPossiblyEvaluatedValues[r]=i.possiblyEvaluate(e);}}}function Ds(t,e){return 256*(t=M(Math.floor(t),0,255))+M(Math.floor(e),0,255)}Ji(Es,"DataDrivenProperty"),Ji(Bs,"DataConstantProperty"),Ji(Cs,"ColorRampProperty");const Vs={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array};class Ls{constructor(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;}}class Fs{constructor(){this.isTransferred=!1,this.capacity=-1,this.resize(0);}static serialize(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}}static deserialize(t){const e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e}_trim(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());}clear(){this.length=0;}resize(t){this.reserve(t),this.length=t;}reserve(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);const e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}}_refreshViews(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")}destroy(){this.int8=this.uint8=this.int16=this.uint16=this.int32=this.uint32=this.float32=null,this.arrayBuffer=null;}}function Rs(t,e=1){let r=0,n=0;return {members:t.map((t=>{const i=Vs[t.type].BYTES_PER_ELEMENT,s=r=Us(r,Math.max(e,i)),a=t.components||1;return n=Math.max(n,i),r+=i*a,{name:t.name,type:t.type,components:a,offset:s}})),size:Us(r,Math.max(n,e)),alignment:e}}function Us(t,e){return Math.ceil(t/e)*e}class $s extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e){const r=this.length;return this.resize(r+1),this.emplace(r,t,e)}emplace(t,e,r){const n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t}}$s.prototype.bytesPerElement=4,Ji($s,"StructArrayLayout2i4");class js extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r){const n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)}emplace(t,e,r,n){const i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t}}js.prototype.bytesPerElement=6,Ji(js,"StructArrayLayout3i6");class Os extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=4*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,t}}Os.prototype.bytesPerElement=8,Ji(Os,"StructArrayLayout4i8");class qs extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a){const o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,s,a)}emplace(t,e,r,n,i,s,a,o){const l=6*t,u=12*t,c=3*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.uint8[u+4]=n,this.uint8[u+5]=i,this.uint8[u+6]=s,this.uint8[u+7]=a,this.float32[c+2]=o,t}}qs.prototype.bytesPerElement=12,Ji(qs,"StructArrayLayout2i4ub1f12");class Ns extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=4*t;return this.float32[s+0]=e,this.float32[s+1]=r,this.float32[s+2]=n,this.float32[s+3]=i,t}}Ns.prototype.bytesPerElement=16,Ji(Ns,"StructArrayLayout4f16");class Gs extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i){const s=this.length;return this.resize(s+1),this.emplace(s,t,e,r,n,i)}emplace(t,e,r,n,i,s){const a=6*t,o=3*t;return this.uint16[a+0]=e,this.uint16[a+1]=r,this.uint16[a+2]=n,this.uint16[a+3]=i,this.float32[o+2]=s,t}}Gs.prototype.bytesPerElement=12,Ji(Gs,"StructArrayLayout4ui1f12");class Zs extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=4*t;return this.uint16[s+0]=e,this.uint16[s+1]=r,this.uint16[s+2]=n,this.uint16[s+3]=i,t}}Zs.prototype.bytesPerElement=8,Ji(Zs,"StructArrayLayout4ui8");class Ks extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s){const a=this.length;return this.resize(a+1),this.emplace(a,t,e,r,n,i,s)}emplace(t,e,r,n,i,s,a){const o=6*t;return this.int16[o+0]=e,this.int16[o+1]=r,this.int16[o+2]=n,this.int16[o+3]=i,this.int16[o+4]=s,this.int16[o+5]=a,t}}Ks.prototype.bytesPerElement=12,Ji(Ks,"StructArrayLayout6i12");class Xs extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h){const p=this.length;return this.resize(p+1),this.emplace(p,t,e,r,n,i,s,a,o,l,u,c,h)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p){const d=12*t;return this.int16[d+0]=e,this.int16[d+1]=r,this.int16[d+2]=n,this.int16[d+3]=i,this.uint16[d+4]=s,this.uint16[d+5]=a,this.uint16[d+6]=o,this.uint16[d+7]=l,this.int16[d+8]=u,this.int16[d+9]=c,this.int16[d+10]=h,this.int16[d+11]=p,t}}Xs.prototype.bytesPerElement=24,Ji(Xs,"StructArrayLayout4i4ui4i24");class Js extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s){const a=this.length;return this.resize(a+1),this.emplace(a,t,e,r,n,i,s)}emplace(t,e,r,n,i,s,a){const o=10*t,l=5*t;return this.int16[o+0]=e,this.int16[o+1]=r,this.int16[o+2]=n,this.float32[l+2]=i,this.float32[l+3]=s,this.float32[l+4]=a,t}}Js.prototype.bytesPerElement=20,Ji(Js,"StructArrayLayout3i3f20");class Hs extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);}emplaceBack(t){const e=this.length;return this.resize(e+1),this.emplace(e,t)}emplace(t,e){return this.uint32[1*t+0]=e,t}}Hs.prototype.bytesPerElement=4,Ji(Hs,"StructArrayLayout1ul4");class Ys extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h,p){const d=this.length;return this.resize(d+1),this.emplace(d,t,e,r,n,i,s,a,o,l,u,c,h,p)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p,d){const f=20*t,y=10*t;return this.int16[f+0]=e,this.int16[f+1]=r,this.int16[f+2]=n,this.int16[f+3]=i,this.int16[f+4]=s,this.float32[y+3]=a,this.float32[y+4]=o,this.float32[y+5]=l,this.float32[y+6]=u,this.int16[f+14]=c,this.uint32[y+8]=h,this.uint16[f+18]=p,this.uint16[f+19]=d,t}}Ys.prototype.bytesPerElement=40,Ji(Ys,"StructArrayLayout5i4f1i1ul2ui40");class Ws extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a){const o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,s,a)}emplace(t,e,r,n,i,s,a,o){const l=8*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+4]=i,this.int16[l+5]=s,this.int16[l+6]=a,this.int16[l+7]=o,t}}Ws.prototype.bytesPerElement=16,Ji(Ws,"StructArrayLayout3i2i2i16");class Qs extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i){const s=this.length;return this.resize(s+1),this.emplace(s,t,e,r,n,i)}emplace(t,e,r,n,i,s){const a=4*t,o=8*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.int16[o+6]=i,this.int16[o+7]=s,t}}Qs.prototype.bytesPerElement=16,Ji(Qs,"StructArrayLayout2f1f2i16");class ta extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=12*t,a=3*t;return this.uint8[s+0]=e,this.uint8[s+1]=r,this.float32[a+1]=n,this.float32[a+2]=i,t}}ta.prototype.bytesPerElement=12,Ji(ta,"StructArrayLayout2ub2f12");class ea extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r){const n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)}emplace(t,e,r,n){const i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t}}ea.prototype.bytesPerElement=12,Ji(ea,"StructArrayLayout3f12");class ra extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r){const n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)}emplace(t,e,r,n){const i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t}}ra.prototype.bytesPerElement=6,Ji(ra,"StructArrayLayout3ui6");class na extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b){const w=this.length;return this.resize(w+1),this.emplace(w,t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b,w){const _=30*t,A=15*t,S=60*t;return this.int16[_+0]=e,this.int16[_+1]=r,this.int16[_+2]=n,this.float32[A+2]=i,this.float32[A+3]=s,this.uint16[_+8]=a,this.uint16[_+9]=o,this.uint32[A+5]=l,this.uint32[A+6]=u,this.uint32[A+7]=c,this.uint16[_+16]=h,this.uint16[_+17]=p,this.uint16[_+18]=d,this.float32[A+10]=f,this.float32[A+11]=y,this.uint8[S+48]=m,this.uint8[S+49]=g,this.uint8[S+50]=x,this.uint32[A+13]=v,this.int16[_+28]=b,this.uint8[S+58]=w,t}}na.prototype.bytesPerElement=60,Ji(na,"StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");class ia extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b,w,_,A,S,k,I,M,T,z){const B=this.length;return this.resize(B+1),this.emplace(B,t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b,w,_,A,S,k,I,M,T,z)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b,w,_,A,S,k,I,M,T,z,B){const E=38*t,C=19*t;return this.int16[E+0]=e,this.int16[E+1]=r,this.int16[E+2]=n,this.float32[C+2]=i,this.float32[C+3]=s,this.int16[E+8]=a,this.int16[E+9]=o,this.int16[E+10]=l,this.int16[E+11]=u,this.int16[E+12]=c,this.int16[E+13]=h,this.uint16[E+14]=p,this.uint16[E+15]=d,this.uint16[E+16]=f,this.uint16[E+17]=y,this.uint16[E+18]=m,this.uint16[E+19]=g,this.uint16[E+20]=x,this.uint16[E+21]=v,this.uint16[E+22]=b,this.uint16[E+23]=w,this.uint16[E+24]=_,this.uint16[E+25]=A,this.uint16[E+26]=S,this.uint16[E+27]=k,this.uint16[E+28]=I,this.uint32[C+15]=M,this.float32[C+16]=T,this.float32[C+17]=z,this.float32[C+18]=B,t}}ia.prototype.bytesPerElement=76,Ji(ia,"StructArrayLayout3i2f6i15ui1ul3f76");class sa extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t){const e=this.length;return this.resize(e+1),this.emplace(e,t)}emplace(t,e){return this.float32[1*t+0]=e,t}}sa.prototype.bytesPerElement=4,Ji(sa,"StructArrayLayout1f4");class aa extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i){const s=this.length;return this.resize(s+1),this.emplace(s,t,e,r,n,i)}emplace(t,e,r,n,i,s){const a=5*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,this.float32[a+4]=s,t}}aa.prototype.bytesPerElement=20,Ji(aa,"StructArrayLayout5f20");class oa extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=6*t;return this.uint32[3*t+0]=e,this.uint16[s+2]=r,this.uint16[s+3]=n,this.uint16[s+4]=i,t}}oa.prototype.bytesPerElement=12,Ji(oa,"StructArrayLayout1ul3ui12");class la extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e){const r=this.length;return this.resize(r+1),this.emplace(r,t,e)}emplace(t,e,r){const n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t}}la.prototype.bytesPerElement=4,Ji(la,"StructArrayLayout2ui4");class ua extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t){const e=this.length;return this.resize(e+1),this.emplace(e,t)}emplace(t,e){return this.uint16[1*t+0]=e,t}}ua.prototype.bytesPerElement=2,Ji(ua,"StructArrayLayout1ui2");class ca extends Fs{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e){const r=this.length;return this.resize(r+1),this.emplace(r,t,e)}emplace(t,e,r){const n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t}}ca.prototype.bytesPerElement=8,Ji(ca,"StructArrayLayout2f8");class ha extends Ls{get projectedAnchorX(){return this._structArray.int16[this._pos2+0]}get projectedAnchorY(){return this._structArray.int16[this._pos2+1]}get projectedAnchorZ(){return this._structArray.int16[this._pos2+2]}get tileAnchorX(){return this._structArray.int16[this._pos2+3]}get tileAnchorY(){return this._structArray.int16[this._pos2+4]}get x1(){return this._structArray.float32[this._pos4+3]}get y1(){return this._structArray.float32[this._pos4+4]}get x2(){return this._structArray.float32[this._pos4+5]}get y2(){return this._structArray.float32[this._pos4+6]}get padding(){return this._structArray.int16[this._pos2+14]}get featureIndex(){return this._structArray.uint32[this._pos4+8]}get sourceLayerIndex(){return this._structArray.uint16[this._pos2+18]}get bucketIndex(){return this._structArray.uint16[this._pos2+19]}}ha.prototype.size=40;class pa extends Ys{get(t){return new ha(this,t)}}Ji(pa,"CollisionBoxArray");class da extends Ls{get projectedAnchorX(){return this._structArray.int16[this._pos2+0]}get projectedAnchorY(){return this._structArray.int16[this._pos2+1]}get projectedAnchorZ(){return this._structArray.int16[this._pos2+2]}get tileAnchorX(){return this._structArray.float32[this._pos4+2]}get tileAnchorY(){return this._structArray.float32[this._pos4+3]}get glyphStartIndex(){return this._structArray.uint16[this._pos2+8]}get numGlyphs(){return this._structArray.uint16[this._pos2+9]}get vertexStartIndex(){return this._structArray.uint32[this._pos4+5]}get lineStartIndex(){return this._structArray.uint32[this._pos4+6]}get lineLength(){return this._structArray.uint32[this._pos4+7]}get segment(){return this._structArray.uint16[this._pos2+16]}get lowerSize(){return this._structArray.uint16[this._pos2+17]}get upperSize(){return this._structArray.uint16[this._pos2+18]}get lineOffsetX(){return this._structArray.float32[this._pos4+10]}get lineOffsetY(){return this._structArray.float32[this._pos4+11]}get writingMode(){return this._structArray.uint8[this._pos1+48]}get placedOrientation(){return this._structArray.uint8[this._pos1+49]}set placedOrientation(t){this._structArray.uint8[this._pos1+49]=t;}get hidden(){return this._structArray.uint8[this._pos1+50]}set hidden(t){this._structArray.uint8[this._pos1+50]=t;}get crossTileID(){return this._structArray.uint32[this._pos4+13]}set crossTileID(t){this._structArray.uint32[this._pos4+13]=t;}get associatedIconIndex(){return this._structArray.int16[this._pos2+28]}get flipState(){return this._structArray.uint8[this._pos1+58]}set flipState(t){this._structArray.uint8[this._pos1+58]=t;}}da.prototype.size=60;class fa extends na{get(t){return new da(this,t)}}Ji(fa,"PlacedSymbolArray");class ya extends Ls{get projectedAnchorX(){return this._structArray.int16[this._pos2+0]}get projectedAnchorY(){return this._structArray.int16[this._pos2+1]}get projectedAnchorZ(){return this._structArray.int16[this._pos2+2]}get tileAnchorX(){return this._structArray.float32[this._pos4+2]}get tileAnchorY(){return this._structArray.float32[this._pos4+3]}get rightJustifiedTextSymbolIndex(){return this._structArray.int16[this._pos2+8]}get centerJustifiedTextSymbolIndex(){return this._structArray.int16[this._pos2+9]}get leftJustifiedTextSymbolIndex(){return this._structArray.int16[this._pos2+10]}get verticalPlacedTextSymbolIndex(){return this._structArray.int16[this._pos2+11]}get placedIconSymbolIndex(){return this._structArray.int16[this._pos2+12]}get verticalPlacedIconSymbolIndex(){return this._structArray.int16[this._pos2+13]}get key(){return this._structArray.uint16[this._pos2+14]}get textBoxStartIndex(){return this._structArray.uint16[this._pos2+15]}get textBoxEndIndex(){return this._structArray.uint16[this._pos2+16]}get verticalTextBoxStartIndex(){return this._structArray.uint16[this._pos2+17]}get verticalTextBoxEndIndex(){return this._structArray.uint16[this._pos2+18]}get iconBoxStartIndex(){return this._structArray.uint16[this._pos2+19]}get iconBoxEndIndex(){return this._structArray.uint16[this._pos2+20]}get verticalIconBoxStartIndex(){return this._structArray.uint16[this._pos2+21]}get verticalIconBoxEndIndex(){return this._structArray.uint16[this._pos2+22]}get featureIndex(){return this._structArray.uint16[this._pos2+23]}get numHorizontalGlyphVertices(){return this._structArray.uint16[this._pos2+24]}get numVerticalGlyphVertices(){return this._structArray.uint16[this._pos2+25]}get numIconVertices(){return this._structArray.uint16[this._pos2+26]}get numVerticalIconVertices(){return this._structArray.uint16[this._pos2+27]}get useRuntimeCollisionCircles(){return this._structArray.uint16[this._pos2+28]}get crossTileID(){return this._structArray.uint32[this._pos4+15]}set crossTileID(t){this._structArray.uint32[this._pos4+15]=t;}get textOffset0(){return this._structArray.float32[this._pos4+16]}get textOffset1(){return this._structArray.float32[this._pos4+17]}get collisionCircleDiameter(){return this._structArray.float32[this._pos4+18]}}ya.prototype.size=76;class ma extends ia{get(t){return new ya(this,t)}}Ji(ma,"SymbolInstanceArray");class ga extends sa{getoffsetX(t){return this.float32[1*t+0]}}Ji(ga,"GlyphOffsetArray");class xa extends $s{getx(t){return this.int16[2*t+0]}gety(t){return this.int16[2*t+1]}}Ji(xa,"SymbolLineVertexArray");class va extends Ls{get featureIndex(){return this._structArray.uint32[this._pos4+0]}get sourceLayerIndex(){return this._structArray.uint16[this._pos2+2]}get bucketIndex(){return this._structArray.uint16[this._pos2+3]}get layoutVertexArrayOffset(){return this._structArray.uint16[this._pos2+4]}}va.prototype.size=12;class ba extends oa{get(t){return new va(this,t)}}Ji(ba,"FeatureIndexArray");class wa extends la{geta_centroid_pos0(t){return this.uint16[2*t+0]}geta_centroid_pos1(t){return this.uint16[2*t+1]}}Ji(wa,"FillExtrusionCentroidArray");const _a=Rs([{name:"a_pattern",components:4,type:"Uint16"},{name:"a_pixel_ratio",components:1,type:"Float32"}]),Aa=Rs([{name:"a_dash",components:4,type:"Uint16"}]);var Sa={exports:{}},ka={exports:{}};ka.exports=function(t,e){var r,n,i,s,a,o,l,u;for(n=t.length-(r=3&t.length),i=e,a=3432918353,o=461845907,u=0;u<n;)l=255&t.charCodeAt(u)|(255&t.charCodeAt(++u))<<8|(255&t.charCodeAt(++u))<<16|(255&t.charCodeAt(++u))<<24,++u,i=27492+(65535&(s=5*(65535&(i=(i^=l=(65535&(l=(l=(65535&l)*a+(((l>>>16)*a&65535)<<16)&4294967295)<<15|l>>>17))*o+(((l>>>16)*o&65535)<<16)&4294967295)<<13|i>>>19))+((5*(i>>>16)&65535)<<16)&4294967295))+((58964+(s>>>16)&65535)<<16);switch(l=0,r){case 3:l^=(255&t.charCodeAt(u+2))<<16;case 2:l^=(255&t.charCodeAt(u+1))<<8;case 1:i^=l=(65535&(l=(l=(65535&(l^=255&t.charCodeAt(u)))*a+(((l>>>16)*a&65535)<<16)&4294967295)<<15|l>>>17))*o+(((l>>>16)*o&65535)<<16)&4294967295;}return i^=t.length,i=2246822507*(65535&(i^=i>>>16))+((2246822507*(i>>>16)&65535)<<16)&4294967295,i=3266489909*(65535&(i^=i>>>13))+((3266489909*(i>>>16)&65535)<<16)&4294967295,(i^=i>>>16)>>>0};var Ia=ka.exports,Ma={exports:{}};Ma.exports=function(t,e){for(var r,n=t.length,i=e^n,s=0;n>=4;)r=1540483477*(65535&(r=255&t.charCodeAt(s)|(255&t.charCodeAt(++s))<<8|(255&t.charCodeAt(++s))<<16|(255&t.charCodeAt(++s))<<24))+((1540483477*(r>>>16)&65535)<<16),i=1540483477*(65535&i)+((1540483477*(i>>>16)&65535)<<16)^(r=1540483477*(65535&(r^=r>>>24))+((1540483477*(r>>>16)&65535)<<16)),n-=4,++s;switch(n){case 3:i^=(255&t.charCodeAt(s+2))<<16;case 2:i^=(255&t.charCodeAt(s+1))<<8;case 1:i=1540483477*(65535&(i^=255&t.charCodeAt(s)))+((1540483477*(i>>>16)&65535)<<16);}return i=1540483477*(65535&(i^=i>>>13))+((1540483477*(i>>>16)&65535)<<16),(i^=i>>>15)>>>0};var Ta=Ia,za=Ma.exports;Sa.exports=Ta,Sa.exports.murmur3=Ta,Sa.exports.murmur2=za;var Ba=p(Sa.exports);class Ea{constructor(){this.ids=[],this.positions=[],this.indexed=!1;}add(t,e,r,n){this.ids.push(Ca(t)),this.positions.push(e,r,n);}getPositions(t){const e=Ca(t);let r=0,n=this.ids.length-1;for(;r<n;){const t=r+n>>1;this.ids[t]>=e?n=t:r=t+1;}const i=[];for(;this.ids[r]===e;)i.push({index:this.positions[3*r],start:this.positions[3*r+1],end:this.positions[3*r+2]}),r++;return i}static serialize(t,e){const r=new Float64Array(t.ids),n=new Uint32Array(t.positions);return Pa(r,n,0,r.length-1),e&&e.push(r.buffer,n.buffer),{ids:r,positions:n}}static deserialize(t){const e=new Ea;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e}}function Ca(t){const e=+t;return !isNaN(e)&&Number.MIN_SAFE_INTEGER<=e&&e<=Number.MAX_SAFE_INTEGER?e:Ba(String(t))}function Pa(t,e,r,n){for(;r<n;){const i=t[r+n>>1];let s=r-1,a=n+1;for(;;){do{s++;}while(t[s]<i);do{a--;}while(t[a]>i);if(s>=a)break;Da(t,s,a),Da(e,3*s,3*a),Da(e,3*s+1,3*a+1),Da(e,3*s+2,3*a+2);}a-r<n-a?(Pa(t,e,r,a),r=a+1):(Pa(t,e,a+1,n),n=a);}}function Da(t,e,r){const n=t[e];t[e]=t[r],t[r]=n;}Ji(Ea,"FeaturePositionMap");class Va{constructor(t){this.gl=t.gl,this.initialized=!1;}fetchUniformLocation(t,e){return this.location||this.initialized||(this.location=this.gl.getUniformLocation(t,e),this.initialized=!0),!!this.location}}class La extends Va{constructor(t){super(t),this.current=0;}set(t,e,r){this.fetchUniformLocation(t,e)&&this.current!==r&&(this.current=r,this.gl.uniform1f(this.location,r));}}class Fa extends Va{constructor(t){super(t),this.current=[0,0,0,0];}set(t,e,r){this.fetchUniformLocation(t,e)&&(r[0]===this.current[0]&&r[1]===this.current[1]&&r[2]===this.current[2]&&r[3]===this.current[3]||(this.current=r,this.gl.uniform4f(this.location,r[0],r[1],r[2],r[3])));}}class Ra extends Va{constructor(t){super(t),this.current=Ee.transparent;}set(t,e,r){this.fetchUniformLocation(t,e)&&(r.r===this.current.r&&r.g===this.current.g&&r.b===this.current.b&&r.a===this.current.a||(this.current=r,this.gl.uniform4f(this.location,r.r,r.g,r.b,r.a)));}}const Ua=new Float32Array(16),$a=new Float32Array(9),ja=new Float32Array(4);function Oa(t){return [Ds(255*t.r,255*t.g),Ds(255*t.b,255*t.a)]}class qa{constructor(t,e,r){this.value=t,this.uniformNames=e.map((t=>`u_${t}`)),this.type=r;}setUniform(t,e,r,n,i){e.set(t,i,n.constantOr(this.value));}getBinding(t,e){return "color"===this.type?new Ra(t):new La(t)}}class Na{constructor(t,e){this.uniformNames=e.map((t=>`u_${t}`)),this.pattern=null,this.pixelRatio=1;}setConstantPatternPositions(t){this.pixelRatio=t.pixelRatio||1,this.pattern=t.tl.concat(t.br);}setUniform(t,e,r,n,i){const s="u_pattern"===i||"u_dash"===i?this.pattern:"u_pixel_ratio"===i?this.pixelRatio:null;s&&e.set(t,i,s);}getBinding(t,e){return "u_pattern"===e||"u_dash"===e?new Fa(t):new La(t)}}class Ga{constructor(t,e,r,n){this.expression=t,this.type=r,this.maxValue=0,this.paintVertexAttributes=e.map((t=>({name:`a_${t}`,type:"Float32",components:"color"===r?2:1,offset:0}))),this.paintVertexArray=new n;}populatePaintArray(t,e,r,n,i,s){const a=this.paintVertexArray.length,o=this.expression.evaluate(new ws(0),e,{},i,n,s);this.paintVertexArray.resize(t),this._setPaintValue(a,t,o);}updatePaintArray(t,e,r,n,i){const s=this.expression.evaluate({zoom:0},r,n,void 0,i);this._setPaintValue(t,e,s);}_setPaintValue(t,e,r){if("color"===this.type){const n=Oa(r);for(let r=t;r<e;r++)this.paintVertexArray.emplace(r,n[0],n[1]);}else {for(let n=t;n<e;n++)this.paintVertexArray.emplace(n,r);this.maxValue=Math.max(this.maxValue,Math.abs(r));}}upload(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));}destroy(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();}}class Za{constructor(t,e,r,n,i,s){this.expression=t,this.uniformNames=e.map((t=>`u_${t}_t`)),this.type=r,this.useIntegerZoom=n,this.zoom=i,this.maxValue=0,this.paintVertexAttributes=e.map((t=>({name:`a_${t}`,type:"Float32",components:"color"===r?4:2,offset:0}))),this.paintVertexArray=new s;}populatePaintArray(t,e,r,n,i,s){const a=this.expression.evaluate(new ws(this.zoom),e,{},i,n,s),o=this.expression.evaluate(new ws(this.zoom+1),e,{},i,n,s),l=this.paintVertexArray.length;this.paintVertexArray.resize(t),this._setPaintValue(l,t,a,o);}updatePaintArray(t,e,r,n,i){const s=this.expression.evaluate({zoom:this.zoom},r,n,void 0,i),a=this.expression.evaluate({zoom:this.zoom+1},r,n,void 0,i);this._setPaintValue(t,e,s,a);}_setPaintValue(t,e,r,n){if("color"===this.type){const i=Oa(r),s=Oa(n);for(let r=t;r<e;r++)this.paintVertexArray.emplace(r,i[0],i[1],s[0],s[1]);}else {for(let i=t;i<e;i++)this.paintVertexArray.emplace(i,r,n);this.maxValue=Math.max(this.maxValue,Math.abs(r),Math.abs(n));}}upload(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));}destroy(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();}setUniform(t,e,r,n,i){const s=this.useIntegerZoom?Math.floor(r.zoom):r.zoom,a=M(this.expression.interpolationFactor(s,this.zoom,this.zoom+1),0,1);e.set(t,i,a);}getBinding(t,e){return new La(t)}}class Ka{constructor(t,e,r,n,i){this.expression=t,this.layerId=i,this.paintVertexAttributes=("array"===r?Aa:_a).members;for(let t=0;t<e.length;++t);this.paintVertexArray=new n;}populatePaintArray(t,e,r){const n=this.paintVertexArray.length;this.paintVertexArray.resize(t),this._setPaintValues(n,t,e.patterns&&e.patterns[this.layerId],r);}updatePaintArray(t,e,r,n,i,s){this._setPaintValues(t,e,r.patterns&&r.patterns[this.layerId],s);}_setPaintValues(t,e,r,n){if(!n||!r)return;const i=n[r];if(!i)return;const{tl:s,br:a,pixelRatio:o}=i;for(let r=t;r<e;r++)this.paintVertexArray.emplace(r,s[0],s[1],a[0],a[1],o);}upload(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));}destroy(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();}}class Xa{constructor(t,e,r=(()=>!0)){this.binders={},this._buffers=[];const n=[];for(const i in t.paint._values){if(!r(i))continue;const s=t.paint.get(i);if(!(s instanceof Ts&&Ln(s.property.specification)))continue;const a=Ya(i,t.type),o=s.value,l=s.property.specification.type,u=!!s.property.useIntegerZoom,c="line-dasharray"===i||i.endsWith("pattern"),h="line-dasharray"===i&&"constant"!==t.layout.get("line-cap").value.kind;if("constant"!==o.kind||h)if("source"===o.kind||h||c){const e=to(i,l,"source");this.binders[i]=c?new Ka(o,a,l,e,t.id):new Ga(o,a,l,e),n.push(`/a_${i}`);}else {const t=to(i,l,"composite");this.binders[i]=new Za(o,a,l,u,e,t),n.push(`/z_${i}`);}else this.binders[i]=c?new Na(o.value,a):new qa(o.value,a,l),n.push(`/u_${i}`);}this.cacheKey=n.sort().join("");}getMaxValue(t){const e=this.binders[t];return e instanceof Ga||e instanceof Za?e.maxValue:0}populatePaintArrays(t,e,r,n,i,s){for(const a in this.binders){const o=this.binders[a];(o instanceof Ga||o instanceof Za||o instanceof Ka)&&o.populatePaintArray(t,e,r,n,i,s);}}setConstantPatternPositions(t){for(const e in this.binders){const r=this.binders[e];r instanceof Na&&r.setConstantPatternPositions(t);}}updatePaintArrays(t,e,r,n,i,s){let a=!1;for(const o in t){const l=e.getPositions(o);for(const e of l){const l=r.feature(e.index);for(const r in this.binders){const u=this.binders[r];if((u instanceof Ga||u instanceof Za||u instanceof Ka)&&!0===u.expression.isStateDependent){const c=n.paint.get(r);u.expression=c.value,u.updatePaintArray(e.start,e.end,l,t[o],i,s),a=!0;}}}}return a}defines(){const t=[];for(const e in this.binders){const r=this.binders[e];(r instanceof qa||r instanceof Na)&&t.push(...r.uniformNames.map((t=>`#define HAS_UNIFORM_${t}`)));}return t}getBinderAttributes(){const t=[];for(const e in this.binders){const r=this.binders[e];if(r instanceof Ga||r instanceof Za||r instanceof Ka)for(let e=0;e<r.paintVertexAttributes.length;e++)t.push(r.paintVertexAttributes[e].name);}return t}getBinderUniforms(){const t=[];for(const e in this.binders){const r=this.binders[e];if(r instanceof qa||r instanceof Na||r instanceof Za)for(const e of r.uniformNames)t.push(e);}return t}getPaintVertexBuffers(){return this._buffers}getUniforms(t){const e=[];for(const r in this.binders){const n=this.binders[r];if(n instanceof qa||n instanceof Na||n instanceof Za)for(const i of n.uniformNames)e.push({name:i,property:r,binding:n.getBinding(t,i)});}return e}setUniforms(t,e,r,n,i){for(const{name:e,property:s,binding:a}of r)this.binders[s].setUniform(t,a,i,n.get(s),e);}updatePaintBuffers(){this._buffers=[];for(const t in this.binders){const e=this.binders[t];(e instanceof Ga||e instanceof Za||e instanceof Ka)&&e.paintVertexBuffer&&this._buffers.push(e.paintVertexBuffer);}}upload(t){for(const e in this.binders){const r=this.binders[e];(r instanceof Ga||r instanceof Za||r instanceof Ka)&&r.upload(t);}this.updatePaintBuffers();}destroy(){for(const t in this.binders){const e=this.binders[t];(e instanceof Ga||e instanceof Za||e instanceof Ka)&&e.destroy();}}}class Ja{constructor(t,e,r=(()=>!0)){this.programConfigurations={};for(const n of t)this.programConfigurations[n.id]=new Xa(n,e,r);this.needsUpload=!1,this._featureMap=new Ea,this._bufferOffset=0;}populatePaintArrays(t,e,r,n,i,s,a){for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t,e,n,i,s,a);void 0!==e.id&&this._featureMap.add(e.id,r,this._bufferOffset,t),this._bufferOffset=t,this.needsUpload=!0;}updatePaintArrays(t,e,r,n,i){for(const s of r)this.needsUpload=this.programConfigurations[s.id].updatePaintArrays(t,this._featureMap,e,s,n,i)||this.needsUpload;}get(t){return this.programConfigurations[t]}upload(t){if(this.needsUpload){for(const e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}}destroy(){for(const t in this.programConfigurations)this.programConfigurations[t].destroy();}}const Ha={"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern","pixel_ratio"],"fill-pattern":["pattern","pixel_ratio"],"fill-extrusion-pattern":["pattern","pixel_ratio"],"line-dasharray":["dash"]};function Ya(t,e){return Ha[t]||[t.replace(`${e}-`,"").replace(/-/g,"_")]}const Wa={"line-pattern":{source:Gs,composite:Gs},"fill-pattern":{source:Gs,composite:Gs},"fill-extrusion-pattern":{source:Gs,composite:Gs},"line-dasharray":{source:Zs,composite:Zs}},Qa={color:{source:ca,composite:Ns},number:{source:sa,composite:ca}};function to(t,e,r){const n=Wa[t];return n&&n[r]||Qa[e][r]}Ji(qa,"ConstantBinder"),Ji(Na,"PatternConstantBinder"),Ji(Ga,"SourceExpressionBinder"),Ji(Ka,"PatternCompositeBinder"),Ji(Za,"CompositeExpressionBinder"),Ji(Xa,"ProgramConfiguration",{omit:["_buffers"]}),Ji(Ja,"ProgramConfigurationSet");const eo="-transition";class ro extends Qt{constructor(t,e){if(super(),this.id=t.id,this.type=t.type,this._featureFilter={filter:()=>!0,needGeometry:!1,needFeature:!1},this._filterCompiled=!1,"custom"!==t.type&&(this.metadata=t.metadata,this.minzoom=t.minzoom,this.maxzoom=t.maxzoom,"background"!==t.type&&"sky"!==t.type&&(this.source=t.source,this.sourceLayer=t["source-layer"],this.filter=t.filter),e.layout&&(this._unevaluatedLayout=new Ms(e.layout)),e.paint)){this._transitionablePaint=new Ss(e.paint);for(const e in t.paint)this.setPaintProperty(e,t.paint[e],{validate:!1});for(const e in t.layout)this.setLayoutProperty(e,t.layout[e],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned(),this.paint=new zs(e.paint);}}getLayoutProperty(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)}setLayoutProperty(t,e,r={}){null!=e&&this._validate(ji,`layers.${this.id}.layout.${t}`,t,e,r)||("visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility=e);}getPaintProperty(t){return U(t,eo)?this._transitionablePaint.getTransition(t.slice(0,-11)):this._transitionablePaint.getValue(t)}setPaintProperty(t,e,r={}){if(null!=e&&this._validate($i,`layers.${this.id}.paint.${t}`,t,e,r))return !1;if(U(t,eo))return this._transitionablePaint.setTransition(t.slice(0,-11),e||void 0),!1;{const r=this._transitionablePaint._values[t],n=r.value.isDataDriven(),i=r.value;this._transitionablePaint.setValue(t,e),this._handleSpecialPaintPropertyUpdate(t);const s=this._transitionablePaint._values[t].value,a=s.isDataDriven(),o=U(t,"pattern")||"line-dasharray"===t;return a||n||o||this._handleOverridablePaintPropertyUpdate(t,i,s)}}_handleSpecialPaintPropertyUpdate(t){}getProgramIds(){return null}getProgramConfiguration(t){return null}_handleOverridablePaintPropertyUpdate(t,e,r){return !1}isHidden(t){return !!(this.minzoom&&t<this.minzoom)||!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility}updateTransitions(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);}hasTransition(){return this._transitioningPaint.hasTransition()}recalculate(t,e){this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t,void 0,e)),this.paint=this._transitioningPaint.possiblyEvaluate(t,void 0,e);}serialize(){const t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return this.visibility&&(t.layout=t.layout||{},t.layout.visibility=this.visibility),j(t,((t,e)=>!(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)))}_validate(t,e,r,n,i={}){return (!i||!1!==i.validate)&&qi(this,t.call(Ui,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:te,style:{glyphs:!0,sprite:!0}}))}is3D(){return !1}isSky(){return !1}isTileClipped(){return !1}hasOffscreenPass(){return !1}resize(){}isStateDependent(){for(const t in this.paint._values){const e=this.paint.get(t);if(e instanceof Ts&&Ln(e.property.specification)&&("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent)return !0}return !1}compileFilter(){this._filterCompiled||(this._featureFilter=hi(this.filter),this._filterCompiled=!0);}invalidateCompiledFilter(){this._filterCompiled=!1;}dynamicFilter(){return this._featureFilter.dynamicFilter}dynamicFilterNeedsFeature(){return this._featureFilter.needFeature}}const no=Rs([{name:"a_pos",components:2,type:"Int16"}],4),io=Rs([{name:"a_pos_3",components:3,type:"Int16"},{name:"a_pos_normal_3",components:3,type:"Int16"}]);class so{constructor(t=[]){this.segments=t;}prepareSegment(t,e,r,n){let i=this.segments[this.segments.length-1];return t>so.MAX_VERTEX_ARRAY_LENGTH&&N(`Max vertices per segment is ${so.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}`),(!i||i.vertexLength+t>so.MAX_VERTEX_ARRAY_LENGTH||i.sortKey!==n)&&(i={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},void 0!==n&&(i.sortKey=n),this.segments.push(i)),i}get(){return this.segments}destroy(){for(const t of this.segments)for(const e in t.vaos)t.vaos[e].destroy();}static simpleSegment(t,e,r,n){return new so([{vertexOffset:t,primitiveOffset:e,vertexLength:r,primitiveLength:n,vaos:{},sortKey:0}])}}so.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,Ji(so,"SegmentVector");var ao=8192;class oo{constructor(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));}setNorthEast(t){return this._ne=t instanceof Ol?new Ol(t.lng,t.lat):Ol.convert(t),this}setSouthWest(t){return this._sw=t instanceof Ol?new Ol(t.lng,t.lat):Ol.convert(t),this}extend(t){const e=this._sw,r=this._ne;let n,i;if(t instanceof Ol)n=t,i=t;else {if(!(t instanceof oo))return Array.isArray(t)?4===t.length||t.every(Array.isArray)?this.extend(oo.convert(t)):this.extend(Ol.convert(t)):"object"==typeof t&&null!==t&&t.hasOwnProperty("lat")&&(t.hasOwnProperty("lon")||t.hasOwnProperty("lng"))?this.extend(Ol.convert(t)):this;if(n=t._sw,i=t._ne,!n||!i)return this}return e||r?(e.lng=Math.min(n.lng,e.lng),e.lat=Math.min(n.lat,e.lat),r.lng=Math.max(i.lng,r.lng),r.lat=Math.max(i.lat,r.lat)):(this._sw=new Ol(n.lng,n.lat),this._ne=new Ol(i.lng,i.lat)),this}getCenter(){return new Ol((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)}getSouthWest(){return this._sw}getNorthEast(){return this._ne}getNorthWest(){return new Ol(this.getWest(),this.getNorth())}getSouthEast(){return new Ol(this.getEast(),this.getSouth())}getWest(){return this._sw.lng}getSouth(){return this._sw.lat}getEast(){return this._ne.lng}getNorth(){return this._ne.lat}toArray(){return [this._sw.toArray(),this._ne.toArray()]}toString(){return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`}isEmpty(){return !(this._sw&&this._ne)}contains(t){const{lng:e,lat:r}=Ol.convert(t);let n=this._sw.lng<=e&&e<=this._ne.lng;return this._sw.lng>this._ne.lng&&(n=this._sw.lng>=e&&e>=this._ne.lng),this._sw.lat<=r&&r<=this._ne.lat&&n}static convert(t){return !t||t instanceof oo?t:new oo(t)}}var lo=1e-6,uo="undefined"!=typeof Float32Array?Float32Array:Array;function co(){var t=new uo(9);return uo!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t}function ho(t,e,r){var n=e[0],i=e[1],s=e[2],a=e[3],o=e[4],l=e[5],u=e[6],c=e[7],h=e[8],p=r[0],d=r[1],f=r[2],y=r[3],m=r[4],g=r[5],x=r[6],v=r[7],b=r[8];return t[0]=p*n+d*a+f*u,t[1]=p*i+d*o+f*c,t[2]=p*s+d*l+f*h,t[3]=y*n+m*a+g*u,t[4]=y*i+m*o+g*c,t[5]=y*s+m*l+g*h,t[6]=x*n+v*a+b*u,t[7]=x*i+v*o+b*c,t[8]=x*s+v*l+b*h,t}function po(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function fo(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=e[4],o=e[5],l=e[6],u=e[7],c=e[8],h=e[9],p=e[10],d=e[11],f=e[12],y=e[13],m=e[14],g=e[15],x=r*o-n*a,v=r*l-i*a,b=r*u-s*a,w=n*l-i*o,_=n*u-s*o,A=i*u-s*l,S=c*y-h*f,k=c*m-p*f,I=c*g-d*f,M=h*m-p*y,T=h*g-d*y,z=p*g-d*m,B=x*z-v*T+b*M+w*I-_*k+A*S;return B?(t[0]=(o*z-l*T+u*M)*(B=1/B),t[1]=(i*T-n*z-s*M)*B,t[2]=(y*A-m*_+g*w)*B,t[3]=(p*_-h*A-d*w)*B,t[4]=(l*I-a*z-u*k)*B,t[5]=(r*z-i*I+s*k)*B,t[6]=(m*b-f*A-g*v)*B,t[7]=(c*A-p*b+d*v)*B,t[8]=(a*T-o*I+u*S)*B,t[9]=(n*I-r*T-s*S)*B,t[10]=(f*_-y*b+g*x)*B,t[11]=(h*b-c*_-d*x)*B,t[12]=(o*k-a*M-l*S)*B,t[13]=(r*M-n*k+i*S)*B,t[14]=(y*v-f*w-m*x)*B,t[15]=(c*w-h*v+p*x)*B,t):null}function yo(t,e,r){var n=e[0],i=e[1],s=e[2],a=e[3],o=e[4],l=e[5],u=e[6],c=e[7],h=e[8],p=e[9],d=e[10],f=e[11],y=e[12],m=e[13],g=e[14],x=e[15],v=r[0],b=r[1],w=r[2],_=r[3];return t[0]=v*n+b*o+w*h+_*y,t[1]=v*i+b*l+w*p+_*m,t[2]=v*s+b*u+w*d+_*g,t[3]=v*a+b*c+w*f+_*x,t[4]=(v=r[4])*n+(b=r[5])*o+(w=r[6])*h+(_=r[7])*y,t[5]=v*i+b*l+w*p+_*m,t[6]=v*s+b*u+w*d+_*g,t[7]=v*a+b*c+w*f+_*x,t[8]=(v=r[8])*n+(b=r[9])*o+(w=r[10])*h+(_=r[11])*y,t[9]=v*i+b*l+w*p+_*m,t[10]=v*s+b*u+w*d+_*g,t[11]=v*a+b*c+w*f+_*x,t[12]=(v=r[12])*n+(b=r[13])*o+(w=r[14])*h+(_=r[15])*y,t[13]=v*i+b*l+w*p+_*m,t[14]=v*s+b*u+w*d+_*g,t[15]=v*a+b*c+w*f+_*x,t}function mo(t,e,r){var n,i,s,a,o,l,u,c,h,p,d,f,y=r[0],m=r[1],g=r[2];return e===t?(t[12]=e[0]*y+e[4]*m+e[8]*g+e[12],t[13]=e[1]*y+e[5]*m+e[9]*g+e[13],t[14]=e[2]*y+e[6]*m+e[10]*g+e[14],t[15]=e[3]*y+e[7]*m+e[11]*g+e[15]):(i=e[1],s=e[2],a=e[3],o=e[4],l=e[5],u=e[6],c=e[7],h=e[8],p=e[9],d=e[10],f=e[11],t[0]=n=e[0],t[1]=i,t[2]=s,t[3]=a,t[4]=o,t[5]=l,t[6]=u,t[7]=c,t[8]=h,t[9]=p,t[10]=d,t[11]=f,t[12]=n*y+o*m+h*g+e[12],t[13]=i*y+l*m+p*g+e[13],t[14]=s*y+u*m+d*g+e[14],t[15]=a*y+c*m+f*g+e[15]),t}function go(t,e,r){var n=r[0],i=r[1],s=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*s,t[9]=e[9]*s,t[10]=e[10]*s,t[11]=e[11]*s,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t}function xo(t,e,r){var n=Math.sin(r),i=Math.cos(r),s=e[4],a=e[5],o=e[6],l=e[7],u=e[8],c=e[9],h=e[10],p=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=s*i+u*n,t[5]=a*i+c*n,t[6]=o*i+h*n,t[7]=l*i+p*n,t[8]=u*i-s*n,t[9]=c*i-a*n,t[10]=h*i-o*n,t[11]=p*i-l*n,t}function vo(t,e,r){var n=Math.sin(r),i=Math.cos(r),s=e[0],a=e[1],o=e[2],l=e[3],u=e[8],c=e[9],h=e[10],p=e[11];return e!==t&&(t[4]=e[4],t[5]=e[5],t[6]=e[6],t[7]=e[7],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=s*i-u*n,t[1]=a*i-c*n,t[2]=o*i-h*n,t[3]=l*i-p*n,t[8]=s*n+u*i,t[9]=a*n+c*i,t[10]=o*n+h*i,t[11]=l*n+p*i,t}function bo(t,e){return t[0]=e[0],t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=e[1],t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=e[2],t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function wo(t,e,r){var n,i,s,a=r[0],o=r[1],l=r[2],u=Math.hypot(a,o,l);return u<lo?null:(a*=u=1/u,o*=u,l*=u,n=Math.sin(e),i=Math.cos(e),t[0]=a*a*(s=1-i)+i,t[1]=o*a*s+l*n,t[2]=l*a*s-o*n,t[3]=0,t[4]=a*o*s-l*n,t[5]=o*o*s+i,t[6]=l*o*s+a*n,t[7]=0,t[8]=a*l*s+o*n,t[9]=o*l*s-a*n,t[10]=l*l*s+i,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t)}Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)});var _o=yo;function Ao(){var t=new uo(3);return uo!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function So(t){var e=new uo(3);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e}function ko(t){return Math.hypot(t[0],t[1],t[2])}function Io(t,e,r){var n=new uo(3);return n[0]=t,n[1]=e,n[2]=r,n}function Mo(t,e,r){return t[0]=e[0]+r[0],t[1]=e[1]+r[1],t[2]=e[2]+r[2],t}function To(t,e,r){return t[0]=e[0]-r[0],t[1]=e[1]-r[1],t[2]=e[2]-r[2],t}function zo(t,e,r){return t[0]=e[0]*r[0],t[1]=e[1]*r[1],t[2]=e[2]*r[2],t}function Bo(t,e,r){return t[0]=Math.min(e[0],r[0]),t[1]=Math.min(e[1],r[1]),t[2]=Math.min(e[2],r[2]),t}function Eo(t,e,r){return t[0]=Math.max(e[0],r[0]),t[1]=Math.max(e[1],r[1]),t[2]=Math.max(e[2],r[2]),t}function Co(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t}function Po(t,e,r,n){return t[0]=e[0]+r[0]*n,t[1]=e[1]+r[1]*n,t[2]=e[2]+r[2]*n,t}function Do(t,e){var r=e[0],n=e[1],i=e[2],s=r*r+n*n+i*i;return s>0&&(s=1/Math.sqrt(s)),t[0]=e[0]*s,t[1]=e[1]*s,t[2]=e[2]*s,t}function Vo(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function Lo(t,e,r){var n=e[0],i=e[1],s=e[2],a=r[0],o=r[1],l=r[2];return t[0]=i*l-s*o,t[1]=s*a-n*l,t[2]=n*o-i*a,t}function Fo(t,e,r){var n=e[0],i=e[1],s=e[2],a=r[3]*n+r[7]*i+r[11]*s+r[15];return t[0]=(r[0]*n+r[4]*i+r[8]*s+r[12])/(a=a||1),t[1]=(r[1]*n+r[5]*i+r[9]*s+r[13])/a,t[2]=(r[2]*n+r[6]*i+r[10]*s+r[14])/a,t}function Ro(t,e,r){var n=r[0],i=r[1],s=r[2],a=e[0],o=e[1],l=e[2],u=i*l-s*o,c=s*a-n*l,h=n*o-i*a,p=i*h-s*c,d=s*u-n*h,f=n*c-i*u,y=2*r[3];return c*=y,h*=y,d*=2,f*=2,t[0]=a+(u*=y)+(p*=2),t[1]=o+c+d,t[2]=l+h+f,t}var Uo,$o=To,jo=zo,Oo=ko;function qo(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t[3]=e[3]*r,t}function No(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=r*r+n*n+i*i+s*s;return a>0&&(a=1/Math.sqrt(a)),t[0]=r*a,t[1]=n*a,t[2]=i*a,t[3]=s*a,t}function Go(t,e,r){var n=e[0],i=e[1],s=e[2],a=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*s+r[12]*a,t[1]=r[1]*n+r[5]*i+r[9]*s+r[13]*a,t[2]=r[2]*n+r[6]*i+r[10]*s+r[14]*a,t[3]=r[3]*n+r[7]*i+r[11]*s+r[15]*a,t}function Zo(){var t=new uo(4);return uo!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}function Ko(t){return t[0]=0,t[1]=0,t[2]=0,t[3]=1,t}function Xo(t,e,r){r*=.5;var n=e[0],i=e[1],s=e[2],a=e[3],o=Math.sin(r),l=Math.cos(r);return t[0]=n*l+a*o,t[1]=i*l+s*o,t[2]=s*l-i*o,t[3]=a*l-n*o,t}function Jo(t,e,r){r*=.5;var n=e[0],i=e[1],s=e[2],a=e[3],o=Math.sin(r),l=Math.cos(r);return t[0]=n*l-s*o,t[1]=i*l+a*o,t[2]=s*l+n*o,t[3]=a*l-i*o,t}Ao(),Uo=new uo(4),uo!=Float32Array&&(Uo[0]=0,Uo[1]=0,Uo[2]=0,Uo[3]=0);var Ho=No;Ao(),Io(1,0,0),Io(0,1,0),Zo(),Zo(),co();const Yo=Rs([{type:"Float32",name:"a_globe_pos",components:3},{type:"Float32",name:"a_uv",components:2}]),{members:Wo}=Yo,Qo=Rs([{name:"a_pos_3",components:3,type:"Int16"}]);var tl=Rs([{name:"a_pos",type:"Int16",components:2}]);class el{constructor(t,e){this.pos=t,this.dir=e;}intersectsPlane(t,e,r){const n=Vo(e,this.dir);if(Math.abs(n)<1e-6)return !1;const i=((t[0]-this.pos[0])*e[0]+(t[1]-this.pos[1])*e[1]+(t[2]-this.pos[2])*e[2])/n;return r[0]=this.pos[0]+this.dir[0]*i,r[1]=this.pos[1]+this.dir[1]*i,r[2]=this.pos[2]+this.dir[2]*i,!0}closestPointOnSphere(t,e,r){if(function(t,e){var r=t[0],n=t[1],i=t[2],s=e[0],a=e[1],o=e[2];return Math.abs(r-s)<=lo*Math.max(1,Math.abs(r),Math.abs(s))&&Math.abs(n-a)<=lo*Math.max(1,Math.abs(n),Math.abs(a))&&Math.abs(i-o)<=lo*Math.max(1,Math.abs(i),Math.abs(o))}(this.pos,t)||0===e)return r[0]=r[1]=r[2]=0,!1;const[n,i,s]=this.dir,a=this.pos[0]-t[0],o=this.pos[1]-t[1],l=this.pos[2]-t[2],u=n*n+i*i+s*s,c=2*(a*n+o*i+l*s),h=c*c-4*u*(a*a+o*o+l*l-e*e);if(h<0){const t=Math.max(-c/2,0),u=a+n*t,h=o+i*t,p=l+s*t,d=Math.hypot(u,h,p);return r[0]=u*e/d,r[1]=h*e/d,r[2]=p*e/d,!1}{const t=(-c-Math.sqrt(h))/(2*u);if(t<0){const t=Math.hypot(a,o,l);return r[0]=a*e/t,r[1]=o*e/t,r[2]=l*e/t,!1}return r[0]=a+n*t,r[1]=o+i*t,r[2]=l+s*t,!0}}}class rl{constructor(t,e,r,n,i){this.TL=t,this.TR=e,this.BR=r,this.BL=n,this.horizon=i;}static fromInvProjectionMatrix(t,e,r){const n=[-1,1,1],i=[1,1,1],s=[1,-1,1],a=[-1,-1,1],o=Fo(n,n,t),l=Fo(i,i,t),u=Fo(s,s,t),c=Fo(a,a,t);return new rl(o,l,u,c,e/r)}}class nl{constructor(t,e){this.points=t,this.planes=e;}static fromInvProjectionMatrix(t,e,r,n){const i=Math.pow(2,r),s=[[-1,1,-1,1],[1,1,-1,1],[1,-1,-1,1],[-1,-1,-1,1],[-1,1,1,1],[1,1,1,1],[1,-1,1,1],[-1,-1,1,1]].map((r=>{const s=Go([],r,t),a=1/s[3]/e*i;return function(t,e,r){return t[0]=e[0]*r[0],t[1]=e[1]*r[1],t[2]=e[2]*r[2],t[3]=e[3]*r[3],t}(s,s,[a,a,n?1/s[3]:a,a])})),a=[[0,1,2],[6,5,4],[0,3,7],[2,1,5],[3,2,6],[0,4,5]].map((t=>{const e=Do([],Lo([],$o([],s[t[0]],s[t[1]]),$o([],s[t[2]],s[t[1]]))),r=-Vo(e,s[t[1]]);return e.concat(r)}));return new nl(s,a)}}class il{static fromPoints(t){const e=[1/0,1/0,1/0],r=[-1/0,-1/0,-1/0];for(const n of t)Bo(e,e,n),Eo(r,r,n);return new il(e,r)}static applyTransform(t,e){const r=t.getCorners();for(let t=0;t<r.length;++t)Fo(r[t],r[t],e);return il.fromPoints(r)}constructor(t,e){this.min=t,this.max=e,this.center=Co([],Mo([],this.min,this.max),.5);}quadrant(t){const e=[t%2==0,t<2],r=So(this.min),n=So(this.max);for(let t=0;t<e.length;t++)r[t]=e[t]?this.min[t]:this.center[t],n[t]=e[t]?this.center[t]:this.max[t];return n[2]=this.max[2],new il(r,n)}distanceX(t){return Math.max(Math.min(this.max[0],t[0]),this.min[0])-t[0]}distanceY(t){return Math.max(Math.min(this.max[1],t[1]),this.min[1])-t[1]}distanceZ(t){return Math.max(Math.min(this.max[2],t[2]),this.min[2])-t[2]}getCorners(){const t=this.min,e=this.max;return [[t[0],t[1],t[2]],[e[0],t[1],t[2]],[e[0],e[1],t[2]],[t[0],e[1],t[2]],[t[0],t[1],e[2]],[e[0],t[1],e[2]],[e[0],e[1],e[2]],[t[0],e[1],e[2]]]}intersects(t){const e=this.getCorners();let r=!0;for(let n=0;n<t.planes.length;n++){const i=t.planes[n];let s=0;for(let t=0;t<e.length;t++)s+=Vo(i,e[t])+i[3]>=0;if(0===s)return 0;s!==e.length&&(r=!1);}if(r)return 2;for(let e=0;e<3;e++){let r=Number.MAX_VALUE,n=-Number.MAX_VALUE;for(let i=0;i<t.points.length;i++){const s=t.points[i][e]-this.min[e];r=Math.min(r,s),n=Math.max(n,s);}if(n<0||r>this.max[e]-this.min[e])return 0}return 1}}const sl=5,al=6,ol=ao/Math.PI/2,ll=16383,ul=64,cl=[ul,32,16],hl=-ol,pl=ol,dl=[new il([hl,hl,hl],[pl,pl,pl]),new il([hl,hl,hl],[0,0,pl]),new il([0,hl,hl],[pl,0,pl]),new il([hl,0,hl],[0,pl,pl]),new il([0,0,hl],[pl,pl,pl])];function fl(t){return t*ol/Ul}function yl(t,e,r,n=!0){const i=Co([],t._camera.position,t.worldSize),s=[e,r,1,1];Go(s,s,t.pixelMatrixInverse),qo(s,s,1/s[3]);const a=Do([],$o([],s,i)),o=t.globeMatrix,l=[o[12],o[13],o[14]],u=$o([],l,i),c=ko(u),h=Do([],u),p=t.worldSize/(2*Math.PI),d=Vo(h,a),f=Math.asin(p/c);if(f<Math.acos(d)){if(!n)return null;const t=[],e=[];Co(t,a,c/d),Do(e,$o(e,t,u)),Do(a,Mo(a,u,Co(a,e,Math.tan(f)*c)));}const y=[];new el(i,a).closestPointOnSphere(l,p,y);const m=Do([],W(o,0)),g=Do([],W(o,1)),x=Do([],W(o,2)),v=Vo(m,y),b=Vo(g,y),w=Vo(x,y),A=_(Math.asin(-b/p));let S=_(Math.atan2(v,w));S=t.center.lng+function(t,e){const r=(e-t+180)%360-180;return r<-180?r+360:r}(t.center.lng,S);const k=Nl(S),I=M(Gl(A),0,1);return new Wl(k,I)}class ml{constructor(t,e,r){this.a=$o([],t,r),this.b=$o([],e,r),this.center=r;const n=Do([],this.a),i=Do([],this.b);this.angle=Math.acos(Vo(n,i));}}function gl(t,e){if(0===t.angle)return null;let r;return r=0===t.a[e]?1/t.angle*.5*Math.PI:1/t.angle*Math.atan(t.b[e]/t.a[e]/Math.sin(t.angle)-1/Math.tan(t.angle)),r<0||r>1?null:function(t,e,r,n){const i=Math.sin(r);return t*(Math.sin((1-n)*r)/i)+e*(Math.sin(n*r)/i)}(t.a[e],t.b[e],t.angle,M(r,0,1))+t.center[e]}function xl(t){if(t.z<=1)return dl[t.z+2*t.y+t.x];const e=Sl(Al(t));return il.fromPoints(e)}function vl(t,e,r){return Co(t,t,1-r),Po(t,t,e,r)}function bl(t,e){const r=Pl(e.zoom);if(0===r)return xl(t);const n=Al(t),i=Sl(n),s=Nl(n.getWest())*e.worldSize,a=Nl(n.getEast())*e.worldSize,o=Gl(n.getNorth())*e.worldSize,l=Gl(n.getSouth())*e.worldSize,u=[s,o,0],c=[a,o,0],h=[s,l,0],p=[a,l,0],d=fo([],e.globeMatrix);return Fo(u,u,d),Fo(c,c,d),Fo(h,h,d),Fo(p,p,d),i[0]=vl(i[0],h,r),i[1]=vl(i[1],p,r),i[2]=vl(i[2],c,r),i[3]=vl(i[3],u,r),il.fromPoints(i)}function wl(t,e,r){for(const n of t)Fo(n,n,e),Co(n,n,r);}function _l(t,e,r){const n=e/t.worldSize,i=t.globeMatrix;if(r.z<=1){const t=xl(r).getCorners();return wl(t,i,n),il.fromPoints(t)}const s=Al(r),a=Sl(s);wl(a,i,n);const o=Number.MAX_VALUE,l=[-o,-o,-o],u=[o,o,o];if(s.contains(t.center)){for(const t of a)Bo(u,u,t),Eo(l,l,t);l[2]=0;const e=t.point,r=[e.x*n,e.y*n,0];return Bo(u,u,r),Eo(l,l,r),new il(u,l)}const c=[i[12]*n,i[13]*n,i[14]*n],h=s.getCenter(),p=M(t.center.lat,-Hl,Hl),d=M(h.lat,-Hl,Hl),f=Nl(t.center.lng),y=Gl(p);let m=f-Nl(h.lng);const g=y-Gl(d);m>.5?m-=1:m<-.5&&(m+=1);let x=0;Math.abs(m)>Math.abs(g)?x=m>=0?1:3:(x=g>=0?0:2,Po(c,c,[i[4]*n,i[5]*n,i[6]*n],-Math.sin(w(g>=0?s.getSouth():s.getNorth()))*ol));const v=a[x],b=a[(x+1)%4],_=new ml(v,b,c),A=[gl(_,0)||v[0],gl(_,1)||v[1],gl(_,2)||v[2]],S=Pl(t.zoom);if(S>0){const n=function({x:t,y:e,z:r},n,i,s,a){const o=1/(1<<r);let l=t*o,u=l+o,c=e*o,h=c+o,p=0;const d=(l+u)/2-s;return d>.5?p=-1:d<-.5&&(p=1),l=((l+p)*n-(s*=n))*i+s,u=((u+p)*n-s)*i+s,c=(c*n-(a*=n))*i+a,h=(h*n-a)*i+a,[[l,h,0],[u,h,0],[u,c,0],[l,c,0]]}(r,e,t._pixelsPerMercatorPixel,f,y);for(let t=0;t<a.length;t++)vl(a[t],n[t],S);const i=Mo([],n[x],n[(x+1)%4]);Co(i,i,.5),vl(A,i,S);}for(const t of a)Bo(u,u,t),Eo(l,l,t);return u[2]=Math.min(v[2],b[2]),Bo(u,u,A),Eo(l,l,A),new il(u,l)}function Al({x:t,y:e,z:r}){const n=1/(1<<r),i=new Ol(Kl(t*n),Xl((e+1)*n)),s=new Ol(Kl((t+1)*n),Xl(e*n));return new oo(i,s)}function Sl(t){const e=w(t.getNorth()),r=w(t.getSouth()),n=Math.cos(e),i=Math.cos(r),s=Math.sin(e),a=Math.sin(r),o=t.getWest(),l=t.getEast();return [kl(i,a,o),kl(i,a,l),kl(n,s,l),kl(n,s,o)]}function kl(t,e,r,n=ol){return r=w(r),[t*Math.sin(r)*n,-e*n,t*Math.cos(r)*n]}function Il(t,e,r){return kl(Math.cos(w(t)),Math.sin(w(t)),e,r)}function Ml(t,e,r,n){const i=1<<r.z,s=(t/ao+r.x)/i;return Il(Xl((e/ao+r.y)/i),Kl(s),n)}function Tl({min:t,max:e}){return ll/Math.max(e[0]-t[0],e[1]-t[1],e[2]-t[2])}const zl=new Float64Array(16);function Bl(t){const e=Tl(t),r=bo(zl,[e,e,e]);return mo(r,r,((n=[])[0]=-(i=t.min)[0],n[1]=-i[1],n[2]=-i[2],n));var n,i;}function El(t){const e=(n=t.min,(r=zl)[0]=1,r[1]=0,r[2]=0,r[3]=0,r[4]=0,r[5]=1,r[6]=0,r[7]=0,r[8]=0,r[9]=0,r[10]=1,r[11]=0,r[12]=n[0],r[13]=n[1],r[14]=n[2],r[15]=1,r);var r,n;const i=1/Tl(t);return go(e,e,[i,i,i])}function Cl(t,e,r,n,i){const s=function(t){const e=ao/(2*Math.PI);return t/(2*Math.PI)/e}(r),a=[t,e,-r/(2*Math.PI)],o=po(new Float64Array(16));return mo(o,o,a),go(o,o,[s,s,s]),xo(o,o,w(-i)),vo(o,o,w(-n)),o}function Pl(t){return T(sl,al,t)}function Dl(t,e){const r=Il(e.lat,e.lng),n=function(t){const e=Il(t._center.lat,t._center.lng);let r=Lo([],Io(0,1,0),e);const n=wo([],-t.angle,e);r=Fo(r,r,n),wo(n,-t._pitch,r);const i=Do([],e);return Co(i,i,fl(t.cameraToCenterDistance/t.pixelsPerMeter)),Fo(i,i,n),Mo([],e,i)}(t);return a=(i=To([],n,r))[0],o=i[1],l=i[2],u=(s=r)[0],c=s[1],h=s[2],d=(p=Math.sqrt(a*a+o*o+l*l)*Math.sqrt(u*u+c*c+h*h))&&Vo(i,s)/p,Math.acos(Math.min(Math.max(d,-1),1));var i,s,a,o,l,u,c,h,p,d;}function Vl(t,e){return Dl(t,e)>Math.PI/2*1.01}const Ll=w(85),Fl=Math.cos(Ll),Rl=Math.sin(Ll),Ul=6371008.8,$l=2*Math.PI*Ul;class jl{constructor(t,e){if(isNaN(t)||isNaN(e))throw new Error(`Invalid LngLat object: (${t}, ${e})`);if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")}wrap(){return new jl(z(this.lng,-180,180),this.lat)}toArray(){return [this.lng,this.lat]}toString(){return `LngLat(${this.lng}, ${this.lat})`}distanceTo(t){const e=Math.PI/180,r=this.lat*e,n=t.lat*e,i=Math.sin(r)*Math.sin(n)+Math.cos(r)*Math.cos(n)*Math.cos((t.lng-this.lng)*e);return Ul*Math.acos(Math.min(i,1))}toBounds(t=0){const e=360*t/40075017,r=e/Math.cos(Math.PI/180*this.lat);return new oo(new jl(this.lng-r,this.lat-e),new jl(this.lng+r,this.lat+e))}toEcef(t){const e=fl(t);return Il(this.lat,this.lng,ol+e)}static convert(t){if(t instanceof jl)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new jl(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new jl(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")}}var Ol=jl;function ql(t){return $l*Math.cos(t*Math.PI/180)}function Nl(t){return (180+t)/360}function Gl(t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function Zl(t,e){return t/ql(e)}function Kl(t){return 360*t-180}function Xl(t){return 360/Math.PI*Math.atan(Math.exp((180-360*t)*Math.PI/180))-90}function Jl(t,e){return t*ql(Xl(e))}const Hl=85.051129;function Yl(t){return 1/Math.cos(t*Math.PI/180)}class Wl{constructor(t,e,r=0){this.x=+t,this.y=+e,this.z=+r;}static fromLngLat(t,e=0){const r=Ol.convert(t);return new Wl(Nl(r.lng),Gl(r.lat),Zl(e,r.lat))}toLngLat(){return new Ol(Kl(this.x),Xl(this.y))}toAltitude(){return Jl(this.z,this.y)}meterInMercatorCoordinateUnits(){return 1/$l*Yl(Xl(this.y))}}function Ql(t,e,r,n,i,s,a,o,l){const u=(e+n)/2,c=(r+i)/2,h=new x(u,c);o(h),function(t,e,r,n,i,s){const a=r-i,o=n-s;return Math.abs((n-e)*a-(r-t)*o)/Math.hypot(a,o)}(h.x,h.y,s.x,s.y,a.x,a.y)>=l?(Ql(t,e,r,u,c,s,h,o,l),Ql(t,u,c,n,i,h,a,o,l)):t.push(a);}function tu(t,e,r){let n=t[0],i=n.x,s=n.y;e(n);const a=[n];for(let o=1;o<t.length;o++){const l=t[o],{x:u,y:c}=l;e(l),Ql(a,i,s,u,c,n,l,e,r),i=u,s=c,n=l;}return a}function eu(t,e,r,n){if(n(e,r)){const i=e.add(r)._mult(.5);eu(t,e,i,n),eu(t,i,r,n);}else t.push(r);}function ru(t,e){let r=t[0];const n=[r];for(let i=1;i<t.length;i++){const s=t[i];eu(n,r,s,e),r=s;}return n}const nu=Math.pow(2,14)-1,iu=-nu-1;function su(t,e){const r=Math.round(t.x*e),n=Math.round(t.y*e);return t.x=M(r,iu,nu),t.y=M(n,iu,nu),(r<t.x||r>t.x+1||n<t.y||n>t.y+1)&&N("Geometry exceeds allowed extent, reduce your vector tile buffer size"),t}function au(t,e,r){const n=t.loadGeometry(),i=t.extent,s=ao/i;if(e&&r&&r.projection.isReprojectedInTileSpace){const s=1<<e.z,{scale:a,x:o,y:l,projection:u}=r,c=t=>{const r=Kl((e.x+t.x/i)/s),n=Xl((e.y+t.y/i)/s),c=u.project(r,n);t.x=(c.x*a-o)*i,t.y=(c.y*a-l)*i;};for(let e=0;e<n.length;e++)if(1!==t.type)n[e]=tu(n[e],c,1);else {const t=[];for(const r of n[e])r.x<0||r.x>=i||r.y<0||r.y>=i||(c(r),t.push(r));n[e]=t;}}for(const t of n)for(const e of t)su(e,s);return n}function ou(t,e){return {type:t.type,id:t.id,properties:t.properties,geometry:e?au(t):[]}}function lu(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}function uu(t,e,r){const n=16384;t.emplaceBack(e.x,e.y,e.z,r[0]*n,r[1]*n,r[2]*n);}class cu{constructor(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.hasPattern=!1,this.projection=t.projection,this.layoutVertexArray=new $s,this.indexArray=new ra,this.segments=new so,this.programConfigurations=new Ja(t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id));}populate(t,e,r,n){const i=this.layers[0],s=[];let a=null;"circle"===i.type&&(a=i.layout.get("circle-sort-key"));for(const{feature:e,id:i,index:o,sourceLayerIndex:l}of t){const t=this.layers[0]._featureFilter.needGeometry,u=ou(e,t);if(!this.layers[0]._featureFilter.filter(new ws(this.zoom),u,r))continue;const c=a?a.evaluate(u,{},r):void 0,h={id:i,properties:e.properties,type:e.type,sourceLayerIndex:l,index:o,geometry:t?u.geometry:au(e,r,n),patterns:{},sortKey:c};s.push(h);}a&&s.sort(((t,e)=>t.sortKey-e.sortKey));let o=null;"globe"===n.projection.name&&(this.globeExtVertexArray=new Ks,o=n.projection);for(const n of s){const{geometry:i,index:s,sourceLayerIndex:a}=n,l=t[s].feature;this.addFeature(n,i,s,e.availableImages,r,o),e.featureIndex.insert(l,i,s,a,this.index);}}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,no.members),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.globeExtVertexArray&&(this.globeExtVertexBuffer=t.createVertexBuffer(this.globeExtVertexArray,io.members))),this.programConfigurations.upload(t),this.uploaded=!0;}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.globeExtVertexBuffer&&this.globeExtVertexBuffer.destroy());}addFeature(t,e,r,n,i,s){for(const r of e)for(const e of r){const r=e.x,n=e.y;if(r<0||r>=ao||n<0||n>=ao)continue;if(s){const t=s.projectTilePoint(r,n,i),e=s.upVector(i,r,n),a=this.globeExtVertexArray;uu(a,t,e),uu(a,t,e),uu(a,t,e),uu(a,t,e);}const a=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray,t.sortKey),o=a.vertexLength;lu(this.layoutVertexArray,r,n,-1,-1),lu(this.layoutVertexArray,r,n,1,-1),lu(this.layoutVertexArray,r,n,1,1),lu(this.layoutVertexArray,r,n,-1,1),this.indexArray.emplaceBack(o,o+1,o+2),this.indexArray.emplaceBack(o,o+2,o+3),a.vertexLength+=4,a.primitiveLength+=2;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,{},n,i);}}function hu(t,e){for(let r=0;r<t.length;r++)if(bu(e,t[r]))return !0;for(let r=0;r<e.length;r++)if(bu(t,e[r]))return !0;return !!yu(t,e)}function pu(t,e,r){return !!bu(t,e)||!!gu(e,t,r)}function du(t,e){if(1===t.length)return vu(e,t[0]);for(let r=0;r<e.length;r++){const n=e[r];for(let e=0;e<n.length;e++)if(bu(t,n[e]))return !0}for(let r=0;r<t.length;r++)if(vu(e,t[r]))return !0;for(let r=0;r<e.length;r++)if(yu(t,e[r]))return !0;return !1}function fu(t,e,r){if(t.length>1){if(yu(t,e))return !0;for(let n=0;n<e.length;n++)if(gu(e[n],t,r))return !0}for(let n=0;n<t.length;n++)if(gu(t[n],e,r))return !0;return !1}function yu(t,e){if(0===t.length||0===e.length)return !1;for(let r=0;r<t.length-1;r++){const n=t[r],i=t[r+1];for(let t=0;t<e.length-1;t++)if(mu(n,i,e[t],e[t+1]))return !0}return !1}function mu(t,e,r,n){return G(t,r,n)!==G(e,r,n)&&G(t,e,r)!==G(t,e,n)}function gu(t,e,r){const n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(let r=1;r<e.length;r++)if(xu(t,e[r-1],e[r])<n)return !0;return !1}function xu(t,e,r){const n=e.distSqr(r);if(0===n)return t.distSqr(e);const i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return t.distSqr(i<0?e:i>1?r:r.sub(e)._mult(i)._add(e))}function vu(t,e){let r,n,i,s=!1;for(let a=0;a<t.length;a++){r=t[a];for(let t=0,a=r.length-1;t<r.length;a=t++)n=r[t],i=r[a],n.y>e.y!=i.y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(s=!s);}return s}function bu(t,e){let r=!1;for(let n=0,i=t.length-1;n<t.length;i=n++){const s=t[n],a=t[i];s.y>e.y!=a.y>e.y&&e.x<(a.x-s.x)*(e.y-s.y)/(a.y-s.y)+s.x&&(r=!r);}return r}function wu(t,e,r,n,i){for(const s of t)if(e<=s.x&&r<=s.y&&n>=s.x&&i>=s.y)return !0;const s=[new x(e,r),new x(e,i),new x(n,i),new x(n,r)];if(t.length>2)for(const e of s)if(bu(t,e))return !0;for(let e=0;e<t.length-1;e++)if(_u(t[e],t[e+1],s))return !0;return !1}function _u(t,e,r){const n=r[0],i=r[2];if(t.x<n.x&&e.x<n.x||t.x>i.x&&e.x>i.x||t.y<n.y&&e.y<n.y||t.y>i.y&&e.y>i.y)return !1;const s=G(t,e,r[0]);return s!==G(t,e,r[1])||s!==G(t,e,r[2])||s!==G(t,e,r[3])}function Au(t,e,r){const n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).getMaxValue(t)}function Su(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function ku(t,e,r,n,i){if(!e[0]&&!e[1])return t;const s=x.convert(e)._mult(i);"viewport"===r&&s._rotate(-n);const a=[];for(let e=0;e<t.length;e++)a.push(t[e].sub(s));return a}function Iu(t,e,r,n){const i=x.convert(t)._mult(n);return "viewport"===e&&i._rotate(-r),i}Ji(cu,"CircleBucket",{omit:["layers"]});const Mu=new Ps({"circle-sort-key":new Es(te.layout_circle["circle-sort-key"])});var Tu={paint:new Ps({"circle-radius":new Es(te.paint_circle["circle-radius"]),"circle-color":new Es(te.paint_circle["circle-color"]),"circle-blur":new Es(te.paint_circle["circle-blur"]),"circle-opacity":new Es(te.paint_circle["circle-opacity"]),"circle-translate":new Bs(te.paint_circle["circle-translate"]),"circle-translate-anchor":new Bs(te.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new Bs(te.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new Bs(te.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new Es(te.paint_circle["circle-stroke-width"]),"circle-stroke-color":new Es(te.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new Es(te.paint_circle["circle-stroke-opacity"])}),layout:Mu};function zu(t,e,r,n,i,s,a,o,l){if(s&&t.queryGeometry.isAboveHorizon)return !1;s&&(l*=t.pixelToTileUnitsFactor);const u=t.tileID.canonical,c=r.projection.upVectorScale(u,r.center.lat,r.worldSize).metersToTile;for(const h of e)for(const e of h){const h=e.add(o),p=i&&r.elevation?r.elevation.exaggeration()*i.getElevationAt(h.x,h.y,!0):0,d=r.projection.projectTilePoint(h.x,h.y,u);if(p>0){const t=r.projection.upVector(u,h.x,h.y);d.x+=t[0]*c*p,d.y+=t[1]*c*p,d.z+=t[2]*c*p;}const f=s?h:Bu(d.x,d.y,d.z,n),y=s?t.tilespaceRays.map((t=>Pu(t,p))):t.queryGeometry.screenGeometry,m=Go([],[d.x,d.y,d.z,1],n);if(!a&&s?l*=m[3]/r.cameraToCenterDistance:a&&!s&&(l*=r.cameraToCenterDistance/m[3]),s){const t=Xl((e.y/ao+u.y)/(1<<u.z));l/=r.projection.pixelsPerMeter(t,1)/Zl(1,t);}if(pu(y,f,l))return !0}return !1}function Bu(t,e,r,n){const i=Go([],[t,e,r,1],n);return new x(i[0]/i[3],i[1]/i[3])}const Eu=Io(0,0,0),Cu=Io(0,0,1);function Pu(t,e){const r=Ao();return Eu[2]=e,t.intersectsPlane(Eu,Cu,r),new x(r[0],r[1])}class Du extends cu{}function Vu(t,{width:e,height:r},n,i){if(i){if(i instanceof Uint8ClampedArray)i=new Uint8Array(i.buffer);else if(i.length!==e*r*n)throw new RangeError("mismatched image size")}else i=new Uint8Array(e*r*n);return t.width=e,t.height=r,t.data=i,t}function Lu(t,e,r){const{width:n,height:i}=e;n===t.width&&i===t.height||(Fu(t,e,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=e.data);}function Fu(t,e,r,n,i,s){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");const a=t.data,o=e.data;for(let l=0;l<i.height;l++){const u=((r.y+l)*t.width+r.x)*s,c=((n.y+l)*e.width+n.x)*s;for(let t=0;t<i.width*s;t++)o[c+t]=a[u+t];}return e}Ji(Du,"HeatmapBucket",{omit:["layers"]});class Ru{constructor(t,e){Vu(this,t,1,e);}resize(t){Lu(this,new Ru(t),1);}clone(){return new Ru({width:this.width,height:this.height},new Uint8Array(this.data))}static copy(t,e,r,n,i){Fu(t,e,r,n,i,1);}}class Uu{constructor(t,e){Vu(this,t,4,e);}resize(t){Lu(this,new Uu(t),4);}replace(t,e){e?this.data.set(t):this.data=t instanceof Uint8ClampedArray?new Uint8Array(t.buffer):t;}clone(){return new Uu({width:this.width,height:this.height},new Uint8Array(this.data))}static copy(t,e,r,n,i){Fu(t,e,r,n,i,4);}}Ji(Ru,"AlphaImage"),Ji(Uu,"RGBAImage");var $u={paint:new Ps({"heatmap-radius":new Es(te.paint_heatmap["heatmap-radius"]),"heatmap-weight":new Es(te.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new Bs(te.paint_heatmap["heatmap-intensity"]),"heatmap-color":new Cs(te.paint_heatmap["heatmap-color"]),"heatmap-opacity":new Bs(te.paint_heatmap["heatmap-opacity"])})};function ju(t){const e={},r=t.resolution||256,n=t.clips?t.clips.length:1,i=t.image||new Uu({width:r,height:n}),s=(r,n,s)=>{e[t.evaluationKey]=s;const a=t.expression.evaluate(e);i.data[r+n+0]=Math.floor(255*a.r/a.a),i.data[r+n+1]=Math.floor(255*a.g/a.a),i.data[r+n+2]=Math.floor(255*a.b/a.a),i.data[r+n+3]=Math.floor(255*a.a);};if(t.clips)for(let e=0,i=0;e<n;++e,i+=4*r)for(let n=0,a=0;n<r;n++,a+=4){const o=n/(r-1),{start:l,end:u}=t.clips[e];s(i,a,l*(1-o)+u*o);}else for(let t=0,e=0;t<r;t++,e+=4)s(0,e,t/(r-1));return i}var Ou={paint:new Ps({"hillshade-illumination-direction":new Bs(te.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new Bs(te.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new Bs(te.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new Bs(te.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new Bs(te.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new Bs(te.paint_hillshade["hillshade-accent-color"])})};const qu=Rs([{name:"a_pos",components:2,type:"Int16"}],4),{members:Nu}=qu;var Gu={exports:{}};function Zu(t,e,r){r=r||2;var n,i,s,a,o,l,u,c=e&&e.length,h=c?e[0]*r:t.length,p=Ku(t,0,h,r,!0),d=[];if(!p||p.next===p.prev)return d;if(c&&(p=function(t,e,r,n){var i,s,a,o=[];for(i=0,s=e.length;i<s;i++)(a=Ku(t,e[i]*n,i<s-1?e[i+1]*n:t.length,n,!1))===a.next&&(a.steiner=!0),o.push(ic(a));for(o.sort(tc),i=0;i<o.length;i++)r=ec(o[i],r);return r}(t,e,p,r)),t.length>80*r){n=s=t[0],i=a=t[1];for(var f=r;f<h;f+=r)(o=t[f])<n&&(n=o),(l=t[f+1])<i&&(i=l),o>s&&(s=o),l>a&&(a=l);u=0!==(u=Math.max(s-n,a-i))?32767/u:0;}return Ju(p,d,r,n,i,u,0),d}function Ku(t,e,r,n,i){var s,a;if(i===gc(t,e,r,n)>0)for(s=e;s<r;s+=n)a=fc(s,t[s],t[s+1],a);else for(s=r-n;s>=e;s-=n)a=fc(s,t[s],t[s+1],a);return a&&lc(a,a.next)&&(yc(a),a=a.next),a}function Xu(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!lc(n,n.next)&&0!==oc(n.prev,n,n.next))n=n.next;else {if(yc(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function Ju(t,e,r,n,i,s,a){if(t){!a&&s&&function(t,e,r,n){var i=t;do{0===i.z&&(i.z=nc(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,s,a,o,l,u=1;do{for(r=t,t=null,s=null,a=0;r;){for(a++,n=r,o=0,e=0;e<u&&(o++,n=n.nextZ);e++);for(l=u;o>0||l>0&&n;)0!==o&&(0===l||!n||r.z<=n.z)?(i=r,r=r.nextZ,o--):(i=n,n=n.nextZ,l--),s?s.nextZ=i:t=i,i.prevZ=s,s=i;r=n;}s.nextZ=null,u*=2;}while(a>1)}(i);}(t,n,i,s);for(var o,l,u=t;t.prev!==t.next;)if(o=t.prev,l=t.next,s?Yu(t,n,i,s):Hu(t))e.push(o.i/r|0),e.push(t.i/r|0),e.push(l.i/r|0),yc(t),t=l.next,u=l.next;else if((t=l)===u){a?1===a?Ju(t=Wu(Xu(t),e,r),e,r,n,i,s,2):2===a&&Qu(t,e,r,n,i,s):Ju(Xu(t),e,r,n,i,s,1);break}}}function Hu(t){var e=t.prev,r=t,n=t.next;if(oc(e,r,n)>=0)return !1;for(var i=e.x,s=r.x,a=n.x,o=e.y,l=r.y,u=n.y,c=i<s?i<a?i:a:s<a?s:a,h=o<l?o<u?o:u:l<u?l:u,p=i>s?i>a?i:a:s>a?s:a,d=o>l?o>u?o:u:l>u?l:u,f=n.next;f!==e;){if(f.x>=c&&f.x<=p&&f.y>=h&&f.y<=d&&sc(i,o,s,l,a,u,f.x,f.y)&&oc(f.prev,f,f.next)>=0)return !1;f=f.next;}return !0}function Yu(t,e,r,n){var i=t.prev,s=t,a=t.next;if(oc(i,s,a)>=0)return !1;for(var o=i.x,l=s.x,u=a.x,c=i.y,h=s.y,p=a.y,d=o<l?o<u?o:u:l<u?l:u,f=c<h?c<p?c:p:h<p?h:p,y=o>l?o>u?o:u:l>u?l:u,m=c>h?c>p?c:p:h>p?h:p,g=nc(d,f,e,r,n),x=nc(y,m,e,r,n),v=t.prevZ,b=t.nextZ;v&&v.z>=g&&b&&b.z<=x;){if(v.x>=d&&v.x<=y&&v.y>=f&&v.y<=m&&v!==i&&v!==a&&sc(o,c,l,h,u,p,v.x,v.y)&&oc(v.prev,v,v.next)>=0)return !1;if(v=v.prevZ,b.x>=d&&b.x<=y&&b.y>=f&&b.y<=m&&b!==i&&b!==a&&sc(o,c,l,h,u,p,b.x,b.y)&&oc(b.prev,b,b.next)>=0)return !1;b=b.nextZ;}for(;v&&v.z>=g;){if(v.x>=d&&v.x<=y&&v.y>=f&&v.y<=m&&v!==i&&v!==a&&sc(o,c,l,h,u,p,v.x,v.y)&&oc(v.prev,v,v.next)>=0)return !1;v=v.prevZ;}for(;b&&b.z<=x;){if(b.x>=d&&b.x<=y&&b.y>=f&&b.y<=m&&b!==i&&b!==a&&sc(o,c,l,h,u,p,b.x,b.y)&&oc(b.prev,b,b.next)>=0)return !1;b=b.nextZ;}return !0}function Wu(t,e,r){var n=t;do{var i=n.prev,s=n.next.next;!lc(i,s)&&uc(i,n,n.next,s)&&pc(i,s)&&pc(s,i)&&(e.push(i.i/r|0),e.push(n.i/r|0),e.push(s.i/r|0),yc(n),yc(n.next),n=t=s),n=n.next;}while(n!==t);return Xu(n)}function Qu(t,e,r,n,i,s){var a=t;do{for(var o=a.next.next;o!==a.prev;){if(a.i!==o.i&&ac(a,o)){var l=dc(a,o);return a=Xu(a,a.next),l=Xu(l,l.next),Ju(a,e,r,n,i,s,0),void Ju(l,e,r,n,i,s,0)}o=o.next;}a=a.next;}while(a!==t)}function tc(t,e){return t.x-e.x}function ec(t,e){var r=function(t,e){var r,n=e,i=t.x,s=t.y,a=-1/0;do{if(s<=n.y&&s>=n.next.y&&n.next.y!==n.y){var o=n.x+(s-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(o<=i&&o>a&&(a=o,r=n.x<n.next.x?n:n.next,o===i))return r}n=n.next;}while(n!==e);if(!r)return null;var l,u=r,c=r.x,h=r.y,p=1/0;n=r;do{i>=n.x&&n.x>=c&&i!==n.x&&sc(s<h?i:a,s,c,h,s<h?a:i,s,n.x,n.y)&&(l=Math.abs(s-n.y)/(i-n.x),pc(n,t)&&(l<p||l===p&&(n.x>r.x||n.x===r.x&&rc(r,n)))&&(r=n,p=l)),n=n.next;}while(n!==u);return r}(t,e);if(!r)return e;var n=dc(r,t);return Xu(n,n.next),Xu(r,r.next)}function rc(t,e){return oc(t.prev,t,e.prev)<0&&oc(e.next,t,t.next)<0}function nc(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=(t-r)*i|0)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=(e-n)*i|0)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function ic(t){var e=t,r=t;do{(e.x<r.x||e.x===r.x&&e.y<r.y)&&(r=e),e=e.next;}while(e!==t);return r}function sc(t,e,r,n,i,s,a,o){return (i-a)*(e-o)>=(t-a)*(s-o)&&(t-a)*(n-o)>=(r-a)*(e-o)&&(r-a)*(s-o)>=(i-a)*(n-o)}function ac(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&uc(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&(pc(t,e)&&pc(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,s=(t.y+e.y)/2;do{r.y>s!=r.next.y>s&&r.next.y!==r.y&&i<(r.next.x-r.x)*(s-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)&&(oc(t.prev,t,e.prev)||oc(t,e.prev,e))||lc(t,e)&&oc(t.prev,t,t.next)>0&&oc(e.prev,e,e.next)>0)}function oc(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function lc(t,e){return t.x===e.x&&t.y===e.y}function uc(t,e,r,n){var i=hc(oc(t,e,r)),s=hc(oc(t,e,n)),a=hc(oc(r,n,t)),o=hc(oc(r,n,e));return i!==s&&a!==o||!(0!==i||!cc(t,r,e))||!(0!==s||!cc(t,n,e))||!(0!==a||!cc(r,t,n))||!(0!==o||!cc(r,e,n))}function cc(t,e,r){return e.x<=Math.max(t.x,r.x)&&e.x>=Math.min(t.x,r.x)&&e.y<=Math.max(t.y,r.y)&&e.y>=Math.min(t.y,r.y)}function hc(t){return t>0?1:t<0?-1:0}function pc(t,e){return oc(t.prev,t,t.next)<0?oc(t,e,t.next)>=0&&oc(t,t.prev,e)>=0:oc(t,e,t.prev)<0||oc(t,t.next,e)<0}function dc(t,e){var r=new mc(t.i,t.x,t.y),n=new mc(e.i,e.x,e.y),i=t.next,s=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,s.next=n,n.prev=s,n}function fc(t,e,r,n){var i=new mc(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function yc(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function mc(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=0,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function gc(t,e,r,n){for(var i=0,s=e,a=r-n;s<r;s+=n)i+=(t[a]-t[s])*(t[s+1]+t[a+1]),a=s;return i}Gu.exports=Zu,Gu.exports.default=Zu,Zu.deviation=function(t,e,r,n){var i=e&&e.length,s=Math.abs(gc(t,0,i?e[0]*r:t.length,r));if(i)for(var a=0,o=e.length;a<o;a++)s-=Math.abs(gc(t,e[a]*r,a<o-1?e[a+1]*r:t.length,r));var l=0;for(a=0;a<n.length;a+=3){var u=n[a]*r,c=n[a+1]*r,h=n[a+2]*r;l+=Math.abs((t[u]-t[h])*(t[c+1]-t[u+1])-(t[u]-t[c])*(t[h+1]-t[u+1]));}return 0===s&&0===l?0:Math.abs((l-s)/s)},Zu.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var s=0;s<t[i].length;s++)for(var a=0;a<e;a++)r.vertices.push(t[i][s][a]);i>0&&r.holes.push(n+=t[i-1].length);}return r};var xc=p(Gu.exports);function vc(t,e,r,n,i){bc(t,e,r||0,n||t.length-1,i||_c);}function bc(t,e,r,n,i){for(;n>r;){if(n-r>600){var s=n-r+1,a=e-r+1,o=Math.log(s),l=.5*Math.exp(2*o/3),u=.5*Math.sqrt(o*l*(s-l)/s)*(a-s/2<0?-1:1);bc(t,e,Math.max(r,Math.floor(e-a*l/s+u)),Math.min(n,Math.floor(e+(s-a)*l/s+u)),i);}var c=t[e],h=r,p=n;for(wc(t,r,e),i(t[n],c)>0&&wc(t,r,n);h<p;){for(wc(t,h,p),h++,p--;i(t[h],c)<0;)h++;for(;i(t[p],c)>0;)p--;}0===i(t[r],c)?wc(t,r,p):wc(t,++p,n),p<=e&&(r=p+1),e<=p&&(n=p-1);}}function wc(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function _c(t,e){return t<e?-1:t>e?1:0}function Ac(t,e){const r=t.length;if(r<=1)return [t];const n=[];let i,s;for(let e=0;e<r;e++){const r=Z(t[e]);0!==r&&(t[e].area=Math.abs(r),void 0===s&&(s=r<0),s===r<0?(i&&n.push(i),i=[t[e]]):i.push(t[e]));}if(i&&n.push(i),e>1)for(let t=0;t<n.length;t++)n[t].length<=e||(vc(n[t],e,1,n[t].length-1,Sc),n[t]=n[t].slice(0,e));return n}function Sc(t,e){return e.area-t.area}function kc(t,e,r){const n=r.patternDependencies;let i=!1;for(const r of e){const e=r.paint.get(`${t}-pattern`);e.isConstant()||(i=!0);const s=e.constantOr(null);s&&(i=!0,n[s]=!0);}return i}function Ic(t,e,r,n,i){const s=i.patternDependencies;for(const a of e){const e=a.paint.get(`${t}-pattern`).value;if("constant"!==e.kind){let t=e.evaluate({zoom:n},r,{},i.availableImages);t=t&&t.name?t.name:t,s[t]=!0,r.patterns[a.id]=t;}}return r}class Mc{constructor(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new $s,this.indexArray=new ra,this.indexArray2=new la,this.programConfigurations=new Ja(t.layers,t.zoom),this.segments=new so,this.segments2=new so,this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id)),this.projection=t.projection;}populate(t,e,r,n){this.hasPattern=kc("fill",this.layers,e);const i=this.layers[0].layout.get("fill-sort-key"),s=[];for(const{feature:a,id:o,index:l,sourceLayerIndex:u}of t){const t=this.layers[0]._featureFilter.needGeometry,c=ou(a,t);if(!this.layers[0]._featureFilter.filter(new ws(this.zoom),c,r))continue;const h=i?i.evaluate(c,{},r,e.availableImages):void 0,p={id:o,properties:a.properties,type:a.type,sourceLayerIndex:u,index:l,geometry:t?c.geometry:au(a,r,n),patterns:{},sortKey:h};s.push(p);}i&&s.sort(((t,e)=>t.sortKey-e.sortKey));for(const n of s){const{geometry:i,index:s,sourceLayerIndex:a}=n;if(this.hasPattern){const t=Ic("fill",this.layers,n,this.zoom,e);this.patternFeatures.push(t);}else this.addFeature(n,i,s,r,{},e.availableImages);e.featureIndex.insert(t[s].feature,i,s,a,this.index);}}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}addFeatures(t,e,r,n,i){for(const t of this.patternFeatures)this.addFeature(t,t.geometry,t.index,e,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Nu),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());}addFeature(t,e,r,n,i,s=[]){for(const t of Ac(e,500)){let e=0;for(const r of t)e+=r.length;const r=this.segments.prepareSegment(e,this.layoutVertexArray,this.indexArray),n=r.vertexLength,i=[],s=[];for(const e of t){if(0===e.length)continue;e!==t[0]&&s.push(i.length/2);const r=this.segments2.prepareSegment(e.length,this.layoutVertexArray,this.indexArray2),n=r.vertexLength;this.layoutVertexArray.emplaceBack(e[0].x,e[0].y),this.indexArray2.emplaceBack(n+e.length-1,n),i.push(e[0].x),i.push(e[0].y);for(let t=1;t<e.length;t++)this.layoutVertexArray.emplaceBack(e[t].x,e[t].y),this.indexArray2.emplaceBack(n+t-1,n+t),i.push(e[t].x),i.push(e[t].y);r.vertexLength+=e.length,r.primitiveLength+=e.length;}const a=xc(i,s);for(let t=0;t<a.length;t+=3)this.indexArray.emplaceBack(n+a[t],n+a[t+1],n+a[t+2]);r.vertexLength+=e,r.primitiveLength+=a.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,s,n);}}Ji(Mc,"FillBucket",{omit:["layers","patternFeatures"]});const Tc=new Ps({"fill-sort-key":new Es(te.layout_fill["fill-sort-key"])});var zc={paint:new Ps({"fill-antialias":new Bs(te.paint_fill["fill-antialias"]),"fill-opacity":new Es(te.paint_fill["fill-opacity"]),"fill-color":new Es(te.paint_fill["fill-color"]),"fill-outline-color":new Es(te.paint_fill["fill-outline-color"]),"fill-translate":new Bs(te.paint_fill["fill-translate"]),"fill-translate-anchor":new Bs(te.paint_fill["fill-translate-anchor"]),"fill-pattern":new Es(te.paint_fill["fill-pattern"])}),layout:Tc};const Bc=Rs([{name:"a_pos_normal_ed",components:4,type:"Int16"}]),Ec=Rs([{name:"a_centroid_pos",components:2,type:"Uint16"}]),Cc=Rs([{name:"a_pos_3",components:3,type:"Int16"},{name:"a_pos_normal_3",components:3,type:"Int16"}]),{members:Pc}=Bc;var Dc={},Vc=m,Lc=Fc;function Fc(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(Rc,this,e);}function Rc(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){for(var r=t.readVarint()+t.pos;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function Uc(t){for(var e,r,n=0,i=0,s=t.length,a=s-1;i<s;a=i++)n+=((r=t[a]).x-(e=t[i]).x)*(e.y+r.y);return n}Fc.types=["Unknown","Point","LineString","Polygon"],Fc.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,i=0,s=0,a=0,o=[];t.pos<r;){if(i<=0){var l=t.readVarint();n=7&l,i=l>>3;}if(i--,1===n||2===n)s+=t.readSVarint(),a+=t.readSVarint(),1===n&&(e&&o.push(e),e=[]),e.push(new Vc(s,a));else {if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&o.push(e),o},Fc.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,s=0,a=1/0,o=-1/0,l=1/0,u=-1/0;t.pos<e;){if(n<=0){var c=t.readVarint();r=7&c,n=c>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<a&&(a=i),i>o&&(o=i),(s+=t.readSVarint())<l&&(l=s),s>u&&(u=s);else if(7!==r)throw new Error("unknown command "+r)}return [a,l,o,u]},Fc.prototype.toGeoJSON=function(t,e,r){var n,i,s=this.extent*Math.pow(2,r),a=this.extent*t,o=this.extent*e,l=this.loadGeometry(),u=Fc.types[this.type];function c(t){for(var e=0;e<t.length;e++){var r=t[e];t[e]=[360*(r.x+a)/s-180,360/Math.PI*Math.atan(Math.exp((180-360*(r.y+o)/s)*Math.PI/180))-90];}}switch(this.type){case 1:var h=[];for(n=0;n<l.length;n++)h[n]=l[n][0];c(l=h);break;case 2:for(n=0;n<l.length;n++)c(l[n]);break;case 3:for(l=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],s=0;s<e;s++){var a=Uc(t[s]);0!==a&&(void 0===n&&(n=a<0),n===a<0?(r&&i.push(r),r=[t[s]]):r.push(t[s]));}return r&&i.push(r),i}(l),n=0;n<l.length;n++)for(i=0;i<l[n].length;i++)c(l[n][i]);}1===l.length?l=l[0]:u="Multi"+u;var p={type:"Feature",geometry:{type:u,coordinates:l},properties:this.properties};return "id"in this&&(p.id=this.id),p};var $c=Lc,jc=Oc;function Oc(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(qc,this,e),this.length=this._features.length;}function qc(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){for(var e=null,r=t.readVarint()+t.pos;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}Oc.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new $c(this._pbf,e,this.extent,this._keys,this._values)};var Nc=jc;function Gc(t,e,r){if(3===t){var n=new Nc(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}var Zc=Dc.VectorTile=function(t,e){this.layers=t.readFields(Gc,{},e);},Kc=Dc.VectorTileFeature=Lc;function Xc(t,e,r,n){const i=[],s=0===n?(t,e,r,n,i,s)=>{t.push(new x(s,r+(s-e)/(n-e)*(i-r)));}:(t,e,r,n,i,s)=>{t.push(new x(e+(s-r)/(i-r)*(n-e),s));};for(const a of t){const t=[];for(const i of a){if(i.length<=2)continue;const a=[];for(let t=0;t<i.length-1;t++){const o=i[t].x,l=i[t].y,u=i[t+1].x,c=i[t+1].y,h=0===n?o:l,p=0===n?u:c;h<e?p>e&&s(a,o,l,u,c,e):h>r?p<r&&s(a,o,l,u,c,r):a.push(i[t]),p<e&&h>=e&&s(a,o,l,u,c,e),p>r&&h<=r&&s(a,o,l,u,c,r);}let o=i[i.length-1];const l=0===n?o.x:o.y;l>=e&&l<=r&&a.push(o),a.length&&(o=a[a.length-1],a[0].x===o.x&&a[0].y===o.y||a.push(a[0]),t.push(a));}t.length&&i.push(t);}return i}Dc.VectorTileLayer=jc;const Jc=Kc.types,Hc=Math.pow(2,13);function Yc(t,e,r,n,i,s,a,o){t.emplaceBack((e<<1)+a,(r<<1)+s,(Math.floor(n*Hc)<<1)+i,Math.round(o));}function Wc(t,e,r){const n=16384;t.emplaceBack(e.x,e.y,e.z,r[0]*n,r[1]*n,r[2]*n);}class Qc{constructor(){this.acc=new x(0,0),this.polyCount=[];}startRing(t){this.currentPolyCount={edges:0,top:0},this.polyCount.push(this.currentPolyCount),this.min||(this.min=new x(t.x,t.y),this.max=new x(t.x,t.y));}append(t,e){this.currentPolyCount.edges++,this.acc._add(t);const r=this.min,n=this.max;t.x<r.x?r.x=t.x:t.x>n.x&&(n.x=t.x),t.y<r.y?r.y=t.y:t.y>n.y&&(n.y=t.y),((0===t.x||t.x===ao)&&t.x===e.x)!=((0===t.y||t.y===ao)&&t.y===e.y)&&this.processBorderOverlap(t,e),e.x<0!=t.x<0&&this.addBorderIntersection(0,Er(e.y,t.y,(0-e.x)/(t.x-e.x))),e.x>ao!=t.x>ao&&this.addBorderIntersection(1,Er(e.y,t.y,(ao-e.x)/(t.x-e.x))),e.y<0!=t.y<0&&this.addBorderIntersection(2,Er(e.x,t.x,(0-e.y)/(t.y-e.y))),e.y>ao!=t.y>ao&&this.addBorderIntersection(3,Er(e.x,t.x,(ao-e.y)/(t.y-e.y)));}addBorderIntersection(t,e){this.borders||(this.borders=[[Number.MAX_VALUE,-Number.MAX_VALUE],[Number.MAX_VALUE,-Number.MAX_VALUE],[Number.MAX_VALUE,-Number.MAX_VALUE],[Number.MAX_VALUE,-Number.MAX_VALUE]]);const r=this.borders[t];e<r[0]&&(r[0]=e),e>r[1]&&(r[1]=e);}processBorderOverlap(t,e){if(t.x===e.x){if(t.y===e.y)return;const r=0===t.x?0:1;this.addBorderIntersection(r,e.y),this.addBorderIntersection(r,t.y);}else {const r=0===t.y?2:3;this.addBorderIntersection(r,e.x),this.addBorderIntersection(r,t.x);}}centroid(){const t=this.polyCount.reduce(((t,e)=>t+e.edges),0);return 0!==t?this.acc.div(t)._round():new x(0,0)}span(){return new x(this.max.x-this.min.x,this.max.y-this.min.y)}intersectsCount(){return this.borders.reduce(((t,e)=>t+ +(e[0]!==Number.MAX_VALUE)),0)}}class th{constructor(t){this.zoom=t.zoom,this.canonical=t.canonical,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.hasPattern=!1,this.edgeRadius=0,this.projection=t.projection,this.layoutVertexArray=new Os,this.centroidVertexArray=new wa,this.indexArray=new ra,this.programConfigurations=new Ja(t.layers,t.zoom),this.segments=new so,this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id)),this.enableTerrain=t.enableTerrain;}populate(t,e,r,n){this.features=[],this.hasPattern=kc("fill-extrusion",this.layers,e),this.featuresOnBorder=[],this.borders=[[],[],[],[]],this.borderDoneWithNeighborZ=[-1,-1,-1,-1],this.tileToMeter=function(t){const e=Math.exp(Math.PI*(1-t.y/(1<<t.z)*2));return 80150034*e/(e*e+1)/ao/(1<<t.z)}(r),this.edgeRadius=this.layers[0].layout.get("fill-extrusion-edge-radius")/this.tileToMeter;for(const{feature:i,id:s,index:a,sourceLayerIndex:o}of t){const t=this.layers[0]._featureFilter.needGeometry,l=ou(i,t);if(!this.layers[0]._featureFilter.filter(new ws(this.zoom),l,r))continue;const u={id:s,sourceLayerIndex:o,index:a,geometry:t?l.geometry:au(i,r,n),properties:i.properties,type:i.type,patterns:{}},c=this.layoutVertexArray.length;this.hasPattern?this.features.push(Ic("fill-extrusion",this.layers,u,this.zoom,e)):this.addFeature(u,u.geometry,a,r,{},e.availableImages,n),e.featureIndex.insert(i,u.geometry,a,o,this.index,c);}this.sortBorders();}addFeatures(t,e,r,n,i){for(const t of this.features){const{geometry:s}=t;this.addFeature(t,s,t.index,e,r,n,i);}this.sortBorders();}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Pc),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.layoutVertexExtArray&&(this.layoutVertexExtBuffer=t.createVertexBuffer(this.layoutVertexExtArray,Cc.members,!0))),this.programConfigurations.upload(t),this.uploaded=!0;}uploadCentroid(t){0!==this.centroidVertexArray.length&&(this.centroidVertexBuffer?this.needsCentroidUpdate&&this.centroidVertexBuffer.updateData(this.centroidVertexArray):this.centroidVertexBuffer=t.createVertexBuffer(this.centroidVertexArray,Ec.members,!0),this.needsCentroidUpdate=!1);}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.centroidVertexBuffer&&this.centroidVertexBuffer.destroy(),this.layoutVertexExtBuffer&&this.layoutVertexExtBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());}addFeature(t,e,r,n,i,s,a){const o=[new x(0,0),new x(ao,ao)],l=a.projection,u="globe"===l.name,c=this.enableTerrain&&!u?new Qc:null,h="Polygon"===Jc[t.type];u&&!this.layoutVertexExtArray&&(this.layoutVertexExtArray=new Ks);const p=Ac(e,500);for(let t=p.length-1;t>=0;t--){const e=p[t];(0===e.length||(d=e[0]).every((t=>t.x<=0))||d.every((t=>t.x>=ao))||d.every((t=>t.y<=0))||d.every((t=>t.y>=ao)))&&p.splice(t,1);}var d;let f;if(u)f=lh(p,o,n);else {f=[];for(const t of p)f.push({polygon:t,bounds:o});}const y=h?this.edgeRadius:0;for(const{polygon:t,bounds:e}of f){let r=0,i=0;for(const e of t)h&&!e[0].equals(e[e.length-1])&&e.push(e[0]),i+=h?e.length-1:e.length;const s=this.segments.prepareSegment((h?5:4)*i,this.layoutVertexArray,this.indexArray);if(h){const e=[],i=[];r=s.vertexLength;for(const r of t){let a,o;r.length&&r!==t[0]&&i.push(e.length/2),a=r[1].sub(r[0])._perp()._unit();for(let t=1;t<r.length;t++){const i=r[t],c=r[t===r.length-1?1:t+1];let{x:h,y:p}=i;if(y){o=c.sub(i)._perp()._unit();const t=a.add(o)._unit(),e=y*Math.min(4,1/(a.x*t.x+a.y*t.y));h+=e*t.x,p+=e*t.y,a=o;}Yc(this.layoutVertexArray,h,p,0,0,1,1,0),s.vertexLength++,e.push(i.x,i.y),u&&Wc(this.layoutVertexExtArray,l.projectTilePoint(h,p,n),l.upVector(n,h,p));}}const a=xc(e,i);for(let t=0;t<a.length;t+=3)this.indexArray.emplaceBack(r+a[t],r+a[t+2],r+a[t+1]),s.primitiveLength++;}for(const i of t){c&&i.length&&c.startRing(i[0]);let t,a,o,p=i.length>4&&sh(i[i.length-2],i[0],i[1]),d=y?rh(i[i.length-2],i[0],i[1],y):0;a=i[1].sub(i[0])._perp()._unit();let f=!0;for(let m=1,g=0;m<i.length;m++){let x=i[m-1],v=i[m];const b=i[m===i.length-1?1:m+1];if(c&&h&&c.currentPolyCount.top++,ih(v,x,e)){y&&(a=b.sub(v)._perp()._unit(),f=!f);continue}c&&c.append(v,x);const w=v.sub(x)._perp(),_=w.x/(Math.abs(w.x)+Math.abs(w.y)),A=w.y>0?1:0,S=x.dist(v);if(g+S>32768&&(g=0),y){o=b.sub(v)._perp()._unit();let t=nh(x,v,b,eh(a,o),y);isNaN(t)&&(t=0);const e=v.sub(x)._unit();x=x.add(e.mult(d))._round(),v=v.add(e.mult(-t))._round(),d=t,a=o;}const k=s.vertexLength,I=i.length>4&&sh(x,v,b);let M=ah(g,p,f);if(Yc(this.layoutVertexArray,x.x,x.y,_,A,0,0,M),Yc(this.layoutVertexArray,x.x,x.y,_,A,0,1,M),g+=S,M=ah(g,I,!f),p=I,Yc(this.layoutVertexArray,v.x,v.y,_,A,0,0,M),Yc(this.layoutVertexArray,v.x,v.y,_,A,0,1,M),s.vertexLength+=4,this.indexArray.emplaceBack(k+0,k+1,k+2),this.indexArray.emplaceBack(k+1,k+3,k+2),s.primitiveLength+=2,y){const n=r+(1===m?i.length-2:m-2),a=1===m?r:n+1;if(this.indexArray.emplaceBack(k+1,n,k+3),this.indexArray.emplaceBack(n,a,k+3),s.primitiveLength+=2,void 0===t&&(t=k),!ih(b,i[m],e)){const e=m===i.length-1?t:s.vertexLength;this.indexArray.emplaceBack(k+2,k+3,e),this.indexArray.emplaceBack(k+3,e+1,e),this.indexArray.emplaceBack(k+3,a,e+1),s.primitiveLength+=3;}f=!f;}if(u){const t=this.layoutVertexExtArray,e=l.projectTilePoint(x.x,x.y,n),r=l.projectTilePoint(v.x,v.y,n),i=l.upVector(n,x.x,x.y),s=l.upVector(n,v.x,v.y);Wc(t,e,i),Wc(t,e,i),Wc(t,r,s),Wc(t,r,s);}}h&&(r+=i.length-1);}}if(c&&c.polyCount.length>0){if(c.borders){c.vertexArrayOffset=this.centroidVertexArray.length;const t=c.borders,e=this.featuresOnBorder.push(c)-1;for(let r=0;r<4;r++)t[r][0]!==Number.MAX_VALUE&&this.borders[r].push(e);}this.encodeCentroid(c.borders?void 0:c.centroid(),c);}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,s,n);}sortBorders(){for(let t=0;t<4;t++)this.borders[t].sort(((e,r)=>this.featuresOnBorder[e].borders[t][0]-this.featuresOnBorder[r].borders[t][0]));}encodeCentroid(t,e,r=!0){let n,i;if(t)if(0!==t.y){const r=e.span()._mult(this.tileToMeter);n=(Math.max(t.x,1)<<3)+Math.min(7,Math.round(r.x/10)),i=(Math.max(t.y,1)<<3)+Math.min(7,Math.round(r.y/10));}else n=Math.ceil(7*(t.x+450)),i=0;else n=0,i=+r;let s=r?this.centroidVertexArray.length:e.vertexArrayOffset;for(const t of e.polyCount){r&&this.centroidVertexArray.resize(this.centroidVertexArray.length+4*t.edges+t.top);for(let e=0;e<t.top;e++)this.centroidVertexArray.emplace(s++,n,i);for(let e=0;e<2*t.edges;e++)this.centroidVertexArray.emplace(s++,0,i),this.centroidVertexArray.emplace(s++,n,i);}}}function eh(t,e){const r=t.add(e)._unit();return t.x*r.x+t.y*r.y}function rh(t,e,r,n){const i=e.sub(t)._perp()._unit(),s=r.sub(e)._perp()._unit();return nh(t,e,r,eh(i,s),n)}function nh(t,e,r,n,i){const s=Math.sqrt(1-n*n);return Math.min(t.dist(e)/3,e.dist(r)/3,i*s/n)}function ih(t,e,r){return t.x<r[0].x&&e.x<r[0].x||t.x>r[1].x&&e.x>r[1].x||t.y<r[0].y&&e.y<r[0].y||t.y>r[1].y&&e.y>r[1].y}function sh(t,e,r){if(t.x<0||t.x>=ao||e.x<0||e.x>=ao||r.x<0||r.x>=ao)return !1;const n=r.sub(e),i=n.perp(),s=t.sub(e);return (n.x*s.x+n.y*s.y)/Math.sqrt((n.x*n.x+n.y*n.y)*(s.x*s.x+s.y*s.y))>-.866&&i.x*s.x+i.y*s.y<0}function ah(t,e,r){const n=e?2|t:-3&t;return r?1|n:-2&n}function oh(){const t=Math.PI/32,e=Math.tan(t),r=Ul;return r*Math.sqrt(1+2*e*e)-r}function lh(t,e,r){const n=1<<r.z,i=Kl(r.x/n),s=Kl((r.x+1)/n),a=Xl(r.y/n),o=Xl((r.y+1)/n);return function(t,e,r,n,i=0,s){const a=[];if(!t.length||!r||!n)return a;const o=(t,e)=>{for(const r of t)a.push({polygon:r,bounds:e});},l=Math.ceil(Math.log2(r)),u=Math.ceil(Math.log2(n)),c=l-u,h=[];for(let t=0;t<Math.abs(c);t++)h.push(c>0?0:1);for(let t=0;t<Math.min(l,u);t++)h.push(0),h.push(1);let p=t;if(p=Xc(p,e[0].y-i,e[1].y+i,1),p=Xc(p,e[0].x-i,e[1].x+i,0),!p.length)return a;const d=[];for(h.length?d.push({polygons:p,bounds:e,depth:0}):o(p,e);d.length;){const t=d.pop(),e=t.depth,r=h[e],n=t.bounds[0],a=t.bounds[1],l=0===r?n.x:n.y,u=0===r?a.x:a.y,c=s?s(r,l,u):.5*(l+u),p=Xc(t.polygons,l-i,c+i,r),f=Xc(t.polygons,c-i,u+i,r);if(p.length){const t=[n,new x(0===r?c:a.x,1===r?c:a.y)];h.length>e+1?d.push({polygons:p,bounds:t,depth:e+1}):o(p,t);}if(f.length){const t=[new x(0===r?c:n.x,1===r?c:n.y),a];h.length>e+1?d.push({polygons:f,bounds:t,depth:e+1}):o(f,t);}}return a}(t,e,Math.ceil((s-i)/11.25),Math.ceil((a-o)/11.25),1,((t,e,i)=>{if(0===t)return .5*(e+i);{const t=Xl((r.y+e/ao)/n);return (Gl(.5*(Xl((r.y+i/ao)/n)+t))*n-r.y)*ao}}))}Ji(th,"FillExtrusionBucket",{omit:["layers","features"]}),Ji(Qc,"PartMetadata");const uh=new Ps({"fill-extrusion-edge-radius":new Bs(te["layout_fill-extrusion"]["fill-extrusion-edge-radius"])});var ch={paint:new Ps({"fill-extrusion-opacity":new Bs(te["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new Es(te["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new Bs(te["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new Bs(te["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new Es(te["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new Es(te["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new Es(te["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new Bs(te["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),"fill-extrusion-ambient-occlusion-intensity":new Bs(te["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),"fill-extrusion-ambient-occlusion-radius":new Bs(te["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),"fill-extrusion-rounded-roof":new Bs(te["paint_fill-extrusion"]["fill-extrusion-rounded-roof"])}),layout:uh};function hh(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}class ph{constructor(t,e,r){this.z=t,this.x=e,this.y=r,this.key=yh(0,t,t,e,r);}equals(t){return this.z===t.z&&this.x===t.x&&this.y===t.y}url(t,e){const r=function(t,e,r){var n=hh(256*t,256*(e=Math.pow(2,r)-e-1),r),i=hh(256*(t+1),256*(e+1),r);return n[0]+","+n[1]+","+i[0]+","+i[1]}(this.x,this.y,this.z),n=function(t,e,r){let n,i="";for(let s=t;s>0;s--)n=1<<s-1,i+=(e&n?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace(/{z}/g,String(this.z)).replace(/{x}/g,String(this.x)).replace(/{y}/g,String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",n).replace("{bbox-epsg-3857}",r)}toString(){return `${this.z}/${this.x}/${this.y}`}}class dh{constructor(t,e){this.wrap=t,this.canonical=e,this.key=yh(t,e.z,e.z,e.x,e.y);}}class fh{constructor(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new ph(r,+n,+i),this.key=0===e&&t===r?this.canonical.key:yh(e,t,r,n,i);}equals(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)}scaledTo(t){const e=this.canonical.z-t;return t>this.canonical.z?new fh(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new fh(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)}calculateScaledKey(t,e=!0){if(this.overscaledZ===t&&e)return this.key;if(t>this.canonical.z)return yh(this.wrap*+e,t,this.canonical.z,this.canonical.x,this.canonical.y);{const r=this.canonical.z-t;return yh(this.wrap*+e,t,t,this.canonical.x>>r,this.canonical.y>>r)}}isChildOf(t){if(t.wrap!==this.wrap)return !1;const e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e}children(t){if(this.overscaledZ>=t)return [new fh(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];const e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new fh(e,this.wrap,e,r,n),new fh(e,this.wrap,e,r+1,n),new fh(e,this.wrap,e,r,n+1),new fh(e,this.wrap,e,r+1,n+1)]}isLessThan(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))}wrapped(){return new fh(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)}unwrapTo(t){return new fh(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)}overscaleFactor(){return Math.pow(2,this.overscaledZ-this.canonical.z)}toUnwrapped(){return new dh(this.wrap,this.canonical)}toString(){return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`}}function yh(t,e,r,n,i){const s=1<<Math.min(r,22);let a=s*(i%s)+n%s;return t&&r<22&&(a+=s*s*((t<0?-2*t-1:2*t)%(1<<2*(22-r)))),16*(32*a+r)+(e-r)}Ji(ph,"CanonicalTileID"),Ji(fh,"OverscaledTileID",{omit:["projMatrix"]});class mh extends x{constructor(t,e,r){super(t,e),this.z=r;}}function gh(t,e){return t.x*e.x+t.y*e.y}function xh(t,e){if(1===t.length){let r=0;const n=e[r++];let i;for(;!i||n.equals(i);)if(i=e[r++],!i)return 1/0;for(;r<e.length;r++){const s=e[r],a=t[0],o=i.sub(n),l=s.sub(n),u=a.sub(n),c=gh(o,o),h=gh(o,l),p=gh(l,l),d=gh(u,o),f=gh(u,l),y=c*p-h*h,m=(p*d-h*f)/y,g=(c*f-h*d)/y,x=n.z*(1-m-g)+i.z*m+s.z*g;if(isFinite(x))return x}return 1/0}{let t=1/0;for(const r of e)t=Math.min(t,r.z);return t}}function vh(t,e,r,n,i,s,a,o){const l=a*i.getElevationAt(t,e,!0,!0),u=0!==s[0],c=u?0===s[1]?a*(s[0]/7-450):a*function(t,e,r){const n=Math.floor(e[0]/8),i=Math.floor(e[1]/8),s=10*(e[0]-8*n),a=10*(e[1]-8*i),o=t.getElevationAt(n,i,!0,!0),l=t.getMeterToDEM(r),u=Math.floor(.5*(s*l-1)),c=Math.floor(.5*(a*l-1)),h=t.tileCoordToPixel(n,i),p=2*u+1,d=2*c+1,f=function(t,e,r,n,i){return [t.getElevationAtPixel(e,r,!0),t.getElevationAtPixel(e+i,r,!0),t.getElevationAtPixel(e,r+i,!0),t.getElevationAtPixel(e+n,r+i,!0)]}(t,h.x-u,h.y-c,p,d),y=Math.abs(f[0]-f[1]),m=Math.abs(f[2]-f[3]),g=Math.abs(f[0]-f[2])+Math.abs(f[1]-f[3]),x=Math.min(.25,.5*l*(y+m)/p),v=Math.min(.25,.5*l*g/d);return o+Math.max(x*s,v*a)}(i,s,o):l;return {base:l+(0===r)?-1:r,top:u?Math.max(c+n,l+r+2):l+n}}const bh=Rs([{name:"a_pos_normal",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"},{name:"a_linesofar",components:1,type:"Float32"}],4),{members:wh}=bh,_h=Rs([{name:"a_packed",components:4,type:"Float32"}]),{members:Ah}=_h,Sh=Kc.types,kh=Math.cos(Math.PI/180*37.5);class Ih{constructor(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.projection=t.projection,this.hasPattern=!1,this.patternFeatures=[],this.lineClipsArray=[],this.gradients={},this.layers.forEach((t=>{this.gradients[t.id]={};})),this.layoutVertexArray=new qs,this.layoutVertexArray2=new Ns,this.indexArray=new ra,this.programConfigurations=new Ja(t.layers,t.zoom),this.segments=new so,this.maxLineLength=0,this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id));}populate(t,e,r,n){this.hasPattern=kc("line",this.layers,e);const i=this.layers[0].layout.get("line-sort-key"),s=[];for(const{feature:e,id:a,index:o,sourceLayerIndex:l}of t){const t=this.layers[0]._featureFilter.needGeometry,u=ou(e,t);if(!this.layers[0]._featureFilter.filter(new ws(this.zoom),u,r))continue;const c=i?i.evaluate(u,{},r):void 0,h={id:a,properties:e.properties,type:e.type,sourceLayerIndex:l,index:o,geometry:t?u.geometry:au(e,r,n),patterns:{},sortKey:c};s.push(h);}i&&s.sort(((t,e)=>t.sortKey-e.sortKey));const{lineAtlas:a,featureIndex:o}=e,l=this.addConstantDashes(a);for(const n of s){const{geometry:i,index:s,sourceLayerIndex:u}=n;if(l&&this.addFeatureDashes(n,a),this.hasPattern){const t=Ic("line",this.layers,n,this.zoom,e);this.patternFeatures.push(t);}else this.addFeature(n,i,s,r,a.positions,e.availableImages);o.insert(t[s].feature,i,s,u,this.index);}}addConstantDashes(t){let e=!1;for(const r of this.layers){const n=r.paint.get("line-dasharray").value,i=r.layout.get("line-cap").value;if("constant"!==n.kind||"constant"!==i.kind)e=!0;else {const e=i.value,r=n.value;if(!r)continue;t.addDash(r,e);}}return e}addFeatureDashes(t,e){const r=this.zoom;for(const n of this.layers){const i=n.paint.get("line-dasharray").value,s=n.layout.get("line-cap").value;if("constant"===i.kind&&"constant"===s.kind)continue;let a,o;if("constant"===i.kind){if(a=i.value,!a)continue}else a=i.evaluate({zoom:r},t);o="constant"===s.kind?s.value:s.evaluate({zoom:r},t),e.addDash(a,o),t.patterns[n.id]=e.getKey(a,o);}}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}addFeatures(t,e,r,n,i){for(const t of this.patternFeatures)this.addFeature(t,t.geometry,t.index,e,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(0!==this.layoutVertexArray2.length&&(this.layoutVertexBuffer2=t.createVertexBuffer(this.layoutVertexArray2,Ah)),this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,wh),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());}lineFeatureClips(t){if(t.properties&&t.properties.hasOwnProperty("mapbox_clip_start")&&t.properties.hasOwnProperty("mapbox_clip_end"))return {start:+t.properties.mapbox_clip_start,end:+t.properties.mapbox_clip_end}}addFeature(t,e,r,n,i,s){const a=this.layers[0].layout,o=a.get("line-join").evaluate(t,{}),l=a.get("line-cap").evaluate(t,{}),u=a.get("line-miter-limit"),c=a.get("line-round-limit");this.lineClips=this.lineFeatureClips(t);for(const r of e)this.addLine(r,t,o,l,u,c);this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,s,n);}addLine(t,e,r,n,i,s){if(this.distance=0,this.scaledDistance=0,this.totalDistance=0,this.lineSoFar=0,this.lineClips){this.lineClipsArray.push(this.lineClips);for(let e=0;e<t.length-1;e++)this.totalDistance+=t[e].dist(t[e+1]);this.updateScaledDistance(),this.maxLineLength=Math.max(this.maxLineLength,this.totalDistance);}const a="Polygon"===Sh[e.type];let o=t.length;for(;o>=2&&t[o-1].equals(t[o-2]);)o--;let l=0;for(;l<o-1&&t[l].equals(t[l+1]);)l++;if(o<(a?3:2))return;"bevel"===r&&(i=1.05);const u=this.overscaling<=16?15*ao/(512*this.overscaling):0,c=this.segments.prepareSegment(10*o,this.layoutVertexArray,this.indexArray);let h,p,d,f,y;this.e1=this.e2=-1,a&&(h=t[o-2],y=t[l].sub(h)._unit()._perp());for(let e=l;e<o;e++){if(d=e===o-1?a?t[l+1]:void 0:t[e+1],d&&t[e].equals(d))continue;y&&(f=y),h&&(p=h),h=t[e],y=d?d.sub(h)._unit()._perp():f,f=f||y;let m=f.add(y);0===m.x&&0===m.y||m._unit();const g=f.x*y.x+f.y*y.y,x=m.x*y.x+m.y*y.y,v=0!==x?1/x:1/0,b=2*Math.sqrt(2-2*x),w=x<kh&&p&&d,_=f.x*y.y-f.y*y.x>0;if(w&&e>l){const t=h.dist(p);if(t>2*u){const e=h.sub(h.sub(p)._mult(u/t)._round());this.updateDistance(p,e),this.addCurrentVertex(e,f,0,0,c),p=e;}}const A=p&&d;let S=A?r:a?"butt":n;if(A&&"round"===S&&(v<s?S="miter":v<=2&&(S="fakeround")),"miter"===S&&v>i&&(S="bevel"),"bevel"===S&&(v>2&&(S="flipbevel"),v<i&&(S="miter")),p&&this.updateDistance(p,h),"miter"===S)m._mult(v),this.addCurrentVertex(h,m,0,0,c);else if("flipbevel"===S){if(v>100)m=y.mult(-1);else {const t=v*f.add(y).mag()/f.sub(y).mag();m._perp()._mult(t*(_?-1:1));}this.addCurrentVertex(h,m,0,0,c),this.addCurrentVertex(h,m.mult(-1),0,0,c);}else if("bevel"===S||"fakeround"===S){const t=-Math.sqrt(v*v-1),e=_?t:0,r=_?0:t;if(p&&this.addCurrentVertex(h,f,e,r,c),"fakeround"===S){const t=Math.round(180*b/Math.PI/20);for(let e=1;e<t;e++){let r=e/t;if(.5!==r){const t=r-.5;r+=r*t*(r-1)*((1.0904+g*(g*(3.55645-1.43519*g)-3.2452))*t*t+(.848013+g*(.215638*g-1.06021)));}const n=y.sub(f)._mult(r)._add(f)._unit()._mult(_?-1:1);this.addHalfVertex(h,n.x,n.y,!1,_,0,c);}}d&&this.addCurrentVertex(h,y,-e,-r,c);}else if("butt"===S)this.addCurrentVertex(h,m,0,0,c);else if("square"===S){const t=p?1:-1;p||this.addCurrentVertex(h,m,t,t,c),this.addCurrentVertex(h,m,0,0,c),p&&this.addCurrentVertex(h,m,t,t,c);}else "round"===S&&(p&&(this.addCurrentVertex(h,f,0,0,c),this.addCurrentVertex(h,f,1,1,c,!0)),d&&(this.addCurrentVertex(h,y,-1,-1,c,!0),this.addCurrentVertex(h,y,0,0,c)));if(w&&e<o-1){const t=h.dist(d);if(t>2*u){const e=h.add(d.sub(h)._mult(u/t)._round());this.updateDistance(h,e),this.addCurrentVertex(e,y,0,0,c),h=e;}}}}addCurrentVertex(t,e,r,n,i,s=!1){const a=e.y*n-e.x,o=-e.y-e.x*n;this.addHalfVertex(t,e.x+e.y*r,e.y-e.x*r,s,!1,r,i),this.addHalfVertex(t,a,o,s,!0,-n,i);}addHalfVertex({x:t,y:e},r,n,i,s,a,o){this.layoutVertexArray.emplaceBack((t<<1)+(i?1:0),(e<<1)+(s?1:0),Math.round(63*r)+128,Math.round(63*n)+128,1+(0===a?0:a<0?-1:1),0,this.lineSoFar),this.lineClips&&this.layoutVertexArray2.emplaceBack(this.scaledDistance,this.lineClipsArray.length,this.lineClips.start,this.lineClips.end);const l=o.vertexLength++;this.e1>=0&&this.e2>=0&&(this.indexArray.emplaceBack(this.e1,this.e2,l),o.primitiveLength++),s?this.e2=l:this.e1=l;}updateScaledDistance(){if(this.lineClips){const t=this.totalDistance/(this.lineClips.end-this.lineClips.start);this.scaledDistance=this.distance/this.totalDistance,this.lineSoFar=t*this.lineClips.start+this.distance;}else this.lineSoFar=this.distance;}updateDistance(t,e){this.distance+=t.dist(e),this.updateScaledDistance();}}Ji(Ih,"LineBucket",{omit:["layers","patternFeatures"]});const Mh=new Ps({"line-cap":new Es(te.layout_line["line-cap"]),"line-join":new Es(te.layout_line["line-join"]),"line-miter-limit":new Bs(te.layout_line["line-miter-limit"]),"line-round-limit":new Bs(te.layout_line["line-round-limit"]),"line-sort-key":new Es(te.layout_line["line-sort-key"])});var Th={paint:new Ps({"line-opacity":new Es(te.paint_line["line-opacity"]),"line-color":new Es(te.paint_line["line-color"]),"line-translate":new Bs(te.paint_line["line-translate"]),"line-translate-anchor":new Bs(te.paint_line["line-translate-anchor"]),"line-width":new Es(te.paint_line["line-width"]),"line-gap-width":new Es(te.paint_line["line-gap-width"]),"line-offset":new Es(te.paint_line["line-offset"]),"line-blur":new Es(te.paint_line["line-blur"]),"line-dasharray":new Es(te.paint_line["line-dasharray"]),"line-pattern":new Es(te.paint_line["line-pattern"]),"line-gradient":new Cs(te.paint_line["line-gradient"]),"line-trim-offset":new Bs(te.paint_line["line-trim-offset"])}),layout:Mh};const zh=new class extends Es{possiblyEvaluate(t,e){return e=new ws(Math.floor(e.zoom),{now:e.now,fadeDuration:e.fadeDuration,transition:e.transition}),super.possiblyEvaluate(t,e)}evaluate(t,e,r,n){return e=C({},e,{zoom:Math.floor(e.zoom)}),super.evaluate(t,e,r,n)}}(Th.paint.properties["line-width"].specification);function Bh(t,e){return e>0?e+2*t:t}zh.useIntegerZoom=!0;const Eh=Rs([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_tex_size",components:4,type:"Uint16"},{name:"a_pixeloffset",components:4,type:"Int16"}],4),Ch=Rs([{name:"a_globe_anchor",components:3,type:"Int16"},{name:"a_globe_normal",components:3,type:"Float32"}],4),Ph=Rs([{name:"a_projected_pos",components:4,type:"Float32"}],4);Rs([{name:"a_fade_opacity",components:1,type:"Uint32"}],4);const Dh=Rs([{name:"a_placed",components:2,type:"Uint8"},{name:"a_shift",components:2,type:"Float32"}]),Vh=Rs([{name:"a_size_scale",components:1,type:"Float32"},{name:"a_padding",components:2,type:"Float32"}]);Rs([{type:"Int16",name:"projectedAnchorX"},{type:"Int16",name:"projectedAnchorY"},{type:"Int16",name:"projectedAnchorZ"},{type:"Int16",name:"tileAnchorX"},{type:"Int16",name:"tileAnchorY"},{type:"Float32",name:"x1"},{type:"Float32",name:"y1"},{type:"Float32",name:"x2"},{type:"Float32",name:"y2"},{type:"Int16",name:"padding"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"}]);const Lh=Rs([{name:"a_pos",components:3,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4),Fh=Rs([{name:"a_pos_2f",components:2,type:"Float32"},{name:"a_radius",components:1,type:"Float32"},{name:"a_flags",components:2,type:"Int16"}],4);Rs([{name:"triangle",components:3,type:"Uint16"}]),Rs([{type:"Int16",name:"projectedAnchorX"},{type:"Int16",name:"projectedAnchorY"},{type:"Int16",name:"projectedAnchorZ"},{type:"Float32",name:"tileAnchorX"},{type:"Float32",name:"tileAnchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"placedOrientation"},{type:"Uint8",name:"hidden"},{type:"Uint32",name:"crossTileID"},{type:"Int16",name:"associatedIconIndex"},{type:"Uint8",name:"flipState"}]),Rs([{type:"Int16",name:"projectedAnchorX"},{type:"Int16",name:"projectedAnchorY"},{type:"Int16",name:"projectedAnchorZ"},{type:"Float32",name:"tileAnchorX"},{type:"Float32",name:"tileAnchorY"},{type:"Int16",name:"rightJustifiedTextSymbolIndex"},{type:"Int16",name:"centerJustifiedTextSymbolIndex"},{type:"Int16",name:"leftJustifiedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Int16",name:"placedIconSymbolIndex"},{type:"Int16",name:"verticalPlacedIconSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"verticalTextBoxStartIndex"},{type:"Uint16",name:"verticalTextBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"verticalIconBoxStartIndex"},{type:"Uint16",name:"verticalIconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numHorizontalGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint16",name:"numVerticalIconVertices"},{type:"Uint16",name:"useRuntimeCollisionCircles"},{type:"Uint32",name:"crossTileID"},{type:"Float32",components:2,name:"textOffset"},{type:"Float32",name:"collisionCircleDiameter"}]),Rs([{type:"Float32",name:"offsetX"}]),Rs([{type:"Int16",name:"x"},{type:"Int16",name:"y"}]);var Rh=24;const Uh=128;function $h(t,e){const{expression:r}=e;if("constant"===r.kind)return {kind:"constant",layoutSize:r.evaluate(new ws(t+1))};if("source"===r.kind)return {kind:"source"};{const{zoomStops:e,interpolationType:n}=r;let i=0;for(;i<e.length&&e[i]<=t;)i++;i=Math.max(0,i-1);let s=i;for(;s<e.length&&e[s]<t+1;)s++;s=Math.min(e.length-1,s);const a=e[i],o=e[s];return "composite"===r.kind?{kind:"composite",minZoom:a,maxZoom:o,interpolationType:n}:{kind:"camera",minZoom:a,maxZoom:o,minSize:r.evaluate(new ws(a)),maxSize:r.evaluate(new ws(o)),interpolationType:n}}}function jh(t,{uSize:e,uSizeT:r},{lowerSize:n,upperSize:i}){return "source"===t.kind?n/Uh:"composite"===t.kind?Er(n/Uh,i/Uh,r):e}function Oh(t,e){let r=0,n=0;if("constant"===t.kind)n=t.layoutSize;else if("source"!==t.kind){const{interpolationType:i,minZoom:s,maxZoom:a}=t,o=i?M(Qr.interpolationFactor(i,e,s,a),0,1):0;"camera"===t.kind?n=Er(t.minSize,t.maxSize,o):r=o;}return {uSizeT:r,uSize:n}}var qh=Object.freeze({__proto__:null,SIZE_PACK_FACTOR:Uh,evaluateSizeForFeature:jh,evaluateSizeForZoom:Oh,getSizeData:$h});function Nh(t,e,r){return t.sections.forEach((t=>{t.text=function(t,e,r){const n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),bs.applyArabicShaping&&(t=bs.applyArabicShaping(t)),t}(t.text,e,r);})),t}const Gh={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂","←":"↑","→":"↓"};function Zh(t){return "︶"===t||"﹈"===t||"︸"===t||"﹄"===t||"﹂"===t||"︾"===t||"︼"===t||"︺"===t||"︘"===t||"﹀"===t||"︐"===t||"︓"===t||"︔"===t||"｀"===t||"￣"===t||"︑"===t||"︒"===t}function Kh(t){return "︵"===t||"﹇"===t||"︷"===t||"﹃"===t||"﹁"===t||"︽"===t||"︻"===t||"︹"===t||"︗"===t||"︿"===t}var Xh=Yh,Jh=function(t,e,r,n,i){var s,a,o=8*i-n-1,l=(1<<o)-1,u=l>>1,c=-7,h=r?i-1:0,p=r?-1:1,d=t[e+h];for(h+=p,s=d&(1<<-c)-1,d>>=-c,c+=o;c>0;s=256*s+t[e+h],h+=p,c-=8);for(a=s&(1<<-c)-1,s>>=-c,c+=n;c>0;a=256*a+t[e+h],h+=p,c-=8);if(0===s)s=1-u;else {if(s===l)return a?NaN:1/0*(d?-1:1);a+=Math.pow(2,n),s-=u;}return (d?-1:1)*a*Math.pow(2,s-n)},Hh=function(t,e,r,n,i,s){var a,o,l,u=8*s-i-1,c=(1<<u)-1,h=c>>1,p=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=n?0:s-1,f=n?1:-1,y=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(o=isNaN(e)?1:0,a=c):(a=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-a))<1&&(a--,l*=2),(e+=a+h>=1?p/l:p*Math.pow(2,1-h))*l>=2&&(a++,l/=2),a+h>=c?(o=0,a=c):a+h>=1?(o=(e*l-1)*Math.pow(2,i),a+=h):(o=e*Math.pow(2,h-1)*Math.pow(2,i),a=0));i>=8;t[r+d]=255&o,d+=f,o/=256,i-=8);for(a=a<<i|o,u+=i;u>0;t[r+d]=255&a,d+=f,a/=256,u-=8);t[r+d-f]|=128*y;};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */function Yh(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}Yh.Varint=0,Yh.Fixed64=1,Yh.Bytes=2,Yh.Fixed32=5;var Wh=4294967296,Qh=1/Wh,tp="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function ep(t){return t.type===Yh.Bytes?t.readVarint()+t.pos:t.pos+1}function rp(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function np(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function ip(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function sp(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function ap(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function op(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function lp(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function up(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function cp(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function hp(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function pp(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function dp(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function fp(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function yp(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}Yh.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,s=this.pos;this.type=7&n,t(i,e,this),this.pos===s&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=dp(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=yp(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=dp(this.buf,this.pos)+dp(this.buf,this.pos+4)*Wh;return this.pos+=8,t},readSFixed64:function(){var t=dp(this.buf,this.pos)+yp(this.buf,this.pos+4)*Wh;return this.pos+=8,t},readFloat:function(){var t=Jh(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=Jh(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,s=r.buf;if(n=(112&(i=s[r.pos++]))>>4,i<128)return rp(t,n,e);if(n|=(127&(i=s[r.pos++]))<<3,i<128)return rp(t,n,e);if(n|=(127&(i=s[r.pos++]))<<10,i<128)return rp(t,n,e);if(n|=(127&(i=s[r.pos++]))<<17,i<128)return rp(t,n,e);if(n|=(127&(i=s[r.pos++]))<<24,i<128)return rp(t,n,e);if(n|=(1&(i=s[r.pos++]))<<31,i<128)return rp(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&tp?function(t,e,r){return tp.decode(t.subarray(e,r))}(this.buf,e,t):function(t,e,r){for(var n="",i=e;i<r;){var s,a,o,l=t[i],u=null,c=l>239?4:l>223?3:l>191?2:1;if(i+c>r)break;1===c?l<128&&(u=l):2===c?128==(192&(s=t[i+1]))&&(u=(31&l)<<6|63&s)<=127&&(u=null):3===c?(a=t[i+2],128==(192&(s=t[i+1]))&&128==(192&a)&&((u=(15&l)<<12|(63&s)<<6|63&a)<=2047||u>=55296&&u<=57343)&&(u=null)):4===c&&(a=t[i+2],o=t[i+3],128==(192&(s=t[i+1]))&&128==(192&a)&&128==(192&o)&&((u=(15&l)<<18|(63&s)<<12|(63&a)<<6|63&o)<=65535||u>=1114112)&&(u=null)),null===u?(u=65533,c=1):u>65535&&(u-=65536,n+=String.fromCharCode(u>>>10&1023|55296),u=56320|1023&u),n+=String.fromCharCode(u),i+=c;}return n}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==Yh.Bytes)return t.push(this.readVarint(e));var r=ep(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==Yh.Bytes)return t.push(this.readSVarint());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==Yh.Bytes)return t.push(this.readBoolean());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==Yh.Bytes)return t.push(this.readFloat());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==Yh.Bytes)return t.push(this.readDouble());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==Yh.Bytes)return t.push(this.readFixed32());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==Yh.Bytes)return t.push(this.readSFixed32());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==Yh.Bytes)return t.push(this.readFixed64());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==Yh.Bytes)return t.push(this.readSFixed64());var e=ep(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===Yh.Varint)for(;this.buf[this.pos++]>127;);else if(e===Yh.Bytes)this.pos=this.readVarint()+this.pos;else if(e===Yh.Fixed32)this.pos+=4;else {if(e!==Yh.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),fp(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),fp(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),fp(this.buf,-1&t,this.pos),fp(this.buf,Math.floor(t*Qh),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),fp(this.buf,-1&t,this.pos),fp(this.buf,Math.floor(t*Qh),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;if(t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0)),t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,r.buf[r.pos]=127&(t>>>=7);}(r,0,e),function(t,e){var r=(7&t)<<4;e.buf[e.pos++]|=r|((t>>>=3)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t)))));}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,s=0;s<e.length;s++){if((n=e.charCodeAt(s))>55295&&n<57344){if(!i){n>56319||s+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&np(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),Hh(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),Hh(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&np(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,Yh.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,ip,e);},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,sp,e);},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,lp,e);},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,ap,e);},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,op,e);},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,up,e);},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,cp,e);},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,hp,e);},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,pp,e);},writeBytesField:function(t,e){this.writeTag(t,Yh.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,Yh.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,Yh.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,Yh.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,Yh.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,Yh.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,Yh.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,Yh.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,Yh.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,Yh.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};var mp=p(Xh);const gp=3;function xp(t,e,r){e.glyphs=[],1===t&&r.readMessage(vp,e);}function vp(t,e,r){if(3===t){const{id:t,bitmap:n,width:i,height:s,left:a,top:o,advance:l}=r.readMessage(bp,{});e.glyphs.push({id:t,bitmap:new Ru({width:i+2*gp,height:s+2*gp},n),metrics:{width:i,height:s,left:a,top:o,advance:l}});}else 4===t?e.ascender=r.readSVarint():5===t&&(e.descender=r.readSVarint());}function bp(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}const wp=gp;function _p(t){let e=0,r=0;for(const n of t)e+=n.w*n.h,r=Math.max(r,n.w);t.sort(((t,e)=>e.h-t.h));const n=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),r),h:1/0}];let i=0,s=0;for(const e of t)for(let t=n.length-1;t>=0;t--){const r=n[t];if(!(e.w>r.w||e.h>r.h)){if(e.x=r.x,e.y=r.y,s=Math.max(s,e.y+e.h),i=Math.max(i,e.x+e.w),e.w===r.w&&e.h===r.h){const e=n.pop();t<n.length&&(n[t]=e);}else e.h===r.h?(r.x+=e.w,r.w-=e.w):e.w===r.w?(r.y+=e.h,r.h-=e.h):(n.push({x:r.x+e.w,y:r.y,w:r.w-e.w,h:e.h}),r.y+=e.h,r.h-=e.h);break}}return {w:i,h:s,fill:e/(i*s)||0}}const Ap=1;class Sp{constructor(t,{pixelRatio:e,version:r,stretchX:n,stretchY:i,content:s}){this.paddedRect=t,this.pixelRatio=e,this.stretchX=n,this.stretchY=i,this.content=s,this.version=r;}get tl(){return [this.paddedRect.x+Ap,this.paddedRect.y+Ap]}get br(){return [this.paddedRect.x+this.paddedRect.w-Ap,this.paddedRect.y+this.paddedRect.h-Ap]}get displaySize(){return [(this.paddedRect.w-2*Ap)/this.pixelRatio,(this.paddedRect.h-2*Ap)/this.pixelRatio]}}class kp{constructor(t,e){const r={},n={};this.haveRenderCallbacks=[];const i=[];this.addImages(t,r,i),this.addImages(e,n,i);const{w:s,h:a}=_p(i),o=new Uu({width:s||1,height:a||1});for(const e in t){const n=t[e],i=r[e].paddedRect;Uu.copy(n.data,o,{x:0,y:0},{x:i.x+Ap,y:i.y+Ap},n.data);}for(const t in e){const r=e[t],i=n[t].paddedRect,s=i.x+Ap,a=i.y+Ap,l=r.data.width,u=r.data.height;Uu.copy(r.data,o,{x:0,y:0},{x:s,y:a},r.data),Uu.copy(r.data,o,{x:0,y:u-1},{x:s,y:a-1},{width:l,height:1}),Uu.copy(r.data,o,{x:0,y:0},{x:s,y:a+u},{width:l,height:1}),Uu.copy(r.data,o,{x:l-1,y:0},{x:s-1,y:a},{width:1,height:u}),Uu.copy(r.data,o,{x:0,y:0},{x:s+l,y:a},{width:1,height:u});}this.image=o,this.iconPositions=r,this.patternPositions=n;}addImages(t,e,r){for(const n in t){const i=t[n],s={x:0,y:0,w:i.data.width+2*Ap,h:i.data.height+2*Ap};r.push(s),e[n]=new Sp(s,i),i.hasRenderCallback&&this.haveRenderCallbacks.push(n);}}patchUpdatedImages(t,e){this.haveRenderCallbacks=this.haveRenderCallbacks.filter((e=>t.hasImage(e))),t.dispatchRenderCallbacks(this.haveRenderCallbacks);for(const r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[r],t.getImage(r),e),this.patchUpdatedImage(this.patternPositions[r],t.getImage(r),e);}patchUpdatedImage(t,e,r){if(!t||!e)return;if(t.version===e.version)return;t.version=e.version;const[n,i]=t.tl;r.update(e.data,void 0,{x:n,y:i});}}Ji(Sp,"ImagePosition"),Ji(kp,"ImageAtlas");const Ip={horizontal:1,vertical:2,horizontalOnly:3},Mp=-17;class Tp{constructor(){this.scale=1,this.fontStack="",this.imageName=null;}static forText(t,e){const r=new Tp;return r.scale=t||1,r.fontStack=e,r}static forImage(t){const e=new Tp;return e.imageName=t,e}}class zp{constructor(){this.text="",this.sectionIndex=[],this.sections=[],this.imageSectionID=null;}static fromFeature(t,e){const r=new zp;for(let n=0;n<t.sections.length;n++){const i=t.sections[n];i.image?r.addImageSection(i):r.addTextSection(i,e);}return r}length(){return this.text.length}getSection(t){return this.sections[this.sectionIndex[t]]}getSections(){return this.sections}getSectionIndex(t){return this.sectionIndex[t]}getCharCode(t){return this.text.charCodeAt(t)}verticalizePunctuation(t){this.text=function(t,e){let r="";for(let n=0;n<t.length;n++){const i=t.charCodeAt(n+1)||null,s=t.charCodeAt(n-1)||null;r+=!e&&(i&&ss(i)&&!Gh[t[n+1]]||s&&ss(s)&&!Gh[t[n-1]])||!Gh[t[n]]?t[n]:Gh[t[n]];}return r}(this.text,t);}trim(){let t=0;for(let e=0;e<this.text.length&&Ep[this.text.charCodeAt(e)];e++)t++;let e=this.text.length;for(let r=this.text.length-1;r>=0&&r>=t&&Ep[this.text.charCodeAt(r)];r--)e--;this.text=this.text.substring(t,e),this.sectionIndex=this.sectionIndex.slice(t,e);}substring(t,e){const r=new zp;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r}toString(){return this.text}getMaxScale(){return this.sectionIndex.reduce(((t,e)=>Math.max(t,this.sections[e].scale)),0)}addTextSection(t,e){this.text+=t.text,this.sections.push(Tp.forText(t.scale,t.fontStack||e));const r=this.sections.length-1;for(let e=0;e<t.text.length;++e)this.sectionIndex.push(r);}addImageSection(t){const e=t.image?t.image.name:"";if(0===e.length)return void N("Can't add FormattedSection with an empty image.");const r=this.getNextImageSectionCharCode();r?(this.text+=String.fromCharCode(r),this.sections.push(Tp.forImage(e)),this.sectionIndex.push(this.sections.length-1)):N("Reached maximum number of images 6401");}getNextImageSectionCharCode(){return this.imageSectionID?this.imageSectionID>=63743?null:++this.imageSectionID:(this.imageSectionID=57344,this.imageSectionID)}}function Bp(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f){const y=zp.fromFeature(t,i);h===Ip.vertical&&y.verticalizePunctuation(p);let m=[];const g=function(t,e,r,n,i,s){if(!t)return [];const a=[],o=function(t,e,r,n,i,s){let a=0;for(let r=0;r<t.length();r++){const o=t.getSection(r);a+=Pp(t.getCharCode(r),o,n,i,e,s);}return a/Math.max(1,Math.ceil(a/r))}(t,e,r,n,i,s),l=t.text.indexOf("​")>=0;let u=0;for(let r=0;r<t.length();r++){const h=t.getSection(r),p=t.getCharCode(r);if(Ep[p]||(u+=Pp(p,h,n,i,e,s)),r<t.length()-1){const e=!((c=p)<11904||!(ts["Bopomofo Extended"](c)||ts.Bopomofo(c)||ts["CJK Compatibility Forms"](c)||ts["CJK Compatibility Ideographs"](c)||ts["CJK Compatibility"](c)||ts["CJK Radicals Supplement"](c)||ts["CJK Strokes"](c)||ts["CJK Symbols and Punctuation"](c)||ts["CJK Unified Ideographs Extension A"](c)||ts["CJK Unified Ideographs"](c)||ts["Enclosed CJK Letters and Months"](c)||ts["Halfwidth and Fullwidth Forms"](c)||ts.Hiragana(c)||ts["Ideographic Description Characters"](c)||ts["Kangxi Radicals"](c)||ts["Katakana Phonetic Extensions"](c)||ts.Katakana(c)||ts["Vertical Forms"](c)||ts["Yi Radicals"](c)||ts["Yi Syllables"](c)));(Cp[p]||e||h.imageName)&&a.push(Lp(r+1,u,o,a,Vp(p,t.getCharCode(r+1),e&&l),!1));}}var c;return Fp(Lp(t.length(),u,o,a,0,!0))}(y,u,s,e,n,d),{processBidirectionalText:x,processStyledBidirectionalText:v}=bs;if(x&&1===y.sections.length){const t=x(y.toString(),g);for(const e of t){const t=new zp;t.text=e,t.sections=y.sections;for(let r=0;r<e.length;r++)t.sectionIndex.push(0);m.push(t);}}else if(v){const t=v(y.text,y.sectionIndex,g);for(const e of t){const t=new zp;t.text=e[0],t.sectionIndex=e[1],t.sections=y.sections,m.push(t);}}else m=function(t,e){const r=[],n=t.text;let i=0;for(const n of e)r.push(t.substring(i,n)),i=n;return i<n.length&&r.push(t.substring(i,n.length)),r}(y,g);const b=[],w={positionedLines:b,text:y.toString(),top:c[1],bottom:c[1],left:c[0],right:c[0],writingMode:h,iconsInText:!1,verticalizable:!1,hasBaseline:!1};return function(t,e,r,n,i,s,a,o,l,u,c,h){let p=0,d=0,f=0;const y="right"===o?1:"left"===o?0:.5;let m=!1;for(const t of i){const r=t.getSections();for(const t of r){if(t.imageName)continue;const r=e[t.fontStack];if(r&&(m=void 0!==r.ascender&&void 0!==r.descender,!m))break}if(!m)break}let g=0;for(const a of i){a.trim();const i=a.getMaxScale(),o=(i-1)*Rh,v={positionedGlyphs:[],lineOffset:0};t.positionedLines[g]=v;const b=v.positionedGlyphs;let w=0;if(!a.length()){d+=s,++g;continue}let _=0,A=0;for(let s=0;s<a.length();s++){const o=a.getSection(s),f=a.getSectionIndex(s),y=a.getCharCode(s);let g=o.scale,v=null,S=null,k=null,I=Rh,M=0;const T=!(l===Ip.horizontal||!c&&!is(y)||c&&(Ep[y]||(x=y,ts.Arabic(x)||ts["Arabic Supplement"](x)||ts["Arabic Extended-A"](x)||ts["Arabic Presentation Forms-A"](x)||ts["Arabic Presentation Forms-B"](x))));if(o.imageName){const e=n[o.imageName];if(!e)continue;k=o.imageName,t.iconsInText=t.iconsInText||!0,S=e.paddedRect;const r=e.displaySize;g=g*Rh/h,v={width:r[0],height:r[1],left:Ap,top:-wp,advance:T?r[1]:r[0],localGlyph:!1},M=m?-v.height*g:Mp+i*Rh-r[1]*g,I=v.advance;const s=(T?r[0]:r[1])*g-Rh*i;s>0&&s>w&&(w=s);}else {const t=r[o.fontStack];if(!t)continue;t[y]&&(S=t[y]);const n=e[o.fontStack];if(!n)continue;const s=n.glyphs[y];if(!s)continue;if(v=s.metrics,I=8203!==y?Rh:0,m){const t=void 0!==n.ascender?Math.abs(n.ascender):0,e=void 0!==n.descender?Math.abs(n.descender):0,r=(t+e)*g;_<r&&(_=r,A=(t-e)/2*g),M=-t*g;}else M=Mp+(i-g)*Rh;}T?(t.verticalizable=!0,b.push({glyph:y,imageName:k,x:p,y:d+M,vertical:T,scale:g,localGlyph:v.localGlyph,fontStack:o.fontStack,sectionIndex:f,metrics:v,rect:S}),p+=I*g+u):(b.push({glyph:y,imageName:k,x:p,y:d+M,vertical:T,scale:g,localGlyph:v.localGlyph,fontStack:o.fontStack,sectionIndex:f,metrics:v,rect:S}),p+=v.advance*g+u);}0!==b.length&&(f=Math.max(p-u,f),m?Up(b,y,w,A,s*i/2):Up(b,y,w,0,s/2)),p=0;const S=s*i+w;v.lineOffset=Math.max(w,o),d+=S,++g;}var x;const v=d,{horizontalAlign:b,verticalAlign:w}=Rp(a);((function(t,e,r,n,i,s){const a=(e-r)*i,o=-s*n;for(const e of t)for(const t of e.positionedGlyphs)t.x+=a,t.y+=o;}))(t.positionedLines,y,b,w,f,v),t.top+=-w*v,t.bottom=t.top+v,t.left+=-b*f,t.right=t.left+f,t.hasBaseline=m;}(w,e,r,n,m,a,o,l,h,u,p,f),!function(t){for(const e of t)if(0!==e.positionedGlyphs.length)return !1;return !0}(b)&&w}const Ep={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},Cp={10:!0,32:!0,38:!0,40:!0,41:!0,43:!0,45:!0,47:!0,173:!0,183:!0,8203:!0,8208:!0,8211:!0,8231:!0};function Pp(t,e,r,n,i,s){if(e.imageName){const t=n[e.imageName];return t?t.displaySize[0]*e.scale*Rh/s+i:0}{const n=r[e.fontStack],s=n&&n.glyphs[t];return s?s.metrics.advance*e.scale+i:0}}function Dp(t,e,r,n){const i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function Vp(t,e,r){let n=0;return 10===t&&(n-=1e4),r&&(n+=150),40!==t&&65288!==t||(n+=50),41!==e&&65289!==e||(n+=50),n}function Lp(t,e,r,n,i,s){let a=null,o=Dp(e,r,i,s);for(const t of n){const n=Dp(e-t.x,r,i,s)+t.badness;n<=o&&(a=t,o=n);}return {index:t,x:e,priorBreak:a,badness:o}}function Fp(t){return t?Fp(t.priorBreak).concat(t.index):[]}function Rp(t){let e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function Up(t,e,r,n,i){if(!(e||r||n||i))return;const s=t.length-1,a=t[s],o=(a.x+a.metrics.advance*a.scale)*e;for(let e=0;e<=s;e++)t[e].x-=o,t[e].y+=r+n+i;}function $p(t,e,r){const{horizontalAlign:n,verticalAlign:i}=Rp(r),s=e[0]-t.displaySize[0]*n,a=e[1]-t.displaySize[1]*i;return {image:t,top:a,bottom:a+t.displaySize[1],left:s,right:s+t.displaySize[0]}}function jp(t,e,r,n,i,s){const a=t.image;let o;if(a.content){const t=a.content,e=a.pixelRatio||1;o=[t[0]/e,t[1]/e,a.displaySize[0]-t[2]/e,a.displaySize[1]-t[3]/e];}const l=e.left*s,u=e.right*s;let c,h,p,d;"width"===r||"both"===r?(d=i[0]+l-n[3],h=i[0]+u+n[1]):(d=i[0]+(l+u-a.displaySize[0])/2,h=d+a.displaySize[0]);const f=e.top*s,y=e.bottom*s;return "height"===r||"both"===r?(c=i[1]+f-n[0],p=i[1]+y+n[2]):(c=i[1]+(f+y-a.displaySize[1])/2,p=c+a.displaySize[1]),{image:a,top:c,right:h,bottom:p,left:d,collisionPadding:o}}class Op extends x{constructor(t,e,r,n,i){super(t,e),this.angle=n,this.z=r,void 0!==i&&(this.segment=i);}clone(){return new Op(this.x,this.y,this.z,this.angle,this.segment)}}function qp(t,e,r,n,i){if(void 0===e.segment)return !0;let s=e,a=e.segment+1,o=0;for(;o>-r/2;){if(a--,a<0)return !1;o-=t[a].dist(s),s=t[a];}o+=t[a].dist(t[a+1]),a++;const l=[];let u=0;for(;o<r/2;){const e=t[a],r=t[a+1];if(!r)return !1;let s=t[a-1].angleTo(e)-e.angleTo(r);for(s=Math.abs((s+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:o,angleDelta:s}),u+=s;o-l[0].distance>n;)u-=l.shift().angleDelta;if(u>i)return !1;a++,o+=e.dist(r);}return !0}function Np(t){let e=0;for(let r=0;r<t.length-1;r++)e+=t[r].dist(t[r+1]);return e}function Gp(t,e,r){return t?.6*e*r:0}function Zp(t,e){return Math.max(t?t.right-t.left:0,e?e.right-e.left:0)}function Kp(t,e,r,n,i,s){const a=Gp(r,i,s),o=Zp(r,n)*s;let l=0;const u=Np(t)/2;for(let r=0;r<t.length-1;r++){const n=t[r],i=t[r+1],s=n.dist(i);if(l+s>u){const c=(u-l)/s,h=Er(n.x,i.x,c),p=Er(n.y,i.y,c),d=new Op(h,p,0,i.angleTo(n),r);return !a||qp(t,d,o,a,e)?d:void 0}l+=s;}}function Xp(t,e,r,n,i,s,a,o,l){const u=Gp(n,s,a),c=Zp(n,i),h=c*a,p=0===t[0].x||t[0].x===l||0===t[0].y||t[0].y===l;return e-h<e/4&&(e=h+e/4),Jp(t,p?e/2*o%e:(c/2+2*s)*a*o%e,e,u,r,h,p,!1,l)}function Jp(t,e,r,n,i,s,a,o,l){const u=s/2,c=Np(t);let h=0,p=e-r,d=[];for(let e=0;e<t.length-1;e++){const a=t[e],o=t[e+1],f=a.dist(o),y=o.angleTo(a);for(;p+r<h+f;){p+=r;const m=(p-h)/f,g=Er(a.x,o.x,m),x=Er(a.y,o.y,m);if(g>=0&&g<l&&x>=0&&x<l&&p-u>=0&&p+u<=c){const r=new Op(g,x,0,y,e);r._round(),n&&!qp(t,r,s,n,i)||d.push(r);}}h+=f;}return o||d.length||a||(d=Jp(t,h/2,r,n,i,s,a,!0,l)),d}function Hp(t,e,r,n,i){const s=[];for(let a=0;a<t.length;a++){const o=t[a];let l;for(let t=0;t<o.length-1;t++){let a=o[t],u=o[t+1];a.x<e&&u.x<e||(a.x<e?a=new x(e,a.y+(e-a.x)/(u.x-a.x)*(u.y-a.y))._round():u.x<e&&(u=new x(e,a.y+(e-a.x)/(u.x-a.x)*(u.y-a.y))._round()),a.y<r&&u.y<r||(a.y<r?a=new x(a.x+(r-a.y)/(u.y-a.y)*(u.x-a.x),r)._round():u.y<r&&(u=new x(a.x+(r-a.y)/(u.y-a.y)*(u.x-a.x),r)._round()),a.x>=n&&u.x>=n||(a.x>=n?a=new x(n,a.y+(n-a.x)/(u.x-a.x)*(u.y-a.y))._round():u.x>=n&&(u=new x(n,a.y+(n-a.x)/(u.x-a.x)*(u.y-a.y))._round()),a.y>=i&&u.y>=i||(a.y>=i?a=new x(a.x+(i-a.y)/(u.y-a.y)*(u.x-a.x),i)._round():u.y>=i&&(u=new x(a.x+(i-a.y)/(u.y-a.y)*(u.x-a.x),i)._round()),l&&a.equals(l[l.length-1])||(l=[a],s.push(l)),l.push(u)))));}}return s}Ji(Op,"Anchor");const Yp=1e20;function Wp(t,e,r,n,i,s,a,o,l){for(let u=e;u<e+n;u++)Qp(t,r*s+u,s,i,a,o,l);for(let u=r;u<r+i;u++)Qp(t,u*s+e,1,n,a,o,l);}function Qp(t,e,r,n,i,s,a){s[0]=0,a[0]=-Yp,a[1]=Yp,i[0]=t[e];for(let o=1,l=0,u=0;o<n;o++){i[o]=t[e+o*r];const n=o*o;do{const t=s[l];u=(i[o]-i[t]+n-t*t)/(o-t)/2;}while(u<=a[l]&&--l>-1);l++,s[l]=o,a[l]=u,a[l+1]=Yp;}for(let o=0,l=0;o<n;o++){for(;a[l+1]<o;)l++;const n=s[l],u=o-n;t[e+o*r]=i[n]+u*u;}}const td=2,ed={none:0,ideographs:1,all:2};class rd{constructor(t,e,r){this.requestManager=t,this.localGlyphMode=e,this.localFontFamily=r,this.entries={},this.localGlyphs={200:{},400:{},500:{},900:{}};}setURL(t){this.url=t;}getGlyphs(t,e){const r=[];for(const e in t)for(const n of t[e])r.push({stack:e,id:n});B(r,(({stack:t,id:e},r)=>{let n=this.entries[t];n||(n=this.entries[t]={glyphs:{},requests:{},ranges:{},ascender:void 0,descender:void 0});let i=n.glyphs[e];if(void 0!==i)return void r(null,{stack:t,id:e,glyph:i});if(i=this._tinySDF(n,t,e),i)return n.glyphs[e]=i,void r(null,{stack:t,id:e,glyph:i});const s=Math.floor(e/256);if(256*s>65535)return void r(new Error("glyphs > 65535 not supported"));if(n.ranges[s])return void r(null,{stack:t,id:e,glyph:i});let a=n.requests[s];a||(a=n.requests[s]=[],rd.loadGlyphRange(t,s,this.url,this.requestManager,((t,e)=>{if(e){n.ascender=e.ascender,n.descender=e.descender;for(const t in e.glyphs)this._doesCharSupportLocalGlyph(+t)||(n.glyphs[+t]=e.glyphs[+t]);n.ranges[s]=!0;}for(const r of a)r(t,e);delete n.requests[s];}))),a.push(((n,i)=>{n?r(n):i&&r(null,{stack:t,id:e,glyph:i.glyphs[e]||null});}));}),((t,r)=>{if(t)e(t);else if(r){const t={};for(const{stack:e,id:n,glyph:i}of r)void 0===t[e]&&(t[e]={}),void 0===t[e].glyphs&&(t[e].glyphs={}),t[e].glyphs[n]=i&&{id:i.id,bitmap:i.bitmap.clone(),metrics:i.metrics},t[e].ascender=this.entries[e].ascender,t[e].descender=this.entries[e].descender;e(null,t);}}));}_doesCharSupportLocalGlyph(t){return this.localGlyphMode!==ed.none&&(this.localGlyphMode===ed.all?!!this.localFontFamily:!!this.localFontFamily&&(ts["CJK Unified Ideographs"](t)||ts["Hangul Syllables"](t)||ts.Hiragana(t)||ts.Katakana(t)||ts["CJK Symbols and Punctuation"](t)))}_tinySDF(t,e,r){const n=this.localFontFamily;if(!n||!this._doesCharSupportLocalGlyph(r))return;let i=t.tinySDF;if(!i){let r="400";/bold/i.test(e)?r="900":/medium/i.test(e)?r="500":/light/i.test(e)&&(r="200"),i=t.tinySDF=new rd.TinySDF({fontFamily:n,fontWeight:r,fontSize:24*td,buffer:3*td,radius:8*td}),i.fontWeight=r;}if(this.localGlyphs[i.fontWeight][r])return this.localGlyphs[i.fontWeight][r];const s=String.fromCharCode(r),{data:a,width:o,height:l,glyphWidth:u,glyphHeight:c,glyphLeft:h,glyphTop:p,glyphAdvance:d}=i.draw(s);return this.localGlyphs[i.fontWeight][r]={id:r,bitmap:new Ru({width:o,height:l},a),metrics:{width:u/td,height:c/td,left:h/td,top:p/td-27,advance:d/td,localGlyph:!0}}}}rd.loadGlyphRange=function(t,e,r,n,i){const s=256*e,a=s+255,o=n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}",t).replace("{range}",`${s}-${a}`),lt.Glyphs);pt(o,((t,e)=>{if(t)i(t);else if(e){const t={},r=function(t){return new mp(t).readFields(xp,{})}(e);for(const e of r.glyphs)t[e.id]=e;i(null,{glyphs:t,ascender:r.ascender,descender:r.descender});}}));},rd.TinySDF=class{constructor({fontSize:t=24,buffer:e=3,radius:r=8,cutoff:n=.25,fontFamily:i="sans-serif",fontWeight:s="normal",fontStyle:a="normal"}={}){this.buffer=e,this.cutoff=n,this.radius=r;const o=this.size=t+4*e,l=this._createCanvas(o),u=this.ctx=l.getContext("2d",{willReadFrequently:!0});u.font=`${a} ${s} ${t}px ${i}`,u.textBaseline="alphabetic",u.textAlign="left",u.fillStyle="black",this.gridOuter=new Float64Array(o*o),this.gridInner=new Float64Array(o*o),this.f=new Float64Array(o),this.z=new Float64Array(o+1),this.v=new Uint16Array(o);}_createCanvas(t){const e=document.createElement("canvas");return e.width=e.height=t,e}draw(t){const{width:e,actualBoundingBoxAscent:r,actualBoundingBoxDescent:n,actualBoundingBoxLeft:i,actualBoundingBoxRight:s}=this.ctx.measureText(t),a=Math.ceil(r),o=Math.max(0,Math.min(this.size-this.buffer,Math.ceil(s-i))),l=Math.min(this.size-this.buffer,a+Math.ceil(n)),u=o+2*this.buffer,c=l+2*this.buffer,h=Math.max(u*c,0),p=new Uint8ClampedArray(h),d={data:p,width:u,height:c,glyphWidth:o,glyphHeight:l,glyphTop:a,glyphLeft:0,glyphAdvance:e};if(0===o||0===l)return d;const{ctx:f,buffer:y,gridInner:m,gridOuter:g}=this;f.clearRect(y,y,o,l),f.fillText(t,y,y+a);const x=f.getImageData(y,y,o,l);g.fill(Yp,0,h),m.fill(0,0,h);for(let t=0;t<l;t++)for(let e=0;e<o;e++){const r=x.data[4*(t*o+e)+3]/255;if(0===r)continue;const n=(t+y)*u+e+y;if(1===r)g[n]=0,m[n]=Yp;else {const t=.5-r;g[n]=t>0?t*t:0,m[n]=t<0?t*t:0;}}Wp(g,0,0,u,c,u,this.f,this.v,this.z),Wp(m,y,y,o,l,u,this.f,this.v,this.z);for(let t=0;t<h;t++){const e=Math.sqrt(g[t])-Math.sqrt(m[t]);p[t]=Math.round(255-255*(e/this.radius+this.cutoff));}return d}};const nd=Ap;function id(t,e,r,n){const i=[],s=t.image,a=s.pixelRatio,o=s.paddedRect.w-2*nd,l=s.paddedRect.h-2*nd,u=t.right-t.left,c=t.bottom-t.top,h=s.stretchX||[[0,o]],p=s.stretchY||[[0,l]],d=(t,e)=>t+e[1]-e[0],f=h.reduce(d,0),y=p.reduce(d,0),m=o-f,g=l-y;let v=0,b=f,w=0,_=y,A=0,S=m,k=0,I=g;if(s.content&&n){const t=s.content;v=sd(h,0,t[0]),w=sd(p,0,t[1]),b=sd(h,t[0],t[2]),_=sd(p,t[1],t[3]),A=t[0]-v,k=t[1]-w,S=t[2]-t[0]-b,I=t[3]-t[1]-_;}const M=(n,i,o,l)=>{const h=od(n.stretch-v,b,u,t.left),p=ld(n.fixed-A,S,n.stretch,f),d=od(i.stretch-w,_,c,t.top),m=ld(i.fixed-k,I,i.stretch,y),g=od(o.stretch-v,b,u,t.left),M=ld(o.fixed-A,S,o.stretch,f),T=od(l.stretch-w,_,c,t.top),z=ld(l.fixed-k,I,l.stretch,y),B=new x(h,d),E=new x(g,d),C=new x(g,T),P=new x(h,T),D=new x(p/a,m/a),V=new x(M/a,z/a),L=e*Math.PI/180;if(L){const t=Math.sin(L),e=Math.cos(L),r=[e,-t,t,e];B._matMult(r),E._matMult(r),P._matMult(r),C._matMult(r);}const F=n.stretch+n.fixed,R=i.stretch+i.fixed;return {tl:B,tr:E,bl:P,br:C,tex:{x:s.paddedRect.x+nd+F,y:s.paddedRect.y+nd+R,w:o.stretch+o.fixed-F,h:l.stretch+l.fixed-R},writingMode:void 0,glyphOffset:[0,0],sectionIndex:0,pixelOffsetTL:D,pixelOffsetBR:V,minFontScaleX:S/a/u,minFontScaleY:I/a/c,isSDF:r}};if(n&&(s.stretchX||s.stretchY)){const t=ad(h,m,f),e=ad(p,g,y);for(let r=0;r<t.length-1;r++){const n=t[r],s=t[r+1];for(let t=0;t<e.length-1;t++)i.push(M(n,e[t],s,e[t+1]));}}else i.push(M({fixed:0,stretch:-1},{fixed:0,stretch:-1},{fixed:0,stretch:o+1},{fixed:0,stretch:l+1}));return i}function sd(t,e,r){let n=0;for(const i of t)n+=Math.max(e,Math.min(r,i[1]))-Math.max(e,Math.min(r,i[0]));return n}function ad(t,e,r){const n=[{fixed:-nd,stretch:0}];for(const[e,r]of t){const t=n[n.length-1];n.push({fixed:e-t.stretch,stretch:t.stretch}),n.push({fixed:e-t.stretch,stretch:t.stretch+(r-e)});}return n.push({fixed:e+nd,stretch:r}),n}function od(t,e,r,n){return t/e*r+n}function ld(t,e,r,n){return t-e*r/n}function ud(t,e,r,n){const i=e+t.positionedLines[n].lineOffset;return 0===n?r+i/2:r+(i+(e+t.positionedLines[n-1].lineOffset))/2}class cd{constructor(t=[],e=hd){if(this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(let t=(this.length>>1)-1;t>=0;t--)this._down(t);}push(t){this.data.push(t),this.length++,this._up(this.length-1);}pop(){if(0===this.length)return;const t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}peek(){return this.data[0]}_up(t){const{data:e,compare:r}=this,n=e[t];for(;t>0;){const i=t-1>>1,s=e[i];if(r(n,s)>=0)break;e[t]=s,t=i;}e[t]=n;}_down(t){const{data:e,compare:r}=this,n=this.length>>1,i=e[t];for(;t<n;){let n=1+(t<<1),s=e[n];const a=n+1;if(a<this.length&&r(e[a],s)<0&&(n=a,s=e[a]),r(s,i)>=0)break;e[t]=s,t=n;}e[t]=i;}}function hd(t,e){return t<e?-1:t>e?1:0}function pd(t,e=1,r=!1){let n=1/0,i=1/0,s=-1/0,a=-1/0;const o=t[0];for(let t=0;t<o.length;t++){const e=o[t];(!t||e.x<n)&&(n=e.x),(!t||e.y<i)&&(i=e.y),(!t||e.x>s)&&(s=e.x),(!t||e.y>a)&&(a=e.y);}const l=Math.min(s-n,a-i);let u=l/2;const c=new cd([],dd);if(0===l)return new x(n,i);for(let e=n;e<s;e+=l)for(let r=i;r<a;r+=l)c.push(new fd(e+u,r+u,u,t));let h=function(t){let e=0,r=0,n=0;const i=t[0];for(let t=0,s=i.length,a=s-1;t<s;a=t++){const s=i[t],o=i[a],l=s.x*o.y-o.x*s.y;r+=(s.x+o.x)*l,n+=(s.y+o.y)*l,e+=3*l;}return new fd(r/e,n/e,0,t)}(t),p=c.length;for(;c.length;){const n=c.pop();(n.d>h.d||!h.d)&&(h=n,r&&console.log("found best %d after %d probes",Math.round(1e4*n.d)/1e4,p)),n.max-h.d<=e||(u=n.h/2,c.push(new fd(n.p.x-u,n.p.y-u,u,t)),c.push(new fd(n.p.x+u,n.p.y-u,u,t)),c.push(new fd(n.p.x-u,n.p.y+u,u,t)),c.push(new fd(n.p.x+u,n.p.y+u,u,t)),p+=4);}return r&&(console.log(`num probes: ${p}`),console.log(`best distance: ${h.d}`)),h.p}function dd(t,e){return e.max-t.max}class fd{constructor(t,e,r,n){this.p=new x(t,e),this.h=r,this.d=function(t,e){let r=!1,n=1/0;for(let i=0;i<e.length;i++){const s=e[i];for(let e=0,i=s.length,a=i-1;e<i;a=e++){const i=s[e],o=s[a];i.y>t.y!=o.y>t.y&&t.x<(o.x-i.x)*(t.y-i.y)/(o.y-i.y)+i.x&&(r=!r),n=Math.min(n,xu(t,i,o));}}return (r?1:-1)*Math.sqrt(n)}(this.p,n),this.max=this.d+this.h*Math.SQRT2;}}const yd=7,md=Number.POSITIVE_INFINITY,gd=Math.sqrt(2);function xd(t,[e,r]){let n=0,i=0;if(r===md){e<0&&(e=0);const r=e/gd;switch(t){case"top-right":case"top-left":i=r-yd;break;case"bottom-right":case"bottom-left":i=-r+yd;break;case"bottom":i=-e+yd;break;case"top":i=e-yd;}switch(t){case"top-right":case"bottom-right":n=-r;break;case"top-left":case"bottom-left":n=r;break;case"left":n=e;break;case"right":n=-e;}}else {switch(e=Math.abs(e),r=Math.abs(r),t){case"top-right":case"top-left":case"top":i=r-yd;break;case"bottom-right":case"bottom-left":case"bottom":i=-r+yd;}switch(t){case"top-right":case"bottom-right":case"right":n=-e;break;case"top-left":case"bottom-left":case"left":n=e;}}return [n,i]}function vd(t,e,r,n,i,s,a,o,l,u){t.createArrays(),t.tilePixelRatio=ao/(512*t.overscaling),t.compareText={},t.iconsNeedLinear=!1;const c=t.layers[0].layout,h=t.layers[0]._unevaluatedLayout._values,p={};if("composite"===t.textSizeData.kind){const{minZoom:e,maxZoom:r}=t.textSizeData;p.compositeTextSizes=[h["text-size"].possiblyEvaluate(new ws(e),o),h["text-size"].possiblyEvaluate(new ws(r),o)];}if("composite"===t.iconSizeData.kind){const{minZoom:e,maxZoom:r}=t.iconSizeData;p.compositeIconSizes=[h["icon-size"].possiblyEvaluate(new ws(e),o),h["icon-size"].possiblyEvaluate(new ws(r),o)];}p.layoutTextSize=h["text-size"].possiblyEvaluate(new ws(l+1),o),p.layoutIconSize=h["icon-size"].possiblyEvaluate(new ws(l+1),o),p.textMaxSize=h["text-size"].possiblyEvaluate(new ws(18),o);const d="map"===c.get("text-rotation-alignment")&&"point"!==c.get("symbol-placement"),f=c.get("text-size");for(const s of t.features){const l=c.get("text-font").evaluate(s,{},o).join(","),h=f.evaluate(s,{},o),y=p.layoutTextSize.evaluate(s,{},o),m=(p.layoutIconSize.evaluate(s,{},o),{horizontal:{},vertical:void 0}),g=s.text;let x,v=[0,0];if(g){const n=g.toString(),a=c.get("text-letter-spacing").evaluate(s,{},o)*Rh,u=c.get("text-line-height").evaluate(s,{},o)*Rh,p=rs(n)?a:0,f=c.get("text-anchor").evaluate(s,{},o),x=c.get("text-variable-anchor");if(!x){const t=c.get("text-radial-offset").evaluate(s,{},o);v=t?xd(f,[t*Rh,md]):c.get("text-offset").evaluate(s,{},o).map((t=>t*Rh));}let b=d?"center":c.get("text-justify").evaluate(s,{},o);const w="point"===c.get("symbol-placement"),_=w?c.get("text-max-width").evaluate(s,{},o)*Rh:1/0,A=s=>{t.allowVerticalPlacement&&es(n)&&(m.vertical=Bp(g,e,r,i,l,_,u,f,s,p,v,Ip.vertical,!0,y,h));};if(!d&&x){const t="auto"===b?x.map((t=>bd(t))):[b];let n=!1;for(let s=0;s<t.length;s++){const a=t[s];if(!m.horizontal[a])if(n)m.horizontal[a]=m.horizontal[0];else {const t=Bp(g,e,r,i,l,_,u,"center",a,p,v,Ip.horizontal,!1,y,h);t&&(m.horizontal[a]=t,n=1===t.positionedLines.length);}}A("left");}else {if("auto"===b&&(b=bd(f)),w||c.get("text-writing-mode").indexOf("horizontal")>=0||!es(n)){const t=Bp(g,e,r,i,l,_,u,f,b,p,v,Ip.horizontal,!1,y,h);t&&(m.horizontal[b]=t);}A(w?"left":b);}}let b=!1;if(s.icon&&s.icon.name){const e=n[s.icon.name];e&&(x=$p(i[s.icon.name],c.get("icon-offset").evaluate(s,{},o),c.get("icon-anchor").evaluate(s,{},o)),b=e.sdf,void 0===t.sdfIcons?t.sdfIcons=e.sdf:t.sdfIcons!==e.sdf&&N("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),(e.pixelRatio!==t.pixelRatio||0!==c.get("icon-rotate").constantOr(1))&&(t.iconsNeedLinear=!0));}const w=kd(m.horizontal)||m.vertical;t.iconsInText||(t.iconsInText=!!w&&w.iconsInText),(w||x)&&wd(t,s,m,x,n,p,y,0,v,b,a,o,u);}s&&t.generateCollisionDebugBuffers(l,t.collisionBoxArray);}function bd(t){switch(t){case"right":case"top-right":case"bottom-right":return "right";case"left":case"top-left":case"bottom-left":return "left"}return "center"}function wd(t,e,r,n,i,s,a,o,l,u,c,h,p){let d=s.textMaxSize.evaluate(e,{},h);void 0===d&&(d=a);const f=t.layers[0].layout,y=f.get("icon-offset").evaluate(e,{},h),m=kd(r.horizontal)||r.vertical,g="globe"===p.name,x=Rh,v=a/x,b=t.tilePixelRatio*d/x,_=(B=t.overscaling,t.zoom>18&&B>2&&(B>>=1),Math.max(ao/(512*B),1)*f.get("symbol-spacing")),A=f.get("text-padding")*t.tilePixelRatio,S=f.get("icon-padding")*t.tilePixelRatio,k=w(f.get("text-max-angle")),I="map"===f.get("text-rotation-alignment")&&"point"!==f.get("symbol-placement"),M="map"===f.get("icon-rotation-alignment")&&"point"!==f.get("symbol-placement"),T=f.get("symbol-placement"),z=_/2;var B;const E=f.get("icon-text-fit");let C;n&&"none"!==E&&(t.allowVerticalPlacement&&r.vertical&&(C=jp(n,r.vertical,E,f.get("icon-text-fit-padding"),y,v)),m&&(n=jp(n,m,E,f.get("icon-text-fit-padding"),y,v)));const P=(a,o,d)=>{if(o.x<0||o.x>=ao||o.y<0||o.y>=ao)return;let f=null;if(g){const{x:t,y:e,z:r}=p.projectTilePoint(o.x,o.y,d);f={anchor:new Op(t,e,r,0,void 0),up:p.upVector(d,o.x,o.y)};}!function(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m,g,x,v,b,w,_,A,S){const k=t.addToLineVertexArray(e,n);let I,M,T,z,B,E,C,P=0,D=0,V=0,L=0,F=-1,R=-1;const U={};let $=Ba("");const j=r?r.anchor:e;let O=0,q=0;if(void 0===l._unevaluatedLayout.getValue("text-radial-offset")?[O,q]=l.layout.get("text-offset").evaluate(b,{},S).map((t=>t*Rh)):(O=l.layout.get("text-radial-offset").evaluate(b,{},S)*Rh,q=md),t.allowVerticalPlacement&&i.vertical){const t=i.vertical;if(f)E=Md(t),o&&(C=Md(o));else {const r=l.layout.get("text-rotate").evaluate(b,{},S)+90;T=Id(u,j,e,c,h,p,t,d,r,y),o&&(z=Id(u,j,e,c,h,p,o,g,r));}}if(s){const n=l.layout.get("icon-rotate").evaluate(b,{},S),i="none"!==l.layout.get("icon-text-fit"),a=id(s,n,_,i),d=o?id(o,n,_,i):void 0;M=Id(u,j,e,c,h,p,s,g,n),P=4*a.length;const f=t.iconSizeData;let y=null;"source"===f.kind?(y=[Uh*l.layout.get("icon-size").evaluate(b,{},S)],y[0]>Ad&&N(`${t.layerIds[0]}: Value for "icon-size" is >= ${_d}. Reduce your "icon-size".`)):"composite"===f.kind&&(y=[Uh*w.compositeIconSizes[0].evaluate(b,{},S),Uh*w.compositeIconSizes[1].evaluate(b,{},S)],(y[0]>Ad||y[1]>Ad)&&N(`${t.layerIds[0]}: Value for "icon-size" is >= ${_d}. Reduce your "icon-size".`)),t.addSymbols(t.icon,a,y,v,x,b,!1,r,e,k.lineStartIndex,k.lineLength,-1,A,S),F=t.icon.placedSymbolArray.length-1,d&&(D=4*d.length,t.addSymbols(t.icon,d,y,v,x,b,Ip.vertical,r,e,k.lineStartIndex,k.lineLength,-1,A,S),R=t.icon.placedSymbolArray.length-1);}for(const n in i.horizontal){const s=i.horizontal[n];I||($=Ba(s.text),f?B=Md(s):I=Id(u,j,e,c,h,p,s,d,l.layout.get("text-rotate").evaluate(b,{},S),y));const o=1===s.positionedLines.length;if(V+=Sd(t,r,e,s,a,l,f,b,y,k,i.vertical?Ip.horizontal:Ip.horizontalOnly,o?Object.keys(i.horizontal):[n],U,F,w,A,S),o)break}i.vertical&&(L+=Sd(t,r,e,i.vertical,a,l,f,b,y,k,Ip.vertical,["vertical"],U,R,w,A,S));let G=-1;const Z=(t,e)=>t?Math.max(t,e):e;G=Z(B,G),G=Z(E,G),G=Z(C,G);const K=G>-1?1:0;t.glyphOffsetArray.length>=of.MAX_GLYPHS&&N("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),void 0!==b.sortKey&&t.addToSortKeyRanges(t.symbolInstances.length,b.sortKey),t.symbolInstances.emplaceBack(j.x,j.y,j.z,e.x,e.y,U.right>=0?U.right:-1,U.center>=0?U.center:-1,U.left>=0?U.left:-1,U.vertical>=0?U.vertical:-1,F,R,$,void 0!==I?I:t.collisionBoxArray.length,void 0!==I?I+1:t.collisionBoxArray.length,void 0!==T?T:t.collisionBoxArray.length,void 0!==T?T+1:t.collisionBoxArray.length,void 0!==M?M:t.collisionBoxArray.length,void 0!==M?M+1:t.collisionBoxArray.length,z||t.collisionBoxArray.length,z?z+1:t.collisionBoxArray.length,c,V,L,P,D,K,0,O,q,G);}(t,o,f,a,r,n,i,C,t.layers[0],t.collisionBoxArray,e.index,e.sourceLayerIndex,t.index,A,I,l,0,S,M,y,e,s,u,c,h);};if("line"===T)for(const i of Hp(e.geometry,0,0,ao,ao)){const e=Xp(i,_,k,r.vertical||m,n,x,b,t.overscaling,ao);for(const r of e)m&&Td(t,m.text,z,r)||P(i,r,h);}else if("line-center"===T){for(const t of e.geometry)if(t.length>1){const e=Kp(t,k,r.vertical||m,n,x,b);e&&P(t,e,h);}}else if("Polygon"===e.type)for(const t of Ac(e.geometry,0)){const e=pd(t,16);P(t[0],new Op(e.x,e.y,0,0,void 0),h);}else if("LineString"===e.type)for(const t of e.geometry)P(t,new Op(t[0].x,t[0].y,0,0,void 0),h);else if("Point"===e.type)for(const t of e.geometry)for(const e of t)P([e],new Op(e.x,e.y,0,0,void 0),h);}const _d=255,Ad=_d*Uh;function Sd(t,e,r,n,i,s,a,o,l,u,c,h,p,d,f,y,m){const g=function(t,e,r,n,i,s,a,o){const l=[];if(0===e.positionedLines.length)return l;const u=n.layout.get("text-rotate").evaluate(s,{})*Math.PI/180,c=function(t){const e=t[0],r=t[1],n=e*r;return n>0?[e,-r]:n<0?[-e,r]:0===e?[r,e]:[r,-e]}(r);let h=Math.abs(e.top-e.bottom);for(const t of e.positionedLines)h-=t.lineOffset;const p=e.positionedLines.length,d=h/p;let f=e.top-r[1];for(let t=0;t<p;++t){const n=e.positionedLines[t];f=ud(e,d,f,t);for(const t of n.positionedGlyphs){if(!t.rect)continue;const n=t.rect||{};let s=wp+1,h=!0,p=1,d=0;if(t.imageName){const e=a[t.imageName];if(!e)continue;if(e.sdf){N("SDF images are not supported in formatted text and will be ignored.");continue}h=!1,p=e.pixelRatio,s=Ap/p;}const y=(i||o)&&t.vertical,m=t.metrics.advance*t.scale/2,g=t.metrics,v=t.rect;if(null===v)continue;o&&e.verticalizable&&(d=t.imageName?m-t.metrics.width*t.scale/2:0);const b=i?[t.x+m,t.y]:[0,0];let w=[0,0],_=[0,0],A=!1;i||(y?(_=[t.x+m+c[0],t.y+c[1]-d],A=!0):w=[t.x+m+r[0],t.y+r[1]-d]);const S=v.w*t.scale/(p*(t.localGlyph?td:1)),k=v.h*t.scale/(p*(t.localGlyph?td:1));let I,M,T,z;if(y){const e=t.y-f,r=new x(-m,m-e),n=-Math.PI/2,i=new x(..._);I=new x(-m+w[0],w[1]),I._rotateAround(n,r)._add(i),I.x+=-e+m,I.y-=(g.left-s)*t.scale;const a=t.imageName?g.advance*t.scale:Rh*t.scale,o=String.fromCharCode(t.glyph);Zh(o)?I.x+=(1-s)*t.scale:Kh(o)?I.x+=a-g.height*t.scale+(-s-1)*t.scale:I.x+=t.imageName||g.width+2*s===v.w&&g.height+2*s===v.h?(a-k)/2:(a-(g.height+2*s)*t.scale)/2,M=new x(I.x,I.y-S),T=new x(I.x+k,I.y),z=new x(I.x+k,I.y-S);}else {const e=(g.left-s)*t.scale-m+w[0],r=(-g.top-s)*t.scale+w[1],n=e+S,i=r+k;I=new x(e,r),M=new x(n,r),T=new x(e,i),z=new x(n,i);}if(u){let t;t=i?new x(0,0):A?new x(c[0],c[1]):new x(r[0],r[1]),I._rotateAround(u,t),M._rotateAround(u,t),T._rotateAround(u,t),z._rotateAround(u,t);}const B=new x(0,0),E=new x(0,0);l.push({tl:I,tr:M,bl:T,br:z,tex:n,writingMode:e.writingMode,glyphOffset:b,sectionIndex:t.sectionIndex,isSDF:h,pixelOffsetTL:B,pixelOffsetBR:E,minFontScaleX:0,minFontScaleY:0});}}return l}(0,n,l,s,a,o,i,t.allowVerticalPlacement),v=t.textSizeData;let b=null;"source"===v.kind?(b=[Uh*s.layout.get("text-size").evaluate(o,{},m)],b[0]>Ad&&N(`${t.layerIds[0]}: Value for "text-size" is >= ${_d}. Reduce your "text-size".`)):"composite"===v.kind&&(b=[Uh*f.compositeTextSizes[0].evaluate(o,{},m),Uh*f.compositeTextSizes[1].evaluate(o,{},m)],(b[0]>Ad||b[1]>Ad)&&N(`${t.layerIds[0]}: Value for "text-size" is >= ${_d}. Reduce your "text-size".`)),t.addSymbols(t.text,g,b,l,a,o,c,e,r,u.lineStartIndex,u.lineLength,d,y,m);for(const e of h)p[e]=t.text.placedSymbolArray.length-1;return 4*g.length}function kd(t){for(const e in t)return t[e];return null}function Id(t,e,r,n,i,s,a,o,l,u){let c=a.top,h=a.bottom,p=a.left,d=a.right;const f=a.collisionPadding;if(f&&(p-=f[0],c-=f[1],d+=f[2],h+=f[3]),l){const t=new x(p,c),e=new x(d,c),r=new x(p,h),n=new x(d,h),i=w(l);let s=new x(0,0);u&&(s=new x(u[0],u[1])),t._rotateAround(i,s),e._rotateAround(i,s),r._rotateAround(i,s),n._rotateAround(i,s),p=Math.min(t.x,e.x,r.x,n.x),d=Math.max(t.x,e.x,r.x,n.x),c=Math.min(t.y,e.y,r.y,n.y),h=Math.max(t.y,e.y,r.y,n.y);}return t.emplaceBack(e.x,e.y,e.z,r.x,r.y,p,c,d,h,o,n,i,s),t.length-1}function Md(t){t.collisionPadding&&(t.top-=t.collisionPadding[1],t.bottom+=t.collisionPadding[3]);const e=t.bottom-t.top;return e>0?Math.max(10,e):null}function Td(t,e,r,n){const i=t.compareText;if(e in i){const t=i[e];for(let e=t.length-1;e>=0;e--)if(n.dist(t[e])<r)return !0}else i[e]=[];return i[e].push(n),!1}function zd(t,e){const r=t.fovAboveCenter,n=t.elevation?t.elevation.getMinElevationBelowMSL()*e:0,i=(t._camera.position[2]*t.worldSize-n)/Math.cos(t._pitch),s=Math.sin(r)*i/Math.sin(Math.max(Math.PI/2-t._pitch-r,.01)),a=Math.sin(t._pitch)*s+i;return Math.min(1.01*a,i*(1/t._horizonShift))}function Bd(t,e){if(!e.isReprojectedInTileSpace)return {scale:1<<t.z,x:t.x,y:t.y,x2:t.x+1,y2:t.y+1,projection:e};const r=Math.pow(2,-t.z),n=t.x*r,i=(t.x+1)*r,s=t.y*r,a=(t.y+1)*r,o=Kl(n),l=Kl(i),u=Xl(s),c=Xl(a),h=e.project(o,u),p=e.project(l,u),d=e.project(l,c),f=e.project(o,c);let y=Math.min(h.x,p.x,d.x,f.x),m=Math.min(h.y,p.y,d.y,f.y),g=Math.max(h.x,p.x,d.x,f.x),x=Math.max(h.y,p.y,d.y,f.y);const v=r/16;function b(t,r,n,i,s,a){const o=(n+s)/2,l=(i+a)/2,u=e.project(Kl(o),Xl(l)),c=Math.max(0,y-u.x,m-u.y,u.x-g,u.y-x);y=Math.min(y,u.x),g=Math.max(g,u.x),m=Math.min(m,u.y),x=Math.max(x,u.y),c>v&&(b(t,u,n,i,o,l),b(u,r,o,l,s,a));}b(h,p,n,s,i,s),b(p,d,i,s,i,a),b(d,f,i,a,n,a),b(f,h,n,a,n,s),y-=v,m-=v,g+=v,x+=v;const w=1/Math.max(g-y,x-m);return {scale:w,x:y*w,y:m*w,x2:g*w,y2:x*w,projection:e}}const Ed=po(new Float32Array(16));class Cd{constructor(t){this.spec=t,this.name=t.name,this.wrap=!1,this.requiresDraping=!1,this.supportsWorldCopies=!1,this.supportsTerrain=!1,this.supportsFog=!1,this.supportsFreeCamera=!1,this.zAxisUnit="meters",this.isReprojectedInTileSpace=!0,this.unsupportedLayers=["custom"],this.center=[0,0],this.range=[3.5,7];}project(t,e){return {x:0,y:0,z:0}}unproject(t,e){return new Ol(0,0)}projectTilePoint(t,e,r){return {x:t,y:e,z:0}}locationPoint(t,e,r=!0){return t._coordinatePoint(t.locationCoordinate(e),r)}pixelsPerMeter(t,e){return Zl(1,t)*e}pixelSpaceConversion(t,e,r){return 1}farthestPixelDistance(t){return zd(t,t.pixelsPerMeter)}pointCoordinate(t,e,r,n){const i=t.horizonLineFromTop(!1),s=new x(e,Math.max(i,r));return t.rayIntersectionCoordinate(t.pointRayIntersection(s,n))}pointCoordinate3D(t,e,r){const n=new x(e,r);if(t.elevation)return t.elevation.pointCoordinate(n);{const e=this.pointCoordinate(t,n.x,n.y,0);return [e.x,e.y,e.z]}}isPointAboveHorizon(t,e){if(t.elevation)return !this.pointCoordinate3D(t,e.x,e.y);const r=t.horizonLineFromTop();return e.y<r}createInversionMatrix(t,e){return Ed}createTileMatrix(t,e,r){let n,i,s;const a=r.canonical,o=po(new Float64Array(16));if(this.isReprojectedInTileSpace){const l=Bd(a,this);n=1,i=l.x+r.wrap*l.scale,s=l.y,go(o,o,[n/l.scale,n/l.scale,t.pixelsPerMeter/e]);}else n=e/t.zoomScale(a.z),i=(a.x+Math.pow(2,a.z)*r.wrap)*n,s=a.y*n;return mo(o,o,[i,s,0]),go(o,o,[n/ao,n/ao,1]),o}upVector(t,e,r){return [0,0,1]}upVectorScale(t,e,r){return {metersToTile:1}}}class Pd extends Cd{constructor(t){super(t),this.range=[4,7],this.center=t.center||[-96,37.5];const[e,r]=this.parallels=t.parallels||[29.5,45.5],n=Math.sin(w(e));this.n=(n+Math.sin(w(r)))/2,this.c=1+n*(2*this.n-n),this.r0=Math.sqrt(this.c)/this.n;}project(t,e){const{n:r,c:n,r0:i}=this,s=w(t-this.center[0]),a=w(e),o=Math.sqrt(n-2*r*Math.sin(a))/r;return {x:o*Math.sin(s*r),y:o*Math.cos(s*r)-i,z:0}}unproject(t,e){const{n:r,c:n,r0:i}=this,s=i+e;let a=Math.atan2(t,Math.abs(s))*Math.sign(s);s*r<0&&(a-=Math.PI*Math.sign(t)*Math.sign(s));const o=w(this.center[0])*r;a=z(a,-Math.PI-o,Math.PI-o);const l=M(_(a/r)+this.center[0],-180,180),u=Math.asin(M((n-(t*t+s*s)*r*r)/(2*r),-1,1)),c=M(_(u),-Hl,Hl);return new Ol(l,c)}}const Dd=1.340264,Vd=-.081106,Ld=893e-6,Fd=.003796,Rd=Math.sqrt(3)/2;class Ud extends Cd{project(t,e){e=e/180*Math.PI,t=t/180*Math.PI;const r=Math.asin(Rd*Math.sin(e)),n=r*r,i=n*n*n;return {x:.5*(t*Math.cos(r)/(Rd*(Dd+3*Vd*n+i*(7*Ld+9*Fd*n)))/Math.PI+.5),y:1-.5*(r*(Dd+Vd*n+i*(Ld+Fd*n))/Math.PI+1),z:0}}unproject(t,e){t=(2*t-.5)*Math.PI;let r=e=(2*(1-e)-1)*Math.PI,n=r*r,i=n*n*n;for(let t,s,a,o=0;o<12&&(s=r*(Dd+Vd*n+i*(Ld+Fd*n))-e,a=Dd+3*Vd*n+i*(7*Ld+9*Fd*n),t=s/a,r=M(r-t,-Math.PI/3,Math.PI/3),n=r*r,i=n*n*n,!(Math.abs(t)<1e-12));++o);const s=Rd*t*(Dd+3*Vd*n+i*(7*Ld+9*Fd*n))/Math.cos(r),a=Math.asin(Math.sin(r)/Rd),o=M(180*s/Math.PI,-180,180),l=M(180*a/Math.PI,-Hl,Hl);return new Ol(o,l)}}class $d extends Cd{constructor(t){super(t),this.wrap=!0,this.supportsWorldCopies=!0;}project(t,e){return {x:.5+t/360,y:.5-e/360,z:0}}unproject(t,e){const r=360*(t-.5),n=M(360*(.5-e),-Hl,Hl);return new Ol(r,n)}}const jd=Math.PI/2;function Od(t){return Math.tan((jd+t)/2)}class qd extends Cd{constructor(t){super(t),this.center=t.center||[0,30];const[e,r]=this.parallels=t.parallels||[30,30];let n=w(e),i=w(r);this.southernCenter=n+i<0,this.southernCenter&&(n=-n,i=-i);const s=Math.cos(n),a=Od(n);this.n=n===i?Math.sin(n):Math.log(s/Math.cos(i))/Math.log(Od(i)/a),this.f=s*Math.pow(Od(n),this.n)/this.n;}project(t,e){e=w(e),this.southernCenter&&(e=-e),t=w(t-this.center[0]);const r=1e-6,{n:n,f:i}=this;i>0?e<-jd+r&&(e=-jd+r):e>jd-r&&(e=jd-r);const s=i/Math.pow(Od(e),n);let a=s*Math.sin(n*t),o=i-s*Math.cos(n*t);return a=.5*(a/Math.PI+.5),o=.5*(o/Math.PI+.5),{x:a,y:this.southernCenter?o:1-o,z:0}}unproject(t,e){t=(2*t-.5)*Math.PI,this.southernCenter&&(e=1-e),e=(2*(1-e)-.5)*Math.PI;const{n:r,f:n}=this,i=n-e,s=Math.sign(i),a=Math.sign(r)*Math.sqrt(t*t+i*i);let o=Math.atan2(t,Math.abs(i))*s;i*r<0&&(o-=Math.PI*Math.sign(t)*s);const l=M(_(o/r)+this.center[0],-180,180),u=M(_(2*Math.atan(Math.pow(n/a,1/r))-jd),-Hl,Hl);return new Ol(l,this.southernCenter?-u:u)}}class Nd extends Cd{constructor(t){super(t),this.wrap=!0,this.supportsWorldCopies=!0,this.supportsTerrain=!0,this.supportsFog=!0,this.supportsFreeCamera=!0,this.isReprojectedInTileSpace=!1,this.unsupportedLayers=[],this.range=null;}project(t,e){return {x:Nl(t),y:Gl(e),z:0}}unproject(t,e){const r=Kl(t),n=Xl(e);return new Ol(r,n)}}const Gd=w(Hl);class Zd extends Cd{project(t,e){const r=(e=w(e))*e,n=r*r;return {x:.5*((t=w(t))*(.8707-.131979*r+n*(n*(.003971*r-.001529*n)-.013791))/Math.PI+.5),y:1-.5*(e*(1.007226+r*(.015085+n*(.028874*r-.044475-.005916*n)))/Math.PI+1),z:0}}unproject(t,e){t=(2*t-.5)*Math.PI;let r=e=(2*(1-e)-1)*Math.PI,n=25,i=0,s=r*r;do{s=r*r;const t=s*s;i=(r*(1.007226+s*(.015085+t*(.028874*s-.044475-.005916*t)))-e)/(1.007226+s*(.045255+t*(.259866*s-.311325-.005916*11*t))),r=M(r-i,-Gd,Gd);}while(Math.abs(i)>1e-6&&--n>0);s=r*r;const a=M(_(t/(.8707+s*(s*(s*s*s*(.003971-.001529*s)-.013791)-.131979))),-180,180),o=_(r);return new Ol(a,o)}}const Kd=w(Hl);class Xd extends Cd{project(t,e){e=w(e),t=w(t);const r=Math.cos(e),n=2/Math.PI,i=Math.acos(r*Math.cos(t/2)),s=Math.sin(i)/i,a=.5*(t*n+2*r*Math.sin(t/2)/s)||0,o=.5*(e+Math.sin(e)/s)||0;return {x:.5*(a/Math.PI+.5),y:1-.5*(o/Math.PI+1),z:0}}unproject(t,e){let r=t=(2*t-.5)*Math.PI,n=e=(2*(1-e)-1)*Math.PI,i=25;const s=1e-6;let a=0,o=0;do{const i=Math.cos(n),s=Math.sin(n),l=2*s*i,u=s*s,c=i*i,h=Math.cos(r/2),p=Math.sin(r/2),d=2*h*p,f=p*p,y=1-c*h*h,m=y?1/y:0,g=y?Math.acos(i*h)*Math.sqrt(1/y):0,x=.5*(2*g*i*p+2*r/Math.PI)-t,v=.5*(g*s+n)-e,b=.5*m*(c*f+g*i*h*u)+1/Math.PI,w=m*(d*l/4-g*s*p),_=.125*m*(l*p-g*s*c*d),A=.5*m*(u*h+g*f*i)+.5,S=w*_-A*b;a=(v*w-x*A)/S,o=(x*_-v*b)/S,r=M(r-a,-Math.PI,Math.PI),n=M(n-o,-Kd,Kd);}while((Math.abs(a)>s||Math.abs(o)>s)&&--i>0);return new Ol(_(r),_(n))}}class Jd extends Cd{constructor(t){super(t),this.center=t.center||[0,0],this.parallels=t.parallels||[0,0],this.cosPhi=Math.max(.01,Math.cos(w(this.parallels[0]))),this.scale=1/(2*Math.max(Math.PI*this.cosPhi,1/this.cosPhi)),this.wrap=!0,this.supportsWorldCopies=!0;}project(t,e){const{scale:r,cosPhi:n}=this;return {x:w(t)*n*r+.5,y:-Math.sin(w(e))/n*r+.5,z:0}}unproject(t,e){const{scale:r,cosPhi:n}=this,i=-(e-.5)/r,s=M(_((t-.5)/r)/n,-180,180),a=Math.asin(M(i*n,-1,1)),o=M(_(a),-Hl,Hl);return new Ol(s,o)}}class Hd extends Nd{constructor(t){super(t),this.requiresDraping=!0,this.supportsWorldCopies=!1,this.supportsFog=!0,this.zAxisUnit="pixels",this.unsupportedLayers=["debug"],this.range=[3,5];}projectTilePoint(t,e,r){const n=Ml(t,e,r);return Fo(n,n,Bl(xl(r))),{x:n[0],y:n[1],z:n[2]}}locationPoint(t,e){const r=Il(e.lat,e.lng),n=Do([],r),i=t.elevation?t.elevation.getAtPointOrZero(t.locationCoordinate(e),t._centerAltitude):t._centerAltitude;Po(r,r,n,Zl(1,0)*ao*i);const s=po(new Float64Array(16));return yo(s,t.pixelMatrix,t.globeMatrix),Fo(r,r,s),new x(r[0],r[1])}pixelsPerMeter(t,e){return Zl(1,0)*e}pixelSpaceConversion(t,e,r){const n=Zl(1,t)*e,i=Er(Zl(1,45)*e,n,r);return this.pixelsPerMeter(t,e)/i}createTileMatrix(t,e,r){const n=El(xl(r.canonical));return yo(new Float64Array(16),t.globeMatrix,n)}createInversionMatrix(t,e){const{center:r}=t,n=Bl(xl(e));return vo(n,n,w(r.lng)),xo(n,n,w(r.lat)),go(n,n,[t._pixelsPerMercatorPixel,t._pixelsPerMercatorPixel,1]),Float32Array.from(n)}pointCoordinate(t,e,r,n){return yl(t,e,r,!0)||new Wl(0,0)}pointCoordinate3D(t,e,r){const n=this.pointCoordinate(t,e,r,0);return [n.x,n.y,n.z]}isPointAboveHorizon(t,e){return !yl(t,e.x,e.y,!1)}farthestPixelDistance(t){const e=function(t,e){const r=t.cameraToCenterDistance,n=t._centerAltitude*e,i=t._camera,s=t._camera.forward(),a=Mo([],Co([],s,-r),[0,0,n]),o=t.worldSize/(2*Math.PI),l=[0,0,-o],u=t.width/t.height,c=Math.tan(t.fovAboveCenter),h=Co([],i.up(),c),p=Co([],i.right(),c*u),d=Do([],Mo([],Mo([],s,h),p)),f=[];let y;if(new el(a,d).closestPointOnSphere(l,o,f)){const e=Mo([],f,l),r=$o([],e,a);y=Math.cos(t.fovAboveCenter)*ko(r);}else {const t=$o([],a,l),e=$o([],l,a);Do(e,e);const r=ko(t)-o;y=Math.sqrt(r*(r+2*o));const n=Math.acos(y/(o+r))-Math.acos(Vo(s,e));y*=Math.cos(n);}return 1.01*y}(t,this.pixelsPerMeter(t.center.lat,t.worldSize)),r=Pl(t.zoom);if(r>0){const n=zd(t,Zl(1,t.center.lat)*t.worldSize),i=t.worldSize/(2*Math.PI),s=Math.max(t.width,t.height)/t.worldSize*Math.PI;return Er(e,n+i*(1-Math.cos(s)),Math.pow(r,10))}return e}upVector(t,e,r){return Ml(e,r,t,1)}upVectorScale(t){return {metersToTile:fl(Tl(xl(t)))}}}function Yd(t){const e=t.parallels,r=!!e&&Math.abs(e[0]+e[1])<.01;switch(t.name){case"mercator":return new Nd(t);case"equirectangular":return new $d(t);case"naturalEarth":return new Zd(t);case"equalEarth":return new Ud(t);case"winkelTripel":return new Xd(t);case"albers":return r?new Jd(t):new Pd(t);case"lambertConformalConic":return r?new Jd(t):new qd(t);case"globe":return new Hd(t)}throw new Error(`Invalid projection name: ${t.name}`)}const Wd=Kc.types,Qd=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function tf(t,e,r,n,i,s,a,o,l,u,c,h,p){const d=o?Math.min(Ad,Math.round(o[0])):0,f=o?Math.min(Ad,Math.round(o[1])):0;t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),s,a,(d<<1)+(l?1:0),f,16*u,16*c,256*h,256*p);}function ef(t,e,r,n,i,s,a){t.emplaceBack(e,r,n,i,s,a);}function rf(t,e,r,n,i){t.emplaceBack(e,r,n,i),t.emplaceBack(e,r,n,i),t.emplaceBack(e,r,n,i),t.emplaceBack(e,r,n,i);}function nf(t){for(const e of t.sections)if(ls(e.text))return !0;return !1}class sf{constructor(t){this.layoutVertexArray=new Xs,this.indexArray=new ra,this.programConfigurations=t,this.segments=new so,this.dynamicLayoutVertexArray=new Ns,this.opacityVertexArray=new Hs,this.placedSymbolArray=new fa,this.globeExtVertexArray=new Js;}isEmpty(){return 0===this.layoutVertexArray.length&&0===this.indexArray.length&&0===this.dynamicLayoutVertexArray.length&&0===this.opacityVertexArray.length}upload(t,e,r,n){this.isEmpty()||(r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Eh.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,Ph.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,Qd,!0),this.globeExtVertexArray.length>0&&(this.globeExtVertexBuffer=t.createVertexBuffer(this.globeExtVertexArray,Ch.members,!0)),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t));}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy(),this.globeExtVertexBuffer&&this.globeExtVertexBuffer.destroy());}}Ji(sf,"SymbolBuffers");class af{constructor(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new so,this.collisionVertexArray=new ta,this.collisionVertexArrayExt=new ea;}upload(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,Dh.members,!0),this.collisionVertexBufferExt=t.createVertexBuffer(this.collisionVertexArrayExt,Vh.members,!0);}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy(),this.collisionVertexBufferExt.destroy());}}Ji(af,"CollisionBuffers");class of{constructor(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1,this.hasRTLText=!1,this.fullyClipped=!1,this.sortKeyRanges=[],this.collisionCircleArray=[],this.placementInvProjMatrix=po([]),this.placementViewportMatrix=po([]);const e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=$h(this.zoom,e["text-size"]),this.iconSizeData=$h(this.zoom,e["icon-size"]);const r=this.layers[0].layout,n=r.get("symbol-sort-key"),i=r.get("symbol-z-order");this.canOverlap=r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement"),this.sortFeaturesByKey="viewport-y"!==i&&void 0!==n.constantOr(1),this.sortFeaturesByY=("viewport-y"===i||"auto"===i&&!this.sortFeaturesByKey)&&this.canOverlap,this.writingModes=r.get("text-writing-mode").map((t=>Ip[t])),this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id)),this.sourceID=t.sourceID,this.projection=t.projection;}createArrays(){this.text=new sf(new Ja(this.layers,this.zoom,(t=>/^text/.test(t)))),this.icon=new sf(new Ja(this.layers,this.zoom,(t=>/^icon/.test(t)))),this.glyphOffsetArray=new ga,this.lineVertexArray=new xa,this.symbolInstances=new ma;}calculateGlyphDependencies(t,e,r,n,i){for(let r=0;r<t.length;r++)if(e[t.charCodeAt(r)]=!0,n&&i){const n=Gh[t.charAt(r)];n&&(e[n.charCodeAt(0)]=!0);}}populate(t,e,r,n){const i=this.layers[0],s=i.layout,a="globe"===this.projection.name,o=s.get("text-font"),l=s.get("text-field"),u=s.get("icon-image"),c=("constant"!==l.value.kind||l.value.value instanceof De&&!l.value.value.isEmpty()||l.value.value.toString().length>0)&&("constant"!==o.value.kind||o.value.value.length>0),h="constant"!==u.value.kind||!!u.value.value||Object.keys(u.parameters).length>0,p=s.get("symbol-sort-key");if(this.features=[],!c&&!h)return;const d=e.iconDependencies,f=e.glyphDependencies,y=e.availableImages,m=new ws(this.zoom);for(const{feature:e,id:l,index:u,sourceLayerIndex:g}of t){const t=i._featureFilter.needGeometry,x=ou(e,t);if(!i._featureFilter.filter(m,x,r))continue;if(t||(x.geometry=au(e,r,n)),a&&1!==e.type&&r.z<=5){const t=x.geometry,e=.98078528056,n=(t,n)=>Vo(Ml(t.x,t.y,r,1),Ml(n.x,n.y,r,1))<e;for(let e=0;e<t.length;e++)t[e]=ru(t[e],n);}let v,b;if(c){const t=i.getValueAndResolveTokens("text-field",x,r,y),e=De.factory(t);nf(e)&&(this.hasRTLText=!0),(!this.hasRTLText||"unavailable"===xs()||this.hasRTLText&&bs.isParsed())&&(v=Nh(e,i,x));}if(h){const t=i.getValueAndResolveTokens("icon-image",x,r,y);b=t instanceof Ve?t:Ve.fromString(t);}if(!v&&!b)continue;const w=this.sortFeaturesByKey?p.evaluate(x,{},r):void 0;if(this.features.push({id:l,text:v,icon:b,index:u,sourceLayerIndex:g,geometry:x.geometry,properties:e.properties,type:Wd[e.type],sortKey:w}),b&&(d[b.name]=!0),v){const t=o.evaluate(x,{},r).join(","),e="map"===s.get("text-rotation-alignment")&&"point"!==s.get("symbol-placement");this.allowVerticalPlacement=this.writingModes&&this.writingModes.indexOf(Ip.vertical)>=0;for(const r of v.sections)if(r.image)d[r.image.name]=!0;else {const n=es(v.toString()),i=r.fontStack||t,s=f[i]=f[i]||{};this.calculateGlyphDependencies(r.text,s,e,this.allowVerticalPlacement,n);}}}"line"===s.get("symbol-placement")&&(this.features=function(t){const e={},r={},n=[];let i=0;function s(e){n.push(t[e]),i++;}function a(t,e,i){const s=r[t];return delete r[t],r[e]=s,n[s].geometry[0].pop(),n[s].geometry[0]=n[s].geometry[0].concat(i[0]),s}function o(t,r,i){const s=e[r];return delete e[r],e[t]=s,n[s].geometry[0].shift(),n[s].geometry[0]=i[0].concat(n[s].geometry[0]),s}function l(t,e,r){const n=r?e[0][e[0].length-1]:e[0][0];return `${t}:${n.x}:${n.y}`}for(let u=0;u<t.length;u++){const c=t[u],h=c.geometry,p=c.text?c.text.toString():null;if(!p){s(u);continue}const d=l(p,h),f=l(p,h,!0);if(d in r&&f in e&&r[d]!==e[f]){const t=o(d,f,h),i=a(d,f,n[t].geometry);delete e[d],delete r[f],r[l(p,n[i].geometry,!0)]=i,n[t].geometry=null;}else d in r?a(d,f,h):f in e?o(d,f,h):(s(u),e[d]=i-1,r[f]=i-1);}return n.filter((t=>t.geometry))}(this.features)),this.sortFeaturesByKey&&this.features.sort(((t,e)=>t.sortKey-e.sortKey));}update(t,e,r,n){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,r,n),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,r,n));}isEmpty(){return 0===this.symbolInstances.length&&!this.hasRTLText}uploadPending(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload}upload(t){!this.uploaded&&this.hasDebugData()&&(this.textCollisionBox.upload(t),this.iconCollisionBox.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;}destroyDebugData(){this.textCollisionBox.destroy(),this.iconCollisionBox.destroy();}getProjection(){return this.projectionInstance||(this.projectionInstance=Yd(this.projection)),this.projectionInstance}destroy(){this.text.destroy(),this.icon.destroy(),this.hasDebugData()&&this.destroyDebugData();}addToLineVertexArray(t,e){const r=this.lineVertexArray.length;if(void 0!==t.segment)for(const{x:t,y:r}of e)this.lineVertexArray.emplaceBack(t,r);return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}}addSymbols(t,e,r,n,i,s,a,o,l,u,c,h,p,d){const f=t.indexArray,y=t.layoutVertexArray,m=t.globeExtVertexArray,g=t.segments.prepareSegment(4*e.length,y,f,this.canOverlap?s.sortKey:void 0),x=this.glyphOffsetArray.length,v=g.vertexLength,b=this.allowVerticalPlacement&&a===Ip.vertical?Math.PI/2:0,w=s.text&&s.text.sections;for(let n=0;n<e.length;n++){const{tl:i,tr:a,bl:u,br:c,tex:h,pixelOffsetTL:x,pixelOffsetBR:v,minFontScaleX:_,minFontScaleY:A,glyphOffset:S,isSDF:k,sectionIndex:I}=e[n],M=g.vertexLength,T=S[1];if(tf(y,l.x,l.y,i.x,T+i.y,h.x,h.y,r,k,x.x,x.y,_,A),tf(y,l.x,l.y,a.x,T+a.y,h.x+h.w,h.y,r,k,v.x,x.y,_,A),tf(y,l.x,l.y,u.x,T+u.y,h.x,h.y+h.h,r,k,x.x,v.y,_,A),tf(y,l.x,l.y,c.x,T+c.y,h.x+h.w,h.y+h.h,r,k,v.x,v.y,_,A),o){const{x:e,y:r,z:n}=o.anchor,[i,s,a]=o.up;ef(m,e,r,n,i,s,a),ef(m,e,r,n,i,s,a),ef(m,e,r,n,i,s,a),ef(m,e,r,n,i,s,a),rf(t.dynamicLayoutVertexArray,e,r,n,b);}else rf(t.dynamicLayoutVertexArray,l.x,l.y,l.z,b);f.emplaceBack(M,M+1,M+2),f.emplaceBack(M+1,M+2,M+3),g.vertexLength+=4,g.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(S[0]),n!==e.length-1&&I===e[n+1].sectionIndex||t.programConfigurations.populatePaintArrays(y.length,s,s.index,{},p,d,w&&w[I]);}const _=o?o.anchor:l;t.placedSymbolArray.emplaceBack(_.x,_.y,_.z,l.x,l.y,x,this.glyphOffsetArray.length-x,v,u,c,l.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],a,0,!1,0,h,0);}_commitLayoutVertex(t,e,r,n,i,s,a){t.emplaceBack(e,r,n,i,s,Math.round(a.x),Math.round(a.y));}_addCollisionDebugVertices(t,e,r,n,i,s,a){const o=r.segments.prepareSegment(4,r.layoutVertexArray,r.indexArray),l=o.vertexLength,u=a.tileAnchorX,c=a.tileAnchorY;for(let t=0;t<4;t++)r.collisionVertexArray.emplaceBack(0,0,0,0);r.collisionVertexArrayExt.emplaceBack(e,-t.padding,-t.padding),r.collisionVertexArrayExt.emplaceBack(e,t.padding,-t.padding),r.collisionVertexArrayExt.emplaceBack(e,t.padding,t.padding),r.collisionVertexArrayExt.emplaceBack(e,-t.padding,t.padding),this._commitLayoutVertex(r.layoutVertexArray,n,i,s,u,c,new x(t.x1,t.y1)),this._commitLayoutVertex(r.layoutVertexArray,n,i,s,u,c,new x(t.x2,t.y1)),this._commitLayoutVertex(r.layoutVertexArray,n,i,s,u,c,new x(t.x2,t.y2)),this._commitLayoutVertex(r.layoutVertexArray,n,i,s,u,c,new x(t.x1,t.y2)),o.vertexLength+=4;const h=r.indexArray;h.emplaceBack(l,l+1),h.emplaceBack(l+1,l+2),h.emplaceBack(l+2,l+3),h.emplaceBack(l+3,l),o.primitiveLength+=4;}_addTextDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceTextSize(t,s,e,a);this._addCollisionDebugVertices(n,i,this.textCollisionBox,n.projectedAnchorX,n.projectedAnchorY,n.projectedAnchorZ,s);}}_addIconDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceIconSize(t,e,s.placedIconSymbolIndex);this._addCollisionDebugVertices(n,i,this.iconCollisionBox,n.projectedAnchorX,n.projectedAnchorY,n.projectedAnchorZ,s);}}generateCollisionDebugBuffers(t,e){this.hasDebugData()&&this.destroyDebugData(),this.textCollisionBox=new af(Ws,Lh.members,la),this.iconCollisionBox=new af(Ws,Lh.members,la);const r=Oh(this.iconSizeData,t),n=Oh(this.textSizeData,t);for(let i=0;i<this.symbolInstances.length;i++){const s=this.symbolInstances.get(i);this._addTextDebugCollisionBoxes(n,t,e,s.textBoxStartIndex,s.textBoxEndIndex,s),this._addTextDebugCollisionBoxes(n,t,e,s.verticalTextBoxStartIndex,s.verticalTextBoxEndIndex,s),this._addIconDebugCollisionBoxes(r,t,e,s.iconBoxStartIndex,s.iconBoxEndIndex,s),this._addIconDebugCollisionBoxes(r,t,e,s.verticalIconBoxStartIndex,s.verticalIconBoxEndIndex,s);}}getSymbolInstanceTextSize(t,e,r,n){const i=this.text.placedSymbolArray.get(e.rightJustifiedTextSymbolIndex>=0?e.rightJustifiedTextSymbolIndex:e.centerJustifiedTextSymbolIndex>=0?e.centerJustifiedTextSymbolIndex:e.leftJustifiedTextSymbolIndex>=0?e.leftJustifiedTextSymbolIndex:e.verticalPlacedTextSymbolIndex>=0?e.verticalPlacedTextSymbolIndex:n),s=jh(this.textSizeData,t,i)/Rh;return this.tilePixelRatio*s}getSymbolInstanceIconSize(t,e,r){const n=this.icon.placedSymbolArray.get(r),i=jh(this.iconSizeData,t,n);return this.tilePixelRatio*i}_commitDebugCollisionVertexUpdate(t,e,r){t.emplaceBack(e,-r,-r),t.emplaceBack(e,r,-r),t.emplaceBack(e,r,r),t.emplaceBack(e,-r,r);}_updateTextDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceTextSize(t,s,e,a);this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt,i,n.padding);}}_updateIconDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceIconSize(t,e,s);this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt,i,n.padding);}}updateCollisionDebugBuffers(t,e){if(!this.hasDebugData())return;this.hasTextCollisionBoxData()&&this.textCollisionBox.collisionVertexArrayExt.clear(),this.hasIconCollisionBoxData()&&this.iconCollisionBox.collisionVertexArrayExt.clear();const r=Oh(this.iconSizeData,t),n=Oh(this.textSizeData,t);for(let i=0;i<this.symbolInstances.length;i++){const s=this.symbolInstances.get(i);this._updateTextDebugCollisionBoxes(n,t,e,s.textBoxStartIndex,s.textBoxEndIndex,s),this._updateTextDebugCollisionBoxes(n,t,e,s.verticalTextBoxStartIndex,s.verticalTextBoxEndIndex,s),this._updateIconDebugCollisionBoxes(r,t,e,s.iconBoxStartIndex,s.iconBoxEndIndex,s.placedIconSymbolIndex),this._updateIconDebugCollisionBoxes(r,t,e,s.verticalIconBoxStartIndex,s.verticalIconBoxEndIndex,s.placedIconSymbolIndex);}this.hasTextCollisionBoxData()&&this.textCollisionBox.collisionVertexBufferExt&&this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt),this.hasIconCollisionBoxData()&&this.iconCollisionBox.collisionVertexBufferExt&&this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);}_deserializeCollisionBoxesForSymbol(t,e,r,n,i,s,a,o,l){const u={};if(e<r){const{x1:r,y1:n,x2:i,y2:s,padding:a,projectedAnchorX:o,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p,featureIndex:d}=t.get(e);u.textBox={x1:r,y1:n,x2:i,y2:s,padding:a,projectedAnchorX:o,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p},u.textFeatureIndex=d;}if(n<i){const{x1:e,y1:r,x2:i,y2:s,padding:a,projectedAnchorX:o,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p,featureIndex:d}=t.get(n);u.verticalTextBox={x1:e,y1:r,x2:i,y2:s,padding:a,projectedAnchorX:o,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p},u.verticalTextFeatureIndex=d;}if(s<a){const{x1:e,y1:r,x2:n,y2:i,padding:a,projectedAnchorX:o,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p,featureIndex:d}=t.get(s);u.iconBox={x1:e,y1:r,x2:n,y2:i,padding:a,projectedAnchorX:o,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p},u.iconFeatureIndex=d;}if(o<l){const{x1:e,y1:r,x2:n,y2:i,padding:s,projectedAnchorX:a,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p,featureIndex:d}=t.get(o);u.verticalIconBox={x1:e,y1:r,x2:n,y2:i,padding:s,projectedAnchorX:a,projectedAnchorY:l,projectedAnchorZ:c,tileAnchorX:h,tileAnchorY:p},u.verticalIconFeatureIndex=d;}return u}deserializeCollisionBoxes(t){this.collisionArrays=[];for(let e=0;e<this.symbolInstances.length;e++){const r=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,r.textBoxStartIndex,r.textBoxEndIndex,r.verticalTextBoxStartIndex,r.verticalTextBoxEndIndex,r.iconBoxStartIndex,r.iconBoxEndIndex,r.verticalIconBoxStartIndex,r.verticalIconBoxEndIndex));}}hasTextData(){return this.text.segments.get().length>0}hasIconData(){return this.icon.segments.get().length>0}hasDebugData(){return this.textCollisionBox&&this.iconCollisionBox}hasTextCollisionBoxData(){return this.hasDebugData()&&this.textCollisionBox.segments.get().length>0}hasIconCollisionBoxData(){return this.hasDebugData()&&this.iconCollisionBox.segments.get().length>0}addIndicesForPlacedSymbol(t,e){const r=t.placedSymbolArray.get(e),n=r.vertexStartIndex+4*r.numGlyphs;for(let e=r.vertexStartIndex;e<n;e+=4)t.indexArray.emplaceBack(e,e+1,e+2),t.indexArray.emplaceBack(e+1,e+2,e+3);}getSortedSymbolIndexes(t){if(this.sortedAngle===t&&void 0!==this.symbolInstanceIndexes)return this.symbolInstanceIndexes;const e=Math.sin(t),r=Math.cos(t),n=[],i=[],s=[];for(let t=0;t<this.symbolInstances.length;++t){s.push(t);const a=this.symbolInstances.get(t);n.push(0|Math.round(e*a.tileAnchorX+r*a.tileAnchorY)),i.push(a.featureIndex);}return s.sort(((t,e)=>n[t]-n[e]||i[e]-i[t])),s}addToSortKeyRanges(t,e){const r=this.sortKeyRanges[this.sortKeyRanges.length-1];r&&r.sortKey===e?r.symbolInstanceEnd=t+1:this.sortKeyRanges.push({sortKey:e,symbolInstanceStart:t,symbolInstanceEnd:t+1});}sortFeatures(t){if(this.sortFeaturesByY&&this.sortedAngle!==t&&!(this.text.segments.get().length>1||this.icon.segments.get().length>1)){this.symbolInstanceIndexes=this.getSortedSymbolIndexes(t),this.sortedAngle=t,this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(const t of this.symbolInstanceIndexes){const e=this.symbolInstances.get(t);this.featureSortOrder.push(e.featureIndex);const{rightJustifiedTextSymbolIndex:r,centerJustifiedTextSymbolIndex:n,leftJustifiedTextSymbolIndex:i,verticalPlacedTextSymbolIndex:s,placedIconSymbolIndex:a,verticalPlacedIconSymbolIndex:o}=e;r>=0&&this.addIndicesForPlacedSymbol(this.text,r),n>=0&&n!==r&&this.addIndicesForPlacedSymbol(this.text,n),i>=0&&i!==n&&i!==r&&this.addIndicesForPlacedSymbol(this.text,i),s>=0&&this.addIndicesForPlacedSymbol(this.text,s),a>=0&&this.addIndicesForPlacedSymbol(this.icon,a),o>=0&&this.addIndicesForPlacedSymbol(this.icon,o);}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}}}Ji(of,"SymbolBucket",{omit:["layers","collisionBoxArray","features","compareText"]}),of.MAX_GLYPHS=65535,of.addDynamicAttributes=rf;const lf=new Ps({"symbol-placement":new Bs(te.layout_symbol["symbol-placement"]),"symbol-spacing":new Bs(te.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new Bs(te.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new Es(te.layout_symbol["symbol-sort-key"]),"symbol-z-order":new Bs(te.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new Bs(te.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new Bs(te.layout_symbol["icon-ignore-placement"]),"icon-optional":new Bs(te.layout_symbol["icon-optional"]),"icon-rotation-alignment":new Bs(te.layout_symbol["icon-rotation-alignment"]),"icon-size":new Es(te.layout_symbol["icon-size"]),"icon-text-fit":new Bs(te.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new Bs(te.layout_symbol["icon-text-fit-padding"]),"icon-image":new Es(te.layout_symbol["icon-image"]),"icon-rotate":new Es(te.layout_symbol["icon-rotate"]),"icon-padding":new Bs(te.layout_symbol["icon-padding"]),"icon-keep-upright":new Bs(te.layout_symbol["icon-keep-upright"]),"icon-offset":new Es(te.layout_symbol["icon-offset"]),"icon-anchor":new Es(te.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new Bs(te.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new Bs(te.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new Bs(te.layout_symbol["text-rotation-alignment"]),"text-field":new Es(te.layout_symbol["text-field"]),"text-font":new Es(te.layout_symbol["text-font"]),"text-size":new Es(te.layout_symbol["text-size"]),"text-max-width":new Es(te.layout_symbol["text-max-width"]),"text-line-height":new Es(te.layout_symbol["text-line-height"]),"text-letter-spacing":new Es(te.layout_symbol["text-letter-spacing"]),"text-justify":new Es(te.layout_symbol["text-justify"]),"text-radial-offset":new Es(te.layout_symbol["text-radial-offset"]),"text-variable-anchor":new Bs(te.layout_symbol["text-variable-anchor"]),"text-anchor":new Es(te.layout_symbol["text-anchor"]),"text-max-angle":new Bs(te.layout_symbol["text-max-angle"]),"text-writing-mode":new Bs(te.layout_symbol["text-writing-mode"]),"text-rotate":new Es(te.layout_symbol["text-rotate"]),"text-padding":new Bs(te.layout_symbol["text-padding"]),"text-keep-upright":new Bs(te.layout_symbol["text-keep-upright"]),"text-transform":new Es(te.layout_symbol["text-transform"]),"text-offset":new Es(te.layout_symbol["text-offset"]),"text-allow-overlap":new Bs(te.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new Bs(te.layout_symbol["text-ignore-placement"]),"text-optional":new Bs(te.layout_symbol["text-optional"])});var uf={paint:new Ps({"icon-opacity":new Es(te.paint_symbol["icon-opacity"]),"icon-color":new Es(te.paint_symbol["icon-color"]),"icon-halo-color":new Es(te.paint_symbol["icon-halo-color"]),"icon-halo-width":new Es(te.paint_symbol["icon-halo-width"]),"icon-halo-blur":new Es(te.paint_symbol["icon-halo-blur"]),"icon-translate":new Bs(te.paint_symbol["icon-translate"]),"icon-translate-anchor":new Bs(te.paint_symbol["icon-translate-anchor"]),"text-opacity":new Es(te.paint_symbol["text-opacity"]),"text-color":new Es(te.paint_symbol["text-color"],{runtimeType:pe,getOverride:t=>t.textColor,hasOverride:t=>!!t.textColor}),"text-halo-color":new Es(te.paint_symbol["text-halo-color"]),"text-halo-width":new Es(te.paint_symbol["text-halo-width"]),"text-halo-blur":new Es(te.paint_symbol["text-halo-blur"]),"text-translate":new Bs(te.paint_symbol["text-translate"]),"text-translate-anchor":new Bs(te.paint_symbol["text-translate-anchor"])}),layout:lf};class cf{constructor(t){this.type=t.property.overrides?t.property.overrides.runtimeType:le,this.defaultValue=t;}evaluate(t){if(t.formattedSection){const e=this.defaultValue.property.overrides;if(e&&e.hasOverride(t.formattedSection))return e.getOverride(t.formattedSection)}return t.feature&&t.featureState?this.defaultValue.evaluate(t.feature,t.featureState):this.defaultValue.property.specification.default}eachChild(t){this.defaultValue.isConstant()||t(this.defaultValue.value._styleExpression.expression);}outputDefined(){return !1}serialize(){return null}}Ji(cf,"FormatSectionOverride",{omit:["defaultValue"]});class hf extends ro{constructor(t){super(t,uf);}recalculate(t,e){super.recalculate(t,e),"auto"===this.layout.get("icon-rotation-alignment")&&(this.layout._values["icon-rotation-alignment"]="point"!==this.layout.get("symbol-placement")?"map":"viewport"),"auto"===this.layout.get("text-rotation-alignment")&&(this.layout._values["text-rotation-alignment"]="point"!==this.layout.get("symbol-placement")?"map":"viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment"));const r=this.layout.get("text-writing-mode");if(r){const t=[];for(const e of r)t.indexOf(e)<0&&t.push(e);this.layout._values["text-writing-mode"]=t;}else this.layout._values["text-writing-mode"]="point"===this.layout.get("symbol-placement")?["horizontal"]:["horizontal","vertical"];this._setPaintOverrides();}getValueAndResolveTokens(t,e,r,n){const i=this.layout.get(t).evaluate(e,{},r,n),s=this._unevaluatedLayout._values[t];return s.isDataDriven()||Jn(s.value)||!i?i:function(t,e){return e.replace(/{([^{}]+)}/g,((e,r)=>r in t?String(t[r]):""))}(e.properties,i)}createBucket(t){return new of(t)}queryRadius(){return 0}queryIntersectsFeature(){return !1}_setPaintOverrides(){for(const t of uf.paint.overridableProperties){if(!hf.hasPaintOverride(this.layout,t))continue;const e=this.paint.get(t),r=new cf(e),n=new Xn(r,e.property.specification);let i=null;i="constant"===e.value.kind||"source"===e.value.kind?new Yn("source",n):new Wn("composite",n,e.value.zoomStops,e.value._interpolationType),this.paint._values[t]=new Ts(e.property,i,e.parameters);}}_handleOverridablePaintPropertyUpdate(t,e,r){return !(!this.layout||e.isDataDriven()||r.isDataDriven())&&hf.hasPaintOverride(this.layout,t)}static hasPaintOverride(t,e){const r=t.get("text-field"),n=uf.paint.properties[e];let i=!1;const s=t=>{for(const e of t)if(n.overrides&&n.overrides.hasOverride(e))return void(i=!0)};if("constant"===r.value.kind&&r.value.value instanceof De)s(r.value.value.sections);else if("source"===r.value.kind){const t=e=>{i||(e instanceof je&&Re(e.value)===me?s(e.value.sections):e instanceof Ze?s(e.sections):e.eachChild(t));},e=r.value;e._styleExpression&&t(e._styleExpression.expression);}return i}getProgramConfiguration(t){return new Xa(this,t)}}var pf={paint:new Ps({"background-color":new Bs(te.paint_background["background-color"]),"background-pattern":new Bs(te.paint_background["background-pattern"]),"background-opacity":new Bs(te.paint_background["background-opacity"])})},df={paint:new Ps({"raster-opacity":new Bs(te.paint_raster["raster-opacity"]),"raster-hue-rotate":new Bs(te.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new Bs(te.paint_raster["raster-brightness-min"]),"raster-brightness-max":new Bs(te.paint_raster["raster-brightness-max"]),"raster-saturation":new Bs(te.paint_raster["raster-saturation"]),"raster-contrast":new Bs(te.paint_raster["raster-contrast"]),"raster-resampling":new Bs(te.paint_raster["raster-resampling"]),"raster-fade-duration":new Bs(te.paint_raster["raster-fade-duration"])})};class ff extends ro{constructor(t){super(t,{}),this.implementation=t;}is3D(){return "3d"===this.implementation.renderingMode}hasOffscreenPass(){return void 0!==this.implementation.prerender}isLayerDraped(){return void 0!==this.implementation.renderToTile}shouldRedrape(){return !!this.implementation.shouldRerenderTiles&&this.implementation.shouldRerenderTiles()}recalculate(){}updateTransitions(){}hasTransition(){return !1}serialize(){}onAdd(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl);}onRemove(t){this.implementation.onRemove&&this.implementation.onRemove(t,t.painter.context.gl);}}var yf={paint:new Ps({"sky-type":new Bs(te.paint_sky["sky-type"]),"sky-atmosphere-sun":new Bs(te.paint_sky["sky-atmosphere-sun"]),"sky-atmosphere-sun-intensity":new Bs(te.paint_sky["sky-atmosphere-sun-intensity"]),"sky-gradient-center":new Bs(te.paint_sky["sky-gradient-center"]),"sky-gradient-radius":new Bs(te.paint_sky["sky-gradient-radius"]),"sky-gradient":new Cs(te.paint_sky["sky-gradient"]),"sky-atmosphere-halo-color":new Bs(te.paint_sky["sky-atmosphere-halo-color"]),"sky-atmosphere-color":new Bs(te.paint_sky["sky-atmosphere-color"]),"sky-opacity":new Bs(te.paint_sky["sky-opacity"])})};function mf(t,e,r){const n=[0,0,1],i=Ko([]);return Jo(i,i,r?-w(t)+Math.PI:w(t)),Xo(i,i,-w(e)),Ro(n,n,i),Do(n,n)}const gf={circle:class extends ro{constructor(t){super(t,Tu);}createBucket(t){return new cu(t)}queryRadius(t){const e=t;return Au("circle-radius",this,e)+Au("circle-stroke-width",this,e)+Su(this.paint.get("circle-translate"))}queryIntersectsFeature(t,e,r,n,i,s,a,o){const l=Iu(this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),s.angle,t.pixelToTileUnitsFactor),u=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r);return zu(t,n,s,a,o,"map"===this.paint.get("circle-pitch-alignment"),"map"===this.paint.get("circle-pitch-scale"),l,u)}getProgramIds(){return ["circle"]}getProgramConfiguration(t){return new Xa(this,t)}},heatmap:class extends ro{createBucket(t){return new Du(t)}constructor(t){super(t,$u),this._updateColorRamp();}_handleSpecialPaintPropertyUpdate(t){"heatmap-color"===t&&this._updateColorRamp();}_updateColorRamp(){this.colorRamp=ju({expression:this._transitionablePaint._values["heatmap-color"].value.expression,evaluationKey:"heatmapDensity",image:this.colorRamp}),this.colorRampTexture=null;}resize(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);}queryRadius(t){return Au("heatmap-radius",this,t)}queryIntersectsFeature(t,e,r,n,i,s,a,o){const l=this.paint.get("heatmap-radius").evaluate(e,r);return zu(t,n,s,a,o,!0,!0,new x(0,0),l)}hasOffscreenPass(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility}getProgramIds(){return ["heatmap","heatmapTexture"]}getProgramConfiguration(t){return new Xa(this,t)}},hillshade:class extends ro{constructor(t){super(t,Ou);}hasOffscreenPass(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility}getProgramIds(){return ["hillshade","hillshadePrepare"]}},fill:class extends ro{constructor(t){super(t,zc);}getProgramIds(){const t=this.paint.get("fill-pattern"),e=t&&t.constantOr(1),r=[e?"fillPattern":"fill"];return this.paint.get("fill-antialias")&&r.push(e&&!this.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline"),r}getProgramConfiguration(t){return new Xa(this,t)}recalculate(t,e){super.recalculate(t,e);const r=this.paint._values["fill-outline-color"];"constant"===r.value.kind&&void 0===r.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);}createBucket(t){return new Mc(t)}queryRadius(){return Su(this.paint.get("fill-translate"))}queryIntersectsFeature(t,e,r,n,i,s){return !t.queryGeometry.isAboveHorizon&&du(ku(t.tilespaceGeometry,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),s.angle,t.pixelToTileUnitsFactor),n)}isTileClipped(){return !0}},"fill-extrusion":class extends ro{constructor(t){super(t,ch);}createBucket(t){return new th(t)}queryRadius(){return Su(this.paint.get("fill-extrusion-translate"))}is3D(){return !0}getProgramIds(){return [this.paint.get("fill-extrusion-pattern").constantOr(1)?"fillExtrusionPattern":"fillExtrusion"]}getProgramConfiguration(t){return new Xa(this,t)}queryIntersectsFeature(t,e,r,n,i,s,a,o,l){const u=Iu(this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),s.angle,t.pixelToTileUnitsFactor),c=this.paint.get("fill-extrusion-height").evaluate(e,r),h=this.paint.get("fill-extrusion-base").evaluate(e,r),p=[0,0],d=o&&s.elevation,f=s.elevation?s.elevation.exaggeration():1,y=t.tile.getBucket(this);if(d&&y instanceof th){const t=y.centroidVertexArray,e=l+1;e<t.length&&(p[0]=t.geta_centroid_pos0(e),p[1]=t.geta_centroid_pos1(e));}if(0===p[0]&&1===p[1])return !1;"globe"===s.projection.name&&(n=lh([n],[new x(0,0),new x(ao,ao)],t.tileID.canonical).map((t=>t.polygon)).flat());const m=d?o:null,[g,v]=function(t,e,r,n,i,s,a,o,l,u,c){return "globe"===t.projection.name?function(t,e,r,n,i,s,a,o,l,u,c){const h=[],p=[],d=t.projection.upVectorScale(c,t.center.lat,t.worldSize).metersToTile,f=[0,0,0,1],y=[0,0,0,1],m=(t,e,r,n)=>{t[0]=e,t[1]=r,t[2]=n,t[3]=1;},g=oh();r>0&&(r+=g),n+=g;for(const g of e){const e=[],x=[];for(const h of g){const p=h.x+i.x,g=h.y+i.y,v=t.projection.projectTilePoint(p,g,c),b=t.projection.upVector(c,h.x,h.y);let w=r,_=n;if(a){const t=vh(p,g,r,n,a,o,l,u);w+=t.base,_+=t.top;}0!==r?m(f,v.x+b[0]*d*w,v.y+b[1]*d*w,v.z+b[2]*d*w):m(f,v.x,v.y,v.z),m(y,v.x+b[0]*d*_,v.y+b[1]*d*_,v.z+b[2]*d*_),Fo(f,f,s),Fo(y,y,s),e.push(new mh(f[0],f[1],f[2])),x.push(new mh(y[0],y[1],y[2]));}h.push(e),p.push(x);}return [h,p]}(t,e,r,n,i,s,a,o,l,u,c):a?function(t,e,r,n,i,s,a,o,l){const u=[],c=[],h=[0,0,0,1];for(const p of t){const t=[],d=[];for(const u of p){const c=u.x+n.x,p=u.y+n.y,f=vh(c,p,e,r,s,a,o,l);h[0]=c,h[1]=p,h[2]=f.base,h[3]=1,Go(h,h,i),h[3]=Math.max(h[3],1e-5);const y=new mh(h[0]/h[3],h[1]/h[3],h[2]/h[3]);h[0]=c,h[1]=p,h[2]=f.top,h[3]=1,Go(h,h,i),h[3]=Math.max(h[3],1e-5);const m=new mh(h[0]/h[3],h[1]/h[3],h[2]/h[3]);t.push(y),d.push(m);}u.push(t),c.push(d);}return [u,c]}(e,r,n,i,s,a,o,l,u):function(t,e,r,n,i){const s=[],a=[],o=i[8]*e,l=i[9]*e,u=i[10]*e,c=i[11]*e,h=i[8]*r,p=i[9]*r,d=i[10]*r,f=i[11]*r;for(const e of t){const t=[],r=[];for(const s of e){const e=s.x+n.x,a=s.y+n.y,y=i[0]*e+i[4]*a+i[12],m=i[1]*e+i[5]*a+i[13],g=i[2]*e+i[6]*a+i[14],x=i[3]*e+i[7]*a+i[15],v=y+o,b=m+l,w=g+u,_=Math.max(x+c,1e-5),A=y+h,S=m+p,k=g+d,I=Math.max(x+f,1e-5);t.push(new mh(v/_,b/_,w/_)),r.push(new mh(A/I,S/I,k/I));}s.push(t),a.push(r);}return [s,a]}(e,r,n,i,s)}(s,n,h,c,u,a,m,p,f,s.center.lat,t.tileID.canonical),b=t.queryGeometry;return function(t,e,r){let n=1/0;du(r,e)&&(n=xh(r,e[0]));for(let i=0;i<e.length;i++){const s=e[i],a=t[i];for(let t=0;t<s.length-1;t++){const e=s[t],i=[e,s[t+1],a[t+1],a[t],e];hu(r,i)&&(n=Math.min(n,xh(r,i)));}}return n!==1/0&&n}(g,v,b.isPointQuery()?b.screenBounds:b.screenGeometry)}},line:class extends ro{constructor(t){super(t,Th),this.gradientVersion=0;}_handleSpecialPaintPropertyUpdate(t){if("line-gradient"===t){const t=this._transitionablePaint._values["line-gradient"].value.expression;this.stepInterpolant=t._styleExpression&&t._styleExpression.expression instanceof Br,this.gradientVersion=(this.gradientVersion+1)%Number.MAX_SAFE_INTEGER;}}gradientExpression(){return this._transitionablePaint._values["line-gradient"].value.expression}widthExpression(){return this._transitionablePaint._values["line-width"].value.expression}recalculate(t,e){super.recalculate(t,e),this.paint._values["line-floorwidth"]=zh.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,t);}createBucket(t){return new Ih(t)}getProgramIds(){return [this.paint.get("line-pattern").constantOr(1)?"linePattern":"line"]}getProgramConfiguration(t){return new Xa(this,t)}queryRadius(t){const e=t,r=Bh(Au("line-width",this,e),Au("line-gap-width",this,e)),n=Au("line-offset",this,e);return r/2+Math.abs(n)+Su(this.paint.get("line-translate"))}queryIntersectsFeature(t,e,r,n,i,s){if(t.queryGeometry.isAboveHorizon)return !1;const a=ku(t.tilespaceGeometry,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),s.angle,t.pixelToTileUnitsFactor),o=t.pixelToTileUnitsFactor/2*Bh(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),l=this.paint.get("line-offset").evaluate(e,r);return l&&(n=function(t,e){const r=[],n=new x(0,0);for(let i=0;i<t.length;i++){const s=t[i],a=[];for(let t=0;t<s.length;t++){const r=s[t],i=s[t+1],o=0===t?n:r.sub(s[t-1])._unit()._perp(),l=t===s.length-1?n:i.sub(r)._unit()._perp(),u=o._add(l)._unit();u._mult(1/(u.x*l.x+u.y*l.y)),a.push(u._mult(e)._add(r));}r.push(a);}return r}(n,l*t.pixelToTileUnitsFactor)),function(t,e,r){for(let n=0;n<e.length;n++){const i=e[n];if(t.length>=3)for(let e=0;e<i.length;e++)if(bu(t,i[e]))return !0;if(fu(t,i,r))return !0}return !1}(a,n,o)}isTileClipped(){return !0}},symbol:hf,background:class extends ro{constructor(t){super(t,pf);}getProgramIds(){return [this.paint.get("background-pattern")?"backgroundPattern":"background"]}},raster:class extends ro{constructor(t){super(t,df);}getProgramIds(){return ["raster"]}},sky:class extends ro{constructor(t){super(t,yf),this._updateColorRamp();}_handleSpecialPaintPropertyUpdate(t){"sky-gradient"===t?this._updateColorRamp():"sky-atmosphere-sun"!==t&&"sky-atmosphere-halo-color"!==t&&"sky-atmosphere-color"!==t&&"sky-atmosphere-sun-intensity"!==t||(this._skyboxInvalidated=!0);}_updateColorRamp(){this.colorRamp=ju({expression:this._transitionablePaint._values["sky-gradient"].value.expression,evaluationKey:"skyRadialProgress"}),this.colorRampTexture&&(this.colorRampTexture.destroy(),this.colorRampTexture=null);}needsSkyboxCapture(t){if(this._skyboxInvalidated||!this.skyboxTexture||!this.skyboxGeometry)return !0;if(!this.paint.get("sky-atmosphere-sun")){const e=t.style.light.properties.get("position");return this._lightPosition.azimuthal!==e.azimuthal||this._lightPosition.polar!==e.polar}return !1}getCenter(t,e){if("atmosphere"===this.paint.get("sky-type")){const r=this.paint.get("sky-atmosphere-sun"),n=!r,i=t.style.light,s=i.properties.get("position");return n&&"viewport"===i.properties.get("anchor")&&N("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."),n?mf(s.azimuthal,90-s.polar,e):mf(r[0],90-r[1],e)}const r=this.paint.get("sky-gradient-center");return mf(r[0],90-r[1],e)}is3D(){return !1}isSky(){return !0}markSkyboxValid(t){this._skyboxInvalidated=!1,this._lightPosition=t.style.light.properties.get("position");}hasOffscreenPass(){return !0}getProgramIds(){const t=this.paint.get("sky-type");return "atmosphere"===t?["skyboxCapture","skybox"]:"gradient"===t?["skyboxGradient"]:null}}};class xf{constructor(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);}update(t,r,n){const{width:i,height:s}=t,{context:a}=this,{gl:o}=a,{HTMLImageElement:l,HTMLCanvasElement:u,HTMLVideoElement:c,ImageData:h,ImageBitmap:p}=e;if(o.bindTexture(o.TEXTURE_2D,this.texture),a.pixelStoreUnpackFlipY.set(!1),a.pixelStoreUnpack.set(1),a.pixelStoreUnpackPremultiplyAlpha.set(this.format===o.RGBA&&(!r||!1!==r.premultiply)),n||this.size&&this.size[0]===i&&this.size[1]===s){const{x:e,y:r}=n||{x:0,y:0};t instanceof l||t instanceof u||t instanceof c||t instanceof h||p&&t instanceof p?o.texSubImage2D(o.TEXTURE_2D,0,e,r,o.RGBA,o.UNSIGNED_BYTE,t):o.texSubImage2D(o.TEXTURE_2D,0,e,r,i,s,o.RGBA,o.UNSIGNED_BYTE,t.data);}else this.size=[i,s],t instanceof l||t instanceof u||t instanceof c||t instanceof h||p&&t instanceof p?o.texImage2D(o.TEXTURE_2D,0,this.format,this.format,o.UNSIGNED_BYTE,t):o.texImage2D(o.TEXTURE_2D,0,this.format,i,s,0,this.format,o.UNSIGNED_BYTE,t.data);this.useMipmap=Boolean(r&&r.useMipmap&&this.isSizePowerOfTwo()),this.useMipmap&&o.generateMipmap(o.TEXTURE_2D);}bind(t,e){const{context:r}=this,{gl:n}=r;n.bindTexture(n.TEXTURE_2D,this.texture),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,this.useMipmap?t===n.NEAREST?n.NEAREST_MIPMAP_NEAREST:n.LINEAR_MIPMAP_NEAREST:t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);}isSizePowerOfTwo(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0}destroy(){const{gl:t}=this.context;t.deleteTexture(this.texture),this.texture=null;}}class vf{constructor(t){this._callback=t,this._triggered=!1,"undefined"!=typeof MessageChannel&&(this._channel=new MessageChannel,this._channel.port2.onmessage=()=>{this._triggered=!1,this._callback();});}trigger(){this._triggered||(this._triggered=!0,this._channel?this._channel.port1.postMessage(!0):setTimeout((()=>{this._triggered=!1,this._callback();}),0));}remove(){this._channel=void 0,this._callback=()=>{};}}class bf{constructor(){this.tasks={},this.taskQueue=[],R(["process"],this),this.invoker=new vf(this.process),this.nextId=0;}add(t,e){const r=this.nextId++,n=function({type:t,isSymbolTile:e,zoom:r}){return r=r||0,"message"===t?0:"maybePrepare"!==t||e?"parseTile"!==t||e?"parseTile"===t&&e?300-r:"maybePrepare"===t&&e?400-r:500:200-r:100-r}(e);if(0===n){K();try{t();}finally{}return {cancel:()=>{}}}return this.tasks[r]={fn:t,metadata:e,priority:n,id:r},this.taskQueue.push(r),this.invoker.trigger(),{cancel:()=>{delete this.tasks[r];}}}process(){K();try{if(this.taskQueue=this.taskQueue.filter((t=>!!this.tasks[t])),!this.taskQueue.length)return;const t=this.pick();if(null===t)return;const e=this.tasks[t];if(delete this.tasks[t],this.taskQueue.length&&this.invoker.trigger(),!e)return;e.fn();}finally{}}pick(){let t=null,e=1/0;for(let r=0;r<this.taskQueue.length;r++){const n=this.tasks[this.taskQueue[r]];n.priority<e&&(e=n.priority,t=r);}if(null===t)return null;const r=this.taskQueue[t];return this.taskQueue.splice(t,1),r}remove(){this.invoker.remove();}}class wf{constructor(t){this._stringToNumber={},this._numberToString=[];for(let e=0;e<t.length;e++){const r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}}encode(t){return this._stringToNumber[t]}decode(t){return this._numberToString[t]}}const _f=["tile","layer","source","sourceLayer","state"];class Af{constructor(t,e,r,n,i){this.type="Feature",this._vectorTileFeature=t,this._z=e,this._x=r,this._y=n,this.properties=t.properties,this.id=i;}get geometry(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._x,this._y,this._z).geometry),this._geometry}set geometry(t){this._geometry=t;}toJSON(){const t={type:"Feature",state:void 0,geometry:this.geometry,properties:this.properties};void 0!==this.id&&(t.id=this.id);for(const e of _f)void 0!==this[e]&&(t[e]=this[e]);return t}}const Sf=32,kf=33,If=new Uint16Array(8184);for(let t=0;t<2046;t++){let e=t+2,r=0,n=0,i=0,s=0,a=0,o=0;for(1&e?i=s=a=Sf:r=n=o=Sf;(e>>=1)>1;){const t=r+i>>1,l=n+s>>1;1&e?(i=r,s=n,r=a,n=o):(r=i,n=s,i=a,s=o),a=t,o=l;}const l=4*t;If[l+0]=r,If[l+1]=n,If[l+2]=i,If[l+3]=s;}const Mf=new Uint16Array(2178),Tf=new Uint8Array(1089),zf=new Uint16Array(1089);function Bf(t){return 0===t?-.03125:32===t?.03125:0}var Ef=Rs([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]);const Cf={type:2,extent:ao,loadGeometry:()=>[[new x(0,0),new x(ao+1,0),new x(ao+1,ao+1),new x(0,ao+1),new x(0,0)]]};class Pf{constructor(t,e,r,n,i){this.tileID=t,this.uid=D(),this.uses=0,this.tileSize=e,this.tileZoom=r,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.hasRTLText=!1,this.dependencies={},this.isRaster=i,this.expiredRequestCount=0,this.state="loading",n&&n.transform&&(this.projection=n.transform.projection);}registerFadeDuration(t){const e=t+this.timeAdded;e<Xt.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);}wasRequested(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state}get tileTransform(){return this._tileTransform||(this._tileTransform=Bd(this.tileID.canonical,this.projection)),this._tileTransform}loadVectorData(t,e,r){if(this.unloadVectorData(),this.state="loaded",t){t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){const r={};if(!e)return r;for(const n of t){const t=n.layerIds.map((t=>e.getLayer(t))).filter(Boolean);if(0!==t.length){n.layers=t,n.stateDependentLayerIds&&(n.stateDependentLayers=n.stateDependentLayerIds.map((e=>t.filter((t=>t.id===e))[0])));for(const e of t)r[e.id]=n;}}return r}(t.buckets,e.style),this.hasSymbolBuckets=!1;for(const t in this.buckets){const e=this.buckets[t];if(e instanceof of){if(this.hasSymbolBuckets=!0,!r)break;e.justReloaded=!0;}}if(this.hasRTLText=!1,this.hasSymbolBuckets)for(const t in this.buckets){const e=this.buckets[t];if(e instanceof of&&e.hasRTLText){this.hasRTLText=!0,bs.isLoading()||bs.isLoaded()||"deferred"!==xs()||vs();break}}this.queryPadding=0;for(const t in this.buckets){const r=this.buckets[t];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(t).queryRadius(r));}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage),t.lineAtlas&&(this.lineAtlas=t.lineAtlas);}else this.collisionBoxArray=new pa;}unloadVectorData(){if(this.hasData()){for(const t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlas&&(this.imageAtlas=null),this.lineAtlas&&(this.lineAtlas=null),this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.lineAtlasTexture&&this.lineAtlasTexture.destroy(),this._tileBoundsBuffer&&(this._tileBoundsBuffer.destroy(),this._tileBoundsIndexBuffer.destroy(),this._tileBoundsSegments.destroy(),this._tileBoundsBuffer=null),this._tileDebugBuffer&&(this._tileDebugBuffer.destroy(),this._tileDebugSegments.destroy(),this._tileDebugBuffer=null),this._tileDebugIndexBuffer&&(this._tileDebugIndexBuffer.destroy(),this._tileDebugIndexBuffer=null),this._globeTileDebugBorderBuffer&&(this._globeTileDebugBorderBuffer.destroy(),this._globeTileDebugBorderBuffer=null),this._tileDebugTextBuffer&&(this._tileDebugTextBuffer.destroy(),this._tileDebugTextSegments.destroy(),this._tileDebugTextIndexBuffer.destroy(),this._tileDebugTextBuffer=null),this._globeTileDebugTextBuffer&&(this._globeTileDebugTextBuffer.destroy(),this._globeTileDebugTextBuffer=null),this.latestFeatureIndex=null,this.state="unloaded";}}getBucket(t){return this.buckets[t.id]}upload(t){for(const e in this.buckets){const r=this.buckets[e];r.uploadPending()&&r.upload(t);}const e=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new xf(t,this.imageAtlas.image,e.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new xf(t,this.glyphAtlasImage,e.ALPHA),this.glyphAtlasImage=null),this.lineAtlas&&!this.lineAtlas.uploaded&&(this.lineAtlasTexture=new xf(t,this.lineAtlas.image,e.ALPHA),this.lineAtlas.uploaded=!0);}prepare(t){this.imageAtlas&&this.imageAtlas.patchUpdatedImages(t,this.imageAtlasTexture);}queryRenderedFeatures(t,e,r,n,i,s,a,o){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({tileResult:n,pixelPosMatrix:a,transform:s,params:i,tileTransform:this.tileTransform},t,e,r):{}}querySourceFeatures(t,e){const r=this.latestFeatureIndex;if(!r||!r.rawTileData)return;const n=r.loadVTLayers(),i=e?e.sourceLayer:"",s=n._geojsonTileLayer||n[i];if(!s)return;const a=hi(e&&e.filter),{z:o,x:l,y:u}=this.tileID.canonical,c={z:o,x:l,y:u};for(let e=0;e<s.length;e++){const n=s.feature(e);if(a.needGeometry){const t=ou(n,!0);if(!a.filter(new ws(this.tileID.overscaledZ),t,this.tileID.canonical))continue}else if(!a.filter(new ws(this.tileID.overscaledZ),n))continue;const h=r.getId(n,i),p=new Af(n,o,l,u,h);p.tile=c,t.push(p);}}hasData(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state}patternsLoaded(){return !!this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length}setExpiryData(t){const e=this.expirationTime;if(t.cacheControl){const e=X(t.cacheControl);e["max-age"]&&(this.expirationTime=Date.now()+1e3*e["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){const t=Date.now();let r=!1;if(this.expirationTime>t)r=!1;else if(e)if(this.expirationTime<e)r=!0;else {const n=this.expirationTime-e;n?this.expirationTime=t+Math.max(n,3e4):r=!0;}else r=!0;r?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}}getExpiryTimeout(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)}setFeatureState(t,e){if(!this.latestFeatureIndex||!this.latestFeatureIndex.rawTileData||0===Object.keys(t).length||!e)return;const r=this.latestFeatureIndex.loadVTLayers(),n=e.style.listImages();for(const i in this.buckets){if(!e.style.hasLayer(i))continue;const s=this.buckets[i],a=s.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],l=t[a];if(!o||!l||0===Object.keys(l).length)continue;if(s.update(l,o,n,this.imageAtlas&&this.imageAtlas.patternPositions||{}),s instanceof Ih||s instanceof Mc){const t=e.style._getSourceCache(s.layers[0].source);e._terrain&&e._terrain.enabled&&t&&s.programConfigurations.needsUpload&&e._terrain._clearRenderCacheForTile(t.id,this.tileID);}const u=e&&e.style&&e.style.getLayer(i);u&&(this.queryPadding=Math.max(this.queryPadding,u.queryRadius(s)));}}holdingForFade(){return void 0!==this.symbolFadeHoldUntil}symbolFadeFinished(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<Xt.now()}clearFadeHold(){this.symbolFadeHoldUntil=void 0;}setHoldDuration(t){this.symbolFadeHoldUntil=Xt.now()+t;}setTexture(t,e){const r=e.context,n=r.gl;this.texture=this.texture||e.getTileTexture(t.width),this.texture?this.texture.update(t,{useMipmap:!0}):(this.texture=new xf(r,t,n.RGBA,{useMipmap:!0}),this.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE));}setDependencies(t,e){const r={};for(const t of e)r[t]=!0;this.dependencies[t]=r;}hasDependency(t,e){for(const r of t){const t=this.dependencies[r];if(t)for(const r of e)if(t[r])return !0}return !1}clearQueryDebugViz(){}_makeDebugTileBoundsBuffers(t,e){if(!e||"mercator"===e.name||this._tileDebugBuffer)return;const r=au(Cf,this.tileID.canonical,this.tileTransform)[0],n=new $s,i=new ua;for(let t=0;t<r.length;t++){const{x:e,y:s}=r[t];n.emplaceBack(e,s),i.emplaceBack(t);}i.emplaceBack(0),this._tileDebugIndexBuffer=t.createIndexBuffer(i),this._tileDebugBuffer=t.createVertexBuffer(n,tl.members),this._tileDebugSegments=so.simpleSegment(0,0,n.length,i.length);}_makeTileBoundsBuffers(t,e){if(this._tileBoundsBuffer||!e||"mercator"===e.name)return;const r=au(Cf,this.tileID.canonical,this.tileTransform)[0];let n,i;if(this.isRaster){const t=function(t,e){const r=Bd(t,e),n=Math.pow(2,t.z);for(let i=0;i<kf;i++)for(let s=0;s<kf;s++){const a=Kl((t.x+(s+Bf(s))/Sf)/n),o=Xl((t.y+(i+Bf(i))/Sf)/n),l=e.project(a,o),u=i*kf+s;Mf[2*u+0]=Math.round((l.x*r.scale-r.x)*ao),Mf[2*u+1]=Math.round((l.y*r.scale-r.y)*ao);}Tf.fill(0),zf.fill(0);for(let t=2045;t>=0;t--){const e=4*t,r=If[e+0],n=If[e+1],i=If[e+2],s=If[e+3],a=r+i>>1,o=n+s>>1,l=a+o-n,u=o+r-a,c=n*kf+r,h=s*kf+i,p=o*kf+a,d=Math.hypot((Mf[2*c+0]+Mf[2*h+0])/2-Mf[2*p+0],(Mf[2*c+1]+Mf[2*h+1])/2-Mf[2*p+1])>=16;Tf[p]=Tf[p]||(d?1:0),t<1022&&(Tf[p]=Tf[p]||Tf[(n+u>>1)*kf+(r+l>>1)]||Tf[(s+u>>1)*kf+(i+l>>1)]);}const i=new Os,s=new ra;let a=0;function o(t,e){const r=e*kf+t;return 0===zf[r]&&(i.emplaceBack(Mf[2*r+0],Mf[2*r+1],t*ao/Sf,e*ao/Sf),zf[r]=++a),zf[r]-1}function l(t,e,r,n,i,a){const u=t+r>>1,c=e+n>>1;if(Math.abs(t-i)+Math.abs(e-a)>1&&Tf[c*kf+u])l(i,a,t,e,u,c),l(r,n,i,a,u,c);else {const l=o(t,e),u=o(r,n),c=o(i,a);s.emplaceBack(l,u,c);}}return l(0,0,Sf,Sf,Sf,0),l(Sf,Sf,0,0,0,Sf),{vertices:i,indices:s}}(this.tileID.canonical,e);n=t.vertices,i=t.indices;}else {n=new Os,i=new ra;for(const{x:t,y:e}of r)n.emplaceBack(t,e,0,0);const t=xc(n.int16,void 0,4);for(let e=0;e<t.length;e+=3)i.emplaceBack(t[e],t[e+1],t[e+2]);}this._tileBoundsBuffer=t.createVertexBuffer(n,Ef.members),this._tileBoundsIndexBuffer=t.createIndexBuffer(i),this._tileBoundsSegments=so.simpleSegment(0,0,n.length,i.length);}_makeGlobeTileDebugBuffers(t,e){const r=e.projection;if(!r||"globe"!==r.name||e.freezeTileCoverage)return;const n=this.tileID.canonical,i=Bl(bl(n,e)),s=Pl(e.zoom);let a;s>0&&(a=fo(new Float64Array(16),e.globeMatrix)),this._makeGlobeTileDebugBorderBuffer(t,n,e,i,a,s),this._makeGlobeTileDebugTextBuffer(t,n,e,i,a,s);}_globePoint(t,e,r,n,i,s,a){let o=Ml(t,e,r);if(s){const i=1<<r.z,l=Nl(n.center.lng),u=Gl(n.center.lat),c=(r.x+.5)/i-l;let h=0;c>.5?h=-1:c<-.5&&(h=1);let p=(t/ao+r.x)/i+h,d=(e/ao+r.y)/i;p=(p-l)*n._pixelsPerMercatorPixel+l,d=(d-u)*n._pixelsPerMercatorPixel+u;const f=[p*n.worldSize,d*n.worldSize,0];Fo(f,f,s),o=vl(o,f,a);}return Fo(o,o,i)}_makeGlobeTileDebugBorderBuffer(t,e,r,n,i,s){const a=new $s,o=new ua,l=new js,u=(t,u,c,h,p)=>{const d=(c-t)/(p-1),f=(h-u)/(p-1),y=a.length;for(let c=0;c<p;c++){const h=t+c*d,p=u+c*f;a.emplaceBack(h,p);const m=this._globePoint(h,p,e,r,n,i,s);l.emplaceBack(m[0],m[1],m[2]),o.emplaceBack(y+c);}},c=ao;u(0,0,c,0,16),u(c,0,c,c,16),u(c,c,0,c,16),u(0,c,0,0,16),this._tileDebugIndexBuffer=t.createIndexBuffer(o),this._tileDebugBuffer=t.createVertexBuffer(a,tl.members),this._globeTileDebugBorderBuffer=t.createVertexBuffer(l,Qo.members),this._tileDebugSegments=so.simpleSegment(0,0,a.length,o.length);}_makeGlobeTileDebugTextBuffer(t,e,r,n,i,s){const a=ao/4,o=new $s,l=new ra,u=new js,c=25;l.reserve(32),o.reserve(c),u.reserve(c);const h=(t,e)=>c*t+e;for(let t=0;t<c;t++){const l=t*a;for(let t=0;t<c;t++){const c=t*a;o.emplaceBack(c,l);const h=this._globePoint(c,l,e,r,n,i,s);u.emplaceBack(h[0],h[1],h[2]);}}for(let t=0;t<4;t++)for(let e=0;e<4;e++){const r=h(t,e),n=h(t,e+1),i=h(t+1,e),s=h(t+1,e+1);l.emplaceBack(r,n,i),l.emplaceBack(i,n,s);}this._tileDebugTextIndexBuffer=t.createIndexBuffer(l),this._tileDebugTextBuffer=t.createVertexBuffer(o,tl.members),this._globeTileDebugTextBuffer=t.createVertexBuffer(u,Qo.members),this._tileDebugTextSegments=so.simpleSegment(0,0,c,32);}}class Df{constructor(){this.state={},this.stateChanges={},this.deletedStates={};}updateState(t,e,r){const n=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][n]=this.stateChanges[t][n]||{},C(this.stateChanges[t][n],r),null===this.deletedStates[t]){this.deletedStates[t]={};for(const e in this.state[t])e!==n&&(this.deletedStates[t][e]=null);}else if(this.deletedStates[t]&&null===this.deletedStates[t][n]){this.deletedStates[t][n]={};for(const e in this.state[t][n])r[e]||(this.deletedStates[t][n][e]=null);}else for(const e in r)this.deletedStates[t]&&this.deletedStates[t][n]&&null===this.deletedStates[t][n][e]&&delete this.deletedStates[t][n][e];}removeFeatureState(t,e,r){if(null===this.deletedStates[t])return;const n=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},r&&void 0!==e)null!==this.deletedStates[t][n]&&(this.deletedStates[t][n]=this.deletedStates[t][n]||{},this.deletedStates[t][n][r]=null);else if(void 0!==e)if(this.stateChanges[t]&&this.stateChanges[t][n])for(r in this.deletedStates[t][n]={},this.stateChanges[t][n])this.deletedStates[t][n][r]=null;else this.deletedStates[t][n]=null;else this.deletedStates[t]=null;}getState(t,e){const r=String(e),n=C({},(this.state[t]||{})[r],(this.stateChanges[t]||{})[r]);if(null===this.deletedStates[t])return {};if(this.deletedStates[t]){const r=this.deletedStates[t][e];if(null===r)return {};for(const t in r)delete n[t];}return n}initializeTileState(t,e){t.setFeatureState(this.state,e);}coalesceChanges(t,e){const r={};for(const t in this.stateChanges){this.state[t]=this.state[t]||{};const e={};for(const r in this.stateChanges[t])this.state[t][r]||(this.state[t][r]={}),C(this.state[t][r],this.stateChanges[t][r]),e[r]=this.state[t][r];r[t]=e;}for(const t in this.deletedStates){this.state[t]=this.state[t]||{};const e={};if(null===this.deletedStates[t])for(const r in this.state[t])e[r]={},this.state[t][r]={};else for(const r in this.deletedStates[t]){if(null===this.deletedStates[t][r])this.state[t][r]={};else if(this.state[t][r])for(const e of Object.keys(this.deletedStates[t][r]))delete this.state[t][r][e];e[r]=this.state[t][r];}r[t]=r[t]||{},C(r[t],e);}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(r).length)for(const n in t)t[n].setFeatureState(r,e);}}class Vf{constructor(t){this.size=t,this.minimums=[],this.maximums=[],this.leaves=[];}getElevation(t,e){const r=this.toIdx(t,e);return {min:this.minimums[r],max:this.maximums[r]}}isLeaf(t,e){return this.leaves[this.toIdx(t,e)]}toIdx(t,e){return e*this.size+t}}function Lf(t,e,r,n){let i=0,s=Number.MAX_VALUE;for(let a=0;a<3;a++)if(Math.abs(n[a])<1e-15){if(r[a]<t[a]||r[a]>e[a])return null}else {const o=1/n[a];let l=(t[a]-r[a])*o,u=(e[a]-r[a])*o;if(l>u){const t=l;l=u,u=t;}if(l>i&&(i=l),u<s&&(s=u),i>s)return null}return i}function Ff(t,e,r,n,i,s,a,o,l,u,c){const h=n-t,p=i-e,d=s-r,f=a-t,y=o-e,m=l-r,g=c[1]*m-c[2]*y,x=c[2]*f-c[0]*m,v=c[0]*y-c[1]*f,b=h*g+p*x+d*v;if(Math.abs(b)<1e-15)return null;const w=1/b,_=u[0]-t,A=u[1]-e,S=u[2]-r,k=(_*g+A*x+S*v)*w;if(k<0||k>1)return null;const I=A*d-S*p,M=S*h-_*d,T=_*p-A*h,z=(c[0]*I+c[1]*M+c[2]*T)*w;return z<0||k+z>1?null:(f*I+y*M+m*T)*w}function Rf(t,e,r){return (t-e)/(r-e)}function Uf(t,e,r,n,i,s,a,o,l){const u=1<<r,c=s-n,h=a-i,p=(t+1)/u*c+n,d=(e+0)/u*h+i,f=(e+1)/u*h+i;o[0]=(t+0)/u*c+n,o[1]=d,l[0]=p,l[1]=f;}class $f{constructor(t){if(this.maximums=[],this.minimums=[],this.leaves=[],this.childOffsets=[],this.nodeCount=0,this.dem=t,this._siblingOffset=[[0,0],[1,0],[0,1],[1,1]],!this.dem)return;const e=function(t){const e=Math.ceil(Math.log2(t.dim/8)),r=[];let n=Math.ceil(Math.pow(2,e));const i=1/n,s=(t,e,r,n,i)=>{const s=n?1:0,a=(t+1)*r-s,o=e*r,l=(e+1)*r-s;i[0]=t*r,i[1]=o,i[2]=a,i[3]=l;};let a=new Vf(n);const o=[];for(let e=0;e<n*n;e++){s(e%n,Math.floor(e/n),i,!1,o);const r=Of(o[0],o[1],t),l=Of(o[2],o[1],t),u=Of(o[2],o[3],t),c=Of(o[0],o[3],t);a.minimums.push(Math.min(r,l,u,c)),a.maximums.push(Math.max(r,l,u,c)),a.leaves.push(1);}for(r.push(a),n/=2;n>=1;n/=2){const t=r[r.length-1];a=new Vf(n);for(let e=0;e<n*n;e++){s(e%n,Math.floor(e/n),2,!0,o);const r=t.getElevation(o[0],o[1]),i=t.getElevation(o[2],o[1]),l=t.getElevation(o[2],o[3]),u=t.getElevation(o[0],o[3]),c=t.isLeaf(o[0],o[1]),h=t.isLeaf(o[2],o[1]),p=t.isLeaf(o[2],o[3]),d=t.isLeaf(o[0],o[3]),f=Math.min(r.min,i.min,l.min,u.min),y=Math.max(r.max,i.max,l.max,u.max),m=c&&h&&p&&d;a.maximums.push(y),a.minimums.push(f),a.leaves.push(y-f<=5&&m?1:0);}r.push(a);}return r}(this.dem),r=e.length-1,n=e[r];this._addNode(n.minimums[0],n.maximums[0],n.leaves[0]),this._construct(e,0,0,r,0);}raycastRoot(t,e,r,n,i,s,a=1){return Lf([t,e,-100],[r,n,this.maximums[0]*a],i,s)}raycast(t,e,r,n,i,s,a=1){if(!this.nodeCount)return null;const o=this.raycastRoot(t,e,r,n,i,s,a);if(null==o)return null;const l=[],u=[],c=[],h=[],p=[{idx:0,t:o,nodex:0,nodey:0,depth:0}];for(;p.length>0;){const{idx:o,t:d,nodex:f,nodey:y,depth:m}=p.pop();if(this.leaves[o]){Uf(f,y,m,t,e,r,n,c,h);const o=1<<m,l=(f+0)/o,u=(f+1)/o,p=(y+0)/o,g=(y+1)/o,x=Of(l,p,this.dem)*a,v=Of(u,p,this.dem)*a,b=Of(u,g,this.dem)*a,w=Of(l,g,this.dem)*a,_=Ff(c[0],c[1],x,h[0],c[1],v,h[0],h[1],b,i,s),A=Ff(h[0],h[1],b,c[0],h[1],w,c[0],c[1],x,i,s),S=Math.min(null!==_?_:Number.MAX_VALUE,null!==A?A:Number.MAX_VALUE);if(S!==Number.MAX_VALUE)return S;{const t=Po([],i,s,d);if(jf(x,v,w,b,Rf(t[0],c[0],h[0]),Rf(t[1],c[1],h[1]))>=t[2])return d}continue}let g=0;for(let p=0;p<this._siblingOffset.length;p++){Uf((f<<1)+this._siblingOffset[p][0],(y<<1)+this._siblingOffset[p][1],m+1,t,e,r,n,c,h),c[2]=-100,h[2]=this.maximums[this.childOffsets[o]+p]*a;const d=Lf(c,h,i,s);if(null!=d){const t=d;l[p]=t;let e=!1;for(let r=0;r<g&&!e;r++)t>=l[u[r]]&&(u.splice(r,0,p),e=!0);e||(u[g]=p),g++;}}for(let t=0;t<g;t++){const e=u[t];p.push({idx:this.childOffsets[o]+e,t:l[e],nodex:(f<<1)+this._siblingOffset[e][0],nodey:(y<<1)+this._siblingOffset[e][1],depth:m+1});}}return null}_addNode(t,e,r){return this.minimums.push(t),this.maximums.push(e),this.leaves.push(r),this.childOffsets.push(0),this.nodeCount++}_construct(t,e,r,n,i){if(1===t[n].isLeaf(e,r))return;this.childOffsets[i]||(this.childOffsets[i]=this.nodeCount);const s=n-1,a=t[s];let o=0,l=0;for(let t=0;t<this._siblingOffset.length;t++){const n=2*e+this._siblingOffset[t][0],i=2*r+this._siblingOffset[t][1],s=a.getElevation(n,i),u=a.isLeaf(n,i),c=this._addNode(s.min,s.max,u);u&&(o|=1<<t),l||(l=c);}for(let n=0;n<this._siblingOffset.length;n++)o&1<<n||this._construct(t,2*e+this._siblingOffset[n][0],2*r+this._siblingOffset[n][1],s,l+n);}}function jf(t,e,r,n,i,s){return Er(Er(t,r,s),Er(e,n,s),i)}function Of(t,e,r){const n=r.dim,i=M(t*n-.5,0,n-1),s=M(e*n-.5,0,n-1),a=Math.floor(i),o=Math.floor(s),l=Math.min(a+1,n-1),u=Math.min(o+1,n-1);return jf(r.get(a,o),r.get(l,o),r.get(a,u),r.get(l,u),i-a,s-o)}const qf={mapbox:[6553.6,25.6,.1,1e4],terrarium:[256,1,1/256,32768]};function Nf(t,e,r){return (256*t*256+256*e+r)/10-1e4}function Gf(t,e,r){return 256*t+e+r/256-32768}class Zf{get tree(){return this._tree||this._buildQuadTree(),this._tree}constructor(t,e,r,n=!1,i=!1){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return N(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);this.stride=e.height;const s=this.dim=e.height-2,a=new Uint32Array(e.data.buffer);if(this.pixels=new Uint8Array(e.data.buffer),this.encoding=r||"mapbox",this.borderReady=n,!n){for(let t=0;t<s;t++)a[this._idx(-1,t)]=a[this._idx(0,t)],a[this._idx(s,t)]=a[this._idx(s-1,t)],a[this._idx(t,-1)]=a[this._idx(t,0)],a[this._idx(t,s)]=a[this._idx(t,s-1)];a[this._idx(-1,-1)]=a[this._idx(0,0)],a[this._idx(s,-1)]=a[this._idx(s-1,0)],a[this._idx(-1,s)]=a[this._idx(0,s-1)],a[this._idx(s,s)]=a[this._idx(s-1,s-1)],i&&this._buildQuadTree();}}_buildQuadTree(){this._tree=new $f(this);}get(t,e,r=!1){r&&(t=M(t,-1,this.dim),e=M(e,-1,this.dim));const n=4*this._idx(t,e);return ("terrarium"===this.encoding?Gf:Nf)(this.pixels[n],this.pixels[n+1],this.pixels[n+2])}static getUnpackVector(t){return qf[t]}get unpackVector(){return qf[this.encoding]}_idx(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return (e+1)*this.stride+(t+1)}static pack(t,e){const r=[0,0,0,0],n=Zf.getUnpackVector(e);let i=Math.floor((t+n[3])/n[2]);return r[2]=i%256,i=Math.floor(i/256),r[1]=i%256,i=Math.floor(i/256),r[0]=i,r}getPixels(){return new Uu({width:this.stride,height:this.stride},this.pixels)}backfillBorder(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");let n=e*this.dim,i=e*this.dim+this.dim,s=r*this.dim,a=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:s=a-1;break;case 1:a=s+1;}const o=-e*this.dim,l=-r*this.dim;for(let e=s;e<a;e++)for(let r=n;r<i;r++){const n=4*this._idx(r,e),i=4*this._idx(r+o,e+l);this.pixels[n+0]=t.pixels[i+0],this.pixels[n+1]=t.pixels[i+1],this.pixels[n+2]=t.pixels[i+2],this.pixels[n+3]=t.pixels[i+3];}}onDeserialize(){this._tree&&(this._tree.dem=this);}}Ji(Zf,"DEMData"),Ji($f,"DemMinMaxQuadTree",{omit:["dem"]});class Kf{constructor(t,e){this.max=t,this.onRemove=e,this.reset();}reset(){for(const t in this.data)for(const e of this.data[t])e.timeout&&clearTimeout(e.timeout),this.onRemove(e.value);return this.data={},this.order=[],this}add(t,e,r){const n=t.wrapped().key;void 0===this.data[n]&&(this.data[n]=[]);const i={value:e,timeout:void 0};if(void 0!==r&&(i.timeout=setTimeout((()=>{this.remove(t,i);}),r)),this.data[n].push(i),this.order.push(n),this.order.length>this.max){const t=this._getAndRemoveByKey(this.order[0]);t&&this.onRemove(t);}return this}has(t){return t.wrapped().key in this.data}getAndRemove(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null}_getAndRemoveByKey(t){const e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value}getByKey(t){const e=this.data[t];return e?e[0].value:null}get(t){return this.has(t)?this.data[t.wrapped().key][0].value:null}remove(t,e){if(!this.has(t))return this;const r=t.wrapped().key,n=void 0===e?0:this.data[r].indexOf(e),i=this.data[r][n];return this.data[r].splice(n,1),i.timeout&&clearTimeout(i.timeout),0===this.data[r].length&&delete this.data[r],this.onRemove(i.value),this.order.splice(this.order.indexOf(r),1),this}setMaxSize(t){for(this.max=t;this.order.length>this.max;){const t=this._getAndRemoveByKey(this.order[0]);t&&this.onRemove(t);}return this}filter(t){const e=[];for(const r in this.data)for(const n of this.data[r])t(n.value)||e.push(n);for(const t of e)this.remove(t.value.tileID,t);}}class Xf{constructor(t,e,r){this.func=t,this.mask=e,this.range=r;}}Xf.ReadOnly=!1,Xf.ReadWrite=!0,Xf.disabled=new Xf(519,Xf.ReadOnly,[0,1]);const Jf=7680;class Hf{constructor(t,e,r,n,i,s){this.test=t,this.ref=e,this.mask=r,this.fail=n,this.depthFail=i,this.pass=s;}}Hf.disabled=new Hf({func:519,mask:0},0,0,Jf,Jf,Jf);class Yf{constructor(t,e,r){this.blendFunction=t,this.blendColor=e,this.mask=r;}}Yf.Replace=[1,0],Yf.disabled=new Yf(Yf.Replace,Ee.transparent,[!1,!1,!1,!1]),Yf.unblended=new Yf(Yf.Replace,Ee.transparent,[!0,!0,!0,!0]),Yf.alphaBlended=new Yf([1,771],Ee.transparent,[!0,!0,!0,!0]);const Wf=1029,Qf=2305;class ty{constructor(t,e,r){this.enable=t,this.mode=e,this.frontFace=r;}}ty.disabled=new ty(!1,Wf,Qf),ty.backCCW=new ty(!0,Wf,Qf),ty.backCW=new ty(!0,Wf,2304),ty.frontCW=new ty(!0,1028,2304),ty.frontCCW=new ty(!0,1028,Qf);class ey extends Qt{constructor(t,e,r){super(),this.id=t,this._onlySymbols=r,e.on("data",(t=>{"source"===t.dataType&&"metadata"===t.sourceDataType&&(this._sourceLoaded=!0),this._sourceLoaded&&!this._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(this.reload(),this.transform&&this.update(this.transform));})),e.on("error",(()=>{this._sourceErrored=!0;})),this._source=e,this._tiles={},this._cache=new Kf(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._minTileCacheSize=e.minTileCacheSize,this._maxTileCacheSize=e.maxTileCacheSize,this._loadedParentTiles={},this._coveredTiles={},this._state=new Df,this._isRaster="raster"===this._source.type||"raster-dem"===this._source.type||"custom"===this._source.type&&"raster"===this._source._dataType;}onAdd(t){this.map=t,this._minTileCacheSize=void 0===this._minTileCacheSize&&t?t._minTileCacheSize:this._minTileCacheSize,this._maxTileCacheSize=void 0===this._maxTileCacheSize&&t?t._maxTileCacheSize:this._maxTileCacheSize;}loaded(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;if(!this._source.loaded())return !1;for(const t in this._tiles){const e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0}getSource(){return this._source}pause(){this._paused=!0;}resume(){if(!this._paused)return;const t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}_loadTile(t,e){return t.isSymbolTile=this._onlySymbols,this._source.loadTile(t,e)}_unloadTile(t){if(this._source.unloadTile)return this._source.unloadTile(t,(()=>{}))}_abortTile(t){if(this._source.abortTile)return this._source.abortTile(t,(()=>{}))}serialize(){return this._source.serialize()}prepare(t){this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null);for(const e in this._tiles){const r=this._tiles[e];r.upload(t),r.prepare(this.map.style.imageManager);}}getIds(){return E(this._tiles).map((t=>t.tileID)).sort(ry).map((t=>t.key))}getRenderableIds(t){const e=[];for(const r in this._tiles)this._isIdRenderable(+r,t)&&e.push(this._tiles[r]);return t?e.sort(((t,e)=>{const r=t.tileID,n=e.tileID,i=new x(r.canonical.x,r.canonical.y)._rotate(this.transform.angle),s=new x(n.canonical.x,n.canonical.y)._rotate(this.transform.angle);return r.overscaledZ-n.overscaledZ||s.y-i.y||s.x-i.x})).map((t=>t.tileID.key)):e.map((t=>t.tileID)).sort(ry).map((t=>t.key))}hasRenderableParent(t){const e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)}_isIdRenderable(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())}reload(){if(this._paused)this._shouldReloadOnResume=!0;else {this._cache.reset();for(const t in this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(+t,"reloading");}}_reloadTile(t,e){const r=this._tiles[t];r&&("loading"!==r.state&&(r.state=e),this._loadTile(r,this._tileLoaded.bind(this,r,t,e)));}_tileLoaded(t,e,r,n){if(n)if(t.state="errored",404!==n.status)this._source.fire(new Wt(n,{tile:t}));else if("raster-dem"===this._source.type&&this.usedForTerrain&&this.map.painter.terrain){const t=this.map.painter.terrain;this.update(this.transform,t.getScaledDemTileSize(),!0),t.resetTileLookupCache(this.id);}else this.update(this.transform);else t.timeAdded=Xt.now(),"expired"===r&&(t.refreshedUponExpiration=!0),this._setTileReloadTimer(e,t),"raster-dem"===this._source.type&&t.dem&&this._backfillDEM(t),this._state.initializeTileState(t,this.map?this.map.painter:null),this._source.fire(new Yt("data",{dataType:"source",tile:t,coord:t.tileID,sourceCacheId:this.id}));}_backfillDEM(t){const e=this.getRenderableIds();for(let n=0;n<e.length;n++){const i=e[n];if(t.neighboringTiles&&t.neighboringTiles[i]){const e=this.getTileByID(i);r(t,e),r(e,t);}}function r(t,e){if(!t.dem||t.dem.borderReady)return;t.needsHillshadePrepare=!0,t.needsDEMTextureUpload=!0;let r=e.tileID.canonical.x-t.tileID.canonical.x;const n=e.tileID.canonical.y-t.tileID.canonical.y,i=Math.pow(2,t.tileID.canonical.z),s=e.tileID.key;0===r&&0===n||Math.abs(n)>1||(Math.abs(r)>1&&(1===Math.abs(r+i)?r+=i:1===Math.abs(r-i)&&(r-=i)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,r,n),t.neighboringTiles&&t.neighboringTiles[s]&&(t.neighboringTiles[s].backfilled=!0)));}}getTile(t){return this.getTileByID(t.key)}getTileByID(t){return this._tiles[t]}_retainLoadedChildren(t,e,r,n){for(const i in this._tiles){let s=this._tiles[i];if(n[i]||!s.hasData()||s.tileID.overscaledZ<=e||s.tileID.overscaledZ>r)continue;let a=s.tileID;for(;s&&s.tileID.overscaledZ>e+1;){const t=s.tileID.scaledTo(s.tileID.overscaledZ-1);s=this._tiles[t.key],s&&s.hasData()&&(a=t);}let o=a;for(;o.overscaledZ>e;)if(o=o.scaledTo(o.overscaledZ-1),t[o.key]){n[a.key]=a;break}}}findLoadedParent(t,e){if(t.key in this._loadedParentTiles){const r=this._loadedParentTiles[t.key];return r&&r.tileID.overscaledZ>=e?r:null}for(let r=t.overscaledZ-1;r>=e;r--){const e=t.scaledTo(r),n=this._getLoadedTile(e);if(n)return n}}_getLoadedTile(t){const e=this._tiles[t.key];return e&&e.hasData()?e:this._cache.getByKey(this._source.reparseOverscaled?t.wrapped().key:t.canonical.key)}updateCacheSize(t,e){e=e||this._source.tileSize;const r=Math.ceil(t.width/e)+1,n=Math.ceil(t.height/e)+1,i=Math.floor(r*n*5),s="number"==typeof this._minTileCacheSize?Math.max(this._minTileCacheSize,i):i,a="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,s):s;this._cache.setMaxSize(a);}handleWrapJump(t){const e=Math.round((t-(void 0===this._prevLng?t:this._prevLng))/360);if(this._prevLng=t,e){const t={};for(const r in this._tiles){const n=this._tiles[r];n.tileID=n.tileID.unwrapTo(n.tileID.wrap+e),t[n.tileID.key]=n;}this._tiles=t;for(const t in this._timers)clearTimeout(this._timers[t]),delete this._timers[t];for(const t in this._tiles)this._setTileReloadTimer(+t,this._tiles[t]);}}update(t,e,r){if(this.transform=t,!this._sourceLoaded||this._paused||this.transform.freezeTileCoverage)return;if(this.usedForTerrain&&!r)return;let n;this.updateCacheSize(t,e),"globe"!==this.transform.projection.name&&this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used||this.usedForTerrain?this._source.tileID?n=t.getVisibleUnwrappedCoordinates(this._source.tileID).map((t=>new fh(t.canonical.z,t.wrap,t.canonical.z,t.canonical.x,t.canonical.y))):(n=t.coveringTiles({tileSize:e||this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom&&!r,reparseOverscaled:this._source.reparseOverscaled,isTerrainDEM:this.usedForTerrain}),this._source.hasTile&&(n=n.filter((t=>this._source.hasTile(t))))):n=[];const i=this._updateRetainedTiles(n);if(ny(this._source.type)&&0!==n.length){const t={},e={},r=Object.keys(i);for(const n of r){const r=i[n],s=this._tiles[n];if(!s||s.fadeEndTime&&s.fadeEndTime<=Xt.now())continue;const a=this.findLoadedParent(r,Math.max(r.overscaledZ-ey.maxOverzooming,this._source.minzoom));a&&(this._addTile(a.tileID),t[a.tileID.key]=a.tileID),e[n]=r;}const s=n[n.length-1].overscaledZ;for(const t in this._tiles){const r=this._tiles[t];if(i[t]||!r.hasData())continue;let n=r.tileID;for(;n.overscaledZ>s;){n=n.scaledTo(n.overscaledZ-1);const s=this._tiles[n.key];if(s&&s.hasData()&&e[n.key]){i[t]=r.tileID;break}}}for(const e in t)i[e]||(this._coveredTiles[e]=!0,i[e]=t[e]);}for(const t in i)this._tiles[t].clearFadeHold();const s=function(t,e){const r=[];for(const n in t)n in e||r.push(n);return r}(this._tiles,i);for(const t of s){const e=this._tiles[t];e.hasSymbolBuckets&&!e.holdingForFade()?e.setHoldDuration(this.map._fadeDuration):e.hasSymbolBuckets&&!e.symbolFadeFinished()||this._removeTile(+t);}this._updateLoadedParentTileCache(),this._onlySymbols&&this._source.afterUpdate&&this._source.afterUpdate();}releaseSymbolFadeTiles(){for(const t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(+t);}_updateRetainedTiles(t){const e={};if(0===t.length)return e;const r={},n=t.reduce(((t,e)=>Math.min(t,e.overscaledZ)),1/0),i=t[0].overscaledZ,s=Math.max(i-ey.maxOverzooming,this._source.minzoom),a=Math.max(i+ey.maxUnderzooming,this._source.minzoom),o={};for(const r of t){const t=this._addTile(r);e[r.key]=r,t.hasData()||n<this._source.maxzoom&&(o[r.key]=r);}this._retainLoadedChildren(o,n,a,e);for(const n of t){let t=this._tiles[n.key];if(t.hasData())continue;if(n.canonical.z>=this._source.maxzoom){const t=n.children(this._source.maxzoom)[0],r=this.getTile(t);if(r&&r.hasData()){e[t.key]=t;continue}}else {const t=n.children(this._source.maxzoom);if(e[t[0].key]&&e[t[1].key]&&e[t[2].key]&&e[t[3].key])continue}let i=t.wasRequested();for(let a=n.overscaledZ-1;a>=s;--a){const s=n.scaledTo(a);if(r[s.key])break;if(r[s.key]=!0,t=this.getTile(s),!t&&i&&(t=this._addTile(s)),t&&(e[s.key]=s,i=t.wasRequested(),t.hasData()))break}}return e}_updateLoadedParentTileCache(){this._loadedParentTiles={};for(const t in this._tiles){const e=[];let r,n=this._tiles[t].tileID;for(;n.overscaledZ>0;){if(n.key in this._loadedParentTiles){r=this._loadedParentTiles[n.key];break}e.push(n.key);const t=n.scaledTo(n.overscaledZ-1);if(r=this._getLoadedTile(t),r)break;n=t;}for(const t of e)this._loadedParentTiles[t]=r;}}_addTile(t){let e=this._tiles[t.key];if(e)return e;e=this._cache.getAndRemove(t),e&&(this._setTileReloadTimer(t.key,e),e.tileID=t,this._state.initializeTileState(e,this.map?this.map.painter:null),this._cacheTimers[t.key]&&(clearTimeout(this._cacheTimers[t.key]),delete this._cacheTimers[t.key],this._setTileReloadTimer(t.key,e)));const r=Boolean(e);if(!r){const r=this.map?this.map.painter:null;e=new Pf(t,this._source.tileSize*t.overscaleFactor(),this.transform.tileZoom,r,this._isRaster),this._loadTile(e,this._tileLoaded.bind(this,e,t.key,e.state));}return e?(e.uses++,this._tiles[t.key]=e,r||this._source.fire(new Yt("dataloading",{tile:e,coord:e.tileID,dataType:"source"})),e):null}_setTileReloadTimer(t,e){t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);const r=e.getExpiryTimeout();r&&(this._timers[t]=setTimeout((()=>{this._reloadTile(t,"expired"),delete this._timers[t];}),r));}_removeTile(t){const e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()&&"reloading"!==e.state?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));}clearTiles(){this._shouldReloadOnResume=!1,this._paused=!1;for(const t in this._tiles)this._removeTile(+t);this._source._clear&&this._source._clear(),this._cache.reset(),this.map&&this.usedForTerrain&&this.map.painter.terrain&&this.map.painter.terrain.resetTileLookupCache(this.id);}tilesIn(t,e,r){const n=[],i=this.transform;if(!i)return n;const s="globe"===i.projection.name,a=Nl(i.center.lng);for(const o in this._tiles){const l=this._tiles[o];if(r&&l.clearQueryDebugViz(),l.holdingForFade())continue;let u;if(s){const t=l.tileID.canonical;if(0===t.z){const e=[Math.abs(M(a,...iy(t,-1))-a),Math.abs(M(a,...iy(t,1))-a)];u=[0,2*e.indexOf(Math.min(...e))-1];}else {const e=[Math.abs(M(a,...iy(t,-1))-a),Math.abs(M(a,...iy(t,0))-a),Math.abs(M(a,...iy(t,1))-a)];u=[e.indexOf(Math.min(...e))-1];}}else u=[0];for(const r of u){const s=t.containsTile(l,i,e,r);s&&n.push(s);}}return n}getVisibleCoordinates(t){const e=this.getRenderableIds(t).map((t=>this._tiles[t].tileID));for(const t of e)t.projMatrix=this.transform.calculateProjMatrix(t.toUnwrapped());return e}hasTransition(){if(this._source.hasTransition())return !0;if(ny(this._source.type))for(const t in this._tiles){const e=this._tiles[t];if(void 0!==e.fadeEndTime&&e.fadeEndTime>=Xt.now())return !0}return !1}setFeatureState(t,e,r){this._state.updateState(t=t||"_geojsonTileLayer",e,r);}removeFeatureState(t,e,r){this._state.removeFeatureState(t=t||"_geojsonTileLayer",e,r);}getFeatureState(t,e){return this._state.getState(t=t||"_geojsonTileLayer",e)}setDependencies(t,e,r){const n=this._tiles[t];n&&n.setDependencies(e,r);}reloadTilesForDependencies(t,e){for(const r in this._tiles)this._tiles[r].hasDependency(t,e)&&this._reloadTile(+r,"reloading");this._cache.filter((r=>!r.hasDependency(t,e)));}_preloadTiles(t,e){if(!this._sourceLoaded){const r=()=>{this._sourceLoaded&&(this._source.off("data",r),this._preloadTiles(t,e));};return void this._source.on("data",r)}const r=new Map,n=Array.isArray(t)?t:[t],i=this.map.painter.terrain,s=this.usedForTerrain&&i?i.getScaledDemTileSize():this._source.tileSize;for(const t of n){const e=t.coveringTiles({tileSize:s,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom&&!this.usedForTerrain,reparseOverscaled:this._source.reparseOverscaled,isTerrainDEM:this.usedForTerrain});for(const t of e)r.set(t.key,t);this.usedForTerrain&&t.updateElevation(!1);}B(Array.from(r.values()),((t,e)=>{const r=new Pf(t,this._source.tileSize*t.overscaleFactor(),this.transform.tileZoom,this.map.painter,this._isRaster);this._loadTile(r,(t=>{"raster-dem"===this._source.type&&r.dem&&this._backfillDEM(r),e(t,r);}));}),e);}}function ry(t,e){const r=Math.abs(2*t.wrap)-+(t.wrap<0),n=Math.abs(2*e.wrap)-+(e.wrap<0);return t.overscaledZ-e.overscaledZ||n-r||e.canonical.y-t.canonical.y||e.canonical.x-t.canonical.x}function ny(t){return "raster"===t||"image"===t||"video"===t||"custom"===t}function iy(t,e){const r=1<<t.z;return [t.x/r+e,(t.x+1)/r+e]}ey.maxOverzooming=10,ey.maxUnderzooming=3;class sy{constructor(t,e,r){this._demTile=t,this._dem=this._demTile.dem,this._scale=e,this._offset=r;}static create(t,e,r){const n=r||t.findDEMTileFor(e);if(!n||!n.dem)return;const i=n.dem,s=n.tileID,a=1<<e.canonical.z-s.canonical.z;return new sy(n,n.tileSize/ao/a,[(e.canonical.x/a-s.canonical.x)*i.dim,(e.canonical.y/a-s.canonical.y)*i.dim])}tileCoordToPixel(t,e){const r=e*this._scale+this._offset[1],n=Math.floor(t*this._scale+this._offset[0]),i=Math.floor(r);return new x(n,i)}getElevationAt(t,e,r,n){const i=t*this._scale+this._offset[0],s=e*this._scale+this._offset[1],a=Math.floor(i),o=Math.floor(s),l=this._dem;return n=!!n,r?Er(Er(l.get(a,o,n),l.get(a,o+1,n),s-o),Er(l.get(a+1,o,n),l.get(a+1,o+1,n),s-o),i-a):l.get(a,o,n)}getElevationAtPixel(t,e,r){return this._dem.get(t,e,!!r)}getMeterToDEM(t){return (1<<this._demTile.tileID.canonical.z)*Zl(1,t)*this._dem.stride}}class ay{constructor(t,e){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=new Ki(ao,16,0),this.featureIndexArray=new ba,this.promoteId=e;}insert(t,e,r,n,i,s=0){const a=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i,s);const o=this.grid;for(let t=0;t<e.length;t++){const r=e[t],n=[1/0,1/0,-1/0,-1/0];for(let t=0;t<r.length;t++){const e=r[t];n[0]=Math.min(n[0],e.x),n[1]=Math.min(n[1],e.y),n[2]=Math.max(n[2],e.x),n[3]=Math.max(n[3],e.y);}n[0]<ao&&n[1]<ao&&n[2]>=0&&n[3]>=0&&o.insert(a,n[0],n[1],n[2],n[3]);}}loadVTLayers(){if(!this.vtLayers){this.vtLayers=new Zc(new mp(this.rawTileData)).layers,this.sourceLayerCoder=new wf(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"]),this.vtFeatures={};for(const t in this.vtLayers)this.vtFeatures[t]=[];}return this.vtLayers}query(t,e,r,n){this.loadVTLayers();const i=t.params||{},s=hi(i.filter),a=t.tileResult,o=t.transform,l=a.bufferedTilespaceBounds,u=this.grid.query(l.min.x,l.min.y,l.max.x,l.max.y,((t,e,r,n)=>wu(a.bufferedTilespaceGeometry,t,e,r,n)));u.sort(ly);let c=null;o.elevation&&u.length>0&&(c=sy.create(o.elevation,this.tileID));const h={};let p;for(let o=0;o<u.length;o++){const l=u[o];if(l===p)continue;p=l;const d=this.featureIndexArray.get(l);let f=null;this.loadMatchingFeature(h,d,s,i.layers,i.availableImages,e,r,n,((e,r,n,i=0)=>(f||(f=au(e,this.tileID.canonical,t.tileTransform)),r.queryIntersectsFeature(a,e,n,f,this.z,t.transform,t.pixelPosMatrix,c,i))));}return h}loadMatchingFeature(t,e,r,n,i,s,a,o,l){const{featureIndex:u,bucketIndex:c,sourceLayerIndex:h,layoutVertexArrayOffset:p}=e,d=this.bucketLayerIDs[c];if(n&&!function(t,e){for(let r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(n,d))return;const f=this.sourceLayerCoder.decode(h),y=this.vtLayers[f].feature(u);if(r.needGeometry){const t=ou(y,!0);if(!r.filter(new ws(this.tileID.overscaledZ),t,this.tileID.canonical))return}else if(!r.filter(new ws(this.tileID.overscaledZ),y))return;const m=this.getId(y,f);for(let e=0;e<d.length;e++){const r=d[e];if(n&&n.indexOf(r)<0)continue;const c=s[r];if(!c)continue;let h={};void 0!==m&&o&&(h=o.getState(c.sourceLayer||"_geojsonTileLayer",m));const f=C({},a[r]);f.paint=oy(f.paint,c.paint,y,h,i),f.layout=oy(f.layout,c.layout,y,h,i);const g=!l||l(y,c,h,p);if(!g)continue;const x=new Af(y,this.z,this.x,this.y,m);x.layer=f;let v=t[r];void 0===v&&(v=t[r]=[]),v.push({featureIndex:u,feature:x,intersectionZ:g});}}lookupSymbolFeatures(t,e,r,n,i,s,a,o){const l={};this.loadVTLayers();const u=hi(i);for(const i of t)this.loadMatchingFeature(l,{bucketIndex:r,sourceLayerIndex:n,featureIndex:i,layoutVertexArrayOffset:0},u,s,a,o,e);return l}loadFeature(t){const{featureIndex:e,sourceLayerIndex:r}=t;this.loadVTLayers();const n=this.sourceLayerCoder.decode(r),i=this.vtFeatures[n];if(i[e])return i[e];const s=this.vtLayers[n].feature(e);return i[e]=s,s}hasLayer(t){for(const e of this.bucketLayerIDs)for(const r of e)if(t===r)return !0;return !1}getId(t,e){let r=t.id;if(this.promoteId){const n="string"==typeof this.promoteId?this.promoteId:this.promoteId[e];null!=n&&(r=t.properties[n]),"boolean"==typeof r&&(r=Number(r));}return r}}function oy(t,e,r,n,i){return $(t,((t,s)=>{const a=e instanceof zs?e.get(s):null;return a&&a.evaluate?a.evaluate(r,n,i):a}))}function ly(t,e){return e-t}Ji(ay,"FeatureIndex",{omit:["rawTileData","sourceLayerCoder"]});class uy{constructor(t,e){this.width=t,this.height=e,this.nextRow=0,this.image=new Ru({width:t,height:e}),this.positions={},this.uploaded=!1;}getDash(t,e){const r=this.getKey(t,e);return this.positions[r]}trim(){const t=this.width,e=this.height=L(this.nextRow);this.image.resize({width:t,height:e});}getKey(t,e){return t.join(",")+e}getDashRanges(t,e,r){const n=[];let i=t.length%2==1?-t[t.length-1]*r:0,s=t[0]*r,a=!0;n.push({left:i,right:s,isDash:a,zeroLength:0===t[0]});let o=t[0];for(let e=1;e<t.length;e++){a=!a;const l=t[e];i=o*r,o+=l,s=o*r,n.push({left:i,right:s,isDash:a,zeroLength:0===l});}return n}addRoundDash(t,e,r){const n=e/2;for(let e=-r;e<=r;e++){const i=this.width*(this.nextRow+r+e);let s=0,a=t[s];for(let o=0;o<this.width;o++){o/a.right>1&&(a=t[++s]);const l=Math.abs(o-a.left),u=Math.abs(o-a.right),c=Math.min(l,u);let h;const p=e/r*(n+1);if(a.isDash){const t=n-Math.abs(p);h=Math.sqrt(c*c+t*t);}else h=n-Math.sqrt(c*c+p*p);this.image.data[i+o]=Math.max(0,Math.min(255,h+128));}}}addRegularDash(t,e){for(let e=t.length-1;e>=0;--e){const r=t[e],n=t[e+1];r.zeroLength?t.splice(e,1):n&&n.isDash===r.isDash&&(n.left=r.left,t.splice(e,1));}const r=t[0],n=t[t.length-1];r.isDash===n.isDash&&(r.left=n.left-this.width,n.right=r.right+this.width);const i=this.width*this.nextRow;let s=0,a=t[s];for(let r=0;r<this.width;r++){r/a.right>1&&(a=t[++s]);const n=Math.abs(r-a.left),o=Math.abs(r-a.right),l=Math.min(n,o);this.image.data[i+r]=Math.max(0,Math.min(255,(a.isDash?l:-l)+e+128));}}addDash(t,e){const r=this.getKey(t,e);if(this.positions[r])return this.positions[r];const n="round"===e,i=n?7:0,s=2*i+1;if(this.nextRow+s>this.height)return N("LineAtlas out of space"),null;0===t.length&&t.push(1);let a=0;for(let e=0;e<t.length;e++)t[e]<0&&(N("Negative value is found in line dasharray, replacing values with 0"),t[e]=0),a+=t[e];if(0!==a){const r=this.width/a,s=this.getDashRanges(t,this.width,r);n?this.addRoundDash(s,r,i):this.addRegularDash(s,"square"===e?.5*r:0);}const o=this.nextRow+i;this.nextRow+=s;const l={tl:[o,i],br:[a,0]};return this.positions[r]=l,l}}Ji(uy,"LineAtlas");const cy=1*td;class hy{constructor(t){const e={},r=[];for(const n in t){const i=t[n],s=e[n]={};for(const t in i.glyphs){const e=i.glyphs[+t];if(!e||0===e.bitmap.width||0===e.bitmap.height)continue;const n=e.metrics.localGlyph?cy:1,a={x:0,y:0,w:e.bitmap.width+2*n,h:e.bitmap.height+2*n};r.push(a),s[t]=a;}}const{w:n,h:i}=_p(r),s=new Ru({width:n||1,height:i||1});for(const r in t){const n=t[r];for(const t in n.glyphs){const i=n.glyphs[+t];if(!i||0===i.bitmap.width||0===i.bitmap.height)continue;const a=e[r][t],o=i.metrics.localGlyph?cy:1;Ru.copy(i.bitmap,s,{x:0,y:0},{x:a.x+o,y:a.y+o},i.bitmap);}}this.image=s,this.positions=e;}}Ji(hy,"GlyphAtlas");class py{constructor(t){this.tileID=new fh(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.tileZoom=t.tileZoom,this.uid=t.uid,this.zoom=t.zoom,this.canonical=t.tileID.canonical,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming,this.returnDependencies=!!t.returnDependencies,this.promoteId=t.promoteId,this.enableTerrain=!!t.enableTerrain,this.isSymbolTile=t.isSymbolTile,this.tileTransform=Bd(t.tileID.canonical,t.projection),this.projection=t.projection;}parse(t,e,r,n,i){this.status="parsing",this.data=t,this.collisionBoxArray=new pa;const s=new wf(Object.keys(t.layers).sort()),a=new ay(this.tileID,this.promoteId);a.bucketLayerIDs=[];const o={},l=new uy(256,256),u={featureIndex:a,iconDependencies:{},patternDependencies:{},glyphDependencies:{},lineAtlas:l,availableImages:r},c=e.familiesBySource[this.source];for(const e in c){const n=t.layers[e];if(!n)continue;let i=!1,l=!1;for(const t of c[e])"symbol"===t[0].type?i=!0:l=!0;if(!0===this.isSymbolTile&&!i)continue;if(!1===this.isSymbolTile&&!l)continue;1===n.version&&N(`Vector tile source "${this.source}" layer "${e}" does not use vector tile spec v2 and therefore may have some rendering errors.`);const h=s.encode(e),p=[];for(let t=0;t<n.length;t++){const r=n.feature(t),i=a.getId(r,e);p.push({feature:r,id:i,index:t,sourceLayerIndex:h});}for(const t of c[e]){const e=t[0];void 0!==this.isSymbolTile&&"symbol"===e.type!==this.isSymbolTile||e.minzoom&&this.zoom<Math.floor(e.minzoom)||e.maxzoom&&this.zoom>=e.maxzoom||"none"!==e.visibility&&(dy(t,this.zoom,r),(o[e.id]=e.createBucket({index:a.bucketLayerIDs.length,layers:t,zoom:this.zoom,canonical:this.canonical,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:h,sourceID:this.source,enableTerrain:this.enableTerrain,projection:this.projection.spec,availableImages:r})).populate(p,u,this.tileID.canonical,this.tileTransform),a.bucketLayerIDs.push(t.map((t=>t.id))));}}let h,p,d,f;l.trim();const y={type:"maybePrepare",isSymbolTile:this.isSymbolTile,zoom:this.zoom},m=()=>{if(h)return i(h);if(p&&d&&f){const t=new hy(p),e=new kp(d,f);for(const n in o){const i=o[n];i instanceof of?(dy(i.layers,this.zoom,r),vd(i,p,t.positions,d,e.iconPositions,this.showCollisionBoxes,r,this.tileID.canonical,this.tileZoom,this.projection)):i.hasPattern&&(i instanceof Ih||i instanceof Mc||i instanceof th)&&(dy(i.layers,this.zoom,r),i.addFeatures(u,this.tileID.canonical,e.patternPositions,r,this.tileTransform));}this.status="done",i(null,{buckets:E(o).filter((t=>!t.isEmpty())),featureIndex:a,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,lineAtlas:l,imageAtlas:e,glyphMap:this.returnDependencies?p:null,iconMap:this.returnDependencies?d:null,glyphPositions:this.returnDependencies?t.positions:null});}},g=$(u.glyphDependencies,(t=>Object.keys(t).map(Number)));Object.keys(g).length?n.send("getGlyphs",{uid:this.uid,stacks:g},((t,e)=>{h||(h=t,p=e,m());}),void 0,!1,y):p={};const x=Object.keys(u.iconDependencies);x.length?n.send("getImages",{icons:x,source:this.source,tileID:this.tileID,type:"icons"},((t,e)=>{h||(h=t,d=e,m());}),void 0,!1,y):d={};const v=Object.keys(u.patternDependencies);v.length?n.send("getImages",{icons:v,source:this.source,tileID:this.tileID,type:"patterns"},((t,e)=>{h||(h=t,f=e,m());}),void 0,!1,y):f={},m();}}function dy(t,e,r){const n=new ws(e);for(const e of t)e.recalculate(n,r);}class fy{constructor(t){this.entries={},this.scheduler=t;}request(t,e,r,n){const i=this.entries[t]=this.entries[t]||{callbacks:[]};if(i.result){const[t,r]=i.result;return this.scheduler?this.scheduler.add((()=>{n(t,r);}),e):n(t,r),()=>{}}return i.callbacks.push(n),i.cancel||(i.cancel=r(((r,n)=>{i.result=[r,n];for(const t of i.callbacks)this.scheduler?this.scheduler.add((()=>{t(r,n);}),e):t(r,n);setTimeout((()=>delete this.entries[t]),3e3);}))),()=>{i.result||(i.callbacks=i.callbacks.filter((t=>t!==n)),i.callbacks.length||(i.cancel(),delete this.entries[t]));}}}function yy(t,e,r){const n=JSON.stringify(t.request);return t.data&&(this.deduped.entries[n]={result:[null,t.data]}),this.deduped.request(n,{type:"parseTile",isSymbolTile:t.isSymbolTile,zoom:t.tileZoom},(e=>{const n=pt(t.request,((t,n,i,s)=>{t?e(t):n&&e(null,{vectorTile:r?void 0:new Zc(new mp(n)),rawData:n,cacheControl:i,expires:s});}));return ()=>{n.cancel(),e();}}),e)}const my=[Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];class gy{static from(t){if(!(t instanceof ArrayBuffer))throw new Error("Data must be an instance of ArrayBuffer.");const[e,r]=new Uint8Array(t,0,2);if(219!==e)throw new Error("Data does not appear to be in a KDBush format.");const n=r>>4;if(1!==n)throw new Error(`Got v${n} data when expected v1.`);const i=my[15&r];if(!i)throw new Error("Unrecognized array type.");const[s]=new Uint16Array(t,2,1),[a]=new Uint32Array(t,4,1);return new gy(a,s,i,t)}constructor(t,e=64,r=Float64Array,n){if(isNaN(t)||t<0)throw new Error(`Unpexpected numItems value: ${t}.`);this.numItems=+t,this.nodeSize=Math.min(Math.max(+e,2),65535),this.ArrayType=r,this.IndexArrayType=t<65536?Uint16Array:Uint32Array;const i=my.indexOf(this.ArrayType),s=2*t*this.ArrayType.BYTES_PER_ELEMENT,a=t*this.IndexArrayType.BYTES_PER_ELEMENT,o=(8-a%8)%8;if(i<0)throw new Error(`Unexpected typed array class: ${r}.`);n&&n instanceof ArrayBuffer?(this.data=n,this.ids=new this.IndexArrayType(this.data,8,t),this.coords=new this.ArrayType(this.data,8+a+o,2*t),this._pos=2*t,this._finished=!0):(this.data=new ArrayBuffer(8+s+a+o),this.ids=new this.IndexArrayType(this.data,8,t),this.coords=new this.ArrayType(this.data,8+a+o,2*t),this._pos=0,this._finished=!1,new Uint8Array(this.data,0,2).set([219,16+i]),new Uint16Array(this.data,2,1)[0]=e,new Uint32Array(this.data,4,1)[0]=t);}add(t,e){const r=this._pos>>1;return this.ids[r]=r,this.coords[this._pos++]=t,this.coords[this._pos++]=e,r}finish(){const t=this._pos>>1;if(t!==this.numItems)throw new Error(`Added ${t} items when expected ${this.numItems}.`);return xy(this.ids,this.coords,this.nodeSize,0,this.numItems-1,0),this._finished=!0,this}range(t,e,r,n){if(!this._finished)throw new Error("Data not yet indexed - call index.finish().");const{ids:i,coords:s,nodeSize:a}=this,o=[0,i.length-1,0],l=[];for(;o.length;){const u=o.pop()||0,c=o.pop()||0,h=o.pop()||0;if(c-h<=a){for(let a=h;a<=c;a++){const o=s[2*a],u=s[2*a+1];o>=t&&o<=r&&u>=e&&u<=n&&l.push(i[a]);}continue}const p=h+c>>1,d=s[2*p],f=s[2*p+1];d>=t&&d<=r&&f>=e&&f<=n&&l.push(i[p]),(0===u?t<=d:e<=f)&&(o.push(h),o.push(p-1),o.push(1-u)),(0===u?r>=d:n>=f)&&(o.push(p+1),o.push(c),o.push(1-u));}return l}within(t,e,r){if(!this._finished)throw new Error("Data not yet indexed - call index.finish().");const{ids:n,coords:i,nodeSize:s}=this,a=[0,n.length-1,0],o=[],l=r*r;for(;a.length;){const u=a.pop()||0,c=a.pop()||0,h=a.pop()||0;if(c-h<=s){for(let r=h;r<=c;r++)_y(i[2*r],i[2*r+1],t,e)<=l&&o.push(n[r]);continue}const p=h+c>>1,d=i[2*p],f=i[2*p+1];_y(d,f,t,e)<=l&&o.push(n[p]),(0===u?t-r<=d:e-r<=f)&&(a.push(h),a.push(p-1),a.push(1-u)),(0===u?t+r>=d:e+r>=f)&&(a.push(p+1),a.push(c),a.push(1-u));}return o}}function xy(t,e,r,n,i,s){if(i-n<=r)return;const a=n+i>>1;vy(t,e,a,n,i,s),xy(t,e,r,n,a-1,1-s),xy(t,e,r,a+1,i,1-s);}function vy(t,e,r,n,i,s){for(;i>n;){if(i-n>600){const a=i-n+1,o=r-n+1,l=Math.log(a),u=.5*Math.exp(2*l/3),c=.5*Math.sqrt(l*u*(a-u)/a)*(o-a/2<0?-1:1);vy(t,e,r,Math.max(n,Math.floor(r-o*u/a+c)),Math.min(i,Math.floor(r+(a-o)*u/a+c)),s);}const a=e[2*r+s];let o=n,l=i;for(by(t,e,n,r),e[2*i+s]>a&&by(t,e,n,i);o<l;){for(by(t,e,o,l),o++,l--;e[2*o+s]<a;)o++;for(;e[2*l+s]>a;)l--;}e[2*n+s]===a?by(t,e,n,l):(l++,by(t,e,l,i)),l<=r&&(n=l+1),r<=l&&(i=l-1);}}function by(t,e,r,n){wy(t,r,n),wy(e,2*r,2*n),wy(e,2*r+1,2*n+1);}function wy(t,e,r){const n=t[e];t[e]=t[r],t[r]=n;}function _y(t,e,r,n){const i=t-r,s=e-n;return i*i+s*s}t.ARRAY_TYPE=uo,t.AUTH_ERR_MSG=xt,t.Aabb=il,t.Actor=class{constructor(t,r,n){this.target=t,this.parent=r,this.mapId=n,this.callbacks={},this.cancelCallbacks={},R(["receive"],this),this.target.addEventListener("message",this.receive,!1),this.globalScope=K()?t:e,this.scheduler=new bf;}send(t,e,r,n,i=!1,s){const a=Math.round(1e18*Math.random()).toString(36).substring(0,10);r&&(r.metadata=s,this.callbacks[a]=r);const o=H(this.globalScope)?void 0:[];return this.target.postMessage({id:a,type:t,hasCallback:!!r,targetMapId:n,mustQueue:i,sourceMapId:this.mapId,data:Wi(e,o)},o),{cancel:()=>{r&&delete this.callbacks[a],this.target.postMessage({id:a,type:"<cancel>",targetMapId:n,sourceMapId:this.mapId});}}}receive(t){const e=t.data,r=e.id;if(r&&(!e.targetMapId||this.mapId===e.targetMapId))if("<cancel>"===e.type){const t=this.cancelCallbacks[r];delete this.cancelCallbacks[r],t&&t.cancel();}else if(e.mustQueue||K()){const t=this.callbacks[r];this.cancelCallbacks[r]=this.scheduler.add((()=>this.processTask(r,e)),t&&t.metadata||{type:"message"});}else this.processTask(r,e);}processTask(t,e){if("<response>"===e.type){const r=this.callbacks[t];delete this.callbacks[t],r&&(e.error?r(Qi(e.error)):r(null,Qi(e.data)));}else {const r=H(this.globalScope)?void 0:[],n=e.hasCallback?(e,n)=>{delete this.cancelCallbacks[t],this.target.postMessage({id:t,type:"<response>",sourceMapId:this.mapId,error:e?Wi(e):null,data:Wi(n,r)},r);}:t=>{},i=Qi(e.data);if(this.parent[e.type])this.parent[e.type](e.sourceMapId,i,n);else if(this.parent.getWorkerSource){const t=e.type.split(".");this.parent.getWorkerSource(e.sourceMapId,t[0],i.source)[t[1]](i,n);}else n(new Error(`Could not find function ${e.type}`));}}remove(){this.scheduler.remove(),this.target.removeEventListener("message",this.receive,!1);}},t.CanonicalTileID=ph,t.Color=Ee,t.ColorMode=Yf,t.CullFaceMode=ty,t.DEMData=Zf,t.DataConstantProperty=Bs,t.DedupedRequest=fy,t.DepthMode=Xf,t.EXTENT=ao,t.Elevation=class{isDataAvailableAtPoint(t){const e=this._source();if(this.isUsingMockSource()||!e||t.y<0||t.y>1)return !1;const r=e.getSource().maxzoom,n=1<<r,i=Math.floor(t.x),s=Math.floor((t.x-i)*n),a=Math.floor(t.y*n),o=this.findDEMTileFor(new fh(r,i,r,s,a));return !(!o||!o.dem)}getAtPointOrZero(t,e=0){return this.getAtPoint(t,e)||0}getAtPoint(t,e,r=!0){if(this.isUsingMockSource())return null;null==e&&(e=null);const n=this._source();if(!n)return e;if(t.y<0||t.y>1)return e;const i=n.getSource().maxzoom,s=1<<i,a=Math.floor(t.x),o=t.x-a,l=new fh(i,a,i,Math.floor(o*s),Math.floor(t.y*s)),u=this.findDEMTileFor(l);if(!u||!u.dem)return e;const c=u.dem,h=1<<u.tileID.canonical.z,p=(o*h-u.tileID.canonical.x)*c.dim,d=(t.y*h-u.tileID.canonical.y)*c.dim,f=Math.floor(p),y=Math.floor(d);return (r?this.exaggeration():1)*Er(Er(c.get(f,y),c.get(f,y+1),d-y),Er(c.get(f+1,y),c.get(f+1,y+1),d-y),p-f)}getAtTileOffset(t,e,r){const n=1<<t.canonical.z;return this.getAtPointOrZero(new Wl(t.wrap+(t.canonical.x+e/ao)/n,(t.canonical.y+r/ao)/n))}getAtTileOffsetFunc(t,e,r,n){return i=>{const s=this.getAtTileOffset(t,i.x,i.y),a=n.upVector(t.canonical,i.x,i.y);return Co(a,a,s*n.upVectorScale(t.canonical,e,r).metersToTile),a}}getForTilePoints(t,e,r,n){if(this.isUsingMockSource())return !1;const i=sy.create(this,t,n);return !!i&&(e.forEach((t=>{t[2]=this.exaggeration()*i.getElevationAt(t[0],t[1],r);})),!0)}getMinMaxForTile(t){if(this.isUsingMockSource())return null;const e=this.findDEMTileFor(t);if(!e||!e.dem)return null;const r=e.dem.tree,n=e.tileID,i=1<<t.canonical.z-n.canonical.z;let s=t.canonical.x/i-n.canonical.x,a=t.canonical.y/i-n.canonical.y,o=0;for(let e=0;e<t.canonical.z-n.canonical.z&&!r.leaves[o];e++){s*=2,a*=2;const t=2*Math.floor(a)+Math.floor(s);o=r.childOffsets[o]+t,s%=1,a%=1;}return {min:this.exaggeration()*r.minimums[o],max:this.exaggeration()*r.maximums[o]}}getMinElevationBelowMSL(){throw new Error("Pure virtual method called.")}raycast(t,e,r){throw new Error("Pure virtual method called.")}pointCoordinate(t){throw new Error("Pure virtual method called.")}_source(){throw new Error("Pure virtual method called.")}isUsingMockSource(){throw new Error("Pure virtual method called.")}exaggeration(){throw new Error("Pure virtual method called.")}findDEMTileFor(t){throw new Error("Pure virtual method called.")}get visibleDemTiles(){throw new Error("Getter must be implemented in subclass.")}},t.ErrorEvent=Wt,t.EvaluationParameters=ws,t.Event=Yt,t.Evented=Qt,t.FillExtrusionBucket=th,t.Frustum=nl,t.FrustumCorners=rl,t.GLOBE_RADIUS=ol,t.GLOBE_SCALE_MATCH_LATITUDE=45,t.GLOBE_ZOOM_THRESHOLD_MAX=al,t.GLOBE_ZOOM_THRESHOLD_MIN=sl,t.GlobeSharedBuffers=class{constructor(t){this._createGrid(t),this._createPoles(t);}destroy(){this._poleIndexBuffer.destroy(),this._gridBuffer.destroy(),this._gridIndexBuffer.destroy(),this._poleNorthVertexBuffer.destroy(),this._poleSouthVertexBuffer.destroy();for(const t of this._poleSegments)t.destroy();for(const t of this._gridSegments)t.withSkirts.destroy(),t.withoutSkirts.destroy();if(this._wireframeIndexBuffer){this._wireframeIndexBuffer.destroy();for(const t of this._wireframeSegments)t.destroy();}}_fillGridMeshWithLods(t,e){const r=new $s,n=new ra,i=[],s=t+1+2,a=e[0]+1,o=e[0]+1+(1+e.length),l=(t,e,r)=>{let n=t===s-1?t-2:0===t?t:t-1;return n+=r?24575:0,[n,e]};for(let t=0;t<s;++t)r.emplaceBack(...l(t,0,!0));for(let t=0;t<a;++t)for(let e=0;e<s;++e)r.emplaceBack(...l(e,t,(0===e||e===s-1)&&!0));for(let t=0;t<e.length;++t){const n=e[t];for(let t=0;t<s;++t)r.emplaceBack(...l(t,n,!0));}for(let t=0;t<e.length;++t){const a=n.length,l=e[t]+1+2,u=new ra;for(let r=0;r<l-1;r++){const i=r===l-2,a=i?s*(o-e.length+t-r):s;for(let t=0;t<s-1;t++){const e=r*s+t;0===r||i||0===t||t===s-2?(u.emplaceBack(e+1,e,e+a),u.emplaceBack(e+a,e+a+1,e+1)):(n.emplaceBack(e+1,e,e+a),n.emplaceBack(e+a,e+a+1,e+1));}}const c=so.simpleSegment(0,a,r.length,n.length-a);for(let t=0;t<u.uint16.length;t+=3)n.emplaceBack(u.uint16[t],u.uint16[t+1],u.uint16[t+2]);const h=so.simpleSegment(0,a,r.length,n.length-a);i.push({withoutSkirts:c,withSkirts:h});}return {vertices:r,indices:n,segments:i}}_createGrid(t){const e=this._fillGridMeshWithLods(ul,cl);this._gridSegments=e.segments,this._gridBuffer=t.createVertexBuffer(e.vertices,tl.members),this._gridIndexBuffer=t.createIndexBuffer(e.indices,!0);}_createPoles(t){const e=new ra;for(let t=0;t<=ul;t++)e.emplaceBack(0,t+1,t+2);this._poleIndexBuffer=t.createIndexBuffer(e,!0);const r=new aa,n=new aa;this._poleSegments=[];for(let t=0,e=0;t<sl;t++){const i=360/(1<<t);r.emplaceBack(0,-ol,0,.5,0),n.emplaceBack(0,-ol,0,.5,1);for(let t=0;t<=ul;t++){const e=t/ul,s=Er(0,i,e),[a,o,l]=kl(Fl,Rl,s,ol);r.emplaceBack(a,o,l,e,0),n.emplaceBack(a,o,l,e,1);}this._poleSegments.push(so.simpleSegment(e,0,66,64)),e+=66;}this._poleNorthVertexBuffer=t.createVertexBuffer(r,Wo,!1),this._poleSouthVertexBuffer=t.createVertexBuffer(n,Wo,!1);}getGridBuffers(t,e){return [this._gridBuffer,this._gridIndexBuffer,e?this._gridSegments[t].withSkirts:this._gridSegments[t].withoutSkirts]}getPoleBuffers(t){return [this._poleNorthVertexBuffer,this._poleSouthVertexBuffer,this._poleIndexBuffer,this._poleSegments[t]]}getWirefameBuffers(t,e){if(!this._wireframeSegments){const e=new la,r=ul,n=r+1+2,i=1;this._wireframeSegments=[];for(let t=0,s=0;t<cl.length;t++){const a=cl[t];for(let t=i;t<a+i;t++)for(let s=i;s<r+i;s++){const r=t*n+s;e.emplaceBack(r,r+1),e.emplaceBack(r,r+n),e.emplaceBack(r,r+n+1);}const o=a*r*3;this._wireframeSegments.push(so.simpleSegment(0,s,(a+1)*n,o)),s+=o;}this._wireframeIndexBuffer=t.createIndexBuffer(e);}return [this._gridBuffer,this._wireframeIndexBuffer,this._wireframeSegments[e]]}},t.GlyphManager=rd,t.ImagePosition=Sp,t.KDBush=gy,t.LivePerformanceUtils=$t,t.LngLat=Ol,t.LngLatBounds=oo,t.LocalGlyphMode=ed,t.MAX_MERCATOR_LATITUDE=Hl,t.MercatorCoordinate=Wl,t.ONE_EM=Rh,t.OverscaledTileID=fh,t.PerformanceMarkers=Ut,t.Point=x,t.Properties=Ps,t.RGBAImage=Uu,t.Ray=el,t.RequestManager=class{constructor(t,e,r){this._transformRequestFn=t,this._customAccessToken=e,this._silenceAuthErrors=!!r,this._createSkuToken();}_createSkuToken(){const t=function(){let t="";for(let e=0;e<10;e++)t+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62*Math.random())];return {token:["1",h,t].join(""),tokenExpiresAt:Date.now()+432e5}}();this._skuToken=t.token,this._skuTokenExpiresAt=t.tokenExpiresAt;}_isSkuTokenExpired(){return Date.now()>this._skuTokenExpiresAt}transformRequest(t,e){return this._transformRequestFn&&this._transformRequestFn(t,e)||{url:t}}normalizeStyleURL(t,e){if(!vt(t))return t;const r=kt(t);return r.path=`/styles/v1${r.path}`,this._makeAPIURL(r,this._customAccessToken||e)}normalizeGlyphsURL(t,e){if(!vt(t))return t;const r=kt(t);return r.path=`/fonts/v1${r.path}`,this._makeAPIURL(r,this._customAccessToken||e)}normalizeSourceURL(t,e,r,n){if(!vt(t))return t;const i=kt(t);return i.path=`/v4/${i.authority}.json`,i.params.push("secure"),r&&i.params.push(`language=${r}`),n&&i.params.push(`worldview=${n}`),this._makeAPIURL(i,this._customAccessToken||e)}normalizeSpriteURL(t,e,r,n){const i=kt(t);return vt(t)?(i.path=`/styles/v1${i.path}/sprite${e}${r}`,this._makeAPIURL(i,this._customAccessToken||n)):(i.path+=`${e}${r}`,It(i))}normalizeTileURL(t,e,r){if(this._isSkuTokenExpired()&&this._createSkuToken(),t&&!vt(t))return t;const n=kt(t);n.path=n.path.replace(/(\.(png|jpg)\d*)(?=$)/,`${e||r&&"raster"!==n.authority&&512===r?"@2x":""}${s.supported?".webp":"$1"}`),"raster"===n.authority?n.path=`/${i.RASTER_URL_PREFIX}${n.path}`:(n.path=n.path.replace(/^.+\/v4\//,"/"),n.path=`/${i.TILE_URL_VERSION}${n.path}`);const a=this._customAccessToken||function(t){for(const e of t){const t=e.match(/^access_token=(.*)$/);if(t)return t[1]}return null}(n.params)||i.ACCESS_TOKEN;return i.REQUIRE_ACCESS_TOKEN&&a&&this._skuToken&&n.params.push(`sku=${this._skuToken}`),this._makeAPIURL(n,a)}canonicalizeTileURL(t,e){const r=kt(t);if(!r.path.match(/^(\/v4\/|\/raster\/v1\/)/)||!r.path.match(/\.[\w]+$/))return t;let n="mapbox://";r.path.match(/^\/raster\/v1\//)?n+=`raster/${r.path.replace(`/${i.RASTER_URL_PREFIX}/`,"")}`:n+=`tiles/${r.path.replace(`/${i.TILE_URL_VERSION}/`,"")}`;let s=r.params;return e&&(s=s.filter((t=>!t.match(/^access_token=/)))),s.length&&(n+=`?${s.join("&")}`),n}canonicalizeTileset(t,e){const r=!!e&&vt(e),n=[];for(const e of t.tiles||[])bt(e)?n.push(this.canonicalizeTileURL(e,r)):n.push(e);return n}_makeAPIURL(t,e){const r="See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes",n=kt(i.API_URL);if(t.protocol=n.protocol,t.authority=n.authority,"http"===t.protocol){const e=t.params.indexOf("secure");e>=0&&t.params.splice(e,1);}if("/"!==n.path&&(t.path=`${n.path}${t.path}`),!i.REQUIRE_ACCESS_TOKEN)return It(t);if(e=e||i.ACCESS_TOKEN,!this._silenceAuthErrors){if(!e)throw new Error(`An API access token is required to use Mapbox GL. ${r}`);if("s"===e[0])throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${r}`)}return t.params=t.params.filter((t=>-1===t.indexOf("access_token"))),t.params.push(`access_token=${e||""}`),It(t)}},t.ResourceType=lt,t.SegmentVector=so,t.SourceCache=ey,t.StencilMode=Hf,t.StructArrayLayout1ui2=ua,t.StructArrayLayout2f1f2i16=Qs,t.StructArrayLayout2i4=$s,t.StructArrayLayout2ui4=la,t.StructArrayLayout3f12=ea,t.StructArrayLayout3ui6=ra,t.StructArrayLayout4i8=Os,t.StructArrayLayout5f20=aa,t.Texture=xf,t.Tile=Pf,t.Transitionable=Ss,t.Uniform1f=La,t.Uniform1i=class extends Va{constructor(t){super(t),this.current=0;}set(t,e,r){this.fetchUniformLocation(t,e)&&this.current!==r&&(this.current=r,this.gl.uniform1i(this.location,r));}},t.Uniform2f=class extends Va{constructor(t){super(t),this.current=[0,0];}set(t,e,r){this.fetchUniformLocation(t,e)&&(r[0]===this.current[0]&&r[1]===this.current[1]||(this.current=r,this.gl.uniform2f(this.location,r[0],r[1])));}},t.Uniform3f=class extends Va{constructor(t){super(t),this.current=[0,0,0];}set(t,e,r){this.fetchUniformLocation(t,e)&&(r[0]===this.current[0]&&r[1]===this.current[1]&&r[2]===this.current[2]||(this.current=r,this.gl.uniform3f(this.location,r[0],r[1],r[2])));}},t.Uniform4f=Fa,t.UniformColor=Ra,t.UniformMatrix2f=class extends Va{constructor(t){super(t),this.current=ja;}set(t,e,r){if(this.fetchUniformLocation(t,e))for(let t=0;t<4;t++)if(r[t]!==this.current[t]){this.current=r,this.gl.uniformMatrix2fv(this.location,!1,r);break}}},t.UniformMatrix3f=class extends Va{constructor(t){super(t),this.current=$a;}set(t,e,r){if(this.fetchUniformLocation(t,e))for(let t=0;t<9;t++)if(r[t]!==this.current[t]){this.current=r,this.gl.uniformMatrix3fv(this.location,!1,r);break}}},t.UniformMatrix4f=class extends Va{constructor(t){super(t),this.current=Ua;}set(t,e,r){if(this.fetchUniformLocation(t,e)){if(r[12]!==this.current[12]||r[0]!==this.current[0])return this.current=r,void this.gl.uniformMatrix4fv(this.location,!1,r);for(let t=1;t<16;t++)if(r[t]!==this.current[t]){this.current=r,this.gl.uniformMatrix4fv(this.location,!1,r);break}}}},t.UnwrappedTileID=dh,t.ValidationError=ri,t.VectorTileFeature=Kc,t.VectorTileWorkerSource=class extends Qt{constructor(t,e,r,n,i){super(),this.actor=t,this.layerIndex=e,this.availableImages=r,this.loadVectorData=i||yy,this.loading={},this.loaded={},this.deduped=new fy(t.scheduler),this.isSpriteLoaded=n,this.scheduler=t.scheduler;}loadTile(t,e){const r=t.uid,n=t&&t.request,i=n&&n.collectResourceTiming,s=this.loading[r]=new py(t);s.abort=this.loadVectorData(t,((a,o)=>{const l=!this.loading[r];if(delete this.loading[r],l||a||!o)return s.status="done",l||(this.loaded[r]=s),e(a);const u=o.rawData,c={};o.expires&&(c.expires=o.expires),o.cacheControl&&(c.cacheControl=o.cacheControl),s.vectorTile=o.vectorTile||new Zc(new mp(u));const h=()=>{s.parse(s.vectorTile,this.layerIndex,this.availableImages,this.actor,((t,r)=>{if(t||!r)return e(t);const s={};if(i){const t=qt(n);t.length>0&&(s.resourceTiming=JSON.parse(JSON.stringify(t)));}e(null,C({rawTileData:u.slice(0)},r,c,s));}));};this.isSpriteLoaded?h():this.once("isSpriteLoaded",(()=>{this.scheduler?this.scheduler.add(h,{type:"parseTile",isSymbolTile:t.isSymbolTile,zoom:t.tileZoom}):h();})),this.loaded=this.loaded||{},this.loaded[r]=s;}));}reloadTile(t,e){const r=this.loaded,n=t.uid,i=this;if(r&&r[n]){const s=r[n];s.showCollisionBoxes=t.showCollisionBoxes,s.enableTerrain=!!t.enableTerrain,s.projection=t.projection,s.tileTransform=Bd(t.tileID.canonical,t.projection);const a=(t,r)=>{const n=s.reloadCallback;n&&(delete s.reloadCallback,s.parse(s.vectorTile,i.layerIndex,this.availableImages,i.actor,n)),e(t,r);};"parsing"===s.status?s.reloadCallback=a:"done"===s.status&&(s.vectorTile?s.parse(s.vectorTile,this.layerIndex,this.availableImages,this.actor,a):a());}}abortTile(t,e){const r=t.uid,n=this.loading[r];n&&(n.abort&&n.abort(),delete this.loading[r]),e();}removeTile(t,e){const r=this.loaded,n=t.uid;r&&r[n]&&delete r[n],e();}},t.WritingMode=Ip,t.ZoomDependentExpression=Wn,t.add=Mo,t.addDynamicAttributes=rf,t.adjoint=function(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=e[4],o=e[5],l=e[6],u=e[7],c=e[8];return t[0]=a*c-o*u,t[1]=i*u-n*c,t[2]=n*o-i*a,t[3]=o*l-s*c,t[4]=r*c-i*l,t[5]=i*s-r*o,t[6]=s*u-a*l,t[7]=n*l-r*u,t[8]=r*a-n*s,t},t.asyncAll=B,t.bezier=k,t.bindAll=R,t.boundsAttributes=Ef,t.bufferConvexPolygon=function(t,e){const r=[];for(let n=0;n<t.length;n++){const i=z(n-1,-1,t.length-1),s=z(n+1,-1,t.length-1),a=t[n],o=t[s],l=t[i].sub(a).unit(),u=o.sub(a).unit(),c=u.angleWithSep(l.x,l.y),h=l.add(u).unit().mult(-1*e/Math.sin(c/2));r.push(a.add(h));}return r},t.cacheEntryPossiblyAdded=function(t){ot++,ot>et&&(t.getActor().send("enforceCacheSizeLimit",tt),ot=0);},t.calculateGlobeLabelMatrix=function(t,e){const{x:r,y:n}=t.point,i=Cl(r,n,t.worldSize/t._pixelsPerMercatorPixel,0,0);return yo(i,i,El(xl(e)))},t.calculateGlobeMatrix=function(t){const{x:e,y:r}=t.point,{lng:n,lat:i}=t._center;return Cl(e,r,t.worldSize,n,i)},t.calculateGlobeMercatorMatrix=function(t){const e=t.pixelsPerMeter,r=e/Zl(1,t.center.lat),n=po(new Float64Array(16));return mo(n,n,[t.point.x,t.point.y,0]),go(n,n,[r,r,e]),Float32Array.from(n)},t.circumferenceAtLatitude=ql,t.clamp=M,t.clearTileCache=function(t){if(!it())return;const r=e.caches.delete(Q);t&&r.catch(t).then((()=>t()));},t.clipLine=Hp,t.clone=function(t){var e=new uo(16);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e[4]=t[4],e[5]=t[5],e[6]=t[6],e[7]=t[7],e[8]=t[8],e[9]=t[9],e[10]=t[10],e[11]=t[11],e[12]=t[12],e[13]=t[13],e[14]=t[14],e[15]=t[15],e},t.clone$1=O,t.collisionCircleLayout=Fh,t.config=i,t.conjugate=function(t,e){return t[0]=-e[0],t[1]=-e[1],t[2]=-e[2],t[3]=e[3],t},t.create=function(){var t=new uo(16);return uo!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.create$1=co,t.createExpression=Hn,t.createLayout=Rs,t.createStyleLayer=function(t){return "custom"===t.type?new ff(t):new gf[t.type](t)},t.cross=Lo,t.degToRad=w,t.distance=function(t,e){return Math.hypot(e[0]-t[0],e[1]-t[1],e[2]-t[2])},t.div=function(t,e,r){return t[0]=e[0]/r[0],t[1]=e[1]/r[1],t[2]=e[2]/r[2],t},t.dot=Vo,t.earthRadius=Ul,t.ease=I,t.easeCubicInOut=S,t.ecefToLatLng=function([t,e,r]){const n=Math.hypot(t,e,r),i=Math.atan2(t,r),s=.5*Math.PI-Math.acos(-e/n);return new Ol(_(i),_(s))},t.emitValidationErrors=qi,t.endsWith=U,t.enforceCacheSizeLimit=function(t){st(),rt&&rt.then((e=>{e.keys().then((r=>{for(let n=0;n<r.length-t;n++)e.delete(r[n]);}));}));},t.evaluateSizeForFeature=jh,t.evaluateSizeForZoom=Oh,t.evaluateVariableOffset=xd,t.evented=gs,t.exactEquals=function(t,e){return t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]},t.exactEquals$1=function(t,e){return t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]},t.exported=Xt,t.exported$1=s,t.extend=C,t.extend$1=ee,t.fillExtrusionHeightLift=oh,t.filterObject=j,t.fromMat4=function(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[4],t[4]=e[5],t[5]=e[6],t[6]=e[8],t[7]=e[9],t[8]=e[10],t},t.fromQuat=function(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=r+r,o=n+n,l=i+i,u=r*a,c=n*a,h=n*o,p=i*a,d=i*o,f=i*l,y=s*a,m=s*o,g=s*l;return t[0]=1-h-f,t[1]=c+g,t[2]=p-m,t[3]=0,t[4]=c-g,t[5]=1-u-f,t[6]=d+y,t[7]=0,t[8]=p+m,t[9]=d-y,t[10]=1-u-h,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.fromScaling=bo,t.furthestTileCorner=function(t){const e=Math.round((t+45+360)%360/90)%4;return A[e]},t.getAABBPointSquareDist=function(t,e,r){let n=0;for(let i=0;i<2;++i){const s=r?r[i]:0;t[i]>s&&(n+=(t[i]-s)*(t[i]-s)),e[i]<s&&(n+=(s-e[i])*(s-e[i]));}return n},t.getAnchorAlignment=Rp,t.getAnchorJustification=bd,t.getBounds=function(t){let e=1/0,r=1/0,n=-1/0,i=-1/0;for(const s of t)e=Math.min(e,s.x),r=Math.min(r,s.y),n=Math.max(n,s.x),i=Math.max(i,s.y);return {min:new x(e,r),max:new x(n,i)}},t.getColumn=W,t.getDefaultExportFromCjs=p,t.getGridMatrix=function(t,e,r,n){const i=e.getNorth(),s=e.getSouth(),a=e.getWest(),o=e.getEast(),l=1<<t.z,u=o-a,c=i-s,h=u/ul,p=-c/cl[r],d=[0,h,0,p,0,0,i,a,0];if(t.z>0){const t=180/n;ho(d,d,[t/u+1,0,0,0,t/c+1,0,-.5*t/h,.5*t/p,1]);}return d[2]=l,d[5]=t.x,d[8]=t.y,d},t.getImage=gt,t.getJSON=function(t,e){return ht(C(t,{type:"json"}),e)},t.getLatitudinalLod=function(t){const e=Hl-5;t=M(t,-e,e)/e*90;const r=Math.pow(Math.abs(Math.sin(w(t))),3);return Math.round(r*(cl.length-1))},t.getMapSessionAPI=Ft,t.getPerformanceMeasurement=qt,t.getProjection=Yd,t.getRTLTextPluginStatus=xs,t.getReferrer=ct,t.getTilePoint=function(t,{x:e,y:r},n=0){return new x(((e-n)*t.scale-t.x)*ao,(r*t.scale-t.y)*ao)},t.getTileVec3=function(t,e,r=0){return Io(((e.x-r)*t.scale-t.x)*ao,(e.y*t.scale-t.y)*ao,Jl(e.z,e.y))},t.getVideo=function(t,r){const n=e.document.createElement("video");n.muted=!0,n.onloadstart=function(){r(null,n);};for(let r=0;r<t.length;r++){const i=e.document.createElement("source");dt(t[r])||(n.crossOrigin="Anonymous"),i.src=t[r],n.appendChild(i);}return {cancel:()=>{}}},t.globeCenterToScreenPoint=function(t){const e=[0,0,0],r=po(new Float64Array(16));return yo(r,t.pixelMatrix,t.globeMatrix),Fo(e,e,r),new x(e[0],e[1])},t.globeDenormalizeECEF=El,t.globeECEFOrigin=function(t,e){const r=[0,0,0];return Fo(r,r,Bl(xl(e.canonical))),Fo(r,r,t),r},t.globeMetersToEcef=fl,t.globeNormalizeECEF=Bl,t.globePixelsToTileUnits=function(t,e){return ao/(512*Math.pow(2,t))*Tl(xl(e))},t.globePoleMatrixForTile=function(t,e,r){const n=po(new Float64Array(16)),i=(e/(1<<t)-.5)*Math.PI*2;return vo(n,r.globeMatrix,i),Float32Array.from(n)},t.globeTileBounds=xl,t.globeTiltAtLngLat=Dl,t.globeToMercatorTransition=Pl,t.globeUseCustomAntiAliasing=function(t,e,r){const n=Pl(r.zoom),i=t.style.map._antialias,s=!!e.extStandardDerivatives,a=e.extStandardDerivativesForceOff||t.terrain&&t.terrain.exaggeration()>0;return 0===n&&!i&&!a&&s},t.identity=po,t.identity$1=Ko,t.invert=fo,t.isFullscreen=function(){return !!e.document.fullscreenElement||!!e.document.webkitFullscreenElement},t.isLngLatBehindGlobe=Vl,t.isMapAuthenticated=function(t){return Rt.has(t)},t.isMapboxURL=vt,t.isSafariWithAntialiasingBug=function(t){const e=t.navigator?t.navigator.userAgent:null;return !!H(t)&&e&&(e.match("Version/15.4")||e.match("Version/15.5")||e.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/))},t.latFromMercatorY=Xl,t.latLngToECEF=Il,t.len=Oo,t.length=ko,t.length$1=function(t){return Math.hypot(t[0],t[1],t[2],t[3])},t.lngFromMercatorX=Kl,t.loadVectorTile=yy,t.makeRequest=ht,t.mapValue=function(t,e,r,n,i){return M((t-e)/(r-e)*(i-n)+n,n,i)},t.mercatorScale=Yl,t.mercatorXfromLng=Nl,t.mercatorYfromLat=Gl,t.mercatorZfromAltitude=Zl,t.mul=_o,t.mul$1=jo,t.multiply=yo,t.multiply$1=ho,t.multiply$2=zo,t.nextPowerOfTwo=L,t.normalize=Do,t.normalize$1=Ho,t.normalize$2=No,t.number=Er,t.ortho=function(t,e,r,n,i,s,a){var o=1/(e-r),l=1/(n-i),u=1/(s-a);return t[0]=-2*o,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*l,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*u,t[11]=0,t[12]=(e+r)*o,t[13]=(i+n)*l,t[14]=(a+s)*u,t[15]=1,t},t.pbf=Xh,t.perspective=function(t,e,r,n,i){var s,a=1/Math.tan(e/2);return t[0]=a/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=a,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=i&&i!==1/0?(t[10]=(i+n)*(s=1/(n-i)),t[14]=2*i*n*s):(t[10]=-1,t[14]=-2*n),t},t.pick=function(t,e){const r={};for(let n=0;n<e.length;n++){const i=e[n];i in t&&(r[i]=t[i]);}return r},t.plugin=bs,t.pointGeometry=m,t.polesInViewport=function(t){const e=po(new Float64Array(16));yo(e,t.pixelMatrix,t.globeMatrix);const r=[0,hl,0],n=[0,pl,0];return Fo(r,r,e),Fo(n,n,e),[r[0]>0&&r[0]<=t.width&&r[1]>0&&r[1]<=t.height&&!Vl(t,new Ol(t.center.lat,90)),n[0]>0&&n[0]<=t.width&&n[1]>0&&n[1]<=t.height&&!Vl(t,new Ol(t.center.lat,-90))]},t.polygonContainsPoint=bu,t.polygonIntersectsBox=wu,t.polygonIntersectsPolygon=hu,t.polygonizeBounds=function(t,e,r=0,n=!0){const i=new x(r,r),s=t.sub(i),a=e.add(i),o=[s,new x(a.x,s.y),a,new x(s.x,a.y)];return n&&o.push(s.clone()),o},t.posAttributes=tl,t.postMapLoadEvent=Pt,t.postPerformanceEvent=Vt,t.postTurnstileEvent=Et,t.potpack=_p,t.prevPowerOfTwo=function(t){return t<=1?1:Math.pow(2,Math.floor(Math.log(t)/Math.LN2))},t.radToDeg=_,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.registerForPluginStateChange=function(t){return t({pluginStatus:ds,pluginURL:fs}),gs.on("pluginStateChange",t),t},t.removeAuthState=function(t){Rt.delete(t);},t.renderColorRamp=ju,t.resample=tu,t.rotateX=xo,t.rotateX$1=Xo,t.rotateY=vo,t.rotateY$1=Jo,t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),s=e[0],a=e[1],o=e[2],l=e[3],u=e[4],c=e[5],h=e[6],p=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=s*i+u*n,t[1]=a*i+c*n,t[2]=o*i+h*n,t[3]=l*i+p*n,t[4]=u*i-s*n,t[5]=c*i-a*n,t[6]=h*i-o*n,t[7]=p*i-l*n,t},t.rotateZ$1=function(t,e,r){r*=.5;var n=e[0],i=e[1],s=e[2],a=e[3],o=Math.sin(r),l=Math.cos(r);return t[0]=n*l+i*o,t[1]=i*l-n*o,t[2]=s*l+a*o,t[3]=a*l-s*o,t},t.scale=go,t.scale$1=qo,t.scale$2=Co,t.scaleAndAdd=Po,t.set=function(t,e,r,n){return t[0]=e,t[1]=r,t[2]=n,t},t.setCacheLimits=function(t,e){tt=t,et=e;},t.setColumn=function(t,e,r){t[4*e+0]=r[0],t[4*e+1]=r[1],t[4*e+2]=r[2],t[4*e+3]=r[3];},t.setRTLTextPlugin=function(t,e,r=!1){if(ds===us||ds===cs||ds===hs)throw new Error("setRTLTextPlugin cannot be called multiple times.");fs=Xt.resolveURL(t),ds=us,ps=e,ms(),r||vs();},t.smoothstep=T,t.spec=te,t.squaredLength=function(t){var e=t[0],r=t[1],n=t[2];return e*e+r*r+n*n},t.storeAuthState=function(t,e){e?Rt.add(t):Rt.delete(t);},t.sub=$o,t.subtract=To,t.symbolSize=qh,t.tileAABB=function(t,e,r,n,i,s,a,o,l){if("globe"===l.name)return _l(t,e,new ph(r,n,i));const u=Bd({z:r,x:n,y:i},l);return new il([(s+u.x/u.scale)*e,e*(u.y/u.scale),a],[(s+u.x2/u.scale)*e,e*(u.y2/u.scale),o])},t.tileCornersToBounds=Al,t.tileTransform=Bd,t.transformMat3=function(t,e,r){var n=e[0],i=e[1],s=e[2];return t[0]=n*r[0]+i*r[3]+s*r[6],t[1]=n*r[1]+i*r[4]+s*r[7],t[2]=n*r[2]+i*r[5]+s*r[8],t},t.transformMat4=Fo,t.transformMat4$1=Go,t.transformQuat=Ro,t.transitionTileAABBinECEF=bl,t.translate=mo,t.transpose=function(t,e){if(t===e){var r=e[1],n=e[2],i=e[5];t[1]=e[3],t[2]=e[6],t[3]=r,t[5]=e[7],t[6]=n,t[7]=i;}else t[0]=e[0],t[1]=e[3],t[2]=e[6],t[3]=e[1],t[4]=e[4],t[5]=e[7],t[6]=e[2],t[7]=e[5],t[8]=e[8];return t},t.triggerPluginCompletionEvent=ys,t.uniqueId=D,t.updateGlobeVertexNormal=function(t,e,r,n,i){const s=5*e+2;t.float32[s+0]=r,t.float32[s+1]=n,t.float32[s+2]=i;},t.validateCustomStyleLayer=function(t){const e=[],r=t.id;return void 0===r&&e.push({message:`layers.${r}: missing required property "id"`}),void 0===t.render&&e.push({message:`layers.${r}: missing required method "render"`}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:`layers.${r}: property "renderingMode" must be either "2d" or "3d"`}),e},t.validateFilter=t=>Oi(Ai(t)),t.validateFog=t=>Oi(Vi(t)),t.validateLayer=t=>Oi(Ti(t)),t.validateLight=t=>Oi(Pi(t)),t.validateSource=t=>Oi(Ei(t)),t.validateStyle=Ui,t.validateTerrain=t=>Oi(Di(t)),t.values=E,t.vectorTile=Dc,t.version=r,t.warnOnce=N,t.window=e,t.wrap=z;}));

define(["./shared"],(function(e){"use strict";function t(e){if("number"==typeof e||"boolean"==typeof e||"string"==typeof e||null==e)return JSON.stringify(e);if(Array.isArray(e)){let r="[";for(const o of e)r+=`${t(o)},`;return `${r}]`}let r="{";for(const o of Object.keys(e).sort())r+=`${o}:${t(e[o])},`;return `${r}}`}function r(r){let o="";for(const i of e.refProperties)o+=`/${t(r[i])}`;return o}class o{constructor(e){this.keyCache={},e&&this.replace(e);}replace(e){this._layerConfigs={},this._layers={},this.update(e,[]);}update(t,o){for(const r of t)this._layerConfigs[r.id]=r,(this._layers[r.id]=e.createStyleLayer(r)).compileFilter(),this.keyCache[r.id]&&delete this.keyCache[r.id];for(const e of o)delete this.keyCache[e],delete this._layerConfigs[e],delete this._layers[e];this.familiesBySource={};const i=function(e,t){const o={};for(let i=0;i<e.length;i++){const n=t&&t[e[i].id]||r(e[i]);t&&(t[e[i].id]=n);let s=o[n];s||(s=o[n]=[]),s.push(e[i]);}const i=[];for(const e in o)i.push(o[e]);return i}(e.values(this._layerConfigs),this.keyCache);for(const e of i){const t=e.map((e=>this._layers[e.id])),r=t[0];if("none"===r.visibility)continue;const o=r.source||"";let i=this.familiesBySource[o];i||(i=this.familiesBySource[o]={});const n=r.sourceLayer||"_geojsonTileLayer";let s=i[n];s||(s=i[n]=[]),s.push(t);}}}class i{loadTile(t,r){const{uid:o,encoding:i,rawImageData:n,padding:s,buildQuadTree:a}=t,l=e.window.ImageBitmap&&n instanceof e.window.ImageBitmap?this.getImageData(n,s):n;r(null,new e.DEMData(o,l,i,s<1,a));}getImageData(e,t){this.offscreenCanvas&&this.offscreenCanvasContext||(this.offscreenCanvas=new OffscreenCanvas(e.width,e.height),this.offscreenCanvasContext=this.offscreenCanvas.getContext("2d",{willReadFrequently:!0})),this.offscreenCanvas.width=e.width,this.offscreenCanvas.height=e.height,this.offscreenCanvasContext.drawImage(e,0,0,e.width,e.height);const r=this.offscreenCanvasContext.getImageData(-t,-t,e.width+2*t,e.height+2*t);return this.offscreenCanvasContext.clearRect(0,0,this.offscreenCanvas.width,this.offscreenCanvas.height),r}}function n(e,t){if(0!==e.length){s(e[0],t);for(var r=1;r<e.length;r++)s(e[r],!t);}}function s(e,t){for(var r=0,o=0,i=0,n=e.length,s=n-1;i<n;s=i++){var a=(e[i][0]-e[s][0])*(e[s][1]+e[i][1]),l=r+a;o+=Math.abs(r)>=Math.abs(a)?r-l+a:a-l+r,r=l;}r+o>=0!=!!t&&e.reverse();}var a=e.getDefaultExportFromCjs((function e(t,r){var o,i=t&&t.type;if("FeatureCollection"===i)for(o=0;o<t.features.length;o++)e(t.features[o],r);else if("GeometryCollection"===i)for(o=0;o<t.geometries.length;o++)e(t.geometries[o],r);else if("Feature"===i)e(t.geometry,r);else if("Polygon"===i)n(t.coordinates,r);else if("MultiPolygon"===i)for(o=0;o<t.coordinates.length;o++)n(t.coordinates[o],r);return t}));const l=e.VectorTileFeature.prototype.toGeoJSON;var u={exports:{}},h=e.pointGeometry,c=e.vectorTile.VectorTileFeature,f=p;function p(e,t){this.options=t||{},this.features=e,this.length=e.length;}function g(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}p.prototype.feature=function(e){return new g(this.features[e],this.options.extent)},g.prototype.loadGeometry=function(){var e=this.rawGeometry;this.geometry=[];for(var t=0;t<e.length;t++){for(var r=e[t],o=[],i=0;i<r.length;i++)o.push(new h(r[i][0],r[i][1]));this.geometry.push(o);}return this.geometry},g.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,o=1/0,i=-1/0,n=0;n<e.length;n++)for(var s=e[n],a=0;a<s.length;a++){var l=s[a];t=Math.min(t,l.x),r=Math.max(r,l.x),o=Math.min(o,l.y),i=Math.max(i,l.y);}return [t,o,r,i]},g.prototype.toGeoJSON=c.prototype.toGeoJSON;var d=e.pbf,m=f;function y(e){var t=new d;return function(e,t){for(var r in e.layers)t.writeMessage(3,v,e.layers[r]);}(e,t),t.finish()}function v(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var o={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)o.feature=e.feature(r),t.writeMessage(2,x,o);var i=o.keys;for(r=0;r<i.length;r++)t.writeStringField(3,i[r]);var n=o.values;for(r=0;r<n.length;r++)t.writeMessage(4,b,n[r]);}function x(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,w,e),t.writeVarintField(3,r.type),t.writeMessage(4,P,r);}function w(e,t){var r=e.feature,o=e.keys,i=e.values,n=e.keycache,s=e.valuecache;for(var a in r.properties){var l=r.properties[a],u=n[a];if(null!==l){void 0===u&&(o.push(a),n[a]=u=o.length-1),t.writeVarint(u);var h=typeof l;"string"!==h&&"boolean"!==h&&"number"!==h&&(l=JSON.stringify(l));var c=h+":"+l,f=s[c];void 0===f&&(i.push(l),s[c]=f=i.length-1),t.writeVarint(f);}}}function S(e,t){return (t<<3)+(7&e)}function M(e){return e<<1^e>>31}function P(e,t){for(var r=e.loadGeometry(),o=e.type,i=0,n=0,s=r.length,a=0;a<s;a++){var l=r[a],u=1;1===o&&(u=l.length),t.writeVarint(S(1,u));for(var h=3===o?l.length-1:l.length,c=0;c<h;c++){1===c&&1!==o&&t.writeVarint(S(2,h-1));var f=l[c].x-i,p=l[c].y-n;t.writeVarint(M(f)),t.writeVarint(M(p)),i+=f,n+=p;}3===o&&t.writeVarint(S(7,1));}}function b(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}u.exports=y,u.exports.fromVectorTileJs=y,u.exports.fromGeojsonVt=function(e,t){t=t||{};var r={};for(var o in e)r[o]=new m(e[o].features,t),r[o].name=o,r[o].version=t.version,r[o].extent=t.extent;return y({layers:r})},u.exports.GeoJSONWrapper=m;var T=e.getDefaultExportFromCjs(u.exports);const k={minZoom:0,maxZoom:16,minPoints:2,radius:40,extent:512,nodeSize:64,log:!1,generateId:!1,reduce:null,map:e=>e},I=Math.fround||(_=new Float32Array(1),e=>(_[0]=+e,_[0]));var _;const C=3,L=5,O=6;class E{constructor(e){this.options=Object.assign(Object.create(k),e),this.trees=new Array(this.options.maxZoom+1),this.stride=this.options.reduce?7:6,this.clusterProps=[];}load(e){const{log:t,minZoom:r,maxZoom:o}=this.options;t&&console.time("total time");const i=`prepare ${e.length} points`;t&&console.time(i),this.points=e;const n=[];for(let t=0;t<e.length;t++){const r=e[t];if(!r.geometry)continue;const[o,i]=r.geometry.coordinates,s=I(N(o)),a=I(Z(i));n.push(s,a,1/0,t,-1,1),this.options.reduce&&n.push(0);}let s=this.trees[o+1]=this._createTree(n);t&&console.timeEnd(i);for(let e=o;e>=r;e--){const r=+Date.now();s=this.trees[e]=this._createTree(this._cluster(s,e)),t&&console.log("z%d: %d clusters in %dms",e,s.numItems,+Date.now()-r);}return t&&console.timeEnd("total time"),this}getClusters(e,t){let r=((e[0]+180)%360+360)%360-180;const o=Math.max(-90,Math.min(90,e[1]));let i=180===e[2]?180:((e[2]+180)%360+360)%360-180;const n=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,i=180;else if(r>i){const e=this.getClusters([r,o,180,n],t),s=this.getClusters([-180,o,i,n],t);return e.concat(s)}const s=this.trees[this._limitZoom(t)],a=s.range(N(r),Z(n),N(i),Z(o)),l=s.data,u=[];for(const e of a){const t=this.stride*e;u.push(l[t+L]>1?j(l,t,this.clusterProps):this.points[l[t+C]]);}return u}getChildren(e){const t=this._getOriginId(e),r=this._getOriginZoom(e),o="No cluster with the specified id.",i=this.trees[r];if(!i)throw new Error(o);const n=i.data;if(t*this.stride>=n.length)throw new Error(o);const s=this.options.radius/(this.options.extent*Math.pow(2,r-1)),a=i.within(n[t*this.stride],n[t*this.stride+1],s),l=[];for(const t of a){const r=t*this.stride;n[r+4]===e&&l.push(n[r+L]>1?j(n,r,this.clusterProps):this.points[n[r+C]]);}if(0===l.length)throw new Error(o);return l}getLeaves(e,t,r){const o=[];return this._appendLeaves(o,e,t=t||10,r=r||0,0),o}getTile(e,t,r){const o=this.trees[this._limitZoom(e)],i=Math.pow(2,e),{extent:n,radius:s}=this.options,a=s/n,l=(r-a)/i,u=(r+1+a)/i,h={features:[]};return this._addTileFeatures(o.range((t-a)/i,l,(t+1+a)/i,u),o.data,t,r,i,h),0===t&&this._addTileFeatures(o.range(1-a/i,l,1,u),o.data,i,r,i,h),t===i-1&&this._addTileFeatures(o.range(0,l,a/i,u),o.data,-1,r,i,h),h.features.length?h:null}getClusterExpansionZoom(e){let t=this._getOriginZoom(e)-1;for(;t<=this.options.maxZoom;){const r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t}_appendLeaves(e,t,r,o,i){const n=this.getChildren(t);for(const t of n){const n=t.properties;if(n&&n.cluster?i+n.point_count<=o?i+=n.point_count:i=this._appendLeaves(e,n.cluster_id,r,o,i):i<o?i++:e.push(t),e.length===r)break}return i}_createTree(t){const r=new e.KDBush(t.length/this.stride|0,this.options.nodeSize,Float32Array);for(let e=0;e<t.length;e+=this.stride)r.add(t[e],t[e+1]);return r.finish(),r.data=t,r}_addTileFeatures(e,t,r,o,i,n){for(const s of e){const e=s*this.stride,a=t[e+L]>1;let l,u,h;if(a)l=F(t,e,this.clusterProps),u=t[e],h=t[e+1];else {const r=this.points[t[e+C]];l=r.properties;const[o,i]=r.geometry.coordinates;u=N(o),h=Z(i);}const c={type:1,geometry:[[Math.round(this.options.extent*(u*i-r)),Math.round(this.options.extent*(h*i-o))]],tags:l};let f;f=a||this.options.generateId?t[e+C]:this.points[t[e+C]].id,void 0!==f&&(c.id=f),n.features.push(c);}}_limitZoom(e){return Math.max(this.options.minZoom,Math.min(Math.floor(+e),this.options.maxZoom+1))}_cluster(e,t){const{radius:r,extent:o,reduce:i,minPoints:n}=this.options,s=r/(o*Math.pow(2,t)),a=e.data,l=[],u=this.stride;for(let r=0;r<a.length;r+=u){if(a[r+2]<=t)continue;a[r+2]=t;const o=a[r],h=a[r+1],c=e.within(a[r],a[r+1],s),f=a[r+L];let p=f;for(const e of c){const r=e*u;a[r+2]>t&&(p+=a[r+L]);}if(p>f&&p>=n){let e,n=o*f,s=h*f,g=-1;const d=((r/u|0)<<5)+(t+1)+this.points.length;for(const o of c){const l=o*u;if(a[l+2]<=t)continue;a[l+2]=t;const h=a[l+L];n+=a[l]*h,s+=a[l+1]*h,a[l+4]=d,i&&(e||(e=this._map(a,r,!0),g=this.clusterProps.length,this.clusterProps.push(e)),i(e,this._map(a,l)));}a[r+4]=d,l.push(n/p,s/p,1/0,d,-1,p),i&&l.push(g);}else {for(let e=0;e<u;e++)l.push(a[r+e]);if(p>1)for(const e of c){const r=e*u;if(!(a[r+2]<=t)){a[r+2]=t;for(let e=0;e<u;e++)l.push(a[r+e]);}}}}return l}_getOriginId(e){return e-this.points.length>>5}_getOriginZoom(e){return (e-this.points.length)%32}_map(e,t,r){if(e[t+L]>1){const o=this.clusterProps[e[t+O]];return r?Object.assign({},o):o}const o=this.points[e[t+C]].properties,i=this.options.map(o);return r&&i===o?Object.assign({},i):i}}function j(e,t,r){return {type:"Feature",id:e[t+C],properties:F(e,t,r),geometry:{type:"Point",coordinates:[(o=e[t],360*(o-.5)),J(e[t+1])]}};var o;}function F(e,t,r){const o=e[t+L],i=o>=1e4?`${Math.round(o/1e3)}k`:o>=1e3?Math.round(o/100)/10+"k":o,n=e[t+O],s=-1===n?{}:Object.assign({},r[n]);return Object.assign(s,{cluster:!0,cluster_id:e[t+C],point_count:o,point_count_abbreviated:i})}function N(e){return e/360+.5}function Z(e){const t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function J(e){const t=(180-360*e)*Math.PI/180;return 360*Math.atan(Math.exp(t))/Math.PI-90}function z(e,t,r,o){for(var i,n=o,s=r-t>>1,a=r-t,l=e[t],u=e[t+1],h=e[r],c=e[r+1],f=t+3;f<r;f+=3){var p=G(e[f],e[f+1],l,u,h,c);if(p>n)i=f,n=p;else if(p===n){var g=Math.abs(f-s);g<a&&(i=f,a=g);}}n>o&&(i-t>3&&z(e,t,i,o),e[i+2]=n,r-i>3&&z(e,i,r,o));}function G(e,t,r,o,i,n){var s=i-r,a=n-o;if(0!==s||0!==a){var l=((e-r)*s+(t-o)*a)/(s*s+a*a);l>1?(r=i,o=n):l>0&&(r+=s*l,o+=a*l);}return (s=e-r)*s+(a=t-o)*a}function W(e,t,r,o){var i={id:void 0===e?null:e,type:t,geometry:r,tags:o,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)Y(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var o=0;o<t.length;o++)Y(e,t[o]);else if("MultiPolygon"===r)for(o=0;o<t.length;o++)for(var i=0;i<t[o].length;i++)Y(e,t[o][i]);}(i),i}function Y(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function X(e,t,r,o){if(t.geometry){var i=t.geometry.coordinates,n=t.geometry.type,s=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),a=[],l=t.id;if(r.promoteId?l=t.properties[r.promoteId]:r.generateId&&(l=o||0),"Point"===n)V(i,a);else if("MultiPoint"===n)for(var u=0;u<i.length;u++)V(i[u],a);else if("LineString"===n)D(i,a,s,!1);else if("MultiLineString"===n){if(r.lineMetrics){for(u=0;u<i.length;u++)D(i[u],a=[],s,!1),e.push(W(l,"LineString",a,t.properties));return}$(i,a,s,!1);}else if("Polygon"===n)$(i,a,s,!0);else {if("MultiPolygon"!==n){if("GeometryCollection"===n){for(u=0;u<t.geometry.geometries.length;u++)X(e,{id:l,geometry:t.geometry.geometries[u],properties:t.properties},r,o);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<i.length;u++){var h=[];$(i[u],h,s,!0),a.push(h);}}e.push(W(l,n,a,t.properties));}}function V(e,t){t.push(A(e[0])),t.push(B(e[1])),t.push(0);}function D(e,t,r,o){for(var i,n,s=0,a=0;a<e.length;a++){var l=A(e[a][0]),u=B(e[a][1]);t.push(l),t.push(u),t.push(0),a>0&&(s+=o?(i*u-l*n)/2:Math.sqrt(Math.pow(l-i,2)+Math.pow(u-n,2))),i=l,n=u;}var h=t.length-3;t[2]=1,z(t,0,h,r),t[h+2]=1,t.size=Math.abs(s),t.start=0,t.end=t.size;}function $(e,t,r,o){for(var i=0;i<e.length;i++){var n=[];D(e[i],n,r,o),t.push(n);}}function A(e){return e/360+.5}function B(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function R(e,t,r,o,i,n,s,a){if(o/=t,n>=(r/=t)&&s<o)return e;if(s<r||n>=o)return null;for(var l=[],u=0;u<e.length;u++){var h=e[u],c=h.geometry,f=h.type,p=0===i?h.minX:h.minY,g=0===i?h.maxX:h.maxY;if(p>=r&&g<o)l.push(h);else if(!(g<r||p>=o)){var d=[];if("Point"===f||"MultiPoint"===f)q(c,d,r,o,i);else if("LineString"===f)Q(c,d,r,o,i,!1,a.lineMetrics);else if("MultiLineString"===f)K(c,d,r,o,i,!1);else if("Polygon"===f)K(c,d,r,o,i,!0);else if("MultiPolygon"===f)for(var m=0;m<c.length;m++){var y=[];K(c[m],y,r,o,i,!0),y.length&&d.push(y);}if(d.length){if(a.lineMetrics&&"LineString"===f){for(m=0;m<d.length;m++)l.push(W(h.id,f,d[m],h.tags));continue}"LineString"!==f&&"MultiLineString"!==f||(1===d.length?(f="LineString",d=d[0]):f="MultiLineString"),"Point"!==f&&"MultiPoint"!==f||(f=3===d.length?"Point":"MultiPoint"),l.push(W(h.id,f,d,h.tags));}}}return l.length?l:null}function q(e,t,r,o,i){for(var n=0;n<e.length;n+=3){var s=e[n+i];s>=r&&s<=o&&(t.push(e[n]),t.push(e[n+1]),t.push(e[n+2]));}}function Q(e,t,r,o,i,n,s){for(var a,l,u=U(e),h=0===i?ee:te,c=e.start,f=0;f<e.length-3;f+=3){var p=e[f],g=e[f+1],d=e[f+2],m=e[f+3],y=e[f+4],v=0===i?p:g,x=0===i?m:y,w=!1;s&&(a=Math.sqrt(Math.pow(p-m,2)+Math.pow(g-y,2))),v<r?x>r&&(l=h(u,p,g,m,y,r),s&&(u.start=c+a*l)):v>o?x<o&&(l=h(u,p,g,m,y,o),s&&(u.start=c+a*l)):H(u,p,g,d),x<r&&v>=r&&(l=h(u,p,g,m,y,r),w=!0),x>o&&v<=o&&(l=h(u,p,g,m,y,o),w=!0),!n&&w&&(s&&(u.end=c+a*l),t.push(u),u=U(e)),s&&(c+=a);}var S=e.length-3;p=e[S],g=e[S+1],d=e[S+2],(v=0===i?p:g)>=r&&v<=o&&H(u,p,g,d),S=u.length-3,n&&S>=3&&(u[S]!==u[0]||u[S+1]!==u[1])&&H(u,u[0],u[1],u[2]),u.length&&t.push(u);}function U(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function K(e,t,r,o,i,n){for(var s=0;s<e.length;s++)Q(e[s],t,r,o,i,n,!1);}function H(e,t,r,o){e.push(t),e.push(r),e.push(o);}function ee(e,t,r,o,i,n){var s=(n-t)/(o-t);return e.push(n),e.push(r+(i-r)*s),e.push(1),s}function te(e,t,r,o,i,n){var s=(n-r)/(i-r);return e.push(t+(o-t)*s),e.push(n),e.push(1),s}function re(e,t){for(var r=[],o=0;o<e.length;o++){var i,n=e[o],s=n.type;if("Point"===s||"MultiPoint"===s||"LineString"===s)i=oe(n.geometry,t);else if("MultiLineString"===s||"Polygon"===s){i=[];for(var a=0;a<n.geometry.length;a++)i.push(oe(n.geometry[a],t));}else if("MultiPolygon"===s)for(i=[],a=0;a<n.geometry.length;a++){for(var l=[],u=0;u<n.geometry[a].length;u++)l.push(oe(n.geometry[a][u],t));i.push(l);}r.push(W(n.id,s,i,n.tags));}return r}function oe(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var o=0;o<e.length;o+=3)r.push(e[o]+t,e[o+1],e[o+2]);return r}function ie(e,t){if(e.transformed)return e;var r,o,i,n=1<<e.z,s=e.x,a=e.y;for(r=0;r<e.features.length;r++){var l=e.features[r],u=l.geometry,h=l.type;if(l.geometry=[],1===h)for(o=0;o<u.length;o+=2)l.geometry.push(ne(u[o],u[o+1],t,n,s,a));else for(o=0;o<u.length;o++){var c=[];for(i=0;i<u[o].length;i+=2)c.push(ne(u[o][i],u[o][i+1],t,n,s,a));l.geometry.push(c);}}return e.transformed=!0,e}function ne(e,t,r,o,i,n){return [Math.round(r*(e*o-i)),Math.round(r*(t*o-n))]}function se(e,t,r,o,i){for(var n=t===i.maxZoom?0:i.tolerance/((1<<t)*i.extent),s={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:o,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},a=0;a<e.length;a++){s.numFeatures++,ae(s,e[a],n,i);var l=e[a].minX,u=e[a].minY,h=e[a].maxX,c=e[a].maxY;l<s.minX&&(s.minX=l),u<s.minY&&(s.minY=u),h>s.maxX&&(s.maxX=h),c>s.maxY&&(s.maxY=c);}return s}function ae(e,t,r,o){var i=t.geometry,n=t.type,s=[];if("Point"===n||"MultiPoint"===n)for(var a=0;a<i.length;a+=3)s.push(i[a]),s.push(i[a+1]),e.numPoints++,e.numSimplified++;else if("LineString"===n)le(s,i,e,r,!1,!1);else if("MultiLineString"===n||"Polygon"===n)for(a=0;a<i.length;a++)le(s,i[a],e,r,"Polygon"===n,0===a);else if("MultiPolygon"===n)for(var l=0;l<i.length;l++){var u=i[l];for(a=0;a<u.length;a++)le(s,u[a],e,r,!0,0===a);}if(s.length){var h=t.tags||null;if("LineString"===n&&o.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=i.start/i.size,h.mapbox_clip_end=i.end/i.size;}var f={geometry:s,type:"Polygon"===n||"MultiPolygon"===n?3:"LineString"===n||"MultiLineString"===n?2:1,tags:h};null!==t.id&&(f.id=t.id),e.features.push(f);}}function le(e,t,r,o,i,n){var s=o*o;if(o>0&&t.size<(i?s:o))r.numPoints+=t.length/3;else {for(var a=[],l=0;l<t.length;l+=3)(0===o||t[l+2]>s)&&(r.numSimplified++,a.push(t[l]),a.push(t[l+1])),r.numPoints++;i&&function(e,t){for(var r=0,o=0,i=e.length,n=i-2;o<i;n=o,o+=2)r+=(e[o]-e[n])*(e[o+1]+e[n+1]);if(r>0===t)for(o=0,i=e.length;o<i/2;o+=2){var s=e[o],a=e[o+1];e[o]=e[i-2-o],e[o+1]=e[i-1-o],e[i-2-o]=s,e[i-1-o]=a;}}(a,n),e.push(a);}}function ue(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var o=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var o=0;o<e.features.length;o++)X(r,e.features[o],t,o);else X(r,"Feature"===e.type?e:{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),o=function(e,t){var r=t.buffer/t.extent,o=e,i=R(e,1,-1-r,r,0,-1,2,t),n=R(e,1,1-r,2+r,0,-1,2,t);return (i||n)&&(o=R(e,1,-r,1+r,0,-1,2,t)||[],i&&(o=re(i,1).concat(o)),n&&(o=o.concat(re(n,-1)))),o}(o,t),o.length&&this.splitTile(o,0,0,0),r&&(o.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function he(e,t,r){return 32*((1<<e)*r+t)+e}function ce(t,r){const o=t.tileID.canonical;if(!this._geoJSONIndex)return r(null,null);const i=this._geoJSONIndex.getTile(o.z,o.x,o.y);if(!i)return r(null,null);const n=new class{constructor(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;}feature(t){return new class{constructor(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));}loadGeometry(){if(1===this._feature.type){const t=[];for(const r of this._feature.geometry)t.push([new e.Point(r[0],r[1])]);return t}{const t=[];for(const r of this._feature.geometry){const o=[];for(const t of r)o.push(new e.Point(t[0],t[1]));t.push(o);}return t}}toGeoJSON(e,t,r){return l.call(this,e,t,r)}}(this._features[t])}}(i.features);let s=T(n);0===s.byteOffset&&s.byteLength===s.buffer.byteLength||(s=new Uint8Array(s)),r(null,{vectorTile:n,rawData:s.buffer});}ue.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},ue.prototype.splitTile=function(e,t,r,o,i,n,s){for(var a=[e,t,r,o],l=this.options,u=l.debug;a.length;){o=a.pop(),r=a.pop(),t=a.pop(),e=a.pop();var h=1<<t,c=he(t,r,o),f=this.tiles[c];if(!f&&(u>1&&console.time("creation"),f=this.tiles[c]=se(e,t,r,o,l),this.tileCoords.push({z:t,x:r,y:o}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,o,f.numFeatures,f.numPoints,f.numSimplified),console.timeEnd("creation"));var p="z"+t;this.stats[p]=(this.stats[p]||0)+1,this.total++;}if(f.source=e,i){if(t===l.maxZoom||t===i)continue;var g=1<<i-t;if(r!==Math.floor(n/g)||o!==Math.floor(s/g))continue}else if(t===l.indexMaxZoom||f.numPoints<=l.indexMaxPoints)continue;if(f.source=null,0!==e.length){u>1&&console.time("clipping");var d,m,y,v,x,w,S=.5*l.buffer/l.extent,M=.5-S,P=.5+S,b=1+S;d=m=y=v=null,x=R(e,h,r-S,r+P,0,f.minX,f.maxX,l),w=R(e,h,r+M,r+b,0,f.minX,f.maxX,l),e=null,x&&(d=R(x,h,o-S,o+P,1,f.minY,f.maxY,l),m=R(x,h,o+M,o+b,1,f.minY,f.maxY,l),x=null),w&&(y=R(w,h,o-S,o+P,1,f.minY,f.maxY,l),v=R(w,h,o+M,o+b,1,f.minY,f.maxY,l),w=null),u>1&&console.timeEnd("clipping"),a.push(d||[],t+1,2*r,2*o),a.push(m||[],t+1,2*r,2*o+1),a.push(y||[],t+1,2*r+1,2*o),a.push(v||[],t+1,2*r+1,2*o+1);}}},ue.prototype.getTile=function(e,t,r){var o=this.options,i=o.extent,n=o.debug;if(e<0||e>24)return null;var s=1<<e,a=he(e,t=(t%s+s)%s,r);if(this.tiles[a])return ie(this.tiles[a],i);n>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var l,u=e,h=t,c=r;!l&&u>0;)u--,h=Math.floor(h/2),c=Math.floor(c/2),l=this.tiles[he(u,h,c)];return l&&l.source?(n>1&&console.log("found parent tile z%d-%d-%d",u,h,c),n>1&&console.time("drilling down"),this.splitTile(l.source,u,h,c,e,t,r),n>1&&console.timeEnd("drilling down"),this.tiles[a]?ie(this.tiles[a],i):null):null};class fe extends e.VectorTileWorkerSource{constructor(e,t,r,o,i){super(e,t,r,o,ce),i&&(this.loadGeoJSON=i);}loadData(t,r){const o=t&&t.request,i=o&&o.collectResourceTiming;this.loadGeoJSON(t,((n,s)=>{if(n||!s)return r(n);if("object"!=typeof s)return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));{a(s,!0);try{if(t.filter){const r=e.createExpression(t.filter,{type:"boolean","property-type":"data-driven",overridable:!1,transition:!1});if("error"===r.result)throw new Error(r.value.map((e=>`${e.key}: ${e.message}`)).join(", "));const o=s.features.filter((e=>r.value.evaluate({zoom:0},e)));s={type:"FeatureCollection",features:o};}this._geoJSONIndex=t.cluster?new E(function({superclusterOptions:t,clusterProperties:r}){if(!r||!t)return t;const o={},i={},n={accumulated:null,zoom:0},s={properties:null},a=Object.keys(r);for(const t of a){const[n,s]=r[t],a=e.createExpression(s),l=e.createExpression("string"==typeof n?[n,["accumulated"],["get",t]]:n);o[t]=a.value,i[t]=l.value;}return t.map=e=>{s.properties=e;const t={};for(const e of a)t[e]=o[e].evaluate(n,s);return t},t.reduce=(e,t)=>{s.properties=t;for(const t of a)n.accumulated=e[t],e[t]=i[t].evaluate(n,s);},t}(t)).load(s.features):function(e,t){return new ue(e,t)}(s,t.geojsonVtOptions);}catch(n){return r(n)}this.loaded={};const l={};if(i){const r=e.getPerformanceMeasurement(o);r&&(l.resourceTiming={},l.resourceTiming[t.source]=JSON.parse(JSON.stringify(r)));}r(null,l);}}));}reloadTile(e,t){const r=this.loaded;return r&&r[e.uid]?super.reloadTile(e,t):this.loadTile(e,t)}loadGeoJSON(t,r){if(t.request)e.getJSON(t.request,r);else {if("string"!=typeof t.data)return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`))}}}getClusterExpansionZoom(e,t){try{t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));}catch(e){t(e);}}getClusterChildren(e,t){try{t(null,this._geoJSONIndex.getChildren(e.clusterId));}catch(e){t(e);}}getClusterLeaves(e,t){try{t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));}catch(e){t(e);}}}class pe{constructor(t){this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.availableImages={},this.isSpriteLoaded={},this.projections={},this.defaultProjection=e.getProjection({name:"mercator"}),this.workerSourceTypes={vector:e.VectorTileWorkerSource,geojson:fe},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=(e,t)=>{if(this.workerSourceTypes[e])throw new Error(`Worker source with name "${e}" already registered.`);this.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=t=>{if(e.plugin.isParsed())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};}clearCaches(e,t,r){delete this.layerIndexes[e],delete this.availableImages[e],delete this.workerSources[e],delete this.demWorkerSources[e],r();}checkIfReady(e,t,r){r();}setReferrer(e,t){this.referrer=t;}spriteLoaded(t,r){this.isSpriteLoaded[t]=r;for(const o in this.workerSources[t]){const i=this.workerSources[t][o];for(const t in i)i[t]instanceof e.VectorTileWorkerSource&&(i[t].isSpriteLoaded=r,i[t].fire(new e.Event("isSpriteLoaded")));}}setImages(e,t,r){this.availableImages[e]=t;for(const r in this.workerSources[e]){const o=this.workerSources[e][r];for(const e in o)o[e].availableImages=t;}r();}enableTerrain(e,t,r){this.terrain=t,r();}setProjection(t,r){this.projections[t]=e.getProjection(r);}setLayers(e,t,r){this.getLayerIndex(e).replace(t),r();}updateLayers(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();}loadTile(t,r,o){const i=this.enableTerrain?e.extend({enableTerrain:this.terrain},r):r;i.projection=this.projections[t]||this.defaultProjection,this.getWorkerSource(t,r.type,r.source).loadTile(i,o);}loadDEMTile(t,r,o){const i=this.enableTerrain?e.extend({buildQuadTree:this.terrain},r):r;this.getDEMWorkerSource(t,r.source).loadTile(i,o);}reloadTile(t,r,o){const i=this.enableTerrain?e.extend({enableTerrain:this.terrain},r):r;i.projection=this.projections[t]||this.defaultProjection,this.getWorkerSource(t,r.type,r.source).reloadTile(i,o);}abortTile(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);}removeTile(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);}removeSource(e,t,r){if(!this.workerSources[e]||!this.workerSources[e][t.type]||!this.workerSources[e][t.type][t.source])return;const o=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==o.removeSource?o.removeSource(t,r):r();}loadWorkerSource(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}}syncRTLPluginState(t,r,o){try{e.plugin.setState(r);const t=e.plugin.getPluginURL();if(e.plugin.isLoaded()&&!e.plugin.isParsed()&&null!=t){this.self.importScripts(t);const r=e.plugin.isParsed();o(r?void 0:new Error(`RTL Text Plugin failed to import scripts from ${t}`),r);}}catch(e){o(e.toString());}}getAvailableImages(e){let t=this.availableImages[e];return t||(t=[]),t}getLayerIndex(e){let t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new o),t}getWorkerSource(e,t,r){if(this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),!this.workerSources[e][t][r]){const o={send:(t,r,o,i,n,s)=>{this.actor.send(t,r,o,e,n,s);},scheduler:this.actor.scheduler};this.workerSources[e][t][r]=new this.workerSourceTypes[t](o,this.getLayerIndex(e),this.getAvailableImages(e),this.isSpriteLoaded[e]);}return this.workerSources[e][t][r]}getDEMWorkerSource(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new i),this.demWorkerSources[e][t]}enforceCacheSizeLimit(t,r){e.enforceCacheSizeLimit(r);}getWorkerPerformanceMetrics(e,t,r){r(void 0,void 0);}}return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope&&(self.worker=new pe(self)),pe}));

define(["./shared"],(function(e){"use strict";function t(e,i){if(Array.isArray(e)){if(!Array.isArray(i)||e.length!==i.length)return !1;for(let o=0;o<e.length;o++)if(!t(e[o],i[o]))return !1;return !0}if("object"==typeof e&&null!==e&&null!==i){if("object"!=typeof i)return !1;if(Object.keys(e).length!==Object.keys(i).length)return !1;for(const o in e)if(!t(e[o],i[o]))return !1;return !0}return e===i}var i=o;function o(e){return !function(e){return "undefined"==typeof window||"undefined"==typeof document?"not a browser":Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray?Function.prototype&&Function.prototype.bind?Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions?"JSON"in window&&"parse"in JSON&&"stringify"in JSON?function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var e,t,i=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(i);try{t=new Worker(o),e=!0;}catch(t){e=!1;}return t&&t.terminate(),URL.revokeObjectURL(o),e}()?"Uint8ClampedArray"in window?ArrayBuffer.isView?function(){var e=document.createElement("canvas");e.width=e.height=1;var t=e.getContext("2d");if(!t)return !1;var i=t.getImageData(0,0,1,1);return i&&i.width===e.width}()?(void 0===r[t=e&&e.failIfMajorPerformanceCaveat]&&(r[t]=function(e){var t,i=function(e){var t=document.createElement("canvas"),i=Object.create(o.webGLContextAttributes);return i.failIfMajorPerformanceCaveat=e,t.getContext("webgl",i)||t.getContext("experimental-webgl",i)}(e);if(!i)return !1;try{t=i.createShader(i.VERTEX_SHADER);}catch(e){return !1}return !(!t||i.isContextLost())&&(i.shaderSource(t,"void main() {}"),i.compileShader(t),!0===i.getShaderParameter(t,i.COMPILE_STATUS))}(t)),r[t]?document.documentMode?"insufficient ECMAScript 6 support":void 0:"insufficient WebGL support"):"insufficient Canvas/getImageData support":"insufficient ArrayBuffer support":"insufficient Uint8ClampedArray support":"insufficient worker support":"insufficient JSON support":"insufficient Object support":"insufficient Function support":"insufficent Array support";var t;}(e)}var r={};function n(t,i,o){const r=e.window.document.createElement(t);return void 0!==i&&(r.className=i),o&&o.appendChild(r),r}function s(t,i,o){const r=e.window.document.createElementNS("http://www.w3.org/2000/svg",t);for(const e of Object.keys(i))r.setAttributeNS(null,e,i[e]);return o&&o.appendChild(r),r}o.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};const a=e.window.document&&e.window.document.documentElement.style,l=a&&void 0!==a.userSelect?"userSelect":"WebkitUserSelect";let c;function h(){a&&l&&(c=a[l],a[l]="none");}function u(){a&&l&&(a[l]=c);}function _(t){t.preventDefault(),t.stopPropagation(),e.window.removeEventListener("click",_,!0);}function d(){e.window.addEventListener("click",_,!0),e.window.setTimeout((()=>{e.window.removeEventListener("click",_,!0);}),0);}function p(e,t){const i=e.getBoundingClientRect();return g(e,i,t)}function m(e,t){const i=e.getBoundingClientRect(),o=[];for(let r=0;r<t.length;r++)o.push(g(e,i,t[r]));return o}function f(t){return void 0!==e.window.InstallTrigger&&2===t.button&&t.ctrlKey&&e.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:t.button}function g(t,i,o){const r=t.offsetWidth===i.width?1:t.offsetWidth/i.width;return new e.Point((o.clientX-i.left)*r,(o.clientY-i.top)*r)}function v(e,t){var i=t[0],o=t[1],r=t[2],n=t[3],s=i*n-r*o;return s?(e[0]=n*(s=1/s),e[1]=-o*s,e[2]=-r*s,e[3]=i*s,e):null}function x(e){const{userImage:t}=e;return !!(t&&t.render&&t.render())&&(e.data.replace(new Uint8Array(t.data.buffer)),!0)}class y extends e.Evented{constructor(){super(),this.images={},this.updatedImages={},this.callbackDispatchedThisFrame={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new e.RGBAImage({width:1,height:1}),this.dirty=!0;}isLoaded(){return this.loaded}setLoaded(e){if(this.loaded!==e&&(this.loaded=e,e)){for(const{ids:e,callback:t}of this.requestors)this._notify(e,t);this.requestors=[];}}hasImage(e){return !!this.getImage(e)}getImage(e){return this.images[e]}addImage(e,t){this._validate(e,t)&&(this.images[e]=t);}_validate(t,i){let o=!0;return this._validateStretch(i.stretchX,i.data&&i.data.width)||(this.fire(new e.ErrorEvent(new Error(`Image "${t}" has invalid "stretchX" value`))),o=!1),this._validateStretch(i.stretchY,i.data&&i.data.height)||(this.fire(new e.ErrorEvent(new Error(`Image "${t}" has invalid "stretchY" value`))),o=!1),this._validateContent(i.content,i)||(this.fire(new e.ErrorEvent(new Error(`Image "${t}" has invalid "content" value`))),o=!1),o}_validateStretch(e,t){if(!e)return !0;let i=0;for(const o of e){if(o[0]<i||o[1]<o[0]||t<o[1])return !1;i=o[1];}return !0}_validateContent(e,t){return !(e&&(4!==e.length||e[0]<0||t.data.width<e[0]||e[1]<0||t.data.height<e[1]||e[2]<0||t.data.width<e[2]||e[3]<0||t.data.height<e[3]||e[2]<e[0]||e[3]<e[1]))}updateImage(e,t){t.version=this.images[e].version+1,this.images[e]=t,this.updatedImages[e]=!0;}removeImage(e){const t=this.images[e];delete this.images[e],delete this.patterns[e],t.userImage&&t.userImage.onRemove&&t.userImage.onRemove();}listImages(){return Object.keys(this.images)}getImages(e,t){let i=!0;if(!this.isLoaded())for(const t of e)this.images[t]||(i=!1);this.isLoaded()||i?this._notify(e,t):this.requestors.push({ids:e,callback:t});}_notify(t,i){const o={};for(const i of t){this.images[i]||this.fire(new e.Event("styleimagemissing",{id:i}));const t=this.images[i];t?o[i]={data:t.data.clone(),pixelRatio:t.pixelRatio,sdf:t.sdf,version:t.version,stretchX:t.stretchX,stretchY:t.stretchY,content:t.content,hasRenderCallback:Boolean(t.userImage&&t.userImage.render)}:e.warnOnce(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);}i(null,o);}getPixelSize(){const{width:e,height:t}=this.atlasImage;return {width:e,height:t}}getPattern(t){const i=this.patterns[t],o=this.getImage(t);if(!o)return null;if(i&&i.position.version===o.version)return i.position;if(i)i.position.version=o.version;else {const i={w:o.data.width+2,h:o.data.height+2,x:0,y:0},r=new e.ImagePosition(i,o);this.patterns[t]={bin:i,position:r};}return this._updatePatternAtlas(),this.patterns[t].position}bind(t){const i=t.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new e.Texture(t,this.atlasImage,i.RGBA),this.atlasTexture&&this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);}_updatePatternAtlas(){const t=[];for(const e in this.patterns)t.push(this.patterns[e].bin);const{w:i,h:o}=e.potpack(t),r=this.atlasImage;r.resize({width:i||1,height:o||1});for(const t in this.patterns){const{bin:i}=this.patterns[t],o=i.x+1,n=i.y+1,s=this.images[t].data,a=s.width,l=s.height;e.RGBAImage.copy(s,r,{x:0,y:0},{x:o,y:n},{width:a,height:l}),e.RGBAImage.copy(s,r,{x:0,y:l-1},{x:o,y:n-1},{width:a,height:1}),e.RGBAImage.copy(s,r,{x:0,y:0},{x:o,y:n+l},{width:a,height:1}),e.RGBAImage.copy(s,r,{x:a-1,y:0},{x:o-1,y:n},{width:1,height:l}),e.RGBAImage.copy(s,r,{x:0,y:0},{x:o+a,y:n},{width:1,height:l});}this.dirty=!0;}beginFrame(){this.callbackDispatchedThisFrame={};}dispatchRenderCallbacks(e){for(const t of e){if(this.callbackDispatchedThisFrame[t])continue;this.callbackDispatchedThisFrame[t]=!0;const e=this.images[t];x(e)&&this.updateImage(t,e);}}}const b=new e.Properties({anchor:new e.DataConstantProperty(e.spec.light.anchor),position:new class{constructor(){this.specification=e.spec.light.position;}possiblyEvaluate(t,i){return function([t,i,o]){const r=e.degToRad(i+90),n=e.degToRad(o);return {x:t*Math.cos(r)*Math.sin(n),y:t*Math.sin(r)*Math.sin(n),z:t*Math.cos(n),azimuthal:i,polar:o}}(t.expression.evaluate(i))}interpolate(t,i,o){return {x:e.number(t.x,i.x,o),y:e.number(t.y,i.y,o),z:e.number(t.z,i.z,o),azimuthal:e.number(t.azimuthal,i.azimuthal,o),polar:e.number(t.polar,i.polar,o)}}},color:new e.DataConstantProperty(e.spec.light.color),intensity:new e.DataConstantProperty(e.spec.light.intensity)});class w extends e.Evented{constructor(t){super(),this._transitionable=new e.Transitionable(b),this.setLight(t),this._transitioning=this._transitionable.untransitioned();}getLight(){return this._transitionable.serialize()}setLight(t,i={}){if(!this._validate(e.validateLight,t,i))for(const i in t){const o=t[i];e.endsWith(i,"-transition")?this._transitionable.setTransition(i.slice(0,-11),o):this._transitionable.setValue(i,o);}}updateTransitions(e){this._transitioning=this._transitionable.transitioned(e,this._transitioning);}hasTransition(){return this._transitioning.hasTransition()}recalculate(e){this.properties=this._transitioning.possiblyEvaluate(e);}_validate(t,i,o){return (!o||!1!==o.validate)&&e.emitValidationErrors(this,t.call(e.validateStyle,e.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:e.spec})))}}const T=new e.Properties({source:new e.DataConstantProperty(e.spec.terrain.source),exaggeration:new e.DataConstantProperty(e.spec.terrain.exaggeration)});let E=class extends e.Evented{constructor(t,i){super(),this._transitionable=new e.Transitionable(T),this.set(t),this._transitioning=this._transitionable.untransitioned(),this.drapeRenderMode=i;}get(){return this._transitionable.serialize()}set(t){for(const i in t){const o=t[i];e.endsWith(i,"-transition")?this._transitionable.setTransition(i.slice(0,-11),o):this._transitionable.setValue(i,o);}}updateTransitions(e){this._transitioning=this._transitionable.transitioned(e,this._transitioning);}hasTransition(){return this._transitioning.hasTransition()}recalculate(e){this.properties=this._transitioning.possiblyEvaluate(e);}};function C(t,i,o,r){const n=e.smoothstep(45,65,o),[s,a]=M(t,r),l=e.length(i);let c=1-Math.min(1,Math.exp((l-s)/(a-s)*-6));return c*=c*c,c=Math.min(1,1.00747*c),c*n*t.alpha}function M(e,t){const i=.5/Math.tan(.5*t);return [e.range[0]+i,e.range[1]+i]}const I=new e.Properties({range:new e.DataConstantProperty(e.spec.fog.range),color:new e.DataConstantProperty(e.spec.fog.color),"high-color":new e.DataConstantProperty(e.spec.fog["high-color"]),"space-color":new e.DataConstantProperty(e.spec.fog["space-color"]),"horizon-blend":new e.DataConstantProperty(e.spec.fog["horizon-blend"]),"star-intensity":new e.DataConstantProperty(e.spec.fog["star-intensity"])});class P extends e.Evented{constructor(t,i){super(),this._transitionable=new e.Transitionable(I),this.set(t),this._transitioning=this._transitionable.untransitioned(),this._transform=i;}get state(){const t=this._transform,i="globe"===t.projection.name,o=e.globeToMercatorTransition(t.zoom),r=this.properties.get("range"),n=[.5,3];return {range:i?[e.number(n[0],r[0],o),e.number(n[1],r[1],o)]:r,horizonBlend:this.properties.get("horizon-blend"),alpha:this.properties.get("color").a}}get(){return this._transitionable.serialize()}set(t,i={}){if(!this._validate(e.validateFog,t,i)){for(const i of Object.keys(e.spec.fog))t&&void 0===t[i]&&(t[i]=e.spec.fog[i].default);for(const i in t){const o=t[i];e.endsWith(i,"-transition")?this._transitionable.setTransition(i.slice(0,-11),o):this._transitionable.setValue(i,o);}}}getOpacity(t){if(!this._transform.projection.supportsFog)return 0;const i=this.properties&&this.properties.get("color")||1;return ("globe"===this._transform.projection.name?1:e.smoothstep(45,65,t))*i.a}getOpacityAtLatLng(t,i){return this._transform.projection.supportsFog?function(t,i,o){const r=e.MercatorCoordinate.fromLngLat(i),n=o.elevation?o.elevation.getAtPointOrZero(r):0,s=[r.x,r.y,n];return e.transformMat4(s,s,o.mercatorFogMatrix),C(t,s,o.pitch,o._fov)}(this.state,t,i):0}getFovAdjustedRange(e){return this._transform.projection.supportsFog?M(this.state,e):[0,1]}updateTransitions(e){this._transitioning=this._transitionable.transitioned(e,this._transitioning);}hasTransition(){return this._transitioning.hasTransition()}recalculate(e){this.properties=this._transitioning.possiblyEvaluate(e);}_validate(t,i,o){return (!o||!1!==o.validate)&&e.emitValidationErrors(this,t.call(e.validateStyle,e.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:e.spec})))}}class S{constructor(t,i){this.workerPool=t,this.actors=[],this.currentActor=0,this.id=e.uniqueId();const o=this.workerPool.acquire(this.id);for(let e=0;e<o.length;e++){const t=new S.Actor(o[e],i,this.id);t.name=`Worker ${e}`,this.actors.push(t);}this.ready=!1,this.broadcast("checkIfReady",null,(()=>{this.ready=!0;}));}broadcast(t,i,o){e.asyncAll(this.actors,((e,o)=>{e.send(t,i,o);}),o=o||function(){});}getActor(){return this.currentActor=(this.currentActor+1)%this.actors.length,this.actors[this.currentActor]}remove(){this.actors.forEach((e=>{e.remove();})),this.actors=[],this.workerPool.release(this.id);}}function D(t,i,o){return i*(e.EXTENT/(t.tileSize*Math.pow(2,o-t.tileID.overscaledZ)))}S.Actor=e.Actor;class L{constructor(e,t,i,o){this.screenBounds=e,this.cameraPoint=t,this._screenRaycastCache={},this._cameraRaycastCache={},this.isAboveHorizon=i,this.screenGeometry=this.bufferedScreenGeometry(0),this.screenGeometryMercator=this._bufferedScreenMercator(0,o);}static createFromScreenPoints(t,i){let o,r;if(t instanceof e.Point||"number"==typeof t[0]){const n=e.Point.convert(t);o=[n],r=i.isPointAboveHorizon(n);}else {const n=e.Point.convert(t[0]),s=e.Point.convert(t[1]);o=[n,s],r=e.polygonizeBounds(n,s).every((e=>i.isPointAboveHorizon(e)));}return new L(o,i.getCameraPoint(),r,i)}isPointQuery(){return 1===this.screenBounds.length}bufferedScreenGeometry(t){return e.polygonizeBounds(this.screenBounds[0],1===this.screenBounds.length?this.screenBounds[0]:this.screenBounds[1],t)}bufferedCameraGeometry(t){const i=this.screenBounds[0],o=1===this.screenBounds.length?this.screenBounds[0].add(new e.Point(1,1)):this.screenBounds[1],r=e.polygonizeBounds(i,o,0,!1);return this.cameraPoint.y>o.y&&(this.cameraPoint.x>i.x&&this.cameraPoint.x<o.x?r.splice(3,0,this.cameraPoint):this.cameraPoint.x>=o.x?r[2]=this.cameraPoint:this.cameraPoint.x<=i.x&&(r[3]=this.cameraPoint)),e.bufferConvexPolygon(r,t)}bufferedCameraGeometryGlobe(t){const i=this.screenBounds[0],o=1===this.screenBounds.length?this.screenBounds[0].add(new e.Point(1,1)):this.screenBounds[1],r=e.polygonizeBounds(i,o,t),n=this.cameraPoint.clone();switch(3*((n.y>i.y)+(n.y>o.y))+((n.x>i.x)+(n.x>o.x))){case 0:r[0]=n,r[4]=n.clone();break;case 1:r.splice(1,0,n);break;case 2:r[1]=n;break;case 3:r.splice(4,0,n);break;case 5:r.splice(2,0,n);break;case 6:r[3]=n;break;case 7:r.splice(3,0,n);break;case 8:r[2]=n;}return r}containsTile(t,i,o,r=0){const n=t.queryPadding/i._pixelsPerMercatorPixel+1,s=o?this._bufferedCameraMercator(n,i):this._bufferedScreenMercator(n,i);let a=t.tileID.wrap+(s.unwrapped?r:0);const l=s.polygon.map((i=>e.getTilePoint(t.tileTransform,i,a)));if(!e.polygonIntersectsBox(l,0,0,e.EXTENT,e.EXTENT))return;a=t.tileID.wrap+(this.screenGeometryMercator.unwrapped?r:0);const c=this.screenGeometryMercator.polygon.map((i=>e.getTileVec3(t.tileTransform,i,a))),h=c.map((t=>new e.Point(t[0],t[1]))),u=i.getFreeCameraOptions().position||new e.MercatorCoordinate(0,0,0),_=e.getTileVec3(t.tileTransform,u,a),d=c.map((t=>{const i=e.sub(t,t,_);return e.normalize(i,i),new e.Ray(_,i)})),p=D(t,1,i.zoom)*i._pixelsPerMercatorPixel;return {queryGeometry:this,tilespaceGeometry:h,tilespaceRays:d,bufferedTilespaceGeometry:l,bufferedTilespaceBounds:(m=e.getBounds(l),m.min.x=e.clamp(m.min.x,0,e.EXTENT),m.min.y=e.clamp(m.min.y,0,e.EXTENT),m.max.x=e.clamp(m.max.x,0,e.EXTENT),m.max.y=e.clamp(m.max.y,0,e.EXTENT),m),tile:t,tileID:t.tileID,pixelToTileUnitsFactor:p};var m;}_bufferedScreenMercator(e,t){const i=R(e);if(this._screenRaycastCache[i])return this._screenRaycastCache[i];{let o;return o="globe"===t.projection.name?this._projectAndResample(this.bufferedScreenGeometry(e),t):{polygon:this.bufferedScreenGeometry(e).map((e=>t.pointCoordinate3D(e))),unwrapped:!0},this._screenRaycastCache[i]=o,o}}_bufferedCameraMercator(e,t){const i=R(e);if(this._cameraRaycastCache[i])return this._cameraRaycastCache[i];{let o;return o="globe"===t.projection.name?this._projectAndResample(this.bufferedCameraGeometryGlobe(e),t):{polygon:this.bufferedCameraGeometry(e).map((e=>t.pointCoordinate3D(e))),unwrapped:!0},this._cameraRaycastCache[i]=o,o}}_projectAndResample(t,i){const o=function(t,i){const o=e.multiply([],i.pixelMatrix,i.globeMatrix),r=[0,-e.GLOBE_RADIUS,0,1],n=[0,e.GLOBE_RADIUS,0,1],s=[0,0,0,1];e.transformMat4$1(r,r,o),e.transformMat4$1(n,n,o),e.transformMat4$1(s,s,o);const a=new e.Point(r[0]/r[3],r[1]/r[3]),l=new e.Point(n[0]/n[3],n[1]/n[3]),c=e.polygonContainsPoint(t,a)&&r[3]<s[3],h=e.polygonContainsPoint(t,l)&&n[3]<s[3];if(!c&&!h)return null;const u=function(e,t,i){for(let o=1;o<e.length;o++){const r=z(t.pointCoordinate3D(e[o-1]).x),n=z(t.pointCoordinate3D(e[o]).x);if(i<0){if(r<n)return {idx:o,t:-r/(n-1-r)}}else if(n<r)return {idx:o,t:(1-r)/(n+1-r)}}return null}(t,i,c?-1:1);if(!u)return null;const{idx:_,t:d}=u;let p=_>1?A(t.slice(0,_),i):[],m=_<t.length?A(t.slice(_),i):[];p=p.map((t=>new e.Point(z(t.x),t.y))),m=m.map((t=>new e.Point(z(t.x),t.y)));const f=[...p];0===f.length&&f.push(m[m.length-1]);const g=e.number(f[f.length-1].y,(0===m.length?p[0]:m[0]).y,d);let v;return v=c?[new e.Point(0,g),new e.Point(0,0),new e.Point(1,0),new e.Point(1,g)]:[new e.Point(1,g),new e.Point(1,1),new e.Point(0,1),new e.Point(0,g)],f.push(...v),0===m.length?f.push(p[0]):f.push(...m),{polygon:f.map((t=>new e.MercatorCoordinate(t.x,t.y))),unwrapped:!1}}(t,i);if(o)return o;const r=function(t,i){let o=!1,r=-1/0,n=0;for(let e=0;e<t.length-1;e++)t[e].x>r&&(r=t[e].x,n=e);for(let e=0;e<t.length-1;e++){const i=(n+e)%(t.length-1),r=t[i],s=t[i+1];Math.abs(r.x-s.x)>.5&&(r.x<s.x?(r.x+=1,0===i&&(t[t.length-1].x+=1)):(s.x+=1,i+1===t.length-1&&(t[0].x+=1)),o=!0);}const s=e.mercatorXfromLng(i.center.lng);return o&&s<Math.abs(s-1)&&t.forEach((e=>{e.x-=1;})),{polygon:t,unwrapped:o}}(A(t,i).map((t=>new e.Point(z(t.x),t.y))),i);return {polygon:r.polygon.map((t=>new e.MercatorCoordinate(t.x,t.y))),unwrapped:r.unwrapped}}}function A(t,i){return e.resample(t,(e=>{const t=i.pointCoordinate3D(e);e.x=t.x,e.y=t.y;}),1/256)}function z(e){return e<0?1+e%1:e%1}function R(e){return 100*e|0}function O(t,i,o,r,n){const s=function(o,r){if(o)return n(o);if(r){t.url&&r.tiles&&t.tiles&&delete t.tiles;const o=e.pick(e.extend(r,t),["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds","scheme","tileSize","encoding"]);r.vector_layers&&(o.vectorLayers=r.vector_layers,o.vectorLayerIds=o.vectorLayers.map((e=>e.id))),o.tiles=i.canonicalizeTileset(o,t.url),n(null,o);}};return t.url?e.getJSON(i.transformRequest(i.normalizeSourceURL(t.url,null,o,r),e.ResourceType.Source),s):e.exported.frame((()=>s(null,t)))}class B{constructor(t,i,o){this.bounds=e.LngLatBounds.convert(this.validateBounds(t)),this.minzoom=i||0,this.maxzoom=o||24;}validateBounds(e){return Array.isArray(e)&&4===e.length?[Math.max(-180,e[0]),Math.max(-90,e[1]),Math.min(180,e[2]),Math.min(90,e[3])]:[-180,-90,180,90]}contains(t){const i=Math.pow(2,t.z),o=Math.floor(e.mercatorXfromLng(this.bounds.getWest())*i),r=Math.floor(e.mercatorYfromLat(this.bounds.getNorth())*i),n=Math.ceil(e.mercatorXfromLng(this.bounds.getEast())*i),s=Math.ceil(e.mercatorYfromLat(this.bounds.getSouth())*i);return t.x>=o&&t.x<n&&t.y>=r&&t.y<s}}class k{constructor(e,t,i){this.context=e;const o=e.gl;this.buffer=o.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),e.bindElementBuffer.set(this.buffer),o.bufferData(o.ELEMENT_ARRAY_BUFFER,t.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||t.destroy();}bind(){this.context.bindElementBuffer.set(this.buffer);}updateData(e){const t=this.context.gl;this.context.unbindVAO(),this.bind(),t.bufferSubData(t.ELEMENT_ARRAY_BUFFER,0,e.arrayBuffer);}destroy(){this.buffer&&(this.context.gl.deleteBuffer(this.buffer),delete this.buffer);}}const F={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"};class U{constructor(e,t,i,o){this.length=t.length,this.attributes=i,this.itemSize=t.bytesPerElement,this.dynamicDraw=o,this.context=e;const r=e.gl;this.buffer=r.createBuffer(),e.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,t.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||t.destroy();}bind(){this.context.bindVertexBuffer.set(this.buffer);}updateData(e){const t=this.context.gl;this.bind(),t.bufferSubData(t.ARRAY_BUFFER,0,e.arrayBuffer);}enableAttributes(e,t){for(let i=0;i<this.attributes.length;i++){const o=t.attributes[this.attributes[i].name];void 0!==o&&e.enableVertexAttribArray(o);}}setVertexAttribPointers(e,t,i){for(let o=0;o<this.attributes.length;o++){const r=this.attributes[o],n=t.attributes[r.name];void 0!==n&&e.vertexAttribPointer(n,r.components,e[F[r.type]],!1,this.itemSize,r.offset+this.itemSize*(i||0));}}destroy(){this.buffer&&(this.context.gl.deleteBuffer(this.buffer),delete this.buffer);}}class N{constructor(e){this.gl=e.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1;}get(){return this.current}set(e){}getDefault(){return this.default}setDefault(){this.set(this.default);}}class j extends N{getDefault(){return e.Color.transparent}set(e){const t=this.current;(e.r!==t.r||e.g!==t.g||e.b!==t.b||e.a!==t.a||this.dirty)&&(this.gl.clearColor(e.r,e.g,e.b,e.a),this.current=e,this.dirty=!1);}}class G extends N{getDefault(){return 1}set(e){(e!==this.current||this.dirty)&&(this.gl.clearDepth(e),this.current=e,this.dirty=!1);}}class Z extends N{getDefault(){return 0}set(e){(e!==this.current||this.dirty)&&(this.gl.clearStencil(e),this.current=e,this.dirty=!1);}}class V extends N{getDefault(){return [!0,!0,!0,!0]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||e[2]!==t[2]||e[3]!==t[3]||this.dirty)&&(this.gl.colorMask(e[0],e[1],e[2],e[3]),this.current=e,this.dirty=!1);}}class W extends N{getDefault(){return !0}set(e){(e!==this.current||this.dirty)&&(this.gl.depthMask(e),this.current=e,this.dirty=!1);}}class X extends N{getDefault(){return 255}set(e){(e!==this.current||this.dirty)&&(this.gl.stencilMask(e),this.current=e,this.dirty=!1);}}class q extends N{getDefault(){return {func:this.gl.ALWAYS,ref:0,mask:255}}set(e){const t=this.current;(e.func!==t.func||e.ref!==t.ref||e.mask!==t.mask||this.dirty)&&(this.gl.stencilFunc(e.func,e.ref,e.mask),this.current=e,this.dirty=!1);}}class $ extends N{getDefault(){const e=this.gl;return [e.KEEP,e.KEEP,e.KEEP]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||e[2]!==t[2]||this.dirty)&&(this.gl.stencilOp(e[0],e[1],e[2]),this.current=e,this.dirty=!1);}}class H extends N{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.STENCIL_TEST):t.disable(t.STENCIL_TEST),this.current=e,this.dirty=!1;}}class Y extends N{getDefault(){return [0,1]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||this.dirty)&&(this.gl.depthRange(e[0],e[1]),this.current=e,this.dirty=!1);}}class K extends N{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.DEPTH_TEST):t.disable(t.DEPTH_TEST),this.current=e,this.dirty=!1;}}class J extends N{getDefault(){return this.gl.LESS}set(e){(e!==this.current||this.dirty)&&(this.gl.depthFunc(e),this.current=e,this.dirty=!1);}}class Q extends N{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.BLEND):t.disable(t.BLEND),this.current=e,this.dirty=!1;}}class ee extends N{getDefault(){const e=this.gl;return [e.ONE,e.ZERO]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||this.dirty)&&(this.gl.blendFunc(e[0],e[1]),this.current=e,this.dirty=!1);}}class te extends N{getDefault(){return e.Color.transparent}set(e){const t=this.current;(e.r!==t.r||e.g!==t.g||e.b!==t.b||e.a!==t.a||this.dirty)&&(this.gl.blendColor(e.r,e.g,e.b,e.a),this.current=e,this.dirty=!1);}}class ie extends N{getDefault(){return this.gl.FUNC_ADD}set(e){(e!==this.current||this.dirty)&&(this.gl.blendEquation(e),this.current=e,this.dirty=!1);}}class oe extends N{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.CULL_FACE):t.disable(t.CULL_FACE),this.current=e,this.dirty=!1;}}class re extends N{getDefault(){return this.gl.BACK}set(e){(e!==this.current||this.dirty)&&(this.gl.cullFace(e),this.current=e,this.dirty=!1);}}class ne extends N{getDefault(){return this.gl.CCW}set(e){(e!==this.current||this.dirty)&&(this.gl.frontFace(e),this.current=e,this.dirty=!1);}}let se,ae=class extends N{getDefault(){return null}set(e){(e!==this.current||this.dirty)&&(this.gl.useProgram(e),this.current=e,this.dirty=!1);}};class le extends N{getDefault(){return this.gl.TEXTURE0}set(e){(e!==this.current||this.dirty)&&(this.gl.activeTexture(e),this.current=e,this.dirty=!1);}}class ce extends N{getDefault(){const e=this.gl;return [0,0,e.drawingBufferWidth,e.drawingBufferHeight]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||e[2]!==t[2]||e[3]!==t[3]||this.dirty)&&(this.gl.viewport(e[0],e[1],e[2],e[3]),this.current=e,this.dirty=!1);}}class he extends N{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindFramebuffer(t.FRAMEBUFFER,e),this.current=e,this.dirty=!1;}}class ue extends N{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindRenderbuffer(t.RENDERBUFFER,e),this.current=e,this.dirty=!1;}}class _e extends N{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindTexture(t.TEXTURE_2D,e),this.current=e,this.dirty=!1;}}class de extends N{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindBuffer(t.ARRAY_BUFFER,e),this.current=e,this.dirty=!1;}}class pe extends N{getDefault(){return null}set(e){const t=this.gl;t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,e),this.current=e,this.dirty=!1;}}class me extends N{constructor(e){super(e),this.vao=e.extVertexArrayObject;}getDefault(){return null}set(e){this.vao&&(e!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(e),this.current=e,this.dirty=!1);}}class fe extends N{getDefault(){return 4}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.pixelStorei(t.UNPACK_ALIGNMENT,e),this.current=e,this.dirty=!1;}}class ge extends N{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL,e),this.current=e,this.dirty=!1;}}class ve extends N{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL,e),this.current=e,this.dirty=!1;}}class xe extends N{constructor(e,t){super(e),this.context=e,this.parent=t;}getDefault(){return null}}class ye extends xe{setDirty(){this.dirty=!0;}set(e){if(e===this.current&&!this.dirty)return;this.context.bindFramebuffer.set(this.parent);const t=this.gl;t.framebufferTexture2D(t.FRAMEBUFFER,t.COLOR_ATTACHMENT0,t.TEXTURE_2D,e,0),this.current=e,this.dirty=!1;}}class be extends xe{attachment(){return this.gl.DEPTH_ATTACHMENT}set(e){if(e===this.current&&!this.dirty)return;this.context.bindFramebuffer.set(this.parent);const t=this.gl;t.framebufferRenderbuffer(t.FRAMEBUFFER,this.attachment(),t.RENDERBUFFER,e),this.current=e,this.dirty=!1;}}class we extends be{attachment(){return this.gl.DEPTH_STENCIL_ATTACHMENT}}class Te{constructor(e,t,i,o){this.context=e,this.width=t,this.height=i;const r=this.framebuffer=e.gl.createFramebuffer();this.colorAttachment=new ye(e,r),o&&(this.depthAttachment=new be(e,r));}destroy(){const e=this.context.gl,t=this.colorAttachment.get();if(t&&e.deleteTexture(t),this.depthAttachment){const t=this.depthAttachment.get();t&&e.deleteRenderbuffer(t);}e.deleteFramebuffer(this.framebuffer);}}class Ee{constructor(e,t=!1){if(this.gl=e,this.isWebGL2=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),t){const t=e;this.extVertexArrayObject={createVertexArrayOES:t.createVertexArray.bind(e),deleteVertexArrayOES:t.deleteVertexArray.bind(e),bindVertexArrayOES:t.bindVertexArray.bind(e)};}this.clearColor=new j(this),this.clearDepth=new G(this),this.clearStencil=new Z(this),this.colorMask=new V(this),this.depthMask=new W(this),this.stencilMask=new X(this),this.stencilFunc=new q(this),this.stencilOp=new $(this),this.stencilTest=new H(this),this.depthRange=new Y(this),this.depthTest=new K(this),this.depthFunc=new J(this),this.blend=new Q(this),this.blendFunc=new ee(this),this.blendColor=new te(this),this.blendEquation=new ie(this),this.cullFace=new oe(this),this.cullFaceSide=new re(this),this.frontFace=new ne(this),this.program=new ae(this),this.activeTexture=new le(this),this.viewport=new ce(this),this.bindFramebuffer=new he(this),this.bindRenderbuffer=new ue(this),this.bindTexture=new _e(this),this.bindVertexBuffer=new de(this),this.bindElementBuffer=new pe(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new me(this),this.pixelStoreUnpack=new fe(this),this.pixelStoreUnpackPremultiplyAlpha=new ge(this),this.pixelStoreUnpackFlipY=new ve(this),this.extTextureFilterAnisotropic=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureFilterAnisotropicForceOff=!1,this.extStandardDerivativesForceOff=!1,this.extDebugRendererInfo=e.getExtension("WEBGL_debug_renderer_info"),this.extDebugRendererInfo&&(this.renderer=e.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL),this.vendor=e.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)),t||(this.extTextureHalfFloat=e.getExtension("OES_texture_half_float")),(t||this.extTextureHalfFloat&&e.getExtension("OES_texture_half_float_linear"))&&(this.extRenderToTextureHalfFloat=e.getExtension("EXT_color_buffer_half_float")),this.extStandardDerivatives=t||e.getExtension("OES_standard_derivatives"),this.extTimerQuery=e.getExtension("EXT_disjoint_timer_query"),this.maxTextureSize=e.getParameter(e.MAX_TEXTURE_SIZE);}setDefault(){this.unbindVAO(),this.clearColor.setDefault(),this.clearDepth.setDefault(),this.clearStencil.setDefault(),this.colorMask.setDefault(),this.depthMask.setDefault(),this.stencilMask.setDefault(),this.stencilFunc.setDefault(),this.stencilOp.setDefault(),this.stencilTest.setDefault(),this.depthRange.setDefault(),this.depthTest.setDefault(),this.depthFunc.setDefault(),this.blend.setDefault(),this.blendFunc.setDefault(),this.blendColor.setDefault(),this.blendEquation.setDefault(),this.cullFace.setDefault(),this.cullFaceSide.setDefault(),this.frontFace.setDefault(),this.program.setDefault(),this.activeTexture.setDefault(),this.bindFramebuffer.setDefault(),this.pixelStoreUnpack.setDefault(),this.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.pixelStoreUnpackFlipY.setDefault();}setDirty(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0;}createIndexBuffer(e,t){return new k(this,e,t)}createVertexBuffer(e,t,i){return new U(this,e,t,i)}createRenderbuffer(e,t,i){const o=this.gl,r=o.createRenderbuffer();return this.bindRenderbuffer.set(r),o.renderbufferStorage(o.RENDERBUFFER,e,t,i),this.bindRenderbuffer.set(null),r}createFramebuffer(e,t,i){return new Te(this,e,t,i)}clear({color:e,depth:t,stencil:i}){const o=this.gl;let r=0;e&&(r|=o.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==t&&(r|=o.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(t),this.depthMask.set(!0)),void 0!==i&&(r|=o.STENCIL_BUFFER_BIT,this.clearStencil.set(i),this.stencilMask.set(255)),o.clear(r);}setCullFace(e){!1===e.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(e.mode),this.frontFace.set(e.frontFace));}setDepthMode(e){e.func!==this.gl.ALWAYS||e.mask?(this.depthTest.set(!0),this.depthFunc.set(e.func),this.depthMask.set(e.mask),this.depthRange.set(e.range)):this.depthTest.set(!1);}setStencilMode(e){e.test.func!==this.gl.ALWAYS||e.mask?(this.stencilTest.set(!0),this.stencilMask.set(e.mask),this.stencilOp.set([e.fail,e.depthFail,e.pass]),this.stencilFunc.set({func:e.test.func,ref:e.ref,mask:e.test.mask})):this.stencilTest.set(!1);}setColorMode(i){t(i.blendFunction,e.ColorMode.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(i.blendFunction),this.blendColor.set(i.blendColor)),this.colorMask.set(i.mask);}unbindVAO(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null);}}class Ce extends e.Evented{constructor(t,i,o,r){if(super(),this.id=t,this.dispatcher=o,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,this._loaded=!1,e.extend(this,e.pick(i,["url","scheme","tileSize","promoteId"])),this._options=e.extend({type:"vector"},i),this._collectResourceTiming=i.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(r),this._tileWorkers={},this._deduped=new e.DedupedRequest;}load(t){this._loaded=!1,this.fire(new e.Event("dataloading",{dataType:"source"}));const i=Array.isArray(this.map._language)?this.map._language.join():this.map._language,o=this.map._worldview;this._tileJSONRequest=O(this._options,this.map._requestManager,i,o,((r,n)=>{this._tileJSONRequest=null,this._loaded=!0,r?(i&&console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`),o&&2!==o.length&&console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`),this.fire(new e.ErrorEvent(r))):n&&(e.extend(this,n),n.bounds&&(this.tileBounds=new B(n.bounds,this.minzoom,this.maxzoom)),e.postTurnstileEvent(n.tiles,this.map._requestManager._customAccessToken),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}))),t&&t(r);}));}loaded(){return this._loaded}hasTile(e){return !this.tileBounds||this.tileBounds.contains(e.canonical)}onAdd(e){this.map=e,this.load();}reload(){this.cancelTileJSONRequest(),this.load((()=>this.map.style._clearSource(this.id)));}setTiles(e){return this._options.tiles=e,this.reload(),this}setUrl(e){return this.url=e,this._options.url=e,this.reload(),this}onRemove(){this.cancelTileJSONRequest();}serialize(){return e.extend({},this._options)}loadTile(t,i){const o=this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles,this.scheme)),r={request:this.map._requestManager.transformRequest(o,e.ResourceType.Tile),data:void 0,uid:t.uid,tileID:t.tileID,tileZoom:t.tileZoom,zoom:t.tileID.overscaledZ,tileSize:this.tileSize*t.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:e.exported.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId,isSymbolTile:t.isSymbolTile};if(r.request.collectResourceTiming=this._collectResourceTiming,t.actor&&"expired"!==t.state)"loading"===t.state?t.reloadCallback=i:t.request=t.actor.send("reloadTile",r,n.bind(this));else if(t.actor=this._tileWorkers[o]=this._tileWorkers[o]||this.dispatcher.getActor(),this.dispatcher.ready)t.request=t.actor.send("loadTile",r,n.bind(this),void 0,!0);else {const i=e.loadVectorTile.call({deduped:this._deduped},r,((e,i)=>{e||!i?n.call(this,e):(r.data={cacheControl:i.cacheControl,expires:i.expires,rawData:i.rawData.slice(0)},t.actor&&t.actor.send("loadTile",r,n.bind(this),void 0,!0));}),!0);t.request={cancel:i};}function n(o,r){return delete t.request,t.aborted?i(null):o&&404!==o.status?i(o):(r&&r.resourceTiming&&(t.resourceTiming=r.resourceTiming),this.map._refreshExpiredTiles&&r&&t.setExpiryData(r),t.loadVectorData(r,this.map.painter),e.cacheEntryPossiblyAdded(this.dispatcher),i(null),void(t.reloadCallback&&(this.loadTile(t,t.reloadCallback),t.reloadCallback=null)))}}abortTile(e){e.request&&(e.request.cancel(),delete e.request),e.actor&&e.actor.send("abortTile",{uid:e.uid,type:this.type,source:this.id});}unloadTile(e){e.unloadVectorData(),e.actor&&e.actor.send("removeTile",{uid:e.uid,type:this.type,source:this.id});}hasTransition(){return !1}afterUpdate(){this._tileWorkers={};}cancelTileJSONRequest(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);}}class Me extends e.Evented{constructor(t,i,o,r){super(),this.id=t,this.dispatcher=o,this.setEventedParent(r),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=e.extend({type:"raster"},i),e.extend(this,e.pick(i,["url","scheme","tileSize"]));}load(t){this._loaded=!1,this.fire(new e.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=O(this._options,this.map._requestManager,null,null,((i,o)=>{this._tileJSONRequest=null,this._loaded=!0,i?this.fire(new e.ErrorEvent(i)):o&&(e.extend(this,o),o.bounds&&(this.tileBounds=new B(o.bounds,this.minzoom,this.maxzoom)),e.postTurnstileEvent(o.tiles),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}))),t&&t(i);}));}loaded(){return this._loaded}onAdd(e){this.map=e,this.load();}reload(){this.cancelTileJSONRequest(),this.load((()=>this.map.style._clearSource(this.id)));}setTiles(e){return this._options.tiles=e,this.reload(),this}setUrl(e){return this.url=e,this._options.url=e,this.reload(),this}onRemove(){this.cancelTileJSONRequest();}serialize(){return e.extend({},this._options)}hasTile(e){return !this.tileBounds||this.tileBounds.contains(e.canonical)}loadTile(t,i){const o=e.exported.devicePixelRatio>=2,r=this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles,this.scheme),o,this.tileSize);t.request=e.getImage(this.map._requestManager.transformRequest(r,e.ResourceType.Tile),((o,r,n,s)=>(delete t.request,t.aborted?(t.state="unloaded",i(null)):o?(t.state="errored",i(o)):r?(this.map._refreshExpiredTiles&&t.setExpiryData({cacheControl:n,expires:s}),t.setTexture(r,this.map.painter),t.state="loaded",e.cacheEntryPossiblyAdded(this.dispatcher),void i(null)):i(null))));}static loadTileData(e,t,i){e.setTexture(t,i);}static unloadTileData(e,t){e.texture&&t.saveTileTexture(e.texture);}abortTile(e,t){e.request&&(e.request.cancel(),delete e.request),t();}unloadTile(e,t){e.texture&&this.map.painter.saveTileTexture(e.texture),t();}hasTransition(){return !1}cancelTileJSONRequest(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);}}function Ie(t,i,o,r,n,s,a,l){const c=[t,o,n,i,r,s,1,1,1],h=[a,l,1],u=e.adjoint([],c),[_,d,p]=e.transformMat3(h,h,e.transpose(u,u));return e.multiply$1(c,[_,0,0,0,d,0,0,0,p],c)}class Pe extends e.Evented{constructor(e,t,i,o){super(),this.id=e,this.dispatcher=i,this.coordinates=t.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this._loaded=!1,this.setEventedParent(o),this.options=t,this._dirty=!1;}load(t,i){this._loaded=i||!1,this.fire(new e.Event("dataloading",{dataType:"source"})),this.url=this.options.url,this._imageRequest=e.getImage(this.map._requestManager.transformRequest(this.url,e.ResourceType.Image),((i,o)=>{if(this._imageRequest=null,this._loaded=!0,i)this.fire(new e.ErrorEvent(i));else if(o){const{HTMLImageElement:i}=e.window;this.image=o instanceof i?e.exported.getImageData(o):o,this._dirty=!0,this.width=this.image.width,this.height=this.image.height,t&&(this.coordinates=t),this._finishLoading();}}));}loaded(){return this._loaded}updateImage(e){return this.image&&e.url?(this._imageRequest&&e.url!==this.options.url&&(this._imageRequest.cancel(),this._imageRequest=null),this.options.url=e.url,this.load(e.coordinates,this._loaded),this):this}_finishLoading(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})));}onAdd(e){this.map=e,this.load();}onRemove(){this._imageRequest&&(this._imageRequest.cancel(),this._imageRequest=null),this.texture&&this.texture.destroy();}setCoordinates(t){this.coordinates=t,this._boundsArray=void 0;const i=t.map(e.MercatorCoordinate.fromLngLat);return this.tileID=function(t){let i=1/0,o=1/0,r=-1/0,n=-1/0;for(const e of t)i=Math.min(i,e.x),o=Math.min(o,e.y),r=Math.max(r,e.x),n=Math.max(n,e.y);const s=Math.max(r-i,n-o),a=Math.max(0,Math.floor(-Math.log(s)/Math.LN2)),l=Math.pow(2,a);return new e.CanonicalTileID(a,Math.floor((i+r)/2*l),Math.floor((o+n)/2*l))}(i),this.minzoom=this.maxzoom=this.tileID.z,this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"})),this}_clear(){this._boundsArray=void 0;}_prepareData(t){for(const e in this.tiles){const t=this.tiles[e];"loaded"!==t.state&&(t.state="loaded",t.texture=this.texture);}if(this._boundsArray)return;const i=e.tileTransform(this.tileID,this.map.transform.projection),[o,r,n,s]=this.coordinates.map((t=>{const o=i.projection.project(t[0],t[1]);return e.getTilePoint(i,o)._round()}));this.perspectiveTransform=function(t,i,o,r,n,s,a,l,c,h){const u=Ie(0,0,t,0,0,i,t,i),_=Ie(o,r,n,s,a,l,c,h);return e.multiply$1(_,e.adjoint(u,u),_),[_[6]/_[8]*t/e.EXTENT,_[7]/_[8]*i/e.EXTENT]}(this.width,this.height,o.x,o.y,r.x,r.y,s.x,s.y,n.x,n.y);const a=this._boundsArray=new e.StructArrayLayout4i8;a.emplaceBack(o.x,o.y,0,0),a.emplaceBack(r.x,r.y,e.EXTENT,0),a.emplaceBack(s.x,s.y,0,e.EXTENT),a.emplaceBack(n.x,n.y,e.EXTENT,e.EXTENT),this.boundsBuffer&&this.boundsBuffer.destroy(),this.boundsBuffer=t.createVertexBuffer(a,e.boundsAttributes.members),this.boundsSegments=e.SegmentVector.simpleSegment(0,0,4,2);}prepare(){if(0===Object.keys(this.tiles).length||!this.image)return;const t=this.map.painter.context,i=t.gl;this._dirty&&(this.texture?this.texture.update(this.image):(this.texture=new e.Texture(t,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this._dirty=!1),this._prepareData(t);}loadTile(e,t){this.tileID&&this.tileID.equals(e.tileID.canonical)?(this.tiles[String(e.tileID.wrap)]=e,e.buckets={},t(null)):(e.state="errored",t(null));}serialize(){return {type:"image",url:this.options.url,coordinates:this.coordinates}}hasTransition(){return !1}}const Se={vector:Ce,raster:Me,"raster-dem":class extends Me{constructor(t,i,o,r){super(t,i,o,r),this.type="raster-dem",this.maxzoom=22,this._options=e.extend({type:"raster-dem"},i),this.encoding=i.encoding||"mapbox";}loadTile(t,i){const o=this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles,this.scheme),!1,this.tileSize);function r(e,o){e&&(t.state="errored",i(e)),o&&(t.dem=o,t.dem.onDeserialize(),t.needsHillshadePrepare=!0,t.needsDEMTextureUpload=!0,t.state="loaded",i(null));}t.request=e.getImage(this.map._requestManager.transformRequest(o,e.ResourceType.Tile),function(o,n,s,a){if(delete t.request,t.aborted)t.state="unloaded",i(null);else if(o)t.state="errored",i(o);else if(n){this.map._refreshExpiredTiles&&t.setExpiryData({cacheControl:s,expires:a});const i=e.window.ImageBitmap&&n instanceof e.window.ImageBitmap&&(null==se&&(se=e.window.OffscreenCanvas&&new e.window.OffscreenCanvas(1,1).getContext("2d")&&"function"==typeof e.window.createImageBitmap),se),o=1-(n.width-e.prevPowerOfTwo(n.width))/2;o<1||t.neighboringTiles||(t.neighboringTiles=this._getNeighboringTiles(t.tileID));const l=i?n:e.exported.getImageData(n,o),c={uid:t.uid,coord:t.tileID,source:this.id,rawImageData:l,encoding:this.encoding,padding:o};t.actor&&"expired"!==t.state||(t.actor=this.dispatcher.getActor(),t.actor.send("loadDEMTile",c,r.bind(this),void 0,!0));}}.bind(this));}_getNeighboringTiles(t){const i=t.canonical,o=Math.pow(2,i.z),r=(i.x-1+o)%o,n=0===i.x?t.wrap-1:t.wrap,s=(i.x+1+o)%o,a=i.x+1===o?t.wrap+1:t.wrap,l={};return l[new e.OverscaledTileID(t.overscaledZ,n,i.z,r,i.y).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,a,i.z,s,i.y).key]={backfilled:!1},i.y>0&&(l[new e.OverscaledTileID(t.overscaledZ,n,i.z,r,i.y-1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,t.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,a,i.z,s,i.y-1).key]={backfilled:!1}),i.y+1<o&&(l[new e.OverscaledTileID(t.overscaledZ,n,i.z,r,i.y+1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,t.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,a,i.z,s,i.y+1).key]={backfilled:!1}),l}unloadTile(e){e.demTexture&&this.map.painter.saveTileTexture(e.demTexture),e.fbo&&(e.fbo.destroy(),delete e.fbo),e.dem&&delete e.dem,delete e.neighboringTiles,e.state="unloaded";}},geojson:class extends e.Evented{constructor(t,i,o,r){super(),this.id=t,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._loaded=!1,this.actor=o.getActor(),this.setEventedParent(r),this._data=i.data,this._options=e.extend({},i),this._collectResourceTiming=i.collectResourceTiming,void 0!==i.maxzoom&&(this.maxzoom=i.maxzoom),i.type&&(this.type=i.type),i.attribution&&(this.attribution=i.attribution),this.promoteId=i.promoteId;const n=e.EXTENT/this.tileSize;this.workerOptions=e.extend({source:this.id,cluster:i.cluster||!1,geojsonVtOptions:{buffer:(void 0!==i.buffer?i.buffer:128)*n,tolerance:(void 0!==i.tolerance?i.tolerance:.375)*n,extent:e.EXTENT,maxZoom:this.maxzoom,lineMetrics:i.lineMetrics||!1,generateId:i.generateId||!1},superclusterOptions:{maxZoom:void 0!==i.clusterMaxZoom?i.clusterMaxZoom:this.maxzoom-1,minPoints:Math.max(2,i.clusterMinPoints||2),extent:e.EXTENT,radius:(void 0!==i.clusterRadius?i.clusterRadius:50)*n,log:!1,generateId:i.generateId||!1},clusterProperties:i.clusterProperties,filter:i.filter},i.workerOptions);}onAdd(e){this.map=e,this.setData(this._data);}setData(e){return this._data=e,this._updateWorkerData(),this}getClusterExpansionZoom(e,t){return this.actor.send("geojson.getClusterExpansionZoom",{clusterId:e,source:this.id},t),this}getClusterChildren(e,t){return this.actor.send("geojson.getClusterChildren",{clusterId:e,source:this.id},t),this}getClusterLeaves(e,t,i,o){return this.actor.send("geojson.getClusterLeaves",{source:this.id,clusterId:e,limit:t,offset:i},o),this}_updateWorkerData(){if(this._pendingLoad)return void(this._coalesce=!0);this.fire(new e.Event("dataloading",{dataType:"source"})),this._loaded=!1;const t=e.extend({},this.workerOptions),i=this._data;"string"==typeof i?(t.request=this.map._requestManager.transformRequest(e.exported.resolveURL(i),e.ResourceType.Source),t.request.collectResourceTiming=this._collectResourceTiming):t.data=JSON.stringify(i),this._pendingLoad=this.actor.send(`${this.type}.loadData`,t,((t,i)=>{if(this._loaded=!0,this._pendingLoad=null,t)this.fire(new e.ErrorEvent(t));else {const t={dataType:"source",sourceDataType:this._metadataFired?"content":"metadata"};this._collectResourceTiming&&i&&i.resourceTiming&&i.resourceTiming[this.id]&&(t.resourceTiming=i.resourceTiming[this.id]),this.fire(new e.Event("data",t)),this._metadataFired=!0;}this._coalesce&&(this._updateWorkerData(),this._coalesce=!1);}));}loaded(){return this._loaded}loadTile(t,i){const o=t.actor?"reloadTile":"loadTile";t.actor=this.actor,t.request=this.actor.send(o,{type:this.type,uid:t.uid,tileID:t.tileID,tileZoom:t.tileZoom,zoom:t.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:e.exported.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId},((e,r)=>(delete t.request,t.unloadVectorData(),t.aborted?i(null):e?i(e):(t.loadVectorData(r,this.map.painter,"reloadTile"===o),i(null)))),void 0,"loadTile"===o);}abortTile(e){e.request&&(e.request.cancel(),delete e.request),e.aborted=!0;}unloadTile(e){e.unloadVectorData(),this.actor.send("removeTile",{uid:e.uid,type:this.type,source:this.id});}onRemove(){this._pendingLoad&&this._pendingLoad.cancel();}serialize(){return e.extend({},this._options,{type:this.type,data:this._data})}hasTransition(){return !1}},video:class extends Pe{constructor(e,t,i,o){super(e,t,i,o),this.roundZoom=!0,this.type="video",this.options=t;}load(){this._loaded=!1;const t=this.options;this.urls=[];for(const i of t.urls)this.urls.push(this.map._requestManager.transformRequest(i,e.ResourceType.Source).url);e.getVideo(this.urls,((t,i)=>{this._loaded=!0,t?this.fire(new e.ErrorEvent(t)):i&&(this.video=i,this.video.loop=!0,this.video.setAttribute("playsinline",""),this.video.addEventListener("playing",(()=>{this.map.triggerRepaint();})),this.map&&this.video.play(),this._finishLoading());}));}pause(){this.video&&this.video.pause();}play(){this.video&&this.video.play();}seek(t){if(this.video){const i=this.video.seekable;t<i.start(0)||t>i.end(0)?this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${this.id}`,null,`Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))):this.video.currentTime=t;}}getVideo(){return this.video}onAdd(e){this.map||(this.map=e,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));}prepare(){if(0===Object.keys(this.tiles).length||this.video.readyState<2)return;const t=this.map.painter.context,i=t.gl;this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new e.Texture(t,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),this.width=this.video.videoWidth,this.height=this.video.videoHeight),this._prepareData(t);}serialize(){return {type:"video",urls:this.urls,coordinates:this.coordinates}}hasTransition(){return this.video&&!this.video.paused}},image:Pe,canvas:class extends Pe{constructor(t,i,o,r){super(t,i,o,r),i.coordinates?Array.isArray(i.coordinates)&&4===i.coordinates.length&&!i.coordinates.some((e=>!Array.isArray(e)||2!==e.length||e.some((e=>"number"!=typeof e))))||this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'missing required property "coordinates"'))),i.animate&&"boolean"!=typeof i.animate&&this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'optional "animate" property must be a boolean value'))),i.canvas?"string"==typeof i.canvas||i.canvas instanceof e.window.HTMLCanvasElement||this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'missing required property "canvas"'))),this.options=i,this.animate=void 0===i.animate||i.animate;}load(){this._loaded=!0,this.canvas||(this.canvas=this.options.canvas instanceof e.window.HTMLCanvasElement?this.options.canvas:e.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new e.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint();},this.pause=function(){this._playing&&(this.prepare(),this._playing=!1);},this._finishLoading());}getCanvas(){return this.canvas}onAdd(e){this.map=e,this.load(),this.canvas&&this.animate&&this.play();}onRemove(){this.pause();}prepare(){let t=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,t=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,t=!0),this._hasInvalidDimensions())return;if(0===Object.keys(this.tiles).length)return;const i=this.map.painter.context;this.texture?(t||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new e.Texture(i,this.canvas,i.gl.RGBA,{premultiply:!0}),this._prepareData(i);}serialize(){return {type:"canvas",coordinates:this.coordinates}}hasTransition(){return this._playing}_hasInvalidDimensions(){for(const e of [this.canvas.width,this.canvas.height])if(isNaN(e)||e<=0)return !0;return !1}},custom:class extends e.Evented{constructor(t,i,o,r){super(),this.id=t,this.type="custom",this._dataType="raster",this._dispatcher=o,this._implementation=i,this.setEventedParent(r),this.scheme="xyz",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this._loaded=!1,this.roundZoom=!0,this._implementation||this.fire(new e.ErrorEvent(new Error(`Missing implementation for ${this.id} custom source`))),this._implementation.loadTile||this.fire(new e.ErrorEvent(new Error(`Missing loadTile implementation for ${this.id} custom source`))),this._implementation.bounds&&(this.tileBounds=new B(this._implementation.bounds,this.minzoom,this.maxzoom)),i.update=this._update.bind(this),i.clearTiles=this._clearTiles.bind(this),i.coveringTiles=this._coveringTiles.bind(this),e.extend(this,e.pick(i,["dataType","scheme","minzoom","maxzoom","tileSize","attribution","minTileCacheSize","maxTileCacheSize"]));}serialize(){return e.pick(this,["type","scheme","minzoom","maxzoom","tileSize","attribution"])}load(){this._loaded=!0,this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}));}loaded(){return this._loaded}onAdd(t){this._map=t,this._loaded=!1,this.fire(new e.Event("dataloading",{dataType:"source"})),this._implementation.onAdd&&this._implementation.onAdd(t),this.load();}onRemove(e){this._implementation.onRemove&&this._implementation.onRemove(e);}hasTile(e){if(this._implementation.hasTile){const{x:t,y:i,z:o}=e.canonical;return this._implementation.hasTile({x:t,y:i,z:o})}return !this.tileBounds||this.tileBounds.contains(e.canonical)}loadTile(t,i){const{x:o,y:r,z:n}=t.tileID.canonical,s=new e.window.AbortController;t.request=Promise.resolve(this._implementation.loadTile({x:o,y:r,z:n},{signal:s.signal})).then(function(o){return delete t.request,t.aborted?(t.state="unloaded",i(null)):void 0===o?(t.state="errored",i(null)):null===o?(this.loadTileData(t,{width:this.tileSize,height:this.tileSize,data:null}),t.state="loaded",i(null)):function(t){return t instanceof e.window.ImageData||t instanceof e.window.HTMLCanvasElement||t instanceof e.window.ImageBitmap||t instanceof e.window.HTMLImageElement}(o)?(this.loadTileData(t,o),t.state="loaded",void i(null)):(t.state="errored",i(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)))}.bind(this)).catch((e=>{20!==e.code&&(t.state="errored",i(e));})),t.request.cancel=()=>s.abort();}loadTileData(e,t){Me.loadTileData(e,t,this._map.painter);}unloadTileData(e){Me.unloadTileData(e,this._map.painter);}unloadTile(e,t){if(this.unloadTileData(e),this._implementation.unloadTile){const{x:t,y:i,z:o}=e.tileID.canonical;this._implementation.unloadTile({x:t,y:i,z:o});}t();}abortTile(e,t){e.request&&e.request.cancel&&(e.request.cancel(),delete e.request),t();}hasTransition(){return !1}_coveringTiles(){return this._map.transform.coveringTiles({tileSize:this.tileSize,minzoom:this.minzoom,maxzoom:this.maxzoom,roundZoom:this.roundZoom}).map((e=>({x:e.canonical.x,y:e.canonical.y,z:e.canonical.z})))}_clearTiles(){this._map.style._clearSource(this.id);}_update(){this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}));}}},De=function(t,i,o,r){const n=new Se[i.type](t,i,o,r);if(n.id!==t)throw new Error(`Expected Source id to be ${t} instead of ${n.id}`);return e.bindAll(["load","abort","unload","serialize","prepare"],n),n};function Le(t,i){const o=e.identity([]);return e.scale(o,o,[.5*t.width,.5*-t.height,1]),e.translate(o,o,[1,-1,0]),e.multiply(o,o,t.calculateProjMatrix(i.toUnwrapped())),Float32Array.from(o)}function Ae(e,t,i,o,r,n,s,a=!1){const l=e.tilesIn(o,s,a);l.sort(Re);const c=[];for(const o of l)c.push({wrappedTileID:o.tile.tileID.wrapped().key,queryResults:o.tile.queryRenderedFeatures(t,i,e._state,o,r,n,Le(e.transform,o.tile.tileID),a)});const h=function(e){const t={},i={};for(const o of e){const e=o.queryResults,r=o.wrappedTileID,n=i[r]=i[r]||{};for(const i in e){const o=e[i],r=n[i]=n[i]||{},s=t[i]=t[i]||[];for(const e of o)r[e.featureIndex]||(r[e.featureIndex]=!0,s.push(e));}}return t}(c);for(const t in h)h[t].forEach((t=>{const i=t.feature,o=i.layer;o&&"background"!==o.type&&"sky"!==o.type&&(i.source=o.source,o["source-layer"]&&(i.sourceLayer=o["source-layer"]),i.state=void 0!==i.id?e.getFeatureState(o["source-layer"],i.id):{});}));return h}function ze(e,t){const i=e.getRenderableIds().map((t=>e.getTileByID(t))),o=[],r={};for(let e=0;e<i.length;e++){const n=i[e],s=n.tileID.canonical.key;r[s]||(r[s]=!0,n.querySourceFeatures(o,t));}return o}function Re(e,t){const i=e.tileID,o=t.tileID;return i.overscaledZ-o.overscaledZ||i.canonical.y-o.canonical.y||i.wrap-o.wrap||i.canonical.x-o.canonical.x}function Oe(){return null!=dn.workerClass?new dn.workerClass:new e.window.Worker(dn.workerUrl)}const Be="mapboxgl_preloaded_worker_pool";class ke{constructor(){this.active={};}acquire(e){if(!this.workers)for(this.workers=[];this.workers.length<ke.workerCount;)this.workers.push(new Oe);return this.active[e]=!0,this.workers.slice()}release(e){delete this.active[e],0===this.numActive()&&(this.workers.forEach((e=>{e.terminate();})),this.workers=null);}isPreloaded(){return !!this.active[Be]}numActive(){return Object.keys(this.active).length}}let Fe;function Ue(){return Fe||(Fe=new ke),Fe}function Ne(t,i){const o={};for(const e in t)"ref"!==e&&(o[e]=t[e]);return e.refProperties.forEach((e=>{e in i&&(o[e]=i[e]);})),o}function je(e){e=e.slice();const t=Object.create(null);for(let i=0;i<e.length;i++)t[e[i].id]=e[i];for(let i=0;i<e.length;i++)"ref"in e[i]&&(e[i]=Ne(e[i],t[e[i].ref]));return e}ke.workerCount=2;const Ge={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight",setTerrain:"setTerrain",setFog:"setFog",setProjection:"setProjection"};function Ze(e,t,i){i.push({command:Ge.addSource,args:[e,t[e]]});}function Ve(e,t,i){t.push({command:Ge.removeSource,args:[e]}),i[e]=!0;}function We(e,t,i,o){Ve(e,i,o),Ze(e,t,i);}function Xe(e,i,o){let r;for(r in e[o])if(e[o].hasOwnProperty(r)&&"data"!==r&&!t(e[o][r],i[o][r]))return !1;for(r in i[o])if(i[o].hasOwnProperty(r)&&"data"!==r&&!t(e[o][r],i[o][r]))return !1;return !0}function qe(e,i,o,r,n,s){let a;for(a in i=i||{},e=e||{})e.hasOwnProperty(a)&&(t(e[a],i[a])||o.push({command:s,args:[r,a,i[a],n]}));for(a in i)i.hasOwnProperty(a)&&!e.hasOwnProperty(a)&&(t(e[a],i[a])||o.push({command:s,args:[r,a,i[a],n]}));}function $e(e){return e.id}function He(e,t){return e[t.id]=t,e}class Ye{constructor(e,t){this.reset(e,t);}reset(e,t){this.points=e||[],this._distances=[0];for(let e=1;e<this.points.length;e++)this._distances[e]=this._distances[e-1]+this.points[e].dist(this.points[e-1]);this.length=this._distances[this._distances.length-1],this.padding=Math.min(t||0,.5*this.length),this.paddedLength=this.length-2*this.padding;}lerp(t){if(1===this.points.length)return this.points[0];t=e.clamp(t,0,1);let i=1,o=this._distances[i];const r=t*this.paddedLength+this.padding;for(;o<r&&i<this._distances.length;)o=this._distances[++i];const n=i-1,s=this._distances[n],a=o-s,l=a>0?(r-s)/a:0;return this.points[n].mult(1-l).add(this.points[i].mult(l))}}class Ke{constructor(e,t,i){const o=this.boxCells=[],r=this.circleCells=[];this.xCellCount=Math.ceil(e/i),this.yCellCount=Math.ceil(t/i);for(let e=0;e<this.xCellCount*this.yCellCount;e++)o.push([]),r.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=e,this.height=t,this.xScale=this.xCellCount/e,this.yScale=this.yCellCount/t,this.boxUid=0,this.circleUid=0;}keysLength(){return this.boxKeys.length+this.circleKeys.length}insert(e,t,i,o,r){this._forEachCell(t,i,o,r,this._insertBoxCell,this.boxUid++),this.boxKeys.push(e),this.bboxes.push(t),this.bboxes.push(i),this.bboxes.push(o),this.bboxes.push(r);}insertCircle(e,t,i,o){this._forEachCell(t-o,i-o,t+o,i+o,this._insertCircleCell,this.circleUid++),this.circleKeys.push(e),this.circles.push(t),this.circles.push(i),this.circles.push(o);}_insertBoxCell(e,t,i,o,r,n){this.boxCells[r].push(n);}_insertCircleCell(e,t,i,o,r,n){this.circleCells[r].push(n);}_query(e,t,i,o,r,n){if(i<0||e>this.width||o<0||t>this.height)return !r&&[];const s=[];if(e<=0&&t<=0&&this.width<=i&&this.height<=o){if(r)return !0;for(let e=0;e<this.boxKeys.length;e++)s.push({key:this.boxKeys[e],x1:this.bboxes[4*e],y1:this.bboxes[4*e+1],x2:this.bboxes[4*e+2],y2:this.bboxes[4*e+3]});for(let e=0;e<this.circleKeys.length;e++){const t=this.circles[3*e],i=this.circles[3*e+1],o=this.circles[3*e+2];s.push({key:this.circleKeys[e],x1:t-o,y1:i-o,x2:t+o,y2:i+o});}return n?s.filter(n):s}return this._forEachCell(e,t,i,o,this._queryCell,s,{hitTest:r,seenUids:{box:{},circle:{}}},n),r?s.length>0:s}_queryCircle(e,t,i,o,r){const n=e-i,s=e+i,a=t-i,l=t+i;if(s<0||n>this.width||l<0||a>this.height)return !o&&[];const c=[];return this._forEachCell(n,a,s,l,this._queryCellCircle,c,{hitTest:o,circle:{x:e,y:t,radius:i},seenUids:{box:{},circle:{}}},r),o?c.length>0:c}query(e,t,i,o,r){return this._query(e,t,i,o,!1,r)}hitTest(e,t,i,o,r){return this._query(e,t,i,o,!0,r)}hitTestCircle(e,t,i,o){return this._queryCircle(e,t,i,!0,o)}_queryCell(e,t,i,o,r,n,s,a){const l=s.seenUids,c=this.boxCells[r];if(null!==c){const r=this.bboxes;for(const h of c)if(!l.box[h]){l.box[h]=!0;const c=4*h;if(e<=r[c+2]&&t<=r[c+3]&&i>=r[c+0]&&o>=r[c+1]&&(!a||a(this.boxKeys[h]))){if(s.hitTest)return n.push(!0),!0;n.push({key:this.boxKeys[h],x1:r[c],y1:r[c+1],x2:r[c+2],y2:r[c+3]});}}}const h=this.circleCells[r];if(null!==h){const r=this.circles;for(const c of h)if(!l.circle[c]){l.circle[c]=!0;const h=3*c;if(this._circleAndRectCollide(r[h],r[h+1],r[h+2],e,t,i,o)&&(!a||a(this.circleKeys[c]))){if(s.hitTest)return n.push(!0),!0;{const e=r[h],t=r[h+1],i=r[h+2];n.push({key:this.circleKeys[c],x1:e-i,y1:t-i,x2:e+i,y2:t+i});}}}}}_queryCellCircle(e,t,i,o,r,n,s,a){const l=s.circle,c=s.seenUids,h=this.boxCells[r];if(null!==h){const e=this.bboxes;for(const t of h)if(!c.box[t]){c.box[t]=!0;const i=4*t;if(this._circleAndRectCollide(l.x,l.y,l.radius,e[i+0],e[i+1],e[i+2],e[i+3])&&(!a||a(this.boxKeys[t])))return n.push(!0),!0}}const u=this.circleCells[r];if(null!==u){const e=this.circles;for(const t of u)if(!c.circle[t]){c.circle[t]=!0;const i=3*t;if(this._circlesCollide(e[i],e[i+1],e[i+2],l.x,l.y,l.radius)&&(!a||a(this.circleKeys[t])))return n.push(!0),!0}}}_forEachCell(e,t,i,o,r,n,s,a){const l=this._convertToXCellCoord(e),c=this._convertToYCellCoord(t),h=this._convertToXCellCoord(i),u=this._convertToYCellCoord(o);for(let _=l;_<=h;_++)for(let l=c;l<=u;l++)if(r.call(this,e,t,i,o,this.xCellCount*l+_,n,s,a))return}_convertToXCellCoord(e){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(e*this.xScale)))}_convertToYCellCoord(e){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(e*this.yScale)))}_circlesCollide(e,t,i,o,r,n){const s=o-e,a=r-t,l=i+n;return l*l>s*s+a*a}_circleAndRectCollide(e,t,i,o,r,n,s){const a=(n-o)/2,l=Math.abs(e-(o+a));if(l>a+i)return !1;const c=(s-r)/2,h=Math.abs(t-(r+c));if(h>c+i)return !1;if(l<=a||h<=c)return !0;const u=l-a,_=h-c;return u*u+_*_<=i*i}}const Je={unknown:0,flipRequired:1,flipNotRequired:2},Qe=Math.tan(85*Math.PI/180);function et(t,i,o,r,n,s,a){const l=e.create();if(o)if("globe"===s.name){const t=e.calculateGlobeLabelMatrix(n,i);e.multiply(l,l,t);}else {const t=v([],a);l[0]=t[0],l[1]=t[1],l[4]=t[2],l[5]=t[3],r||e.rotateZ(l,l,n.angle);}else e.multiply(l,n.labelPlaneMatrix,t);return l}function tt(e,t,i,o,r,n,s){const a=et(e,t,i,o,r,n,s);return "globe"===n.name&&i||(a[2]=a[6]=a[10]=a[14]=0),a}function it(t,i,o,r,n,s,a){if(o){if("globe"===s.name){const l=et(t,i,o,r,n,s,a);return e.invert(l,l),e.multiply(l,t,l),l}{const i=e.clone(t),o=e.identity([]);return o[0]=a[0],o[1]=a[1],o[4]=a[2],o[5]=a[3],e.multiply(i,i,o),r||e.rotateZ(i,i,-n.angle),i}}return n.glCoordMatrix}function ot(t,i,o,r){const n=[t,i,o,1];o?e.transformMat4$1(n,n,r):pt(n,n,r);const s=n[3];return n[0]/=s,n[1]/=s,n[2]/=s,n}function rt(e,t){return Math.min(.5+e/t*.5,1.5)}function nt(e,t){const i=e[0]/e[3],o=e[1]/e[3];return i>=-t[0]&&i<=t[0]&&o>=-t[1]&&o<=t[1]}function st(t,i,o,r,n,s,a,l,c,h){const u=o.transform,_=r?t.textSizeData:t.iconSizeData,d=e.evaluateSizeForZoom(_,o.transform.zoom),p="globe"===u.projection.name,m=[256/o.width*2+1,256/o.height*2+1],f=r?t.text.dynamicLayoutVertexArray:t.icon.dynamicLayoutVertexArray;f.clear();let g=null;p&&(g=r?t.text.globeExtVertexArray:t.icon.globeExtVertexArray);const v=t.lineVertexArray,x=r?t.text.placedSymbolArray:t.icon.placedSymbolArray,y=o.transform.width/o.transform.height;let b,w=!1;for(let r=0;r<x.length;r++){const p=x.get(r),{numGlyphs:T,writingMode:E}=p;if(E!==e.WritingMode.vertical||w||b===e.WritingMode.horizontal||(w=!0),b=E,(p.hidden||E===e.WritingMode.vertical)&&!w){dt(T,f);continue}w=!1;const C=new e.Point(p.tileAnchorX,p.tileAnchorY);let{x:M,y:I,z:P}=u.projection.projectTilePoint(C.x,C.y,h.canonical);if(c){const[e,t,i]=c(C);M+=e,I+=t,P+=i;}const S=[M,I,P,1];if(e.transformMat4$1(S,S,i),!nt(S,m)){dt(T,f);continue}const D=rt(o.transform.cameraToCenterDistance,S[3]),L=e.evaluateSizeForFeature(_,d,p),A=a?L/D:L*D,z=ot(M,I,P,n);if(z[3]<=0){dt(T,f);continue}let R={};const O=a?null:c,B=ct(p,A,!1,l,i,n,s,t.glyphOffsetArray,v,f,g,z,C,R,y,O,u.projection,h,a);w=B.useVertical,O&&B.needsFlipping&&(R={}),(B.notEnoughRoom||w||B.needsFlipping&&ct(p,A,!0,l,i,n,s,t.glyphOffsetArray,v,f,g,z,C,R,y,O,u.projection,h,a).notEnoughRoom)&&dt(T,f);}r?(t.text.dynamicLayoutVertexBuffer.updateData(f),g&&t.text.globeExtVertexBuffer.updateData(g)):(t.icon.dynamicLayoutVertexBuffer.updateData(f),g&&t.icon.globeExtVertexBuffer.updateData(g));}function at(e,t,i,o,r,n,s,a,l,c,h,u,_,d,p,m){const{lineStartIndex:f,glyphStartIndex:g,segment:v}=a,x=g+a.numGlyphs,y=f+a.lineLength,b=t.getoffsetX(g),w=t.getoffsetX(x-1),T=_t(e*b,i,o,r,n,s,v,f,y,l,c,h,u,_,!0,d,p,m);if(!T)return null;const E=_t(e*w,i,o,r,n,s,v,f,y,l,c,h,u,_,!0,d,p,m);return E?{first:T,last:E}:null}function lt(t,i,o,r){return t===e.WritingMode.horizontal&&Math.abs(r)>Math.abs(o)?{useVertical:!0}:t===e.WritingMode.vertical?r>0?{needsFlipping:!0}:null:i!==Je.unknown&&function(e,t){return 0===e||Math.abs(t/e)>Qe}(o,r)?i===Je.flipRequired?{needsFlipping:!0}:null:o<0?{needsFlipping:!0}:null}function ct(t,i,o,r,n,s,a,l,c,h,u,_,d,p,m,f,g,v,x){const y=i/24,b=t.lineOffsetX*y,w=t.lineOffsetY*y,{lineStartIndex:T,glyphStartIndex:E,numGlyphs:C,segment:M,writingMode:I,flipState:P}=t,S=T+t.lineLength,D=t=>{if(u){const[i,o,r]=t.up,n=h.length;e.updateGlobeVertexNormal(u,n+0,i,o,r),e.updateGlobeVertexNormal(u,n+1,i,o,r),e.updateGlobeVertexNormal(u,n+2,i,o,r),e.updateGlobeVertexNormal(u,n+3,i,o,r);}const[i,o,r]=t.point;e.addDynamicAttributes(h,i,o,r,t.angle);};if(C>1){const e=at(y,l,b,w,o,_,d,t,c,s,p,f,!1,g,v,x);if(!e)return {notEnoughRoom:!0};if(r&&!o){let[i,o,r]=e.first.point,[n,s,l]=e.last.point;[i,o]=ot(i,o,r,a),[n,s]=ot(n,s,l,a);const c=lt(I,P,(n-i)*m,s-o);if(t.flipState=c&&c.needsFlipping?Je.flipRequired:Je.flipNotRequired,c)return c}D(e.first);for(let e=E+1;e<E+C-1;e++){const t=_t(y*l.getoffsetX(e),b,w,o,_,d,M,T,S,c,s,p,f,!1,!1,g,v,x);if(!t)return h.length-=4*(e-E),{notEnoughRoom:!0};D(t);}D(e.last);}else {if(r&&!o){const i=ot(d.x,d.y,0,n),o=T+M+1,r=new e.Point(c.getx(o),c.gety(o)),s=ot(r.x,r.y,0,n),a=s[3]>0?s:ut(d,r,i,1,n,void 0,g,v.canonical),l=lt(I,P,(a[0]-i[0])*m,a[1]-i[1]);if(t.flipState=l&&l.needsFlipping?Je.flipRequired:Je.flipNotRequired,l)return l}const i=_t(y*l.getoffsetX(E),b,w,o,_,d,M,T,S,c,s,p,f,!1,!1,g,v,x);if(!i)return {notEnoughRoom:!0};D(i);}return {}}function ht(e,t,i,o,r){const{x:n,y:s,z:a}=o.projectTilePoint(e.x,e.y,t);if(!r)return ot(n,s,a,i);const[l,c,h]=r(e);return ot(n+l,s+c,a+h,i)}function ut(t,i,o,r,n,s,a,l){const c=ht(t.sub(i)._unit()._add(t),l,n,a,s);return e.sub(c,o,c),e.normalize(c,c),e.scaleAndAdd(c,o,c,r)}function _t(t,i,o,r,n,s,a,l,c,h,u,_,d,p,m,f,g,v){const x=r?t-i:t+i;let y=x>0?1:-1,b=0;r&&(y*=-1,b=Math.PI),y<0&&(b+=Math.PI);let w=l+a+(y>0?0:1)|0,T=n,E=n,C=0,M=0;const I=Math.abs(x),P=[],S=[];let D=s,L=D;const A=()=>ut(L,D,E,I-C+1,u,d,f,g.canonical);for(;C+M<=I;){if(w+=y,w<l||w>=c)return null;if(E=T,L=D,P.push(E),p&&S.push(L),D=new e.Point(h.getx(w),h.gety(w)),T=_[w],!T){const e=ht(D,g.canonical,u,f,d);T=e[3]>0?_[w]=e:A();}C+=M,M=e.distance(E,T);}m&&d&&(_[w]&&(T=A(),M=e.distance(E,T)),_[w]=T);const z=(I-C)/M,R=D.sub(L)._mult(z)._add(L),O=e.sub([],T,E),B=e.scaleAndAdd([],E,O,z);let k=[0,0,1],F=O[0],U=O[1];if(v&&(k=f.upVector(g.canonical,R.x,R.y),0!==k[0]||0!==k[1]||1!==k[2])){const t=[k[2],0,-k[0]],i=e.cross([],k,t);e.normalize(t,t),e.normalize(i,i),F=e.dot(O,t),U=e.dot(O,i);}if(o){const t=e.cross([],k,O);e.normalize(t,t),e.scaleAndAdd(B,B,t,o*y);}const N=b+Math.atan2(U,F);return P.push(B),p&&S.push(R),{point:B,angle:N,path:P,tilePath:S,up:k}}function dt(e,t){const i=t.length,o=i+4*e;t.resize(o),t.float32.fill(-1/0,4*i,4*o);}function pt(e,t,i){const o=t[0],r=t[1];return e[0]=i[0]*o+i[4]*r+i[12],e[1]=i[1]*o+i[5]*r+i[13],e[3]=i[3]*o+i[7]*r+i[15],e}const mt=100;class ft{constructor(e,t,i=new Ke(e.width+200,e.height+200,25),o=new Ke(e.width+200,e.height+200,25)){this.transform=e,this.grid=i,this.ignoredGrid=o,this.pitchfactor=Math.cos(e._pitch)*e.cameraToCenterDistance,this.screenRightBoundary=e.width+mt,this.screenBottomBoundary=e.height+mt,this.gridRightBoundary=e.width+200,this.gridBottomBoundary=e.height+200,this.fogState=t;}placeCollisionBox(e,t,i,o,r,n,s,a){let l=i.projectedAnchorX,c=i.projectedAnchorY,h=i.projectedAnchorZ;const u=i.elevation,_=i.tileID,d=e.getProjection();if(u&&_){const[e,t,o]=d.upVector(_.canonical,i.tileAnchorX,i.tileAnchorY),r=d.upVectorScale(_.canonical,this.transform.center.lat,this.transform.worldSize).metersToTile;l+=e*u*r,c+=t*u*r,h+=o*u*r;}const p=this.projectAndGetPerspectiveRatio(s,l,c,h,i.tileID,"globe"===d.name||!!u||this.transform.pitch>0,d),m=n*p.perspectiveRatio,f=(i.x1*t+o.x-i.padding)*m+p.point.x,g=(i.y1*t+o.y-i.padding)*m+p.point.y,v=(i.x2*t+o.x+i.padding)*m+p.point.x,x=(i.y2*t+o.y+i.padding)*m+p.point.y,y=p.perspectiveRatio<=.55||p.occluded;return !this.isInsideGrid(f,g,v,x)||!r&&this.grid.hitTest(f,g,v,x,a)||y?{box:[],offscreen:!1,occluded:p.occluded}:{box:[f,g,v,x],offscreen:this.isOffscreen(f,g,v,x),occluded:!1}}placeCollisionCircles(t,i,o,r,n,s,a,l,c,h,u,_,d,p,m){const f=[],g=this.transform.elevation,v=t.getProjection(),x=g?g.getAtTileOffsetFunc(m,this.transform.center.lat,this.transform.worldSize,v):null,y=new e.Point(o.tileAnchorX,o.tileAnchorY);let{x:b,y:w,z:T}=v.projectTilePoint(y.x,y.y,m.canonical);if(x){const[e,t,i]=x(y);b+=e,w+=t,T+=i;}const E="globe"===v.name,C=this.projectAndGetPerspectiveRatio(a,b,w,T,m,E||!!g||this.transform.pitch>0,v),{perspectiveRatio:M}=C,I=(u?s/M:s*M)/e.ONE_EM,P=ot(b,w,T,l),S=C.signedDistanceFromCamera>0?at(I,n,o.lineOffsetX*I,o.lineOffsetY*I,!1,P,y,o,r,l,{},g&&!u?x:null,u&&!!g,v,m,u):null;let D=!1,L=!1,A=!0;if(S&&!C.occluded){const t=.5*d*M+p,o=new e.Point(-100,-100),r=new e.Point(this.screenRightBoundary,this.screenBottomBoundary),n=new Ye,{first:s,last:a}=S,l=s.path.length;let u=[];for(let e=l-1;e>=1;e--)u.push(s.path[e]);for(let e=1;e<a.path.length;e++)u.push(a.path[e]);const m=2.5*t;c&&(u=u.map((([e,t,i],o)=>(x&&!E&&(i=x(o<l-1?s.tilePath[l-1-o]:a.tilePath[o-l+2])[2]),ot(e,t,i,c)))),u.some((e=>e[3]<=0))&&(u=[]));let g=[];if(u.length>0){let t=1/0,i=-1/0,n=1/0,s=-1/0;for(const e of u)t=Math.min(t,e[0]),n=Math.min(n,e[1]),i=Math.max(i,e[0]),s=Math.max(s,e[1]);i>=o.x&&t<=r.x&&s>=o.y&&n<=r.y&&(g=[u.map((t=>new e.Point(t[0],t[1])))],(t<o.x||i>r.x||n<o.y||s>r.y)&&(g=e.clipLine(g,o.x,o.y,r.x,r.y)));}for(const e of g){n.reset(e,.25*t);let o=0;o=n.length<=.5*t?1:Math.ceil(n.paddedLength/m)+1;for(let e=0;e<o;e++){const r=e/Math.max(o-1,1),s=n.lerp(r),a=s.x+mt,l=s.y+mt;f.push(a,l,t,0);const c=a-t,u=l-t,d=a+t,p=l+t;if(A=A&&this.isOffscreen(c,u,d,p),L=L||this.isInsideGrid(c,u,d,p),!i&&this.grid.hitTestCircle(a,l,t,_)&&(D=!0,!h))return {circles:[],offscreen:!1,collisionDetected:D,occluded:!1}}}}return {circles:!h&&D||!L?[]:f,offscreen:A,collisionDetected:D,occluded:C.occluded}}queryRenderedSymbols(t){if(0===t.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};const i=[];let o=1/0,r=1/0,n=-1/0,s=-1/0;for(const a of t){const t=new e.Point(a.x+mt,a.y+mt);o=Math.min(o,t.x),r=Math.min(r,t.y),n=Math.max(n,t.x),s=Math.max(s,t.y),i.push(t);}const a=this.grid.query(o,r,n,s).concat(this.ignoredGrid.query(o,r,n,s)),l={},c={};for(const t of a){const o=t.key;if(void 0===l[o.bucketInstanceId]&&(l[o.bucketInstanceId]={}),l[o.bucketInstanceId][o.featureIndex])continue;const r=[new e.Point(t.x1,t.y1),new e.Point(t.x2,t.y1),new e.Point(t.x2,t.y2),new e.Point(t.x1,t.y2)];e.polygonIntersectsPolygon(i,r)&&(l[o.bucketInstanceId][o.featureIndex]=!0,void 0===c[o.bucketInstanceId]&&(c[o.bucketInstanceId]=[]),c[o.bucketInstanceId].push(o.featureIndex));}return c}insertCollisionBox(e,t,i,o,r){(t?this.ignoredGrid:this.grid).insert({bucketInstanceId:i,featureIndex:o,collisionGroupID:r},e[0],e[1],e[2],e[3]);}insertCollisionCircles(e,t,i,o,r){const n=t?this.ignoredGrid:this.grid,s={bucketInstanceId:i,featureIndex:o,collisionGroupID:r};for(let t=0;t<e.length;t+=4)n.insertCircle(s,e[t],e[t+1],e[t+2]);}projectAndGetPerspectiveRatio(t,i,o,r,n,s,a){const l=[i,o,r,1];let c=!1;if(r||this.transform.pitch>0){if(e.transformMat4$1(l,l,t),this.fogState&&n&&"globe"!==a.name){const t=function(t,i,o,r,n,s){const a=s.calculateFogTileMatrix(n),l=[i,o,r];return e.transformMat4(l,l,a),C(t,l,s.pitch,s._fov)}(this.fogState,i,o,r,n.toUnwrapped(),this.transform);c=t>.9;}}else pt(l,l,t);const h=l[3];return {point:new e.Point((l[0]/h+1)/2*this.transform.width+mt,(-l[1]/h+1)/2*this.transform.height+mt),perspectiveRatio:Math.min(.5+this.transform.getCameraToCenterDistance(a)/h*.5,1.5),signedDistanceFromCamera:h,occluded:s&&l[2]>h||c}}isOffscreen(e,t,i,o){return i<mt||e>=this.screenRightBoundary||o<mt||t>this.screenBottomBoundary}isInsideGrid(e,t,i,o){return i>=0&&e<this.gridRightBoundary&&o>=0&&t<this.gridBottomBoundary}getViewportMatrix(){const t=e.identity([]);return e.translate(t,t,[-100,-100,0]),t}}function gt(t,i,o){const r=i.createTileMatrix(t,t.worldSize,o.toUnwrapped());return e.multiply(new Float32Array(16),t.projMatrix,r)}function vt(e,t,i){if(t.projection.name===i.projection.name)return e.projMatrix;const o=i.clone();return o.setProjection(t.projection),gt(o,t.getProjection(),e)}function xt(e,t,i){return t.name===i.projection.name?e.projMatrix:gt(i,t,e)}class yt{constructor(e,t,i,o){this.opacity=e?Math.max(0,Math.min(1,e.opacity+(e.placed?t:-t))):o&&i?1:0,this.placed=i;}isHidden(){return 0===this.opacity&&!this.placed}}class bt{constructor(e,t,i,o,r,n=!1){this.text=new yt(e?e.text:null,t,i,r),this.icon=new yt(e?e.icon:null,t,o,r),this.clipped=n;}isHidden(){return this.text.isHidden()&&this.icon.isHidden()}}class wt{constructor(e,t,i,o=!1){this.text=e,this.icon=t,this.skipFade=i,this.clipped=o;}}class Tt{constructor(){this.invProjMatrix=e.create(),this.viewportMatrix=e.create(),this.circles=[];}}class Et{constructor(e,t,i,o,r){this.bucketInstanceId=e,this.featureIndex=t,this.sourceLayerIndex=i,this.bucketIndex=o,this.tileID=r;}}class Ct{constructor(e){this.crossSourceCollisions=e,this.maxGroupID=0,this.collisionGroups={};}get(e){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[e]){const t=++this.maxGroupID;this.collisionGroups[e]={ID:t,predicate:e=>e.collisionGroupID===t};}return this.collisionGroups[e]}}function Mt(t,i,o,r,n){const{horizontalAlign:s,verticalAlign:a}=e.getAnchorAlignment(t),l=-(s-.5)*i,c=-(a-.5)*o,h=e.evaluateVariableOffset(t,r);return new e.Point(l+h[0]*n,c+h[1]*n)}function It(t,i,o,r,n){const s=new e.Point(t,i);return o&&s._rotate(r?n:-n),s}class Pt{constructor(e,t,i,o,r){this.transform=e.clone(),this.projection=e.projection.name,this.collisionIndex=new ft(this.transform,r),this.placements={},this.opacities={},this.variableOffsets={},this.stale=!1,this.commitTime=0,this.fadeDuration=t,this.retainedQueryData={},this.collisionGroups=new Ct(i),this.collisionCircleArrays={},this.prevPlacement=o,o&&(o.prevPlacement=void 0),this.placedOrientations={};}getBucketParts(t,i,o,r){const n=o.getBucket(i),s=o.latestFeatureIndex;if(!n||!s||i.id!==n.layerIds[0])return;const a=n.layers[0].layout,l=o.collisionBoxArray,c=Math.pow(2,this.transform.zoom-o.tileID.overscaledZ),h=o.tileSize/e.EXTENT,u=o.tileID.toUnwrapped();this.transform.setProjection(n.projection);const _=(d=o.tileID,p=n.getProjection(),m=this.transform,p.name===this.projection?m.calculateProjMatrix(d.toUnwrapped()):gt(m,p,d));var d,p,m;const f="map"===a.get("text-pitch-alignment"),g="map"===a.get("text-rotation-alignment");i.compileFilter();const v=i.dynamicFilter(),x=i.dynamicFilterNeedsFeature(),y=this.transform.calculatePixelsToTileUnitsMatrix(o),b=tt(_,o.tileID.canonical,f,g,this.transform,n.getProjection(),y);let w=null;if(f){const t=it(_,o.tileID.canonical,f,g,this.transform,n.getProjection(),y);w=e.multiply([],this.transform.labelPlaneMatrix,t);}let T=null;v&&o.latestFeatureIndex&&(T={unwrappedTileID:u,dynamicFilter:v,dynamicFilterNeedsFeature:x,featureIndex:o.latestFeatureIndex}),this.retainedQueryData[n.bucketInstanceId]=new Et(n.bucketInstanceId,s,n.sourceLayerIndex,n.index,o.tileID);const E={bucket:n,layout:a,posMatrix:_,textLabelPlaneMatrix:b,labelToScreenMatrix:w,clippingData:T,scale:c,textPixelRatio:h,holdingForFade:o.holdingForFade(),collisionBoxArray:l,partiallyEvaluatedTextSize:e.evaluateSizeForZoom(n.textSizeData,this.transform.zoom),partiallyEvaluatedIconSize:e.evaluateSizeForZoom(n.iconSizeData,this.transform.zoom),collisionGroup:this.collisionGroups.get(n.sourceID)};if(r)for(const e of n.sortKeyRanges){const{sortKey:i,symbolInstanceStart:o,symbolInstanceEnd:r}=e;t.push({sortKey:i,symbolInstanceStart:o,symbolInstanceEnd:r,parameters:E});}else t.push({symbolInstanceStart:0,symbolInstanceEnd:n.symbolInstances.length,parameters:E});}attemptAnchorPlacement(e,t,i,o,r,n,s,a,l,c,h,u,_,d,p,m,f,g){const{textOffset0:v,textOffset1:x,crossTileID:y}=u,b=[v,x],w=Mt(e,i,o,b,r),T=this.collisionIndex.placeCollisionBox(d,r,t,It(w.x,w.y,n,s,this.transform.angle),h,a,l,c.predicate);if(m){const e=d.getSymbolInstanceIconSize(g,this.transform.zoom,u.placedIconSymbolIndex);if(0===this.collisionIndex.placeCollisionBox(d,e,m,It(w.x,w.y,n,s,this.transform.angle),h,a,l,c.predicate).box.length)return}if(T.box.length>0){let t;return this.prevPlacement&&this.prevPlacement.variableOffsets[y]&&this.prevPlacement.placements[y]&&this.prevPlacement.placements[y].text&&(t=this.prevPlacement.variableOffsets[y].anchor),this.variableOffsets[y]={textOffset:b,width:i,height:o,anchor:e,textScale:r,prevAnchor:t},this.markUsedJustification(d,e,u,p),d.allowVerticalPlacement&&(this.markUsedOrientation(d,p,u),this.placedOrientations[y]=p),{shift:w,placedGlyphBoxes:T}}}placeLayerBucketPart(t,i,o,r){const{bucket:n,layout:s,posMatrix:a,textLabelPlaneMatrix:l,labelToScreenMatrix:c,clippingData:h,textPixelRatio:u,holdingForFade:_,collisionBoxArray:d,partiallyEvaluatedTextSize:p,partiallyEvaluatedIconSize:m,collisionGroup:f}=t.parameters,g=s.get("text-optional"),v=s.get("icon-optional"),x=s.get("text-allow-overlap"),y=s.get("icon-allow-overlap"),b="map"===s.get("text-rotation-alignment"),w="map"===s.get("text-pitch-alignment"),T="none"!==s.get("icon-text-fit"),E="viewport-y"===s.get("symbol-z-order");this.transform.setProjection(n.projection);let C=x&&(y||!n.hasIconData()||v),M=y&&(x||!n.hasTextData()||g);!n.collisionArrays&&d&&n.deserializeCollisionBoxes(d),o&&r&&n.updateCollisionDebugBuffers(this.transform.zoom,d);const I=(t,r,d)=>{const{crossTileID:E,numVerticalGlyphVertices:I}=t;if(h){const o={zoom:this.transform.zoom,pitch:this.transform.pitch};let r=null;if(h.dynamicFilterNeedsFeature){const e=this.retainedQueryData[n.bucketInstanceId];r=h.featureIndex.loadFeature({featureIndex:t.featureIndex,bucketIndex:e.bucketIndex,sourceLayerIndex:e.sourceLayerIndex,layoutVertexArrayOffset:0});}if(!(0,h.dynamicFilter)(o,r,this.retainedQueryData[n.bucketInstanceId].tileID.canonical,new e.Point(t.tileAnchorX,t.tileAnchorY),this.transform.calculateDistanceTileData(h.unwrappedTileID)))return this.placements[E]=new wt(!1,!1,!1,!0),void i.add(E)}if(i.has(E))return;if(_)return void(this.placements[E]=new wt(!1,!1,!1));let P=!1,S=!1,D=!0,L=!1,A=!1,z=null,R={box:null,offscreen:null,occluded:null},O={box:null,offscreen:null,occluded:null},B=null,k=null,F=null,U=0,N=0,j=0;d.textFeatureIndex?U=d.textFeatureIndex:t.useRuntimeCollisionCircles&&(U=t.featureIndex),d.verticalTextFeatureIndex&&(N=d.verticalTextFeatureIndex);const G=e=>{e.tileID=this.retainedQueryData[n.bucketInstanceId].tileID;const t=this.transform.elevation;(t||e.elevation)&&(e.elevation=t?t.getAtTileOffset(e.tileID,e.tileAnchorX,e.tileAnchorY):0);},Z=d.textBox;if(Z){G(Z);const i=i=>{let o=e.WritingMode.horizontal;if(n.allowVerticalPlacement&&!i&&this.prevPlacement){const e=this.prevPlacement.placedOrientations[E];e&&(this.placedOrientations[E]=e,o=e,this.markUsedOrientation(n,o,t));}return o},o=(t,i)=>{if(n.allowVerticalPlacement&&I>0&&d.verticalTextBox){for(const o of n.writingModes)if(o===e.WritingMode.vertical?(R=i(),O=R):R=t(),R&&R.box&&R.box.length)break}else R=t();};if(s.get("text-variable-anchor")){let l=s.get("text-variable-anchor");if(this.prevPlacement&&this.prevPlacement.variableOffsets[E]){const e=this.prevPlacement.variableOffsets[E];l.indexOf(e.anchor)>0&&(l=l.filter((t=>t!==e.anchor)),l.unshift(e.anchor));}const c=(e,i,o)=>{const s=n.getSymbolInstanceTextSize(p,t,this.transform.zoom,r),c=(e.x2-e.x1)*s+2*e.padding,h=(e.y2-e.y1)*s+2*e.padding,_=T&&!y?i:null;_&&G(_);let d={box:[],offscreen:!1,occluded:!1};const g=x?2*l.length:l.length;for(let i=0;i<g;++i){const g=this.attemptAnchorPlacement(l[i%l.length],e,c,h,s,b,w,u,a,f,i>=l.length,t,r,n,o,_,p,m);if(g&&(d=g.placedGlyphBoxes,d&&d.box&&d.box.length)){P=!0,z=g.shift;break}}return d};o((()=>c(Z,d.iconBox,e.WritingMode.horizontal)),(()=>{const t=d.verticalTextBox;return t&&G(t),n.allowVerticalPlacement&&!(R&&R.box&&R.box.length)&&I>0&&t?c(t,d.verticalIconBox,e.WritingMode.vertical):{box:null,offscreen:null,occluded:null}})),R&&(P=R.box,D=R.offscreen,L=R.occluded);const h=i(!(!R||!R.box));if(!P&&this.prevPlacement){const e=this.prevPlacement.variableOffsets[E];e&&(this.variableOffsets[E]=e,this.markUsedJustification(n,e.anchor,t,h));}}else {const s=(i,o)=>{const s=n.getSymbolInstanceTextSize(p,t,this.transform.zoom,r),l=this.collisionIndex.placeCollisionBox(n,s,i,new e.Point(0,0),x,u,a,f.predicate);return l&&l.box&&l.box.length&&(this.markUsedOrientation(n,o,t),this.placedOrientations[E]=o),l};o((()=>s(Z,e.WritingMode.horizontal)),(()=>{const t=d.verticalTextBox;return n.allowVerticalPlacement&&I>0&&t?(G(t),s(t,e.WritingMode.vertical)):{box:null,offscreen:null,occluded:null}})),i(!!(R&&R.box&&R.box.length));}}if(B=R,P=B&&B.box&&B.box.length>0,D=B&&B.offscreen,L=B&&B.occluded,t.useRuntimeCollisionCircles){const i=n.text.placedSymbolArray.get(t.centerJustifiedTextSymbolIndex>=0?t.centerJustifiedTextSymbolIndex:t.verticalPlacedTextSymbolIndex),r=e.evaluateSizeForFeature(n.textSizeData,p,i),h=s.get("text-padding");k=this.collisionIndex.placeCollisionCircles(n,x,i,n.lineVertexArray,n.glyphOffsetArray,r,a,l,c,o,w,f.predicate,t.collisionCircleDiameter*r/e.ONE_EM,h,this.retainedQueryData[n.bucketInstanceId].tileID),P=x||k.circles.length>0&&!k.collisionDetected,D=D&&k.offscreen,L=k.occluded;}if(d.iconFeatureIndex&&(j=d.iconFeatureIndex),d.iconBox){const i=i=>{G(i);const o=T&&z?It(z.x,z.y,b,w,this.transform.angle):new e.Point(0,0),r=n.getSymbolInstanceIconSize(m,this.transform.zoom,t.placedIconSymbolIndex);return this.collisionIndex.placeCollisionBox(n,r,i,o,y,u,a,f.predicate)};O&&O.box&&O.box.length&&d.verticalIconBox?(F=i(d.verticalIconBox),S=F.box.length>0):(F=i(d.iconBox),S=F.box.length>0),D=D&&F.offscreen,A=F.occluded;}const V=g||0===t.numHorizontalGlyphVertices&&0===I,W=v||0===t.numIconVertices;if(V||W?W?V||(S=S&&P):P=S&&P:S=P=S&&P,P&&B&&B.box&&this.collisionIndex.insertCollisionBox(B.box,s.get("text-ignore-placement"),n.bucketInstanceId,O&&O.box&&N?N:U,f.ID),S&&F&&this.collisionIndex.insertCollisionBox(F.box,s.get("icon-ignore-placement"),n.bucketInstanceId,j,f.ID),k&&(P&&this.collisionIndex.insertCollisionCircles(k.circles,s.get("text-ignore-placement"),n.bucketInstanceId,U,f.ID),o)){const e=n.bucketInstanceId;let t=this.collisionCircleArrays[e];void 0===t&&(t=this.collisionCircleArrays[e]=new Tt);for(let e=0;e<k.circles.length;e+=4)t.circles.push(k.circles[e+0]),t.circles.push(k.circles[e+1]),t.circles.push(k.circles[e+2]),t.circles.push(k.collisionDetected?1:0);}const X="globe"!==n.projection.name;C=C&&(X||!L),M=M&&(X||!A),this.placements[E]=new wt(P||C,S||M,D||n.justReloaded),i.add(E);};if(E){const e=n.getSortedSymbolIndexes(this.transform.angle);for(let t=e.length-1;t>=0;--t){const i=e[t];I(n.symbolInstances.get(i),i,n.collisionArrays[i]);}}else for(let e=t.symbolInstanceStart;e<t.symbolInstanceEnd;e++)I(n.symbolInstances.get(e),e,n.collisionArrays[e]);if(o&&n.bucketInstanceId in this.collisionCircleArrays){const t=this.collisionCircleArrays[n.bucketInstanceId];e.invert(t.invProjMatrix,a),t.viewportMatrix=this.collisionIndex.getViewportMatrix();}n.justReloaded=!1;}markUsedJustification(t,i,o,r){const{leftJustifiedTextSymbolIndex:n,centerJustifiedTextSymbolIndex:s,rightJustifiedTextSymbolIndex:a,verticalPlacedTextSymbolIndex:l,crossTileID:c}=o,h=e.getAnchorJustification(i),u=r===e.WritingMode.vertical?l:"left"===h?n:"center"===h?s:"right"===h?a:-1;n>=0&&(t.text.placedSymbolArray.get(n).crossTileID=u>=0&&n!==u?0:c),s>=0&&(t.text.placedSymbolArray.get(s).crossTileID=u>=0&&s!==u?0:c),a>=0&&(t.text.placedSymbolArray.get(a).crossTileID=u>=0&&a!==u?0:c),l>=0&&(t.text.placedSymbolArray.get(l).crossTileID=u>=0&&l!==u?0:c);}markUsedOrientation(t,i,o){const r=i===e.WritingMode.horizontal||i===e.WritingMode.horizontalOnly?i:0,n=i===e.WritingMode.vertical?i:0,{leftJustifiedTextSymbolIndex:s,centerJustifiedTextSymbolIndex:a,rightJustifiedTextSymbolIndex:l,verticalPlacedTextSymbolIndex:c}=o,h=t.text.placedSymbolArray;s>=0&&(h.get(s).placedOrientation=r),a>=0&&(h.get(a).placedOrientation=r),l>=0&&(h.get(l).placedOrientation=r),c>=0&&(h.get(c).placedOrientation=n);}commit(e){this.commitTime=e,this.zoomAtLastRecencyCheck=this.transform.zoom;const t=this.prevPlacement;let i=!1;this.prevZoomAdjustment=t?t.zoomAdjustment(this.transform.zoom):0;const o=t?t.symbolFadeChange(e):1,r=t?t.opacities:{},n=t?t.variableOffsets:{},s=t?t.placedOrientations:{};for(const e in this.placements){const t=this.placements[e],n=r[e];n?(this.opacities[e]=new bt(n,o,t.text,t.icon,null,t.clipped),i=i||t.text!==n.text.placed||t.icon!==n.icon.placed):(this.opacities[e]=new bt(null,o,t.text,t.icon,t.skipFade,t.clipped),i=i||t.text||t.icon);}for(const e in r){const t=r[e];if(!this.opacities[e]){const r=new bt(t,o,!1,!1);r.isHidden()||(this.opacities[e]=r,i=i||t.text.placed||t.icon.placed);}}for(const e in n)this.variableOffsets[e]||!this.opacities[e]||this.opacities[e].isHidden()||(this.variableOffsets[e]=n[e]);for(const e in s)this.placedOrientations[e]||!this.opacities[e]||this.opacities[e].isHidden()||(this.placedOrientations[e]=s[e]);i?this.lastPlacementChangeTime=e:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=t?t.lastPlacementChangeTime:e);}updateLayerOpacities(e,t){const i=new Set;for(const o of t){const t=o.getBucket(e);t&&o.latestFeatureIndex&&e.id===t.layerIds[0]&&this.updateBucketOpacities(t,i,o.collisionBoxArray);}}updateBucketOpacities(t,i,o){t.hasTextData()&&t.text.opacityVertexArray.clear(),t.hasIconData()&&t.icon.opacityVertexArray.clear(),t.hasIconCollisionBoxData()&&t.iconCollisionBox.collisionVertexArray.clear(),t.hasTextCollisionBoxData()&&t.textCollisionBox.collisionVertexArray.clear();const r=t.layers[0].layout,n=!!t.layers[0].dynamicFilter(),s=new bt(null,0,!1,!1,!0),a=r.get("text-allow-overlap"),l=r.get("icon-allow-overlap"),c=r.get("text-variable-anchor"),h="map"===r.get("text-rotation-alignment"),u="map"===r.get("text-pitch-alignment"),_="none"!==r.get("icon-text-fit"),d=new bt(null,0,a&&(l||!t.hasIconData()||r.get("icon-optional")),l&&(a||!t.hasTextData()||r.get("text-optional")),!0);!t.collisionArrays&&o&&(t.hasIconCollisionBoxData()||t.hasTextCollisionBoxData())&&t.deserializeCollisionBoxes(o);const p=(e,t,i)=>{for(let o=0;o<t/4;o++)e.opacityVertexArray.emplaceBack(i);};let m=0;for(let o=0;o<t.symbolInstances.length;o++){const r=t.symbolInstances.get(o),{numHorizontalGlyphVertices:a,numVerticalGlyphVertices:l,crossTileID:f,numIconVertices:g}=r,v=i.has(f);let x=this.opacities[f];v?x=s:x||(x=d,this.opacities[f]=x),i.add(f);const y=a>0||l>0,b=g>0,w=this.placedOrientations[f],T=w===e.WritingMode.vertical,E=w===e.WritingMode.horizontal||w===e.WritingMode.horizontalOnly;if(!y&&!b||x.isHidden()||m++,y){const e=kt(x.text);p(t.text,a,T?Ft:e),p(t.text,l,E?Ft:e);const i=x.text.isHidden(),{leftJustifiedTextSymbolIndex:o,centerJustifiedTextSymbolIndex:n,rightJustifiedTextSymbolIndex:s,verticalPlacedTextSymbolIndex:c}=r,h=t.text.placedSymbolArray,u=i||T?1:0;o>=0&&(h.get(o).hidden=u),n>=0&&(h.get(n).hidden=u),s>=0&&(h.get(s).hidden=u),c>=0&&(h.get(c).hidden=i||E?1:0);const _=this.variableOffsets[f];_&&this.markUsedJustification(t,_.anchor,r,w);const d=this.placedOrientations[f];d&&(this.markUsedJustification(t,"left",r,d),this.markUsedOrientation(t,d,r));}if(b){const e=kt(x.icon),{placedIconSymbolIndex:i,verticalPlacedIconSymbolIndex:o}=r,n=t.icon.placedSymbolArray,s=x.icon.isHidden()?1:0;i>=0&&(p(t.icon,g,T?Ft:e),n.get(i).hidden=s),o>=0&&(p(t.icon,r.numVerticalIconVertices,E?Ft:e),n.get(o).hidden=s);}if(t.hasIconCollisionBoxData()||t.hasTextCollisionBoxData()){const i=t.collisionArrays[o];if(i){let o=new e.Point(0,0),r=!0;if(i.textBox||i.verticalTextBox){if(c){const e=this.variableOffsets[f];e?(o=Mt(e.anchor,e.width,e.height,e.textOffset,e.textScale),h&&o._rotate(u?this.transform.angle:-this.transform.angle)):r=!1;}n&&(r=!x.clipped),i.textBox&&St(t.textCollisionBox.collisionVertexArray,x.text.placed,!r||T,o.x,o.y),i.verticalTextBox&&St(t.textCollisionBox.collisionVertexArray,x.text.placed,!r||E,o.x,o.y);}const s=r&&Boolean(!E&&i.verticalIconBox);i.iconBox&&St(t.iconCollisionBox.collisionVertexArray,x.icon.placed,s,_?o.x:0,_?o.y:0),i.verticalIconBox&&St(t.iconCollisionBox.collisionVertexArray,x.icon.placed,!s,_?o.x:0,_?o.y:0);}}}if(t.fullyClipped=0===m,t.sortFeatures(this.transform.angle),this.retainedQueryData[t.bucketInstanceId]&&(this.retainedQueryData[t.bucketInstanceId].featureSortOrder=t.featureSortOrder),t.hasTextData()&&t.text.opacityVertexBuffer&&t.text.opacityVertexBuffer.updateData(t.text.opacityVertexArray),t.hasIconData()&&t.icon.opacityVertexBuffer&&t.icon.opacityVertexBuffer.updateData(t.icon.opacityVertexArray),t.hasIconCollisionBoxData()&&t.iconCollisionBox.collisionVertexBuffer&&t.iconCollisionBox.collisionVertexBuffer.updateData(t.iconCollisionBox.collisionVertexArray),t.hasTextCollisionBoxData()&&t.textCollisionBox.collisionVertexBuffer&&t.textCollisionBox.collisionVertexBuffer.updateData(t.textCollisionBox.collisionVertexArray),t.bucketInstanceId in this.collisionCircleArrays){const e=this.collisionCircleArrays[t.bucketInstanceId];t.placementInvProjMatrix=e.invProjMatrix,t.placementViewportMatrix=e.viewportMatrix,t.collisionCircleArray=e.circles,delete this.collisionCircleArrays[t.bucketInstanceId];}}symbolFadeChange(e){return 0===this.fadeDuration?1:(e-this.commitTime)/this.fadeDuration+this.prevZoomAdjustment}zoomAdjustment(e){return Math.max(0,(this.transform.zoom-e)/1.5)}hasTransitions(e){return this.stale||e-this.lastPlacementChangeTime<this.fadeDuration}stillRecent(e,t){const i=this.zoomAtLastRecencyCheck===t?1-this.zoomAdjustment(t):1;return this.zoomAtLastRecencyCheck=t,this.commitTime+this.fadeDuration*i>e}setStale(){this.stale=!0;}}function St(e,t,i,o,r){e.emplaceBack(t?1:0,i?1:0,o||0,r||0),e.emplaceBack(t?1:0,i?1:0,o||0,r||0),e.emplaceBack(t?1:0,i?1:0,o||0,r||0),e.emplaceBack(t?1:0,i?1:0,o||0,r||0);}const Dt=Math.pow(2,25),Lt=Math.pow(2,24),At=Math.pow(2,17),zt=Math.pow(2,16),Rt=Math.pow(2,9),Ot=Math.pow(2,8),Bt=Math.pow(2,1);function kt(e){if(0===e.opacity&&!e.placed)return 0;if(1===e.opacity&&e.placed)return 4294967295;const t=e.placed?1:0,i=Math.floor(127*e.opacity);return i*Dt+t*Lt+i*At+t*zt+i*Rt+t*Ot+i*Bt+t}const Ft=0;class Ut{constructor(e){this._sortAcrossTiles="viewport-y"!==e.layout.get("symbol-z-order")&&void 0!==e.layout.get("symbol-sort-key").constantOr(1),this._currentTileIndex=0,this._currentPartIndex=0,this._seenCrossTileIDs=new Set,this._bucketParts=[];}continuePlacement(e,t,i,o,r){const n=this._bucketParts;for(;this._currentTileIndex<e.length;)if(t.getBucketParts(n,o,e[this._currentTileIndex],this._sortAcrossTiles),this._currentTileIndex++,r())return !0;for(this._sortAcrossTiles&&(this._sortAcrossTiles=!1,n.sort(((e,t)=>e.sortKey-t.sortKey)));this._currentPartIndex<n.length;){const e=n[this._currentPartIndex];if(t.placeLayerBucketPart(e,this._seenCrossTileIDs,i,0===e.symbolInstanceStart),this._currentPartIndex++,r())return !0}return !1}}class Nt{constructor(e,t,i,o,r,n,s,a){this.placement=new Pt(e,r,n,s,a),this._currentPlacementIndex=t.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=o,this._done=!1;}isDone(){return this._done}continuePlacement(t,i,o){const r=e.exported.now(),n=()=>{const t=e.exported.now()-r;return !this._forceFullPlacement&&t>2};for(;this._currentPlacementIndex>=0;){const e=i[t[this._currentPlacementIndex]],r=this.placement.collisionIndex.transform.zoom;if("symbol"===e.type&&(!e.minzoom||e.minzoom<=r)&&(!e.maxzoom||e.maxzoom>r)){if(this._inProgressLayer||(this._inProgressLayer=new Ut(e)),this._inProgressLayer.continuePlacement(o[e.source],this.placement,this._showCollisionBoxes,e,n))return;delete this._inProgressLayer;}this._currentPlacementIndex--;}this._done=!0;}commit(e){return this.placement.commit(e),this.placement}}const jt=512/e.EXTENT/2;class Gt{constructor(t,i,o){this.tileID=t,this.bucketInstanceId=o,this.index=new e.KDBush(i.length,16,Int32Array),this.keys=[],this.crossTileIDs=[];const r=t.canonical.x*e.EXTENT,n=t.canonical.y*e.EXTENT;for(let e=0;e<i.length;e++){const{key:t,crossTileID:o,tileAnchorX:s,tileAnchorY:a}=i.get(e),l=Math.floor((r+s)*jt),c=Math.floor((n+a)*jt);this.index.add(l,c),this.keys.push(t),this.crossTileIDs.push(o);}this.index.finish();}findMatches(t,i,o){const r=this.tileID.canonical.z<i.canonical.z?1:Math.pow(2,this.tileID.canonical.z-i.canonical.z),n=jt/Math.pow(2,i.canonical.z-this.tileID.canonical.z),s=i.canonical.x*e.EXTENT,a=i.canonical.y*e.EXTENT;for(let e=0;e<t.length;e++){const i=t.get(e);if(i.crossTileID)continue;const{key:l,tileAnchorX:c,tileAnchorY:h}=i,u=Math.floor((s+c)*n),_=Math.floor((a+h)*n),d=this.index.range(u-r,_-r,u+r,_+r);for(const e of d){const t=this.crossTileIDs[e];if(this.keys[e]===l&&!o.has(t)){o.add(t),i.crossTileID=t;break}}}}}class Zt{constructor(){this.maxCrossTileID=0;}generate(){return ++this.maxCrossTileID}}class Vt{constructor(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;}handleWrapJump(e){const t=Math.round((e-this.lng)/360);if(0!==t)for(const e in this.indexes){const i=this.indexes[e],o={};for(const e in i){const r=i[e];r.tileID=r.tileID.unwrapTo(r.tileID.wrap+t),o[r.tileID.key]=r;}this.indexes[e]=o;}this.lng=e;}addBucket(e,t,i){if(this.indexes[e.overscaledZ]&&this.indexes[e.overscaledZ][e.key]){if(this.indexes[e.overscaledZ][e.key].bucketInstanceId===t.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(e.overscaledZ,this.indexes[e.overscaledZ][e.key]);}for(let e=0;e<t.symbolInstances.length;e++)t.symbolInstances.get(e).crossTileID=0;this.usedCrossTileIDs[e.overscaledZ]||(this.usedCrossTileIDs[e.overscaledZ]=new Set);const o=this.usedCrossTileIDs[e.overscaledZ];for(const i in this.indexes){const r=this.indexes[i];if(Number(i)>e.overscaledZ)for(const i in r){const n=r[i];n.tileID.isChildOf(e)&&n.findMatches(t.symbolInstances,e,o);}else {const n=r[e.scaledTo(Number(i)).key];n&&n.findMatches(t.symbolInstances,e,o);}}for(let e=0;e<t.symbolInstances.length;e++){const r=t.symbolInstances.get(e);r.crossTileID||(r.crossTileID=i.generate(),o.add(r.crossTileID));}return void 0===this.indexes[e.overscaledZ]&&(this.indexes[e.overscaledZ]={}),this.indexes[e.overscaledZ][e.key]=new Gt(e,t.symbolInstances,t.bucketInstanceId),!0}removeBucketCrossTileIDs(e,t){for(const i of t.crossTileIDs)this.usedCrossTileIDs[e].delete(i);}removeStaleBuckets(e){let t=!1;for(const i in this.indexes){const o=this.indexes[i];for(const r in o)e[o[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,o[r]),delete o[r],t=!0);}return t}}class Wt{constructor(){this.layerIndexes={},this.crossTileIDs=new Zt,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};}addLayer(e,t,i,o){let r=this.layerIndexes[e.id];void 0===r&&(r=this.layerIndexes[e.id]=new Vt);let n=!1;const s={};"globe"!==o.name&&r.handleWrapJump(i);for(const i of t){const t=i.getBucket(e);t&&e.id===t.layerIds[0]&&(t.bucketInstanceId||(t.bucketInstanceId=++this.maxBucketInstanceId),r.addBucket(i.tileID,t,this.crossTileIDs)&&(n=!0),s[t.bucketInstanceId]=!0);}return r.removeStaleBuckets(s)&&(n=!0),n}pruneUnusedLayers(e){const t={};e.forEach((e=>{t[e]=!0;}));for(const e in this.layerIndexes)t[e]||delete this.layerIndexes[e];}}const Xt=(t,i)=>e.emitValidationErrors(t,i&&i.filter((e=>"source.canvas"!==e.identifier))),qt=e.pick(Ge,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData","setTerrain","setFog","setProjection"]),$t=e.pick(Ge,["setCenter","setZoom","setBearing","setPitch"]),Ht={version:8,layers:[],sources:{}},Yt={fill:!0,line:!0,background:!0,hillshade:!0,raster:!0};class Kt extends e.Evented{constructor(t,i={}){super(),this.map=t,this.dispatcher=new S(Ue(),this),this.imageManager=new y,this.imageManager.setEventedParent(this),this.glyphManager=new e.GlyphManager(t._requestManager,i.localFontFamily?e.LocalGlyphMode.all:i.localIdeographFontFamily?e.LocalGlyphMode.ideographs:e.LocalGlyphMode.none,i.localFontFamily||i.localIdeographFontFamily),this.crossTileSymbolIndex=new Wt,this._layers={},this._num3DLayers=0,this._numSymbolLayers=0,this._numCircleLayers=0,this._serializedLayers={},this._sourceCaches={},this._otherSourceCaches={},this._symbolSourceCaches={},this._loaded=!1,this._availableImages=[],this._order=[],this._drapedFirstOrder=[],this._markersNeedUpdate=!1,this._resetUpdates(),this.dispatcher.broadcast("setReferrer",e.getReferrer());const o=this;this._rtlTextPluginCallback=Kt.registerForPluginStateChange((t=>{o.dispatcher.broadcast("syncRTLPluginState",{pluginStatus:t.pluginStatus,pluginURL:t.pluginURL},((t,i)=>{if(e.triggerPluginCompletionEvent(t),i&&i.every((e=>e)))for(const e in o._sourceCaches){const t=o._sourceCaches[e],i=t.getSource().type;"vector"!==i&&"geojson"!==i||t.reload();}}));})),this.on("data",(e=>{if("source"!==e.dataType||"metadata"!==e.sourceDataType)return;const t=this.getSource(e.sourceId);if(t&&t.vectorLayerIds)for(const e in this._layers){const i=this._layers[e];i.source===t.id&&this._validateLayer(i);}}));}loadURL(t,i={}){this.fire(new e.Event("dataloading",{dataType:"style"}));const o="boolean"==typeof i.validate?i.validate:!e.isMapboxURL(t);t=this.map._requestManager.normalizeStyleURL(t,i.accessToken);const r=this.map._requestManager.transformRequest(t,e.ResourceType.Style);this._request=e.getJSON(r,((t,i)=>{this._request=null,t?this.fire(new e.ErrorEvent(t)):i&&this._load(i,o);}));}loadJSON(t,i={}){this.fire(new e.Event("dataloading",{dataType:"style"})),this._request=e.exported.frame((()=>{this._request=null,this._load(t,!1!==i.validate);}));}loadEmpty(){this.fire(new e.Event("dataloading",{dataType:"style"})),this._load(Ht,!1);}_updateLayerCount(e,t){const i=t?1:-1;e.is3D()&&(this._num3DLayers+=i),"circle"===e.type&&(this._numCircleLayers+=i),"symbol"===e.type&&(this._numSymbolLayers+=i);}_load(t,i){if(i&&Xt(this,e.validateStyle(t)))return;this._loaded=!0,this.stylesheet=e.clone$1(t),this._updateMapProjection();for(const e in t.sources)this.addSource(e,t.sources[e],{validate:!1});this._changed=!1,t.sprite?this._loadSprite(t.sprite):(this.imageManager.setLoaded(!0),this.dispatcher.broadcast("spriteLoaded",!0)),this.glyphManager.setURL(t.glyphs);const o=je(this.stylesheet.layers);this._order=o.map((e=>e.id)),this._layers={},this._serializedLayers={};for(const t of o){const i=e.createStyleLayer(t);i.setEventedParent(this,{layer:{id:i.id}}),this._layers[i.id]=i,this._serializedLayers[i.id]=i.serialize(),this._updateLayerCount(i,!0);}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new w(this.stylesheet.light),this.stylesheet.terrain&&!this.terrainSetForDrapingOnly()&&this._createTerrain(this.stylesheet.terrain,1),this.stylesheet.fog&&this._createFog(this.stylesheet.fog),this._updateDrapeFirstLayers(),this.fire(new e.Event("data",{dataType:"style"})),this.fire(new e.Event("style.load"));}terrainSetForDrapingOnly(){return !!this.terrain&&0===this.terrain.drapeRenderMode}setProjection(e){e?this.stylesheet.projection=e:delete this.stylesheet.projection,this._updateMapProjection();}applyProjectionUpdate(){this._loaded&&(this.dispatcher.broadcast("setProjection",this.map.transform.projectionOptions),this.map.transform.projection.requiresDraping?this.getTerrain()||this.stylesheet.terrain||this.setTerrainForDraping():this.terrainSetForDrapingOnly()&&this.setTerrain(null));}_updateMapProjection(){this.map._useExplicitProjection?this.applyProjectionUpdate():this.map._prioritizeAndUpdateProjection(null,this.stylesheet.projection);}_loadSprite(t){this._spriteRequest=function(t,i,o){let r,n,s;const a=e.exported.devicePixelRatio>1?"@2x":"";let l=e.getJSON(i.transformRequest(i.normalizeSpriteURL(t,a,".json"),e.ResourceType.SpriteJSON),((e,t)=>{l=null,s||(s=e,r=t,h());})),c=e.getImage(i.transformRequest(i.normalizeSpriteURL(t,a,".png"),e.ResourceType.SpriteImage),((e,t)=>{c=null,s||(s=e,n=t,h());}));function h(){if(s)o(s);else if(r&&n){const t=e.exported.getImageData(n),i={};for(const o in r){const{width:n,height:s,x:a,y:l,sdf:c,pixelRatio:h,stretchX:u,stretchY:_,content:d}=r[o],p=new e.RGBAImage({width:n,height:s});e.RGBAImage.copy(t,p,{x:a,y:l},{x:0,y:0},{width:n,height:s}),i[o]={data:p,pixelRatio:h,sdf:c,stretchX:u,stretchY:_,content:d};}o(null,i);}}return {cancel(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(t,this.map._requestManager,((t,i)=>{if(this._spriteRequest=null,t)this.fire(new e.ErrorEvent(t));else if(i)for(const e in i)this.imageManager.addImage(e,i[e]);this.imageManager.setLoaded(!0),this._availableImages=this.imageManager.listImages(),this.dispatcher.broadcast("setImages",this._availableImages),this.dispatcher.broadcast("spriteLoaded",!0),this.fire(new e.Event("data",{dataType:"style"}));}));}_validateLayer(t){const i=this.getSource(t.source);if(!i)return;const o=t.sourceLayer;o&&("geojson"===i.type||i.vectorLayerIds&&-1===i.vectorLayerIds.indexOf(o))&&this.fire(new e.ErrorEvent(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t.id}"`)));}loaded(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(const e in this._sourceCaches)if(!this._sourceCaches[e].loaded())return !1;return !!this.imageManager.isLoaded()}_serializeLayers(e){const t=[];for(const i of e){const e=this._layers[i];"custom"!==e.type&&t.push(e.serialize());}return t}hasTransitions(){if(this.light&&this.light.hasTransition())return !0;if(this.fog&&this.fog.hasTransition())return !0;for(const e in this._sourceCaches)if(this._sourceCaches[e].hasTransition())return !0;for(const e in this._layers)if(this._layers[e].hasTransition())return !0;return !1}get order(){return this.map._optimizeForTerrain&&this.terrain?this._drapedFirstOrder:this._order}isLayerDraped(e){return !!this.terrain&&("function"==typeof e.isLayerDraped?e.isLayerDraped():Yt[e.type])}_checkLoaded(){if(!this._loaded)throw new Error("Style is not done loading")}update(t){if(!this._loaded)return;const i=this._changed;if(this._changed){const e=Object.keys(this._updatedLayers),i=Object.keys(this._removedLayers);(e.length||i.length)&&this._updateWorkerLayers(e,i);for(const e in this._updatedSources){const t=this._updatedSources[e];"reload"===t?this._reloadSource(e):"clear"===t&&this._clearSource(e);}this._updateTilesForChangedImages();for(const e in this._updatedPaintProps)this._layers[e].updateTransitions(t);this.light.updateTransitions(t),this.fog&&this.fog.updateTransitions(t),this._resetUpdates();}const o={};for(const e in this._sourceCaches){const t=this._sourceCaches[e];o[e]=t.used,t.used=!1;}for(const e of this._order){const i=this._layers[e];if(i.recalculate(t,this._availableImages),!i.isHidden(t.zoom)){const e=this._getLayerSourceCache(i);e&&(e.used=!0);}const o=this.map.painter;if(o){const e=i.getProgramIds();if(!e)continue;const r=i.getProgramConfiguration(t.zoom);for(const t of e)o.useProgram(t,r);}}for(const t in o){const i=this._sourceCaches[t];o[t]!==i.used&&i.getSource().fire(new e.Event("data",{sourceDataType:"visibility",dataType:"source",sourceId:i.getSource().id}));}this.light.recalculate(t),this.terrain&&this.terrain.recalculate(t),this.fog&&this.fog.recalculate(t),this.z=t.zoom,this._markersNeedUpdate&&(this._updateMarkersOpacity(),this._markersNeedUpdate=!1),i&&this.fire(new e.Event("data",{dataType:"style"}));}_updateTilesForChangedImages(){const e=Object.keys(this._changedImages);if(e.length){for(const t in this._sourceCaches)this._sourceCaches[t].reloadTilesForDependencies(["icons","patterns"],e);this._changedImages={};}}_updateWorkerLayers(e,t){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(e),removedIds:t});}_resetUpdates(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={},this._changedImages={};}setState(i){if(this._checkLoaded(),Xt(this,e.validateStyle(i)))return !1;(i=e.clone$1(i)).layers=je(i.layers);const o=function(e,i){if(!e)return [{command:Ge.setStyle,args:[i]}];let o=[];try{if(!t(e.version,i.version))return [{command:Ge.setStyle,args:[i]}];t(e.center,i.center)||o.push({command:Ge.setCenter,args:[i.center]}),t(e.zoom,i.zoom)||o.push({command:Ge.setZoom,args:[i.zoom]}),t(e.bearing,i.bearing)||o.push({command:Ge.setBearing,args:[i.bearing]}),t(e.pitch,i.pitch)||o.push({command:Ge.setPitch,args:[i.pitch]}),t(e.sprite,i.sprite)||o.push({command:Ge.setSprite,args:[i.sprite]}),t(e.glyphs,i.glyphs)||o.push({command:Ge.setGlyphs,args:[i.glyphs]}),t(e.transition,i.transition)||o.push({command:Ge.setTransition,args:[i.transition]}),t(e.light,i.light)||o.push({command:Ge.setLight,args:[i.light]}),t(e.fog,i.fog)||o.push({command:Ge.setFog,args:[i.fog]}),t(e.projection,i.projection)||o.push({command:Ge.setProjection,args:[i.projection]});const r={},n=[];!function(e,i,o,r){let n;for(n in i=i||{},e=e||{})e.hasOwnProperty(n)&&(i.hasOwnProperty(n)||Ve(n,o,r));for(n in i){if(!i.hasOwnProperty(n))continue;const s=i[n];e.hasOwnProperty(n)?t(e[n],s)||("geojson"===e[n].type&&"geojson"===s.type&&Xe(e,i,n)?o.push({command:Ge.setGeoJSONSourceData,args:[n,s.data]}):We(n,i,o,r)):Ze(n,i,o);}}(e.sources,i.sources,n,r);const s=[];e.layers&&e.layers.forEach((e=>{e.source&&r[e.source]?o.push({command:Ge.removeLayer,args:[e.id]}):s.push(e);}));let a=e.terrain;a&&r[a.source]&&(o.push({command:Ge.setTerrain,args:[void 0]}),a=void 0),o=o.concat(n),t(a,i.terrain)||o.push({command:Ge.setTerrain,args:[i.terrain]}),function(e,i,o){i=i||[];const r=(e=e||[]).map($e),n=i.map($e),s=e.reduce(He,{}),a=i.reduce(He,{}),l=r.slice(),c=Object.create(null);let h,u,_,d,p,m,f;for(h=0,u=0;h<r.length;h++)_=r[h],a.hasOwnProperty(_)?u++:(o.push({command:Ge.removeLayer,args:[_]}),l.splice(l.indexOf(_,u),1));for(h=0,u=0;h<n.length;h++)_=n[n.length-1-h],l[l.length-1-h]!==_&&(s.hasOwnProperty(_)?(o.push({command:Ge.removeLayer,args:[_]}),l.splice(l.lastIndexOf(_,l.length-u),1)):u++,m=l[l.length-h],o.push({command:Ge.addLayer,args:[a[_],m]}),l.splice(l.length-h,0,_),c[_]=!0);for(h=0;h<n.length;h++)if(_=n[h],d=s[_],p=a[_],!c[_]&&!t(d,p))if(t(d.source,p.source)&&t(d["source-layer"],p["source-layer"])&&t(d.type,p.type)){for(f in qe(d.layout,p.layout,o,_,null,Ge.setLayoutProperty),qe(d.paint,p.paint,o,_,null,Ge.setPaintProperty),t(d.filter,p.filter)||o.push({command:Ge.setFilter,args:[_,p.filter]}),t(d.minzoom,p.minzoom)&&t(d.maxzoom,p.maxzoom)||o.push({command:Ge.setLayerZoomRange,args:[_,p.minzoom,p.maxzoom]}),d)d.hasOwnProperty(f)&&"layout"!==f&&"paint"!==f&&"filter"!==f&&"metadata"!==f&&"minzoom"!==f&&"maxzoom"!==f&&(0===f.indexOf("paint.")?qe(d[f],p[f],o,_,f.slice(6),Ge.setPaintProperty):t(d[f],p[f])||o.push({command:Ge.setLayerProperty,args:[_,f,p[f]]}));for(f in p)p.hasOwnProperty(f)&&!d.hasOwnProperty(f)&&"layout"!==f&&"paint"!==f&&"filter"!==f&&"metadata"!==f&&"minzoom"!==f&&"maxzoom"!==f&&(0===f.indexOf("paint.")?qe(d[f],p[f],o,_,f.slice(6),Ge.setPaintProperty):t(d[f],p[f])||o.push({command:Ge.setLayerProperty,args:[_,f,p[f]]}));}else o.push({command:Ge.removeLayer,args:[_]}),m=l[l.lastIndexOf(_)+1],o.push({command:Ge.addLayer,args:[p,m]});}(s,i.layers,o);}catch(e){console.warn("Unable to compute style diff:",e),o=[{command:Ge.setStyle,args:[i]}];}return o}(this.serialize(),i).filter((e=>!(e.command in $t)));if(0===o.length)return !1;const r=o.filter((e=>!(e.command in qt)));if(r.length>0)throw new Error(`Unimplemented: ${r.map((e=>e.command)).join(", ")}.`);return o.forEach((e=>{"setTransition"!==e.command&&"setProjection"!==e.command&&this[e.command].apply(this,e.args);})),this.stylesheet=i,this._updateMapProjection(),!0}addImage(t,i){return this.getImage(t)?this.fire(new e.ErrorEvent(new Error("An image with this name already exists."))):(this.imageManager.addImage(t,i),this._afterImageUpdated(t),this)}updateImage(e,t){this.imageManager.updateImage(e,t);}getImage(e){return this.imageManager.getImage(e)}removeImage(t){return this.getImage(t)?(this.imageManager.removeImage(t),this._afterImageUpdated(t),this):this.fire(new e.ErrorEvent(new Error("No image with this name exists.")))}_afterImageUpdated(t){this._availableImages=this.imageManager.listImages(),this._changedImages[t]=!0,this._changed=!0,this.dispatcher.broadcast("setImages",this._availableImages),this.fire(new e.Event("data",{dataType:"style"}));}listImages(){return this._checkLoaded(),this._availableImages.slice()}addSource(t,i,o={}){if(this._checkLoaded(),void 0!==this.getSource(t))throw new Error("There is already a source with this ID");if(!i.type)throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);if(["vector","raster","geojson","video","image"].indexOf(i.type)>=0&&this._validate(e.validateSource,`sources.${t}`,i,null,o))return;this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);const r=De(t,i,this.dispatcher,this);r.setEventedParent(this,(()=>({isSourceLoaded:this._isSourceCacheLoaded(t),source:r.serialize(),sourceId:t})));const n=i=>{const o=(i?"symbol:":"other:")+t,n=this._sourceCaches[o]=new e.SourceCache(o,r,i);(i?this._symbolSourceCaches:this._otherSourceCaches)[t]=n,n.style=this,n.onAdd(this.map);};n(!1),"vector"!==i.type&&"geojson"!==i.type||n(!0),r.onAdd&&r.onAdd(this.map),this._changed=!0;}removeSource(t){this._checkLoaded();const i=this.getSource(t);if(!i)throw new Error("There is no source with this ID");for(const i in this._layers)if(this._layers[i].source===t)return this.fire(new e.ErrorEvent(new Error(`Source "${t}" cannot be removed while layer "${i}" is using it.`)));if(this.terrain&&this.terrain.get().source===t)return this.fire(new e.ErrorEvent(new Error(`Source "${t}" cannot be removed while terrain is using it.`)));const o=this._getSourceCaches(t);for(const t of o)delete this._sourceCaches[t.id],delete this._updatedSources[t.id],t.fire(new e.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:t.getSource().id})),t.setEventedParent(null),t.clearTiles();return delete this._otherSourceCaches[t],delete this._symbolSourceCaches[t],i.setEventedParent(null),i.onRemove&&i.onRemove(this.map),this._changed=!0,this}setGeoJSONSourceData(e,t){this._checkLoaded(),this.getSource(e).setData(t),this._changed=!0;}getSource(e){const t=this._getSourceCache(e);return t&&t.getSource()}_getSources(){const e=[];for(const t in this._otherSourceCaches){const i=this._getSourceCache(t);i&&e.push(i.getSource());}return e}addLayer(t,i,o={}){this._checkLoaded();const r=t.id;if(this.getLayer(r))return void this.fire(new e.ErrorEvent(new Error(`Layer with id "${r}" already exists on this map`)));let n;if("custom"===t.type){if(Xt(this,e.validateCustomStyleLayer(t)))return;n=e.createStyleLayer(t);}else {if("object"==typeof t.source&&(this.addSource(r,t.source),t=e.clone$1(t),t=e.extend(t,{source:r})),this._validate(e.validateLayer,`layers.${r}`,t,{arrayIndex:-1},o))return;n=e.createStyleLayer(t),this._validateLayer(n),n.setEventedParent(this,{layer:{id:r}}),this._serializedLayers[n.id]=n.serialize(),this._updateLayerCount(n,!0);}const s=i?this._order.indexOf(i):this._order.length;if(i&&-1===s)return void this.fire(new e.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`)));this._order.splice(s,0,r),this._layerOrderChanged=!0,this._layers[r]=n;const a=this._getLayerSourceCache(n);if(this._removedLayers[r]&&n.source&&a&&"custom"!==n.type){const e=this._removedLayers[r];delete this._removedLayers[r],e.type!==n.type?this._updatedSources[n.source]="clear":(this._updatedSources[n.source]="reload",a.pause());}this._updateLayer(n),n.onAdd&&n.onAdd(this.map),this._updateDrapeFirstLayers();}moveLayer(t,i){if(this._checkLoaded(),this._changed=!0,!this._layers[t])return void this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot be moved.`)));if(t===i)return;const o=this._order.indexOf(t);this._order.splice(o,1);const r=i?this._order.indexOf(i):this._order.length;i&&-1===r?this.fire(new e.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`))):(this._order.splice(r,0,t),this._layerOrderChanged=!0,this._updateDrapeFirstLayers());}removeLayer(t){this._checkLoaded();const i=this._layers[t];if(!i)return void this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot be removed.`)));i.setEventedParent(null),this._updateLayerCount(i,!1);const o=this._order.indexOf(t);this._order.splice(o,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[t]=i,delete this._layers[t],delete this._serializedLayers[t],delete this._updatedLayers[t],delete this._updatedPaintProps[t],i.onRemove&&i.onRemove(this.map),this._updateDrapeFirstLayers();}getLayer(e){return this._layers[e]}hasLayer(e){return e in this._layers}hasLayerType(e){for(const t in this._layers)if(this._layers[t].type===e)return !0;return !1}setLayerZoomRange(t,i,o){this._checkLoaded();const r=this.getLayer(t);r?r.minzoom===i&&r.maxzoom===o||(null!=i&&(r.minzoom=i),null!=o&&(r.maxzoom=o),this._updateLayer(r)):this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot have zoom extent.`)));}setFilter(i,o,r={}){this._checkLoaded();const n=this.getLayer(i);if(n){if(!t(n.filter,o))return null==o?(n.filter=void 0,void this._updateLayer(n)):void(this._validate(e.validateFilter,`layers.${n.id}.filter`,o,{layerType:n.type},r)||(n.filter=e.clone$1(o),this._updateLayer(n)))}else this.fire(new e.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be filtered.`)));}getFilter(t){const i=this.getLayer(t);return i&&e.clone$1(i.filter)}setLayoutProperty(i,o,r,n={}){this._checkLoaded();const s=this.getLayer(i);s?t(s.getLayoutProperty(o),r)||(s.setLayoutProperty(o,r,n),this._updateLayer(s)):this.fire(new e.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));}getLayoutProperty(t,i){const o=this.getLayer(t);if(o)return o.getLayoutProperty(i);this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style.`)));}setPaintProperty(i,o,r,n={}){this._checkLoaded();const s=this.getLayer(i);s?t(s.getPaintProperty(o),r)||(s.setPaintProperty(o,r,n)&&this._updateLayer(s),this._changed=!0,this._updatedPaintProps[i]=!0):this.fire(new e.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));}getPaintProperty(e,t){const i=this.getLayer(e);return i&&i.getPaintProperty(t)}setFeatureState(t,i){this._checkLoaded();const o=t.source,r=t.sourceLayer,n=this.getSource(o);if(!n)return void this.fire(new e.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));const s=n.type;if("geojson"===s&&r)return void this.fire(new e.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));if("vector"===s&&!r)return void this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));void 0===t.id&&this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided.")));const a=this._getSourceCaches(o);for(const e of a)e.setFeatureState(r,t.id,i);}removeFeatureState(t,i){this._checkLoaded();const o=t.source,r=this.getSource(o);if(!r)return void this.fire(new e.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));const n=r.type,s="vector"===n?t.sourceLayer:void 0;if("vector"===n&&!s)return void this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));if(i&&"string"!=typeof t.id&&"number"!=typeof t.id)return void this.fire(new e.ErrorEvent(new Error("A feature id is required to remove its specific state property.")));const a=this._getSourceCaches(o);for(const e of a)e.removeFeatureState(s,t.id,i);}getFeatureState(t){this._checkLoaded();const i=t.source,o=t.sourceLayer,r=this.getSource(i);if(r){if("vector"!==r.type||o)return void 0===t.id&&this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided."))),this._getSourceCaches(i)[0].getFeatureState(o,t.id);this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new e.ErrorEvent(new Error(`The source '${i}' does not exist in the map's style.`)));}getTransition(){return e.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)}serialize(){const t={};for(const e in this._sourceCaches){const i=this._sourceCaches[e].getSource();t[i.id]||(t[i.id]=i.serialize());}return e.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,terrain:this.getTerrain()||void 0,fog:this.stylesheet.fog,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,projection:this.stylesheet.projection,sources:t,layers:this._serializeLayers(this._order)},(e=>void 0!==e))}_updateLayer(e){this._updatedLayers[e.id]=!0;const t=this._getLayerSourceCache(e);e.source&&!this._updatedSources[e.source]&&t&&"raster"!==t.getSource().type&&(this._updatedSources[e.source]="reload",t.pause()),this._changed=!0,e.invalidateCompiledFilter();}_flattenAndSortRenderedFeatures(e){const t=e=>"fill-extrusion"===this._layers[e].type,i={},o=[];for(let r=this._order.length-1;r>=0;r--){const n=this._order[r];if(t(n)){i[n]=r;for(const t of e){const e=t[n];if(e)for(const t of e)o.push(t);}}}o.sort(((e,t)=>t.intersectionZ-e.intersectionZ));const r=[];for(let n=this._order.length-1;n>=0;n--){const s=this._order[n];if(t(s))for(let e=o.length-1;e>=0;e--){const t=o[e].feature;if(i[t.layer.id]<n)break;r.push(t),o.pop();}else for(const t of e){const e=t[s];if(e)for(const t of e)r.push(t.feature);}}return r}queryRenderedFeatures(t,i,o){i&&i.filter&&this._validate(e.validateFilter,"queryRenderedFeatures.filter",i.filter,null,i);const r={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new e.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(const t of i.layers){const i=this._layers[t];if(!i)return this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot be queried for features.`))),[];r[i.source]=!0;}}const n=[];i.availableImages=this._availableImages;const s=i&&i.layers?i.layers.some((e=>{const t=this.getLayer(e);return t&&t.is3D()})):this.has3DLayers(),a=L.createFromScreenPoints(t,o);for(const e in this._sourceCaches){const t=this._sourceCaches[e].getSource().id;i.layers&&!r[t]||n.push(Ae(this._sourceCaches[e],this._layers,this._serializedLayers,a,i,o,s,!!this.map._showQueryGeometry));}return this.placement&&n.push(function(e,t,i,o,r,n,s){const a={},l=n.queryRenderedSymbols(o),c=[];for(const e of Object.keys(l).map(Number))c.push(s[e]);c.sort(Re);for(const i of c){const o=i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId],t,i.bucketIndex,i.sourceLayerIndex,r.filter,r.layers,r.availableImages,e);for(const e in o){const t=a[e]=a[e]||[],r=o[e];r.sort(((e,t)=>{const o=i.featureSortOrder;if(o){const i=o.indexOf(e.featureIndex);return o.indexOf(t.featureIndex)-i}return t.featureIndex-e.featureIndex}));for(const e of r)t.push(e);}}for(const t in a)a[t].forEach((o=>{const r=o.feature,n=i(e[t]);if(!n)return;const s=n.getFeatureState(r.layer["source-layer"],r.id);r.source=r.layer.source,r.layer["source-layer"]&&(r.sourceLayer=r.layer["source-layer"]),r.state=s;}));return a}(this._layers,this._serializedLayers,this._getLayerSourceCache.bind(this),a.screenGeometry,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(n)}querySourceFeatures(t,i){i&&i.filter&&this._validate(e.validateFilter,"querySourceFeatures.filter",i.filter,null,i);const o=this._getSourceCaches(t);let r=[];for(const e of o)r=r.concat(ze(e,i));return r}addSourceType(e,t,i){return Kt.getSourceType(e)?i(new Error(`A source type called "${e}" already exists.`)):(Kt.setSourceType(e,t),t.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:e,url:t.workerSourceURL},i):i(null,null))}getLight(){return this.light.getLight()}setLight(e,i={}){this._checkLoaded();const o=this.light.getLight();let r=!1;for(const i in e)if(!t(e[i],o[i])){r=!0;break}if(!r)return;const n=this._setTransitionParameters({duration:300,delay:0});this.light.setLight(e,i),this.light.updateTransitions(n);}getTerrain(){return this.terrain&&1===this.terrain.drapeRenderMode?this.terrain.get():null}setTerrainForDraping(){this.setTerrain({source:"",exaggeration:0},0);}setTerrain(i,o=1){if(this._checkLoaded(),!i)return delete this.terrain,delete this.stylesheet.terrain,this.dispatcher.broadcast("enableTerrain",!1),this._force3DLayerUpdate(),void(this._markersNeedUpdate=!0);let r=i;if(1===o){if("object"==typeof r.source){const t="terrain-dem-src";this.addSource(t,r.source),r=e.clone$1(r),r=e.extend(r,{source:t});}if(this._validate(e.validateTerrain,"terrain",r))return}if(!this.terrain||this.terrain&&o!==this.terrain.drapeRenderMode){if(!r)return;this._createTerrain(r,o);}else {const i=this.terrain,o=i.get();for(const t of Object.keys(e.spec.terrain))!r.hasOwnProperty(t)&&e.spec.terrain[t].default&&(r[t]=e.spec.terrain[t].default);for(const e in r)if(!t(r[e],o[e])){i.set(r),this.stylesheet.terrain=r;const e=this._setTransitionParameters({duration:0});i.updateTransitions(e);break}}this._updateDrapeFirstLayers(),this._markersNeedUpdate=!0;}_createFog(e){const t=this.fog=new P(e,this.map.transform);this.stylesheet.fog=e;const i=this._setTransitionParameters({duration:0});t.updateTransitions(i);}_updateMarkersOpacity(){0!==this.map._markers.length&&this.map._requestDomTask((()=>{for(const e of this.map._markers)e._evaluateOpacity();}));}getFog(){return this.fog?this.fog.get():null}setFog(e){if(this._checkLoaded(),!e)return delete this.fog,delete this.stylesheet.fog,void(this._markersNeedUpdate=!0);if(this.fog){const i=this.fog,o=i.get();0===Object.keys(e).length&&i.set(e);for(const r in e)if(!t(e[r],o[r])){i.set(e),this.stylesheet.fog=e;const t=this._setTransitionParameters({duration:0});i.updateTransitions(t);break}}else this._createFog(e);this._markersNeedUpdate=!0;}_setTransitionParameters(t){return {now:e.exported.now(),transition:e.extend(t,this.stylesheet.transition)}}_updateDrapeFirstLayers(){if(!this.map._optimizeForTerrain||!this.terrain)return;const e=this._order.filter((e=>this.isLayerDraped(this._layers[e]))),t=this._order.filter((e=>!this.isLayerDraped(this._layers[e])));this._drapedFirstOrder=[],this._drapedFirstOrder.push(...e),this._drapedFirstOrder.push(...t);}_createTerrain(e,t){const i=this.terrain=new E(e,t);this.stylesheet.terrain=e,this.dispatcher.broadcast("enableTerrain",!this.terrainSetForDrapingOnly()),this._force3DLayerUpdate();const o=this._setTransitionParameters({duration:0});i.updateTransitions(o);}_force3DLayerUpdate(){for(const e in this._layers){const t=this._layers[e];"fill-extrusion"===t.type&&this._updateLayer(t);}}_forceSymbolLayerUpdate(){for(const e in this._layers){const t=this._layers[e];"symbol"===t.type&&this._updateLayer(t);}}_validate(t,i,o,r,n={}){return (!n||!1!==n.validate)&&Xt(this,t.call(e.validateStyle,e.extend({key:i,style:this.serialize(),value:o,styleSpec:e.spec},r)))}_remove(){this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),e.evented.off("pluginStateChange",this._rtlTextPluginCallback);for(const e in this._layers)this._layers[e].setEventedParent(null);for(const e in this._sourceCaches)this._sourceCaches[e].clearTiles(),this._sourceCaches[e].setEventedParent(null);this.imageManager.setEventedParent(null),this.setEventedParent(null),this.dispatcher.remove();}_clearSource(e){const t=this._getSourceCaches(e);for(const e of t)e.clearTiles();}_reloadSource(e){const t=this._getSourceCaches(e);for(const e of t)e.resume(),e.reload();}_reloadSources(){for(const e of this._getSources())e.reload&&e.reload();}_updateSources(e){for(const t in this._sourceCaches)this._sourceCaches[t].update(e);}_generateCollisionBoxes(){for(const e in this._sourceCaches){const t=this._sourceCaches[e];t.resume(),t.reload();}}_updatePlacement(t,i,o,r,n=!1){let s=!1,a=!1;const l={};for(const e of this._order){const i=this._layers[e];if("symbol"!==i.type)continue;if(!l[i.source]){const e=this._getLayerSourceCache(i);if(!e)continue;l[i.source]=e.getRenderableIds(!0).map((t=>e.getTileByID(t))).sort(((e,t)=>t.tileID.overscaledZ-e.tileID.overscaledZ||(e.tileID.isLessThan(t.tileID)?-1:1)));}const o=this.crossTileSymbolIndex.addLayer(i,l[i.source],t.center.lng,t.projection);s=s||o;}if(this.crossTileSymbolIndex.pruneUnusedLayers(this._order),n=n||this._layerOrderChanged||0===o,this._layerOrderChanged&&this.fire(new e.Event("neworder")),(n||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(e.exported.now(),t.zoom))&&(this.pauseablePlacement=new Nt(t,this._order,n,i,o,r,this.placement,this.fog&&t.projection.supportsFog?this.fog.state:null),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,l),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(e.exported.now()),a=!0),s&&this.pauseablePlacement.placement.setStale()),a||s)for(const e of this._order){const t=this._layers[e];"symbol"===t.type&&this.placement.updateLayerOpacities(t,l[t.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(e.exported.now())}_releaseSymbolFadeTiles(){for(const e in this._sourceCaches)this._sourceCaches[e].releaseSymbolFadeTiles();}getImages(e,t,i){this.imageManager.getImages(t.icons,i),this._updateTilesForChangedImages();const o=e=>{e&&e.setDependencies(t.tileID.key,t.type,t.icons);};o(this._otherSourceCaches[t.source]),o(this._symbolSourceCaches[t.source]);}getGlyphs(e,t,i){this.glyphManager.getGlyphs(t.stacks,i);}getResource(t,i,o){return e.makeRequest(i,o)}_getSourceCache(e){return this._otherSourceCaches[e]}_getLayerSourceCache(e){return "symbol"===e.type?this._symbolSourceCaches[e.source]:this._otherSourceCaches[e.source]}_getSourceCaches(e){const t=[];return this._otherSourceCaches[e]&&t.push(this._otherSourceCaches[e]),this._symbolSourceCaches[e]&&t.push(this._symbolSourceCaches[e]),t}_isSourceCacheLoaded(t){const i=this._getSourceCaches(t);return 0===i.length?(this.fire(new e.ErrorEvent(new Error(`There is no source with ID '${t}'`))),!1):i.every((e=>e.loaded()))}has3DLayers(){return this._num3DLayers>0}hasSymbolLayers(){return this._numSymbolLayers>0}hasCircleLayers(){return this._numCircleLayers>0}_clearWorkerCaches(){this.dispatcher.broadcast("clearCaches");}destroy(){this._clearWorkerCaches(),this.terrainSetForDrapingOnly()&&(delete this.terrain,delete this.stylesheet.terrain);}}Kt.getSourceType=function(e){return Se[e]},Kt.setSourceType=function(e,t){Se[e]=t;},Kt.registerForPluginStateChange=e.registerForPluginStateChange;var Jt="\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#define EXTENT 8192.0\n#define HALF_PI PI/2.0\n#define QUARTER_PI PI/4.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0",Qt="attribute highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;varying highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}",ei="\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\nconst float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}\n#ifdef TERRAIN\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;\n#else\nuniform sampler2D u_dem;uniform sampler2D u_dem_prev;\n#endif\nuniform vec4 u_dem_unpack;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float decodeElevation(vec4 v) {return dot(vec4(v.xyz*255.0,-1.0),u_dem_unpack);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem,pos));\n#ifdef TERRAIN_DEM_NEAREST_FILTER\nreturn u_exaggeration*tl;\n#endif\nfloat tr=decodeElevation(texture2D(u_dem,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem_prev,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem_prev,pos));float tr=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem_prev,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture2D(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture2D(u_depth,uv-df.xz)),unpack_depth(texture2D(u_depth,uv+df.xz)),unpack_depth(texture2D(u_depth,uv-df.zy)),unpack_depth(texture2D(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nfloat tl=texture2D(u_dem,pos).a;float tr=texture2D(u_dem,pos+vec2(off.x,0.0)).a;float bl=texture2D(u_dem,pos+vec2(0.0,off.y)).a;float br=texture2D(u_dem,pos+off).a;\n#else\nvec4 demtl=vec4(texture2D(u_dem,pos).xyz*255.0,-1.0);float tl=dot(demtl,u_dem_unpack);vec4 demtr=vec4(texture2D(u_dem,pos+vec2(off.x,0.0)).xyz*255.0,-1.0);float tr=dot(demtr,u_dem_unpack);vec4 dembl=vec4(texture2D(u_dem,pos+vec2(0.0,off.y)).xyz*255.0,-1.0);float bl=dot(dembl,u_dem_unpack);vec4 dembr=vec4(texture2D(u_dem,pos+off).xyz*255.0,-1.0);float br=dot(dembr,u_dem_unpack);\n#endif\nreturn vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif",ti="#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;varying vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif",ii="#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump float u_fog_temporal_offset;varying vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,opacity);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec3 fog_dither(vec3 color) {vec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif";let oi={},ri={};const ni=[];hi(Jt,ni),hi(ei,ni),hi(ti,ni),hi(ii,ni),oi=ui("",ei),ri=ui(ii,ti);const si=ui("\n#if __VERSION__ >=300\n#define varying in\n#define gl_FragColor glFragColor\n#define texture2D texture\n#define textureCube texture\nout vec4 glFragColor;\n#endif\nhighp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}","\n#if __VERSION__ >=300\n#define attribute in\n#define varying out\n#define texture2D texture\n#endif\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}const vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);//Normalized device coordinate that is not rendered."),ai=Jt,li="\n#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif";var ci={background:ui("uniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nvarying vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform vec4 u_color;varying vec4 v_color;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting(u_color);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),backgroundPattern:ui("uniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos;void main() {vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),circle:ui("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\ngl_FragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}"),clippingMask:ui("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),heatmap:ui("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {gl_FragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),heatmapTexture:ui("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),collisionBox:ui("varying float v_placed;varying float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);gl_FragColor =mix(red,blue,step(0.5,v_placed))*0.5;gl_FragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}","attribute vec3 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;attribute float a_size_scale;attribute vec2 a_padding;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*elevation(a_anchor_pos),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),collisionCircle:ui("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}","attribute vec2 a_pos_2f;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),debug:ui("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}","attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;\n#endif\nvarying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}"),fill:ui("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillOutline:ui("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillOutlinePattern:ui("uniform vec2 u_texsize;uniform sampler2D u_image;varying vec2 v_pos;varying vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos;varying vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillPattern:ui("uniform vec2 u_texsize;uniform sampler2D u_image;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillExtrusion:ui("varying vec4 v_color;\n#ifdef RENDER_SHADOWS\nvarying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying float v_depth;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#ifdef ZERO_ROOF_RADIUS\nvarying vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nvarying highp vec3 v_normal;\n#endif\nvoid main() {\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nvec3 normal=v_normal;\n#endif\nfloat z;vec4 color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);color=mix(v_color,v_roof_color,z);\n#else\ncolor=v_color;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);color.rgb=color.rgb*shade;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef ZERO_ROOF_RADIUS\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#endif\ncolor.xyz=shadowed_color_normal(color.xyz,normalize(normal),v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec4 v_color;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying float v_depth;\n#endif\n#ifdef ZERO_ROOF_RADIUS\nvarying vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nvarying highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nv_normal=normal;\n#endif\nbase=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nv_pos_light_view_0=u_light_matrix_0*vec4(pos,1);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1);v_depth=gl_Position.w;\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}v_color=vec4(0.0,0.0,0.0,1.0);\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting(color,NdotL);\n#else\nv_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));\n#endif\nv_color*=u_opacity;\n#ifdef ZERO_ROOF_RADIUS\nv_roof_color=vec4(0.0,0.0,0.0,1.0);\n#ifdef LIGHTING_3D_MODE\nv_roof_color=apply_lighting(color,calculate_NdotL(vec3(0.0,0.0,1.0)));\n#else\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));\n#endif\nv_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),fillExtrusionPattern:ui("uniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nvarying float v_NdotL;\n#endif\nvarying vec2 v_pos;varying vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,v_NdotL)*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec2 v_pos;varying vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nvarying float v_NdotL;\n#endif\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_NdotL=NdotL;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}"),hillshadePrepare:ui("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nreturn texture2D(u_image,coord).a/4.0;\n#else\nvec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;\n#endif\n}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),hillshade:ui("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\ngl_FragColor=apply_lighting(gl_FragColor);\n#endif\n#ifdef FOG\ngl_FragColor=fog_dither(fog_apply_premultiplied(gl_FragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),line:ui("uniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;varying vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nuniform float u_border_width;uniform vec4 u_border_color;float luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture2D(u_dash_image,v_tex).a;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture2D(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trimmed=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {out_color=vec4(0,0,0,0);trimmed=0.0;}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef RENDER_LINE_ALPHA_DISCARD\nif (alpha < u_alpha_discard_threshold) {discard;}\n#endif\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(u_border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);\n#ifdef RENDER_LINE_BORDER_AUTO\nfloat Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}\n#else\nout_color.rgb=mix(u_border_color.rgb*u_border_color.a*trimmed,out_color.rgb,smoothAlpha);\n#endif\n}\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define EXTRUDE_SCALE 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nattribute highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nattribute float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;varying vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),linePattern:ui("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;vec2 pattern_size=vec2(display_size.x/u_tile_units_to_pixels,display_size.y);float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x=mod(v_linesofar/pattern_size.x*aspect,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));vec4 color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),raster:ui("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply(out_color,v_fog_pos));\n#endif\ngl_FragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {float w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,0,w);v_pos0=a_texture_pos/8192.0;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),symbolIcon:ui("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;}"),symbolSDF:ui("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade);}"),symbolTextAndIcon:ui("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade,is_sdf);}"),terrainRaster:ui("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvarying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nvoid main() {vec4 color=texture2D(u_image0,v_pos0);\n#ifdef RENDER_SHADOWS\ncolor.xyz=shadowed_color(color.xyz,v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_skirt_height;attribute vec2 a_pos;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nconst float wireframeOffset=0.00015;void main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;\n#ifdef TERRAIN_WIREFRAME\nelevation+=wireframeOffset;\n#endif\nv_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);v_depth=gl_Position.w;\n#endif\n}"),terrainDepth:ui("#ifdef GL_ES\nprecision highp float;\n#endif\nvarying float v_depth;void main() {gl_FragColor=pack_depth(v_depth);}","uniform mat4 u_matrix;attribute vec2 a_pos;varying float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}"),skybox:ui("\nvarying lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=textureCube(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);gl_FragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}",Qt),skyboxGradient:ui("varying highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture2D(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}",Qt),skyboxCapture:ui("\nvarying highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;\n#ifdef GL_ES\nprecision highp float;\n#endif\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;gl_FragColor=vec4(color,1.0);}","attribute highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;varying highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),globeRaster:ui("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture2D(u_image0,v_pos0);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#else\ncolor=texture2D(u_image0,v_pos0);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nattribute vec3 a_globe_pos;attribute vec2 a_uv;\n#else\nattribute vec2 a_pos;\n#endif\nvarying vec2 v_pos0;const float wireframeOffset=1e3;float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(QUARTER_PI+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);\n#ifdef TERRAIN_WIREFRAME\nheight+=wireframeOffset;\n#endif\nglobe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}"),globeAtmosphere:ui("uniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec3 u_start_color;uniform vec4 u_color;uniform vec4 u_space_color;uniform vec4 u_high_color;uniform float u_star_intensity;uniform float u_star_size;uniform float u_star_density;uniform float u_horizon_angle;uniform mat4 u_rotation_matrix;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;highp float random(highp vec3 p) {p=fract(p*vec3(23.2342,97.1231,91.2342));p+=dot(p.zxy,p.yxz+123.1234);return fract(p.x*p.y);}float stars(vec3 p,float scale,vec2 offset) {vec2 uv_scale=(u_viewport/u_star_size)*scale;vec3 position=vec3(p.xy*uv_scale+offset*u_viewport,p.z);vec3 q=fract(position)-0.5;vec3 id=floor(position);float random_visibility=step(random(id),u_star_density);float circle=smoothstep(0.5+u_star_intensity,0.5,length(q));return circle*random_visibility;}void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {discard;return;}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(dot(dir,horizon_dir)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;float closest_point_to_center=length(closest_point-u_globe_pos);float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;vec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c =mix(color_stop_2,c2,t);float a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);vec2 uv=gl_FragCoord.xy/u_viewport-0.5;float aspect_ratio=u_viewport.x/u_viewport.y;vec4 uv_dir=vec4(normalize(vec3(uv.x*aspect_ratio,uv.y,1.0)),1.0);uv_dir=u_rotation_matrix*uv_dir;vec3 n=abs(uv_dir.xyz);vec2 uv_remap=(n.x > n.y && n.x > n.z) ? uv_dir.yz/uv_dir.x:\n(n.y > n.x && n.y > n.z) ? uv_dir.zx/uv_dir.y:\nuv_dir.xy/uv_dir.z;uv_remap.x/=aspect_ratio;vec3 D=vec3(uv_remap,1.0);highp float star_field=0.0;if (u_star_intensity > 0.0) {star_field+=stars(D,1.2,vec2(0.0,0.0));star_field+=stars(D,1.0,vec2(1.0,0.0));star_field+=stars(D,0.8,vec2(0.0,1.0));star_field+=stars(D,0.6,vec2(1.0,1.0));star_field*=(1.0-pow(t,0.25+(1.0-u_high_color.a)*0.75));c+=star_field*alpha_2;}c=dither(c,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=vec4(c,a);}","attribute vec3 a_pos;attribute vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}")};function hi(e,t){const i=e.replace(/\s*\/\/[^\n]*\n/g,"\n").split("\n");for(let e of i)if(e=e.trim(),"#"===e[0]&&e.includes("if")&&!e.includes("endif")){e=e.replace("#","").replace(/ifdef|ifndef|elif|if/g,"").replace(/!|defined|\(|\)|\|\||&&/g,"").replace(/\s+/g," ").trim();const i=e.split(" ");for(const e of i)t.includes(e)||t.push(e);}}function ui(e,t){const i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,o=t.match(/attribute (highp |mediump |lowp )?([\w]+) ([\w]+)/g),r={},n=[...ni];return hi(e,n),hi(t,n),{fragmentSource:e=e.replace(i,((e,t,i,o,n)=>(r[n]=!0,"define"===t?`\n#ifndef HAS_UNIFORM_u_${n}\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n`:`\n#ifdef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = u_${n};\n#endif\n`))),vertexSource:t=t.replace(i,((e,t,i,o,n)=>{const s="float"===o?"vec2":"vec4",a=n.match(/color/)?"color":s;return r[n]?"define"===t?`\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${s} a_${n};\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n`:"vec4"===a?`\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`:`\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`:"define"===t?`\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${s} a_${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n`:"vec4"===a?`\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`:`\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`})),staticAttributes:o,usedDefines:n}}class _i{constructor(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffers=[],this.vao=null;}bind(e,t,i,o,r,n,s){this.context=e;let a=this.boundPaintVertexBuffers.length!==o.length;for(let e=0;!a&&e<o.length;e++)this.boundPaintVertexBuffers[e]!==o[e]&&(a=!0);let l=this.boundDynamicVertexBuffers.length!==s.length;for(let e=0;!l&&e<s.length;e++)this.boundDynamicVertexBuffers[e]!==s[e]&&(l=!0);if(!e.extVertexArrayObject||!this.vao||this.boundProgram!==t||this.boundLayoutVertexBuffer!==i||a||l||this.boundIndexBuffer!==r||this.boundVertexOffset!==n)this.freshBind(t,i,o,r,n,s);else {e.bindVertexArrayOES.set(this.vao);for(const e of s)e&&e.bind();r&&r.dynamicDraw&&r.bind();}}freshBind(e,t,i,o,r,n){let s;const a=e.numAttributes,l=this.context,c=l.gl;if(l.extVertexArrayObject)this.vao&&this.destroy(),this.vao=l.extVertexArrayObject.createVertexArrayOES(),l.bindVertexArrayOES.set(this.vao),s=0,this.boundProgram=e,this.boundLayoutVertexBuffer=t,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=o,this.boundVertexOffset=r,this.boundDynamicVertexBuffers=n;else {s=l.currentNumAttributes||0;for(let e=a;e<s;e++)c.disableVertexAttribArray(e);}t.enableAttributes(c,e),t.bind(),t.setVertexAttribPointers(c,e,r);for(const t of i)t.enableAttributes(c,e),t.bind(),t.setVertexAttribPointers(c,e,r);for(const t of n)t&&(t.enableAttributes(c,e),t.bind(),t.setVertexAttribPointers(c,e,r));o&&o.bind(),l.currentNumAttributes=a;}destroy(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);}}function di(t,i){const o=Math.pow(2,i.canonical.z),r=i.canonical.y;return [new e.MercatorCoordinate(0,r/o).toLngLat().lat,new e.MercatorCoordinate(0,(r+1)/o).toLngLat().lat]}function pi(t,i,o,r,n,s,a){const l=t.context,c=l.gl,h=o.fbo;if(!h)return;t.prepareDrawTile();const u=t.useProgram("hillshade");l.activeTexture.set(c.TEXTURE0),c.bindTexture(c.TEXTURE_2D,h.colorAttachment.get());const _=((e,t,i,o)=>{const r=i.paint.get("hillshade-shadow-color"),n=i.paint.get("hillshade-highlight-color"),s=i.paint.get("hillshade-accent-color");let a=i.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===i.paint.get("hillshade-illumination-anchor")&&(a-=e.transform.angle);const l=!e.options.moving;return {u_matrix:o||e.transform.calculateProjMatrix(t.tileID.toUnwrapped(),l),u_image:0,u_latrange:di(0,t.tileID),u_light:[i.paint.get("hillshade-exaggeration"),a],u_shadow:r,u_highlight:n,u_accent:s}})(t,o,r,t.terrain?i.projMatrix:null);t.prepareDrawProgram(l,u,i.toUnwrapped());const{tileBoundsBuffer:d,tileBoundsIndexBuffer:p,tileBoundsSegments:m}=t.getTileBoundsBuffers(o);u.draw(l,c.TRIANGLES,n,s,a,e.CullFaceMode.disabled,_,r.id,d,p,m);}function mi(t,i,o){if(!i.needsDEMTextureUpload)return;const r=t.context,n=r.gl;r.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||t.getTileTexture(o.stride);const s=o.getPixels();i.demTexture?i.demTexture.update(s,{premultiply:!1}):i.demTexture=new e.Texture(r,s,n.RGBA,{premultiply:!1}),i.needsDEMTextureUpload=!1;}function fi(t,i,o,r,n,s){const a=t.context,l=a.gl;if(!i.dem)return;const c=i.dem;if(a.activeTexture.set(l.TEXTURE1),mi(t,i,c),!i.demTexture)return;i.demTexture.bind(l.NEAREST,l.CLAMP_TO_EDGE);const h=c.dim;a.activeTexture.set(l.TEXTURE0);let u=i.fbo;if(!u){const t=new e.Texture(a,{width:h,height:h,data:null},l.RGBA);t.bind(l.LINEAR,l.CLAMP_TO_EDGE),u=i.fbo=a.createFramebuffer(h,h,!0),u.colorAttachment.set(t.texture);}a.bindFramebuffer.set(u.framebuffer),a.viewport.set([0,0,h,h]);const{tileBoundsBuffer:_,tileBoundsIndexBuffer:d,tileBoundsSegments:p}=t.getMercatorTileBoundsBuffers();t.useProgram("hillshadePrepare").draw(a,l.TRIANGLES,r,n,s,e.CullFaceMode.disabled,((t,i)=>{const o=i.stride,r=e.create();return e.ortho(r,0,e.EXTENT,-e.EXTENT,0,0,1),e.translate(r,r,[0,-e.EXTENT,0]),{u_matrix:r,u_image:1,u_dimension:[o,o],u_zoom:t.overscaledZ,u_unpack:i.unpackVector}})(i.tileID,c),o.id,_,d,p),i.needsHillshadePrepare=!1;}const gi=t=>({u_matrix:new e.UniformMatrix4f(t),u_image0:new e.Uniform1i(t),u_skirt_height:new e.Uniform1f(t)}),vi=(e,t)=>({u_matrix:e,u_image0:0,u_skirt_height:t}),xi=(e,t,i,o,r,n,s,a,l,c,h,u,_,d,p)=>({u_proj_matrix:Float32Array.from(e),u_globe_matrix:t,u_normalize_matrix:Float32Array.from(o),u_merc_matrix:i,u_zoom_transition:r,u_merc_center:n,u_image0:0,u_frustum_tl:s,u_frustum_tr:a,u_frustum_br:l,u_frustum_bl:c,u_globe_pos:h,u_globe_radius:u,u_viewport:_,u_grid_matrix:p?Float32Array.from(p):new Float32Array(9),u_skirt_height:d});function yi(e,t){return null!=e&&null!=t&&!(!e.hasData()||!t.hasData())&&null!=e.demTexture&&null!=t.demTexture&&e.tileID.key!==t.tileID.key}const bi=new class{constructor(){this.operations={};}newMorphing(e,t,i,o,r){if(e in this.operations){const t=this.operations[e];t.to.tileID.key!==i.tileID.key&&(t.queued=i);}else this.operations[e]={startTime:o,phase:0,duration:r,from:t,to:i,queued:null};}getMorphValuesForProxy(e){if(!(e in this.operations))return null;const t=this.operations[e];return {from:t.from,to:t.to,phase:t.phase}}update(e){for(const t in this.operations){const i=this.operations[t];for(i.phase=(e-i.startTime)/i.duration;i.phase>=1||!this._validOp(i);)if(!this._nextOp(i,e)){delete this.operations[t];break}}}_nextOp(e,t){return !!e.queued&&(e.from=e.to,e.to=e.queued,e.queued=null,e.phase=0,e.startTime=t,!0)}_validOp(e){return e.from.hasData()&&e.to.hasData()}},wi={0:null,1:"TERRAIN_VERTEX_MORPHING",2:"TERRAIN_WIREFRAME"};function Ti(e){return 6*Math.pow(1.5,22-e)}function Ei(e,t){const i=1<<e.z;return !t&&(0===e.x||e.x===i-1)||0===e.y||e.y===i-1}const Ci=e=>({u_matrix:e});function Mi(t,i,o,r,n){if(n>0){const s=e.exported.now(),a=(s-t.timeAdded)/n,l=i?(s-i.timeAdded)/n:-1,c=o.getSource(),h=r.coveringZoomLevel({tileSize:c.tileSize,roundZoom:c.roundZoom}),u=!i||Math.abs(i.tileID.overscaledZ-h)>Math.abs(t.tileID.overscaledZ-h),_=u&&t.refreshedUponExpiration?1:e.clamp(u?a:1-l,0,1);return t.refreshedUponExpiration&&a>=1&&(t.refreshedUponExpiration=!1),i?{opacity:1,mix:1-_}:{opacity:_,mix:0}}return {opacity:1,mix:0}}class Ii extends e.SourceCache{constructor(e){const t={type:"raster-dem",maxzoom:e.transform.maxZoom},i=new S(Ue(),null),o=De("mock-dem",t,i,e.style);super("mock-dem",o,!1),o.setEventedParent(this),this._sourceLoaded=!0;}_loadTile(e,t){e.state="loaded",t(null);}}class Pi extends e.SourceCache{constructor(e){const t=De("proxy",{type:"geojson",maxzoom:e.transform.maxZoom},new S(Ue(),null),e.style);super("proxy",t,!1),t.setEventedParent(this),this.map=this.getSource().map=e,this.used=this._sourceLoaded=!0,this.renderCache=[],this.renderCachePool=[],this.proxyCachedFBO={};}update(t,i,o){if(t.freezeTileCoverage)return;this.transform=t;const r=t.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}).reduce(((i,o)=>{if(i[o.key]="",!this._tiles[o.key]){const i=new e.Tile(o,this._source.tileSize*o.overscaleFactor(),t.tileZoom);i.state="loaded",this._tiles[o.key]=i;}return i}),{});for(const e in this._tiles)e in r||(this.freeFBO(e),this._tiles[e].unloadVectorData(),delete this._tiles[e]);}freeFBO(e){const t=this.proxyCachedFBO[e];if(void 0!==t){const i=Object.values(t);this.renderCachePool.push(...i),delete this.proxyCachedFBO[e];}}deallocRenderCache(){this.renderCache.forEach((e=>e.fb.destroy())),this.renderCache=[],this.renderCachePool=[],this.proxyCachedFBO={};}}class Si extends e.OverscaledTileID{constructor(e,t,i){super(e.overscaledZ,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y),this.proxyTileKey=t,this.projMatrix=i;}}class Di extends e.Elevation{constructor(t,i){super(),this.painter=t,this.terrainTileForTile={},this.prevTerrainTileForTile={};const[o,r,n]=function(t){const i=new e.StructArrayLayout2i4,o=new e.StructArrayLayout3ui6,r=131;i.reserve(17161),o.reserve(33800);const n=e.EXTENT/128,s=e.EXTENT+n/2,a=s+n;for(let t=-n;t<a;t+=n)for(let o=-n;o<a;o+=n){const r=o<0||o>s||t<0||t>s?24575:0,n=e.clamp(Math.round(o),0,e.EXTENT),a=e.clamp(Math.round(t),0,e.EXTENT);i.emplaceBack(n+r,a);}const l=(e,t)=>{const i=t*r+e;o.emplaceBack(i+1,i,i+r),o.emplaceBack(i+r,i+r+1,i+1);};for(let e=1;e<129;e++)for(let t=1;t<129;t++)l(t,e);return [0,129].forEach((e=>{for(let t=0;t<130;t++)l(t,e),l(e,t);})),[i,o,32768]}(),s=t.context;this.gridBuffer=s.createVertexBuffer(o,e.posAttributes.members),this.gridIndexBuffer=s.createIndexBuffer(r),this.gridSegments=e.SegmentVector.simpleSegment(0,0,o.length,r.length),this.gridNoSkirtSegments=e.SegmentVector.simpleSegment(0,0,o.length,n),this.proxyCoords=[],this.proxiedCoords={},this._visibleDemTiles=[],this._drapedRenderBatches=[],this._sourceTilesOverlap={},this.proxySourceCache=new Pi(i.map),this.orthoMatrix=e.create(),e.ortho(this.orthoMatrix,"globe"===this.painter.transform.projection.name?.015:0,e.EXTENT,0,e.EXTENT,0,1);const a=s.gl;this._overlapStencilMode=new e.StencilMode({func:a.GEQUAL,mask:255},0,255,a.KEEP,a.KEEP,a.REPLACE),this._previousZoom=t.transform.zoom,this.pool=[],this._findCoveringTileCache={},this._tilesDirty={},this.style=i,this._useVertexMorphing=!0,this._exaggeration=1,this._mockSourceCache=new Ii(i.map);}set style(e){e.on("data",this._onStyleDataEvent.bind(this)),e.on("neworder",this._checkRenderCacheEfficiency.bind(this)),this._style=e,this._checkRenderCacheEfficiency(),this._style.map.on("moveend",(()=>{this._clearLineLayersFromRenderCache();}));}update(t,i,o){if(t&&t.terrain){this._style!==t&&(this.style=t),this.enabled=!0;const r=t.terrain.properties;this.sourceCache=0===t.terrain.drapeRenderMode?this._mockSourceCache:t._getSourceCache(r.get("source")),this._exaggeration=r.get("exaggeration");const n=()=>{this.sourceCache.used&&e.warnOnce(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);const t=this.getScaledDemTileSize();this.sourceCache.update(i,t,!0),this.resetTileLookupCache(this.sourceCache.id);};this.sourceCache.usedForTerrain||(this.resetTileLookupCache(this.sourceCache.id),this.sourceCache.usedForTerrain=!0,n(),this._initializing=!0),n(),i.updateElevation(!0,o),this.resetTileLookupCache(this.proxySourceCache.id),this.proxySourceCache.update(i),this._emptyDEMTextureDirty=!0;}else this._disable();}resetTileLookupCache(e){this._findCoveringTileCache[e]={};}getScaledDemTileSize(){return this.sourceCache.getSource().tileSize/128*this.proxySourceCache.getSource().tileSize}_checkRenderCacheEfficiency(){const t=this.renderCacheEfficiency(this._style);this._style.map._optimizeForTerrain||100!==t.efficiency&&e.warnOnce(`Terrain render cache efficiency is not optimal (${t.efficiency}%) and performance\n                may be affected negatively, consider placing all background, fill and line layers before layer\n                with id '${t.firstUndrapedLayer}' or create a map using optimizeForTerrain: true option.`);}_onStyleDataEvent(e){e.coord&&"source"===e.dataType?this._clearRenderCacheForTile(e.sourceCacheId,e.coord):"style"===e.dataType&&(this._invalidateRenderCache=!0);}_disable(){if(this.enabled&&(this.enabled=!1,this._sharedDepthStencil=void 0,this.proxySourceCache.deallocRenderCache(),this._style))for(const e in this._style._sourceCaches)this._style._sourceCaches[e].usedForTerrain=!1;}destroy(){this._disable(),this._emptyDEMTexture&&this._emptyDEMTexture.destroy(),this._emptyDepthBufferTexture&&this._emptyDepthBufferTexture.destroy(),this.pool.forEach((e=>e.fb.destroy())),this.pool=[],this._depthFBO&&(this._depthFBO.destroy(),this._depthFBO=void 0,this._depthTexture=void 0);}_source(){return this.enabled?this.sourceCache:null}isUsingMockSource(){return this.sourceCache===this._mockSourceCache}exaggeration(){return this._exaggeration}get visibleDemTiles(){return this._visibleDemTiles}get drapeBufferSize(){const e=2*this.proxySourceCache.getSource().tileSize;return [e,e]}set useVertexMorphing(e){this._useVertexMorphing=e;}updateTileBinding(t){if(!this.enabled)return;this.prevTerrainTileForTile=this.terrainTileForTile;const i=this.proxySourceCache,o=this.painter.transform;this._initializing&&(this._initializing=0===o._centerAltitude&&-1===this.getAtPointOrZero(e.MercatorCoordinate.fromLngLat(o.center),-1),this._emptyDEMTextureDirty=!this._initializing);const r=this.proxyCoords=i.getIds().map((e=>{const t=i.getTileByID(e).tileID;return t.projMatrix=o.calculateProjMatrix(t.toUnwrapped()),t}));!function(t,i){const o=i.transform.pointCoordinate(i.transform.getCameraPoint()),r=new e.Point(o.x,o.y);t.sort(((t,i)=>{if(i.overscaledZ-t.overscaledZ)return i.overscaledZ-t.overscaledZ;const o=new e.Point(t.canonical.x+(1<<t.canonical.z)*t.wrap,t.canonical.y),n=new e.Point(i.canonical.x+(1<<i.canonical.z)*i.wrap,i.canonical.y),s=r.mult(1<<t.canonical.z);return s.x-=.5,s.y-=.5,s.distSqr(o)-s.distSqr(n)}));}(r,this.painter),this._previousZoom=o.zoom;const n=this.proxyToSource||{};this.proxyToSource={},r.forEach((e=>{this.proxyToSource[e.key]={};})),this.terrainTileForTile={};const s=this._style._sourceCaches;for(const e in s){const i=s[e];if(!i.used)continue;if(i!==this.sourceCache&&this.resetTileLookupCache(i.id),this._setupProxiedCoordsForOrtho(i,t[e],n),i.usedForTerrain)continue;const o=t[e];i.getSource().reparseOverscaled&&this._assignTerrainTiles(o);}this.proxiedCoords[i.id]=r.map((e=>new Si(e,e.key,this.orthoMatrix))),this._assignTerrainTiles(r),this._prepareDEMTextures(),this._setupDrapedRenderBatches(),this._initFBOPool(),this._setupRenderCache(n),this.renderingToTexture=!1,this._updateTimestamp=e.exported.now();const a={};this._visibleDemTiles=[];for(const e of this.proxyCoords){const t=this.terrainTileForTile[e.key];if(!t)continue;const i=t.tileID.key;i in a||(this._visibleDemTiles.push(t),a[i]=i);}}_assignTerrainTiles(e){this._initializing||e.forEach((e=>{if(this.terrainTileForTile[e.key])return;const t=this._findTileCoveringTileID(e,this.sourceCache);t&&(this.terrainTileForTile[e.key]=t);}));}_prepareDEMTextures(){const e=this.painter.context,t=e.gl;for(const i in this.terrainTileForTile){const o=this.terrainTileForTile[i],r=o.dem;!r||o.demTexture&&!o.needsDEMTextureUpload||(e.activeTexture.set(t.TEXTURE1),mi(this.painter,o,r));}}_prepareDemTileUniforms(e,t,i,o){if(!t||null==t.demTexture)return !1;const r=e.tileID.canonical,n=Math.pow(2,t.tileID.canonical.z-r.z),s=o||"";return i[`u_dem_tl${s}`]=[r.x*n%1,r.y*n%1],i[`u_dem_scale${s}`]=n,!0}get emptyDEMTexture(){return !this._emptyDEMTextureDirty&&this._emptyDEMTexture?this._emptyDEMTexture:this._updateEmptyDEMTexture()}get emptyDepthBufferTexture(){const t=this.painter.context,i=t.gl;if(!this._emptyDepthBufferTexture){const o=new e.RGBAImage({width:1,height:1},Uint8Array.of(255,255,255,255));this._emptyDepthBufferTexture=new e.Texture(t,o,i.RGBA,{premultiply:!1});}return this._emptyDepthBufferTexture}_getLoadedAreaMinimum(){let e=0;const t=this._visibleDemTiles.reduce(((t,i)=>{if(!i.dem)return t;const o=i.dem.tree.minimums[0];return o>0&&e++,t+o}),0);return e?t/e:0}_updateEmptyDEMTexture(){const t=this.painter.context,i=t.gl;t.activeTexture.set(i.TEXTURE2);const o=this._getLoadedAreaMinimum(),r=new e.RGBAImage({width:1,height:1},new Uint8Array(e.DEMData.pack(o,this.sourceCache.getSource().encoding)));this._emptyDEMTextureDirty=!1;let n=this._emptyDEMTexture;return n?n.update(r,{premultiply:!1}):n=this._emptyDEMTexture=new e.Texture(t,r,i.RGBA,{premultiply:!1}),n}setupElevationDraw(t,i,o){const r=this.painter.context,n=r.gl,s=(a=this.sourceCache.getSource().encoding,{u_dem:2,u_dem_prev:4,u_dem_unpack:e.DEMData.getUnpackVector(a),u_dem_tl:[0,0],u_dem_tl_prev:[0,0],u_dem_scale:0,u_dem_scale_prev:0,u_dem_size:0,u_dem_lerp:1,u_depth:3,u_depth_size_inv:[0,0],u_exaggeration:0});var a;s.u_dem_size=this.sourceCache.getSource().tileSize,s.u_exaggeration=this.exaggeration();let l=null,c=null,h=1;if(o&&o.morphing&&this._useVertexMorphing){const e=o.morphing.srcDemTile,i=o.morphing.dstDemTile;h=o.morphing.phase,e&&i&&(this._prepareDemTileUniforms(t,e,s,"_prev")&&(c=e),this._prepareDemTileUniforms(t,i,s)&&(l=i));}if(c&&l?(r.activeTexture.set(n.TEXTURE2),l.demTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE,n.NEAREST),r.activeTexture.set(n.TEXTURE4),c.demTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE,n.NEAREST),s.u_dem_lerp=h):(l=this.terrainTileForTile[t.tileID.key],r.activeTexture.set(n.TEXTURE2),(this._prepareDemTileUniforms(t,l,s)?l.demTexture:this.emptyDEMTexture).bind(n.NEAREST,n.CLAMP_TO_EDGE)),r.activeTexture.set(n.TEXTURE3),o&&o.useDepthForOcclusion?(this._depthTexture&&this._depthTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE),this._depthFBO&&(s.u_depth_size_inv=[1/this._depthFBO.width,1/this._depthFBO.height])):(this.emptyDepthBufferTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE),s.u_depth_size_inv=[1,1]),o&&o.useMeterToDem&&l){const t=(1<<l.tileID.canonical.z)*e.mercatorZfromAltitude(1,this.painter.transform.center.lat)*this.sourceCache.getSource().tileSize;s.u_meter_to_dem=t;}if(o&&o.labelPlaneMatrixInv&&(s.u_label_plane_matrix_inv=o.labelPlaneMatrixInv),i.setTerrainUniformValues(r,s),"globe"===this.painter.transform.projection.name){const e=this.globeUniformValues(this.painter.transform,t.tileID.canonical,o&&o.useDenormalizedUpVectorScale);i.setGlobeUniformValues(r,e);}}globeUniformValues(t,i,o){const r=t.projection;return {u_tile_tl_up:r.upVector(i,0,0),u_tile_tr_up:r.upVector(i,e.EXTENT,0),u_tile_br_up:r.upVector(i,e.EXTENT,e.EXTENT),u_tile_bl_up:r.upVector(i,0,e.EXTENT),u_tile_up_scale:o?e.globeMetersToEcef(1):r.upVectorScale(i,t.center.lat,t.worldSize).metersToTile}}renderToBackBuffer(t){const i=this.painter,o=this.painter.context;0!==t.length&&(o.bindFramebuffer.set(null),o.viewport.set([0,0,i.width,i.height]),i.gpuTimingDeferredRenderStart(),this.renderingToTexture=!1,function(t,i,o,r,n){if("globe"===t.transform.projection.name)!function(t,i,o,r,n){const s=t.context,a=s.gl;let l,c;const h=t.options.showTerrainWireframe?2:0,u=t.transform,_=e.globeUseCustomAntiAliasing(t,s,u),d=(e,i)=>{if(c===e)return;const o=[wi[e],"PROJECTION_GLOBE_VIEW"];_&&o.push("CUSTOM_ANTIALIASING"),i&&o.push(wi[h]),l=t.useProgram("globeRaster",null,o),c=e;},p=t.colorModeForRenderPass(),m=new e.DepthMode(a.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D);bi.update(n);const f=e.calculateGlobeMercatorMatrix(u),g=[e.mercatorXfromLng(u.center.lng),e.mercatorYfromLat(u.center.lat)],v=h?[!1,!0]:[!1],x=t.globeSharedBuffers,y=[u.width*e.exported.devicePixelRatio,u.height*e.exported.devicePixelRatio],b=Float32Array.from(u.globeMatrix),w={useDenormalizedUpVectorScale:!0};if(v.forEach((h=>{const u=t.transform,_=Ti(u.zoom)*i.exaggeration();c=-1;const v=h?a.LINES:a.TRIANGLES;for(const c of r){const r=o.getTile(c),T=e.StencilMode.disabled,E=i.prevTerrainTileForTile[c.key],C=i.terrainTileForTile[c.key];yi(E,C)&&bi.newMorphing(c.key,E,C,n,250),s.activeTexture.set(a.TEXTURE0),r.texture.bind(a.LINEAR,a.CLAMP_TO_EDGE);const M=bi.getMorphValuesForProxy(c.key),I=M?1:0;M&&e.extend$1(w,{morphing:{srcDemTile:M.from,dstDemTile:M.to,phase:e.easeCubicInOut(M.phase)}});const P=e.tileCornersToBounds(c.canonical),S=e.getLatitudinalLod(P.getCenter().lat),D=e.getGridMatrix(c.canonical,P,S,u.worldSize/u._pixelsPerMercatorPixel),L=e.globeNormalizeECEF(e.globeTileBounds(c.canonical)),A=xi(u.projMatrix,b,f,L,e.globeToMercatorTransition(u.zoom),g,u.frustumCorners.TL,u.frustumCorners.TR,u.frustumCorners.BR,u.frustumCorners.BL,u.globeCenterInViewSpace,u.globeRadius,y,_,D);if(d(I,h),i.setupElevationDraw(r,l,w),t.prepareDrawProgram(s,l,c.toUnwrapped()),x){const[i,o,r]=h?x.getWirefameBuffers(t.context,S):x.getGridBuffers(S,0!==_);l.draw(s,v,m,T,p,e.CullFaceMode.backCCW,A,"globe_raster",i,o,r);}}})),x){const n=["GLOBE_POLES","PROJECTION_GLOBE_VIEW"];_&&n.push("CUSTOM_ANTIALIASING"),l=t.useProgram("globeRaster",null,n);for(const n of r){const{x:r,y:c,z:h}=n.canonical,_=0===c,d=c===(1<<h)-1,[f,v,b,T]=x.getPoleBuffers(h);if(T&&(_||d)){const c=o.getTile(n);s.activeTexture.set(a.TEXTURE0),c.texture.bind(a.LINEAR,a.CLAMP_TO_EDGE);let x=e.globePoleMatrixForTile(h,r,u);const E=e.globeNormalizeECEF(e.globeTileBounds(n.canonical)),C=(t,i)=>t.draw(s,a.TRIANGLES,m,e.StencilMode.disabled,p,e.CullFaceMode.disabled,xi(u.projMatrix,x,x,E,0,g,u.frustumCorners.TL,u.frustumCorners.TR,u.frustumCorners.BR,u.frustumCorners.BL,u.globeCenterInViewSpace,u.globeRadius,y,0),"globe_pole_raster",i,b,T);i.setupElevationDraw(c,l,w),t.prepareDrawProgram(s,l,n.toUnwrapped()),_&&C(l,f),d&&(x=e.scale(e.create(),x,[1,-1,1]),C(l,v));}}}}(t,i,o,r,n);else {const s=t.context,a=s.gl;let l,c;const h=t.options.showTerrainWireframe?2:0,u=(e,i)=>{if(c===e)return;const o=[wi[e]];i&&o.push(wi[h]),l=t.useProgram("terrainRaster",null,o),c=e;},_=t.colorModeForRenderPass(),d=new e.DepthMode(a.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D);bi.update(n);const p=t.transform,m=Ti(p.zoom)*i.exaggeration();(h?[!1,!0]:[!1]).forEach((h=>{c=-1;const f=h?a.LINES:a.TRIANGLES,[g,v]=h?i.getWirefameBuffer():[i.gridIndexBuffer,i.gridSegments];for(const c of r){const r=o.getTile(c),x=e.StencilMode.disabled,y=i.prevTerrainTileForTile[c.key],b=i.terrainTileForTile[c.key];yi(y,b)&&bi.newMorphing(c.key,y,b,n,250),s.activeTexture.set(a.TEXTURE0),r.texture.bind(a.LINEAR,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST);const w=bi.getMorphValuesForProxy(c.key),T=w?1:0;let E;w&&(E={morphing:{srcDemTile:w.from,dstDemTile:w.to,phase:e.easeCubicInOut(w.phase)}});const C=vi(c.projMatrix,Ei(c.canonical,p.renderWorldCopies)?m/10:m);u(T,h),i.setupElevationDraw(r,l,E),t.prepareDrawProgram(s,l,c.toUnwrapped()),l.draw(s,f,d,x,_,e.CullFaceMode.backCCW,C,"terrain_raster",i.gridBuffer,g,v);}}));}}(i,this,this.proxySourceCache,t,this._updateTimestamp),this.renderingToTexture=!0,i.gpuTimingDeferredRenderEnd(),t.splice(0,t.length));}renderBatch(t){if(0===this._drapedRenderBatches.length)return t+1;this.renderingToTexture=!0;const i=this.painter,o=this.painter.context,r=this.proxySourceCache,n=this.proxiedCoords[r.id],s=this._drapedRenderBatches.shift(),a=[],l=i.style.order;let c=0;for(const h of n){const n=r.getTileByID(h.proxyTileKey),u=r.proxyCachedFBO[h.key]?r.proxyCachedFBO[h.key][t]:void 0,_=void 0!==u?r.renderCache[u]:this.pool[c++],d=void 0!==u;if(n.texture=_.tex,d&&!_.dirty){a.push(n.tileID);continue}let p;o.bindFramebuffer.set(_.fb.framebuffer),this.renderedToTile=!1,_.dirty&&(o.clear({color:e.Color.transparent,stencil:0}),_.dirty=!1);for(let e=s.start;e<=s.end;++e){const t=i.style._layers[l[e]];if(t.isHidden(i.transform.zoom))continue;const r=i.style._getLayerSourceCache(t),n=r?this.proxyToSource[h.key][r.id]:[h];if(!n)continue;const s=n;o.viewport.set([0,0,_.fb.width,_.fb.height]),p!==(r?r.id:null)&&(this._setupStencil(_,n,t,r),p=r?r.id:null),i.renderLayer(i,r,t,s);}this.renderedToTile?(_.dirty=!0,a.push(n.tileID)):d||--c,5===c&&(c=0,this.renderToBackBuffer(a));}return this.renderToBackBuffer(a),this.renderingToTexture=!1,o.bindFramebuffer.set(null),o.viewport.set([0,0,i.width,i.height]),s.end+1}postRender(){}renderCacheEfficiency(e){const t=e.order.length;if(0===t)return {efficiency:100};let i,o=0,r=0,n=!1;for(let s=0;s<t;++s){const t=e._layers[e.order[s]];this._style.isLayerDraped(t)?(n&&++o,++r):n||(n=!0,i=t.id);}return 0===r?{efficiency:100}:{efficiency:100*(1-o/r),firstUndrapedLayer:i}}getMinElevationBelowMSL(){let e=0;return this._visibleDemTiles.filter((e=>e.dem)).forEach((t=>{e=Math.min(e,t.dem.tree.minimums[0]);})),0===e?e:(e-30)*this._exaggeration}raycast(e,t,i){if(!this._visibleDemTiles)return null;const o=this._visibleDemTiles.filter((e=>e.dem)).map((o=>{const r=o.tileID,n=1<<r.overscaledZ,{x:s,y:a}=r.canonical,l=s/n,c=(s+1)/n,h=a/n,u=(a+1)/n;return {minx:l,miny:h,maxx:c,maxy:u,t:o.dem.tree.raycastRoot(l,h,c,u,e,t,i),tile:o}}));o.sort(((e,t)=>(null!==e.t?e.t:Number.MAX_VALUE)-(null!==t.t?t.t:Number.MAX_VALUE)));for(const r of o){if(null==r.t)return null;const o=r.tile.dem.tree.raycast(r.minx,r.miny,r.maxx,r.maxy,e,t,i);if(null!=o)return o}return null}_createFBO(){const t=this.painter.context,i=t.gl,o=this.drapeBufferSize;t.activeTexture.set(i.TEXTURE0);const r=new e.Texture(t,{width:o[0],height:o[1],data:null},i.RGBA);r.bind(i.LINEAR,i.CLAMP_TO_EDGE);const n=t.createFramebuffer(o[0],o[1],!1);return n.colorAttachment.set(r.texture),n.depthAttachment=new we(t,n.framebuffer),void 0===this._sharedDepthStencil?(this._sharedDepthStencil=t.createRenderbuffer(t.gl.DEPTH_STENCIL,o[0],o[1]),this._stencilRef=0,n.depthAttachment.set(this._sharedDepthStencil),t.clear({stencil:0})):n.depthAttachment.set(this._sharedDepthStencil),t.extTextureFilterAnisotropic&&!t.extTextureFilterAnisotropicForceOff&&i.texParameterf(i.TEXTURE_2D,t.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,t.extTextureFilterAnisotropicMax),{fb:n,tex:r,dirty:!1}}_initFBOPool(){for(;this.pool.length<Math.min(5,this.proxyCoords.length);)this.pool.push(this._createFBO());}_shouldDisableRenderCache(){if(this._style.light&&this._style.light.hasTransition())return !0;for(const e in this._style._sourceCaches)if(this._style._sourceCaches[e].hasTransition())return !0;return this._style.order.some((e=>{const t=this._style._layers[e],i=t.isHidden(this.painter.transform.zoom);return "custom"===t.type?!i&&t.shouldRedrape():!i&&t.hasTransition()}))}_clearLineLayersFromRenderCache(){let t=!1;for(const e of this._style._getSources())if(e instanceof Ce){t=!0;break}if(!t)return;const i={};for(let t=0;t<this._style.order.length;++t){const o=this._style._layers[this._style.order[t]],r=this._style._getLayerSourceCache(o);if(r&&!i[r.id]&&!o.isHidden(this.painter.transform.zoom)&&"line"===o.type&&o.widthExpression()instanceof e.ZoomDependentExpression){i[r.id]=!0;for(const e of this.proxyCoords){const t=this.proxyToSource[e.key][r.id];if(t)for(const e of t)this._clearRenderCacheForTile(r.id,e);}}}}_clearRasterLayersFromRenderCache(){let e=!1;for(const t in this._style._sourceCaches)if(this._style._sourceCaches[t]._source instanceof Me){e=!0;break}if(!e)return;const t={};for(let e=0;e<this._style.order.length;++e){const i=this._style._layers[this._style.order[e]],o=this._style._getLayerSourceCache(i);if(!o||t[o.id])continue;if(i.isHidden(this.painter.transform.zoom)||"raster"!==i.type)continue;const r=i.paint.get("raster-fade-duration");for(const e of this.proxyCoords){const t=this.proxyToSource[e.key][o.id];if(t)for(const e of t){const t=Mi(o.getTile(e),o.findLoadedParent(e,0),o,this.painter.transform,r);(1!==t.opacity||0!==t.mix)&&this._clearRenderCacheForTile(o.id,e);}}}}_setupDrapedRenderBatches(){const e=this._style.order,t=e.length;if(0===t)return;const i=[];let o,r=0,n=this._style._layers[e[r]];for(;!this._style.isLayerDraped(n)&&n.isHidden(this.painter.transform.zoom)&&++r<t;)n=this._style._layers[e[r]];for(;r<t;++r){const t=this._style._layers[e[r]];t.isHidden(this.painter.transform.zoom)||(this._style.isLayerDraped(t)?void 0===o&&(o=r):void 0!==o&&(i.push({start:o,end:r-1}),o=void 0));}void 0!==o&&i.push({start:o,end:r-1}),this._drapedRenderBatches=i;}_setupRenderCache(e){const t=this.proxySourceCache;if(this._shouldDisableRenderCache()||this._invalidateRenderCache){if(this._invalidateRenderCache=!1,t.renderCache.length>t.renderCachePool.length){const e=Object.values(t.proxyCachedFBO);t.proxyCachedFBO={};for(let i=0;i<e.length;++i){const o=Object.values(e[i]);t.renderCachePool.push(...o);}}return}this._clearRasterLayersFromRenderCache();const i=this.proxyCoords,o=this._tilesDirty;for(let r=i.length-1;r>=0;r--){const n=i[r];if(t.getTileByID(n.key),void 0!==t.proxyCachedFBO[n.key]){const i=e[n.key],r=this.proxyToSource[n.key];let s=0;for(const e in r){const t=r[e],n=i[e];if(!n||n.length!==t.length||t.some(((t,i)=>t!==n[i]||o[e]&&o[e].hasOwnProperty(t.key)))){s=-1;break}++s;}for(const e in t.proxyCachedFBO[n.key])t.renderCache[t.proxyCachedFBO[n.key][e]].dirty=s<0||s!==Object.values(i).length;}}const r=[...this._drapedRenderBatches];r.sort(((e,t)=>t.end-t.start-(e.end-e.start)));for(const e of r)for(const o of i){if(t.proxyCachedFBO[o.key])continue;let i=t.renderCachePool.pop();void 0===i&&t.renderCache.length<50&&(i=t.renderCache.length,t.renderCache.push(this._createFBO())),void 0!==i&&(t.proxyCachedFBO[o.key]={},t.proxyCachedFBO[o.key][e.start]=i,t.renderCache[i].dirty=!0);}this._tilesDirty={};}_setupStencil(e,t,i,o){if(!o||!this._sourceTilesOverlap[o.id])return void(this._overlapStencilType&&(this._overlapStencilType=!1));const r=this.painter.context,n=r.gl;if(t.length<=1)return void(this._overlapStencilType=!1);let s;if(i.isTileClipped())s=t.length,this._overlapStencilMode.test={func:n.EQUAL,mask:255},this._overlapStencilType="Clip";else {if(!(t[0].overscaledZ>t[t.length-1].overscaledZ))return void(this._overlapStencilType=!1);s=1,this._overlapStencilMode.test={func:n.GREATER,mask:255},this._overlapStencilType="Mask";}this._stencilRef+s>255&&(r.clear({stencil:0}),this._stencilRef=0),this._stencilRef+=s,this._overlapStencilMode.ref=this._stencilRef,i.isTileClipped()&&this._renderTileClippingMasks(t,this._overlapStencilMode.ref);}clipOrMaskOverlapStencilType(){return "Clip"===this._overlapStencilType||"Mask"===this._overlapStencilType}stencilModeForRTTOverlap(t){return this.renderingToTexture&&this._overlapStencilType?("Clip"===this._overlapStencilType&&(this._overlapStencilMode.ref=this.painter._tileClippingMaskIDs[t.key]),this._overlapStencilMode):e.StencilMode.disabled}_renderTileClippingMasks(t,i){const o=this.painter,r=this.painter.context,n=r.gl;o._tileClippingMaskIDs={},r.setColorMode(e.ColorMode.disabled),r.setDepthMode(e.DepthMode.disabled);const s=o.useProgram("clippingMask");for(const a of t){const t=o._tileClippingMaskIDs[a.key]=--i;s.draw(r,n.TRIANGLES,e.DepthMode.disabled,new e.StencilMode({func:n.ALWAYS,mask:0},t,255,n.KEEP,n.KEEP,n.REPLACE),e.ColorMode.disabled,e.CullFaceMode.disabled,Ci(a.projMatrix),"$clipping",o.tileExtentBuffer,o.quadTriangleIndexBuffer,o.tileExtentSegments);}}pointCoordinate(t){const i=this.painter.transform;if(t.x<0||t.x>i.width||t.y<0||t.y>i.height)return null;const o=[t.x,t.y,1,1];e.transformMat4$1(o,o,i.pixelMatrixInverse),e.scale$1(o,o,1/o[3]),o[0]/=i.worldSize,o[1]/=i.worldSize;const r=i._camera.position,n=e.mercatorZfromAltitude(1,i.center.lat),s=[r[0],r[1],r[2]/n,0],a=e.subtract([],o.slice(0,3),s);e.normalize(a,a);const l=this.raycast(s,a,this._exaggeration);return null!==l&&l?(e.scaleAndAdd(s,s,a,l),s[3]=s[2],s[2]*=n,s):null}drawDepth(){const t=this.painter,i=t.context,o=this.proxySourceCache,r=Math.ceil(t.width),n=Math.ceil(t.height);if(!this._depthFBO||this._depthFBO.width===r&&this._depthFBO.height===n||(this._depthFBO.destroy(),this._depthFBO=void 0,this._depthTexture=void 0),!this._depthFBO){const t=i.gl,o=i.createFramebuffer(r,n,!0);i.activeTexture.set(t.TEXTURE0);const s=new e.Texture(i,{width:r,height:n,data:null},t.RGBA);s.bind(t.NEAREST,t.CLAMP_TO_EDGE),o.colorAttachment.set(s.texture);const a=i.createRenderbuffer(i.gl.DEPTH_COMPONENT16,r,n);o.depthAttachment.set(a),this._depthFBO=o,this._depthTexture=s;}i.bindFramebuffer.set(this._depthFBO.framebuffer),i.viewport.set([0,0,r,n]),function(t,i,o,r){if("globe"===t.transform.projection.name)return;const n=t.context,s=n.gl;n.clear({depth:1});const a=t.useProgram("terrainDepth"),l=new e.DepthMode(s.LESS,e.DepthMode.ReadWrite,t.depthRangeFor3D);for(const t of r){const r=o.getTile(t),c=vi(t.projMatrix,0);i.setupElevationDraw(r,a),a.draw(n,s.TRIANGLES,l,e.StencilMode.disabled,e.ColorMode.unblended,e.CullFaceMode.backCCW,c,"terrain_depth",i.gridBuffer,i.gridIndexBuffer,i.gridNoSkirtSegments);}}(t,this,o,this.proxyCoords);}_setupProxiedCoordsForOrtho(e,t,i){if(e.getSource()instanceof Pe)return this._setupProxiedCoordsForImageSource(e,t,i);this._findCoveringTileCache[e.id]=this._findCoveringTileCache[e.id]||{};const o=this.proxiedCoords[e.id]=[],r=this.proxyCoords;for(let t=0;t<r.length;t++){const n=r[t],s=this._findTileCoveringTileID(n,e);if(s){const t=this._createProxiedId(n,s,i[n.key]&&i[n.key][e.id]);o.push(t),this.proxyToSource[n.key][e.id]=[t];}}let n=!1;for(let r=0;r<t.length;r++){const s=e.getTile(t[r]);if(!s||!s.hasData())continue;const a=this._findTileCoveringTileID(s.tileID,this.proxySourceCache);if(a&&a.tileID.canonical.z!==s.tileID.canonical.z){const t=this.proxyToSource[a.tileID.key][e.id],r=this._createProxiedId(a.tileID,s,i[a.tileID.key]&&i[a.tileID.key][e.id]);t?t.splice(t.length-1,0,r):this.proxyToSource[a.tileID.key][e.id]=[r],o.push(r),n=!0;}}this._sourceTilesOverlap[e.id]=n;}_setupProxiedCoordsForImageSource(t,i,o){if(!t.getSource().loaded())return;const r=this.proxiedCoords[t.id]=[],n=this.proxyCoords,s=t.getSource(),a=new e.Point(s.tileID.x,s.tileID.y)._div(1<<s.tileID.z),l=s.coordinates.map(e.MercatorCoordinate.fromLngLat).reduce(((e,t)=>(e.min.x=Math.min(e.min.x,t.x-a.x),e.min.y=Math.min(e.min.y,t.y-a.y),e.max.x=Math.max(e.max.x,t.x-a.x),e.max.y=Math.max(e.max.y,t.y-a.y),e)),{min:new e.Point(Number.MAX_VALUE,Number.MAX_VALUE),max:new e.Point(-Number.MAX_VALUE,-Number.MAX_VALUE)}),c=(t,i)=>{const o=t.wrap+t.canonical.x/(1<<t.canonical.z),r=t.canonical.y/(1<<t.canonical.z),n=e.EXTENT/(1<<t.canonical.z),s=i.wrap+i.canonical.x/(1<<i.canonical.z),a=i.canonical.y/(1<<i.canonical.z);return o+n<s+l.min.x||o>s+l.max.x||r+n<a+l.min.y||r>a+l.max.y};for(let e=0;e<n.length;e++){const s=n[e];for(let e=0;e<i.length;e++){const n=t.getTile(i[e]);if(!n||!n.hasData())continue;if(c(s,n.tileID))continue;const a=this._createProxiedId(s,n,o[s.key]&&o[s.key][t.id]),l=this.proxyToSource[s.key][t.id];l?l.push(a):this.proxyToSource[s.key][t.id]=[a],r.push(a);}}}_createProxiedId(t,i,o){let r=this.orthoMatrix;if(o){const e=o.find((e=>e.key===i.tileID.key));if(e)return e}if(i.tileID.key!==t.key){const o=t.canonical.z-i.tileID.canonical.z;let n,s,a;r=e.create();const l=i.tileID.wrap-t.wrap<<t.overscaledZ;o>0?(n=e.EXTENT>>o,s=n*((i.tileID.canonical.x<<o)-t.canonical.x+l),a=n*((i.tileID.canonical.y<<o)-t.canonical.y)):(n=e.EXTENT<<-o,s=e.EXTENT*(i.tileID.canonical.x-(t.canonical.x+l<<-o)),a=e.EXTENT*(i.tileID.canonical.y-(t.canonical.y<<-o))),e.ortho(r,0,n,0,n,0,1),e.translate(r,r,[s,a,0]);}return new Si(i.tileID,t.key,r)}_findTileCoveringTileID(t,i){let o=i.getTile(t);if(o&&o.hasData())return o;const r=this._findCoveringTileCache[i.id],n=r[t.key];if(o=n?i.getTileByID(n):null,o&&o.hasData()||null===n)return o;let s=o?o.tileID:t,a=s.overscaledZ;const l=i.getSource().minzoom,c=[];if(!n){const r=i.getSource().maxzoom;if(t.canonical.z>=r){const o=t.canonical.z-r;i.getSource().reparseOverscaled?(a=Math.max(t.canonical.z+2,i.transform.tileZoom),s=new e.OverscaledTileID(a,t.wrap,r,t.canonical.x>>o,t.canonical.y>>o)):0!==o&&(a=r,s=new e.OverscaledTileID(a,t.wrap,r,t.canonical.x>>o,t.canonical.y>>o));}s.key!==t.key&&(c.push(s.key),o=i.getTile(s));}const h=e=>{c.forEach((t=>{r[t]=e;})),c.length=0;};for(a-=1;a>=l&&(!o||!o.hasData());a--){o&&h(o.tileID.key);const e=s.calculateScaledKey(a);if(o=i.getTileByID(e),o&&o.hasData())break;const t=r[e];if(null===t)break;void 0===t?c.push(e):o=i.getTileByID(t);}return h(o?o.tileID.key:null),o&&o.hasData()?o:null}findDEMTileFor(e){return this.enabled?this._findTileCoveringTileID(e,this.sourceCache):null}prepareDrawTile(){this.renderedToTile=!0;}_clearRenderCacheForTile(e,t){let i=this._tilesDirty[e];i||(i=this._tilesDirty[e]={}),i[t.key]=!0;}getWirefameBuffer(){if(!this.wireframeSegments){const t=function(t){let i=0;const o=new e.StructArrayLayout2ui4,r=131;for(let e=1;e<129;e++){for(let t=1;t<129;t++)i=e*r+t,o.emplaceBack(i,i+1),o.emplaceBack(i,i+r),o.emplaceBack(i+1,i+r),128===e&&o.emplaceBack(i+r,i+r+1);o.emplaceBack(i+1,i+1+r);}return o}();this.wireframeIndexBuffer=this.painter.context.createIndexBuffer(t),this.wireframeSegments=e.SegmentVector.simpleSegment(0,0,this.gridBuffer.length,t.length);}return [this.wireframeIndexBuffer,this.wireframeSegments]}}class Li{static cacheKey(e,t,i,o){let r=`${t}${o?o.cacheKey:""}`;for(const t of i)e.usedDefines.includes(t)&&(r+=`/${t}`);return r}constructor(t,i,o,r,n,s){const a=t.gl;this.program=a.createProgram();const l=function(e){const t=[];for(let i=0;i<e.length;i++){if(null===e[i])continue;const o=e[i].split(" ");t.push(o.pop());}return t}(o.staticAttributes),c=r?r.getBinderAttributes():[],h=l.concat(c);let u=r?r.defines():[];u=u.concat(s.map((e=>`#define ${e}`)));const _=t.isWebGL2?"#version 300 es\n":"",d=_+u.concat(t.extStandardDerivatives&&0===_.length?"#extension GL_OES_standard_derivatives : enable\n".concat(li):li,li,ai,si.fragmentSource,ri.fragmentSource,o.fragmentSource).join("\n"),p=_+u.concat("\n#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif",ai,si.vertexSource,ri.vertexSource,oi.vertexSource,o.vertexSource).join("\n"),m=a.createShader(a.FRAGMENT_SHADER);if(a.isContextLost())return void(this.failedToCreate=!0);a.shaderSource(m,d),a.compileShader(m),a.attachShader(this.program,m);const f=a.createShader(a.VERTEX_SHADER);if(a.isContextLost())this.failedToCreate=!0;else {a.shaderSource(f,p),a.compileShader(f),a.attachShader(this.program,f),this.attributes={},this.numAttributes=h.length;for(let e=0;e<this.numAttributes;e++)h[e]&&(a.bindAttribLocation(this.program,e,h[e]),this.attributes[h[e]]=e);a.linkProgram(this.program),a.deleteShader(f),a.deleteShader(m),this.fixedUniforms=n(t),this.binderUniforms=r?r.getUniforms(t):[],s.includes("TERRAIN")&&(this.terrainUniforms=(t=>({u_dem:new e.Uniform1i(t),u_dem_prev:new e.Uniform1i(t),u_dem_unpack:new e.Uniform4f(t),u_dem_tl:new e.Uniform2f(t),u_dem_scale:new e.Uniform1f(t),u_dem_tl_prev:new e.Uniform2f(t),u_dem_scale_prev:new e.Uniform1f(t),u_dem_size:new e.Uniform1f(t),u_dem_lerp:new e.Uniform1f(t),u_exaggeration:new e.Uniform1f(t),u_depth:new e.Uniform1i(t),u_depth_size_inv:new e.Uniform2f(t),u_meter_to_dem:new e.Uniform1f(t),u_label_plane_matrix_inv:new e.UniformMatrix4f(t)}))(t)),s.includes("GLOBE")&&(this.globeUniforms=(t=>({u_tile_tl_up:new e.Uniform3f(t),u_tile_tr_up:new e.Uniform3f(t),u_tile_br_up:new e.Uniform3f(t),u_tile_bl_up:new e.Uniform3f(t),u_tile_up_scale:new e.Uniform1f(t)}))(t)),s.includes("FOG")&&(this.fogUniforms=(t=>({u_fog_matrix:new e.UniformMatrix4f(t),u_fog_range:new e.Uniform2f(t),u_fog_color:new e.Uniform4f(t),u_fog_horizon_blend:new e.Uniform1f(t),u_fog_temporal_offset:new e.Uniform1f(t),u_frustum_tl:new e.Uniform3f(t),u_frustum_tr:new e.Uniform3f(t),u_frustum_br:new e.Uniform3f(t),u_frustum_bl:new e.Uniform3f(t),u_globe_pos:new e.Uniform3f(t),u_globe_radius:new e.Uniform1f(t),u_globe_transition:new e.Uniform1f(t),u_is_globe:new e.Uniform1i(t),u_viewport:new e.Uniform2f(t)}))(t));}}setTerrainUniformValues(e,t){if(!this.terrainUniforms)return;const i=this.terrainUniforms;if(!this.failedToCreate){e.program.set(this.program);for(const e in t)i[e]&&i[e].set(this.program,e,t[e]);}}setGlobeUniformValues(e,t){if(!this.globeUniforms)return;const i=this.globeUniforms;if(!this.failedToCreate){e.program.set(this.program);for(const e in t)i[e]&&i[e].set(this.program,e,t[e]);}}setFogUniformValues(e,t){if(!this.fogUniforms)return;const i=this.fogUniforms;if(!this.failedToCreate){e.program.set(this.program);for(const e in t)i[e].set(this.program,e,t[e]);}}draw(e,t,i,o,r,n,s,a,l,c,h,u,_,d,p){const m=e.gl;if(this.failedToCreate)return;e.program.set(this.program),e.setDepthMode(i),e.setStencilMode(o),e.setColorMode(r),e.setCullFace(n);for(const e of Object.keys(this.fixedUniforms))this.fixedUniforms[e].set(this.program,e,s[e]);d&&d.setUniforms(this.program,e,this.binderUniforms,u,{zoom:_});const f={[m.LINES]:2,[m.TRIANGLES]:3,[m.LINE_STRIP]:1}[t];for(const i of h.get()){const o=i.vaos||(i.vaos={});(o[a]||(o[a]=new _i)).bind(e,this,l,d?d.getPaintVertexBuffers():[],c,i.vertexOffset,p||[]),m.drawElements(t,i.primitiveLength*f,m.UNSIGNED_SHORT,i.primitiveOffset*f*2);}}}function Ai(e,t){const i=Math.pow(2,t.tileID.overscaledZ),o=t.tileSize*Math.pow(2,e.transform.tileZoom)/i,r=o*(t.tileID.canonical.x+t.tileID.wrap*i),n=o*t.tileID.canonical.y;return {u_image:0,u_texsize:t.imageAtlasTexture.size,u_tile_units_to_pixels:1/D(t,1,e.transform.tileZoom),u_pixel_coord_upper:[r>>16,n>>16],u_pixel_coord_lower:[65535&r,65535&n]}}const zi=e.create(),Ri=(t,i,o,r,n,s,a,l,c,h,u)=>{const _=i.style.light,d=_.properties.get("position"),p=[d.x,d.y,d.z],m=e.create$1();"viewport"===_.properties.get("anchor")&&(e.fromRotation(m,-i.transform.angle),e.transformMat3(p,p,m));const f=_.properties.get("color"),g=i.transform,v={u_matrix:t,u_lightpos:p,u_lightintensity:_.properties.get("intensity"),u_lightcolor:[f.r,f.g,f.b],u_vertical_gradient:+o,u_opacity:r,u_tile_id:[0,0,0],u_zoom_transition:0,u_inv_rot_matrix:zi,u_merc_center:[0,0],u_up_dir:[0,0,0],u_height_lift:0,u_ao:n,u_edge_radius:s};return "globe"===g.projection.name&&(v.u_tile_id=[a.canonical.x,a.canonical.y,1<<a.canonical.z],v.u_zoom_transition=c,v.u_inv_rot_matrix=u,v.u_merc_center=h,v.u_up_dir=g.projection.upVector(new e.CanonicalTileID(0,0,0),h[0]*e.EXTENT,h[1]*e.EXTENT),v.u_height_lift=l),v},Oi=(t,i,o,r,n,s,a,l,c,h,u,_)=>{const d=Ri(t,i,o,r,n,s,a,c,h,u,_),p={u_height_factor:-Math.pow(2,a.overscaledZ)/l.tileSize/8};return e.extend(d,Ai(i,l),p)},Bi=e=>({u_matrix:e}),ki=(t,i,o)=>e.extend(Bi(t),Ai(i,o)),Fi=(e,t)=>({u_matrix:e,u_world:t}),Ui=(t,i,o,r)=>e.extend(ki(t,i,o),{u_world:r}),Ni=e.create(),ji=(t,i,o,r,n,s)=>{const a=t.transform,l="globe"===a.projection.name;let c;if("map"===s.paint.get("circle-pitch-alignment"))if(l){const t=e.globePixelsToTileUnits(a.zoom,i.canonical)*a._pixelsPerMercatorPixel;c=Float32Array.from([t,0,0,t]);}else c=a.calculatePixelsToTileUnitsMatrix(o);else c=new Float32Array([a.pixelsToGLUnits[0],0,0,a.pixelsToGLUnits[1]]);const h={u_camera_to_center_distance:a.cameraToCenterDistance,u_matrix:t.translatePosMatrix(i.projMatrix,o,s.paint.get("circle-translate"),s.paint.get("circle-translate-anchor")),u_device_pixel_ratio:e.exported.devicePixelRatio,u_extrude_scale:c,u_inv_rot_matrix:Ni,u_merc_center:[0,0],u_tile_id:[0,0,0],u_zoom_transition:0,u_up_dir:[0,0,0]};if(l){h.u_inv_rot_matrix=r,h.u_merc_center=n,h.u_tile_id=[i.canonical.x,i.canonical.y,1<<i.canonical.z],h.u_zoom_transition=e.globeToMercatorTransition(a.zoom);const t=n[0]*e.EXTENT,o=n[1]*e.EXTENT;h.u_up_dir=a.projection.upVector(new e.CanonicalTileID(0,0,0),t,o);}return h},Gi=e=>{const t=[];return "map"===e.paint.get("circle-pitch-alignment")&&t.push("PITCH_WITH_MAP"),"map"===e.paint.get("circle-pitch-scale")&&t.push("SCALE_WITH_MAP"),t},Zi=(t,i,o,r)=>{const n=e.EXTENT/o.tileSize;return {u_matrix:t,u_camera_to_center_distance:i.getCameraToCenterDistance(r),u_extrude_scale:[i.pixelsToGLUnits[0]/n,i.pixelsToGLUnits[1]/n]}},Vi=(e,t,i=1)=>({u_matrix:e,u_color:t,u_overlay:0,u_overlay_scale:i}),Wi=e.create(),Xi=(t,i,o,r,n,s,a)=>{const l=t.transform,c="globe"===l.projection.name,h=c?e.globePixelsToTileUnits(l.zoom,i.canonical)*l._pixelsPerMercatorPixel:D(o,1,s),u={u_matrix:i.projMatrix,u_extrude_scale:h,u_intensity:a,u_inv_rot_matrix:Wi,u_merc_center:[0,0],u_tile_id:[0,0,0],u_zoom_transition:0,u_up_dir:[0,0,0]};if(c){u.u_inv_rot_matrix=r,u.u_merc_center=n,u.u_tile_id=[i.canonical.x,i.canonical.y,1<<i.canonical.z],u.u_zoom_transition=e.globeToMercatorTransition(l.zoom);const t=n[0]*e.EXTENT,o=n[1]*e.EXTENT;u.u_up_dir=l.projection.upVector(new e.CanonicalTileID(0,0,0),t,o);}return u},qi=(e,t,i,o,r,n,s)=>{const a=e.transform,l=a.calculatePixelsToTileUnitsMatrix(t);return {u_matrix:Yi(e,t,i,o),u_pixels_to_tile_units:l,u_device_pixel_ratio:n,u_units_to_pixels:[1/a.pixelsToGLUnits[0],1/a.pixelsToGLUnits[1]],u_dash_image:0,u_gradient_image:1,u_image_height:r,u_texsize:Ki(i)?t.lineAtlasTexture.size:[0,0],u_tile_units_to_pixels:Hi(t,e.transform),u_alpha_discard_threshold:0,u_trim_offset:s}},$i=(e,t,i,o,r)=>{const n=e.transform;return {u_matrix:Yi(e,t,i,o),u_texsize:t.imageAtlasTexture.size,u_pixels_to_tile_units:n.calculatePixelsToTileUnitsMatrix(t),u_device_pixel_ratio:r,u_image:0,u_tile_units_to_pixels:Hi(t,n),u_units_to_pixels:[1/n.pixelsToGLUnits[0],1/n.pixelsToGLUnits[1]],u_alpha_discard_threshold:0}};function Hi(e,t){return 1/D(e,1,t.tileZoom)}function Yi(e,t,i,o){return e.translatePosMatrix(o||t.tileID.projMatrix,t,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}function Ki(e){const t=e.paint.get("line-dasharray").value;return t.value||"constant"!==t.kind}const Ji=(e,t,i,o,r,n)=>{return {u_matrix:e,u_tl_parent:t,u_scale_parent:i,u_fade_t:o.mix,u_opacity:o.opacity*r.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:r.paint.get("raster-brightness-min"),u_brightness_high:r.paint.get("raster-brightness-max"),u_saturation_factor:(a=r.paint.get("raster-saturation"),a>0?1-1/(1.001-a):-a),u_contrast_factor:(s=r.paint.get("raster-contrast"),s>0?1/(1-s):1+s),u_spin_weights:Qi(r.paint.get("raster-hue-rotate")),u_perspective_transform:n};var s,a;};function Qi(e){e*=Math.PI/180;const t=Math.sin(e),i=Math.cos(e);return [(2*i+1)/3,(-Math.sqrt(3)*t-i+1)/3,(Math.sqrt(3)*t-i+1)/3]}const eo=e.create(),to=(t,i,o,r,n,s,a,l,c,h,u,_,d,p,m,f)=>{const g=n.transform,v={u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:i?i.uSizeT:0,u_size:i?i.uSize:0,u_camera_to_center_distance:g.cameraToCenterDistance,u_rotate_symbol:+o,u_aspect_ratio:g.width/g.height,u_fade_change:n.options.fadeDuration?n.symbolFadeChange:1,u_matrix:s,u_label_plane_matrix:a,u_coord_matrix:l,u_is_text:+c,u_pitch_with_map:+r,u_texsize:h,u_texture:0,u_tile_id:[0,0,0],u_zoom_transition:0,u_inv_rot_matrix:eo,u_merc_center:[0,0],u_camera_forward:[0,0,0],u_ecef_origin:[0,0,0],u_tile_matrix:eo,u_up_vector:[0,-1,0]};return "globe"===f.name&&(v.u_tile_id=[u.canonical.x,u.canonical.y,1<<u.canonical.z],v.u_zoom_transition=_,v.u_inv_rot_matrix=p,v.u_merc_center=d,v.u_camera_forward=g._camera.forward(),v.u_ecef_origin=e.globeECEFOrigin(g.globeMatrix,u.toUnwrapped()),v.u_tile_matrix=Float32Array.from(g.globeMatrix),v.u_up_vector=m),v},io=(t,i,o,r,n,s,a,l,c,h,u,_,d,p,m,f,g)=>e.extend(to(t,i,o,r,n,s,a,l,c,h,_,d,p,m,f,g),{u_gamma_scale:r?n.transform.cameraToCenterDistance*Math.cos(n.terrain?0:n.transform._pitch):1,u_device_pixel_ratio:e.exported.devicePixelRatio,u_is_halo:+u}),oo=(t,i,o,r,n,s,a,l,c,h,u,_,d,p,m,f)=>e.extend(io(t,i,o,r,n,s,a,l,!0,c,!0,u,_,d,p,m,f),{u_texsize_icon:h,u_texture_icon:1}),ro=(e,t,i)=>({u_matrix:e,u_opacity:t,u_color:i}),no=(t,i,o,r,n)=>e.extend(function(e,t,i){const o=t.imageManager.getPattern(e.toString()),{width:r,height:n}=t.imageManager.getPixelSize(),s=Math.pow(2,i.tileID.overscaledZ),a=i.tileSize*Math.pow(2,t.transform.tileZoom)/s,l=a*(i.tileID.canonical.x+i.tileID.wrap*s),c=a*i.tileID.canonical.y;return {u_image:0,u_pattern_tl:o.tl,u_pattern_br:o.br,u_texsize:[r,n],u_pattern_size:o.displaySize,u_tile_units_to_pixels:1/D(i,1,t.transform.tileZoom),u_pixel_coord_upper:[l>>16,c>>16],u_pixel_coord_lower:[65535&l,65535&c]}}(r,o,n),{u_matrix:t,u_opacity:i}),so={fillExtrusion:t=>({u_matrix:new e.UniformMatrix4f(t),u_lightpos:new e.Uniform3f(t),u_lightintensity:new e.Uniform1f(t),u_lightcolor:new e.Uniform3f(t),u_vertical_gradient:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t),u_edge_radius:new e.Uniform1f(t),u_ao:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_up_dir:new e.Uniform3f(t),u_height_lift:new e.Uniform1f(t)}),fillExtrusionPattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_lightpos:new e.Uniform3f(t),u_lightintensity:new e.Uniform1f(t),u_lightcolor:new e.Uniform3f(t),u_vertical_gradient:new e.Uniform1f(t),u_height_factor:new e.Uniform1f(t),u_edge_radius:new e.Uniform1f(t),u_ao:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_up_dir:new e.Uniform3f(t),u_height_lift:new e.Uniform1f(t),u_image:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t)}),fill:t=>({u_matrix:new e.UniformMatrix4f(t)}),fillPattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_image:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t)}),fillOutline:t=>({u_matrix:new e.UniformMatrix4f(t),u_world:new e.Uniform2f(t)}),fillOutlinePattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_world:new e.Uniform2f(t),u_image:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t)}),circle:t=>({u_camera_to_center_distance:new e.Uniform1f(t),u_extrude_scale:new e.UniformMatrix2f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_up_dir:new e.Uniform3f(t)}),collisionBox:t=>({u_matrix:new e.UniformMatrix4f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_extrude_scale:new e.Uniform2f(t)}),collisionCircle:t=>({u_matrix:new e.UniformMatrix4f(t),u_inv_matrix:new e.UniformMatrix4f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_viewport_size:new e.Uniform2f(t)}),debug:t=>({u_color:new e.UniformColor(t),u_matrix:new e.UniformMatrix4f(t),u_overlay:new e.Uniform1i(t),u_overlay_scale:new e.Uniform1f(t)}),clippingMask:t=>({u_matrix:new e.UniformMatrix4f(t)}),heatmap:t=>({u_extrude_scale:new e.Uniform1f(t),u_intensity:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_up_dir:new e.Uniform3f(t)}),heatmapTexture:t=>({u_image:new e.Uniform1i(t),u_color_ramp:new e.Uniform1i(t),u_opacity:new e.Uniform1f(t)}),hillshade:t=>({u_matrix:new e.UniformMatrix4f(t),u_image:new e.Uniform1i(t),u_latrange:new e.Uniform2f(t),u_light:new e.Uniform2f(t),u_shadow:new e.UniformColor(t),u_highlight:new e.UniformColor(t),u_accent:new e.UniformColor(t)}),hillshadePrepare:t=>({u_matrix:new e.UniformMatrix4f(t),u_image:new e.Uniform1i(t),u_dimension:new e.Uniform2f(t),u_zoom:new e.Uniform1f(t),u_unpack:new e.Uniform4f(t)}),line:t=>({u_matrix:new e.UniformMatrix4f(t),u_pixels_to_tile_units:new e.UniformMatrix2f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_units_to_pixels:new e.Uniform2f(t),u_dash_image:new e.Uniform1i(t),u_gradient_image:new e.Uniform1i(t),u_image_height:new e.Uniform1f(t),u_texsize:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t),u_alpha_discard_threshold:new e.Uniform1f(t),u_trim_offset:new e.Uniform2f(t)}),linePattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_texsize:new e.Uniform2f(t),u_pixels_to_tile_units:new e.UniformMatrix2f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_image:new e.Uniform1i(t),u_units_to_pixels:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t),u_alpha_discard_threshold:new e.Uniform1f(t)}),raster:t=>({u_matrix:new e.UniformMatrix4f(t),u_tl_parent:new e.Uniform2f(t),u_scale_parent:new e.Uniform1f(t),u_fade_t:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t),u_image0:new e.Uniform1i(t),u_image1:new e.Uniform1i(t),u_brightness_low:new e.Uniform1f(t),u_brightness_high:new e.Uniform1f(t),u_saturation_factor:new e.Uniform1f(t),u_contrast_factor:new e.Uniform1f(t),u_spin_weights:new e.Uniform3f(t),u_perspective_transform:new e.Uniform2f(t)}),symbolIcon:t=>({u_is_size_zoom_constant:new e.Uniform1i(t),u_is_size_feature_constant:new e.Uniform1i(t),u_size_t:new e.Uniform1f(t),u_size:new e.Uniform1f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_rotate_symbol:new e.Uniform1i(t),u_aspect_ratio:new e.Uniform1f(t),u_fade_change:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_label_plane_matrix:new e.UniformMatrix4f(t),u_coord_matrix:new e.UniformMatrix4f(t),u_is_text:new e.Uniform1i(t),u_pitch_with_map:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_camera_forward:new e.Uniform3f(t),u_tile_matrix:new e.UniformMatrix4f(t),u_up_vector:new e.Uniform3f(t),u_ecef_origin:new e.Uniform3f(t),u_texture:new e.Uniform1i(t)}),symbolSDF:t=>({u_is_size_zoom_constant:new e.Uniform1i(t),u_is_size_feature_constant:new e.Uniform1i(t),u_size_t:new e.Uniform1f(t),u_size:new e.Uniform1f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_rotate_symbol:new e.Uniform1i(t),u_aspect_ratio:new e.Uniform1f(t),u_fade_change:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_label_plane_matrix:new e.UniformMatrix4f(t),u_coord_matrix:new e.UniformMatrix4f(t),u_is_text:new e.Uniform1i(t),u_pitch_with_map:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_texture:new e.Uniform1i(t),u_gamma_scale:new e.Uniform1f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_camera_forward:new e.Uniform3f(t),u_tile_matrix:new e.UniformMatrix4f(t),u_up_vector:new e.Uniform3f(t),u_ecef_origin:new e.Uniform3f(t),u_is_halo:new e.Uniform1i(t)}),symbolTextAndIcon:t=>({u_is_size_zoom_constant:new e.Uniform1i(t),u_is_size_feature_constant:new e.Uniform1i(t),u_size_t:new e.Uniform1f(t),u_size:new e.Uniform1f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_rotate_symbol:new e.Uniform1i(t),u_aspect_ratio:new e.Uniform1f(t),u_fade_change:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_label_plane_matrix:new e.UniformMatrix4f(t),u_coord_matrix:new e.UniformMatrix4f(t),u_is_text:new e.Uniform1i(t),u_pitch_with_map:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_texsize_icon:new e.Uniform2f(t),u_texture:new e.Uniform1i(t),u_texture_icon:new e.Uniform1i(t),u_gamma_scale:new e.Uniform1f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_is_halo:new e.Uniform1i(t)}),background:t=>({u_matrix:new e.UniformMatrix4f(t),u_opacity:new e.Uniform1f(t),u_color:new e.UniformColor(t)}),backgroundPattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_opacity:new e.Uniform1f(t),u_image:new e.Uniform1i(t),u_pattern_tl:new e.Uniform2f(t),u_pattern_br:new e.Uniform2f(t),u_texsize:new e.Uniform2f(t),u_pattern_size:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t)}),terrainRaster:gi,terrainDepth:gi,skybox:t=>({u_matrix:new e.UniformMatrix4f(t),u_sun_direction:new e.Uniform3f(t),u_cubemap:new e.Uniform1i(t),u_opacity:new e.Uniform1f(t),u_temporal_offset:new e.Uniform1f(t)}),skyboxGradient:t=>({u_matrix:new e.UniformMatrix4f(t),u_color_ramp:new e.Uniform1i(t),u_center_direction:new e.Uniform3f(t),u_radius:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t),u_temporal_offset:new e.Uniform1f(t)}),skyboxCapture:t=>({u_matrix_3f:new e.UniformMatrix3f(t),u_sun_direction:new e.Uniform3f(t),u_sun_intensity:new e.Uniform1f(t),u_color_tint_r:new e.Uniform4f(t),u_color_tint_m:new e.Uniform4f(t),u_luminance:new e.Uniform1f(t)}),globeRaster:t=>({u_proj_matrix:new e.UniformMatrix4f(t),u_globe_matrix:new e.UniformMatrix4f(t),u_normalize_matrix:new e.UniformMatrix4f(t),u_merc_matrix:new e.UniformMatrix4f(t),u_zoom_transition:new e.Uniform1f(t),u_merc_center:new e.Uniform2f(t),u_image0:new e.Uniform1i(t),u_grid_matrix:new e.UniformMatrix3f(t),u_skirt_height:new e.Uniform1f(t),u_frustum_tl:new e.Uniform3f(t),u_frustum_tr:new e.Uniform3f(t),u_frustum_br:new e.Uniform3f(t),u_frustum_bl:new e.Uniform3f(t),u_globe_pos:new e.Uniform3f(t),u_globe_radius:new e.Uniform1f(t),u_viewport:new e.Uniform2f(t)}),globeAtmosphere:t=>({u_frustum_tl:new e.Uniform3f(t),u_frustum_tr:new e.Uniform3f(t),u_frustum_br:new e.Uniform3f(t),u_frustum_bl:new e.Uniform3f(t),u_horizon:new e.Uniform1f(t),u_transition:new e.Uniform1f(t),u_fadeout_range:new e.Uniform1f(t),u_color:new e.Uniform4f(t),u_high_color:new e.Uniform4f(t),u_space_color:new e.Uniform4f(t),u_star_intensity:new e.Uniform1f(t),u_star_density:new e.Uniform1f(t),u_star_size:new e.Uniform1f(t),u_temporal_offset:new e.Uniform1f(t),u_horizon_angle:new e.Uniform1f(t),u_rotation_matrix:new e.UniformMatrix4f(t)})};let ao;function lo(t,i,o,r,n,s,a){const l=t.context,c=l.gl,h=t.transform,u=t.useProgram("collisionBox"),_=[];let d=0,p=0;for(let m=0;m<r.length;m++){const f=r[m],g=i.getTile(f),v=g.getBucket(o);if(!v)continue;const x=vt(f,v,h);let y=x;0===n[0]&&0===n[1]||(y=t.translatePosMatrix(x,g,n,s));const b=a?v.textCollisionBox:v.iconCollisionBox,w=v.collisionCircleArray;if(w.length>0){const t=e.create(),i=y;e.mul(t,v.placementInvProjMatrix,h.glCoordMatrix),e.mul(t,t,v.placementViewportMatrix),_.push({circleArray:w,circleOffset:p,transform:i,invTransform:t,projection:v.getProjection()}),d+=w.length/4,p=d;}b&&(t.terrain&&t.terrain.setupElevationDraw(g,u),u.draw(l,c.LINES,e.DepthMode.disabled,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.disabled,Zi(y,h,g,v.getProjection()),o.id,b.layoutVertexBuffer,b.indexBuffer,b.segments,null,h.zoom,null,[b.collisionVertexBuffer,b.collisionVertexBufferExt]));}if(!a||!_.length)return;const m=t.useProgram("collisionCircle"),f=new e.StructArrayLayout2f1f2i16;f.resize(4*d),f._trim();let g=0;for(const e of _)for(let t=0;t<e.circleArray.length/4;t++){const i=4*t,o=e.circleArray[i+0],r=e.circleArray[i+1],n=e.circleArray[i+2],s=e.circleArray[i+3];f.emplace(g++,o,r,n,s,0),f.emplace(g++,o,r,n,s,1),f.emplace(g++,o,r,n,s,2),f.emplace(g++,o,r,n,s,3);}(!ao||ao.length<2*d)&&(ao=function(t){const i=2*t,o=new e.StructArrayLayout3ui6;o.resize(i),o._trim();for(let e=0;e<i;e++){const t=6*e;o.uint16[t+0]=4*e+0,o.uint16[t+1]=4*e+1,o.uint16[t+2]=4*e+2,o.uint16[t+3]=4*e+2,o.uint16[t+4]=4*e+3,o.uint16[t+5]=4*e+0;}return o}(d));const v=l.createIndexBuffer(ao,!0),x=l.createVertexBuffer(f,e.collisionCircleLayout.members,!0);for(const i of _){const r={u_matrix:i.transform,u_inv_matrix:i.invTransform,u_camera_to_center_distance:(y=h).getCameraToCenterDistance(i.projection),u_viewport_size:[y.width,y.height]};m.draw(l,c.TRIANGLES,e.DepthMode.disabled,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.disabled,r,o.id,x,v,e.SegmentVector.simpleSegment(0,2*i.circleOffset,i.circleArray.length,i.circleArray.length/2),null,h.zoom);}var y;x.destroy(),v.destroy();}const co=e.create();function ho({width:t,height:i,anchor:o,textOffset:r,textScale:n},s){const{horizontalAlign:a,verticalAlign:l}=e.getAnchorAlignment(o),c=-(a-.5)*t,h=-(l-.5)*i,u=e.evaluateVariableOffset(o,r);return new e.Point((c/n+u[0])*s,(h/n+u[1])*s)}function uo(t,i,o,r,n,s,a,l,c,h,u){const _=t.text.placedSymbolArray,d=t.text.dynamicLayoutVertexArray,p=t.icon.dynamicLayoutVertexArray,m={},f=t.getProjection(),g=xt(l,f,s),v=s.elevation,x=f.upVectorScale(l.canonical,s.center.lat,s.worldSize).metersToTile;d.clear();for(let p=0;p<_.length;p++){const y=_.get(p),{tileAnchorX:b,tileAnchorY:w,numGlyphs:T}=y,E=y.hidden||!y.crossTileID||t.allowVerticalPlacement&&!y.placedOrientation?null:r[y.crossTileID];if(E){let r=0,_=0,p=0;if(v){const e=v?v.getAtTileOffset(l,b,w):0,[t,i,o]=f.upVector(l.canonical,b,w);r=e*t*x,_=e*i*x,p=e*o*x;}let[C,M,I,P]=ot(y.projectedAnchorX+r,y.projectedAnchorY+_,y.projectedAnchorZ+p,o?g:a);const S=rt(s.getCameraToCenterDistance(f),P);let D=n.evaluateSizeForFeature(t.textSizeData,h,y)*S/e.ONE_EM;o&&(D*=t.tilePixelRatio/c);const L=ho(E,D);o?(({x:C,y:M,z:I}=f.projectTilePoint(b+L.x,w+L.y,l.canonical)),[C,M,I]=ot(C+r,M+_,I+p,a)):(i&&L._rotate(-s.angle),C+=L.x,M+=L.y,I=0);const A=t.allowVerticalPlacement&&y.placedOrientation===e.WritingMode.vertical?Math.PI/2:0;for(let t=0;t<T;t++)e.addDynamicAttributes(d,C,M,I,A);u&&y.associatedIconIndex>=0&&(m[y.associatedIconIndex]={x:C,y:M,z:I,angle:A});}else dt(T,d);}if(u){p.clear();const i=t.icon.placedSymbolArray;for(let t=0;t<i.length;t++){const o=i.get(t),{numGlyphs:r}=o,n=m[t];if(o.hidden||!n)dt(r,p);else {const{x:t,y:i,z:o,angle:s}=n;for(let n=0;n<r;n++)e.addDynamicAttributes(p,t,i,o,s);}}t.icon.dynamicLayoutVertexBuffer.updateData(p);}t.text.dynamicLayoutVertexBuffer.updateData(d);}function _o(e,t,i){return i.iconsInText&&t?"symbolTextAndIcon":e?"symbolSDF":"symbolIcon"}function po(t,i,o,r,n,s,a,l,c,h,u,_){const d=t.context,p=d.gl,m=t.transform,f="map"===l,g="map"===c,v=f&&"point"!==o.layout.get("symbol-placement"),x=f&&!g&&!v,y=void 0!==o.layout.get("symbol-sort-key").constantOr(1);let b=!1;const w=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),T=[e.mercatorXfromLng(m.center.lng),e.mercatorYfromLat(m.center.lat)],E=o.layout.get("text-variable-anchor"),C="globe"===m.projection.name,M=[],I=[0,-1,0];let P=I;!C&&!m.mercatorFromTransition||f||(P=function(t){const i=t._camera.getWorldToCamera(t.worldSize,1),o=e.multiply([],i,t.globeMatrix);e.invert(o,o);const r=[0,0,0],n=[0,1,0,0];return e.transformMat4$1(n,n,o),r[0]=n[0],r[1]=n[1],r[2]=n[2],e.normalize(r,r),r}(m));for(const l of r){const r=i.getTile(l),c=r.getBucket(o);if(!c)continue;if("mercator"===c.projection.name&&C)continue;const u=n?c.text:c.icon;if(!u||c.fullyClipped||!u.segments.get().length)continue;const _=u.programConfigurations.get(o.id),d=n||c.sdfIcons,w=n?c.textSizeData:c.iconSizeData,S=g||0!==m.pitch,D=e.evaluateSizeForZoom(w,m.zoom);let L,A,z,R,O=[0,0],B=null;if(n)A=r.glyphAtlasTexture,z=p.LINEAR,L=r.glyphAtlasTexture.size,c.iconsInText&&(O=r.imageAtlasTexture.size,B=r.imageAtlasTexture,R=S||t.options.rotating||t.options.zooming||"composite"===w.kind||"camera"===w.kind?p.LINEAR:p.NEAREST);else {const e=1!==o.layout.get("icon-size").constantOr(0)||c.iconsNeedLinear;A=r.imageAtlasTexture,z=d||t.options.rotating||t.options.zooming||e||S?p.LINEAR:p.NEAREST,L=r.imageAtlasTexture.size;}const k="globe"===c.projection.name,F=k?P:I,U=k?e.globeToMercatorTransition(m.zoom):0,N=xt(l,c.getProjection(),m),j=m.calculatePixelsToTileUnitsMatrix(r),G=et(N,r.tileID.canonical,g,f,m,c.getProjection(),j),Z=t.terrain&&g&&v?e.invert(e.create(),G):co,V=it(N,r.tileID.canonical,g,f,m,c.getProjection(),j),W=E&&c.hasTextData(),X="none"!==o.layout.get("icon-text-fit")&&W&&c.hasIconData();if(v){const e=m.elevation,i=e?e.getAtTileOffsetFunc(l,m.center.lat,m.worldSize,c.getProjection()):null,o=tt(N,r.tileID.canonical,g,f,m,c.getProjection(),j);st(c,N,t,n,o,V,g,h,i,l);}const q=v||n&&E||X,$=t.translatePosMatrix(N,r,s,a),H=q?co:G,Y=t.translatePosMatrix(V,r,s,a,!0),K=c.getProjection().createInversionMatrix(m,l.canonical),J=[];t.terrainRenderModeElevated()&&g&&J.push("PITCH_WITH_MAP_TERRAIN"),k&&J.push("PROJECTION_GLOBE_VIEW"),q&&J.push("PROJECTED_POS_ON_VIEWPORT");const Q=d&&0!==o.paint.get(n?"text-halo-width":"icon-halo-width").constantOr(1);let ee;ee=d?c.iconsInText?oo(w.kind,D,x,g,t,$,H,Y,L,O,l,U,T,K,F,c.getProjection()):io(w.kind,D,x,g,t,$,H,Y,n,L,!0,l,U,T,K,F,c.getProjection()):to(w.kind,D,x,g,t,$,H,Y,n,L,l,U,T,K,F,c.getProjection());const te={program:t.useProgram(_o(d,n,c),_,J),buffers:u,uniformValues:ee,atlasTexture:A,atlasTextureIcon:B,atlasInterpolation:z,atlasInterpolationIcon:R,isSDF:d,hasHalo:Q,tile:r,labelPlaneMatrixInv:Z};if(y&&c.canOverlap){b=!0;const t=u.segments.get();for(const i of t)M.push({segments:new e.SegmentVector([i]),sortKey:i.sortKey,state:te});}else M.push({segments:u.segments,sortKey:0,state:te});}b&&M.sort(((e,t)=>e.sortKey-t.sortKey));for(const e of M){const i=e.state;if(t.terrain&&t.terrain.setupElevationDraw(i.tile,i.program,{useDepthForOcclusion:!C,labelPlaneMatrixInv:i.labelPlaneMatrixInv}),d.activeTexture.set(p.TEXTURE0),i.atlasTexture.bind(i.atlasInterpolation,p.CLAMP_TO_EDGE),i.atlasTextureIcon&&(d.activeTexture.set(p.TEXTURE1),i.atlasTextureIcon&&i.atlasTextureIcon.bind(i.atlasInterpolationIcon,p.CLAMP_TO_EDGE)),i.isSDF){const r=i.uniformValues;i.hasHalo&&(r.u_is_halo=1,mo(i.buffers,e.segments,o,t,i.program,w,u,_,r)),r.u_is_halo=0;}mo(i.buffers,e.segments,o,t,i.program,w,u,_,i.uniformValues);}}function mo(t,i,o,r,n,s,a,l,c){const h=r.context,u=[t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer,t.globeExtVertexBuffer];n.draw(h,h.gl.TRIANGLES,s,a,l,e.CullFaceMode.disabled,c,o.id,t.layoutVertexBuffer,t.indexBuffer,i,o.paint,r.transform.zoom,t.programConfigurations.get(o.id),u);}function fo(t,i,o,r,n,s,a){const l=t.context.gl,c=o.paint.get("fill-pattern"),h=c&&c.constantOr(1);let u,_,d,p,m;a?(_=h&&!o.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",u=l.LINES):(_=h?"fillPattern":"fill",u=l.TRIANGLES);for(const f of r){const r=i.getTile(f);if(h&&!r.patternsLoaded())continue;const g=r.getBucket(o);if(!g)continue;t.prepareDrawTile();const v=g.programConfigurations.get(o.id),x=t.useProgram(_,v);h&&(t.context.activeTexture.set(l.TEXTURE0),r.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),v.updatePaintBuffers());const y=c.constantOr(null);if(y&&r.imageAtlas){const e=r.imageAtlas.patternPositions[y.toString()];e&&v.setConstantPatternPositions(e);}const b=t.translatePosMatrix(f.projMatrix,r,o.paint.get("fill-translate"),o.paint.get("fill-translate-anchor"));if(a){p=g.indexBuffer2,m=g.segments2;const e=t.terrain&&t.terrain.renderingToTexture?t.terrain.drapeBufferSize:[l.drawingBufferWidth,l.drawingBufferHeight];d="fillOutlinePattern"===_&&h?Ui(b,t,r,e):Fi(b,e);}else p=g.indexBuffer,m=g.segments,d=h?ki(b,t,r):Bi(b);t.prepareDrawProgram(t.context,x,f.toUnwrapped()),x.draw(t.context,u,n,t.stencilModeForClipping(f),s,e.CullFaceMode.disabled,d,o.id,g.layoutVertexBuffer,p,m,o.paint,t.transform.zoom,v);}}function go(t,i,o,r,n,s,a){const l=t.context,c=l.gl,h=t.transform,u=o.paint.get("fill-extrusion-pattern"),_=u.constantOr(1),d=o.paint.get("fill-extrusion-opacity"),p=[o.paint.get("fill-extrusion-ambient-occlusion-intensity"),o.paint.get("fill-extrusion-ambient-occlusion-radius")],m=o.layout.get("fill-extrusion-edge-radius"),f=m>0&&!o.paint.get("fill-extrusion-rounded-roof"),g=f?0:m,v="globe"===h.projection.name?e.fillExtrusionHeightLift():0,x="globe"===h.projection.name,y=x?e.globeToMercatorTransition(h.zoom):0,b=[e.mercatorXfromLng(h.center.lng),e.mercatorYfromLat(h.center.lat)],w=[];x&&w.push("PROJECTION_GLOBE_VIEW"),p[0]>0&&w.push("FAUX_AO"),f&&w.push("ZERO_ROOF_RADIUS");for(const m of r){const r=i.getTile(m),f=r.getBucket(o);if(!f||f.projection.name!==h.projection.name)continue;const T=f.programConfigurations.get(o.id),E=t.useProgram(_?"fillExtrusionPattern":"fillExtrusion",T,w);if(t.terrain){const e=t.terrain;if(t.style.terrainSetForDrapingOnly())e.setupElevationDraw(r,E,{useMeterToDem:!0});else {if(!f.enableTerrain)continue;if(e.setupElevationDraw(r,E,{useMeterToDem:!0}),vo(l,i,m,f,o,e),!f.centroidVertexBuffer){const e=E.attributes.a_centroid_pos;void 0!==e&&c.vertexAttrib2f(e,0,0);}}}_&&(t.context.activeTexture.set(c.TEXTURE0),r.imageAtlasTexture.bind(c.LINEAR,c.CLAMP_TO_EDGE),T.updatePaintBuffers());const C=u.constantOr(null);if(C&&r.imageAtlas){const e=r.imageAtlas.patternPositions[C.toString()];e&&T.setConstantPatternPositions(e);}const M=t.translatePosMatrix(m.projMatrix,r,o.paint.get("fill-extrusion-translate"),o.paint.get("fill-extrusion-translate-anchor")),I=h.projection.createInversionMatrix(h,m.canonical),P=o.paint.get("fill-extrusion-vertical-gradient"),S=_?Oi(M,t,P,d,p,g,m,r,v,y,b,I):Ri(M,t,P,d,p,g,m,v,y,b,I);t.prepareDrawProgram(l,E,m.toUnwrapped());const D=[];t.terrain&&D.push(f.centroidVertexBuffer),x&&D.push(f.layoutVertexExtBuffer),E.draw(l,l.gl.TRIANGLES,n,s,a,e.CullFaceMode.backCCW,S,o.id,f.layoutVertexBuffer,f.indexBuffer,f.segments,o.paint,t.transform.zoom,T,D);}}function vo(t,i,o,r,n,s){const a=[t=>{let i=t.canonical.x-1,o=t.wrap;return i<0&&(i=(1<<t.canonical.z)-1,o--),new e.OverscaledTileID(t.overscaledZ,o,t.canonical.z,i,t.canonical.y)},t=>{let i=t.canonical.x+1,o=t.wrap;return i===1<<t.canonical.z&&(i=0,o++),new e.OverscaledTileID(t.overscaledZ,o,t.canonical.z,i,t.canonical.y)},t=>new e.OverscaledTileID(t.overscaledZ,t.wrap,t.canonical.z,t.canonical.x,(0===t.canonical.y?1<<t.canonical.z:t.canonical.y)-1),t=>new e.OverscaledTileID(t.overscaledZ,t.wrap,t.canonical.z,t.canonical.x,t.canonical.y===(1<<t.canonical.z)-1?0:t.canonical.y+1)],l=e=>{const t=i.getSource().minzoom,o=e=>{const t=i.getTileByID(e);if(t&&t.hasData())return t.getBucket(n)},r=[0,-1,1];for(const i of r){if(e.overscaledZ+i<t)continue;const r=o(e.calculateScaledKey(e.overscaledZ+i));if(r)return r}},c=[0,0,0],h=(t,i)=>(c[0]=Math.min(t.min.y,i.min.y),c[1]=Math.max(t.max.y,i.max.y),c[2]=e.EXTENT-i.min.x>t.max.x?i.min.x-e.EXTENT:t.max.x,c),u=(t,i)=>(c[0]=Math.min(t.min.x,i.min.x),c[1]=Math.max(t.max.x,i.max.x),c[2]=e.EXTENT-i.min.y>t.max.y?i.min.y-e.EXTENT:t.max.y,c),_=[(e,t)=>h(e,t),(e,t)=>h(t,e),(e,t)=>u(e,t),(e,t)=>u(t,e)],d=new e.Point(0,0);let p,m,f;const g=(t,i,r,n,a)=>{const l=[[n?r:t,n?t:r,0],[n?r:i,n?i:r,0]],c=a<0?e.EXTENT+a:a,h=[n?c:(t+i)/2,n?(t+i)/2:c,0];return 0===r&&a<0||0!==r&&a>0?s.getForTilePoints(f,[h],!0,m):l.push(h),s.getForTilePoints(o,l,!0,p),Math.max(l[0][2],l[1][2],h[2])/s.exaggeration()};for(let t=0;t<4;t++){const i=(t<2?1:5)-t,n=r.borders[t];if(0===n.length)continue;const c=f=a[t](o),h=l(c);if(!(h&&h instanceof e.FillExtrusionBucket&&h.enableTerrain))continue;if(r.borderDoneWithNeighborZ[t]===h.canonical.z&&h.borderDoneWithNeighborZ[i]===r.canonical.z)continue;if(m=s.findDEMTileFor(c),!m||!m.dem)continue;if(!p){const e=s.findDEMTileFor(o);if(!e||!e.dem)return;p=e;}const u=h.borders[i];let v=0;const x=h.borderDoneWithNeighborZ[i]!==r.canonical.z;if(r.canonical.z===h.canonical.z){for(let o=0;o<n.length;o++){const s=r.featuresOnBorder[n[o]],a=s.borders[t];let l;for(;v<u.length&&(l=h.featuresOnBorder[u[v]],!(l.borders[i][1]>a[0]+3));)x&&h.encodeCentroid(void 0,l,!1),v++;if(l&&v<u.length){const o=v;let n=0;for(;!(l.borders[i][0]>a[1]-3)&&(n++,++v!==u.length);)l=h.featuresOnBorder[u[v]];if(l=h.featuresOnBorder[u[o]],s.intersectsCount()>1||l.intersectsCount()>1||1!==n){1!==n&&(v=o),r.encodeCentroid(void 0,s,!1),x&&h.encodeCentroid(void 0,l,!1);continue}const c=_[t](s,l),p=t%2?e.EXTENT-1:0;d.x=g(c[0],Math.min(e.EXTENT-1,c[1]),p,t<2,c[2]),d.y=0,r.encodeCentroid(d,s,!1),x&&h.encodeCentroid(d,l,!1);}else r.encodeCentroid(void 0,s,!1);}r.borderDoneWithNeighborZ[t]=h.canonical.z,r.needsCentroidUpdate=!0,x&&(h.borderDoneWithNeighborZ[i]=r.canonical.z,h.needsCentroidUpdate=!0);}else {for(const e of n)r.encodeCentroid(void 0,r.featuresOnBorder[e],!1);if(x){for(const e of u)h.encodeCentroid(void 0,h.featuresOnBorder[e],!1);h.borderDoneWithNeighborZ[i]=r.canonical.z,h.needsCentroidUpdate=!0;}r.borderDoneWithNeighborZ[t]=h.canonical.z,r.needsCentroidUpdate=!0;}}(r.needsCentroidUpdate||!r.centroidVertexBuffer&&0!==r.centroidVertexArray.length)&&r.uploadCentroid(t);}const xo=new e.Color(1,0,0,1),yo=new e.Color(0,1,0,1),bo=new e.Color(0,0,1,1),wo=new e.Color(1,0,1,1),To=new e.Color(0,1,1,1);function Eo(t,i,o){const r=t.context,n=t.transform,s=r.gl,a="globe"===n.projection.name,l=a?["PROJECTION_GLOBE_VIEW"]:null;let c=o.projMatrix;if(a&&e.globeToMercatorTransition(n.zoom)>0){const t=e.transitionTileAABBinECEF(o.canonical,n),i=e.globeDenormalizeECEF(t);c=e.multiply(new Float32Array(16),n.globeMatrix,i),e.multiply(c,n.projMatrix,c);}const h=t.useProgram("debug",null,l),u=i.getTileByID(o.key);t.terrain&&t.terrain.setupElevationDraw(u,h);const _=e.DepthMode.disabled,d=e.StencilMode.disabled,p=t.colorModeForRenderPass(),m="$debug";r.activeTexture.set(s.TEXTURE0),t.emptyTexture.bind(s.LINEAR,s.CLAMP_TO_EDGE),a?u._makeGlobeTileDebugBuffers(t.context,n):u._makeDebugTileBoundsBuffers(t.context,n.projection);const f=u._tileDebugBuffer||t.debugBuffer,g=u._tileDebugIndexBuffer||t.debugIndexBuffer,v=u._tileDebugSegments||t.debugSegments;h.draw(r,s.LINE_STRIP,_,d,p,e.CullFaceMode.disabled,Vi(c,e.Color.red),m,f,g,v,null,null,null,[u._globeTileDebugBorderBuffer]);const x=u.latestRawTileData,y=Math.floor((x&&x.byteLength||0)/1024),b=i.getTile(o).tileSize,w=512/Math.min(b,512)*(o.overscaledZ/n.zoom)*.5;let T=o.canonical.toString();o.overscaledZ!==o.canonical.z&&(T+=` => ${o.overscaledZ}`),T+=` ${y}kb`,function(e,t){e.initDebugOverlayCanvas();const i=e.debugOverlayCanvas,o=e.context.gl,r=e.debugOverlayCanvas.getContext("2d");r.clearRect(0,0,i.width,i.height),r.shadowColor="white",r.shadowBlur=2,r.lineWidth=1.5,r.strokeStyle="white",r.textBaseline="top",r.font="bold 36px Open Sans, sans-serif",r.fillText(t,5,5),r.strokeText(t,5,5),e.debugOverlayTexture.update(i),e.debugOverlayTexture.bind(o.LINEAR,o.CLAMP_TO_EDGE);}(t,T);const E=u._tileDebugTextBuffer||t.debugBuffer,C=u._tileDebugTextIndexBuffer||t.quadTriangleIndexBuffer,M=u._tileDebugTextSegments||t.debugSegments;h.draw(r,s.TRIANGLES,_,d,e.ColorMode.alphaBlended,e.CullFaceMode.disabled,Vi(c,e.Color.transparent,w),m,E,C,M,null,null,null,[u._globeTileDebugTextBuffer]);}function Co(e,t,i,o){Io(e,0,t+i/2,e.transform.width,i,o);}function Mo(e,t,i,o){Io(e,t-i/2,0,i,e.transform.height,o);}function Io(t,i,o,r,n,s){const a=t.context,l=a.gl;l.enable(l.SCISSOR_TEST),l.scissor(i*e.exported.devicePixelRatio,o*e.exported.devicePixelRatio,r*e.exported.devicePixelRatio,n*e.exported.devicePixelRatio),a.clear({color:s}),l.disable(l.SCISSOR_TEST);}const Po=e.createLayout([{name:"a_pos_3f",components:3,type:"Float32"}]),{members:So}=Po;function Do(e,t,i,o){e.emplaceBack(t,i,o);}class Lo{constructor(t){this.vertexArray=new e.StructArrayLayout3f12,this.indices=new e.StructArrayLayout3ui6,Do(this.vertexArray,-1,-1,1),Do(this.vertexArray,1,-1,1),Do(this.vertexArray,-1,1,1),Do(this.vertexArray,1,1,1),Do(this.vertexArray,-1,-1,-1),Do(this.vertexArray,1,-1,-1),Do(this.vertexArray,-1,1,-1),Do(this.vertexArray,1,1,-1),this.indices.emplaceBack(5,1,3),this.indices.emplaceBack(3,7,5),this.indices.emplaceBack(6,2,0),this.indices.emplaceBack(0,4,6),this.indices.emplaceBack(2,6,7),this.indices.emplaceBack(7,3,2),this.indices.emplaceBack(5,4,0),this.indices.emplaceBack(0,1,5),this.indices.emplaceBack(0,2,3),this.indices.emplaceBack(3,1,0),this.indices.emplaceBack(7,6,4),this.indices.emplaceBack(4,5,7),this.vertexBuffer=t.createVertexBuffer(this.vertexArray,So),this.indexBuffer=t.createIndexBuffer(this.indices),this.segment=e.SegmentVector.simpleSegment(0,0,36,12);}}function Ao(t,i,o,r,n,s){const a=t.gl,l=i.paint.get("sky-atmosphere-color"),c=i.paint.get("sky-atmosphere-halo-color"),h=i.paint.get("sky-atmosphere-sun-intensity"),u=((e,t,i,o,r)=>({u_matrix_3f:e,u_sun_direction:t,u_sun_intensity:i,u_color_tint_r:[o.r,o.g,o.b,o.a],u_color_tint_m:[r.r,r.g,r.b,r.a],u_luminance:5e-5}))(e.fromMat4(e.create$1(),r),n,h,l,c);a.framebufferTexture2D(a.FRAMEBUFFER,a.COLOR_ATTACHMENT0,a.TEXTURE_CUBE_MAP_POSITIVE_X+s,i.skyboxTexture,0),o.draw(t,a.TRIANGLES,e.DepthMode.disabled,e.StencilMode.disabled,e.ColorMode.unblended,e.CullFaceMode.frontCW,u,"skyboxCapture",i.skyboxGeometry.vertexBuffer,i.skyboxGeometry.indexBuffer,i.skyboxGeometry.segment);}const zo=e.createLayout([{type:"Float32",name:"a_pos",components:3},{type:"Float32",name:"a_uv",components:2}]);class Ro{constructor(t){const i=new e.StructArrayLayout5f20;i.emplaceBack(-1,1,1,0,0),i.emplaceBack(1,1,1,1,0),i.emplaceBack(1,-1,1,1,1),i.emplaceBack(-1,-1,1,0,1);const o=new e.StructArrayLayout3ui6;o.emplaceBack(0,1,2),o.emplaceBack(2,3,0),this.vertexBuffer=t.createVertexBuffer(i,zo.members),this.indexBuffer=t.createIndexBuffer(o),this.segments=e.SegmentVector.simpleSegment(0,0,4,2);}destroy(){this.vertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy();}}const Oo={symbol:function(t,i,o,r,n){if("translucent"!==t.renderPass)return;const s=e.StencilMode.disabled,a=t.colorModeForRenderPass();o.layout.get("text-variable-anchor")&&function(t,i,o,r,n,s,a){const l=i.transform,c="map"===n,h="map"===s;for(const i of t){const t=r.getTile(i),n=t.getBucket(o);if(!n||!n.text||!n.text.segments.get().length)continue;const s=e.evaluateSizeForZoom(n.textSizeData,l.zoom),u=xt(i,n.getProjection(),l),_=l.calculatePixelsToTileUnitsMatrix(t),d=et(u,t.tileID.canonical,h,c,l,n.getProjection(),_),p="none"!==o.layout.get("icon-text-fit")&&n.hasIconData();if(s){const o=Math.pow(2,l.zoom-t.tileID.overscaledZ);uo(n,c,h,a,e.symbolSize,l,d,i,o,s,p);}}}(r,t,o,i,o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),n),0!==o.paint.get("icon-opacity").constantOr(1)&&po(t,i,o,r,!1,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),o.layout.get("icon-rotation-alignment"),o.layout.get("icon-pitch-alignment"),o.layout.get("icon-keep-upright"),s,a),0!==o.paint.get("text-opacity").constantOr(1)&&po(t,i,o,r,!0,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),o.layout.get("text-keep-upright"),s,a),i.map.showCollisionBoxes&&(lo(t,i,o,r,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),!0),lo(t,i,o,r,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),!1));},circle:function(t,i,o,r){if("translucent"!==t.renderPass)return;const n=o.paint.get("circle-opacity"),s=o.paint.get("circle-stroke-width"),a=o.paint.get("circle-stroke-opacity"),l=void 0!==o.layout.get("circle-sort-key").constantOr(1);if(0===n.constantOr(1)&&(0===s.constantOr(1)||0===a.constantOr(1)))return;const c=t.context,h=c.gl,u=t.transform,_=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),d=e.StencilMode.disabled,p=t.colorModeForRenderPass(),m="globe"===u.projection.name,f=[e.mercatorXfromLng(u.center.lng),e.mercatorYfromLat(u.center.lat)],g=[];for(let n=0;n<r.length;n++){const s=r[n],a=i.getTile(s),c=a.getBucket(o);if(!c||c.projection.name!==u.projection.name)continue;const h=c.programConfigurations.get(o.id),_=Gi(o);m&&_.push("PROJECTION_GLOBE_VIEW");const d=t.useProgram("circle",h,_),p=c.layoutVertexBuffer,v=c.globeExtVertexBuffer,x=c.indexBuffer,y=u.projection.createInversionMatrix(u,s.canonical),b={programConfiguration:h,program:d,layoutVertexBuffer:p,globeExtVertexBuffer:v,indexBuffer:x,uniformValues:ji(t,s,a,y,f,o),tile:a};if(l){const t=c.segments.get();for(const i of t)g.push({segments:new e.SegmentVector([i]),sortKey:i.sortKey,state:b});}else g.push({segments:c.segments,sortKey:0,state:b});}l&&g.sort(((e,t)=>e.sortKey-t.sortKey));const v={useDepthForOcclusion:!m};for(const i of g){const{programConfiguration:r,program:n,layoutVertexBuffer:s,globeExtVertexBuffer:a,indexBuffer:l,uniformValues:m,tile:f}=i.state,g=i.segments;t.terrain&&t.terrain.setupElevationDraw(f,n,v),t.prepareDrawProgram(c,n,f.tileID.toUnwrapped()),n.draw(c,h.TRIANGLES,_,d,p,e.CullFaceMode.disabled,m,o.id,s,l,g,o.paint,u.zoom,r,[a]);}},heatmap:function(t,i,o,r){if(0!==o.paint.get("heatmap-opacity"))if("offscreen"===t.renderPass){const n=t.context,s=n.gl,a=e.StencilMode.disabled,l=new e.ColorMode([s.ONE,s.ONE],e.Color.transparent,[!0,!0,!0,!0]);!function(e,t,i,o){const r=e.gl,n=t.width*o,s=t.height*o;e.activeTexture.set(r.TEXTURE1),e.viewport.set([0,0,n,s]);let a=i.heatmapFbo;if(!a||a&&(a.width!==n||a.height!==s)){a&&a.destroy();const t=r.createTexture();r.bindTexture(r.TEXTURE_2D,t),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,r.LINEAR),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MAG_FILTER,r.LINEAR),a=i.heatmapFbo=e.createFramebuffer(n,s,!1),function(e,t,i,o,r,n){const s=e.gl;s.texImage2D(s.TEXTURE_2D,0,e.isWebGL2&&e.extRenderToTextureHalfFloat?s.RGBA16F:s.RGBA,r,n,0,s.RGBA,e.extRenderToTextureHalfFloat?e.isWebGL2?s.HALF_FLOAT:e.extTextureHalfFloat.HALF_FLOAT_OES:s.UNSIGNED_BYTE,null),o.colorAttachment.set(i);}(e,0,t,a,n,s);}else r.bindTexture(r.TEXTURE_2D,a.colorAttachment.get()),e.bindFramebuffer.set(a.framebuffer);}(n,t,o,"globe"===t.transform.projection.name?.5:.25),n.clear({color:e.Color.transparent});const c=t.transform,h="globe"===c.projection.name,u=h?["PROJECTION_GLOBE_VIEW"]:null,_=h?e.CullFaceMode.frontCCW:e.CullFaceMode.disabled,d=[e.mercatorXfromLng(c.center.lng),e.mercatorYfromLat(c.center.lat)];for(let p=0;p<r.length;p++){const m=r[p];if(i.hasRenderableParent(m))continue;const f=i.getTile(m),g=f.getBucket(o);if(!g||g.projection.name!==c.projection.name)continue;const v=g.programConfigurations.get(o.id),x=t.useProgram("heatmap",v,u),{zoom:y}=t.transform;t.terrain&&t.terrain.setupElevationDraw(f,x),t.prepareDrawProgram(n,x,m.toUnwrapped());const b=c.projection.createInversionMatrix(c,m.canonical);x.draw(n,s.TRIANGLES,e.DepthMode.disabled,a,l,_,Xi(t,m,f,b,d,y,o.paint.get("heatmap-intensity")),o.id,g.layoutVertexBuffer,g.indexBuffer,g.segments,o.paint,t.transform.zoom,v,h?[g.globeExtVertexBuffer]:null);}n.viewport.set([0,0,t.width,t.height]);}else "translucent"===t.renderPass&&(t.context.setColorMode(t.colorModeForRenderPass()),function(t,i){const o=t.context,r=o.gl,n=i.heatmapFbo;if(!n)return;o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,n.colorAttachment.get()),o.activeTexture.set(r.TEXTURE1);let s=i.colorRampTexture;s||(s=i.colorRampTexture=new e.Texture(o,i.colorRamp,r.RGBA)),s.bind(r.LINEAR,r.CLAMP_TO_EDGE),t.useProgram("heatmapTexture").draw(o,r.TRIANGLES,e.DepthMode.disabled,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.disabled,((e,t,i,o)=>({u_image:0,u_color_ramp:1,u_opacity:t.paint.get("heatmap-opacity")}))(0,i),i.id,t.viewportBuffer,t.quadTriangleIndexBuffer,t.viewportSegments,i.paint,t.transform.zoom);}(t,o));},line:function(t,i,o,r){if("translucent"!==t.renderPass)return;const n=o.paint.get("line-opacity"),s=o.paint.get("line-width");if(0===n.constantOr(1)||0===s.constantOr(1))return;const a=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),l=t.colorModeForRenderPass(),c=t.terrain&&t.terrain.renderingToTexture?1:e.exported.devicePixelRatio,h=o.paint.get("line-dasharray"),u=h.constantOr(1),_=o.layout.get("line-cap"),d=o.paint.get("line-pattern"),p=d.constantOr(1),m=o.paint.get("line-gradient"),f=p?"linePattern":"line",g=t.context,v=g.gl,x=(e=>{const t=[];Ki(e)&&t.push("RENDER_LINE_DASH"),e.paint.get("line-gradient")&&t.push("RENDER_LINE_GRADIENT");const i=e.paint.get("line-trim-offset");0===i[0]&&0===i[1]||t.push("RENDER_LINE_TRIM_OFFSET");const o=e.paint.get("line-pattern").constantOr(1),r=1!==e.paint.get("line-opacity").constantOr(1);return !o&&r&&t.push("RENDER_LINE_ALPHA_DISCARD"),t})(o);let y=x.includes("RENDER_LINE_ALPHA_DISCARD");t.terrain&&t.terrain.clipOrMaskOverlapStencilType()&&(y=!1);for(const n of r){const r=i.getTile(n);if(p&&!r.patternsLoaded())continue;const s=r.getBucket(o);if(!s)continue;t.prepareDrawTile();const b=s.programConfigurations.get(o.id),w=t.useProgram(f,b,x),T=d.constantOr(null);if(T&&r.imageAtlas){const e=r.imageAtlas.patternPositions[T.toString()];e&&b.setConstantPatternPositions(e);}const E=h.constantOr(null),C=_.constantOr(null);if(!p&&E&&C&&r.lineAtlas){const e=r.lineAtlas.getDash(E,C);e&&b.setConstantPatternPositions(e);}let[M,I]=o.paint.get("line-trim-offset");if("round"===C||"square"===C){const e=1;M!==I&&(0===M&&(M-=e),1===I&&(I+=e));}const P=t.terrain?n.projMatrix:null,S=p?$i(t,r,o,P,c):qi(t,r,o,P,s.lineClipsArray.length,c,[M,I]);if(m){const r=s.gradients[o.id];let a=r.texture;if(o.gradientVersion!==r.version){let l=256;if(o.stepInterpolant){const o=i.getSource().maxzoom,r=n.canonical.z===o?Math.ceil(1<<t.transform.maxZoom-n.canonical.z):1;l=e.clamp(e.nextPowerOfTwo(s.maxLineLength/e.EXTENT*1024*r),256,g.maxTextureSize);}r.gradient=e.renderColorRamp({expression:o.gradientExpression(),evaluationKey:"lineProgress",resolution:l,image:r.gradient||void 0,clips:s.lineClipsArray}),r.texture?r.texture.update(r.gradient):r.texture=new e.Texture(g,r.gradient,v.RGBA),r.version=o.gradientVersion,a=r.texture;}g.activeTexture.set(v.TEXTURE1),a.bind(o.stepInterpolant?v.NEAREST:v.LINEAR,v.CLAMP_TO_EDGE);}u&&(g.activeTexture.set(v.TEXTURE0),r.lineAtlasTexture.bind(v.LINEAR,v.REPEAT),b.updatePaintBuffers()),p&&(g.activeTexture.set(v.TEXTURE0),r.imageAtlasTexture.bind(v.LINEAR,v.CLAMP_TO_EDGE),b.updatePaintBuffers()),t.prepareDrawProgram(g,w,n.toUnwrapped());const D=i=>{w.draw(g,v.TRIANGLES,a,i,l,e.CullFaceMode.disabled,S,o.id,s.layoutVertexBuffer,s.indexBuffer,s.segments,o.paint,t.transform.zoom,b,[s.layoutVertexBuffer2]);};if(y){const i=t.stencilModeForClipping(n).ref;0===i&&t.terrain&&g.clear({stencil:0});const o={func:v.EQUAL,mask:255};S.u_alpha_discard_threshold=.8,D(new e.StencilMode(o,i,255,v.KEEP,v.KEEP,v.INVERT)),S.u_alpha_discard_threshold=0,D(new e.StencilMode(o,i,255,v.KEEP,v.KEEP,v.KEEP));}else D(t.stencilModeForClipping(n));}y&&(t.resetStencilClippingMasks(),t.terrain&&g.clear({stencil:0}));},fill:function(t,i,o,r){const n=o.paint.get("fill-color"),s=o.paint.get("fill-opacity");if(0===s.constantOr(1))return;const a=t.colorModeForRenderPass(),l=o.paint.get("fill-pattern"),c=t.opaquePassEnabledForLayer()&&!l.constantOr(1)&&1===n.constantOr(e.Color.transparent).a&&1===s.constantOr(0)?"opaque":"translucent";if(t.renderPass===c){const n=t.depthModeForSublayer(1,"opaque"===t.renderPass?e.DepthMode.ReadWrite:e.DepthMode.ReadOnly);fo(t,i,o,r,n,a,!1);}if("translucent"===t.renderPass&&o.paint.get("fill-antialias")){const n=t.depthModeForSublayer(o.getPaintProperty("fill-outline-color")?2:0,e.DepthMode.ReadOnly);fo(t,i,o,r,n,a,!0);}},"fill-extrusion":function(t,i,o,r){const n=o.paint.get("fill-extrusion-opacity");if(0!==n&&"translucent"===t.renderPass){const s=new e.DepthMode(t.context.gl.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D);if(1!==n||o.paint.get("fill-extrusion-pattern").constantOr(1))go(t,i,o,r,s,e.StencilMode.disabled,e.ColorMode.disabled),go(t,i,o,r,s,t.stencilModeFor3D(),t.colorModeForRenderPass()),t.resetStencilClippingMasks();else {const n=t.colorModeForRenderPass();go(t,i,o,r,s,e.StencilMode.disabled,n);}}},hillshade:function(t,i,o,r){if("offscreen"!==t.renderPass&&"translucent"!==t.renderPass)return;const n=t.context,s=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),a=t.colorModeForRenderPass(),l=t.terrain&&t.terrain.renderingToTexture,[c,h]="translucent"!==t.renderPass||l?[{},r]:t.stencilConfigForOverlap(r);for(const r of h){const n=i.getTile(r);if(n.needsHillshadePrepare&&"offscreen"===t.renderPass)fi(t,n,o,s,e.StencilMode.disabled,a);else if("translucent"===t.renderPass){const e=l&&t.terrain?t.terrain.stencilModeForRTTOverlap(r):c[r.overscaledZ];pi(t,r,n,o,s,e,a);}}n.viewport.set([0,0,t.width,t.height]),t.resetStencilClippingMasks();},raster:function(t,i,o,r,n,s){if("translucent"!==t.renderPass)return;if(0===o.paint.get("raster-opacity"))return;if(!r.length)return;const a=t.context,l=a.gl,c=i.getSource(),h=t.useProgram("raster"),u=t.colorModeForRenderPass(),_=t.terrain&&t.terrain.renderingToTexture,[d,p]=c instanceof Pe||_?[{},r]:t.stencilConfigForOverlap(r),m=p[p.length-1].overscaledZ,f=!t.options.moving;for(const r of p){const n=_?e.DepthMode.disabled:t.depthModeForSublayer(r.overscaledZ-m,1===o.paint.get("raster-opacity")?e.DepthMode.ReadWrite:e.DepthMode.ReadOnly,l.LESS),p=r.toUnwrapped(),g=i.getTile(r);if(_&&(!g||!g.hasData()))continue;const v=_?r.projMatrix:t.transform.calculateProjMatrix(p,f),x=t.terrain&&_?t.terrain.stencilModeForRTTOverlap(r):d[r.overscaledZ],y=s?0:o.paint.get("raster-fade-duration");g.registerFadeDuration(y);const b=i.findLoadedParent(r,0),w=Mi(g,b,i,t.transform,y);let T,E;t.terrain&&t.terrain.prepareDrawTile();const C="nearest"===o.paint.get("raster-resampling")?l.NEAREST:l.LINEAR;a.activeTexture.set(l.TEXTURE0),g.texture.bind(C,l.CLAMP_TO_EDGE),a.activeTexture.set(l.TEXTURE1),b?(b.texture.bind(C,l.CLAMP_TO_EDGE),T=Math.pow(2,b.tileID.overscaledZ-g.tileID.overscaledZ),E=[g.tileID.canonical.x*T%1,g.tileID.canonical.y*T%1]):g.texture.bind(C,l.CLAMP_TO_EDGE),g.texture.useMipmap&&a.extTextureFilterAnisotropic&&t.transform.pitch>20&&l.texParameterf(l.TEXTURE_2D,a.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,a.extTextureFilterAnisotropicMax);const M=Ji(v,E||[0,0],T||1,w,o,c instanceof Pe?c.perspectiveTransform:[0,0]);if(t.prepareDrawProgram(a,h,p),c instanceof Pe)c.boundsBuffer&&c.boundsSegments&&h.draw(a,l.TRIANGLES,n,e.StencilMode.disabled,u,e.CullFaceMode.disabled,M,o.id,c.boundsBuffer,t.quadTriangleIndexBuffer,c.boundsSegments);else {const{tileBoundsBuffer:i,tileBoundsIndexBuffer:r,tileBoundsSegments:s}=t.getTileBoundsBuffers(g);h.draw(a,l.TRIANGLES,n,x,u,e.CullFaceMode.disabled,M,o.id,i,r,s);}}t.resetStencilClippingMasks();},background:function(t,i,o,r){const n=o.paint.get("background-color"),s=o.paint.get("background-opacity");if(0===s)return;const a=t.context,l=a.gl,c=t.transform,h=c.tileSize,u=o.paint.get("background-pattern");if(t.isPatternMissing(u))return;const _=!u&&1===n.a&&1===s&&t.opaquePassEnabledForLayer()?"opaque":"translucent";if(t.renderPass!==_)return;const d=e.StencilMode.disabled,p=t.depthModeForSublayer(0,"opaque"===_?e.DepthMode.ReadWrite:e.DepthMode.ReadOnly),m=t.colorModeForRenderPass(),f=t.useProgram(u?"backgroundPattern":"background");let g,v=r;v||(g=t.getBackgroundTiles(),v=Object.values(g).map((e=>e.tileID))),u&&(a.activeTexture.set(l.TEXTURE0),t.imageManager.bind(t.context));for(const _ of v){const v=_.toUnwrapped(),x=r?_.projMatrix:t.transform.calculateProjMatrix(v);t.prepareDrawTile();const y=i?i.getTile(_):g?g[_.key]:new e.Tile(_,h,c.zoom,t),b=u?no(x,s,t,u,{tileID:_,tileSize:h}):ro(x,s,n);t.prepareDrawProgram(a,f,v);const{tileBoundsBuffer:w,tileBoundsIndexBuffer:T,tileBoundsSegments:E}=t.getTileBoundsBuffers(y);f.draw(a,l.TRIANGLES,p,d,m,e.CullFaceMode.disabled,b,o.id,w,T,E);}},sky:function(t,i,o){const r=t.transform,n="mercator"===r.projection.name||"globe"===r.projection.name?1:e.smoothstep(7,8,r.zoom),s=o.paint.get("sky-opacity")*n;if(0===s)return;const a=t.context,l=o.paint.get("sky-type"),c=new e.DepthMode(a.gl.LEQUAL,e.DepthMode.ReadOnly,[0,1]),h=t.frameCounter/1e3%1;"atmosphere"===l?"offscreen"===t.renderPass?o.needsSkyboxCapture(t)&&(function(t,i,o,r){const n=t.context,s=n.gl;let a=i.skyboxFbo;if(!a){a=i.skyboxFbo=n.createFramebuffer(32,32,!1),i.skyboxGeometry=new Lo(n),i.skyboxTexture=n.gl.createTexture(),s.bindTexture(s.TEXTURE_CUBE_MAP,i.skyboxTexture),s.texParameteri(s.TEXTURE_CUBE_MAP,s.TEXTURE_WRAP_S,s.CLAMP_TO_EDGE),s.texParameteri(s.TEXTURE_CUBE_MAP,s.TEXTURE_WRAP_T,s.CLAMP_TO_EDGE),s.texParameteri(s.TEXTURE_CUBE_MAP,s.TEXTURE_MIN_FILTER,s.LINEAR),s.texParameteri(s.TEXTURE_CUBE_MAP,s.TEXTURE_MAG_FILTER,s.LINEAR);for(let e=0;e<6;++e)s.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X+e,0,s.RGBA,32,32,0,s.RGBA,s.UNSIGNED_BYTE,null);}n.bindFramebuffer.set(a.framebuffer),n.viewport.set([0,0,32,32]);const l=i.getCenter(t,!0),c=t.useProgram("skyboxCapture"),h=new Float64Array(16);e.identity(h),e.rotateY(h,h,.5*-Math.PI),Ao(n,i,c,h,l,0),e.identity(h),e.rotateY(h,h,.5*Math.PI),Ao(n,i,c,h,l,1),e.identity(h),e.rotateX(h,h,.5*-Math.PI),Ao(n,i,c,h,l,2),e.identity(h),e.rotateX(h,h,.5*Math.PI),Ao(n,i,c,h,l,3),e.identity(h),Ao(n,i,c,h,l,4),e.identity(h),e.rotateY(h,h,Math.PI),Ao(n,i,c,h,l,5),n.viewport.set([0,0,t.width,t.height]);}(t,o),o.markSkyboxValid(t)):"sky"===t.renderPass&&function(t,i,o,r,n){const s=t.context,a=s.gl,l=t.transform,c=t.useProgram("skybox");s.activeTexture.set(a.TEXTURE0),a.bindTexture(a.TEXTURE_CUBE_MAP,i.skyboxTexture);const h=((e,t,i,o,r)=>({u_matrix:e,u_sun_direction:t,u_cubemap:0,u_opacity:o,u_temporal_offset:r}))(l.skyboxMatrix,i.getCenter(t,!1),0,r,n);t.prepareDrawProgram(s,c),c.draw(s,a.TRIANGLES,o,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.backCW,h,"skybox",i.skyboxGeometry.vertexBuffer,i.skyboxGeometry.indexBuffer,i.skyboxGeometry.segment);}(t,o,c,s,h):"gradient"===l&&"sky"===t.renderPass&&function(t,i,o,r,n){const s=t.context,a=s.gl,l=t.transform,c=t.useProgram("skyboxGradient");i.skyboxGeometry||(i.skyboxGeometry=new Lo(s)),s.activeTexture.set(a.TEXTURE0);let h=i.colorRampTexture;h||(h=i.colorRampTexture=new e.Texture(s,i.colorRamp,a.RGBA)),h.bind(a.LINEAR,a.CLAMP_TO_EDGE);const u=((t,i,o,r,n)=>({u_matrix:t,u_color_ramp:0,u_center_direction:i,u_radius:e.degToRad(o),u_opacity:r,u_temporal_offset:n}))(l.skyboxMatrix,i.getCenter(t,!1),i.paint.get("sky-gradient-radius"),r,n);t.prepareDrawProgram(s,c),c.draw(s,a.TRIANGLES,o,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.backCW,u,"skyboxGradient",i.skyboxGeometry.vertexBuffer,i.skyboxGeometry.indexBuffer,i.skyboxGeometry.segment);}(t,o,c,s,h);},debug:function(e,t,i){for(let o=0;o<i.length;o++)Eo(e,t,i[o]);},custom:function(t,i,o,r){const n=t.context,s=o.implementation;if(!t.transform.projection.unsupportedLayers||!t.transform.projection.unsupportedLayers.includes("custom")||t.terrain&&(t.terrain.renderingToTexture||"offscreen"===t.renderPass)&&o.isLayerDraped()){if("offscreen"===t.renderPass){const i=s.prerender;if(i){if(t.setCustomLayerDefaults(),n.setColorMode(t.colorModeForRenderPass()),"globe"===t.transform.projection.name){const o=t.transform.pointMerc;i.call(s,n.gl,t.transform.customLayerMatrix(),t.transform.getProjection(),t.transform.globeToMercatorMatrix(),e.globeToMercatorTransition(t.transform.zoom),[o.x,o.y],t.transform.pixelsPerMeterRatio);}else i.call(s,n.gl,t.transform.customLayerMatrix());n.setDirty(),t.setBaseState();}}else if("translucent"===t.renderPass){if(t.terrain&&t.terrain.renderingToTexture){const i=s.renderToTile;if(i){const o=r[0].canonical,a=new e.MercatorCoordinate(o.x+r[0].wrap*(1<<o.z),o.y,o.z);n.setDepthMode(e.DepthMode.disabled),n.setStencilMode(e.StencilMode.disabled),n.setColorMode(t.colorModeForRenderPass()),t.setCustomLayerDefaults(),i.call(s,n.gl,a),n.setDirty(),t.setBaseState();}return}t.setCustomLayerDefaults(),n.setColorMode(t.colorModeForRenderPass()),n.setStencilMode(e.StencilMode.disabled);const i="3d"===s.renderingMode?new e.DepthMode(t.context.gl.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D):t.depthModeForSublayer(0,e.DepthMode.ReadOnly);if(n.setDepthMode(i),"globe"===t.transform.projection.name){const i=t.transform.pointMerc;s.render(n.gl,t.transform.customLayerMatrix(),t.transform.getProjection(),t.transform.globeToMercatorMatrix(),e.globeToMercatorTransition(t.transform.zoom),[i.x,i.y],t.transform.pixelsPerMeterRatio);}else s.render(n.gl,t.transform.customLayerMatrix());n.setDirty(),t.setBaseState(),n.bindFramebuffer.set(null);}}else e.warnOnce("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");}};class Bo{constructor(t,i,o=!1){this.context=new Ee(t,o),this.transform=i,this._tileTextures={},this.frameCopies=[],this.loadTimeStamps=[],this.setup(),this.numSublayers=e.SourceCache.maxUnderzooming+e.SourceCache.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.deferredRenderGpuTimeQueries=[],this.gpuTimers={},this.frameCounter=0,this._backgroundTiles={};}updateTerrain(e,t){const i=!!e&&!!e.terrain&&this.transform.projection.supportsTerrain;if(!(i||this._terrain&&this._terrain.enabled))return;this._terrain||(this._terrain=new Di(this,e));const o=this._terrain;this.transform.elevation=i?o:null,o.update(e,this.transform,t);}_updateFog(e){const t=e.fog;if(!t||"globe"===this.transform.projection.name||t.getOpacity(this.transform.pitch)<1||t.properties.get("horizon-blend")<.03)return void(this.transform.fogCullDistSq=null);const[i,o]=t.getFovAdjustedRange(this.transform._fov);if(i>o)return void(this.transform.fogCullDistSq=null);const r=i+.78*(o-i);this.transform.fogCullDistSq=r*r;}get terrain(){return this.transform._terrainEnabled()&&this._terrain&&this._terrain.enabled?this._terrain:null}resize(t,i){if(this.width=t*e.exported.devicePixelRatio,this.height=i*e.exported.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(const e of this.style.order)this.style._layers[e].resize();}setup(){const t=this.context,i=new e.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(e.EXTENT,0),i.emplaceBack(0,e.EXTENT),i.emplaceBack(e.EXTENT,e.EXTENT),this.tileExtentBuffer=t.createVertexBuffer(i,e.posAttributes.members),this.tileExtentSegments=e.SegmentVector.simpleSegment(0,0,4,2);const o=new e.StructArrayLayout2i4;o.emplaceBack(0,0),o.emplaceBack(e.EXTENT,0),o.emplaceBack(0,e.EXTENT),o.emplaceBack(e.EXTENT,e.EXTENT),this.debugBuffer=t.createVertexBuffer(o,e.posAttributes.members),this.debugSegments=e.SegmentVector.simpleSegment(0,0,4,5);const r=new e.StructArrayLayout2i4;r.emplaceBack(-1,-1),r.emplaceBack(1,-1),r.emplaceBack(-1,1),r.emplaceBack(1,1),this.viewportBuffer=t.createVertexBuffer(r,e.posAttributes.members),this.viewportSegments=e.SegmentVector.simpleSegment(0,0,4,2);const n=new e.StructArrayLayout4i8;n.emplaceBack(0,0,0,0),n.emplaceBack(e.EXTENT,0,e.EXTENT,0),n.emplaceBack(0,e.EXTENT,0,e.EXTENT),n.emplaceBack(e.EXTENT,e.EXTENT,e.EXTENT,e.EXTENT),this.mercatorBoundsBuffer=t.createVertexBuffer(n,e.boundsAttributes.members),this.mercatorBoundsSegments=e.SegmentVector.simpleSegment(0,0,4,2);const s=new e.StructArrayLayout3ui6;s.emplaceBack(0,1,2),s.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=t.createIndexBuffer(s);const a=new e.StructArrayLayout1ui2;for(const e of [0,1,3,2,0])a.emplaceBack(e);this.debugIndexBuffer=t.createIndexBuffer(a),this.emptyTexture=new e.Texture(t,new e.RGBAImage({width:1,height:1},Uint8Array.of(0,0,0,0)),t.gl.RGBA),this.identityMat=e.create();const l=this.context.gl;this.stencilClearMode=new e.StencilMode({func:l.ALWAYS,mask:0},0,255,l.ZERO,l.ZERO,l.ZERO),this.loadTimeStamps.push(e.window.performance.now()),this.atmosphereBuffer=new Ro(this.context);}getMercatorTileBoundsBuffers(){return {tileBoundsBuffer:this.mercatorBoundsBuffer,tileBoundsIndexBuffer:this.quadTriangleIndexBuffer,tileBoundsSegments:this.mercatorBoundsSegments}}getTileBoundsBuffers(e){return e._makeTileBoundsBuffers(this.context,this.transform.projection),e._tileBoundsBuffer?{tileBoundsBuffer:e._tileBoundsBuffer,tileBoundsIndexBuffer:e._tileBoundsIndexBuffer,tileBoundsSegments:e._tileBoundsSegments}:this.getMercatorTileBoundsBuffers()}clearStencil(){const t=this.context,i=t.gl;this.nextStencilID=1,this.currentStencilSource=void 0,this._tileClippingMaskIDs={},this.useProgram("clippingMask").draw(t,i.TRIANGLES,e.DepthMode.disabled,this.stencilClearMode,e.ColorMode.disabled,e.CullFaceMode.disabled,Ci(this.identityMat),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments);}resetStencilClippingMasks(){this.terrain||(this.currentStencilSource=void 0,this._tileClippingMaskIDs={});}_renderTileClippingMasks(t,i,o){if(!i||this.currentStencilSource===i.id||!t.isTileClipped()||!o||0===o.length)return;if(this._tileClippingMaskIDs&&!this.terrain){let e=!1;for(const t of o)if(void 0===this._tileClippingMaskIDs[t.key]){e=!0;break}if(!e)return}this.currentStencilSource=i.id;const r=this.context,n=r.gl;this.nextStencilID+o.length>256&&this.clearStencil(),r.setColorMode(e.ColorMode.disabled),r.setDepthMode(e.DepthMode.disabled);const s=this.useProgram("clippingMask");this._tileClippingMaskIDs={};for(const t of o){const o=i.getTile(t),a=this._tileClippingMaskIDs[t.key]=this.nextStencilID++,{tileBoundsBuffer:l,tileBoundsIndexBuffer:c,tileBoundsSegments:h}=this.getTileBoundsBuffers(o);s.draw(r,n.TRIANGLES,e.DepthMode.disabled,new e.StencilMode({func:n.ALWAYS,mask:0},a,255,n.KEEP,n.KEEP,n.REPLACE),e.ColorMode.disabled,e.CullFaceMode.disabled,Ci(t.projMatrix),"$clipping",l,c,h);}}stencilModeFor3D(){this.currentStencilSource=void 0,this.nextStencilID+1>256&&this.clearStencil();const t=this.nextStencilID++,i=this.context.gl;return new e.StencilMode({func:i.NOTEQUAL,mask:255},t,255,i.KEEP,i.KEEP,i.REPLACE)}stencilModeForClipping(t){if(this.terrain)return this.terrain.stencilModeForRTTOverlap(t);const i=this.context.gl;return new e.StencilMode({func:i.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,i.KEEP,i.KEEP,i.REPLACE)}stencilConfigForOverlap(t){const i=this.context.gl,o=t.sort(((e,t)=>t.overscaledZ-e.overscaledZ)),r=o[o.length-1].overscaledZ,n=o[0].overscaledZ-r+1;if(n>1){this.currentStencilSource=void 0,this.nextStencilID+n>256&&this.clearStencil();const t={};for(let o=0;o<n;o++)t[o+r]=new e.StencilMode({func:i.GEQUAL,mask:255},o+this.nextStencilID,255,i.KEEP,i.KEEP,i.REPLACE);return this.nextStencilID+=n,[t,o]}return [{[r]:e.StencilMode.disabled},o]}colorModeForRenderPass(){const t=this.context.gl;if(this._showOverdrawInspector){const i=1/8;return new e.ColorMode([t.CONSTANT_COLOR,t.ONE],new e.Color(i,i,i,0),[!0,!0,!0,!0])}return "opaque"===this.renderPass?e.ColorMode.unblended:e.ColorMode.alphaBlended}depthModeForSublayer(t,i,o){if(!this.opaquePassEnabledForLayer())return e.DepthMode.disabled;const r=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon;return new e.DepthMode(o||this.context.gl.LEQUAL,i,[r,r])}opaquePassEnabledForLayer(){return this.currentLayer<this.opaquePassCutoff}render(t,i){this.style=t,this.options=i,this.imageManager=t.imageManager,this.glyphManager=t.glyphManager,this.symbolFadeChange=t.placement.symbolFadeChange(e.exported.now()),this.imageManager.beginFrame();const o=this.style.order,r=this.style._sourceCaches;for(const e in r){const t=r[e];t.used&&t.prepare(this.context);}const n={},s={},a={};for(const e in r){const t=r[e];n[e]=t.getVisibleCoordinates(),s[e]=n[e].slice().reverse(),a[e]=t.getVisibleCoordinates(!0).reverse();}this.opaquePassCutoff=1/0;for(let e=0;e<o.length;e++)if(this.style._layers[o[e]].is3D()){this.opaquePassCutoff=e;break}if(this.terrain&&(this.terrain.updateTileBinding(a),this.opaquePassCutoff=0),"globe"!==this.transform.projection.name||this.globeSharedBuffers||(this.globeSharedBuffers=new e.GlobeSharedBuffers(this.context)),!e.isMapAuthenticated(this.context.gl))return;this.renderPass="offscreen";for(const e of o){const i=this.style._layers[e],o=t._getLayerSourceCache(i);if(!i.hasOffscreenPass()||i.isHidden(this.transform.zoom))continue;const r=o?s[o.id]:void 0;("custom"===i.type||i.isSky()||r&&r.length)&&this.renderLayer(this,o,i,r);}this.depthRangeFor3D=[0,1-(t.order.length+2)*this.numSublayers*this.depthEpsilon];const l=this.terrain;if(l&&(this.style.hasSymbolLayers()||this.style.hasCircleLayers())&&l.drawDepth(),this.context.bindFramebuffer.set(null),this.context.viewport.set([0,0,this.width,this.height]),this.context.clear({color:i.showOverdrawInspector?e.Color.black:e.Color.transparent,depth:1}),this.clearStencil(),this._showOverdrawInspector=i.showOverdrawInspector,this.renderPass="opaque",!this.terrain)for(this.currentLayer=o.length-1;this.currentLayer>=0;this.currentLayer--){const e=this.style._layers[o[this.currentLayer]],i=t._getLayerSourceCache(e);if(e.isSky())continue;const r=i?s[i.id]:void 0;this._renderTileClippingMasks(e,i,r),this.renderLayer(this,i,e,r);}if(this.style.fog&&this.transform.projection.supportsFog&&function(t,i){const o=t.context,r=o.gl,n=t.transform,s=new e.DepthMode(r.LEQUAL,e.DepthMode.ReadOnly,[0,1]),a=t.useProgram("globeAtmosphere",null,"globe"===n.projection.name?["PROJECTION_GLOBE_VIEW","FOG"]:["FOG"]),l=e.globeToMercatorTransition(n.zoom),c=i.properties.get("color").toArray01(),h=i.properties.get("high-color").toArray01(),u=i.properties.get("space-color").toArray01PremultipliedAlpha(),_=e.identity$1([]);e.rotateY$1(_,_,-e.degToRad(n._center.lng)),e.rotateX$1(_,_,e.degToRad(n._center.lat)),e.rotateZ$1(_,_,n.angle),e.rotateX$1(_,_,-n._pitch);const d=e.fromQuat(new Float32Array(16),_),p=e.mapValue(i.properties.get("star-intensity"),0,1,0,.25),m=5e-4,f=e.mapValue(i.properties.get("horizon-blend"),0,1,m,.25),g=e.globeUseCustomAntiAliasing(t,o,n)&&f===m?n.worldSize/(2*Math.PI*1.025)-1:n.globeRadius,v=t.frameCounter/1e3%1,x=e.length(n.globeCenterInViewSpace),y=Math.sqrt(Math.pow(x,2)-Math.pow(g,2)),b=Math.acos(y/x),w=((t,i,o,r,n,s,a,l,c,h,u,_,d,p)=>({u_frustum_tl:t,u_frustum_tr:i,u_frustum_br:o,u_frustum_bl:r,u_horizon:n,u_transition:s,u_fadeout_range:a,u_color:l,u_high_color:c,u_space_color:h,u_star_intensity:u,u_star_size:5*e.exported.devicePixelRatio,u_star_density:0,u_temporal_offset:_,u_horizon_angle:d,u_rotation_matrix:p}))(n.frustumCorners.TL,n.frustumCorners.TR,n.frustumCorners.BR,n.frustumCorners.BL,n.frustumCorners.horizon,l,f,c,h,u,p,v,b,d);t.prepareDrawProgram(o,a);const T=t.atmosphereBuffer;T&&a.draw(o,r.TRIANGLES,s,e.StencilMode.disabled,e.ColorMode.alphaBlended,e.CullFaceMode.backCW,w,"skybox",T.vertexBuffer,T.indexBuffer,T.segments);}(this,this.style.fog),this.renderPass="sky",(e.globeToMercatorTransition(this.transform.zoom)>0||"globe"!==this.transform.projection.name)&&this.transform.isHorizonVisible())for(this.currentLayer=0;this.currentLayer<o.length;this.currentLayer++){const e=this.style._layers[o[this.currentLayer]],i=t._getLayerSourceCache(e);e.isSky()&&this.renderLayer(this,i,e,i?s[i.id]:void 0);}for(this.renderPass="translucent",this.currentLayer=0;this.currentLayer<o.length;){const e=this.style._layers[o[this.currentLayer]],i=t._getLayerSourceCache(e);if(e.isSky()){++this.currentLayer;continue}if(this.terrain&&this.style.isLayerDraped(e)){if(e.isHidden(this.transform.zoom)){++this.currentLayer;continue}this.currentLayer=this.terrain.renderBatch(this.currentLayer);continue}const r=i?("symbol"===e.type?a:s)[i.id]:void 0;this._renderTileClippingMasks(e,i,i?n[i.id]:void 0),this.renderLayer(this,i,e,r),++this.currentLayer;}if(this.terrain&&this.terrain.postRender(),this.options.showTileBoundaries||this.options.showQueryGeometry||this.options.showTileAABBs){let i=null;e.values(this.style._layers).forEach((e=>{const o=t._getLayerSourceCache(e);o&&!e.isHidden(this.transform.zoom)&&(!i||i.getSource().maxzoom<o.getSource().maxzoom)&&(i=o);})),i&&this.options.showTileBoundaries&&Oo.debug(this,i,i.getVisibleCoordinates());}this.options.showPadding&&function(e){const t=e.transform.padding;Co(e,e.transform.height-(t.top||0),3,xo),Co(e,t.bottom||0,3,yo),Mo(e,t.left||0,3,bo),Mo(e,e.transform.width-(t.right||0),3,wo);const i=e.transform.centerPoint;!function(e,t,i,o){Io(e,t-1,i-10,2,20,o),Io(e,t-10,i-1,20,2,o);}(e,i.x,e.transform.height-i.y,To);}(this),this.context.setDefault(),this.frameCounter=(this.frameCounter+1)%Number.MAX_SAFE_INTEGER,this.tileLoaded&&this.options.speedIndexTiming&&(this.loadTimeStamps.push(e.window.performance.now()),this.saveCanvasCopy());}renderLayer(e,t,i,o){i.isHidden(this.transform.zoom)||("background"===i.type||"sky"===i.type||"custom"===i.type||o&&o.length)&&(this.id=i.id,this.gpuTimingStart(i),(!e.transform.projection.unsupportedLayers||!e.transform.projection.unsupportedLayers.includes(i.type)||e.terrain&&"custom"===i.type)&&Oo[i.type](e,t,i,o,this.style.placement.variableOffsets,this.options.isInitialLoad),this.gpuTimingEnd());}gpuTimingStart(e){if(!this.options.gpuTiming)return;const t=this.context.extTimerQuery;let i=this.gpuTimers[e.id];i||(i=this.gpuTimers[e.id]={calls:0,cpuTime:0,query:t.createQueryEXT()}),i.calls++,t.beginQueryEXT(t.TIME_ELAPSED_EXT,i.query);}gpuTimingDeferredRenderStart(){if(this.options.gpuTimingDeferredRender){const e=this.context.extTimerQuery,t=e.createQueryEXT();this.deferredRenderGpuTimeQueries.push(t),e.beginQueryEXT(e.TIME_ELAPSED_EXT,t);}}gpuTimingDeferredRenderEnd(){if(!this.options.gpuTimingDeferredRender)return;const e=this.context.extTimerQuery;e.endQueryEXT(e.TIME_ELAPSED_EXT);}gpuTimingEnd(){if(!this.options.gpuTiming)return;const e=this.context.extTimerQuery;e.endQueryEXT(e.TIME_ELAPSED_EXT);}collectGpuTimers(){const e=this.gpuTimers;return this.gpuTimers={},e}collectDeferredRenderGpuQueries(){const e=this.deferredRenderGpuTimeQueries;return this.deferredRenderGpuTimeQueries=[],e}queryGpuTimers(e){const t={};for(const i in e){const o=e[i],r=this.context.extTimerQuery,n=r.getQueryObjectEXT(o.query,r.QUERY_RESULT_EXT)/1e6;r.deleteQueryEXT(o.query),t[i]=n;}return t}queryGpuTimeDeferredRender(e){if(!this.options.gpuTimingDeferredRender)return 0;const t=this.context.extTimerQuery;let i=0;for(const o of e)i+=t.getQueryObjectEXT(o,t.QUERY_RESULT_EXT)/1e6,t.deleteQueryEXT(o);return i}translatePosMatrix(t,i,o,r,n){if(!o[0]&&!o[1])return t;const s=n?"map"===r?this.transform.angle:0:"viewport"===r?-this.transform.angle:0;if(s){const e=Math.sin(s),t=Math.cos(s);o=[o[0]*t-o[1]*e,o[0]*e+o[1]*t];}const a=[n?o[0]:D(i,o[0],this.transform.zoom),n?o[1]:D(i,o[1],this.transform.zoom),0],l=new Float32Array(16);return e.translate(l,t,a),l}saveTileTexture(e){const t=this._tileTextures[e.size[0]];t?t.push(e):this._tileTextures[e.size[0]]=[e];}getTileTexture(e){const t=this._tileTextures[e];return t&&t.length>0?t.pop():null}isPatternMissing(e){return null===e||void 0!==e&&!this.imageManager.getPattern(e.toString())}terrainRenderModeElevated(){return this.style&&!!this.style.getTerrain()&&!!this.terrain&&!this.terrain.renderingToTexture}currentGlobalDefines(){const e=this.terrain&&this.terrain.renderingToTexture,t=this.terrain&&0===this.terrain.exaggeration(),i=this.style&&this.style.fog,o=[];return this.terrainRenderModeElevated()&&o.push("TERRAIN"),"globe"===this.transform.projection.name&&o.push("GLOBE"),t&&o.push("ZERO_EXAGGERATION"),i&&!e&&0!==i.getOpacity(this.transform.pitch)&&o.push("FOG"),e&&o.push("RENDER_TO_TEXTURE"),this._showOverdrawInspector&&o.push("OVERDRAW_INSPECTOR"),o}useProgram(e,t,i){this.cache=this.cache||{};const o=i||[],r=this.currentGlobalDefines().concat(o),n=Li.cacheKey(ci[e],e,r,t);return this.cache[n]||(this.cache[n]=new Li(this.context,e,ci[e],t,so[e],r)),this.cache[n]}setCustomLayerDefaults(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.frontFace.setDefault(),this.context.cullFaceSide.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault();}setBaseState(){const e=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(e.FUNC_ADD);}initDebugOverlayCanvas(){null==this.debugOverlayCanvas&&(this.debugOverlayCanvas=e.window.document.createElement("canvas"),this.debugOverlayCanvas.width=512,this.debugOverlayCanvas.height=512,this.debugOverlayTexture=new e.Texture(this.context,this.debugOverlayCanvas,this.context.gl.RGBA));}destroy(){this._terrain&&this._terrain.destroy(),this.globeSharedBuffers&&this.globeSharedBuffers.destroy(),this.emptyTexture.destroy(),this.debugOverlayTexture&&this.debugOverlayTexture.destroy(),this.atmosphereBuffer&&this.atmosphereBuffer.destroy();}prepareDrawTile(){this.terrain&&this.terrain.prepareDrawTile();}prepareDrawProgram(t,i,o){if(this.terrain&&this.terrain.renderingToTexture)return;const r=this.style.fog;if(r){const n=r.getOpacity(this.transform.pitch),s=((t,i,o,r,n,s,a,l,c,h,u)=>{const _=t.transform,d=i.properties.get("color").toArray01();d[3]=r;const p=t.frameCounter/1e3%1;return {u_fog_matrix:o?_.calculateFogTileMatrix(o):t.identityMat,u_fog_range:i.getFovAdjustedRange(_._fov),u_fog_color:d,u_fog_horizon_blend:i.properties.get("horizon-blend"),u_fog_temporal_offset:p,u_frustum_tl:n,u_frustum_tr:s,u_frustum_br:a,u_frustum_bl:l,u_globe_pos:c,u_globe_radius:h,u_viewport:u,u_globe_transition:e.globeToMercatorTransition(_.zoom),u_is_globe:+("globe"===_.projection.name)}})(this,r,o,n,this.transform.frustumCorners.TL,this.transform.frustumCorners.TR,this.transform.frustumCorners.BR,this.transform.frustumCorners.BL,this.transform.globeCenterInViewSpace,this.transform.globeRadius,[this.transform.width*e.exported.devicePixelRatio,this.transform.height*e.exported.devicePixelRatio]);i.setFogUniformValues(t,s);}}setTileLoadedFlag(e){this.tileLoaded=e;}saveCanvasCopy(){const e=this.canvasCopy();e&&(this.frameCopies.push(e),this.tileLoaded=!1);}canvasCopy(){const e=this.context.gl,t=e.createTexture();return e.bindTexture(e.TEXTURE_2D,t),e.copyTexImage2D(e.TEXTURE_2D,0,e.RGBA,0,0,e.drawingBufferWidth,e.drawingBufferHeight,0),t}getCanvasCopiesAndTimestamps(){return {canvasCopies:this.frameCopies,timeStamps:this.loadTimeStamps}}averageElevationNeedsEasing(){if(!this.transform._elevation)return !1;const e=this.style&&this.style.fog;return !!e&&0!==e.getOpacity(this.transform.pitch)}getBackgroundTiles(){const t=this._backgroundTiles,i=this._backgroundTiles={},o=this.transform.coveringTiles({tileSize:512});for(const r of o)i[r.key]=t[r.key]||new e.Tile(r,512,this.transform.tileZoom,this);return i}clearBackgroundTiles(){this._backgroundTiles={};}}class ko{constructor(e=0,t=0,i=0,o=0){if(isNaN(e)||e<0||isNaN(t)||t<0||isNaN(i)||i<0||isNaN(o)||o<0)throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");this.top=e,this.bottom=t,this.left=i,this.right=o;}interpolate(t,i,o){return null!=i.top&&null!=t.top&&(this.top=e.number(t.top,i.top,o)),null!=i.bottom&&null!=t.bottom&&(this.bottom=e.number(t.bottom,i.bottom,o)),null!=i.left&&null!=t.left&&(this.left=e.number(t.left,i.left,o)),null!=i.right&&null!=t.right&&(this.right=e.number(t.right,i.right,o)),this}getCenter(t,i){const o=e.clamp((this.left+t-this.right)/2,0,t),r=e.clamp((this.top+i-this.bottom)/2,0,i);return new e.Point(o,r)}equals(e){return this.top===e.top&&this.bottom===e.bottom&&this.left===e.left&&this.right===e.right}clone(){return new ko(this.top,this.bottom,this.left,this.right)}toJSON(){return {top:this.top,bottom:this.bottom,left:this.left,right:this.right}}}function Fo(t,i){const o=e.getColumn(t,3);e.fromQuat(t,i),e.setColumn(t,3,o);}function Uo(t,i){const o=e.identity$1([]);return e.rotateZ$1(o,o,-i),e.rotateX$1(o,o,-t),o}function No(t,i){const o=[t[0],t[1],0],r=[i[0],i[1],0];if(e.length(o)>=1e-15){const t=e.normalize([],o);e.scale$2(r,t,e.dot(r,t)),i[0]=r[0],i[1]=r[1];}const n=e.cross([],i,t);if(e.len(n)<1e-15)return null;const s=Math.atan2(-n[1],n[0]);return Uo(Math.atan2(Math.sqrt(t[0]*t[0]+t[1]*t[1]),-t[2]),s)}class jo{constructor(e,t){this.position=e,this.orientation=t;}get position(){return this._position}set position(t){if(t){const i=t instanceof e.MercatorCoordinate?t:new e.MercatorCoordinate(t[0],t[1],t[2]);this._renderWorldCopies&&(i.x=e.wrap(i.x,0,1)),this._position=i;}else this._position=null;}lookAtPoint(t,i){if(this.orientation=null,!this.position)return;const o=this.position,r=this._elevation?this._elevation.getAtPointOrZero(e.MercatorCoordinate.fromLngLat(t)):0,n=e.MercatorCoordinate.fromLngLat(t,r),s=[n.x-o.x,n.y-o.y,n.z-o.z];i||(i=[0,0,1]),i[2]=Math.abs(i[2]),this.orientation=No(s,i);}setPitchBearing(t,i){this.orientation=Uo(e.degToRad(t),e.degToRad(-i));}}class Go{constructor(t,i){this._transform=e.identity([]),this.orientation=i,this.position=t;}get mercatorPosition(){const t=this.position;return new e.MercatorCoordinate(t[0],t[1],t[2])}get position(){const t=e.getColumn(this._transform,3);return [t[0],t[1],t[2]]}set position(t){var i;t&&e.setColumn(this._transform,3,[(i=t)[0],i[1],i[2],1]);}get orientation(){return this._orientation}set orientation(t){this._orientation=t||e.identity$1([]),t&&Fo(this._transform,this._orientation);}getPitchBearing(){const e=this.forward(),t=this.right();return {bearing:Math.atan2(-t[1],t[0]),pitch:Math.atan2(Math.sqrt(e[0]*e[0]+e[1]*e[1]),-e[2])}}setPitchBearing(e,t){this._orientation=Uo(e,t),Fo(this._transform,this._orientation);}forward(){const t=e.getColumn(this._transform,2);return [-t[0],-t[1],-t[2]]}up(){const t=e.getColumn(this._transform,1);return [-t[0],-t[1],-t[2]]}right(){const t=e.getColumn(this._transform,0);return [t[0],t[1],t[2]]}getCameraToWorld(t,i){const o=new Float64Array(16);return e.invert(o,this.getWorldToCamera(t,i)),o}getWorldToCameraPosition(t,i,o){const r=this.position;e.scale$2(r,r,-t);const n=new Float64Array(16);return e.fromScaling(n,[o,o,o]),e.translate(n,n,r),n[10]*=i,n}getWorldToCamera(t,i){const o=new Float64Array(16),r=new Float64Array(4),n=this.position;return e.conjugate(r,this._orientation),e.scale$2(n,n,-t),e.fromQuat(o,r),e.translate(o,o,n),o[1]*=-1,o[5]*=-1,o[9]*=-1,o[13]*=-1,o[8]*=i,o[9]*=i,o[10]*=i,o[11]*=i,o}getCameraToClipPerspective(t,i,o,r){const n=new Float64Array(16);return e.perspective(n,t,i,o,r),n}getDistanceToElevation(t,i=!1){const o=0===t?0:e.mercatorZfromAltitude(t,i?e.latFromMercatorY(this.position[1]):this.position[1]),r=this.forward();return (o-this.position[2])/r[2]}clone(){return new Go([...this.position],[...this.orientation])}}function Zo(t,i){const o=Wo(t.projection,t.zoom,t.width,t.height),r=function(t,i,o,r,n){const s=new e.LngLat(o.lng-180*Xo,o.lat),a=new e.LngLat(o.lng+180*Xo,o.lat),l=t.project(s.lng,s.lat),c=t.project(a.lng,a.lat),h=-Math.atan2(c.y-l.y,c.x-l.x),u=e.MercatorCoordinate.fromLngLat(o);u.y=e.clamp(u.y,-1+Xo,1-Xo);const _=u.toLngLat(),d=t.project(_.lng,_.lat),p=e.MercatorCoordinate.fromLngLat(_);p.x+=Xo;const m=p.toLngLat(),f=t.project(m.lng,m.lat),g=$o(f.x-d.x,f.y-d.y,h),v=e.MercatorCoordinate.fromLngLat(_);v.y+=Xo;const x=v.toLngLat(),y=t.project(x.lng,x.lat),b=$o(y.x-d.x,y.y-d.y,h),w=Math.abs(g.x)/Math.abs(b.y),T=e.identity([]);e.rotateZ(T,T,-h*(1-(n?0:r)));const E=e.identity([]);return e.scale(E,E,[1,1-(1-w)*r,1]),E[4]=-b.x/b.y*r,e.rotateZ(E,E,h),e.multiply(E,T,E),E}(t.projection,0,t.center,o,i),n=Vo(t);return e.scale(r,r,[n,n,1]),r}function Vo(t){const i=t.projection,o=Wo(t.projection,t.zoom,t.width,t.height),r=qo(i,t.center),n=qo(i,e.LngLat.convert(i.center));return Math.pow(2,r*o+(1-o)*n)}function Wo(t,i,o,r,n=1/0){const s=t.range;if(!s)return 0;const a=Math.min(n,Math.max(o,r)),l=Math.log(a/1024)/Math.LN2;return e.smoothstep(s[0]+l,s[1]+l,i)}const Xo=1/4e4;function qo(t,i){const o=e.clamp(i.lat,-e.MAX_MERCATOR_LATITUDE,e.MAX_MERCATOR_LATITUDE),r=new e.LngLat(i.lng-180*Xo,o),n=new e.LngLat(i.lng+180*Xo,o),s=t.project(r.lng,o),a=t.project(n.lng,o),l=e.MercatorCoordinate.fromLngLat(r),c=e.MercatorCoordinate.fromLngLat(n),h=a.x-s.x,u=a.y-s.y,_=c.x-l.x,d=c.y-l.y,p=Math.sqrt((_*_+d*d)/(h*h+u*u));return Math.log(p)/Math.LN2}function $o(e,t,i){const o=Math.cos(i),r=Math.sin(i);return {x:e*o-t*r,y:e*r+t*o}}class Ho{constructor(t,i,o,r,n,s,a){this.tileSize=512,this._renderWorldCopies=void 0===n||n,this._minZoom=t||0,this._maxZoom=i||22,this._minPitch=null==o?0:o,this._maxPitch=null==r?60:r,this.setProjection(s),this.setMaxBounds(a),this.width=0,this.height=0,this._center=new e.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._nearZ=0,this._farZ=0,this._unmodified=!0,this._edgeInsets=new ko,this._projMatrixCache={},this._alignedProjMatrixCache={},this._fogTileMatrixCache={},this._distanceTileDataCache={},this._camera=new Go,this._centerAltitude=0,this._averageElevation=0,this.cameraElevationReference="ground",this._pixelsPerMercatorPixel=1,this.globeRadius=0,this.globeCenterInViewSpace=[0,0,0],this._horizonShift=.1;}clone(){const e=new Ho(this._minZoom,this._maxZoom,this._minPitch,this.maxPitch,this._renderWorldCopies,this.getProjection());return e._elevation=this._elevation,e._centerAltitude=this._centerAltitude,e._centerAltitudeValidForExaggeration=this._centerAltitudeValidForExaggeration,e.tileSize=this.tileSize,e.mercatorFromTransition=this.mercatorFromTransition,e.width=this.width,e.height=this.height,e.cameraElevationReference=this.cameraElevationReference,e._center=this._center,e._setZoom(this.zoom),e._seaLevelZoom=this._seaLevelZoom,e.angle=this.angle,e._fov=this._fov,e._pitch=this._pitch,e._nearZ=this._nearZ,e._farZ=this._farZ,e._averageElevation=this._averageElevation,e._unmodified=this._unmodified,e._edgeInsets=this._edgeInsets.clone(),e._camera=this._camera.clone(),e._calcMatrices(),e.freezeTileCoverage=this.freezeTileCoverage,e.frustumCorners=this.frustumCorners,e}get elevation(){return this._elevation}set elevation(e){this._elevation!==e&&(this._elevation=e,this._updateCameraOnTerrain(),this._calcMatrices());}updateElevation(e,t=!1){const i=this._elevation&&this._elevation.exaggeration()!==this._centerAltitudeValidForExaggeration;(null==this._seaLevelZoom||i)&&this._updateCameraOnTerrain(),(e||i)&&this._constrainCamera(t),this._calcMatrices();}getProjection(){return e.pick(this.projection,["name","center","parallels"])}setProjection(i){this.projectionOptions=i||{name:"mercator"};const o=this.projection?this.getProjection():void 0;this.projection=e.getProjection(this.projectionOptions);const r=!t(o,this.getProjection());return r&&this._calcMatrices(),this.mercatorFromTransition=!1,r}setMercatorFromTransition(){const t=this.projection.name;this.mercatorFromTransition=!0,this.projectionOptions={name:"mercator"},this.projection=e.getProjection({name:"mercator"});const i=t!==this.projection.name;return i&&this._calcMatrices(),i}get minZoom(){return this._minZoom}set minZoom(e){this._minZoom!==e&&(this._minZoom=e,this.zoom=Math.max(this.zoom,e));}get maxZoom(){return this._maxZoom}set maxZoom(e){this._maxZoom!==e&&(this._maxZoom=e,this.zoom=Math.min(this.zoom,e));}get minPitch(){return this._minPitch}set minPitch(e){this._minPitch!==e&&(this._minPitch=e,this.pitch=Math.max(this.pitch,e));}get maxPitch(){return this._maxPitch}set maxPitch(e){this._maxPitch!==e&&(this._maxPitch=e,this.pitch=Math.min(this.pitch,e));}get renderWorldCopies(){return this._renderWorldCopies&&!0===this.projection.supportsWorldCopies}set renderWorldCopies(e){void 0===e?e=!0:null===e&&(e=!1),this._renderWorldCopies=e;}get worldSize(){return this.tileSize*this.scale}get cameraWorldSizeForFog(){const e=Math.max(this._camera.getDistanceToElevation(this._averageElevation),Number.EPSILON);return this._worldSizeFromZoom(this._zoomFromMercatorZ(e))}get cameraWorldSize(){const e=Math.max(this._camera.getDistanceToElevation(this._averageElevation,!0),Number.EPSILON);return this._worldSizeFromZoom(this._zoomFromMercatorZ(e))}get pixelsPerMeter(){return this.projection.pixelsPerMeter(this.center.lat,this.worldSize)}get cameraPixelsPerMeter(){return e.mercatorZfromAltitude(this.center.lat,this.cameraWorldSizeForFog)}get centerOffset(){return this.centerPoint._sub(this.size._div(2))}get size(){return new e.Point(this.width,this.height)}get bearing(){return e.wrap(this.rotation,-180,180)}set bearing(e){this.rotation=e;}get rotation(){return -this.angle/Math.PI*180}set rotation(t){const i=-t*Math.PI/180;var o;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=(o=new e.ARRAY_TYPE(4),e.ARRAY_TYPE!=Float32Array&&(o[1]=0,o[2]=0),o[0]=1,o[3]=1,o),function(e,t,i){var o=t[0],r=t[1],n=t[2],s=t[3],a=Math.sin(i),l=Math.cos(i);e[0]=o*l+n*a,e[1]=r*l+s*a,e[2]=o*-a+n*l,e[3]=r*-a+s*l;}(this.rotationMatrix,this.rotationMatrix,this.angle));}get pitch(){return this._pitch/Math.PI*180}set pitch(t){const i=e.clamp(t,this.minPitch,this.maxPitch)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());}get aspect(){return this.width/this.height}get fov(){return this._fov/Math.PI*180}get fovX(){return this._fov}get fovY(){const e=1/Math.tan(.5*this.fovX);return 2*Math.atan(1/this.aspect/e)}set fov(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=e.degToRad(t),this._calcMatrices());}get averageElevation(){return this._averageElevation}set averageElevation(e){this._averageElevation=e,this._calcFogMatrices(),this._distanceTileDataCache={};}get zoom(){return this._zoom}set zoom(e){const t=Math.min(Math.max(e,this.minZoom),this.maxZoom);this._zoom!==t&&(this._unmodified=!1,this._setZoom(t),this._updateSeaLevelZoom(),this._constrain(),this._calcMatrices());}_setZoom(e){this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom;}_updateCameraOnTerrain(){if(!this._elevation||!this._elevation.isDataAvailableAtPoint(this.locationCoordinate(this.center)))return this._centerAltitude=0,this._seaLevelZoom=null,void(this._centerAltitudeValidForExaggeration=void 0);const e=this._elevation;this._centerAltitude=e.getAtPointOrZero(this.locationCoordinate(this.center)),this._centerAltitudeValidForExaggeration=e.exaggeration(),this._updateSeaLevelZoom();}_updateSeaLevelZoom(){void 0!==this._centerAltitudeValidForExaggeration&&(this._seaLevelZoom=this._zoomFromMercatorZ((this.pixelsPerMeter*this._centerAltitude+this.cameraToCenterDistance)/this.worldSize));}sampleAverageElevation(){if(!this._elevation)return 0;const t=this._elevation,i=[[.5,.2],[.3,.5],[.5,.5],[.7,.5],[.5,.8]],o=this.horizonLineFromTop();let r=0,n=0;for(let s=0;s<i.length;s++){const a=new e.Point(i[s][0]*this.width,o+i[s][1]*(this.height-o)),l=t.pointCoordinate(a);if(!l)continue;const c=1/Math.hypot(l[0]-this._camera.position[0],l[1]-this._camera.position[1]);r+=l[3]*c,n+=c;}return 0===n?NaN:r/n}get center(){return this._center}set center(e){e.lat===this._center.lat&&e.lng===this._center.lng||(this._unmodified=!1,this._center=e,this._terrainEnabled()&&("ground"===this.cameraElevationReference?this._updateCameraOnTerrain():this._updateZoomFromElevation()),this._constrain(),this._calcMatrices());}_updateZoomFromElevation(){if(null==this._seaLevelZoom||!this._elevation)return;const e=this._seaLevelZoom,t=this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)),i=this.pixelsPerMeter/this.worldSize*t,o=this._mercatorZfromZoom(e),r=this._mercatorZfromZoom(this._maxZoom),n=Math.max(o-i,r);this._setZoom(this._zoomFromMercatorZ(n));}get padding(){return this._edgeInsets.toJSON()}set padding(e){this._edgeInsets.equals(e)||(this._unmodified=!1,this._edgeInsets.interpolate(this._edgeInsets,e,1),this._calcMatrices());}computeZoomRelativeTo(t){const i=this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint,t.toAltitude()));let o;o=t.z<this._camera.position[2]?[i.x,i.y,i.z]:[t.x,t.y,t.z];const r=e.length(e.sub([],this._camera.position,o));return e.clamp(this._zoomFromMercatorZ(r),this._minZoom,this._maxZoom)}setFreeCameraOptions(t){if(!this.height)return;if(!t.position&&!t.orientation)return;this._updateCameraState();let i=!1;if(t.orientation&&!e.exactEquals(t.orientation,this._camera.orientation)&&(i=this._setCameraOrientation(t.orientation)),t.position){const o=[t.position.x,t.position.y,t.position.z];e.exactEquals$1(o,this._camera.position)||(this._setCameraPosition(o),i=!0);}i&&(this._updateStateFromCamera(),this.recenterOnTerrain());}getFreeCameraOptions(){this._updateCameraState();const t=this._camera.position,i=new jo;return i.position=new e.MercatorCoordinate(t[0],t[1],t[2]),i.orientation=this._camera.orientation,i._elevation=this.elevation,i._renderWorldCopies=this.renderWorldCopies,i}_setCameraOrientation(t){if(!e.length$1(t))return !1;e.normalize$1(t,t);const i=e.transformQuat([],[0,0,-1],t),o=e.transformQuat([],[0,-1,0],t);if(o[2]<0)return !1;const r=No(i,o);return !!r&&(this._camera.orientation=r,!0)}_setCameraPosition(t){const i=this.zoomScale(this.minZoom)*this.tileSize,o=this.zoomScale(this.maxZoom)*this.tileSize,r=this.cameraToCenterDistance;t[2]=e.clamp(t[2],r/o,r/i),this._camera.position=t;}get centerPoint(){return this._edgeInsets.getCenter(this.width,this.height)}get fovAboveCenter(){return this._fov*(.5+this.centerOffset.y/this.height)}isPaddingEqual(e){return this._edgeInsets.equals(e)}interpolatePadding(e,t,i){this._unmodified=!1,this._edgeInsets.interpolate(e,t,i),this._constrain(),this._calcMatrices();}coveringZoomLevel(e){const t=(e.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/e.tileSize));return Math.max(0,t)}getVisibleUnwrappedCoordinates(t){const i=[new e.UnwrappedTileID(0,t)];if(this.renderWorldCopies){const o=this.pointCoordinate(new e.Point(0,0)),r=this.pointCoordinate(new e.Point(this.width,0)),n=this.pointCoordinate(new e.Point(this.width,this.height)),s=this.pointCoordinate(new e.Point(0,this.height)),a=Math.floor(Math.min(o.x,r.x,n.x,s.x)),l=Math.floor(Math.max(o.x,r.x,n.x,s.x)),c=1;for(let o=a-c;o<=l+c;o++)0!==o&&i.push(new e.UnwrappedTileID(o,t));}return i}coveringTiles(t){let i=this.coveringZoomLevel(t);const o=i,r=this.elevation&&!t.isTerrainDEM,n="mercator"===this.projection.name;if(void 0!==t.minzoom&&i<t.minzoom)return [];void 0!==t.maxzoom&&i>t.maxzoom&&(i=t.maxzoom);const s=this.locationCoordinate(this.center),a=this.center.lat,l=1<<i,c=[l*s.x,l*s.y,0],h="globe"===this.projection.name,u=!h,_=e.Frustum.fromInvProjectionMatrix(this.invProjMatrix,this.worldSize,i,u),d=h?this._camera.mercatorPosition:this.pointCoordinate(this.getCameraPoint()),p=l*e.mercatorZfromAltitude(1,this.center.lat),m=this._camera.position[2]/e.mercatorZfromAltitude(1,this.center.lat),f=[l*d.x,l*d.y,m*(u?1:p)],g=this.cameraToCenterDistance/t.tileSize*(t.roundZoom?1:.502),v=this.pitch<=60&&this._edgeInsets.top<=this._edgeInsets.bottom&&!this._elevation&&!this.projection.isReprojectedInTileSpace?i:0,x=t.isTerrainDEM&&this._elevation?1e4*this._elevation.exaggeration():this._centerAltitude,y=t.isTerrainDEM?-x:this._elevation?this._elevation.getMinElevationBelowMSL():0,b=this.projection.isReprojectedInTileSpace?Vo(this):1,w=t=>{const i=1/4e4,o=new e.MercatorCoordinate(t.x+i,t.y,t.z),r=new e.MercatorCoordinate(t.x,t.y+i,t.z),n=t.toLngLat(),s=o.toLngLat(),a=r.toLngLat(),l=this.locationCoordinate(n),c=this.locationCoordinate(s),h=this.locationCoordinate(a),u=Math.hypot(c.x-l.x,c.y-l.y),_=Math.hypot(h.x-l.x,h.y-l.y);return Math.sqrt(u*_)*b/i},T=t=>{const i=x,o=y;return {aabb:e.tileAABB(this,l,0,0,0,t,o,i,this.projection),zoom:0,x:0,y:0,minZ:o,maxZ:i,wrap:t,fullyVisible:!1}},E=[];let C=[];const M=i,I=t.reparseOverscaled?o:i,P=e=>e*e,S=P((m-this._centerAltitude)*p),D=e=>{if(!this._elevation||!e.tileID||!n)return;const t=this._elevation.getMinMaxForTile(e.tileID),i=e.aabb;t?(i.min[2]=t.min,i.max[2]=t.max,i.center[2]=(i.min[2]+i.max[2])/2):(e.shouldSplit=L(e),e.shouldSplit||(i.min[2]=i.max[2]=i.center[2]=this._centerAltitude));},L=t=>{if(t.zoom<v)return !0;if(t.zoom===M)return !1;if(null!=t.shouldSplit)return t.shouldSplit;const i=t.aabb.distanceX(f),n=t.aabb.distanceY(f);let s=S,l=1;if(h){s=P(t.aabb.distanceZ(f));const i=Math.pow(2,t.zoom),o=e.latFromMercatorY((t.y+1)/i),r=e.latFromMercatorY(t.y/i),n=Math.min(Math.max(a,o),r),c=e.circumferenceAtLatitude(n)/e.circumferenceAtLatitude(a);if(l=n===a?1/Math.max(1,this._mercatorScaleRatio-.3):Math.min(1,c/this._mercatorScaleRatio),this.zoom<=e.GLOBE_ZOOM_THRESHOLD_MIN&&t.zoom===M-1&&c>=.9)return !0}else if(r&&(s=P(t.aabb.distanceZ(f)*p)),this.projection.isReprojectedInTileSpace&&o<=5){const i=Math.pow(2,t.zoom),o=w(new e.MercatorCoordinate((t.x+.5)/i,(t.y+.5)/i));l=o>.85?1:o;}const c=i*i+n*n+s,u=P((1<<M-t.zoom)*g*l*((e,t)=>{if(t*P(.707)<e)return 1;const i=Math.sqrt(t/e);return i/(1.4144271570014144+(Math.pow(1.1,i-1.4144271570014144+1)-1)/(1.1-1)-1)})(Math.max(s,S),c));return c<u};if(this.renderWorldCopies)for(let e=1;e<=3;e++)E.push(T(-e)),E.push(T(e));for(E.push(T(0));E.length>0;){const o=E.pop(),s=o.x,a=o.y;let u=o.fullyVisible;if(!u){const e=o.aabb.intersects(_);if(0===e)continue;u=2===e;}if(o.zoom!==M&&L(o))for(let t=0;t<4;t++){const i=(s<<1)+t%2,c=(a<<1)+(t>>1),_={aabb:n?o.aabb.quadrant(t):e.tileAABB(this,l,o.zoom+1,i,c,o.wrap,o.minZ,o.maxZ,this.projection),zoom:o.zoom+1,x:i,y:c,wrap:o.wrap,fullyVisible:u,tileID:void 0,shouldSplit:void 0,minZ:o.minZ,maxZ:o.maxZ};r&&!h&&(_.tileID=new e.OverscaledTileID(o.zoom+1===M?I:o.zoom+1,o.wrap,o.zoom+1,i,c),D(_)),E.push(_);}else {const r=o.zoom===M?I:o.zoom;if(t.minzoom&&t.minzoom>r)continue;const n=c[0]-(.5+s+(o.wrap<<o.zoom))*(1<<i-o.zoom),l=c[1]-.5-a,h=o.tileID?o.tileID:new e.OverscaledTileID(r,o.wrap,o.zoom,s,a);C.push({tileID:h,distanceSq:n*n+l*l});}}if(this.fogCullDistSq){const i=this.fogCullDistSq,o=this.horizonLineFromTop();C=C.filter((r=>{const n=[0,0,0,1],s=[e.EXTENT,e.EXTENT,0,1],a=this.calculateFogTileMatrix(r.tileID.toUnwrapped());e.transformMat4$1(n,n,a),e.transformMat4$1(s,s,a);const l=e.getAABBPointSquareDist(n,s);if(0===l)return !0;let c=!1;const h=this._elevation;if(h&&l>i&&0!==o){const i=this.calculateProjMatrix(r.tileID.toUnwrapped());let n;t.isTerrainDEM||(n=h.getMinMaxForTile(r.tileID)),n||(n={min:y,max:x});const s=e.furthestTileCorner(this.rotation),a=[s[0]*e.EXTENT,s[1]*e.EXTENT,n.max];e.transformMat4(a,a,i),c=(1-a[1])*this.height*.5<o;}return l<i||c}));}return C.sort(((e,t)=>e.distanceSq-t.distanceSq)).map((e=>e.tileID))}resize(e,t){this.width=e,this.height=t,this.pixelsToGLUnits=[2/e,-2/t],this._constrain(),this._calcMatrices();}get unmodified(){return this._unmodified}zoomScale(e){return Math.pow(2,e)}scaleZoom(e){return Math.log(e)/Math.LN2}project(t){const i=e.clamp(t.lat,-e.MAX_MERCATOR_LATITUDE,e.MAX_MERCATOR_LATITUDE),o=this.projection.project(t.lng,i);return new e.Point(o.x*this.worldSize,o.y*this.worldSize)}unproject(e){return this.projection.unproject(e.x/this.worldSize,e.y/this.worldSize)}get point(){return this.project(this.center)}get pointMerc(){return this.point._div(this.worldSize)}get pixelsPerMeterRatio(){return this.pixelsPerMeter/e.mercatorZfromAltitude(1,this.center.lat)/this.worldSize}setLocationAtPoint(t,i){let o,r;const n=this.centerPoint;if("globe"===this.projection.name){const e=this.worldSize;o=(i.x-n.x)/e,r=(i.y-n.y)/e;}else {const e=this.pointCoordinate(i),t=this.pointCoordinate(n);o=e.x-t.x,r=e.y-t.y;}const s=this.locationCoordinate(t);this.setLocation(new e.MercatorCoordinate(s.x-o,s.y-r));}setLocation(e){this.center=this.coordinateLocation(e),this.projection.wrap&&(this.center=this.center.wrap());}locationPoint(e){return this.projection.locationPoint(this,e)}locationPoint3D(e){return this.projection.locationPoint(this,e,!0)}pointLocation(e){return this.coordinateLocation(this.pointCoordinate(e))}pointLocation3D(e){return this.coordinateLocation(this.pointCoordinate3D(e))}locationCoordinate(t,i){const o=i?e.mercatorZfromAltitude(i,t.lat):void 0,r=this.projection.project(t.lng,t.lat);return new e.MercatorCoordinate(r.x,r.y,o)}coordinateLocation(e){return this.projection.unproject(e.x,e.y)}pointRayIntersection(t,i){const o=null!=i?i:this._centerAltitude,r=[t.x,t.y,0,1],n=[t.x,t.y,1,1];e.transformMat4$1(r,r,this.pixelMatrixInverse),e.transformMat4$1(n,n,this.pixelMatrixInverse);const s=n[3];e.scale$1(r,r,1/r[3]),e.scale$1(n,n,1/s);const a=r[2],l=n[2];return {p0:r,p1:n,t:a===l?0:(o-a)/(l-a)}}screenPointToMercatorRay(t){const i=[t.x,t.y,0,1],o=[t.x,t.y,1,1];return e.transformMat4$1(i,i,this.pixelMatrixInverse),e.transformMat4$1(o,o,this.pixelMatrixInverse),e.scale$1(i,i,1/i[3]),e.scale$1(o,o,1/o[3]),i[2]=e.mercatorZfromAltitude(i[2],this._center.lat)*this.worldSize,o[2]=e.mercatorZfromAltitude(o[2],this._center.lat)*this.worldSize,e.scale$1(i,i,1/this.worldSize),e.scale$1(o,o,1/this.worldSize),new e.Ray([i[0],i[1],i[2]],e.normalize([],e.sub([],o,i)))}rayIntersectionCoordinate(t){const{p0:i,p1:o,t:r}=t,n=e.mercatorZfromAltitude(i[2],this._center.lat),s=e.mercatorZfromAltitude(o[2],this._center.lat);return new e.MercatorCoordinate(e.number(i[0],o[0],r)/this.worldSize,e.number(i[1],o[1],r)/this.worldSize,e.number(n,s,r))}pointCoordinate(e,t=this._centerAltitude){return this.projection.pointCoordinate(this,e.x,e.y,t)}pointCoordinate3D(t){if(!this.elevation)return this.pointCoordinate(t);let i=this.projection.pointCoordinate3D(this,t.x,t.y);if(i)return new e.MercatorCoordinate(i[0],i[1],i[2]);let o=0,r=this.horizonLineFromTop();if(t.y>r)return this.pointCoordinate(t);const n=.02*r,s=t.clone();for(let t=0;t<10&&r-o>n;t++){s.y=e.number(o,r,.66);const t=this.projection.pointCoordinate3D(this,s.x,s.y);t?(r=s.y,i=t):o=s.y;}return i?new e.MercatorCoordinate(i[0],i[1],i[2]):this.pointCoordinate(t)}isPointAboveHorizon(e){return this.projection.isPointAboveHorizon(this,e)}isPointOnSurface(t){if(t.y<0||t.y>this.height||t.x<0||t.x>this.width)return !1;if(this.elevation||this.zoom>=e.GLOBE_ZOOM_THRESHOLD_MAX)return !this.isPointAboveHorizon(t);const i=this.pointCoordinate(t);return i.y>=0&&i.y<=1}_coordinatePoint(t,i){const o=i&&this.elevation?this.elevation.getAtPointOrZero(t,this._centerAltitude):this._centerAltitude,r=[t.x*this.worldSize,t.y*this.worldSize,o+t.toAltitude(),1];return e.transformMat4$1(r,r,this.pixelMatrix),r[3]>0?new e.Point(r[0]/r[3],r[1]/r[3]):new e.Point(Number.MAX_VALUE,Number.MAX_VALUE)}_getBoundsNonRectangular(){const{top:t,left:i}=this._edgeInsets,o=this.height-this._edgeInsets.bottom,r=this.width-this._edgeInsets.right,n=this.pointLocation3D(new e.Point(i,t)),s=this.pointLocation3D(new e.Point(r,t)),a=this.pointLocation3D(new e.Point(r,o)),l=this.pointLocation3D(new e.Point(i,o));let c=Math.min(n.lng,s.lng,a.lng,l.lng),h=Math.max(n.lng,s.lng,a.lng,l.lng),u=Math.min(n.lat,s.lat,a.lat,l.lat),_=Math.max(n.lat,s.lat,a.lat,l.lat);const d=Math.pow(2,-this.zoom)/16*270,p="globe"===this.projection.name?1:4,m=(t,i,o,r,n)=>{const s=(t+o)/2,a=(i+r)/2,l=new e.Point(s,a),{lng:f,lat:g}=this.pointLocation3D(l),v=Math.max(0,c-f,u-g,f-h,g-_);c=Math.min(c,f),h=Math.max(h,f),u=Math.min(u,g),_=Math.max(_,g),(n<p||v>d)&&(m(t,i,s,a,n+1),m(s,a,o,r,n+1));};if(m(i,t,r,t,1),m(r,t,r,o,1),m(r,o,i,o,1),m(i,o,i,t,1),"globe"===this.projection.name){const[t,i]=e.polesInViewport(this);t?(_=90,h=180,c=-180):i&&(u=-90,h=180,c=-180);}return new e.LngLatBounds(new e.LngLat(c,u),new e.LngLat(h,_))}_getBoundsRectangular(t,i){const{top:o,left:r}=this._edgeInsets,n=this.height-this._edgeInsets.bottom,s=this.width-this._edgeInsets.right,a=new e.Point(r,o),l=new e.Point(s,o),c=new e.Point(s,n),h=new e.Point(r,n);let u=this.pointCoordinate(a,t),_=this.pointCoordinate(l,t);const d=this.pointCoordinate(c,i),p=this.pointCoordinate(h,i),m=(e,t)=>(t.y-e.y)/(t.x-e.x);return u.y>1&&_.y>=0?u=new e.MercatorCoordinate((1-p.y)/m(p,u)+p.x,1):u.y<0&&_.y<=1&&(u=new e.MercatorCoordinate(-p.y/m(p,u)+p.x,0)),_.y>1&&u.y>=0?_=new e.MercatorCoordinate((1-d.y)/m(d,_)+d.x,1):_.y<0&&u.y<=1&&(_=new e.MercatorCoordinate(-d.y/m(d,_)+d.x,0)),(new e.LngLatBounds).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(_)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(d))}_getBoundsRectangularTerrain(){const e=this.elevation;if(!e.visibleDemTiles.length||e.isUsingMockSource())return this._getBoundsRectangular(0,0);const t=e.visibleDemTiles.reduce(((e,t)=>{if(t.dem){const i=t.dem.tree;e.min=Math.min(e.min,i.minimums[0]),e.max=Math.max(e.max,i.maximums[0]);}return e}),{min:Number.MAX_VALUE,max:0});return this._getBoundsRectangular(t.min*e.exaggeration(),t.max*e.exaggeration())}getBounds(){return "mercator"===this.projection.name||"equirectangular"===this.projection.name?this._terrainEnabled()?this._getBoundsRectangularTerrain():this._getBoundsRectangular(0,0):this._getBoundsNonRectangular()}horizonLineFromTop(e=!0){const t=this.height/2/Math.tan(this._fov/2)/Math.tan(Math.max(this._pitch,.1))+this.centerOffset.y,i=this.height/2-t*(1-this._horizonShift);return e?Math.max(0,i):i}getMaxBounds(){return this.maxBounds}setMaxBounds(t){this.maxBounds=t,this.minLat=-e.MAX_MERCATOR_LATITUDE,this.maxLat=e.MAX_MERCATOR_LATITUDE,this.minLng=-180,this.maxLng=180,t&&(this.minLat=t.getSouth(),this.maxLat=t.getNorth(),this.minLng=t.getWest(),this.maxLng=t.getEast(),this.maxLng<this.minLng&&(this.maxLng+=360)),this.worldMinX=e.mercatorXfromLng(this.minLng)*this.tileSize,this.worldMaxX=e.mercatorXfromLng(this.maxLng)*this.tileSize,this.worldMinY=e.mercatorYfromLat(this.maxLat)*this.tileSize,this.worldMaxY=e.mercatorYfromLat(this.minLat)*this.tileSize,this._constrain();}calculatePosMatrix(e,t){return this.projection.createTileMatrix(this,t,e)}calculateDistanceTileData(t){const i=t.key,o=this._distanceTileDataCache;if(o[i])return o[i];const r=t.canonical,n=1/this.height,s=this.cameraWorldSize,a=s/this.zoomScale(r.z),l=(r.x+Math.pow(2,r.z)*t.wrap)*a,c=r.y*a,h=this.point;h.x*=s/this.worldSize,h.y*=s/this.worldSize;const u=this.angle,_=Math.sin(-u),d=-Math.cos(-u);return o[i]={bearing:[_,d],center:[(h.x-l)*n,(h.y-c)*n],scale:a/e.EXTENT*n},o[i]}calculateFogTileMatrix(t){const i=t.key,o=this._fogTileMatrixCache;if(o[i])return o[i];const r=this.projection.createTileMatrix(this,this.cameraWorldSizeForFog,t);return e.multiply(r,this.worldToFogMatrix,r),o[i]=new Float32Array(r),o[i]}calculateProjMatrix(t,i=!1){const o=t.key,r=i?this._alignedProjMatrixCache:this._projMatrixCache;if(r[o])return r[o];const n=this.calculatePosMatrix(t,this.worldSize);return e.multiply(n,this.projection.isReprojectedInTileSpace?this.mercatorMatrix:i?this.alignedProjMatrix:this.projMatrix,n),r[o]=new Float32Array(n),r[o]}calculatePixelsToTileUnitsMatrix(t){const i=t.tileID.key,o=this._pixelsToTileUnitsCache;if(o[i])return o[i];const r=function(t,i){const{scale:o}=t.tileTransform,r=o*e.EXTENT/(t.tileSize*Math.pow(2,i.zoom-t.tileID.overscaledZ+t.tileID.canonical.z));return n=new Float32Array(4),l=(s=i.inverseAdjustmentMatrix)[1],c=s[2],h=s[3],_=(a=[r,r])[1],n[0]=s[0]*(u=a[0]),n[1]=l*u,n[2]=c*_,n[3]=h*_,n;var n,s,a,l,c,h,u,_;}(t,this);return o[i]=r,o[i]}customLayerMatrix(){return this.mercatorMatrix.slice()}globeToMercatorMatrix(){if("globe"===this.projection.name){const t=1/this.worldSize,i=e.fromScaling([],[t,t,t]);return e.multiply(i,i,this.globeMatrix),i}}recenterOnTerrain(){if(!this._elevation||"globe"===this.projection.name)return;const t=this._elevation;this._updateCameraState();const i=e.mercatorZfromAltitude(1,this._center.lat)*this.worldSize,o=this._computeCameraPosition(i),r=this._camera.forward(),n=e.mercatorZfromAltitude(1,this._center.lat);o[2]/=n,r[2]/=n,e.normalize(r,r);const s=t.raycast(o,r,t.exaggeration());if(s){const t=e.scaleAndAdd([],o,r,s),i=new e.MercatorCoordinate(t[0],t[1],e.mercatorZfromAltitude(t[2],e.latFromMercatorY(t[1]))),a=(i.z+e.length([i.x-o[0],i.y-o[1],i.z-o[2]*n]))*this._pixelsPerMercatorPixel;this._seaLevelZoom=this._zoomFromMercatorZ(a),this._centerAltitude=i.toAltitude(),this._center=this.coordinateLocation(i),this._updateZoomFromElevation(),this._constrain(),this._calcMatrices();}}_constrainCamera(t=!1){if(!this._elevation)return;const i=this._elevation,o=e.mercatorZfromAltitude(1,this._center.lat)*this.worldSize,r=this._computeCameraPosition(o),n=i.getAtPointOrZero(new e.MercatorCoordinate(...r)),s=this.pixelsPerMeter/this.worldSize*n,a=this._minimumHeightOverTerrain(),l=r[2]-s;if(l<=a)if(l<0||t){const t=this.locationCoordinate(this._center,this._centerAltitude),i=[r[0],r[1],t.z-r[2]],o=e.length(i);i[2]-=(a-l)/this._pixelsPerMercatorPixel;const n=e.length(i);if(0===n)return;e.scale$2(i,i,o/n*this._pixelsPerMercatorPixel),this._camera.position=[r[0],r[1],t.z*this._pixelsPerMercatorPixel-i[2]],this._updateStateFromCamera();}else this._isCameraConstrained=!0;}_constrain(){if(!this.center||!this.width||!this.height||this._constraining)return;this._constraining=!0;const t="globe"===this.projection.name||this.mercatorFromTransition;if(this.projection.isReprojectedInTileSpace||t){const i=this.center;return i.lat=e.clamp(i.lat,this.minLat,this.maxLat),(this.maxBounds||!this.renderWorldCopies&&!t)&&(i.lng=e.clamp(i.lng,this.minLng,this.maxLng)),this.center=i,void(this._constraining=!1)}const i=this._unmodified,{x:o,y:r}=this.point;let n=0,s=o,a=r;const l=this.width/2,c=this.height/2,h=this.worldMinY*this.scale,u=this.worldMaxY*this.scale;if(r-c<h&&(a=h+c),r+c>u&&(a=u-c),u-h<this.height&&(n=Math.max(n,this.height/(u-h)),a=(u+h)/2),this.maxBounds||!this._renderWorldCopies||!this.projection.wrap){const e=this.worldMinX*this.scale,t=this.worldMaxX*this.scale,i=this.worldSize/2-(e+t)/2;s=(o+i+this.worldSize)%this.worldSize-i,s-l<e&&(s=e+l),s+l>t&&(s=t-l),t-e<this.width&&(n=Math.max(n,this.width/(t-e)),s=(t+e)/2);}s===o&&a===r||(this.center=this.unproject(new e.Point(s,a))),n&&(this.zoom+=this.scaleZoom(n)),this._constrainCamera(),this._unmodified=i,this._constraining=!1;}_minZoomForBounds(){let e=Math.max(0,this.scaleZoom(this.height/(this.worldMaxY-this.worldMinY)));return this.maxBounds&&(e=Math.max(e,this.scaleZoom(this.width/(this.worldMaxX-this.worldMinX)))),e}_maxCameraBoundsDistance(){return this._mercatorZfromZoom(this._minZoomForBounds())}_calcMatrices(){if(!this.height)return;const t=this.centerOffset,i=this.pixelsPerMeter;"globe"===this.projection.name&&(this._mercatorScaleRatio=e.mercatorZfromAltitude(1,this.center.lat)/e.mercatorZfromAltitude(1,e.GLOBE_SCALE_MATCH_LATITUDE));const o=Wo(this.projection,this.zoom,this.width,this.height,1024);this._pixelsPerMercatorPixel=this.projection.pixelSpaceConversion(this.center.lat,this.worldSize,o),this.cameraToCenterDistance=.5/Math.tan(.5*this._fov)*this.height*this._pixelsPerMercatorPixel,this._updateCameraState(),this._farZ=this.projection.farthestPixelDistance(this),this._nearZ=this.height/50;const r="meters"===this.projection.zAxisUnit?i:1,n=this._camera.getWorldToCamera(this.worldSize,r),s=this._camera.getCameraToClipPerspective(this._fov,this.width/this.height,this._nearZ,this._farZ);s[8]=2*-t.x/this.width,s[9]=2*t.y/this.height;let a=e.mul([],s,n);if(this.projection.isReprojectedInTileSpace){const t=this.locationCoordinate(this.center),i=e.identity([]);e.translate(i,i,[t.x*this.worldSize,t.y*this.worldSize,0]),e.multiply(i,i,Zo(this)),e.translate(i,i,[-t.x*this.worldSize,-t.y*this.worldSize,0]),e.multiply(a,a,i),this.inverseAdjustmentMatrix=function(e){const t=Zo(e,!0);return v([],[t[0],t[1],t[4],t[5]])}(this);}else this.inverseAdjustmentMatrix=[1,0,0,1];this.mercatorMatrix=e.scale([],a,[this.worldSize,this.worldSize,this.worldSize/r,1]),this.projMatrix=a,this.invProjMatrix=e.invert(new Float64Array(16),this.projMatrix);const l=e.invert([],s);this.frustumCorners=e.FrustumCorners.fromInvProjectionMatrix(l,this.horizonLineFromTop(),this.height);const c=new Float32Array(16);e.identity(c),e.scale(c,c,[1,-1,1]),e.rotateX(c,c,this._pitch),e.rotateZ(c,c,this.angle);const h=e.perspective(new Float32Array(16),this._fov,this.width/this.height,this._nearZ,this._farZ),u=(Math.PI/2-this._pitch)*(this.height/this._fov)*this._horizonShift;h[8]=2*-t.x/this.width,h[9]=2*(t.y+u)/this.height,this.skyboxMatrix=e.multiply(c,h,c);const _=this.point,d=_.x,p=_.y,m=this.width%2/2,f=this.height%2/2,g=Math.cos(this.angle),x=Math.sin(this.angle),y=d-Math.round(d)+g*m+x*f,b=p-Math.round(p)+g*f+x*m,w=new Float64Array(a);if(e.translate(w,w,[y>.5?y-1:y,b>.5?b-1:b,0]),this.alignedProjMatrix=w,a=e.create(),e.scale(a,a,[this.width/2,-this.height/2,1]),e.translate(a,a,[1,-1,0]),this.labelPlaneMatrix=a,a=e.create(),e.scale(a,a,[1,-1,1]),e.translate(a,a,[-1,-1,0]),e.scale(a,a,[2/this.width,2/this.height,1]),this.glCoordMatrix=a,this.pixelMatrix=e.multiply(new Float64Array(16),this.labelPlaneMatrix,this.projMatrix),this._calcFogMatrices(),this._distanceTileDataCache={},a=e.invert(new Float64Array(16),this.pixelMatrix),!a)throw new Error("failed to invert matrix");if(this.pixelMatrixInverse=a,"globe"===this.projection.name||this.mercatorFromTransition){this.globeMatrix=e.calculateGlobeMatrix(this);const t=[this.globeMatrix[12],this.globeMatrix[13],this.globeMatrix[14]];this.globeCenterInViewSpace=e.transformMat4(t,t,n),this.globeRadius=this.worldSize/2/Math.PI-1;}else this.globeMatrix=a;this._projMatrixCache={},this._alignedProjMatrixCache={},this._pixelsToTileUnitsCache={};}_calcFogMatrices(){this._fogTileMatrixCache={};const t=this.cameraWorldSizeForFog,i=this.cameraPixelsPerMeter,o=this._camera.position,r=1/this.height/this._pixelsPerMercatorPixel,n=[t,t,i];e.scale$2(n,n,r),e.scale$2(o,o,-1),e.multiply$2(o,o,n);const s=e.create();e.translate(s,s,o),e.scale(s,s,n),this.mercatorFogMatrix=s,this.worldToFogMatrix=this._camera.getWorldToCameraPosition(t,i,r);}_computeCameraPosition(e){const t=(e=e||this.pixelsPerMeter)/this.pixelsPerMeter,i=this._camera.forward(),o=this.point,r=this._mercatorZfromZoom(this._seaLevelZoom?this._seaLevelZoom:this._zoom)*t-e/this.worldSize*this._centerAltitude;return [o.x/this.worldSize-i[0]*r,o.y/this.worldSize-i[1]*r,e/this.worldSize*this._centerAltitude-i[2]*r]}_updateCameraState(){this.height&&(this._camera.setPitchBearing(this._pitch,this.angle),this._camera.position=this._computeCameraPosition());}_translateCameraConstrained(t){const i=this._maxCameraBoundsDistance()*Math.cos(this._pitch),o=this._camera.position[2],r=t[2];let n=1;this.projection.wrap&&(this.center=this.center.wrap()),r>0&&(n=Math.min((i-o)/r,1)),this._camera.position=e.scaleAndAdd([],this._camera.position,t,n),this._updateStateFromCamera();}_updateStateFromCamera(){const t=this._camera.position,i=this._camera.forward(),{pitch:o,bearing:r}=this._camera.getPitchBearing(),n=e.mercatorZfromAltitude(this._centerAltitude,this.center.lat)*this._pixelsPerMercatorPixel,s=this._mercatorZfromZoom(this._maxZoom)*Math.cos(e.degToRad(this._maxPitch)),a=Math.max((t[2]-n)/Math.cos(o),s),l=this._zoomFromMercatorZ(a);e.scaleAndAdd(t,t,i,a),this._pitch=e.clamp(o,e.degToRad(this.minPitch),e.degToRad(this.maxPitch)),this.angle=e.wrap(r,-Math.PI,Math.PI),this._setZoom(e.clamp(l,this._minZoom,this._maxZoom)),this._updateSeaLevelZoom(),this._center=this.coordinateLocation(new e.MercatorCoordinate(t[0],t[1],t[2])),this._unmodified=!1,this._constrain(),this._calcMatrices();}_worldSizeFromZoom(e){return Math.pow(2,e)*this.tileSize}_mercatorZfromZoom(e){return this.cameraToCenterDistance/this._worldSizeFromZoom(e)}_minimumHeightOverTerrain(){const e=Math.min((null!=this._seaLevelZoom?this._seaLevelZoom:this._zoom)+4,this._maxZoom);return this._mercatorZfromZoom(e)}_zoomFromMercatorZ(e){return this.scaleZoom(this.cameraToCenterDistance/(e*this.tileSize))}zoomFromMercatorZAdjusted(t){let i=0,o=e.GLOBE_ZOOM_THRESHOLD_MAX,r=0,n=1/0;for(;o-i>1e-6&&o>i;){const e=i+.5*(o-i),s=this.tileSize*Math.pow(2,e),a=this.getCameraToCenterDistance(this.projection,e,s),l=this.scaleZoom(a/(t*this.tileSize)),c=Math.abs(e-l);c<n&&(n=c,r=e),e<l?i=e:o=e;}return r}_terrainEnabled(){return !(!this._elevation||!this.projection.supportsTerrain&&(e.warnOnce("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."),1))}anyCornerOffEdge(t,i){const o=Math.min(t.x,i.x),r=Math.max(t.x,i.x),n=Math.min(t.y,i.y),s=Math.max(t.y,i.y);if(n<this.horizonLineFromTop(!1))return !0;if("mercator"!==this.projection.name)return !1;const a=[new e.Point(o,n),new e.Point(r,s),new e.Point(o,s),new e.Point(r,n)],l=this.renderWorldCopies?-3:0,c=this.renderWorldCopies?4:1;for(const e of a){const t=this.pointRayIntersection(e);if(t.t<0)return !0;const i=this.rayIntersectionCoordinate(t);if(i.x<l||i.y<0||i.x>c||i.y>1)return !0}return !1}isHorizonVisible(){return this.pitch+e.radToDeg(this.fovAboveCenter)>88||this.anyCornerOffEdge(new e.Point(0,0),new e.Point(this.width,this.height))}zoomDeltaToMovement(t,i){const o=e.length(e.sub([],this._camera.position,t)),r=this._zoomFromMercatorZ(o)+i;return o-this._mercatorZfromZoom(r)}getCameraPoint(){if("globe"===this.projection.name){const t=function([t,i,o],r){const n=[t,i,o,1];e.transformMat4$1(n,n,r);const s=n[3]=Math.max(n[3],1e-6);return n[0]/=s,n[1]/=s,n[2]/=s,n}([this.globeMatrix[12],this.globeMatrix[13],this.globeMatrix[14]],this.pixelMatrix);return new e.Point(t[0],t[1])}{const t=Math.tan(this._pitch)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new e.Point(0,t))}}getCameraToCenterDistance(e,t=this.zoom,i=this.worldSize){const o=Wo(e,t,this.width,this.height,1024),r=e.pixelSpaceConversion(this.center.lat,i,o);return .5/Math.tan(.5*this._fov)*this.height*r}getWorldToCameraMatrix(){const t=this._camera.getWorldToCamera(this.worldSize,"meters"===this.projection.zAxisUnit?this.pixelsPerMeter:1);return "globe"===this.projection.name&&e.multiply(t,t,this.globeMatrix),t}}function Yo(e,t){let i=!1,o=null;const r=()=>{o=null,i&&(e(),o=setTimeout(r,t),i=!1);};return ()=>(i=!0,o||r(),o)}class Ko{constructor(t){this._hashName=t&&encodeURIComponent(t),e.bindAll(["_getCurrentHash","_onHashChange","_updateHash"],this),this._updateHash=Yo(this._updateHashUnthrottled.bind(this),300);}addTo(t){return this._map=t,e.window.addEventListener("hashchange",this._onHashChange,!1),t.on("moveend",this._updateHash),this}remove(){return this._map?(this._map.off("moveend",this._updateHash),e.window.removeEventListener("hashchange",this._onHashChange,!1),clearTimeout(this._updateHash()),this._map=void 0,this):this}getHashString(){const t=this._map;if(!t)return "";const i=Jo(t);if(this._hashName){const t=this._hashName;let o=!1;const r=e.window.location.hash.slice(1).split("&").map((e=>{const r=e.split("=")[0];return r===t?(o=!0,`${r}=${i}`):e})).filter((e=>e));return o||r.push(`${t}=${i}`),`#${r.join("&")}`}return `#${i}`}_getCurrentHash(){const t=e.window.location.hash.replace("#","");if(this._hashName){let e;return t.split("&").map((e=>e.split("="))).forEach((t=>{t[0]===this._hashName&&(e=t);})),(e&&e[1]||"").split("/")}return t.split("/")}_onHashChange(){const e=this._map;if(!e)return !1;const t=this._getCurrentHash();if(t.length>=3&&!t.some((e=>isNaN(e)))){const i=e.dragRotate.isEnabled()&&e.touchZoomRotate.isEnabled()?+(t[3]||0):e.getBearing();return e.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:i,pitch:+(t[4]||0)}),!0}return !1}_updateHashUnthrottled(){const t=e.window.location.href.replace(/(#.+)?$/,this.getHashString());e.window.history.replaceState(e.window.history.state,null,t);}}function Jo(e,t){const i=e.getCenter(),o=Math.round(100*e.getZoom())/100,r=Math.ceil((o*Math.LN2+Math.log(512/360/.5))/Math.LN10),n=Math.pow(10,r),s=Math.round(i.lng*n)/n,a=Math.round(i.lat*n)/n,l=e.getBearing(),c=e.getPitch();let h=t?`/${s}/${a}/${o}`:`${o}/${a}/${s}`;return (l||c)&&(h+="/"+Math.round(10*l)/10),c&&(h+=`/${Math.round(c)}`),h}const Qo={linearity:.3,easing:e.bezier(0,0,.3,1)},er=e.extend({deceleration:2500,maxSpeed:1400},Qo),tr=e.extend({deceleration:20,maxSpeed:1400},Qo),ir=e.extend({deceleration:1e3,maxSpeed:360},Qo),or=e.extend({deceleration:1e3,maxSpeed:90},Qo);class rr{constructor(e){this._map=e,this.clear();}clear(){this._inertiaBuffer=[];}record(t){this._drainInertiaBuffer(),this._inertiaBuffer.push({time:e.exported.now(),settings:t});}_drainInertiaBuffer(){const t=this._inertiaBuffer,i=e.exported.now();for(;t.length>0&&i-t[0].time>160;)t.shift();}_onMoveEnd(t){if(this._map._prefersReducedMotion())return;if(this._drainInertiaBuffer(),this._inertiaBuffer.length<2)return;const i={zoom:0,bearing:0,pitch:0,pan:new e.Point(0,0),pinchAround:void 0,around:void 0};for(const{settings:e}of this._inertiaBuffer)i.zoom+=e.zoomDelta||0,i.bearing+=e.bearingDelta||0,i.pitch+=e.pitchDelta||0,e.panDelta&&i.pan._add(e.panDelta),e.around&&(i.around=e.around),e.pinchAround&&(i.pinchAround=e.pinchAround);const o=this._inertiaBuffer[this._inertiaBuffer.length-1].time-this._inertiaBuffer[0].time,r={};if(i.pan.mag()){const n=sr(i.pan.mag(),o,e.extend({},er,t||{}));r.offset=i.pan.mult(n.amount/i.pan.mag()),r.center=this._map.transform.center,nr(r,n);}if(i.zoom){const e=sr(i.zoom,o,tr);r.zoom=this._map.transform.zoom+e.amount,nr(r,e);}if(i.bearing){const t=sr(i.bearing,o,ir);r.bearing=this._map.transform.bearing+e.clamp(t.amount,-179,179),nr(r,t);}if(i.pitch){const e=sr(i.pitch,o,or);r.pitch=this._map.transform.pitch+e.amount,nr(r,e);}if(r.zoom||r.bearing){const e=void 0===i.pinchAround?i.around:i.pinchAround;r.around=e?this._map.unproject(e):this._map.getCenter();}return this.clear(),r.noMoveStart=!0,r}}function nr(e,t){(!e.duration||e.duration<t.duration)&&(e.duration=t.duration,e.easing=t.easing);}function sr(t,i,o){const{maxSpeed:r,linearity:n,deceleration:s}=o,a=e.clamp(t*n/(i/1e3),-r,r),l=Math.abs(a)/(s*n);return {easing:o.easing,duration:1e3*l,amount:a*(l/2)}}class ar extends e.Event{preventDefault(){this._defaultPrevented=!0;}get defaultPrevented(){return this._defaultPrevented}constructor(t,i,o,r={}){const n=p(i.getCanvasContainer(),o),s=i.unproject(n);super(t,e.extend({point:n,lngLat:s,originalEvent:o},r)),this._defaultPrevented=!1,this.target=i;}}class lr extends e.Event{preventDefault(){this._defaultPrevented=!0;}get defaultPrevented(){return this._defaultPrevented}constructor(t,i,o){const r="touchend"===t?o.changedTouches:o.touches,n=m(i.getCanvasContainer(),r),s=n.map((e=>i.unproject(e))),a=n.reduce(((e,t,i,o)=>e.add(t.div(o.length))),new e.Point(0,0));super(t,{points:n,point:a,lngLats:s,lngLat:i.unproject(a),originalEvent:o}),this._defaultPrevented=!1;}}class cr extends e.Event{preventDefault(){this._defaultPrevented=!0;}get defaultPrevented(){return this._defaultPrevented}constructor(e,t,i){super(e,{originalEvent:i}),this._defaultPrevented=!1;}}class hr{constructor(e,t){this._map=e,this._clickTolerance=t.clickTolerance;}reset(){this._mousedownPos=void 0;}wheel(e){return this._firePreventable(new cr(e.type,this._map,e))}mousedown(e,t){return this._mousedownPos=t,this._firePreventable(new ar(e.type,this._map,e))}mouseup(e){this._map.fire(new ar(e.type,this._map,e));}preclick(t){const i=e.extend({},t);i.type="preclick",this._map.fire(new ar(i.type,this._map,i));}click(e,t){this._mousedownPos&&this._mousedownPos.dist(t)>=this._clickTolerance||(this.preclick(e),this._map.fire(new ar(e.type,this._map,e)));}dblclick(e){return this._firePreventable(new ar(e.type,this._map,e))}mouseover(e){this._map.fire(new ar(e.type,this._map,e));}mouseout(e){this._map.fire(new ar(e.type,this._map,e));}touchstart(e){return this._firePreventable(new lr(e.type,this._map,e))}touchmove(e){this._map.fire(new lr(e.type,this._map,e));}touchend(e){this._map.fire(new lr(e.type,this._map,e));}touchcancel(e){this._map.fire(new lr(e.type,this._map,e));}_firePreventable(e){if(this._map.fire(e),e.defaultPrevented)return {}}isEnabled(){return !0}isActive(){return !1}enable(){}disable(){}}class ur{constructor(e){this._map=e;}reset(){this._delayContextMenu=!1,this._contextMenuEvent=void 0;}mousemove(e){this._map.fire(new ar(e.type,this._map,e));}mousedown(){this._delayContextMenu=!0;}mouseup(){this._delayContextMenu=!1,this._contextMenuEvent&&(this._map.fire(new ar("contextmenu",this._map,this._contextMenuEvent)),delete this._contextMenuEvent);}contextmenu(e){this._delayContextMenu?this._contextMenuEvent=e:this._map.fire(new ar(e.type,this._map,e)),this._map.listens("contextmenu")&&e.preventDefault();}isEnabled(){return !0}isActive(){return !1}enable(){}disable(){}}class _r{constructor(e,t){this._map=e,this._el=e.getCanvasContainer(),this._container=e.getContainer(),this._clickTolerance=t.clickTolerance||1;}isEnabled(){return !!this._enabled}isActive(){return !!this._active}enable(){this.isEnabled()||(this._enabled=!0);}disable(){this.isEnabled()&&(this._enabled=!1);}mousedown(e,t){this.isEnabled()&&e.shiftKey&&0===e.button&&(h(),this._startPos=this._lastPos=t,this._active=!0);}mousemoveWindow(e,t){if(!this._active)return;const i=t,o=this._startPos,r=this._lastPos;if(!o||!r||r.equals(i)||!this._box&&i.dist(o)<this._clickTolerance)return;this._lastPos=i,this._box||(this._box=n("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",e));const s=Math.min(o.x,i.x),a=Math.max(o.x,i.x),l=Math.min(o.y,i.y),c=Math.max(o.y,i.y);this._map._requestDomTask((()=>{this._box&&(this._box.style.transform=`translate(${s}px,${l}px)`,this._box.style.width=a-s+"px",this._box.style.height=c-l+"px");}));}mouseupWindow(t,i){if(!this._active)return;const o=this._startPos,r=i;if(o&&0===t.button){if(this.reset(),d(),o.x!==r.x||o.y!==r.y)return this._map.fire(new e.Event("boxzoomend",{originalEvent:t})),{cameraAnimation:e=>e.fitScreenCoordinates(o,r,this._map.getBearing(),{linear:!1})};this._fireEvent("boxzoomcancel",t);}}keydown(e){this._active&&27===e.keyCode&&(this.reset(),this._fireEvent("boxzoomcancel",e));}blur(){this.reset();}reset(){this._active=!1,this._container.classList.remove("mapboxgl-crosshair"),this._box&&(this._box.remove(),this._box=null),u(),delete this._startPos,delete this._lastPos;}_fireEvent(t,i){return this._map.fire(new e.Event(t,{originalEvent:i}))}}function dr(e,t){const i={};for(let o=0;o<e.length;o++)i[e[o].identifier]=t[o];return i}class pr{constructor(e){this.reset(),this.numTouches=e.numTouches;}reset(){this.centroid=void 0,this.startTime=0,this.touches={},this.aborted=!1;}touchstart(t,i,o){(this.centroid||o.length>this.numTouches)&&(this.aborted=!0),this.aborted||(0===this.startTime&&(this.startTime=t.timeStamp),o.length===this.numTouches&&(this.centroid=function(t){const i=new e.Point(0,0);for(const e of t)i._add(e);return i.div(t.length)}(i),this.touches=dr(o,i)));}touchmove(e,t,i){if(this.aborted||!this.centroid)return;const o=dr(i,t);for(const e in this.touches){const t=o[e];(!t||t.dist(this.touches[e])>30)&&(this.aborted=!0);}}touchend(e,t,i){if((!this.centroid||e.timeStamp-this.startTime>500)&&(this.aborted=!0),0===i.length){const e=!this.aborted&&this.centroid;if(this.reset(),e)return e}}}class mr{constructor(e){this.singleTap=new pr(e),this.numTaps=e.numTaps,this.reset();}reset(){this.lastTime=1/0,this.lastTap=void 0,this.count=0,this.singleTap.reset();}touchstart(e,t,i){this.singleTap.touchstart(e,t,i);}touchmove(e,t,i){this.singleTap.touchmove(e,t,i);}touchend(e,t,i){const o=this.singleTap.touchend(e,t,i);if(o){const t=e.timeStamp-this.lastTime<500,i=!this.lastTap||this.lastTap.dist(o)<30;if(t&&i||this.reset(),this.count++,this.lastTime=e.timeStamp,this.lastTap=o,this.count===this.numTaps)return this.reset(),o}}}class fr{constructor(){this._zoomIn=new mr({numTouches:1,numTaps:2}),this._zoomOut=new mr({numTouches:2,numTaps:1}),this.reset();}reset(){this._active=!1,this._zoomIn.reset(),this._zoomOut.reset();}touchstart(e,t,i){this._zoomIn.touchstart(e,t,i),this._zoomOut.touchstart(e,t,i);}touchmove(e,t,i){this._zoomIn.touchmove(e,t,i),this._zoomOut.touchmove(e,t,i);}touchend(e,t,i){const o=this._zoomIn.touchend(e,t,i),r=this._zoomOut.touchend(e,t,i);return o?(this._active=!0,e.preventDefault(),setTimeout((()=>this.reset()),0),{cameraAnimation:t=>t.easeTo({duration:300,zoom:t.getZoom()+1,around:t.unproject(o)},{originalEvent:e})}):r?(this._active=!0,e.preventDefault(),setTimeout((()=>this.reset()),0),{cameraAnimation:t=>t.easeTo({duration:300,zoom:t.getZoom()-1,around:t.unproject(r)},{originalEvent:e})}):void 0}touchcancel(){this.reset();}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}const gr={0:1,2:2};class vr{constructor(e){this.reset(),this._clickTolerance=e.clickTolerance||1;}blur(){this.reset();}reset(){this._active=!1,this._moved=!1,this._lastPoint=void 0,this._eventButton=void 0;}_correctButton(e,t){return !1}_move(e,t){return {}}mousedown(e,t){if(this._lastPoint)return;const i=f(e);this._correctButton(e,i)&&(this._lastPoint=t,this._eventButton=i);}mousemoveWindow(e,t){const i=this._lastPoint;if(i)if(e.preventDefault(),null!=this._eventButton&&function(e,t){const i=gr[t];return void 0===e.buttons||(e.buttons&i)!==i}(e,this._eventButton))this.reset();else if(this._moved||!(t.dist(i)<this._clickTolerance))return this._moved=!0,this._lastPoint=t,this._move(i,t)}mouseupWindow(e){this._lastPoint&&f(e)===this._eventButton&&(this._moved&&d(),this.reset());}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}class xr extends vr{mousedown(e,t){super.mousedown(e,t),this._lastPoint&&(this._active=!0);}_correctButton(e,t){return 0===t&&!e.ctrlKey}_move(e,t){return {around:t,panDelta:t.sub(e)}}}class yr extends vr{_correctButton(e,t){return 0===t&&e.ctrlKey||2===t}_move(e,t){const i=.8*(t.x-e.x);if(i)return this._active=!0,{bearingDelta:i}}contextmenu(e){e.preventDefault();}}class br extends vr{_correctButton(e,t){return 0===t&&e.ctrlKey||2===t}_move(e,t){const i=-.5*(t.y-e.y);if(i)return this._active=!0,{pitchDelta:i}}contextmenu(e){e.preventDefault();}}class wr{constructor(t,i){this._map=t,this._el=t.getCanvasContainer(),this._minTouches=1,this._clickTolerance=i.clickTolerance||1,this.reset(),e.bindAll(["_addTouchPanBlocker","_showTouchPanBlockerAlert"],this);}reset(){this._active=!1,this._touches={},this._sum=new e.Point(0,0);}touchstart(e,t,i){return this._calculateTransform(e,t,i)}touchmove(t,i,o){if(this._active&&!(o.length<this._minTouches)){if(this._map._cooperativeGestures&&!this._map.isMoving()){if(1===o.length&&!e.isFullscreen())return void this._showTouchPanBlockerAlert();"hidden"!==this._alertContainer.style.visibility&&(this._alertContainer.style.visibility="hidden",clearTimeout(this._alertTimer));}return t.cancelable&&t.preventDefault(),this._calculateTransform(t,i,o)}}touchend(e,t,i){this._calculateTransform(e,t,i),this._active&&i.length<this._minTouches&&this.reset();}touchcancel(){this.reset();}_calculateTransform(t,i,o){o.length>0&&(this._active=!0);const r=dr(o,i),n=new e.Point(0,0),s=new e.Point(0,0);let a=0;for(const e in r){const t=r[e],i=this._touches[e];i&&(n._add(t),s._add(t.sub(i)),a++,r[e]=t);}if(this._touches=r,a<this._minTouches||!s.mag())return;const l=s.div(a);return this._sum._add(l),this._sum.mag()<this._clickTolerance?void 0:{around:n.div(a),panDelta:l}}enable(){this._enabled=!0,this._map._cooperativeGestures&&(this._addTouchPanBlocker(),this._el.classList.add("mapboxgl-touch-pan-blocker-override","mapboxgl-scrollable-page"));}disable(){this._enabled=!1,this._map._cooperativeGestures&&(clearTimeout(this._alertTimer),this._alertContainer.remove(),this._el.classList.remove("mapboxgl-touch-pan-blocker-override","mapboxgl-scrollable-page")),this.reset();}isEnabled(){return !!this._enabled}isActive(){return !!this._active}_addTouchPanBlocker(){this._map&&!this._alertContainer&&(this._alertContainer=n("div","mapboxgl-touch-pan-blocker",this._map._container),this._alertContainer.textContent=this._map._getUIString("TouchPanBlocker.Message"),this._alertContainer.style.fontSize=`${Math.max(10,Math.min(24,Math.floor(.05*this._el.clientWidth)))}px`);}_showTouchPanBlockerAlert(){this._alertContainer.style.visibility="visible",this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"),this._alertContainer.setAttribute("role","alert"),clearTimeout(this._alertTimer),this._alertTimer=setTimeout((()=>{this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"),this._alertContainer.setAttribute("role","null");}),500);}}class Tr{constructor(){this.reset();}reset(){this._active=!1,this._firstTwoTouches=void 0;}_start(e){}_move(e,t,i){return {}}touchstart(e,t,i){this._firstTwoTouches||i.length<2||(this._firstTwoTouches=[i[0].identifier,i[1].identifier],this._start([t[0],t[1]]));}touchmove(e,t,i){const o=this._firstTwoTouches;if(!o)return;e.preventDefault();const[r,n]=o,s=Er(i,t,r),a=Er(i,t,n);if(!s||!a)return;const l=this._aroundCenter?null:s.add(a).div(2);return this._move([s,a],l,e)}touchend(e,t,i){if(!this._firstTwoTouches)return;const[o,r]=this._firstTwoTouches,n=Er(i,t,o),s=Er(i,t,r);n&&s||(this._active&&d(),this.reset());}touchcancel(){this.reset();}enable(e){this._enabled=!0,this._aroundCenter=!!e&&"center"===e.around;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}function Er(e,t,i){for(let o=0;o<e.length;o++)if(e[o].identifier===i)return t[o]}function Cr(e,t){return Math.log(e/t)/Math.LN2}class Mr extends Tr{reset(){super.reset(),this._distance=0,this._startDistance=0;}_start(e){this._startDistance=this._distance=e[0].dist(e[1]);}_move(e,t){const i=this._distance;if(this._distance=e[0].dist(e[1]),this._active||!(Math.abs(Cr(this._distance,this._startDistance))<.1))return this._active=!0,{zoomDelta:Cr(this._distance,i),pinchAround:t}}}function Ir(e,t){return 180*e.angleWith(t)/Math.PI}class Pr extends Tr{reset(){super.reset(),this._minDiameter=0,this._startVector=void 0,this._vector=void 0;}_start(e){this._startVector=this._vector=e[0].sub(e[1]),this._minDiameter=e[0].dist(e[1]);}_move(e,t){const i=this._vector;if(this._vector=e[0].sub(e[1]),i&&(this._active||!this._isBelowThreshold(this._vector)))return this._active=!0,{bearingDelta:Ir(this._vector,i),pinchAround:t}}_isBelowThreshold(e){this._minDiameter=Math.min(this._minDiameter,e.mag());const t=25/(Math.PI*this._minDiameter)*360,i=this._startVector;if(!i)return !1;const o=Ir(e,i);return Math.abs(o)<t}}function Sr(e){return Math.abs(e.y)>Math.abs(e.x)}class Dr extends Tr{constructor(e){super(),this._map=e;}reset(){super.reset(),this._valid=void 0,this._firstMove=void 0,this._lastPoints=void 0;}_start(e){this._lastPoints=e,Sr(e[0].sub(e[1]))&&(this._valid=!1);}_move(t,i,o){const r=this._lastPoints;if(!r)return;const n=t[0].sub(r[0]),s=t[1].sub(r[1]);return this._map._cooperativeGestures&&!e.isFullscreen()&&o.touches.length<3||(this._valid=this.gestureBeginsVertically(n,s,o.timeStamp),!this._valid)?void 0:(this._lastPoints=t,this._active=!0,{pitchDelta:(n.y+s.y)/2*-.5})}gestureBeginsVertically(e,t,i){if(void 0!==this._valid)return this._valid;const o=e.mag()>=2,r=t.mag()>=2;if(!o&&!r)return;if(!o||!r)return null==this._firstMove&&(this._firstMove=i),i-this._firstMove<100&&void 0;const n=e.y>0==t.y>0;return Sr(e)&&Sr(t)&&n}}const Lr={panStep:100,bearingStep:15,pitchStep:10};class Ar{constructor(){const e=Lr;this._panStep=e.panStep,this._bearingStep=e.bearingStep,this._pitchStep=e.pitchStep,this._rotationDisabled=!1;}blur(){this.reset();}reset(){this._active=!1;}keydown(e){if(e.altKey||e.ctrlKey||e.metaKey)return;let t=0,i=0,o=0,r=0,n=0;switch(e.keyCode){case 61:case 107:case 171:case 187:t=1;break;case 189:case 109:case 173:t=-1;break;case 37:e.shiftKey?i=-1:(e.preventDefault(),r=-1);break;case 39:e.shiftKey?i=1:(e.preventDefault(),r=1);break;case 38:e.shiftKey?o=1:(e.preventDefault(),n=-1);break;case 40:e.shiftKey?o=-1:(e.preventDefault(),n=1);break;default:return}return this._rotationDisabled&&(i=0,o=0),{cameraAnimation:s=>{const a=s.getZoom();s.easeTo({duration:300,easeId:"keyboardHandler",easing:zr,zoom:t?Math.round(a)+t*(e.shiftKey?2:1):a,bearing:s.getBearing()+i*this._bearingStep,pitch:s.getPitch()+o*this._pitchStep,offset:[-r*this._panStep,-n*this._panStep],center:s.getCenter()},{originalEvent:e});}}}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}disableRotation(){this._rotationDisabled=!0;}enableRotation(){this._rotationDisabled=!1;}}function zr(e){return e*(2-e)}const Rr=4.000244140625;class Or{constructor(t,i){this._map=t,this._el=t.getCanvasContainer(),this._handler=i,this._delta=0,this._defaultZoomRate=.01,this._wheelZoomRate=.0022222222222222222,e.bindAll(["_onTimeout","_addScrollZoomBlocker","_showBlockerAlert"],this);}setZoomRate(e){this._defaultZoomRate=e;}setWheelZoomRate(e){this._wheelZoomRate=e;}isEnabled(){return !!this._enabled}isActive(){return this._active||void 0!==this._finishTimeout}isZooming(){return !!this._zooming}enable(e){this.isEnabled()||(this._enabled=!0,this._aroundCenter=!!e&&"center"===e.around,this._map._cooperativeGestures&&this._addScrollZoomBlocker());}disable(){this.isEnabled()&&(this._enabled=!1,this._map._cooperativeGestures&&(clearTimeout(this._alertTimer),this._alertContainer.remove()));}wheel(t){if(!this.isEnabled())return;if(this._map._cooperativeGestures){if(!(t.ctrlKey||t.metaKey||this.isZooming()||e.isFullscreen()))return void this._showBlockerAlert();"hidden"!==this._alertContainer.style.visibility&&(this._alertContainer.style.visibility="hidden",clearTimeout(this._alertTimer));}let i=t.deltaMode===e.window.WheelEvent.DOM_DELTA_LINE?40*t.deltaY:t.deltaY;const o=e.exported.now(),r=o-(this._lastWheelEventTime||0);this._lastWheelEventTime=o,0!==i&&i%Rr==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":r>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,t)):this._type||(this._type=Math.abs(r*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),t.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=t,this._delta-=i,this._active||this._start(t)),t.preventDefault();}_onTimeout(e){this._type="wheel",this._delta-=this._lastValue,this._active||this._start(e);}_start(e){if(!this._delta)return;this._frameId&&(this._frameId=null),this._active=!0,this.isZooming()||(this._zooming=!0),this._finishTimeout&&(clearTimeout(this._finishTimeout),delete this._finishTimeout);const t=p(this._el,e);this._aroundPoint=this._aroundCenter?this._map.transform.centerPoint:t,this._aroundCoord=this._map.transform.pointCoordinate3D(this._aroundPoint),this._targetZoom=void 0,this._frameId||(this._frameId=!0,this._handler._triggerRenderFrame());}renderFrame(){if(!this._frameId)return;if(this._frameId=null,!this.isActive())return;const t=this._map.transform;"wheel"===this._type&&t.projection.wrap&&(t._center.lng>=180||t._center.lng<=-180)&&(this._prevEase=null,this._easing=null,this._lastWheelEvent=null,this._lastWheelEventTime=0);const i=()=>t._terrainEnabled()&&this._aroundCoord?t.computeZoomRelativeTo(this._aroundCoord):t.zoom;if(0!==this._delta){const e="wheel"===this._type&&Math.abs(this._delta)>Rr?this._wheelZoomRate:this._defaultZoomRate;let o=2/(1+Math.exp(-Math.abs(this._delta*e)));this._delta<0&&0!==o&&(o=1/o);const r=i(),n=Math.pow(2,r),s="number"==typeof this._targetZoom?t.zoomScale(this._targetZoom):n;this._targetZoom=Math.min(t.maxZoom,Math.max(t.minZoom,t.scaleZoom(s*o))),"wheel"===this._type&&(this._startZoom=r,this._easing=this._smoothOutEasing(200)),this._delta=0;}const o="number"==typeof this._targetZoom?this._targetZoom:i(),r=this._startZoom,n=this._easing;let s,a=!1;if("wheel"===this._type&&r&&n){const t=Math.min((e.exported.now()-this._lastWheelEventTime)/200,1),i=n(t);s=e.number(r,o,i),t<1?this._frameId||(this._frameId=!0):a=!0;}else s=o,a=!0;return this._active=!0,a&&(this._active=!1,this._finishTimeout=setTimeout((()=>{this._zooming=!1,this._handler._triggerRenderFrame(),delete this._targetZoom,delete this._finishTimeout;}),200)),{noInertia:!0,needsRenderFrame:!a,zoomDelta:s-i(),around:this._aroundPoint,aroundCoord:this._aroundCoord,originalEvent:this._lastWheelEvent}}_smoothOutEasing(t){let i=e.ease;if(this._prevEase){const t=this._prevEase,o=(e.exported.now()-t.start)/t.duration,r=t.easing(o+.01)-t.easing(o),n=.27/Math.sqrt(r*r+1e-4)*.01,s=Math.sqrt(.0729-n*n);i=e.bezier(n,s,.25,1);}return this._prevEase={start:e.exported.now(),duration:t,easing:i},i}blur(){this.reset();}reset(){this._active=!1;}_addScrollZoomBlocker(){this._map&&!this._alertContainer&&(this._alertContainer=n("div","mapboxgl-scroll-zoom-blocker",this._map._container),this._alertContainer.textContent=/(Mac|iPad)/i.test(e.window.navigator.userAgent)?this._map._getUIString("ScrollZoomBlocker.CmdMessage"):this._map._getUIString("ScrollZoomBlocker.CtrlMessage"),this._alertContainer.style.fontSize=`${Math.max(10,Math.min(24,Math.floor(.05*this._el.clientWidth)))}px`);}_showBlockerAlert(){this._alertContainer.style.visibility="visible",this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"),this._alertContainer.setAttribute("role","alert"),clearTimeout(this._alertTimer),this._alertTimer=setTimeout((()=>{this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"),this._alertContainer.setAttribute("role","null");}),200);}}class Br{constructor(e,t){this._clickZoom=e,this._tapZoom=t;}enable(){this._clickZoom.enable(),this._tapZoom.enable();}disable(){this._clickZoom.disable(),this._tapZoom.disable();}isEnabled(){return this._clickZoom.isEnabled()&&this._tapZoom.isEnabled()}isActive(){return this._clickZoom.isActive()||this._tapZoom.isActive()}}class kr{constructor(){this.reset();}reset(){this._active=!1;}blur(){this.reset();}dblclick(e,t){return e.preventDefault(),{cameraAnimation:i=>{i.easeTo({duration:300,zoom:i.getZoom()+(e.shiftKey?-1:1),around:i.unproject(t)},{originalEvent:e});}}}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}class Fr{constructor(){this._tap=new mr({numTouches:1,numTaps:1}),this.reset();}reset(){this._active=!1,this._swipePoint=void 0,this._swipeTouch=0,this._tapTime=0,this._tap.reset();}touchstart(e,t,i){this._swipePoint||(this._tapTime&&e.timeStamp-this._tapTime>500&&this.reset(),this._tapTime?i.length>0&&(this._swipePoint=t[0],this._swipeTouch=i[0].identifier):this._tap.touchstart(e,t,i));}touchmove(e,t,i){if(this._tapTime){if(this._swipePoint){if(i[0].identifier!==this._swipeTouch)return;const o=t[0],r=o.y-this._swipePoint.y;return this._swipePoint=o,e.preventDefault(),this._active=!0,{zoomDelta:r/128}}}else this._tap.touchmove(e,t,i);}touchend(e,t,i){this._tapTime?this._swipePoint&&0===i.length&&this.reset():this._tap.touchend(e,t,i)&&(this._tapTime=e.timeStamp);}touchcancel(){this.reset();}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}class Ur{constructor(e,t,i){this._el=e,this._mousePan=t,this._touchPan=i;}enable(e){this._inertiaOptions=e||{},this._mousePan.enable(),this._touchPan.enable(),this._el.classList.add("mapboxgl-touch-drag-pan");}disable(){this._mousePan.disable(),this._touchPan.disable(),this._el.classList.remove("mapboxgl-touch-drag-pan");}isEnabled(){return this._mousePan.isEnabled()&&this._touchPan.isEnabled()}isActive(){return this._mousePan.isActive()||this._touchPan.isActive()}}class Nr{constructor(e,t,i){this._pitchWithRotate=e.pitchWithRotate,this._mouseRotate=t,this._mousePitch=i;}enable(){this._mouseRotate.enable(),this._pitchWithRotate&&this._mousePitch.enable();}disable(){this._mouseRotate.disable(),this._mousePitch.disable();}isEnabled(){return this._mouseRotate.isEnabled()&&(!this._pitchWithRotate||this._mousePitch.isEnabled())}isActive(){return this._mouseRotate.isActive()||this._mousePitch.isActive()}}class jr{constructor(e,t,i,o){this._el=e,this._touchZoom=t,this._touchRotate=i,this._tapDragZoom=o,this._rotationDisabled=!1,this._enabled=!0;}enable(e){this._touchZoom.enable(e),this._rotationDisabled||this._touchRotate.enable(e),this._tapDragZoom.enable(),this._el.classList.add("mapboxgl-touch-zoom-rotate");}disable(){this._touchZoom.disable(),this._touchRotate.disable(),this._tapDragZoom.disable(),this._el.classList.remove("mapboxgl-touch-zoom-rotate");}isEnabled(){return this._touchZoom.isEnabled()&&(this._rotationDisabled||this._touchRotate.isEnabled())&&this._tapDragZoom.isEnabled()}isActive(){return this._touchZoom.isActive()||this._touchRotate.isActive()||this._tapDragZoom.isActive()}disableRotation(){this._rotationDisabled=!0,this._touchRotate.disable();}enableRotation(){this._rotationDisabled=!1,this._touchZoom.isEnabled()&&this._touchRotate.enable();}}const Gr=e=>e.zoom||e.drag||e.pitch||e.rotate;class Zr extends e.Event{}class Vr{constructor(){this.constants=[1,1,.01],this.radius=0;}setup(t,i){const o=e.sub([],i,t);this.radius=e.length(o[2]<0?e.div([],o,this.constants):[o[0],o[1],0]);}projectRay(t){e.div(t,t,this.constants),e.normalize(t,t),e.mul$1(t,t,this.constants);const i=e.scale$2([],t,this.radius);if(i[2]>0){const t=e.scale$2([],[0,0,1],e.dot(i,[0,0,1])),o=e.scale$2([],e.normalize([],[i[0],i[1],0]),this.radius),r=e.add([],i,e.scale$2([],e.sub([],e.add([],o,t),i),2));i[0]=r[0],i[1]=r[1];}return i}}function Wr(e){return e.panDelta&&e.panDelta.mag()||e.zoomDelta||e.bearingDelta||e.pitchDelta}class Xr{constructor(t,i){this._map=t,this._el=this._map.getCanvasContainer(),this._handlers=[],this._handlersById={},this._changes=[],this._inertia=new rr(t),this._bearingSnap=i.bearingSnap,this._previousActiveHandlers={},this._trackingEllipsoid=new Vr,this._dragOrigin=null,this._eventsInProgress={},this._addDefaultHandlers(i),e.bindAll(["handleEvent","handleWindowEvent"],this);const o=this._el;this._listeners=[[o,"touchstart",{passive:!0}],[o,"touchmove",{passive:!1}],[o,"touchend",void 0],[o,"touchcancel",void 0],[o,"mousedown",void 0],[o,"mousemove",void 0],[o,"mouseup",void 0],[e.window.document,"mousemove",{capture:!0}],[e.window.document,"mouseup",void 0],[o,"mouseover",void 0],[o,"mouseout",void 0],[o,"dblclick",void 0],[o,"click",void 0],[o,"keydown",{capture:!1}],[o,"keyup",void 0],[o,"wheel",{passive:!1}],[o,"contextmenu",void 0],[e.window,"blur",void 0]];for(const[t,i,o]of this._listeners)t.addEventListener(i,t===e.window.document?this.handleWindowEvent:this.handleEvent,o);}destroy(){for(const[t,i,o]of this._listeners)t.removeEventListener(i,t===e.window.document?this.handleWindowEvent:this.handleEvent,o);}_addDefaultHandlers(e){const t=this._map,i=t.getCanvasContainer();this._add("mapEvent",new hr(t,e));const o=t.boxZoom=new _r(t,e);this._add("boxZoom",o);const r=new fr,n=new kr;t.doubleClickZoom=new Br(n,r),this._add("tapZoom",r),this._add("clickZoom",n);const s=new Fr;this._add("tapDragZoom",s);const a=t.touchPitch=new Dr(t);this._add("touchPitch",a);const l=new yr(e),c=new br(e);t.dragRotate=new Nr(e,l,c),this._add("mouseRotate",l,["mousePitch"]),this._add("mousePitch",c,["mouseRotate"]);const h=new xr(e),u=new wr(t,e);t.dragPan=new Ur(i,h,u),this._add("mousePan",h),this._add("touchPan",u,["touchZoom","touchRotate"]);const _=new Pr,d=new Mr;t.touchZoomRotate=new jr(i,d,_,s),this._add("touchRotate",_,["touchPan","touchZoom"]),this._add("touchZoom",d,["touchPan","touchRotate"]),this._add("blockableMapEvent",new ur(t));const p=t.scrollZoom=new Or(t,this);this._add("scrollZoom",p,["mousePan"]);const m=t.keyboard=new Ar;this._add("keyboard",m);for(const i of ["boxZoom","doubleClickZoom","tapDragZoom","touchPitch","dragRotate","dragPan","touchZoomRotate","scrollZoom","keyboard"])e.interactive&&e[i]&&t[i].enable(e[i]);}_add(e,t,i){this._handlers.push({handlerName:e,handler:t,allowed:i}),this._handlersById[e]=t;}stop(e){if(!this._updatingCamera){for(const{handler:e}of this._handlers)e.reset();this._inertia.clear(),this._fireEvents({},{},e),this._changes=[];}}isActive(){for(const{handler:e}of this._handlers)if(e.isActive())return !0;return !1}isZooming(){return !!this._eventsInProgress.zoom||this._map.scrollZoom.isZooming()}isRotating(){return !!this._eventsInProgress.rotate}isMoving(){return !!Gr(this._eventsInProgress)||this.isZooming()}_isDragging(){return !!this._eventsInProgress.drag}_blockedByActive(e,t,i){for(const o in e)if(o!==i&&(!t||t.indexOf(o)<0))return !0;return !1}handleWindowEvent(e){this.handleEvent(e,`${e.type}Window`);}_getMapTouches(e){const t=[];for(const i of e)this._el.contains(i.target)&&t.push(i);return t}handleEvent(e,t){this._updatingCamera=!0;const i="renderFrame"===e.type,o=i?void 0:e,r={needsRenderFrame:!1},n={},s={},a=e.touches?this._getMapTouches(e.touches):void 0,l=a?m(this._el,a):i?void 0:p(this._el,e);for(const{handlerName:i,handler:c,allowed:h}of this._handlers){if(!c.isEnabled())continue;let u;this._blockedByActive(s,h,i)?c.reset():c[t||e.type]&&(u=c[t||e.type](e,l,a),this.mergeHandlerResult(r,n,u,i,o),u&&u.needsRenderFrame&&this._triggerRenderFrame()),(u||c.isActive())&&(s[i]=c);}const c={};for(const e in this._previousActiveHandlers)s[e]||(c[e]=o);this._previousActiveHandlers=s,(Object.keys(c).length||Wr(r))&&(this._changes.push([r,n,c]),this._triggerRenderFrame()),(Object.keys(s).length||Wr(r))&&this._map._stop(!0),this._updatingCamera=!1;const{cameraAnimation:h}=r;h&&(this._inertia.clear(),this._fireEvents({},{},!0),this._changes=[],h(this._map));}mergeHandlerResult(t,i,o,r,n){if(!o)return;e.extend(t,o);const s={handlerName:r,originalEvent:o.originalEvent||n};void 0!==o.zoomDelta&&(i.zoom=s),void 0!==o.panDelta&&(i.drag=s),void 0!==o.pitchDelta&&(i.pitch=s),void 0!==o.bearingDelta&&(i.rotate=s);}_applyChanges(){const t={},i={},o={};for(const[r,n,s]of this._changes)r.panDelta&&(t.panDelta=(t.panDelta||new e.Point(0,0))._add(r.panDelta)),r.zoomDelta&&(t.zoomDelta=(t.zoomDelta||0)+r.zoomDelta),r.bearingDelta&&(t.bearingDelta=(t.bearingDelta||0)+r.bearingDelta),r.pitchDelta&&(t.pitchDelta=(t.pitchDelta||0)+r.pitchDelta),void 0!==r.around&&(t.around=r.around),void 0!==r.aroundCoord&&(t.aroundCoord=r.aroundCoord),void 0!==r.pinchAround&&(t.pinchAround=r.pinchAround),r.noInertia&&(t.noInertia=r.noInertia),e.extend(i,n),e.extend(o,s);this._updateMapTransform(t,i,o),this._changes=[];}_updateMapTransform(t,i,o){const r=this._map,n=r.transform,s=e=>[e.x,e.y,e.z];if((e=>{const t=this._eventsInProgress.drag;return t&&!this._handlersById[t.handlerName].isActive()})()&&!Wr(t)){const e=n.zoom;n.cameraElevationReference="sea",n.recenterOnTerrain(),n.cameraElevationReference="ground",e!==n.zoom&&this._map._update(!0);}if(n._isCameraConstrained&&r._stop(!0),!Wr(t))return void this._fireEvents(i,o,!0);let{panDelta:a,zoomDelta:l,bearingDelta:c,pitchDelta:h,around:u,aroundCoord:_,pinchAround:d}=t;n._isCameraConstrained&&(l>0&&(l=0),n._isCameraConstrained=!1),void 0!==d&&(u=d),(l||(e=>i[e]&&!this._eventsInProgress[e])("drag"))&&u&&(this._dragOrigin=s(n.pointCoordinate3D(u)),this._trackingEllipsoid.setup(n._camera.position,this._dragOrigin)),n.cameraElevationReference="sea",r._stop(!0),u=u||r.transform.centerPoint,c&&(n.bearing+=c),h&&(n.pitch+=h),n._updateCameraState();const p=[0,0,0];if(a)if("mercator"===n.projection.name){const e=this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u).dir),t=this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u.sub(a)).dir);p[0]=t[0]-e[0],p[1]=t[1]-e[1];}else {const t=n.pointCoordinate(u);if("globe"===n.projection.name){a=a.rotate(-n.angle);const i=n._pixelsPerMercatorPixel/n.worldSize;p[0]=-a.x*e.mercatorScale(e.latFromMercatorY(t.y))*i,p[1]=-a.y*e.mercatorScale(n.center.lat)*i;}else {const e=n.pointCoordinate(u.sub(a));t&&e&&(p[0]=e.x-t.x,p[1]=e.y-t.y);}}const m=n.zoom,f=[0,0,0];if(l){const t=s(_||n.pointCoordinate3D(u)),i={dir:e.normalize([],e.sub([],t,n._camera.position))};if(i.dir[2]<0){const o=n.zoomDeltaToMovement(t,l);e.scale$2(f,i.dir,o);}}const g=e.add(p,p,f);n._translateCameraConstrained(g),l&&Math.abs(n.zoom-m)>1e-4&&n.recenterOnTerrain(),n.cameraElevationReference="ground",this._map._update(),t.noInertia||this._inertia.record(t),this._fireEvents(i,o,!0);}_fireEvents(t,i,o){const r=Gr(this._eventsInProgress),n=Gr(t),s={};for(const e in t){const{originalEvent:i}=t[e];this._eventsInProgress[e]||(s[`${e}start`]=i),this._eventsInProgress[e]=t[e];}!r&&n&&this._fireEvent("movestart",n.originalEvent);for(const e in s)this._fireEvent(e,s[e]);n&&this._fireEvent("move",n.originalEvent);for(const e in t){const{originalEvent:i}=t[e];this._fireEvent(e,i);}const a={};let l;for(const e in this._eventsInProgress){const{handlerName:t,originalEvent:o}=this._eventsInProgress[e];this._handlersById[t].isActive()||(delete this._eventsInProgress[e],l=i[t]||o,a[`${e}end`]=l);}for(const e in a)this._fireEvent(e,a[e]);const c=Gr(this._eventsInProgress);if(o&&(r||n)&&!c){this._updatingCamera=!0;const t=this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions),i=e=>0!==e&&-this._bearingSnap<e&&e<this._bearingSnap;t?(i(t.bearing||this._map.getBearing())&&(t.bearing=0),this._map.easeTo(t,{originalEvent:l})):(this._map.fire(new e.Event("moveend",{originalEvent:l})),i(this._map.getBearing())&&this._map.resetNorth()),this._updatingCamera=!1;}}_fireEvent(t,i){this._map.fire(new e.Event(t,i?{originalEvent:i}:{}));}_requestFrame(){return this._map.triggerRepaint(),this._map._renderTaskQueue.add((e=>{this._frameId=void 0,this.handleEvent(new Zr("renderFrame",{timeStamp:e})),this._applyChanges();}))}_triggerRenderFrame(){void 0===this._frameId&&(this._frameId=this._requestFrame());}}const qr="map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";class $r extends e.Evented{constructor(t,i){super(),this._moving=!1,this._zooming=!1,this.transform=t,this._bearingSnap=i.bearingSnap,this._respectPrefersReducedMotion=!1!==i.respectPrefersReducedMotion,e.bindAll(["_renderFrameCallback"],this);}getCenter(){return new e.LngLat(this.transform.center.lng,this.transform.center.lat)}setCenter(e,t){return this.jumpTo({center:e},t)}panBy(t,i,o){return t=e.Point.convert(t).mult(-1),this.panTo(this.transform.center,e.extend({offset:t},i),o)}panTo(t,i,o){return this.easeTo(e.extend({center:t},i),o)}getZoom(){return this.transform.zoom}setZoom(e,t){return this.jumpTo({zoom:e},t),this}zoomTo(t,i,o){return this.easeTo(e.extend({zoom:t},i),o)}zoomIn(e,t){return this.zoomTo(this.getZoom()+1,e,t),this}zoomOut(e,t){return this.zoomTo(this.getZoom()-1,e,t),this}getBearing(){return this.transform.bearing}setBearing(e,t){return this.jumpTo({bearing:e},t),this}getPadding(){return this.transform.padding}setPadding(e,t){return this.jumpTo({padding:e},t),this}rotateTo(t,i,o){return this.easeTo(e.extend({bearing:t},i),o)}resetNorth(t,i){return this.rotateTo(0,e.extend({duration:1e3},t),i),this}resetNorthPitch(t,i){return this.easeTo(e.extend({bearing:0,pitch:0,duration:1e3},t),i),this}snapToNorth(e,t){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(e,t):this}getPitch(){return this.transform.pitch}setPitch(e,t){return this.jumpTo({pitch:e},t),this}cameraForBounds(t,i){t=e.LngLatBounds.convert(t);const o=i&&i.bearing||0,r=i&&i.pitch||0,n=t.getNorthWest(),s=t.getSouthEast();return this._cameraForBounds(this.transform,n,s,o,r,i)}_extendCameraOptions(t){const i={top:0,bottom:0,right:0,left:0};if("number"==typeof(t=e.extend({padding:i,offset:[0,0],maxZoom:this.transform.maxZoom},t)).padding){const e=t.padding;t.padding={top:e,bottom:e,right:e,left:e};}return t.padding=e.extend(i,t.padding),t}_minimumAABBFrustumDistance(e,t){const i=t.max[0]-t.min[0],o=t.max[1]-t.min[1];return i/o>e.aspect?i/(2*Math.tan(.5*e.fovX)*e.aspect):o/(2*Math.tan(.5*e.fovY)*e.aspect)}_cameraForBoundsOnGlobe(t,i,o,r,n,s){const a=t.clone(),l=this._extendCameraOptions(s);a.bearing=r,a.pitch=n;const c=e.LngLat.convert(i),h=e.LngLat.convert(o),u=.5*(c.lat+h.lat),_=.5*(c.lng+h.lng),d=e.latLngToECEF(u,_),p=e.normalize([],d),m=e.normalize([],e.cross([],p,[0,1,0])),f=e.cross([],m,p),g=[m[0],m[1],m[2],0,f[0],f[1],f[2],0,p[0],p[1],p[2],0,0,0,0,1],v=[d,e.latLngToECEF(c.lat,c.lng),e.latLngToECEF(h.lat,c.lng),e.latLngToECEF(h.lat,h.lng),e.latLngToECEF(c.lat,h.lng),e.latLngToECEF(u,c.lng),e.latLngToECEF(u,h.lng),e.latLngToECEF(c.lat,_),e.latLngToECEF(h.lat,_)];let x=e.Aabb.fromPoints(v.map((t=>[e.dot(m,t),e.dot(f,t),e.dot(p,t)])));const y=e.transformMat4([],x.center,g);0===e.squaredLength(y)&&e.set(y,0,0,1),e.normalize(y,y),e.scale$2(y,y,e.GLOBE_RADIUS),a.center=e.ecefToLatLng(y);const b=a.getWorldToCameraMatrix(),w=e.invert(new Float64Array(16),b);x=e.Aabb.applyTransform(x,e.multiply([],b,g)),e.transformMat4(y,y,b);const T=.5*(x.max[2]-x.min[2]),E=this._minimumAABBFrustumDistance(a,x),C=e.scale$2([],[0,0,1],T),M=e.add(C,y,C),I=E+(0===a.pitch?0:e.distance(y,M)),P=a.globeCenterInViewSpace,S=e.sub([],y,[P[0],P[1],P[2]]);e.normalize(S,S),e.scale$2(S,S,I);const D=e.add([],y,S);e.transformMat4(D,D,w);const L=e.earthRadius/e.GLOBE_RADIUS,A=e.length(D),z=e.mercatorZfromAltitude(Math.max(A*L-e.earthRadius,Number.EPSILON),0),R=Math.min(a.zoomFromMercatorZAdjusted(z),l.maxZoom);return R>.5*(e.GLOBE_ZOOM_THRESHOLD_MIN+e.GLOBE_ZOOM_THRESHOLD_MAX)?(a.setProjection({name:"mercator"}),a.zoom=R,this._cameraForBounds(a,i,o,r,n,s)):{center:a.center,zoom:R,bearing:r,pitch:n}}queryTerrainElevation(t,i){const o=this.transform.elevation;return o?(i=e.extend({},{exaggerated:!0},i),o.getAtPoint(e.MercatorCoordinate.fromLngLat(t),null,i.exaggerated)):null}_cameraForBounds(t,i,o,r,n,s){if("globe"===t.projection.name)return this._cameraForBoundsOnGlobe(t,i,o,r,n,s);const a=t.clone(),l=this._extendCameraOptions(s),c=a.padding;a.bearing=r,a.pitch=n;const h=e.LngLat.convert(i),u=e.LngLat.convert(o),_=new e.LngLat(h.lng,u.lat),d=new e.LngLat(u.lng,h.lat),p=a.project(h),m=a.project(u),f=this.queryTerrainElevation(h),g=this.queryTerrainElevation(u),v=this.queryTerrainElevation(_),x=this.queryTerrainElevation(d),y=[[p.x,p.y,Math.min(f||0,g||0,v||0,x||0)],[m.x,m.y,Math.max(f||0,g||0,v||0,x||0)]];let b=e.Aabb.fromPoints(y);const w=a.getWorldToCameraMatrix(),T=e.invert(new Float64Array(16),w);b=e.Aabb.applyTransform(b,w);const E=e.sub([],b.max,b.min),C=c.left||0,M=c.right||0,I=c.bottom||0,P=c.top||0,{left:S,right:D,top:L,bottom:A}=l.padding,z=.5*(C+M),R=.5*(P+I),O=Math.min(a.scaleZoom(a.scale*Math.min((a.width-(C+M+S+D))/E[0],(a.height-(I+P+A+L))/E[1])),l.maxZoom),B=a.scale/a.zoomScale(O);b=new e.Aabb([b.min[0]-(S+z)*B,b.min[1]-(A+R)*B,b.min[2]],[b.max[0]+(D+z)*B,b.max[1]+(L+R)*B,b.max[2]]);const k=.5*E[2],F=this._minimumAABBFrustumDistance(a,b),U=[0,0,1,0];e.transformMat4$1(U,U,w),e.normalize$2(U,U);const N=e.scale$2([],U,F+k),j=e.add([],b.center,N),G=("number"==typeof l.offset.x&&"number"==typeof l.offset.y?new e.Point(l.offset.x,l.offset.y):e.Point.convert(l.offset)).rotate(-e.degToRad(r));b.center[0]-=G.x*B,b.center[1]+=G.y*B,e.transformMat4(b.center,b.center,T),e.transformMat4(j,j,T);const Z=[b.center[0],b.center[1],j[2]*a.pixelsPerMeter];e.scale$2(Z,Z,1/a.worldSize);const V=e.lngFromMercatorX(Z[0]),W=e.latFromMercatorY(Z[1]),X=Math.min(a._zoomFromMercatorZ(Z[2]),l.maxZoom),q=new e.LngLat(V,W);return a.mercatorFromTransition&&X<.5*(e.GLOBE_ZOOM_THRESHOLD_MIN+e.GLOBE_ZOOM_THRESHOLD_MAX)?(a.setProjection({name:"globe"}),a.zoom=X,this._cameraForBounds(a,i,o,r,n,s)):{center:q,zoom:X,bearing:r,pitch:n}}fitBounds(e,t,i){const o=this.cameraForBounds(e,t);return this._fitInternal(o,t,i)}fitScreenCoordinates(t,i,o,r,n){const s=e.Point.convert(t),a=e.Point.convert(i),l=new e.Point(Math.min(s.x,a.x),Math.min(s.y,a.y)),c=new e.Point(Math.max(s.x,a.x),Math.max(s.y,a.y));if("mercator"===this.transform.projection.name&&this.transform.anyCornerOffEdge(s,a))return this;const h=this.transform.pointLocation3D(l),u=this.transform.pointLocation3D(c),_=this.transform.pointLocation3D(new e.Point(l.x,c.y)),d=this.transform.pointLocation3D(new e.Point(c.x,l.y)),p=[Math.min(h.lng,u.lng,_.lng,d.lng),Math.min(h.lat,u.lat,_.lat,d.lat)],m=[Math.max(h.lng,u.lng,_.lng,d.lng),Math.max(h.lat,u.lat,_.lat,d.lat)],f=r&&r.pitch?r.pitch:this.getPitch(),g=this._cameraForBounds(this.transform,p,m,o,f,r);return this._fitInternal(g,r,n)}_fitInternal(t,i,o){return t?(delete(i=e.extend(t,i)).padding,i.linear?this.easeTo(i,o):this.flyTo(i,o)):this}jumpTo(t,i){this.stop();const o=t.preloadOnly?this.transform.clone():this.transform;let r=!1,n=!1,s=!1;return "zoom"in t&&o.zoom!==+t.zoom&&(r=!0,o.zoom=+t.zoom),void 0!==t.center&&(o.center=e.LngLat.convert(t.center)),"bearing"in t&&o.bearing!==+t.bearing&&(n=!0,o.bearing=+t.bearing),"pitch"in t&&o.pitch!==+t.pitch&&(s=!0,o.pitch=+t.pitch),null==t.padding||o.isPaddingEqual(t.padding)||(o.padding=t.padding),t.preloadOnly?(this._preloadTiles(o),this):(this.fire(new e.Event("movestart",i)).fire(new e.Event("move",i)),r&&this.fire(new e.Event("zoomstart",i)).fire(new e.Event("zoom",i)).fire(new e.Event("zoomend",i)),n&&this.fire(new e.Event("rotatestart",i)).fire(new e.Event("rotate",i)).fire(new e.Event("rotateend",i)),s&&this.fire(new e.Event("pitchstart",i)).fire(new e.Event("pitch",i)).fire(new e.Event("pitchend",i)),this.fire(new e.Event("moveend",i)))}getFreeCameraOptions(){return this.transform.projection.supportsFreeCamera||e.warnOnce(qr),this.transform.getFreeCameraOptions()}setFreeCameraOptions(t,i){const o=this.transform;if(!o.projection.supportsFreeCamera)return e.warnOnce(qr),this;this.stop();const r=o.zoom,n=o.pitch,s=o.bearing;o.setFreeCameraOptions(t);const a=r!==o.zoom,l=n!==o.pitch,c=s!==o.bearing;return this.fire(new e.Event("movestart",i)).fire(new e.Event("move",i)),a&&this.fire(new e.Event("zoomstart",i)).fire(new e.Event("zoom",i)).fire(new e.Event("zoomend",i)),c&&this.fire(new e.Event("rotatestart",i)).fire(new e.Event("rotate",i)).fire(new e.Event("rotateend",i)),l&&this.fire(new e.Event("pitchstart",i)).fire(new e.Event("pitch",i)).fire(new e.Event("pitchend",i)),this.fire(new e.Event("moveend",i)),this}easeTo(t,i){this._stop(!1,t.easeId),(!1===(t=e.extend({offset:[0,0],duration:500,easing:e.ease},t)).animate||this._prefersReducedMotion(t))&&(t.duration=0);const o=this.transform,r=this.getZoom(),n=this.getBearing(),s=this.getPitch(),a=this.getPadding(),l="zoom"in t?+t.zoom:r,c="bearing"in t?this._normalizeBearing(t.bearing,n):n,h="pitch"in t?+t.pitch:s,u="padding"in t?t.padding:o.padding,_=e.Point.convert(t.offset);let d,p,m;if("globe"===o.projection.name){const i=e.MercatorCoordinate.fromLngLat(o.center),r=_.rotate(-o.angle);i.x+=r.x/o.worldSize,i.y+=r.y/o.worldSize;const n=i.toLngLat(),s=e.LngLat.convert(t.center||n);this._normalizeCenter(s),d=o.centerPoint.add(r),p=new e.Point(i.x,i.y).mult(o.worldSize),m=new e.Point(e.mercatorXfromLng(s.lng),e.mercatorYfromLat(s.lat)).mult(o.worldSize).sub(p);}else {d=o.centerPoint.add(_);const i=o.pointLocation(d),r=e.LngLat.convert(t.center||i);this._normalizeCenter(r),p=o.project(i),m=o.project(r).sub(p);}const f=o.zoomScale(l-r);let g,v;t.around&&(g=e.LngLat.convert(t.around),v=o.locationPoint(g));const x=this._zooming||l!==r,y=this._rotating||n!==c,b=this._pitching||h!==s,w=!o.isPaddingEqual(u),T=o=>T=>{if(x&&(o.zoom=e.number(r,l,T)),y&&(o.bearing=e.number(n,c,T)),b&&(o.pitch=e.number(s,h,T)),w&&(o.interpolatePadding(a,u,T),d=o.centerPoint.add(_)),g)o.setLocationAtPoint(g,v);else {const e=o.zoomScale(o.zoom-r),t=l>r?Math.min(2,f):Math.max(.5,f),i=Math.pow(t,1-T),n=o.unproject(p.add(m.mult(T*i)).mult(e));o.setLocationAtPoint(o.renderWorldCopies?n.wrap():n,d);}return t.preloadOnly||this._fireMoveEvents(i),o};if(t.preloadOnly){const e=this._emulate(T,t.duration,o);return this._preloadTiles(e),this}const E={moving:this._moving,zooming:this._zooming,rotating:this._rotating,pitching:this._pitching};return this._zooming=x,this._rotating=y,this._pitching=b,this._padding=w,this._easeId=t.easeId,this._prepareEase(i,t.noMoveStart,E),this._ease(T(o),(e=>{o.recenterOnTerrain(),this._afterEase(i,e);}),t),this}_prepareEase(t,i,o={}){this._moving=!0,this.transform.cameraElevationReference="sea",i||o.moving||this.fire(new e.Event("movestart",t)),this._zooming&&!o.zooming&&this.fire(new e.Event("zoomstart",t)),this._rotating&&!o.rotating&&this.fire(new e.Event("rotatestart",t)),this._pitching&&!o.pitching&&this.fire(new e.Event("pitchstart",t));}_fireMoveEvents(t){this.fire(new e.Event("move",t)),this._zooming&&this.fire(new e.Event("zoom",t)),this._rotating&&this.fire(new e.Event("rotate",t)),this._pitching&&this.fire(new e.Event("pitch",t));}_afterEase(t,i){if(this._easeId&&i&&this._easeId===i)return;this._easeId=void 0,this.transform.cameraElevationReference="ground";const o=this._zooming,r=this._rotating,n=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,this._padding=!1,o&&this.fire(new e.Event("zoomend",t)),r&&this.fire(new e.Event("rotateend",t)),n&&this.fire(new e.Event("pitchend",t)),this.fire(new e.Event("moveend",t));}flyTo(t,i){if(this._prefersReducedMotion(t)){const o=e.pick(t,["center","zoom","bearing","pitch","around"]);return this.jumpTo(o,i)}this.stop(),t=e.extend({offset:[0,0],speed:1.2,curve:1.42,easing:e.ease},t);const o=this.transform,r=this.getZoom(),n=this.getBearing(),s=this.getPitch(),a=this.getPadding(),l="zoom"in t?e.clamp(+t.zoom,o.minZoom,o.maxZoom):r,c="bearing"in t?this._normalizeBearing(t.bearing,n):n,h="pitch"in t?+t.pitch:s,u="padding"in t?t.padding:o.padding,_=o.zoomScale(l-r),d=e.Point.convert(t.offset);let p=o.centerPoint.add(d);const m=o.pointLocation(p),f=e.LngLat.convert(t.center||m);this._normalizeCenter(f);const g=o.project(m),v=o.project(f).sub(g);let x=t.curve;const y=Math.max(o.width,o.height),b=y/_,w=v.mag();if("minZoom"in t){const i=e.clamp(Math.min(t.minZoom,r,l),o.minZoom,o.maxZoom),n=y/o.zoomScale(i-r);x=Math.sqrt(n/w*2);}const T=x*x;function E(e){const t=(b*b-y*y+(e?-1:1)*T*T*w*w)/(2*(e?b:y)*T*w);return Math.log(Math.sqrt(t*t+1)-t)}function C(e){return (Math.exp(e)-Math.exp(-e))/2}function M(e){return (Math.exp(e)+Math.exp(-e))/2}const I=E(0);let P=function(e){return M(I)/M(I+x*e)},S=function(e){return y*((M(I)*(C(t=I+x*e)/M(t))-C(I))/T)/w;var t;},D=(E(1)-I)/x;if(Math.abs(w)<1e-6||!isFinite(D)){if(Math.abs(y-b)<1e-6)return this.easeTo(t,i);const e=b<y?-1:1;D=Math.abs(Math.log(b/y))/x,S=function(){return 0},P=function(t){return Math.exp(e*x*t)};}t.duration="duration"in t?+t.duration:1e3*D/("screenSpeed"in t?+t.screenSpeed/x:+t.speed),t.maxDuration&&t.duration>t.maxDuration&&(t.duration=0);const L=n!==c,A=h!==s,z=!o.isPaddingEqual(u),R=o=>_=>{const m=_*D,x=1/P(m);o.zoom=1===_?l:r+o.scaleZoom(x),L&&(o.bearing=e.number(n,c,_)),A&&(o.pitch=e.number(s,h,_)),z&&(o.interpolatePadding(a,u,_),p=o.centerPoint.add(d));const y=1===_?f:o.unproject(g.add(v.mult(S(m))).mult(x));return o.setLocationAtPoint(o.renderWorldCopies?y.wrap():y,p),o._updateCameraOnTerrain(),t.preloadOnly||this._fireMoveEvents(i),o};if(t.preloadOnly){const e=this._emulate(R,t.duration,o);return this._preloadTiles(e),this}return this._zooming=!0,this._rotating=L,this._pitching=A,this._padding=z,this._prepareEase(i,!1),this._ease(R(o),(()=>this._afterEase(i)),t),this}isEasing(){return !!this._easeFrameId}stop(){return this._stop()}_stop(e,t){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),this._easeFrameId=void 0,this._onEaseFrame=void 0),this._onEaseEnd){const e=this._onEaseEnd;this._onEaseEnd=void 0,e.call(this,t);}if(!e){const e=this.handlers;e&&e.stop(!1);}return this}_ease(t,i,o){!1===o.animate||0===o.duration?(t(1),i()):(this._easeStart=e.exported.now(),this._easeOptions=o,this._onEaseFrame=t,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));}_renderFrameCallback(){const t=Math.min((e.exported.now()-this._easeStart)/this._easeOptions.duration,1),i=this._onEaseFrame;i&&i(this._easeOptions.easing(t)),t<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();}_normalizeBearing(t,i){t=e.wrap(t,-180,180);const o=Math.abs(t-i);return Math.abs(t-360-i)<o&&(t-=360),Math.abs(t+360-i)<o&&(t+=360),t}_normalizeCenter(e){const t=this.transform;if(!t.renderWorldCopies||t.maxBounds)return;const i=e.lng-t.center.lng;e.lng+=i>180?-360:i<-180?360:0;}_prefersReducedMotion(t){return this._respectPrefersReducedMotion&&e.exported.prefersReducedMotion&&!(t&&t.essential)}_emulate(e,t,i){const o=Math.ceil(15*t/1e3),r=[],n=e(i.clone());for(let e=0;e<=o;e++){const t=n(e/o);r.push(t.clone());}return r}}class Hr{constructor(t={}){this.options=t,e.bindAll(["_toggleAttribution","_updateEditLink","_updateData","_updateCompact"],this);}getDefaultPosition(){return "bottom-right"}onAdd(e){const t=this.options&&this.options.compact;return this._map=e,this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._compactButton=n("button","mapboxgl-ctrl-attrib-button",this._container),n("span","mapboxgl-ctrl-icon",this._compactButton).setAttribute("aria-hidden","true"),this._compactButton.type="button",this._compactButton.addEventListener("click",this._toggleAttribution),this._setElementTitle(this._compactButton,"ToggleAttribution"),this._innerContainer=n("div","mapboxgl-ctrl-attrib-inner",this._container),this._innerContainer.setAttribute("role","list"),t&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===t&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container}onRemove(){this._container.remove(),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0,this._attribHTML=void 0;}_setElementTitle(e,t){const i=this._map._getUIString(`AttributionControl.${t}`);e.setAttribute("aria-label",i),e.removeAttribute("title"),e.firstElementChild&&e.firstElementChild.setAttribute("title",i);}_toggleAttribution(){this._container.classList.contains("mapboxgl-compact-show")?(this._container.classList.remove("mapboxgl-compact-show"),this._compactButton.setAttribute("aria-expanded","false")):(this._container.classList.add("mapboxgl-compact-show"),this._compactButton.setAttribute("aria-expanded","true"));}_updateEditLink(){let t=this._editLink;t||(t=this._editLink=this._container.querySelector(".mapbox-improve-map"));const i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:this._map._requestManager._customAccessToken||e.config.ACCESS_TOKEN}];if(t){const o=i.reduce(((e,t,o)=>(t.value&&(e+=`${t.key}=${t.value}${o<i.length-1?"&":""}`),e)),"?");t.href=`${e.config.FEEDBACK_URL}/${o}#${Jo(this._map,!0)}`,t.rel="noopener nofollow",this._setElementTitle(t,"MapFeedback");}}_updateData(e){!e||"metadata"!==e.sourceDataType&&"visibility"!==e.sourceDataType&&"style"!==e.dataType||(this._updateAttributions(),this._updateEditLink());}_updateAttributions(){if(!this._map.style)return;let e=[];if(this._map.style.stylesheet){const e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}const t=this._map.style._sourceCaches;for(const i in t){const o=t[i];if(o.used){const t=o.getSource();t.attribution&&e.indexOf(t.attribution)<0&&e.push(t.attribution);}}e.sort(((e,t)=>e.length-t.length)),e=e.filter(((t,i)=>{for(let o=i+1;o<e.length;o++)if(e[o].indexOf(t)>=0)return !1;return !0})),this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?e=[...this.options.customAttribution,...e]:e.unshift(this.options.customAttribution));const i=e.join(" | ");i!==this._attribHTML&&(this._attribHTML=i,e.length?(this._innerContainer.innerHTML=i,this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null);}_updateCompact(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact","mapboxgl-compact-show");}}class Yr{constructor(){e.bindAll(["_updateLogo","_updateCompact"],this);}onAdd(e){this._map=e,this._container=n("div","mapboxgl-ctrl");const t=n("a","mapboxgl-ctrl-logo");return t.target="_blank",t.rel="noopener nofollow",t.href="https://www.mapbox.com/",t.setAttribute("aria-label",this._map._getUIString("LogoControl.Title")),t.setAttribute("rel","noopener nofollow"),this._container.appendChild(t),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container}onRemove(){this._container.remove(),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);}getDefaultPosition(){return "bottom-left"}_updateLogo(e){e&&"metadata"!==e.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");}_logoRequired(){if(!this._map.style)return !0;const e=this._map.style._sourceCaches;if(0===Object.entries(e).length)return !0;for(const t in e){const i=e[t].getSource();if(i.hasOwnProperty("mapbox_logo")&&!i.mapbox_logo)return !1}return !0}_updateCompact(){const e=this._container.children;if(e.length){const t=e[0];this._map.getCanvasContainer().offsetWidth<250?t.classList.add("mapboxgl-compact"):t.classList.remove("mapboxgl-compact");}}}class Kr{constructor(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;}add(e){const t=++this._id;return this._queue.push({callback:e,id:t,cancelled:!1}),t}remove(e){const t=this._currentlyRunning,i=t?this._queue.concat(t):this._queue;for(const t of i)if(t.id===e)return void(t.cancelled=!0)}run(e=0){const t=this._currentlyRunning=this._queue;this._queue=[];for(const i of t)if(!i.cancelled&&(i.callback(e),this._cleared))break;this._cleared=!1,this._currentlyRunning=!1;}clear(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];}}function Jr(t,i,o){if(t=new e.LngLat(t.lng,t.lat),i){const r=new e.LngLat(t.lng-360,t.lat),n=new e.LngLat(t.lng+360,t.lat),s=360*Math.ceil(Math.abs(t.lng-o.center.lng)/360),a=o.locationPoint(t).distSqr(i),l=i.x<0||i.y<0||i.x>o.width||i.y>o.height;o.locationPoint(r).distSqr(i)<a&&(l||Math.abs(r.lng-o.center.lng)<s)?t=r:o.locationPoint(n).distSqr(i)<a&&(l||Math.abs(n.lng-o.center.lng)<s)&&(t=n);}for(;Math.abs(t.lng-o.center.lng)>180;){const e=o.locationPoint(t);if(e.x>=0&&e.y>=0&&e.x<=o.width&&e.y<=o.height)break;t.lng>o.center.lng?t.lng-=360:t.lng+=360;}return t}const Qr={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};class en extends e.Evented{constructor(t,i){if(super(),(t instanceof e.window.HTMLElement||i)&&(t=e.extend({element:t},i)),e.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick","_onKeyPress","_clearFadeTimer"],this),this._anchor=t&&t.anchor||"center",this._color=t&&t.color||"#3FB1CE",this._scale=t&&t.scale||1,this._draggable=t&&t.draggable||!1,this._clickTolerance=t&&t.clickTolerance||0,this._isDragging=!1,this._state="inactive",this._rotation=t&&t.rotation||0,this._rotationAlignment=t&&t.rotationAlignment||"auto",this._pitchAlignment=t&&t.pitchAlignment&&t.pitchAlignment||"auto",this._updateMoving=()=>this._update(!0),this._occludedOpacity=t&&t.occludedOpacity||.2,t&&t.element)this._element=t.element,this._offset=e.Point.convert(t&&t.offset||[0,0]);else {this._defaultMarker=!0,this._element=n("div");const i=41,o=27,r=s("svg",{display:"block",height:i*this._scale+"px",width:o*this._scale+"px",viewBox:`0 0 ${o} ${i}`},this._element),a=s("radialGradient",{id:"shadowGradient"},s("defs",{},r));s("stop",{offset:"10%","stop-opacity":.4},a),s("stop",{offset:"100%","stop-opacity":.05},a),s("ellipse",{cx:13.5,cy:34.8,rx:10.5,ry:5.25,fill:"url(#shadowGradient)"},r),s("path",{fill:this._color,d:"M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"},r),s("path",{opacity:.25,d:"M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"},r),s("circle",{fill:"white",cx:13.5,cy:13.5,r:5.5},r),this._offset=e.Point.convert(t&&t.offset||[0,-14]);}this._element.hasAttribute("aria-label")||this._element.setAttribute("aria-label","Map marker"),this._element.classList.add("mapboxgl-marker"),this._element.addEventListener("dragstart",(e=>{e.preventDefault();})),this._element.addEventListener("mousedown",(e=>{e.preventDefault();}));const o=this._element.classList;for(const e in Qr)o.remove(`mapboxgl-marker-anchor-${e}`);o.add(`mapboxgl-marker-anchor-${this._anchor}`),this._popup=null;}addTo(e){return e===this._map||(this.remove(),this._map=e,e.getCanvasContainer().appendChild(this._element),e.on("move",this._updateMoving),e.on("moveend",this._update),e.on("remove",this._clearFadeTimer),e._addMarker(this),this.setDraggable(this._draggable),this._update(),e.on("click",this._onMapClick)),this}remove(){const e=this._map;return e&&(e.off("click",this._onMapClick),e.off("move",this._updateMoving),e.off("moveend",this._update),e.off("mousedown",this._addDragHandler),e.off("touchstart",this._addDragHandler),e.off("mouseup",this._onUp),e.off("touchend",this._onUp),e.off("mousemove",this._onMove),e.off("touchmove",this._onMove),e.off("remove",this._clearFadeTimer),e._removeMarker(this),this._map=void 0),this._clearFadeTimer(),this._element.remove(),this._popup&&this._popup.remove(),this}getLngLat(){return this._lngLat}setLngLat(t){return this._lngLat=e.LngLat.convert(t),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(!0),this}getElement(){return this._element}setPopup(e){if(this._popup&&(this._popup.remove(),this._popup=null,this._element.removeAttribute("role"),this._element.removeEventListener("keypress",this._onKeyPress),this._originalTabIndex||this._element.removeAttribute("tabindex")),e){if(!("offset"in e.options)){const t=38.1,i=13.5,o=Math.sqrt(Math.pow(i,2)/2);e.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-t],"bottom-left":[o,-1*(t-i+o)],"bottom-right":[-o,-1*(t-i+o)],left:[i,-1*(t-i)],right:[-i,-1*(t-i)]}:this._offset;}this._popup=e,e._marker=this,this._lngLat&&this._popup.setLngLat(this._lngLat),this._element.setAttribute("role","button"),this._originalTabIndex=this._element.getAttribute("tabindex"),this._originalTabIndex||this._element.setAttribute("tabindex","0"),this._element.addEventListener("keypress",this._onKeyPress),this._element.setAttribute("aria-expanded","false");}return this}_onKeyPress(e){const t=e.code,i=e.charCode||e.keyCode;"Space"!==t&&"Enter"!==t&&32!==i&&13!==i||this.togglePopup();}_onMapClick(e){const t=e.originalEvent.target,i=this._element;this._popup&&(t===i||i.contains(t))&&this.togglePopup();}getPopup(){return this._popup}togglePopup(){const e=this._popup;return e?(e.isOpen()?(e.remove(),this._element.setAttribute("aria-expanded","false")):this._map&&(e.addTo(this._map),this._element.setAttribute("aria-expanded","true")),this):this}_behindTerrain(){const e=this._map,t=this._pos;if(!e||!t)return !1;const i=e.unproject(t),o=e.getFreeCameraOptions();if(!o.position)return !1;const r=o.position.toLngLat();return r.distanceTo(i)<.9*r.distanceTo(this._lngLat)}_evaluateOpacity(){const t=this._map;if(!t)return;const i=this._pos;if(!i||i.x<0||i.x>t.transform.width||i.y<0||i.y>t.transform.height)return void this._clearFadeTimer();const o=t.unproject(i);let r;t._showingGlobe()&&e.isLngLatBehindGlobe(t.transform,this._lngLat)?r=0:(r=1-t._queryFogOpacity(o),t.transform._terrainEnabled()&&t.getTerrain()&&this._behindTerrain()&&(r*=this._occludedOpacity)),this._element.style.opacity=`${r}`,this._element.style.pointerEvents=r>0?"auto":"none",this._popup&&this._popup._setOpacity(r),this._fadeTimer=null;}_clearFadeTimer(){this._fadeTimer&&(clearTimeout(this._fadeTimer),this._fadeTimer=null);}_updateDOM(){const e=this._pos;if(!e||!this._map)return;const t=this._offset.mult(this._scale);this._element.style.transform=`\n            translate(${e.x}px,${e.y}px)\n            ${Qr[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t.x}px,${t.y}px)\n        `;}_calculateXYTransform(){const t=this._pos,i=this._map,o=this.getPitchAlignment();if(!i||!t||"map"!==o)return "";if(!i._showingGlobe()){const e=i.getPitch();return e?`rotateX(${e}deg)`:""}const r=e.radToDeg(e.globeTiltAtLngLat(i.transform,this._lngLat)),n=t.sub(e.globeCenterToScreenPoint(i.transform)),s=Math.abs(n.x)+Math.abs(n.y);if(0===s)return "";const a=r/s;return `rotateX(${-n.y*a}deg) rotateY(${n.x*a}deg)`}_calculateZTransform(){const t=this._pos,i=this._map;if(!i||!t)return "";let o=0;const r=this.getRotationAlignment();if("map"===r)if(i._showingGlobe()){const t=i.project(new e.LngLat(this._lngLat.lng,this._lngLat.lat+.001)),r=i.project(new e.LngLat(this._lngLat.lng,this._lngLat.lat-.001)).sub(t);o=e.radToDeg(Math.atan2(r.y,r.x))-90;}else o=-i.getBearing();else if("horizon"===r){const r=e.smoothstep(4,6,i.getZoom()),n=e.globeCenterToScreenPoint(i.transform);n.y+=r*i.transform.height;const s=t.sub(n),a=e.radToDeg(Math.atan2(s.y,s.x));o=(a>90?a-270:a+90)*(1-r);}return o+=this._rotation,o?`rotateZ(${o}deg)`:""}_update(t){e.window.cancelAnimationFrame(this._updateFrameId);const i=this._map;i&&(i.transform.renderWorldCopies&&(this._lngLat=Jr(this._lngLat,this._pos,i.transform)),this._pos=i.project(this._lngLat),!0===t?this._updateFrameId=e.window.requestAnimationFrame((()=>{this._element&&this._pos&&this._anchor&&(this._pos=this._pos.round(),this._updateDOM());})):this._pos=this._pos.round(),i._requestDomTask((()=>{this._map&&(this._element&&this._pos&&this._anchor&&this._updateDOM(),(i._showingGlobe()||i.getTerrain()||i.getFog())&&!this._fadeTimer&&(this._fadeTimer=setTimeout(this._evaluateOpacity.bind(this),60)));})));}getOffset(){return this._offset}setOffset(t){return this._offset=e.Point.convert(t),this._update(),this}_onMove(t){const i=this._map;if(!i)return;const o=this._pointerdownPos,r=this._positionDelta;if(o&&r){if(!this._isDragging){const e=this._clickTolerance||i._clickTolerance;if(t.point.dist(o)<e)return;this._isDragging=!0;}this._pos=t.point.sub(r),this._lngLat=i.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new e.Event("dragstart"))),this.fire(new e.Event("drag"));}}_onUp(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._pointerdownPos=null,this._isDragging=!1;const t=this._map;t&&(t.off("mousemove",this._onMove),t.off("touchmove",this._onMove)),"active"===this._state&&this.fire(new e.Event("dragend")),this._state="inactive";}_addDragHandler(e){const t=this._map,i=this._pos;t&&i&&this._element.contains(e.originalEvent.target)&&(e.preventDefault(),this._positionDelta=e.point.sub(i),this._pointerdownPos=e.point,this._state="pending",t.on("mousemove",this._onMove),t.on("touchmove",this._onMove),t.once("mouseup",this._onUp),t.once("touchend",this._onUp));}setDraggable(e){this._draggable=!!e;const t=this._map;return t&&(e?(t.on("mousedown",this._addDragHandler),t.on("touchstart",this._addDragHandler)):(t.off("mousedown",this._addDragHandler),t.off("touchstart",this._addDragHandler))),this}isDraggable(){return this._draggable}setRotation(e){return this._rotation=e||0,this._update(),this}getRotation(){return this._rotation}setRotationAlignment(e){return this._rotationAlignment=e||"auto",this._update(),this}getRotationAlignment(){return "auto"===this._rotationAlignment||"horizon"===this._rotationAlignment&&this._map&&!this._map._showingGlobe()?"viewport":this._rotationAlignment}setPitchAlignment(e){return this._pitchAlignment=e||"auto",this._update(),this}getPitchAlignment(){return "auto"===this._pitchAlignment?this.getRotationAlignment():this._pitchAlignment}setOccludedOpacity(e){return this._occludedOpacity=e||.2,this._update(),this}getOccludedOpacity(){return this._occludedOpacity}}const tn={closeButton:!0,closeOnClick:!0,focusAfterOpen:!0,className:"",maxWidth:"240px"},on=["a[href]","[tabindex]:not([tabindex='-1'])","[contenteditable]:not([contenteditable='false'])","button:not([disabled])","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].join(", ");function rn(t=new e.Point(0,0),i="bottom"){if("number"==typeof t){const o=Math.round(Math.sqrt(.5*Math.pow(t,2)));switch(i){case"top":return new e.Point(0,t);case"top-left":return new e.Point(o,o);case"top-right":return new e.Point(-o,o);case"bottom":return new e.Point(0,-t);case"bottom-left":return new e.Point(o,-o);case"bottom-right":return new e.Point(-o,-o);case"left":return new e.Point(t,0);case"right":return new e.Point(-t,0)}return new e.Point(0,0)}return t instanceof e.Point||Array.isArray(t)?e.Point.convert(t):e.Point.convert(t[i]||[0,0])}class nn{constructor(e){this.jumpTo(e);}getValue(t){if(t<=this._startTime)return this._start;if(t>=this._endTime)return this._end;const i=e.easeCubicInOut((t-this._startTime)/(this._endTime-this._startTime));return this._start*(1-i)+this._end*i}isEasing(e){return e>=this._startTime&&e<=this._endTime}jumpTo(e){this._startTime=-1/0,this._endTime=-1/0,this._start=e,this._end=e;}easeTo(e,t,i){this._start=this.getValue(t),this._end=e,this._startTime=t,this._endTime=t+i;}}const sn={"AttributionControl.ToggleAttribution":"Toggle attribution","AttributionControl.MapFeedback":"Map feedback","FullscreenControl.Enter":"Enter fullscreen","FullscreenControl.Exit":"Exit fullscreen","GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available","LogoControl.Title":"Mapbox logo","Map.Title":"Map","NavigationControl.ResetBearing":"Reset bearing to north","NavigationControl.ZoomIn":"Zoom in","NavigationControl.ZoomOut":"Zoom out","ScrollZoomBlocker.CtrlMessage":"Use ctrl + scroll to zoom the map","ScrollZoomBlocker.CmdMessage":"Use ⌘ + scroll to zoom the map","TouchPanBlocker.Message":"Use two fingers to move the map"},an={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:-2,maxZoom:22,minPitch:0,maxPitch:85,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,touchPitch:!0,cooperativeGestures:!1,performanceMetricsCollection:!0,bearingSnap:7,clickTolerance:3,pitchWithRotate:!0,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,optimizeForTerrain:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,minTileCacheSize:null,maxTileCacheSize:null,localIdeographFontFamily:"sans-serif",localFontFamily:null,transformRequest:null,accessToken:null,fadeDuration:300,respectPrefersReducedMotion:!0,crossSourceCollisions:!0},ln={showCompass:!0,showZoom:!0,visualizePitch:!1};class cn{constructor(t,i,o=!1){this._clickTolerance=10,this.element=i,this.mouseRotate=new yr({clickTolerance:t.dragRotate._mouseRotate._clickTolerance}),this.map=t,o&&(this.mousePitch=new br({clickTolerance:t.dragRotate._mousePitch._clickTolerance})),e.bindAll(["mousedown","mousemove","mouseup","touchstart","touchmove","touchend","reset"],this),i.addEventListener("mousedown",this.mousedown),i.addEventListener("touchstart",this.touchstart,{passive:!1}),i.addEventListener("touchmove",this.touchmove),i.addEventListener("touchend",this.touchend),i.addEventListener("touchcancel",this.reset);}down(e,t){this.mouseRotate.mousedown(e,t),this.mousePitch&&this.mousePitch.mousedown(e,t),h();}move(e,t){const i=this.map,o=this.mouseRotate.mousemoveWindow(e,t),r=o&&o.bearingDelta;if(r&&i.setBearing(i.getBearing()+r),this.mousePitch){const o=this.mousePitch.mousemoveWindow(e,t),r=o&&o.pitchDelta;r&&i.setPitch(i.getPitch()+r);}}off(){const e=this.element;e.removeEventListener("mousedown",this.mousedown),e.removeEventListener("touchstart",this.touchstart,{passive:!1}),e.removeEventListener("touchmove",this.touchmove),e.removeEventListener("touchend",this.touchend),e.removeEventListener("touchcancel",this.reset),this.offTemp();}offTemp(){u(),e.window.removeEventListener("mousemove",this.mousemove),e.window.removeEventListener("mouseup",this.mouseup);}mousedown(t){this.down(e.extend({},t,{ctrlKey:!0,preventDefault:()=>t.preventDefault()}),p(this.element,t)),e.window.addEventListener("mousemove",this.mousemove),e.window.addEventListener("mouseup",this.mouseup);}mousemove(e){this.move(e,p(this.element,e));}mouseup(e){this.mouseRotate.mouseupWindow(e),this.mousePitch&&this.mousePitch.mouseupWindow(e),this.offTemp();}touchstart(e){1!==e.targetTouches.length?this.reset():(this._startPos=this._lastPos=m(this.element,e.targetTouches)[0],this.down({type:"mousedown",button:0,ctrlKey:!0,preventDefault:()=>e.preventDefault()},this._startPos));}touchmove(e){1!==e.targetTouches.length?this.reset():(this._lastPos=m(this.element,e.targetTouches)[0],this.move({preventDefault:()=>e.preventDefault()},this._lastPos));}touchend(e){0===e.targetTouches.length&&this._startPos&&this._lastPos&&this._startPos.dist(this._lastPos)<this._clickTolerance&&this.element.click(),this.reset();}reset(){this.mouseRotate.reset(),this.mousePitch&&this.mousePitch.reset(),delete this._startPos,delete this._lastPos,this.offTemp();}}const hn={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showAccuracyCircle:!0,showUserLocation:!0,showUserHeading:!1},un={maxWidth:100,unit:"metric"},_n={kilometer:"km",meter:"m",mile:"mi",foot:"ft","nautical-mile":"nm"},dn={version:e.version,supported:i,setRTLTextPlugin:e.setRTLTextPlugin,getRTLTextPluginStatus:e.getRTLTextPluginStatus,Map:class extends $r{constructor(t){if(e.LivePerformanceUtils.mark(e.PerformanceMarkers.create),null!=(t=e.extend({},an,t)).minZoom&&null!=t.maxZoom&&t.minZoom>t.maxZoom)throw new Error("maxZoom must be greater than or equal to minZoom");if(null!=t.minPitch&&null!=t.maxPitch&&t.minPitch>t.maxPitch)throw new Error("maxPitch must be greater than or equal to minPitch");if(null!=t.minPitch&&t.minPitch<0)throw new Error("minPitch must be greater than or equal to 0");if(null!=t.maxPitch&&t.maxPitch>85)throw new Error("maxPitch must be less than or equal to 85");if(t.antialias&&e.isSafariWithAntialiasingBug(e.window)&&(t.antialias=!1,e.warnOnce("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")),super(new Ho(t.minZoom,t.maxZoom,t.minPitch,t.maxPitch,t.renderWorldCopies),t),this._interactive=t.interactive,this._minTileCacheSize=t.minTileCacheSize,this._maxTileCacheSize=t.maxTileCacheSize,this._failIfMajorPerformanceCaveat=t.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=t.preserveDrawingBuffer,this._antialias=t.antialias,this._useWebGL2=t.useWebGL2,this._trackResize=t.trackResize,this._bearingSnap=t.bearingSnap,this._refreshExpiredTiles=t.refreshExpiredTiles,this._fadeDuration=t.fadeDuration,this._isInitialLoad=!0,this._crossSourceCollisions=t.crossSourceCollisions,this._collectResourceTiming=t.collectResourceTiming,this._optimizeForTerrain=t.optimizeForTerrain,this._language=this._parseLanguage(t.language),this._worldview=t.worldview,this._renderTaskQueue=new Kr,this._domRenderTaskQueue=new Kr,this._controls=[],this._markers=[],this._popups=[],this._mapId=e.uniqueId(),this._locale=e.extend({},sn,t.locale),this._clickTolerance=t.clickTolerance,this._cooperativeGestures=t.cooperativeGestures,this._performanceMetricsCollection=t.performanceMetricsCollection,this._containerWidth=0,this._containerHeight=0,this._averageElevationLastSampledAt=-1/0,this._averageElevationExaggeration=0,this._averageElevation=new nn(0),this._interactionRange=[1/0,-1/0],this._visibilityHidden=0,this._useExplicitProjection=!1,this._requestManager=new e.RequestManager(t.transformRequest,t.accessToken,t.testMode),this._silenceAuthErrors=!!t.testMode,"string"==typeof t.container){if(this._container=e.window.document.getElementById(t.container),!this._container)throw new Error(`Container '${t.container}' not found.`)}else {if(!(t.container instanceof e.window.HTMLElement))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=t.container;}if(this._container.childNodes.length>0&&e.warnOnce("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."),t.maxBounds&&this.setMaxBounds(t.maxBounds),e.bindAll(["_onWindowOnline","_onWindowResize","_onVisibilityChange","_onMapScroll","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",(()=>this._update(!1))),this.on("moveend",(()=>this._update(!1))),this.on("zoom",(()=>this._update(!0))),void 0!==e.window&&(e.window.addEventListener("online",this._onWindowOnline,!1),e.window.addEventListener("resize",this._onWindowResize,!1),e.window.addEventListener("orientationchange",this._onWindowResize,!1),e.window.addEventListener("webkitfullscreenchange",this._onWindowResize,!1),e.window.addEventListener("visibilitychange",this._onVisibilityChange,!1)),this.handlers=new Xr(this,t),this._localFontFamily=t.localFontFamily,this._localIdeographFontFamily=t.localIdeographFontFamily,t.style&&this.setStyle(t.style,{localFontFamily:this._localFontFamily,localIdeographFontFamily:this._localIdeographFontFamily}),t.projection&&this.setProjection(t.projection),this._hash=t.hash&&new Ko("string"==typeof t.hash&&t.hash||void 0).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:t.center,zoom:t.zoom,bearing:t.bearing,pitch:t.pitch}),t.bounds&&(this.resize(),this.fitBounds(t.bounds,e.extend({},t.fitBoundsOptions,{duration:0})))),this.resize(),t.attributionControl&&this.addControl(new Hr({customAttribution:t.customAttribution})),this._logoControl=new Yr,this.addControl(this._logoControl,t.logoPosition),this.on("style.load",(()=>{this.transform.unmodified&&this.jumpTo(this.style.stylesheet);})),this.on("data",(t=>{this._update("style"===t.dataType),this.fire(new e.Event(`${t.dataType}data`,t));})),this.on("dataloading",(t=>{this.fire(new e.Event(`${t.dataType}dataloading`,t));}));}_getMapId(){return this._mapId}addControl(t,i){if(void 0===i&&(i=t.getDefaultPosition?t.getDefaultPosition():"top-right"),!t||!t.onAdd)return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));const o=t.onAdd(this);this._controls.push(t);const r=this._controlPositions[i];return -1!==i.indexOf("bottom")?r.insertBefore(o,r.firstChild):r.appendChild(o),this}removeControl(t){if(!t||!t.onRemove)return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));const i=this._controls.indexOf(t);return i>-1&&this._controls.splice(i,1),t.onRemove(this),this}hasControl(e){return this._controls.indexOf(e)>-1}getContainer(){return this._container}getCanvasContainer(){return this._canvasContainer}getCanvas(){return this._canvas}resize(t){if(this._updateContainerDimensions(),this._containerWidth===this.transform.width&&this._containerHeight===this.transform.height)return this;this._resizeCanvas(this._containerWidth,this._containerHeight),this.transform.resize(this._containerWidth,this._containerHeight),this.painter.resize(Math.ceil(this._containerWidth),Math.ceil(this._containerHeight));const i=!this._moving;return i&&this.fire(new e.Event("movestart",t)).fire(new e.Event("move",t)),this.fire(new e.Event("resize",t)),i&&this.fire(new e.Event("moveend",t)),this}getBounds(){return this.transform.getBounds()}getMaxBounds(){return this.transform.getMaxBounds()||null}setMaxBounds(t){return this.transform.setMaxBounds(e.LngLatBounds.convert(t)),this._update()}setMinZoom(t){if((t=null==t?-2:t)>=-2&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t?this.setZoom(t):this.fire(new e.Event("zoomstart")).fire(new e.Event("zoom")).fire(new e.Event("zoomend")),this;throw new Error("minZoom must be between -2 and the current maxZoom, inclusive")}getMinZoom(){return this.transform.minZoom}setMaxZoom(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t?this.setZoom(t):this.fire(new e.Event("zoomstart")).fire(new e.Event("zoom")).fire(new e.Event("zoomend")),this;throw new Error("maxZoom must be greater than the current minZoom")}getMaxZoom(){return this.transform.maxZoom}setMinPitch(t){if((t=null==t?0:t)<0)throw new Error("minPitch must be greater than or equal to 0");if(t>=0&&t<=this.transform.maxPitch)return this.transform.minPitch=t,this._update(),this.getPitch()<t?this.setPitch(t):this.fire(new e.Event("pitchstart")).fire(new e.Event("pitch")).fire(new e.Event("pitchend")),this;throw new Error("minPitch must be between 0 and the current maxPitch, inclusive")}getMinPitch(){return this.transform.minPitch}setMaxPitch(t){if((t=null==t?85:t)>85)throw new Error("maxPitch must be less than or equal to 85");if(t>=this.transform.minPitch)return this.transform.maxPitch=t,this._update(),this.getPitch()>t?this.setPitch(t):this.fire(new e.Event("pitchstart")).fire(new e.Event("pitch")).fire(new e.Event("pitchend")),this;throw new Error("maxPitch must be greater than or equal to minPitch")}getMaxPitch(){return this.transform.maxPitch}getRenderWorldCopies(){return this.transform.renderWorldCopies}setRenderWorldCopies(e){return this.transform.renderWorldCopies=e,this.transform.renderWorldCopies||this._forceMarkerAndPopupUpdate(!0),this._update()}getLanguage(){return this._language}_parseLanguage(t){return "auto"===t?e.window.navigator.language:Array.isArray(t)?0===t.length?void 0:t.map((t=>"auto"===t?e.window.navigator.language:t)):t}setLanguage(e){const t=this._parseLanguage(e);if(!this.style||t===this._language)return this;this._language=t,this.style._reloadSources();for(const e of this._controls)e._setLanguage&&e._setLanguage(this._language);return this}getWorldview(){return this._worldview}setWorldview(e){return this.style&&e!==this._worldview?(this._worldview=e,this.style._reloadSources(),this):this}getProjection(){return this.transform.mercatorFromTransition?{name:"globe",center:[0,0]}:this.transform.getProjection()}_showingGlobe(){return "globe"===this.transform.projection.name}setProjection(e){return this._lazyInitEmptyStyle(),e?"string"==typeof e&&(e={name:e}):e=null,this._useExplicitProjection=!!e,this._prioritizeAndUpdateProjection(e,this.style.stylesheet?this.style.stylesheet.projection:null)}_updateProjectionTransition(){if("globe"!==this.getProjection().name)return;const t=this.transform,i=t.projection.name;let o;"globe"===i&&t.zoom>=e.GLOBE_ZOOM_THRESHOLD_MAX?(t.setMercatorFromTransition(),o=!0):"mercator"===i&&t.zoom<e.GLOBE_ZOOM_THRESHOLD_MAX&&(t.setProjection({name:"globe"}),o=!0),o&&(this.style.applyProjectionUpdate(),this.style._forceSymbolLayerUpdate());}_prioritizeAndUpdateProjection(e,t){return this._updateProjection(e||t||{name:"mercator"})}_updateProjection(t){let i;if(i="globe"===t.name&&this.transform.zoom>=e.GLOBE_ZOOM_THRESHOLD_MAX?this.transform.setMercatorFromTransition():this.transform.setProjection(t),this.style.applyProjectionUpdate(),i){this.painter.clearBackgroundTiles();for(const e in this.style._sourceCaches)this.style._sourceCaches[e].clearTiles();this._update(!0),this._forceMarkerAndPopupUpdate(!0);}return this}project(t){return this.transform.locationPoint3D(e.LngLat.convert(t))}unproject(t){return this.transform.pointLocation3D(e.Point.convert(t))}isMoving(){return this._moving||this.handlers&&this.handlers.isMoving()||!1}isZooming(){return this._zooming||this.handlers&&this.handlers.isZooming()||!1}isRotating(){return this._rotating||this.handlers&&this.handlers.isRotating()||!1}_isDragging(){return this.handlers&&this.handlers._isDragging()||!1}_createDelegatedListener(e,t,i){if("mouseenter"===e||"mouseover"===e){let o=!1;const r=r=>{const n=t.filter((e=>this.getLayer(e))),s=n.length?this.queryRenderedFeatures(r.point,{layers:n}):[];s.length?o||(o=!0,i.call(this,new ar(e,this,r.originalEvent,{features:s}))):o=!1;},n=()=>{o=!1;};return {layers:new Set(t),listener:i,delegates:{mousemove:r,mouseout:n}}}if("mouseleave"===e||"mouseout"===e){let o=!1;const r=r=>{const n=t.filter((e=>this.getLayer(e)));(n.length?this.queryRenderedFeatures(r.point,{layers:n}):[]).length?o=!0:o&&(o=!1,i.call(this,new ar(e,this,r.originalEvent)));},n=t=>{o&&(o=!1,i.call(this,new ar(e,this,t.originalEvent)));};return {layers:new Set(t),listener:i,delegates:{mousemove:r,mouseout:n}}}{const o=e=>{const o=t.filter((e=>this.getLayer(e))),r=o.length?this.queryRenderedFeatures(e.point,{layers:o}):[];r.length&&(e.features=r,i.call(this,e),delete e.features);};return {layers:new Set(t),listener:i,delegates:{[e]:o}}}}on(e,t,i){if(void 0===i)return super.on(e,t);Array.isArray(t)||(t=[t]);const o=this._createDelegatedListener(e,t,i);this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[e]=this._delegatedListeners[e]||[],this._delegatedListeners[e].push(o);for(const e in o.delegates)this.on(e,o.delegates[e]);return this}once(e,t,i){if(void 0===i)return super.once(e,t);Array.isArray(t)||(t=[t]);const o=this._createDelegatedListener(e,t,i);for(const e in o.delegates)this.once(e,o.delegates[e]);return this}off(e,t,i){if(void 0===i)return super.off(e,t);t=new Set(Array.isArray(t)?t:[t]);const o=(e,t)=>{if(e.size!==t.size)return !1;for(const i of e)if(!t.has(i))return !1;return !0},r=this._delegatedListeners?this._delegatedListeners[e]:void 0;return r&&(e=>{for(let r=0;r<e.length;r++){const n=e[r];if(n.listener===i&&o(n.layers,t)){for(const e in n.delegates)this.off(e,n.delegates[e]);return e.splice(r,1),this}}})(r),this}queryRenderedFeatures(t,i){return this.style?(void 0!==i||void 0===t||t instanceof e.Point||Array.isArray(t)||(i=t,t=void 0),this.style.queryRenderedFeatures(t=t||[[0,0],[this.transform.width,this.transform.height]],i=i||{},this.transform)):[]}querySourceFeatures(e,t){return this.style.querySourceFeatures(e,t)}isPointOnSurface(t){const{name:i}=this.transform.projection;return "globe"!==i&&"mercator"!==i&&e.warnOnce(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`),this.transform.isPointOnSurface(e.Point.convert(t))}setStyle(t,i){return !1!==(i=e.extend({},{localIdeographFontFamily:this._localIdeographFontFamily,localFontFamily:this._localFontFamily},i)).diff&&i.localIdeographFontFamily===this._localIdeographFontFamily&&i.localFontFamily===this._localFontFamily&&this.style&&t?(this._diffStyle(t,i),this):(this._localIdeographFontFamily=i.localIdeographFontFamily,this._localFontFamily=i.localFontFamily,this._updateStyle(t,i))}_getUIString(e){const t=this._locale[e];if(null==t)throw new Error(`Missing UI string '${e}'`);return t}_updateStyle(e,t){return this.style&&(this.style.setEventedParent(null),this.style._remove(),this.style=void 0),e&&(this.style=new Kt(this,t||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof e?this.style.loadURL(e):this.style.loadJSON(e)),this._updateTerrain(),this}_lazyInitEmptyStyle(){this.style||(this.style=new Kt(this,{}),this.style.setEventedParent(this,{style:this.style}),this.style.loadEmpty());}_diffStyle(t,i){if("string"==typeof t){const o=this._requestManager.normalizeStyleURL(t),r=this._requestManager.transformRequest(o,e.ResourceType.Style);e.getJSON(r,((t,o)=>{t?this.fire(new e.ErrorEvent(t)):o&&this._updateDiff(o,i);}));}else "object"==typeof t&&this._updateDiff(t,i);}_updateDiff(t,i){try{this.style.setState(t)&&this._update(!0);}catch(o){e.warnOnce(`Unable to perform style diff: ${o.message||o.error||o}.  Rebuilding the style from scratch.`),this._updateStyle(t,i);}}getStyle(){if(this.style)return this.style.serialize()}isStyleLoaded(){return this.style?this.style.loaded():(e.warnOnce("There is no style added to the map."),!1)}addSource(e,t){return this._lazyInitEmptyStyle(),this.style.addSource(e,t),this._update(!0)}isSourceLoaded(e){return !!this.style&&this.style._isSourceCacheLoaded(e)}areTilesLoaded(){const e=this.style&&this.style._sourceCaches;for(const t in e){const i=e[t]._tiles;for(const e in i){const t=i[e];if("loaded"!==t.state&&"errored"!==t.state)return !1}}return !0}addSourceType(e,t,i){this._lazyInitEmptyStyle(),this.style.addSourceType(e,t,i);}removeSource(e){return this.style.removeSource(e),this._updateTerrain(),this._update(!0)}getSource(e){return this.style.getSource(e)}addImage(t,i,{pixelRatio:o=1,sdf:r=!1,stretchX:n,stretchY:s,content:a}={}){if(this._lazyInitEmptyStyle(),i instanceof e.window.HTMLImageElement||e.window.ImageBitmap&&i instanceof e.window.ImageBitmap){const{width:l,height:c,data:h}=e.exported.getImageData(i);this.style.addImage(t,{data:new e.RGBAImage({width:l,height:c},h),pixelRatio:o,stretchX:n,stretchY:s,content:a,sdf:r,version:0});}else if(void 0===i.width||void 0===i.height)this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));else {const{width:l,height:c}=i,h=i;this.style.addImage(t,{data:new e.RGBAImage({width:l,height:c},new Uint8Array(h.data)),pixelRatio:o,stretchX:n,stretchY:s,content:a,sdf:r,version:0,userImage:h}),h.onAdd&&h.onAdd(this,t);}}updateImage(t,i){const o=this.style.getImage(t);if(!o)return void this.fire(new e.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));const r=i instanceof e.window.HTMLImageElement||e.window.ImageBitmap&&i instanceof e.window.ImageBitmap?e.exported.getImageData(i):i,{width:n,height:s}=r;void 0!==n&&void 0!==s?n===o.data.width&&s===o.data.height?(o.data.replace(r.data,!(i instanceof e.window.HTMLImageElement||e.window.ImageBitmap&&i instanceof e.window.ImageBitmap)),this.style.updateImage(t,o)):this.fire(new e.ErrorEvent(new Error(`The width and height of the updated image (${n}, ${s})\n                must be that same as the previous version of the image\n                (${o.data.width}, ${o.data.height})`))):this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));}hasImage(t){return t?!!this.style.getImage(t):(this.fire(new e.ErrorEvent(new Error("Missing required image id"))),!1)}removeImage(e){this.style.removeImage(e);}loadImage(t,i){e.getImage(this._requestManager.transformRequest(t,e.ResourceType.Image),((t,o)=>{i(t,o instanceof e.window.HTMLImageElement?e.exported.getImageData(o):o);}));}listImages(){return this.style.listImages()}addLayer(e,t){return this._lazyInitEmptyStyle(),this.style.addLayer(e,t),this._update(!0)}moveLayer(e,t){return this.style.moveLayer(e,t),this._update(!0)}removeLayer(e){return this.style.removeLayer(e),this._update(!0)}getLayer(e){return this.style.getLayer(e)}setLayerZoomRange(e,t,i){return this.style.setLayerZoomRange(e,t,i),this._update(!0)}setFilter(e,t,i={}){return this.style.setFilter(e,t,i),this._update(!0)}getFilter(e){return this.style.getFilter(e)}setPaintProperty(e,t,i,o={}){return this.style.setPaintProperty(e,t,i,o),this._update(!0)}getPaintProperty(e,t){return this.style.getPaintProperty(e,t)}setLayoutProperty(e,t,i,o={}){return this.style.setLayoutProperty(e,t,i,o),this._update(!0)}getLayoutProperty(e,t){return this.style.getLayoutProperty(e,t)}setLight(e,t={}){return this._lazyInitEmptyStyle(),this.style.setLight(e,t),this._update(!0)}getLight(){return this.style.getLight()}setTerrain(e){return this._lazyInitEmptyStyle(),!e&&this.transform.projection.requiresDraping?this.style.setTerrainForDraping():this.style.setTerrain(e),this._averageElevationLastSampledAt=-1/0,this._update(!0)}getTerrain(){return this.style?this.style.getTerrain():null}setFog(e){return this._lazyInitEmptyStyle(),this.style.setFog(e),this._update(!0)}getFog(){return this.style?this.style.getFog():null}_queryFogOpacity(t){return this.style&&this.style.fog?this.style.fog.getOpacityAtLatLng(e.LngLat.convert(t),this.transform):0}setFeatureState(e,t){return this.style.setFeatureState(e,t),this._update()}removeFeatureState(e,t){return this.style.removeFeatureState(e,t),this._update()}getFeatureState(e){return this.style.getFeatureState(e)}_updateContainerDimensions(){if(!this._container)return;const t=this._container.getBoundingClientRect().width||400,i=this._container.getBoundingClientRect().height||300;let o,r,n,s=this._container;for(;s&&(!r||!n);){const t=e.window.getComputedStyle(s).transform;t&&"none"!==t&&(o=t.match(/matrix.*\((.+)\)/)[1].split(", "),o[0]&&"0"!==o[0]&&"1"!==o[0]&&(r=o[0]),o[3]&&"0"!==o[3]&&"1"!==o[3]&&(n=o[3])),s=s.parentElement;}this._containerWidth=r?Math.abs(t/r):t,this._containerHeight=n?Math.abs(i/n):i;}_detectMissingCSS(){"rgb(250, 128, 114)"!==e.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&e.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");}_setupContainer(){const e=this._container;e.classList.add("mapboxgl-map"),(this._missingCSSCanary=n("div","mapboxgl-canary",e)).style.visibility="hidden",this._detectMissingCSS();const t=this._canvasContainer=n("div","mapboxgl-canvas-container",e);this._interactive&&t.classList.add("mapboxgl-interactive"),this._canvas=n("canvas","mapboxgl-canvas",t),this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label",this._getUIString("Map.Title")),this._canvas.setAttribute("role","region"),this._updateContainerDimensions(),this._resizeCanvas(this._containerWidth,this._containerHeight);const i=this._controlContainer=n("div","mapboxgl-control-container",e),o=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach((e=>{o[e]=n("div",`mapboxgl-ctrl-${e}`,i);})),this._container.addEventListener("scroll",this._onMapScroll,!1);}_resizeCanvas(t,i){const o=e.exported.devicePixelRatio||1;this._canvas.width=o*Math.ceil(t),this._canvas.height=o*Math.ceil(i),this._canvas.style.width=`${t}px`,this._canvas.style.height=`${i}px`;}_addMarker(e){this._markers.push(e);}_removeMarker(e){const t=this._markers.indexOf(e);-1!==t&&this._markers.splice(t,1);}_addPopup(e){this._popups.push(e);}_removePopup(e){const t=this._popups.indexOf(e);-1!==t&&this._popups.splice(t,1);}_setupPainter(){const t=e.extend({},i.webGLContextAttributes,{failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer,antialias:this._antialias||!1}),o=this._useWebGL2&&this._canvas.getContext("webgl2",t),r=o||this._canvas.getContext("webgl",t)||this._canvas.getContext("experimental-webgl",t);r?(this._useWebGL2&&!o&&e.warnOnce("Failed to create WebGL 2 context. Using WebGL 1."),e.storeAuthState(r,!0),this.painter=new Bo(r,this.transform,!!o),this.on("data",(e=>{"source"===e.dataType&&this.painter.setTileLoadedFlag(!0);})),e.exported$1.testSupport(r)):this.fire(new e.ErrorEvent(new Error("Failed to initialize WebGL")));}_contextLost(t){t.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new e.Event("webglcontextlost",{originalEvent:t}));}_contextRestored(t){this._setupPainter(),this.resize(),this._update(),this.fire(new e.Event("webglcontextrestored",{originalEvent:t}));}_onMapScroll(e){if(e.target===this._container)return this._container.scrollTop=0,this._container.scrollLeft=0,!1}loaded(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()}_update(e){return this.style?(this._styleDirty=this._styleDirty||e,this._sourcesDirty=!0,this.triggerRepaint(),this):this}_requestRenderFrame(e){return this._update(),this._renderTaskQueue.add(e)}_cancelRenderFrame(e){this._renderTaskQueue.remove(e);}_requestDomTask(e){!this.loaded()||this.loaded()&&!this.isMoving()?e():this._domRenderTaskQueue.add(e);}_render(t){let i;const o=this.painter.context.extTimerQuery,r=e.exported.now();if(this.listens("gpu-timing-frame")&&(i=o.createQueryEXT(),o.beginQueryEXT(o.TIME_ELAPSED_EXT,i)),this.painter.context.setDirty(),this.painter.setBaseState(),(this.isMoving()||this.isRotating()||this.isZooming())&&(this._interactionRange[0]=Math.min(this._interactionRange[0],e.window.performance.now()),this._interactionRange[1]=Math.max(this._interactionRange[1],e.window.performance.now())),this._renderTaskQueue.run(t),this._domRenderTaskQueue.run(t),this._removed)return;this._updateProjectionTransition();const n=this._isInitialLoad?0:this._fadeDuration;if(this.style&&this._styleDirty){this._styleDirty=!1;const t=this.transform.zoom,i=this.transform.pitch,o=e.exported.now(),r=new e.EvaluationParameters(t,{now:o,fadeDuration:n,pitch:i,transition:this.style.getTransition()});this.style.update(r);}this.style&&this.style.fog&&this.style.fog.hasTransition()&&(this.style._markersNeedUpdate=!0,this._sourcesDirty=!0);let s=!1;if(this.style&&this._sourcesDirty?(this._sourcesDirty=!1,this.painter._updateFog(this.style),this._updateTerrain(),s=this._updateAverageElevation(r),this.style._updateSources(this.transform),this._forceMarkerAndPopupUpdate()):s=this._updateAverageElevation(r),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,n,this._crossSourceCollisions),this.style&&this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showTerrainWireframe:this.showTerrainWireframe,showOverdrawInspector:this._showOverdrawInspector,showQueryGeometry:!!this._showQueryGeometry,showTileAABBs:this.showTileAABBs,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),fadeDuration:n,isInitialLoad:this._isInitialLoad,showPadding:this.showPadding,gpuTiming:!!this.listens("gpu-timing-layer"),gpuTimingDeferredRender:!!this.listens("gpu-timing-deferred-render"),speedIndexTiming:this.speedIndexTiming}),this.fire(new e.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new e.Event("load"))),this.style&&this.style.hasTransitions()&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),i){const t=e.exported.now()-r;o.endQueryEXT(o.TIME_ELAPSED_EXT,i),setTimeout((()=>{const n=o.getQueryObjectEXT(i,o.QUERY_RESULT_EXT)/1e6;o.deleteQueryEXT(i),this.fire(new e.Event("gpu-timing-frame",{cpuTime:t,gpuTime:n})),e.window.performance.mark("frame-gpu",{startTime:r,detail:{gpuTime:n}});}),50);}if(this.listens("gpu-timing-layer")){const t=this.painter.collectGpuTimers();setTimeout((()=>{const i=this.painter.queryGpuTimers(t);this.fire(new e.Event("gpu-timing-layer",{layerTimes:i}));}),50);}if(this.listens("gpu-timing-deferred-render")){const t=this.painter.collectDeferredRenderGpuQueries();setTimeout((()=>{const i=this.painter.queryGpuTimeDeferredRender(t);this.fire(new e.Event("gpu-timing-deferred-render",{gpuTime:i}));}),50);}const a=this._sourcesDirty||this._styleDirty||this._placementDirty||s;if(a||this._repaint)this.triggerRepaint();else {const t=!this.isMoving()&&this.loaded();if(t&&(s=this._updateAverageElevation(r,!0)),s)this.triggerRepaint();else if(this._triggerFrame(!1),t&&(this.fire(new e.Event("idle")),this._isInitialLoad=!1,this.speedIndexTiming)){const t=this._calculateSpeedIndex();this.fire(new e.Event("speedindexcompleted",{speedIndex:t})),this.speedIndexTiming=!1;}}!this._loaded||this._fullyLoaded||a||(this._fullyLoaded=!0,e.LivePerformanceUtils.mark(e.PerformanceMarkers.fullLoad),this._performanceMetricsCollection&&e.postPerformanceEvent(this._requestManager._customAccessToken,{width:this.painter.width,height:this.painter.height,interactionRange:this._interactionRange,visibilityHidden:this._visibilityHidden,terrainEnabled:!!this.painter.style.getTerrain(),fogEnabled:!!this.painter.style.getFog(),projection:this.getProjection().name,zoom:this.transform.zoom,renderer:this.painter.context.renderer,vendor:this.painter.context.vendor}),this._authenticate());}_forceMarkerAndPopupUpdate(e){for(const t of this._markers)e&&!this.getRenderWorldCopies()&&(t._lngLat=t._lngLat.wrap()),t._update();for(const t of this._popups)!e||this.getRenderWorldCopies()||t._trackPointer||(t._lngLat=t._lngLat.wrap()),t._update();}_updateAverageElevation(e,t=!1){const i=e=>(this.transform.averageElevation=e,this._update(!1),!0);if(!this.painter.averageElevationNeedsEasing())return 0!==this.transform.averageElevation&&i(0);if((t||e-this._averageElevationLastSampledAt>500)&&!this._averageElevation.isEasing(e)){const t=this.transform.averageElevation;let o=this.transform.sampleAverageElevation(),r=!1;this.transform.elevation&&(r=this.transform.elevation.exaggeration()!==this._averageElevationExaggeration,this._averageElevationExaggeration=this.transform.elevation.exaggeration()),isNaN(o)?o=0:this._averageElevationLastSampledAt=e;const n=Math.abs(t-o);if(n>1){if(this._isInitialLoad||r)return this._averageElevation.jumpTo(o),i(o);this._averageElevation.easeTo(o,e,300);}else if(n>1e-4)return this._averageElevation.jumpTo(o),i(o)}return !!this._averageElevation.isEasing(e)&&i(this._averageElevation.getValue(e))}_authenticate(){e.getMapSessionAPI(this._getMapId(),this._requestManager._skuToken,this._requestManager._customAccessToken,(t=>{if(t&&(t.message===e.AUTH_ERR_MSG||401===t.status)){const t=this.painter.context.gl;e.storeAuthState(t,!1),this._logoControl instanceof Yr&&this._logoControl._updateLogo(),t&&t.clear(t.DEPTH_BUFFER_BIT|t.COLOR_BUFFER_BIT|t.STENCIL_BUFFER_BIT),this._silenceAuthErrors||this.fire(new e.ErrorEvent(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));}})),e.postMapLoadEvent(this._getMapId(),this._requestManager._skuToken,this._requestManager._customAccessToken,(()=>{}));}_updateTerrain(){const e=this._isDragging();this.painter.updateTerrain(this.style,e);}_calculateSpeedIndex(){const e=this.painter.canvasCopy(),t=this.painter.getCanvasCopiesAndTimestamps();t.timeStamps.push(performance.now());const i=this.painter.context.gl,o=i.createFramebuffer();function r(e){i.framebufferTexture2D(i.FRAMEBUFFER,i.COLOR_ATTACHMENT0,i.TEXTURE_2D,e,0);const t=new Uint8Array(i.drawingBufferWidth*i.drawingBufferHeight*4);return i.readPixels(0,0,i.drawingBufferWidth,i.drawingBufferHeight,i.RGBA,i.UNSIGNED_BYTE,t),t}return i.bindFramebuffer(i.FRAMEBUFFER,o),this._canvasPixelComparison(r(e),t.canvasCopies.map(r),t.timeStamps)}_canvasPixelComparison(e,t,i){let o=i[1]-i[0];const r=e.length/4;for(let n=0;n<t.length;n++){const s=t[n];let a=0;for(let t=0;t<s.length;t+=4)s[t]===e[t]&&s[t+1]===e[t+1]&&s[t+2]===e[t+2]&&s[t+3]===e[t+3]&&(a+=1);o+=(i[n+2]-i[n+1])*(1-a/r);}return o}remove(){this._hash&&this._hash.remove();for(const e of this._controls)e.onRemove(this);this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this._domRenderTaskQueue.clear(),this.style&&this.style.destroy(),this.painter.destroy(),this.handlers&&this.handlers.destroy(),this.handlers=void 0,this.setStyle(null),void 0!==e.window&&(e.window.removeEventListener("resize",this._onWindowResize,!1),e.window.removeEventListener("orientationchange",this._onWindowResize,!1),e.window.removeEventListener("webkitfullscreenchange",this._onWindowResize,!1),e.window.removeEventListener("online",this._onWindowOnline,!1),e.window.removeEventListener("visibilitychange",this._onVisibilityChange,!1));const t=this.painter.context.gl.getExtension("WEBGL_lose_context");t&&t.loseContext(),this._canvas.removeEventListener("webglcontextlost",this._contextLost,!1),this._canvas.removeEventListener("webglcontextrestored",this._contextRestored,!1),this._canvasContainer.remove(),this._controlContainer.remove(),this._missingCSSCanary.remove(),this._canvas=void 0,this._canvasContainer=void 0,this._controlContainer=void 0,this._missingCSSCanary=void 0,this._container.classList.remove("mapboxgl-map"),this._container.removeEventListener("scroll",this._onMapScroll,!1),e.removeAuthState(this.painter.context.gl),this._removed=!0,this.fire(new e.Event("remove"));}triggerRepaint(){this._triggerFrame(!0);}_triggerFrame(t){this._renderNextFrame=this._renderNextFrame||t,this.style&&!this._frame&&(this._frame=e.exported.frame((e=>{const t=!!this._renderNextFrame;this._frame=null,this._renderNextFrame=null,t&&this._render(e);})));}_preloadTiles(t){const i=this.style?Object.values(this.style._sourceCaches):[];return e.asyncAll(i,((e,i)=>e._preloadTiles(t,i)),(()=>{this.triggerRepaint();})),this}_onWindowOnline(){this._update();}_onWindowResize(e){this._trackResize&&this.resize({originalEvent:e})._update();}_onVisibilityChange(){"hidden"===e.window.document.visibilityState&&this._visibilityHidden++;}get showTileBoundaries(){return !!this._showTileBoundaries}set showTileBoundaries(e){this._showTileBoundaries!==e&&(this._showTileBoundaries=e,this._update());}get showTerrainWireframe(){return !!this._showTerrainWireframe}set showTerrainWireframe(e){this._showTerrainWireframe!==e&&(this._showTerrainWireframe=e,this._update());}get speedIndexTiming(){return !!this._speedIndexTiming}set speedIndexTiming(e){this._speedIndexTiming!==e&&(this._speedIndexTiming=e,this._update());}get showPadding(){return !!this._showPadding}set showPadding(e){this._showPadding!==e&&(this._showPadding=e,this._update());}get showCollisionBoxes(){return !!this._showCollisionBoxes}set showCollisionBoxes(e){this._showCollisionBoxes!==e&&(this._showCollisionBoxes=e,e?this.style._generateCollisionBoxes():this._update());}get showOverdrawInspector(){return !!this._showOverdrawInspector}set showOverdrawInspector(e){this._showOverdrawInspector!==e&&(this._showOverdrawInspector=e,this._update());}get repaint(){return !!this._repaint}set repaint(e){this._repaint!==e&&(this._repaint=e,this.triggerRepaint());}get vertices(){return !!this._vertices}set vertices(e){this._vertices=e,this._update();}get showTileAABBs(){return !!this._showTileAABBs}set showTileAABBs(e){this._showTileAABBs!==e&&(this._showTileAABBs=e,e&&this._update());}_setCacheLimits(t,i){e.setCacheLimits(t,i);}get version(){return e.version}},NavigationControl:class{constructor(t){this.options=e.extend({},ln,t),this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",(e=>e.preventDefault())),this.options.showZoom&&(e.bindAll(["_setButtonTitle","_updateZoomButtons"],this),this._zoomInButton=this._createButton("mapboxgl-ctrl-zoom-in",(e=>{this._map&&this._map.zoomIn({},{originalEvent:e});})),n("span","mapboxgl-ctrl-icon",this._zoomInButton).setAttribute("aria-hidden","true"),this._zoomOutButton=this._createButton("mapboxgl-ctrl-zoom-out",(e=>{this._map&&this._map.zoomOut({},{originalEvent:e});})),n("span","mapboxgl-ctrl-icon",this._zoomOutButton).setAttribute("aria-hidden","true")),this.options.showCompass&&(e.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-compass",(e=>{const t=this._map;t&&(this.options.visualizePitch?t.resetNorthPitch({},{originalEvent:e}):t.resetNorth({},{originalEvent:e}));})),this._compassIcon=n("span","mapboxgl-ctrl-icon",this._compass),this._compassIcon.setAttribute("aria-hidden","true"));}_updateZoomButtons(){const e=this._map;if(!e)return;const t=e.getZoom(),i=t===e.getMaxZoom(),o=t===e.getMinZoom();this._zoomInButton.disabled=i,this._zoomOutButton.disabled=o,this._zoomInButton.setAttribute("aria-disabled",i.toString()),this._zoomOutButton.setAttribute("aria-disabled",o.toString());}_rotateCompassArrow(){const e=this._map;if(!e)return;const t=this.options.visualizePitch?`scale(${1/Math.pow(Math.cos(e.transform.pitch*(Math.PI/180)),.5)}) rotateX(${e.transform.pitch}deg) rotateZ(${e.transform.angle*(180/Math.PI)}deg)`:`rotate(${e.transform.angle*(180/Math.PI)}deg)`;e._requestDomTask((()=>{this._compassIcon&&(this._compassIcon.style.transform=t);}));}onAdd(e){return this._map=e,this.options.showZoom&&(this._setButtonTitle(this._zoomInButton,"ZoomIn"),this._setButtonTitle(this._zoomOutButton,"ZoomOut"),e.on("zoom",this._updateZoomButtons),this._updateZoomButtons()),this.options.showCompass&&(this._setButtonTitle(this._compass,"ResetBearing"),this.options.visualizePitch&&e.on("pitch",this._rotateCompassArrow),e.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new cn(e,this._compass,this.options.visualizePitch)),this._container}onRemove(){const e=this._map;e&&(this._container.remove(),this.options.showZoom&&e.off("zoom",this._updateZoomButtons),this.options.showCompass&&(this.options.visualizePitch&&e.off("pitch",this._rotateCompassArrow),e.off("rotate",this._rotateCompassArrow),this._handler&&this._handler.off(),this._handler=void 0),this._map=void 0);}_createButton(e,t){const i=n("button",e,this._container);return i.type="button",i.addEventListener("click",t),i}_setButtonTitle(e,t){if(!this._map)return;const i=this._map._getUIString(`NavigationControl.${t}`);e.setAttribute("aria-label",i),e.firstElementChild&&e.firstElementChild.setAttribute("title",i);}},GeolocateControl:class extends e.Evented{constructor(t){super(),this.options=e.extend({geolocation:e.window.navigator.geolocation},hn,t),e.bindAll(["_onSuccess","_onError","_onZoom","_finish","_setupUI","_updateCamera","_updateMarker","_updateMarkerRotation","_onDeviceOrientation"],this),this._updateMarkerRotationThrottled=Yo(this._updateMarkerRotation,20),this._numberOfWatches=0;}onAdd(e){return this._map=e,this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkGeolocationSupport(this._setupUI),this._container}onRemove(){void 0!==this._geolocationWatchID&&(this.options.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),this.options.showAccuracyCircle&&this._accuracyCircleMarker&&this._accuracyCircleMarker.remove(),this._container.remove(),this._map.off("zoom",this._onZoom),this._map=void 0,this._numberOfWatches=0,this._noTimeout=!1;}_checkGeolocationSupport(t){const i=(e=!!this.options.geolocation)=>{this._supportsGeolocation=e,t(e);};void 0!==this._supportsGeolocation?t(this._supportsGeolocation):void 0!==e.window.navigator.permissions?e.window.navigator.permissions.query({name:"geolocation"}).then((e=>i("denied"!==e.state))).catch((()=>i())):i();}_isOutOfMapMaxBounds(e){const t=this._map.getMaxBounds(),i=e.coords;return !!t&&(i.longitude<t.getWest()||i.longitude>t.getEast()||i.latitude<t.getSouth()||i.latitude>t.getNorth())}_setErrorState(){switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}}_onSuccess(t){if(this._map){if(this._isOutOfMapMaxBounds(t))return this._setErrorState(),this.fire(new e.Event("outofmaxbounds",t)),this._updateMarker(),void this._finish();if(this.options.trackUserLocation)switch(this._lastKnownPosition=t,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(t),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(t),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new e.Event("geolocate",t)),this._finish();}}_updateCamera(t){const i=new e.LngLat(t.coords.longitude,t.coords.latitude),o=t.coords.accuracy,r=this._map.getBearing(),n=e.extend({bearing:r},this.options.fitBoundsOptions);this._map.fitBounds(i.toBounds(o),n,{geolocateSource:!0});}_updateMarker(t){if(t){const i=new e.LngLat(t.coords.longitude,t.coords.latitude);this._accuracyCircleMarker.setLngLat(i).addTo(this._map),this._userLocationDotMarker.setLngLat(i).addTo(this._map),this._accuracy=t.coords.accuracy,this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();}else this._userLocationDotMarker.remove(),this._accuracyCircleMarker.remove();}_updateCircleRadius(){const t=this._map.transform,i=e.mercatorZfromAltitude(1,t._center.lat)*t.worldSize,o=Math.ceil(2*this._accuracy*i);this._circleElement.style.width=`${o}px`,this._circleElement.style.height=`${o}px`;}_onZoom(){this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();}_updateMarkerRotation(){this._userLocationDotMarker&&"number"==typeof this._heading?(this._userLocationDotMarker.setRotation(this._heading),this._dotElement.classList.add("mapboxgl-user-location-show-heading")):(this._dotElement.classList.remove("mapboxgl-user-location-show-heading"),this._userLocationDotMarker.setRotation(0));}_onError(t){if(this._map){if(this.options.trackUserLocation)if(1===t.code){this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.disabled=!0;const e=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.setAttribute("aria-label",e),this._geolocateButton.firstElementChild&&this._geolocateButton.firstElementChild.setAttribute("title",e),void 0!==this._geolocationWatchID&&this._clearWatch();}else {if(3===t.code&&this._noTimeout)return;this._setErrorState();}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new e.Event("error",t)),this._finish();}}_finish(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;}_setupUI(t){if(void 0!==this._map){if(this._container.addEventListener("contextmenu",(e=>e.preventDefault())),this._geolocateButton=n("button","mapboxgl-ctrl-geolocate",this._container),n("span","mapboxgl-ctrl-icon",this._geolocateButton).setAttribute("aria-hidden","true"),this._geolocateButton.type="button",!1===t){e.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");const t=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.disabled=!0,this._geolocateButton.setAttribute("aria-label",t),this._geolocateButton.firstElementChild&&this._geolocateButton.firstElementChild.setAttribute("title",t);}else {const e=this._map._getUIString("GeolocateControl.FindMyLocation");this._geolocateButton.setAttribute("aria-label",e),this._geolocateButton.firstElementChild&&this._geolocateButton.firstElementChild.setAttribute("title",e);}this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=n("div","mapboxgl-user-location"),this._dotElement.appendChild(n("div","mapboxgl-user-location-dot")),this._dotElement.appendChild(n("div","mapboxgl-user-location-heading")),this._userLocationDotMarker=new en({element:this._dotElement,rotationAlignment:"map",pitchAlignment:"map"}),this._circleElement=n("div","mapboxgl-user-location-accuracy-circle"),this._accuracyCircleMarker=new en({element:this._circleElement,pitchAlignment:"map"}),this.options.trackUserLocation&&(this._watchState="OFF"),this._map.on("zoom",this._onZoom)),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",(t=>{t.geolocateSource||"ACTIVE_LOCK"!==this._watchState||t.originalEvent&&"resize"===t.originalEvent.type||(this._watchState="BACKGROUND",this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this.fire(new e.Event("trackuserlocationend")));}));}}_onDeviceOrientation(e){this._userLocationDotMarker&&(e.webkitCompassHeading?this._heading=e.webkitCompassHeading:!0===e.absolute&&(this._heading=-1*e.alpha),this._updateMarkerRotationThrottled());}trigger(){if(!this._setup)return e.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new e.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":this._numberOfWatches--,this._noTimeout=!1,this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new e.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new e.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}if("OFF"===this._watchState&&void 0!==this._geolocationWatchID)this._clearWatch();else if(void 0===this._geolocationWatchID){let e;this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),this._numberOfWatches++,this._numberOfWatches>1?(e={maximumAge:6e5,timeout:0},this._noTimeout=!0):(e=this.options.positionOptions,this._noTimeout=!1),this._geolocationWatchID=this.options.geolocation.watchPosition(this._onSuccess,this._onError,e),this.options.showUserHeading&&this._addDeviceOrientationListener();}}else this.options.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0}_addDeviceOrientationListener(){const t=()=>{e.window.addEventListener("ondeviceorientationabsolute"in e.window?"deviceorientationabsolute":"deviceorientation",this._onDeviceOrientation);};void 0!==e.window.DeviceMotionEvent&&"function"==typeof e.window.DeviceMotionEvent.requestPermission?DeviceOrientationEvent.requestPermission().then((e=>{"granted"===e&&t();})).catch(console.error):t();}_clearWatch(){this.options.geolocation.clearWatch(this._geolocationWatchID),e.window.removeEventListener("deviceorientation",this._onDeviceOrientation),e.window.removeEventListener("deviceorientationabsolute",this._onDeviceOrientation),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);}},AttributionControl:Hr,ScaleControl:class{constructor(t){this.options=e.extend({},un,t),this._isNumberFormatSupported=function(){try{return new Intl.NumberFormat("en",{style:"unit",unitDisplay:"short",unit:"meter"}),!0}catch(e){return !1}}(),e.bindAll(["_update","_setScale","setUnit"],this);}getDefaultPosition(){return "bottom-left"}_update(){const e=this.options.maxWidth||100,t=this._map,i=t._containerHeight/2,o=t._containerWidth/2-e/2,r=t.unproject([o,i]),n=t.unproject([o+e,i]),s=r.distanceTo(n);if("imperial"===this.options.unit){const t=3.2808*s;t>5280?this._setScale(e,t/5280,"mile"):this._setScale(e,t,"foot");}else "nautical"===this.options.unit?this._setScale(e,s/1852,"nautical-mile"):s>=1e3?this._setScale(e,s/1e3,"kilometer"):this._setScale(e,s,"meter");}_setScale(e,t,i){this._map._requestDomTask((()=>{const o=function(e){const t=Math.pow(10,`${Math.floor(e)}`.length-1);let i=e/t;return i=i>=10?10:i>=5?5:i>=3?3:i>=2?2:i>=1?1:function(e){const t=Math.pow(10,Math.ceil(-Math.log(e)/Math.LN10));return Math.round(e*t)/t}(i),t*i}(t),r=o/t;this._container.innerHTML=this._isNumberFormatSupported&&"nautical-mile"!==i?new Intl.NumberFormat(this._language,{style:"unit",unitDisplay:"short",unit:i}).format(o):`${o}&nbsp;${_n[i]}`,this._container.style.width=e*r+"px";}));}onAdd(e){return this._map=e,this._language=e.getLanguage(),this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-scale",e.getContainer()),this._container.dir="auto",this._map.on("move",this._update),this._update(),this._container}onRemove(){this._container.remove(),this._map.off("move",this._update),this._map=void 0;}_setLanguage(e){this._language=e,this._update();}setUnit(e){this.options.unit=e,this._update();}},FullscreenControl:class{constructor(t){this._fullscreen=!1,t&&t.container&&(t.container instanceof e.window.HTMLElement?this._container=t.container:e.warnOnce("Full screen control 'container' must be a DOM element.")),e.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in e.window.document?this._fullscreenchange="fullscreenchange":"onwebkitfullscreenchange"in e.window.document&&(this._fullscreenchange="webkitfullscreenchange");}onAdd(t){return this._map=t,this._container||(this._container=this._map.getContainer()),this._controlContainer=n("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",e.warnOnce("This device does not support fullscreen mode.")),this._controlContainer}onRemove(){this._controlContainer.remove(),this._map=null,e.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);}_checkFullscreenSupport(){return !(!e.window.document.fullscreenEnabled&&!e.window.document.webkitFullscreenEnabled)}_setupUI(){const t=this._fullscreenButton=n("button","mapboxgl-ctrl-fullscreen",this._controlContainer);n("span","mapboxgl-ctrl-icon",t).setAttribute("aria-hidden","true"),t.type="button",this._updateTitle(),this._fullscreenButton.addEventListener("click",this._onClickFullscreen),e.window.document.addEventListener(this._fullscreenchange,this._changeIcon);}_updateTitle(){const e=this._getTitle();this._fullscreenButton.setAttribute("aria-label",e),this._fullscreenButton.firstElementChild&&this._fullscreenButton.firstElementChild.setAttribute("title",e);}_getTitle(){return this._map._getUIString(this._isFullscreen()?"FullscreenControl.Exit":"FullscreenControl.Enter")}_isFullscreen(){return this._fullscreen}_changeIcon(){(e.window.document.fullscreenElement||e.window.document.webkitFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"),this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"),this._updateTitle());}_onClickFullscreen(){this._isFullscreen()?e.window.document.exitFullscreen?e.window.document.exitFullscreen():e.window.document.webkitCancelFullScreen&&e.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen();}},Popup:class extends e.Evented{constructor(t){super(),this.options=e.extend(Object.create(tn),t),e.bindAll(["_update","_onClose","remove","_onMouseEvent"],this),this._classList=new Set(t&&t.className?t.className.trim().split(/\s+/):[]);}addTo(t){return this._map&&this.remove(),this._map=t,this.options.closeOnClick&&t.on("preclick",this._onClose),this.options.closeOnMove&&t.on("move",this._onClose),t.on("remove",this.remove),this._update(),t._addPopup(this),this._focusFirstElement(),this._trackPointer?(t.on("mousemove",this._onMouseEvent),t.on("mouseup",this._onMouseEvent),t._canvasContainer.classList.add("mapboxgl-track-pointer")):t.on("move",this._update),this.fire(new e.Event("open")),this}isOpen(){return !!this._map}remove(){this._content&&this._content.remove(),this._container&&(this._container.remove(),this._container=void 0);const t=this._map;return t&&(t.off("move",this._update),t.off("move",this._onClose),t.off("preclick",this._onClose),t.off("click",this._onClose),t.off("remove",this.remove),t.off("mousemove",this._onMouseEvent),t.off("mouseup",this._onMouseEvent),t.off("drag",this._onMouseEvent),t._canvasContainer&&t._canvasContainer.classList.remove("mapboxgl-track-pointer"),t._removePopup(this),this._map=void 0),this.fire(new e.Event("close")),this}getLngLat(){return this._lngLat}setLngLat(t){this._lngLat=e.LngLat.convert(t),this._pos=null,this._trackPointer=!1,this._update();const i=this._map;return i&&(i.on("move",this._update),i.off("mousemove",this._onMouseEvent),i._canvasContainer.classList.remove("mapboxgl-track-pointer")),this}trackPointer(){this._trackPointer=!0,this._pos=null,this._update();const e=this._map;return e&&(e.off("move",this._update),e.on("mousemove",this._onMouseEvent),e.on("drag",this._onMouseEvent),e._canvasContainer.classList.add("mapboxgl-track-pointer")),this}getElement(){return this._container}setText(t){return this.setDOMContent(e.window.document.createTextNode(t))}setHTML(t){const i=e.window.document.createDocumentFragment(),o=e.window.document.createElement("body");let r;for(o.innerHTML=t;r=o.firstChild,r;)i.appendChild(r);return this.setDOMContent(i)}getMaxWidth(){return this._container&&this._container.style.maxWidth}setMaxWidth(e){return this.options.maxWidth=e,this._update(),this}setDOMContent(e){let t=this._content;if(t)for(;t.hasChildNodes();)t.firstChild&&t.removeChild(t.firstChild);else t=this._content=n("div","mapboxgl-popup-content",this._container||void 0);if(t.appendChild(e),this.options.closeButton){const e=this._closeButton=n("button","mapboxgl-popup-close-button",t);e.type="button",e.setAttribute("aria-label","Close popup"),e.setAttribute("aria-hidden","true"),e.innerHTML="&#215;",e.addEventListener("click",this._onClose);}return this._update(),this._focusFirstElement(),this}addClassName(e){return this._classList.add(e),this._updateClassList(),this}removeClassName(e){return this._classList.delete(e),this._updateClassList(),this}setOffset(e){return this.options.offset=e,this._update(),this}toggleClassName(e){let t;return this._classList.delete(e)?t=!1:(this._classList.add(e),t=!0),this._updateClassList(),t}_onMouseEvent(e){this._update(e.point);}_getAnchor(e){if(this.options.anchor)return this.options.anchor;const t=this._map,i=this._container,o=this._pos;if(!t||!i||!o)return "bottom";const r=i.offsetWidth,n=i.offsetHeight,s=o.x<r/2,a=o.x>t.transform.width-r/2;if(o.y+e<n)return s?"top-left":a?"top-right":"top";if(o.y>t.transform.height-n){if(s)return "bottom-left";if(a)return "bottom-right"}return s?"left":a?"right":"bottom"}_updateClassList(){const e=this._container;if(!e)return;const t=[...this._classList];t.push("mapboxgl-popup"),this._anchor&&t.push(`mapboxgl-popup-anchor-${this._anchor}`),this._trackPointer&&t.push("mapboxgl-popup-track-pointer"),e.className=t.join(" ");}_update(t){const i=this._map,o=this._content;if(!i||!this._lngLat&&!this._trackPointer||!o)return;let r=this._container;if(r||(r=this._container=n("div","mapboxgl-popup",i.getContainer()),this._tip=n("div","mapboxgl-popup-tip",r),r.appendChild(o)),this.options.maxWidth&&r.style.maxWidth!==this.options.maxWidth&&(r.style.maxWidth=this.options.maxWidth),i.transform.renderWorldCopies&&!this._trackPointer&&(this._lngLat=Jr(this._lngLat,this._pos,i.transform)),!this._trackPointer||t){const e=this._pos=this._trackPointer&&t?t:i.project(this._lngLat),o=rn(this.options.offset),r=this._anchor=this._getAnchor(o.y),n=rn(this.options.offset,r),s=e.add(n).round();i._requestDomTask((()=>{this._container&&r&&(this._container.style.transform=`${Qr[r]} translate(${s.x}px,${s.y}px)`);}));}if(!this._marker&&i._showingGlobe()){const t=e.isLngLatBehindGlobe(i.transform,this._lngLat)?0:1;this._setOpacity(t);}this._updateClassList();}_focusFirstElement(){if(!this.options.focusAfterOpen||!this._container)return;const e=this._container.querySelector(on);e&&e.focus();}_onClose(){this.remove();}_setOpacity(e){this._container&&(this._container.style.opacity=`${e}`),this._content&&(this._content.style.pointerEvents=e?"auto":"none");}},Marker:en,Style:Kt,LngLat:e.LngLat,LngLatBounds:e.LngLatBounds,Point:e.Point,MercatorCoordinate:e.MercatorCoordinate,FreeCameraOptions:jo,Evented:e.Evented,config:e.config,prewarm:function(){Ue().acquire(Be);},clearPrewarmedResources:function(){const e=Fe;e&&(e.isPreloaded()&&1===e.numActive()?(e.release(Be),Fe=null):console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));},get accessToken(){return e.config.ACCESS_TOKEN},set accessToken(t){e.config.ACCESS_TOKEN=t;},get baseApiUrl(){return e.config.API_URL},set baseApiUrl(t){e.config.API_URL=t;},get workerCount(){return ke.workerCount},set workerCount(e){ke.workerCount=e;},get maxParallelImageRequests(){return e.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(t){e.config.MAX_PARALLEL_IMAGE_REQUESTS=t;},clearStorage(t){e.clearTileCache(t);},workerUrl:"",workerClass:null,setNow:e.exported.setNow,restoreNow:e.exported.restoreNow};return dn}));

//
// Our custom intro provides a specialized "define()" function, called by the
// AMD modules below, that sets up the worker blob URL and then executes the
// main module, storing its exported value as 'mapboxgl'


var mapboxgl$1 = mapboxgl;

return mapboxgl$1;

}));
//# sourceMappingURL=mapbox-gl.js.map


/***/ }),

/***/ 7452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = "object" === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof __webpack_require__.g === "object" ? __webpack_require__.g :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);


/***/ }),

/***/ 5611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var content = __webpack_require__(8259);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 3027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(7874);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 7874:
/***/ (function(module) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ 3893:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3893__;

/***/ }),

/***/ 6252:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__6252__;

/***/ }),

/***/ 2776:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"AD":"AND","AE":"ARE","AF":"AFG","AG":"ATG","AI":"AIA","AL":"ALB","AM":"ARM","AO":"AGO","AQ":"ATA","AR":"ARG","AS":"ASM","AT":"AUT","AU":"AUS","AW":"ABW","AX":"ALA","AZ":"AZE","BA":"BIH","BB":"BRB","BD":"BGD","BE":"BEL","BF":"BFA","BG":"BGR","BH":"BHR","BI":"BDI","BJ":"BEN","BL":"BLM","BM":"BMU","BN":"BRN","BO":"BOL","BQ":"BES","BR":"BRA","BS":"BHS","BT":"BTN","BV":"BVT","BW":"BWA","BY":"BLR","BZ":"BLZ","CA":"CAN","CC":"CCK","CD":"COD","CF":"CAF","CG":"COG","CH":"CHE","CI":"CIV","CK":"COK","CL":"CHL","CM":"CMR","CN":"CHN","CO":"COL","CR":"CRI","CU":"CUB","CV":"CPV","CW":"CUW","CX":"CXR","CY":"CYP","CZ":"CZE","DE":"DEU","DJ":"DJI","DK":"DNK","DM":"DMA","DO":"DOM","DZ":"DZA","EC":"ECU","EE":"EST","EG":"EGY","EH":"ESH","ER":"ERI","ES":"ESP","ET":"ETH","FI":"FIN","FJ":"FJI","FK":"FLK","FM":"FSM","FO":"FRO","FR":"FRA","GA":"GAB","GB":"GBR","GD":"GRD","GE":"GEO","GF":"GUF","GG":"GGY","GH":"GHA","GI":"GIB","GL":"GRL","GM":"GMB","GN":"GIN","GP":"GLP","GQ":"GNQ","GR":"GRC","GS":"SGS","GT":"GTM","GU":"GUM","GW":"GNB","GY":"GUY","HK":"HKG","HM":"HMD","HN":"HND","HR":"HRV","HT":"HTI","HU":"HUN","ID":"IDN","IE":"IRL","IL":"ISR","IM":"IMN","IN":"IND","IO":"IOT","IQ":"IRQ","IR":"IRN","IS":"ISL","IT":"ITA","JE":"JEY","JM":"JAM","JO":"JOR","JP":"JPN","KE":"KEN","KG":"KGZ","KH":"KHM","KI":"KIR","KM":"COM","KN":"KNA","KP":"PRK","KR":"KOR","KW":"KWT","KY":"CYM","KZ":"KAZ","LA":"LAO","LB":"LBN","LC":"LCA","LI":"LIE","LK":"LKA","LR":"LBR","LS":"LSO","LT":"LTU","LU":"LUX","LV":"LVA","LY":"LBY","MA":"MAR","MC":"MCO","MD":"MDA","ME":"MNE","MF":"MAF","MG":"MDG","MH":"MHL","MK":"MKD","ML":"MLI","MM":"MMR","MN":"MNG","MO":"MAC","MP":"MNP","MQ":"MTQ","MR":"MRT","MS":"MSR","MT":"MLT","MU":"MUS","MV":"MDV","MW":"MWI","MX":"MEX","MY":"MYS","MZ":"MOZ","NA":"NAM","NC":"NCL","NE":"NER","NF":"NFK","NG":"NGA","NI":"NIC","NL":"NLD","NO":"NOR","NP":"NPL","NR":"NRU","NU":"NIU","NZ":"NZL","OM":"OMN","PA":"PAN","PE":"PER","PF":"PYF","PG":"PNG","PH":"PHL","PK":"PAK","PL":"POL","PM":"SPM","PN":"PCN","PR":"PRI","PS":"PSE","PT":"PRT","PW":"PLW","PY":"PRY","QA":"QAT","RE":"REU","RO":"ROU","RS":"SRB","RU":"RUS","RW":"RWA","SA":"SAU","SB":"SLB","SC":"SYC","SD":"SDN","SE":"SWE","SG":"SGP","SH":"SHN","SI":"SVN","SJ":"SJM","SK":"SVK","SL":"SLE","SM":"SMR","SN":"SEN","SO":"SOM","SR":"SUR","SS":"SSD","ST":"STP","SV":"SLV","SX":"SXM","SY":"SYR","SZ":"SWZ","TC":"TCA","TD":"TCD","TF":"ATF","TG":"TGO","TH":"THA","TJ":"TJK","TK":"TKL","TL":"TLS","TM":"TKM","TN":"TUN","TO":"TON","TR":"TUR","TT":"TTO","TV":"TUV","TW":"TWN","TZ":"TZA","UA":"UKR","UG":"UGA","UM":"UMI","US":"USA","UY":"URY","UZ":"UZB","VA":"VAT","VC":"VCT","VE":"VEN","VG":"VGB","VI":"VIR","VN":"VNM","VU":"VUT","WF":"WLF","WS":"WSM","YE":"YEM","YT":"MYT","ZA":"ZAF","ZM":"ZMB","ZW":"ZWE"}');

/***/ }),

/***/ 3702:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["AD","AE","AF","AG","AI","AL","AM","AO","AQ","AR","AS","AT","AU","AW","AX","AZ","BA","BB","BD","BE","BF","BG","BH","BI","BJ","BL","BM","BN","BO","BQ","BR","BS","BT","BV","BW","BY","BZ","CA","CC","CD","CF","CG","CH","CI","CK","CL","CM","CN","CO","CR","CU","CV","CW","CX","CY","CZ","DE","DJ","DK","DM","DO","DZ","EC","EE","EG","EH","ER","ES","ET","FI","FJ","FK","FM","FO","FR","GA","GB","GD","GE","GF","GG","GH","GI","GL","GM","GN","GP","GQ","GR","GS","GT","GU","GW","GY","HK","HM","HN","HR","HT","HU","ID","IE","IL","IM","IN","IO","IQ","IR","IS","IT","JE","JM","JO","JP","KE","KG","KH","KI","KM","KN","KP","KR","KW","KY","KZ","LA","LB","LC","LI","LK","LR","LS","LT","LU","LV","LY","MA","MC","MD","ME","MF","MG","MH","MK","ML","MM","MN","MO","MP","MQ","MR","MS","MT","MU","MV","MW","MX","MY","MZ","NA","NC","NE","NF","NG","NI","NL","NO","NP","NR","NU","NZ","OM","PA","PE","PF","PG","PH","PK","PL","PM","PN","PR","PS","PT","PW","PY","QA","RE","RO","RS","RU","RW","SA","SB","SC","SD","SE","SG","SH","SI","SJ","SK","SL","SM","SN","SO","SR","SS","ST","SV","SX","SY","SZ","TC","TD","TF","TG","TH","TJ","TK","TL","TM","TN","TO","TR","TT","TV","TW","TZ","UA","UG","UM","US","UY","UZ","VA","VC","VE","VG","VI","VN","VU","WF","WS","YE","YT","ZA","ZM","ZW"]');

/***/ }),

/***/ 1345:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"AND":"AD","ARE":"AE","AFG":"AF","ATG":"AG","AIA":"AI","ALB":"AL","ARM":"AM","AGO":"AO","ATA":"AQ","ARG":"AR","ASM":"AS","AUT":"AT","AUS":"AU","ABW":"AW","ALA":"AX","AZE":"AZ","BIH":"BA","BRB":"BB","BGD":"BD","BEL":"BE","BFA":"BF","BGR":"BG","BHR":"BH","BDI":"BI","BEN":"BJ","BLM":"BL","BMU":"BM","BRN":"BN","BOL":"BO","BES":"BQ","BRA":"BR","BHS":"BS","BTN":"BT","BVT":"BV","BWA":"BW","BLR":"BY","BLZ":"BZ","CAN":"CA","CCK":"CC","COD":"CD","CAF":"CF","COG":"CG","CHE":"CH","CIV":"CI","COK":"CK","CHL":"CL","CMR":"CM","CHN":"CN","COL":"CO","CRI":"CR","CUB":"CU","CPV":"CV","CUW":"CW","CXR":"CX","CYP":"CY","CZE":"CZ","DEU":"DE","DJI":"DJ","DNK":"DK","DMA":"DM","DOM":"DO","DZA":"DZ","ECU":"EC","EST":"EE","EGY":"EG","ESH":"EH","ERI":"ER","ESP":"ES","ETH":"ET","FIN":"FI","FJI":"FJ","FLK":"FK","FSM":"FM","FRO":"FO","FRA":"FR","GAB":"GA","GBR":"GB","GRD":"GD","GEO":"GE","GUF":"GF","GGY":"GG","GHA":"GH","GIB":"GI","GRL":"GL","GMB":"GM","GIN":"GN","GLP":"GP","GNQ":"GQ","GRC":"GR","SGS":"GS","GTM":"GT","GUM":"GU","GNB":"GW","GUY":"GY","HKG":"HK","HMD":"HM","HND":"HN","HRV":"HR","HTI":"HT","HUN":"HU","IDN":"ID","IRL":"IE","ISR":"IL","IMN":"IM","IND":"IN","IOT":"IO","IRQ":"IQ","IRN":"IR","ISL":"IS","ITA":"IT","JEY":"JE","JAM":"JM","JOR":"JO","JPN":"JP","KEN":"KE","KGZ":"KG","KHM":"KH","KIR":"KI","COM":"KM","KNA":"KN","PRK":"KP","KOR":"KR","KWT":"KW","CYM":"KY","KAZ":"KZ","LAO":"LA","LBN":"LB","LCA":"LC","LIE":"LI","LKA":"LK","LBR":"LR","LSO":"LS","LTU":"LT","LUX":"LU","LVA":"LV","LBY":"LY","MAR":"MA","MCO":"MC","MDA":"MD","MNE":"ME","MAF":"MF","MDG":"MG","MHL":"MH","MKD":"MK","MLI":"ML","MMR":"MM","MNG":"MN","MAC":"MO","MNP":"MP","MTQ":"MQ","MRT":"MR","MSR":"MS","MLT":"MT","MUS":"MU","MDV":"MV","MWI":"MW","MEX":"MX","MYS":"MY","MOZ":"MZ","NAM":"NA","NCL":"NC","NER":"NE","NFK":"NF","NGA":"NG","NIC":"NI","NLD":"NL","NOR":"NO","NPL":"NP","NRU":"NR","NIU":"NU","NZL":"NZ","OMN":"OM","PAN":"PA","PER":"PE","PYF":"PF","PNG":"PG","PHL":"PH","PAK":"PK","POL":"PL","SPM":"PM","PCN":"PN","PRI":"PR","PSE":"PS","PRT":"PT","PLW":"PW","PRY":"PY","QAT":"QA","REU":"RE","ROU":"RO","SRB":"RS","RUS":"RU","RWA":"RW","SAU":"SA","SLB":"SB","SYC":"SC","SDN":"SD","SWE":"SE","SGP":"SG","SHN":"SH","SVN":"SI","SJM":"SJ","SVK":"SK","SLE":"SL","SMR":"SM","SEN":"SN","SOM":"SO","SUR":"SR","SSD":"SS","STP":"ST","SLV":"SV","SXM":"SX","SYR":"SY","SWZ":"SZ","TCA":"TC","TCD":"TD","ATF":"TF","TGO":"TG","THA":"TH","TJK":"TJ","TKL":"TK","TLS":"TL","TKM":"TM","TUN":"TN","TON":"TO","TUR":"TR","TTO":"TT","TUV":"TV","TWN":"TW","TZA":"TZ","UKR":"UA","UGA":"UG","UMI":"UM","USA":"US","URY":"UY","UZB":"UZ","VAT":"VA","VCT":"VC","VEN":"VE","VGB":"VG","VIR":"VI","VNM":"VN","VUT":"VU","WLF":"WF","WSM":"WS","YEM":"YE","MYT":"YT","ZAF":"ZA","ZMB":"ZM","ZWE":"ZW"}');

/***/ }),

/***/ 6269:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"AD":"AD","ANDORRA":"AD","UNITEDARABEMIRATES":"AE","دولةالإماراتالعربيةالمتحدة":"AE","UAE":"AE","AE":"AE","ARE":"AE","AFGHANISTAN":"AF","افغانستان":"AF","AFGANISTAN":"AF","AF":"AF","AFG":"AF","ANTIGUABARBUDA":"AG","ANTIGUAANDBARBUDA":"AG","AG":"AG","ATG":"AG","ANGUILLA":"AI","AI":"AI","AIA":"AI","ALBANIA":"AL","SHQIPERIA":"AL","SHQIPERI":"AL","SHQIPNIA":"AL","AL":"AL","ALB":"AL","ARMENIA":"AM","ՀԱՅԱՍՏԱՆ":"AM","HAYASTAN":"AM","REPUBLICARMENIA":"AM","REPUBLICOFARMENIA":"AM","ՀԱՅԱՍՏԱՆԻՀԱՆՐԱՊԵՏՈՒԹՅՈՒՆ":"AM","AM":"AM","ARM":"AM","ANGOLA":"AO","REPUBLICADEANGOLA":"AO","REPUBLIKADEANGOLA":"AO","AO":"AO","AGO":"AO","AQ":"AQ","ATA":"AQ","ANTARCTICA":"AQ","ARGENTINA":"AR","ARGENTINEREPUBLIC":"AR","REPUBLICAARGENTINA":"AR","AR":"AR","ARG":"AR","AMERICANSAMOA":"AS","AMERIKASAMOA":"AS","AMELIKASAMOA":"AS","SAMOAAMELIKA":"AS","AS":"AS","ASM":"AS","AUSTRIA":"AT","OSTERREICH":"AT","OESTERREICH":"AT","AT":"AT","AUT":"AT","AUSTRALIA":"AU","AU":"AU","AUS":"AU","ARUBA":"AW","AW":"AW","ABW":"AW","AX":"AX","ALA":"AX","ALANDISLANDS":"AX","AZERBAIJAN":"AZ","AZƏRBAYCAN":"AZ","REPUBLICAZERBAIJAN":"AZ","REPUBLICOFAZERBAIJAN":"AZ","AZƏRBAYCANRESPUBLIKASI":"AZ","AZ":"AZ","AZE":"AZ","AZERBAIJANREPUBLIC":"AZ","AZERBAIJANREPUBLICOF":"AZ","BOSNIAHERZEGOVINA":"BA","BOSNIAANDHERZEGOVINA":"BA","BOSNAIHERCEGOVINA":"BA","BOSNAIHERTSEGOVINA":"BA","BA":"BA","BIH":"BA","BARBADOS":"BB","BB":"BB","BRB":"BB","BANGLADESH":"BD","বাংলাদেশ":"BD","PEOPLESREPUBLICBANGLADESH":"BD","PEOPLESREPUBLICOFBANGLADESH":"BD","GONOPROJATONTRIBANGLADESH":"BD","BD":"BD","BGD":"BD","BELGIUM":"BE","BELGIE":"BE","BELGIEN":"BE","BELGIQUE":"BE","KINGDOMBELGIUM":"BE","KINGDOMOFBELGIUM":"BE","KONINKRIJKBELGIE":"BE","ROYAUMEDEBELGIQUE":"BE","KONIGREICHBELGIEN":"BE","BE":"BE","BEL":"BE","BURKINAFASO":"BF","BF":"BF","BFA":"BF","BULGARIA":"BG","BLGARIYA":"BG","REPUBLICBULGARIA":"BG","REPUBLICOFBULGARIA":"BG","REPUBLIKABLGARIYA":"BG","BG":"BG","BGR":"BG","BAHRAIN":"BH","‏البحرين":"BH","KINGDOMBAHRAIN":"BH","KINGDOMOFBAHRAIN":"BH","MAMLAKATALBAHRAYN":"BH","BH":"BH","BHR":"BH","BURUNDI":"BI","REPUBLICBURUNDI":"BI","REPUBLICOFBURUNDI":"BI","REPUBLIKAYUBURUNDI":"BI","REPUBLIQUEDUBURUNDI":"BI","BI":"BI","BDI":"BI","BENIN":"BJ","REPUBLICBENIN":"BJ","REPUBLICOFBENIN":"BJ","REPUBLIQUEDUBENIN":"BJ","BJ":"BJ","BEN":"BJ","BL":"BL","BLM":"BL","SAINTBARTHELEMY":"BL","BERMUDA":"BM","ISLANDSBERMUDA":"BM","THEISLANDSOFBERMUDA":"BM","BERMUDAS":"BM","THEBERMUDAS":"BM","SOMERSISLES":"BM","BM":"BM","BMU":"BM","BRUNEIDARUSSALAM":"BN","BRUNEI":"BN","NEGARABRUNEIDARUSSALAM":"BN","NATIONBRUNEI":"BN","NATIONOFBRUNEI":"BN","ABODEPEACE":"BN","THEABODEOFPEACE":"BN","BN":"BN","BRN":"BN","BOLIVIAPLURINATIONALSTATE":"BO","BOLIVIAPLURINATIONALSTATEOF":"BO","BOLIVIA":"BO","BULIWYA":"BO","WULIWYA":"BO","PLURINATIONALSTATEBOLIVIA":"BO","PLURINATIONALSTATEOFBOLIVIA":"BO","ESTADOPLURINACIONALDEBOLIVIA":"BO","BULIWYAMAMALLAQTA":"BO","WULIWYASUYU":"BO","TETAVOLIVIA":"BO","BO":"BO","BOL":"BO","BQ":"BQ","BES":"BQ","BONAIRESINTEUSTATIUSSABA":"BQ","BONAIRESINTEUSTATIUSANDSABA":"BQ","BONAIRESAINTEUSTATIUSSABA":"BQ","BONAIRESAINTEUSTATIUSANDSABA":"BQ","BRAZIL":"BR","BRASIL":"BR","FEDERATIVEREPUBLICBRAZIL":"BR","FEDERATIVEREPUBLICOFBRAZIL":"BR","REPUBLICAFEDERATIVADOBRASIL":"BR","BR":"BR","BRA":"BR","BAHAMAS":"BS","THEBAHAMAS":"BS","COMMONWEALTHBAHAMAS":"BS","COMMONWEALTHOFTHEBAHAMAS":"BS","BS":"BS","BHS":"BS","BHUTAN":"BT","ʼBRUGYUL":"BT","KINGDOMBHUTAN":"BT","KINGDOMOFBHUTAN":"BT","BT":"BT","BTN":"BT","BV":"BV","BVT":"BV","BOUVETISLAND":"BV","BOTSWANA":"BW","REPUBLICBOTSWANA":"BW","REPUBLICOFBOTSWANA":"BW","LEFATSHELABOTSWANA":"BW","BW":"BW","BWA":"BW","BELARUS":"BY","BELARÚS":"BY","BIELARUS":"BY","REPUBLICBELARUS":"BY","REPUBLICOFBELARUS":"BY","BELORUSSIYA":"BY","RESPUBLIKABELARUS":"BY","RESPUBLIKABELARUS’":"BY","BY":"BY","BLR":"BY","BELIZE":"BZ","BZ":"BZ","BLZ":"BZ","CANADA":"CA","CA":"CA","CAN":"CA","COCOSKEELINGISLANDS":"CC","TERRITORYCOCOSKEELINGISLANDS":"CC","TERRITORYOFTHECOCOSKEELINGISLANDS":"CC","KEELINGISLANDS":"CC","CC":"CC","CCK":"CC","CONGODEMOCRATICREPUBLIC":"CD","CONGODEMOCRATICREPUBLICOFTHE":"CD","DEMOCRATICREPUBLICCONGO":"CD","DEMOCRATICREPUBLICOFTHECONGO":"CD","REPUBLIQUEDEMOCRATIQUEDUCONGO":"CD","DRCONGO":"CD","CONGOKINSHASA":"CD","DRC":"CD","CD":"CD","COD":"CD","CONGOTHEDEMOCRATICREPUBLICOFTHE":"CD","CENTRALAFRICANREPUBLIC":"CF","KODOROSESETIBEAFRIKA":"CF","REPUBLIQUECENTRAFRICAINE":"CF","CF":"CF","CAF":"CF","CONGO":"CG","REPUBLICCONGO":"CG","REPUBLICOFTHECONGO":"CG","REPUBLIQUEDUCONGO":"CG","CONGOBRAZZAVILLE":"CG","CG":"CG","COG":"CG","SWITZERLAND":"CH","SCHWEIZ":"CH","SWISSCONFEDERATION":"CH","SUISSE":"CH","SVIZZERA":"CH","SVIZRA":"CH","CH":"CH","CHE":"CH","COTEDIVOIRE":"CI","IVORYCOAST":"CI","REPUBLICCOTEDIVOIRE":"CI","REPUBLICOFCOTEDIVOIRE":"CI","REPUBLIQUEDECOTEDIVOIRE":"CI","CI":"CI","CIV":"CI","COOKISLANDS":"CK","KUKIAIRANI":"CK","CK":"CK","COK":"CK","CHILE":"CL","REPUBLICCHILE":"CL","REPUBLICOFCHILE":"CL","REPUBLICADECHILE":"CL","CL":"CL","CHL":"CL","CAMEROON":"CM","REPUBLICCAMEROON":"CM","REPUBLICOFCAMEROON":"CM","REPUBLIQUEDUCAMEROUN":"CM","CM":"CM","CMR":"CM","CHINA":"CN","中国":"CN","ZHONGGUO":"CN","ZHONGHUA":"CN","PEOPLESREPUBLICCHINA":"CN","PEOPLESREPUBLICOFCHINA":"CN","中华人民共和国":"CN","ZHONGHUARENMINGONGHEGUO":"CN","CN":"CN","CHN":"CN","CHINAPEOPLESREPUBLIC":"CN","CHINAPEOPLESREPUBLICOF":"CN","COLOMBIA":"CO","REPUBLICCOLOMBIA":"CO","REPUBLICOFCOLOMBIA":"CO","REPUBLICADECOLOMBIA":"CO","CO":"CO","COL":"CO","COSTARICA":"CR","REPUBLICCOSTARICA":"CR","REPUBLICOFCOSTARICA":"CR","REPUBLICADECOSTARICA":"CR","CR":"CR","CRI":"CR","CUBA":"CU","REPUBLICCUBA":"CU","REPUBLICOFCUBA":"CU","REPUBLICADECUBA":"CU","CU":"CU","CUB":"CU","CABOVERDE":"CV","CAPEVERDE":"CV","REPUBLICCABOVERDE":"CV","REPUBLICOFCABOVERDE":"CV","REPUBLICADECABOVERDE":"CV","CV":"CV","CPV":"CV","CW":"CW","CUW":"CW","CURACAO":"CW","CHRISTMASISLAND":"CX","TERRITORYCHRISTMASISLAND":"CX","TERRITORYOFCHRISTMASISLAND":"CX","CX":"CX","CXR":"CX","CYPRUS":"CY","ΚΎΠΡΟΣ":"CY","KYPROS":"CY","KIBRIS":"CY","REPUBLICCYPRUS":"CY","REPUBLICOFCYPRUS":"CY","ΚΥΠΡΙΑΚΉΔΗΜΟΚΡΑΤΊΑ":"CY","KIBRISCUMHURIYETI":"CY","CY":"CY","CYP":"CY","CZECHIA":"CZ","CZECHREPUBLIC":"CZ","CESKAREPUBLIKA":"CZ","CESKO":"CZ","CZ":"CZ","CZE":"CZ","GERMANY":"DE","DEUTSCHLAND":"DE","FEDERALREPUBLICGERMANY":"DE","FEDERALREPUBLICOFGERMANY":"DE","BUNDESREPUBLIKDEUTSCHLAND":"DE","DE":"DE","DEU":"DE","DJIBOUTI":"DJ","JABUUTI":"DJ","GABUUTI":"DJ","REPUBLICDJIBOUTI":"DJ","REPUBLICOFDJIBOUTI":"DJ","REPUBLIQUEDEDJIBOUTI":"DJ","GABUUTIHUMMUUNO":"DJ","JAMHUURIYADDAJABUUTI":"DJ","DJ":"DJ","DJI":"DJ","DENMARK":"DK","DANMARK":"DK","KINGDOMDENMARK":"DK","KINGDOMOFDENMARK":"DK","KONGERIGETDANMARK":"DK","DK":"DK","DNK":"DK","DOMINICA":"DM","DOMINIQUE":"DM","WAI‘TUKUBULI":"DM","COMMONWEALTHDOMINICA":"DM","COMMONWEALTHOFDOMINICA":"DM","DM":"DM","DMA":"DM","DOMINICANREPUBLIC":"DO","REPUBLICADOMINICANA":"DO","DO":"DO","DOM":"DO","ALGERIA":"DZ","الجزائر":"DZ","DZAYER":"DZ","ALGERIE":"DZ","DZ":"DZ","DZA":"DZ","ECUADOR":"EC","REPUBLICECUADOR":"EC","REPUBLICOFECUADOR":"EC","REPUBLICADELECUADOR":"EC","EC":"EC","ECU":"EC","ESTONIA":"EE","EESTI":"EE","REPUBLICESTONIA":"EE","REPUBLICOFESTONIA":"EE","EESTIVABARIIK":"EE","EE":"EE","EST":"EE","EGYPT":"EG","مصر‎":"EG","ARABREPUBLICEGYPT":"EG","ARABREPUBLICOFEGYPT":"EG","EG":"EG","EGY":"EG","WESTERNSAHARA":"EH","الصحراءالغربية":"EH","TANEZROFTTUTRIMT":"EH","EH":"EH","ESH":"EH","ERITREA":"ER","ኤርትራ":"ER","STATEERITREA":"ER","STATEOFERITREA":"ER","ሃገረኤርትራ":"ER","DAWLATIRITRIYA":"ER","ʾERTRA":"ER","IRITRIYA":"ER","ER":"ER","ERI":"ER","SPAIN":"ES","ESPANA":"ES","KINGDOMSPAIN":"ES","KINGDOMOFSPAIN":"ES","REINODEESPANA":"ES","ES":"ES","ESP":"ES","ETHIOPIA":"ET","ኢትዮጵያ":"ET","ʾITYOPPYA":"ET","FEDERALDEMOCRATICREPUBLICETHIOPIA":"ET","FEDERALDEMOCRATICREPUBLICOFETHIOPIA":"ET","የኢትዮጵያፌዴራላዊዲሞክራሲያዊሪፐብሊክ":"ET","ET":"ET","ETH":"ET","FINLAND":"FI","SUOMI":"FI","REPUBLICFINLAND":"FI","REPUBLICOFFINLAND":"FI","SUOMENTASAVALTA":"FI","REPUBLIKENFINLAND":"FI","FI":"FI","FIN":"FI","FIJI":"FJ","VITI":"FJ","REPUBLICFIJI":"FJ","REPUBLICOFFIJI":"FJ","MATANITUKOVITI":"FJ","FIJIGANARAJYA":"FJ","FJ":"FJ","FJI":"FJ","FALKLANDISLANDSMALVINAS":"FK","FALKLANDISLANDS":"FK","ISLASMALVINAS":"FK","FK":"FK","FLK":"FK","MICRONESIAFEDERATEDSTATES":"FM","MICRONESIAFEDERATEDSTATESOF":"FM","FEDERATEDSTATESMICRONESIA":"FM","FEDERATEDSTATESOFMICRONESIA":"FM","MICRONESIA":"FM","FM":"FM","FSM":"FM","FAROEISLANDS":"FO","FOROYAR":"FO","FAEROERNE":"FO","FO":"FO","FRO":"FO","FRANCE":"FR","FRENCHREPUBLIC":"FR","REPUBLIQUEFRANCAISE":"FR","FR":"FR","FRA":"FR","GABON":"GA","GABONESEREPUBLIC":"GA","REPUBLIQUEGABONAISE":"GA","GA":"GA","GAB":"GA","ENGLAND":"GB","GB":"GB","GBR":"GB","GREATBRITAIN":"GB","NIRELAND":"GB","NORTHERNIRELAND":"GB","SCOTLAND":"GB","UK":"GB","UNITEDKINGDOMGBNI":"GB","UNITEDKINGDOMOFGBANDNI":"GB","UNITEDKINGDOMGBNORTHERNIRELAND":"GB","UNITEDKINGDOMOFGBANDNORTHERNIRELAND":"GB","UNITEDKINGDOMGREATBRITAINNIRELAND":"GB","UNITEDKINGDOMOFGREATBRITAINANDNIRELAND":"GB","UNITEDKINGDOMGREATBRITAINNI":"GB","UNITEDKINGDOMOFGREATBRITAINANDNI":"GB","UNITEDKINGDOMGREATBRITAINNORTHERNIRELAND":"GB","UNITEDKINGDOMOFGREATBRITAINANDNORTHERNIRELAND":"GB","UNITEDKINGDOMGREATBRITAIN":"GB","UNITEDKINGDOMOFGREATBRITAIN":"GB","UNITEDKINGDOM":"GB","WALES":"GB","GRENADA":"GD","GD":"GD","GRD":"GD","GEORGIA":"GE","ᲡᲐᲥᲐᲠᲗᲕᲔᲚᲝ":"GE","SAKARTVELO":"GE","GE":"GE","GEO":"GE","FRENCHGUIANA":"GF","GUYANEFRANCAISE":"GF","GUIANA":"GF","GUYANE":"GF","GF":"GF","GUF":"GF","GUERNSEY":"GG","BAILIWICKGUERNSEY":"GG","BAILIWICKOFGUERNSEY":"GG","BAILLIAGEDEGUERNESEY":"GG","GG":"GG","GGY":"GG","GHANA":"GH","GH":"GH","GHA":"GH","GIBRALTAR":"GI","GI":"GI","GIB":"GI","GREENLAND":"GL","KALAALLITNUNAAT":"GL","GRONLAND":"GL","GL":"GL","GRL":"GL","GAMBIA":"GM","THEGAMBIA":"GM","REPUBLICGAMBIA":"GM","REPUBLICOFTHEGAMBIA":"GM","GM":"GM","GMB":"GM","GUINEA":"GN","GUINEE":"GN","REPUBLICGUINEA":"GN","REPUBLICOFGUINEA":"GN","REPUBLIQUEDEGUINEE":"GN","GN":"GN","GIN":"GN","GUADELOUPE":"GP","GWADLOUP":"GP","GP":"GP","GLP":"GP","EQUATORIALGUINEA":"GQ","GUINEAECUATORIAL":"GQ","REPUBLICEQUATORIALGUINEA":"GQ","REPUBLICOFEQUATORIALGUINEA":"GQ","REPUBLICADEGUINEAECUATORIAL":"GQ","REPUBLIQUEDEGUINEEEQUATORIALE":"GQ","REPUBLICADAGUINEEQUATORIAL":"GQ","GQ":"GQ","GNQ":"GQ","GREECE":"GR","ΕΛΛΆΔΑ":"GR","ELLADA":"GR","HELLENICREPUBLIC":"GR","ΕΛΛΗΝΙΚΉΔΗΜΟΚΡΑΤΊΑ":"GR","GR":"GR","GRC":"GR","SOUTHGEORGIASOUTHSANDWICHISLANDS":"GS","SOUTHGEORGIAANDTHESOUTHSANDWICHISLANDS":"GS","SOUTHGEORGIA":"GS","GS":"GS","SGS":"GS","GUATEMALA":"GT","GT":"GT","GTM":"GT","GUAM":"GU","GUAHAN":"GU","GU":"GU","GUM":"GU","GUINEABISSAU":"GW","GUINEBISSAU":"GW","REPUBLICGUINEABISSAU":"GW","REPUBLICOFGUINEABISSAU":"GW","REPUBLICADAGUINEBISSAU":"GW","GW":"GW","GNB":"GW","GUYANA":"GY","COOPERATIVEREPUBLICGUYANA":"GY","COOPERATIVEREPUBLICOFGUYANA":"GY","GY":"GY","GUY":"GY","HONGKONG":"HK","香港":"HK","HK":"HK","HKG":"HK","HKSAR":"HK","HONGKONGSPECIALADMINISTRATIVEREGIONPEOPLESREPUBLICCHINA":"HK","HONGKONGSPECIALADMINISTRATIVEREGIONOFTHEPEOPLESREPUBLICOFCHINA":"HK","HONGKONGSARCHINA":"HK","HEARDISLANDMCDONALDISLANDS":"HM","HEARDISLANDANDMCDONALDISLANDS":"HM","HM":"HM","HMD":"HM","HONDURAS":"HN","REPUBLICHONDURAS":"HN","REPUBLICOFHONDURAS":"HN","REPUBLICADEHONDURAS":"HN","HN":"HN","HND":"HN","CROATIA":"HR","HRVATSKA":"HR","REPUBLICCROATIA":"HR","REPUBLICOFCROATIA":"HR","REPUBLIKAHRVATSKA":"HR","HR":"HR","HRV":"HR","HAITI":"HT","REPUBLICHAITI":"HT","REPUBLICOFHAITI":"HT","REPUBLIQUEDHAITI":"HT","REPIBLIKAYITI":"HT","HT":"HT","HTI":"HT","HUNGARY":"HU","MAGYARORSZAG":"HU","HU":"HU","HUN":"HU","INDONESIA":"ID","REPUBLICINDONESIA":"ID","REPUBLICOFINDONESIA":"ID","REPUBLIKINDONESIA":"ID","ID":"ID","IDN":"ID","IRELAND":"IE","EIRE":"IE","REPUBLICIRELAND":"IE","REPUBLICOFIRELAND":"IE","POBLACHTNAHEIREANN":"IE","IE":"IE","IRL":"IE","ISRAEL":"IL","יִשְׂרָאֵל":"IL","STATEISRAEL":"IL","STATEOFISRAEL":"IL","MEDINATYISRAEL":"IL","IL":"IL","ISR":"IL","ISLEMAN":"IM","ISLEOFMAN":"IM","ELLANVANNIN":"IM","MANN":"IM","MANNIN":"IM","IM":"IM","IMN":"IM","INDIA":"IN","भारत":"IN","BHARAT":"IN","REPUBLICINDIA":"IN","REPUBLICOFINDIA":"IN","BHARATGANRAJYA":"IN","IN":"IN","IND":"IN","BRITISHINDIANOCEANTERRITORY":"IO","IO":"IO","IOT":"IO","IRAQ":"IQ","العراق":"IQ","REPUBLICIRAQ":"IQ","REPUBLICOFIRAQ":"IQ","JUMHURIYYATAL‘IRAQ":"IQ","IQ":"IQ","IRQ":"IQ","IRANISLAMICREPUBLIC":"IR","IRANISLAMICREPUBLICOF":"IR","IRAN":"IR","ISLAMICREPUBLICIRAN":"IR","ISLAMICREPUBLICOFIRAN":"IR","JOMHURIYEESLAMIYEIRAN":"IR","IR":"IR","IRN":"IR","ICELAND":"IS","ISLAND":"IS","REPUBLICICELAND":"IS","REPUBLICOFICELAND":"IS","LYDVELDIDISLAND":"IS","IS":"IS","ISL":"IS","ITALY":"IT","ITALIA":"IT","ITALIANREPUBLIC":"IT","REPUBBLICAITALIANA":"IT","IT":"IT","ITA":"IT","JERSEY":"JE","BAILIWICKJERSEY":"JE","BAILIWICKOFJERSEY":"JE","BAILLIAGEDEJERSEY":"JE","BAILLIAGEDEJERRI":"JE","JE":"JE","JEY":"JE","JAMAICA":"JM","JM":"JM","JAM":"JM","JORDAN":"JO","الأردن":"JO","HASHEMITEKINGDOMJORDAN":"JO","HASHEMITEKINGDOMOFJORDAN":"JO","ALMAMLAKAHALURDUNIYAHALHASHIMIYAH":"JO","JO":"JO","JOR":"JO","JAPAN":"JP","日本":"JP","NIPPON":"JP","NIHON":"JP","JP":"JP","JPN":"JP","KENYA":"KE","REPUBLICKENYA":"KE","REPUBLICOFKENYA":"KE","JAMHURIYAKENYA":"KE","KE":"KE","KEN":"KE","KYRGYZSTAN":"KG","KIRGIZSTAN":"KG","KIRGIZIYA":"KG","KYRGYZREPUBLIC":"KG","KIRGIZRESPUBLIKASI":"KG","KYRGYZRESPUBLIKASY":"KG","KG":"KG","KGZ":"KG","CAMBODIA":"KH","KAMPUCHEA":"KH","KINGDOMCAMBODIA":"KH","KINGDOMOFCAMBODIA":"KH","KH":"KH","KHM":"KH","KIRIBATI":"KI","REPUBLICKIRIBATI":"KI","REPUBLICOFKIRIBATI":"KI","RIBABERIKIKIRIBATI":"KI","KI":"KI","KIR":"KI","COMOROS":"KM","KOMORI":"KM","UNIONCOMOROS":"KM","UNIONOFTHECOMOROS":"KM","UNIONDESCOMORES":"KM","UDZIMAWAKOMORI":"KM","ALITTIHADALQUMURI":"KM","KM":"KM","COM":"KM","SAINTKITTSNEVIS":"KN","SAINTKITTSANDNEVIS":"KN","FEDERATIONSAINTCHRISTOPHERNEVIS":"KN","FEDERATIONOFSAINTCHRISTOPHERANDNEVIS":"KN","KN":"KN","KNA":"KN","KOREADEMOCRATICPEOPLESREPUBLIC":"KP","KOREADEMOCRATICPEOPLESREPUBLICOF":"KP","NORTHKOREA":"KP","북한":"KP","DEMOCRATICPEOPLESREPUBLICKOREA":"KP","DEMOCRATICPEOPLESREPUBLICOFKOREA":"KP","조선민주주의인민공화국":"KP","CHOSONMINJUJUUIINMINKONGHWAGUK":"KP","KP":"KP","PRK":"KP","KOREAREPUBLIC":"KR","KOREAREPUBLICOF":"KR","SOUTHKOREA":"KR","대한민국":"KR","REPUBLICKOREA":"KR","REPUBLICOFKOREA":"KR","KR":"KR","KOR":"KR","KUWAIT":"KW","الكويت":"KW","STATEKUWAIT":"KW","STATEOFKUWAIT":"KW","DAWLATALKUWAIT":"KW","KW":"KW","KWT":"KW","CAYMANISLANDS":"KY","KY":"KY","CYM":"KY","KAZAKHSTAN":"KZ","ҚAZAҚSTAN":"KZ","QAZAQSTAN":"KZ","KAZAHSTAN":"KZ","REPUBLICKAZAKHSTAN":"KZ","REPUBLICOFKAZAKHSTAN":"KZ","ҚAZAҚSTANRESPUBLIKASI":"KZ","QAZAQSTANRESPUBLIKASI":"KZ","RESPUBLIKAKAZAHSTAN":"KZ","RESPUBLIKAKAZAKHSTAN":"KZ","KZ":"KZ","KAZ":"KZ","LAOPEOPLESDEMOCRATICREPUBLIC":"LA","LAOS":"LA","ສປປລາວ":"LA","SATHALANALATPAXATHIPATAIPAXAXONLAO":"LA","LA":"LA","LAO":"LA","LEBANON":"LB","لبنان":"LB","LEBANESEREPUBLIC":"LB","ALJUMHURIYAHALLIBNANIYAH":"LB","LB":"LB","LBN":"LB","SAINTLUCIA":"LC","LC":"LC","LCA":"LC","LIECHTENSTEIN":"LI","PRINCIPALITYLIECHTENSTEIN":"LI","PRINCIPALITYOFLIECHTENSTEIN":"LI","FURSTENTUMLIECHTENSTEIN":"LI","LI":"LI","LIE":"LI","SRILANKA":"LK","SRILAMKAVA":"LK","ILANKAI":"LK","DEMOCRATICSOCIALISTREPUBLICSRILANKA":"LK","DEMOCRATICSOCIALISTREPUBLICOFSRILANKA":"LK","LK":"LK","LKA":"LK","LIBERIA":"LR","REPUBLICLIBERIA":"LR","REPUBLICOFLIBERIA":"LR","LR":"LR","LBR":"LR","LESOTHO":"LS","KINGDOMLESOTHO":"LS","KINGDOMOFLESOTHO":"LS","MUSOOALESOTHO":"LS","LS":"LS","LSO":"LS","LITHUANIA":"LT","LIETUVA":"LT","REPUBLICLITHUANIA":"LT","REPUBLICOFLITHUANIA":"LT","LIETUVOSRESPUBLIKA":"LT","LT":"LT","LTU":"LT","LUXEMBOURG":"LU","GRANDDUCHYLUXEMBOURG":"LU","GRANDDUCHYOFLUXEMBOURG":"LU","GRANDDUCHEDELUXEMBOURG":"LU","GROSSHERZOGTUMLUXEMBURG":"LU","GROUSSHERZOGTUMLETZEBUERG":"LU","LU":"LU","LUX":"LU","LATVIA":"LV","LATVIJA":"LV","REPUBLICLATVIA":"LV","REPUBLICOFLATVIA":"LV","LATVIJASREPUBLIKA":"LV","LV":"LV","LVA":"LV","LIBYA":"LY","‏ليبيا":"LY","STATELIBYA":"LY","STATEOFLIBYA":"LY","DAWLATLIBYA":"LY","LY":"LY","LBY":"LY","MOROCCO":"MA","المغرب":"MA","KINGDOMMOROCCO":"MA","KINGDOMOFMOROCCO":"MA","ALMAMLAKAHALMAGRIBIYAH":"MA","MA":"MA","MAR":"MA","MONACO":"MC","PRINCIPALITYMONACO":"MC","PRINCIPALITYOFMONACO":"MC","PRINCIPAUTEDEMONACO":"MC","MC":"MC","MCO":"MC","MOLDOVAREPUBLIC":"MD","MOLDOVAREPUBLICOF":"MD","MOLDOVA":"MD","REPUBLICMOLDOVA":"MD","REPUBLICOFMOLDOVA":"MD","REPUBLICAMOLDOVA":"MD","MD":"MD","MDA":"MD","ME":"ME","MNE":"ME","MONTENEGRO":"ME","MF":"MF","MAF":"MF","SAINTMARTINFRENCHPART":"MF","SAINTMARTIN":"MF","MADAGASCAR":"MG","MADAGASIKARA":"MG","REPUBLICMADAGASCAR":"MG","REPUBLICOFMADAGASCAR":"MG","REPOBLIKANIMADAGASIKARA":"MG","REPUBLIQUEDEMADAGASCAR":"MG","MG":"MG","MDG":"MG","MARSHALLISLANDS":"MH","M̧AJEL":"MH","REPUBLICMARSHALLISLANDS":"MH","REPUBLICOFTHEMARSHALLISLANDS":"MH","AOLEPANAOROKINM̧AJEL":"MH","MH":"MH","MHL":"MH","NORTHMACEDONIA":"MK","REPUBLICMACEDONIA":"MK","REPUBLICOFMACEDONIA":"MK","MAKEDONIЈA":"MK","REPUBLIKAMAKEDONIЈA":"MK","MK":"MK","MKD":"MK","MACEDONIAFORMERYUGOSLAVREPUBLIC":"MK","MACEDONIATHEFORMERYUGOSLAVREPUBLICOF":"MK","NORTHMACEDONIAREPUBLIC":"MK","NORTHMACEDONIAREPUBLICOF":"MK","MALI":"ML","REPUBLICMALI":"ML","REPUBLICOFMALI":"ML","REPUBLIQUEDUMALI":"ML","ML":"ML","MLI":"ML","MM":"MM","MMR":"MM","MYANMAR":"MM","MONGOLIA":"MN","MONGOLULS":"MN","MN":"MN","MNG":"MN","MACAO":"MO","MACAU":"MO","澳門":"MO","澳门":"MO","MACAOSPECIALADMINISTRATIVEREGIONPEOPLESREPUBLICCHINA":"MO","MACAOSPECIALADMINISTRATIVEREGIONOFTHEPEOPLESREPUBLICOFCHINA":"MO","中華人民共和國澳門特別行政區":"MO","REGIAOADMINISTRATIVAESPECIALDEMACAUDAREPUBLICAPOPULARDACHINA":"MO","MO":"MO","MAC":"MO","NORTHERNMARIANAISLANDS":"MP","COMMONWEALTHNORTHERNMARIANAISLANDS":"MP","COMMONWEALTHOFTHENORTHERNMARIANAISLANDS":"MP","SANKATTANSIHANAISLASMARIANAS":"MP","MP":"MP","MNP":"MP","MARTINIQUE":"MQ","MQ":"MQ","MTQ":"MQ","MAURITANIA":"MR","موريتانيا":"MR","ISLAMICREPUBLICMAURITANIA":"MR","ISLAMICREPUBLICOFMAURITANIA":"MR","ALJUMHURIYYAHALʾISLAMIYYAHALMURITANIYYAH":"MR","MR":"MR","MRT":"MR","MONTSERRAT":"MS","MS":"MS","MSR":"MS","MALTA":"MT","REPUBLICMALTA":"MT","REPUBLICOFMALTA":"MT","REPUBBLIKATAMALTA":"MT","MT":"MT","MLT":"MT","MAURITIUS":"MU","MAURICE":"MU","REPUBLICMAURITIUS":"MU","REPUBLICOFMAURITIUS":"MU","REPUBLIQUEDEMAURICE":"MU","MU":"MU","MUS":"MU","MALDIVES":"MV","MALDIVEISLANDS":"MV","REPUBLICMALDIVES":"MV","REPUBLICOFTHEMALDIVES":"MV","DHIVEHIRAAJJEYGEJUMHOORIYYA":"MV","MV":"MV","MDV":"MV","MALAWI":"MW","REPUBLICMALAWI":"MW","REPUBLICOFMALAWI":"MW","MW":"MW","MWI":"MW","MEXICO":"MX","MEXICANOS":"MX","UNITEDMEXICANSTATES":"MX","ESTADOSUNIDOSMEXICANOS":"MX","MX":"MX","MEX":"MX","MALAYSIA":"MY","MY":"MY","MYS":"MY","MOZAMBIQUE":"MZ","MOCAMBIQUE":"MZ","REPUBLICMOZAMBIQUE":"MZ","REPUBLICOFMOZAMBIQUE":"MZ","REPUBLICADEMOCAMBIQUE":"MZ","MZ":"MZ","MOZ":"MZ","NAMIBIA":"NA","NAMIBIE":"NA","REPUBLICNAMIBIA":"NA","REPUBLICOFNAMIBIA":"NA","NA":"NA","NAM":"NA","NEWCALEDONIA":"NC","NOUVELLECALEDONIE":"NC","NC":"NC","NCL":"NC","NIGER":"NE","NIJAR":"NE","REPUBLICNIGER":"NE","REPUBLICOFNIGER":"NE","REPUBLIQUEDUNIGER":"NE","NE":"NE","NER":"NE","NORFOLKISLAND":"NF","TERRITORYNORFOLKISLAND":"NF","TERRITORYOFNORFOLKISLAND":"NF","TERATRINORFKAILEN":"NF","TERATRIOFNORFKAILEN":"NF","NF":"NF","NFK":"NF","NIGERIA":"NG","NIJERIYA":"NG","NAIJIRIA":"NG","FEDERALREPUBLICNIGERIA":"NG","FEDERALREPUBLICOFNIGERIA":"NG","NG":"NG","NGA":"NG","NICARAGUA":"NI","REPUBLICNICARAGUA":"NI","REPUBLICOFNICARAGUA":"NI","REPUBLICADENICARAGUA":"NI","NI":"NI","NIC":"NI","NETHERLANDS":"NL","NEDERLAND":"NL","HOLLAND":"NL","NL":"NL","NLD":"NL","NORWAY":"NO","NORGE":"NO","NOREG":"NO","KINGDOMNORWAY":"NO","KINGDOMOFNORWAY":"NO","KONGERIKETNORGE":"NO","KONGERIKETNOREG":"NO","NO":"NO","NOR":"NO","NEPAL":"NP","नेपाल":"NP","FEDERALDEMOCRATICREPUBLICNEPAL":"NP","FEDERALDEMOCRATICREPUBLICOFNEPAL":"NP","LOKTANTRIKGANATANTRANEPAL":"NP","NP":"NP","NPL":"NP","NAURU":"NR","NAOERO":"NR","PLEASANTISLAND":"NR","REPUBLICNAURU":"NR","REPUBLICOFNAURU":"NR","RIPUBLIKNAOERO":"NR","NR":"NR","NRU":"NR","NIUE":"NU","NU":"NU","NIU":"NU","NEWZEALAND":"NZ","AOTEAROA":"NZ","NZ":"NZ","NZL":"NZ","OMAN":"OM","عمان":"OM","SULTANATEOMAN":"OM","SULTANATEOFOMAN":"OM","SALTANATʻUMAN":"OM","OM":"OM","OMN":"OM","PANAMA":"PA","REPUBLICPANAMA":"PA","REPUBLICOFPANAMA":"PA","REPUBLICADEPANAMA":"PA","PA":"PA","PAN":"PA","PERU":"PE","REPUBLICPERU":"PE","REPUBLICOFPERU":"PE","REPUBLICADELPERU":"PE","PE":"PE","PER":"PE","FRENCHPOLYNESIA":"PF","POLYNESIEFRANCAISE":"PF","PORINETIAFARANI":"PF","PF":"PF","PYF":"PF","PAPUANEWGUINEA":"PG","PAPUANIUGINI":"PG","INDEPENDENTSTATEPAPUANEWGUINEA":"PG","INDEPENDENTSTATEOFPAPUANEWGUINEA":"PG","INDEPENDENSTETBILONGPAPUANIUGINI":"PG","PG":"PG","PNG":"PG","PHILIPPINES":"PH","PILIPINAS":"PH","REPUBLICPHILIPPINES":"PH","REPUBLICOFTHEPHILIPPINES":"PH","REPUBLIKANGPILIPINAS":"PH","PH":"PH","PHL":"PH","PAKISTAN":"PK","ISLAMICREPUBLICPAKISTAN":"PK","ISLAMICREPUBLICOFPAKISTAN":"PK","ISLAMIJUMHURIYAEHPAKISTAN":"PK","PK":"PK","PAK":"PK","POLAND":"PL","POLSKA":"PL","REPUBLICPOLAND":"PL","REPUBLICOFPOLAND":"PL","RZECZPOSPOLITAPOLSKA":"PL","PL":"PL","POL":"PL","SAINTPIERREMIQUELON":"PM","SAINTPIERREANDMIQUELON":"PM","SAINTPIERREETMIQUELON":"PM","COLLECTIVITETERRITORIALEDESAINTPIERREETMIQUELON":"PM","PM":"PM","SPM":"PM","PITCAIRN":"PN","PITCAIRNISLANDS":"PN","PITCAIRNHENDERSONDUCIEOENOISLANDS":"PN","PITCAIRNHENDERSONDUCIEANDOENOISLANDS":"PN","PN":"PN","PCN":"PN","PUERTORICO":"PR","COMMONWEALTHPUERTORICO":"PR","COMMONWEALTHOFPUERTORICO":"PR","ESTADOLIBREASOCIADODEPUERTORICO":"PR","PR":"PR","PRI":"PR","PS":"PS","PSE":"PS","PALESTINESTATE":"PS","PALESTINESTATEOF":"PS","PALESTINIANTERRITORYOCCUPIED":"PS","STATEPALESTINE":"PS","STATEOFPALESTINE":"PS","PALESTINE":"PS","PORTUGAL":"PT","PORTUGUESA":"PT","PORTUGUESEREPUBLIC":"PT","REPUBLICAPORTUGUESA":"PT","PT":"PT","PRT":"PT","PALAU":"PW","REPUBLICPALAU":"PW","REPUBLICOFPALAU":"PW","BELUUERABELAU":"PW","PW":"PW","PLW":"PW","PARAGUAY":"PY","REPUBLICPARAGUAY":"PY","REPUBLICOFPARAGUAY":"PY","REPUBLICADELPARAGUAY":"PY","TETAPARAGUAI":"PY","PY":"PY","PRY":"PY","QATAR":"QA","قطر":"QA","STATEQATAR":"QA","STATEOFQATAR":"QA","DAWLATQATAR":"QA","QA":"QA","QAT":"QA","REUNION":"RE","LAREUNION":"RE","RE":"RE","REU":"RE","ROMANIA":"RO","RUMANIA":"RO","ROUMANIA":"RO","RO":"RO","ROU":"RO","RS":"RS","SRB":"RS","SERBIA":"RS","RUSSIANFEDERATION":"RU","RUSSIA":"RU","ROSSIYA":"RU","ROSSIISKAYAFEDERATSIYA":"RU","ROSSIYSKAYAFEDERATSIYA":"RU","RU":"RU","RUS":"RU","RWANDA":"RW","REPUBLICRWANDA":"RW","REPUBLICOFRWANDA":"RW","REPUBULIKAYURWANDA":"RW","REPUBLIQUEDURWANDA":"RW","RW":"RW","RWA":"RW","SAUDIARABIA":"SA","العربيةالسعودية":"SA","KINGDOMSAUDIARABIA":"SA","KINGDOMOFSAUDIARABIA":"SA","ALMAMLAKAHAL‘ARABIYYAHASSU‘UDIYYAH":"SA","SA":"SA","SAU":"SA","KSA":"SA","SOLOMONISLANDS":"SB","SB":"SB","SLB":"SB","SEYCHELLES":"SC","REPUBLICSEYCHELLES":"SC","REPUBLICOFSEYCHELLES":"SC","REPIBLIKSESEL":"SC","REPUBLIQUEDESSEYCHELLES":"SC","SC":"SC","SYC":"SC","SUDAN":"SD","السودان":"SD","REPUBLICSUDAN":"SD","REPUBLICOFTHESUDAN":"SD","JUMHURIYATASSUDAN":"SD","SD":"SD","SDN":"SD","SWEDEN":"SE","SVERIGE":"SE","KINGDOMSWEDEN":"SE","KINGDOMOFSWEDEN":"SE","KONUNGARIKETSVERIGE":"SE","SE":"SE","SWE":"SE","SINGAPORE":"SG","SINGAPURA":"SG","REPUBLIKSINGAPURA":"SG","新加坡共和国":"SG","SG":"SG","SGP":"SG","SAINTHELENAASCENSIONTRISTANDACUNHA":"SH","SAINTHELENAASCENSIONANDTRISTANDACUNHA":"SH","SAINTHELENA":"SH","SH":"SH","SHN":"SH","SLOVENIA":"SI","SLOVENIJA":"SI","REPUBLICSLOVENIA":"SI","REPUBLICOFSLOVENIA":"SI","REPUBLIKASLOVENIJA":"SI","SI":"SI","SVN":"SI","SVALBARDJANMAYEN":"SJ","SVALBARDANDJANMAYEN":"SJ","SVALBARDOGJANMAYEN":"SJ","SVALBARDJANMAYENISLANDS":"SJ","SVALBARDANDJANMAYENISLANDS":"SJ","SJ":"SJ","SJM":"SJ","SLOVAKIA":"SK","SLOVENSKO":"SK","SLOVAKREPUBLIC":"SK","SLOVENSKAREPUBLIKA":"SK","SK":"SK","SVK":"SK","SIERRALEONE":"SL","REPUBLICSIERRALEONE":"SL","REPUBLICOFSIERRALEONE":"SL","SL":"SL","SLE":"SL","SANMARINO":"SM","REPUBLICSANMARINO":"SM","REPUBLICOFSANMARINO":"SM","REPUBBLICADISANMARINO":"SM","SM":"SM","SMR":"SM","SENEGAL":"SN","REPUBLICSENEGAL":"SN","REPUBLICOFSENEGAL":"SN","REPUBLIQUEDUSENEGAL":"SN","SN":"SN","SEN":"SN","SOMALIA":"SO","SOOMAALIYA":"SO","ASSUMAL":"SO","FEDERALREPUBLICSOMALIA":"SO","FEDERALREPUBLICOFSOMALIA":"SO","JAMHUURIYADDAFEDERAALKASOOMAALIYA":"SO","JUMHURIYYATASSUMALALFIDERALIYYA":"SO","SO":"SO","SOM":"SO","SURINAME":"SR","SARNAM":"SR","SRANANGRON":"SR","REPUBLICSURINAME":"SR","REPUBLICOFSURINAME":"SR","REPUBLIEKSURINAME":"SR","SR":"SR","SUR":"SR","SOUTHSUDAN":"SS","SS":"SS","SSD":"SS","SAOTOMEPRINCIPE":"ST","SAOTOMEANDPRINCIPE":"ST","SAOTOMEEPRINCIPE":"ST","DEMOCRATICREPUBLICSAOTOMEPRINCIPE":"ST","DEMOCRATICREPUBLICOFSAOTOMEANDPRINCIPE":"ST","REPUBLICADEMOCRATICADESAOTOMEEPRINCIPE":"ST","ST":"ST","STP":"ST","ELSALVADOR":"SV","REPUBLICELSALVADOR":"SV","REPUBLICOFELSALVADOR":"SV","REPUBLICADEELSALVADOR":"SV","SV":"SV","SLV":"SV","SX":"SX","SXM":"SX","SINTMAARTENDUTCHPART":"SX","SINTMAARTEN":"SX","SYRIANARABREPUBLIC":"SY","SYRIA":"SY","سوريا":"SY","ALJUMHURIYAHALʻARABIYAHASSURIYAH":"SY","SY":"SY","SYR":"SY","ESWATINI":"SZ","SWAZILAND":"SZ","WESWATINI":"SZ","SWATINI":"SZ","NGWANE":"SZ","KINGDOMSWAZILAND":"SZ","KINGDOMOFSWAZILAND":"SZ","UMBUSOWASESWATINI":"SZ","SZ":"SZ","SWZ":"SZ","TC":"TC","TCA":"TC","TURKSCAICOSISLANDS":"TC","TURKSANDCAICOSISLANDS":"TC","CHAD":"TD","TCHAD":"TD","REPUBLICCHAD":"TD","REPUBLICOFCHAD":"TD","REPUBLIQUEDUTCHAD":"TD","TD":"TD","TCD":"TD","FRENCHSOUTHERNTERRITORIES":"TF","FRENCHSOUTHERNANTARCTICLANDS":"TF","FRENCHSOUTHERNANDANTARCTICLANDS":"TF","TERRITOIREDESTERRESAUSTRALESETANTARCTIQUESFRANCAISES":"TF","TF":"TF","ATF":"TF","TOGO":"TG","TOGOLESE":"TG","TOGOLESEREPUBLIC":"TG","REPUBLIQUETOGOLAISE":"TG","TG":"TG","TGO":"TG","THAILAND":"TH","ประเทศไทย":"TH","PRATHET":"TH","THAI":"TH","KINGDOMTHAILAND":"TH","KINGDOMOFTHAILAND":"TH","ราชอาณาจักรไทย":"TH","RATCHAANACHAKTHAI":"TH","TH":"TH","THA":"TH","TAJIKISTAN":"TJ","TOҶIKISTON":"TJ","TOCIKISTON":"TJ","REPUBLICTAJIKISTAN":"TJ","REPUBLICOFTAJIKISTAN":"TJ","ҶUMҲURIITOҶIKISTON":"TJ","CUMHURIYITOCIKISTON":"TJ","TJ":"TJ","TJK":"TJ","TOKELAU":"TK","TK":"TK","TKL":"TK","TIMORLESTE":"TL","EASTTIMOR":"TL","DEMOCRATICREPUBLICTIMORLESTE":"TL","DEMOCRATICREPUBLICOFTIMORLESTE":"TL","REPUBLICADEMOCRATICADETIMORLESTE":"TL","REPUBLIKADEMOKRATIKATIMORLESTE":"TL","TL":"TL","TLS":"TL","TURKMENISTAN":"TM","TM":"TM","TKM":"TM","TUNISIA":"TN","تونس":"TN","REPUBLICTUNISIA":"TN","REPUBLICOFTUNISIA":"TN","ALJUMHURIYYAHATTUNISIYYAH":"TN","TN":"TN","TUN":"TN","TONGA":"TO","TO":"TO","TON":"TO","REPUBLICTURKEY":"TR","REPUBLICOFTURKEY":"TR","REPUBLICTURKIYE":"TR","REPUBLICOFTURKIYE":"TR","TR":"TR","TUR":"TR","TURKEY":"TR","TURKIYECUMHURIYETI":"TR","TURKIYE":"TR","TRINIDADTOBAGO":"TT","TRINIDADANDTOBAGO":"TT","REPUBLICTRINIDADTOBAGO":"TT","REPUBLICOFTRINIDADANDTOBAGO":"TT","TT":"TT","TTO":"TT","TUVALU":"TV","TV":"TV","TUV":"TV","TAIWANPROVINCECHINA":"TW","TAIWANPROVINCEOFCHINA":"TW","TAIWAN":"TW","臺灣":"TW","REPUBLICCHINA":"TW","REPUBLICOFCHINA":"TW","中華民國":"TW","ZHONGHUAMINGUO":"TW","TW":"TW","TWN":"TW","TANZANIAUNITEDREPUBLIC":"TZ","TANZANIAUNITEDREPUBLICOF":"TZ","TANZANIA":"TZ","UNITEDREPUBLICTANZANIA":"TZ","UNITEDREPUBLICOFTANZANIA":"TZ","JAMHURIYAMUUNGANOWATANZANIA":"TZ","TZ":"TZ","TZA":"TZ","UKRAINE":"UA","UKRAYINA":"UA","UA":"UA","UKR":"UA","UGANDA":"UG","REPUBLICUGANDA":"UG","REPUBLICOFUGANDA":"UG","JAMHURIYAUGANDA":"UG","UG":"UG","UGA":"UG","UM":"UM","UMI":"UM","UNITEDSTATESMINOROUTLYINGISLANDS":"UM","AMERICA":"US","UNITEDSTATESAMERICA":"US","UNITEDSTATESOFAMERICA":"US","UNITEDSTATES":"US","USOFA":"US","USANDA":"US","US":"US","USA":"US","URUGUAY":"UY","ORIENTALREPUBLICURUGUAY":"UY","ORIENTALREPUBLICOFURUGUAY":"UY","REPUBLICAORIENTALDELURUGUAY":"UY","UY":"UY","URY":"UY","UZBEKISTAN":"UZ","O‘ZBEKISTON":"UZ","REPUBLICUZBEKISTAN":"UZ","REPUBLICOFUZBEKISTAN":"UZ","O‘ZBEKISTONRESPUBLIKASI":"UZ","ЎZBEKISTONRESPUBLIKASI":"UZ","UZ":"UZ","UZB":"UZ","VA":"VA","VAT":"VA","HOLYSEE":"VA","HOLYSEEVATICANCITYSTATE":"VA","VATICAN":"VA","VATICANCITY":"VA","VATICANCITYSTATE":"VA","SAINTVINCENTGRENADINES":"VC","SAINTVINCENTANDTHEGRENADINES":"VC","VC":"VC","VCT":"VC","VENEZUELABOLIVARIANREPUBLIC":"VE","VENEZUELABOLIVARIANREPUBLICOF":"VE","VENEZUELA":"VE","BOLIVARIANREPUBLICVENEZUELA":"VE","BOLIVARIANREPUBLICOFVENEZUELA":"VE","REPUBLICABOLIVARIANADEVENEZUELA":"VE","VE":"VE","VEN":"VE","VG":"VG","VGB":"VG","VIRGINISLANDSBRITISH":"VG","BRITISHVIRGINISLANDS":"VG","VI":"VI","VIR":"VI","VIRGINISLANDSUS":"VI","USVIRGINISLANDS":"VI","AMERICANVIRGINISLANDS":"VI","VIETNAM":"VN","SOCIALISTREPUBLICVIETNAM":"VN","SOCIALISTREPUBLICOFVIETNAM":"VN","CONGHOAXAHOICHUNGHIAVIETNAM":"VN","VN":"VN","VNM":"VN","VANUATU":"VU","REPUBLICVANUATU":"VU","REPUBLICOFVANUATU":"VU","RIPABLIKBLONGVANUATU":"VU","REPUBLIQUEDEVANUATU":"VU","VU":"VU","VUT":"VU","WALLISFUTUNA":"WF","WALLISANDFUTUNA":"WF","WALLISETFUTUNA":"WF","TERRITORYWALLISFUTUNAISLANDS":"WF","TERRITORYOFTHEWALLISANDFUTUNAISLANDS":"WF","TERRITOIREDESILESWALLISETFUTUNA":"WF","WF":"WF","WLF":"WF","SAMOA":"WS","INDEPENDENTSTATESAMOA":"WS","INDEPENDENTSTATEOFSAMOA":"WS","MALOSAʻOLOTOTUTOʻATASIOSAMOA":"WS","WS":"WS","WSM":"WS","YEMEN":"YE","اليَمَن":"YE","YEMENIREPUBLIC":"YE","ALJUMHURIYYAHALYAMANIYYAH":"YE","YE":"YE","YEM":"YE","MAYOTTE":"YT","DEPARTMENTMAYOTTE":"YT","DEPARTMENTOFMAYOTTE":"YT","DEPARTEMENTDEMAYOTTE":"YT","YT":"YT","MYT":"YT","SOUTHAFRICA":"ZA","RSA":"ZA","SUIDAFRIKA":"ZA","REPUBLICSOUTHAFRICA":"ZA","REPUBLICOFSOUTHAFRICA":"ZA","ZA":"ZA","ZAF":"ZA","ZAMBIA":"ZM","REPUBLICZAMBIA":"ZM","REPUBLICOFZAMBIA":"ZM","ZM":"ZM","ZMB":"ZM","ZIMBABWE":"ZW","REPUBLICZIMBABWE":"ZW","REPUBLICOFZIMBABWE":"ZW","ZW":"ZW","ZWE":"ZW"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Chart: function() { return /* reexport */ Chart; },
  ColorScheme: function() { return /* reexport */ ColorScheme; },
  Maps: function() { return /* reexport */ Maps; },
  Settings: function() { return /* reexport */ Settings; },
  tooltip: function() { return /* reexport */ config_tooltip; },
  version: function() { return /* reexport */ package_namespaceObject.rE; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__(489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__(8604);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__(2975);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__(3863);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.symbol.async-iterator.js
var es7_symbol_async_iterator = __webpack_require__(2820);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__(9650);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__(5144);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__(5165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__(5890);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__(4509);
;// ./src/js/nv/core.js
var core = function core(nv) {
  nv.dev = false;
  nv.tooltip = nv.tooltip || {};
  nv.utils = nv.utils || {};
  nv.upgradedUtils = nv.upgradedUtils || {};
  nv.models = nv.models || {};
  nv.charts = {};
  nv.chartHelpers = nv.chartHelpers || {};
  nv.logs = {};
  nv.dom = {};
  nv.log = function () {
    if (nv.dev && window.console && console.log && console.log.apply) {
      console.log.apply(console, arguments);
    } else if (nv.dev && window.console && typeof console.log === 'function' && Function.prototype.bind) {
      var log = Function.prototype.bind.call(console.log, console);
      log.apply(console, arguments);
    }
    return arguments[arguments.length - 1];
  };
  nv.deprecated = function (name, info) {
    if (console && console.warn) {
      console.warn('nvd3 warning: `' + name + '` has been deprecated. ', info || '');
    }
  };
};
;// ./src/js/nv/dom.js
var dom = function dom(nv) {
  nv.dom.write = function (callback) {
    if (window.fastdom !== undefined) {
      return window.fastdom.write(callback);
    }
    return callback();
  };
  nv.dom.read = function (callback) {
    if (window.fastdom !== undefined) {
      return window.fastdom.read(callback);
    }
    return callback();
  };
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__(341);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__(3386);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.sort.js
var es6_array_sort = __webpack_require__(7075);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.epsilon.js
var es6_number_epsilon = __webpack_require__(4419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__(8305);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__(8647);
;// ./src/js/nv/chartHelpers/additional-symbols.js




var DEFAULT_SIZE = 64;
var NUM_REGEX = /-?\d*\.?\d+/g;
var symbolPaths = {
  'significanceUp': 'M8 5L4 2L0 5L0 3L4 0L8 3L8 5Z',
  'significanceDown': 'M0 0L4 3L8 0V2L4 5L0 2L0 0Z',
  'significanceMixed': 'M8 5L4 2L0 5L0 3L4 0L8 3L8 5Z M0 4L4 7L8 4V6L4 9L0 6V4Z'
};
var sizeSymbol = function sizeSymbol(symbolPath, size) {
  if (size === undefined || size === DEFAULT_SIZE) {
    return symbolPath;
  }
  var multiplier = size / DEFAULT_SIZE;
  return symbolPath.replace(NUM_REGEX, function (numStr) {
    return "".concat(parseFloat(numStr) * multiplier);
  });
};
function addSymbols(symbolMap) {
  Object.keys(symbolPaths).forEach(function (key) {
    symbolMap.set(key, function (size) {
      return sizeSymbol(symbolPaths[key], size);
    });
  });
  return symbolMap;
}
;// ./src/js/nv/utils.js













function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var utils = function utils(nv) {
  nv.utils.windowSize = function () {
    var size = {
      width: 640,
      height: 480
    };
    if (window.innerWidth && window.innerHeight) {
      size.width = window.innerWidth;
      size.height = window.innerHeight;
      return size;
    }
    if (document.compatMode === 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth) {
      size.width = document.documentElement.offsetWidth;
      size.height = document.documentElement.offsetHeight;
      return size;
    }
    if (document.body && document.body.offsetWidth) {
      size.width = document.body.offsetWidth;
      size.height = document.body.offsetHeight;
      return size;
    }
    return size;
  };
  nv.utils.windowResize = function (handler) {
    if (window.addEventListener) {
      window.addEventListener('resize', handler);
    } else {
      nv.log('ERROR: Failed to bind to window.resize with: ', handler);
    }
    return {
      callback: handler,
      clear: function clear() {
        window.removeEventListener('resize', handler);
      }
    };
  };
  nv.utils.getColor = function (color) {
    if (color === undefined) {
      return nv.utils.defaultColor();
    } else if (Array.isArray(color)) {
      var color_scale = d3.scale.ordinal().range(color);
      return function (d, i) {
        var key = i === undefined ? d : i;
        return d.color || color_scale(key);
      };
    } else {
      return color;
    }
  };
  nv.utils.defaultColor = function () {
    return nv.utils.getColor(d3.scale.category20().range());
  };
  nv.utils.contrastColor = function (color, pattern) {
    if (pattern) {
      return '#404040';
    }
    var rgb = d3.rgb(color);
    var yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= 128 ? '#404040' : '#FFFFFF';
  };
  nv.utils.customTheme = function (dictionary, getKey, defaultColors) {
    getKey = getKey || function (series) {
      return series.key;
    };
    defaultColors = defaultColors || d3.scale.category20().range();
    var defIndex = defaultColors.length;
    return function (series) {
      var key = getKey(series);
      if (typeof dictionary[key] === 'function') {
        return dictionary[key]();
      } else if (dictionary[key] !== undefined) {
        return dictionary[key];
      } else {
        if (!defIndex) {
          defIndex = defaultColors.length;
        }
        defIndex = defIndex - 1;
        return defaultColors[defIndex];
      }
    };
  };
  nv.utils.pjax = function (links, content) {
    var load = function load(href) {
      d3.html(href, function (fragment) {
        var target = d3.select(content).node();
        target.parentNode.replaceChild(d3.select(fragment).select(content).node(), target);
        nv.utils.pjax(links, content);
      });
    };
    d3.selectAll(links).on('click', function () {
      history.pushState(this.href, this.textContent, this.href);
      load(this.href);
      d3.event.preventDefault();
    });
    d3.select(window).on('popstate', function () {
      if (d3.event.state) {
        load(d3.event.state);
      }
    });
  };
  nv.utils.calcApproxTextWidth = function (svgTextElem) {
    if (typeof svgTextElem.style === 'function' && typeof svgTextElem.text === 'function') {
      var fontSize = parseInt(svgTextElem.style('font-size').replace('px', ''), 10);
      var textLength = svgTextElem.text().length;
      return textLength * fontSize * 0.5;
    }
    return 0;
  };
  nv.utils.getTextWidth = function (selection) {
    var node = selection.node();
    var width;
    try {
      width = node.getComputedTextLength();
      if (width <= 0) {
        throw Error();
      }
    } catch (_unused) {
      width = nv.utils.calcApproxTextWidth(selection);
    }
    return width;
  };
  nv.utils.isNumeric = function (n) {
    return !isNaN(parseFloat(n));
  };
  nv.utils.NaNtoZero = function (n) {
    if (typeof n !== 'number' || isNaN(n) || n === null || n === Infinity || n === -Infinity) {
      return 0;
    }
    return n;
  };
  d3.selection.prototype.watchTransition = function (renderWatch) {
    var args = [this].concat([].slice.call(arguments, 1));
    return renderWatch.transition.apply(renderWatch, args);
  };
  nv.utils.renderWatch = function (dispatch, duration) {
    if (!(this instanceof nv.utils.renderWatch)) {
      return new nv.utils.renderWatch(dispatch, duration);
    }
    var _duration = duration !== undefined ? duration : 250;
    var renderStack = [];
    var self = this;
    this.models = function (models) {
      models = [].slice.call(arguments, 0);
      models.forEach(function (model) {
        model.__rendered = false;
        (function (m) {
          m.dispatch.on('renderEnd', function () {
            m.__rendered = true;
            self.renderEnd('model');
          });
        })(model);
        if (renderStack.indexOf(model) < 0) {
          renderStack.push(model);
        }
      });
      return this;
    };
    this.reset = function (duration) {
      if (duration !== undefined) {
        _duration = duration;
      }
      renderStack = [];
    };
    this.transition = function (selection, args, duration) {
      args = arguments.length > 1 ? [].slice.call(arguments, 1) : [];
      if (args.length > 1) {
        duration = args.pop();
      } else {
        duration = _duration !== undefined ? _duration : 250;
      }
      selection.__rendered = false;
      if (renderStack.indexOf(selection) < 0) {
        renderStack.push(selection);
      }
      if (duration === 0) {
        selection.__rendered = true;
        selection.delay = function () {
          return this;
        };
        selection.duration = function () {
          return this;
        };
        return selection;
      } else {
        if (selection.length === 0) {
          selection.__rendered = true;
        } else if (selection.every(function (d) {
          return !d.length;
        })) {
          selection.__rendered = true;
        } else {
          selection.__rendered = false;
        }
        var n = 0;
        return selection.transition().duration(duration).each(function () {
          ++n;
        }).each('end', function () {
          if (--n === 0) {
            selection.__rendered = true;
            self.renderEnd.apply(this, args);
          }
        });
      }
    };
    this.renderEnd = function () {
      if (renderStack.every(function (d) {
        return d.__rendered;
      })) {
        renderStack.forEach(function (d) {
          d.__rendered = false;
        });
        dispatch.renderEnd.apply(this, arguments);
      }
    };
  };
  nv.utils.deepExtend = function (dst) {
    var sources = arguments.length > 1 ? [].slice.call(arguments, 1) : [];
    sources.forEach(function (source) {
      for (var key in source) {
        var isArray = dst[key] instanceof Array;
        var isObject = _typeof(dst[key]) === 'object';
        var srcObj = _typeof(source[key]) === 'object';
        if (isObject && !isArray && srcObj) {
          nv.utils.deepExtend(dst[key], source[key]);
        } else {
          dst[key] = source[key];
        }
      }
    });
  };
  nv.utils.state = function () {
    if (!(this instanceof nv.utils.state)) {
      return new nv.utils.state();
    }
    var state = {};
    var _setState = function _setState() {};
    var _getState = function _getState() {
      return {};
    };
    var init = null;
    this.dispatch = d3.dispatch('change', 'set');
    this.dispatch.on('set', function (state) {
      _setState(state, true);
    });
    this.getter = function (fn) {
      _getState = fn;
      return this;
    };
    this.setter = function (fn, callback) {
      if (!callback) {
        callback = function callback() {};
      }
      _setState = function _setState(state, update) {
        fn(state);
        if (update) {
          callback();
        }
      };
      return this;
    };
    this.init = function (state) {
      init = init || {};
      nv.utils.deepExtend(init, state);
    };
    var _set = function _set() {
      var settings = _getState();
      if (JSON.stringify(settings) === JSON.stringify(state)) {
        return false;
      }
      for (var key in settings) {
        if (state[key] === undefined) {
          state[key] = {};
        }
        state[key] = settings[key];
      }
      return true;
    };
    this.update = function () {
      if (init) {
        _setState(init, false);
        init = null;
      }
      if (_set.call(this)) {
        this.dispatch.change(state);
      }
    };
  };
  nv.utils.optionsFunc = function (args) {
    if (args) {
      d3.map(args).forEach(function (key, value) {
        if (typeof this[key] === 'function') {
          this[key](value);
        }
      }.bind(this));
    }
    return this;
  };
  nv.utils.calcTicksX = function (numTicks, data) {
    var numValues = nv.utils.calcTickCount(data);
    nv.log('Requested number of ticks: ', numTicks);
    nv.log('Calculated max values to be: ', numValues);
    numTicks = numTicks > numValues ? numTicks = numValues - 1 : numTicks;
    numTicks = numTicks < 1 ? 1 : numTicks;
    numTicks = Math.floor(numTicks);
    nv.log('Calculating tick count as: ', numTicks);
    return numTicks;
  };
  nv.utils.calcTicksY = function (numTicks, data, axisDomain, formatAxisValueFunction) {
    var maxNumTicksBasedOnSpace = Math.floor(numTicks),
      minimumRecommendedCount = 4,
      numValues = d3.max(data.map(function (series) {
        return series && series.values ? series.values.length : 0;
      }));
    var recommendedTicksBasedOnData = Math.max(numValues, minimumRecommendedCount);
    var recommendedTicks = Math.min(recommendedTicksBasedOnData, maxNumTicksBasedOnSpace);
    if (axisDomain && formatAxisValueFunction) {
      if (isNaN(axisDomain[0]) || isNaN(axisDomain[1])) {
        return 0;
      }
      if (Math.abs(axisDomain[0] - axisDomain[1]) < 0.0001) {
        return 1;
      }
      try {
        var formattedAxisModeCount = getFormattedAxisModeCount(recommendedTicks, axisDomain[0], axisDomain[1], formatAxisValueFunction);
        if (formattedAxisModeCount > 0) {
          return Math.floor(recommendedTicks / formattedAxisModeCount);
        }
      } catch (error) {
        console.error('Unable to determine the number of duplicate y axis values.', error.message, {
          axisDomain: axisDomain,
          recommendedTicks: recommendedTicks
        });
      }
    }
    return recommendedTicks;
  };
  function getFormattedAxisModeCount(numberOfAxisValues, axisMin, axisMax, formatAxisValueFunction) {
    if (axisMin === axisMax || numberOfAxisValues <= 1) {
      return numberOfAxisValues;
    }
    if (axisMin > axisMax) {
      throw new Error('Axis max must be greater than axis min.');
    }
    var step = (axisMax - axisMin) / (numberOfAxisValues - 1);
    var axisRange = getFormattedRange(axisMin, axisMax, step, formatAxisValueFunction);
    return getModeCount(axisRange);
  }
  var EPSILON = Number.EPSILON || Math.pow(2, -52);
  function getFormattedRange(start, end, step, formatFunction) {
    if (!(start + step > start && start < end)) {
      throw new Error('Creating chart range would result in an infinite loop.');
    }
    var range = [];
    for (var i = start; i <= end + EPSILON; i += step) {
      range.push(formatFunction(i));
    }
    return range;
  }
  function getModeCount(range) {
    var maxCount = 0;
    var valueCounts = {};
    for (var i = 0; i < range.length; i++) {
      var value = range[i];
      var count = valueCounts[value];
      if (!count) {
        count = 1;
      } else {
        count++;
      }
      if (count > maxCount) {
        maxCount = count;
      }
      valueCounts[value] = count;
    }
    return maxCount;
  }
  nv.utils.calcTickCount = function (data) {
    var numValues = 1;
    var i = 0;
    for (i; i < data.length; i += 1) {
      var stream_len = data[i] && data[i].values ? data[i].values.length : 0;
      numValues = stream_len > numValues ? stream_len : numValues;
    }
    return numValues;
  };
  nv.utils.initOption = function (chart, name) {
    if (chart._calls && chart._calls[name]) {
      chart[name] = chart._calls[name];
    } else {
      chart[name] = function (_) {
        if (!arguments.length) {
          return chart._options[name];
        }
        chart._overrides[name] = true;
        chart._options[name] = _;
        return chart;
      };
      chart['_' + name] = function (_) {
        if (!arguments.length) {
          return chart._options[name];
        }
        if (!chart._overrides[name]) {
          chart._options[name] = _;
        }
        return chart;
      };
    }
  };
  nv.utils.initOptions = function (chart) {
    chart._overrides = chart._overrides || {};
    var ops = Object.getOwnPropertyNames(chart._options || {});
    var calls = Object.getOwnPropertyNames(chart._calls || {});
    ops = ops.concat(calls);
    for (var i in ops) {
      nv.utils.initOption(chart, ops[i]);
    }
  };
  nv.utils.inheritOptionsD3 = function (target, d3_source, oplist) {
    target._d3options = oplist.concat(target._d3options || []);
    oplist.unshift(d3_source);
    oplist.unshift(target);
    d3.rebind.apply(this, oplist);
  };
  nv.utils.arrayUnique = function (a) {
    return a.sort().filter(function (item, pos) {
      return !pos || item !== a[pos - 1];
    });
  };
  nv.utils.symbolMap = addSymbols(new Map());
  nv.utils.symbol = function () {
    var type,
      size = d3.functor(64);
    function symbol(d, i) {
      var t = type.call(this, d, i);
      var s = size.call(this, d, i);
      if (d3.svg.symbolTypes.indexOf(t) !== -1) {
        return d3.svg.symbol().type(t).size(s)();
      }
      if (nv.utils.symbolMap.has(t)) {
        return nv.utils.symbolMap.get(t)(s);
      }
    }
    symbol.type = function (_) {
      if (!arguments.length) {
        return type;
      }
      type = d3.functor(_);
      return symbol;
    };
    symbol.size = function (_) {
      if (!arguments.length) {
        return size;
      }
      size = d3.functor(_);
      return symbol;
    };
    return symbol;
  };
  nv.utils.inheritOptions = function (target, source) {
    var ops = Object.getOwnPropertyNames(source._options || {});
    var calls = Object.getOwnPropertyNames(source._calls || {});
    var inherited = source._inherited || [];
    var d3ops = source._d3options || [];
    var args = ops.concat(calls).concat(inherited).concat(d3ops);
    args.unshift(source);
    args.unshift(target);
    d3.rebind.apply(this, args);
    target._inherited = nv.utils.arrayUnique(ops.concat(calls).concat(inherited).concat(ops).concat(target._inherited || []));
    target._d3options = nv.utils.arrayUnique(d3ops.concat(target._d3options || []));
  };
  nv.utils.initSVG = function (svg) {
    svg.classed({
      'nvd3-svg': true
    });
  };
  nv.utils.sanitizeHeight = function (height, container) {
    return height || parseInt(container.style('height'), 10) || 400;
  };
  nv.utils.sanitizeWidth = function (width, container) {
    return width || parseInt(container.style('width'), 10) || 960;
  };
  nv.utils.availableHeight = function (height, container, margin) {
    return Math.max(0, nv.utils.sanitizeHeight(height, container) - margin.top - margin.bottom);
  };
  nv.utils.availableWidth = function (width, container, margin) {
    return Math.max(0, nv.utils.sanitizeWidth(width, container) - margin.left - margin.right);
  };
  nv.utils.noData = function (chart, container) {
    var opt = chart.options(),
      margin = opt.margin(),
      noData = opt.noData(),
      data = noData === null ? ['No Data Available.'] : [noData],
      height = nv.utils.availableHeight(null, container, margin),
      width = nv.utils.availableWidth(null, container, margin),
      x = margin.left + width / 2,
      y = margin.top + height / 2;
    container.selectAll('g').remove();
    var noDataText = container.selectAll('.nv-noData').data(data);
    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
    noDataText.attr('x', x).attr('y', y).text(function (t) {
      return t;
    });
  };
  nv.utils.computeLineWidth = function (boxWidth, lineHeightPixels, lineNumber, angle) {
    if (!angle || Math.abs(angle % 90) === 0) {
      return boxWidth;
    }
    return Math.max(0, boxWidth - computeAngledWidthAdjustment(lineHeightPixels, lineNumber, angle));
  };
  function computeAngledWidthAdjustment(lineHeightPixels, lineNumber, angle) {
    return lineHeightPixels * (lineNumber - 1) / Math.tan(Math.abs(angle) / 180 * Math.PI);
  }
  nv.utils.wrapTicks = function (text, width, maxLineCount, angle, otherLineWidth, otherLineDx) {
    text.each(function () {
      var text = d3.select(this),
        words = text.text().toString().trim().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1,
        x = text.attr('x') || 0,
        y = text.attr('y') || 0,
        tempDy = parseFloat(text.attr('dy')),
        dy = isNaN(tempDy) ? 0 : tempDy,
        dx = 0,
        tspan = text.text(null).append('tspan').attr('x', x).attr('y', y),
        lineCount = 0,
        splitIndex;
      text.style('opacity', 1);
      maxLineCount = maxLineCount === null ? 2 : maxLineCount;
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(' '));
        var EM_TO_PX_FACTOR = 12;
        var lineWidth = nv.utils.computeLineWidth(width, lineHeight * EM_TO_PX_FACTOR, lineCount, angle);
        if (tspan.node().getComputedTextLength() + 2 > lineWidth) {
          lineCount += 1;
          if (lineCount >= maxLineCount) {
            line.push('...');
            tspan.text(line.join(' '));
            while (tspan.node().getComputedTextLength() + 2 > lineWidth && line.length > 1) {
              line.pop();
              line.pop();
              if (line.length === 0) {
                for (splitIndex = 2; splitIndex < word.length; splitIndex += 1) {
                  tspan.text(word.substring(0, splitIndex));
                  if (tspan.node().getComputedTextLength() + 2 > lineWidth) {
                    line.push(word.substring(0, splitIndex));
                    if (maxLineCount === 1) {
                      line.push('...');
                    }
                    tspan.text(line.join(' '));
                    break;
                  }
                }
                break;
              }
              line.push('...');
              tspan.text(line.join(' '));
            }
            break;
          }
          line.pop();
          if (line.length === 0) {
            for (splitIndex = 2; splitIndex <= word.length; splitIndex += 1) {
              tspan.text(word.substring(0, splitIndex));
              if (tspan.node().getComputedTextLength() > lineWidth) {
                tspan.text(word.substring(0, splitIndex - 1));
                words.push(word.substring(splitIndex - 1));
                break;
              }
            }
          } else {
            tspan.text(line.join(' '));
            words.push(word);
            line = [];
          }
          width = otherLineWidth === undefined ? width : otherLineWidth;
          dx = otherLineDx === undefined ? dx : otherLineDx;
          tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').attr('dx', dx);
        }
      }
    });
  };
  nv.utils.truncateText = function (text, width) {
    return nv.utils.wrapTicks(text, width, 1, 0);
  };
  nv.utils.arrayEquals = function (array1, array2) {
    if (array1 === array2) {
      return true;
    }
    if (!array1 || !array2) {
      return false;
    }
    if (array1.length !== array2.length) {
      return false;
    }
    for (var i = 0, l = array1.length; i < l; i++) {
      if (array1[i] instanceof Array && array2[i] instanceof Array) {
        if (!nv.arrayEquals(array1[i], array2[i])) {
          return false;
        }
      } else if (array1[i] !== array2[i]) {
        return false;
      }
    }
    return true;
  };
  nv.utils.variableTicks = function (elements, maxSet) {
    elements.each(function (data) {
      var line = d3.select(this);
      line.transition().attr('y2', function () {
        return maxSet[data];
      });
    });
  };
  nv.utils.makeBorder = function (color, size) {
    if (size < 1) {
      return;
    }
    var totalBorder = makeShadowBorder(color, 1 + 'px');
    for (var offset = 2; offset <= size; offset++) {
      totalBorder += ',' + makeShadowBorder(color, offset + 'px');
    }
    return totalBorder;
  };
  function makeShadowBorder(color, offset) {
    return '-' + offset + ' -' + offset + ' 0 ' + color + ',' + ' ' + offset + ' -' + offset + ' 0 ' + color + ',' + ' -' + offset + ' ' + offset + ' 0 ' + color + ',' + ' ' + offset + ' ' + offset + ' 0 ' + color;
  }
  nv.utils.withAnimation = function (node, duration) {
    return duration > 0 ? node.transition() : node;
  };
  d3.selection.prototype.moveToFront = function () {
    return this.each(function () {
      this.parentNode.appendChild(this);
    });
  };
};
;// ./node_modules/d3-dispatch/src/dispatch.js
var noop = {value: () => {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ var src_dispatch = (dispatch);

;// ./node_modules/d3-array/src/ascending.js
/* harmony default export */ function src_ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// ./node_modules/d3-array/src/bisector.js


/* harmony default export */ function bisector(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
}

function ascendingComparator(f) {
  return function(d, x) {
    return src_ascending(f(d), x);
  };
}

;// ./node_modules/d3-array/src/bisect.js



var ascendingBisect = bisector(src_ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ var src_bisect = ((/* unused pure expression or super */ null && (bisectRight)));

;// ./node_modules/d3-array/src/extent.js
/* harmony default export */ function src_extent(values, valueof) {
  let min;
  let max;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && value >= value) {
        if (min === undefined) {
          min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && value >= value) {
        if (min === undefined) {
          min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  }
  return [min, max];
}

;// ./node_modules/d3-array/src/array.js
var array = Array.prototype;

var array_slice = array.slice;
var array_map = array.map;

;// ./node_modules/d3-array/src/ticks.js
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function ticks_tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

;// ./node_modules/d3-array/src/histogram.js









/* harmony default export */ function histogram() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    if (!Array.isArray(data)) data = Array.from(data);

    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisect(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
}

;// ./node_modules/d3-array/src/threshold/freedmanDiaconis.js





/* harmony default export */ function freedmanDiaconis(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

;// ./node_modules/d3-array/src/max.js
function max(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null
          && value >= value
          && (max === undefined || max < value)) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && value >= value
          && (max === undefined || max < value)) {
        max = value;
      }
    }
  }
  return max;
}

;// ./node_modules/d3-array/src/merge.js
function* flatten(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}

function merge(arrays) {
  return Array.from(flatten(arrays));
}

;// ./node_modules/d3-array/src/min.js
function min_min(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null
          && value >= value
          && (min === undefined || min > value)) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && value >= value
          && (min === undefined || min > value)) {
        min = value;
      }
    }
  }
  return min;
}

;// ./node_modules/d3-array/src/permute.js
/* harmony default export */ function permute(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}

;// ./node_modules/d3-array/src/range.js
/* harmony default export */ function src_range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

;// ./node_modules/d3-array/src/index.js































;// ./node_modules/d3-scale/src/init.js
function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}

;// ./node_modules/d3-scale/src/ordinal.js


const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

;// ./node_modules/d3-scale-chromatic/src/colors.js
/* harmony default export */ function colors(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

;// ./node_modules/d3-scale-chromatic/src/categorical/category10.js


/* harmony default export */ var category10 = (colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));

;// ./node_modules/d3-shape/src/math.js
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var math_max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

;// ./node_modules/d3-shape/src/symbol/circle.js


/* harmony default export */ var circle = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
});

;// ./node_modules/d3-shape/src/symbol/cross.js
/* harmony default export */ var cross = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});

;// ./node_modules/d3-shape/src/symbol/diamond.js
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ var diamond = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});

;// ./node_modules/d3-shape/src/symbol/square.js
/* harmony default export */ var square = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});

;// ./node_modules/d3-shape/src/symbol/triangle.js
var sqrt3 = Math.sqrt(3);

/* harmony default export */ var triangle = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});

;// ./node_modules/d3-path/src/path.js
const path_pi = Math.PI,
    path_tau = 2 * path_pi,
    path_epsilon = 1e-6,
    tauEpsilon = path_tau - path_epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > path_epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > path_epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((path_pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > path_epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > path_epsilon || Math.abs(this._y1 - y0) > path_epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % path_tau + path_tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > path_epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= path_pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ var src_path = (path);

;// ./node_modules/d3-shape/src/symbol/star.js


var ka = 0.89081309152928522810,
    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
    kx = Math.sin(tau / 10) * kr,
    ky = -Math.cos(tau / 10) * kr;

/* harmony default export */ var star = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});

;// ./node_modules/d3-shape/src/symbol/wye.js
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ var wye = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});

;// ./node_modules/d3-shape/src/constant.js
/* harmony default export */ function src_constant(x) {
  return function constant() {
    return x;
  };
}

;// ./node_modules/d3-shape/src/symbol.js










var symbols = [
  circle,
  cross,
  diamond,
  square,
  star,
  triangle,
  wye
];

/* harmony default export */ function src_symbol(type, size) {
  var context = null;
  type = typeof type === "function" ? type : src_constant(type || circle);
  size = typeof size === "function" ? size : src_constant(size === undefined ? 64 : +size);

  function symbol() {
    var buffer;
    if (!context) context = buffer = src_path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : src_constant(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : src_constant(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
}

;// ./node_modules/d3-selection/src/selector.js
function none() {}

/* harmony default export */ function selector(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}

;// ./node_modules/d3-selection/src/selection/select.js



/* harmony default export */ function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

;// ./node_modules/d3-selection/src/array.js
/* harmony default export */ function src_array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

;// ./node_modules/d3-selection/src/selectorAll.js
function empty() {
  return [];
}

/* harmony default export */ function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

;// ./node_modules/d3-selection/src/selection/selectAll.js




function arrayAll(select) {
  return function() {
    var group = select.apply(this, arguments);
    return group == null ? [] : src_array(group);
  };
}

/* harmony default export */ function selectAll(select) {
  if (typeof select === "function") select = arrayAll(select);
  else select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
}

;// ./node_modules/d3-selection/src/matcher.js
/* harmony default export */ function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}


;// ./node_modules/d3-selection/src/selection/selectChild.js


var find = Array.prototype.find;

function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

/* harmony default export */ function selectChild(match) {
  return this.select(match == null ? childFirst
      : childFind(typeof match === "function" ? match : childMatcher(match)));
}

;// ./node_modules/d3-selection/src/selection/selectChildren.js


var filter = Array.prototype.filter;

function children() {
  return this.children;
}

function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}

/* harmony default export */ function selectChildren(match) {
  return this.selectAll(match == null ? children
      : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}

;// ./node_modules/d3-selection/src/selection/filter.js



/* harmony default export */ function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

;// ./node_modules/d3-selection/src/selection/sparse.js
/* harmony default export */ function sparse(update) {
  return new Array(update.length);
}

;// ./node_modules/d3-selection/src/selection/enter.js



/* harmony default export */ function enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

;// ./node_modules/d3-selection/src/constant.js
/* harmony default export */ function d3_selection_src_constant(x) {
  return function() {
    return x;
  };
}

;// ./node_modules/d3-selection/src/selection/data.js





function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = new Map,
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue.get(keyValues[i]) === node)) {
      exit[i] = node;
    }
  }
}

function datum(node) {
  return node.__data__;
}

/* harmony default export */ function data(value, key) {
  if (!arguments.length) return Array.from(this, datum);

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = d3_selection_src_constant(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = src_array(value.call(parent, parent && parent.__data__, j, parents)),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

;// ./node_modules/d3-selection/src/selection/exit.js



/* harmony default export */ function exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}

;// ./node_modules/d3-selection/src/selection/join.js
/* harmony default export */ function join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

;// ./node_modules/d3-selection/src/selection/merge.js


/* harmony default export */ function selection_merge(selection) {
  if (!(selection instanceof Selection)) throw new Error("invalid merge");

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
}

;// ./node_modules/d3-selection/src/selection/order.js
/* harmony default export */ function order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

;// ./node_modules/d3-selection/src/selection/sort.js


/* harmony default export */ function sort(compare) {
  if (!compare) compare = sort_ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
}

function sort_ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// ./node_modules/d3-selection/src/selection/call.js
/* harmony default export */ function call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

;// ./node_modules/d3-selection/src/selection/nodes.js
/* harmony default export */ function nodes() {
  return Array.from(this);
}

;// ./node_modules/d3-selection/src/selection/node.js
/* harmony default export */ function node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

;// ./node_modules/d3-selection/src/selection/size.js
/* harmony default export */ function size() {
  let size = 0;
  for (const node of this) ++size; // eslint-disable-line no-unused-vars
  return size;
}

;// ./node_modules/d3-selection/src/selection/empty.js
/* harmony default export */ function selection_empty() {
  return !this.node();
}

;// ./node_modules/d3-selection/src/selection/each.js
/* harmony default export */ function each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

;// ./node_modules/d3-selection/src/namespaces.js
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ var namespaces = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});

;// ./node_modules/d3-selection/src/namespace.js


/* harmony default export */ function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name; // eslint-disable-line no-prototype-builtins
}

;// ./node_modules/d3-selection/src/selection/attr.js


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ function attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
}

;// ./node_modules/d3-selection/src/window.js
/* harmony default export */ function src_window(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

;// ./node_modules/d3-selection/src/selection/style.js


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ function style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || src_window(node).getComputedStyle(node, null).getPropertyValue(name);
}

;// ./node_modules/d3-selection/src/selection/property.js
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ function property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

;// ./node_modules/d3-selection/src/selection/classed.js
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ function classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

;// ./node_modules/d3-selection/src/selection/text.js
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
}

;// ./node_modules/d3-selection/src/selection/html.js
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ function html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

;// ./node_modules/d3-selection/src/selection/raise.js
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ function selection_raise() {
  return this.each(raise);
}

;// ./node_modules/d3-selection/src/selection/lower.js
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ function selection_lower() {
  return this.each(lower);
}

;// ./node_modules/d3-selection/src/creator.js



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

;// ./node_modules/d3-selection/src/selection/append.js


/* harmony default export */ function append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

;// ./node_modules/d3-selection/src/selection/insert.js



function constantNull() {
  return null;
}

/* harmony default export */ function insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

;// ./node_modules/d3-selection/src/selection/remove.js
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ function selection_remove() {
  return this.each(remove);
}

;// ./node_modules/d3-selection/src/selection/clone.js
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

/* harmony default export */ function clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

;// ./node_modules/d3-selection/src/selection/datum.js
/* harmony default export */ function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

;// ./node_modules/d3-selection/src/selection/on.js
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}

function on_parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, options: options};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ function on(typename, value, options) {
  var typenames = on_parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options));
  return this;
}

;// ./node_modules/d3-selection/src/selection/dispatch.js


function dispatchEvent(node, type, params) {
  var window = src_window(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

;// ./node_modules/d3-selection/src/selection/iterator.js
/* harmony default export */ function* iterator() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) yield node;
    }
  }
}

;// ./node_modules/d3-selection/src/selection/index.js



































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

function selection_selection() {
  return this;
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selectAll,
  selectChild: selectChild,
  selectChildren: selectChildren,
  filter: selection_filter,
  data: data,
  enter: enter,
  exit: exit,
  join: join,
  merge: selection_merge,
  selection: selection_selection,
  order: order,
  sort: sort,
  call: call,
  nodes: nodes,
  node: node,
  size: size,
  empty: selection_empty,
  each: each,
  attr: attr,
  style: style,
  property: property,
  classed: classed,
  text: selection_text,
  html: html,
  raise: selection_raise,
  lower: selection_lower,
  append: append,
  insert: insert,
  remove: selection_remove,
  clone: clone,
  datum: selection_datum,
  on: on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: iterator
};

/* harmony default export */ var src_selection = (selection);

;// ./node_modules/d3-selection/src/select.js


/* harmony default export */ function src_select(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
}

;// ./src/js/nv/upgraded_utils.js



















var upgradedUtils = function upgradedUtils(nv) {
  nv.upgradedUtils.getColor = function (color) {
    if (color === undefined) {
      return nv.upgradedUtils.defaultColor();
    } else if (Array.isArray(color)) {
      var color_scale = ordinal().range(color);
      return function (d, i) {
        var key = i === undefined ? d : i;
        return d.color || color_scale(key);
      };
    } else {
      return color;
    }
  };
  nv.upgradedUtils.defaultColor = function () {
    return nv.upgradedUtils.getColor(ordinal(category10).range());
  };
  nv.upgradedUtils.calcApproxTextWidth = function (svgTextElem) {
    if (typeof svgTextElem.style === 'function' && typeof svgTextElem.text === 'function') {
      var fontSize = parseInt(svgTextElem.style('font-size').replace('px', ''), 10);
      var textLength = svgTextElem.text().length;
      var constantFactor = 0.5;
      return textLength * fontSize * constantFactor;
    }
    return 0;
  };
  nv.upgradedUtils.getTextWidth = function (selection) {
    var node = selection.node();
    var width;
    try {
      width = node.getComputedTextLength();
      if (width <= 0) {
        throw Error();
      }
    } catch (_unused) {
      width = nv.upgradedUtils.calcApproxTextWidth(selection);
    }
    return width;
  };
  nv.upgradedUtils.isNumeric = function (n) {
    return !isNaN(parseFloat(n));
  };
  nv.upgradedUtils.NaNtoZero = function (n) {
    if (typeof n !== 'number' || isNaN(n) || n === null || n === Infinity || n === -Infinity) {
      return 0;
    }
    return n;
  };
  src_selection.prototype.watchTransition = function (renderWatch) {
    var args = [this].concat([].slice.call(arguments, 1));
    return renderWatch.transition.apply(renderWatch, args);
  };
  nv.upgradedUtils.renderWatch = function (dispatch, duration) {
    if (!(this instanceof nv.upgradedUtils.renderWatch)) {
      return new nv.upgradedUtils.renderWatch(dispatch, duration);
    }
    var _duration = duration !== undefined ? duration : 250;
    var renderStack = [];
    var self = this;
    this.models = function (models) {
      models = [].slice.call(arguments, 0);
      models.forEach(function (model) {
        model.__rendered = false;
        (function (m) {
          m.dispatch.on('renderEnd', function () {
            m.__rendered = true;
            self.renderEnd('model');
          });
        })(model);
        if (renderStack.indexOf(model) < 0) {
          renderStack.push(model);
        }
      });
      return this;
    };
    this.reset = function (duration) {
      if (duration !== undefined) {
        _duration = duration;
      }
      renderStack = [];
    };
    this.transition = function (selection, args, duration) {
      args = arguments.length > 1 ? [].slice.call(arguments, 1) : [];
      if (args.length > 1) {
        duration = args.pop();
      } else {
        duration = _duration !== undefined ? _duration : 250;
      }
      selection.__rendered = false;
      if (renderStack.indexOf(selection) < 0) {
        renderStack.push(selection);
      }
      if (duration === 0) {
        selection.__rendered = true;
        selection.delay = function () {
          return this;
        };
        selection.duration = function () {
          return this;
        };
        return selection;
      } else {
        if (selection.length === 0) {
          selection.__rendered = true;
        } else if (selection.nodes().every(function (d) {
          return !d.length;
        })) {
          selection.__rendered = true;
        } else {
          selection.__rendered = false;
        }
        var n = 0;
        return selection.transition().duration(duration).each(function () {
          ++n;
        }).on('end', function () {
          if (--n === 0) {
            selection.__rendered = true;
            self.renderEnd.apply(this, args);
          }
        });
      }
    };
    this.renderEnd = function () {
      if (renderStack.every(function (d) {
        return d.__rendered;
      })) {
        renderStack.forEach(function (d) {
          d.__rendered = false;
        });
        dispatch.call('renderEnd', this, arguments);
      }
    };
  };
  nv.upgradedUtils.state = function () {
    if (!(this instanceof nv.upgradedUtils.state)) {
      return new nv.upgradedUtils.state();
    }
    var state = {};
    var _setState = function _setState() {};
    var _getState = function _getState() {
      return {};
    };
    var init = null;
    this.dispatch = src_dispatch('change', 'set');
    this.dispatch.on('set', function (state) {
      _setState(state, true);
    });
    this.getter = function (fn) {
      _getState = fn;
      return this;
    };
    this.setter = function (fn, callback) {
      if (!callback) {
        callback = function callback() {};
      }
      _setState = function _setState(state, update) {
        fn(state);
        if (update) {
          callback();
        }
      };
      return this;
    };
    this.init = function (state) {
      init = init || {};
      nv.upgradedUtils.deepExtend(init, state);
    };
    var _set = function _set() {
      var settings = _getState();
      if (JSON.stringify(settings) === JSON.stringify(state)) {
        return false;
      }
      for (var key in settings) {
        if (state[key] === undefined) {
          state[key] = {};
        }
        state[key] = settings[key];
      }
      return true;
    };
    this.update = function () {
      if (init) {
        _setState(init, false);
        init = null;
      }
      if (_set.call(this)) {
        this.dispatch.call('change', state);
      }
    };
  };
  nv.upgradedUtils.optionsFunc = function (args) {
    if (args) {
      var argsMap = new Map(args);
      argsMap.forEach(function (key, value) {
        if (typeof this[key] === 'function') {
          this[key](value);
        }
      }.bind(this));
    }
    return this;
  };
  nv.upgradedUtils.calcTicksX = function (numTicks, data) {
    var numValues = nv.upgradedUtils.calcTickCount(data);
    nv.log('Requested number of ticks: ', numTicks);
    nv.log('Calculated max values to be: ', numValues);
    numTicks = numTicks > numValues ? numTicks = numValues - 1 : numTicks;
    numTicks = numTicks < 1 ? 1 : numTicks;
    numTicks = Math.floor(numTicks);
    nv.log('Calculating tick count as: ', numTicks);
    return numTicks;
  };
  nv.upgradedUtils.calcTicksY = function (numTicks, data, axisDomain, formatAxisValueFunction) {
    var maxNumTicksBasedOnSpace = Math.floor(numTicks),
      minimumRecommendedCount = 4,
      numValues = max(data.map(function (series) {
        return series && series.values ? series.values.length : 0;
      }));
    var recommendedTicksBasedOnData = Math.max(numValues, minimumRecommendedCount);
    var recommendedTicks = Math.min(recommendedTicksBasedOnData, maxNumTicksBasedOnSpace);
    if (axisDomain && formatAxisValueFunction) {
      if (isNaN(axisDomain[0]) || isNaN(axisDomain[1])) {
        return 0;
      }
      if (Math.abs(axisDomain[0] - axisDomain[1]) < 0.0001) {
        return 1;
      }
      try {
        var formattedAxisModeCount = getFormattedAxisModeCount(recommendedTicks, axisDomain[0], axisDomain[1], formatAxisValueFunction);
        if (formattedAxisModeCount > 0) {
          return Math.floor(recommendedTicks / formattedAxisModeCount);
        }
      } catch (error) {
        console.error('Unable to determine the number of duplicate y axis values.', error.message, {
          axisDomain: axisDomain,
          recommendedTicks: recommendedTicks
        });
      }
    }
    return recommendedTicks;
  };
  function getFormattedAxisModeCount(numberOfAxisValues, axisMin, axisMax, formatAxisValueFunction) {
    if (axisMin === axisMax || numberOfAxisValues <= 1) {
      return numberOfAxisValues;
    }
    if (axisMin > axisMax) {
      throw new Error('Axis max must be greater than axis min.');
    }
    var step = (axisMax - axisMin) / (numberOfAxisValues - 1);
    var axisRange = getFormattedRange(axisMin, axisMax, step, formatAxisValueFunction);
    return getModeCount(axisRange);
  }
  var EPSILON = Number.EPSILON || Math.pow(2, -52);
  function getFormattedRange(start, end, step, formatFunction) {
    if (!(start + step > start && start < end)) {
      throw new Error('Creating chart range would result in an infinite loop.');
    }
    var range = [];
    for (var i = start; i <= end + EPSILON; i += step) {
      range.push(formatFunction(i));
    }
    return range;
  }
  function getModeCount(range) {
    var maxCount = 0;
    var valueCounts = {};
    for (var i = 0; i < range.length; i++) {
      var value = range[i];
      var count = valueCounts[value];
      if (!count) {
        count = 1;
      } else {
        count++;
      }
      if (count > maxCount) {
        maxCount = count;
      }
      valueCounts[value] = count;
    }
    return maxCount;
  }
  nv.upgradedUtils.calcTickCount = function (data) {
    var numValues = 1;
    var i = 0;
    for (i; i < data.length; i += 1) {
      var stream_len = data[i] && data[i].values ? data[i].values.length : 0;
      numValues = stream_len > numValues ? stream_len : numValues;
    }
    return numValues;
  };
  nv.upgradedUtils.initOption = function (chart, name) {
    if (chart._calls && chart._calls[name]) {
      chart[name] = chart._calls[name];
    } else {
      chart[name] = function (_) {
        if (!arguments.length) {
          return chart._options[name];
        }
        chart._overrides[name] = true;
        chart._options[name] = _;
        return chart;
      };
      chart['_' + name] = function (_) {
        if (!arguments.length) {
          return chart._options[name];
        }
        if (!chart._overrides[name]) {
          chart._options[name] = _;
        }
        return chart;
      };
    }
  };
  nv.upgradedUtils.initOptions = function (chart) {
    chart._overrides = chart._overrides || {};
    var ops = Object.getOwnPropertyNames(chart._options || {});
    var calls = Object.getOwnPropertyNames(chart._calls || {});
    ops = ops.concat(calls);
    for (var i in ops) {
      nv.upgradedUtils.initOption(chart, ops[i]);
    }
  };
  nv.upgradedUtils.inheritOptionsD3 = function (target, d3_source, oplist) {
    target._d3options = oplist.concat(target._d3options || []);
    oplist.unshift(d3_source);
    oplist.unshift(target);
    nv.upgradedUtils.rebind.apply(this, oplist);
  };
  nv.upgradedUtils.arrayUnique = function (a) {
    return a.sort().filter(function (item, pos) {
      return !pos || item !== a[pos - 1];
    });
  };
  nv.upgradedUtils.symbolMap = addSymbols(new Map());
  var symbolTriangleDown = {
    draw: function draw(context, size) {
      var sqrt3 = Math.sqrt(3);
      var y = Math.sqrt(size / (sqrt3 * 3));
      context.moveTo(0, y * 2);
      context.lineTo(-sqrt3 * y, -y);
      context.lineTo(sqrt3 * y, -y);
      context.closePath();
    }
  };
  nv.upgradedUtils.d3SymbolMap = new Map([['circle', circle], ['cross', cross], ['diamond', diamond], ['square', square], ['triangle-up', triangle], ['triangle-down', symbolTriangleDown]]);
  nv.upgradedUtils.symbol = function () {
    var type,
      size = nv.upgradedUtils.functor(64);
    function symbol(d, i) {
      var t = type.call(this, d, i);
      var s = size.call(this, d, i);
      if (nv.upgradedUtils.d3SymbolMap.has(t)) {
        return src_symbol().type(nv.upgradedUtils.d3SymbolMap.get(t)).size(s)();
      }
      if (nv.upgradedUtils.symbolMap.has(t)) {
        return nv.upgradedUtils.symbolMap.get(t)(s);
      }
    }
    symbol.type = function (_) {
      if (!arguments.length) {
        return type;
      }
      type = nv.upgradedUtils.functor(_);
      return symbol;
    };
    symbol.size = function (_) {
      if (!arguments.length) {
        return size;
      }
      size = nv.upgradedUtils.functor(_);
      return symbol;
    };
    return symbol;
  };
  nv.upgradedUtils.functor = function (v) {
    return typeof v === 'function' ? v : function () {
      return v;
    };
  };
  nv.upgradedUtils.inheritOptions = function (target, source) {
    var ops = Object.getOwnPropertyNames(source._options || {});
    var calls = Object.getOwnPropertyNames(source._calls || {});
    var inherited = source._inherited || [];
    var d3ops = source._d3options || [];
    var args = ops.concat(calls).concat(inherited).concat(d3ops);
    args.unshift(source);
    args.unshift(target);
    nv.upgradedUtils.rebind.apply(this, args);
    target._inherited = nv.upgradedUtils.arrayUnique(ops.concat(calls).concat(inherited).concat(ops).concat(target._inherited || []));
    target._d3options = nv.upgradedUtils.arrayUnique(d3ops.concat(target._d3options || []));
  };
  nv.upgradedUtils.rebind = function (target, source) {
    var i = 1,
      n = arguments.length,
      method;
    while (++i < n) {
      target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    }
    return target;
  };
  function d3_rebind(target, source, method) {
    return function () {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  nv.upgradedUtils.initSVG = function (svg) {
    svg.classed({
      'nvd3-svg': true
    });
  };
  nv.upgradedUtils.sanitizeHeight = function (height, container) {
    return height || parseInt(container.style('height'), 10) || 400;
  };
  nv.upgradedUtils.sanitizeWidth = function (width, container) {
    return width || parseInt(container.style('width'), 10) || 960;
  };
  nv.upgradedUtils.availableHeight = function (height, container, margin) {
    return Math.max(0, nv.upgradedUtils.sanitizeHeight(height, container) - margin.top - margin.bottom);
  };
  nv.upgradedUtils.availableWidth = function (width, container, margin) {
    return Math.max(0, nv.upgradedUtils.sanitizeWidth(width, container) - margin.left - margin.right);
  };
  nv.upgradedUtils.noData = function (chart, container) {
    var opt = chart.options(),
      margin = opt.margin(),
      noData = opt.noData(),
      data = noData === null ? ['No Data Available.'] : [noData],
      height = nv.upgradedUtils.availableHeight(null, container, margin),
      width = nv.upgradedUtils.availableWidth(null, container, margin),
      x = margin.left + width / 2,
      y = margin.top + height / 2;
    container.selectAll('g').remove();
    var noDataText = container.selectAll('.nv-noData').data(data);
    var noDataTextEnter = noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
    noDataTextEnter.merge(noDataText).attr('x', x).attr('y', y).text(function (t) {
      return t;
    });
  };
  nv.upgradedUtils.computeLineWidth = function (boxWidth, lineHeightPixels, lineNumber, angle) {
    if (!angle || Math.abs(angle % 90) === 0) {
      return boxWidth;
    }
    return Math.max(0, boxWidth - computeAngledWidthAdjustment(lineHeightPixels, lineNumber, angle));
  };
  function computeAngledWidthAdjustment(lineHeightPixels, lineNumber, angle) {
    return lineHeightPixels * (lineNumber - 1) / Math.tan(Math.abs(angle) / 180 * Math.PI);
  }
  nv.upgradedUtils.wrapTicks = function (text, width, maxLineCount, angle, otherLineWidth, otherLineDx) {
    text.each(function () {
      var text = src_select(this);
      var words = nv.upgradedUtils.getWordsFromSelection(this.childNodes).reverse();
      var word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1,
        x = text.attr('x') || 0,
        y = text.attr('y') || 0,
        tempDy = parseFloat(text.attr('dy')),
        dy = isNaN(tempDy) ? 0 : tempDy,
        dx = 0,
        tspan = text.text(null).append('tspan').attr('x', x).attr('y', y),
        lineCount = 0,
        splitIndex;
      text.style('opacity', 1);
      maxLineCount = maxLineCount === null ? 2 : maxLineCount;
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(' '));
        var EM_TO_PX_FACTOR = 12;
        var lineWidth = nv.upgradedUtils.computeLineWidth(width, lineHeight * EM_TO_PX_FACTOR, lineCount, angle);
        if (tspan.node().getComputedTextLength() + 2 > lineWidth) {
          lineCount += 1;
          if (lineCount >= maxLineCount) {
            line.push('...');
            tspan.text(line.join(' '));
            while (tspan.node().getComputedTextLength() + 2 > lineWidth && line.length > 1) {
              line.pop();
              line.pop();
              if (line.length === 0) {
                for (splitIndex = 2; splitIndex < word.length; splitIndex += 1) {
                  tspan.text(word.substring(0, splitIndex));
                  if (tspan.node().getComputedTextLength() + 2 > lineWidth) {
                    line.push(word.substring(0, splitIndex));
                    if (maxLineCount === 1) {
                      line.push('...');
                    }
                    tspan.text(line.join(' '));
                    break;
                  }
                }
                break;
              }
              line.push('...');
              tspan.text(line.join(' '));
            }
            break;
          }
          line.pop();
          if (line.length === 0) {
            for (splitIndex = 2; splitIndex <= word.length; splitIndex += 1) {
              tspan.text(word.substring(0, splitIndex));
              if (tspan.node().getComputedTextLength() > lineWidth) {
                tspan.text(word.substring(0, splitIndex - 1));
                words.push(word.substring(splitIndex - 1));
                break;
              }
            }
          } else {
            tspan.text(line.join(' '));
            words.push(word);
            line = [];
          }
          width = otherLineWidth === undefined ? width : otherLineWidth;
          dx = otherLineDx === undefined ? dx : otherLineDx;
          tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').attr('dx', dx);
        }
      }
    });
  };
  nv.upgradedUtils.getWordsFromSelection = function (nodes) {
    if (!nodes) {
      return [];
    }
    if (nodes.length === 1) {
      return nodes[0].textContent.toString().trim().split(/\s+/);
    }
    return Array.from(nodes).reduce(function (textContent, tspan) {
      return textContent.concat(tspan.textContent.split(/\s+/));
    }, []);
  };
  nv.upgradedUtils.truncateText = function (text, width) {
    return nv.upgradedUtils.wrapTicks(text, width, 1, 0);
  };
  nv.upgradedUtils.variableTicks = function (elements, maxSet) {
    elements.each(function (data) {
      var line = src_select(this);
      line.transition().attr('y2', function () {
        return maxSet[data];
      });
    });
  };
};
// EXTERNAL MODULE: ./src/less/index.less
var less = __webpack_require__(5611);
var less_default = /*#__PURE__*/__webpack_require__.n(less);
;// ./src/js/constants.js
var constants_Constants = {
  BLACK: '#272727',
  WHITE: '#FFFFFF',
  POSITIVE_GREEN: '#66CD00',
  NEGATIVE_RED: '#FF1919',
  DULL_GREY: '#A5A5A5',
  LABEL_GRAY: '#89919A',
  NUMBER_DEFAULT: '#32363A',
  DEFAULT_BLUE: '#2179F9',
  FONT_SIZE: 12,
  TOP_PADDING: 20,
  TOOLTIP_DISTANCE: 18,
  NORTHSTAR_TOOLTIP_DISTANCE: 40,
  DEFAULT_TOOLTIP_DISTANCE: 25,
  DOMAIN_PADDING_RATIO_SMALL_DATA_POINT: 0.15,
  DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT: 0.25,
  DOMAIN_PADDING_RATIO_LARGE_DATA_POINT: 0.5,
  SMALL_DATA_POINT_SIZE: 79,
  MEDIUM_DATA_POINT_SIZE: 201,
  LARGE_DATA_POINT_SIZE: 805,
  MINIMUM_DOMAIN_SEPARATION: 0.0001,
  ARROW_NUMBER_PADDING: {
    DEFAULT: 10,
    INLINE: 8
  },
  ARROW_POSITIONING_MULTIPLIERS: {
    DEFAULT: {
      UP: 2 / 3,
      DOWN: 1 / 3
    },
    INLINE: {
      UP: 7 / 8,
      DOWN: 1 / 2
    }
  },
  DEFAULT_COMPARISON_ARROW_DIMENSION_SIZE: 16,
  TEXT_WIDTH_PROPORTION: .96,
  COMPARISON_FONT_SIZE: 14,
  COMPARISON_HEIGHT_PADDING: 6,
  NUMBER_COMPARISON_WRAPPED_LINE_MULTIPLIER: 0.75,
  NUMBER_COMPARISON_TEXT_ANGLE: 0,
  NUMBER_COMPARISON_WRAPPED_LINES: 3,
  BOLD_FONT_WEIGHT: 'bold',
  ANIMATION_DURATION: 400,
  CHAR_WIDTH: 12 * 0.65,
  SVG_PATH_MOVE_COMMAND: 'M',
  SVG_PATH_LINE_COMMAND: 'L',
  SVG_PATH_ARC_COMMAND: 'A',
  SVG_PATH_CLOSE_COMMAND: 'Z',
  SVG_PATH_BEZIER_COMMAND: 'Q',
  SHOW_VALUE: 'value',
  SHOW_LABEL: 'label',
  SHOW_PERCENT: 'percent',
  LEGEND_POSITIONS: {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  },
  LEGEND_SHAPES: {
    CIRCLE: 'circle',
    RECTANGLE: 'rectangle',
    SQUARE: 'roundedSquare',
    LINE: 'line'
  },
  POSITIVE_DIRECTION: 'up',
  NEGATIVE_DIRECTION: 'down',
  VERTICAL_CHART_ALIGNMENTS: {
    TOP: 'top',
    MIDDLE: 'middle'
  },
  HORIZONTAL_AXIS_PADDING: 4,
  HORIZONTAL_CHART_ALIGNMENTS: {
    LEFT: 'left',
    CENTER: 'center'
  },
  FONT_WEIGHTS: {
    normal: true,
    bold: true,
    lighter: true,
    bolder: true,
    inherit: true,
    initial: true,
    unset: true,
    100: true,
    200: true,
    300: true,
    400: true,
    500: true,
    600: true,
    700: true,
    800: true,
    900: true
  },
  SVG_COMMAND_TYPES: {
    MOVE: 'move',
    DRAW: 'draw',
    CLOSE: 'close'
  },
  ANCHOR_POSITIONS: {
    START: 'start',
    MIDDLE: 'middle'
  },
  GRAVITY: {
    EAST: 'e',
    WEST: 'w',
    SOUTH: 's',
    NORTH: 'n',
    CENTER: 'center'
  },
  DEFAULT_FONT_SIZE_PROPORTION: .6,
  CHAR_WIDTH_PROPORTIONS: {
    '+': .55,
    '%': .85,
    '.': .25,
    '-': .4,
    '1': .45,
    ',': .15,
    't': .55,
    'm': .9,
    ' ': .30
  },
  LINE_LABEL_STROKE_WIDTH: 2,
  LINE_LABEL_PADDING_Y: 3,
  LINE_LABEL_PADDING_X: 6,
  LINE_LABEL_MARGIN: 5,
  LINE_LABEL_MAX_PCT: 0.3,
  RIGHT_LINE_LABEL_WIDTHS: [{
    THRESHOLD: 768,
    MAX_PERCENTAGE: 0.2
  }, {
    THRESHOLD: 375,
    MAX_PERCENTAGE: 0.3
  }, {
    THRESHOLD: 0,
    MAX_PERCENTAGE: 0.4
  }],
  LINE_LABEL_PLACEMENT: {
    INLINE: 'inline',
    RIGHT: 'right',
    LEGEND: 'legend'
  },
  AXIS_LABEL_PADDING_X: 2,
  AXIS_LABEL_PADDING_Y: 1,
  AXIS_LABEL_DISTANCE: 24,
  MULTI_CHART_TICK_LABEL_ROTATION: 90,
  MULTI_CHART_MAX_TICK_LABEL_LINES: 3,
  MULTI_CHART_TICK_LABEL_FALLBACK: 1,
  HIDDEN_CLASS: 'hidden',
  NO_DISPLAY_CLASS: 'no-display',
  DATA_TYPES: {
    LINE: 'line',
    BAR: 'bar'
  },
  SHOW_VALUE_OPTIONS: {
    MIN_MAX: 'min-max',
    LAST: 'last',
    ALL: 'all',
    X_AXIS_Y_AXIS: 'X-Axis and Y-Axis',
    X_AXIS: 'X-Axis',
    Y_AXIS: 'Y-Axis',
    SIZE_METRIC: 'Data point size metric',
    GROUP: 'Group'
  },
  BAR_VALUE_PADDING: 4,
  Y_AXIS_TICK_DISTANCE: 36,
  BAR_ICON_WIDTH: 14,
  REGION_INTERACTIVE_UPDATE_DELAY: 300,
  TIER_PADDING: {
    1: {
      top: 12,
      bottom: 16,
      horizontal: 20
    },
    2: {
      top: 9,
      bottom: 12,
      horizontal: 15
    },
    3: {
      top: 6,
      bottom: 8,
      horizontal: 10
    },
    4: {
      top: 4,
      bottom: 6,
      horizontal: 6
    },
    5: {
      top: 3,
      bottom: 4,
      horizontal: 5
    }
  },
  TIER_FONT_SIZE: {
    1: '30px',
    2: '24px',
    3: '20px',
    4: '16px',
    5: '14px'
  },
  WORD_CLOUD_LAYOUT: {
    CENTER_OUT: 'center-out',
    TOP_DOWN: 'top-down'
  },
  TABLET_WIDTH_BREAKPOINT: 512,
  KEYS: {
    ENTER: 'Enter',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    SPACE: ' '
  },
  DEFAULT_DIMENSIONS: {
    WIDTH: 400,
    HEIGHT: 400
  },
  TROTTLE_TIME: 300,
  ALLOWED_TAGS: ['a', 'b', 'blockquote', 'br', 'caption', 'code', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 'span', 'strike', 'strong', 'table', 'tbody', 'td', 'text', 'th', 'thead', 'tr', 'ul', 'circle', 'clippath', 'ellipse', 'filter', 'g', 'line', 'lineargradient', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'svg', 'text', 'tspan'],
  ALLOWED_ATTR: ['alt', 'cols', 'colspan', 'class', 'href', 'id', 'role', 'rows', 'rowspan', 'src', 'style', 'tabindex', 'cx', 'cy', 'd', 'dx', 'dy', 'fill', 'fill-opacity', 'filter', 'gradientTransform', 'height', 'offset', 'pathlength', 'points', 'r', 'rotate', 'rx', 'ry', 'stop-color', 'stop-opacity', 'stroke', 'stroke-width', 'viewBox', 'width', 'x', 'x1', 'x2', 'y', 'y1', 'y2'],
  TOUCH_START: 'touchstart',
  INTERACTION_EVENTS: {
    mouseEnter: 'mouseenter',
    mouseLeave: 'mouseleave',
    mouseMove: 'mousemove',
    touchStart: 'touchstart',
    touchMove: 'touchmove'
  }
};
;// ./node_modules/dompurify/dist/purify.es.mjs
/*! @license DOMPurify 3.2.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.0/LICENSE */

const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object; // eslint-disable-line import/no-mutable-exports
let {
  apply,
  construct
} = typeof Reflect !== 'undefined' && Reflect;
if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!construct) {
  construct = function construct(Func, args) {
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */
function unapply(func) {
  return function (thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */
function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */
function purify_es_clone(object) {
  const newObject = create(null);
  for (const [property, value] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = purify_es_clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}

const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
// SVG
const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const purify_es_text = freeze(['#text']);

const purify_es_html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

// eslint-disable-next-line unicorn/better-regex
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

var EXPRESSIONS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ARIA_ATTR: ARIA_ATTR,
  ATTR_WHITESPACE: ATTR_WHITESPACE,
  CUSTOM_ELEMENT: CUSTOM_ELEMENT,
  DATA_ATTR: DATA_ATTR,
  DOCTYPE_NAME: DOCTYPE_NAME,
  ERB_EXPR: ERB_EXPR,
  IS_ALLOWED_URI: IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR: MUSTACHE_EXPR,
  TMPLIT_EXPR: TMPLIT_EXPR
});

/* eslint-disable @typescript-eslint/indent */
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12 // Deprecated
};
const getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }
  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
  const DOMPurify = root => createDOMPurify(root);
  DOMPurify.version = '3.2.0';
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document
  } = window;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node,
    Element,
    NodeFilter,
    NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = '';
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document;
  const {
    importNode
  } = originalDocument;
  let hooks = {};
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const {
    MUSTACHE_EXPR,
    ERB_EXPR,
    TMPLIT_EXPR,
    DATA_ATTR,
    ARIA_ATTR,
    IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE,
    CUSTOM_ELEMENT
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */
  /* allowed element names */
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...purify_es_text]);
  /* Allowed attribute names */
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...purify_es_html, ...svg, ...mathMl, ...xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  let FORBID_ATTR = null;
  /* Decide if ARIA attributes are okay */
  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */
  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */
  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */
  let SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */
  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */
  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);
  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */
  let CONFIG = null;
  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */
  const formElement = document.createElement('form');
  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity
  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */
    cfg = purify_es_clone(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */
    ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(purify_es_clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(purify_es_clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
    FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, purify_es_text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, purify_es_html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = purify_es_clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = purify_es_clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = purify_es_clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      // Overwrite existing TrustedTypes policy.
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      // Sign local variables required by `sanitize`.
      emptyHTML = trustedTypesPolicy.createHTML('');
    } else {
      // Uninitialized policy, attempt to initialize the internal dompurify policy.
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      // If creating the internal policy succeeded sign internal variables.
      if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
        emptyHTML = trustedTypesPolicy.createHTML('');
      }
    }
    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element);
    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      }
      // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      }
      // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      }
      // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */
  const _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */
  const _removeAttribute = function _removeAttribute(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    // We void attribute values for unremovable "is"" attributes
    if (name === 'is' && !ALLOWED_ATTR[name]) {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */
  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */
  const _createNodeIterator = function _createNodeIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */
  const _isClobbered = function _isClobbered(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
  };
  /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */
  const _isNode = function _isNode(value) {
    return typeof Node === 'function' && value instanceof Node;
  };
  function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }
    arrayForEach(hooks[entryPoint], hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */
  const _sanitizeElements = function _sanitizeElements(currentNode) {
    let content = null;
    /* Execute a hook if present */
    _executeHook('beforeSanitizeElements', currentNode, null);
    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Now let's check the element's type and name */
    const tagName = transformCaseFunc(currentNode.nodeName);
    /* Execute a hook if present */
    _executeHook('uponSanitizeElement', currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Detect mXSS attempts abusing namespace confusion */
    if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any occurrence of processing instructions */
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    /* Check whether element has a valid namespace */
    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        content = stringReplace(content, expr, ' ');
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */
    _executeHook('afterSanitizeElements', currentNode, null);
    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
      // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
      // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
      return false;
    } else ;
    return true;
  };
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */
  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */
  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHook('beforeSanitizeAttributes', currentNode, null);
    const {
      attributes
    } = currentNode;
    /* Check if we have attributes; if not we might have a text node */
    if (!attributes) {
      return;
    }
    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      const attr = attributes[l];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      let value = name === 'value' ? attrValue : stringTrim(attrValue);
      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode);
        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Remove attribute */
      _removeAttribute(name, currentNode);
      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }
      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          value = stringReplace(value, expr, ' ');
        });
      }
      /* Is `value` valid for this attribute? */
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }
      /* Handle attributes that require Trusted Types */
      if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ; else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }
            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }
      /* Handle invalid data-* attribute set by try-catching it */
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
          currentNode.setAttribute(name, value);
        }
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
        } else {
          arrayPop(DOMPurify.removed);
        }
      } catch (_) {}
    }
    /* Execute a hook if present */
    _executeHook('afterSanitizeAttributes', currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */
  const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */
    _executeHook('beforeSanitizeShadowDOM', fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);
      /* Sanitize tags and elements */
      if (_sanitizeElements(shadowNode)) {
        continue;
      }
      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }
      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(shadowNode);
    }
    /* Execute a hook if present */
    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      if (typeof dirty.toString === 'function') {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      } else {
        throw typeErrorCreate('toString is not a function');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */
    DOMPurify.removed = [];
    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */
      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Sanitize tags and elements */
      if (_sanitizeElements(currentNode)) {
        continue;
      }
      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(currentNode);
    }
    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }
    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        serializedHTML = stringReplace(serializedHTML, expr, ' ');
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    hooks[entryPoint] = hooks[entryPoint] || [];
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      return arrayPop(hooks[entryPoint]);
    }
  };
  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };
  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };
  return DOMPurify;
}
var purify = createDOMPurify();


//# sourceMappingURL=purify.es.mjs.map

;// ./src/js/tooltip/tooltip_offset.js

var GRAVITY_FALLBACK_VALUES = {
  'e': ['e', 'w', 's', 'n'],
  'w': ['w', 'e', 's', 'n'],
  'n': ['n', 's', 'w', 'e'],
  's': ['s', 'n', 'w', 'e']
};
var TOOLTIP_OFFSET = 10;
var GRAVITY = constants_Constants.GRAVITY;
function calculateGravityOffset(dimensions, pos, startingGravity, distance) {
  var left = 0;
  var top = 0;
  var currentGravity;
  var currentIndex = 0;
  var tmp;
  var height = dimensions.height,
    width = dimensions.width,
    clientHeight = dimensions.clientHeight,
    clientWidth = dimensions.clientWidth;
  var DEFAULT_OFFSET = {
    left: -(width / 2),
    top: -(height / 2),
    location: GRAVITY.CENTER
  };
  while (currentIndex <= 3) {
    if (startingGravity === GRAVITY.CENTER || !startingGravity || !GRAVITY_FALLBACK_VALUES[startingGravity]) {
      return DEFAULT_OFFSET;
    }
    currentGravity = GRAVITY_FALLBACK_VALUES[startingGravity][currentIndex];
    switch (currentGravity) {
      case GRAVITY.EAST:
        left = -width - distance - TOOLTIP_OFFSET;
        top = -(height / 2);
        if (pos.left + left < 0) {
          currentIndex++;
          break;
        }
        if (tmp = pos.top + top < 0) {
          top -= tmp;
        }
        if ((tmp = pos.top + top + height) > clientHeight) {
          top -= tmp - clientHeight;
        }
        return {
          left: left,
          top: top,
          location: currentGravity
        };
      case GRAVITY.WEST:
        left = distance - TOOLTIP_OFFSET;
        top = -(height / 2);
        if (pos.left + left + width > clientWidth) {
          currentIndex++;
          break;
        }
        if ((tmp = pos.top + top) < 0) {
          top -= tmp;
        }
        if ((tmp = pos.top + top + height) > clientHeight) {
          top -= tmp - clientHeight;
        }
        return {
          left: left,
          top: top,
          location: currentGravity
        };
      case GRAVITY.NORTH:
        left = -(width / 2);
        top = distance - TOOLTIP_OFFSET;
        if (pos.top + top + height > clientHeight) {
          currentIndex++;
          break;
        }
        if ((tmp = pos.left + left) < 0) {
          left -= tmp;
        }
        if ((tmp = pos.left + left + width) > clientWidth) {
          left -= tmp - clientWidth;
        }
        return {
          left: left,
          top: top,
          location: currentGravity
        };
      case GRAVITY.SOUTH:
        left = -(width / 2);
        top = -height - distance + TOOLTIP_OFFSET;
        if (pos.top + top < 0) {
          currentIndex++;
          break;
        }
        if ((tmp = pos.left + left) < 0) {
          left -= tmp;
        }
        if ((tmp = pos.left + left + width) > clientWidth) {
          left -= tmp - clientWidth;
        }
        return {
          left: left,
          top: top,
          location: currentGravity
        };
      default:
        return DEFAULT_OFFSET;
    }
  }
  return DEFAULT_OFFSET;
}
;// ./src/js/nv/tooltip.js






function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var DEFAULT_TOOLTIP_DISTANCE = constants_Constants.DEFAULT_TOOLTIP_DISTANCE,
  tooltip_GRAVITY = constants_Constants.GRAVITY,
  THROTTLE_TIME = constants_Constants.THROTTLE_TIME,
  ALLOWED_ATTR = constants_Constants.ALLOWED_ATTR,
  ALLOWED_TAGS = constants_Constants.ALLOWED_TAGS,
  TOUCH_START = constants_Constants.TOUCH_START;
var DARK_DIALOG_MARGIN = 32;
function getEventPosition(d3Event) {
  if (d3Event === null) {
    return {
      left: 0,
      top: 0
    };
  }
  if (d3Event.type === TOUCH_START) {
    var _d3Event$touches = _slicedToArray(d3Event.touches, 1),
      tapPosition = _d3Event$touches[0];
    return {
      left: tapPosition.clientX,
      top: tapPosition.clientY
    };
  }
  return {
    left: d3Event.clientX,
    top: d3Event.clientY
  };
}
function dataSeriesExists(d) {
  if (d && d.series) {
    if (d.series instanceof Array) {
      return !!d.series.length;
    }
    if (d.series instanceof Object) {
      d.series = [d.series];
      return true;
    }
  }
  return false;
}
var sanitize = function sanitize(content) {
  if (content === null || content === undefined) {
    return '';
  }
  return purify.sanitize(String(content), {
    RETURN_DOM: true,
    ALLOWED_ATTR: ALLOWED_ATTR,
    ALLOWED_TAGS: ALLOWED_TAGS
  }).innerHTML;
};
var tooltip = function tooltip(nv) {
  nv.models.tooltip = function () {
    var _dataValidator;
    var id = 'nvtooltip-' + Math.floor(Math.random() * 100000),
      data = null,
      gravity = tooltip_GRAVITY.WEST,
      fallbackGravity = null,
      distance = DEFAULT_TOOLTIP_DISTANCE,
      snapDistance = 0,
      classes = null,
      chartContainer = null,
      hidden = true,
      hideDelay = 200,
      tooltip = null,
      lastPosition = {
        left: null,
        top: null
      },
      enabled = true,
      duration = 100,
      headerEnabled = true,
      nvPointerEventsClass = 'nv-pointer-events-none';
    var position = function position() {
      return getEventPosition(d3.event);
    };
    var valueFormatter = function valueFormatter(d) {
      return d;
    };
    var headerFormatter = function headerFormatter(d) {
      return d;
    };
    var keyFormatter = function keyFormatter(d) {
      return d;
    };
    var contentGenerator = function contentGenerator(d) {
      if (d === null) {
        return '';
      }
      var table = d3.select(document.createElement('table'));
      if (headerEnabled) {
        var theadEnter = table.selectAll('thead').data([d]).enter().append('thead');
        theadEnter.append('tr').append('td').attr('colspan', 3).append('strong').classed('x-value', true).html(sanitize(headerFormatter(d.value)));
      }
      var tbodyEnter = table.selectAll('tbody').data([d]).enter().append('tbody');
      var trowEnter = tbodyEnter.selectAll('tr').data(function (p) {
        return p.series;
      }).enter().append('tr').classed('highlight', function (p) {
        return p.highlight;
      });
      trowEnter.append('td').classed('legend-color-guide', true).append('div').style('background-color', function (p) {
        return p.color;
      });
      trowEnter.append('td').classed('key', true).classed('total', function (p) {
        return !!p.total;
      }).html(function (p, i) {
        return sanitize(keyFormatter(p.key, i));
      });
      trowEnter.append('td').classed('value', true).html(function (p, i) {
        return sanitize(valueFormatter(p.value, i));
      });
      trowEnter.selectAll('td').each(function (p) {
        if (p.highlight) {
          var opacityScale = d3.scale.linear().domain([0, 1]).range(['#fff', p.color]);
          var opacity = 0.6;
          d3.select(this).style('border-bottom-color', opacityScale(opacity)).style('border-top-color', opacityScale(opacity));
        }
      });
      var html = table.node().outerHTML;
      if (d.footer !== undefined) {
        html += '<div class=\'footer\'>' + d.footer + '</div>';
      }
      return sanitize(html);
    };
    var validateTooltipData = function validateTooltipData() {
      if (_dataValidator && typeof _dataValidator === 'function') {
        return _dataValidator(data);
      }
      return dataSeriesExists(data);
    };
    var calcGravityOffset = _.throttle(function (pos) {
      var isDarkDialog = tooltip.node().getElementsByClassName('dark-dialog').length;
      var height = isDarkDialog ? tooltip.node().firstChild.clientHeight + DARK_DIALOG_MARGIN : tooltip.node().offsetHeight;
      var width = isDarkDialog ? tooltip.node().firstChild.clientWidth + DARK_DIALOG_MARGIN : tooltip.node().offsetWidth;
      var dimensions = {
        height: height,
        width: width,
        clientHeight: document.documentElement.clientHeight,
        clientWidth: document.documentElement.clientWidth
      };
      return calculateGravityOffset(dimensions, pos, gravity, distance);
    }, THROTTLE_TIME);
    var positionTooltip = function positionTooltip() {
      nv.dom.read(function () {
        var pos = position(),
          gravityOffset = calcGravityOffset(pos),
          left = parseInt(pos.left + gravityOffset.left, 10),
          top = parseInt(pos.top + gravityOffset.top, 10);
        if (hidden) {
          tooltip.interrupt().transition().delay(hideDelay).duration(0).style('opacity', 0);
        } else {
          var old_translate = 'translate(' + lastPosition.left + 'px, ' + lastPosition.top + 'px)';
          var new_translate = 'translate(' + left + 'px, ' + top + 'px)';
          var translateInterpolator = d3.interpolateString(old_translate, new_translate);
          var is_hidden = tooltip.style('opacity') < 0.1;
          tooltip.classed({
            'nv-n': gravityOffset.location === tooltip_GRAVITY.NORTH,
            'nv-e': gravityOffset.location === tooltip_GRAVITY.EAST,
            'nv-s': gravityOffset.location === tooltip_GRAVITY.SOUTH,
            'nv-w': gravityOffset.location === tooltip_GRAVITY.WEST
          }).interrupt().transition().duration(is_hidden ? 0 : duration).styleTween('transform', function () {
            return translateInterpolator;
          }, 'important').styleTween('-webkit-transform', function () {
            return translateInterpolator;
          }).style('-ms-transform', new_translate).style('opacity', 1);
        }
        lastPosition.left = left;
        lastPosition.top = top;
      });
    };
    function initTooltip() {
      if (!tooltip) {
        var container = chartContainer ? chartContainer : document.body;
        tooltip = d3.select(container).select('div.nvtooltip.' + (classes ? classes : 'xy-tooltip'));
        if (tooltip.empty()) {
          tooltip = d3.select(container).append('div').attr('class', (less_default()).dqTooltip + ' nvtooltip ' + (classes ? classes : 'xy-tooltip')).attr('id', id);
        } else {
          id = tooltip.attr('id');
        }
        tooltip.style('top', 0).style('left', 0);
        tooltip.style('opacity', 0);
        tooltip.style('position', 'fixed');
        tooltip.selectAll('div, table, td, tr').classed(nvPointerEventsClass, true);
        tooltip.classed(nvPointerEventsClass, true);
      }
    }
    function nvtooltip() {
      if (!enabled) {
        return;
      }
      if (!validateTooltipData(data)) {
        return;
      }
      nv.dom.write(function () {
        initTooltip();
        var newContent = contentGenerator(data);
        if (newContent) {
          tooltip.node().innerHTML = sanitize(newContent);
        }
        positionTooltip();
      });
      return nvtooltip;
    }
    nvtooltip.nvPointerEventsClass = nvPointerEventsClass;
    nvtooltip.options = nv.utils.optionsFunc.bind(nvtooltip);
    nvtooltip._options = Object.create({}, {
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
        }
      },
      dataValidator: {
        get: function get() {
          return _dataValidator;
        },
        set: function set(_) {
          _dataValidator = _;
        }
      },
      gravity: {
        get: function get() {
          return gravity;
        },
        set: function set(_) {
          gravity = _;
        }
      },
      fallbackGravity: {
        get: function get() {
          return fallbackGravity;
        },
        set: function set(_) {
          fallbackGravity = _;
        }
      },
      distance: {
        get: function get() {
          return distance;
        },
        set: function set(_) {
          distance = _;
        }
      },
      snapDistance: {
        get: function get() {
          return snapDistance;
        },
        set: function set(_) {
          snapDistance = _;
        }
      },
      classes: {
        get: function get() {
          return classes;
        },
        set: function set(_) {
          classes = _;
        }
      },
      chartContainer: {
        get: function get() {
          return chartContainer;
        },
        set: function set(_) {
          chartContainer = _;
        }
      },
      enabled: {
        get: function get() {
          return enabled;
        },
        set: function set(_) {
          enabled = _;
        }
      },
      hideDelay: {
        get: function get() {
          return hideDelay;
        },
        set: function set(_) {
          hideDelay = _;
        }
      },
      contentGenerator: {
        get: function get() {
          return contentGenerator;
        },
        set: function set(_) {
          contentGenerator = _;
        }
      },
      valueFormatter: {
        get: function get() {
          return valueFormatter;
        },
        set: function set(_) {
          valueFormatter = _;
        }
      },
      headerFormatter: {
        get: function get() {
          return headerFormatter;
        },
        set: function set(_) {
          headerFormatter = _;
        }
      },
      keyFormatter: {
        get: function get() {
          return keyFormatter;
        },
        set: function set(_) {
          keyFormatter = _;
        }
      },
      headerEnabled: {
        get: function get() {
          return headerEnabled;
        },
        set: function set(_) {
          headerEnabled = _;
        }
      },
      position: {
        get: function get() {
          return position;
        },
        set: function set(_) {
          position = _;
        }
      },
      calcGravityOffset: {
        get: function get() {
          return calcGravityOffset;
        },
        set: function set(_) {
          calcGravityOffset = _;
        }
      },
      hidden: {
        get: function get() {
          return hidden;
        },
        set: function set(_) {
          if (hidden !== _) {
            hidden = !!_;
            nvtooltip();
          }
        }
      },
      data: {
        get: function get() {
          return data;
        },
        set: function set(_) {
          if (_.point) {
            _.value = _.point.x;
            _.series = _.series || {};
            _.series.value = _.point.y;
            _.series.color = _.point.color || _.series.color;
          }
          data = _;
        }
      },
      node: {
        get: function get() {
          return tooltip.node();
        },
        set: function set() {}
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set() {}
      }
    });
    nv.utils.initOptions(nvtooltip);
    return nvtooltip;
  };
};
;// ./node_modules/d3-interpolate/src/number.js
/* harmony default export */ function src_number(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

;// ./node_modules/d3-interpolate/src/string.js


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: src_number(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

;// ./node_modules/d3-scale/node_modules/d3-array/src/ticks.js
var ticks_e10 = Math.sqrt(50),
    ticks_e5 = Math.sqrt(10),
    ticks_e2 = Math.sqrt(2);

/* harmony default export */ function src_ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = ticks_tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function ticks_tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= ticks_e10 ? 10 : error >= ticks_e5 ? 5 : error >= ticks_e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= ticks_e10 ? 10 : error >= ticks_e5 ? 5 : error >= ticks_e2 ? 2 : 1);
}

function src_ticks_tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= ticks_e10) step1 *= 10;
  else if (error >= ticks_e5) step1 *= 5;
  else if (error >= ticks_e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

;// ./node_modules/d3-scale/node_modules/d3-array/src/ascending.js
/* harmony default export */ function d3_array_src_ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// ./node_modules/d3-scale/node_modules/d3-array/src/bisector.js


/* harmony default export */ function src_bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = bisector_ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function bisector_ascendingComparator(f) {
  return (d, x) => d3_array_src_ascending(f(d), x);
}

;// ./node_modules/d3-scale/node_modules/d3-array/src/number.js
/* harmony default export */ function d3_array_src_number(x) {
  return x === null ? NaN : +x;
}

function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}

;// ./node_modules/d3-scale/node_modules/d3-array/src/bisect.js




const bisect_ascendingBisect = src_bisector(d3_array_src_ascending);
const bisect_bisectRight = bisect_ascendingBisect.right;
const bisect_bisectLeft = bisect_ascendingBisect.left;
const bisectCenter = src_bisector(d3_array_src_number).center;
/* harmony default export */ var d3_array_src_bisect = (bisect_bisectRight);

;// ./node_modules/d3-color/src/define.js
/* harmony default export */ function src_define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

;// ./node_modules/d3-color/src/color.js


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

src_define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function color_rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

src_define(Rgb, color_rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

src_define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

;// ./node_modules/d3-interpolate/src/basis.js
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ function src_basis(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

;// ./node_modules/d3-interpolate/src/basisClosed.js


/* harmony default export */ function basisClosed(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

;// ./node_modules/d3-interpolate/src/constant.js
/* harmony default export */ var d3_interpolate_src_constant = (x => () => x);

;// ./node_modules/d3-interpolate/src/color.js


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : d3_interpolate_src_constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : d3_interpolate_src_constant(isNaN(a) ? b : a);
}

;// ./node_modules/d3-interpolate/src/rgb.js





/* harmony default export */ var rgb = ((function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = color_rgb(start)).r, (end = color_rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = color_rgb(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(src_basis);
var rgbBasisClosed = rgbSpline(basisClosed);

;// ./node_modules/d3-interpolate/src/array.js



/* harmony default export */ function d3_interpolate_src_array(a, b) {
  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

;// ./node_modules/d3-interpolate/src/date.js
/* harmony default export */ function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

;// ./node_modules/d3-interpolate/src/object.js


/* harmony default export */ function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = value(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

;// ./node_modules/d3-interpolate/src/numberArray.js
/* harmony default export */ function src_numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function numberArray_isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

;// ./node_modules/d3-interpolate/src/value.js










/* harmony default export */ function value(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? d3_interpolate_src_constant(b)
      : (t === "number" ? src_number
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : string)
      : b instanceof color ? rgb
      : b instanceof Date ? date
      : numberArray_isNumberArray(b) ? src_numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : src_number)(a, b);
}

;// ./node_modules/d3-interpolate/src/round.js
/* harmony default export */ function round(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

;// ./node_modules/d3-scale/src/constant.js
function constants(x) {
  return function() {
    return x;
  };
}

;// ./node_modules/d3-scale/src/number.js
function number_number(x) {
  return +x;
}

;// ./node_modules/d3-scale/src/continuous.js





var unit = [0, 1];

function continuous_identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = d3_array_src_bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = value,
      transform,
      untransform,
      unknown,
      clamp = continuous_identity,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== continuous_identity) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), src_number)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number_number), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate = round, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : continuous_identity, rescale()) : clamp !== continuous_identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(continuous_identity, continuous_identity);
}

;// ./node_modules/d3-format/src/formatSpecifier.js
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

;// ./node_modules/d3-format/src/formatDecimal.js
/* harmony default export */ function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

;// ./node_modules/d3-format/src/exponent.js


/* harmony default export */ function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

;// ./node_modules/d3-format/src/precisionPrefix.js


/* harmony default export */ function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

;// ./node_modules/d3-format/src/formatGroup.js
/* harmony default export */ function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

;// ./node_modules/d3-format/src/formatNumerals.js
/* harmony default export */ function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

;// ./node_modules/d3-format/src/formatTrim.js
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

;// ./node_modules/d3-format/src/formatPrefixAuto.js


var prefixExponent;

/* harmony default export */ function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

;// ./node_modules/d3-format/src/formatRounded.js


/* harmony default export */ function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

;// ./node_modules/d3-format/src/formatTypes.js




/* harmony default export */ var formatTypes = ({
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
});

;// ./node_modules/d3-format/src/identity.js
/* harmony default export */ function src_identity(x) {
  return x;
}

;// ./node_modules/d3-format/src/locale.js









var locale_map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ function locale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? src_identity : formatGroup(locale_map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? src_identity : formatNumerals(locale_map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

;// ./node_modules/d3-format/src/defaultLocale.js


var defaultLocale_locale;
var format;
var formatPrefix;

defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  defaultLocale_locale = locale(definition);
  format = defaultLocale_locale.format;
  formatPrefix = defaultLocale_locale.formatPrefix;
  return defaultLocale_locale;
}

;// ./node_modules/d3-format/src/precisionRound.js


/* harmony default export */ function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

;// ./node_modules/d3-format/src/precisionFixed.js


/* harmony default export */ function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

;// ./node_modules/d3-scale/src/tickFormat.js



function tickFormat(start, stop, count, specifier) {
  var step = src_ticks_tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

;// ./node_modules/d3-scale/src/linear.js





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return src_ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = ticks_tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start
        d[i1] = stop
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear_linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear_linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

;// ./node_modules/d3-timer/src/timer.js
var timer_frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --timer_frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  timer_frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    timer_frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (timer_frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    timer_frame = 1, setFrame(wake);
  }
}

;// ./node_modules/d3-timer/src/timeout.js


/* harmony default export */ function src_timeout(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(elapsed => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

;// ./node_modules/d3-transition/src/transition/schedule.js



var emptyOn = src_dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var schedule_SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  schedule_create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = schedule_get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function schedule_set(node, id) {
  var schedule = schedule_get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function schedule_get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function schedule_create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = schedule_SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== schedule_SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return src_timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    src_timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

;// ./node_modules/d3-transition/src/interrupt.js


/* harmony default export */ function interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

;// ./node_modules/d3-transition/src/selection/interrupt.js


/* harmony default export */ function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}

;// ./node_modules/d3-interpolate/src/transform/decompose.js
var degrees = 180 / Math.PI;

var decompose_identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

;// ./node_modules/d3-interpolate/src/transform/parse.js


var svgNode;

/* eslint-disable no-undef */
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? decompose_identity : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}

function parseSvg(value) {
  if (value == null) return decompose_identity;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return decompose_identity;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

;// ./node_modules/d3-interpolate/src/transform/index.js



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: src_number(xa, xb)}, {i: i - 2, x: src_number(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: src_number(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: src_number(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: src_number(xa, xb)}, {i: i - 2, x: src_number(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

;// ./node_modules/d3-transition/src/transition/tween.js


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ function tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = schedule_get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = schedule_set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return schedule_get(node, id).value[name];
  };
}

;// ./node_modules/d3-transition/src/transition/interpolate.js



/* harmony default export */ function interpolate(a, b) {
  var c;
  return (typeof b === "number" ? src_number
      : b instanceof color ? rgb
      : (c = color(b)) ? (b = c, rgb)
      : string)(a, b);
}

;// ./node_modules/d3-transition/src/transition/attr.js





function attr_attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attr_attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attr_attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attr_attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attr_attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attr_attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

/* harmony default export */ function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attr_attrFunctionNS : attr_attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attr_attrRemoveNS : attr_attrRemove)(fullname)
      : (fullname.local ? attr_attrConstantNS : attr_attrConstant)(fullname, i, value));
}

;// ./node_modules/d3-transition/src/transition/attrTween.js


function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

;// ./node_modules/d3-transition/src/transition/delay.js


function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

/* harmony default export */ function delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : schedule_get(this.node(), id).delay;
}

;// ./node_modules/d3-transition/src/transition/duration.js


function durationFunction(id, value) {
  return function() {
    schedule_set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    schedule_set(this, id).duration = value;
  };
}

/* harmony default export */ function duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : schedule_get(this.node(), id).duration;
}

;// ./node_modules/d3-transition/src/transition/ease.js


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    schedule_set(this, id).ease = value;
  };
}

/* harmony default export */ function ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : schedule_get(this.node(), id).ease;
}

;// ./node_modules/d3-transition/src/transition/easeVarying.js


function easeVarying(id, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error;
    schedule_set(this, id).ease = v;
  };
}

/* harmony default export */ function transition_easeVarying(value) {
  if (typeof value !== "function") throw new Error;
  return this.each(easeVarying(this._id, value));
}

;// ./node_modules/d3-transition/src/transition/filter.js



/* harmony default export */ function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new transition_Transition(subgroups, this._parents, this._name, this._id);
}

;// ./node_modules/d3-transition/src/transition/merge.js


/* harmony default export */ function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new transition_Transition(merges, this._parents, this._name, this._id);
}

;// ./node_modules/d3-transition/src/transition/on.js


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : schedule_set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? schedule_get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

;// ./node_modules/d3-transition/src/transition/remove.js
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

;// ./node_modules/d3-transition/src/transition/select.js




/* harmony default export */ function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, schedule_get(node, id));
      }
    }
  }

  return new transition_Transition(subgroups, this._parents, name, id);
}

;// ./node_modules/d3-transition/src/transition/selectAll.js




/* harmony default export */ function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = schedule_get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new transition_Transition(subgroups, parents, name, id);
}

;// ./node_modules/d3-transition/src/transition/selection.js


var selection_Selection = src_selection.prototype.constructor;

/* harmony default export */ function transition_selection() {
  return new selection_Selection(this._groups, this._parents);
}

;// ./node_modules/d3-transition/src/transition/style.js






function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function style_styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function style_styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function style_styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = schedule_set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = style_styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

/* harmony default export */ function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, style_styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, style_styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, style_styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
}

;// ./node_modules/d3-transition/src/transition/styleTween.js
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

;// ./node_modules/d3-transition/src/transition/text.js


function text_textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function text_textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? text_textFunction(tweenValue(this, "text", value))
      : text_textConstant(value == null ? "" : value + ""));
}

;// ./node_modules/d3-transition/src/transition/textTween.js
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

;// ./node_modules/d3-transition/src/transition/transition.js



/* harmony default export */ function transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = schedule_get(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new transition_Transition(groups, this._parents, name, id1);
}

;// ./node_modules/d3-transition/src/transition/end.js


/* harmony default export */ function end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = schedule_set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });

    // The selection was empty, resolve end immediately
    if (size === 0) resolve();
  });
}

;// ./node_modules/d3-transition/src/transition/index.js






















var id = 0;

function transition_Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition_transition(name) {
  return src_selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = src_selection.prototype;

transition_Transition.prototype = transition_transition.prototype = {
  constructor: transition_Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: tween,
  delay: delay,
  duration: duration,
  ease: ease,
  easeVarying: transition_easeVarying,
  end: end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

;// ./node_modules/d3-ease/src/cubic.js
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

;// ./node_modules/d3-transition/src/selection/transition.js





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id} not found`);
    }
  }
  return timing;
}

/* harmony default export */ function selection_transition(name) {
  var id,
      timing;

  if (name instanceof transition_Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new transition_Transition(groups, this._parents, name, id);
}

;// ./node_modules/d3-transition/src/selection/index.js




src_selection.prototype.interrupt = selection_interrupt;
src_selection.prototype.transition = selection_transition;

;// ./node_modules/d3-transition/src/active.js



var active_root = (/* unused pure expression or super */ null && ([null]));

/* harmony default export */ function active(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], active_root, name, +i);
      }
    }
  }

  return null;
}

;// ./node_modules/d3-transition/src/index.js





;// ./src/js/nv/upgraded_tooltip.js






function upgraded_tooltip_slicedToArray(r, e) { return upgraded_tooltip_arrayWithHoles(r) || upgraded_tooltip_iterableToArrayLimit(r, e) || upgraded_tooltip_unsupportedIterableToArray(r, e) || upgraded_tooltip_nonIterableRest(); }
function upgraded_tooltip_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function upgraded_tooltip_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return upgraded_tooltip_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? upgraded_tooltip_arrayLikeToArray(r, a) : void 0; } }
function upgraded_tooltip_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function upgraded_tooltip_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function upgraded_tooltip_arrayWithHoles(r) { if (Array.isArray(r)) return r; }








var upgraded_tooltip_ALLOWED_ATTR = constants_Constants.ALLOWED_ATTR,
  upgraded_tooltip_ALLOWED_TAGS = constants_Constants.ALLOWED_TAGS,
  upgraded_tooltip_DEFAULT_TOOLTIP_DISTANCE = constants_Constants.DEFAULT_TOOLTIP_DISTANCE,
  upgraded_tooltip_GRAVITY = constants_Constants.GRAVITY,
  upgraded_tooltip_THROTTLE_TIME = constants_Constants.THROTTLE_TIME,
  upgraded_tooltip_TOUCH_START = constants_Constants.TOUCH_START;
var upgraded_tooltip_DARK_DIALOG_MARGIN = 32;
function upgraded_tooltip_getEventPosition(event) {
  if (event === null) {
    return {
      left: 0,
      top: 0
    };
  }
  if (event.type === upgraded_tooltip_TOUCH_START) {
    var _event$touches = upgraded_tooltip_slicedToArray(event.touches, 1),
      tapPosition = _event$touches[0];
    return {
      left: tapPosition.clientX,
      top: tapPosition.clientY
    };
  }
  return {
    left: event.clientX,
    top: event.clientY
  };
}
function upgraded_tooltip_dataSeriesExists(d) {
  if (d && d.series) {
    if (d.series instanceof Array) {
      return !!d.series.length;
    }
    if (d.series instanceof Object) {
      d.series = [d.series];
      return true;
    }
  }
  return false;
}
var upgraded_tooltip_sanitize = function sanitize(content) {
  if (content === null || content === undefined) {
    return '';
  }
  return purify.sanitize(String(content), {
    RETURN_DOM: true,
    ALLOWED_ATTR: upgraded_tooltip_ALLOWED_ATTR,
    ALLOWED_TAGS: upgraded_tooltip_ALLOWED_TAGS
  }).innerHTML;
};
var upgradedTooltip = function upgradedTooltip(nv) {
  nv.models.upgradedTooltip = function () {
    var _dataValidator;
    var id = 'nvtooltip-' + Math.floor(Math.random() * 100000),
      data = null,
      gravity = upgraded_tooltip_GRAVITY.WEST,
      fallbackGravity = null,
      distance = upgraded_tooltip_DEFAULT_TOOLTIP_DISTANCE,
      snapDistance = 0,
      classes = null,
      chartContainer = null,
      hidden = true,
      hideDelay = 200,
      tooltip = null,
      lastPosition = {
        left: null,
        top: null
      },
      enabled = true,
      duration = 100,
      headerEnabled = true,
      nvPointerEventsClass = 'nv-pointer-events-none';
    var position = function position() {
      return upgraded_tooltip_getEventPosition(event);
    };
    var valueFormatter = function valueFormatter(d) {
      return d;
    };
    var headerFormatter = function headerFormatter(d) {
      return d;
    };
    var keyFormatter = function keyFormatter(d) {
      return d;
    };
    var contentGenerator = function contentGenerator(d) {
      if (d === null) {
        return '';
      }
      var table = src_select(document.createElement('table'));
      if (headerEnabled) {
        var theadEnter = table.selectAll('thead').data([d]).enter().append('thead');
        theadEnter.append('tr').append('td').attr('colspan', 3).append('strong').classed('x-value', true).html(upgraded_tooltip_sanitize(headerFormatter(d.value)));
      }
      var tbodyEnter = table.selectAll('tbody').data([d]).enter().append('tbody');
      var trowEnter = tbodyEnter.selectAll('tr').data(function (p) {
        return p.series;
      }).enter().append('tr').classed('highlight', function (p) {
        return p.highlight;
      });
      trowEnter.append('td').classed('legend-color-guide', true).append('div').style('background-color', function (p) {
        return p.color;
      });
      trowEnter.append('td').classed('key', true).classed('total', function (p) {
        return !!p.total;
      }).html(function (p, i) {
        return upgraded_tooltip_sanitize(keyFormatter(p.key, i));
      });
      trowEnter.append('td').classed('value', true).html(function (p, i) {
        return upgraded_tooltip_sanitize(valueFormatter(p.value, i));
      });
      trowEnter.selectAll('td').each(function (p) {
        if (p.highlight) {
          var opacityScale = linear_linear().domain([0, 1]).range(['#fff', p.color]);
          var opacity = 0.6;
          src_select(this).style('border-bottom-color', opacityScale(opacity)).style('border-top-color', opacityScale(opacity));
        }
      });
      var html = table.node().outerHTML;
      if (d.footer !== undefined) {
        html += '<div class=\'footer\'>' + d.footer + '</div>';
      }
      return upgraded_tooltip_sanitize(html);
    };
    var dataSeriesExists = function dataSeriesExists(d) {
      if (d && d.series) {
        if (d.series instanceof Array) {
          return !!d.series.length;
        }
        if (d.series instanceof Object) {
          d.series = [d.series];
          return true;
        }
      }
      return false;
    };
    var validateTooltipData = function validateTooltipData() {
      if (_dataValidator && typeof _dataValidator === 'function') {
        return _dataValidator(data);
      }
      return dataSeriesExists(data);
    };
    var calcGravityOffset = _.throttle(function (pos) {
      var isDarkDialog = tooltip.node().getElementsByClassName('dark-dialog').length;
      var height = isDarkDialog ? tooltip.node().firstChild.clientHeight + upgraded_tooltip_DARK_DIALOG_MARGIN : tooltip.node().offsetHeight;
      var width = isDarkDialog ? tooltip.node().firstChild.clientWidth + upgraded_tooltip_DARK_DIALOG_MARGIN : tooltip.node().offsetWidth;
      var dimensions = {
        height: height,
        width: width,
        clientHeight: document.documentElement.clientHeight,
        clientWidth: document.documentElement.clientWidth
      };
      return calculateGravityOffset(dimensions, pos, gravity, distance);
    }, upgraded_tooltip_THROTTLE_TIME);
    var positionTooltip = function positionTooltip() {
      nv.dom.read(function () {
        var pos = position(),
          gravityOffset = calcGravityOffset(pos),
          left = parseInt(pos.left + gravityOffset.left, 10),
          top = parseInt(pos.top + gravityOffset.top, 10);
        if (hidden) {
          tooltip.interrupt().transition().delay(hideDelay).duration(0).style('opacity', 0);
        } else {
          var old_translate = 'translate(' + lastPosition.left + 'px, ' + lastPosition.top + 'px)';
          var new_translate = 'translate(' + left + 'px, ' + top + 'px)';
          var translateInterpolator = string(old_translate, new_translate);
          var is_hidden = tooltip.style('opacity') < 0.1;
          tooltip.classed({
            'nv-n': gravityOffset.location === upgraded_tooltip_GRAVITY.NORTH,
            'nv-e': gravityOffset.location === upgraded_tooltip_GRAVITY.EAST,
            'nv-s': gravityOffset.location === upgraded_tooltip_GRAVITY.SOUTH,
            'nv-w': gravityOffset.location === upgraded_tooltip_GRAVITY.WEST
          });
          tooltip.interrupt().transition().duration(is_hidden ? 0 : duration).styleTween('transform', function () {
            return translateInterpolator;
          }, 'important').styleTween('-webkit-transform', function () {
            return translateInterpolator;
          }).style('-ms-transform', new_translate).style('opacity', 1);
        }
        lastPosition.left = left;
        lastPosition.top = top;
      });
    };
    function initTooltip() {
      if (!tooltip) {
        var container = chartContainer ? chartContainer : document.body;
        tooltip = src_select(container).select('div.nvtooltip.' + (classes ? classes : 'xy-tooltip'));
        if (tooltip.empty()) {
          tooltip = src_select(container).append('div').attr('class', (less_default()).dqTooltip + ' nvtooltip ' + (classes ? classes : 'xy-tooltip')).attr('id', id);
        } else {
          id = tooltip.attr('id');
        }
        tooltip.style('top', 0).style('left', 0);
        tooltip.style('opacity', 0);
        tooltip.style('position', 'fixed');
        tooltip.selectAll('div, table, td, tr').classed(nvPointerEventsClass, true);
        tooltip.classed(nvPointerEventsClass, true);
      }
    }
    function nvtooltip() {
      if (!enabled) {
        return;
      }
      if (!validateTooltipData(data)) {
        return;
      }
      nv.dom.write(function () {
        initTooltip();
        var newContent = contentGenerator(data);
        if (newContent) {
          tooltip.node().innerHTML = upgraded_tooltip_sanitize(newContent);
        }
        positionTooltip();
      });
      return nvtooltip;
    }
    nvtooltip.nvPointerEventsClass = nvPointerEventsClass;
    nvtooltip.options = nv.utils.optionsFunc.bind(nvtooltip);
    nvtooltip._options = Object.create({}, {
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
        }
      },
      dataValidator: {
        get: function get() {
          return _dataValidator;
        },
        set: function set(_) {
          _dataValidator = _;
        }
      },
      gravity: {
        get: function get() {
          return gravity;
        },
        set: function set(_) {
          gravity = _;
        }
      },
      fallbackGravity: {
        get: function get() {
          return fallbackGravity;
        },
        set: function set(_) {
          fallbackGravity = _;
        }
      },
      distance: {
        get: function get() {
          return distance;
        },
        set: function set(_) {
          distance = _;
        }
      },
      snapDistance: {
        get: function get() {
          return snapDistance;
        },
        set: function set(_) {
          snapDistance = _;
        }
      },
      classes: {
        get: function get() {
          return classes;
        },
        set: function set(_) {
          classes = _;
        }
      },
      chartContainer: {
        get: function get() {
          return chartContainer;
        },
        set: function set(_) {
          chartContainer = _;
        }
      },
      enabled: {
        get: function get() {
          return enabled;
        },
        set: function set(_) {
          enabled = _;
        }
      },
      hideDelay: {
        get: function get() {
          return hideDelay;
        },
        set: function set(_) {
          hideDelay = _;
        }
      },
      contentGenerator: {
        get: function get() {
          return contentGenerator;
        },
        set: function set(_) {
          contentGenerator = _;
        }
      },
      valueFormatter: {
        get: function get() {
          return valueFormatter;
        },
        set: function set(_) {
          valueFormatter = _;
        }
      },
      headerFormatter: {
        get: function get() {
          return headerFormatter;
        },
        set: function set(_) {
          headerFormatter = _;
        }
      },
      keyFormatter: {
        get: function get() {
          return keyFormatter;
        },
        set: function set(_) {
          keyFormatter = _;
        }
      },
      headerEnabled: {
        get: function get() {
          return headerEnabled;
        },
        set: function set(_) {
          headerEnabled = _;
        }
      },
      position: {
        get: function get() {
          return position;
        },
        set: function set(_) {
          position = _;
        }
      },
      calcGravityOffset: {
        get: function get() {
          return calcGravityOffset;
        },
        set: function set(_) {
          calcGravityOffset = _;
        }
      },
      hidden: {
        get: function get() {
          return hidden;
        },
        set: function set(_) {
          if (hidden !== _) {
            hidden = !!_;
            nvtooltip();
          }
        }
      },
      data: {
        get: function get() {
          return data;
        },
        set: function set(_) {
          if (_.point) {
            _.value = _.point.x;
            _.series = _.series || {};
            _.series.value = _.point.y;
            _.series.color = _.point.color || _.series.color;
          }
          data = _;
        }
      },
      node: {
        get: function get() {
          return tooltip.node();
        },
        set: function set() {}
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set() {}
      }
    });
    nv.utils.initOptions(nvtooltip);
    return nvtooltip;
  };
};
;// ./src/js/nv/utils/pattern_service.js

var patternService = function patternService(nv) {
  nv.utils.patternService = {
    getDataFill: function getDataFill(parentNode, dataPoint, defaultColorFill) {
      if (dataPoint.pattern) {
        try {
          var patternId = this._attachPatternToDOM(parentNode, dataPoint.pattern, dataPoint.color);
          return 'url(#' + patternId + ')';
        } catch (error) {
          nv.log(error);
          console.error(error);
          return defaultColorFill;
        }
      } else {
        return defaultColorFill;
      }
    },
    applyPatternToValues: function applyPatternToValues(pattern, values) {
      if (pattern) {
        values.forEach(function (value) {
          value.pattern = pattern;
        });
      }
      return values;
    },
    _attachPatternToDOM: function _attachPatternToDOM(parentNode, patternId, patternColor) {
      if (!this._isValidPattern(patternId)) {
        throw new Error('Invalid pattern defined.');
      }
      if (!parentNode) {
        throw new Error('Top-level defs element not defined.');
      }
      var patternColorId = patternId + '-' + patternColor;
      var patternNode = this._findPatternNode(parentNode, patternColorId);
      if (patternNode === null) {
        patternNode = this._generatePattern(this._patterns[patternId].svg, patternColorId, patternColor);
        parentNode.append(patternNode);
      }
      return patternNode.id;
    },
    _generatePattern: function _generatePattern(patternSvg, patternId, patternColor) {
      var parser = new DOMParser();
      var svgHtml = '<svg ' + 'xmlns=\'http://www.w3.org/2000/svg\' ' + 'width=\'500\' ' + 'height=\'500\'>' + '<defs>' + patternSvg + '</defs>' + '</svg>';
      var doc = parser.parseFromString(svgHtml, 'image/svg+xml');
      var patternNode = doc.documentElement.querySelector('pattern');
      patternNode.setAttribute('pattern-id', patternId);
      patternNode.setAttribute('stroke', patternColor);
      patternNode.setAttribute('id', this._generateId());
      return patternNode;
    },
    _isValidPattern: function _isValidPattern(patternId) {
      return !!this._patterns[patternId];
    },
    _findPatternNode: function _findPatternNode(parentNode, patternColorId) {
      return parentNode.querySelector("[pattern-id=\"".concat(patternColorId, "\"]"));
    },
    _generateId: function _generateId() {
      return 'q_pattern_' + _.uniqueId();
    },
    _patterns: {
      'diagonal-stripe-1': {
        svg: '<pattern ' + 'width=\'3.55\' ' + 'height=\'3.55\' ' + 'stroke-linecap=\'square\' ' + 'stroke-width=\'1.5\' ' + 'patternTransform=\'rotate(45) scale(1.2)\' ' + 'patternUnits=\'userSpaceOnUse\'>' + '<line ' + 'x1=\'0\' ' + 'y1=\'0\' ' + 'x2=\'0\' ' + 'y2=\'10\'>' + '</line>' + '</pattern>'
      },
      empty: {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<rect x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" fill=\"white\" fill-opacity=\"0\"/>\n\t\t\t\t</pattern>"
      },
      'empty-solid': {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<rect x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" fill=\"white\" fill-opacity=\"1\"/>\n\t\t\t\t</pattern>"
      },
      'empty-circle': {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<circle fill=\"white\" fill-opacity=\"1\" cx=\"5\" cy=\"5\" r=\"4\" stroke-opacity=\"1\" stroke-width=\"2\"></circle>\n\t\t\t\t</pattern>"
      },
      'upward-arrow-circle': {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<rect x=\"-50%\" y=\"-50%\" width=\"300%\" height=\"300%\" fill-opacity=\"1\"/>\n\t\t\t\t\t<path stroke-width=\"0\" d=\"M8 7L5 4L2 7L2 5L5 2L8 5L8 7Z\" fill=\"#ffffff\"/>\n\t\t\t\t</pattern>"
      },
      'downward-arrow-circle': {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<rect x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"300%\" fill-opacity=\"1\"/>\n\t\t\t\t\t<path stroke-width=\"0\" d=\"M2 3L5 6L8 3V5L5 8L2 5L2 3Z\" fill=\"#ffffff\"/>\n\t\t\t\t</pattern>"
      },
      'mixed-direction-arrow-circle': {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<rect x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"300%\" fill-opacity=\"1\"/>\n\t\t\t\t\t<path stroke-width=\"0\" d=\"M8 6L5 3L2 6L2 4L5 1L8 4L8 6Z M2 4L5 7L8 4V6L5 9L2 6L2 4Z\" fill=\"#ffffff\"/>\n\t\t\t\t</pattern>"
      },
      'slashedCircle': {
        svg: "<pattern x=\"0\" y=\"0\" width=\"100%\" height=\"100%\">\n\t\t\t\t\t<circle fill=\"white\" fill-opacity=\"1\" cx=\"5\" cy=\"5\" r=\"4\" stoke-opacity=\"1\" stroke-width=\"2\"></circle>\n\t\t\t\t\t<line x1=\"1\" y1=\"5\" x2=\"9\" y2=\"5\" stroke-width=\"2\" transform=\"rotate(-45, 5, 5)\"></line>\n\t\t\t\t</pattern>"
      }
    }
  };
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__(4040);
// EXTERNAL MODULE: external "d3"
var external_d3_ = __webpack_require__(3893);
var external_d3_default = /*#__PURE__*/__webpack_require__.n(external_d3_);
;// ./src/js/utils/dq-locale.js
var dq_locale_locale = {
  decimal: '.',
  thousands: ',',
  grouping: [3],
  currency: ['$', ''],
  dateTime: '%a %b %e %X %Y',
  date: '%m/%d/%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};
var setLocale = function setLocale(currentLocale) {
  if (currentLocale) {
    dq_locale_locale = currentLocale;
  }
};
;// ./src/js/nv/utils/date_axis_tick_formatter.js









function date_axis_tick_formatter_slicedToArray(r, e) { return date_axis_tick_formatter_arrayWithHoles(r) || date_axis_tick_formatter_iterableToArrayLimit(r, e) || date_axis_tick_formatter_unsupportedIterableToArray(r, e) || date_axis_tick_formatter_nonIterableRest(); }
function date_axis_tick_formatter_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function date_axis_tick_formatter_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return date_axis_tick_formatter_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? date_axis_tick_formatter_arrayLikeToArray(r, a) : void 0; } }
function date_axis_tick_formatter_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function date_axis_tick_formatter_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function date_axis_tick_formatter_arrayWithHoles(r) { if (Array.isArray(r)) return r; }


var EN_SHORT_QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
var EN_SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  SIX_MONTH: 'sixMonth',
  YEAR: 'year'
};
var WEEK = PERIODS.WEEK,
  MONTH = PERIODS.MONTH,
  YEAR = PERIODS.YEAR;
var shouldAddYear = function shouldAddYear(date, lastDate) {
  return !lastDate || lastDate.getYear() !== date.getYear();
};
var truth = function truth() {
  return true;
};
var PeriodMap = {
  day: {
    interval: replaceRange((external_d3_default()).time.day),
    textWidth: 64,
    nextPeriod: WEEK,
    steps: [1, 2, 3],
    formatters: [['%b %-e, %Y', shouldAddYear], ['%b %-e', truth]]
  },
  week: {
    interval: (external_d3_default()).time.monday,
    textWidth: 64,
    nextPeriod: MONTH,
    steps: [1, 2, 4],
    formatters: [['%b %-e, %Y', shouldAddYear], ['%b %-e', truth]]
  },
  month: {
    interval: (external_d3_default()).time.month,
    textWidth: 64,
    nextPeriod: YEAR,
    steps: [1, 2, 3, 6],
    formatters: [['%b %Y', shouldAddYear], ['%B', truth]]
  },
  quarter: {
    interval: (external_d3_default()).time.month,
    textWidth: 48,
    nextPeriod: YEAR,
    steps: [3, 6],
    formatters: [[function (date, lastDate) {
      var quarter = Math.floor(date.getMonth() / 3);
      var quarters = dq_locale_locale.shortQuarters || EN_SHORT_QUARTERS;
      return quarters[quarter] + (shouldAddYear(date, lastDate) ? " ".concat(date.getFullYear()) : '');
    }, truth]]
  },
  sixMonth: {
    interval: (external_d3_default()).time.month,
    textWidth: 88,
    nextPeriod: YEAR,
    steps: [6, 12],
    formatters: [[function (date, lastDate) {
      var endDate = external_d3_default().time.month.offset(date, 5);
      var months = dq_locale_locale.shortMonths || EN_SHORT_MONTHS;
      var year = '';
      if (shouldAddYear(date, lastDate) || endDate.getFullYear() !== date.getFullYear()) {
        year = " ".concat(endDate.getFullYear());
      }
      return "".concat(months[date.getMonth()], " - ").concat(months[endDate.getMonth()]).concat(year);
    }, truth]]
  },
  year: {
    interval: (external_d3_default()).time.year,
    textWidth: 40,
    steps: [1],
    formatters: [['%Y', truth]]
  }
};
function replaceRange(interval) {
  var intervalFunc = function intervalFunc() {
    return interval.apply(void 0, arguments);
  };
  ['floor', 'round', 'ceil', 'offset', 'utc'].forEach(function (prop) {
    return intervalFunc[prop] = interval[prop];
  });
  intervalFunc.range = function (minDate, maxDate, step) {
    var time = interval.ceil(minDate);
    var range = [];
    while (time < maxDate) {
      range.push(time);
      time = interval.offset(time, step);
    }
    return range;
  };
  return intervalFunc;
}
function getDateTicksConfiguration(scale, period) {
  var _scale$domain = scale.domain(),
    _scale$domain2 = date_axis_tick_formatter_slicedToArray(_scale$domain, 2),
    minDate = _scale$domain2[0],
    maxDate = _scale$domain2[1];
  var axisWidth = Math.abs(scale.range()[1] - scale.range()[0]);
  var _PeriodMap$period = PeriodMap[period],
    textWidth = _PeriodMap$period.textWidth,
    nextPeriod = _PeriodMap$period.nextPeriod,
    steps = _PeriodMap$period.steps;
  var interval = PeriodMap[period].interval;
  var breakPoints = steps.slice(0);
  var step = breakPoints.shift();
  var dateRange = interval.range(minDate, maxDate, step);
  while (dateRange.length * textWidth > axisWidth) {
    if (!breakPoints.length) {
      if (!nextPeriod) {
        step *= 2;
      } else {
        return getDateTicksConfiguration(scale, nextPeriod);
      }
    } else {
      step = breakPoints.shift();
    }
    dateRange = interval.range(minDate, maxDate, step);
  }
  return {
    interval: interval,
    step: step,
    period: period
  };
}
function getDateAxisTickFormatter(period) {
  var d3Locale = external_d3_default().locale(dq_locale_locale);
  var formatters = PeriodMap[period].formatters;
  var multiFormatList = formatters.map(function (_ref) {
    var _ref2 = date_axis_tick_formatter_slicedToArray(_ref, 2),
      formatter = _ref2[0],
      predicate = _ref2[1];
    if (typeof formatter === 'string') {
      formatter = d3Locale.timeFormat(formatter);
    }
    return [formatter, predicate];
  });
  var lastDate;
  return function (date) {
    var _multiFormatList$find = multiFormatList.find(function (_ref3) {
        var _ref4 = date_axis_tick_formatter_slicedToArray(_ref3, 2),
          predicate = _ref4[1];
        return predicate(date, lastDate);
      }),
      _multiFormatList$find2 = date_axis_tick_formatter_slicedToArray(_multiFormatList$find, 1),
      formatter = _multiFormatList$find2[0];
    var formatted = formatter(date, lastDate);
    lastDate = date;
    return formatted;
  };
}
function getDateAxisConfiguration(scale, startPeriod) {
  var _getDateTicksConfigur = getDateTicksConfiguration(scale, startPeriod),
    interval = _getDateTicksConfigur.interval,
    step = _getDateTicksConfigur.step,
    period = _getDateTicksConfigur.period;
  var formatter = getDateAxisTickFormatter(period);
  return {
    interval: interval,
    step: step,
    formatter: formatter
  };
}
function getDateStringParser(period) {
  var formatter = d3.time.format('%Y-%m-%dT%H:%M:%S');
  var timezoneRegex = /Z|([+-]\d\d:\d\d)$/;
  function dateOrNull(dateString) {
    var date = new Date(dateString);
    return date instanceof Date && !isNaN(date) ? date : null;
  }
  return function (dateString) {
    dateString = dateString.replace(timezoneRegex, '');
    var date = formatter.parse(dateString) || dateOrNull(dateString);
    if (date && PeriodMap[period]) {
      date = PeriodMap[period].interval.floor(date);
    }
    return date;
  };
}
function getDateAxisMargin(period) {
  if (!period || !PeriodMap[period]) {
    return 0;
  }
  return PeriodMap[period].textWidth / 2;
}
function getDatesInRange(dateRange, period) {
  if (!dateRange || !period || !PeriodMap[period]) {
    return null;
  }
  var _PeriodMap$period2 = PeriodMap[period],
    interval = _PeriodMap$period2.interval,
    steps = _PeriodMap$period2.steps;
  var step = steps[0];
  var startDate = dateRange[0];
  var endDate = interval.offset(dateRange[1], step);
  return interval.range(startDate, endDate, step);
}
;// ./src/js/nv/models/axis.js


var axis = function axis(nv) {
  nv.models.axis = function () {
    var axis = d3.svg.axis();
    var scale = d3.scale.linear();
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 75,
      height = 60,
      axisLabelText = null,
      secondaryAxisLabelText = null,
      showMaxMin = true,
      rotateLabels = 0,
      rotateYLabel = true,
      staggerLabels = false,
      isOrdinal = false,
      ticks = null,
      axisLabelDistance = 0,
      secondaryAxisLabelDistance = 0,
      duration = 250,
      dispatch = d3.dispatch('renderEnd'),
      placeLabelAt = null,
      dateAxisGroupBy = null,
      secondaryAxisLabelPadding = 20;
    var tickFormat = function tickFormat(d) {
      return String(d);
    };
    axis.scale(scale).orient('bottom').tickFormat(tickFormat);
    var scale0;
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var wrap = container.selectAll('g.nv-wrap.nv-axis').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-axis');
        wrapEnter.append('g');
        var g = wrap.select('g');
        if (dateAxisGroupBy) {
          var _getDateAxisConfigura = getDateAxisConfiguration(scale, dateAxisGroupBy),
            interval = _getDateAxisConfigura.interval,
            step = _getDateAxisConfigura.step,
            formatter = _getDateAxisConfigura.formatter;
          axis.ticks(interval, step);
          axis.tickFormat(formatter);
        } else {
          if (ticks !== null) {
            axis.ticks(ticks);
          } else if (axis.orient() === 'top' || axis.orient() === 'bottom') {
            axis.ticks(Math.abs(scale.range()[1] - scale.range()[0]) / 100);
          }
        }
        g.watchTransition(renderWatch, 'axis').call(axis);
        g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (!dateAxisGroupBy) {
          scale0 = scale0 || axis.scale();
          var fmt = axis.tickFormat();
          if (fmt === null) {
            fmt = scale0.tickFormat();
          }
        }
        var axisLabel = g.selectAll('text.nv-axislabel').data([axisLabelText || null]);
        axisLabel.exit().remove();
        var secondaryAxisLabel = g.selectAll('text.nv-secondaryaxislabel').data([secondaryAxisLabelText || null]);
        axisLabel.exit().remove();
        var xLabelMargin;
        var axisMaxMin;
        var w;
        switch (axis.orient()) {
          case 'top':
            axisLabel.enter().append('text').attr('class', 'nv-axislabel');
            w = 0;
            if (scale.range().length === 1) {
              w = isOrdinal ? scale.range()[0] * 2 + scale.rangeBand() : 0;
            } else if (scale.range().length === 2) {
              w = isOrdinal ? scale.range()[0] + scale.range()[1] + scale.rangeBand() : scale.range()[1];
            } else if (scale.range().length > 2) {
              w = scale.range()[scale.range().length - 1] + (scale.range()[1] - scale.range()[0]);
            }
            if (placeLabelAt !== null) {
              w = placeLabelAt * 2;
            }
            axisLabel.attr('text-anchor', 'middle').attr('y', 0).attr('x', w / 2);
            if (showMaxMin) {
              axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data(scale.domain());
              axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-x', i === 0 ? 'nv-axisMin-x' : 'nv-axisMax-x'].join(' ');
              }).append('text');
              axisMaxMin.exit().remove();
              axisMaxMin.attr('transform', function (d) {
                return 'translate(' + nv.utils.NaNtoZero(scale(d)) + ',0)';
              }).select('text').attr('dy', '-0.5em').attr('y', -axis.tickPadding()).attr('text-anchor', 'middle').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMin.watchTransition(renderWatch, 'min-max top').attr('transform', function (d, i) {
                return 'translate(' + nv.utils.NaNtoZero(scale.range()[i]) + ',0)';
              });
            }
            break;
          case 'bottom':
            xLabelMargin = height;
            var xTicks = g.selectAll('g').select('text');
            var rotateLabelsRule = '';
            if (rotateLabels % 360) {
              rotateLabelsRule = 'rotate(' + rotateLabels + ' 0, 14)';
              xTicks.attr('transform', rotateLabelsRule).style('text-anchor', 'end');
            } else {
              xTicks.style('text-anchor', 'middle');
              if (staggerLabels) {
                xTicks.attr('transform', function (d, i) {
                  return 'translate(0,' + (i % 2 === 0 ? '0' : '12') + ')';
                });
              } else {
                xTicks.attr('transform', 'translate(0,0)');
              }
            }
            axisLabel.enter().append('text').attr('class', 'nv-axislabel');
            secondaryAxisLabel.enter().append('text').attr('class', 'nv-secondaryaxislabel');
            w = 0;
            if (scale.range().length === 1) {
              w = isOrdinal ? scale.range()[0] * 2 + scale.rangeBand() : 0;
            } else if (scale.range().length === 2) {
              w = isOrdinal ? scale.range()[0] + scale.range()[1] + scale.rangeBand() : scale.range()[1];
            } else if (scale.range().length > 2) {
              w = scale.range()[scale.range().length - 1] + (scale.range()[1] - scale.range()[0]);
            }
            if (placeLabelAt !== null) {
              w = placeLabelAt * 2;
            }
            secondaryAxisLabelDistance = xLabelMargin;
            if (secondaryAxisLabelText) {
              xLabelMargin = xLabelMargin - secondaryAxisLabelPadding;
            }
            axisLabel.attr('text-anchor', 'middle').attr('y', xLabelMargin).attr('x', w / 2);
            secondaryAxisLabel.attr('text-anchor', 'middle').attr('y', secondaryAxisLabelDistance).attr('x', w / 2);
            if (showMaxMin) {
              axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data([scale.domain()[0], scale.domain()[scale.domain().length - 1]]);
              axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-x', i === 0 ? 'nv-axisMin-x' : 'nv-axisMax-x'].join(' ');
              }).append('text');
              axisMaxMin.exit().remove();
              axisMaxMin.attr('transform', function (d) {
                return 'translate(' + nv.utils.NaNtoZero(scale(d) + (isOrdinal ? scale.rangeBand() / 2 : 0)) + ',0)';
              }).select('text').attr('dy', '.71em').attr('y', axis.tickPadding()).attr('transform', rotateLabelsRule).style('text-anchor', rotateLabels ? rotateLabels % 360 > 0 ? 'start' : 'end' : 'middle').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMin.watchTransition(renderWatch, 'min-max bottom').attr('transform', function (d) {
                return 'translate(' + nv.utils.NaNtoZero(scale(d) + (isOrdinal ? scale.rangeBand() / 2 : 0)) + ',0)';
              });
            }
            break;
          case 'right':
            var labelPosition = rotateYLabel ? d3.max(scale.range()) / 2 : axis.tickPadding();
            if (placeLabelAt !== null) {
              labelPosition = placeLabelAt;
            }
            axisLabel.enter().append('text').attr('class', 'nv-axislabel');
            axisLabel.style('text-anchor', rotateYLabel ? 'middle' : 'begin').attr('transform', rotateYLabel ? 'rotate(90)' : '').attr('y', rotateYLabel ? -axisLabelDistance || -Math.max(margin.right, width) + 12 : -10).attr('x', labelPosition);
            if (showMaxMin) {
              axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data(scale.domain());
              axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-y', i === 0 ? 'nv-axisMin-y' : 'nv-axisMax-y'].join(' ');
              }).append('text').style('opacity', 0);
              axisMaxMin.exit().remove();
              axisMaxMin.attr('transform', function (d) {
                return 'translate(0,' + nv.utils.NaNtoZero(scale(d)) + ')';
              }).select('text').attr('dy', '.32em').attr('y', 0).attr('x', axis.tickPadding()).style('text-anchor', 'start').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMin.watchTransition(renderWatch, 'min-max right').attr('transform', function (d, i) {
                return 'translate(0,' + nv.utils.NaNtoZero(scale.range()[i]) + ')';
              }).select('text').style('opacity', 1);
            }
            break;
          case 'left':
            labelPosition = rotateYLabel ? -d3.max(scale.range()) / 2 : -axis.tickPadding();
            if (placeLabelAt !== null) {
              labelPosition = placeLabelAt;
            }
            secondaryAxisLabelDistance = axisLabelDistance;
            if (secondaryAxisLabelText) {
              axisLabelDistance = axisLabelDistance + secondaryAxisLabelPadding;
            }
            axisLabel.enter().append('text').attr('class', 'nv-axislabel');
            axisLabel.style('text-anchor', rotateYLabel ? 'middle' : 'end').attr('transform', rotateYLabel ? 'rotate(-90)' : '').attr('y', rotateYLabel ? -axisLabelDistance || -Math.max(margin.left, width) + 13 : -10).attr('x', labelPosition);
            secondaryAxisLabel.enter().append('text').attr('class', 'nv-secondaryaxislabel');
            secondaryAxisLabel.style('text-anchor', rotateYLabel ? 'middle' : 'end').attr('transform', rotateYLabel ? 'rotate(-90)' : '').attr('y', rotateYLabel ? -secondaryAxisLabelDistance || -Math.max(margin.left, width) + 13 : -10).attr('x', labelPosition);
            if (showMaxMin) {
              axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data(scale.domain());
              axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-y', i === 0 ? 'nv-axisMin-y' : 'nv-axisMax-y'].join(' ');
              }).append('text').style('opacity', 0);
              axisMaxMin.exit().remove();
              axisMaxMin.attr('transform', function (d) {
                return 'translate(0,' + nv.utils.NaNtoZero(scale0(d)) + ')';
              }).select('text').attr('dy', '.32em').attr('y', 0).attr('x', -axis.tickPadding()).attr('text-anchor', 'end').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMin.watchTransition(renderWatch, 'min-max right').attr('transform', function (d, i) {
                return 'translate(0,' + nv.utils.NaNtoZero(scale.range()[i]) + ')';
              }).select('text').style('opacity', 1);
            }
            break;
        }
        axisLabel.text(function (d) {
          return d;
        });
        secondaryAxisLabel.text(function (d) {
          return d;
        });
        if (showMaxMin && (axis.orient() === 'left' || axis.orient() === 'right')) {
          g.selectAll('g').each(function (d) {
            d3.select(this).select('text').attr('opacity', 1);
            if (scale(d) < scale.range()[1] + 10 || scale(d) > scale.range()[0] - 10) {
              if (d > 1e-10 || d < -1e-10) {
                d3.select(this).attr('opacity', 0);
              }
              d3.select(this).select('text').attr('opacity', 0);
            }
          });
          if (scale.domain()[0] === scale.domain()[1] && scale.domain()[0] === 0) {
            wrap.selectAll('g.nv-axisMaxMin').style('opacity', function (d, i) {
              return !i ? 1 : 0;
            });
          }
        }
        if (showMaxMin && (axis.orient() === 'top' || axis.orient() === 'bottom')) {
          var maxMinRange = [];
          wrap.selectAll('g.nv-axisMaxMin').each(function (d, i) {
            try {
              if (i) {
                maxMinRange.push(scale(d) - this.getBoundingClientRect().width - 4);
              } else {
                maxMinRange.push(scale(d) + this.getBoundingClientRect().width + 4);
              }
            } catch (_unused) {
              if (i) {
                maxMinRange.push(scale(d) - 4);
              } else {
                maxMinRange.push(scale(d) + 4);
              }
            }
          });
          g.selectAll('g').each(function (d) {
            if (scale(d) < maxMinRange[0] || scale(d) > maxMinRange[1]) {
              if (d > 1e-10 || d < -1e-10) {
                d3.select(this).remove();
              } else {
                d3.select(this).select('text').remove();
              }
            }
          });
        }
        g.selectAll('.tick').filter(function (d) {
          return !parseFloat(Math.round(d * 100000) / 1000000) && d !== undefined;
        }).classed('zero', true);
        scale0 = scale.copy();
      });
      renderWatch.renderEnd('axis immediate');
      return chart;
    }
    chart.axis = axis;
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      axisLabelDistance: {
        get: function get() {
          return axisLabelDistance;
        },
        set: function set(_) {
          axisLabelDistance = _;
        }
      },
      staggerLabels: {
        get: function get() {
          return staggerLabels;
        },
        set: function set(_) {
          staggerLabels = _;
        }
      },
      rotateLabels: {
        get: function get() {
          return rotateLabels;
        },
        set: function set(_) {
          rotateLabels = _;
        }
      },
      rotateYLabel: {
        get: function get() {
          return rotateYLabel;
        },
        set: function set(_) {
          rotateYLabel = _;
        }
      },
      showMaxMin: {
        get: function get() {
          return showMaxMin;
        },
        set: function set(_) {
          showMaxMin = _;
        }
      },
      axisLabel: {
        get: function get() {
          return axisLabelText;
        },
        set: function set(_) {
          axisLabelText = _;
        }
      },
      secondaryAxisLabel: {
        get: function get() {
          return secondaryAxisLabelText;
        },
        set: function set(_) {
          secondaryAxisLabelText = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      ticks: {
        get: function get() {
          return ticks;
        },
        set: function set(_) {
          ticks = _;
        }
      },
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      placeLabelAt: {
        get: function get() {
          return placeLabelAt;
        },
        set: function set(_) {
          placeLabelAt = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      scale: {
        get: function get() {
          return scale;
        },
        set: function set(_) {
          scale = _;
          axis.scale(scale);
          isOrdinal = typeof scale.rangeBands === 'function';
          nv.utils.inheritOptionsD3(chart, scale, ['domain', 'range', 'rangeBand', 'rangeBands']);
        }
      },
      dateAxisGroupBy: {
        get: function get() {
          return dateAxisGroupBy;
        },
        set: function set(_) {
          dateAxisGroupBy = _;
        }
      },
      tickFormat: {
        get: function get() {
          return tickFormat;
        },
        set: function set(_tickFormat) {
          tickFormat = function tickFormat(d, i) {
            return String(_tickFormat(d, i));
          };
          axis.tickFormat(tickFormat);
        }
      }
    });
    nv.utils.initOptions(chart);
    nv.utils.inheritOptionsD3(chart, axis, ['orient', 'tickValues', 'tickSubdivide', 'tickSize', 'tickPadding']);
    nv.utils.inheritOptionsD3(chart, scale, ['domain', 'range', 'rangeBand', 'rangeBands']);
    return chart;
  };
};
;// ./node_modules/d3-time/src/interval.js
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

;// ./node_modules/d3-time/src/duration.js
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

;// ./node_modules/d3-time/src/utcWeek.js



function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

;// ./node_modules/d3-time/src/utcDay.js



var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ var src_utcDay = (utcDay);
var utcDays = utcDay.range;

;// ./node_modules/d3-time/src/week.js



function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

;// ./node_modules/d3-time/src/day.js



var day = newInterval(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  date => date.getDate() - 1
);

/* harmony default export */ var src_day = (day);
var days = day.range;

;// ./node_modules/d3-time/src/year.js


var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ var src_year = (year);
var years = year.range;

;// ./node_modules/d3-time/src/utcYear.js


var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ var src_utcYear = (utcYear);
var utcYears = utcYear.range;

;// ./node_modules/d3-time-format/src/locale.js


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = src_utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? monday.ceil(week) : monday(week);
          week = src_day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + src_day.count(src_year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(src_year(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday.count(src_year(d), d) + (src_year(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(src_year(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + src_utcDay.count(src_utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(src_utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(src_utcYear(d), d) + (src_utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(src_utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

;// ./node_modules/d3-time-format/src/defaultLocale.js


var src_defaultLocale_locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale_defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale_defaultLocale(definition) {
  src_defaultLocale_locale = formatLocale(definition);
  timeFormat = src_defaultLocale_locale.format;
  timeParse = src_defaultLocale_locale.parse;
  utcFormat = src_defaultLocale_locale.utcFormat;
  utcParse = src_defaultLocale_locale.utcParse;
  return src_defaultLocale_locale;
}

;// ./node_modules/d3-time/src/month.js


var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ var src_month = (month);
var months = month.range;

;// ./src/js/nv/utils/upgraded_date_axis_tick_formatter.js








function upgraded_date_axis_tick_formatter_slicedToArray(r, e) { return upgraded_date_axis_tick_formatter_arrayWithHoles(r) || upgraded_date_axis_tick_formatter_iterableToArrayLimit(r, e) || upgraded_date_axis_tick_formatter_unsupportedIterableToArray(r, e) || upgraded_date_axis_tick_formatter_nonIterableRest(); }
function upgraded_date_axis_tick_formatter_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function upgraded_date_axis_tick_formatter_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return upgraded_date_axis_tick_formatter_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? upgraded_date_axis_tick_formatter_arrayLikeToArray(r, a) : void 0; } }
function upgraded_date_axis_tick_formatter_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function upgraded_date_axis_tick_formatter_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function upgraded_date_axis_tick_formatter_arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var upgraded_date_axis_tick_formatter_EN_SHORT_QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
var upgraded_date_axis_tick_formatter_EN_SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var upgraded_date_axis_tick_formatter_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  SIX_MONTH: 'sixMonth',
  YEAR: 'year'
};
var upgraded_date_axis_tick_formatter_WEEK = upgraded_date_axis_tick_formatter_PERIODS.WEEK,
  upgraded_date_axis_tick_formatter_MONTH = upgraded_date_axis_tick_formatter_PERIODS.MONTH,
  upgraded_date_axis_tick_formatter_YEAR = upgraded_date_axis_tick_formatter_PERIODS.YEAR;
var upgraded_date_axis_tick_formatter_shouldAddYear = function shouldAddYear(date, lastDate) {
  return !lastDate || lastDate.getYear() !== date.getYear();
};
var upgraded_date_axis_tick_formatter_truth = function truth() {
  return true;
};
var upgraded_date_axis_tick_formatter_PeriodMap = {
  day: {
    interval: src_day,
    textWidth: 64,
    nextPeriod: upgraded_date_axis_tick_formatter_WEEK,
    steps: [1, 2, 3],
    formatters: [['%b %-e, %Y', upgraded_date_axis_tick_formatter_shouldAddYear], ['%b %-e', upgraded_date_axis_tick_formatter_truth]]
  },
  week: {
    interval: monday,
    textWidth: 64,
    nextPeriod: upgraded_date_axis_tick_formatter_MONTH,
    steps: [1, 2, 4],
    formatters: [['%b %-e, %Y', upgraded_date_axis_tick_formatter_shouldAddYear], ['%b %-e', upgraded_date_axis_tick_formatter_truth]]
  },
  month: {
    interval: src_month,
    textWidth: 64,
    nextPeriod: upgraded_date_axis_tick_formatter_YEAR,
    steps: [1, 2, 3, 6],
    formatters: [['%b %Y', upgraded_date_axis_tick_formatter_shouldAddYear], ['%B', upgraded_date_axis_tick_formatter_truth]]
  },
  quarter: {
    interval: src_month,
    textWidth: 48,
    nextPeriod: upgraded_date_axis_tick_formatter_YEAR,
    steps: [3, 6],
    formatters: [[function (date, lastDate) {
      var quarter = Math.floor(date.getMonth() / 3);
      var quarters = dq_locale_locale.shortQuarters || upgraded_date_axis_tick_formatter_EN_SHORT_QUARTERS;
      return quarters[quarter] + (upgraded_date_axis_tick_formatter_shouldAddYear(date, lastDate) ? " ".concat(date.getFullYear()) : '');
    }, upgraded_date_axis_tick_formatter_truth]]
  },
  sixMonth: {
    interval: src_month,
    textWidth: 88,
    nextPeriod: upgraded_date_axis_tick_formatter_YEAR,
    steps: [6, 12],
    formatters: [[function (date, lastDate) {
      var endDate = src_month.offset(date, 5);
      var months = dq_locale_locale.shortMonths || upgraded_date_axis_tick_formatter_EN_SHORT_MONTHS;
      var year = '';
      if (upgraded_date_axis_tick_formatter_shouldAddYear(date, lastDate) || endDate.getFullYear() !== date.getFullYear()) {
        year = " ".concat(endDate.getFullYear());
      }
      return "".concat(months[date.getMonth()], " - ").concat(months[endDate.getMonth()]).concat(year);
    }, upgraded_date_axis_tick_formatter_truth]]
  },
  year: {
    interval: src_year,
    textWidth: 40,
    steps: [1],
    formatters: [['%Y', upgraded_date_axis_tick_formatter_truth]]
  }
};
function upgradedGetDateTicksConfiguration(scale, period) {
  var _scale$domain = scale.domain(),
    _scale$domain2 = upgraded_date_axis_tick_formatter_slicedToArray(_scale$domain, 2),
    minDate = _scale$domain2[0],
    maxDate = _scale$domain2[1];
  var axisWidth = Math.abs(scale.range()[1] - scale.range()[0]);
  var _PeriodMap$period = upgraded_date_axis_tick_formatter_PeriodMap[period],
    textWidth = _PeriodMap$period.textWidth,
    nextPeriod = _PeriodMap$period.nextPeriod,
    steps = _PeriodMap$period.steps;
  var interval = upgraded_date_axis_tick_formatter_PeriodMap[period].interval;
  var breakPoints = steps.slice(0);
  var step = breakPoints.shift();
  var dateRange = getDateRange(minDate, maxDate, step, interval, period);
  while (dateRange.length * textWidth > axisWidth) {
    if (!breakPoints.length) {
      if (!nextPeriod) {
        step *= 2;
      } else {
        return upgradedGetDateTicksConfiguration(scale, nextPeriod);
      }
    } else {
      step = breakPoints.shift();
    }
    dateRange = getDateRange(minDate, maxDate, step, interval, period);
  }
  return {
    interval: interval,
    step: step,
    period: period
  };
}
function getDateRange(minDate, maxDate, step, interval) {
  return interval === src_day ? interval.range(minDate, maxDate, step) : interval.every(step).range(minDate, maxDate);
}
function upgradedGetDateAxisTickFormatter(period) {
  var formatters = upgraded_date_axis_tick_formatter_PeriodMap[period].formatters;
  var multiFormatList = formatters.map(function (_ref) {
    var _ref2 = upgraded_date_axis_tick_formatter_slicedToArray(_ref, 2),
      formatter = _ref2[0],
      predicate = _ref2[1];
    if (typeof formatter === 'string') {
      formatter = formatLocale(dq_locale_locale).format(formatter);
    }
    return [formatter, predicate];
  });
  var lastDate;
  return function (date) {
    var _multiFormatList$find = multiFormatList.find(function (_ref3) {
        var _ref4 = upgraded_date_axis_tick_formatter_slicedToArray(_ref3, 2),
          predicate = _ref4[1];
        return predicate(date, lastDate);
      }),
      _multiFormatList$find2 = upgraded_date_axis_tick_formatter_slicedToArray(_multiFormatList$find, 1),
      formatter = _multiFormatList$find2[0];
    var formatted = formatter(date, lastDate);
    lastDate = date;
    return formatted;
  };
}
function upgradedGetDateAxisConfiguration(scale, startPeriod) {
  var _upgradedGetDateTicks = upgradedGetDateTicksConfiguration(scale, startPeriod),
    interval = _upgradedGetDateTicks.interval,
    step = _upgradedGetDateTicks.step,
    period = _upgradedGetDateTicks.period;
  var formatter = upgradedGetDateAxisTickFormatter(period);
  return {
    interval: interval,
    step: step,
    formatter: formatter
  };
}
function upgradedGetDateStringParser(period) {
  var formatter = timeParse('%Y-%m-%dT%H:%M:%S');
  var timezoneRegex = /Z|([+-]\d\d:\d\d)$/;
  function dateOrNull(dateString) {
    var date = new Date(dateString);
    return date instanceof Date && !isNaN(date) ? date : null;
  }
  return function (dateString) {
    dateString = dateString.replace(timezoneRegex, '');
    var date = formatter(dateString) || dateOrNull(dateString);
    if (date && upgraded_date_axis_tick_formatter_PeriodMap[period]) {
      date = upgraded_date_axis_tick_formatter_PeriodMap[period].interval.floor(date);
    }
    return date;
  };
}
function upgradedGetDateAxisMargin(period) {
  if (!period || !upgraded_date_axis_tick_formatter_PeriodMap[period]) {
    return 0;
  }
  return upgraded_date_axis_tick_formatter_PeriodMap[period].textWidth / 2;
}
function upgradedGetDatesInRange(dateRange, period) {
  if (!dateRange || !period || !upgraded_date_axis_tick_formatter_PeriodMap[period]) {
    return null;
  }
  var _PeriodMap$period2 = upgraded_date_axis_tick_formatter_PeriodMap[period],
    interval = _PeriodMap$period2.interval,
    steps = _PeriodMap$period2.steps;
  var step = steps[0];
  var startDate = dateRange[0];
  var endDate = interval.offset(dateRange[1], step);
  return interval.every(step).range(startDate, endDate);
}
;// ./node_modules/d3-axis/src/array.js
var src_array_slice = Array.prototype.slice;

;// ./node_modules/d3-axis/src/identity.js
/* harmony default export */ function d3_axis_src_identity(x) {
  return x;
}

;// ./node_modules/d3-axis/src/axis.js



var axis_top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    axis_epsilon = 1e-6;

function translateX(x) {
  return "translate(" + x + ",0)";
}

function translateY(y) {
  return "translate(0," + y + ")";
}

function axis_number(scale) {
  return d => +scale(d);
}

function center(scale, offset) {
  offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
  if (scale.round()) offset = Math.round(offset);
  return d => +scale(d) + offset;
}

function entering() {
  return !this.__axis;
}

function axis_axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5,
      k = orient === axis_top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === axis_top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : d3_axis_src_identity) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + offset,
        range1 = +range[range.length - 1] + offset,
        position = (scale.bandwidth ? center : axis_number)(scale.copy(), offset),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === axis_top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", axis_epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", axis_epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient === right
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d) + offset); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = src_array_slice.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : src_array_slice.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : src_array_slice.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  axis.offset = function(_) {
    return arguments.length ? (offset = +_, axis) : offset;
  };

  return axis;
}

function axisTop(scale) {
  return axis_axis(axis_top, scale);
}

function axisRight(scale) {
  return axis_axis(right, scale);
}

function axisBottom(scale) {
  return axis_axis(bottom, scale);
}

function axisLeft(scale) {
  return axis_axis(left, scale);
}

;// ./src/js/nv/models/upgraded_axis.js








var upgradedAxis = function upgradedAxis(nv) {
  nv.models.upgradedAxis = function (axisOrientation) {
    var axis = axisBottom();
    switch (axisOrientation) {
      case 'left':
        axis = axisLeft();
        break;
      case 'right':
        axis = axisRight();
        break;
      case 'top':
        axis = axisTop();
    }
    var scale = linear_linear();
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 75,
      height = 60,
      axisLabelText = null,
      secondaryAxisLabelText = null,
      showMaxMin = true,
      rotateLabels = 0,
      rotateYLabel = true,
      staggerLabels = false,
      isOrdinal = false,
      ticks = null,
      axisLabelDistance = 0,
      secondaryAxisLabelDistance = 0,
      duration = 250,
      dispatch = src_dispatch('renderEnd'),
      placeLabelAt = null,
      dateAxisGroupBy = null,
      secondaryAxisLabelPadding = 20;
    var tickFormat = function tickFormat(d) {
      return String(d);
    };
    axis.scale(scale).tickFormat(tickFormat);
    var scale0;
    var renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        var wrap = container.selectAll('g.nv-wrap.nv-axis').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-axis');
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var wrapMerge = wrapEnter.merge(wrap);
        var gMerge = gEnter.merge(g);
        if (dateAxisGroupBy) {
          var _upgradedGetDateAxisC = upgradedGetDateAxisConfiguration(scale, dateAxisGroupBy),
            interval = _upgradedGetDateAxisC.interval,
            step = _upgradedGetDateAxisC.step,
            formatter = _upgradedGetDateAxisC.formatter;
          axis.ticks(interval.every(step));
          axis.tickFormat(formatter);
        } else {
          if (ticks !== null) {
            axis.ticks(ticks);
          } else if (axisOrientation === 'top' || axisOrientation === 'bottom') {
            axis.ticks(Math.abs(scale.range()[1] - scale.range()[0]) / 100);
          }
        }
        gMerge.watchTransition(renderWatch, 'axis').call(axis);
        gMerge.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (!dateAxisGroupBy) {
          scale0 = scale0 || axis.scale();
          var fmt = axis.tickFormat();
          if (fmt === null) {
            fmt = scale0.tickFormat();
          }
        }
        var axisLabel = gMerge.selectAll('text.nv-axislabel').data([axisLabelText || null]);
        axisLabel.exit().remove();
        var axisLabelMergeSelection = axisLabel.enter().append('text').attr('class', 'nv-axislabel').merge(axisLabel);
        var secondaryAxisLabel = gMerge.selectAll('text.nv-secondaryaxislabel').data([secondaryAxisLabelText || null]);
        secondaryAxisLabel.exit().remove();
        var secondaryAxisLabelMergeSelection = secondaryAxisLabel.enter().append('text').attr('class', 'nv-secondaryaxislabel').merge(secondaryAxisLabel);
        var xLabelMargin;
        var axisMaxMin;
        var w;
        switch (axisOrientation) {
          case 'top':
            w = 0;
            if (scale.range().length === 1) {
              w = isOrdinal ? scale.range()[0] * 2 + scale.bandwidth() : 0;
            } else if (scale.range().length === 2) {
              w = isOrdinal ? scale.range()[0] + scale.range()[1] + scale.bandwidth() : scale.range()[1];
            } else if (scale.range().length > 2) {
              w = scale.range()[scale.range().length - 1] + (scale.range()[1] - scale.range()[0]);
            }
            if (placeLabelAt !== null) {
              w = placeLabelAt * 2;
            }
            axisLabelMergeSelection.attr('text-anchor', 'middle').attr('y', 0).attr('x', w / 2);
            if (showMaxMin) {
              axisMaxMin = wrapMerge.selectAll('g.nv-axisMaxMin').data(scale.domain());
              var axisMaxMinTopMergeSelection = axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-x', i === 0 ? 'nv-axisMin-x' : 'nv-axisMax-x'].join(' ');
              }).append('text').merge(axisMaxMin);
              axisMaxMin.exit().remove();
              axisMaxMinTopMergeSelection.attr('transform', function (d) {
                return 'translate(' + nv.upgradedUtils.NaNtoZero(scale(d)) + ',0)';
              }).select('text').attr('dy', '-0.5em').attr('y', -axis.tickPadding()).attr('text-anchor', 'middle').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMinTopMergeSelection.watchTransition(renderWatch, 'min-max top').attr('transform', function (d, i) {
                return 'translate(' + nv.upgradedUtils.NaNtoZero(scale.range()[i]) + ',0)';
              });
            }
            break;
          case 'bottom':
            xLabelMargin = height;
            var xTicks = gMerge.selectAll('g').select('text');
            var rotateLabelsRule = '';
            if (rotateLabels % 360) {
              rotateLabelsRule = 'rotate(' + rotateLabels + ' 0, 14)';
              xTicks.attr('transform', rotateLabelsRule).style('text-anchor', 'end');
            } else {
              xTicks.style('text-anchor', 'middle');
              if (staggerLabels) {
                xTicks.attr('transform', function (d, i) {
                  return 'translate(0,' + (i % 2 === 0 ? '0' : '12') + ')';
                });
              } else {
                xTicks.attr('transform', 'translate(0,0)');
              }
            }
            w = 0;
            if (scale.range().length === 1) {
              w = isOrdinal ? scale.range()[0] * 2 + scale.bandwidth() : 0;
            } else if (scale.range().length === 2) {
              w = isOrdinal ? scale.range()[0] + scale.range()[1] + scale.bandwidth() : scale.range()[1];
            } else if (scale.range().length > 2) {
              w = scale.range()[scale.range().length - 1] + (scale.range()[1] - scale.range()[0]);
            }
            if (placeLabelAt !== null) {
              w = placeLabelAt * 2;
            }
            secondaryAxisLabelDistance = xLabelMargin;
            if (secondaryAxisLabelText) {
              xLabelMargin = xLabelMargin - secondaryAxisLabelPadding;
            }
            axisLabelMergeSelection.attr('text-anchor', 'middle').attr('y', xLabelMargin).attr('x', w / 2);
            secondaryAxisLabelMergeSelection.attr('text-anchor', 'middle').attr('y', secondaryAxisLabelDistance).attr('x', w / 2);
            if (showMaxMin) {
              axisMaxMin = wrapMerge.selectAll('g.nv-axisMaxMin').data([scale.domain()[0], scale.domain()[scale.domain().length - 1]]);
              var axisMaxMinBottomMergeSelection = axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-x', i === 0 ? 'nv-axisMin-x' : 'nv-axisMax-x'].join(' ');
              }).append('text').merge(axisMaxMin);
              axisMaxMin.exit().remove();
              axisMaxMinBottomMergeSelection.attr('transform', function (d) {
                return 'translate(' + nv.upgradedUtils.NaNtoZero(scale(d) + (isOrdinal ? scale.bandwidth() / 2 : 0)) + ',0)';
              }).select('text').attr('dy', '.71em').attr('y', axis.tickPadding()).attr('transform', rotateLabelsRule).style('text-anchor', rotateLabels ? rotateLabels % 360 > 0 ? 'start' : 'end' : 'middle').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMinBottomMergeSelection.watchTransition(renderWatch, 'min-max bottom').attr('transform', function (d) {
                return 'translate(' + nv.upgradedUtils.NaNtoZero(scale(d) + (isOrdinal ? scale.bandwidth() / 2 : 0)) + ',0)';
              });
            }
            break;
          case 'right':
            var labelPosition = rotateYLabel ? max(scale.range()) / 2 : axis.tickPadding();
            if (placeLabelAt !== null) {
              labelPosition = placeLabelAt;
            }
            axisLabelMergeSelection.style('text-anchor', rotateYLabel ? 'middle' : 'begin').attr('transform', rotateYLabel ? 'rotate(90)' : '').attr('y', rotateYLabel ? -axisLabelDistance || -Math.max(margin.right, width) + 12 : -10).attr('x', labelPosition);
            if (showMaxMin) {
              axisMaxMin = wrapMerge.selectAll('g.nv-axisMaxMin').data(scale.domain());
              var axisMaxMinRightMergeSelection = axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-y', i === 0 ? 'nv-axisMin-y' : 'nv-axisMax-y'].join(' ');
              }).append('text').style('opacity', 0).merge(axisMaxMin);
              axisMaxMin.exit().remove();
              axisMaxMinRightMergeSelection.attr('transform', function (d) {
                return 'translate(0,' + nv.upgradedUtils.NaNtoZero(scale(d)) + ')';
              }).select('text').attr('dy', '.32em').attr('y', 0).attr('x', axis.tickPadding()).style('text-anchor', 'start').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMinRightMergeSelection.watchTransition(renderWatch, 'min-max right').attr('transform', function (d, i) {
                return 'translate(0,' + nv.upgradedUtils.NaNtoZero(scale.range()[i]) + ')';
              }).select('text').style('opacity', 1);
            }
            break;
          case 'left':
            labelPosition = rotateYLabel ? -max(scale.range()) / 2 : -axis.tickPadding();
            if (placeLabelAt !== null) {
              labelPosition = placeLabelAt;
            }
            secondaryAxisLabelDistance = axisLabelDistance;
            if (secondaryAxisLabelText) {
              axisLabelDistance = axisLabelDistance + secondaryAxisLabelPadding;
            }
            axisLabelMergeSelection.style('text-anchor', rotateYLabel ? 'middle' : 'end').attr('transform', rotateYLabel ? 'rotate(-90)' : '').attr('y', rotateYLabel ? -axisLabelDistance || -Math.max(margin.left, width) + 13 : -10).attr('x', labelPosition);
            secondaryAxisLabelMergeSelection.style('text-anchor', rotateYLabel ? 'middle' : 'end').attr('transform', rotateYLabel ? 'rotate(-90)' : '').attr('y', rotateYLabel ? -secondaryAxisLabelDistance || -Math.max(margin.left, width) + 13 : -10).attr('x', labelPosition);
            if (showMaxMin) {
              axisMaxMin = wrapMerge.selectAll('g.nv-axisMaxMin').data(scale.domain());
              var axisMaxMinLeftMergeSelection = axisMaxMin.enter().append('g').attr('class', function (d, i) {
                return ['nv-axisMaxMin', 'nv-axisMaxMin-y', i === 0 ? 'nv-axisMin-y' : 'nv-axisMax-y'].join(' ');
              }).append('text').style('opacity', 0).merge(axisMaxMin);
              axisMaxMin.exit().remove();
              axisMaxMinLeftMergeSelection.attr('transform', function (d) {
                return 'translate(0,' + nv.upgradedUtils.NaNtoZero(scale0(d)) + ')';
              }).select('text').attr('dy', '.32em').attr('y', 0).attr('x', -axis.tickPadding()).attr('text-anchor', 'end').text(function (d) {
                var v = fmt(d);
                return ('' + v).match('NaN') ? '' : v;
              });
              axisMaxMinLeftMergeSelection.watchTransition(renderWatch, 'min-max right').attr('transform', function (d, i) {
                return 'translate(0,' + nv.upgradedUtils.NaNtoZero(scale.range()[i]) + ')';
              }).select('text').style('opacity', 1);
            }
            break;
        }
        axisLabelMergeSelection.text(function (d) {
          return d;
        });
        secondaryAxisLabelMergeSelection.text(function (d) {
          return d;
        });
        if (showMaxMin && (axisOrientation === 'left' || axisOrientation === 'right')) {
          gMerge.selectAll('g').each(function (d) {
            src_select(this).select('text').attr('opacity', 1);
            if (scale(d) < scale.range()[1] + 10 || scale(d) > scale.range()[0] - 10) {
              if (d > 1e-10 || d < -1e-10) {
                src_select(this).attr('opacity', 0);
              }
              src_select(this).select('text').attr('opacity', 0);
            }
          });
          if (scale.domain()[0] === scale.domain()[1] && scale.domain()[0] === 0) {
            wrapMerge.selectAll('g.nv-axisMaxMin').style('opacity', function (d, i) {
              return !i ? 1 : 0;
            });
          }
        }
        if (showMaxMin && (axisOrientation === 'top' || axisOrientation === 'bottom')) {
          var maxMinRange = [];
          wrapMerge.selectAll('g.nv-axisMaxMin').each(function (d, i) {
            try {
              if (i) {
                maxMinRange.push(scale(d) - this.getBoundingClientRect().width - 4);
              } else {
                maxMinRange.push(scale(d) + this.getBoundingClientRect().width + 4);
              }
            } catch (_unused) {
              if (i) {
                maxMinRange.push(scale(d) - 4);
              } else {
                maxMinRange.push(scale(d) + 4);
              }
            }
          });
          gMerge.selectAll('g').each(function (d) {
            if (scale(d) < maxMinRange[0] || scale(d) > maxMinRange[1]) {
              if (d > 1e-10 || d < -1e-10) {
                src_select(this).remove();
              } else {
                src_select(this).select('text').remove();
              }
            }
          });
        }
        var axisTicks = gMerge.selectAll('.tick');
        axisTicks.attr('font-size', constants_Constants.FONT_SIZE);
        axisTicks.filter(function (d) {
          return !parseFloat(Math.round(d * 100000) / 1000000) && d !== undefined;
        }).classed('zero', true);
        scale0 = scale.copy();
      });
      renderWatch.renderEnd('axis immediate');
      return chart;
    }
    chart.axis = axis;
    chart.dispatch = dispatch;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      axisLabelDistance: {
        get: function get() {
          return axisLabelDistance;
        },
        set: function set(_) {
          axisLabelDistance = _;
        }
      },
      staggerLabels: {
        get: function get() {
          return staggerLabels;
        },
        set: function set(_) {
          staggerLabels = _;
        }
      },
      rotateLabels: {
        get: function get() {
          return rotateLabels;
        },
        set: function set(_) {
          rotateLabels = _;
        }
      },
      rotateYLabel: {
        get: function get() {
          return rotateYLabel;
        },
        set: function set(_) {
          rotateYLabel = _;
        }
      },
      showMaxMin: {
        get: function get() {
          return showMaxMin;
        },
        set: function set(_) {
          showMaxMin = _;
        }
      },
      axisLabel: {
        get: function get() {
          return axisLabelText;
        },
        set: function set(_) {
          axisLabelText = _;
        }
      },
      secondaryAxisLabel: {
        get: function get() {
          return secondaryAxisLabelText;
        },
        set: function set(_) {
          secondaryAxisLabelText = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      ticks: {
        get: function get() {
          return ticks;
        },
        set: function set(_) {
          ticks = _;
        }
      },
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      placeLabelAt: {
        get: function get() {
          return placeLabelAt;
        },
        set: function set(_) {
          placeLabelAt = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      scale: {
        get: function get() {
          return scale;
        },
        set: function set(_) {
          scale = _;
          axis.scale(scale);
          isOrdinal = typeof scale.bandwidth === 'function';
          nv.upgradedUtils.inheritOptionsD3(chart, scale, ['domain', 'range', 'bandwidth']);
        }
      },
      dateAxisGroupBy: {
        get: function get() {
          return dateAxisGroupBy;
        },
        set: function set(_) {
          dateAxisGroupBy = _;
        }
      },
      tickFormat: {
        get: function get() {
          return tickFormat;
        },
        set: function set(_tickFormat) {
          tickFormat = function tickFormat(d, i) {
            return String(_tickFormat(d, i));
          };
          axis.tickFormat(tickFormat);
        }
      }
    });
    nv.upgradedUtils.initOptions(chart);
    nv.upgradedUtils.inheritOptionsD3(chart, axis, ['orient', 'tickValues', 'tickSubdivide', 'tickSize', 'tickPadding']);
    nv.upgradedUtils.inheritOptionsD3(chart, scale, ['domain', 'range', 'bandwidth']);
    return chart;
  };
};
;// ./src/js/nv/models/boxPlot.js


var boxPlot = function boxPlot(nv) {
  nv.models.boxPlot = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 960,
      height = 500,
      id = Math.floor(Math.random() * 10000),
      xScale = d3.scale.ordinal(),
      yScale = d3.scale.linear(),
      getX = function getX(d) {
        return d.label;
      },
      getQ1 = function getQ1(d) {
        return d.values.Q1;
      },
      getQ2 = function getQ2(d) {
        return d.values.Q2;
      },
      getQ3 = function getQ3(d) {
        return d.values.Q3;
      },
      getWl = function getWl(d) {
        return d.values.whisker_low;
      },
      getWh = function getWh(d) {
        return d.values.whisker_high;
      },
      getColor = function getColor(d) {
        return d.color;
      },
      getOlItems = function getOlItems(d) {
        return d.values.outliers;
      },
      getOlValue = function getOlValue(d) {
        return d;
      },
      getOlLabel = function getOlLabel(d) {
        return d;
      },
      getOlColor = function getOlColor() {
        return nv.utils.defaultColor();
      },
      color = nv.utils.defaultColor(),
      container = null,
      xDomain,
      xRange,
      yDomain,
      yRange,
      dispatch = d3.dispatch('elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd'),
      duration = 250,
      maxBoxWidth = null;
    var xScale0, yScale0;
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = d3.select(this);
        nv.utils.initSVG(container);
        xScale.domain(xDomain || data.map(function (d, i) {
          return getX(d, i);
        })).rangeBands(xRange || [0, availableWidth], 0.1);
        var yData = [];
        if (!yDomain) {
          var values = [],
            yMin,
            yMax;
          data.forEach(function (d) {
            var q1 = getQ1(d),
              q3 = getQ3(d),
              wl = getWl(d),
              wh = getWh(d);
            var olItems = getOlItems(d);
            if (olItems) {
              olItems.forEach(function (e, i) {
                values.push(getOlValue(e, i, undefined));
              });
            }
            if (wl) {
              values.push(wl);
            }
            if (q1) {
              values.push(q1);
            }
            if (q3) {
              values.push(q3);
            }
            if (wh) {
              values.push(wh);
            }
          });
          yMin = d3.min(values);
          yMax = d3.max(values);
          yData = [yMin, yMax];
        }
        yScale.domain(yDomain || yData);
        yScale.range(yRange || [availableHeight, 0]);
        xScale0 = xScale0 || xScale;
        yScale0 = yScale0 || yScale.copy().range([yScale(0), yScale(0)]);
        var wrap = container.selectAll('g.nv-wrap').data([data]);
        wrap.enter().append('g').attr('class', 'nvd3 nv-wrap');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var boxplots = wrap.selectAll('.nv-boxplot').data(function (d) {
          return d;
        });
        var boxEnter = boxplots.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
        boxplots.attr('class', 'nv-boxplot').attr('transform', function (d, i) {
          return 'translate(' + (xScale(getX(d, i)) + xScale.rangeBand() * 0.05) + ', 0)';
        }).classed('hover', function (d) {
          return d.hover;
        });
        boxplots.watchTransition(renderWatch, 'nv-boxplot: boxplots').style('stroke-opacity', 1).style('fill-opacity', 0.75).delay(function (d, i) {
          return i * duration / data.length;
        }).attr('transform', function (d, i) {
          return 'translate(' + (xScale(getX(d, i)) + xScale.rangeBand() * 0.05) + ', 0)';
        });
        boxplots.exit().remove();
        boxEnter.each(function (d) {
          var box = d3.select(this);
          [getWl, getWh].forEach(function (f) {
            if (f(d) !== undefined && f(d) !== null) {
              var key = f === getWl ? 'low' : 'high';
              box.append('line').attr('class', 'nv-boxplot-whisker nv-boxplot-' + key);
              box.append('line').attr('class', 'nv-boxplot-tick nv-boxplot-' + key);
            }
          });
        });
        var box_width = function box_width() {
          return maxBoxWidth === null ? xScale.rangeBand() * 0.9 : Math.min(75, xScale.rangeBand() * 0.9);
        };
        var box_left = function box_left() {
          return xScale.rangeBand() * 0.45 - box_width() / 2;
        };
        var box_right = function box_right() {
          return xScale.rangeBand() * 0.45 + box_width() / 2;
        };
        [getWl, getWh].forEach(function (f) {
          var key = f === getWl ? 'low' : 'high';
          var endpoint = f === getWl ? getQ1 : getQ3;
          boxplots.select('line.nv-boxplot-whisker.nv-boxplot-' + key).watchTransition(renderWatch, 'nv-boxplot: boxplots').attr('x1', xScale.rangeBand() * 0.45).attr('y1', function (d) {
            return yScale(f(d));
          }).attr('x2', xScale.rangeBand() * 0.45).attr('y2', function (d) {
            return yScale(endpoint(d));
          });
          boxplots.select('line.nv-boxplot-tick.nv-boxplot-' + key).watchTransition(renderWatch, 'nv-boxplot: boxplots').attr('x1', box_left).attr('y1', function (d) {
            return yScale(f(d));
          }).attr('x2', box_right).attr('y2', function (d) {
            return yScale(f(d));
          });
        });
        [getWl, getWh].forEach(function (f) {
          var key = f === getWl ? 'low' : 'high';
          boxEnter.selectAll('.nv-boxplot-' + key).on('mouseover', function (d, i, j) {
            d3.select(this).classed('hover', true);
            dispatch.elementMouseover({
              series: {
                key: f(d),
                color: getColor(d) || color(d, j)
              },
              e: d3.event
            });
          }).on('mouseout', function (d, i, j) {
            d3.select(this).classed('hover', false);
            dispatch.elementMouseout({
              series: {
                key: f(d),
                color: getColor(d) || color(d, j)
              },
              e: d3.event
            });
          }).on('mousemove', function () {
            dispatch.elementMousemove({
              e: d3.event
            });
          });
        });
        boxEnter.append('rect').attr('class', 'nv-boxplot-box').on('mouseover', function (d, i) {
          d3.select(this).classed('hover', true);
          dispatch.elementMouseover({
            key: getX(d),
            value: getX(d),
            series: [{
              key: 'Q3',
              value: getQ3(d),
              color: getColor(d) || color(d, i)
            }, {
              key: 'Q2',
              value: getQ2(d),
              color: getColor(d) || color(d, i)
            }, {
              key: 'Q1',
              value: getQ1(d),
              color: getColor(d) || color(d, i)
            }],
            data: d,
            index: i,
            e: d3.event
          });
        }).on('mouseout', function (d, i) {
          d3.select(this).classed('hover', false);
          dispatch.elementMouseout({
            key: getX(d),
            value: getX(d),
            series: [{
              key: 'Q3',
              value: getQ3(d),
              color: getColor(d) || color(d, i)
            }, {
              key: 'Q2',
              value: getQ2(d),
              color: getColor(d) || color(d, i)
            }, {
              key: 'Q1',
              value: getQ1(d),
              color: getColor(d) || color(d, i)
            }],
            data: d,
            index: i,
            e: d3.event
          });
        }).on('mousemove', function () {
          dispatch.elementMousemove({
            e: d3.event
          });
        });
        boxplots.select('rect.nv-boxplot-box').watchTransition(renderWatch, 'nv-boxplot: boxes').attr('y', function (d) {
          return yScale(getQ3(d));
        }).attr('width', box_width).attr('x', box_left).attr('height', function (d) {
          return Math.abs(yScale(getQ3(d)) - yScale(getQ1(d))) || 1;
        }).style('fill', function (d, i) {
          return getColor(d) || color(d, i);
        }).style('stroke', function (d, i) {
          return getColor(d) || color(d, i);
        });
        boxEnter.append('line').attr('class', 'nv-boxplot-median');
        boxplots.select('line.nv-boxplot-median').watchTransition(renderWatch, 'nv-boxplot: boxplots line').attr('x1', box_left).attr('y1', function (d) {
          return yScale(getQ2(d));
        }).attr('x2', box_right).attr('y2', function (d) {
          return yScale(getQ2(d));
        });
        var outliers = boxplots.selectAll('.nv-boxplot-outlier').data(function (d) {
          return getOlItems(d) || [];
        });
        outliers.enter().append('circle').style('z-index', 9000).on('mouseover', function (d, i, j) {
          d3.select(this).classed('hover', true);
          dispatch.elementMouseover({
            series: {
              key: getOlLabel(d, i, j),
              color: getOlColor(d, i, j) || color(d, j)
            },
            e: d3.event
          });
        }).on('mouseout', function (d, i, j) {
          d3.select(this).classed('hover', false);
          dispatch.elementMouseout({
            series: {
              key: getOlLabel(d, i, j),
              color: getOlColor(d, i, j) || color(d, j)
            },
            e: d3.event
          });
        }).on('mousemove', function () {
          dispatch.elementMousemove({
            e: d3.event
          });
        });
        outliers.attr('class', 'nv-boxplot-outlier');
        outliers.watchTransition(renderWatch, 'nv-boxplot: nv-boxplot-outlier').attr('cx', xScale.rangeBand() * 0.45).attr('cy', function (d, i, j) {
          return yScale(getOlValue(d, i, j));
        }).attr('r', '3');
        outliers.exit().remove();
        xScale0 = xScale.copy();
        yScale0 = yScale.copy();
        wrap.selectAll('.nv-boxplot-whisker, .nv-boxplot-tick, .nv-boxplot-outlier').each(function (boxData, boxIndex) {
          d3.select(this).style('stroke', getColor(boxData) || color(boxData, boxIndex));
        });
        wrap.selectAll('.nv-boxplot-outlier').each(function (boxData, boxIndex, outlierIndex) {
          d3.select(this).style('fill', getOlColor(boxData, boxIndex, outlierIndex) || color(boxData, outlierIndex));
        });
      });
      renderWatch.renderEnd('nv-boxplot immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      maxBoxWidth: {
        get: function get() {
          return maxBoxWidth;
        },
        set: function set(_) {
          maxBoxWidth = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
        }
      },
      q1: {
        get: function get() {
          return getQ1;
        },
        set: function set(_) {
          getQ1 = _;
        }
      },
      q2: {
        get: function get() {
          return getQ2;
        },
        set: function set(_) {
          getQ2 = _;
        }
      },
      q3: {
        get: function get() {
          return getQ3;
        },
        set: function set(_) {
          getQ3 = _;
        }
      },
      wl: {
        get: function get() {
          return getWl;
        },
        set: function set(_) {
          getWl = _;
        }
      },
      wh: {
        get: function get() {
          return getWh;
        },
        set: function set(_) {
          getWh = _;
        }
      },
      itemColor: {
        get: function get() {
          return getColor;
        },
        set: function set(_) {
          getColor = _;
        }
      },
      outliers: {
        get: function get() {
          return getOlItems;
        },
        set: function set(_) {
          getOlItems = _;
        }
      },
      outlierValue: {
        get: function get() {
          return getOlValue;
        },
        set: function set(_) {
          getOlValue = _;
        }
      },
      outlierLabel: {
        get: function get() {
          return getOlLabel;
        },
        set: function set(_) {
          getOlLabel = _;
        }
      },
      outlierColor: {
        get: function get() {
          return getOlColor;
        },
        set: function set(_) {
          getOlColor = _;
        }
      },
      xScale: {
        get: function get() {
          return xScale;
        },
        set: function set(_) {
          xScale = _;
        }
      },
      yScale: {
        get: function get() {
          return yScale;
        },
        set: function set(_) {
          yScale = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      y: {
        get: function get() {
          console.warn('BoxPlot \'y\' chart option is deprecated. Please use model overrides instead.');
          return {};
        },
        set: function set() {
          console.warn('BoxPlot \'y\' chart option is deprecated. Please use model overrides instead.');
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/boxPlotChart.js
var boxPlotChart = function boxPlotChart(nv) {
  nv.models.boxPlotChart = function () {
    var boxplot = nv.models.boxPlot(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis();
    var margin = {
        top: 15,
        right: 10,
        bottom: 50,
        left: 60
      },
      width = null,
      height = null,
      color = nv.utils.getColor(),
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      staggerLabels = false,
      tooltip = nv.models.tooltip(),
      x,
      y,
      noData = 'No Data Available.',
      dispatch = d3.dispatch('beforeUpdate', 'renderEnd'),
      duration = 250;
    xAxis.orient('bottom').showMaxMin(false).tickFormat(function (d) {
      return d;
    });
    yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickFormat(d3.format(',.1f'));
    tooltip.duration(0);
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(boxplot);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right;
        var availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
        chart.update = function () {
          dispatch.beforeUpdate();
          container.transition().duration(duration).call(chart);
        };
        chart.container = this;
        if (!data || !data.length) {
          var noDataText = container.selectAll('.nv-noData').data([noData]);
          noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
          noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function (d) {
            return d;
          });
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = boxplot.xScale();
        y = boxplot.yScale().clamp(true);
        var wrap = container.selectAll('g.nv-wrap.nv-boxPlotWithAxes').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-boxPlotWithAxes').append('g');
        var defsEnter = gEnter.append('defs');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis').append('g').attr('class', 'nv-zeroLine').append('line');
        gEnter.append('g').attr('class', 'nv-barsWrap');
        g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        boxplot.width(availableWidth).height(availableHeight);
        var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function (d) {
          return !d.disabled;
        }));
        barsWrap.transition().call(boxplot);
        defsEnter.append('clipPath').attr('id', 'nv-x-label-clip-' + boxplot.id()).append('rect');
        g.select('#nv-x-label-clip-' + boxplot.id() + ' rect').attr('width', x.rangeBand() * (staggerLabels ? 2 : 1)).attr('height', 16).attr('x', -x.rangeBand() / (staggerLabels ? 1 : 2));
        if (showXAxis) {
          xAxis.scale(x).ticks(nv.utils.calcTicksX(availableWidth / 100, data)).tickSize(-availableHeight, 0);
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
          g.select('.nv-x.nv-axis').call(xAxis);
          var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
          if (staggerLabels) {
            xTicks.selectAll('text').attr('transform', function (d, i, j) {
              return 'translate(0,' + (j % 2 === 0 ? '5' : '17') + ')';
            });
          }
        } else {
          g.select('.nv-x.nv-axis').selectAll('.tick.zero,.nv-axislabel').remove();
        }
        if (showYAxis) {
          yAxis.scale(y).ticks(Math.floor(availableHeight / 36)).tickSize(-availableWidth, 0);
          g.select('.nv-y.nv-axis').call(yAxis);
        } else {
          g.select('.nv-y.nv-axis').selectAll('.tick.zero,.nv-axislabel').remove();
        }
        g.select('.nv-zeroLine line').attr('x1', 0).attr('x2', availableWidth).attr('y1', y(0)).attr('y2', y(0));
      });
      renderWatch.renderEnd('nv-boxplot chart immediate');
      return chart;
    }
    boxplot.dispatch.on('elementMouseover.tooltip', function (evt) {
      tooltip.data(evt).hidden(false);
    });
    boxplot.dispatch.on('elementMouseout.tooltip', function (evt) {
      tooltip.data(evt).hidden(true);
    });
    boxplot.dispatch.on('elementMousemove.tooltip', function () {
      tooltip();
    });
    chart.dispatch = dispatch;
    chart.boxplot = boxplot;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      staggerLabels: {
        get: function get() {
          return staggerLabels;
        },
        set: function set(_) {
          staggerLabels = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      tooltipContent: {
        get: function get() {
          return tooltip;
        },
        set: function set(_) {
          tooltip = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          boxplot.duration(duration);
          xAxis.duration(duration);
          yAxis.duration(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          boxplot.color(color);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(_ ? 'right' : 'left');
        }
      }
    });
    nv.utils.inheritOptions(chart, boxplot);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/bullet.js

var bullet = function bullet(nv) {
  nv.models.bullet = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      orient = 'left',
      reverse = false,
      ranges = function ranges(d) {
        return d.ranges;
      },
      markers = function markers(d) {
        return d.markers ? d.markers : [];
      },
      measures = function measures(d) {
        return d.measures;
      },
      rangeLabels = function rangeLabels(d) {
        return d.rangeLabels ? d.rangeLabels : [];
      },
      markerLabels = function markerLabels(d) {
        return d.markerLabels ? d.markerLabels : [];
      },
      measureLabels = function measureLabels(d) {
        return d.measureLabels ? d.measureLabels : [];
      },
      forceX = [0],
      width = 380,
      height = 30,
      container = null,
      tickFormat = null,
      color = nv.utils.getColor(['#1f77b4']),
      dispatch = d3.dispatch('elementMouseover', 'elementMouseout', 'elementMousemove');
    function chart(selection) {
      selection.each(function (d, i) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = d3.select(this);
        nv.utils.initSVG(container);
        var rangez = ranges.call(this, d, i).slice().sort(d3.descending),
          markerz = markers.call(this, d, i).slice().sort(d3.descending),
          measurez = measures.call(this, d, i).slice().sort(d3.descending),
          rangeLabelz = rangeLabels.call(this, d, i).slice(),
          markerLabelz = markerLabels.call(this, d, i).slice(),
          measureLabelz = measureLabels.call(this, d, i).slice();
        var x1 = d3.scale.linear().domain(d3.extent(d3.merge([forceX, rangez]))).range(reverse ? [availableWidth, 0] : [0, availableWidth]);
        this.__chart__ = x1;
        var rangeMin = d3.min(rangez),
          rangeMax = d3.max(rangez),
          rangeAvg = rangez[1];
        var wrap = container.selectAll('g.nv-wrap.nv-bullet').data([d]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-bullet');
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        gEnter.append('rect').attr('class', 'nv-range nv-rangeMax');
        gEnter.append('rect').attr('class', 'nv-range nv-rangeAvg');
        gEnter.append('rect').attr('class', 'nv-range nv-rangeMin');
        gEnter.append('rect').attr('class', 'nv-measure');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var w1 = function w1(d) {
          return Math.abs(x1(d) - x1(0));
        };
        var xp1 = function xp1(d) {
          return d < 0 ? x1(d) : x1(0);
        };
        g.select('rect.nv-rangeMax').attr('height', availableHeight).attr('width', w1(rangeMax > 0 ? rangeMax : rangeMin)).attr('x', xp1(rangeMax > 0 ? rangeMax : rangeMin)).datum(rangeMax > 0 ? rangeMax : rangeMin);
        g.select('rect.nv-rangeAvg').attr('height', availableHeight).attr('width', w1(rangeAvg)).attr('x', xp1(rangeAvg)).datum(rangeAvg);
        g.select('rect.nv-rangeMin').attr('height', availableHeight).attr('width', w1(rangeMax)).attr('x', xp1(rangeMax)).attr('width', w1(rangeMax > 0 ? rangeMin : rangeMax)).attr('x', xp1(rangeMax > 0 ? rangeMin : rangeMax)).datum(rangeMax > 0 ? rangeMin : rangeMax);
        g.select('rect.nv-measure').style('fill', color).attr('height', availableHeight / 3).attr('y', availableHeight / 3).attr('width', measurez < 0 ? x1(0) - x1(measurez[0]) : x1(measurez[0]) - x1(0)).attr('x', xp1(measurez)).on('mouseover', function () {
          dispatch.elementMouseover({
            value: measurez[0],
            label: measureLabelz[0] || 'Current',
            color: d3.select(this).style('fill')
          });
        }).on('mousemove', function () {
          dispatch.elementMousemove({
            value: measurez[0],
            label: measureLabelz[0] || 'Current',
            color: d3.select(this).style('fill')
          });
        }).on('mouseout', function () {
          dispatch.elementMouseout({
            value: measurez[0],
            label: measureLabelz[0] || 'Current',
            color: d3.select(this).style('fill')
          });
        });
        var h3 = availableHeight / 6;
        var markerData = markerz.map(function (marker, index) {
          return {
            value: marker,
            label: markerLabelz[index]
          };
        });
        gEnter.selectAll('path.nv-markerTriangle').data(markerData).enter().append('path').attr('class', 'nv-markerTriangle').attr('d', 'M0,' + h3 + 'L' + h3 + ',' + -h3 + ' ' + -h3 + ',' + -h3 + 'Z').on('mouseover', function (d) {
          dispatch.elementMouseover({
            value: d.value,
            label: d.label || 'Previous',
            color: d3.select(this).style('fill'),
            pos: [x1(d.value), availableHeight / 2]
          });
        }).on('mousemove', function (d) {
          dispatch.elementMousemove({
            value: d.value,
            label: d.label || 'Previous',
            color: d3.select(this).style('fill')
          });
        }).on('mouseout', function (d) {
          dispatch.elementMouseout({
            value: d.value,
            label: d.label || 'Previous',
            color: d3.select(this).style('fill')
          });
        });
        g.selectAll('path.nv-markerTriangle').data(markerData).attr('transform', function (d) {
          return 'translate(' + x1(d.value) + ',' + availableHeight / 2 + ')';
        });
        wrap.selectAll('.nv-range').on('mouseover', function (d, i) {
          var label = rangeLabelz[i] || (!i ? 'Maximum' : i === 1 ? 'Mean' : 'Minimum');
          dispatch.elementMouseover({
            value: d,
            label: label,
            color: d3.select(this).style('fill')
          });
        }).on('mousemove', function () {
          dispatch.elementMousemove({
            value: measurez[0],
            label: measureLabelz[0] || 'Previous',
            color: d3.select(this).style('fill')
          });
        }).on('mouseout', function (d, i) {
          var label = rangeLabelz[i] || (!i ? 'Maximum' : i === 1 ? 'Mean' : 'Minimum');
          dispatch.elementMouseout({
            value: d,
            label: label,
            color: d3.select(this).style('fill')
          });
        });
      });
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      ranges: {
        get: function get() {
          return ranges;
        },
        set: function set(_) {
          ranges = _;
        }
      },
      markers: {
        get: function get() {
          return markers;
        },
        set: function set(_) {
          markers = _;
        }
      },
      measures: {
        get: function get() {
          return measures;
        },
        set: function set(_) {
          measures = _;
        }
      },
      forceX: {
        get: function get() {
          return forceX;
        },
        set: function set(_) {
          forceX = _;
        }
      },
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      tickFormat: {
        get: function get() {
          return tickFormat;
        },
        set: function set(_) {
          tickFormat = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      orient: {
        get: function get() {
          return orient;
        },
        set: function set(_) {
          orient = _;
          reverse = orient === 'right' || orient === 'bottom';
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/bulletChart.js

var bulletChart = function bulletChart(nv) {
  nv.models.bulletChart = function () {
    var bullet = nv.models.bullet();
    var tooltip = nv.models.tooltip();
    var orient = 'left',
      reverse = false,
      margin = {
        top: 5,
        right: 40,
        bottom: 20,
        left: 120
      },
      ranges = function ranges(d) {
        return d.ranges;
      },
      markers = function markers(d) {
        return d.markers ? d.markers : [];
      },
      measures = function measures(d) {
        return d.measures;
      },
      width = null,
      height = 55,
      tickFormat = null,
      ticks = null,
      noData = null,
      dispatch = d3.dispatch();
    tooltip.duration(0).headerEnabled(false);
    function chart(selection) {
      selection.each(function (d, i) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = height - margin.top - margin.bottom;
        chart.update = function () {
          chart(selection);
        };
        chart.container = this;
        if (!d || !ranges.call(this, d, i)) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        var rangez = ranges.call(this, d, i).slice().sort(d3.descending),
          markerz = markers.call(this, d, i).slice().sort(d3.descending),
          measurez = measures.call(this, d, i).slice().sort(d3.descending);
        var wrap = container.selectAll('g.nv-wrap.nv-bulletChart').data([d]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-bulletChart');
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-bulletWrap');
        gEnter.append('g').attr('class', 'nv-titles');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var x1 = d3.scale.linear().domain([0, Math.max(rangez[0], markerz[0] || 0, measurez[0])]).range(reverse ? [availableWidth, 0] : [0, availableWidth]);
        var x0 = this.__chart__ || d3.scale.linear().domain([0, Infinity]).range(x1.range());
        this.__chart__ = x1;
        var title = gEnter.select('.nv-titles').append('g').attr('text-anchor', 'end').attr('transform', 'translate(-6,' + (height - margin.top - margin.bottom) / 2 + ')');
        title.append('text').attr('class', 'nv-title').text(function (d) {
          return d.title;
        });
        title.append('text').attr('class', 'nv-subtitle').attr('dy', '1em').text(function (d) {
          return d.subtitle;
        });
        bullet.width(availableWidth).height(availableHeight);
        var bulletWrap = g.select('.nv-bulletWrap');
        d3.transition(bulletWrap).call(bullet);
        var format = tickFormat || x1.tickFormat(availableWidth / 100);
        var tick = g.selectAll('g.nv-tick').data(x1.ticks(ticks ? ticks : availableWidth / 50), function (d) {
          return this.textContent || format(d);
        });
        var tickEnter = tick.enter().append('g').attr('class', 'nv-tick').attr('transform', function (d) {
          return 'translate(' + x0(d) + ',0)';
        }).style('opacity', 1e-6);
        tickEnter.append('line').attr('y1', availableHeight).attr('y2', availableHeight * 7 / 6);
        tickEnter.append('text').attr('text-anchor', 'middle').attr('dy', '1em').attr('y', availableHeight * 7 / 6).text(format);
        var tickUpdate = d3.transition(tick).attr('transform', function (d) {
          return 'translate(' + x1(d) + ',0)';
        }).style('opacity', 1);
        tickUpdate.select('line').attr('y1', availableHeight).attr('y2', availableHeight * 7 / 6);
        tickUpdate.select('text').attr('y', availableHeight * 7 / 6);
        d3.transition(tick.exit()).attr('transform', function (d) {
          return 'translate(' + x1(d) + ',0)';
        }).style('opacity', 1e-6).remove();
      });
      d3.timer.flush();
      return chart;
    }
    bullet.dispatch.on('elementMouseover.tooltip', function (evt) {
      evt.series = {
        key: evt.label,
        value: evt.value,
        color: evt.color
      };
      tooltip.data(evt).hidden(false);
    });
    bullet.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    bullet.dispatch.on('elementMousemove.tooltip', function () {
      tooltip();
    });
    chart.bullet = bullet;
    chart.dispatch = dispatch;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      ranges: {
        get: function get() {
          return ranges;
        },
        set: function set(_) {
          ranges = _;
        }
      },
      markers: {
        get: function get() {
          return markers;
        },
        set: function set(_) {
          markers = _;
        }
      },
      measures: {
        get: function get() {
          return measures;
        },
        set: function set(_) {
          measures = _;
        }
      },
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      tickFormat: {
        get: function get() {
          return tickFormat;
        },
        set: function set(_) {
          tickFormat = _;
        }
      },
      ticks: {
        get: function get() {
          return ticks;
        },
        set: function set(_) {
          ticks = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      orient: {
        get: function get() {
          return orient;
        },
        set: function set(_) {
          orient = _;
          reverse = orient === 'right' || orient === 'bottom';
        }
      }
    });
    nv.utils.inheritOptions(chart, bullet);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/cumulativeLineChart.js


var cumulativeLineChart = function cumulativeLineChart(nv) {
  nv.models.cumulativeLineChart = function () {
    var lines = nv.models.line(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      controls = nv.models.legend(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 30,
        bottom: 50,
        left: 60
      },
      color = nv.utils.defaultColor(),
      width = null,
      height = null,
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      showControls = true,
      useRegionInteraction = false,
      rescaleY = true,
      x,
      y,
      id = lines.id(),
      state = nv.utils.state(),
      defaultState = null,
      noData = null,
      average = function average(d) {
        return d.average;
      },
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd'),
      duration = 250,
      noErrorCheck = false;
    state.index = 0;
    state.rescaleY = rescaleY;
    xAxis.orient('bottom').tickPadding(7);
    yAxis.orient(rightAlignYAxis ? 'right' : 'left');
    tooltip.valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    }).headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    });
    controls.updateState(false);
    var dx = d3.scale.linear(),
      index = {
        i: 0,
        x: 0
      },
      renderWatch = nv.utils.renderWatch(dispatch, duration);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          }),
          index: index.i,
          rescaleY: rescaleY
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.index !== undefined) {
          index.i = state.index;
        }
        if (state.rescaleY !== undefined) {
          rescaleY = state.rescaleY;
        }
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(lines);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        container.classed('nv-chart-' + id, true);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        var indexDrag = d3.behavior.drag().on('dragstart', dragStart).on('drag', dragMove).on('dragend', dragEnd);
        function dragStart() {
          d3.select(chart.container).style('cursor', 'ew-resize');
        }
        function dragMove() {
          index.x = d3.event.x;
          index.i = Math.round(dx.invert(index.x));
          updateZero();
        }
        function dragEnd() {
          d3.select(chart.container).style('cursor', 'auto');
          state.index = index.i;
          dispatch.stateChange(state);
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = lines.xScale();
        y = lines.yScale();
        if (!rescaleY) {
          var seriesDomains = data.filter(function (series) {
            return !series.disabled;
          }).map(function (series) {
            var initialDomain = d3.extent(series.values, lines.y());
            if (initialDomain[0] < -0.95) {
              initialDomain[0] = -0.95;
            }
            return [(initialDomain[0] - initialDomain[1]) / (1 + initialDomain[1]), (initialDomain[1] - initialDomain[0]) / (1 + initialDomain[0])];
          });
          var completeDomain = [d3.min(seriesDomains, function (d) {
            return d[0];
          }), d3.max(seriesDomains, function (d) {
            return d[1];
          })];
          lines.yDomain(completeDomain);
        } else {
          lines.yDomain(null);
        }
        dx.domain([0, data[0].values.length - 1]).range([0, availableWidth]).clamp(true);
        data = indexify(index.i, data);
        var interactivePointerEvents = useRegionInteraction ? 'none' : 'all';
        var wrap = container.selectAll('g.nv-wrap.nv-cumulativeLine').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-cumulativeLine').append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-interactive');
        gEnter.append('g').attr('class', 'nv-x nv-axis').style('pointer-events', 'none');
        gEnter.append('g').attr('class', 'nv-y nv-axis');
        gEnter.append('g').attr('class', 'nv-background');
        gEnter.append('g').attr('class', 'nv-linesWrap').style('pointer-events', interactivePointerEvents);
        gEnter.append('g').attr('class', 'nv-avgLinesWrap').style('pointer-events', 'none');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        gEnter.append('g').attr('class', 'nv-controlsWrap');
        if (showLegend) {
          legend.width(availableWidth);
          g.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          g.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
        }
        if (showControls) {
          var controlsData = [{
            key: 'Re-scale y-axis',
            disabled: !rescaleY
          }];
          controls.width(140).color(['#444', '#444', '#444']).rightAlign(false).margin({
            top: 5,
            right: 0,
            bottom: 5,
            left: 20
          });
          g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        var tempDisabled = data.filter(function (d) {
          return d.tempDisabled;
        });
        wrap.select('.tempDisabled').remove();
        if (tempDisabled.length) {
          wrap.append('text').attr('class', 'tempDisabled').attr('x', availableWidth / 2).attr('y', '-.71em').style('text-anchor', 'end').text(tempDisabled.map(function (d) {
            return d.key;
          }).join(', ') + ' values cannot be calculated for this time period.');
        }
        gEnter.select('.nv-background').append('rect');
        g.select('.nv-background rect').attr('width', availableWidth).attr('height', availableHeight);
        lines.y(function (d) {
          return d.display.y;
        }).width(availableWidth).height(availableHeight).color(data.map(function (d, i) {
          return d.color || color(d, i);
        }).filter(function (d, i) {
          return !data[i].disabled && !data[i].tempDisabled;
        }));
        var linesWrap = g.select('.nv-linesWrap').datum(data.filter(function (d) {
          return !d.disabled && !d.tempDisabled;
        }));
        linesWrap.call(lines);
        data.forEach(function (d, i) {
          d.seriesIndex = i;
        });
        var avgLineData = data.filter(function (d) {
          return !d.disabled && !!average(d);
        });
        var avgLines = g.select('.nv-avgLinesWrap').selectAll('line').data(avgLineData, function (d) {
          return d.key;
        });
        var getAvgLineY = function getAvgLineY(d) {
          var yVal = y(average(d));
          if (yVal < 0) {
            return 0;
          }
          if (yVal > availableHeight) {
            return availableHeight;
          }
          return yVal;
        };
        avgLines.enter().append('line').style('stroke-width', 2).style('stroke-dasharray', '10,10').style('stroke', function (d) {
          return lines.color()(d, d.seriesIndex);
        }).attr('x1', 0).attr('x2', availableWidth).attr('y1', getAvgLineY).attr('y2', getAvgLineY);
        avgLines.style('stroke-opacity', function (d) {
          var yVal = y(average(d));
          if (yVal < 0 || yVal > availableHeight) {
            return 0;
          }
          return 1;
        }).attr('x1', 0).attr('x2', availableWidth).attr('y1', getAvgLineY).attr('y2', getAvgLineY);
        avgLines.exit().remove();
        var indexLine = linesWrap.selectAll('.nv-indexLine').data([index]);
        indexLine.enter().append('rect').attr('class', 'nv-indexLine').attr('width', 3).attr('x', -2).attr('fill', 'red').attr('fill-opacity', 0.5).style('pointer-events', 'all').call(indexDrag);
        indexLine.attr('transform', function (d) {
          return 'translate(' + dx(d.i) + ',0)';
        }).attr('height', availableHeight);
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.utils.calcTicksX(availableWidth / 70, data)).tickSize(-availableHeight, 0);
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
          g.select('.nv-x.nv-axis').call(xAxis);
        }
        if (showYAxis) {
          yAxis.scale(y)._ticks(nv.utils.calcTicksY(availableHeight / 36, data)).tickSize(-availableWidth, 0);
          g.select('.nv-y.nv-axis').call(yAxis);
        }
        function updateZero() {
          indexLine.data([index]);
          var oldDuration = chart.duration();
          chart.duration(0);
          chart.update();
          chart.duration(oldDuration);
        }
        g.select('.nv-background rect').on('click', function () {
          index.x = d3.mouse(this)[0];
          index.i = Math.round(dx.invert(index.x));
          state.index = index.i;
          dispatch.stateChange(state);
          updateZero();
        });
        lines.dispatch.on('elementClick', function (e) {
          index.i = e.pointIndex;
          index.x = dx(index.i);
          state.index = index.i;
          dispatch.stateChange(state);
          updateZero();
        });
        controls.dispatch.on('legendClick', function (d) {
          d.disabled = !d.disabled;
          rescaleY = !d.disabled;
          state.rescaleY = rescaleY;
          dispatch.stateChange(state);
          chart.update();
        });
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          if (typeof e.index !== 'undefined') {
            index.i = e.index;
            index.x = dx(index.i);
            state.index = e.index;
            indexLine.data([index]);
          }
          if (typeof e.rescaleY !== 'undefined') {
            rescaleY = e.rescaleY;
          }
          chart.update();
        });
      });
      renderWatch.renderEnd('cumulativeLineChart immediate');
      return chart;
    }
    lines.dispatch.on('elementMouseover.tooltip', function (evt) {
      var point = {
        x: chart.x()(evt.point),
        y: chart.y()(evt.point),
        color: evt.point.color
      };
      evt.point = point;
      tooltip.data(evt).hidden(false);
    });
    lines.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    var indexifyYGetter = null;
    function indexify(idx, data) {
      if (!indexifyYGetter) {
        indexifyYGetter = lines.y();
      }
      return data.map(function (line) {
        if (!line.values) {
          return line;
        }
        var indexValue = line.values[idx];
        if (indexValue === null) {
          return line;
        }
        var v = indexifyYGetter(indexValue, idx);
        if (v < -0.95 && !noErrorCheck) {
          line.tempDisabled = true;
          return line;
        }
        line.tempDisabled = false;
        line.values = line.values.map(function (point, pointIndex) {
          point.display = {
            y: (indexifyYGetter(point, pointIndex) - v) / (1 + v)
          };
          return point;
        });
        return line;
      });
    }
    chart.dispatch = dispatch;
    chart.lines = lines;
    chart.legend = legend;
    chart.controls = controls;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.state = state;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      rescaleY: {
        get: function get() {
          return rescaleY;
        },
        set: function set(_) {
          rescaleY = _;
        }
      },
      showControls: {
        get: function get() {
          return showControls;
        },
        set: function set(_) {
          showControls = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      average: {
        get: function get() {
          return average;
        },
        set: function set(_) {
          average = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      noErrorCheck: {
        get: function get() {
          return noErrorCheck;
        },
        set: function set(_) {
          noErrorCheck = _;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          legend.color(color);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(_ ? 'right' : 'left');
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          lines.duration(duration);
          xAxis.duration(duration);
          yAxis.duration(duration);
          renderWatch.reset(duration);
        }
      }
    });
    nv.utils.inheritOptions(chart, lines);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/discreteBar.js


var discreteBar = function discreteBar(nv) {
  nv.models.discreteBar = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 960,
      height = 500,
      id = Math.floor(Math.random() * 10000),
      container,
      x = d3.scale.ordinal(),
      y = d3.scale.linear(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      forceY = [0],
      color = nv.utils.defaultColor(),
      showValues = false,
      valueFormat = d3.format(',.2f'),
      xDomain,
      yDomain,
      xRange,
      yRange,
      dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd'),
      rectClass = 'discreteBar',
      duration = 250;
    var x0, y0;
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = d3.select(this);
        nv.utils.initSVG(container);
        data.forEach(function (series, i) {
          series.values.forEach(function (point) {
            point.series = i;
          });
        });
        var seriesData = xDomain && yDomain ? [] : data.map(function (d) {
          return d.values.map(function (d, i) {
            return {
              x: getX(d, i),
              y: getY(d, i),
              y0: d.y0
            };
          });
        });
        x.domain(xDomain || d3.merge(seriesData).map(function (d) {
          return d.x;
        })).rangeBands(xRange || [0, availableWidth], 0.1);
        y.domain(yDomain || d3.extent(d3.merge(seriesData).map(function (d) {
          return d.y;
        }).concat(forceY)));
        if (showValues) {
          y.range(yRange || [availableHeight - (y.domain()[0] < 0 ? 12 : 0), y.domain()[1] > 0 ? 12 : 0]);
        } else {
          y.range(yRange || [availableHeight, 0]);
        }
        x0 = x0 || x;
        y0 = y0 || y.copy().range([y(0), y(0)]);
        var wrap = container.selectAll('g.nv-wrap.nv-discretebar').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-discretebar');
        var gEnter = wrapEnter.append('g');
        gEnter.append('g').attr('class', 'nv-groups');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function (d) {
          return d;
        }, function (d) {
          return d.key;
        });
        groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
        groups.exit().watchTransition(renderWatch, 'discreteBar: exit groups').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).remove();
        groups.attr('class', function (d, i) {
          return 'nv-group nv-series-' + i;
        }).classed('hover', function (d) {
          return d.hover;
        });
        groups.watchTransition(renderWatch, 'discreteBar: groups').style('stroke-opacity', 1).style('fill-opacity', 0.75);
        var bars = groups.selectAll('g.nv-bar').data(function (d) {
          return d.values;
        });
        bars.exit().remove();
        var barsEnter = bars.enter().append('g').attr('transform', function (d, i) {
          return 'translate(' + (x(getX(d, i)) + x.rangeBand() * 0.05) + ', ' + y(0) + ')';
        }).on('mouseover', function (d, i) {
          d3.select(this).classed('hover', true);
          dispatch.elementMouseover({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
        }).on('mouseout', function (d, i) {
          d3.select(this).classed('hover', false);
          dispatch.elementMouseout({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
        }).on('mousemove', function (d, i) {
          dispatch.elementMousemove({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
        }).on('click', function (d, i) {
          dispatch.elementClick({
            data: d,
            index: i,
            color: d3.select(this).style('fill'),
            event: d3.event,
            element: this
          });
          d3.event.stopPropagation();
        }).on('dblclick', function (d, i) {
          dispatch.elementDblClick({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
          d3.event.stopPropagation();
        });
        barsEnter.append('rect').attr('height', 0).attr('width', x.rangeBand() * 0.9 / data.length);
        if (showValues) {
          barsEnter.append('text').attr('text-anchor', 'middle');
          bars.select('text').text(function (d, i) {
            return valueFormat(getY(d, i));
          }).watchTransition(renderWatch, 'discreteBar: bars text').attr('x', x.rangeBand() * 0.9 / 2).attr('y', function (d, i) {
            return getY(d, i) < 0 ? y(getY(d, i)) - y(0) + 12 : -4;
          });
        } else {
          bars.selectAll('text').remove();
        }
        bars.attr('class', function (d, i) {
          return getY(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive';
        }).style('fill', function (d, i) {
          return d.color || color(d, i);
        }).style('stroke', function (d, i) {
          return d.color || color(d, i);
        }).select('rect').attr('class', rectClass).watchTransition(renderWatch, 'discreteBar: bars rect').attr('width', x.rangeBand() * 0.9 / data.length);
        bars.watchTransition(renderWatch, 'discreteBar: bars').attr('transform', function (d, i) {
          var left = x(getX(d, i)) + x.rangeBand() * 0.05,
            top = getY(d, i) < 0 ? y(0) : y(0) - y(getY(d, i)) < 1 ? y(0) - 1 : y(getY(d, i));
          return 'translate(' + left + ', ' + top + ')';
        }).select('rect').attr('height', function (d, i) {
          return Math.max(Math.abs(y(getY(d, i)) - y(0)), 1);
        });
        x0 = x.copy();
        y0 = y.copy();
      });
      renderWatch.renderEnd('discreteBar immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      forceY: {
        get: function get() {
          return forceY;
        },
        set: function set(_) {
          forceY = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      rectClass: {
        get: function get() {
          return rectClass;
        },
        set: function set(_) {
          rectClass = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/discreteBarChart.js


var discreteBarChart = function discreteBarChart(nv) {
  nv.models.discreteBarChart = function () {
    var discretebar = nv.models.discreteBar(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 15,
        right: 10,
        bottom: 50,
        left: 60
      },
      width = null,
      height = null,
      color = nv.utils.getColor(),
      showLegend = false,
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      staggerLabels = false,
      wrapLabels = false,
      rotateLabels = 0,
      x,
      y,
      noData = null,
      dispatch = d3.dispatch('beforeUpdate', 'renderEnd'),
      duration = 250;
    xAxis.orient('bottom').showMaxMin(false).tickFormat(function (d) {
      return d;
    });
    yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickFormat(d3.format(',.1f'));
    tooltip.duration(0).headerEnabled(false).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    }).keyFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    });
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(discretebar);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          dispatch.beforeUpdate();
          container.transition().duration(duration).call(chart);
        };
        chart.container = this;
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = discretebar.xScale();
        y = discretebar.yScale().clamp(true);
        var wrap = container.selectAll('g.nv-wrap.nv-discreteBarWithAxes').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-discreteBarWithAxes').append('g');
        var defsEnter = gEnter.append('defs');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis').append('g').attr('class', 'nv-zeroLine').append('line');
        gEnter.append('g').attr('class', 'nv-barsWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (showLegend) {
          legend.width(availableWidth);
          g.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          wrap.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
        }
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        discretebar.width(availableWidth).height(availableHeight);
        var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function (d) {
          return !d.disabled;
        }));
        barsWrap.transition().call(discretebar);
        defsEnter.append('clipPath').attr('id', 'nv-x-label-clip-' + discretebar.id()).append('rect');
        g.select('#nv-x-label-clip-' + discretebar.id() + ' rect').attr('width', x.rangeBand() * (staggerLabels ? 2 : 1)).attr('height', 16).attr('x', -x.rangeBand() / (staggerLabels ? 1 : 2));
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.utils.calcTicksX(availableWidth / 100, data)).tickSize(-availableHeight, 0);
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + (y.range()[0] + (discretebar.showValues() && y.domain()[0] < 0 ? 16 : 0)) + ')');
          g.select('.nv-x.nv-axis').call(xAxis);
          var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
          if (staggerLabels) {
            xTicks.selectAll('text').attr('transform', function (d, i, j) {
              return 'translate(0,' + (j % 2 === 0 ? '5' : '17') + ')';
            });
          }
          if (rotateLabels) {
            xTicks.selectAll('.tick text').attr('transform', 'rotate(' + rotateLabels + ' 0,0)').style('text-anchor', rotateLabels > 0 ? 'start' : 'end');
          }
          if (wrapLabels) {
            g.selectAll('.tick text').call(nv.utils.wrapTicks, chart.xAxis.rangeBand());
          }
        }
        if (showYAxis) {
          yAxis.scale(y)._ticks(nv.utils.calcTicksY(availableHeight / 36, data)).tickSize(-availableWidth, 0);
          g.select('.nv-y.nv-axis').call(yAxis);
        }
        g.select('.nv-zeroLine line').attr('x1', 0).attr('x2', rightAlignYAxis ? -availableWidth : availableWidth).attr('y1', y(0)).attr('y2', y(0));
      });
      renderWatch.renderEnd('discreteBar chart immediate');
      return chart;
    }
    discretebar.dispatch.on('elementMouseover.tooltip', function (evt) {
      evt.series = {
        key: chart.x()(evt.data),
        value: chart.y()(evt.data),
        color: evt.color
      };
      tooltip.data(evt).hidden(false);
    });
    discretebar.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    discretebar.dispatch.on('elementMousemove.tooltip', function () {
      tooltip();
    });
    chart.dispatch = dispatch;
    chart.discretebar = discretebar;
    chart.legend = legend;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      staggerLabels: {
        get: function get() {
          return staggerLabels;
        },
        set: function set(_) {
          staggerLabels = _;
        }
      },
      rotateLabels: {
        get: function get() {
          return rotateLabels;
        },
        set: function set(_) {
          rotateLabels = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = !!_;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          discretebar.duration(duration);
          xAxis.duration(duration);
          yAxis.duration(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          discretebar.color(color);
          legend.color(color);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(_ ? 'right' : 'left');
        }
      }
    });
    nv.utils.inheritOptions(chart, discretebar);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/distribution.js


var distribution = function distribution(nv) {
  nv.models.distribution = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 400,
      size = 8,
      axis = 'x',
      getData = function getData(d) {
        return d[axis];
      },
      color = nv.utils.defaultColor(),
      scale = d3.scale.linear(),
      duration = 250,
      dispatch = d3.dispatch('renderEnd');
    var scale0;
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var naxis = axis === 'x' ? 'y' : 'x',
          container = d3.select(this);
        nv.utils.initSVG(container);
        scale0 = scale0 || scale;
        var wrap = container.selectAll('g.nv-distribution').data([data]);
        wrap.enter().append('g').attr('class', 'nvd3 nv-distribution');
        var g = wrap.select('g');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var distWrap = g.selectAll('g.nv-dist').data(function (d) {
          return d;
        }, function (d) {
          return d.key;
        });
        distWrap.enter().append('g');
        distWrap.attr('class', function (d, i) {
          return 'nv-dist nv-series-' + i;
        }).style('stroke', function (d, i) {
          return color(d, i);
        });
        var dist = distWrap.selectAll('line.nv-dist' + axis).data(function (d) {
          return d.values;
        });
        dist.enter().append('line').attr(axis + '1', function (d, i) {
          return scale0(getData(d, i));
        }).attr(axis + '2', function (d, i) {
          return scale0(getData(d, i));
        });
        renderWatch.transition(distWrap.exit().selectAll('line.nv-dist' + axis), 'dist exit').attr(axis + '1', function (d, i) {
          return scale(getData(d, i));
        }).attr(axis + '2', function (d, i) {
          return scale(getData(d, i));
        }).style('stroke-opacity', 0).remove();
        dist.attr('class', function (d, i) {
          return 'nv-dist' + axis + ' nv-dist' + axis + '-' + i;
        }).attr(naxis + '1', 0).attr(naxis + '2', size);
        renderWatch.transition(dist, 'dist').attr(axis + '1', function (d, i) {
          return scale(getData(d, i));
        }).attr(axis + '2', function (d, i) {
          return scale(getData(d, i));
        });
        scale0 = scale.copy();
      });
      renderWatch.renderEnd('distribution immediate');
      return chart;
    }
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart.dispatch = dispatch;
    chart.margin = function (_) {
      if (!arguments.length) {
        return margin;
      }
      margin.top = typeof _.top !== 'undefined' ? _.top : margin.top;
      margin.right = typeof _.right !== 'undefined' ? _.right : margin.right;
      margin.bottom = typeof _.bottom !== 'undefined' ? _.bottom : margin.bottom;
      margin.left = typeof _.left !== 'undefined' ? _.left : margin.left;
      return chart;
    };
    chart.width = function (_) {
      if (!arguments.length) {
        return width;
      }
      width = _;
      return chart;
    };
    chart.axis = function (_) {
      if (!arguments.length) {
        return axis;
      }
      axis = _;
      return chart;
    };
    chart.size = function (_) {
      if (!arguments.length) {
        return size;
      }
      size = _;
      return chart;
    };
    chart.getData = function (_) {
      if (!arguments.length) {
        return getData;
      }
      getData = d3.functor(_);
      return chart;
    };
    chart.scale = function (_) {
      if (!arguments.length) {
        return scale;
      }
      scale = _;
      return chart;
    };
    chart.color = function (_) {
      if (!arguments.length) {
        return color;
      }
      color = nv.utils.getColor(_);
      return chart;
    };
    chart.duration = function (_) {
      if (!arguments.length) {
        return duration;
      }
      duration = _;
      renderWatch.reset(duration);
      return chart;
    };
    return chart;
  };
};
;// ./src/js/nv/utils/ensureDomain.ts






function ensureDomain_slicedToArray(r, e) { return ensureDomain_arrayWithHoles(r) || ensureDomain_iterableToArrayLimit(r, e) || ensureDomain_unsupportedIterableToArray(r, e) || ensureDomain_nonIterableRest(); }
function ensureDomain_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ensureDomain_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return ensureDomain_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ensureDomain_arrayLikeToArray(r, a) : void 0; } }
function ensureDomain_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ensureDomain_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ensureDomain_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ensureDomain(scale) {
  var _scale$domain = scale.domain(),
    _scale$domain2 = ensureDomain_slicedToArray(_scale$domain, 2),
    d1 = _scale$domain2[0],
    d2 = _scale$domain2[1];
  if (d1 === d2) {
    var domain = d1 ? [d1 - d1 * 0.01, d2 + d2 * 0.01] : [-1, 1];
    scale.domain(domain);
  }
}
;// ./src/js/nv/models/historicalBar.js



var historicalBar = function historicalBar(nv) {
  nv.models.historicalBar = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = null,
      height = null,
      id = Math.floor(Math.random() * 10000),
      container = null,
      x = d3.scale.linear(),
      y = d3.scale.linear(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      forceX = [],
      forceY = [0],
      padData = false,
      clipEdge = true,
      color = nv.utils.defaultColor(),
      xDomain,
      yDomain,
      xRange,
      yRange,
      dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd'),
      interactive = true;
    var renderWatch = nv.utils.renderWatch(dispatch, 0);
    function chart(selection) {
      selection.each(function (data) {
        renderWatch.reset();
        container = d3.select(this);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        nv.utils.initSVG(container);
        x.domain(xDomain || d3.extent(data[0].values.map(getX).concat(forceX)));
        if (padData) {
          x.range(xRange || [availableWidth * 0.5 / data[0].values.length, availableWidth * (data[0].values.length - 0.5) / data[0].values.length]);
        } else {
          x.range(xRange || [0, availableWidth]);
        }
        y.domain(yDomain || d3.extent(data[0].values.map(getY).concat(forceY))).range(yRange || [availableHeight, 0]);
        ensureDomain(x);
        ensureDomain(y);
        var wrap = container.selectAll('g.nv-wrap.nv-historicalBar-' + id).data([data[0].values]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-historicalBar-' + id);
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-bars');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        container.on('click', function (d, i) {
          dispatch.chartClick({
            data: d,
            index: i,
            pos: d3.event,
            id: id
          });
        });
        defsEnter.append('clipPath').attr('id', 'nv-chart-clip-path-' + id).append('rect');
        wrap.select('#nv-chart-clip-path-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
        g.attr('clip-path', clipEdge ? 'url(#nv-chart-clip-path-' + id + ')' : '');
        var bars = wrap.select('.nv-bars').selectAll('.nv-bar').data(function (d) {
          return d;
        }, function (d, i) {
          return getX(d, i);
        });
        bars.exit().remove();
        bars.enter().append('rect').attr('x', 0).attr('y', function (d, i) {
          return nv.utils.NaNtoZero(y(Math.max(0, getY(d, i))));
        }).attr('height', function (d, i) {
          return nv.utils.NaNtoZero(Math.abs(y(getY(d, i)) - y(0)));
        }).attr('transform', function (d, i) {
          return 'translate(' + (x(getX(d, i)) - availableWidth / data[0].values.length * 0.45) + ',0)';
        }).on('mouseover', function (d, i) {
          if (!interactive) {
            return;
          }
          d3.select(this).classed('hover', true);
          dispatch.elementMouseover({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
        }).on('mouseout', function (d, i) {
          if (!interactive) {
            return;
          }
          d3.select(this).classed('hover', false);
          dispatch.elementMouseout({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
        }).on('mousemove', function (d, i) {
          if (!interactive) {
            return;
          }
          dispatch.elementMousemove({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
        }).on('click', function (d, i) {
          if (!interactive) {
            return;
          }
          dispatch.elementClick({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
          d3.event.stopPropagation();
        }).on('dblclick', function (d, i) {
          if (!interactive) {
            return;
          }
          dispatch.elementDblClick({
            data: d,
            index: i,
            color: d3.select(this).style('fill')
          });
          d3.event.stopPropagation();
        });
        bars.attr('fill', function (d, i) {
          return color(d, i);
        }).attr('class', function (d, i, j) {
          return (getY(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive') + ' nv-bar-' + j + '-' + i;
        }).watchTransition(renderWatch, 'bars').attr('transform', function (d, i) {
          return 'translate(' + (x(getX(d, i)) - availableWidth / data[0].values.length * 0.45) + ',0)';
        }).attr('width', availableWidth / data[0].values.length * 0.9);
        bars.watchTransition(renderWatch, 'bars').attr('y', function (d, i) {
          var rval = getY(d, i) < 0 ? y(0) : y(0) - y(getY(d, i)) < 1 ? y(0) - 1 : y(getY(d, i));
          return nv.utils.NaNtoZero(rval);
        }).attr('height', function (d, i) {
          return nv.utils.NaNtoZero(Math.max(Math.abs(y(getY(d, i)) - y(0)), 1));
        });
      });
      renderWatch.renderEnd('historicalBar immediate');
      return chart;
    }
    chart.highlightPoint = function (pointIndex, isHoverOver) {
      container.select('.nv-bars .nv-bar-0-' + pointIndex).classed('hover', isHoverOver);
    };
    chart.clearHighlights = function () {
      container.select('.nv-bars .nv-bar.hover').classed('hover', false);
    };
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      forceX: {
        get: function get() {
          return forceX;
        },
        set: function set(_) {
          forceX = _;
        }
      },
      forceY: {
        get: function get() {
          return forceY;
        },
        set: function set(_) {
          forceY = _;
        }
      },
      padData: {
        get: function get() {
          return padData;
        },
        set: function set(_) {
          padData = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      interactive: {
        get: function get() {
          return interactive;
        },
        set: function set(_) {
          interactive = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/historicalBarChart.js


var historicalBarChart = function historicalBarChart(nv) {
  nv.models.historicalBarChart = function (bar_model) {
    var bars = bar_model || nv.models.historicalBar(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 90,
        bottom: 50,
        left: 90
      },
      color = nv.utils.defaultColor(),
      width = null,
      height = null,
      showLegend = false,
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      useRegionInteraction = false,
      x,
      y,
      state = {},
      defaultState = null,
      noData = null,
      dispatch = d3.dispatch('tooltipHide', 'stateChange', 'changeState', 'renderEnd'),
      transitionDuration = 250;
    xAxis.orient('bottom').tickPadding(7);
    yAxis.orient(rightAlignYAxis ? 'right' : 'left');
    tooltip.duration(0).headerEnabled(false).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    }).headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    });
    var renderWatch = nv.utils.renderWatch(dispatch, 0);
    function chart(selection) {
      selection.each(function (data) {
        renderWatch.reset();
        renderWatch.models(bars);
        if (showXAxis) {
          renderWatch.models(xAxis);
        }
        if (showYAxis) {
          renderWatch.models(yAxis);
        }
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          container.transition().duration(transitionDuration).call(chart);
        };
        chart.container = this;
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = bars.xScale();
        y = bars.yScale();
        var wrap = container.selectAll('g.nv-wrap.nv-historicalBarChart').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-historicalBarChart').append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis');
        gEnter.append('g').attr('class', 'nv-barsWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        gEnter.append('g').attr('class', 'nv-interactive');
        if (showLegend) {
          legend.width(availableWidth);
          g.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          wrap.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        bars.width(availableWidth).height(availableHeight).color(data.map(function (d, i) {
          return d.color || color(d, i);
        }).filter(function (d, i) {
          return !data[i].disabled;
        }));
        var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function (d) {
          return !d.disabled;
        }));
        barsWrap.transition().call(bars);
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.utils.calcTicksX(availableWidth / 100, data)).tickSize(-availableHeight, 0);
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
          g.select('.nv-x.nv-axis').transition().call(xAxis);
        }
        if (showYAxis) {
          yAxis.scale(y)._ticks(nv.utils.calcTicksY(availableHeight / 36, data)).tickSize(-availableWidth, 0);
          g.select('.nv-y.nv-axis').transition().call(yAxis);
        }
        legend.dispatch.on('legendClick', function (d) {
          d.disabled = !d.disabled;
          if (!data.filter(function (d) {
            return !d.disabled;
          }).length) {
            data.map(function (d) {
              d.disabled = false;
              wrap.selectAll('.nv-series').classed('disabled', false);
              return d;
            });
          }
          state.disabled = data.map(function (d) {
            return !!d.disabled;
          });
          dispatch.stateChange(state);
          selection.transition().call(chart);
        });
        legend.dispatch.on('legendDblclick', function (d) {
          data.forEach(function (d) {
            d.disabled = true;
          });
          d.disabled = false;
          state.disabled = data.map(function (d) {
            return !!d.disabled;
          });
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          chart.update();
        });
      });
      renderWatch.renderEnd('historicalBarChart immediate');
      return chart;
    }
    bars.dispatch.on('elementMouseover.tooltip', function (evt) {
      evt.series = {
        key: chart.x()(evt.data),
        value: chart.y()(evt.data),
        color: evt.color
      };
      tooltip.data(evt).hidden(false);
    });
    bars.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    bars.dispatch.on('elementMousemove.tooltip', function () {
      tooltip();
    });
    chart.dispatch = dispatch;
    chart.bars = bars;
    chart.legend = legend;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          legend.color(color);
          bars.color(color);
        }
      },
      duration: {
        get: function get() {
          return transitionDuration;
        },
        set: function set(_) {
          transitionDuration = _;
          renderWatch.reset(transitionDuration);
          yAxis.duration(transitionDuration);
          xAxis.duration(transitionDuration);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(_ ? 'right' : 'left');
        }
      }
    });
    nv.utils.inheritOptions(chart, bars);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/legend.js

var legend = function legend(nv) {
  nv.models.legend = function () {
    var margin = {
        top: 5,
        right: 0,
        bottom: 5,
        left: 0
      },
      width = 400,
      height = 20,
      getKey = function getKey(d) {
        return d.key;
      },
      color = nv.utils.getColor(),
      maxKeyLength = 20,
      align = true,
      padding = 32,
      rightAlign = true,
      updateState = true,
      radioButtonMode = false,
      expanded = false,
      dispatch = d3.dispatch('legendClick', 'legendDblclick', 'legendMouseover', 'legendMouseout', 'stateChange'),
      vers = 'classic';
    function chart(selection) {
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          container = d3.select(this);
        nv.utils.initSVG(container);
        var wrap = container.selectAll('g.nv-legend').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-legend').append('g');
        var g = wrap.select('g');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var series = g.selectAll('.nv-series').data(function (d) {
          if (vers !== 'furious') {
            return d;
          }
          return d.filter(function (n) {
            return expanded ? true : !n.disengaged;
          });
        });
        var seriesEnter = series.enter().append('g').attr('class', 'nv-series');
        var seriesShape;
        var versPadding;
        switch (vers) {
          case 'furious':
            versPadding = 23;
            break;
          case 'classic':
            versPadding = 20;
        }
        if (vers === 'classic') {
          seriesEnter.append('circle').style('stroke-width', 2).attr('class', 'nv-legend-symbol').attr('r', 5);
          seriesShape = series.select('circle');
        } else if (vers === 'furious') {
          seriesEnter.append('rect').style('stroke-width', 2).attr('class', 'nv-legend-symbol').attr('rx', 3).attr('ry', 3);
          seriesShape = series.select('.nv-legend-symbol');
          seriesEnter.append('g').attr('class', 'nv-check-box').property('innerHTML', '<path d="M0.5,5 L22.5,5 L22.5,26.5 L0.5,26.5 L0.5,5 Z" class="nv-box"></path><path d="M5.5,12.8618467 L11.9185089,19.2803556 L31,0.198864511" class="nv-check"></path>').attr('transform', 'translate(-10,-8)scale(0.5)');
          var seriesCheckbox = series.select('.nv-check-box');
          seriesCheckbox.each(function (d, i) {
            d3.select(this).selectAll('path').attr('stroke', setTextColor(d, i));
          });
        }
        seriesEnter.append('text').attr('text-anchor', 'start').attr('class', 'nv-legend-text').attr('dy', '.32em').attr('dx', '8');
        var seriesText = series.select('text.nv-legend-text');
        series.on('mouseover', function (d, i) {
          dispatch.legendMouseover(d, i);
        }).on('mouseout', function (d, i) {
          dispatch.legendMouseout(d, i);
        }).on('click', function (d, i) {
          dispatch.legendClick(d, i);
          var data = series.data();
          if (updateState) {
            if (vers === 'classic') {
              if (radioButtonMode) {
                data.forEach(function (series) {
                  series.disabled = true;
                });
                d.disabled = false;
              } else {
                d.disabled = !d.disabled;
                if (data.every(function (series) {
                  return series.disabled;
                })) {
                  data.forEach(function (series) {
                    series.disabled = false;
                  });
                }
              }
            } else if (vers === 'furious') {
              if (expanded) {
                d.disengaged = !d.disengaged;
                d.userDisabled = d.userDisabled === undefined ? !!d.disabled : d.userDisabled;
                d.disabled = d.disengaged || d.userDisabled;
              } else if (!expanded) {
                d.disabled = !d.disabled;
                d.userDisabled = d.disabled;
                var engaged = data.filter(function (d) {
                  return !d.disengaged;
                });
                if (engaged.every(function (series) {
                  return series.userDisabled;
                })) {
                  data.forEach(function (series) {
                    series.disabled = series.userDisabled = false;
                  });
                }
              }
            }
            dispatch.stateChange({
              disabled: data.map(function (d) {
                return !!d.disabled;
              }),
              disengaged: data.map(function (d) {
                return !!d.disengaged;
              })
            });
          }
        }).on('dblclick', function (d, i) {
          if (vers === 'furious' && expanded) {
            return;
          }
          dispatch.legendDblclick(d, i);
          if (updateState) {
            var data = series.data();
            data.forEach(function (series) {
              series.disabled = true;
              if (vers === 'furious') {
                series.userDisabled = series.disabled;
              }
            });
            d.disabled = false;
            if (vers === 'furious') {
              d.userDisabled = d.disabled;
            }
            dispatch.stateChange({
              disabled: data.map(function (d) {
                return !!d.disabled;
              })
            });
          }
        });
        series.classed('nv-disabled', function (d) {
          return d.userDisabled;
        });
        series.exit().remove();
        seriesText.attr('fill', setTextColor).text(getKey);
        var legendWidth = 0;
        if (align) {
          var seriesWidths = [];
          series.each(function (d) {
            var legendText;
            if (getKey(d).length > maxKeyLength) {
              var trimmedKey = getKey(d).substring(0, maxKeyLength);
              legendText = d3.select(this).select('text').text(trimmedKey + '...');
              d3.select(this).append('svg:title').text(getKey(d));
            } else {
              legendText = d3.select(this).select('text');
            }
            var nodeTextLength = nv.utils.getTextWidth(legendText);
            seriesWidths.push(nodeTextLength + padding);
          });
          var seriesPerRow = 0;
          var columnWidths = [];
          legendWidth = 0;
          while (legendWidth < availableWidth && seriesPerRow < seriesWidths.length) {
            columnWidths[seriesPerRow] = seriesWidths[seriesPerRow];
            legendWidth += seriesWidths[seriesPerRow++];
          }
          if (seriesPerRow === 0) {
            seriesPerRow = 1;
          }
          while (legendWidth > availableWidth && seriesPerRow > 1) {
            columnWidths = [];
            seriesPerRow--;
            for (var k = 0; k < seriesWidths.length; k++) {
              if (seriesWidths[k] > (columnWidths[k % seriesPerRow] || 0)) {
                columnWidths[k % seriesPerRow] = seriesWidths[k];
              }
            }
            legendWidth = columnWidths.reduce(function (prev, cur) {
              return prev + cur;
            });
          }
          var xPositions = [];
          for (var i = 0, curX = 0; i < seriesPerRow; i++) {
            xPositions[i] = curX;
            curX += columnWidths[i];
          }
          series.attr('transform', function (d, i) {
            return 'translate(' + xPositions[i % seriesPerRow] + ',' + (5 + Math.floor(i / seriesPerRow) * versPadding) + ')';
          });
          if (rightAlign) {
            g.attr('transform', 'translate(' + (width - margin.right - legendWidth) + ',' + margin.top + ')');
          } else {
            g.attr('transform', 'translate(0' + ',' + margin.top + ')');
          }
          height = margin.top + margin.bottom + Math.ceil(seriesWidths.length / seriesPerRow) * versPadding;
        } else {
          var ypos = 5,
            newxpos = 5,
            maxwidth = 0,
            xpos;
          series.attr('transform', function () {
            var length = d3.select(this).select('text').node().getComputedTextLength() + padding;
            xpos = newxpos;
            if (width < margin.left + margin.right + xpos + length) {
              newxpos = xpos = 5;
              ypos += versPadding;
            }
            newxpos += length;
            if (newxpos > maxwidth) {
              maxwidth = newxpos;
            }
            if (legendWidth < xpos + maxwidth) {
              legendWidth = xpos + maxwidth;
            }
            return 'translate(' + xpos + ',' + ypos + ')';
          });
          g.attr('transform', 'translate(' + (width - margin.right - maxwidth) + ',' + margin.top + ')');
          height = margin.top + margin.bottom + ypos + 15;
        }
        if (vers === 'furious') {
          seriesShape.attr('width', function (d, i) {
            return seriesText[0][i].getComputedTextLength() + 27;
          }).attr('height', 18).attr('y', -9).attr('x', -15);
          gEnter.insert('rect', ':first-child').attr('class', 'nv-legend-bg').attr('fill', '#eee').attr('opacity', 0);
          var seriesBG = g.select('.nv-legend-bg');
          seriesBG.transition().duration(300).attr('x', -versPadding).attr('width', legendWidth + versPadding - 12).attr('height', height + 10).attr('y', -margin.top - 10).attr('opacity', expanded ? 1 : 0);
        }
        seriesShape.style('fill', setBGColor).style('fill-opacity', setBGOpacity).style('stroke', setBGColor);
      });
      function setTextColor(d, i) {
        if (vers !== 'furious') {
          return '#000';
        }
        if (expanded) {
          return d.disengaged ? '#000' : '#fff';
        } else if (!expanded) {
          if (!d.color) {
            d.color = color(d, i);
          }
          return d.disabled ? d.color : '#fff';
        }
      }
      function setBGColor(d, i) {
        if (expanded && vers === 'furious') {
          return d.disengaged ? '#eee' : d.color || color(d, i);
        } else {
          return d.color || color(d, i);
        }
      }
      function setBGOpacity(d) {
        if (expanded && vers === 'furious') {
          return 1;
        } else {
          return d.disabled ? 0 : 1;
        }
      }
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      key: {
        get: function get() {
          return getKey;
        },
        set: function set(_) {
          getKey = _;
        }
      },
      align: {
        get: function get() {
          return align;
        },
        set: function set(_) {
          align = _;
        }
      },
      maxKeyLength: {
        get: function get() {
          return maxKeyLength;
        },
        set: function set(_) {
          maxKeyLength = _;
        }
      },
      rightAlign: {
        get: function get() {
          return rightAlign;
        },
        set: function set(_) {
          rightAlign = _;
        }
      },
      padding: {
        get: function get() {
          return padding;
        },
        set: function set(_) {
          padding = _;
        }
      },
      updateState: {
        get: function get() {
          return updateState;
        },
        set: function set(_) {
          updateState = _;
        }
      },
      radioButtonMode: {
        get: function get() {
          return radioButtonMode;
        },
        set: function set(_) {
          radioButtonMode = _;
        }
      },
      expanded: {
        get: function get() {
          return expanded;
        },
        set: function set(_) {
          expanded = _;
        }
      },
      vers: {
        get: function get() {
          return vers;
        },
        set: function set(_) {
          vers = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/upgraded_legend.js



var upgradedLegend = function upgradedLegend(nv) {
  nv.models.upgradedLegend = function () {
    var margin = {
        top: 5,
        right: 0,
        bottom: 5,
        left: 0
      },
      width = 400,
      height = 20,
      getKey = function getKey(d) {
        return d.key;
      },
      color = nv.utils.getColor(),
      maxKeyLength = 20,
      align = true,
      padding = 32,
      rightAlign = true,
      updateState = true,
      radioButtonMode = false,
      expanded = false,
      dispatch = src_dispatch('legendClick', 'legendDblclick', 'legendMouseover', 'legendMouseout', 'stateChange'),
      vers = 'classic';
    function chart(selection) {
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          container = src_select(this);
        nv.utils.initSVG(container);
        var wrap = container.selectAll('g.nv-legend').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-legend');
        var wrapMergeSelection = wrapEnter.merge(wrap);
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var gMergeSelection = gEnter.merge(g);
        wrapMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var series = gMergeSelection.selectAll('.nv-series').data(function (d) {
          if (vers !== 'furious') {
            return d;
          }
          return d.filter(function (n) {
            return expanded ? true : !n.disengaged;
          });
        });
        var seriesEnter = series.enter().append('g').attr('class', 'nv-series');
        var seriesMergeSelection = seriesEnter.merge(series);
        var seriesShape;
        var versPadding;
        switch (vers) {
          case 'furious':
            versPadding = 23;
            break;
          case 'classic':
            versPadding = 20;
        }
        if (vers === 'classic') {
          seriesEnter.append('circle').style('stroke-width', 2).attr('class', 'nv-legend-symbol').attr('r', 5);
          seriesShape = seriesMergeSelection.select('circle');
        } else if (vers === 'furious') {
          seriesEnter.append('rect').style('stroke-width', 2).attr('class', 'nv-legend-symbol').attr('rx', 3).attr('ry', 3);
          seriesShape = seriesMergeSelection.select('.nv-legend-symbol');
          seriesEnter.append('g').attr('class', 'nv-check-box').property('innerHTML', '<path d="M0.5,5 L22.5,5 L22.5,26.5 L0.5,26.5 L0.5,5 Z" class="nv-box"></path><path d="M5.5,12.8618467 L11.9185089,19.2803556 L31,0.198864511" class="nv-check"></path>').attr('transform', 'translate(-10,-8)scale(0.5)');
          var seriesCheckbox = seriesMergeSelection.select('.nv-check-box');
          seriesCheckbox.each(function (d, i) {
            src_select(this).selectAll('path').attr('stroke', setTextColor(d, i));
          });
        }
        seriesEnter.append('text').attr('text-anchor', 'start').attr('class', 'nv-legend-text').attr('dy', '.32em').attr('dx', '8');
        var seriesText = seriesMergeSelection.select('text.nv-legend-text');
        seriesMergeSelection.on('mouseover', function (d, i) {
          dispatch.call('legendMouseover', this, d, i);
        }).on('mouseout', function (d, i) {
          dispatch.call('legendMouseout', this, d, i);
        }).on('click', function (d, i) {
          dispatch.call('legendClick', this, d, i);
          var data = seriesMergeSelection.data();
          if (updateState) {
            if (vers === 'classic') {
              if (radioButtonMode) {
                data.forEach(function (series) {
                  series.disabled = true;
                });
                d.disabled = false;
              } else {
                d.disabled = !d.disabled;
                if (data.every(function (series) {
                  return series.disabled;
                })) {
                  data.forEach(function (series) {
                    series.disabled = false;
                  });
                }
              }
            } else if (vers === 'furious') {
              if (expanded) {
                d.disengaged = !d.disengaged;
                d.userDisabled = d.userDisabled === undefined ? !!d.disabled : d.userDisabled;
                d.disabled = d.disengaged || d.userDisabled;
              } else if (!expanded) {
                d.disabled = !d.disabled;
                d.userDisabled = d.disabled;
                var engaged = data.filter(function (d) {
                  return !d.disengaged;
                });
                if (engaged.every(function (series) {
                  return series.userDisabled;
                })) {
                  data.forEach(function (series) {
                    series.disabled = series.userDisabled = false;
                  });
                }
              }
            }
            dispatch.call('stateChange', this, {
              disabled: data.map(function (d) {
                return !!d.disabled;
              }),
              disengaged: data.map(function (d) {
                return !!d.disengaged;
              })
            });
          }
        }).on('dblclick', function (d, i) {
          if (vers === 'furious' && expanded) {
            return;
          }
          dispatch.call('legendDblclick', this, d, i);
          if (updateState) {
            var data = seriesMergeSelection.data();
            data.forEach(function (series) {
              series.disabled = true;
              if (vers === 'furious') {
                series.userDisabled = series.disabled;
              }
            });
            d.disabled = false;
            if (vers === 'furious') {
              d.userDisabled = d.disabled;
            }
            dispatch.call('stateChange', this, {
              disabled: data.map(function (d) {
                return !!d.disabled;
              })
            });
          }
        });
        seriesMergeSelection.classed('nv-disabled', function (d) {
          return d.userDisabled;
        });
        series.exit().remove();
        seriesText.attr('fill', setTextColor).text(getKey);
        var legendWidth = 0;
        if (align) {
          var seriesWidths = [];
          seriesMergeSelection.each(function (d) {
            var legendText;
            if (getKey(d).length > maxKeyLength) {
              var trimmedKey = getKey(d).substring(0, maxKeyLength);
              legendText = src_select(this).select('text').text(trimmedKey + '...');
              src_select(this).append('svg:title').text(getKey(d));
            } else {
              legendText = src_select(this).select('text');
            }
            var nodeTextLength = nv.utils.getTextWidth(legendText);
            seriesWidths.push(nodeTextLength + padding);
          });
          var seriesPerRow = 0;
          var columnWidths = [];
          legendWidth = 0;
          while (legendWidth < availableWidth && seriesPerRow < seriesWidths.length) {
            columnWidths[seriesPerRow] = seriesWidths[seriesPerRow];
            legendWidth += seriesWidths[seriesPerRow++];
          }
          if (seriesPerRow === 0) {
            seriesPerRow = 1;
          }
          while (legendWidth > availableWidth && seriesPerRow > 1) {
            columnWidths = [];
            seriesPerRow--;
            for (var k = 0; k < seriesWidths.length; k++) {
              if (seriesWidths[k] > (columnWidths[k % seriesPerRow] || 0)) {
                columnWidths[k % seriesPerRow] = seriesWidths[k];
              }
            }
            legendWidth = columnWidths.reduce(function (prev, cur) {
              return prev + cur;
            });
          }
          var xPositions = [];
          for (var i = 0, curX = 0; i < seriesPerRow; i++) {
            xPositions[i] = curX;
            curX += columnWidths[i];
          }
          seriesMergeSelection.attr('transform', function (d, i) {
            return 'translate(' + xPositions[i % seriesPerRow] + ',' + (5 + Math.floor(i / seriesPerRow) * versPadding) + ')';
          });
          if (rightAlign) {
            gMergeSelection.attr('transform', 'translate(' + (width - margin.right - legendWidth) + ',' + margin.top + ')');
          } else {
            gMergeSelection.attr('transform', 'translate(0' + ',' + margin.top + ')');
          }
          height = margin.top + margin.bottom + Math.ceil(seriesWidths.length / seriesPerRow) * versPadding;
        } else {
          var ypos = 5,
            newxpos = 5,
            maxwidth = 0,
            xpos;
          seriesMergeSelection.attr('transform', function () {
            var length = src_select(this).select('text').node().getComputedTextLength() + padding;
            xpos = newxpos;
            if (width < margin.left + margin.right + xpos + length) {
              newxpos = xpos = 5;
              ypos += versPadding;
            }
            newxpos += length;
            if (newxpos > maxwidth) {
              maxwidth = newxpos;
            }
            if (legendWidth < xpos + maxwidth) {
              legendWidth = xpos + maxwidth;
            }
            return 'translate(' + xpos + ',' + ypos + ')';
          });
          gMergeSelection.attr('transform', 'translate(' + (width - margin.right - maxwidth) + ',' + margin.top + ')');
          height = margin.top + margin.bottom + ypos + 15;
        }
        if (vers === 'furious') {
          seriesShape.attr('width', function (d, i) {
            return seriesText[0][i].getComputedTextLength() + 27;
          }).attr('height', 18).attr('y', -9).attr('x', -15);
          wrapMergeSelection.insert('rect', ':first-child').attr('class', 'nv-legend-bg').attr('fill', '#eee').attr('opacity', 0);
          var seriesBG = gMergeSelection.select('.nv-legend-bg');
          seriesBG.transition().duration(300).attr('x', -versPadding).attr('width', legendWidth + versPadding - 12).attr('height', height + 10).attr('y', -margin.top - 10).attr('opacity', expanded ? 1 : 0);
        }
        seriesShape.style('fill', setBGColor).style('fill-opacity', setBGOpacity).style('stroke', setBGColor);
      });
      function setTextColor(d, i) {
        if (vers !== 'furious') {
          return '#000';
        }
        if (expanded) {
          return d.disengaged ? '#000' : '#fff';
        } else if (!expanded) {
          if (!d.color) {
            d.color = color(d, i);
          }
          return d.disabled ? d.color : '#fff';
        }
      }
      function setBGColor(d, i) {
        if (expanded && vers === 'furious') {
          return d.disengaged ? '#eee' : d.color || color(d, i);
        } else {
          return d.color || color(d, i);
        }
      }
      function setBGOpacity(d) {
        if (expanded && vers === 'furious') {
          return 1;
        } else {
          return d.disabled ? 0 : 1;
        }
      }
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      key: {
        get: function get() {
          return getKey;
        },
        set: function set(_) {
          getKey = _;
        }
      },
      align: {
        get: function get() {
          return align;
        },
        set: function set(_) {
          align = _;
        }
      },
      maxKeyLength: {
        get: function get() {
          return maxKeyLength;
        },
        set: function set(_) {
          maxKeyLength = _;
        }
      },
      rightAlign: {
        get: function get() {
          return rightAlign;
        },
        set: function set(_) {
          rightAlign = _;
        }
      },
      padding: {
        get: function get() {
          return padding;
        },
        set: function set(_) {
          padding = _;
        }
      },
      updateState: {
        get: function get() {
          return updateState;
        },
        set: function set(_) {
          updateState = _;
        }
      },
      radioButtonMode: {
        get: function get() {
          return radioButtonMode;
        },
        set: function set(_) {
          radioButtonMode = _;
        }
      },
      expanded: {
        get: function get() {
          return expanded;
        },
        set: function set(_) {
          expanded = _;
        }
      },
      vers: {
        get: function get() {
          return vers;
        },
        set: function set(_) {
          vers = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.fixed.js
var es6_string_fixed = __webpack_require__(7083);
;// ./node_modules/d3-force/src/lcg.js
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const lcg_a = 1664525;
const lcg_c = 1013904223;
const m = 4294967296; // 2^32

/* harmony default export */ function lcg() {
  let s = 1;
  return () => (s = (lcg_a * s + lcg_c) % m) / m;
}

;// ./node_modules/d3-force/src/simulation.js




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ function simulation(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = new Map(),
      stepper = timer(step),
      event = src_dispatch("tick", "end"),
      random = lcg();

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick(iterations) {
    var i, n = nodes.length, node;

    if (iterations === undefined) iterations = 1;

    for (var k = 0; k < iterations; ++k) {
      alpha += (alphaTarget - alpha) * alphaDecay;

      forces.forEach(function(force) {
        force(alpha);
      });

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.fx == null) node.x += node.vx *= velocityDecay;
        else node.x = node.fx, node.vx = 0;
        if (node.fy == null) node.y += node.vy *= velocityDecay;
        else node.y = node.fy, node.vy = 0;
      }
    }

    return simulation;
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (node.fx != null) node.x = node.fx;
      if (node.fy != null) node.y = node.fy;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes, random);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    randomSource: function(_) {
      return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.delete(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
}

;// ./node_modules/d3-force/src/constant.js
/* harmony default export */ function d3_force_src_constant(x) {
  return function() {
    return x;
  };
}

;// ./node_modules/d3-force/src/jiggle.js
/* harmony default export */ function jiggle(random) {
  return (random() - 0.5) * 1e-6;
}

;// ./node_modules/d3-force/src/link.js



function index(d) {
  return d.index;
}

function link_find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("node not found: " + nodeId);
  return node;
}

/* harmony default export */ function src_link(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = d3_force_src_constant(30),
      distances,
      nodes,
      count,
      bias,
      random,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle(random);
        y = target.y + target.vy - source.y - source.vy || jiggle(random);
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = new Map(nodes.map((d, i) => [id(d, i, nodes), d])),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = link_find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = link_find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : d3_force_src_constant(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : d3_force_src_constant(+_), initializeDistance(), force) : distance;
  };

  return force;
}

;// ./node_modules/d3-quadtree/src/add.js
/* harmony default export */ function add(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add_add(this.cover(x, y), x, y, d);
}

function add_add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add_add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

;// ./node_modules/d3-quadtree/src/cover.js
/* harmony default export */ function cover(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
}

;// ./node_modules/d3-quadtree/src/data.js
/* harmony default export */ function src_data() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
}

;// ./node_modules/d3-quadtree/src/extent.js
/* harmony default export */ function d3_quadtree_src_extent(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
}

;// ./node_modules/d3-quadtree/src/quad.js
/* harmony default export */ function quad(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
}

;// ./node_modules/d3-quadtree/src/find.js


/* harmony default export */ function src_find(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new quad(node[3], xm, ym, x2, y2),
        new quad(node[2], x1, ym, xm, y2),
        new quad(node[1], xm, y1, x2, ym),
        new quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
}

;// ./node_modules/d3-quadtree/src/remove.js
/* harmony default export */ function src_remove(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
}

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

;// ./node_modules/d3-quadtree/src/root.js
/* harmony default export */ function src_root() {
  return this._root;
}

;// ./node_modules/d3-quadtree/src/size.js
/* harmony default export */ function src_size() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}

;// ./node_modules/d3-quadtree/src/visit.js


/* harmony default export */ function visit(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
    }
  }
  return this;
}

;// ./node_modules/d3-quadtree/src/visitAfter.js


/* harmony default export */ function visitAfter(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
}

;// ./node_modules/d3-quadtree/src/x.js
function defaultX(d) {
  return d[0];
}

/* harmony default export */ function src_x(_) {
  return arguments.length ? (this._x = _, this) : this._x;
}

;// ./node_modules/d3-quadtree/src/y.js
function defaultY(d) {
  return d[1];
}

/* harmony default export */ function src_y(_) {
  return arguments.length ? (this._y = _, this) : this._y;
}

;// ./node_modules/d3-quadtree/src/quadtree.js













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = add;
treeProto.addAll = addAll;
treeProto.cover = cover;
treeProto.data = src_data;
treeProto.extent = d3_quadtree_src_extent;
treeProto.find = src_find;
treeProto.remove = src_remove;
treeProto.removeAll = removeAll;
treeProto.root = src_root;
treeProto.size = src_size;
treeProto.visit = visit;
treeProto.visitAfter = visitAfter;
treeProto.x = src_x;
treeProto.y = src_y;

;// ./node_modules/d3-quadtree/index.js


;// ./node_modules/d3-force/src/manyBody.js





/* harmony default export */ function manyBody() {
  var nodes,
      node,
      random,
      alpha,
      strength = d3_force_src_constant(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x, y).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = jiggle(random), l += x * x;
        if (y === 0) y = jiggle(random), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = jiggle(random), l += x * x;
      if (y === 0) y = jiggle(random), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : d3_force_src_constant(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
}

;// ./src/js/nv/utils/end_line_label_positioner.js










function end_line_label_positioner_slicedToArray(r, e) { return end_line_label_positioner_arrayWithHoles(r) || end_line_label_positioner_iterableToArrayLimit(r, e) || end_line_label_positioner_unsupportedIterableToArray(r, e) || end_line_label_positioner_nonIterableRest(); }
function end_line_label_positioner_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function end_line_label_positioner_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return end_line_label_positioner_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? end_line_label_positioner_arrayLikeToArray(r, a) : void 0; } }
function end_line_label_positioner_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function end_line_label_positioner_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function end_line_label_positioner_arrayWithHoles(r) { if (Array.isArray(r)) return r; }


var LINE_LABEL_STROKE_WIDTH = constants_Constants.LINE_LABEL_STROKE_WIDTH,
  LINE_LABEL_PADDING_Y = constants_Constants.LINE_LABEL_PADDING_Y,
  LINE_LABEL_PADDING_X = constants_Constants.LINE_LABEL_PADDING_X,
  LINE_LABEL_MARGIN = constants_Constants.LINE_LABEL_MARGIN;
var FRICTION = 0.1;
var POINT_LINK_STRENGTH = 1;
var WEAK_POINT_LINK_STRENGTH = 0.1;
var NODE_LINK_STRENGTH = 3.5;
var end_line_label_positioner_GRAVITY = 0;
var TICKS = 100;
var LABEL_NODE_OFFSET = 1;
var POINT_NODE_OFFSET = 2;
var PREVIOUS_LABEL_NODE_OFFSET = 3;
var OVERLAPPING_POINT_OFFSET = 5;
var SPACE_BETWEEN_NODES = LINE_LABEL_STROKE_WIDTH + 1;
var MAX_LABELS_FOR_SIM = 350;
var endLabelPositioner = function endLabelPositioner(xScale, yScale, getX, getY, pointActive, showAllLabels) {
  return function (selection) {
    var _generateSimNodes = generateSimNodes(selection, xScale, yScale, getX, getY, showAllLabels, labelsFit),
      nodes = _generateSimNodes.nodes,
      links = _generateSimNodes.links,
      labelsFit = _generateSimNodes.labelsFit;
    if (labelsFit) {
      runEndLabelForceSimulation(nodes, links, yScale.range());
    }
    selection.attr('transform', function (d) {
      return "translate(".concat(d.x, ", ").concat(d.y, ")");
    });
  };
};
var boundY = function boundY(y, nodeHeight, minY, maxY) {
  return Math.max(minBound(minY, nodeHeight), Math.min(maxBound(maxY), y));
};
var minBound = function minBound(minY, nodeHeight) {
  return minY + (nodeHeight - LINE_LABEL_PADDING_Y);
};
var maxBound = function maxBound(maxY) {
  return maxY - LINE_LABEL_PADDING_Y;
};
var getStartX = function getStartX(d, xScale, getX) {
  var lastIndex = d.values.length - 1;
  var lastPoint = d.values[lastIndex];
  return xScale(getX(lastPoint, lastIndex));
};
var getStartY = function getStartY(d, yScale, getY) {
  var lastNonEmptyIndex = d.values.reduce(function (lastValIndex, d, index) {
    var value = getY(d, index);
    return value === null || value === undefined ? lastValIndex : index;
  }, 0);
  var lastNonEmptyPoint = d.values[lastNonEmptyIndex];
  return yScale(getY(lastNonEmptyPoint, lastNonEmptyIndex));
};
var calculateXOffset = function calculateXOffset(valueText, showAllLabels) {
  var valueTextLength = valueText ? valueText.getComputedTextLength() + LINE_LABEL_MARGIN : 0;
  var valueTextOffset = showAllLabels ? valueTextLength / 2 : valueTextLength;
  return LINE_LABEL_MARGIN + LINE_LABEL_PADDING_X + valueTextOffset;
};
var generateSimNodes = function generateSimNodes(selection, xScale, yScale, getX, getY, showAllLabels) {
  var labelNodes = [];
  var nodes = [];
  var links = [];
  var _yScale$range = yScale.range(),
    _yScale$range2 = end_line_label_positioner_slicedToArray(_yScale$range, 2),
    maxY = _yScale$range2[0],
    minY = _yScale$range2[1];
  selection.each(function (d) {
    var pointNode = {
      fixed: true,
      x: getStartX(d, xScale, getX),
      y: getStartY(d, yScale, getY) + LINE_LABEL_PADDING_Y
    };
    var xOffset = calculateXOffset(this.querySelector('.data-points'), showAllLabels);
    var height = this.getBBox().height + SPACE_BETWEEN_NODES;
    d.y = boundY(pointNode.y, height, minY, maxY);
    d.x = pointNode.x + xOffset;
    d.pointNode = pointNode;
    d.nodeHeight = height;
    labelNodes.push(d);
  });
  labelNodes.sort(function (a, b) {
    return a.pointNode.y - b.pointNode.y;
  }).forEach(function (d) {
    nodes.push(d.pointNode, d);
    links.push({
      strength: POINT_LINK_STRENGTH,
      distance: LINE_LABEL_MARGIN,
      source: nodes.length - POINT_NODE_OFFSET,
      target: nodes.length - LABEL_NODE_OFFSET
    });
    var lastNodeIndex = nodes.length - PREVIOUS_LABEL_NODE_OFFSET;
    if (lastNodeIndex > 0) {
      var lastNode = nodes[lastNodeIndex];
      var requiredDistance = d.nodeHeight / 2 + lastNode.nodeHeight / 2;
      var pointDistance = d.pointNode.y - lastNode.pointNode.y;
      if (requiredDistance > pointDistance) {
        links[links.length - 1].strength = WEAK_POINT_LINK_STRENGTH;
        links.push({
          strength: NODE_LINK_STRENGTH,
          distance: requiredDistance,
          source: lastNodeIndex,
          target: nodes.length - LABEL_NODE_OFFSET
        });
        if (pointDistance === 0) {
          d.y = lastNode.y + OVERLAPPING_POINT_OFFSET;
        }
      }
    }
  });
  var labelsFit = MAX_LABELS_FOR_SIM > labelNodes.length;
  return {
    nodes: nodes,
    links: links,
    labelsFit: labelsFit
  };
};
var runEndLabelForceSimulation = function runEndLabelForceSimulation(nodes, links, yRange) {
  var labelNodes = nodes.filter(function (_ref) {
    var fixed = _ref.fixed;
    return !fixed;
  });
  var _yRange = end_line_label_positioner_slicedToArray(yRange, 2),
    maxY = _yRange[0],
    minY = _yRange[1];
  labelNodes.forEach(function (node) {
    return node.startX = node.x;
  });
  var force = simulation(nodes).force('link', src_link(links)).force('gravity', manyBody().strength(end_line_label_positioner_GRAVITY)).alphaDecay(FRICTION);
  for (var i = 0; i < TICKS; ++i) {
    force.tick();
    labelNodes.forEach(function (node) {
      node.x = node.vx = node.startX;
    });
  }
  force.stop();
  boundLabels(labelNodes, minY, maxY);
};
var boundLabels = function boundLabels(labelNodes, minY, maxY) {
  if (!labelNodes.length) {
    return;
  }
  var firstNodeHeight = labelNodes[0].nodeHeight;
  var lastNodeHeight = labelNodes[labelNodes.length - 1].nodeHeight;
  var highY = minY + firstNodeHeight - LINE_LABEL_PADDING_Y * 2;
  var totalHeight = 0;
  labelNodes.forEach(function (node) {
    if (node.y < highY) {
      node.y = highY;
    }
    highY = node.y + node.nodeHeight;
    totalHeight += node.nodeHeight;
  });
  var heightMultiplier = Math.min(1, (maxY - minY) / totalHeight);
  var lowY = maxY - LINE_LABEL_PADDING_Y + lastNodeHeight * heightMultiplier;
  labelNodes.reverse().forEach(function (node) {
    var nodeHeight = heightMultiplier * node.nodeHeight;
    if (node.y > lowY - nodeHeight) {
      node.y = lowY - nodeHeight;
    }
    lowY = node.y;
  });
};
;// ./node_modules/d3-voronoi/src/constant.js
/* harmony default export */ function d3_voronoi_src_constant(x) {
  return function() {
    return x;
  };
}

;// ./node_modules/d3-voronoi/src/point.js
function point_x(d) {
  return d[0];
}

function point_y(d) {
  return d[1];
}

;// ./node_modules/d3-voronoi/src/RedBlackTree.js
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ var src_RedBlackTree = (RedBlackTree);

;// ./node_modules/d3-voronoi/src/Edge.js


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > Diagram_epsilon
            || Math.abs(edge[0][1] - edge[1][1]) > Diagram_epsilon)) {
      delete edges[i];
    }
  }
}

;// ./node_modules/d3-voronoi/src/Cell.js



function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > Diagram_epsilon || Math.abs(endY - startY) > Diagram_epsilon) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < Diagram_epsilon && y1 - endY > Diagram_epsilon ? [x0, Math.abs(startX - x0) < Diagram_epsilon ? startY : y1]
              : Math.abs(endY - y1) < Diagram_epsilon && x1 - endX > Diagram_epsilon ? [Math.abs(startY - y1) < Diagram_epsilon ? startX : x1, y1]
              : Math.abs(endX - x1) < Diagram_epsilon && endY - y0 > Diagram_epsilon ? [x1, Math.abs(startX - x1) < Diagram_epsilon ? startY : y0]
              : Math.abs(endY - y0) < Diagram_epsilon && endX - x0 > Diagram_epsilon ? [Math.abs(startY - y0) < Diagram_epsilon ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

;// ./node_modules/d3-voronoi/src/Circle.js



var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

;// ./node_modules/d3-voronoi/src/Beach.js






var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < Diagram_epsilon
      && Math.abs(y - lArc.circle.cy) < Diagram_epsilon) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < Diagram_epsilon
      && Math.abs(y - rArc.circle.cy) < Diagram_epsilon) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > Diagram_epsilon) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > Diagram_epsilon) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -Diagram_epsilon) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -Diagram_epsilon) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

;// ./node_modules/d3-voronoi/src/Diagram.js






var Diagram_epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new src_RedBlackTree;
  circles = new src_RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}

;// ./node_modules/d3-voronoi/src/voronoi.js




/* harmony default export */ function src_voronoi() {
  var x = point_x,
      y = point_y,
      extent = null;

  function voronoi(data) {
    return new Diagram(data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / Diagram_epsilon) * Diagram_epsilon, Math.round(y(d, i, data) / Diagram_epsilon) * Diagram_epsilon];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : d3_voronoi_src_constant(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : d3_voronoi_src_constant(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
}

;// ./node_modules/d3-voronoi/src/index.js


;// ./node_modules/d3-polygon/src/area.js
/* harmony default export */ function src_area(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
}

;// ./node_modules/d3-polygon/src/centroid.js
/* harmony default export */ function src_centroid(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
}

;// ./src/js/nv/utils/voronoi.js








function voronoi_slicedToArray(r, e) { return voronoi_arrayWithHoles(r) || voronoi_iterableToArrayLimit(r, e) || voronoi_unsupportedIterableToArray(r, e) || voronoi_nonIterableRest(); }
function voronoi_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function voronoi_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return voronoi_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? voronoi_arrayLikeToArray(r, a) : void 0; } }
function voronoi_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function voronoi_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function voronoi_arrayWithHoles(r) { if (Array.isArray(r)) return r; }


var PADDING = 20;
var FAKE_SERIES_INDEX = -1;
var POLYGON_EXTENT = [[-1e6, -1e6], [1e6, 1e6]];
var getGroupedVoronoi = function getGroupedVoronoi(data, getters) {
  var voronoi = computeVoronoi(data, getters);
  return groupVoronoi(data, voronoi);
};
var findLargestVoronoi = function findLargestVoronoi(voronoi) {
  if (!voronoi || !voronoi.length) {
    return undefined;
  }
  return voronoi.reduce(function (max, voronois) {
    return max.area * max.centroidDistance > voronois.area * voronois.centroidDistance ? max : voronois;
  });
};
var computeVoronoi = function computeVoronoi(data, getters) {
  var x = getters.x,
    y = getters.y;
  var vertices = mapVertices(data, getters);
  if (vertices.length === 0) {
    return [];
  }
  if (vertices.length < 3) {
    var _x$range = x.range(),
      _x$range2 = voronoi_slicedToArray(_x$range, 2),
      left = _x$range2[0],
      right = _x$range2[1];
    var _y$range = y.range(),
      _y$range2 = voronoi_slicedToArray(_y$range, 2),
      top = _y$range2[0],
      bottom = _y$range2[1];
    vertices.push([left - PADDING, top - PADDING, FAKE_SERIES_INDEX]);
    vertices.push([left - PADDING, bottom + PADDING, FAKE_SERIES_INDEX]);
    vertices.push([right + PADDING, top - PADDING, FAKE_SERIES_INDEX]);
    vertices.push([right + PADDING, bottom - PADDING, FAKE_SERIES_INDEX]);
  }
  var width = x.range()[1];
  var height = y.range()[0];
  var bounds = [[-PADDING, -PADDING], [-PADDING, height + PADDING], [width + PADDING, height + PADDING], [width + PADDING, -PADDING]];
  var voronoi = src_voronoi().extent(POLYGON_EXTENT).polygons(vertices).map(function (d) {
    return d[0] ? polygonClip(d, bounds) : null;
  });
  return vertices.map(function (_ref, index) {
    var _ref2 = voronoi_slicedToArray(_ref, 5),
      x = _ref2[0],
      y = _ref2[1],
      seriesIndex = _ref2[2],
      pointIndex = _ref2[3],
      point = _ref2[4];
    var polygonData = voronoi[index] || [];
    var area = src_area(polygonData);
    var centroid = src_centroid(polygonData);
    var centroidDistance = pointDistance([x, y], centroid);
    var centroidAngle = pointAngle([x, y], centroid);
    return {
      polygonData: polygonData,
      area: area,
      centroid: centroid,
      centroidDistance: centroidDistance,
      centroidAngle: centroidAngle,
      seriesIndex: seriesIndex,
      pointIndex: pointIndex,
      point: point,
      x: x,
      y: y
    };
  }).filter(function (_ref3) {
    var seriesIndex = _ref3.seriesIndex;
    return seriesIndex !== FAKE_SERIES_INDEX;
  });
};
var mapVertices = function mapVertices(data, getters) {
  var x = getters.x,
    y = getters.y,
    getX = getters.getX,
    getY = getters.getY,
    _getters$pointActive = getters.pointActive,
    pointActive = _getters$pointActive === void 0 ? function () {
      return true;
    } : _getters$pointActive;
  return data.reduce(function (vertexArray, series, seriesIndex) {
    var _series$values = series.values,
      values = _series$values === void 0 ? [] : _series$values;
    var valueVerticies = values.map(function (point, pointIndex) {
      var randomOffset = (Math.random() + seriesIndex) / 1000;
      var randomOffsetY = (Math.random() + seriesIndex) / 1000;
      var xPos = (x(getX(point, pointIndex)) || 0) + randomOffset;
      var yPos = (y(getY(point, pointIndex)) || 0) + randomOffsetY;
      return [xPos, yPos, seriesIndex, pointIndex, point];
    }).filter(function (_ref4) {
      var _ref5 = voronoi_slicedToArray(_ref4, 5),
        pointIndex = _ref5[3],
        point = _ref5[4];
      return pointActive(point, pointIndex);
    });
    return vertexArray.concat(valueVerticies);
  }, []);
};
var groupVoronoi = function groupVoronoi(data, voronoi) {
  var voronoiGroups = data.map(function () {
    return [];
  });
  return voronoi.reduce(function (groups, voronois) {
    var seriesIndex = voronois.seriesIndex;
    if (seriesIndex < groups.length) {
      groups[seriesIndex].push(voronois);
    }
    return groups;
  }, voronoiGroups);
};
var pointDistance = function pointDistance(_ref6, _ref7) {
  var _ref8 = voronoi_slicedToArray(_ref6, 2),
    x1 = _ref8[0],
    y1 = _ref8[1];
  var _ref9 = voronoi_slicedToArray(_ref7, 2),
    x2 = _ref9[0],
    y2 = _ref9[1];
  var xDiff = x2 - x1;
  var yDiff = y2 - y1;
  return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
};
var pointAngle = function pointAngle(_ref10, _ref11) {
  var _ref12 = voronoi_slicedToArray(_ref10, 2),
    x1 = _ref12[0],
    y1 = _ref12[1];
  var _ref13 = voronoi_slicedToArray(_ref11, 2),
    x2 = _ref13[0],
    y2 = _ref13[1];
  return Math.atan2(y2 - y1, x2 - x1);
};
var polygonClip = function polygonClip(cell, bounds) {
  var input,
    closed = polygonClosed(cell),
    i = -1,
    n = bounds.length - polygonClosed(bounds),
    j,
    m,
    a = bounds[n - 1],
    b,
    c,
    d;
  while (++i < n) {
    input = cell.slice();
    cell.length = 0;
    b = bounds[i];
    c = input[(m = input.length - closed) - 1];
    j = -1;
    while (++j < m) {
      d = input[j];
      if (polygonInside(d, a, b)) {
        if (!polygonInside(c, a, b)) {
          cell.push(polygonIntersect(c, d, a, b));
        }
        cell.push(d);
      } else if (polygonInside(c, a, b)) {
        cell.push(polygonIntersect(c, d, a, b));
      }
      c = d;
    }
    if (closed) {
      cell.push(cell[0]);
    }
    a = b;
  }
  return cell;
};
var polygonInside = function polygonInside(p, a, b) {
  return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
};
var polygonIntersect = function polygonIntersect(c, d, a, b) {
  var x1 = c[0],
    x3 = a[0],
    x21 = d[0] - x1,
    x43 = b[0] - x3,
    y1 = c[1],
    y3 = a[1],
    y21 = d[1] - y1,
    y43 = b[1] - y3,
    ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
  return [x1 + ua * x21, y1 + ua * y21];
};
var polygonClosed = function polygonClosed(coordinates) {
  var a = coordinates[0],
    b = coordinates[coordinates.length - 1];
  return !(a[0] - b[0] || a[1] - b[1]);
};
;// ./src/js/nv/utils/in_line_label_positioner.js







function in_line_label_positioner_slicedToArray(r, e) { return in_line_label_positioner_arrayWithHoles(r) || in_line_label_positioner_iterableToArrayLimit(r, e) || in_line_label_positioner_unsupportedIterableToArray(r, e) || in_line_label_positioner_nonIterableRest(); }
function in_line_label_positioner_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function in_line_label_positioner_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function in_line_label_positioner_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || in_line_label_positioner_unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function in_line_label_positioner_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return in_line_label_positioner_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? in_line_label_positioner_arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return in_line_label_positioner_arrayLikeToArray(r); }
function in_line_label_positioner_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var in_line_label_positioner_LINE_LABEL_PADDING_Y = constants_Constants.LINE_LABEL_PADDING_Y,
  in_line_label_positioner_LINE_LABEL_PADDING_X = constants_Constants.LINE_LABEL_PADDING_X,
  in_line_label_positioner_LINE_LABEL_MARGIN = constants_Constants.LINE_LABEL_MARGIN,
  FONT_SIZE = constants_Constants.FONT_SIZE;
var inlineLabelPositioner = function inlineLabelPositioner(xScale, yScale, getX, getY, pointActive) {
  return function (selection) {
    var selectionData = getDataFromSelection(selection);
    var voronoiGroups = getGroupedVoronoi(selectionData, {
      x: xScale,
      y: yScale,
      getX: getX,
      getY: getY,
      pointActive: pointActive
    });
    positionLabelsInVoronoi(selection, voronoiGroups, xScale, yScale);
    selection.attr('transform', function (d) {
      return "translate(".concat(d.x, ", ").concat(d.y, ")");
    });
  };
};
var getDataFromSelection = function getDataFromSelection(selection) {
  var data = [];
  selection.each(function (d) {
    return data.push(d);
  });
  return data;
};
var positionLabelsInVoronoi = function positionLabelsInVoronoi(selection, voronoiGroups, xScale, yScale) {
  var labelBoxPoints = [];
  selection.each(function (d) {
    var voronoi = voronoiGroups.shift();
    var points = voronoi.map(function (_ref) {
      var x = _ref.x,
        y = _ref.y;
      return [x, y];
    });
    if (!voronoi.length) {
      return;
    }
    var _this$getBBox = this.getBBox(),
      width = _this$getBBox.width,
      height = _this$getBBox.height;
    var labelBox = getLabelBox(width, height, voronoi, points, labelBoxPoints, xScale, yScale);
    var _getLabelXYFromBox = getLabelXYFromBox(labelBox),
      labelX = _getLabelXYFromBox.labelX,
      labelY = _getLabelXYFromBox.labelY;
    d.x = labelX;
    d.y = labelY;
    labelBoxPoints.push.apply(labelBoxPoints, _toConsumableArray(getBoxPoints(labelBox)));
  });
};
var getLabelBox = function getLabelBox(width, height, voronoi, chartPoints, labelBoxPoints, xScale, yScale) {
  var labelBox;
  var voronois;
  do {
    voronois = findLargestVoronoi(voronoi);
    labelBox = getPositionedLabelBox(width, height, voronois, chartPoints);
    labelBox = boundLabelBox(labelBox, xScale, yScale);
    voronoi = voronoi.filter(function (_ref2) {
      var pointIndex = _ref2.pointIndex;
      return pointIndex !== voronois.pointIndex;
    });
  } while (voronoi.length && hasPointsInBox(labelBox, labelBoxPoints));
  return labelBox;
};
var getPositionedLabelBox = function getPositionedLabelBox(width, height, voronois, chartPoints) {
  var x = voronois.x,
    y = voronois.y,
    centroidAngle = voronois.centroidAngle;
  var vPoint = [x, y];
  var labelBox;
  var maxLoops = 50;
  do {
    vPoint = movePoint(vPoint, centroidAngle, 2);
    labelBox = getCenteredLabelBox(vPoint, width, height);
  } while (maxLoops-- && hasPointsInBox(labelBox, chartPoints));
  return labelBox;
};
var boundLabelBox = function boundLabelBox(labelBox, xScale, yScale) {
  var BLEED = 20;
  var PADDING = in_line_label_positioner_LINE_LABEL_MARGIN + BLEED;
  var x = labelBox.x,
    y = labelBox.y,
    width = labelBox.width,
    height = labelBox.height;
  var chartWidth = xScale.range()[1];
  var chartHeight = yScale.range()[0];
  var maxX = chartWidth - width + PADDING;
  var maxY = chartHeight - height + PADDING;
  return {
    x: Math.max(-PADDING, Math.min(maxX, x)),
    y: Math.max(-PADDING, Math.min(maxY, y)),
    width: width,
    height: height
  };
};
var hasPointsInBox = function hasPointsInBox(box, chartPoints) {
  return !!chartPoints.find(function (point) {
    return pointInBox(point, box);
  });
};
var getCenteredLabelBox = function getCenteredLabelBox(_ref3, width, height) {
  var _ref4 = in_line_label_positioner_slicedToArray(_ref3, 2),
    x = _ref4[0],
    y = _ref4[1];
  var fullWidth = width + in_line_label_positioner_LINE_LABEL_MARGIN * 2;
  var fullHeight = height + in_line_label_positioner_LINE_LABEL_MARGIN * 2;
  var xOffset = fullWidth / 2;
  var yOffset = fullHeight / 2;
  return {
    x: x - xOffset,
    y: y - yOffset,
    width: fullWidth,
    height: fullHeight
  };
};
var getLabelXYFromBox = function getLabelXYFromBox(box) {
  var x = box.x,
    y = box.y;
  return {
    labelX: x + in_line_label_positioner_LINE_LABEL_MARGIN + in_line_label_positioner_LINE_LABEL_PADDING_X,
    labelY: y + in_line_label_positioner_LINE_LABEL_MARGIN + in_line_label_positioner_LINE_LABEL_PADDING_Y + FONT_SIZE - 1
  };
};
var pointInBox = function pointInBox(_ref5, box) {
  var _ref6 = in_line_label_positioner_slicedToArray(_ref5, 2),
    x = _ref6[0],
    y = _ref6[1];
  x = Math.round(x);
  y = Math.round(y);
  var x1 = Math.round(box.x);
  var x2 = Math.round(box.x + box.width);
  var y1 = Math.round(box.y);
  var y2 = Math.round(box.y + box.height);
  return x1 <= x && x <= x2 && y1 <= y && y <= y2;
};
var movePoint = function movePoint(_ref7, angle, distance) {
  var _ref8 = in_line_label_positioner_slicedToArray(_ref7, 2),
    x = _ref8[0],
    y = _ref8[1];
  return [x + Math.cos(angle) * distance, y + Math.sin(angle) * distance];
};
var getBoxPoints = function getBoxPoints(box) {
  var x = box.x,
    y = box.y,
    width = box.width,
    height = box.height;
  return [[x, y], [x, y + height], [x + width, y], [x + width, y + height]];
};
;// ./src/js/nv/utils/add_background_rect.js

var addBackgroundRect = function addBackgroundRect(groupSelection, options) {
  var _ref = options || {},
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 2 : _ref$borderRadius,
    _ref$xPadding = _ref.xPadding,
    xPadding = _ref$xPadding === void 0 ? 4 : _ref$xPadding,
    _ref$yPadding = _ref.yPadding,
    yPadding = _ref$yPadding === void 0 ? 2 : _ref$yPadding,
    _ref$textSelector = _ref.textSelector,
    textSelector = _ref$textSelector === void 0 ? 'text' : _ref$textSelector;
  groupSelection.filter(function () {
    return !this.querySelector('rect.nv-background');
  }).each(function () {
    var bbox = this.querySelector(textSelector).getBBox();
    src_select(this).insert('rect', textSelector).attr('class', 'nv-background').attr('x', bbox.x - xPadding).attr('y', bbox.y - yPadding).attr('width', bbox.width + xPadding * 2).attr('height', bbox.height + yPadding * 2).attr('rx', borderRadius).attr('ry', borderRadius);
  });
  return groupSelection;
};
/* harmony default export */ var add_background_rect = (addBackgroundRect);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__(1632);
;// ./src/js/nv/utils/lineHighlighter.js




function lineHighlighter(group) {
  var selectedLines = new Set();
  var lineLabels = group.selectAll('.nv-line-label').on('click', lineLabelClickHandler).on('mouseover', lineLabelFocusHandler).on('mouseout', lineLabelBlurHandler);
  function lineLabelClickHandler(event, d) {
    var i = d.index;
    if (selectedLines.has(i)) {
      selectedLines.delete(i);
    } else {
      selectedLines.add(i);
    }
    if (selectedLines.size >= lineLabels.size()) {
      selectedLines.clear();
      group.classed('line-focused', false);
      group.selectAll('.focused').classed('focused', false);
    }
  }
  function lineLabelFocusHandler(event, d) {
    var i = d.index;
    var lineAndLabel = group.selectAll(".nv-series-".concat(i));
    lineAndLabel.classed('focused', true);
    group.classed('line-focused', true);
  }
  function lineLabelBlurHandler(event, d) {
    var i = d.index;
    var lineAndLabel = group.selectAll(".nv-series-".concat(i));
    lineAndLabel.classed('focused', selectedLines.has(i));
    group.classed('line-focused', !!selectedLines.size);
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__(4614);
;// ./src/js/nv/utils/format_missing_data.js
function format_missing_data_typeof(o) { "@babel/helpers - typeof"; return format_missing_data_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, format_missing_data_typeof(o); }







function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == format_missing_data_typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != format_missing_data_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != format_missing_data_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formatMissingData = function formatMissingData(data) {
  return data.map(function (series) {
    var values = series.values;
    return _objectSpread(_objectSpread({}, series), {}, {
      values: values.map(function (value, j) {
        var showAlways = value.showAlways || (!values[j - 1] || values[j - 1].y === null || values[j - 1].y === undefined) && (!values[j + 1] || values[j + 1].y === null || values[j + 1].y === undefined);
        return _objectSpread(_objectSpread({}, value), (showAlways || value.hasOwnProperty('showAlways')) && {
          showAlways: showAlways
        });
      })
    });
  });
};
;// ./src/js/nv/utils/subdivision_event_handler.js

function registerSubdivisionEvents(dispatch, elements, events) {
  var collisionChecker = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultCollisionChecker;
  var clippingElements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  events.forEach(function (event) {
    dispatch.on(event.incoming, function (e) {
      elements.forEach(function (element, index) {
        var collisionElement = clippingElements === null ? element : clippingElements[index];
        if (collisionChecker(collisionElement, {
          x: e.mouseX,
          y: e.mouseY
        })) {
          if (event.outgoing.hovered && !event.outgoing.hovered(element)) {
            element.dispatchEvent(new Event(event.outgoing.enter));
          } else {
            element.dispatchEvent(new Event(event.outgoing));
          }
        } else {
          if (event.outgoing.hovered && event.outgoing.hovered(element)) {
            element.dispatchEvent(new Event(event.outgoing.exit));
          }
        }
      });
    });
  });
}
function defaultCollisionChecker(element, mouse) {
  return isCoordinateInRect(mouse, element.getBoundingClientRect());
}
function isCoordinateInRect(coordinate, rect) {
  return coordinate.x >= rect.x && coordinate.x <= rect.x + rect.width && coordinate.y >= rect.y && coordinate.y <= rect.y + rect.height;
}
function circleCollisionChecker(circle, coordinate) {
  var circleRect = circle.getBoundingClientRect();
  var radius = circleRect.height / 2;
  var circleX = circleRect.left + radius;
  var circleY = circleRect.top + radius;
  var distance = Math.sqrt(Math.pow(circleX - coordinate.x, 2) + Math.pow(circleY - coordinate.y, 2));
  return distance <= radius;
}
;// ./node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ function curve_linear(context) {
  return new Linear(context);
}

;// ./node_modules/d3-shape/src/array.js
var d3_shape_src_array_slice = Array.prototype.slice;

/* harmony default export */ function d3_shape_src_array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

;// ./node_modules/d3-shape/src/point.js
function src_point_x(p) {
  return p[0];
}

function src_point_y(p) {
  return p[1];
}

;// ./node_modules/d3-shape/src/line.js






/* harmony default export */ function src_line(x, y) {
  var defined = src_constant(true),
      context = null,
      curve = curve_linear,
      output = null;

  x = typeof x === "function" ? x : (x === undefined) ? src_point_x : src_constant(x);
  y = typeof y === "function" ? y : (y === undefined) ? src_point_y : src_constant(y);

  function line(data) {
    var i,
        n = (data = d3_shape_src_array(data)).length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = src_path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : src_constant(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : src_constant(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : src_constant(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

;// ./node_modules/d3-shape/src/area.js







/* harmony default export */ function d3_shape_src_area(x0, y0, y1) {
  var x1 = null,
      defined = src_constant(true),
      context = null,
      curve = curve_linear,
      output = null;

  x0 = typeof x0 === "function" ? x0 : (x0 === undefined) ? src_point_x : src_constant(+x0);
  y0 = typeof y0 === "function" ? y0 : (y0 === undefined) ? src_constant(0) : src_constant(+y0);
  y1 = typeof y1 === "function" ? y1 : (y1 === undefined) ? src_point_y : src_constant(+y1);

  function area(data) {
    var i,
        j,
        k,
        n = (data = d3_shape_src_array(data)).length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = src_path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return src_line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : src_constant(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : src_constant(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : src_constant(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : src_constant(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : src_constant(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : src_constant(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : src_constant(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

;// ./node_modules/d3-shape/src/curve/monotone.js
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__(6517);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.set-prototype-of.js
var es6_object_set_prototype_of = __webpack_require__(8132);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(7452);
;// ./src/js/utils/collision_detection.js
function collision_detection_typeof(o) { "@babel/helpers - typeof"; return collision_detection_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, collision_detection_typeof(o); }











function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == collision_detection_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(collision_detection_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var _marked = _regeneratorRuntime().mark(generateRadialLocations);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = collision_detection_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function collision_detection_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return collision_detection_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? collision_detection_arrayLikeToArray(r, a) : void 0; } }
function collision_detection_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var MAX_ELEMENTS = 200;
var RADIAL_COUNTS = [2, 4, 8, 16, 32];
var NUMBER_OF_RING_ELEMENTS_TO_SKIP = 2;
function findPositionedLocations(unpositionedElements, bounds) {
  var pointBufferRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var initialPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var maxDistanceFromExpected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
  var verticalOnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  initialPosition = parseFloat(initialPosition);
  var maxDiagonal = getDiagonalLength({
    width: pointBufferRadius,
    height: pointBufferRadius
  });
  var collisionTree = quadtree().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  });
  var elements = [];
  var _iterator = _createForOfIteratorHelper(unpositionedElements),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var unpositionedElement = _step.value;
      var point = makePoint(unpositionedElement, pointBufferRadius);
      collisionTree.add(point);
      if (elements.length >= MAX_ELEMENTS) {
        continue;
      }
      var elementRadius = unpositionedElement.radius ? unpositionedElement.radius : 0;
      var _element = makeElement(unpositionedElement);
      _element.potentialLocations = generateRadialLocations(_element, bounds, {
        x: _element.x,
        y: _element.y
      }, pointBufferRadius + elementRadius, initialPosition, verticalOnly);
      maxDiagonal = Math.max(maxDiagonal, getDiagonalLength(_element));
      elements.push(_element);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  for (var _i = 0, _elements = elements; _i < _elements.length; _i++) {
    var element = _elements[_i];
    var _iterator2 = _createForOfIteratorHelper(element.potentialLocations),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var potentialLocation = _step2.value;
        element.x = potentialLocation.x;
        element.y = potentialLocation.y;
        var distanceFromExpected = calculateDistance(element.expectedX, element.expectedY, element.x, element.y);
        if (!isIntersectingOthers(element, collisionTree, maxDiagonal) && distanceFromExpected < maxDistanceFromExpected) {
          collisionTree.add(makePointFromElement(element));
          element.display = true;
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return elements;
}
function findPositionedLocationsVertical(unpositionedElement, bounds) {
  var pointBufferRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var initialPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  var maxDistanceFromExpected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
  return findPositionedLocations(unpositionedElement, bounds, pointBufferRadius, initialPosition, maxDistanceFromExpected, true);
}
function isColliding(rect1, rect2) {
  return !(rect1.x >= rect2.x + rect2.width || rect2.x >= rect1.x + rect1.width || rect1.y >= rect2.y + rect2.height || rect2.y >= rect1.y + rect1.height);
}
function isIntersectingOthers(element, collisionTree, maxDiagonal) {
  var nonCollisions = [];
  while (true) {
    var possibleCollision = collisionTree.find(element.x, element.y, maxDiagonal);
    if (!possibleCollision) {
      break;
    }
    if (isColliding(possibleCollision, element)) {
      collisionTree.addAll(nonCollisions);
      return true;
    } else {
      var sizeBeforeRemoving = collisionTree.size();
      collisionTree.remove(possibleCollision);
      if (sizeBeforeRemoving === collisionTree.size()) {
        return true;
      }
      nonCollisions.push(possibleCollision);
    }
  }
  collisionTree.addAll(nonCollisions);
  return false;
}
function generateRadialLocations(rect, bounds, centerPoint, pointBufferRadius, initalRadianPosition, verticalOnly) {
  var halfWidth, halfHeight, i, radialCount, deltaR, curRadian, radialMult, radialSpacingW, radialSpacingH, position, PIVal, xTranslation, yTranslation, potentialLocation;
  return _regeneratorRuntime().wrap(function generateRadialLocations$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        halfWidth = rect.width / 2;
        halfHeight = rect.height / 2;
        i = 0;
      case 3:
        if (!(i < RADIAL_COUNTS.length)) {
          _context.next = 28;
          break;
        }
        radialCount = RADIAL_COUNTS[i];
        deltaR = 2 / RADIAL_COUNTS[i];
        curRadian = initalRadianPosition;
        radialMult = Math.max(i - NUMBER_OF_RING_ELEMENTS_TO_SKIP, 0);
        radialSpacingW = Math.max(radialMult * halfWidth, pointBufferRadius);
        radialSpacingH = Math.max(radialMult * halfHeight, pointBufferRadius);
        position = 0;
      case 11:
        if (!(position < radialCount)) {
          _context.next = 25;
          break;
        }
        PIVal = curRadian * Math.PI;
        xTranslation = Math.cos(PIVal) * (halfWidth + radialSpacingW);
        yTranslation = Math.sin(PIVal) * (halfHeight + radialSpacingH);
        if (!(verticalOnly && i > 1 && Math.round(xTranslation) !== 0)) {
          _context.next = 17;
          break;
        }
        return _context.abrupt("continue", 22);
      case 17:
        potentialLocation = {
          x: Math.round(xTranslation + centerPoint.x - halfWidth),
          y: Math.round(yTranslation + centerPoint.y - halfHeight)
        };
        if (!isInBounds(potentialLocation, rect.height, rect.width, bounds)) {
          _context.next = 21;
          break;
        }
        _context.next = 21;
        return potentialLocation;
      case 21:
        curRadian += deltaR;
      case 22:
        position++;
        _context.next = 11;
        break;
      case 25:
        i++;
        _context.next = 3;
        break;
      case 28:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
function getDiagonalLength(element) {
  return Math.sqrt(Math.pow(element.width, 2) + Math.pow(element.height, 2));
}
function calculateDistance(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
}
function isInBounds(point, height, width, bounds) {
  return point.x >= bounds.x && point.x <= bounds.x + bounds.width && point.y >= bounds.y && point.y <= bounds.y + bounds.height && point.x + width >= bounds.x && point.x + width <= bounds.x + bounds.width && point.y - height >= bounds.y && point.y - height <= bounds.y + bounds.height;
}
function makePoint(unpositionedElement, pointBufferRadius) {
  return {
    x: parseInt(unpositionedElement.expectedX) - pointBufferRadius / 2,
    y: parseInt(unpositionedElement.expectedY) - pointBufferRadius / 2,
    width: pointBufferRadius,
    height: pointBufferRadius
  };
}
function makePointFromElement(element) {
  return {
    x: element.x,
    y: element.y,
    width: element.width,
    height: element.height
  };
}
function makeElement(unpositionedElement) {
  return {
    id: unpositionedElement.id,
    x: parseInt(unpositionedElement.expectedX),
    y: parseInt(unpositionedElement.expectedY),
    expectedX: parseInt(unpositionedElement.expectedX),
    expectedY: parseInt(unpositionedElement.expectedY),
    width: parseInt(unpositionedElement.width),
    height: parseInt(unpositionedElement.height),
    display: false,
    radius: parseInt(unpositionedElement.radius)
  };
}
;// ./src/js/nv/chartHelpers/compare-data-points.js
var areDataPointsEqual = function areDataPointsEqual(currentDataPoint, dataPointToCompare) {
  var _dataPointToCompare$p, _currentDataPoint$poi, _dataPointToCompare$p2, _currentDataPoint$poi2, _dataPointToCompare$p3, _currentDataPoint$poi3;
  if (!dataPointToCompare && !currentDataPoint) {
    return true;
  }
  if (!dataPointToCompare && currentDataPoint || dataPointToCompare && !currentDataPoint) {
    return false;
  }
  if (!currentDataPoint.point && dataPointToCompare.point || currentDataPoint.point && !dataPointToCompare.point) {
    return false;
  }
  if (!currentDataPoint.point) {
    var isSameKeyPoint = dataPointToCompare.id === currentDataPoint.id && dataPointToCompare.key === currentDataPoint.key;
    return isSameKeyPoint;
  }
  var isSameSeriesPoint = ((_dataPointToCompare$p = dataPointToCompare.point) === null || _dataPointToCompare$p === void 0 ? void 0 : _dataPointToCompare$p.seriesId) === ((_currentDataPoint$poi = currentDataPoint.point) === null || _currentDataPoint$poi === void 0 ? void 0 : _currentDataPoint$poi.seriesId) && dataPointToCompare.pointIndex === currentDataPoint.pointIndex && ((_dataPointToCompare$p2 = dataPointToCompare.point) === null || _dataPointToCompare$p2 === void 0 ? void 0 : _dataPointToCompare$p2.pointId) === ((_currentDataPoint$poi2 = currentDataPoint.point) === null || _currentDataPoint$poi2 === void 0 ? void 0 : _currentDataPoint$poi2.pointId) && (dataPointToCompare === null || dataPointToCompare === void 0 ? void 0 : (_dataPointToCompare$p3 = dataPointToCompare.point) === null || _dataPointToCompare$p3 === void 0 ? void 0 : _dataPointToCompare$p3.id) === ((_currentDataPoint$poi3 = currentDataPoint.point) === null || _currentDataPoint$poi3 === void 0 ? void 0 : _currentDataPoint$poi3.id);
  return isSameSeriesPoint;
};
;// ./src/js/nv/models/line.js















var line_LINE_LABEL_STROKE_WIDTH = constants_Constants.LINE_LABEL_STROKE_WIDTH,
  line_LINE_LABEL_PADDING_Y = constants_Constants.LINE_LABEL_PADDING_Y,
  line_LINE_LABEL_PADDING_X = constants_Constants.LINE_LABEL_PADDING_X,
  LINE_LABEL_PLACEMENT = constants_Constants.LINE_LABEL_PLACEMENT,
  line_LINE_LABEL_MARGIN = constants_Constants.LINE_LABEL_MARGIN,
  SHOW_VALUE_OPTIONS = constants_Constants.SHOW_VALUE_OPTIONS;
var line = function line(nv) {
  nv.models.line = function () {
    var scatter = nv.models.upgradedScatter();
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 960,
      height = 500,
      container = null,
      strokeWidth = 2,
      color = nv.upgradedUtils.defaultColor(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      defined = function defined(d, i) {
        return !isNaN(getY(d, i)) && getY(d, i) !== null;
      },
      isArea = function isArea(d) {
        return d.area;
      },
      clipEdge = false,
      x,
      y,
      curve = curve_linear,
      duration = 250,
      dispatch = src_dispatch('elementClick', 'elementMouseover', 'elementMouseout', 'renderEnd', 'pathClick', 'selectedDataPointNotFound'),
      showValues = false,
      valueFormat = format(',.2f'),
      valuePadding = 12,
      valueLabelLocation = 'top',
      showLabels = false,
      maxLabelWidth = 100,
      pointSize = 75,
      disableInteraction = false,
      pointActive = function pointActive(d) {
        return !(d.notActive || d.y === null || d.y === undefined);
      },
      useRegionInteraction,
      interactionDispatch,
      dashed,
      dashFormat = '4,6',
      widgetAsFilter = false,
      selectedDataPoint,
      isCurrentChartSelected;
    scatter.pointDomain([16, 256]).pointActive(pointActive).labelPlacementFunction(findPositionedLocationsVertical);
    var x0,
      y0,
      renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    var timeoutID;
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(scatter);
      selection.each(function (data) {
        var _this = this;
        data = formatMissingData(data);
        container = src_select(this);
        var availableWidth = nv.upgradedUtils.availableWidth(width, container, margin),
          availableHeight = nv.upgradedUtils.availableHeight(height, container, margin);
        nv.upgradedUtils.initSVG(container);
        x = scatter.xScale();
        y = scatter.yScale();
        x0 = x0 || x;
        y0 = y0 || y;
        var wrap = container.selectAll('g.nv-wrap.nv-line').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-line');
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var wrapMergeSelection = wrapEnter.merge(wrap);
        var gMergeSelection = gEnter.merge(g);
        gEnter.append('g').attr('class', 'nv-groups');
        gEnter.append('g').attr('class', 'nv-scatterWrap');
        gEnter.append('g').attr('class', 'nv-line-labels');
        wrapMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        scatter.pointSize(function (d) {
          return d.size || pointSize;
        }).width(availableWidth).height(availableHeight).interactive(!disableInteraction);
        if (showValues) {
          scatter.valueArrangement(function (d) {
            return d && data[d[0].series] && data[d[0].series].labelLocation || valueLabelLocation;
          }).valueFormat(valueFormat).showValues(showValues).showOnlyYValues(true).padYBy(valuePadding).padY(false);
        } else {
          scatter.showValues(false);
        }
        var scatterWrap = wrapMergeSelection.select('.nv-scatterWrap');
        scatterWrap.call(scatter);
        defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + scatter.id()).append('rect');
        wrapMergeSelection.select('#nv-edge-clip-' + scatter.id() + ' rect').attr('width', availableWidth).attr('height', availableHeight > 0 ? availableHeight : 0);
        gMergeSelection.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + scatter.id() + ')' : '');
        scatterWrap.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + scatter.id() + ')' : '');
        var groups = wrapMergeSelection.select('.nv-groups').selectAll('.nv-group').data(function (d) {
          return d;
        });
        var groupsMergeSelection = groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).merge(groups);
        groups.exit().remove();
        groupsMergeSelection.attr('class', function (d, i) {
          return (d.classed || '') + ' nv-group nv-series-' + i;
        }).classed('hover', function (d) {
          return d.hover;
        }).style('stroke-width', function (d) {
          return d.strokeWidth || strokeWidth;
        }).style('fill', function (d, i) {
          return color(d, i);
        }).style('stroke', function (d, i) {
          return color(d, i);
        });
        groupsMergeSelection.watchTransition(renderWatch, 'line: groups').style('stroke-opacity', 1).style('fill-opacity', function (d) {
          return d.fillOpacity || 0.5;
        });
        var areaPaths = groupsMergeSelection.selectAll('path.nv-area').data(function (d) {
          return isArea(d) ? [d] : [];
        });
        var areaPathsMergeSelection = areaPaths.enter().append('path').attr('class', 'nv-area').attr('d', function (d) {
          return d3_shape_src_area().curve(curve).defined(defined).x(function (d, i) {
            return nv.upgradedUtils.NaNtoZero(x0(getX(d, i)));
          }).y0(function (d, i) {
            return nv.upgradedUtils.NaNtoZero(y0(getY(d, i)));
          }).y1(function () {
            return y0(y.domain()[0] <= 0 ? y.domain()[1] >= 0 ? 0 : y.domain()[1] : y.domain()[0]);
          }).apply(this, [d.values]);
        }).merge(areaPaths);
        groups.exit().selectAll('path.nv-area').remove();
        areaPathsMergeSelection.watchTransition(renderWatch, 'line: areaPaths').attr('d', function (d) {
          return d3_shape_src_area().curve(curve).defined(defined).x(function (d, i) {
            return nv.upgradedUtils.NaNtoZero(x(getX(d, i)));
          }).y0(function (d, i) {
            return nv.upgradedUtils.NaNtoZero(y(getY(d, i)));
          }).y1(function () {
            return y(y.domain()[0] <= 0 ? y.domain()[1] >= 0 ? 0 : y.domain()[1] : y.domain()[0]);
          }).apply(this, [d.values]);
        });
        var linePaths = groupsMergeSelection.filter(function (d) {
          return !d.spline;
        }).selectAll('path.nv-line').data(function (d) {
          return [d.values];
        });
        var splineLinePaths = groupsMergeSelection.filter(function (d) {
          return d.spline;
        }).selectAll('path.nv-line').data(function (d) {
          return [d.values];
        });
        var linePathsMergeSelection = linePaths.enter().append('path').attr('class', 'nv-line').attr('d', src_line().curve(curve).defined(defined).x(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(x0(getX(d, i)));
        }).y(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(y0(getY(d, i)));
        })).style('stroke-dasharray', function () {
          return dashed ? dashFormat : undefined;
        }).merge(linePaths);
        var splineLinePathsMergeSelection = splineLinePaths.enter().append('path').attr('class', 'nv-line').attr('d', src_line().curve(monotoneX).defined(defined).x(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(x0(getX(d, i)));
        }).y(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(y0(getY(d, i)));
        })).merge(splineLinePaths);
        linePathsMergeSelection.watchTransition(renderWatch, 'line: linePaths').attr('d', src_line().curve(curve).defined(defined).x(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(x(getX(d, i)));
        }).y(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(y(getY(d, i)));
        }));
        splineLinePathsMergeSelection.watchTransition(renderWatch, 'line: linePaths').attr('d', src_line().curve(monotoneX).defined(defined).x(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(x(getX(d, i)));
        }).y(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(y(getY(d, i)));
        }));
        function lineClickHander(event, d) {
          var points = [];
          d.forEach(function (point) {
            points.push({
              axisKey: point.axisKey,
              label: point.label,
              pos: [point.x, point.y]
            });
          });
          dispatch.call('pathClick', this, {
            series: d[0].series,
            seriesID: d[0].seriesID,
            points: points
          });
        }
        linePathsMergeSelection.on('click', lineClickHander);
        splineLinePathsMergeSelection.on('click', lineClickHander);
        var showLastValue = showValues === SHOW_VALUE_OPTIONS.LAST;
        var showRightLabel = showLabels === LINE_LABEL_PLACEMENT.RIGHT;
        var showAllValues = showValues === SHOW_VALUE_OPTIONS.ALL;
        if (showLastValue && !showRightLabel) {
          var dataPoints = groupsMergeSelection.selectAll('text.data-points').data(function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return [{
              position: position,
              point: point
            }];
          });
          var dataPointsMergeSelection = dataPoints.enter().append('text').attr('class', 'data-points').attr('x', function (d) {
            return nv.upgradedUtils.NaNtoZero(x0(getX(d.point, d.position))) + (margin.rightLabel ? valuePadding / 2 : valuePadding);
          }).attr('y', function (d) {
            return nv.upgradedUtils.NaNtoZero(y0(getY(d.point, d.position))) + 3;
          }).text(function (d) {
            return valueFormat(getY(d.point, d.position));
          }).merge(dataPoints);
          dataPoints.exit().remove();
          dataPointsMergeSelection.watchTransition(renderWatch, 'line: line:Paths').attr('x', function (d) {
            return nv.upgradedUtils.NaNtoZero(x(getX(d.point, d.position))) + (margin.rightLabel ? valuePadding / 2 : valuePadding);
          }).attr('y', function (d) {
            return nv.upgradedUtils.NaNtoZero(y(getY(d.point, d.position))) + 3;
          }).text(function (d) {
            return valueFormat(getY(d.point, d.position));
          });
        } else {
          groupsMergeSelection.selectAll('text.data-points').remove();
        }
        var nvLineLabels = gMergeSelection.select('.nv-line-labels');
        if (showLabels) {
          var positioner = showRightLabel ? endLabelPositioner : inlineLabelPositioner;
          var includeLastValue = showRightLabel && showLastValue;
          var maxTextWidth = maxLabelWidth - 2 * line_LINE_LABEL_PADDING_X - (showRightLabel ? line_LINE_LABEL_MARGIN : 0);
          var lineLabels = nvLineLabels.selectAll('.nv-line-label').data(function (d) {
            return d.map(function (d) {
              return d;
            });
          });
          var lineLabelsMergeSelection = lineLabels.enter().append('g').merge(lineLabels);
          lineLabels.exit().remove();
          lineLabelsMergeSelection.selectAll('*').remove();
          lineLabelsMergeSelection.append('text').attr('class', 'label-text').text(function (d) {
            return d.key;
          }).call(nv.upgradedUtils.wrapTicks, maxTextWidth, 2);
          lineLabelsMergeSelection.call(add_background_rect, {
            xPadding: line_LINE_LABEL_PADDING_X,
            yPadding: line_LINE_LABEL_PADDING_Y,
            textSelector: '.label-text'
          });
          if (includeLastValue || showAllValues) {
            lineLabelsMergeSelection.insert('text', '.label-text').attr('class', 'data-points').classed('hide-text', showAllValues).attr('text-anchor', 'end').attr('x', -line_LINE_LABEL_PADDING_X - line_LINE_LABEL_MARGIN).text(function (_ref) {
              var values = _ref.values;
              var pointIndex = values.length - 1;
              var point = values[pointIndex];
              return valueFormat(getY(point, pointIndex));
            });
          }
          lineLabelsMergeSelection.attr('class', function (d, i) {
            return "nv-line-label nv-series-".concat(i);
          }).classed('hover', function (d) {
            return d.hover;
          }).style('stroke-width', line_LINE_LABEL_STROKE_WIDTH).style('fill', function (d, i) {
            return color(d, i);
          }).style('stroke', function (d, i) {
            return color(d, i);
          }).call(positioner(x0, y0, getX, getY, pointActive, showAllValues));
          lineLabelsMergeSelection.watchTransition(renderWatch, 'line: line:Paths').call(positioner(x, y, getX, getY, pointActive, showAllValues));
          gMergeSelection.each(function (data) {
            data.forEach(function (d, i) {
              d.index = i;
            });
          });
          lineHighlighter(gMergeSelection);
        } else {
          nvLineLabels.selectAll('.nv-line-label').remove();
        }
        var hideHighlightDataPoint = function hideHighlightDataPoint() {
          ['selected', 'focused'].forEach(function (className) {
            container.selectAll('.nv-point').classed(className, false);
            container.selectAll(".".concat(className)).classed(className, false);
            container.selectAll(".line-".concat(className)).classed("line-".concat(className), false);
          });
        };
        var disableLineHighlighter = function disableLineHighlighter() {
          gMergeSelection.selectAll('.nv-line-label').on('click', null).on('mouseover', null).on('mouseout', null);
        };
        var highlightSelectedDataPoint = function highlightSelectedDataPoint() {
          hideHighlightDataPoint();
          if (!isCurrentChartSelected) {
            disableLineHighlighter();
            container.select('.nvd3.nv-wrap.nv-line > g').classed('line-selected', true);
            return;
          }
          var _selectedDataPoint = selectedDataPoint,
            seriesIndex = _selectedDataPoint.seriesIndex,
            pointIndex = _selectedDataPoint.pointIndex;
          var selectedLine = container.selectAll(".nv-group.nv-series-".concat(seriesIndex));
          var selectedPoint = selectedLine.selectAll('.nv-point').filter(function (d) {
            var _selectedDataPoint2, _selectedDataPoint2$p, _selectedDataPoint3, _selectedDataPoint3$p;
            return d[0].id === ((_selectedDataPoint2 = selectedDataPoint) === null || _selectedDataPoint2 === void 0 ? void 0 : (_selectedDataPoint2$p = _selectedDataPoint2.point) === null || _selectedDataPoint2$p === void 0 ? void 0 : _selectedDataPoint2$p.id) && d[0].seriesId === ((_selectedDataPoint3 = selectedDataPoint) === null || _selectedDataPoint3 === void 0 ? void 0 : (_selectedDataPoint3$p = _selectedDataPoint3.point) === null || _selectedDataPoint3$p === void 0 ? void 0 : _selectedDataPoint3$p.seriesId) && d[1] === pointIndex;
          });
          if (!selectedPoint.empty()) {
            disableLineHighlighter();
            container.select('.nvd3.nv-wrap.nv-line > g').classed('line-selected', true);
            selectedLine.classed('selected', true);
            selectedLine.selectAll(".nv-point.nv-point-".concat(pointIndex)).classed('selected', true);
          } else {
            dispatch.call('selectedDataPointNotFound', _this, true);
          }
        };
        if (!widgetAsFilter) {
          selectedDataPoint = undefined;
        }
        if (selectedDataPoint && widgetAsFilter) {
          highlightSelectedDataPoint();
        } else {
          hideHighlightDataPoint();
        }
        var updateInteractiveLayer = function updateInteractiveLayer() {
          if (useRegionInteraction) {
            var lineLabelsEventList = [{
              incoming: 'regionClick.lineLabels',
              outgoing: 'click'
            }, {
              incoming: 'regionMousemove.lineLabels',
              outgoing: {
                enter: 'mouseover',
                exit: 'mouseout',
                hovered: function hovered(element) {
                  return element.classList.contains('focused');
                }
              }
            }];
            registerSubdivisionEvents(interactionDispatch, container.selectAll('.nv-line-label').nodes(), lineLabelsEventList);
          }
        };
        clearTimeout(timeoutID);
        timeoutID = setTimeout(updateInteractiveLayer, constants_Constants.REGION_INTERACTIVE_UPDATE_DELAY);
        x0 = x.copy();
        y0 = y.copy();
      });
      renderWatch.renderEnd('line immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.scatter = scatter;
    scatter.dispatch.on('elementClick', function () {
      var dataPoint = arguments[0];
      var isSameDataPoint = areDataPointsEqual(selectedDataPoint, dataPoint);
      if (widgetAsFilter && !isSameDataPoint) {
        selectedDataPoint = dataPoint;
        isCurrentChartSelected = true;
      } else {
        selectedDataPoint = undefined;
        isCurrentChartSelected = false;
      }
      dispatch.apply('elementClick', this, arguments);
    });
    scatter.dispatch.on('elementMouseover', function () {
      dispatch.apply('elementMouseover', this, arguments);
    });
    scatter.dispatch.on('elementMouseout', function () {
      dispatch.apply('elementMouseout', this, arguments);
    });
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      defined: {
        get: function get() {
          return defined;
        },
        set: function set(_) {
          defined = _;
        }
      },
      curve: {
        get: function get() {
          return curve;
        },
        set: function set(_) {
          curve = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      valuePadding: {
        get: function get() {
          return valuePadding;
        },
        set: function set(_) {
          valuePadding = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      pointSize: {
        get: function get() {
          return pointSize;
        },
        set: function set(_) {
          pointSize = _;
        }
      },
      disableInteraction: {
        get: function get() {
          return disableInteraction;
        },
        set: function set(_) {
          disableInteraction = _;
        }
      },
      labelLocation: {
        get: function get() {
          return valueLabelLocation;
        },
        set: function set(_) {
          valueLabelLocation = _;
        }
      },
      showLabels: {
        get: function get() {
          return showLabels;
        },
        set: function set(_) {
          showLabels = _;
        }
      },
      maxLabelWidth: {
        get: function get() {
          return maxLabelWidth;
        },
        set: function set(_) {
          maxLabelWidth = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          scatter.duration(duration);
        }
      },
      isArea: {
        get: function get() {
          return isArea;
        },
        set: function set(_) {
          isArea = nv.upgradedUtils.functor(_);
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
          scatter.x(_);
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = _;
          scatter.y(_);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
          scatter.color(color);
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
          scatter.useRegionInteraction(_);
        }
      },
      dashed: {
        get: function get() {
          return dashed;
        },
        set: function set(_) {
          dashed = _;
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
          scatter.interactionDispatch(_);
        }
      },
      widgetAsFilter: {
        get: function get() {
          return widgetAsFilter;
        },
        set: function set(_) {
          widgetAsFilter = _;
        }
      },
      selectedDataPoint: {
        get: function get() {
          return selectedDataPoint;
        },
        set: function set(_) {
          selectedDataPoint = _;
        }
      },
      isCurrentChartSelected: {
        get: function get() {
          return isCurrentChartSelected;
        },
        set: function set(_) {
          isCurrentChartSelected = _;
        }
      }
    });
    nv.upgradedUtils.inheritOptions(chart, scatter);
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/lineChart.js




var lineChart = function lineChart(nv) {
  nv.models.lineChart = function () {
    var availableHeight2;
    var margin = {
        top: 30,
        right: 20,
        bottom: 50,
        left: 60
      },
      margin2 = {
        top: 0,
        right: 20,
        bottom: 20,
        left: 60
      },
      color = nv.upgradedUtils.defaultColor(),
      width = null,
      height = null,
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      useRegionInteraction = false,
      x,
      y,
      x2,
      y2,
      focusEnable = false,
      focusShowAxisY = false,
      focusShowAxisX = true,
      focusHeight = 50,
      brushExtent = null,
      state = nv.upgradedUtils.state(),
      defaultState = null,
      noData = null,
      dispatch = src_dispatch('tooltipShow', 'tooltipHide', 'brush', 'stateChange', 'changeState', 'renderEnd'),
      duration = 250,
      wrapLabels = false;
    var lines = nv.models.line(),
      xAxis = nv.models.upgradedAxis('bottom').tickPadding(7),
      yAxis = nv.models.upgradedAxis(rightAlignYAxis ? 'right' : 'left'),
      legend = nv.models.upgradedLegend(),
      tooltip = nv.models.upgradedTooltip(),
      lines2 = nv.models.line(),
      x2Axis = nv.models.upgradedAxis('bottom').tickPadding(5),
      y2Axis = nv.models.upgradedAxis(rightAlignYAxis ? 'right' : 'left'),
      brush = d3.svg.brush();
    lines.clipEdge(true).duration(0);
    lines2.interactive(false);
    lines2.pointActive(function () {
      return false;
    });
    tooltip.valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    }).headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    });
    var renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          })
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(lines);
      renderWatch.models(lines2);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      lines.valueFormat(yAxis.tickFormat());
      lines2.valueFormat(y2Axis.tickFormat());
      if (focusShowAxisX) {
        renderWatch.models(x2Axis);
      }
      if (focusShowAxisY) {
        renderWatch.models(y2Axis);
      }
      selection.each(function (data) {
        var container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        var availableWidth = nv.upgradedUtils.availableWidth(width, container, margin);
        var availableHeight1 = nv.upgradedUtils.availableHeight(height, container, margin) - (focusEnable ? focusHeight : 0);
        var availableHeight2 = focusHeight - margin2.top - margin2.bottom;
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.upgradedUtils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = lines.xScale();
        y = lines.yScale();
        x2 = lines2.xScale();
        y2 = lines2.yScale();
        var wrap = container.selectAll('g.nv-wrap.nv-lineChart').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-lineChart').append('g');
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var wrapMergeSelection = wrapEnter.merge(wrap);
        var gMergeSelection = gEnter.merge(g);
        gEnter.append('g').attr('class', 'nv-legendWrap');
        var focusEnter = gEnter.append('g').attr('class', 'nv-focus');
        focusEnter.append('g').attr('class', 'nv-background').append('rect');
        focusEnter.append('g').attr('class', 'nv-x nv-axis');
        focusEnter.append('g').attr('class', 'nv-y nv-axis');
        focusEnter.append('g').attr('class', 'nv-linesWrap');
        var contextEnter = gEnter.append('g').attr('class', 'nv-context');
        contextEnter.append('g').attr('class', 'nv-background').append('rect');
        contextEnter.append('g').attr('class', 'nv-x nv-axis');
        contextEnter.append('g').attr('class', 'nv-y nv-axis');
        contextEnter.append('g').attr('class', 'nv-linesWrap');
        contextEnter.append('g').attr('class', 'nv-brushBackground');
        contextEnter.append('g').attr('class', 'nv-x nv-brush');
        if (showLegend) {
          legend.width(availableWidth);
          gMergeSelection.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight1 = nv.upgradedUtils.availableHeight(height, container, margin) - (focusEnable ? focusHeight : 0);
          }
          wrapMergeSelection.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
        }
        wrapMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (rightAlignYAxis) {
          gMergeSelection.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        gMergeSelection.select('.nv-focus .nv-background rect').attr('width', availableWidth).attr('height', availableHeight1);
        lines.width(availableWidth).height(availableHeight1).color(data.map(function (d, i) {
          return d.color || color(d, i);
        }).filter(function (d, i) {
          return !data[i].disabled;
        }));
        var linesWrap = gMergeSelection.select('.nv-linesWrap').datum(data.filter(function (d) {
          return !d.disabled;
        }));
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.upgradedUtils.calcTicksX(availableWidth / 100, data)).tickSize(-availableHeight1, 0);
          if (lines.padData()) {
            xAxis.placeLabelAt(availableWidth / 2);
          } else {
            xAxis.placeLabelAt(null);
          }
        } else {
          gMergeSelection.select('.nv-focus .nv-x.nv-axis').html('');
        }
        if (showYAxis) {
          yAxis.scale(y)._ticks(nv.upgradedUtils.calcTicksY(availableHeight1 / 36, data)).tickSize(-availableWidth, 0);
        } else {
          gMergeSelection.select('.nv-focus .nv-y.nv-axis').html('');
        }
        function updateXAxis() {
          if (showXAxis) {
            gMergeSelection.select('.nv-focus .nv-x.nv-axis').transition().duration(duration).call(xAxis);
            if (wrapLabels) {
              gMergeSelection.select('.nv-x.nv-axis').selectAll('.tick text').call(nv.upgradedUtils.wrapTicks, availableWidth / data[0].values.length, 2);
            }
          }
        }
        function updateYAxis() {
          if (showYAxis) {
            gMergeSelection.select('.nv-focus .nv-y.nv-axis').transition().duration(duration).call(yAxis);
          }
        }
        gMergeSelection.select('.nv-focus .nv-x.nv-axis').attr('transform', 'translate(0,' + availableHeight1 + ')');
        if (!focusEnable) {
          linesWrap.call(lines);
          updateXAxis();
          updateYAxis();
        } else {
          lines2.defined(lines.defined()).width(availableWidth).height(availableHeight2).color(data.map(function (d, i) {
            return d.color || color(d, i);
          }).filter(function (d, i) {
            return !data[i].disabled;
          }));
          gMergeSelection.select('.nv-context').attr('transform', 'translate(0,' + (availableHeight1 + margin.bottom + margin2.top) + ')').style('display', focusEnable ? 'initial' : 'none');
          var contextLinesWrap = gMergeSelection.select('.nv-context .nv-linesWrap').datum(data.filter(function (d) {
            return !d.disabled;
          }));
          contextLinesWrap.transition().call(lines2);
          brush.x(x2).on('brush', function () {
            onBrush();
          });
          if (brushExtent) {
            brush.extent(brushExtent);
          }
          var brushBG = gMergeSelection.select('.nv-brushBackground').selectAll('g').data([brushExtent || brush.extent()]);
          var brushBGMergeSelection = brushBG.enter().append('g').merge(brushBG);
          brushBGMergeSelection.append('rect').attr('class', 'left').attr('x', 0).attr('y', 0).attr('height', availableHeight2);
          brushBGMergeSelection.append('rect').attr('class', 'right').attr('x', 0).attr('y', 0).attr('height', availableHeight2);
          var gBrush = gMergeSelection.select('.nv-x.nv-brush').call(brush);
          gBrush.selectAll('rect').attr('height', availableHeight2);
          gBrush.selectAll('.resize').append('path').attr('d', resizePath);
          onBrush();
          gMergeSelection.select('.nv-context .nv-background rect').attr('width', availableWidth).attr('height', availableHeight2);
          if (focusShowAxisX) {
            x2Axis.scale(x2)._ticks(nv.upgradedUtils.calcTicksX(availableWidth / 100, data)).tickSize(-availableHeight2, 0);
            gMergeSelection.select('.nv-context .nv-x.nv-axis').attr('transform', 'translate(0,' + y2.range()[0] + ')');
            gMergeSelection.select('.nv-context .nv-x.nv-axis').transition().call(x2Axis);
          }
          if (focusShowAxisY) {
            y2Axis.scale(y2)._ticks(nv.upgradedUtils.calcTicksY(availableHeight2 / 36, data)).tickSize(-availableWidth, 0);
            gMergeSelection.select('.nv-context .nv-y.nv-axis').transition().call(y2Axis);
          }
          gMergeSelection.select('.nv-context .nv-x.nv-axis').attr('transform', 'translate(0,' + y2.range()[0] + ')');
        }
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined' && data.length === e.disabled.length) {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          chart.update();
        });
        function resizePath(d) {
          var e = +(d === 'e'),
            x = e ? 1 : -1,
            y = availableHeight2 / 3;
          return 'M' + 0.5 * x + ',' + y + 'A6,6 0 0 ' + e + ' ' + 6.5 * x + ',' + (y + 6) + 'V' + (2 * y - 6) + 'A6,6 0 0 ' + e + ' ' + 0.5 * x + ',' + 2 * y + 'Z' + 'M' + 2.5 * x + ',' + (y + 8) + 'V' + (2 * y - 8) + 'M' + 4.5 * x + ',' + (y + 8) + 'V' + (2 * y - 8);
        }
        function updateBrushBG() {
          if (!brush.empty()) {
            brush.extent(brushExtent);
          }
          brushBG.data([brush.empty() ? x2.domain() : brushExtent]).each(function (d) {
            var leftWidth = x2(d[0]) - x.range()[0],
              rightWidth = availableWidth - x2(d[1]);
            src_select(this).select('.left').attr('width', leftWidth < 0 ? 0 : leftWidth);
            src_select(this).select('.right').attr('x', x2(d[1])).attr('width', rightWidth < 0 ? 0 : rightWidth);
          });
        }
        function onBrush() {
          brushExtent = brush.empty() ? null : brush.extent();
          var extent = brush.empty() ? x2.domain() : brush.extent();
          if (Math.abs(extent[0] - extent[1]) <= 1) {
            return;
          }
          dispatch.brush({
            extent: extent,
            brush: brush
          });
          updateBrushBG();
          var focusLinesWrap = gMergeSelection.select('.nv-focus .nv-linesWrap').datum(data.filter(function (d) {
            return !d.disabled;
          }).map(function (d) {
            return {
              key: d.key,
              area: d.area,
              classed: d.classed,
              values: d.values.filter(function (d, i) {
                return lines.x()(d, i) >= extent[0] && lines.x()(d, i) <= extent[1];
              }),
              disableTooltip: d.disableTooltip
            };
          }));
          focusLinesWrap.transition().duration(duration).call(lines);
          updateXAxis();
          updateYAxis();
        }
      });
      renderWatch.renderEnd('lineChart immediate');
      return chart;
    }
    lines.dispatch.on('elementMouseover.tooltip', function (evt) {
      if (!evt.series.disableTooltip) {
        tooltip.data(evt).position(function () {
          return evt.pos;
        }).hidden(false);
      }
    });
    lines.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    chart.dispatch = dispatch;
    chart.lines = lines;
    chart.lines2 = lines2;
    chart.legend = legend;
    chart.xAxis = xAxis;
    chart.x2Axis = x2Axis;
    chart.yAxis = yAxis;
    chart.y2Axis = y2Axis;
    chart.tooltip = tooltip;
    chart.state = state;
    chart.dispatch = dispatch;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      focusEnable: {
        get: function get() {
          return focusEnable;
        },
        set: function set(_) {
          focusEnable = _;
        }
      },
      focusHeight: {
        get: function get() {
          return availableHeight2;
        },
        set: function set(_) {
          focusHeight = _;
        }
      },
      focusShowAxisX: {
        get: function get() {
          return focusShowAxisX;
        },
        set: function set(_) {
          focusShowAxisX = _;
        }
      },
      focusShowAxisY: {
        get: function get() {
          return focusShowAxisY;
        },
        set: function set(_) {
          focusShowAxisY = _;
        }
      },
      brushExtent: {
        get: function get() {
          return brushExtent;
        },
        set: function set(_) {
          brushExtent = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = !!_;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          lines.duration(duration);
          xAxis.duration(duration);
          x2Axis.duration(duration);
          yAxis.duration(duration);
          y2Axis.duration(duration);
        }
      },
      focusMargin: {
        get: function get() {
          return margin2;
        },
        set: function set(_) {
          margin2.top = _.top !== undefined ? _.top : margin2.top;
          margin2.right = _.right !== undefined ? _.right : margin2.right;
          margin2.bottom = _.bottom !== undefined ? _.bottom : margin2.bottom;
          margin2.left = _.left !== undefined ? _.left : margin2.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
          legend.color(color);
          lines.color(color);
        }
      },
      curve: {
        get: function get() {
          return lines.curve();
        },
        set: function set(_) {
          lines.curve(_);
          lines2.curve(_);
        }
      },
      xTickFormat: {
        get: function get() {
          return xAxis.tickFormat();
        },
        set: function set(_) {
          xAxis.tickFormat(_);
          x2Axis.tickFormat(_);
        }
      },
      yTickFormat: {
        get: function get() {
          return yAxis.tickFormat();
        },
        set: function set(_) {
          yAxis.tickFormat(_);
          y2Axis.tickFormat(_);
        }
      },
      x: {
        get: function get() {
          return lines.x();
        },
        set: function set(_) {
          lines.x(_);
          lines2.x(_);
        }
      },
      y: {
        get: function get() {
          return lines.y();
        },
        set: function set(_) {
          lines.y(_);
          lines2.y(_);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis = nv.models.upgradedAxis(rightAlignYAxis ? 'right' : 'left');
        }
      }
    });
    nv.upgradedUtils.inheritOptions(chart, lines);
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
  nv.models.lineWithFocusChart = function () {
    return nv.models.lineChart().margin({
      bottom: 30
    }).focusEnable(true);
  };
};
;// ./src/js/nv/utils/upgraded_bar_auxiliary_data.js



var TEXT_HEIGHT = constants_Constants.FONT_SIZE - 2;
var MIDDLE_EM = '0.35em';
var ICON_PADDING = 4;
var NULL_VALUE_TEXT = '-';
var TEXT_PADDING = 5;
var AUX_CLASS = 'aux-info';
var BAR_TEXT_CLASS = 'bar-text';
var BAR_VALUE_CLASS = 'bar-value';
var BAR_ICON_CLASS = 'bar-icon';
var CUSTOM_ICON_CLASS = 'custom-icon icon';
function upgradedDrawAuxiliaryData(dataContainers, options, getters) {
  var showValues = options.showValues;
  dataContainers.each(function (d, i) {
    var auxInfo = showValues || d.icon || d.customIcon ? getAuxDataInfo(this, d, i, options, getters) : null;
    renderAuxInfo(src_select(this), auxInfo, options, getters);
  });
}
function getAuxDataInfo(barElement, d, i, options, getters) {
  var isNegative = getters.getY(d, i) < 0;
  var bar = getBarInfo(barElement, d, i, options, isNegative);
  var text = getValueText(d, i, options, getters);
  var icon = d.icon,
    customIcon = d.customIcon,
    series = d.series;
  return {
    bar: bar,
    text: text,
    icon: icon,
    customIcon: customIcon,
    isNegative: isNegative,
    key: "".concat(series, "-").concat(i),
    iconBox: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },
    textWidth: 0
  };
}
function getBarInfo(bar, d) {
  var _d$barDimensions = d.barDimensions,
    x = _d$barDimensions.x,
    y = _d$barDimensions.y,
    width = _d$barDimensions.width,
    height = _d$barDimensions.height;
  return {
    x: x,
    y: y,
    width: width,
    height: height,
    transform: bar.getAttribute('transform'),
    color: d.color,
    pattern: d.pattern
  };
}
function getValueText(d, i, options, getters) {
  if (!options.showValues) {
    return undefined;
  }
  var getY = getters.getY,
    valueFormat = getters.valueFormat;
  var value = getY(d, i);
  if (value === null || value === undefined) {
    return NULL_VALUE_TEXT;
  }
  return valueFormat(value, d);
}
function renderAuxInfo(container, auxInfo, options) {
  container.selectAll('*').remove();
  if (!auxInfo) {
    return;
  }
  var valueSelection;
  var iconSelection;
  var text = auxInfo.text,
    customIcon = auxInfo.customIcon;
  if (text || customIcon) {
    valueSelection = container.append('text').attr('class', BAR_TEXT_CLASS);
    if (customIcon) {
      valueSelection.append('tspan').attr('class', CUSTOM_ICON_CLASS).text(customIcon.icon).style('font-family', 'Qualtrics Icons').style('font-size', customIcon.fontSize || null).attr('fill', customIcon.color || null).attr('letter-spacing', 2);
    }
    if (text) {
      valueSelection.append('tspan').attr('class', BAR_VALUE_CLASS).text(text);
    }
    auxInfo.textWidth = js_nv.upgradedUtils.getTextWidth(valueSelection);
  }
  var icon = auxInfo.icon;
  if (icon) {
    iconSelection = container.append('path').attr('class', BAR_ICON_CLASS).attr('d', js_nv.upgradedUtils.symbol().type(function (d) {
      var _d$icon;
      return (_d$icon = d.icon) !== null && _d$icon !== void 0 ? _d$icon : icon;
    }));
    auxInfo.iconBox = iconSelection.node().getBBox();
  }
  if (valueSelection) {
    valueSelection.call(positionValue, auxInfo, options);
  }
  if (iconSelection) {
    iconSelection.call(positionIcon, auxInfo, options);
  }
}
function positionValue(value, auxInfo, options) {
  var stacked = options.stacked,
    horizontal = options.horizontal,
    barDistance = options.barDistance;
  var bar = auxInfo.bar,
    icon = auxInfo.icon,
    iconBox = auxInfo.iconBox,
    isNegative = auxInfo.isNegative;
  if (!stacked && !horizontal || stacked && horizontal) {
    var iconXOffset = icon ? (iconBox.width + ICON_PADDING) / 2 : 0;
    var y = bar.y;
    if (!horizontal && isNegative) {
      y += bar.height + TEXT_PADDING + TEXT_HEIGHT;
    } else {
      y -= TEXT_PADDING;
    }
    value.attr('text-anchor', 'middle').attr('dy', null).attr('x', bar.x + bar.width / 2 + iconXOffset).attr('y', y).classed('hidden', !canTextFitAboveBar(auxInfo, barDistance, horizontal));
  } else if (stacked && !horizontal || horizontal && !stacked && isNegative) {
    var canFit = horizontal ? canFitNextToHorizontalBar(barDistance) : canTextFitLeftOfBar(auxInfo, barDistance);
    value.attr('text-anchor', 'end').attr('dy', MIDDLE_EM).attr('x', bar.x - TEXT_PADDING).attr('y', bar.y + bar.height / 2).classed('hidden', !canFit);
  } else {
    var _iconXOffset = icon ? iconBox.width + ICON_PADDING : 0;
    value.attr('text-anchor', 'start').attr('dy', MIDDLE_EM).attr('x', bar.x + bar.width + _iconXOffset + TEXT_PADDING).attr('y', bar.y + bar.height / 2).classed('hidden', !canFitNextToHorizontalBar(barDistance));
  }
}
function positionIcon(icon, auxInfo, options) {
  var stacked = options.stacked,
    barDistance = options.barDistance,
    horizontal = options.horizontal;
  var bar = auxInfo.bar,
    textWidth = auxInfo.textWidth;
  var _ref = horizontal ? getHorizontalIconXY(auxInfo, options) : getVerticalIconXY(auxInfo, options),
    x = _ref.x,
    y = _ref.y,
    showInside = _ref.showInside;
  icon.attr('transform', "translate(".concat(x, ", ").concat(y, ")"));
  if (showInside && !bar.pattern) {
    icon.attr('fill', '#FFFFFF').attr('stroke', null).attr('stroke-width', 0).attr('paint-order', 'stroke');
  } else {
    icon.attr('fill', bar.color).attr('stroke', '#FFFFFF').attr('stroke-width', 4).attr('stroke-linejoin', 'round').attr('paint-order', 'stroke');
  }
  var noText = !textWidth || (horizontal ? !canTextFitAboveHorizontalBar(auxInfo, barDistance) : !canTextFitLeftOfBar(auxInfo, barDistance));
  if (stacked && !showInside && noText) {
    icon.classed('hidden', true);
  }
}
function getVerticalIconXY(auxInfo, options) {
  var isNegative = auxInfo.isNegative;
  var stacked = options.stacked,
    barDistance = options.barDistance;
  var showInside = showVerticalIconInside(auxInfo);
  var x;
  var y;
  if (showInside) {
    x = getCenterX(auxInfo);
    if (stacked) {
      y = getCenterY(auxInfo);
    } else if (isNegative) {
      y = getInsideBottomY(auxInfo);
    } else {
      y = getInsideTopY(auxInfo);
    }
  } else {
    if (stacked) {
      x = getOutsideLeftX(auxInfo);
      y = getCenterY(auxInfo);
    } else {
      x = getOutsideX(auxInfo, barDistance);
      y = isNegative ? getOutsideBottomY(auxInfo) : getOutsideTopY(auxInfo);
    }
  }
  return {
    x: x,
    y: y,
    showInside: showInside
  };
}
function getHorizontalIconXY(auxInfo, options) {
  var isNegative = auxInfo.isNegative;
  var stacked = options.stacked,
    barDistance = options.barDistance;
  var showInside = showHorizontalIconInside(auxInfo);
  var x;
  var y;
  if (showInside) {
    y = getCenterY(auxInfo);
    if (stacked) {
      x = getCenterX(auxInfo);
    } else if (isNegative) {
      x = getInsideLeftX(auxInfo);
    } else {
      x = getInsideRightX(auxInfo);
    }
  } else {
    if (stacked) {
      x = getOutsideX(auxInfo, barDistance);
      y = getOutsideTopY(auxInfo);
    } else {
      y = getCenterY(auxInfo);
      x = isNegative ? getOutsideLeftX(auxInfo) : getOutsideRightX(auxInfo);
    }
  }
  return {
    x: x,
    y: y,
    showInside: showInside
  };
}
function canTextFitAboveBar(auxInfo, barDistance, horizontal) {
  return horizontal ? canTextFitAboveHorizontalBar(auxInfo, barDistance) : canTextFitAboveVerticalBar(auxInfo, barDistance);
}
function canTextFitAboveHorizontalBar(auxInfo, barDistance) {
  var iconBox = auxInfo.iconBox,
    textWidth = auxInfo.textWidth,
    bar = auxInfo.bar;
  return textWidth + iconBox.width < bar.width && TEXT_HEIGHT + TEXT_PADDING * 2 < barDistance - bar.height;
}
function canTextFitAboveVerticalBar(auxInfo, barDistance) {
  var iconBox = auxInfo.iconBox,
    textWidth = auxInfo.textWidth;
  return textWidth + iconBox.width <= barDistance;
}
function canTextFitLeftOfBar(auxInfo, barDistance) {
  var textWidth = auxInfo.textWidth,
    bar = auxInfo.bar,
    iconBox = auxInfo.iconBox;
  var neededSpace = ICON_PADDING + iconBox.width + ICON_PADDING + textWidth + constants_Constants.BAR_VALUE_PADDING + bar.width;
  return bar.height > TEXT_HEIGHT && neededSpace <= barDistance;
}
function canFitNextToHorizontalBar(barDistance) {
  return TEXT_HEIGHT + constants_Constants.BAR_VALUE_PADDING / 2 <= barDistance;
}
function showVerticalIconInside(_ref2) {
  var bar = _ref2.bar,
    iconBox = _ref2.iconBox,
    text = _ref2.text;
  return bar.height > iconBox.height + ICON_PADDING * 2 && !text;
}
function showHorizontalIconInside(_ref3) {
  var bar = _ref3.bar,
    iconBox = _ref3.iconBox,
    text = _ref3.text;
  return bar.width > iconBox.width + ICON_PADDING * 2 && !text;
}
function getCenterX(_ref4) {
  var bar = _ref4.bar,
    iconBox = _ref4.iconBox;
  return bar.x + bar.width / 2 - (iconBox.x + iconBox.width / 2);
}
function getInsideRightX(_ref5) {
  var bar = _ref5.bar,
    iconBox = _ref5.iconBox;
  return bar.x + bar.width - (iconBox.x + iconBox.width) - ICON_PADDING;
}
function getInsideLeftX(_ref6) {
  var bar = _ref6.bar,
    iconBox = _ref6.iconBox;
  return bar.x + ICON_PADDING - iconBox.x;
}
function getOutsideX(d, barDistance) {
  var x = getCenterX(d);
  if (d.textWidth && canTextFitAboveBar(d, barDistance)) {
    x -= (ICON_PADDING + d.textWidth) / 2;
  }
  return x;
}
function getOutsideLeftX(_ref7) {
  var bar = _ref7.bar,
    textWidth = _ref7.textWidth,
    iconBox = _ref7.iconBox;
  return bar.x - (iconBox.x + iconBox.width + ICON_PADDING + textWidth + TEXT_PADDING);
}
function getOutsideRightX(_ref8) {
  var bar = _ref8.bar,
    iconBox = _ref8.iconBox;
  return bar.x + bar.width + ICON_PADDING - iconBox.x;
}
function getCenterY(_ref9) {
  var bar = _ref9.bar,
    iconBox = _ref9.iconBox;
  return bar.y + bar.height / 2 - (iconBox.y + iconBox.height / 2);
}
function getInsideTopY(_ref10) {
  var bar = _ref10.bar,
    iconBox = _ref10.iconBox;
  return bar.y + ICON_PADDING - iconBox.y;
}
function getInsideBottomY(_ref11) {
  var bar = _ref11.bar,
    iconBox = _ref11.iconBox;
  return bar.y + bar.height - (iconBox.y + iconBox.height + ICON_PADDING);
}
function getOutsideTopY(_ref12) {
  var bar = _ref12.bar,
    iconBox = _ref12.iconBox,
    text = _ref12.text;
  var iconOffset = text ? TEXT_PADDING + (TEXT_HEIGHT + iconBox.height) / 2 : iconBox.height + ICON_PADDING;
  return bar.y - iconBox.y - iconOffset;
}
function getOutsideBottomY(_ref13) {
  var bar = _ref13.bar,
    iconBox = _ref13.iconBox,
    text = _ref13.text;
  var iconOffset = text ? TEXT_PADDING + (TEXT_HEIGHT - iconBox.height) / 2 : ICON_PADDING;
  return bar.y + bar.height - iconBox.y + iconOffset;
}
;// ./src/js/nv/utils/bar_paths.js
var MIN_SIZE = 0.05;
function createVerticalBarPath(barDimensions, seriesIndex, barValue, yZero, stacked) {
  var width = barDimensions.width,
    height = barDimensions.height,
    x = barDimensions.x,
    y = barDimensions.y,
    radius = barDimensions.radius,
    strokeWidth = barDimensions.strokeWidth;
  if (isNaN(height) || stacked && !barValue) {
    return '';
  }
  var isPositive = barValue >= 0;
  var isBetweenBar = stacked && seriesIndex;
  var halfStroke = strokeWidth / 2;
  var bottomOffset = isBetweenBar ? -1 : halfStroke;
  var lineClose = isBetweenBar ? 'z' : '';
  y += halfStroke;
  x += halfStroke;
  width -= strokeWidth;
  height -= strokeWidth - bottomOffset;
  if (height <= 0) {
    height = MIN_SIZE;
    if (isPositive && y > yZero - halfStroke && !stacked) {
      y = yZero - halfStroke;
    } else if (!isPositive && y < yZero + halfStroke + bottomOffset && !stacked) {
      y = yZero + halfStroke + bottomOffset;
    }
  }
  if (isPositive) {
    return "M ".concat(x, " ").concat(y + height) + " v ".concat(radius - height) + " q 0 -".concat(radius, " ").concat(radius, " -").concat(radius) + " h ".concat(width - 2 * radius) + " q ".concat(radius, " 0 ").concat(radius, " ").concat(radius) + " v ".concat(height - radius) + " ".concat(lineClose);
  }
  return "M ".concat(x, " ").concat(y - bottomOffset) + " v ".concat(height - radius) + " q 0 ".concat(radius, " ").concat(radius, " ").concat(radius) + " h ".concat(width - 2 * radius) + " q ".concat(radius, " 0 ").concat(radius, " -").concat(radius) + " v ".concat(radius - height) + " ".concat(lineClose);
}
function createHorizontalBarPath(barDimensions, seriesIndex, barValue, xZero, stacked) {
  var width = barDimensions.width,
    height = barDimensions.height,
    x = barDimensions.x,
    y = barDimensions.y,
    radius = barDimensions.radius,
    strokeWidth = barDimensions.strokeWidth;
  var isPositive = barValue >= 0;
  var isBetweenBar = stacked && seriesIndex;
  var halfStroke = strokeWidth / 2;
  var leftOffset = isBetweenBar ? -1 : halfStroke;
  var lineClose = isBetweenBar ? 'z' : '';
  y += halfStroke;
  x += halfStroke;
  height -= strokeWidth;
  width -= strokeWidth - leftOffset;
  if (width <= 0) {
    width = MIN_SIZE;
    if (isPositive && x < xZero + halfStroke + leftOffset && !stacked) {
      x = xZero + halfStroke + leftOffset;
    } else if (!isPositive && x > xZero - halfStroke && !stacked) {
      x = xZero - halfStroke;
    }
  }
  if (stacked && !barValue) {
    return '';
  }
  if (isPositive) {
    return "M ".concat(x - leftOffset, " ").concat(y) + " h ".concat(width - radius) + " q ".concat(radius, " 0 ").concat(radius, " ").concat(radius) + " v ".concat(height - 2 * radius) + " q 0 ".concat(radius, " -").concat(radius, " ").concat(radius) + " h ".concat(radius - width) + " ".concat(lineClose);
  }
  return "M ".concat(x + width, " ").concat(y) + " h ".concat(radius - width) + " q -".concat(radius, " 0 -").concat(radius, " ").concat(radius) + " v ".concat(height - 2 * radius) + " q 0 ".concat(radius, " ").concat(radius, " ").concat(radius) + " h ".concat(width - radius) + " ".concat(lineClose);
}
;// ./src/js/nv/utils/bar_radius_helper.js
var DEFAULT_BAR_RADIUS = 2;
var DEFAULT_BAR_WIDTH = 16;
var SMALL_BAR_RADIUS_FACTOR = DEFAULT_BAR_WIDTH / DEFAULT_BAR_RADIUS;
function getBarRadius(d, data, stacked, barWidth, strokeWidth) {
  if (stacked && d.series + 1 !== data.length) {
    return 0;
  }
  var totalWidth = barWidth + strokeWidth;
  var barRadius = DEFAULT_BAR_RADIUS / strokeWidth;
  if (totalWidth < DEFAULT_BAR_WIDTH) {
    barRadius = totalWidth / SMALL_BAR_RADIUS_FACTOR / strokeWidth;
  }
  return barRadius;
}
;// ./node_modules/d3-scale/node_modules/d3-array/src/range.js
/* harmony default export */ function d3_array_src_range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

;// ./node_modules/d3-scale/src/band.js




function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = d3_array_src_range(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function band_point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

;// ./src/js/nv/utils/stack_layout_helper.js


var stackLayout = function stackLayout() {
  var values = d3_identity,
    order = d3_layout_stackOrderDefault,
    offset = d3_layout_stackOffsetZero,
    out = d3_layout_stackOut,
    x = d3_layout_stackX,
    y = d3_layout_stackY;
  function stack(data, index) {
    if (!(n = data.length)) {
      return data;
    }
    var series = data.map(function (d, i) {
      return values.call(stack, d, i);
    });
    var points = series.map(function (d) {
      return d.map(function (v, i) {
        return [x.call(stack, v, i), y.call(stack, v, i)];
      });
    });
    var orders = order.call(stack, points, index);
    series = permute(series, orders);
    points = permute(points, orders);
    var offsets = offset.call(stack, points, index);
    var m = series[0].length,
      n,
      i,
      j,
      o;
    for (j = 0; j < m; ++j) {
      out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
      for (i = 1; i < n; ++i) {
        out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
      }
    }
    return data;
  }
  stack.values = function (x) {
    if (!arguments.length) {
      return values;
    }
    values = x;
    return stack;
  };
  stack.order = function (x) {
    if (!arguments.length) {
      return order;
    }
    order = typeof x === 'function' ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
    return stack;
  };
  stack.offset = function (x) {
    if (!arguments.length) {
      return offset;
    }
    offset = typeof x === 'function' ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
    return stack;
  };
  stack.x = function (z) {
    if (!arguments.length) {
      return x;
    }
    x = z;
    return stack;
  };
  stack.y = function (z) {
    if (!arguments.length) {
      return y;
    }
    y = z;
    return stack;
  };
  stack.out = function (z) {
    if (!arguments.length) {
      return out;
    }
    out = z;
    return stack;
  };
  return stack;
};
function d3_layout_stackX(d) {
  return d.x;
}
function d3_layout_stackY(d) {
  return d.y;
}
function d3_layout_stackOut(d, y0, y) {
  d.y0 = y0;
  d.y = y;
}
var d3_layout_stackOrders = d3.map({
  'inside-out': function insideOut(data) {
    var n = data.length,
      i,
      j,
      max = data.map(d3_layout_stackMaxIndex),
      sums = data.map(d3_layout_stackReduceSum),
      index = d3.range(n).sort(function (a, b) {
        return max[a] - max[b];
      }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];
    for (i = 0; i < n; ++i) {
      j = index[i];
      if (top < bottom) {
        top += sums[j];
        tops.push(j);
      } else {
        bottom += sums[j];
        bottoms.push(j);
      }
    }
    return bottoms.reverse().concat(tops);
  },
  'reverse': function reverse(data) {
    return d3.range(data.length).reverse();
  },
  'default': d3_layout_stackOrderDefault
});
var d3_layout_stackOffsets = d3.map({
  'silhouette': function silhouette(data) {
    var n = data.length,
      m = data[0].length,
      sums = [],
      max = 0,
      i,
      j,
      o,
      y0 = [];
    for (j = 0; j < m; ++j) {
      for (i = 0, o = 0; i < n; i++) {
        o += data[i][j][1];
      }
      if (o > max) {
        max = o;
      }
      sums.push(o);
    }
    for (j = 0; j < m; ++j) {
      y0[j] = (max - sums[j]) / 2;
    }
    return y0;
  },
  'wiggle': function wiggle(data) {
    var n = data.length,
      x = data[0],
      m = x.length,
      i,
      j,
      k,
      s1,
      s2,
      s3,
      dx,
      o,
      o0,
      y0 = [];
    y0[0] = o = o0 = 0;
    for (j = 1; j < m; ++j) {
      for (i = 0, s1 = 0; i < n; ++i) {
        s1 += data[i][j][1];
      }
      for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
        for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
          s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
        }
        s2 += s3 * data[i][j][1];
      }
      y0[j] = o -= s1 ? s2 / s1 * dx : 0;
      if (o < o0) {
        o0 = o;
      }
    }
    for (j = 0; j < m; ++j) {
      y0[j] -= o0;
    }
    return y0;
  },
  'expand': function expand(data) {
    var n = data.length,
      m = data[0].length,
      k = 1 / n,
      i,
      j,
      o,
      y0 = [];
    for (j = 0; j < m; ++j) {
      for (i = 0, o = 0; i < n; i++) {
        o += data[i][j][1];
      }
      if (o) {
        for (i = 0; i < n; i++) {
          data[i][j][1] /= o;
        }
      } else {
        for (i = 0; i < n; i++) {
          data[i][j][1] = k;
        }
      }
    }
    for (j = 0; j < m; ++j) {
      y0[j] = 0;
    }
    return y0;
  },
  'zero': d3_layout_stackOffsetZero
});
function d3_layout_stackOrderDefault(data) {
  return src_range(data.length);
}
function d3_layout_stackOffsetZero(data) {
  var j = -1,
    m = data[0].length,
    y0 = [];
  while (++j < m) {
    y0[j] = 0;
  }
  return y0;
}
function d3_layout_stackMaxIndex(array) {
  var i = 1,
    j = 0,
    v = array[0][1],
    k,
    n = array.length;
  for (; i < n; ++i) {
    if ((k = array[i][1]) > v) {
      j = i;
      v = k;
    }
  }
  return j;
}
function d3_layout_stackReduceSum(d) {
  return d.reduce(d3_layout_stackSum, 0);
}
function d3_layout_stackSum(p, d) {
  return p + d[1];
}
function d3_identity(d) {
  return d;
}
;// ./src/js/nv/models/multiBar.js
function multiBar_typeof(o) { "@babel/helpers - typeof"; return multiBar_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, multiBar_typeof(o); }







function multiBar_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function multiBar_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? multiBar_ownKeys(Object(t), !0).forEach(function (r) { multiBar_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : multiBar_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function multiBar_defineProperty(e, r, t) { return (r = multiBar_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function multiBar_toPropertyKey(t) { var i = multiBar_toPrimitive(t, "string"); return "symbol" == multiBar_typeof(i) ? i : i + ""; }
function multiBar_toPrimitive(t, r) { if ("object" != multiBar_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != multiBar_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













var REGION_INTERACTIVE_UPDATE_DELAY = constants_Constants.REGION_INTERACTIVE_UPDATE_DELAY;
var multiBar = function multiBar(nv) {
  nv.models.multiBar = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 960,
      height = 500,
      x = band(),
      y = linear_linear(),
      id = Math.floor(Math.random() * 10000),
      container = null,
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      forceY = [0],
      clipEdge = false,
      stacked = false,
      stackOffset = 'zero',
      color = nv.upgradedUtils.defaultColor(),
      hideable = false,
      duration = 500,
      xDomain,
      yDomain,
      yDomainMin,
      yDomainMax,
      xRange,
      yRange,
      groupPaddingRatio = 0.1,
      outerPaddingRatio = 0,
      dispatch = src_dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd', 'selectedDataPointNotFound'),
      showValues = false,
      valuePadding = 15,
      valueFormat = format(',.2f'),
      padBefore = 0,
      padAfter = 0,
      disableInteraction = false,
      barWidth = 16,
      columnWidth,
      innerPaddingWidth = 2,
      strokeWidth = 2,
      useRegionInteraction = false,
      widgetAsFilter = false,
      interactionDispatch,
      selectedDataPoint,
      isCurrentChartSelected;
    var x0,
      y0,
      timeoutID,
      renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var _this = this;
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        var nonStackableCount = 0;
        if (hideable && data.length) {
          hideable = [{
            values: data[0].values.map(function (d) {
              return {
                x: d.x,
                y: 0,
                series: d.series,
                size: 0.01
              };
            })
          }];
        }
        if (stacked) {
          var parsed = stackLayout().values(function (d) {
            return d.values;
          }).y(getY)(!data.length && hideable ? hideable : data);
          parsed.forEach(function (series, i) {
            if (series.nonStackable) {
              data[i].nonStackableSeries = nonStackableCount++;
              parsed[i] = data[i];
            } else {
              if (i > 0 && parsed[i - 1].nonStackable) {
                parsed[i].values.map(function (d, j) {
                  d.y0 -= parsed[i - 1].values[j].y;
                  d.y1 = d.y0 + d.y;
                });
              }
            }
          });
          data = parsed;
        }
        data.forEach(function (series, i) {
          series.values.forEach(function (point) {
            point.series = i;
            point.key = series.key;
          });
        });
        if (stacked) {
          data[0].values.map(function (d, i) {
            var posBase = 0,
              negBase = 0;
            data.map(function (d, idx) {
              if (!data[idx].nonStackable) {
                var f = d.values[i];
                f.size = Math.abs(f.y);
                if (f.y < 0) {
                  f.y1 = negBase;
                  negBase = negBase - f.size;
                } else {
                  f.y1 = f.size + posBase;
                  posBase = posBase + f.size;
                }
              }
            });
          });
        }
        var seriesData = xDomain && yDomain ? [] : data.map(function (d, idx) {
          return d.values.map(function (d, i) {
            return {
              x: getX(d, i),
              y: getY(d, i),
              y0: d.y0,
              y1: d.y1,
              idx: idx
            };
          });
        });
        xDomain = xDomain || merge(seriesData).map(function (_ref) {
          var x = _ref.x;
          return x;
        });
        x.domain(xDomain);
        if (barWidth === 1) {
          x.range(xRange || [0, availableWidth]).paddingInner(groupPaddingRatio).paddingOuter(outerPaddingRatio);
        } else {
          x.rangeRound(xRange || [0, availableWidth]).paddingInner(groupPaddingRatio).paddingOuter(outerPaddingRatio);
        }
        var _yDomain = src_extent(merge(seriesData).map(function (d) {
          var domain = d.y;
          if (stacked && !data[d.idx].nonStackable) {
            if (d.y > 0) {
              domain = d.y1;
            } else {
              domain = d.y1 + d.y;
            }
          }
          return domain;
        }).concat(forceY));
        if (nv.upgradedUtils.isNumeric(yDomainMin)) {
          _yDomain[0] = parseFloat(yDomainMin);
        }
        if (nv.upgradedUtils.isNumeric(yDomainMax)) {
          _yDomain[1] = parseFloat(yDomainMax);
        }
        y.domain(yDomain || _yDomain);
        y.rangeRound(yRange || [availableHeight, 0]);
        y.clamp(true);
        ensureDomain(x);
        ensureDomain(y);
        x0 = x0 || x;
        y0 = y0 || y;
        var wrap = container.selectAll('g.nv-wrap.nv-multibar').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multibar').classed('interactive', !disableInteraction);
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var wrapMergeSelection = wrapEnter.merge(wrap);
        var gMergeSelection = gEnter.merge(g);
        gEnter.append('g').attr('class', 'nv-groups');
        wrapMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
        wrapMergeSelection.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
        gMergeSelection.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
        var group = wrapMergeSelection.select('.nv-groups');
        var patternContainer = group.append('defs').node();
        var groups = group.selectAll('.nv-group').data(function (d) {
          return d;
        }, function (d, i) {
          return i;
        });
        var groupsMergeSelection = groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).merge(groups);
        groups.exit().style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).remove();
        groupsMergeSelection.attr('class', function (d, i) {
          return 'nv-group nv-series-' + i;
        }).classed('hover', function (d) {
          return d.hover;
        }).style('fill', function (d, i) {
          var defaultColorFill = color(d, i);
          return nv.utils.patternService.getDataFill(patternContainer, d, defaultColorFill);
        });
        groupsMergeSelection.watchTransition(renderWatch, 'multibar groups').style('stroke-opacity', 1).style('fill-opacity', 0.75);
        var getBarX = function getBarX(d) {
          return stacked && !data[d.series].nonStackable ? nv.chartHelpers.upgradedGetStackedBarPosition(x, barWidth) : nv.chartHelpers.upgradedGetBarPosition(x, barWidth, innerPaddingWidth, d, data, padBefore, padAfter);
        };
        var getBarY = function getBarY(d, i) {
          return stacked && !data[d.series].nonStackable ? y(d.y1) : y(Math.max(0, getY(d, i)));
        };
        var yZero = y(0);
        var getBarHeight = function getBarHeight(d, i) {
          return stacked && !data[d.series].nonStackable ? Math.max(Math.abs(y(d.y + d.y0) - y(d.y0)), 0) : Math.max(Math.abs(y(getY(d, i)) - yZero), 0);
        };
        var getBarDimensions = function getBarDimensions(d, i) {
          return {
            strokeWidth: strokeWidth,
            width: barWidth,
            height: getBarHeight(d, i),
            x: getBarX(d, i),
            y: getBarY(d, i),
            radius: getBarRadius(d, data, stacked, barWidth, strokeWidth)
          };
        };
        var bars = groupsMergeSelection.selectAll('g.nv-bar').data(function (series) {
          var values = hideable && !data.length ? hideable.values : nv.utils.patternService.applyPatternToValues(series.pattern, series.values);
          return values.map(function (d, i) {
            return multiBar_objectSpread(multiBar_objectSpread({}, d), {}, {
              barDimensions: getBarDimensions(d, i),
              index: i
            });
          });
        });
        var barsEnter = bars.enter().append('g').attr('class', function (d, i) {
          return "nv-bar nv-bar-index-".concat(i);
        }).attr('id', function (d, i) {
          return "nv-bar-".concat(id, "-series-").concat(d.series, "-index-").concat(i);
        });
        bars.exit().remove();
        barsEnter.append('path').attr('d', function (d) {
          return createVerticalBarPath(multiBar_objectSpread(multiBar_objectSpread({}, d.barDimensions), {}, {
            height: 0,
            y: y(0)
          }), d.series, 0, yZero, stacked);
        }).attr('aria-label', function (d, i) {
          var _d$label;
          return "".concat((_d$label = d.label) !== null && _d$label !== void 0 ? _d$label : d.x, " ").concat(valueFormat(getY(d, i), d));
        }).attr('role', 'img');
        barsEnter.append('g').attr('class', 'data-values').attr('aria-hidden', true);
        var barsMergeSelection = barsEnter.merge(bars);
        barsMergeSelection.attr('transform', function (d, i) {
          return "translate(".concat(x(getX(d, i)), ",0)");
        }).attr('fill', function (d) {
          if (!d.color) {
            d.color = color(d, d.series);
          }
          return nv.utils.patternService.getDataFill(patternContainer, d, d.color);
        }).attr('stroke', function (_ref2) {
          var color = _ref2.color;
          return color;
        }).attr('stroke-width', strokeWidth).classed('null', function (d, i) {
          return getY(d, i) === null;
        });
        barsMergeSelection.each(function (d, i) {
          var bar = src_select(this);
          var barDistance = stacked || data.length === 1 ? columnWidth : barWidth + innerPaddingWidth;
          bar.select('path').watchTransition(renderWatch, 'multibar paths', Math.min(250, duration)).delay(i * duration / data[0].values.length).attr('d', createVerticalBarPath(d.barDimensions, d.series, getY(d, i), yZero, stacked));
          bar.select('.data-values').call(upgradedDrawAuxiliaryData, {
            showValues: showValues,
            stacked: stacked,
            barDistance: barDistance
          }, {
            getY: getY,
            valueFormat: valueFormat
          });
        });
        var hideHighlightDataPoint = function hideHighlightDataPoint() {
          ['selected', 'hovered'].forEach(function (className) {
            container.selectAll(".".concat(className, "-group")).classed("".concat(className, "-group"), false);
            container.selectAll(".".concat(className, "-bar")).classed("".concat(className, "-bar"), false);
          });
        };
        var highlightSelectedDataPoint = function highlightSelectedDataPoint() {
          hideHighlightDataPoint();
          if (!isCurrentChartSelected) {
            container.select('.nv-groups').selectAll('.nv-group').classed('selected-group', true);
            return;
          }
          var dataPointFound = container.selectAll('.nv-bar').filter(function (d) {
            return d.id === selectedDataPoint.id && d.key === selectedDataPoint.key;
          });
          if (!dataPointFound.empty()) {
            container.select('.nv-groups').selectAll('.nv-group').classed('selected-group', true);
            dataPointFound.classed('selected-bar', true).style('stroke', function (_ref3) {
              var color = _ref3.color;
              return color;
            });
          } else {
            dispatch.call('selectedDataPointNotFound', _this, true);
          }
        };
        if (!widgetAsFilter) {
          selectedDataPoint = undefined;
        }
        if (selectedDataPoint && widgetAsFilter) {
          highlightSelectedDataPoint();
        } else {
          hideHighlightDataPoint();
        }
        var updateInteractiveLayer = function updateInteractiveLayer() {
          if (useRegionInteraction) {
            var showHighlights = function showHighlights(evt) {
              container.select('.nv-groups').selectAll('.nv-group').classed('hovered-group', true);
              container.select('.nv-groups').selectAll(".nv-bar-index-".concat(evt.dataPoint.x)).classed('hovered-bar', true).style('stroke', function (_ref4) {
                var color = _ref4.color;
                return color;
              });
            };
            var hideHighlights = function hideHighlights() {
              container.selectAll('.hovered-group').classed('hovered-group', false);
              container.selectAll('.hovered-bar').classed('hovered-bar', false);
            };
            interactionDispatch.on('mouseOverRegion.hover', showHighlights);
            interactionDispatch.on('mouseOutRegion.hover', hideHighlights);
            var barsEventList = [{
              incoming: 'regionClick',
              outgoing: 'click'
            }];
            registerSubdivisionEvents(interactionDispatch, container.selectAll('.nv-bar').nodes(), barsEventList);
          }
        };
        if (!disableInteraction) {
          barsMergeSelection.on('mouseover', function (event, d) {
            src_select(this).classed('hover', true);
            dispatch.call('elementMouseover', this, {
              data: d,
              index: d.index,
              color: src_select(this).style('fill')
            });
          }).on('mouseout', function (event, d) {
            src_select(this).classed('hover', false);
            dispatch.call('elementMouseout', this, {
              data: d,
              index: d.index,
              color: src_select(this).style('fill')
            });
          }).on('mousemove', function (event, d) {
            dispatch.call('elementMousemove', this, {
              data: d,
              index: d.index,
              color: src_select(this).style('fill')
            });
          }).on('click', function (event, d) {
            var isSameDataPoint = areDataPointsEqual(selectedDataPoint, d);
            if (widgetAsFilter && !isSameDataPoint) {
              selectedDataPoint = d;
              isCurrentChartSelected = true;
            } else {
              selectedDataPoint = undefined;
              isCurrentChartSelected = false;
            }
            dispatch.call('elementClick', this, {
              data: d,
              index: d.index,
              color: src_select(this).style('fill'),
              event: event,
              element: this
            });
            event.stopPropagation();
          }).on('dblclick', function (event, d) {
            dispatch.call('elementDblClick', this, {
              data: d,
              index: d.index,
              color: src_select(this).style('fill')
            });
            event.stopPropagation();
          });
        }
        clearTimeout(timeoutID);
        timeoutID = setTimeout(updateInteractiveLayer, REGION_INTERACTIVE_UPDATE_DELAY);
        x0 = x.copy();
        y0 = y.copy();
      });
      renderWatch.renderEnd('multibar immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      yDomainMin: {
        get: function get() {
          return yDomainMin;
        },
        set: function set(_) {
          yDomainMin = _;
        }
      },
      yDomainMax: {
        get: function get() {
          return yDomainMax;
        },
        set: function set(_) {
          yDomainMax = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      forceY: {
        get: function get() {
          return forceY;
        },
        set: function set(_) {
          forceY = _;
        }
      },
      stacked: {
        get: function get() {
          return stacked;
        },
        set: function set(_) {
          stacked = _;
        }
      },
      stackOffset: {
        get: function get() {
          return stackOffset;
        },
        set: function set(_) {
          stackOffset = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      hideable: {
        get: function get() {
          return hideable;
        },
        set: function set(_) {
          hideable = _;
        }
      },
      groupPaddingRatio: {
        get: function get() {
          return groupPaddingRatio;
        },
        set: function set(_) {
          groupPaddingRatio = _;
        }
      },
      outerPaddingRatio: {
        get: function get() {
          return outerPaddingRatio;
        },
        set: function set(_) {
          outerPaddingRatio = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      padBefore: {
        get: function get() {
          return padBefore;
        },
        set: function set(_) {
          padBefore = _;
        }
      },
      padAfter: {
        get: function get() {
          return padAfter;
        },
        set: function set(_) {
          padAfter = _;
        }
      },
      valuePadding: {
        get: function get() {
          return valuePadding;
        },
        set: function set(_) {
          valuePadding = _;
        }
      },
      disableInteraction: {
        get: function get() {
          return disableInteraction;
        },
        set: function set(_) {
          disableInteraction = _;
        }
      },
      barWidth: {
        get: function get() {
          return barWidth;
        },
        set: function set(_) {
          barWidth = _;
        }
      },
      columnWidth: {
        get: function get() {
          return columnWidth;
        },
        set: function set(_) {
          columnWidth = _;
        }
      },
      innerPaddingWidth: {
        get: function get() {
          return innerPaddingWidth;
        },
        set: function set(_) {
          innerPaddingWidth = _;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
        }
      },
      widgetAsFilter: {
        get: function get() {
          return widgetAsFilter;
        },
        set: function set(_) {
          widgetAsFilter = _;
        }
      },
      selectedDataPoint: {
        get: function get() {
          return selectedDataPoint;
        },
        set: function set(_) {
          selectedDataPoint = _;
        }
      },
      isCurrentChartSelected: {
        get: function get() {
          return isCurrentChartSelected;
        },
        set: function set(_) {
          isCurrentChartSelected = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
        }
      }
    });
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/multiBarChart.js


var multiBarChart = function multiBarChart(nv) {
  nv.models.multiBarChart = function () {
    var multibar = nv.models.multiBar(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      controls = nv.models.legend(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 20,
        bottom: 50,
        left: 60
      },
      width = null,
      height = null,
      color = nv.utils.defaultColor(),
      showControls = true,
      controlLabels = {},
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      reduceXTicks = false,
      staggerLabels = false,
      wrapLabels = false,
      rotateLabels = 0,
      x,
      y,
      state = nv.utils.state(),
      defaultState = null,
      noData = null,
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd'),
      controlWidth = function controlWidth() {
        return showControls ? 180 : 0;
      },
      duration = 250,
      useRegionInteraction = false,
      widgetAsFilter = false,
      interactionDispatch;
    state.stacked = false;
    multibar.stacked(false);
    xAxis.orient('bottom').tickPadding(8).showMaxMin(false).tickFormat(function (d) {
      return d;
    });
    yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickFormat(d3.format(',.1f'));
    tooltip.duration(0).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    }).headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    });
    controls.updateState(false);
    var renderWatch = nv.utils.renderWatch(dispatch);
    var stacked = false;
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          }),
          stacked: stacked
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.stacked !== undefined) {
          stacked = state.stacked;
        }
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(multibar);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      multibar.valueFormat(yAxis.tickFormat());
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = multibar.xScale();
        y = multibar.yScale();
        var wrap = container.selectAll('g.nv-wrap.nv-multiBarWithLegend').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multiBarWithLegend').append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis');
        gEnter.append('g').attr('class', 'nv-barsWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        gEnter.append('g').attr('class', 'nv-controlsWrap');
        if (showLegend) {
          legend.width(availableWidth - controlWidth());
          g.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          g.select('.nv-legendWrap').attr('transform', 'translate(' + controlWidth() + ',' + -margin.top + ')');
        }
        if (showControls) {
          var controlsData = [{
            key: controlLabels.grouped || 'Grouped',
            disabled: multibar.stacked()
          }, {
            key: controlLabels.stacked || 'Stacked',
            disabled: !multibar.stacked()
          }];
          controls.width(controlWidth()).color(['#444', '#444', '#444']);
          g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        multibar.width(availableWidth).height(availableHeight).color(data.map(function (d, i) {
          return d.color || color(d, i);
        }).filter(function (d, i) {
          return !data[i].disabled;
        }));
        var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function (d) {
          return !d.disabled;
        }));
        barsWrap.call(multibar);
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.utils.calcTicksX(availableWidth / 100, data)).tickSize(0);
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
          g.select('.nv-x.nv-axis').call(xAxis);
          var xTicks = g.select('.nv-x.nv-axis > g').selectAll('g');
          xTicks.selectAll('line, text').style('opacity', 1);
          if (staggerLabels) {
            var getTranslate = function getTranslate(x, y) {
              return 'translate(' + x + ',' + y + ')';
            };
            var staggerUp = 5,
              staggerDown = 17;
            xTicks.selectAll('text').attr('transform', function (d, i, j) {
              return getTranslate(0, j % 2 === 0 ? staggerUp : staggerDown);
            });
            var totalInBetweenTicks = d3.selectAll('.nv-x.nv-axis .nv-wrap g g text')[0].length;
            g.selectAll('.nv-x.nv-axis .nv-axisMaxMin text').attr('transform', function (d, i) {
              return getTranslate(0, i === 0 || totalInBetweenTicks % 2 !== 0 ? staggerDown : staggerUp);
            });
          }
          if (wrapLabels) {
            g.selectAll('.tick text').call(nv.utils.wrapTicks, chart.xAxis.rangeBand(), 2);
          }
          if (reduceXTicks) {
            xTicks.filter(function (d, i) {
              return i % Math.ceil(data[0].values.length / (availableWidth / 100)) !== 0;
            }).selectAll('text, line').remove();
          }
          if (rotateLabels) {
            xTicks.selectAll('.tick text').attr('transform', 'rotate(' + rotateLabels + ' 0,0)').style('text-anchor', rotateLabels > 0 ? 'start' : 'end');
          }
          g.select('.nv-x.nv-axis').selectAll('g.nv-axisMaxMin text').style('opacity', 1);
        } else {
          g.select('.nv-x.nv-axis').html('');
        }
        if (showYAxis) {
          yAxis.scale(y)._ticks(nv.utils.calcTicksY(availableHeight / 36, data)).tickSize(-availableWidth, 0);
          g.select('.nv-y.nv-axis').call(yAxis);
        } else {
          g.select('.nv-y.nv-axis').html('');
        }
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        controls.dispatch.on('legendClick', function (d) {
          if (!d.disabled) {
            return;
          }
          controlsData = controlsData.map(function (s) {
            s.disabled = true;
            return s;
          });
          d.disabled = false;
          switch (d.key) {
            case 'Grouped':
            case controlLabels.grouped:
              multibar.stacked(false);
              break;
            case 'Stacked':
            case controlLabels.stacked:
              multibar.stacked(true);
              break;
          }
          state.stacked = multibar.stacked();
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          if (typeof e.stacked !== 'undefined') {
            multibar.stacked(e.stacked);
            state.stacked = e.stacked;
            stacked = e.stacked;
          }
          chart.update();
        });
        multibar.dispatch.on('elementMouseover.tooltip', function (evt) {
          evt.value = chart.x()(evt.data);
          evt.series = {
            key: evt.data.key,
            value: chart.y()(evt.data),
            color: evt.color
          };
          tooltip.data(evt).hidden(false);
        });
        multibar.dispatch.on('elementMouseout.tooltip', function () {
          tooltip.hidden(true);
        });
        multibar.dispatch.on('elementMousemove.tooltip', function () {
          tooltip();
        });
      });
      renderWatch.renderEnd('multibarchart immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.multibar = multibar;
    chart.legend = legend;
    chart.controls = controls;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.state = state;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showControls: {
        get: function get() {
          return showControls;
        },
        set: function set(_) {
          showControls = _;
        }
      },
      controlLabels: {
        get: function get() {
          return controlLabels;
        },
        set: function set(_) {
          controlLabels = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      reduceXTicks: {
        get: function get() {
          return reduceXTicks;
        },
        set: function set(_) {
          reduceXTicks = _;
        }
      },
      rotateLabels: {
        get: function get() {
          return rotateLabels;
        },
        set: function set(_) {
          rotateLabels = _;
        }
      },
      staggerLabels: {
        get: function get() {
          return staggerLabels;
        },
        set: function set(_) {
          staggerLabels = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = !!_;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          multibar.duration(duration);
          xAxis.duration(duration);
          yAxis.duration(duration);
          renderWatch.reset(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          legend.color(color);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(rightAlignYAxis ? 'right' : 'left');
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
          multibar.useRegionInteraction(_);
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
          multibar.interactionDispatch(_);
        }
      },
      widgetAsFilter: {
        get: function get() {
          return widgetAsFilter;
        },
        set: function set(_) {
          widgetAsFilter = _;
          multibar.widgetAsFilter(_);
        }
      }
    });
    nv.utils.inheritOptions(chart, multibar);
    nv.utils.initOptions(chart);
    return chart;
  };
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__(9087);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__(8872);
;// ./src/js/nv/models/multiBarHorizontal.js
function multiBarHorizontal_typeof(o) { "@babel/helpers - typeof"; return multiBarHorizontal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, multiBarHorizontal_typeof(o); }









function multiBarHorizontal_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function multiBarHorizontal_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? multiBarHorizontal_ownKeys(Object(t), !0).forEach(function (r) { multiBarHorizontal_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : multiBarHorizontal_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function multiBarHorizontal_defineProperty(e, r, t) { return (r = multiBarHorizontal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function multiBarHorizontal_toPropertyKey(t) { var i = multiBarHorizontal_toPrimitive(t, "string"); return "symbol" == multiBarHorizontal_typeof(i) ? i : i + ""; }
function multiBarHorizontal_toPrimitive(t, r) { if ("object" != multiBarHorizontal_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != multiBarHorizontal_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












var multiBarHorizontal = function multiBarHorizontal(nv) {
  nv.models.multiBarHorizontal = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 960,
      height = 500,
      id = Math.floor(Math.random() * 10000),
      container = null,
      x = band(),
      y = linear_linear(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      forceY = [0],
      clipEdge = false,
      color = nv.upgradedUtils.defaultColor(),
      stacked = false,
      showValues = false,
      valuePadding = 0,
      groupPaddingRatio = 0.1,
      outerPaddingRatio = 0,
      columnWidth = 0,
      valueFormat = format(',.2f'),
      xDomain,
      yDomain,
      yDomainMin,
      yDomainMax,
      xRange,
      yRange,
      duration = 250,
      disableInteraction = false,
      dispatch = src_dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd'),
      interactionDispatch,
      barWidth = 24,
      innerPaddingWidth = 4,
      strokeWidth = 2,
      barWidthThreshold = 10,
      useRegionInteraction = false,
      widgetAsFilter = false;
    var x0, y0;
    var renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    var timeoutID;
    var selectedDataPoint;
    function getLabelXCoordinate(d, i, offset) {
      if (stacked) {
        return getY(d, i) < 0 ? (y(0) - y(getY(d, i))) / 2 : (y(getY(d, i)) - y(0)) / 2 + offset;
      } else {
        return getY(d, i) < 0 ? -4 : y(getY(d, i)) - y(0) + 4 + offset;
      }
    }
    function setupIconBackground(backgroundContainer, iconWidth, fontSize) {
      backgroundContainer.attr('width', iconWidth).attr('height', fontSize).attr('rx', '2px').attr('y', backgroundContainer.attr('y') - fontSize / 2).style('fill', '#FFFFFF');
    }
    function setupDataLabelSettings(d, index, container) {
      var textContainer = container.select('text.value-text'),
        backgroundContainer = container.select('rect.icon-background'),
        textWidth = textContainer.node().getComputedTextLength(),
        textOffset = 0,
        iconWidth = 0,
        assumedFontSize = 12,
        maxFontSize = assumedFontSize;
      if (d.customIcon) {
        var iconContainer = container.select('text.icon'),
          iconPadding = 3,
          iconOffset = 0;
        iconWidth = iconContainer.node().getComputedTextLength();
        d.totalLabelWidth = textWidth + iconWidth + iconPadding;
        if (stacked) {
          iconPadding = 5;
          iconOffset = -(textWidth + iconPadding) / 2;
          textOffset = (iconWidth + iconPadding) / 2;
          maxFontSize = Math.max(assumedFontSize, d.customIcon.fontSize);
          setupIconBackground(backgroundContainer, iconWidth, maxFontSize);
        } else {
          textOffset = iconWidth + iconPadding;
        }
        d.customIcon.x = getLabelXCoordinate(d, index, iconOffset);
        d.textX = getLabelXCoordinate(d, index, textOffset);
      } else {
        d.totalLabelWidth = textWidth;
        d.textX = getLabelXCoordinate(d, index, textOffset);
      }
    }
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        if (stacked) {
          data = stackLayout().values(function (d) {
            return d.values;
          }).y(getY)(data);
        }
        data.forEach(function (series, i) {
          series.values.forEach(function (point) {
            point.series = i;
            point.key = series.key;
          });
        });
        if (stacked) {
          data[0].values.map(function (d, i) {
            var posBase = 0,
              negBase = 0;
            data.map(function (d) {
              var f = d.values[i];
              f.size = Math.abs(f.y);
              if (f.y < 0) {
                f.y1 = negBase - f.size;
                negBase = negBase - f.size;
              } else {
                f.y1 = posBase;
                posBase = posBase + f.size;
              }
            });
          });
        }
        var seriesData = xDomain && yDomain ? [] : data.map(function (d) {
          return d.values.map(function (d, i) {
            return {
              x: getX(d, i),
              y: getY(d, i),
              y0: d.y0,
              y1: d.y1
            };
          });
        });
        var domainData = xDomain || merge(seriesData).map(function (_ref) {
          var x = _ref.x;
          return x;
        });
        if (availableHeight < domainData.length) {
          x.domain(domainData).range(xRange || [0, availableHeight]).paddingInner(groupPaddingRatio).paddingOuter(outerPaddingRatio);
        } else {
          x.domain(domainData).rangeRound(xRange || [0, availableHeight]).paddingInner(groupPaddingRatio).paddingOuter(outerPaddingRatio);
        }
        var _yDomain = src_extent(merge(seriesData).map(function (d) {
          return stacked ? d.y > 0 ? d.y1 + d.y : d.y1 : d.y;
        }).concat(forceY));
        if (nv.upgradedUtils.isNumeric(yDomainMin)) {
          y.clamp(true);
          _yDomain[0] = parseFloat(yDomainMin);
        }
        if (nv.upgradedUtils.isNumeric(yDomainMax)) {
          y.clamp(true);
          _yDomain[1] = parseFloat(yDomainMax);
        }
        y.domain(yDomain || _yDomain);
        var _yRange = yRange || [y.domain()[0] < 0 ? valuePadding : 0, availableWidth - (y.domain()[1] > 0 ? valuePadding : 0)];
        y.rangeRound(_yRange);
        x0 = x0 || x;
        y0 = y0 || linear_linear().domain(y.domain()).range([y(0), y(0)]);
        var wrap = src_select(this).selectAll('g.nv-wrap.nv-multibarHorizontal').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multibarHorizontal').classed('interactive', !disableInteraction);
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var wrapMerge = wrapEnter.merge(wrap);
        var gMerge = gEnter.merge(g);
        gMerge.append('g').attr('class', 'nv-groups');
        wrapMerge.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var clipPadding = showValues ? constants_Constants.TOP_PADDING : 0;
        var clipId = "nv-edge-clip-".concat(id);
        defsEnter.append('clipPath').attr('id', clipId).append('rect');
        wrapMerge.select("#".concat(clipId, " rect")).attr('width', availableWidth + clipPadding).attr('height', availableHeight + clipPadding).attr('y', -clipPadding);
        gMerge.attr('clip-path', clipEdge ? "url(#".concat(clipId, ")") : '');
        var group = wrapMerge.select('.nv-groups');
        var patternContainer = group.append('defs').node();
        var groups = group.selectAll('.nv-group').data(function (d) {
          return d;
        }, function (d, i) {
          return i;
        });
        var groupsEnter = groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
        groups.exit().style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).remove();
        groupsEnter.merge(groups).attr('class', function (d, i) {
          return 'nv-group nv-series-' + i;
        }).classed('hover', function (d) {
          return d.hover;
        }).style('fill', function (d, i) {
          var defaultColorFill = color(d, i);
          return nv.utils.patternService.getDataFill(patternContainer, d, defaultColorFill);
        });
        groupsEnter.merge(groups).watchTransition(renderWatch, 'multibarhorizontal: groups').style('stroke-opacity', 1).style('fill-opacity', 0.75);
        var xZero = y(0);
        var getBarX = function getBarX(d, i) {
          return stacked ? y(d.y1) : getY(d, i) < 0 ? y(getY(d, i)) : xZero;
        };
        var getBarY = function getBarY(d) {
          return stacked ? nv.chartHelpers.upgradedGetStackedBarPosition(x, barWidth) : nv.chartHelpers.upgradedGetBarPosition(x, barWidth, innerPaddingWidth, d, data);
        };
        var getBarWidth = function getBarWidth(d, i) {
          return stacked ? Math.abs(y(getY(d, i) + d.y0) - y(d.y0)) || 0 : Math.max(Math.abs(y(getY(d, i)) - y(0)), 1) || 0;
        };
        var getBarDimensions = function getBarDimensions(d, i) {
          return {
            strokeWidth: strokeWidth,
            width: getBarWidth(d, i),
            height: barWidth,
            x: getBarX(d, i),
            y: getBarY(d, i),
            radius: getBarRadius(d, data, stacked, barWidth, strokeWidth)
          };
        };
        var bars = groupsEnter.merge(groups).selectAll('g.nv-bar').data(function (d) {
          var values = nv.utils.patternService.applyPatternToValues(d.pattern, d.values);
          return values.map(function (d, i) {
            return multiBarHorizontal_objectSpread(multiBarHorizontal_objectSpread({}, d), {}, {
              barDimensions: getBarDimensions(d, i),
              index: i
            });
          });
        });
        bars.exit().remove();
        var barsEnter = bars.enter().append('g').attr('class', function (d, i) {
          return "nv-bar nv-bar-index-".concat(i);
        }).attr('id', function (d, i) {
          return "nv-bar-".concat(id, "-series-").concat(d.series, "-index-").concat(i);
        }).attr('transform', function (d, i) {
          return "translate(0,".concat(x(getX(d, i)), ")");
        }).attr('role', 'img').attr('aria-label', function (d, i) {
          var _d$label;
          return "".concat((_d$label = d.label) !== null && _d$label !== void 0 ? _d$label : d.x, " ").concat(valueFormat(getY(d, i), d));
        });
        barsEnter.append('path').attr('d', function (_ref2) {
          var barDimensions = _ref2.barDimensions,
            series = _ref2.series;
          return createHorizontalBarPath(multiBarHorizontal_objectSpread(multiBarHorizontal_objectSpread({}, barDimensions), {}, {
            width: 0,
            x: y(0)
          }), series, 0, xZero, stacked);
        });
        var browserInfo = navigator.userAgent;
        var isChromium117 = browserInfo.includes('Chrome/117');
        barsEnter.append('g').attr('class', 'data-values').attr('aria-hidden', !isChromium117);
        barsEnter.merge(bars).attr('transform', function (d, i) {
          return "translate(0, ".concat(x(getX(d, i)), ")");
        }).style('fill', function (d) {
          if (!d.color) {
            d.color = color(d, d.series);
          }
          return nv.utils.patternService.getDataFill(patternContainer, d, d.color);
        }).style('stroke', function (d) {
          return d.color;
        }).style('stroke-width', strokeWidth + 'px');
        barsEnter.merge(bars).each(function (d, i) {
          var bar = src_select(this);
          var barDistance = stacked || data.length === 1 ? columnWidth : barWidth + innerPaddingWidth;
          bar.select('path').watchTransition(renderWatch, 'multibarhorizontal: bars').attr('d', createHorizontalBarPath(d.barDimensions, d.series, getY(d, i), xZero, stacked));
          bar.select('.data-values').call(upgradedDrawAuxiliaryData, {
            showValues: showValues,
            stacked: stacked,
            barDistance: barDistance,
            horizontal: true
          }, {
            getY: getY,
            valueFormat: valueFormat
          });
        });
        var hideHighlightDataPoint = function hideHighlightDataPoint() {
          ['selected', 'hovered'].forEach(function (className) {
            container.selectAll(".".concat(className, "-group")).classed("".concat(className, "-group"), false);
            container.selectAll(".".concat(className, "-bar")).classed("".concat(className, "-bar"), false);
          });
        };
        var highlightSelectedDataPoint = function highlightSelectedDataPoint() {
          hideHighlightDataPoint();
          var dataPointFound = container.selectAll('.nv-bar').filter(function (d) {
            return d.id === selectedDataPoint.id && d.key === selectedDataPoint.key;
          });
          if (!dataPointFound.empty()) {
            container.select('.nv-groups').selectAll('.nv-group').classed('selected-group', true);
            dataPointFound.classed('selected-bar', true).style('stroke', function (_ref3) {
              var color = _ref3.color;
              return color;
            });
          }
        };
        if (!widgetAsFilter) {
          selectedDataPoint = undefined;
        }
        if (selectedDataPoint && widgetAsFilter) {
          highlightSelectedDataPoint();
        } else {
          hideHighlightDataPoint();
        }
        var updateInteractiveLayer = function updateInteractiveLayer() {
          if (useRegionInteraction) {
            var showHighlights = function showHighlights(evt) {
              container.select('.nv-groups').selectAll('.nv-group').classed('hovered-group', true);
              container.select('.nv-groups').selectAll(".nv-bar-index-".concat(evt.dataPoint.subdivision)).classed('hovered-bar', true);
            };
            var hideHighlights = function hideHighlights() {
              container.selectAll('.hovered-group').classed('hovered-group', false);
              container.selectAll('.hovered-bar').classed('hovered-bar', false);
            };
            interactionDispatch.on('mouseOverRegion.hover', showHighlights);
            interactionDispatch.on('mouseOutRegion.hover', hideHighlights);
            var barsEventList = [{
              incoming: 'regionClick',
              outgoing: 'click'
            }];
            registerSubdivisionEvents(interactionDispatch, container.selectAll('.nv-bar').nodes(), barsEventList);
          }
        };
        if (!disableInteraction) {
          var dispatcher = function dispatcher(eventName, action) {
            return function (d, data) {
              if (eventName === 'elementClick') {
                var isSameDataPoint = areDataPointsEqual(selectedDataPoint, data);
                if (widgetAsFilter && !isSameDataPoint) {
                  selectedDataPoint = data;
                } else {
                  selectedDataPoint = undefined;
                }
              }
              dispatch.call(eventName, this, {
                data: data,
                index: data.index,
                color: data.color
              });
              action && action(this, data, data.index);
            };
          };
          var addHover = function addHover(el) {
            return el.classList.add('hover');
          };
          var removeHover = function removeHover(el) {
            return el.classList.remove('hover');
          };
          var stopEventPropagation = function stopEventPropagation() {
            return event && event.stopPropagation();
          };
          barsEnter.merge(bars).on('mouseover', dispatcher('elementMouseover', addHover)).on('mouseout', dispatcher('elementMouseout', removeHover)).on('mousemove', dispatcher('elementMousemove')).on('click', dispatcher('elementClick', stopEventPropagation)).on('dblclick', dispatcher('elementDblClick', stopEventPropagation));
        }
        clearTimeout(timeoutID);
        timeoutID = setTimeout(updateInteractiveLayer, constants_Constants.REGION_INTERACTIVE_UPDATE_DELAY);
        x0 = x.copy();
        y0 = y.copy();
      });
      renderWatch.renderEnd('multibarHorizontal immediate');
      return chart;
    }
    chart._getLabelXCoordinate = getLabelXCoordinate;
    chart._setupIconBackground = setupIconBackground;
    chart._setupDataLabelSettings = setupDataLabelSettings;
    chart.dispatch = dispatch;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      yDomainMin: {
        get: function get() {
          return yDomainMin;
        },
        set: function set(_) {
          yDomainMin = _;
        }
      },
      yDomainMax: {
        get: function get() {
          return yDomainMax;
        },
        set: function set(_) {
          yDomainMax = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      forceY: {
        get: function get() {
          return forceY;
        },
        set: function set(_) {
          forceY = _;
        }
      },
      stacked: {
        get: function get() {
          return stacked;
        },
        set: function set(_) {
          stacked = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      valuePadding: {
        get: function get() {
          return valuePadding;
        },
        set: function set(_) {
          valuePadding = _;
        }
      },
      groupPaddingRatio: {
        get: function get() {
          return groupPaddingRatio;
        },
        set: function set(_) {
          groupPaddingRatio = _;
        }
      },
      outerPaddingRatio: {
        get: function get() {
          return outerPaddingRatio;
        },
        set: function set(_) {
          outerPaddingRatio = _;
        }
      },
      disableInteraction: {
        get: function get() {
          return disableInteraction;
        },
        set: function set(_) {
          disableInteraction = _;
        }
      },
      barWidth: {
        get: function get() {
          return barWidth;
        },
        set: function set(_) {
          barWidth = _;
        }
      },
      innerPaddingWidth: {
        get: function get() {
          return innerPaddingWidth;
        },
        set: function set(_) {
          innerPaddingWidth = _;
        }
      },
      columnWidth: {
        get: function get() {
          return columnWidth;
        },
        set: function set(_) {
          columnWidth = _;
        }
      },
      barWidthThreshold: {
        get: function get() {
          return barWidthThreshold;
        },
        set: function set(_) {
          barWidthThreshold = _;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
        }
      },
      widgetAsFilter: {
        get: function get() {
          return widgetAsFilter;
        },
        set: function set(_) {
          widgetAsFilter = _;
        }
      }
    });
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","amd":"lodash","root":"_"}
var external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_ = __webpack_require__(6252);
var external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_);
;// ./src/js/nv/utils/upgraded_guideline_helper.js
var upgradedGuidelineHandler = function upgradedGuidelineHandler(_ref) {
  var guidelineLength = _ref.guidelineLength,
    guidelineWrap = _ref.guidelineWrap,
    interactionDispatch = _ref.interactionDispatch,
    isHorizontal = _ref.isHorizontal,
    isEnabled = _ref.isEnabled;
  var verticalGuideline = {
    x: 0,
    display: 'none'
  };
  var horizontalGuideline = {
    y: 0,
    display: 'none'
  };
  var guideline = guidelineWrap.selectAll('.nv-guideline').data(isHorizontal ? [horizontalGuideline] : [verticalGuideline]);
  var guidelineEnter = guideline.enter().append('line').attr('class', 'nv-guideline');
  guideline.exit().remove();
  guidelineEnter.merge(guideline).style('display', function (_ref2) {
    var display = _ref2.display;
    return display;
  }).attr('x1', isHorizontal ? guidelineLength : function (_ref3) {
    var x = _ref3.x;
    return x;
  }).attr('x2', isHorizontal ? 0 : function (_ref4) {
    var x = _ref4.x;
    return x;
  }).attr('y1', isHorizontal ? function (_ref5) {
    var y = _ref5.y;
    return y;
  } : -10).attr('y2', isHorizontal ? function (_ref6) {
    var y = _ref6.y;
    return y;
  } : guidelineLength);
  interactionDispatch.on('mouseOverRegion.guideline', function (evt) {
    if (evt.x !== undefined && isEnabled) {
      updateGuidelinePosition(evt);
      toggleGuideline(true);
    }
  });
  interactionDispatch.on('mouseOutRegion.guideline', function () {
    return toggleGuideline(false);
  });
  var updateGuidelinePosition = function updateGuidelinePosition(evt) {
    if (isHorizontal) {
      horizontalGuideline.y = evt.x;
      guidelineEnter.merge(guideline).data([horizontalGuideline]).attr('y1', function (_ref7) {
        var y = _ref7.y;
        return y;
      }).attr('y2', function (_ref8) {
        var y = _ref8.y;
        return y;
      });
    } else {
      verticalGuideline.x = evt.x;
      guidelineEnter.merge(guideline).data([verticalGuideline]).attr('x1', function (_ref9) {
        var x = _ref9.x;
        return x;
      }).attr('x2', function (_ref10) {
        var x = _ref10.x;
        return x;
      });
    }
  };
  var toggleGuideline = function toggleGuideline(shouldShow) {
    if (isHorizontal) {
      horizontalGuideline.display = shouldShow ? null : 'none';
    } else {
      verticalGuideline.display = shouldShow ? null : 'none';
    }
    guidelineEnter.merge(guideline).style('display', function (_ref11) {
      var display = _ref11.display;
      return display;
    });
  };
};
;// ./node_modules/d3-selection/src/sourceEvent.js
/* harmony default export */ function sourceEvent(event) {
  let sourceEvent;
  while (sourceEvent = event.sourceEvent) event = sourceEvent;
  return event;
}

;// ./node_modules/d3-selection/src/pointer.js


/* harmony default export */ function pointer(event, node) {
  event = sourceEvent(event);
  if (node === undefined) node = event.currentTarget;
  if (node) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      point.x = event.clientX, point.y = event.clientY;
      point = point.matrixTransform(node.getScreenCTM().inverse());
      return [point.x, point.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}

;// ./src/js/nv/utils/upgraded_subdivision_interaction.js
function upgraded_subdivision_interaction_typeof(o) { "@babel/helpers - typeof"; return upgraded_subdivision_interaction_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, upgraded_subdivision_interaction_typeof(o); }











function upgraded_subdivision_interaction_toConsumableArray(r) { return upgraded_subdivision_interaction_arrayWithoutHoles(r) || upgraded_subdivision_interaction_iterableToArray(r) || upgraded_subdivision_interaction_unsupportedIterableToArray(r) || upgraded_subdivision_interaction_nonIterableSpread(); }
function upgraded_subdivision_interaction_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function upgraded_subdivision_interaction_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return upgraded_subdivision_interaction_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? upgraded_subdivision_interaction_arrayLikeToArray(r, a) : void 0; } }
function upgraded_subdivision_interaction_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function upgraded_subdivision_interaction_arrayWithoutHoles(r) { if (Array.isArray(r)) return upgraded_subdivision_interaction_arrayLikeToArray(r); }
function upgraded_subdivision_interaction_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function upgraded_subdivision_interaction_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function upgraded_subdivision_interaction_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? upgraded_subdivision_interaction_ownKeys(Object(t), !0).forEach(function (r) { upgraded_subdivision_interaction_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : upgraded_subdivision_interaction_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function upgraded_subdivision_interaction_defineProperty(e, r, t) { return (r = upgraded_subdivision_interaction_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function upgraded_subdivision_interaction_toPropertyKey(t) { var i = upgraded_subdivision_interaction_toPrimitive(t, "string"); return "symbol" == upgraded_subdivision_interaction_typeof(i) ? i : i + ""; }
function upgraded_subdivision_interaction_toPrimitive(t, r) { if ("object" != upgraded_subdivision_interaction_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != upgraded_subdivision_interaction_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var upgradedInteractionHandler = function upgradedInteractionHandler(_ref) {
  var container = _ref.container,
    data = _ref.data,
    height = _ref.height,
    xScale = _ref.xScale,
    yScale = _ref.yScale,
    getX = _ref.getX,
    chartDimensions = _ref.chartDimensions,
    _ref$isHorizontal = _ref.isHorizontal,
    isHorizontal = _ref$isHorizontal === void 0 ? false : _ref$isHorizontal,
    _ref$isStacked = _ref.isStacked,
    isStacked = _ref$isStacked === void 0 ? false : _ref$isStacked,
    _ref$cutOffLastRegion = _ref.cutOffLastRegion,
    cutOffLastRegion = _ref$cutOffLastRegion === void 0 ? false : _ref$cutOffLastRegion;
  var POINT_RADIUS = 10;
  var interactionDispatch = src_dispatch('mouseOverRegion', 'mouseOutRegion', 'regionClick', 'regionMousemove', 'regionDblClick');
  var subdivisionDataValues = unpackSubdivisionData(data);
  var subdivisionWidth = isHorizontal ? chartDimensions.columnWidth : Math.max((chartDimensions.xRange[1] - chartDimensions.xRange[0]) / subdivisionDataValues.length, chartDimensions.columnWidth);
  var midpointOffset = subdivisionWidth / 2;
  var regionHeight = isHorizontal ? subdivisionWidth : height;
  var regionWidth = isHorizontal ? height : subdivisionWidth;
  var getXVal = function getXVal(d, i) {
    return calculateSubdivisionX(i, subdivisionWidth, chartDimensions, subdivisionDataValues.length) - midpointOffset;
  };
  var regionX = isHorizontal ? 0 : getXVal;
  var regionY = isHorizontal ? getXVal : 0;
  subdivisionDataValues.forEach(function (d, i) {
    d.index = i;
  });
  var subdivisions = container.selectAll('rect').data(subdivisionDataValues);
  var subdivisionsEnter = subdivisions.enter().append('rect').attr('class', 'nv-subdivision').attr('id', function (d, i) {
    return 'subdivision-' + i;
  });
  subdivisions.exit().remove();
  subdivisionsEnter.merge(subdivisions).attr('height', regionHeight).attr('width', function (d, i) {
    if (i === subdivisionDataValues.length - 1 && cutOffLastRegion) {
      return regionWidth / 2;
    }
    return regionWidth;
  }).attr('x', regionX).attr('y', regionY).style('pointer-events', 'all').style('fill', 'none').on('mouseenter', function (_event, d, i, nodes) {
    return onSubdivisionEventCallback(d, 'mouseOverRegion', d.index, nodes === null || nodes === void 0 ? void 0 : nodes[i]);
  }).on('mouseout', function (_event, d) {
    return onSubdivisionEventCallback(d, 'mouseOutRegion', d.index);
  }).on('click', function (event, d, i, nodes) {
    return passThroughEventHandler(d, 0, event, nodes === null || nodes === void 0 ? void 0 : nodes[i]);
  }).on('dblclick', function (event, d, i, nodes) {
    return passThroughEventHandler(d, 0, event, nodes === null || nodes === void 0 ? void 0 : nodes[i]);
  }).on('mousemove', function (event, d, i, nodes) {
    return passThroughEventHandler(d, d.index, event, nodes === null || nodes === void 0 ? void 0 : nodes[i]);
  });
  var onSubdivisionEventCallback = function onSubdivisionEventCallback(subdivisionData, interactionEvent, subdivisionIndex, element) {
    var subdivisionCenter = calculateSubdivisionX(subdivisionIndex, subdivisionWidth, chartDimensions, subdivisionDataValues.length);
    var x;
    var y;
    var closestDataPoint;
    if (subdivisionData !== undefined) {
      closestDataPoint = findClosestDatapoint(subdivisionData, subdivisionIndex);
      if (!closestDataPoint) {
        return;
      }
      x = isHorizontal ? subdivisionCenter : xScale(getX(closestDataPoint, closestDataPoint.x));
      y = yScale(closestDataPoint.y);
    }
    interactionDispatch.call(interactionEvent, element, {
      subdivisionData: subdivisionData,
      dataPoint: closestDataPoint,
      x: x,
      y: y
    });
  };
  return interactionDispatch;
  function passThroughEventHandler(subdivisionData, subdivisionIndex, event, element) {
    var mouseX = event.clientX;
    var mouseY = event.clientY;
    var subdivisionCenter = calculateSubdivisionX(subdivisionIndex, subdivisionWidth, chartDimensions, subdivisionDataValues.length);
    var x;
    var y;
    var closestDataPoint;
    if (subdivisionData !== undefined) {
      closestDataPoint = findClosestDatapoint(subdivisionData, subdivisionIndex);
      if (!closestDataPoint) {
        return;
      }
      x = isHorizontal ? subdivisionCenter : xScale(getX(closestDataPoint, closestDataPoint.x));
      y = yScale(closestDataPoint.y);
    }
    interactionDispatch.call('regionMousemove', element, {
      mouseX: mouseX,
      mouseY: mouseY,
      subdivisionData: subdivisionData,
      subdivisionIndex: subdivisionIndex,
      dataPoint: closestDataPoint,
      x: x,
      y: y
    });
    if (event.type === 'click') {
      interactionDispatch.call('regionClick', element, {
        mouseX: mouseX,
        mouseY: mouseY,
        subdivisionData: subdivisionData,
        subdivisionIndex: subdivisionIndex
      });
    }
    if (event.type === 'dblclick') {
      interactionDispatch.call('regionDblClick', element, {
        mouseX: mouseX,
        mouseY: mouseY,
        subdivisionData: subdivisionData,
        subdivisionIndex: subdivisionIndex
      });
    }
  }
  function unpackSubdivisionData(data) {
    return data.reduce(function (subdivisions, series, seriesIndex) {
      series.values.forEach(function (value, index) {
        var _value$color, _value$series, _series$disabled;
        if (!subdivisions[index]) {
          subdivisions[index] = [];
        }
        subdivisions[index].push(upgraded_subdivision_interaction_objectSpread(upgraded_subdivision_interaction_objectSpread({}, value), {}, {
          color: (_value$color = value.color) !== null && _value$color !== void 0 ? _value$color : series.color,
          key: series.key,
          x: isHorizontal ? value.x : index,
          value: value.y,
          type: series.type,
          subdivision: index,
          series: (_value$series = value.series) !== null && _value$series !== void 0 ? _value$series : seriesIndex,
          disabled: (_series$disabled = series.disabled) !== null && _series$disabled !== void 0 ? _series$disabled : false
        }));
      });
      return subdivisions;
    }, []);
  }
  function findClosestDatapoint(data, subdivisionIndex) {
    var activeData = data.filter(function (datapoint) {
      return !datapoint.disabled;
    });
    var mouseCoords = pointer(event, container.node());
    var mouseX = isHorizontal ? mouseCoords[1] : mouseCoords[0];
    var mouseY = isHorizontal ? mouseCoords[0] : mouseCoords[1];
    if (isMultiChart(activeData)) {
      var lineData = activeData.filter(function (datapoint) {
        return datapoint.type === 'line';
      });
      var pointDistances = calculateDistancesToDatapoints(lineData, subdivisionIndex, [mouseX, mouseY]);
      var _shortestDistance = Math.min.apply(Math, upgraded_subdivision_interaction_toConsumableArray(pointDistances.filter(function (d) {
        return d || d === 0;
      })));
      if (_shortestDistance <= POINT_RADIUS) {
        return lineData[pointDistances.indexOf(_shortestDistance)];
      }
      activeData = activeData.filter(function (datapoint) {
        return datapoint.type === 'bar';
      });
    }
    var distances = calculateDistancesToDatapoints(activeData, subdivisionIndex, [mouseX, mouseY]);
    var shortestDistance = Math.min.apply(Math, upgraded_subdivision_interaction_toConsumableArray(distances.filter(function (d) {
      return d || d === 0;
    })));
    var shortestIndexes = findIndexes(shortestDistance, distances);
    if (shortestIndexes.length > 1) {
      var subdivisionXStart = calculateSubdivisionX(subdivisionIndex, subdivisionWidth, chartDimensions, subdivisionDataValues.length) - midpointOffset;
      var subsectionWidth = subdivisionWidth / shortestIndexes.length;
      var hoveredSubsection = Math.floor((mouseX - subdivisionXStart) / subsectionWidth);
      if (hoveredSubsection >= shortestIndexes.length) {
        return activeData[shortestIndexes[shortestIndexes.length - 1]];
      } else if (hoveredSubsection < 0) {
        return activeData[shortestIndexes[0]];
      }
      return activeData[shortestIndexes[hoveredSubsection]];
    }
    return activeData[shortestIndexes[0]];
  }
  function calculateDatapointLocation(datapoint, subdivisionIndex, barIndex) {
    if (datapoint.type === 'line') {
      return [calculateStackedBarX(chartDimensions, subdivisionIndex), yScale(datapoint.y)];
    }
    if (isStacked) {
      return [calculateStackedBarX(chartDimensions, subdivisionIndex), calculateBarY(datapoint, yScale)];
    }
    return [calculateBarX(chartDimensions, subdivisionIndex, barIndex), yScale.range()[0]];
  }
  function calculateDistancesToDatapoints(data, subdivisionIndex, mouse) {
    var distances = [];
    var lineAdjustment = 0;
    for (var i = 0; i < data.length; i++) {
      if (data[i].type === 'line') {
        lineAdjustment += 1;
      }
      var datapointLocation = calculateDatapointLocation(data[i], subdivisionIndex, i - lineAdjustment);
      distances.push(upgraded_subdivision_interaction_calculateDistance(mouse, datapointLocation));
    }
    return distances;
  }
};
function calculateBarX(chartDimensions, subdivisionIndex, barIndex) {
  var outerOffset = chartDimensions.columnWidth * subdivisionIndex;
  var innerOffset = (chartDimensions.barWidth + chartDimensions.innerPaddingWidth) * barIndex;
  return outerOffset + innerOffset + chartDimensions.outerPaddingWidth + chartDimensions.barWidth / 2;
}
function calculateStackedBarX(chartDimensions, subdivisionIndex) {
  return chartDimensions.columnWidth * (subdivisionIndex + 0.5);
}
function calculateBarY(barData, yScale) {
  return yScale(barData.y0 + barData.size / 2);
}
function upgraded_subdivision_interaction_calculateDistance(point1, point2) {
  return Math.sqrt(Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2));
}
function isMultiChart(data) {
  return !data.every(function (datapoint) {
    return datapoint.type === data[0].type;
  });
}
function calculateSubdivisionX(subdivisionIndex, subdivisionWidth, chartDimensions, numSubdivisions) {
  var xRange = chartDimensions.xRange;
  var excessSpace = xRange[1] - xRange[0] - subdivisionWidth * numSubdivisions || 0;
  return subdivisionIndex * subdivisionWidth + subdivisionWidth / 2 + excessSpace / 2;
}
function findIndexes(searchElement, arrayToSearch) {
  var indexes = [];
  arrayToSearch.forEach(function (item, index) {
    if (item === searchElement) {
      indexes.push(index);
    }
  });
  return indexes;
}
;// ./src/js/nv/utils/upgraded_tooltip_helper.js
function upgraded_tooltip_helper_typeof(o) { "@babel/helpers - typeof"; return upgraded_tooltip_helper_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, upgraded_tooltip_helper_typeof(o); }











function upgraded_tooltip_helper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function upgraded_tooltip_helper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? upgraded_tooltip_helper_ownKeys(Object(t), !0).forEach(function (r) { upgraded_tooltip_helper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : upgraded_tooltip_helper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function upgraded_tooltip_helper_defineProperty(e, r, t) { return (r = upgraded_tooltip_helper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function upgraded_tooltip_helper_toPropertyKey(t) { var i = upgraded_tooltip_helper_toPrimitive(t, "string"); return "symbol" == upgraded_tooltip_helper_typeof(i) ? i : i + ""; }
function upgraded_tooltip_helper_toPrimitive(t, r) { if ("object" != upgraded_tooltip_helper_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != upgraded_tooltip_helper_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function upgraded_tooltip_helper_toConsumableArray(r) { return upgraded_tooltip_helper_arrayWithoutHoles(r) || upgraded_tooltip_helper_iterableToArray(r) || upgraded_tooltip_helper_unsupportedIterableToArray(r) || upgraded_tooltip_helper_nonIterableSpread(); }
function upgraded_tooltip_helper_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function upgraded_tooltip_helper_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return upgraded_tooltip_helper_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? upgraded_tooltip_helper_arrayLikeToArray(r, a) : void 0; } }
function upgraded_tooltip_helper_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function upgraded_tooltip_helper_arrayWithoutHoles(r) { if (Array.isArray(r)) return upgraded_tooltip_helper_arrayLikeToArray(r); }
function upgraded_tooltip_helper_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var upgraded_tooltip_helper_GRAVITY = constants_Constants.GRAVITY,
  upgraded_tooltip_helper_THROTTLE_TIME = constants_Constants.THROTTLE_TIME;
var GRAVITY_OFFSET = 10;
var upgradedTooltipHandler = function upgradedTooltipHandler(_ref) {
  var container = _ref.container,
    data = _ref.data,
    interactionDispatch = _ref.interactionDispatch,
    margin = _ref.margin,
    tooltip = _ref.tooltip,
    yAxis = _ref.yAxis,
    width = _ref.width,
    yScale = _ref.yScale,
    isStacked = _ref.isStacked,
    _ref$isHorizontal = _ref.isHorizontal,
    isHorizontal = _ref$isHorizontal === void 0 ? false : _ref$isHorizontal;
  var chartTooltip = tooltip.duration(0).valueFormatter(function (d) {
    return d === null ? 'N/A' : yAxis.tickFormat()(d);
  }).hidden(true);
  interactionDispatch.on('mouseOverRegion.tooltip', function (evt) {
    if (evt.x !== undefined) {
      updateTooltipPosition(evt);
    }
  }).on('regionMousemove.tooltip', function (evt) {
    if (evt.x !== undefined) {
      updateTooltipPosition(evt);
    }
  }).on('mouseOutRegion.tooltip', function () {
    return chartTooltip.hidden(true);
  });
  var tooltipY = computeMaxTooltipY(data);
  var updateTooltipPosition = function updateTooltipPosition(evt) {
    chartTooltip.hidden(true);
    var containerRect = container.node().getBoundingClientRect();
    var chartOffset = containerRect.left + (containerRect.width - width) / 2 + margin.left;
    chartTooltip.data(getTooltipData(evt)).position(function () {
      if (isHorizontal) {
        return {
          left: chartOffset + yScale(tooltipY),
          top: containerRect.top + evt.x
        };
      }
      return {
        left: evt.x + chartOffset,
        top: containerRect.top + yScale(tooltipY)
      };
    }).calcGravityOffset(_.throttle(function (position) {
      var _tooltip$node$offsetW, _tooltip$node, _tooltip$node$offsetH, _tooltip$node2;
      var clientHeight = document.documentElement.clientHeight;
      var _container$node$paren = container.node().parentElement.getBoundingClientRect(),
        clientWidth = _container$node$paren.width,
        clientXOffset = _container$node$paren.x;
      var tooltipWidth = (_tooltip$node$offsetW = (_tooltip$node = tooltip.node()) === null || _tooltip$node === void 0 ? void 0 : _tooltip$node.offsetWidth) !== null && _tooltip$node$offsetW !== void 0 ? _tooltip$node$offsetW : 0;
      var tooltipHeight = (_tooltip$node$offsetH = (_tooltip$node2 = tooltip.node()) === null || _tooltip$node2 === void 0 ? void 0 : _tooltip$node2.offsetHeight) !== null && _tooltip$node$offsetH !== void 0 ? _tooltip$node$offsetH : 0;
      var pageWidth = document.documentElement.clientWidth;
      var dialogHeight = tooltip.node().querySelector('.dark-dialog').offsetHeight;
      var left;
      var top;
      if (isHorizontal) {
        top = -(tooltipHeight / 2);
        if (isAllNegative(data)) {
          left = -tooltipWidth;
          if (position.left + left < clientXOffset) {
            return calculateFallbackGravityOffset(upgraded_tooltip_helper_GRAVITY.SOUTH);
          }
          return {
            top: correctVerticalPosition(top),
            left: left,
            location: upgraded_tooltip_helper_GRAVITY.CENTER
          };
        }
        left = GRAVITY_OFFSET;
        if (position.left + left + tooltipWidth > clientWidth + clientXOffset) {
          return calculateFallbackGravityOffset(upgraded_tooltip_helper_GRAVITY.SOUTH);
        }
        return {
          top: correctVerticalPosition(top),
          left: GRAVITY_OFFSET,
          location: upgraded_tooltip_helper_GRAVITY.CENTER
        };
      } else {
        left = -(tooltipWidth / 2);
        if (isAllNegative(data)) {
          top = 0;
          if (position.top + top + tooltipHeight > clientHeight) {
            return calculateFallbackGravityOffset(upgraded_tooltip_helper_GRAVITY.WEST);
          }
          return {
            left: correctHorizontalPosition(left),
            top: 0,
            location: upgraded_tooltip_helper_GRAVITY.CENTER
          };
        }
        top = -(tooltipHeight / 2) - dialogHeight / 2;
        if (position.top + top < 0) {
          return calculateFallbackGravityOffset(upgraded_tooltip_helper_GRAVITY.WEST);
        }
        return {
          left: correctHorizontalPosition(left),
          top: -(tooltipHeight / 2) - dialogHeight / 2,
          location: upgraded_tooltip_helper_GRAVITY.CENTER
        };
      }
      function calculateFallbackGravityOffset(startingGravity) {
        var seriesWidth = estimateSeriesWidth(data);
        var gravity = startingGravity;
        var left = 0;
        var top = 0;
        switch (gravity) {
          case upgraded_tooltip_helper_GRAVITY.EAST:
            left = -seriesWidth / 2 - tooltipWidth;
            top = -tooltipHeight / 2;
            if (position.left + left < 0) {
              gravity = upgraded_tooltip_helper_GRAVITY.WEST;
            }
            top = correctVerticalPosition(top);
            break;
          case upgraded_tooltip_helper_GRAVITY.WEST:
            left = seriesWidth / 2;
            top = -tooltipHeight / 2;
            if (position.left + left + tooltipWidth > clientWidth) {
              gravity = upgraded_tooltip_helper_GRAVITY.EAST;
            }
            top = correctVerticalPosition(top);
            break;
          case upgraded_tooltip_helper_GRAVITY.NORTH:
            left = 0;
            top = seriesWidth / 2;
            if (position.top + top + tooltipHeight > clientHeight) {
              gravity = upgraded_tooltip_helper_GRAVITY.SOUTH;
            }
            left = correctHorizontalPosition(left);
            break;
          case upgraded_tooltip_helper_GRAVITY.SOUTH:
            left = 0;
            top = -seriesWidth / 2 - tooltipHeight;
            if (position.top + top < 0) {
              gravity = upgraded_tooltip_helper_GRAVITY.NORTH;
            }
            left = correctHorizontalPosition(left);
            break;
        }
        if (startingGravity !== gravity) {
          return calculateFallbackGravityOffset(gravity);
        }
        return {
          left: left,
          top: top,
          location: upgraded_tooltip_helper_GRAVITY.CENTER
        };
      }
      function correctVerticalPosition(top) {
        var offsetTop = position.top + top;
        if (offsetTop < 0) {
          top -= offsetTop;
        }
        var offsetBottom = position.top + top + tooltipHeight;
        if (offsetBottom > clientHeight) {
          top -= offsetBottom - clientHeight;
        }
        return top;
      }
      function correctHorizontalPosition(left) {
        var offsetLeft = position.left + left;
        var offsetRight = position.left + left + tooltipWidth;
        if (offsetLeft < clientXOffset) {
          left = left - offsetLeft + clientXOffset;
        } else if (offsetRight > clientWidth + clientXOffset) {
          left = left - (offsetRight - clientWidth) + clientXOffset;
        }
        offsetLeft = position.left + left;
        offsetRight = offsetLeft + tooltipWidth;
        if (offsetRight > pageWidth) {
          left -= offsetRight - pageWidth;
        } else if (offsetLeft < 0) {
          left -= offsetLeft;
        }
        return left;
      }
      function estimateSeriesWidth(data) {
        var bar = container.node().querySelector('.nv-bar');
        if (bar) {
          var barWidth = isHorizontal ? bar.getBBox().height : bar.getBBox().width;
          if (isStacked) {
            return barWidth;
          }
          var barsPerGroup = data.length;
          return barsPerGroup * barWidth;
        }
        return 0;
      }
    }), upgraded_tooltip_helper_THROTTLE_TIME).hidden(false);
  };
  function computeMaxTooltipY(data) {
    var allNegative = isAllNegative(data);
    var maxY = allNegative ? Infinity : -Infinity;
    var longestValuesLength = data.reduce(function (max, _ref2) {
      var values = _ref2.values;
      return Math.max(max, values.length);
    }, 0);
    var _loop = function _loop(i) {
      var subdivisionYValues = data.map(function (series) {
        return series.values[i] && series.values[i].y;
      }).filter(function (value) {
        return value !== null && value !== undefined;
      });
      var yValue;
      if (isStacked) {
        yValue = Math.max.apply(Math, [subdivisionYValues.reduce(function (i, j) {
          return i + j;
        }, 0)].concat(upgraded_tooltip_helper_toConsumableArray(subdivisionYValues)));
      } else {
        yValue = allNegative ? Math.min.apply(Math, upgraded_tooltip_helper_toConsumableArray(subdivisionYValues)) : Math.max.apply(Math, upgraded_tooltip_helper_toConsumableArray(subdivisionYValues));
      }
      maxY = allNegative ? Math.min(maxY, yValue) : Math.max(maxY, yValue);
    };
    for (var i = 0; i < longestValuesLength; i++) {
      _loop(i);
    }
    return maxY;
  }
  function isAllNegative(data) {
    var allValues = merge(data.map(function (series) {
      return series.values;
    }));
    return allValues.every(function (value) {
      return value.y <= 0;
    });
  }
  var getTooltipData = function getTooltipData(evt) {
    return {
      color: evt.dataPoint.color,
      data: upgraded_tooltip_helper_objectSpread(upgraded_tooltip_helper_objectSpread({}, evt.dataPoint), {}, {
        x: isNaN(evt.dataPoint.x) ? evt.dataPoint.subdivision : evt.dataPoint.x
      }),
      pointIndex: evt.dataPoint.x,
      index: evt.dataPoint.subdivision,
      series: evt.subdivisionData,
      seriesIndex: evt.dataPoint.series,
      value: evt.dataPoint.label,
      yAxis: yAxis
    };
  };
};
;// ./src/js/nv/models/multiBarHorizontalChart.js












var multiBarHorizontalChart_FONT_SIZE = constants_Constants.FONT_SIZE,
  HIDDEN_CLASS = constants_Constants.HIDDEN_CLASS,
  HORIZONTAL_AXIS_PADDING = constants_Constants.HORIZONTAL_AXIS_PADDING,
  MULTI_CHART_MAX_TICK_LABEL_LINES = constants_Constants.MULTI_CHART_MAX_TICK_LABEL_LINES,
  MULTI_CHART_TICK_LABEL_FALLBACK = constants_Constants.MULTI_CHART_TICK_LABEL_FALLBACK,
  NO_DISPLAY_CLASS = constants_Constants.NO_DISPLAY_CLASS;
var multiBarHorizontalChart = function multiBarHorizontalChart(nv) {
  nv.models.multiBarHorizontalChart = function () {
    var multibar = nv.models.multiBarHorizontal(),
      xAxis = nv.models.upgradedAxis('left'),
      yAxis = nv.models.upgradedAxis('bottom'),
      legend = nv.models.upgradedLegend().height(30),
      controls = nv.models.upgradedLegend().height(30),
      tooltip = nv.models.upgradedTooltip();
    var margin = {
        top: 30,
        right: 20,
        bottom: 50,
        left: 60
      },
      width = null,
      height = null,
      color = nv.upgradedUtils.defaultColor(),
      showControls = true,
      controlLabels = {},
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      stacked = false,
      wrapLabels = false,
      showVerticalGrid = true,
      showHorizontalGrid = false,
      x,
      y,
      state = nv.upgradedUtils.state(),
      defaultState = null,
      noData = null,
      dispatch = src_dispatch('stateChange', 'changeState', 'renderEnd', 'elementClick'),
      interactionDispatch,
      controlWidth = function controlWidth() {
        return showControls ? 180 : 0;
      },
      duration = 250,
      useRegionInteraction = false,
      widgetAsFilter = false;
    state.stacked = false;
    multibar.stacked(stacked);
    xAxis.tickPadding(5).showMaxMin(false).margin({
      right: 4
    }).tickFormat(function (d) {
      return d;
    });
    yAxis.showMaxMin(false).tickFormat(format(',.1f'));
    tooltip.duration(0).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    }).headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    });
    controls.updateState(false);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          }),
          stacked: stacked
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.stacked !== undefined) {
          stacked = state.stacked;
        }
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    var renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(multibar);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      multibar.valueFormat(yAxis.tickFormat());
      selection.each(function (data) {
        var initialTooltipState = tooltip.enabled();
        if (useRegionInteraction) {
          tooltip.enabled(false);
        }
        var container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        var availableWidth = nv.upgradedUtils.availableWidth(width, container, margin),
          availableHeight = nv.upgradedUtils.availableHeight(height, container, margin);
        chart.update = function () {
          container.transition().duration(duration).call(chart);
        };
        chart.container = this;
        stacked = multibar.stacked();
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.upgradedUtils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        var series1 = data.map(function (d) {
          return d.values.map(function (d) {
            return d.x;
          });
        });
        var xValues = !(0,external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_.isEmpty)(series1) ? series1[0] : [];
        var chartDimensions = nv.chartHelpers.getHorizontalChartDimensions(availableHeight, data, xValues.length, stacked, data, null, multibar.showValues());
        x = multibar.xScale();
        y = multibar.yScale();
        x.range(chartDimensions.xRange);
        var wrap = container.selectAll('g.nv-wrap.nv-multiBarHorizontalChart').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multiBarHorizontalChart').append('g');
        var g = gEnter.merge(wrap).select('g');
        var gMerge = gEnter.merge(g);
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis').append('g').attr('class', 'nv-zeroLine').append('line');
        gEnter.append('g').attr('class', 'nv-guidelineWrap');
        gEnter.append('g').attr('class', 'nv-barsWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        gEnter.append('g').attr('class', 'nv-controlsWrap');
        gEnter.append('g').attr('class', 'nv-interactionWrap');
        if (showLegend) {
          legend.width(availableWidth - controlWidth());
          gMerge.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.upgradedUtils.availableHeight(height, container, margin);
          }
          gMerge.select('.nv-legendWrap').attr('transform', 'translate(' + controlWidth() + ',' + -margin.top + ')');
        }
        if (showControls) {
          var controlsData = [{
            key: controlLabels.grouped || 'Grouped',
            disabled: multibar.stacked()
          }, {
            key: controlLabels.stacked || 'Stacked',
            disabled: !multibar.stacked()
          }];
          controls.width(controlWidth()).color(['#444', '#444', '#444']);
          gMerge.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
        }
        gMerge.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        multibar.width(availableWidth).height(availableHeight).xRange(chartDimensions.xRange).barWidth(chartDimensions.barWidth).innerPaddingWidth(chartDimensions.innerPaddingWidth).groupPaddingRatio(chartDimensions.groupPaddingRatio).outerPaddingRatio(chartDimensions.outerPaddingRatio).columnWidth(chartDimensions.columnWidth).color(data.map(function (d, i) {
          return d.color || color(d, i);
        }).filter(function (d, i) {
          return !data[i].disabled;
        }));
        var barsWrap = gMerge.select('.nv-barsWrap').datum(data.filter(function (d) {
          return !d.disabled;
        }));
        barsWrap.transition().call(multibar);
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.upgradedUtils.calcTicksX(availableHeight / 24, data)).tickSize(0).placeLabelAt(-availableHeight / 2);
          gMerge.select('.nv-x.nv-axis').call(xAxis);
          var maxLineCount = min_min([MULTI_CHART_MAX_TICK_LABEL_LINES, chartDimensions.columnWidth / (multiBarHorizontalChart_FONT_SIZE * 2) || MULTI_CHART_TICK_LABEL_FALLBACK]);
          var xAxisSelection = gMerge.selectAll('.nv-x.nv-axis');
          xAxisSelection.attr('aria-hidden', true);
          var xAxisTickLabels = xAxisSelection.selectAll('.tick text');
          xAxisSelection.transition().on('end', function () {
            if (wrapLabels) {
              xAxisTickLabels.call(nv.upgradedUtils.wrapTicks, margin.left - (xAxis.axisLabel() ? 10 : 0) - 8, maxLineCount);
            }
            xAxisTickLabels.each(function () {
              var actualLineCount = src_select(this).selectAll('tspan').size();
              var translateLabel = -(actualLineCount - 1) * 6;
              src_select(this).attr('transform', "translate(0,".concat(translateLabel, ")"));
            });
            gMerge.select('.nv-x .nvd3 g').attr('transform', "translate(-".concat(HORIZONTAL_AXIS_PADDING, ", 0)"));
            gMerge.selectAll('.nv-x .nvd3 .tick line').remove();
          });
        } else {
          gMerge.select('.nv-x.nv-axis').selectAll('*').remove();
        }
        gMerge.select('.nv-zeroLine line').attr('x1', y(0)).attr('x2', y(0)).attr('y1', 0).attr('y2', -availableHeight).classed(HIDDEN_CLASS, !showXAxis);
        yAxis.scale(y)._ticks(nv.upgradedUtils.calcTicksY(availableWidth / 50, data, yAxis.scale().domain(), yAxis.tickFormat())).tickSize(-availableHeight, 0).height(margin.bottom);
        gMerge.select('.nv-y.nv-axis').attr('transform', 'translate(0,' + availableHeight + ')').attr('aria-hidden', true);
        gMerge.select('.nv-y.nv-axis').call(yAxis);
        gMerge.selectAll('.nv-y .nvd3 .tick text').classed(NO_DISPLAY_CLASS, !showYAxis);
        gMerge.selectAll('.nv-y .nvd3 .tick line').classed(HIDDEN_CLASS, !showVerticalGrid);
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.call('stateChange', this, state);
          chart.update();
        });
        controls.dispatch.on('legendClick', function (d) {
          if (!d.disabled) {
            return;
          }
          controlsData = controlsData.map(function (s) {
            s.disabled = true;
            return s;
          });
          d.disabled = false;
          switch (d.key) {
            case 'Grouped':
              multibar.stacked(false);
              break;
            case 'Stacked':
              multibar.stacked(true);
              break;
          }
          state.stacked = multibar.stacked();
          dispatch.call('stateChange', this, state);
          stacked = multibar.stacked();
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          if (typeof e.stacked !== 'undefined') {
            multibar.stacked(e.stacked);
            state.stacked = e.stacked;
            stacked = e.stacked;
          }
          chart.update();
        });
        if (useRegionInteraction) {
          var interactionWrap = gMerge.select('.nv-interactionWrap');
          interactionWrap.attr('aria-hidden', true);
          var guidelineWrap = gMerge.select('.nv-guidelineWrap');
          interactionDispatch = upgradedInteractionHandler({
            container: interactionWrap,
            data: data,
            height: availableWidth,
            xScale: x,
            yScale: y,
            getX: chart.x(),
            chartDimensions: chartDimensions,
            isHorizontal: true,
            isStacked: stacked
          });
          upgradedGuidelineHandler({
            guidelineLength: availableWidth,
            guidelineWrap: guidelineWrap,
            interactionDispatch: interactionDispatch,
            isHorizontal: true,
            isEnabled: initialTooltipState
          });
          upgradedTooltipHandler({
            color: color,
            container: container,
            data: data,
            interactionDispatch: interactionDispatch,
            margin: margin,
            tooltip: tooltip,
            yAxis: yAxis,
            width: width,
            yScale: y,
            isStacked: stacked,
            isHorizontal: true
          });
          multibar.interactionDispatch(interactionDispatch);
          tooltip.enabled(initialTooltipState);
        } else {
          multibar.dispatch.on('elementMouseover.tooltip', function (evt) {
            evt.value = chart.x()(evt.data);
            evt.series = {
              key: evt.data.key,
              value: chart.y()(evt.data),
              color: evt.color
            };
            tooltip.duration(0).data(evt).position(function () {
              return {
                left: event !== null ? event.clientX : 0,
                top: event !== null ? event.clientY : 0
              };
            }).hidden(false);
          });
          multibar.dispatch.on('elementMouseout.tooltip', function () {
            tooltip.hidden(true);
          });
          multibar.dispatch.on('elementMousemove.tooltip', function () {
            tooltip();
          });
        }
        multibar.dispatch.on('elementClick', function (options) {
          dispatch.call('elementClick', this, options);
        });
      });
      renderWatch.renderEnd('multibar horizontal chart immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.multibar = multibar;
    chart.legend = legend;
    chart.controls = controls;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.state = state;
    chart.tooltip = tooltip;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showControls: {
        get: function get() {
          return showControls;
        },
        set: function set(_) {
          showControls = _;
        }
      },
      controlLabels: {
        get: function get() {
          return controlLabels;
        },
        set: function set(_) {
          controlLabels = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = !!_;
        }
      },
      showVerticalGrid: {
        get: function get() {
          return showVerticalGrid;
        },
        set: function set(_) {
          showVerticalGrid = _;
        }
      },
      showHorizontalGrid: {
        get: function get() {
          return showHorizontalGrid;
        },
        set: function set(_) {
          showHorizontalGrid = _;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
          multibar.useRegionInteraction(_);
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          multibar.duration(duration);
          xAxis.duration(duration);
          yAxis.duration(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
          legend.color(color);
        }
      },
      widgetAsFilter: {
        get: function get() {
          return widgetAsFilter;
        },
        set: function set(_) {
          widgetAsFilter = _;
          multibar.widgetAsFilter(_);
        }
      }
    });
    nv.upgradedUtils.inheritOptions(chart, multibar);
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
;// ./node_modules/d3-time/src/millisecond.js


var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ var src_millisecond = (millisecond);
var milliseconds = millisecond.range;

;// ./node_modules/d3-time/src/second.js



var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ var src_second = (second);
var seconds = second.range;

;// ./node_modules/d3-time/src/minute.js



var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ var src_minute = (minute);
var minutes = minute.range;

;// ./node_modules/d3-time/src/hour.js



var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

/* harmony default export */ var src_hour = (hour);
var hours = hour.range;

;// ./node_modules/d3-time/src/utcMinute.js



var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ var src_utcMinute = (utcMinute);
var utcMinutes = utcMinute.range;

;// ./node_modules/d3-time/src/utcHour.js



var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ var src_utcHour = (utcHour);
var utcHours = utcHour.range;

;// ./node_modules/d3-time/src/utcMonth.js


var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ var src_utcMonth = (utcMonth);
var utcMonths = utcMonth.range;

;// ./node_modules/d3-time/src/ticks.js

















function ticker(year, month, week, day, hour, minute) {

  const tickIntervals = [
    [src_second,  1,      durationSecond],
    [src_second,  5,  5 * durationSecond],
    [src_second, 15, 15 * durationSecond],
    [src_second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(ticks_tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return src_millisecond.every(Math.max(ticks_tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

const [utcTicks, utcTickInterval] = ticker(src_utcYear, src_utcMonth, utcSunday, src_utcDay, src_utcHour, src_utcMinute);
const [timeTicks, timeTickInterval] = ticker(src_year, src_month, sunday, src_day, src_hour, src_minute);



;// ./node_modules/d3-scale/src/nice.js
function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

;// ./node_modules/d3-scale/src/time.js






function time_date(t) {
  return new Date(t);
}

function time_number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, time_number)) : domain().map(time_date);
  };

  scale.ticks = function(interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, src_year, src_month, sunday, src_day, src_hour, src_minute, src_second, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

;// ./src/js/nv/models/multiChart.js














var AXIS_LABEL_DISTANCE = constants_Constants.AXIS_LABEL_DISTANCE,
  multiChart_FONT_SIZE = constants_Constants.FONT_SIZE,
  MULTI_CHART_TICK_LABEL_ROTATION = constants_Constants.MULTI_CHART_TICK_LABEL_ROTATION,
  multiChart_MULTI_CHART_MAX_TICK_LABEL_LINES = constants_Constants.MULTI_CHART_MAX_TICK_LABEL_LINES,
  multiChart_MULTI_CHART_TICK_LABEL_FALLBACK = constants_Constants.MULTI_CHART_TICK_LABEL_FALLBACK,
  multiChart_HIDDEN_CLASS = constants_Constants.HIDDEN_CLASS,
  multiChart_NO_DISPLAY_CLASS = constants_Constants.NO_DISPLAY_CLASS,
  Y_AXIS_TICK_DISTANCE = constants_Constants.Y_AXIS_TICK_DISTANCE,
  multiChart_SHOW_VALUE_OPTIONS = constants_Constants.SHOW_VALUE_OPTIONS;
var multiChart = function multiChart(nv) {
  nv.models.multiChart = function () {
    var margin = {
        top: 30,
        right: 20,
        bottom: 50,
        left: 60
      },
      color = nv.upgradedUtils.defaultColor(),
      width = null,
      height = null,
      showLegend = true,
      noData = null,
      yDomain1,
      yDomain2,
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      curve = monotoneX,
      useVoronoi = true,
      useRegionInteraction = false,
      legendRightAxisHint = ' (right axis)',
      showXAxis = true,
      showYAxis = true,
      showYAxis2 = true,
      splitYAxes = false,
      splitYAxesRatio = 0.5,
      splitYAxesPadding = 25,
      wrapLabels = true,
      padDataOuter = 0.1,
      padData = false,
      defaultType = 'bar',
      defaultAxis = 1,
      showVerticalGrid = false,
      showHorizontalGrid = true,
      horizontalGridExtension = {
        left: 0,
        right: 0
      },
      showValues = false,
      showLineLabels = false,
      maxLineLabelWidth = 100,
      disableInteraction = false,
      duration = 300,
      stacked = true,
      valuePadding = 16,
      yDomainMin,
      yDomainMax,
      yDomain2Min,
      yDomain2Max,
      xScale = linear_linear(),
      yScale = linear_linear(),
      lineCount = 2,
      dynamicXAxis = true,
      labelLayoutGenerator = null,
      dataSizedVerticalGrids = false,
      dateAxisGroupBy = null,
      alternateXLabels = false,
      labelAngle = 0,
      referenceLines,
      dashed = false,
      widgetAsFilter = false;
    var x = xScale,
      yScale1 = yScale,
      yScale2 = linear_linear(),
      lines1 = nv.models.line().yScale(yScale1).valuePadding(valuePadding),
      lines2 = nv.models.line().yScale(yScale2).valuePadding(valuePadding),
      scatters1 = nv.models.upgradedScatter().yScale(yScale1),
      scatters2 = nv.models.upgradedScatter().yScale(yScale2),
      bars1 = nv.models.multiBar().stacked(false).yScale(yScale1).valuePadding(valuePadding),
      bars2 = nv.models.multiBar().stacked(false).yScale(yScale2).valuePadding(valuePadding),
      stack1 = nv.models.stackedArea().yScale(yScale1),
      stack2 = nv.models.stackedArea().yScale(yScale2),
      xAxis = nv.models.upgradedAxis('bottom').scale(x).tickPadding(14);
    var yAxis1 = nv.models.upgradedAxis('left').scale(yScale1).showMaxMin(false),
      yAxis2 = nv.models.upgradedAxis('right').scale(yScale2).showMaxMin(false),
      legend = nv.models.upgradedLegend().height(20),
      tooltip = nv.models.upgradedTooltip(),
      dispatch = src_dispatch('renderEnd', 'elementClick', 'areaClick', 'pathClick'),
      interactionDispatch,
      selectedDataPoint;
    var renderWatch = nv.upgradedUtils.renderWatch(dispatch);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var _margin$rightLabel;
        var initialTooltipState = tooltip.enabled();
        if (useRegionInteraction) {
          tooltip.enabled(false);
        }
        var container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        chart.update = function () {
          container.transition().call(chart);
        };
        chart.container = this;
        if (splitYAxes) {
          margin.left -= margin.leftLabel;
        }
        var availableWidth = nv.upgradedUtils.availableWidth(width, container, margin),
          availableHeight = nv.upgradedUtils.availableHeight(height, container, margin);
        var generateFilterFunction = function generateFilterFunction(type, axis) {
          return function (d) {
            return d.type === type && d.yAxis === axis;
          };
        };
        data.forEach(function (d) {
          if (!d.type || d.setToDefaultType) {
            d.type = defaultType;
            d.setToDefaultType = true;
          }
          if (!d.yAxis) {
            d.yAxis = defaultAxis;
          }
        });
        var dataLines1 = data.filter(generateFilterFunction('line', 1));
        var dataLines2 = data.filter(generateFilterFunction('line', 2));
        var dataScatters1 = data.filter(generateFilterFunction('scatter', 1));
        var dataScatters2 = data.filter(generateFilterFunction('scatter', 2));
        var dataBars1 = data.filter(generateFilterFunction('bar', 1));
        var dataBars2 = data.filter(generateFilterFunction('bar', 2));
        var dataStack1 = data.filter(generateFilterFunction('area', 1));
        var dataStack2 = data.filter(generateFilterFunction('area', 2));
        if (!data || !data.length || !data.filter(function (_ref) {
          var values = _ref.values;
          return values.length;
        }).length) {
          nv.upgradedUtils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        var getSeriesData = function getSeriesData(data, yAxisIndex) {
          return data.filter(function (_ref2) {
            var disabled = _ref2.disabled,
              yAxis = _ref2.yAxis;
            return !disabled && yAxis === yAxisIndex;
          }).map(function (_ref3) {
            var values = _ref3.values;
            return values.map(function (d, i) {
              return {
                x: getX(d, i),
                y: getY(d, i),
                label: d.label,
                dateString: d.dateString
              };
            });
          });
        };
        var series1 = getSeriesData(data, 1);
        var series2 = getSeriesData(data, 2);
        var allValues = merge(series1.concat(series2));
        var xDomain;
        var xValues;
        var isSinglePoint;
        var getXValue = getX;
        if (dateAxisGroupBy && !allValues.find(function (_ref4) {
          var dateString = _ref4.dateString;
          return !dateString;
        })) {
          var dateParser = upgradedGetDateStringParser(dateAxisGroupBy);
          var xDates = allValues.map(function (_ref5) {
            var dateString = _ref5.dateString;
            return dateParser(dateString);
          });
          xDomain = src_extent(xDates);
          xValues = upgradedGetDatesInRange(xDomain, dateAxisGroupBy);
          getXValue = function getXValue(d) {
            return d.__date || (d.__date = dateParser(d.dateString));
          };
          bars1.x(getXValue).xDomain(xValues).duration(0);
          bars2.x(getXValue).xDomain(xValues).duration(0);
          lines1.x(getXValue);
          lines2.x(getXValue);
          isSinglePoint = xDomain[0].getTime() === xDomain[1].getTime();
          if (isSinglePoint) {
            xDomain = [new Date(xDomain[0].getTime() - 1), new Date(xDomain[1].getTime() + 1)];
          }
        } else {
          xValues = nv.upgradedUtils.arrayUnique(allValues.map(function (_ref6) {
            var x = _ref6.x;
            return x;
          }));
          xDomain = src_extent(xValues.map(function (d) {
            return parseInt(d, 10);
          }));
          bars1.x(getX).xDomain(null).duration(duration);
          bars2.x(getX).xDomain(null).duration(duration);
          lines1.x(getX);
          lines2.x(getX);
          isSinglePoint = xDomain[0] === xDomain[1];
          if (isSinglePoint) {
            xDomain = xDomain[0] ? [xDomain[0] - xDomain[0] * 0.01, xDomain[1] + xDomain[1] * 0.01] : [-1, 1];
          }
        }
        var chartDimensions = nv.chartHelpers.getChartDimensions(availableWidth, data, xValues.length, stacked, dataBars1, dataBars2, showValues, yAxis1.tickFormat(), yAxis2.tickFormat(), getY, container);
        var showBarValues = showValues && !chartDimensions.hideValues;
        bars1.showValues(showBarValues);
        bars2.showValues(showBarValues);
        var spacePerLabel = chartDimensions.columnWidth;
        if (showXAxis && dynamicXAxis && labelLayoutGenerator) {
          var labels = xValues.map(function (xValue) {
            return xAxis.tickFormat()(xValue);
          });
          var labelLayout = labelLayoutGenerator(availableHeight, chartDimensions.columnWidth, labels, margin.left, dateAxisGroupBy ? 0 : MULTI_CHART_TICK_LABEL_ROTATION);
          availableHeight -= labelLayout.maxHeight + 10;
          lineCount = labelLayout.lineCount;
          spacePerLabel = labelLayout.maxLineSpaceUsed;
          labelAngle = labelLayout.angle || 0;
          alternateXLabels = labelLayout.maxWidth > chartDimensions.columnWidth;
        }
        xAxis.rotateLabels(labelAngle);
        x.domain(xDomain).range(chartDimensions.xRange);
        if (padData && data[0] && !isSinglePoint) {
          var barWidth = chartDimensions.barWidth,
            groupWidth = chartDimensions.groupWidth,
            outerPaddingWidth = chartDimensions.outerPaddingWidth,
            xRange = chartDimensions.xRange,
            groupPaddingRatio = chartDimensions.groupPaddingRatio,
            outerPaddingRatio = chartDimensions.outerPaddingRatio;
          var groupOffset = groupWidth / 2;
          var totalOffset = outerPaddingWidth + groupOffset;
          var rangeStart = xRange[0] + totalOffset;
          var rangeEnd = xRange[1] - totalOffset;
          if (dataBars1.length || dataBars2.length) {
            var tempScale = band().domain(xValues);
            if (barWidth === 1) {
              tempScale.range(xRange).paddingInner(groupPaddingRatio).paddingOuter(outerPaddingRatio);
            } else {
              tempScale.rangeRound(xRange).paddingInner(groupPaddingRatio).paddingOuter(outerPaddingRatio);
            }
            var tempRange = xValues.map(function (d) {
              return tempScale(d);
            });
            rangeStart = tempRange[0] + groupOffset;
            rangeEnd = tempRange[tempRange.length - 1] + groupOffset;
          }
          x.range([rangeStart, rangeEnd]);
        }
        var wrap = container.selectAll('g.wrap.multiChart').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'wrap nvd3 multiChart').append('g');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-zeroLine').append('line');
        gEnter.append('g').attr('class', 'nv-y1 nv-axis');
        gEnter.append('g').attr('class', 'nv-y2 nv-axis');
        gEnter.append('g').attr('class', 'guidelineWrap');
        gEnter.append('g').attr('class', 'stack1Wrap');
        gEnter.append('g').attr('class', 'stack2Wrap');
        gEnter.append('g').attr('class', 'bars1Wrap');
        gEnter.append('g').attr('class', 'bars2Wrap');
        gEnter.append('g').attr('class', 'scatters1Wrap');
        gEnter.append('g').attr('class', 'scatters2Wrap');
        gEnter.append('g').attr('class', 'lines1Wrap');
        gEnter.append('g').attr('class', 'lines2Wrap');
        gEnter.append('g').attr('class', 'nv-tickLabel-y1 nv-axis');
        gEnter.append('g').attr('class', 'nv-tickLabel-y2 nv-axis');
        gEnter.append('g').attr('class', 'legendWrap');
        gEnter.append('g').attr('class', 'interactionWrap');
        var g = gEnter.merge(wrap).select('g');
        var gMergeSelection = gEnter.merge(g);
        var color_array = data.map(function (d, i) {
          return data[i].color || color(d, i);
        });
        if (showLegend) {
          var legendWidth = legend.align() ? availableWidth / 2 : availableWidth;
          var legendXPosition = legend.align() ? legendWidth : 0;
          renderWatch.models(legend);
          legend.width(legendWidth);
          legend.color(color_array);
          gMergeSelection.select('.legendWrap').datum(data.map(function (series) {
            series.originalKey = series.originalKey === undefined ? series.key : series.originalKey;
            series.key = series.originalKey + (series.yAxis === 1 ? '' : legendRightAxisHint);
            return series;
          })).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.upgradedUtils.availableHeight(height, container, margin);
          }
          gMergeSelection.select('.legendWrap').attr('transform', 'translate(' + legendXPosition + ',' + -margin.top + ')');
        }
        var undisabledBars1 = dataBars1.filter(function (d) {
          return !d.disabled;
        });
        var undisabledBars2 = dataBars2.filter(function (d) {
          return !d.disabled;
        });
        if (undisabledBars1.length || undisabledBars2.length) {
          lines1.padY(false);
          lines2.padY(false);
        }
        lines1.width(x.range()[1] - x.range()[0] || 1).height(availableHeight).valueFormat(yAxis1.tickFormat()).curve(curve).dashed(dashed).disableInteraction(disableInteraction).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 1 && data[i].type === 'line';
        }));
        lines2.width(x.range()[1] - x.range()[0] || 1).height(availableHeight).valueFormat(yAxis2.tickFormat()).curve(curve).dashed(dashed).disableInteraction(disableInteraction).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 2 && data[i].type === 'line';
        }));
        scatters1.width(x.range()[1] - x.range()[0]).height(availableHeight).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 1 && data[i].type === 'scatter';
        }));
        scatters2.width(x.range()[1] - x.range()[0]).height(availableHeight).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 2 && data[i].type === 'scatter';
        }));
        bars1.width(availableWidth).height(availableHeight).xRange(chartDimensions.xRange).barWidth(chartDimensions.barWidth).columnWidth(chartDimensions.columnWidth).innerPaddingWidth(chartDimensions.innerPaddingWidth).groupPaddingRatio(chartDimensions.groupPaddingRatio).outerPaddingRatio(chartDimensions.outerPaddingRatio).valueFormat(yAxis1.tickFormat()).disableInteraction(disableInteraction).padAfter(stacked ? undisabledBars2.length ? 1 : undisabledBars2.length : undisabledBars2.length || 0).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 1 && data[i].type === 'bar';
        }));
        bars2.width(availableWidth).height(availableHeight).xRange(chartDimensions.xRange).barWidth(chartDimensions.barWidth).columnWidth(chartDimensions.columnWidth).innerPaddingWidth(chartDimensions.innerPaddingWidth).groupPaddingRatio(chartDimensions.groupPaddingRatio).outerPaddingRatio(chartDimensions.outerPaddingRatio).valueFormat(yAxis2.tickFormat()).disableInteraction(disableInteraction).padBefore(stacked ? undisabledBars1.length ? 1 : undisabledBars1.length : undisabledBars1.length || 0).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 2 && data[i].type === 'bar';
        }));
        stack1.width(x.range()[1] - x.range()[0]).height(availableHeight).valueFormat(yAxis1.tickFormat()).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 1 && data[i].type === 'area';
        }));
        stack2.width(x.range()[1] - x.range()[0]).height(availableHeight).valueFormat(yAxis2.tickFormat()).color(color_array.filter(function (d, i) {
          return !data[i].disabled && data[i].yAxis === 2 && data[i].type === 'area';
        }));
        gMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var guidelineWrap = gMergeSelection.select('.guidelineWrap');
        var lines1Wrap = gMergeSelection.select('.lines1Wrap').datum(dataLines1.filter(function (d) {
          return !d.disabled;
        }));
        var scatters1Wrap = gMergeSelection.select('.scatters1Wrap').datum(dataScatters1.filter(function (d) {
          return !d.disabled;
        }));
        var bars1Wrap = gMergeSelection.select('.bars1Wrap').datum(dataBars1.filter(function (d) {
          return !d.disabled;
        }));
        var stack1Wrap = gMergeSelection.select('.stack1Wrap').datum(dataStack1.filter(function (d) {
          return !d.disabled;
        }));
        var lines2Wrap = gMergeSelection.select('.lines2Wrap').datum(dataLines2.filter(function (d) {
          return !d.disabled;
        }));
        var scatters2Wrap = gMergeSelection.select('.scatters2Wrap').datum(dataScatters2.filter(function (d) {
          return !d.disabled;
        }));
        var bars2Wrap = gMergeSelection.select('.bars2Wrap').datum(dataBars2.filter(function (d) {
          return !d.disabled;
        }));
        var stack2Wrap = gMergeSelection.select('.stack2Wrap').datum(dataStack2.filter(function (d) {
          return !d.disabled;
        }));
        var interactionWrap = gMergeSelection.select('.interactionWrap');
        interactionWrap.attr('aria-hidden', true);
        var hasLines1 = !!dataLines1.length;
        var hasLines2 = !!dataLines2.length;
        var hasBars1 = !!dataBars1.length;
        var hasBars2 = !!dataBars2.length;
        var hasScatters1 = !!dataScatters1.length;
        var hasScatters2 = !!dataScatters2.length;
        var hasStack1 = !!dataStack1.length;
        var hasStack2 = !!dataStack2.length;
        !hasLines1 && gMergeSelection.select('.lines1Wrap').selectAll('*').remove();
        !hasLines2 && gMergeSelection.select('.lines2Wrap').selectAll('*').remove();
        !hasBars1 && gMergeSelection.select('.bars1Wrap').selectAll('*').remove();
        !hasBars2 && gMergeSelection.select('.bars2Wrap').selectAll('*').remove();
        !hasScatters1 && gMergeSelection.select('.scatters1Wrap').selectAll('*').remove();
        !hasScatters2 && gMergeSelection.select('.scatters2Wrap').selectAll('*').remove();
        !hasStack1 && gMergeSelection.select('.stack1Wrap').selectAll('*').remove();
        !hasStack2 && gMergeSelection.select('.stack2Wrap').selectAll('*').remove();
        var isNum = function isNum(num) {
          return nv.upgradedUtils.isNumeric(num);
        };
        var getYDomain = function getYDomain(series, dataStack, dataBars, yMin, yMax) {
          var format = d3.format('.4f');
          var getStackedValues = function getStackedValues(stackedData) {
            if (!stackedData || !stackedData.length) {
              return [];
            }
            return stackedData.map(function (_ref7) {
              var values = _ref7.values;
              return values.map(getY);
            }).reduce(function (sumValues, values) {
              return sumValues.map(function (sumVal, i) {
                return +format(sumVal + values[i]);
              });
            });
          };
          var yValues = merge(series).map(function (_ref8) {
            var y = _ref8.y;
            return y;
          });
          if (referenceLines && yValues.length) {
            referenceLines.forEach(function (referenceLine) {
              yValues.push(referenceLine.y);
            });
          }
          if (dataStack.length || dataBars.length) {
            yValues = yValues.concat([0]).concat(getStackedValues(dataStack)).concat(getStackedValues(stacked ? dataBars : []));
          }
          var yDomain = src_extent(yValues);
          var distortion = 0.0001;
          if (isNum(yMin)) {
            yDomain[0] = parseFloat(yMin);
            if (!isNum(yMax) && yDomain[1] <= yDomain[0]) {
              yDomain[1] = yDomain[0] + distortion;
            }
          }
          if (isNum(yMax)) {
            yDomain[1] = parseFloat(yMax);
            if (!isNum(yMin) && yDomain[1] <= yDomain[0]) {
              yDomain[0] = yDomain[1] - distortion;
            }
          }
          return yDomain;
        };
        var _yDomain1 = yDomain1 || getYDomain(series1, dataStack1, dataBars1, yDomainMin, yDomainMax);
        yScale1.domain(_yDomain1).range([0, availableHeight]).clamp(true);
        if (!yDomain1 && !isNum(yDomainMin) && !isNum(yDomainMax) && (showHorizontalGrid || showYAxis)) {
          var yAxis1TickCount = nv.upgradedUtils.calcTicksY(availableHeight / Y_AXIS_TICK_DISTANCE, data, _yDomain1, yAxis1.tickFormat());
          yScale1.nice(yAxis1TickCount);
        }
        var _yDomain2 = yDomain2 || getYDomain(series2, dataStack2, dataBars2, yDomain2Min, yDomain2Max);
        yScale2.domain(_yDomain2).range([0, availableHeight]).clamp(true);
        if (!yDomain2 && !isNum(yDomain2Min) && !isNum(yDomain2Max) && (showHorizontalGrid || showYAxis2)) {
          var yAxis2TickCount = nv.upgradedUtils.calcTicksY(availableHeight / Y_AXIS_TICK_DISTANCE, data, _yDomain2, yAxis2.tickFormat());
          yScale2.nice(yAxis2TickCount);
        }
        lines1.yDomain(yScale1.domain());
        scatters1.yDomain(yScale1.domain());
        bars1.yDomain(yScale1.domain());
        stack1.yDomain(yScale1.domain());
        lines2.yDomain(yScale2.domain());
        scatters2.yDomain(yScale2.domain());
        bars2.yDomain(yScale2.domain());
        stack2.yDomain(yScale2.domain());
        var yHeight1 = splitYAxes ? availableHeight * splitYAxesRatio - splitYAxesPadding : availableHeight;
        var yRange1 = [yHeight1, 0];
        var yHeight2 = splitYAxes ? availableHeight * splitYAxesRatio + splitYAxesPadding : 0;
        var yRange2 = [availableHeight, yHeight2];
        var canAddValuePadding = availableHeight > valuePadding;
        if (showValues && canAddValuePadding) {
          if (hasBars1 && !stacked || hasScatters1 || hasStack1 || hasLines1 && lines1.showValues() !== multiChart_SHOW_VALUE_OPTIONS.LAST) {
            if (yScale1.domain()[1] >= 0) {
              yRange1[1] += valuePadding;
            }
            if (yScale1.domain()[0] < 0) {
              yRange1[0] -= valuePadding;
            }
          }
          if (hasBars2 && !stacked || hasScatters2 || hasStack2 || hasLines2 && lines2.showValues() !== multiChart_SHOW_VALUE_OPTIONS.LAST) {
            if (yScale2.domain()[1] >= 0) {
              yRange2[1] += valuePadding;
            }
            if (yScale2.domain()[0] < 0) {
              yRange2[0] -= valuePadding;
            }
          }
        }
        lines1.yRange(yRange1);
        scatters1.yRange(yRange1);
        bars1.yRange(yRange1);
        stack1.yRange(yRange1);
        lines2.yRange(yRange2);
        scatters2.yRange(yRange2);
        bars2.yRange(yRange2);
        stack2.yRange(yRange2);
        if (dataStack1.length) {
          renderWatch.models(stack1);
          stack1Wrap.attr('transform', 'translate(' + x.range()[0] + ', 0)');
          stack1Wrap.transition().call(stack1);
        }
        if (dataStack2.length) {
          renderWatch.models(stack2);
          stack2Wrap.attr('transform', 'translate(' + x.range()[0] + ', 0)');
          stack2Wrap.transition().call(stack2);
        }
        if (dataBars1.length) {
          renderWatch.models(bars1);
          bars1Wrap.transition().call(bars1);
        }
        if (dataBars2.length) {
          renderWatch.models(bars2);
          bars2Wrap.transition().call(bars2);
        }
        if (dataLines1.length) {
          renderWatch.models(lines1);
          lines1Wrap.attr('transform', 'translate(' + x.range()[0] + ',0)');
          lines1Wrap.transition().call(lines1);
        }
        if (dataLines2.length) {
          renderWatch.models(lines2);
          lines2Wrap.attr('transform', 'translate(' + x.range()[0] + ',0)');
          lines2Wrap.transition().call(lines2);
        }
        if (dataScatters1.length) {
          renderWatch.models(scatters1);
          scatters1Wrap.attr('transform', 'translate(' + x.range()[0] + ',0)');
          scatters1Wrap.transition().call(scatters1);
        }
        if (dataScatters2.length) {
          renderWatch.models(scatters2);
          scatters2Wrap.attr('transform', 'translate(' + x.range()[0] + ',0)');
          scatters2Wrap.transition().call(scatters2);
        }
        var tickCount = nv.upgradedUtils.calcTickCount(data);
        renderWatch.models(xAxis);
        xAxis.height(margin.bottom);
        if (!dateAxisGroupBy) {
          xAxis._ticks(tickCount).placeLabelAt(availableWidth / 2);
        }
        if (!isSinglePoint && xDomain && !dateAxisGroupBy) {
          var ticks = [];
          for (var i = xDomain[0]; i <= xDomain[1]; i++) {
            ticks.push(i);
          }
          xAxis.tickValues(ticks);
        } else {
          xAxis.tickValues(null);
        }
        gMergeSelection.select('.nv-x.nv-axis').attr('transform', "translate(0, ".concat(availableHeight, " )")).attr('aria-hidden', true).classed('alternate-labels', alternateXLabels);
        xAxis.tickSize(-availableHeight, 0);
        gMergeSelection.select('.nv-x.nv-axis').transition().call(xAxis);
        gMergeSelection.selectAll('.nv-x.nv-axis .tick text').classed(multiChart_NO_DISPLAY_CLASS, !showXAxis);
        gMergeSelection.selectAll('.nv-x.nv-axis .nv-axislabel').classed(multiChart_NO_DISPLAY_CLASS, !showXAxis);
        gMergeSelection.selectAll('.nv-x.nv-axis line').classed(multiChart_HIDDEN_CLASS, !showVerticalGrid);
        var horizontalLineLength = -availableWidth - horizontalGridExtension.right - margin.leftLabel;
        var zeroLine = gMergeSelection.select('.nv-zeroLine line');
        var zeroY = hasBars1 || hasBars2 ? yScale(0) : availableHeight;
        zeroLine.attr('x1', 0).attr('x2', -horizontalLineLength).attr('y1', zeroY).attr('y2', zeroY).attr('transform', "translate(".concat(-margin.leftLabel, ",0)")).classed(multiChart_HIDDEN_CLASS, !showXAxis || showHorizontalGrid);
        if (showXAxis) {
          var xAxisSelection = gMergeSelection.selectAll('.nv-x.nv-axis');
          var xAxisTickLabels = xAxisSelection.selectAll('.tick text');
          xAxisSelection.transition().on('end', function () {
            if (wrapLabels && !dateAxisGroupBy) {
              xAxisTickLabels.call(nv.upgradedUtils.wrapTicks, spacePerLabel, min_min([multiChart_MULTI_CHART_MAX_TICK_LABEL_LINES, lineCount || multiChart_MULTI_CHART_TICK_LABEL_FALLBACK]), labelAngle);
            }
            var maxTickLabelHeight = 0;
            if (labelAngle) {
              xAxisTickLabels.each(function () {
                var bbox = this.getBBox();
                var width = bbox.width;
                if (width > maxTickLabelHeight) {
                  maxTickLabelHeight = width;
                }
                var actualLineCount = src_select(this).selectAll('tspan').size();
                var translateLabel = 2 - actualLineCount * (multiChart_FONT_SIZE / 2);
                var existingRotation = src_select(this).attr('transform');
                src_select(this).attr('transform', "translate(".concat(translateLabel, ",0)") + existingRotation);
              });
            } else {
              xAxisTickLabels.each(function () {
                var bbox = this.getBBox();
                var height = bbox.height;
                if (height > maxTickLabelHeight) {
                  maxTickLabelHeight = height;
                }
              });
            }
            var xAxisLabel = xAxisSelection.selectAll('text.nv-axislabel');
            xAxisLabel.call(nv.upgradedUtils.truncateText, availableWidth - AXIS_LABEL_DISTANCE);
            xAxisLabel.attr('transform', "translate(0,".concat(maxTickLabelHeight + multiChart_FONT_SIZE / 2, ")"));
            if (showVerticalGrid && dataSizedVerticalGrids) {
              var tickSize = data.reduce(function (tickSize, entry) {
                if (entry.values) {
                  entry.values.forEach(function (element, i) {
                    var xIndex = getX(element, i);
                    if (tickSize[xIndex]) {
                      tickSize[xIndex] = Math.max(tickSize[xIndex], element.y);
                    } else {
                      tickSize[xIndex] = element.y;
                    }
                  });
                }
                return tickSize;
              }, {});
              for (var key in tickSize) {
                tickSize[key] = (yScale(tickSize[key]) || 0) - availableHeight;
              }
              xAxisSelection.selectAll('.tick line').call(nv.upgradedUtils.variableTicks, tickSize);
            }
          });
        }
        var yAxis1Domain = yAxis1.scale().domain();
        renderWatch.models(yAxis1);
        yAxis1._ticks(nv.upgradedUtils.calcTicksY(availableHeight / Y_AXIS_TICK_DISTANCE, data, yAxis1Domain, yAxis1.tickFormat())).showMaxMin(false);
        var translateY1 = function translateY1() {
          return "translate(".concat(splitYAxes ? 0 : -margin.leftLabel, ", 0)");
        };
        yAxis1.tickSize(horizontalLineLength, horizontalGridExtension.left);
        gMergeSelection.select('.nv-y1.nv-axis').transition().call(yAxis1);
        gMergeSelection.selectAll('.nv-y1.nv-axis').selectAll('text').remove();
        if (showYAxis) {
          gMergeSelection.select('.nv-y1.nv-axis').classed('nv-disabled', series1.length ? false : true).attr('transform', translateY1);
        } else {
          gMergeSelection.select('.nv-y1.nv-axis').attr('transform', null);
        }
        gMergeSelection.select('.nv-tickLabel-y1.nv-axis').transition().call(yAxis1);
        gMergeSelection.selectAll('.nv-tickLabel-y1.nv-axis').selectAll('line').remove();
        gMergeSelection.selectAll('.nv-tickLabel-y1.nv-axis').attr('transform', translateY1).attr('aria-hidden', true);
        gMergeSelection.selectAll('.nv-ticklabel-y1.nv-axis text.nv-axislabel').call(nv.upgradedUtils.truncateText, availableHeight - AXIS_LABEL_DISTANCE);
        gMergeSelection.selectAll('.nv-tickLabel-y1.nv-axis .tick line').remove();
        gMergeSelection.selectAll('.nv-tickLabel-y1.nv-axis .tick rect').classed(multiChart_NO_DISPLAY_CLASS, !showYAxis);
        gMergeSelection.selectAll('.nv-tickLabel-y1.nv-axis .tick text').classed(multiChart_NO_DISPLAY_CLASS, !showYAxis);
        gMergeSelection.selectAll('.nv-y1.nv-axis .tick text').remove();
        gMergeSelection.selectAll('.nv-y1.nv-axis .tick line').classed(multiChart_HIDDEN_CLASS, !showHorizontalGrid);
        gMergeSelection.selectAll('.nv-tickLabel-y1.nv-axis .nv-axislabel').classed(multiChart_NO_DISPLAY_CLASS, !showYAxis);
        var yAxis2Domain = yAxis2.scale().domain();
        renderWatch.models(yAxis2);
        if (splitYAxes) {
          yAxis2 = nv.models.upgradedAxis('left').scale(yScale2);
        }
        yAxis2._ticks(nv.upgradedUtils.calcTicksY(availableHeight / Y_AXIS_TICK_DISTANCE, data, yAxis2Domain, yAxis2.tickFormat())).showMaxMin(false);
        if (showHorizontalGrid) {
          if (splitYAxes) {
            yAxis2.tickSize(-availableWidth - horizontalGridExtension.right - margin.leftLabel, horizontalGridExtension.left);
          } else {
            yAxis2.tickSize(-16, 0);
          }
        } else {
          yAxis2.tickSize(0);
        }
        var yAxis2TickOffset = (_margin$rightLabel = margin.rightLabel) !== null && _margin$rightLabel !== void 0 ? _margin$rightLabel : 0;
        var dotOffset = availableWidth % 5;
        var translateY2 = function translateY2() {
          return "translate(".concat(splitYAxes ? 0 : availableWidth - dotOffset + yAxis2TickOffset, ", 0)");
        };
        gMergeSelection.select('.nv-y2.nv-axis').transition().call(yAxis2);
        gMergeSelection.selectAll('.nv-y2.nv-axis').selectAll('text').remove();
        gMergeSelection.select('.nv-y2.nv-axis').classed('nv-disabled', false).classed('split-axis', splitYAxes).attr('transform', translateY2);
        gMergeSelection.select('.nv-tickLabel-y2.nv-axis').transition().call(yAxis2);
        gMergeSelection.select('.nv-tickLabel-y2.nv-axis').classed('nv-disabled', false).classed('split-axis', splitYAxes).attr('transform', translateY2).attr('aria-hidden', true);
        gMergeSelection.selectAll('.nv-tickLabel-y2.nv-axis').selectAll('line').remove();
        gMergeSelection.selectAll('.nv-tickLabel-y2.nv-axis .tick line').remove();
        gMergeSelection.selectAll('.nv-tickLabel-y2.nv-axis .tick rect').classed(multiChart_NO_DISPLAY_CLASS, !showYAxis2);
        gMergeSelection.selectAll('.nv-tickLabel-y2.nv-axis .tick text').classed(multiChart_NO_DISPLAY_CLASS, !showYAxis2);
        gMergeSelection.selectAll('.nv-y2.nv-axis .tick text').remove();
        gMergeSelection.selectAll('.nv-y2.nv-axis .tick line').classed(multiChart_HIDDEN_CLASS, !showHorizontalGrid);
        gMergeSelection.selectAll('.nv-tickLabel-y2.nv-axis .nv-axislabel').classed(multiChart_NO_DISPLAY_CLASS, !showYAxis2);
        legend.dispatch.on('stateChange', function () {
          chart.update();
        });
        function mouseover_line(evt) {
          var isYAxis2 = data[evt.seriesIndex].yAxis === 2;
          var yaxis = isYAxis2 ? yAxis2 : yAxis1;
          evt.value = evt.point.x;
          evt.series = {
            value: evt.point.y,
            color: evt.point.color,
            key: evt.series.key
          };
          tooltip.duration(0).valueFormatter(function (d, i) {
            return yaxis.tickFormat()(d, i);
          }).data(evt).position(function () {
            return evt.pos;
          }).hidden(false);
        }
        function mouseover_scatter(evt) {
          var yaxis = data[evt.seriesIndex].yAxis === 2 ? yAxis2 : yAxis1;
          evt.value = evt.point.x;
          evt.series = {
            value: evt.point.y,
            color: evt.point.color,
            key: evt.series.key
          };
          tooltip.duration(100).valueFormatter(function (d, i) {
            return yaxis.tickFormat()(d, i);
          }).data(evt).hidden(false);
        }
        function mouseover_stack(evt) {
          var yaxis = data[evt.seriesIndex].yAxis === 2 ? yAxis2 : yAxis1;
          evt.point.x = stack1.x()(evt.point);
          evt.point.y = stack1.y()(evt.point);
          tooltip.duration(0).valueFormatter(function (d, i) {
            return yaxis.tickFormat()(d, i);
          }).data(evt).position(function () {
            return evt.pos;
          }).hidden(false);
        }
        function mouseover_bar(evt) {
          var isYAxis2 = data[evt.data.series].yAxis === 2;
          var yaxis = isYAxis2 ? yAxis2 : yAxis1;
          var chart = isYAxis2 ? bars2 : bars1;
          evt.value = chart.x()(evt.data);
          evt.series = {
            value: chart.y()(evt.data),
            color: evt.color,
            key: evt.data.key
          };
          tooltip.duration(0).valueFormatter(function (d, i) {
            return yaxis.tickFormat()(d, i);
          }).data(evt).hidden(false);
        }
        var resetSelectedDataPoint = function resetSelectedDataPoint() {
          selectedDataPoint = undefined;
          lines2.selectedDataPoint(undefined);
          lines1.selectedDataPoint(undefined);
          bars1.selectedDataPoint(undefined);
          bars2.selectedDataPoint(undefined);
          chart.update();
        };
        if (!disableInteraction) {
          if (useRegionInteraction) {
            interactionDispatch = upgradedInteractionHandler({
              container: interactionWrap,
              data: data,
              height: availableHeight,
              xScale: xScale,
              yScale: !showYAxis && showYAxis2 ? yScale2 : yScale1,
              getX: getXValue,
              chartDimensions: chartDimensions,
              isHorizontal: false,
              isStacked: stacked,
              cutOffLastRegion: defaultType === 'line'
            });
            upgradedGuidelineHandler({
              guidelineLength: availableHeight,
              guidelineWrap: guidelineWrap,
              interactionDispatch: interactionDispatch,
              isHorizontal: false,
              isEnabled: initialTooltipState
            });
            upgradedTooltipHandler({
              color: color,
              container: container,
              data: data,
              interactionDispatch: interactionDispatch,
              margin: margin,
              tooltip: tooltip,
              yAxis: !showYAxis && showYAxis2 ? yAxis2 : yAxis1,
              width: width,
              yScale: !showYAxis && showYAxis2 ? yScale2 : yScale,
              isStacked: stacked
            });
            chart.interactionDispatch(interactionDispatch);
            tooltip.enabled(initialTooltipState);
          } else {
            lines1.dispatch.on('elementMouseover.tooltip', mouseover_line);
            lines2.dispatch.on('elementMouseover.tooltip', mouseover_line);
            lines1.dispatch.on('elementMouseout.tooltip', function () {
              tooltip.hidden(true);
            });
            lines2.dispatch.on('elementMouseout.tooltip', function () {
              tooltip.hidden(true);
            });
            scatters1.dispatch.on('elementMouseover.tooltip', mouseover_scatter);
            scatters2.dispatch.on('elementMouseover.tooltip', mouseover_scatter);
            scatters1.dispatch.on('elementMouseout.tooltip', function () {
              tooltip.hidden(true);
            });
            scatters2.dispatch.on('elementMouseout.tooltip', function () {
              tooltip.hidden(true);
            });
            bars1.dispatch.on('elementMouseover.tooltip', mouseover_bar);
            bars2.dispatch.on('elementMouseover.tooltip', mouseover_bar);
            bars1.dispatch.on('elementMouseout.tooltip', function () {
              tooltip.hidden(true);
            });
            bars2.dispatch.on('elementMouseout.tooltip', function () {
              tooltip.hidden(true);
            });
            bars1.dispatch.on('elementMousemove.tooltip', function () {
              tooltip();
            });
            bars2.dispatch.on('elementMousemove.tooltip', function () {
              tooltip();
            });
          }
          lines1.dispatch.on('elementClick', function (options) {
            if (widgetAsFilter) {
              selectedDataPoint = areDataPointsEqual(options, selectedDataPoint) ? undefined : options;
              bars1.selectedDataPoint(selectedDataPoint);
              bars2.selectedDataPoint(selectedDataPoint);
              lines2.selectedDataPoint(selectedDataPoint);
              bars1.isCurrentChartSelected(false);
              bars2.isCurrentChartSelected(false);
              lines2.isCurrentChartSelected(false);
            }
            chart.dispatch.call('elementClick', this, options);
          });
          lines2.dispatch.on('elementClick', function (options) {
            if (widgetAsFilter) {
              selectedDataPoint = areDataPointsEqual(options, selectedDataPoint) ? undefined : options;
              bars1.selectedDataPoint(selectedDataPoint);
              bars2.selectedDataPoint(selectedDataPoint);
              lines1.selectedDataPoint(selectedDataPoint);
              bars1.isCurrentChartSelected(false);
              bars2.isCurrentChartSelected(false);
              lines1.isCurrentChartSelected(false);
            }
            chart.dispatch.call('elementClick', this, options);
          });
          lines1.dispatch.on('selectedDataPointNotFound', function () {
            resetSelectedDataPoint();
          });
          lines2.dispatch.on('selectedDataPointNotFound', function () {
            resetSelectedDataPoint();
          });
          lines1.dispatch.on('pathClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          lines2.dispatch.on('pathClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          scatters1.dispatch.on('elementClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          scatters2.dispatch.on('elementClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          stack1.dispatch.on('elementMouseover.tooltip', mouseover_stack);
          stack2.dispatch.on('elementMouseover.tooltip', mouseover_stack);
          stack1.dispatch.on('elementMouseout.tooltip', function () {
            tooltip.hidden(true);
          });
          stack2.dispatch.on('elementMouseout.tooltip', function () {
            tooltip.hidden(true);
          });
          stack1.dispatch.on('elementClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          stack2.dispatch.on('elementClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          stack1.dispatch.on('areaClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          stack2.dispatch.on('areaClick', function (options) {
            chart.dispatch.call('elementClick', this, options);
          });
          bars1.dispatch.on('elementClick', function (options) {
            if (widgetAsFilter) {
              selectedDataPoint = areDataPointsEqual(options.data, selectedDataPoint) ? undefined : options.data;
              lines1.selectedDataPoint(selectedDataPoint);
              lines2.selectedDataPoint(selectedDataPoint);
              bars2.selectedDataPoint(selectedDataPoint);
              bars2.isCurrentChartSelected(false);
              lines1.isCurrentChartSelected(false);
              lines2.isCurrentChartSelected(false);
            }
            chart.dispatch.call('elementClick', this, options);
          });
          bars2.dispatch.on('elementClick', function (options) {
            if (widgetAsFilter) {
              selectedDataPoint = areDataPointsEqual(options.data, selectedDataPoint) ? undefined : options.data;
              lines1.selectedDataPoint(selectedDataPoint);
              lines2.selectedDataPoint(selectedDataPoint);
              bars1.selectedDataPoint(selectedDataPoint);
              bars1.isCurrentChartSelected(false);
              lines1.isCurrentChartSelected(false);
              lines2.isCurrentChartSelected(false);
            }
            chart.dispatch.call('elementClick', this, options);
          });
          bars1.dispatch.on('selectedDataPointNotFound', function () {
            resetSelectedDataPoint();
          });
          bars2.dispatch.on('selectedDataPointNotFound', function () {
            resetSelectedDataPoint();
          });
        }
      });
      renderWatch.renderEnd('multichart immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.legend = legend;
    chart.lines1 = lines1;
    chart.lines2 = lines2;
    chart.scatters1 = scatters1;
    chart.scatters2 = scatters2;
    chart.bars1 = bars1;
    chart.bars2 = bars2;
    chart.stack1 = stack1;
    chart.stack2 = stack2;
    chart.xAxis = xAxis;
    chart.yAxis1 = yAxis1;
    chart.yAxis2 = yAxis2;
    chart.tooltip = tooltip;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      yDomain1: {
        get: function get() {
          return yDomain1;
        },
        set: function set(_) {
          yDomain1 = _;
        }
      },
      yDomain2: {
        get: function get() {
          return yDomain2;
        },
        set: function set(_) {
          yDomain2 = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      curve: {
        get: function get() {
          return curve;
        },
        set: function set(_) {
          curve = _;
        }
      },
      legendRightAxisHint: {
        get: function get() {
          return legendRightAxisHint;
        },
        set: function set(_) {
          legendRightAxisHint = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      showYAxis2: {
        get: function get() {
          return showYAxis2;
        },
        set: function set(_) {
          showYAxis2 = _;
        }
      },
      splitYAxes: {
        get: function get() {
          return splitYAxes;
        },
        set: function set(_) {
          splitYAxes = _;
        }
      },
      splitYAxesRatio: {
        get: function get() {
          return splitYAxesRatio;
        },
        set: function set(_) {
          splitYAxesRatio = _;
        }
      },
      splitYAxesPadding: {
        get: function get() {
          return splitYAxesPadding;
        },
        set: function set(_) {
          splitYAxesPadding = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = !!_;
        }
      },
      padDataOuter: {
        get: function get() {
          return padDataOuter;
        },
        set: function set(_) {
          padDataOuter = _;
        }
      },
      padData: {
        get: function get() {
          return padData;
        },
        set: function set(_) {
          padData = _;
        }
      },
      defaultType: {
        get: function get() {
          return defaultType;
        },
        set: function set(_) {
          defaultType = _;
        }
      },
      showVerticalGrid: {
        get: function get() {
          return showVerticalGrid;
        },
        set: function set(_) {
          showVerticalGrid = _;
        }
      },
      showHorizontalGrid: {
        get: function get() {
          return showHorizontalGrid;
        },
        set: function set(_) {
          showHorizontalGrid = _;
        }
      },
      horizontalGridExtension: {
        get: function get() {
          return horizontalGridExtension;
        },
        set: function set(_) {
          horizontalGridExtension.right = _.right !== undefined ? _.right : horizontalGridExtension.right;
          horizontalGridExtension.left = _.left !== undefined ? _.left : horizontalGridExtension.left;
        }
      },
      yDomainMin: {
        get: function get() {
          return yDomainMin;
        },
        set: function set(_) {
          yDomainMin = _;
        }
      },
      yDomainMax: {
        get: function get() {
          return yDomainMax;
        },
        set: function set(_) {
          yDomainMax = _;
        }
      },
      yDomain2Min: {
        get: function get() {
          return yDomain2Min;
        },
        set: function set(_) {
          yDomain2Min = _;
        }
      },
      yDomain2Max: {
        get: function get() {
          return yDomain2Max;
        },
        set: function set(_) {
          yDomain2Max = _;
        }
      },
      xScale: {
        get: function get() {
          return xScale;
        },
        set: function set(_) {
          xScale = _;
        }
      },
      yScale: {
        get: function get() {
          return yScale;
        },
        set: function set(_) {
          yScale = _;
        }
      },
      yScale2: {
        get: function get() {
          return yScale2;
        },
        set: function set(_) {
          yScale2 = _;
        }
      },
      lineCount: {
        get: function get() {
          return lineCount;
        },
        set: function set(_) {
          lineCount = _;
        }
      },
      dataSizedVerticalGrids: {
        get: function get() {
          return dataSizedVerticalGrids;
        },
        set: function set(_) {
          dataSizedVerticalGrids = _;
        }
      },
      dynamicXAxis: {
        get: function get() {
          return dynamicXAxis;
        },
        set: function set(_) {
          dynamicXAxis = _;
        }
      },
      labelLayoutGenerator: {
        get: function get() {
          return labelLayoutGenerator;
        },
        set: function set(_) {
          labelLayoutGenerator = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = !!_;
          lines1.showValues(_);
          lines2.showValues(_);
          scatters1.showValues(!!_);
          scatters2.showValues(!!_);
          bars1.showValues(!!_);
          bars2.showValues(!!_);
          stack1.showValues(!!_);
          stack2.showValues(!!_);
        }
      },
      showLineLabels: {
        get: function get() {
          return showLineLabels;
        },
        set: function set(_) {
          showLineLabels = _;
          lines1.showLabels(_);
          lines2.showLabels(_);
        }
      },
      maxLineLabelWidth: {
        get: function get() {
          return maxLineLabelWidth;
        },
        set: function set(_) {
          maxLineLabelWidth = _;
          lines1.maxLabelWidth(_);
          lines2.maxLabelWidth(_);
        }
      },
      disableInteraction: {
        get: function get() {
          return disableInteraction;
        },
        set: function set(_) {
          disableInteraction = _;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          lines1.duration(_);
          lines2.duration(_);
          scatters1.duration(_);
          scatters2.duration(_);
          bars1.duration(_);
          bars2.duration(_);
          stack1.duration(_);
          stack2.duration(_);
          if (_ === 0) {
            xAxis.duration(_);
            yAxis1.duration(_);
            yAxis2.duration(_);
          }
        }
      },
      stacked: {
        get: function get() {
          return stacked;
        },
        set: function set(_) {
          stacked = _;
          bars1.stacked(_);
          bars2.stacked(_);
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
          margin.leftLabel = _.leftLabel !== undefined ? _.leftLabel : margin.leftLabel;
          margin.rightLabel = _.rightLabel !== undefined ? _.rightLabel : margin.rightLabel;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
          lines1.x(_);
          lines2.x(_);
          scatters1.x(_);
          scatters2.x(_);
          bars1.x(_);
          bars2.x(_);
          stack1.x(_);
          stack2.x(_);
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = _;
          lines1.y(_);
          lines2.y(_);
          scatters1.y(_);
          scatters2.y(_);
          bars1.y(_);
          bars2.y(_);
        }
      },
      useVoronoi: {
        get: function get() {
          return useVoronoi;
        },
        set: function set(_) {
          useVoronoi = _;
          lines1.useVoronoi(_);
          lines2.useVoronoi(_);
          stack1.useVoronoi(_);
          stack2.useVoronoi(_);
        }
      },
      dateAxisGroupBy: {
        get: function get() {
          return dateAxisGroupBy;
        },
        set: function set(_) {
          dateAxisGroupBy = _;
          x = xScale = dateAxisGroupBy ? time() : linear_linear();
          xAxis.dateAxisGroupBy(dateAxisGroupBy).scale(x);
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
          lines1.useRegionInteraction(_);
          lines2.useRegionInteraction(_);
          scatters1.useRegionInteraction(_);
          scatters2.useRegionInteraction(_);
          bars1.useRegionInteraction(_);
          bars2.useRegionInteraction(_);
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
          lines1.interactionDispatch(_);
          lines2.interactionDispatch(_);
          scatters1.interactionDispatch(_);
          scatters2.interactionDispatch(_);
          bars1.interactionDispatch(_);
          bars2.interactionDispatch(_);
        }
      },
      dashed: {
        get: function get() {
          return dashed;
        },
        set: function set(_) {
          dashed = _;
        }
      },
      referenceLines: {
        get: function get() {
          return referenceLines;
        },
        set: function set(_) {
          referenceLines = _;
        }
      },
      widgetAsFilter: {
        get: function get() {
          return widgetAsFilter;
        },
        set: function set(_) {
          widgetAsFilter = _;
          lines1.widgetAsFilter(_);
          lines2.widgetAsFilter(_);
          bars1.widgetAsFilter(_);
          bars2.widgetAsFilter(_);
        }
      }
    });
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/pie.js

var pie = function pie(nv) {
  nv.models.pie = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 500,
      height = 500,
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      id = Math.floor(Math.random() * 10000),
      container = null,
      color = nv.utils.defaultColor(),
      valueFormat = d3.format(',.2f'),
      showLabels = true,
      labelsOutside = false,
      labelType = 'key',
      labelThreshold = 0.02,
      donut = false,
      title = false,
      disableInteraction = false,
      growOnHover = true,
      titleOffset = 0,
      labelSunbeamLayout = false,
      startAngle = false,
      padAngle = false,
      endAngle = false,
      cornerRadius = 0,
      donutRatio = 0.5,
      arcsRadius = [],
      dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd');
    var arcs = [];
    var arcsOver = [];
    var renderWatch = nv.utils.renderWatch(dispatch);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom,
          radius = Math.min(availableWidth, availableHeight) / 2,
          arcsRadiusOuter = [],
          arcsRadiusInner = [];
        container = d3.select(this);
        if (arcsRadius.length === 0) {
          var outer = radius - radius / 5;
          var inner = donutRatio * radius;
          for (var i = 0; i < data[0].length; i++) {
            arcsRadiusOuter.push(outer);
            arcsRadiusInner.push(inner);
          }
        } else {
          arcsRadiusOuter = arcsRadius.map(function (d) {
            return (d.outer - d.outer / 5) * radius;
          });
          arcsRadiusInner = arcsRadius.map(function (d) {
            return (d.inner - d.inner / 5) * radius;
          });
          donutRatio = d3.min(arcsRadius.map(function (d) {
            return d.inner - d.inner / 5;
          }));
        }
        nv.utils.initSVG(container);
        var wrap = container.selectAll('.nv-wrap.nv-pie').data(data);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-pie nv-chart-' + id);
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        var g_pie = gEnter.append('g').attr('class', 'nv-pie');
        gEnter.append('g').attr('class', 'nv-pieLabels');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        g.select('.nv-pie').attr('transform', 'translate(' + availableWidth / 2 + ',' + availableHeight / 2 + ')');
        g.select('.nv-pieLabels').attr('transform', 'translate(' + availableWidth / 2 + ',' + availableHeight / 2 + ')');
        container.on('click', function (d, i) {
          dispatch.chartClick({
            data: d,
            index: i,
            pos: d3.event,
            id: id
          });
        });
        arcs = [];
        arcsOver = [];
        for (var _i = 0; _i < data[0].length; _i++) {
          var arc = d3.svg.arc().outerRadius(arcsRadiusOuter[_i]);
          var arcOver = d3.svg.arc().outerRadius(arcsRadiusOuter[_i] + 5);
          if (startAngle !== false) {
            arc.startAngle(startAngle);
            arcOver.startAngle(startAngle);
          }
          if (endAngle !== false) {
            arc.endAngle(endAngle);
            arcOver.endAngle(endAngle);
          }
          if (donut) {
            arc.innerRadius(arcsRadiusInner[_i]);
            arcOver.innerRadius(arcsRadiusInner[_i]);
          }
          if (arc.cornerRadius && cornerRadius) {
            arc.cornerRadius(cornerRadius);
            arcOver.cornerRadius(cornerRadius);
          }
          arcs.push(arc);
          arcsOver.push(arcOver);
        }
        var pie = d3.layout.pie().sort(null).value(function (d) {
          return d.disabled ? 0 : getY(d);
        });
        if (pie.padAngle && padAngle) {
          pie.padAngle(padAngle);
        }
        if (donut && title) {
          g_pie.append('text').attr('class', 'nv-pie-title');
          wrap.select('.nv-pie-title').style('text-anchor', 'middle').text(function () {
            return title;
          }).style('font-size', Math.min(availableWidth, availableHeight) * donutRatio * 2 / (title.length + 2) + 'px').attr('dy', '0.35em').attr('transform', function () {
            return 'translate(0, ' + titleOffset + ')';
          });
        }
        var slices = wrap.select('.nv-pie').selectAll('.nv-slice').data(pie);
        var pieLabels = wrap.select('.nv-pieLabels').selectAll('.nv-label').data(pie);
        slices.exit().remove();
        pieLabels.exit().remove();
        var ae = slices.enter().append('g');
        ae.attr('class', 'nv-slice');
        if (!disableInteraction) {
          ae.on('mouseover', function (d, i) {
            d3.select(this).classed('hover', true);
            if (growOnHover) {
              d3.select(this).select('path').transition().duration(70).attr('d', arcsOver[i]);
            }
            dispatch.elementMouseover({
              data: d.data,
              index: i,
              color: d3.select(this).style('fill')
            });
          });
          ae.on('mouseout', function (d, i) {
            d3.select(this).classed('hover', false);
            if (growOnHover) {
              d3.select(this).select('path').transition().duration(50).attr('d', arcs[i]);
            }
            dispatch.elementMouseout({
              data: d.data,
              index: i
            });
          });
          ae.on('mousemove', function (d, i) {
            dispatch.elementMousemove({
              data: d.data,
              index: i
            });
          });
          ae.on('click', function (d, i) {
            dispatch.elementClick({
              data: d.data,
              index: i,
              color: d3.select(this).style('fill'),
              event: d3.event,
              element: this
            });
          });
          ae.on('dblclick', function (d, i) {
            dispatch.elementDblClick({
              data: d.data,
              index: i,
              color: d3.select(this).style('fill')
            });
          });
        }
        slices.attr('fill', function (d, i) {
          return color(d.data, i);
        });
        slices.attr('stroke', function (d, i) {
          return color(d.data, i);
        });
        ae.append('path').each(function (d) {
          this._current = d;
        });
        slices.select('path').transition().attr('d', function (d, i) {
          return arcs[i](d);
        }).attrTween('d', arcTween);
        if (showLabels) {
          var labelsArc = [];
          for (var _i2 = 0; _i2 < data[0].length; _i2++) {
            labelsArc.push(arcs[_i2]);
            if (labelsOutside) {
              if (donut) {
                labelsArc[_i2] = d3.svg.arc().outerRadius(arcs[_i2].outerRadius());
                if (startAngle !== false) {
                  labelsArc[_i2].startAngle(startAngle);
                }
                if (endAngle !== false) {
                  labelsArc[_i2].endAngle(endAngle);
                }
              }
            } else if (!donut) {
              labelsArc[_i2].innerRadius(0);
            }
          }
          pieLabels.enter().append('g').classed('nv-label', true).each(function (d) {
            var group = d3.select(this);
            group.attr('transform', function (d, i) {
              if (labelSunbeamLayout) {
                d.outerRadius = arcsRadiusOuter[i] + 10;
                d.innerRadius = arcsRadiusOuter[i] + 15;
                var rotateAngle = (d.startAngle + d.endAngle) / 2 * (180 / Math.PI);
                if ((d.startAngle + d.endAngle) / 2 < Math.PI) {
                  rotateAngle -= 90;
                } else {
                  rotateAngle += 90;
                }
                return 'translate(' + labelsArc[i].centroid(d) + ') rotate(' + rotateAngle + ')';
              } else {
                d.outerRadius = radius + 10;
                d.innerRadius = radius + 15;
                return 'translate(' + labelsArc[i].centroid(d) + ')';
              }
            });
            group.append('rect').style('stroke', '#fff').style('fill', '#fff').attr('rx', 3).attr('ry', 3);
            group.append('text').style('text-anchor', labelSunbeamLayout ? (d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end' : 'middle').style('fill', '#000');
          });
          var labelLocationHash = {};
          var avgHeight = 14;
          var avgWidth = 140;
          var createHashKey = function createHashKey(coordinates) {
            return Math.floor(coordinates[0] / avgWidth) * avgWidth + ',' + Math.floor(coordinates[1] / avgHeight) * avgHeight;
          };
          var getSlicePercentage = function getSlicePercentage(d) {
            return (d.endAngle - d.startAngle) / (2 * Math.PI);
          };
          pieLabels.watchTransition(renderWatch, 'pie labels').attr('transform', function (d, i) {
            if (labelSunbeamLayout) {
              d.outerRadius = arcsRadiusOuter[i] + 10;
              d.innerRadius = arcsRadiusOuter[i] + 15;
              var rotateAngle = (d.startAngle + d.endAngle) / 2 * (180 / Math.PI);
              if ((d.startAngle + d.endAngle) / 2 < Math.PI) {
                rotateAngle -= 90;
              } else {
                rotateAngle += 90;
              }
              return 'translate(' + labelsArc[i].centroid(d) + ') rotate(' + rotateAngle + ')';
            } else {
              d.outerRadius = radius + 10;
              d.innerRadius = radius + 15;
              var center = labelsArc[i].centroid(d);
              var percent = getSlicePercentage(d);
              if (d.value && percent >= labelThreshold) {
                var hashKey = createHashKey(center);
                if (labelLocationHash[hashKey]) {
                  center[1] -= avgHeight;
                }
                labelLocationHash[createHashKey(center)] = true;
              }
              return 'translate(' + center + ')';
            }
          });
          pieLabels.select('.nv-label text').style('text-anchor', function (d) {
            return labelSunbeamLayout ? (d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end' : 'middle';
          }).text(function (d, i) {
            var percent = getSlicePercentage(d);
            var label = '';
            if (!d.value || percent < labelThreshold) {
              return '';
            }
            if (typeof labelType === 'function') {
              label = labelType(d, i, {
                key: getX(d.data),
                value: getY(d.data),
                percent: valueFormat(percent)
              });
            } else {
              switch (labelType) {
                case 'key':
                  label = getX(d.data);
                  break;
                case 'value':
                  label = valueFormat(getY(d.data));
                  break;
                case 'percent':
                  label = d3.format('%')(percent);
                  break;
              }
            }
            return label;
          });
        }
        function arcTween(a, idx) {
          a.endAngle = isNaN(a.endAngle) ? 0 : a.endAngle;
          a.startAngle = isNaN(a.startAngle) ? 0 : a.startAngle;
          if (!donut) {
            a.innerRadius = 0;
          }
          var i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function (t) {
            return arcs[idx] ? arcs[idx](i(t)) : 0;
          };
        }
      });
      renderWatch.renderEnd('pie immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      arcsRadius: {
        get: function get() {
          return arcsRadius;
        },
        set: function set(_) {
          arcsRadius = _;
        }
      },
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLabels: {
        get: function get() {
          return showLabels;
        },
        set: function set(_) {
          showLabels = _;
        }
      },
      title: {
        get: function get() {
          return title;
        },
        set: function set(_) {
          title = _;
        }
      },
      titleOffset: {
        get: function get() {
          return titleOffset;
        },
        set: function set(_) {
          titleOffset = _;
        }
      },
      labelThreshold: {
        get: function get() {
          return labelThreshold;
        },
        set: function set(_) {
          labelThreshold = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      endAngle: {
        get: function get() {
          return endAngle;
        },
        set: function set(_) {
          endAngle = _;
        }
      },
      startAngle: {
        get: function get() {
          return startAngle;
        },
        set: function set(_) {
          startAngle = _;
        }
      },
      padAngle: {
        get: function get() {
          return padAngle;
        },
        set: function set(_) {
          padAngle = _;
        }
      },
      cornerRadius: {
        get: function get() {
          return cornerRadius;
        },
        set: function set(_) {
          cornerRadius = _;
        }
      },
      donutRatio: {
        get: function get() {
          return donutRatio;
        },
        set: function set(_) {
          donutRatio = _;
        }
      },
      labelsOutside: {
        get: function get() {
          return labelsOutside;
        },
        set: function set(_) {
          labelsOutside = _;
        }
      },
      labelSunbeamLayout: {
        get: function get() {
          return labelSunbeamLayout;
        },
        set: function set(_) {
          labelSunbeamLayout = _;
        }
      },
      donut: {
        get: function get() {
          return donut;
        },
        set: function set(_) {
          donut = _;
        }
      },
      growOnHover: {
        get: function get() {
          return growOnHover;
        },
        set: function set(_) {
          growOnHover = _;
        }
      },
      disableInteraction: {
        get: function get() {
          return disableInteraction;
        },
        set: function set(_) {
          disableInteraction = _;
        }
      },
      pieLabelsOutside: {
        get: function get() {
          return labelsOutside;
        },
        set: function set(_) {
          labelsOutside = _;
          nv.deprecated('pieLabelsOutside', 'use labelsOutside instead');
        }
      },
      donutLabelsOutside: {
        get: function get() {
          return labelsOutside;
        },
        set: function set(_) {
          labelsOutside = _;
          nv.deprecated('donutLabelsOutside', 'use labelsOutside instead');
        }
      },
      labelFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
          nv.deprecated('labelFormat', 'use valueFormat instead');
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = typeof _.top !== 'undefined' ? _.top : margin.top;
          margin.right = typeof _.right !== 'undefined' ? _.right : margin.right;
          margin.bottom = typeof _.bottom !== 'undefined' ? _.bottom : margin.bottom;
          margin.left = typeof _.left !== 'undefined' ? _.left : margin.left;
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = d3.functor(_);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      },
      labelType: {
        get: function get() {
          return labelType;
        },
        set: function set(_) {
          labelType = _ || 'key';
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/pieChart.js

var pieChart = function pieChart(nv) {
  nv.models.pieChart = function () {
    var pie = nv.models.pie();
    var legend = nv.models.legend();
    var tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 20,
        bottom: 20,
        left: 20
      },
      width = null,
      height = null,
      showLegend = true,
      disableInteraction = false,
      legendPosition = 'top',
      color = nv.utils.defaultColor(),
      state = nv.utils.state(),
      defaultState = null,
      noData = null,
      duration = 250,
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd', 'elementClick');
    tooltip.duration(0).headerEnabled(false).valueFormatter(function (d, i) {
      return pie.valueFormat()(d, i);
    });
    var renderWatch = nv.utils.renderWatch(dispatch);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          })
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(pie);
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          container.transition().call(chart);
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        var wrap = container.selectAll('g.nv-wrap.nv-pieChart').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-pieChart').append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-pieWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        if (showLegend) {
          if (legendPosition === 'top') {
            legend.width(availableWidth).key(pie.x());
            wrap.select('.nv-legendWrap').datum(data).call(legend);
            if (margin.top !== legend.height()) {
              margin.top = legend.height();
              availableHeight = nv.utils.availableHeight(height, container, margin);
            }
            wrap.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
          } else if (legendPosition === 'right') {
            var legendWidth = nv.models.legend().width();
            if (availableWidth / 2 < legendWidth) {
              legendWidth = availableWidth / 2;
            }
            legend.height(availableHeight).key(pie.x());
            legend.width(legendWidth);
            availableWidth -= legend.width();
            wrap.select('.nv-legendWrap').datum(data).call(legend).attr('transform', 'translate(' + availableWidth + ',0)');
          }
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        pie.width(availableWidth).height(availableHeight);
        pie.disableInteraction(disableInteraction);
        var pieWrap = g.select('.nv-pieWrap').datum([data]);
        d3.transition(pieWrap).call(pie);
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          chart.update();
        });
      });
      renderWatch.renderEnd('pieChart immediate');
      return chart;
    }
    if (!disableInteraction) {
      pie.dispatch.on('elementMouseover.tooltip', function (evt) {
        evt.series = {
          key: chart.x()(evt.data),
          value: chart.y()(evt.data),
          color: evt.color
        };
        tooltip.data(evt).hidden(false);
      });
      pie.dispatch.on('elementMouseout.tooltip', function () {
        tooltip.hidden(true);
      });
      pie.dispatch.on('elementMousemove.tooltip', function () {
        tooltip();
      });
      pie.dispatch.on('elementClick', dispatch.elementClick);
    }
    chart.legend = legend;
    chart.dispatch = dispatch;
    chart.pie = pie;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      disableInteraction: {
        get: function get() {
          return disableInteraction;
        },
        set: function set(_) {
          disableInteraction = _;
        }
      },
      legendPosition: {
        get: function get() {
          return legendPosition;
        },
        set: function set(_) {
          legendPosition = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = _;
          legend.color(color);
          pie.color(color);
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      }
    });
    nv.utils.inheritOptions(chart, pie);
    nv.utils.initOptions(chart);
    return chart;
  };
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.freeze.js
var es6_object_freeze = __webpack_require__(8236);
;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}

;// ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != typeof_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof_typeof(i) ? i : i + "";
}

;// ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof_typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function defineProperty_defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function arrayWithHoles_arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function iterableToArray_iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function arrayLikeToArray_arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function unsupportedIterableToArray_unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray_arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray_arrayLikeToArray(r, a) : void 0;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function nonIterableRest_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(r) {
  return arrayWithHoles_arrayWithHoles(r) || iterableToArray_iterableToArray(r) || unsupportedIterableToArray_unsupportedIterableToArray(r) || nonIterableRest_nonIterableRest();
}

;// ./node_modules/i18next/dist/esm/i18next.js










function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Logger);
    this.init(concreteLogger, options);
  }
  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.observers = {};
  }
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function i18next_copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
    obj = _getLastOfPath.obj,
    k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
    obj = _getLastOfPath2.obj,
    k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
    obj = _getLastOfPath3.obj,
    k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);
  var _super = _createSuper$3(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    _classCallCheck(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);
  var _super = _createSuper$2(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    i18next_copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (typeof_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (typeof_typeof(options) === 'object') options = _objectSpread$4({}, options);
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _this$extractFromKey.key,
        namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: "".concat(namespace).concat(nsSeparator).concat(key),
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace
            };
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
          interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function deepFindWithDefaults(data, defaultData, key) {
  var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        clonedOptions = _objectSpread$3({}, options);
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
          _opt$split2 = _toArray(_opt$split),
          key = _opt$split2[0],
          rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];
    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val, opt.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }
  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng) {
      var _this = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
          formatName = _parseFormatStr.formatName,
          formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);
  var _super = _createSuper$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (n) {
                if (loaded[l][n] === undefined) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      var resolver = function resolver(err, data) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      var fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          var r = fc(lng, ns);
          if (r && typeof r.then === 'function') {
            r.then(function (data) {
              return resolver(null, data);
            })["catch"](resolver);
          } else {
            resolver(null, r);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
          isUpdate: isUpdate
        });
        var fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            var r;
            if (fc.length === 5) {
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);

function i18next_get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (typeof_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (typeof_typeof(args[2]) === 'object' || typeof_typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? i18next_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function i18next_noop() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);
  var _super = _createSuper(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = i18next_get();
      this.options = i18next_objectSpread(i18next_objectSpread(i18next_objectSpread({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = i18next_objectSpread(i18next_objectSpread({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = i18next_noop;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : i18next_noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = i18next_noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if (typeof_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = i18next_objectSpread({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(function (k) {
            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
          });
        } else {
          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        }
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(i18next_get());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : i18next_noop;
      var mergedOptions = i18next_objectSpread(i18next_objectSpread(i18next_objectSpread({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = i18next_objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
defineProperty_defineProperty(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var dir = instance.dir;
var i18next_init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;



;// ./src/js/translations/translations.json
var translations_namespaceObject = /*#__PURE__*/JSON.parse('{"da":{"DQ":{"DQ.Label":"Mærke {{customLabel}}","DQ.LegendCannotBeToggled":"Dette er det sidste resterende segment i diagrammet. Skift er ikke tilgængelig.","DQ.LegendGroupAriaLabel":"Denne gruppe indeholder forklaringsetiketter.","DQ.LegendToggleOff":"Segment er skjult i diagram. Tryk på mellemrumstasten for at vise.","DQ.LegendToggleOn":"Segment vises i diagram. Tryk på mellemrumstasten for at skjule.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"{{count}} svar","DQ.ResponsesLabel":"{{count}} svar","DQ.Size":"Størrelse {{sizeValue}}","DQ.Stars":"{{numStars}} stjerner","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X-akse {{xAxisValue}}","DQ.YAxis":"Y-akse {{yAxisValue}}"}},"de":{"DQ":{"DQ.Label":"Label {{customLabel}}","DQ.LegendCannotBeToggled":"Das ist das letzte verfügbare Segment im Diagramm. Die Funktion zum Ein- und Ausblenden ist nicht verfügbar.","DQ.LegendGroupAriaLabel":"In dieser Gruppe sind Legenden-Labels enthalten","DQ.LegendToggleOff":"Das Segment wird im Diagramm ausgeblendet. Drücken Sie die Leertaste zum Anzeigen.","DQ.LegendToggleOn":"Das Segment wird im Diagramm angezeigt. Drücken Sie die Leertaste zum Ausblenden.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"Antworten {{count}}","DQ.ResponsesLabel":"{{count}} Antworten","DQ.Size":"Größe {{sizeValue}}","DQ.Stars":"{{numStars}} Sterne","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X-Achse {{xAxisValue}}","DQ.YAxis":"Y-Achse {{yAxisValue}}"}},"en":{"DQ":{"DQ.Label":"Label {{customLabel}}","DQ.LegendCannotBeToggled":"This is the last remaining segment on chart. Toggle is unavailable.","DQ.LegendGroupAriaLabel":"This group contains legend labels.","DQ.LegendToggleOff":"Segment is hidden in chart. Press space bar to display.","DQ.LegendToggleOn":"Segment is displayed in chart. Press space bar to hide.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Responses {{count}}","DQ.ResponsesLabel":"{{count}} Responses","DQ.Size":"Size {{sizeValue}}","DQ.Stars":"{{numStars}} stars","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X axis {{xAxisValue}}","DQ.YAxis":"Y axis {{yAxisValue}}"}},"en-GB":{"DQ":{"DQ.Label":"Label {{customLabel}}","DQ.LegendCannotBeToggled":"This is the last remaining segment on chart. Toggle is unavailable.","DQ.LegendGroupAriaLabel":"This group contains legend labels.","DQ.LegendToggleOff":"Segment is hidden in chart. Press space bar to display.","DQ.LegendToggleOn":"Segment is displayed in chart. Press space bar to hide.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Responses {{count}}","DQ.ResponsesLabel":"{{count}} Responses","DQ.Size":"Size {{sizeValue}}","DQ.Stars":"{{numStars}} stars","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X axis {{xAxisValue}}","DQ.YAxis":"Y axis {{yAxisValue}}"}},"es":{"DQ":{"DQ.Label":"Eqiqueta {{customLabel}}","DQ.LegendCannotBeToggled":"Este es el último segmento restante en el gráfico. El conmutador no está disponible.","DQ.LegendGroupAriaLabel":"Este grupo contiene etiquetas de leyenda.","DQ.LegendToggleOff":"El segmento está oculto en el gráfico. Pulse la barra espaciadora para visualizarlo.","DQ.LegendToggleOn":"El segmento se visualiza en el gráfico. Pulse la barra espaciadora para ocultarlo.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"Respuestas {{count}}","DQ.ResponsesLabel":"{{count}} respuestas","DQ.Size":"Tamaño {{sizeValue}}","DQ.Stars":"{{numStars}} estrellas","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Eje X {{xAxisValue}}","DQ.YAxis":"Eje Y {{yAxisValue}}"}},"es-419":{"DQ":{"DQ.Label":"Etiqueta {{customLabel}}","DQ.LegendCannotBeToggled":"Este es el último segmento restante del gráfico. No está disponible su cambio.","DQ.LegendGroupAriaLabel":"Este grupo contiene etiquetas de leyenda.","DQ.LegendToggleOff":"El segmento está oculto en el gráfico. Presione la barra espaciadora para visualizarlo.","DQ.LegendToggleOn":"El segmento se visualiza en el gráfico. Presione la barra espaciadora para esconderlo.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"Respuestas {{count}}","DQ.ResponsesLabel":"{{count}} respuestas","DQ.Size":"Tamaño {{sizeValue}}","DQ.Stars":"{{numStars}} estrellas","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Eje x {{xAxisValue}}","DQ.YAxis":"Eje y {{yAxisValue}}"}},"fi":{"DQ":{"DQ.Label":"Tarra {{customLabel}}","DQ.LegendCannotBeToggled":"Tämä on kaavion viimeinen jäljellä oleva segmentti. Vaihto ei ole käytettävissä.","DQ.LegendGroupAriaLabel":"Tämä ryhmä sisältää selitteen otsikot.","DQ.LegendToggleOff":"Segmentti on piilotettu kaaviossa. Näytä painamalla välilyöntinäppäintä.","DQ.LegendToggleOn":"Segmentti näytetään kaaviossa. Piilota painamalla välilyöntinäppäintä.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"Vastauksia {{count}}","DQ.ResponsesLabel":"{{count}} vastausta","DQ.Size":"Koko {{sizeValue}}","DQ.Stars":"{{numStars}} tähteä","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X-akseli {{xAxisValue}}","DQ.YAxis":"Y-akseli {{yAxisValue}}"}},"fr":{"DQ":{"DQ.Label":"Libellé {{customLabel}}","DQ.LegendCannotBeToggled":"Ce segment est le dernier segment dans le tableau. Le basculement est indisponible.","DQ.LegendGroupAriaLabel":"Ce groupe contient des libellés de légende.","DQ.LegendToggleOff":"Le segment est masqué dans le tableau. Appuyez sur la barre d\'espace pour l\'afficher. ","DQ.LegendToggleOn":"Le segment est affiché dans le tableau. Appuyez sur la barre d\'espace pour le masquer.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"{{count}} réponses","DQ.ResponsesLabel":"{{count}} réponses","DQ.Size":"Taille {{sizeValue}}","DQ.Stars":"{{numStars}} étoiles","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Axe des abscisses (X) {{xAxisValue}}","DQ.YAxis":"Axe des ordonnées (Y) {{yAxisValue}}"}},"fr-CA":{"DQ":{"DQ.Label":"Libellé {{customLabel}}","DQ.LegendCannotBeToggled":"Ce segment est le dernier segment dans le tableau. Le basculement est indisponible.","DQ.LegendGroupAriaLabel":"Ce groupe contient des libellés de légende.","DQ.LegendToggleOff":"Le segment est masqué dans le tableau. Appuyez sur la barre d\'espace pour l\'afficher. ","DQ.LegendToggleOn":"Le segment est affiché dans le tableau. Appuyez sur la barre d\'espace pour le masquer.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"{{count}} réponses","DQ.ResponsesLabel":"{{count}} réponses","DQ.Size":"Taille {{sizeValue}}","DQ.Stars":"{{numStars}} étoiles","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Axe des abscisses (X) {{xAxisValue}}","DQ.YAxis":"Axe des ordonnées (Y) {{yAxisValue}}"}},"id":{"DQ":{"DQ.Label":"Label {{customLabel}}","DQ.LegendCannotBeToggled":"Segmen terakhir yang tersisa di bagan. Tombol alih tidak tersedia.","DQ.LegendGroupAriaLabel":"Grup ini berisi label keterangan.","DQ.LegendToggleOff":"Segmen disembunyikan di bagan. Tekan spasi untuk menampilkan.","DQ.LegendToggleOn":"Segmen ditampilkan di bagan. Tekan spasi untuk menyembunyikan.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Respons {{count}}","DQ.ResponsesLabel":"{{count}} Respons","DQ.Size":"Ukuran {{sizeValue}}","DQ.Stars":"{{numStars}} bintang-bintang","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}},  {{second}}","DQ.XAxis":"Sumbu X {{xAxisValue}}","DQ.YAxis":"Sumbu Y {{yAxisValue}}"}},"it":{"DQ":{"DQ.Label":"Etichetta {{customLabel}}","DQ.LegendCannotBeToggled":"Ultimo segmento rimanente nel grafico. Commutazione non disponibile.","DQ.LegendGroupAriaLabel":"Questo gruppo contiene etichette di legenda.","DQ.LegendToggleOff":"Il segmento è nascosto nel grafico. Premi la barra spaziatrice per visualizzarlo.","DQ.LegendToggleOn":"Il segmento è visualizzato nel grafico. Premi la barra spaziatrice per nasconderlo.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Risposte {{count}}","DQ.ResponsesLabel":"{{count}} risposte","DQ.Size":"Dimensioni {{sizeValue}}","DQ.Stars":"{{numStars}} stelle","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Asse X {{xAxisValue}}","DQ.YAxis":"Asse Y {{yAxisValue}}"}},"ja":{"DQ":{"DQ.Label":"ラベル（{{customLabel}}）","DQ.LegendCannotBeToggled":"これがチャートに残っている最後のセグメントです。非表示に切り替えられません。","DQ.LegendGroupAriaLabel":"このグループには凡例ラベルがあります。","DQ.LegendToggleOff":"セグメントはチャートで非表示になっています。表示するにはスペースバーを押してください。","DQ.LegendToggleOn":"セグメントはチャートに表示されます。非表示にするにはスペースバーを押してください。","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"回答（{{count}}）","DQ.ResponsesLabel":"{{count}}件の回答","DQ.Size":"サイズ（{{sizeValue}}）","DQ.Stars":"{{numStars}}個の星","DQ.ThreeItemList":"{{first}}、{{second}}、{{third}}","DQ.TwoItemList":"{{first}}、 {{second}}","DQ.XAxis":"X軸（{{xAxisValue}}）","DQ.YAxis":"Y軸（{{yAxisValue}}）"}},"ko":{"DQ":{"DQ.Label":"레이블 {{customLabel}}","DQ.LegendCannotBeToggled":"차트에 마지막으로 남아 있는 세그먼트입니다. 토글을 사용할 수 없습니다.","DQ.LegendGroupAriaLabel":"이 그룹에는 범례 레이블이 포함되어 있습니다.","DQ.LegendToggleOff":"세그먼트가 차트에서 숨겨져 있습니다. 표시하려면 스페이스바를 누르십시오.","DQ.LegendToggleOn":"세그먼트가 차트에 표시됩니다. 숨기려면 스페이스바를 누르십시오.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"응답 {{count}}","DQ.ResponsesLabel":"{{count}} 응답","DQ.Size":"크기 {{sizeValue}}","DQ.Stars":"{{numStars}}개 별표","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X축 {{xAxisValue}}","DQ.YAxis":"Y축 {{yAxisValue}}"}},"ms":{"DQ":{"DQ.Label":"Label {{customLabel}}","DQ.LegendCannotBeToggled":"Ini adalah baki segmen terakhir pada carta. Togol tidak tersedia.","DQ.LegendGroupAriaLabel":"Kumpulan ini mengandungi label petunjuk.","DQ.LegendToggleOff":"Segmen disembunyikan dalam carta. Tekan bar ruang untuk dipaparkan.","DQ.LegendToggleOn":"Segmen dipaparkan dalam carta. Tekan bar ruang untuk sembunyikan.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"{{count}} Maklum balas","DQ.ResponsesLabel":"{{count}} Maklum balas","DQ.Size":"Saiz {{sizeValue}}","DQ.Stars":"{{numStars}} bintang","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"paksi X {{xAxisValue}}","DQ.YAxis":"paksi Y {{yAxisValue}}"}},"nl":{"DQ":{"DQ.Label":"Label {{customLabel}}","DQ.LegendCannotBeToggled":"Dit is het laatste resterende segment in het diagram. In-/uitschakelen is niet beschikbaar.","DQ.LegendGroupAriaLabel":"Deze groep bevat legendalabels.","DQ.LegendToggleOff":"Segment is verborgen in diagram. Druk op de spatiebalk om weer te geven.","DQ.LegendToggleOn":"Segment wordt weergegeven in diagram. Druk op de spatiebalk om deze te verbergen.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"{{count}} antwoorden","DQ.ResponsesLabel":"{{count}} antwoorden","DQ.Size":"Grootte {{sizeValue}}","DQ.Stars":"{{numStars}} sterren","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X-as {{xAxisValue}}","DQ.YAxis":"Y-as {{yAxisValue}}"}},"pb":{"DQ":{"DQ.Label":"⟦용용용용 Ľǻьєľ {{customLabel}} 歴歴歴歴⟧","DQ.LegendCannotBeToggled":"⟦용용용 Ŧнįś ϊś ŧнê ļãŝτ ґêmåϊлïňġ şëĝmêηŧ öл čħǻґτ. Τŏĝĝľε ìѕ űлâνάιļαьľé. 歴歴歴⟧","DQ.LegendGroupAriaLabel":"⟦용용용 Ťħîş ĝѓòµρ ¢σлţąīńş ĺєĝėήď ľàьĕļś. 歴歴歴⟧","DQ.LegendToggleOff":"⟦용용 Śëğmêŋŧ ιŝ ħíďďèи їπ çħäґť. Ρŕєѕŝ ŝρāčέ вâѓ τŏ ďϊśρľąỳ. 歴歴⟧","DQ.LegendToggleOn":"⟦용용 Śеĝmέйŧ ïѕ ďїŝρļǻŷěď ій сĥâґτ. Ρŕĕśś śράċє вāŕ τō ніďє. 歴歴⟧","DQ.PercentageLabel":"⟦용용용용 {{percentage}}% 歴歴歴歴⟧","DQ.Responses":"⟦용용용용용 Ґеśρȭŉśëѕ {{count}} 歴歴歴歴歴⟧","DQ.ResponsesLabel":"⟦용용용용용 {{count}} Ŕėŝρōńşεŝ 歴歴歴歴歴⟧","DQ.Size":"⟦용용용용용 Ŝíźê {{sizeValue}} 歴歴歴歴歴⟧","DQ.Stars":"⟦용용용용용 {{numStars}} śťāřѕ 歴歴歴歴歴⟧","DQ.ThreeItemList":"⟦용용용 {{first}}, {{second}}, {{third}} 歴歴歴⟧","DQ.TwoItemList":"⟦용용용용 {{first}}, {{second}} 歴歴歴歴⟧","DQ.XAxis":"⟦용용용용 Х å×ϊş {{xAxisValue}} 歴歴歴歴⟧","DQ.YAxis":"⟦용용용용 Υ ă×ιś {{yAxisValue}} 歴歴歴歴⟧"}},"pt":{"DQ":{"DQ.Label":"Etiqueta {{customLabel}}","DQ.LegendCannotBeToggled":"Este é o último segmento restante na tabela. Não é possível alternar.","DQ.LegendGroupAriaLabel":"Este grupo contém etiquetas de legenda.","DQ.LegendToggleOff":"O segmento está oculto no gráfico. Pressione a barra de espaços para exibir.","DQ.LegendToggleOn":"O segmento é apresentado no gráfico. Pressione a barra de espaços para ocultar.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Respostas {{count}}","DQ.ResponsesLabel":"{{count}} respostas","DQ.Size":"Tamanho {{sizeValue}}","DQ.Stars":"{{numStars}} asteriscos","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Eixo X {{xAxisValue}}","DQ.YAxis":"Eixo Y {{yAxisValue}}"}},"pt-BR":{"DQ":{"DQ.Label":"Rótulo {{customLabel}}","DQ.LegendCannotBeToggled":"Este é o último segmento restante no gráfico. Exibir/ocultar está indisponível.","DQ.LegendGroupAriaLabel":"Este grupo contém rótulos de legenda.","DQ.LegendToggleOff":"Segmento oculto no gráfico. Aperte a barra de espaço para exibir.","DQ.LegendToggleOn":"Segmento exibido no gráfico. Aperte a barra de espaço para ocultar.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Respostas {{count}}","DQ.ResponsesLabel":"{{count}} respostas","DQ.Size":"Tamanho {{sizeValue}}","DQ.Stars":"{{numStars}} estrelas","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Eixo X {{xAxisValue}}","DQ.YAxis":"Eixo Y {{yAxisValue}}"}},"ru":{"DQ":{"DQ.Label":"Этикетка {{customLabel}}","DQ.LegendCannotBeToggled":"Это последний оставшийся сегмент на диаграмме. Переключатель недоступен.","DQ.LegendGroupAriaLabel":"Эта группа содержит метки условных обозначений.","DQ.LegendToggleOff":"Сегмент скрыт в диаграмме. Для просмотра нажмите клавишу пробела.","DQ.LegendToggleOn":"Сегмент отображается на диаграмме. Чтобы скрыть, нажмите клавишу пробела.","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"Ответы {{count}}","DQ.ResponsesLabel":"{{count}} отв.","DQ.Size":"Размер {{sizeValue}}","DQ.Stars":"{{numStars}} звезды","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"Ось X {{xAxisValue}}","DQ.YAxis":"Ось Y {{yAxisValue}}"}},"sv":{"DQ":{"DQ.Label":"Märka {{customLabel}}","DQ.LegendCannotBeToggled":"Detta är det sista återstående segmentet i diagrammet. Växlingsknappen är inte tillgänglig.","DQ.LegendGroupAriaLabel":"Den här gruppen innehåller förklaringsetiketter.","DQ.LegendToggleOff":"Segment är dolt i diagram. Tryck på blanksteg för att visa.","DQ.LegendToggleOn":"Segment visas i diagram. Tryck på blanksteg för att dölja.","DQ.PercentageLabel":"{{percentage}} %","DQ.Responses":"Svar {{count}}","DQ.ResponsesLabel":"{{count}} svar","DQ.Size":"Storlek {{sizeValue}}","DQ.Stars":"{{numStars}} stjärnor","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}}, {{second}}","DQ.XAxis":"X-axel {{xAxisValue}}","DQ.YAxis":"Y-axel {{yAxisValue}}"}},"th":{"DQ":{"DQ.Label":"ฉลาก {{customLabel}}","DQ.LegendCannotBeToggled":"เซกเมนต์นี้คือเซกเมนต์สุดท้ายที่เหลืออยู่ในแผนภูมิ จึงไม่สามารถสลับได้","DQ.LegendGroupAriaLabel":"กลุ่มนี้มีป้ายชื่อคำอธิบายสัญลักษณ์","DQ.LegendToggleOff":"เซกเมนต์ซ่อนอยู่ในแผนภูมิ กด Space bar เพื่อแสดง","DQ.LegendToggleOn":"เซกเมนต์แสดงในแผนภูมิ กด Space bar เพื่อซ่อน","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"การตอบกลับ {{count}}","DQ.ResponsesLabel":"{{count}} การตอบกลับ","DQ.Size":"ขนาด {{sizeValue}}","DQ.Stars":"{{numStars}} ดาว","DQ.ThreeItemList":"{{first}}, {{second}}, {{third}}","DQ.TwoItemList":"{{first}},  {{second}}","DQ.XAxis":"แกน X {{xAxisValue}}","DQ.YAxis":"แกน Y {{yAxisValue}}"}},"zh-Hans":{"DQ":{"DQ.Label":"标签 {{customLabel}}","DQ.LegendCannotBeToggled":"这是图表剩余的最后一个细分组。无法使用切换功能。","DQ.LegendGroupAriaLabel":"此分组包含图例标签。","DQ.LegendToggleOff":"图表隐藏细分组。按空格键显示。","DQ.LegendToggleOn":"图表显示细分组。按空格键隐藏。","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"回复 {{count}}","DQ.ResponsesLabel":"{{count}} 个回复","DQ.Size":"大小 {{sizeValue}}","DQ.Stars":"{{numStars}} 星","DQ.ThreeItemList":"{{first}}、{{second}}、{{third}}","DQ.TwoItemList":"{{first}}、{{second}}","DQ.XAxis":"X 轴 {{xAxisValue}}","DQ.YAxis":"Y 轴 {{yAxisValue}}"}},"zh-Hant":{"DQ":{"DQ.Label":"標籤 {{customLabel}}","DQ.LegendCannotBeToggled":"這是圖表中的最後一個剩餘區段。無法使用切換。","DQ.LegendGroupAriaLabel":"這個群組包含圖例標籤。","DQ.LegendToggleOff":"區段會在圖表中隱藏。按下空格鍵以顯示。","DQ.LegendToggleOn":"區段會在圖表中展示。按下空白鍵以隱藏。","DQ.PercentageLabel":"{{percentage}}%","DQ.Responses":"回應 {{count}}","DQ.ResponsesLabel":"{{count}} 個回應","DQ.Size":"大小 {{sizeValue}}","DQ.Stars":"{{numStars}} 顆星","DQ.ThreeItemList":"{{first}}、{{second}}、{{third}}","DQ.TwoItemList":"{{first}}、{{second}}","DQ.XAxis":"X 軸 {{xAxisValue}}","DQ.YAxis":"Y 軸 {{yAxisValue}}"}}}');
;// ./src/js/translations/bcp47-language-code.json
var bcp47_language_code_namespaceObject = /*#__PURE__*/JSON.parse('{"AR":"ar","ASM":"as","AZ_AZ":"az","BEL":"be","BG":"bg","BN":"bn","BS":"bs","CA":"ca","CEB":"ceb","SR_ME":"cnr","CS":"cs","CY":"cy","DA":"da","DE":"de","EL":"el","EN":"en","EN_GB":"en-GB","EO":"eo","ES_ES":"es","ES":"es-419","ET":"et","FA":"fa","FI":"fi","FR":"fr","FR_CA":"fr-CA","GU":"gu","HE":"he","HI":"hi","HIL":"hil","HR":"hr","HU":"hu","HYE":"hy","ID":"id","ISL":"is","IT":"it","JA":"ja","KAT":"ka","KAZ":"kk","KM":"km","KAN":"kn","KO":"ko","LT":"lt","LV":"lv","MK":"mk","MAL":"ml","MN":"mn","MAR":"mr","MS":"ms","MY":"my","NL":"nl","NO":"no","ORI":"or","PA_IN":"pa","PB":"pb","PL":"pl","PT":"pt","PT_BR":"pt-BR","RI_GI":"ri-GI","RO":"ro","RU":"ru","SIN":"si","SK":"sk","SL":"sl","SQI":"sq","SR":"sr","SV":"sv","SW":"sw","TA":"ta","TEL":"te","TH":"th","TGL":"tl","TR":"tr","UK":"uk","UR":"ur","VI":"vi","ZH_S":"zh-Hans","ZH_T":"zh-Hant"}');
;// ./src/js/translations/translate.js



function translate_typeof(o) { "@babel/helpers - typeof"; return translate_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, translate_typeof(o); }
function translate_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function translate_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, translate_toPropertyKey(o.key), o); } }
function translate_createClass(e, r, t) { return r && translate_defineProperties(e.prototype, r), t && translate_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function translate_defineProperty(e, r, t) { return (r = translate_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function translate_toPropertyKey(t) { var i = translate_toPrimitive(t, "string"); return "symbol" == translate_typeof(i) ? i : i + ""; }
function translate_toPrimitive(t, r) { if ("object" != translate_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != translate_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var translate_locale = window.Qualtrics && window.Qualtrics.Environment && window.Qualtrics.Environment.user && window.Qualtrics.Environment.user.language || '';
var DEFAULT_LANGUAGE_KEY = bcp47_language_code_namespaceObject.EN;
var DEFAULT_NAMESPACE = 'DQ';
var TranslationService = function () {
  function TranslationService() {
    var _this$_intl8next;
    translate_classCallCheck(this, TranslationService);
    translate_defineProperty(this, "_intl8next", void 0);
    if ((_this$_intl8next = this._intl8next) !== null && _this$_intl8next !== void 0 && _this$_intl8next.isInitialized) {
      return;
    }
    this._intl8next = instance.createInstance();
    var bcpLocale = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().get(bcp47_language_code_namespaceObject, [translate_locale]) || DEFAULT_LANGUAGE_KEY;
    this._intl8next.init({
      fallbackLng: DEFAULT_LANGUAGE_KEY,
      lng: bcpLocale,
      keySeparator: false,
      defaultNS: DEFAULT_NAMESPACE,
      resources: translations_namespaceObject
    });
  }
  return translate_createClass(TranslationService, [{
    key: "translate",
    value: function translate(translationKey) {
      var _this$_intl8next$t;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (_this$_intl8next$t = this._intl8next.t(translationKey, options)) !== null && _this$_intl8next$t !== void 0 ? _this$_intl8next$t : translationKey;
    }
  }]);
}();
var translationService = new TranslationService();
;// ./src/js/nv/models/scatter.js
function scatter_typeof(o) { "@babel/helpers - typeof"; return scatter_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, scatter_typeof(o); }














function scatter_slicedToArray(r, e) { return scatter_arrayWithHoles(r) || scatter_iterableToArrayLimit(r, e) || scatter_unsupportedIterableToArray(r, e) || scatter_nonIterableRest(); }
function scatter_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function scatter_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return scatter_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? scatter_arrayLikeToArray(r, a) : void 0; } }
function scatter_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function scatter_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function scatter_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function scatter_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function scatter_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? scatter_ownKeys(Object(t), !0).forEach(function (r) { scatter_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : scatter_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function scatter_defineProperty(e, r, t) { return (r = scatter_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function scatter_toPropertyKey(t) { var i = scatter_toPrimitive(t, "string"); return "symbol" == scatter_typeof(i) ? i : i + ""; }
function scatter_toPrimitive(t, r) { if ("object" != scatter_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != scatter_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var DOMAIN_PADDING_RATIO_SMALL_DATA_POINT = constants_Constants.DOMAIN_PADDING_RATIO_SMALL_DATA_POINT,
  DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT = constants_Constants.DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT,
  DOMAIN_PADDING_RATIO_LARGE_DATA_POINT = constants_Constants.DOMAIN_PADDING_RATIO_LARGE_DATA_POINT,
  SMALL_DATA_POINT_SIZE = constants_Constants.SMALL_DATA_POINT_SIZE,
  MEDIUM_DATA_POINT_SIZE = constants_Constants.MEDIUM_DATA_POINT_SIZE,
  LARGE_DATA_POINT_SIZE = constants_Constants.LARGE_DATA_POINT_SIZE,
  MINIMUM_DOMAIN_SEPARATION = constants_Constants.MINIMUM_DOMAIN_SEPARATION,
  scatter_SHOW_VALUE_OPTIONS = constants_Constants.SHOW_VALUE_OPTIONS,
  KEYS = constants_Constants.KEYS;
var scatter = function scatter(nv) {
  nv.constants = {};
  nv.constants.BACKGROUND_IMAGE_POSITIONS = Object.freeze({
    FIT: 'FIT',
    FILL: 'FILL',
    STRETCH: 'STRETCH'
  });
  nv.models.scatter = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = null,
      height = null,
      color = nv.utils.defaultColor(),
      id = Math.floor(Math.random() * 100000),
      container = null,
      x = d3.scale.linear(),
      y = d3.scale.linear(),
      z = d3.scale.linear(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      getSize = function getSize(d) {
        return d.size || 1;
      },
      getLabel = function getLabel(d) {
        return d.label || d.size || 1;
      },
      getGroup = function getGroup(d) {
        return d.group || '-';
      },
      getShape = function getShape(d) {
        return d.shape || 'circle';
      },
      forceX = [],
      forceY = [],
      forceSize = [],
      interactive = true,
      pointActive = function pointActive(d) {
        return !d.notActive;
      },
      padData = false,
      padDataOuter = 0.1,
      clipEdge = false,
      clipVoronoi = true,
      showVoronoi = false,
      clipRadius = function clipRadius() {
        return 25;
      },
      xDomain = null,
      xDomainMin,
      xDomainMax,
      yDomain = null,
      yDomainMin,
      yDomainMax,
      xRange = null,
      yRange = null,
      sizeDomain = null,
      sizeRange = null,
      staticPointSize = null,
      singlePoint = false,
      dispatch = d3.dispatch('elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'renderEnd'),
      useVoronoi = true,
      duration = 250,
      interactiveUpdateDelay = 300,
      showValues = false,
      showValuesType = null,
      labelPlacementFunction = undefined,
      showOnlyYValues = false,
      getValueArrangement = function getValueArrangement(d) {
        return d && d.valueArrangement || 'bottom';
      },
      valueFormat = d3.format(',.2f'),
      padY = false,
      padYBy = 22,
      defaultStrokeWidth = 1,
      boundPad = 10,
      backgroundImageUrl = null,
      backgroundImagePosition = null,
      useRegionInteraction = false,
      xAxisLabel = null,
      yAxisLabel = null,
      sizeLabel = null,
      xValueFormat = d3.format('.1f'),
      yValueFormat = d3.format('.1f'),
      enableAutoAxisScaling = false,
      showsDataPointResponses = false,
      interactionDispatch;
    var x0,
      y0,
      z0,
      timeoutID,
      needsUpdate = false,
      renderWatch = nv.utils.renderWatch(dispatch, duration),
      _sizeRange_def = [16, 256];
    function getDataValueText(d) {
      var customDataValue = d[0].customDataValue;
      if (customDataValue || customDataValue === '') {
        return customDataValue;
      } else {
        switch (showValuesType) {
          case scatter_SHOW_VALUE_OPTIONS.X_AXIS_Y_AXIS:
            return "".concat(getX(d[0]), ", ").concat(getY(d[0]));
          case scatter_SHOW_VALUE_OPTIONS.X_AXIS:
            return getX(d[0]);
          case scatter_SHOW_VALUE_OPTIONS.Y_AXIS:
            return getY(d[0]);
          case scatter_SHOW_VALUE_OPTIONS.SIZE_METRIC:
            return getLabel(d[0]);
          case scatter_SHOW_VALUE_OPTIONS.GROUP:
            return getGroup(d[0]);
        }
        return !showOnlyYValues && d[0].label ? d[0].label : valueFormat(getY(d[0], d[1]));
      }
    }
    function setupDataValueIcon(symbolContainer, customIconSettings) {
      var yTranslateSymbol = 1;
      symbolContainer.style('font-size', customIconSettings.fontSize + 'px').style('fill', customIconSettings.color).attr('y', yTranslateSymbol).text(customIconSettings.icon);
      if (customIconSettings.fontFamily) {
        symbolContainer.style('font-family', customIconSettings.fontFamily).attr('class', customIconSettings.iconClass);
      } else {
        symbolContainer.attr('class', 'icon');
      }
    }
    function setupDataValueLabelBackground(hasText, hasSymbol, rectContainer, textSize, symbolSize, maxFontSize, symbolPadding) {
      var yTranslateRectTextOnly = 4;
      var yTranslateRectSymbolOnly = 5;
      var xTranslateRectBoth = 4;
      var bothPadding = 2;
      if (hasText && hasSymbol) {
        rectContainer.attr('width', textSize + symbolSize + bothPadding).attr('height', maxFontSize).attr('x', -(textSize / 2 + symbolSize / 2) - (xTranslateRectBoth + bothPadding)).attr('y', -(maxFontSize / 2 + yTranslateRectSymbolOnly));
      } else if (hasText) {
        rectContainer.attr('width', textSize).attr('height', maxFontSize).attr('x', -textSize / 2).attr('y', -(maxFontSize / 2 + yTranslateRectTextOnly));
      } else if (hasSymbol) {
        rectContainer.attr('width', symbolSize + symbolPadding).attr('height', maxFontSize).attr('x', -symbolSize / 2).attr('y', -(maxFontSize / 2 + yTranslateRectSymbolOnly));
      }
    }
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        container = d3.select(this);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        nv.utils.initSVG(container);
        data.forEach(function (series, i) {
          series.values.forEach(function (point) {
            point.series = i;
          });
        });
        var seriesData = xDomain && yDomain && sizeDomain ? [] : d3.merge(data.map(function (d) {
          return d.values.map(function (d, i) {
            return {
              x: getX(d, i),
              y: getY(d, i),
              size: getSize(d, i)
            };
          });
        }));
        var isNum = function isNum(num) {
          return nv.utils.isNumeric(num);
        };
        var allDataSeries = data.filter(function (series) {
          return !series.disabled;
        }).map(function (series) {
          return series.values;
        });
        var _xDomain = d3.extent(seriesData.map(function (d) {
          return d.x;
        }).concat(forceX));
        if (enableAutoAxisScaling) {
          _xDomain = getXDomain(allDataSeries, forceX, isNum, xDomainMin, xDomainMax, staticPointSize);
        }
        if (nv.utils.isNumeric(xDomainMin)) {
          _xDomain[0] = parseFloat(xDomainMin);
        }
        if (nv.utils.isNumeric(xDomainMax)) {
          _xDomain[1] = parseFloat(xDomainMax);
        }
        x.domain(xDomain || _xDomain);
        if (padData && data[0]) {
          x.range(xRange || [(availableWidth * padDataOuter + availableWidth) / (2 * data[0].values.length), availableWidth - availableWidth * (1 + padDataOuter) / (2 * data[0].values.length)]);
        } else {
          x.range(xRange || [0, availableWidth]);
        }
        var _yRange = [availableHeight, 0];
        if (chart.yScale().name === 'o') {
          var min = d3.min(seriesData.map(function (d) {
            if (d.y !== 0) {
              return d.y;
            }
          }));
          y.clamp(!clipEdge).domain(yDomain || d3.extent(seriesData.map(function (d) {
            if (d.y !== 0) {
              return d.y;
            } else {
              return min * 0.1;
            }
          }).concat(forceY))).range(yRange || _yRange);
        } else {
          var _yDomain = d3.extent(seriesData.map(function (d) {
            return d.y;
          }).concat(forceY));
          if (enableAutoAxisScaling) {
            _yDomain = getYDomain(allDataSeries, forceY, isNum, yDomainMin, yDomainMax, staticPointSize);
          }
          if (nv.utils.isNumeric(yDomainMin)) {
            y.clamp(!clipEdge);
            _yDomain[0] = parseFloat(yDomainMin);
          }
          if (nv.utils.isNumeric(yDomainMax)) {
            y.clamp(!clipEdge);
            _yDomain[1] = parseFloat(yDomainMax);
          }
          y.domain(yDomain || _yDomain).range(yRange || _yRange);
        }
        z.domain(sizeDomain || d3.extent(seriesData.map(function (d) {
          return d.size;
        }).concat(forceSize))).range(sizeRange || _sizeRange_def);
        singlePoint = x.domain()[0] === x.domain()[1] || y.domain()[0] === y.domain()[1];
        ensureDomain(x);
        ensureDomain(y);
        if (isNaN(x.domain()[0])) {
          x.domain([-1, 1]);
        }
        if (isNaN(y.domain()[0])) {
          y.domain([-1, 1]);
        }
        x0 = x0 || x;
        y0 = y0 || y;
        z0 = z0 || z;
        var wrap = container.selectAll('g.nv-wrap.nv-scatter').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatter nv-chart-' + id);
        wrapEnter.append('rect').attr('id', 'background-image-rect-' + id);
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        wrap.classed('nv-single-point', singlePoint);
        gEnter.append('g').attr('class', 'nv-groups');
        gEnter.append('g').attr('class', 'nv-point-paths');
        wrapEnter.append('g').attr('class', 'nv-point-clips');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
        wrap.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight > 0 ? availableHeight : 0);
        g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
        if (backgroundImageUrl) {
          wrap.select('defs').append('pattern').attr('id', 'background-image-pattern-' + id).append('image').attr('id', 'background-image-' + id);
          var backgroundImagePattern = wrap.select('#background-image-pattern-' + id);
          backgroundImagePattern.attr('patternUnits', 'userSpaceOnUse').attr('width', '100%').attr('height', '100%');
          var aspectRatioValue;
          switch (backgroundImagePosition) {
            case nv.constants.BACKGROUND_IMAGE_POSITIONS.FILL:
              aspectRatioValue = 'xMidYMid slice';
              break;
            case nv.constants.BACKGROUND_IMAGE_POSITIONS.FIT:
              aspectRatioValue = 'xMidYMid meet';
              break;
            case nv.constants.BACKGROUND_IMAGE_POSITIONS.STRETCH:
            default:
              aspectRatioValue = 'none';
          }
          var backgroundImage = wrap.select('#background-image-' + id);
          backgroundImage.attr('xlink:href', backgroundImageUrl).attr('width', availableWidth + 'px').attr('height', availableHeight + 'px').attr('preserveAspectRatio', aspectRatioValue);
          var backgroundImageContainer = wrap.select('#background-image-rect-' + id);
          backgroundImageContainer.attr('width', availableWidth + 'px').attr('height', availableHeight + 'px').attr('fill', 'url(#background-image-pattern-' + id + ')');
        } else {
          backgroundImage = wrap.select('#background-image-' + id);
          backgroundImage.attr('xlink:href', '');
        }
        function updateInteractiveLayer() {
          needsUpdate = false;
          if (!interactive) {
            return false;
          }
          if (useVoronoi === true) {
            var mouseEventCallback = function mouseEventCallback(d, mDispatch) {
              var originalPoint = d.point,
                seriesIndex = d.seriesIndex,
                pointIndex = d.pointIndex;
              if (needsUpdate || seriesIndex === undefined || !data[seriesIndex]) {
                return;
              }
              var series = data[seriesIndex];
              var point = scatter_objectSpread(scatter_objectSpread({}, originalPoint), {}, {
                color: color(series, seriesIndex),
                x: getX(originalPoint, pointIndex),
                y: getY(originalPoint, pointIndex)
              });
              var left = x(point.x) + margin.left;
              var top = y(point.y) + margin.top;
              var box = container.node().getBoundingClientRect();
              var pos = {
                left: left + box.left + boundPad,
                top: top + box.top + boundPad
              };
              mDispatch({
                point: point,
                series: series,
                pointIndex: pointIndex,
                seriesIndex: seriesIndex,
                pos: pos,
                relativePos: [left, top]
              });
            };
            var pointLabelEventCallback = function pointLabelEventCallback(_ref, event) {
              var _ref2 = scatter_slicedToArray(_ref, 2),
                data = _ref2[0],
                point = _ref2[1];
              var series = data.series;
              var voronoiPoint = voronoi.find(function (_ref3) {
                var seriesIndex = _ref3.seriesIndex,
                  pointIndex = _ref3.pointIndex;
                return seriesIndex === series && pointIndex === point;
              });
              mouseEventCallback(voronoiPoint, event);
            };
            var voronoi = computeVoronoi(data, {
              x: x,
              y: y,
              getX: getX,
              getY: getY,
              pointActive: pointActive
            });
            if (!voronoi.length) {
              return;
            }
            wrap.select('.nv-point-paths').selectAll('path').remove();
            var pointPaths = wrap.select('.nv-point-paths').selectAll('path').data(voronoi);
            var pointLabels = wrap.selectAll('g.data-point-label');
            var vPointPaths = pointPaths.enter().append('svg:path').attr('d', function (d) {
              if (!d || !d.polygonData || d.polygonData.length === 0) {
                return 'M 0 0';
              } else {
                return 'M' + d.polygonData.join(',') + 'Z';
              }
            }).attr('id', function (d, i) {
              return 'nv-path-' + i;
            }).attr('clip-path', function (d, i) {
              return 'url(#nv-clip-' + id + '-' + i + ')';
            });
            if (showVoronoi) {
              vPointPaths.style('fill', d3.rgb(230, 230, 230)).style('stroke-opacity', 1).style('stroke', d3.rgb(200, 200, 200));
            }
            if (clipVoronoi) {
              wrap.select('.nv-point-clips').selectAll('*').remove();
              var pointClips = wrap.select('.nv-point-clips').selectAll('clipPath').data(voronoi);
              pointClips.enter().append('svg:clipPath').attr('id', function (d, i) {
                return 'nv-clip-' + id + '-' + i;
              }).append('svg:circle').attr('cx', function (d) {
                return d.x;
              }).attr('cy', function (d) {
                return d.y;
              }).attr('r', clipRadius);
            }
            var toggleHighlights = function toggleHighlights(evt, isHoverOver) {
              if (evt.dataPoint.x !== undefined) {
                container.select('.nv-groups').selectAll('.nv-point-' + evt.dataPoint.x).classed('hover', isHoverOver);
              }
            };
            wrap.select('.nv-groups').selectAll('.nv-point').on('keydown', function (d, index) {
              var nodes = wrap.select('.nv-groups').selectAll('.nv-point')[0];
              if (d3.event.key === 'Enter') {
                pointLabelEventCallback(d, dispatch.elementClick);
              }
              switch (d3.event.key) {
                case KEYS.ARROW_DOWN:
                case KEYS.ARROW_LEFT:
                  if (index > 0 && index <= nodes.length - 1) {
                    nodes[index - 1].focus();
                  }
                  break;
                case KEYS.ARROW_UP:
                case KEYS.ARROW_RIGHT:
                  if (index >= 0 && index < nodes.length - 1) {
                    nodes[index + 1].focus();
                  }
                  break;
                default:
                  break;
              }
            }).on('focus', function (d) {
              return pointLabelEventCallback(d, dispatch.elementMouseover);
            }).on('blur', function (d) {
              return pointLabelEventCallback(d, dispatch.elementMouseout);
            });
            pointPaths.on('click', function (d) {
              return mouseEventCallback(d, dispatch.elementClick);
            }).on('dblclick', function (d) {
              return mouseEventCallback(d, dispatch.elementDblClick);
            }).on('mouseover', function (d) {
              return mouseEventCallback(d, dispatch.elementMouseover);
            }).on('mouseout', function (d) {
              return mouseEventCallback(d, dispatch.elementMouseout);
            });
            pointLabels.on('click', function (d) {
              return pointLabelEventCallback(d, dispatch.elementClick);
            }).on('dblclick', function (d) {
              return pointLabelEventCallback(d, dispatch.elementDblClick);
            }).on('mouseover', function (d) {
              return pointLabelEventCallback(d, dispatch.elementMouseover);
            }).on('mouseout', function (d) {
              return pointLabelEventCallback(d, dispatch.elementMouseout);
            });
            if (useRegionInteraction) {
              interactionDispatch.on('mouseOverRegion.highlight', function (evt) {
                return toggleHighlights(evt, true);
              });
              interactionDispatch.on('mouseOutRegion.highlight', function (evt) {
                return toggleHighlights(evt, false);
              });
              var pointsEventList = [{
                incoming: 'regionClick.point',
                outgoing: 'click'
              }, {
                incoming: 'regionDblClick.point',
                outgoing: 'dblclick'
              }];
              var dataLabelsEventList = [{
                incoming: 'regionClick.pointDataLabel',
                outgoing: 'click'
              }, {
                incoming: 'regionDblClick.pointDataLabel',
                outgoing: 'dblclick'
              }];
              var clippingElements = clipVoronoi ? wrap.select('.nv-point-clips').selectAll('clipPath circle')[0] : null;
              registerSubdivisionEvents(interactionDispatch, wrap.select('.nv-point-paths').selectAll('path')[0], pointsEventList, clipVoronoi ? circleCollisionChecker : defaultCollisionChecker, clippingElements);
              registerSubdivisionEvents(interactionDispatch, wrap.selectAll('g.data-point-label')[0], dataLabelsEventList);
            }
          } else {
            wrap.select('.nv-groups').selectAll('.nv-group').selectAll('.nv-point').on('click', function (d, i) {
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.elementClick({
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i
              });
            }).on('dblclick', function (d, i) {
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.elementDblClick({
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i
              });
            }).on('mouseover', function (d, i) {
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.elementMouseover({
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i,
                color: color(d, i)
              });
            }).on('mouseout', function (d, i) {
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.elementMouseout({
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i,
                color: color(d, i)
              });
            });
            if (useRegionInteraction) {
              var _pointsEventList = [{
                incoming: 'regionClick.point',
                outgoing: 'click'
              }, {
                incoming: 'regionDblClick.point',
                outgoing: 'dblclick'
              }];
              registerSubdivisionEvents(interactionDispatch, wrap.select('.nv-point')[0], _pointsEventList);
            }
          }
        }
        needsUpdate = true;
        var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function (d) {
          return d;
        }, function (d, i) {
          return d.id || i;
        });
        groups.enter().append('g').style('stroke-opacity', 1e-6);
        groups.exit().remove();
        groups.attr('class', function (d, i) {
          return (d.classed || '') + ' nv-group nv-series-' + i;
        }).classed('hover', function (d) {
          return d.hover;
        });
        groups.watchTransition(renderWatch, 'scatter: groups').style('fill', function (d, i) {
          return color(d, i);
        }).style('stroke', function (d, i) {
          return color(d, i);
        }).style('stroke-opacity', 1).style('stroke-width', function (d) {
          return (d.strokeWidth || defaultStrokeWidth) + 'px';
        });
        var points = groups.selectAll('path.nv-point').data(function (d) {
          return d.values.map(function (point, pointIndex) {
            return [point, pointIndex];
          }).filter(function (pointArray, pointIndex) {
            return pointActive(pointArray[0], pointIndex);
          });
        }, function (d, i) {
          return d[0].id || i;
        });
        var patternContainers = groups.append('defs');
        var getPatternContainer = function getPatternContainer(index) {
          return patternContainers.filter(function (d, containerIndex) {
            return containerIndex === index;
          }).node();
        };
        var getPointFill = function getPointFill(d, i, j) {
          var color = d[0].color;
          if (d[0].pattern) {
            return nv.utils.patternService.getDataFill(getPatternContainer(j), d[0], color);
          }
          return color;
        };
        points.enter().append('path').style('fill', getPointFill).style('stroke', function (d) {
          return d.color;
        }).attr('transform', function (d) {
          return 'translate(' + nv.utils.NaNtoZero(x0(getX(d[0], d[1]))) + ',' + nv.utils.NaNtoZero(y0(getY(d[0], d[1]))) + ')';
        }).attr('d', nv.utils.symbol().type(function (d) {
          return getShape(d[0]);
        }).size(function (d) {
          return staticPointSize || z(getSize(d[0], d[1]));
        }));
        points.exit().remove();
        groups.exit().selectAll('path.nv-point').watchTransition(renderWatch, 'scatter exit').attr('transform', function (d) {
          return 'translate(' + nv.utils.NaNtoZero(x(getX(d[0], d[1]))) + ',' + nv.utils.NaNtoZero(y(getY(d[0], d[1]))) + ')';
        }).remove();
        points.each(function (d) {
          d3.select(this).classed('nv-point', true).classed('nv-point-' + d[1], true).classed('nv-noninteractive', !interactive).classed('hover', false).classed('always-visible', function (d) {
            return !!d[0].showAlways;
          });
        });
        points.watchTransition(renderWatch, 'scatter points').attr('transform', function (d) {
          return 'translate(' + nv.utils.NaNtoZero(x(getX(d[0], d[1]))) + ',' + nv.utils.NaNtoZero(y(getY(d[0], d[1]))) + ')';
        }).attr('d', nv.utils.symbol().type(function (d) {
          return getShape(d[0]);
        }).size(function (d) {
          return staticPointSize || z(getSize(d[0], d[1]));
        })).style('fill', getPointFill);
        points.attr('tabindex', '0').attr('aria-label', function (d) {
          var ariaLabels = [];
          var seriesNum = d[0].series;
          var label = getDataValueText(d);
          var type = data[seriesNum].key;
          var xVal = xValueFormat(d[0].x);
          var yVal = yValueFormat(d[0].y);
          var sizeVal = d[0].size;
          var responsesCount = d[0].count;
          var xAxisAriaLabel = translationService.translate('DQ.XAxis', {
            xAxisValue: xVal
          });
          var yAxisAriaLabel = translationService.translate('DQ.YAxis', {
            yAxisValue: yVal
          });
          var sizeAriaLabel = sizeLabel ? sizeLabel + ' ' + sizeVal : translationService.translate('DQ.Size', {
            sizeValue: sizeVal
          });
          var labelAriaLabel = translationService.translate('DQ.Label', {
            customLabel: label
          });
          ariaLabels = [xAxisAriaLabel, yAxisAriaLabel, sizeAriaLabel];
          if (showsDataPointResponses) {
            ariaLabels.push(translationService.translate('DQ.Responses', {
              count: responsesCount
            }));
          }
          ariaLabels.push(labelAriaLabel, type);
          var ariaLabel = (ariaLabels.join(', ') + '.').toLowerCase();
          var capitalizedAriaLabel = ariaLabel.charAt(0).toUpperCase() + ariaLabel.slice(1);
          return capitalizedAriaLabel;
        }).attr('role', 'img').attr('id', function (d) {
          return d[0].label;
        });
        if (showValues) {
          groups.selectAll('g.data-points').remove();
          var filterDataValueText = false;
          var dataPoints = groups.selectAll('g.data-points').data(function (d) {
            if (showValues === scatter_SHOW_VALUE_OPTIONS.MIN_MAX) {
              var min;
              var max;
              for (var i = 0; i < d.values.length; i++) {
                var on = d.values[i].y;
                if (min === undefined || min[0].y >= on) {
                  min = [d.values[i], i];
                }
                if (max === undefined || max[0].y <= on) {
                  max = [d.values[i], i];
                }
              }
              filterDataValueText = true;
              if (min && max) {
                d.values[min[1]].showTextLabel = true;
                d.values[max[1]].showTextLabel = true;
              }
            } else if (showValues === scatter_SHOW_VALUE_OPTIONS.LAST) {
              filterDataValueText = true;
            }
            return d.values.map(function (point, index) {
              return [point, index];
            }).filter(function (e) {
              return e[0].y !== undefined && e[0].y !== null;
            });
          }, function (d) {
            return d[0].id || d[1];
          });
          var dataPointsEnter = dataPoints.enter().append('g');
          dataPointsEnter.attr('id', function (d, i) {
            return 'label-' + d[0].series + '-' + i;
          }).attr('class', function () {
            return 'data-points data-point-label';
          }).attr('data-expectedY', function (d) {
            return nv.utils.NaNtoZero(y(getY(d[0], d[1])));
          }).attr('data-expectedX', function (d) {
            return nv.utils.NaNtoZero(x(getX(d[0], d[1])));
          });
          dataPointsEnter.append('rect');
          dataPointsEnter.append('text').attr('id', 'dataPointText').attr('text-anchor', 'middle');
          dataPointsEnter.append('text').attr('id', 'dataPointSymbol').attr('text-anchor', 'middle');
          dataPoints.exit().remove();
          dataPoints.each(function (d) {
            var pointContainer = d3.select(this),
              textContainer = pointContainer.selectAll('text').filter('#dataPointText'),
              symbolContainer = pointContainer.selectAll('text').filter('#dataPointSymbol'),
              rectContainer = pointContainer.select('rect'),
              textSize = 0,
              assumedFontSize = 12,
              symbolPadding = 1,
              maxFontSize = assumedFontSize,
              symbolSize = 0;
            textContainer.text(function () {
              if (filterDataValueText === true && d[0].showTextLabel !== true) {
                return;
              }
              return getDataValueText(d);
            });
            textSize = textContainer.node().getComputedTextLength();
            if (textSize > availableWidth) {
              textContainer.text('');
            }
            var hasText = textSize > 0;
            var customIconSettings = d[0].customIcon;
            if (customIconSettings) {
              setupDataValueIcon(symbolContainer, customIconSettings);
              maxFontSize = _.max([assumedFontSize, customIconSettings.fontSize]);
              symbolSize = symbolContainer.node().getComputedTextLength();
              if (hasText) {
                symbolContainer.attr('x', -(textSize / 2 + symbolSize / 2) - symbolPadding);
              }
            }
            var hasSymbol = symbolSize > 0;
            setupDataValueLabelBackground(hasText, hasSymbol, rectContainer, textSize, symbolSize, maxFontSize, symbolPadding);
            pointContainer.attr('width', textSize).attr('height', assumedFontSize);
            d.labelContainer = pointContainer;
          });
          dataPoints.attr('data-y', function (d) {
            var positioning = boundPad * 2;
            if (getValueArrangement(d) === 'top') {
              positioning = -boundPad;
            }
            return parseInt(d.labelContainer.attr('data-expectedY')) + positioning;
          }).attr('data-x', function (d) {
            return d.labelContainer.attr('data-expectedX');
          });
          if (labelPlacementFunction) {
            var unpositionedLabels = [];
            var pointSizes = new Map();
            points.forEach(function (series) {
              series.forEach(function (seriesPoint) {
                var _seriesPoint$getBBox$, _seriesPoint$getBBox;
                var width = (_seriesPoint$getBBox$ = seriesPoint === null || seriesPoint === void 0 ? void 0 : (_seriesPoint$getBBox = seriesPoint.getBBox) === null || _seriesPoint$getBBox === void 0 ? void 0 : _seriesPoint$getBBox.call(seriesPoint).width) !== null && _seriesPoint$getBBox$ !== void 0 ? _seriesPoint$getBBox$ : 0;
                pointSizes.set(seriesPoint.id, width);
              });
            });
            dataPoints.each(function (dataPoint) {
              var unpositionedLabel = {
                id: dataPoint.labelContainer,
                width: dataPoint.labelContainer.attr('width'),
                height: dataPoint.labelContainer.attr('height'),
                expectedX: dataPoint.labelContainer.attr('data-expectedX'),
                expectedY: dataPoint.labelContainer.attr('data-expectedY'),
                radius: pointSizes.get(dataPoint[0].label) / 2
              };
              if (parseInt(unpositionedLabel.width) !== 0) {
                unpositionedLabels.push(unpositionedLabel);
              }
            });
            var bounds = {
              x: -boundPad,
              y: -boundPad,
              width: availableWidth + boundPad,
              height: availableHeight + boundPad
            };
            var pointBufferRadius = 4;
            var defaultPositioningRadian = 0.5;
            if (getValueArrangement() === 'top') {
              defaultPositioningRadian = 1.5;
            }
            var positionedLabels = labelPlacementFunction(unpositionedLabels, bounds, pointBufferRadius, defaultPositioningRadian, availableWidth * 0.4);
            positionedLabels.forEach(function (label) {
              if (!label.display) {
                label.id.attr('style', 'opacity:0;');
              } else {
                label.id.attr('data-y', label.y + label.height * 0.75);
                label.id.attr('data-x', label.x + label.width / 2);
              }
            });
          }
          dataPoints.each(function (data) {
            data.labelContainer.attr('transform', function () {
              return 'translate(' + data.labelContainer.attr('data-x') + ',' + data.labelContainer.attr('data-y') + ')';
            });
          });
        } else {
          groups.selectAll('g.data-points').remove();
        }
        if (interactiveUpdateDelay) {
          clearTimeout(timeoutID);
          timeoutID = setTimeout(updateInteractiveLayer, interactiveUpdateDelay);
        } else {
          updateInteractiveLayer();
        }
        x0 = x.copy();
        y0 = y.copy();
        z0 = z.copy();
      });
      renderWatch.renderEnd('scatter immediate');
      return chart;
    }
    chart._getDataValueText = getDataValueText;
    chart._setupDataValueIcon = setupDataValueIcon;
    chart._setupDataValueLabelBackground = setupDataValueLabelBackground;
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._calls = new function () {
      this.clearHighlights = function () {
        nv.dom.write(function () {
          container.selectAll('.nv-point.hover').classed('hover', false);
        });
        return null;
      };
      this.highlightPoint = function (data, isHoverOver) {
        nv.dom.write(function () {
          container.select('.nv-groups').select('g#label-' + data.seriesIndex + '-' + data.pointIndex + ' text').classed('hover', isHoverOver);
          container.select('.nv-groups').selectAll('.nv-series-' + data.seriesIndex).selectAll('.nv-point-' + data.pointIndex).classed('hover', isHoverOver);
        });
      };
    }();
    dispatch.on('elementMouseover.point', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, true);
      }
    });
    dispatch.on('elementMouseout.point', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, false);
      }
    });
    dispatch.on('elementMouseover.labelContainer', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, true);
      }
    });
    dispatch.on('elementMouseout.labelContainer', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, false);
      }
    });
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      pointScale: {
        get: function get() {
          return z;
        },
        set: function set(_) {
          z = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      xDomainMin: {
        get: function get() {
          return xDomainMin;
        },
        set: function set(_) {
          xDomainMin = _;
        }
      },
      xDomainMax: {
        get: function get() {
          return xDomainMax;
        },
        set: function set(_) {
          xDomainMax = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      yDomainMin: {
        get: function get() {
          return yDomainMin;
        },
        set: function set(_) {
          yDomainMin = _;
        }
      },
      yDomainMax: {
        get: function get() {
          return yDomainMax;
        },
        set: function set(_) {
          yDomainMax = _;
        }
      },
      staticPointSize: {
        get: function get() {
          return staticPointSize;
        },
        set: function set(_) {
          staticPointSize = _;
        }
      },
      pointDomain: {
        get: function get() {
          return sizeDomain;
        },
        set: function set(_) {
          sizeDomain = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      pointRange: {
        get: function get() {
          return sizeRange;
        },
        set: function set(_) {
          sizeRange = _;
        }
      },
      forceX: {
        get: function get() {
          return forceX;
        },
        set: function set(_) {
          forceX = _;
        }
      },
      forceY: {
        get: function get() {
          return forceY;
        },
        set: function set(_) {
          forceY = _;
        }
      },
      forcePoint: {
        get: function get() {
          return forceSize;
        },
        set: function set(_) {
          forceSize = _;
        }
      },
      interactive: {
        get: function get() {
          return interactive;
        },
        set: function set(_) {
          interactive = _;
        }
      },
      pointActive: {
        get: function get() {
          return pointActive;
        },
        set: function set(_) {
          pointActive = _;
        }
      },
      padDataOuter: {
        get: function get() {
          return padDataOuter;
        },
        set: function set(_) {
          padDataOuter = _;
        }
      },
      padData: {
        get: function get() {
          return padData;
        },
        set: function set(_) {
          padData = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      clipVoronoi: {
        get: function get() {
          return clipVoronoi;
        },
        set: function set(_) {
          clipVoronoi = _;
        }
      },
      clipRadius: {
        get: function get() {
          return clipRadius;
        },
        set: function set(_) {
          clipRadius = _;
        }
      },
      showVoronoi: {
        get: function get() {
          return showVoronoi;
        },
        set: function set(_) {
          showVoronoi = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      interactiveUpdateDelay: {
        get: function get() {
          return interactiveUpdateDelay;
        },
        set: function set(_) {
          interactiveUpdateDelay = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      showValuesType: {
        get: function get() {
          return showValuesType;
        },
        set: function set(_) {
          showValuesType = _;
        }
      },
      labelPlacementFunction: {
        get: function get() {
          return labelPlacementFunction;
        },
        set: function set(_) {
          labelPlacementFunction = _;
        }
      },
      showOnlyYValues: {
        get: function get() {
          return showOnlyYValues;
        },
        set: function set(_) {
          showOnlyYValues = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      padY: {
        get: function get() {
          return padY;
        },
        set: function set(_) {
          padY = _;
        }
      },
      padYBy: {
        get: function get() {
          return padYBy;
        },
        set: function set(_) {
          padYBy = _;
        }
      },
      backgroundImageUrl: {
        get: function get() {
          return backgroundImageUrl;
        },
        set: function set(_) {
          backgroundImageUrl = _;
        }
      },
      backgroundImagePosition: {
        get: function get() {
          return backgroundImagePosition;
        },
        set: function set(_) {
          backgroundImagePosition = _;
        }
      },
      xAxisLabel: {
        get: function get() {
          return xAxisLabel;
        },
        set: function set(_) {
          xAxisLabel = _;
        }
      },
      yAxisLabel: {
        get: function get() {
          return yAxisLabel;
        },
        set: function set(_) {
          yAxisLabel = _;
        }
      },
      sizeLabel: {
        get: function get() {
          return sizeLabel;
        },
        set: function set(_) {
          sizeLabel = _;
        }
      },
      xValueFormat: {
        get: function get() {
          return xValueFormat;
        },
        set: function set(_) {
          xValueFormat = _;
        }
      },
      yValueFormat: {
        get: function get() {
          return yValueFormat;
        },
        set: function set(_) {
          yValueFormat = _;
        }
      },
      isNumberOfResponsesShownInTooltip: {
        get: function get() {
          return showsDataPointResponses;
        },
        set: function set(_) {
          showsDataPointResponses = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = d3.functor(_);
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = d3.functor(_);
        }
      },
      pointSize: {
        get: function get() {
          return getSize;
        },
        set: function set(_) {
          getSize = d3.functor(_);
        }
      },
      pointShape: {
        get: function get() {
          return getShape;
        },
        set: function set(_) {
          getShape = d3.functor(_);
        }
      },
      valueArrangement: {
        get: function get() {
          return getValueArrangement;
        },
        set: function set(_) {
          getValueArrangement = d3.functor(_);
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
        }
      },
      enableAutoAxisScaling: {
        get: function get() {
          return enableAutoAxisScaling;
        },
        set: function set(_) {
          enableAutoAxisScaling = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      },
      useVoronoi: {
        get: function get() {
          return useVoronoi;
        },
        set: function set(_) {
          useVoronoi = _;
          if (useVoronoi === false) {
            clipVoronoi = false;
          }
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
function getYDomain(series, forceY, isNum, yMin, yMax, dataPointSize) {
  var yValues = d3.merge(series).map(function (value) {
    return Number(value.y);
  }).concat(forceY);
  var domainPaddingRatio = 0;
  switch (dataPointSize) {
    case SMALL_DATA_POINT_SIZE:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_SMALL_DATA_POINT;
      break;
    case MEDIUM_DATA_POINT_SIZE:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT;
      break;
    case LARGE_DATA_POINT_SIZE:
    default:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_LARGE_DATA_POINT;
  }
  var yDomain = d3.extent(yValues);
  var range = yDomain[1] - yDomain[0];
  yDomain[0] -= range * domainPaddingRatio;
  yDomain[1] += range * domainPaddingRatio;
  if (isNum(yMin)) {
    yDomain[0] = parseFloat(yMin);
    if (!isNum(yMax) && yDomain[1] <= yDomain[0]) {
      yDomain[1] = yDomain[0] + MINIMUM_DOMAIN_SEPARATION;
    }
  }
  if (isNum(yMax)) {
    yDomain[1] = parseFloat(yMax);
    if (!isNum(yMin) && yDomain[1] <= yDomain[0]) {
      yDomain[0] = yDomain[1] - MINIMUM_DOMAIN_SEPARATION;
    }
  }
  return yDomain;
}
function getXDomain(series, forceX, isNum, xMin, xMax, dataPointSize) {
  var xValues = d3.merge(series).map(function (value) {
    return Number(value.x);
  }).concat(forceX);
  var domainPaddingRatio = 0;
  switch (dataPointSize) {
    case SMALL_DATA_POINT_SIZE:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_SMALL_DATA_POINT;
      break;
    case MEDIUM_DATA_POINT_SIZE:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT;
      break;
    case LARGE_DATA_POINT_SIZE:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_LARGE_DATA_POINT;
      break;
    default:
      domainPaddingRatio = DOMAIN_PADDING_RATIO_LARGE_DATA_POINT;
  }
  var xDomain = d3.extent(xValues);
  var range = xDomain[1] - xDomain[0];
  xDomain[0] -= range * domainPaddingRatio;
  xDomain[1] += range * domainPaddingRatio;
  if (isNum(xMin)) {
    xDomain[0] = parseFloat(xMin);
    if (!isNum(xMax) && xDomain[1] <= xDomain[0]) {
      xDomain[1] = xDomain[0] + MINIMUM_DOMAIN_SEPARATION;
    }
  }
  if (isNum(xMax)) {
    xDomain[1] = parseFloat(xMax);
    if (!isNum(xMin) && xDomain[1] <= xDomain[0]) {
      xDomain[0] = xDomain[1] - MINIMUM_DOMAIN_SEPARATION;
    }
  }
  return xDomain;
}
;// ./src/js/nv/models/upgradedScatter.js
function upgradedScatter_typeof(o) { "@babel/helpers - typeof"; return upgradedScatter_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, upgradedScatter_typeof(o); }














function upgradedScatter_slicedToArray(r, e) { return upgradedScatter_arrayWithHoles(r) || upgradedScatter_iterableToArrayLimit(r, e) || upgradedScatter_unsupportedIterableToArray(r, e) || upgradedScatter_nonIterableRest(); }
function upgradedScatter_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function upgradedScatter_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return upgradedScatter_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? upgradedScatter_arrayLikeToArray(r, a) : void 0; } }
function upgradedScatter_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function upgradedScatter_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function upgradedScatter_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function upgradedScatter_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function upgradedScatter_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? upgradedScatter_ownKeys(Object(t), !0).forEach(function (r) { upgradedScatter_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : upgradedScatter_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function upgradedScatter_defineProperty(e, r, t) { return (r = upgradedScatter_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function upgradedScatter_toPropertyKey(t) { var i = upgradedScatter_toPrimitive(t, "string"); return "symbol" == upgradedScatter_typeof(i) ? i : i + ""; }
function upgradedScatter_toPrimitive(t, r) { if ("object" != upgradedScatter_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != upgradedScatter_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











var upgradedScatter_DOMAIN_PADDING_RATIO_SMALL_DATA_POINT = constants_Constants.DOMAIN_PADDING_RATIO_SMALL_DATA_POINT,
  upgradedScatter_DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT = constants_Constants.DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT,
  upgradedScatter_DOMAIN_PADDING_RATIO_LARGE_DATA_POINT = constants_Constants.DOMAIN_PADDING_RATIO_LARGE_DATA_POINT,
  upgradedScatter_SMALL_DATA_POINT_SIZE = constants_Constants.SMALL_DATA_POINT_SIZE,
  upgradedScatter_MEDIUM_DATA_POINT_SIZE = constants_Constants.MEDIUM_DATA_POINT_SIZE,
  upgradedScatter_LARGE_DATA_POINT_SIZE = constants_Constants.LARGE_DATA_POINT_SIZE,
  upgradedScatter_MINIMUM_DOMAIN_SEPARATION = constants_Constants.MINIMUM_DOMAIN_SEPARATION,
  upgradedScatter_SHOW_VALUE_OPTIONS = constants_Constants.SHOW_VALUE_OPTIONS,
  upgradedScatter_KEYS = constants_Constants.KEYS;
var upgradedScatter = function upgradedScatter(nv) {
  nv.constants = {};
  nv.constants.BACKGROUND_IMAGE_POSITIONS = Object.freeze({
    FIT: 'FIT',
    FILL: 'FILL',
    STRETCH: 'STRETCH'
  });
  nv.models.upgradedScatter = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = null,
      height = null,
      color = nv.upgradedUtils.defaultColor(),
      id = Math.floor(Math.random() * 100000),
      container = null,
      x = linear_linear(),
      y = linear_linear(),
      z = linear_linear(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      getSize = function getSize(d) {
        return d.size || 1;
      },
      getGroup = function getGroup(d) {
        return d.group || '-';
      },
      getShape = function getShape(d) {
        return d.shape || 'circle';
      },
      forceX = [],
      forceY = [],
      forceSize = [],
      interactive = true,
      pointActive = function pointActive(d) {
        return !d.notActive;
      },
      padData = false,
      padDataOuter = 0.1,
      clipEdge = false,
      clipVoronoi = true,
      showVoronoi = false,
      clipRadius = function clipRadius() {
        return 25;
      },
      xDomain = null,
      xDomainMin,
      xDomainMax,
      yDomain = null,
      yDomainMin,
      yDomainMax,
      xRange = null,
      yRange = null,
      sizeDomain = null,
      sizeRange = null,
      staticPointSize = null,
      singlePoint = false,
      dispatch = src_dispatch('elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'renderEnd'),
      useVoronoi = true,
      duration = 250,
      interactiveUpdateDelay = 300,
      showValues = false,
      showValuesType = null,
      labelPlacementFunction = undefined,
      showOnlyYValues = false,
      getValueArrangement = function getValueArrangement(d) {
        return d && d.valueArrangement || 'bottom';
      },
      valueFormat = format(',.2f'),
      padY = false,
      padYBy = 22,
      defaultStrokeWidth = 1,
      boundPad = 10,
      backgroundImageUrl = null,
      backgroundImagePosition = null,
      useRegionInteraction = false,
      xAxisLabel = null,
      yAxisLabel = null,
      sizeLabel = null,
      xValueFormat = format('.1f'),
      yValueFormat = format('.1f'),
      enableAutoAxisScaling = false,
      showsDataPointResponses = false,
      interactionDispatch;
    var x0,
      y0,
      z0,
      timeoutID,
      needsUpdate = false,
      renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration),
      _sizeRange_def = [16, 256];
    function getDataValueText(d) {
      var customDataValue = d[0].customDataValue;
      if (customDataValue || customDataValue === '') {
        return customDataValue;
      } else {
        switch (showValuesType) {
          case upgradedScatter_SHOW_VALUE_OPTIONS.X_AXIS_Y_AXIS:
            return "".concat(getX(d[0]), ", ").concat(getY(d[0]));
          case upgradedScatter_SHOW_VALUE_OPTIONS.X_AXIS:
            return getX(d[0]);
          case upgradedScatter_SHOW_VALUE_OPTIONS.Y_AXIS:
            return getY(d[0]);
          case upgradedScatter_SHOW_VALUE_OPTIONS.SIZE_METRIC:
            return getSize(d[0]);
          case upgradedScatter_SHOW_VALUE_OPTIONS.GROUP:
            return getGroup(d[0]);
        }
        return !showOnlyYValues && d[0].label ? d[0].label : valueFormat(getY(d[0], d[1]));
      }
    }
    function setupDataValueIcon(symbolContainer, customIconSettings) {
      var yTranslateSymbol = 1;
      symbolContainer.style('font-size', customIconSettings.fontSize + 'px').style('fill', customIconSettings.color).attr('y', yTranslateSymbol).text(customIconSettings.icon);
      if (customIconSettings.fontFamily) {
        symbolContainer.style('font-family', customIconSettings.fontFamily).attr('class', customIconSettings.iconClass);
      } else {
        symbolContainer.attr('class', 'icon');
      }
    }
    function setupDataValueLabelBackground(hasText, hasSymbol, rectContainer, textSize, symbolSize, maxFontSize, symbolPadding) {
      var yTranslateRectTextOnly = 4;
      var yTranslateRectSymbolOnly = 5;
      var xTranslateRectBoth = 4;
      var bothPadding = 2;
      if (hasText && hasSymbol) {
        rectContainer.attr('width', textSize + symbolSize + bothPadding).attr('height', maxFontSize).attr('x', -(textSize / 2 + symbolSize / 2) - (xTranslateRectBoth + bothPadding)).attr('y', -(maxFontSize / 2 + yTranslateRectSymbolOnly));
      } else if (hasText) {
        rectContainer.attr('width', textSize).attr('height', maxFontSize).attr('x', -textSize / 2).attr('y', -(maxFontSize / 2 + yTranslateRectTextOnly));
      } else if (hasSymbol) {
        rectContainer.attr('width', symbolSize + symbolPadding).attr('height', maxFontSize).attr('x', -symbolSize / 2).attr('y', -(maxFontSize / 2 + yTranslateRectSymbolOnly));
      }
    }
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        container = src_select(this);
        var availableWidth = nv.upgradedUtils.availableWidth(width, container, margin),
          availableHeight = nv.upgradedUtils.availableHeight(height, container, margin);
        nv.upgradedUtils.initSVG(container);
        data.forEach(function (series, i) {
          series.values.forEach(function (point) {
            point.series = i;
          });
        });
        var seriesData = xDomain && yDomain && sizeDomain ? [] : merge(data.map(function (d) {
          return d.values.map(function (d, i) {
            return {
              x: getX(d, i),
              y: getY(d, i),
              size: getSize(d, i)
            };
          });
        }));
        var isNum = function isNum(num) {
          return nv.upgradedUtils.isNumeric(num);
        };
        var allDataSeries = data.filter(function (series) {
          return !series.disabled;
        }).map(function (series) {
          return series.values;
        });
        var _xDomain = src_extent(seriesData.map(function (d) {
          return d.x;
        }).concat(forceX));
        if (enableAutoAxisScaling) {
          _xDomain = upgradedScatter_getXDomain(allDataSeries, forceX, isNum, xDomainMin, xDomainMax, staticPointSize);
        }
        if (nv.upgradedUtils.isNumeric(xDomainMin)) {
          _xDomain[0] = parseFloat(xDomainMin);
        }
        if (nv.upgradedUtils.isNumeric(xDomainMax)) {
          _xDomain[1] = parseFloat(xDomainMax);
        }
        x.domain(xDomain || _xDomain);
        if (padData && data[0]) {
          x.range(xRange || [(availableWidth * padDataOuter + availableWidth) / (2 * data[0].values.length), availableWidth - availableWidth * (1 + padDataOuter) / (2 * data[0].values.length)]);
        } else {
          x.range(xRange || [0, availableWidth]);
        }
        var _yRange = [availableHeight, 0];
        if (chart.yScale().name === 'o') {
          var min = min_min(seriesData.map(function (d) {
            if (d.y !== 0) {
              return d.y;
            }
          }));
          y.clamp(!clipEdge).domain(yDomain || src_extent(seriesData.map(function (d) {
            if (d.y !== 0) {
              return d.y;
            } else {
              return min * 0.1;
            }
          }).concat(forceY))).range(yRange || _yRange);
        } else {
          var _yDomain = src_extent(seriesData.map(function (d) {
            return d.y;
          }).concat(forceY));
          if (enableAutoAxisScaling) {
            _yDomain = upgradedScatter_getYDomain(allDataSeries, forceY, isNum, yDomainMin, yDomainMax, staticPointSize);
          }
          if (nv.upgradedUtils.isNumeric(yDomainMin)) {
            y.clamp(!clipEdge);
            _yDomain[0] = parseFloat(yDomainMin);
          }
          if (nv.upgradedUtils.isNumeric(yDomainMax)) {
            y.clamp(!clipEdge);
            _yDomain[1] = parseFloat(yDomainMax);
          }
          y.domain(yDomain || _yDomain).range(yRange || _yRange);
        }
        z.domain(sizeDomain || src_extent(seriesData.map(function (d) {
          return d.size;
        }).concat(forceSize))).range(sizeRange || _sizeRange_def);
        singlePoint = x.domain()[0] === x.domain()[1] || y.domain()[0] === y.domain()[1];
        ensureDomain(x);
        ensureDomain(y);
        if (isNaN(x.domain()[0])) {
          x.domain([-1, 1]);
        }
        if (isNaN(y.domain()[0])) {
          y.domain([-1, 1]);
        }
        x0 = x0 || x;
        y0 = y0 || y;
        z0 = z0 || z;
        var wrap = container.selectAll('g.nv-wrap.nv-scatter').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatter nv-chart-' + id);
        wrapEnter.append('rect').attr('id', 'background-image-rect-' + id);
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var g = gEnter.merge(wrap).select('g');
        var wrapMergeSelection = wrapEnter.merge(wrap);
        var gMergeSelection = gEnter.merge(g);
        wrapMergeSelection.classed('nv-single-point', singlePoint);
        gEnter.append('g').attr('class', 'nv-groups');
        gEnter.append('g').attr('class', 'nv-point-paths');
        wrapEnter.append('g').attr('class', 'nv-point-clips');
        wrapMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
        wrapMergeSelection.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight > 0 ? availableHeight : 0);
        gMergeSelection.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
        if (backgroundImageUrl) {
          wrapMergeSelection.select('defs').append('pattern').attr('id', 'background-image-pattern-' + id).append('image').attr('id', 'background-image-' + id);
          var backgroundImagePattern = wrapMergeSelection.select('#background-image-pattern-' + id);
          backgroundImagePattern.attr('patternUnits', 'userSpaceOnUse').attr('width', '100%').attr('height', '100%');
          var aspectRatioValue;
          switch (backgroundImagePosition) {
            case nv.constants.BACKGROUND_IMAGE_POSITIONS.FILL:
              aspectRatioValue = 'xMidYMid slice';
              break;
            case nv.constants.BACKGROUND_IMAGE_POSITIONS.FIT:
              aspectRatioValue = 'xMidYMid meet';
              break;
            case nv.constants.BACKGROUND_IMAGE_POSITIONS.STRETCH:
            default:
              aspectRatioValue = 'none';
          }
          var backgroundImage = wrapMergeSelection.select('#background-image-' + id);
          backgroundImage.attr('xlink:href', backgroundImageUrl).attr('width', availableWidth + 'px').attr('height', availableHeight + 'px').attr('preserveAspectRatio', aspectRatioValue);
          var backgroundImageContainer = wrapMergeSelection.select('#background-image-rect-' + id);
          backgroundImageContainer.attr('width', availableWidth + 'px').attr('height', availableHeight + 'px').attr('fill', 'url(#background-image-pattern-' + id + ')');
        } else {
          backgroundImage = wrapMergeSelection.select('#background-image-' + id);
          backgroundImage.attr('xlink:href', '');
        }
        function updateInteractiveLayer() {
          needsUpdate = false;
          if (!interactive) {
            return false;
          }
          if (useVoronoi === true) {
            var mouseEventCallback = function mouseEventCallback(d, eventName) {
              var originalPoint = d.point,
                seriesIndex = d.seriesIndex,
                pointIndex = d.pointIndex;
              if (needsUpdate || seriesIndex === undefined || !data[seriesIndex]) {
                return;
              }
              var series = data[seriesIndex];
              var point = upgradedScatter_objectSpread(upgradedScatter_objectSpread({}, originalPoint), {}, {
                color: color(series, seriesIndex),
                x: getX(originalPoint, pointIndex),
                y: getY(originalPoint, pointIndex)
              });
              var left = x(point.x) + margin.left;
              var top = y(point.y) + margin.top;
              var box = container.node().getBoundingClientRect();
              var pos = {
                left: left + box.left + boundPad,
                top: top + box.top + boundPad
              };
              dispatch.call(eventName, this, {
                point: point,
                series: series,
                pointIndex: pointIndex,
                seriesIndex: seriesIndex,
                pos: pos,
                relativePos: [left, top]
              });
            };
            var pointLabelEventCallback = function pointLabelEventCallback(_ref, eventName) {
              var _ref2 = upgradedScatter_slicedToArray(_ref, 2),
                data = _ref2[0],
                point = _ref2[1];
              var series = data.series;
              var voronoiPoint = voronoi.find(function (_ref3) {
                var seriesIndex = _ref3.seriesIndex,
                  pointIndex = _ref3.pointIndex;
                return seriesIndex === series && pointIndex === point;
              });
              mouseEventCallback(voronoiPoint, eventName);
            };
            var voronoi = computeVoronoi(data, {
              x: x,
              y: y,
              getX: getX,
              getY: getY,
              pointActive: pointActive
            });
            if (!voronoi.length) {
              return;
            }
            wrapMergeSelection.select('.nv-point-paths').selectAll('path').remove();
            var pointPaths = wrapMergeSelection.select('.nv-point-paths').selectAll('path').data(voronoi);
            var pointLabels = wrapMergeSelection.selectAll('g.data-point-label');
            var pointPathsMergeSelection = pointPaths.enter().append('svg:path').attr('d', function (d) {
              if (!d || !d.polygonData || d.polygonData.length === 0) {
                return 'M 0 0';
              } else {
                return 'M' + d.polygonData.join(',') + 'Z';
              }
            }).attr('id', function (d, i) {
              return 'nv-path-' + i;
            }).attr('clip-path', function (d, i) {
              return 'url(#nv-clip-' + id + '-' + i + ')';
            }).merge(pointPaths);
            if (showVoronoi) {
              pointPathsMergeSelection.style('fill', color_rgb(230, 230, 230)).style('stroke-opacity', 1).style('stroke', color_rgb(200, 200, 200));
            }
            if (clipVoronoi) {
              wrapMergeSelection.select('.nv-point-clips').selectAll('*').remove();
              var pointClips = wrapMergeSelection.select('.nv-point-clips').selectAll('clipPath').data(voronoi);
              pointClips.enter().append('svg:clipPath').attr('id', function (d, i) {
                return 'nv-clip-' + id + '-' + i;
              }).append('svg:circle').attr('cx', function (d) {
                return d.x;
              }).attr('cy', function (d) {
                return d.y;
              }).attr('r', clipRadius);
            }
            var toggleHighlights = function toggleHighlights(evt, isHoverOver) {
              if (evt.dataPoint.x !== undefined) {
                container.select('.nv-groups').selectAll('.nv-point-' + evt.dataPoint.x).classed('hover', isHoverOver);
              }
            };
            wrapMergeSelection.select('.nv-groups').selectAll('.nv-point').on('keydown', function (event, d) {
              var nodes = wrapMergeSelection.select('.nv-groups').selectAll('.nv-point').nodes();
              var index = d[1];
              if (event.key === 'Enter') {
                pointLabelEventCallback(d, 'elementClick');
              }
              switch (event.key) {
                case upgradedScatter_KEYS.ARROW_DOWN:
                case upgradedScatter_KEYS.ARROW_LEFT:
                  if (index > 0 && index <= nodes.length - 1) {
                    nodes[index - 1].focus();
                  }
                  break;
                case upgradedScatter_KEYS.ARROW_UP:
                case upgradedScatter_KEYS.ARROW_RIGHT:
                  if (index >= 0 && index < nodes.length - 1) {
                    nodes[index + 1].focus();
                  }
                  break;
                default:
                  break;
              }
            }).on('focus', function (event, d) {
              return pointLabelEventCallback(d, 'elementMouseover');
            }).on('blur', function (event, d) {
              return pointLabelEventCallback(d, 'elementMouseout');
            });
            pointPathsMergeSelection.on('click', function (event, d) {
              return mouseEventCallback(d, 'elementClick');
            }).on('dblclick', function (event, d) {
              return mouseEventCallback(d, 'elementDblClick');
            }).on('mouseover', function (event, d) {
              return mouseEventCallback(d, 'elementMouseover');
            }).on('mouseout', function (event, d) {
              return mouseEventCallback(d, 'elementMouseout');
            });
            pointLabels.on('click', function (event, d) {
              return pointLabelEventCallback(d, 'elementClick');
            }).on('dblclick', function (event, d) {
              return pointLabelEventCallback(d, 'elementDblClick');
            }).on('mouseover', function (event, d) {
              return pointLabelEventCallback(d, 'elementMouseover');
            }).on('mouseout', function (event, d) {
              return pointLabelEventCallback(d, 'elementMouseout');
            });
            if (useRegionInteraction) {
              interactionDispatch.on('mouseOverRegion.highlight', function (evt) {
                return toggleHighlights(evt, true);
              });
              interactionDispatch.on('mouseOutRegion.highlight', function (evt) {
                return toggleHighlights(evt, false);
              });
              var pointsEventList = [{
                incoming: 'regionClick.point',
                outgoing: 'click'
              }, {
                incoming: 'regionDblClick.point',
                outgoing: 'dblclick'
              }];
              var dataLabelsEventList = [{
                incoming: 'regionClick.pointDataLabel',
                outgoing: 'click'
              }, {
                incoming: 'regionDblClick.pointDataLabel',
                outgoing: 'dblclick'
              }];
              var clippingElements = clipVoronoi ? wrapMergeSelection.select('.nv-point-clips').selectAll('clipPath circle').nodes() : null;
              registerSubdivisionEvents(interactionDispatch, wrapMergeSelection.select('.nv-point-paths').selectAll('path').nodes(), pointsEventList, clipVoronoi ? circleCollisionChecker : defaultCollisionChecker, clippingElements);
              registerSubdivisionEvents(interactionDispatch, wrapMergeSelection.selectAll('g.data-point-label').nodes(), dataLabelsEventList);
            }
          } else {
            wrapMergeSelection.select('.nv-groups').selectAll('.nv-group').selectAll('.nv-point').on('click', function (event, d) {
              var i = d.index;
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.call('elementClick', this, {
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i
              });
            }).on('dblclick', function (event, d) {
              var i = d.index;
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.call('elementDblClick', this, {
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i
              });
            }).on('mouseover', function (event, d) {
              var i = d.index;
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.call('elementMouseover', this, {
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i,
                color: color(d, i)
              });
            }).on('mouseout', function (event, d) {
              var i = d.index;
              if (needsUpdate || !data[d.series]) {
                return 0;
              }
              var series = data[d.series],
                point = series.values[i];
              dispatch.call('elementMouseout', this, {
                point: point,
                series: series,
                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
                seriesIndex: d.series,
                pointIndex: i,
                color: color(d, i)
              });
            });
            if (useRegionInteraction) {
              var _pointsEventList = [{
                incoming: 'regionClick.point',
                outgoing: 'click'
              }, {
                incoming: 'regionDblClick.point',
                outgoing: 'dblclick'
              }];
              registerSubdivisionEvents(interactionDispatch, wrapMergeSelection.select('.nv-point').nodes(), _pointsEventList);
            }
          }
        }
        needsUpdate = true;
        var groups = wrapMergeSelection.select('.nv-groups').selectAll('.nv-group').data(function (d) {
          return d;
        }, function (d, i) {
          return d.id || i;
        });
        var groupsMergeSelection = groups.enter().append('g').style('stroke-opacity', 1e-6).merge(groups);
        groups.exit().remove();
        groupsMergeSelection.attr('class', function (d, i) {
          return (d.classed || '') + ' nv-group nv-series-' + i;
        }).classed('hover', function (d) {
          return d.hover;
        });
        groupsMergeSelection.watchTransition(renderWatch, 'scatter: groups').style('fill', function (d, i) {
          return color(d, i);
        }).style('stroke', function (d, i) {
          return color(d, i);
        }).style('stroke-opacity', 1).style('stroke-width', function (d) {
          return (d.strokeWidth || defaultStrokeWidth) + 'px';
        });
        var points = groupsMergeSelection.selectAll('path.nv-point').data(function (d) {
          return d.values.map(function (point, pointIndex) {
            return [point, pointIndex];
          }).filter(function (pointArray, pointIndex) {
            return pointActive(pointArray[0], pointIndex);
          });
        }, function (d, i) {
          return d[0].id || i;
        });
        var patternContainers = groupsMergeSelection.append('defs');
        var getPatternContainer = function getPatternContainer(index) {
          return patternContainers.filter(function (d, containerIndex) {
            return containerIndex === index;
          }).node();
        };
        var getPointFill = function getPointFill(d) {
          var color = d[0].color;
          if (d[0].pattern) {
            return nv.utils.patternService.getDataFill(getPatternContainer(d[0].series), d[0], color);
          }
          return color;
        };
        var pointsMergeSelection = points.enter().append('path').style('fill', getPointFill).style('stroke', function (d) {
          return d.color;
        }).attr('transform', function (d) {
          return 'translate(' + nv.upgradedUtils.NaNtoZero(x0(getX(d[0], d[1]))) + ',' + nv.upgradedUtils.NaNtoZero(y0(getY(d[0], d[1]))) + ')';
        }).attr('d', nv.upgradedUtils.symbol().type(function (d) {
          return getShape(d[0]);
        }).size(function (d) {
          return z(getSize(d[0], d[1]));
        })).merge(points);
        points.exit().remove();
        groupsMergeSelection.exit().selectAll('path.nv-point').watchTransition(renderWatch, 'scatter exit').attr('transform', function (d) {
          return 'translate(' + nv.upgradedUtils.NaNtoZero(x(getX(d[0], d[1]))) + ',' + nv.upgradedUtils.NaNtoZero(y(getY(d[0], d[1]))) + ')';
        }).remove();
        pointsMergeSelection.each(function (d) {
          src_select(this).classed('nv-point', true).classed('nv-point-' + d[1], true).classed('nv-noninteractive', !interactive).classed('hover', false).classed('always-visible', function (d) {
            return !!d[0].showAlways;
          });
        });
        pointsMergeSelection.watchTransition(renderWatch, 'scatter points').attr('transform', function (d) {
          return 'translate(' + nv.upgradedUtils.NaNtoZero(x(getX(d[0], d[1]))) + ',' + nv.upgradedUtils.NaNtoZero(y(getY(d[0], d[1]))) + ')';
        }).attr('d', nv.upgradedUtils.symbol().type(function (d) {
          return getShape(d[0]);
        }).size(function (d) {
          return z(getSize(d[0], d[1]));
        })).style('fill', getPointFill);
        pointsMergeSelection.attr('tabindex', '0').attr('aria-label', function (d) {
          var ariaLabels = [];
          var seriesNum = d[0].series;
          var label = getDataValueText(d);
          var type = data[seriesNum].key;
          var xVal = xValueFormat(d[0].x);
          var yVal = yValueFormat(d[0].y);
          var sizeVal = d[0].size;
          var responsesCount = d[0].count;
          var xAxisAriaLabel = translationService.translate('DQ.XAxis', {
            xAxisValue: xVal
          });
          var yAxisAriaLabel = translationService.translate('DQ.YAxis', {
            yAxisValue: yVal
          });
          var sizeAriaLabel = sizeLabel ? sizeLabel + ' ' + sizeVal : translationService.translate('DQ.Size', {
            sizeValue: sizeVal
          });
          var labelAriaLabel = translationService.translate('DQ.Label', {
            customLabel: label
          });
          ariaLabels = [xAxisAriaLabel, yAxisAriaLabel, sizeAriaLabel];
          if (showsDataPointResponses) {
            ariaLabels.push(translationService.translate('DQ.Responses', {
              count: responsesCount
            }));
          }
          ariaLabels.push(labelAriaLabel, type);
          var ariaLabel = (ariaLabels.join(', ') + '.').toLowerCase();
          var capitalizedAriaLabel = ariaLabel.charAt(0).toUpperCase() + ariaLabel.slice(1);
          return capitalizedAriaLabel;
        }).attr('role', 'img').attr('id', function (d) {
          return d[0].label;
        });
        if (showValues) {
          groupsMergeSelection.selectAll('g.data-points').remove();
          var filterDataValueText = false;
          var dataPoints = groupsMergeSelection.selectAll('g.data-points').data(function (d) {
            if (showValues === upgradedScatter_SHOW_VALUE_OPTIONS.MIN_MAX) {
              var min;
              var max;
              for (var i = 0; i < d.values.length; i++) {
                var on = d.values[i].y;
                if (min === undefined || min[0].y >= on) {
                  min = [d.values[i], i];
                }
                if (max === undefined || max[0].y <= on) {
                  max = [d.values[i], i];
                }
              }
              filterDataValueText = true;
              if (min && max) {
                d.values[min[1]].showTextLabel = true;
                d.values[max[1]].showTextLabel = true;
              }
            } else if (showValues === upgradedScatter_SHOW_VALUE_OPTIONS.LAST) {
              filterDataValueText = true;
            }
            return d.values.map(function (point, index) {
              return [point, index];
            }).filter(function (e) {
              return e[0].y !== undefined && e[0].y !== null;
            });
          }, function (d) {
            return d[0].id || d[1];
          });
          var dataPointsMergeSelection = dataPoints.enter().append('g').merge(dataPoints);
          dataPointsMergeSelection.attr('id', function (d, i) {
            return 'label-' + d[0].series + '-' + i;
          }).attr('class', function () {
            return 'data-points data-point-label';
          }).attr('data-expectedY', function (d) {
            return nv.upgradedUtils.NaNtoZero(y(getY(d[0], d[1])));
          }).attr('data-expectedX', function (d) {
            return nv.upgradedUtils.NaNtoZero(x(getX(d[0], d[1])));
          });
          dataPointsMergeSelection.append('rect');
          dataPointsMergeSelection.append('text').attr('id', 'dataPointText').attr('text-anchor', 'middle');
          dataPointsMergeSelection.append('text').attr('id', 'dataPointSymbol').attr('text-anchor', 'middle');
          dataPoints.exit().remove();
          dataPointsMergeSelection.each(function (d) {
            var pointContainer = src_select(this),
              textContainer = pointContainer.selectAll('text').filter('#dataPointText'),
              symbolContainer = pointContainer.selectAll('text').filter('#dataPointSymbol'),
              rectContainer = pointContainer.select('rect'),
              textSize = 0,
              assumedFontSize = 12,
              symbolPadding = 1,
              maxFontSize = assumedFontSize,
              symbolSize = 0;
            textContainer.text(function () {
              if (filterDataValueText === true && d[0].showTextLabel !== true) {
                return;
              }
              return getDataValueText(d);
            });
            textSize = textContainer.node().getComputedTextLength();
            if (textSize > availableWidth) {
              textContainer.text('');
            }
            var hasText = textSize > 0;
            var customIconSettings = d[0].customIcon;
            if (customIconSettings) {
              setupDataValueIcon(symbolContainer, customIconSettings);
              maxFontSize = _.max([assumedFontSize, customIconSettings.fontSize]);
              symbolSize = symbolContainer.node().getComputedTextLength();
              if (hasText) {
                symbolContainer.attr('x', -(textSize / 2 + symbolSize / 2) - symbolPadding);
              }
            }
            var hasSymbol = symbolSize > 0;
            setupDataValueLabelBackground(hasText, hasSymbol, rectContainer, textSize, symbolSize, maxFontSize, symbolPadding);
            pointContainer.attr('width', textSize).attr('height', assumedFontSize);
            d.labelContainer = pointContainer;
          });
          dataPointsMergeSelection.attr('data-y', function (d) {
            var positioning = boundPad * 2;
            if (getValueArrangement(d) === 'top') {
              positioning = -boundPad;
            }
            return parseInt(d.labelContainer.attr('data-expectedY')) + positioning;
          }).attr('data-x', function (d) {
            return d.labelContainer.attr('data-expectedX');
          });
          if (labelPlacementFunction) {
            var unpositionedLabels = [];
            var pointSizes = new Map();
            points.each(function (series) {
              series.forEach(function (seriesPoint) {
                var _seriesPoint$getBBox$, _seriesPoint$getBBox;
                var width = (_seriesPoint$getBBox$ = seriesPoint === null || seriesPoint === void 0 ? void 0 : (_seriesPoint$getBBox = seriesPoint.getBBox) === null || _seriesPoint$getBBox === void 0 ? void 0 : _seriesPoint$getBBox.call(seriesPoint).width) !== null && _seriesPoint$getBBox$ !== void 0 ? _seriesPoint$getBBox$ : 0;
                pointSizes.set(seriesPoint.id, width);
              });
            });
            dataPointsMergeSelection.each(function (dataPoint) {
              var unpositionedLabel = {
                id: dataPoint.labelContainer,
                width: dataPoint.labelContainer.attr('width'),
                height: dataPoint.labelContainer.attr('height'),
                expectedX: dataPoint.labelContainer.attr('data-expectedX'),
                expectedY: dataPoint.labelContainer.attr('data-expectedY'),
                radius: pointSizes.get(dataPoint[0].label) / 2
              };
              if (parseInt(unpositionedLabel.width) !== 0) {
                unpositionedLabels.push(unpositionedLabel);
              }
            });
            var bounds = {
              x: -boundPad,
              y: -boundPad,
              width: availableWidth + boundPad,
              height: availableHeight + boundPad
            };
            var pointBufferRadius = 4;
            var defaultPositioningRadian = 0.5;
            if (getValueArrangement() === 'top') {
              defaultPositioningRadian = 1.5;
            }
            var positionedLabels = labelPlacementFunction(unpositionedLabels, bounds, pointBufferRadius, defaultPositioningRadian, availableWidth * 0.4);
            positionedLabels.forEach(function (label) {
              if (!label.display) {
                label.id.attr('style', 'opacity:0;');
              } else {
                label.id.attr('data-y', label.y + label.height * 0.75);
                label.id.attr('data-x', label.x + label.width / 2);
              }
            });
          }
          dataPointsMergeSelection.each(function (data) {
            data.labelContainer.attr('transform', function () {
              return 'translate(' + data.labelContainer.attr('data-x') + ',' + data.labelContainer.attr('data-y') + ')';
            });
          });
        } else {
          groupsMergeSelection.selectAll('g.data-points').remove();
        }
        if (interactiveUpdateDelay) {
          clearTimeout(timeoutID);
          timeoutID = setTimeout(updateInteractiveLayer, interactiveUpdateDelay);
        } else {
          updateInteractiveLayer();
        }
        x0 = x.copy();
        y0 = y.copy();
        z0 = z.copy();
      });
      renderWatch.renderEnd('scatter immediate');
      return chart;
    }
    chart._getDataValueText = getDataValueText;
    chart._setupDataValueIcon = setupDataValueIcon;
    chart._setupDataValueLabelBackground = setupDataValueLabelBackground;
    chart.dispatch = dispatch;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._calls = new function () {
      this.clearHighlights = function () {
        nv.dom.write(function () {
          container.selectAll('.nv-point.hover').classed('hover', false);
        });
        return null;
      };
      this.highlightPoint = function (data, isHoverOver) {
        nv.dom.write(function () {
          container.select('.nv-groups').select('g#label-' + data.seriesIndex + '-' + data.pointIndex + ' text').classed('hover', isHoverOver);
          container.select('.nv-groups').selectAll('.nv-series-' + data.seriesIndex).selectAll('.nv-point-' + data.pointIndex).classed('hover', isHoverOver);
        });
      };
    }();
    dispatch.on('elementMouseover.point', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, true);
      }
    });
    dispatch.on('elementMouseout.point', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, false);
      }
    });
    dispatch.on('elementMouseover.labelContainer', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, true);
      }
    });
    dispatch.on('elementMouseout.labelContainer', function (d) {
      if (interactive) {
        chart._calls.highlightPoint(d, false);
      }
    });
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      pointScale: {
        get: function get() {
          return z;
        },
        set: function set(_) {
          z = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      xDomainMin: {
        get: function get() {
          return xDomainMin;
        },
        set: function set(_) {
          xDomainMin = _;
        }
      },
      xDomainMax: {
        get: function get() {
          return xDomainMax;
        },
        set: function set(_) {
          xDomainMax = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      yDomainMin: {
        get: function get() {
          return yDomainMin;
        },
        set: function set(_) {
          yDomainMin = _;
        }
      },
      yDomainMax: {
        get: function get() {
          return yDomainMax;
        },
        set: function set(_) {
          yDomainMax = _;
        }
      },
      pointDomain: {
        get: function get() {
          return sizeDomain;
        },
        set: function set(_) {
          sizeDomain = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      pointRange: {
        get: function get() {
          return sizeRange;
        },
        set: function set(_) {
          sizeRange = _;
        }
      },
      forceX: {
        get: function get() {
          return forceX;
        },
        set: function set(_) {
          forceX = _;
        }
      },
      forceY: {
        get: function get() {
          return forceY;
        },
        set: function set(_) {
          forceY = _;
        }
      },
      forcePoint: {
        get: function get() {
          return forceSize;
        },
        set: function set(_) {
          forceSize = _;
        }
      },
      interactive: {
        get: function get() {
          return interactive;
        },
        set: function set(_) {
          interactive = _;
        }
      },
      pointActive: {
        get: function get() {
          return pointActive;
        },
        set: function set(_) {
          pointActive = _;
        }
      },
      padDataOuter: {
        get: function get() {
          return padDataOuter;
        },
        set: function set(_) {
          padDataOuter = _;
        }
      },
      padData: {
        get: function get() {
          return padData;
        },
        set: function set(_) {
          padData = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      clipVoronoi: {
        get: function get() {
          return clipVoronoi;
        },
        set: function set(_) {
          clipVoronoi = _;
        }
      },
      clipRadius: {
        get: function get() {
          return clipRadius;
        },
        set: function set(_) {
          clipRadius = _;
        }
      },
      showVoronoi: {
        get: function get() {
          return showVoronoi;
        },
        set: function set(_) {
          showVoronoi = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      interactiveUpdateDelay: {
        get: function get() {
          return interactiveUpdateDelay;
        },
        set: function set(_) {
          interactiveUpdateDelay = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      showValuesType: {
        get: function get() {
          return showValuesType;
        },
        set: function set(_) {
          showValuesType = _;
        }
      },
      labelPlacementFunction: {
        get: function get() {
          return labelPlacementFunction;
        },
        set: function set(_) {
          labelPlacementFunction = _;
        }
      },
      showOnlyYValues: {
        get: function get() {
          return showOnlyYValues;
        },
        set: function set(_) {
          showOnlyYValues = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      padY: {
        get: function get() {
          return padY;
        },
        set: function set(_) {
          padY = _;
        }
      },
      padYBy: {
        get: function get() {
          return padYBy;
        },
        set: function set(_) {
          padYBy = _;
        }
      },
      backgroundImageUrl: {
        get: function get() {
          return backgroundImageUrl;
        },
        set: function set(_) {
          backgroundImageUrl = _;
        }
      },
      backgroundImagePosition: {
        get: function get() {
          return backgroundImagePosition;
        },
        set: function set(_) {
          backgroundImagePosition = _;
        }
      },
      xAxisLabel: {
        get: function get() {
          return xAxisLabel;
        },
        set: function set(_) {
          xAxisLabel = _;
        }
      },
      yAxisLabel: {
        get: function get() {
          return yAxisLabel;
        },
        set: function set(_) {
          yAxisLabel = _;
        }
      },
      sizeLabel: {
        get: function get() {
          return sizeLabel;
        },
        set: function set(_) {
          sizeLabel = _;
        }
      },
      xValueFormat: {
        get: function get() {
          return xValueFormat;
        },
        set: function set(_) {
          xValueFormat = _;
        }
      },
      yValueFormat: {
        get: function get() {
          return yValueFormat;
        },
        set: function set(_) {
          yValueFormat = _;
        }
      },
      isNumberOfResponsesShownInTooltip: {
        get: function get() {
          return showsDataPointResponses;
        },
        set: function set(_) {
          showsDataPointResponses = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = nv.upgradedUtils.functor(_);
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = nv.upgradedUtils.functor(_);
        }
      },
      pointSize: {
        get: function get() {
          return getSize;
        },
        set: function set(_) {
          getSize = nv.upgradedUtils.functor(_);
        }
      },
      pointShape: {
        get: function get() {
          return getShape;
        },
        set: function set(_) {
          getShape = nv.upgradedUtils.functor(_);
        }
      },
      valueArrangement: {
        get: function get() {
          return getValueArrangement;
        },
        set: function set(_) {
          getValueArrangement = nv.upgradedUtils.functor(_);
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      interactionDispatch: {
        get: function get() {
          return interactionDispatch;
        },
        set: function set(_) {
          interactionDispatch = _;
        }
      },
      enableAutoAxisScaling: {
        get: function get() {
          return enableAutoAxisScaling;
        },
        set: function set(_) {
          enableAutoAxisScaling = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
        }
      },
      useVoronoi: {
        get: function get() {
          return useVoronoi;
        },
        set: function set(_) {
          useVoronoi = _;
          if (useVoronoi === false) {
            clipVoronoi = false;
          }
        }
      }
    });
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
function upgradedScatter_getYDomain(series, forceY, isNum, yMin, yMax, dataPointSize) {
  var yValues = d3.merge(series).map(function (value) {
    return Number(value.y);
  }).concat(forceY);
  var domainPaddingRatio = 0;
  switch (dataPointSize) {
    case upgradedScatter_SMALL_DATA_POINT_SIZE:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_SMALL_DATA_POINT;
      break;
    case upgradedScatter_MEDIUM_DATA_POINT_SIZE:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT;
      break;
    case upgradedScatter_LARGE_DATA_POINT_SIZE:
    default:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_LARGE_DATA_POINT;
  }
  var yDomain = d3.extent(yValues);
  var range = yDomain[1] - yDomain[0];
  yDomain[0] -= range * domainPaddingRatio;
  yDomain[1] += range * domainPaddingRatio;
  if (isNum(yMin)) {
    yDomain[0] = parseFloat(yMin);
    if (!isNum(yMax) && yDomain[1] <= yDomain[0]) {
      yDomain[1] = yDomain[0] + upgradedScatter_MINIMUM_DOMAIN_SEPARATION;
    }
  }
  if (isNum(yMax)) {
    yDomain[1] = parseFloat(yMax);
    if (!isNum(yMin) && yDomain[1] <= yDomain[0]) {
      yDomain[0] = yDomain[1] - upgradedScatter_MINIMUM_DOMAIN_SEPARATION;
    }
  }
  return yDomain;
}
function upgradedScatter_getXDomain(series, forceX, isNum, xMin, xMax, dataPointSize) {
  var xValues = d3.merge(series).map(function (value) {
    return Number(value.x);
  }).concat(forceX);
  var domainPaddingRatio = 0;
  switch (dataPointSize) {
    case upgradedScatter_SMALL_DATA_POINT_SIZE:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_SMALL_DATA_POINT;
      break;
    case upgradedScatter_MEDIUM_DATA_POINT_SIZE:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_MEDIUM_DATA_POINT;
      break;
    case upgradedScatter_LARGE_DATA_POINT_SIZE:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_LARGE_DATA_POINT;
      break;
    default:
      domainPaddingRatio = upgradedScatter_DOMAIN_PADDING_RATIO_LARGE_DATA_POINT;
  }
  var xDomain = d3.extent(xValues);
  var range = xDomain[1] - xDomain[0];
  xDomain[0] -= range * domainPaddingRatio;
  xDomain[1] += range * domainPaddingRatio;
  if (isNum(xMin)) {
    xDomain[0] = parseFloat(xMin);
    if (!isNum(xMax) && xDomain[1] <= xDomain[0]) {
      xDomain[1] = xDomain[0] + upgradedScatter_MINIMUM_DOMAIN_SEPARATION;
    }
  }
  if (isNum(xMax)) {
    xDomain[1] = parseFloat(xMax);
    if (!isNum(xMin) && xDomain[1] <= xDomain[0]) {
      xDomain[0] = xDomain[1] - upgradedScatter_MINIMUM_DOMAIN_SEPARATION;
    }
  }
  return xDomain;
}
;// ./src/js/nv/models/scatterChart.js


var SECTION_LABEL_VERTICAL_PADDING = 3;
var SECTION_LABEL_HORIZONTAL_PADDING = 4;
var TOTAL_HORIZONTAL_PADDING_MULTIPLIER = 2;
var TOTAL_VERTICAL_PADDING_MULTIPLIER = 2;
var SECTION_TYPES = {
  TOP_BOTTOM: 'top-bottom',
  LEFT_RIGHT: 'left-right',
  QUADRANTS: 'quadrants',
  NONE: 'none'
};
var SECTION_LABEL_LOCATIONS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left'
};
var SECTION_LABEL = 'Section';
var QUADRANT_LABEL = 'Quadrant';
var AXIS_LABEL_PADDING = 10;
var BORDER_RADIUS = 2;
var LABEL_LOCATIONS = {
  TOP: 'top'
};
var scatterChart = function scatterChart(nv) {
  nv.models.scatterChart = function () {
    var scatter = nv.models.scatter(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      distX = nv.models.distribution(),
      distY = nv.models.distribution(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 20,
        bottom: 50,
        left: 75
      },
      width = null,
      height = null,
      container = null,
      color = nv.utils.defaultColor(),
      x = scatter.xScale(),
      y = scatter.yScale(),
      showDistX = false,
      showDistY = false,
      showHorizontalGrid = false,
      showVerticalGrid = false,
      showGridLineBorders = true,
      showSectionLabels = false,
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      useSubtleGrid = false,
      enableOutlineBubbleStyle = false,
      rightAlignYAxis = false,
      state = nv.utils.state(),
      defaultState = null,
      valueLabelLocation = null,
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd', 'elementClick'),
      noData = null,
      duration = 250,
      wrapLabels = null,
      referenceLines = [],
      sectionLabels = [],
      sectionType = 'none',
      leftPadding = 24,
      maxLines = 2;
    scatter.xScale(x).yScale(y);
    xAxis.showMaxMin(false).orient('bottom').tickPadding(14);
    yAxis.showMaxMin(false).orient(rightAlignYAxis ? 'right' : 'left');
    distX.axis('x');
    distY.axis('y');
    tooltip.headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    }).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    });
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          })
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    var validateIsFinite = function validateIsFinite(obj) {
      return isFinite && isFinite(obj) && !isNaN(parseFloat(obj));
    };
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(scatter);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      if (showDistX) {
        renderWatch.models(distX);
      }
      if (showDistY) {
        renderWatch.models(distY);
      }
      selection.each(function (data) {
        var _sectionLabels$, _sectionLabels$2, _sectionLabels$3, _sectionLabels$4, _sectionLabels$5, _sectionLabels$6, _sectionLabels$7, _sectionLabels$8;
        container = d3.select(this);
        nv.utils.initSVG(container);
        if (validateIsFinite(wrapLabels) && margin.left > wrapLabels) {
          margin.left = wrapLabels;
        }
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          renderWatch.renderEnd('scatter immediate');
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = scatter.xScale();
        y = scatter.yScale();
        var subtleGridClass = useSubtleGrid ? 'subtle-grid' : '';
        var wrap = container.selectAll('g.nv-wrap.nv-scatterChart').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', "nvd3 nv-wrap nv-scatterChart nv-chart-".concat(scatter.id(), " ").concat(subtleGridClass));
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        var scatterChartContainer = wrap.select('.nv-scatterChart g');
        gEnter.append('rect').attr('class', 'nvd3 nv-background').style('pointer-events', 'none');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis');
        gEnter.append('g').attr('class', 'nv-scatterWrap');
        gEnter.append('g').attr('class', 'nv-regressionLinesWrap');
        gEnter.append('g').attr('class', 'nv-distWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        if (showLegend) {
          var legendWidth = availableWidth;
          legend.width(legendWidth);
          wrap.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          wrap.select('.nv-legendWrap').attr('transform', 'translate(0' + ',' + -margin.top + ')');
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        scatter.width(availableWidth).height(availableHeight).duration(duration).color(data.map(function (d, i) {
          d.color = d.color || color(d, i);
          return d.color;
        }).filter(function (d, i) {
          return !data[i].disabled;
        }));
        if (valueLabelLocation === LABEL_LOCATIONS.TOP) {
          scatter.valueArrangement('top');
          scatter.labelPlacementFunction(false);
        }
        wrap.select('.nv-scatterWrap').datum(data.filter(function (d) {
          return !d.disabled;
        })).call(scatter);
        if (valueLabelLocation === LABEL_LOCATIONS.TOP) {
          d3.selectAll('#dataPointText').classed('outline-text', true);
        }
        wrap.select('.nv-regressionLinesWrap').attr('clip-path', 'url(#nv-edge-clip-' + scatter.id() + ')');
        var regWrap = wrap.select('.nv-regressionLinesWrap').selectAll('.nv-regLines').data(function (d) {
          return d;
        }, function (d, i) {
          return d.id || d.key || i;
        });
        regWrap.enter().append('g').attr('class', 'nv-regLines');
        var regLine = regWrap.selectAll('.nv-regLine').data(function (d) {
          return [d];
        });
        var uncampledYScale = y.copy();
        uncampledYScale.clamp(false);
        regLine.enter().append('line').attr('class', 'nv-regLine').style('stroke-opacity', 0);
        regLine.filter(function (d) {
          return d.slope !== undefined && d.intercept !== undefined;
        }).watchTransition(renderWatch, 'scatterPlusLineChart: regline').attr('x1', x.range()[0]).attr('x2', x.range()[1]).attr('y1', function (d) {
          return uncampledYScale(x.domain()[0] * d.slope + d.intercept);
        }).attr('y2', function (d) {
          return uncampledYScale(x.domain()[1] * d.slope + d.intercept);
        }).style('stroke', function (d, i, j) {
          return color(d, j);
        }).style('stroke-opacity', function (d) {
          return d.disabled || typeof d.slope === 'undefined' || typeof d.intercept === 'undefined' ? 0 : 1;
        });
        regWrap.exit().remove();
        if (enableOutlineBubbleStyle) {
          wrap.select('.nv-scatter').classed('bubble', true);
          wrap.select('.nv-groups').classed('bubble', true);
        }
        if (showXAxis) {
          xAxis.height(margin.bottom - 3).scale(x)._ticks(Math.floor(availableWidth / 100)).tickSize(0).duration(duration);
          if (showVerticalGrid) {
            xAxis.tickSize(-availableHeight, 0);
          }
          if (showVerticalGrid) {
            xAxis.tickSize(-availableHeight, 0);
          }
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')').call(xAxis);
          if (useSubtleGrid) {
            g.select('.nv-x.nv-axis .domain').remove();
          }
          g.selectAll('.nv-x.nv-axis text.nv-axislabel').call(nv.utils.truncateText, availableWidth);
          if (!showGridLineBorders) {
            var xAxisTicks = scatterChartContainer.select('.nv-x .nv-axis').selectAll('.tick');
            xAxisTicks.filter(":nth-child(".concat(xAxisTicks.size(), ")")).select('line').style('stroke-opacity', 0);
            xAxisTicks.filter(":nth-child(".concat(1, ")")).select('line').style('stroke-opacity', 0);
          }
        } else {
          g.select('.nv-x.nv-axis').selectAll('*').remove();
        }
        if (showYAxis) {
          if (!useSubtleGrid) {
            yAxis.tickPadding(14);
          }
          yAxis.width(rightAlignYAxis ? margin.right : margin.left).scale(y)._ticks(Math.floor(availableHeight / 36)).tickSize(0, 0).duration(duration);
          if (showHorizontalGrid) {
            yAxis.tickSize(-availableWidth, 0);
          }
          g.select('.nv-y.nv-axis').call(yAxis);
          if (useSubtleGrid) {
            g.select('.nv-y.nv-axis .domain').remove();
          }
          if (validateIsFinite(wrapLabels)) {
            g.selectAll('.nv-y.nv-axis .tick text').call(nv.utils.wrapTicks, wrapLabels - leftPadding, maxLines);
          }
          g.selectAll('.nv-y.nv-axis text.nv-axislabel').call(nv.utils.truncateText, availableHeight);
          if (!showGridLineBorders) {
            var yAxisTicks = scatterChartContainer.select('.nv-y .nv-axis').selectAll('.tick');
            yAxisTicks.filter(":nth-child(".concat(yAxisTicks.size(), ")")).select('line').style('stroke-opacity', 0);
            yAxisTicks.filter(":nth-child(".concat(1, ")")).select('line').style('stroke-opacity', 0);
          }
        } else {
          g.select('.nv-y.nv-axis').selectAll('*').remove();
        }
        scatterChartContainer.selectAll('.nv-sectionLabels').remove();
        if (showSectionLabels) {
          scatterChartContainer.append('g').attr('class', 'nv-sectionLabels');
          var maxTextWidth = 0;
          g.selectAll('.nv-y.nv-axis .tick text').each(function () {
            if (this.getBBox().width > maxTextWidth) {
              maxTextWidth = this.getBBox().width;
            }
          });
          var sectionLabelsContainer = scatterChartContainer.select('.nv-sectionLabels');
          switch (sectionType) {
            case SECTION_TYPES.QUADRANTS:
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$ = sectionLabels[0]) !== null && _sectionLabels$ !== void 0 ? _sectionLabels$ : "".concat(QUADRANT_LABEL, " 1"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.TOP_RIGHT, nv.utils.truncateText);
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$2 = sectionLabels[1]) !== null && _sectionLabels$2 !== void 0 ? _sectionLabels$2 : "".concat(QUADRANT_LABEL, " 2"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.TOP_LEFT, nv.utils.truncateText);
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$3 = sectionLabels[2]) !== null && _sectionLabels$3 !== void 0 ? _sectionLabels$3 : "".concat(QUADRANT_LABEL, " 3"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.BOTTOM_LEFT, nv.utils.truncateText);
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$4 = sectionLabels[3]) !== null && _sectionLabels$4 !== void 0 ? _sectionLabels$4 : "".concat(QUADRANT_LABEL, " 4"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.BOTTOM_RIGHT, nv.utils.truncateText);
              break;
            case SECTION_TYPES.LEFT_RIGHT:
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$5 = sectionLabels[0]) !== null && _sectionLabels$5 !== void 0 ? _sectionLabels$5 : "".concat(SECTION_LABEL, " 1"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.TOP_LEFT, nv.utils.truncateText);
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$6 = sectionLabels[1]) !== null && _sectionLabels$6 !== void 0 ? _sectionLabels$6 : "".concat(SECTION_LABEL, " 2"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.TOP_RIGHT, nv.utils.truncateText);
              break;
            case SECTION_TYPES.TOP_BOTTOM:
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$7 = sectionLabels[0]) !== null && _sectionLabels$7 !== void 0 ? _sectionLabels$7 : "".concat(SECTION_LABEL, " 1"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.TOP_RIGHT, nv.utils.truncateText);
              createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$8 = sectionLabels[1]) !== null && _sectionLabels$8 !== void 0 ? _sectionLabels$8 : "".concat(SECTION_LABEL, " 2"), scatter.height(), scatter.width(), SECTION_LABEL_LOCATIONS.BOTTOM_RIGHT, nv.utils.truncateText);
              break;
          }
        }
        if (showDistX) {
          distX.getData(scatter.x()).scale(x).width(availableWidth).color(data.map(function (d, i) {
            return d.color || color(d, i);
          }).filter(function (d, i) {
            return !data[i].disabled;
          }));
          gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionX');
          g.select('.nv-distributionX').attr('transform', 'translate(0,' + y.range()[0] + ')').datum(data.filter(function (d) {
            return !d.disabled;
          })).call(distX);
        }
        if (showDistY) {
          distY.getData(scatter.y()).scale(y).width(availableHeight).color(data.map(function (d, i) {
            return d.color || color(d, i);
          }).filter(function (d, i) {
            return !data[i].disabled;
          }));
          gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionY');
          g.select('.nv-distributionY').attr('transform', 'translate(' + (rightAlignYAxis ? availableWidth : -distY.size()) + ',0)').datum(data.filter(function (d) {
            return !d.disabled;
          })).call(distY);
        }
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          chart.update();
        });
        var indexCache = {
          seriesIndex: null,
          pointIndex: null
        };
        function mouseOutReaction(evt) {
          if (evt) {
            indexCache.seriesIndex = evt.seriesIndex;
            indexCache.pointIndex = evt.pointIndex;
          }
          tooltip.hidden(true);
          container.select('.nv-chart-' + scatter.id() + ' .nv-series-' + indexCache.seriesIndex + ' .nv-distx-' + indexCache.pointIndex).attr('y1', 0);
          container.select('.nv-chart-' + scatter.id() + ' .nv-series-' + indexCache.seriesIndex + ' .nv-disty-' + indexCache.pointIndex).attr('x2', distY.size());
        }
        function mouseOverReaction(evt) {
          var overlappingDataPoints = getOverlappingDataPoints(evt.point.id);
          evt.overlappingDataPoints = overlappingDataPoints;
          container.select('.nv-series-' + evt.seriesIndex + ' .nv-distx-' + evt.pointIndex).attr('y1', evt.relativePos[1] - availableHeight);
          container.select('.nv-series-' + evt.seriesIndex + ' .nv-disty-' + evt.pointIndex).attr('x2', evt.relativePos[0] + distX.size());
          tooltip.data(evt).position(function () {
            return evt.pos;
          }).hidden(false);
          indexCache.seriesIndex = evt.seriesIndex;
          indexCache.pointIndex = evt.pointIndex;
        }
        function onTouchStart() {
          if (!tooltip.hidden()) {
            mouseOutReaction();
          }
        }
        scatter.dispatch.on('elementMouseout.tooltip', mouseOutReaction);
        scatter.dispatch.on('elementMouseover.tooltip', mouseOverReaction);
        d3.select(document.body).on('touchstart', onTouchStart);
        scatter.dispatch.on('elementClick', chart.dispatch.elementClick);
      });
      renderWatch.renderEnd('scatter with line immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.scatter = scatter;
    chart.legend = legend;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.distX = distX;
    chart.distY = distY;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      container: {
        get: function get() {
          return container;
        },
        set: function set(_) {
          container = _;
        }
      },
      showDistX: {
        get: function get() {
          return showDistX;
        },
        set: function set(_) {
          showDistX = _;
        }
      },
      showDistY: {
        get: function get() {
          return showDistY;
        },
        set: function set(_) {
          showDistY = _;
        }
      },
      showVerticalGrid: {
        get: function get() {
          return showVerticalGrid;
        },
        set: function set(_) {
          showVerticalGrid = _;
        }
      },
      showHorizontalGrid: {
        get: function get() {
          return showHorizontalGrid;
        },
        set: function set(_) {
          showHorizontalGrid = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      useSubtleGrid: {
        get: function get() {
          return useSubtleGrid;
        },
        set: function set(_) {
          useSubtleGrid = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = _;
        }
      },
      enableOutlineBubbleStyle: {
        get: function get() {
          return enableOutlineBubbleStyle;
        },
        set: function set(_) {
          enableOutlineBubbleStyle = _;
        }
      },
      showGridLineBorders: {
        get: function get() {
          return showGridLineBorders;
        },
        set: function set(_) {
          showGridLineBorders = _;
        }
      },
      showSectionLabels: {
        get: function get() {
          return showSectionLabels;
        },
        set: function set(_) {
          showSectionLabels = _;
        }
      },
      referenceLines: {
        get: function get() {
          return referenceLines;
        },
        set: function set(_) {
          referenceLines = _;
        }
      },
      sectionLabels: {
        get: function get() {
          return sectionLabels;
        },
        set: function set(_) {
          sectionLabels = _;
        }
      },
      sectionType: {
        get: function get() {
          return sectionType;
        },
        set: function set(_) {
          sectionType = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(_ ? 'right' : 'left');
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          legend.color(color);
          distX.color(color);
          distY.color(color);
        }
      },
      labelLocation: {
        get: function get() {
          return valueLabelLocation;
        },
        set: function set(_) {
          valueLabelLocation = _;
        }
      }
    });
    nv.utils.inheritOptions(chart, scatter);
    nv.utils.initOptions(chart);
    return chart;
  };
};
function createSectionLabel(sectionLabelContainer, maxTextWidth, title, height, width, location, truncateFunction) {
  var quadrant = sectionLabelContainer.append('g');
  var sectionLabelBackground = quadrant.append('rect').attr('class', 'nv-sectionLabel').attr('rx', BORDER_RADIUS).attr('ry', BORDER_RADIUS);
  var sectionLabel = quadrant.append('text').text(title).call(truncateFunction, width / 4);
  var sectionLabelWidth = sectionLabel.node().getBBox().width + SECTION_LABEL_HORIZONTAL_PADDING * TOTAL_HORIZONTAL_PADDING_MULTIPLIER;
  var sectionLabelHeight = sectionLabel.node().getBBox().height + SECTION_LABEL_VERTICAL_PADDING * TOTAL_VERTICAL_PADDING_MULTIPLIER;
  var transformX, transformY;
  switch (location) {
    case SECTION_LABEL_LOCATIONS.TOP_RIGHT:
      transformX = width - sectionLabelWidth + SECTION_LABEL_HORIZONTAL_PADDING;
      transformY = sectionLabelHeight - SECTION_LABEL_VERTICAL_PADDING * TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
    case SECTION_LABEL_LOCATIONS.TOP_LEFT:
      transformX = maxTextWidth + SECTION_LABEL_VERTICAL_PADDING + AXIS_LABEL_PADDING;
      transformY = sectionLabelHeight - SECTION_LABEL_VERTICAL_PADDING * TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
    case SECTION_LABEL_LOCATIONS.BOTTOM_RIGHT:
      transformX = width - sectionLabelWidth + SECTION_LABEL_HORIZONTAL_PADDING;
      transformY = height - SECTION_LABEL_VERTICAL_PADDING * TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
    case SECTION_LABEL_LOCATIONS.BOTTOM_LEFT:
      transformX = maxTextWidth + SECTION_LABEL_VERTICAL_PADDING + AXIS_LABEL_PADDING;
      transformY = height - SECTION_LABEL_VERTICAL_PADDING * TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
  }
  quadrant.style('transform', "translate(".concat(transformX, "px, ").concat(transformY, "px)"));
  sectionLabelBackground.attr('height', sectionLabelHeight).attr('width', sectionLabelWidth).style('transform', "translate(-".concat(SECTION_LABEL_HORIZONTAL_PADDING, "px, -").concat(sectionLabelHeight - SECTION_LABEL_VERTICAL_PADDING * TOTAL_VERTICAL_PADDING_MULTIPLIER, "px)"));
}
function getOverlappingDataPoints(dataPointId) {
  var dataPoints = d3.selectAll('.nv-point').filter(function (dataPoint) {
    return dataPoint[0].id !== dataPointId;
  });
  var hoveredDataPoint = d3.select('.nv-point.hover');
  var hoveredDataPointRadius = hoveredDataPoint.node().getBoundingClientRect().width / 2;
  var overlappingDataPoints = [hoveredDataPoint.data()[0]];
  dataPoints.each(function (dataPoint) {
    var dataPointElement = d3.select(this);
    var dataPointRadius = dataPointElement.node().getBoundingClientRect().width / 2;
    var dx = hoveredDataPoint.node().getBoundingClientRect().x - dataPointElement.node().getBoundingClientRect().x;
    var dy = hoveredDataPoint.node().getBoundingClientRect().y - dataPointElement.node().getBoundingClientRect().y;
    var distance = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
    if (distance <= hoveredDataPointRadius + dataPointRadius) {
      overlappingDataPoints.push(dataPoint);
    }
  });
  return overlappingDataPoints;
}
;// ./src/js/nv/models/upgradedScatterChart.js


var upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING = 3;
var upgradedScatterChart_SECTION_LABEL_HORIZONTAL_PADDING = 4;
var upgradedScatterChart_TOTAL_HORIZONTAL_PADDING_MULTIPLIER = 2;
var upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER = 2;
var upgradedScatterChart_SECTION_TYPES = {
  TOP_BOTTOM: 'top-bottom',
  LEFT_RIGHT: 'left-right',
  QUADRANTS: 'quadrants',
  NONE: 'none'
};
var upgradedScatterChart_SECTION_LABEL_LOCATIONS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left'
};
var upgradedScatterChart_SECTION_LABEL = 'Section';
var upgradedScatterChart_QUADRANT_LABEL = 'Quadrant';
var upgradedScatterChart_AXIS_LABEL_PADDING = 10;
var upgradedScatterChart_BORDER_RADIUS = 2;
var upgradedScatterChart_LABEL_LOCATIONS = {
  TOP: 'top'
};
var upgradedScatterChart = function upgradedScatterChart(nv) {
  nv.models.upgradedScatterChart = function () {
    var scatter = nv.models.upgradedScatter(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      distX = nv.models.distribution(),
      distY = nv.models.distribution(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 20,
        bottom: 50,
        left: 75
      },
      width = null,
      height = null,
      container = null,
      color = nv.utils.defaultColor(),
      x = scatter.xScale(),
      y = scatter.yScale(),
      showDistX = false,
      showDistY = false,
      showHorizontalGrid = false,
      showVerticalGrid = false,
      showGridLineBorders = true,
      showSectionLabels = false,
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      useSubtleGrid = false,
      enableOutlineBubbleStyle = false,
      rightAlignYAxis = false,
      state = nv.utils.state(),
      defaultState = null,
      valueLabelLocation = null,
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd', 'elementClick'),
      noData = null,
      duration = 250,
      wrapLabels = null,
      referenceLines = [],
      sectionLabels = [],
      sectionType = 'none',
      leftPadding = 24,
      maxLines = 2;
    scatter.xScale(x).yScale(y);
    xAxis.showMaxMin(false).orient('bottom').tickPadding(14);
    yAxis.showMaxMin(false).orient(rightAlignYAxis ? 'right' : 'left');
    distX.axis('x');
    distY.axis('y');
    tooltip.headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    }).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    });
    var renderWatch = nv.utils.renderWatch(dispatch, duration);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          })
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    var validateIsFinite = function validateIsFinite(obj) {
      return isFinite && isFinite(obj) && !isNaN(parseFloat(obj));
    };
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(scatter);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      if (showDistX) {
        renderWatch.models(distX);
      }
      if (showDistY) {
        renderWatch.models(distY);
      }
      selection.each(function (data) {
        var _sectionLabels$, _sectionLabels$2, _sectionLabels$3, _sectionLabels$4, _sectionLabels$5, _sectionLabels$6, _sectionLabels$7, _sectionLabels$8;
        container = d3.select(this);
        nv.utils.initSVG(container);
        if (validateIsFinite(wrapLabels) && margin.left > wrapLabels) {
          margin.left = wrapLabels;
        }
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          renderWatch.renderEnd('scatter immediate');
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = scatter.xScale();
        y = scatter.yScale();
        var subtleGridClass = useSubtleGrid ? 'subtle-grid' : '';
        var wrap = container.selectAll('g.nv-wrap.nv-scatterChart').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', "nvd3 nv-wrap nv-scatterChart nv-chart-".concat(scatter.id(), " ").concat(subtleGridClass));
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        var scatterChartContainer = wrap.select('.nv-scatterChart g');
        gEnter.append('rect').attr('class', 'nvd3 nv-background').style('pointer-events', 'none');
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis');
        gEnter.append('g').attr('class', 'nv-scatterWrap');
        gEnter.append('g').attr('class', 'nv-regressionLinesWrap');
        gEnter.append('g').attr('class', 'nv-distWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        if (showLegend) {
          var legendWidth = availableWidth;
          legend.width(legendWidth);
          wrap.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          wrap.select('.nv-legendWrap').attr('transform', 'translate(0' + ',' + -margin.top + ')');
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        scatter.width(availableWidth).height(availableHeight).duration(duration).color(data.map(function (d, i) {
          d.color = d.color || color(d, i);
          return d.color;
        }).filter(function (d, i) {
          return !data[i].disabled;
        }));
        if (valueLabelLocation === upgradedScatterChart_LABEL_LOCATIONS.TOP) {
          scatter.valueArrangement('top');
          scatter.labelPlacementFunction(false);
        }
        wrap.select('.nv-scatterWrap').datum(data.filter(function (d) {
          return !d.disabled;
        })).call(scatter);
        if (valueLabelLocation === upgradedScatterChart_LABEL_LOCATIONS.TOP) {
          d3.selectAll('#dataPointText').classed('outline-text', true);
        }
        wrap.select('.nv-regressionLinesWrap').attr('clip-path', 'url(#nv-edge-clip-' + scatter.id() + ')');
        var regWrap = wrap.select('.nv-regressionLinesWrap').selectAll('.nv-regLines').data(function (d) {
          return d;
        }, function (d, i) {
          return d.id || d.key || i;
        });
        regWrap.enter().append('g').attr('class', 'nv-regLines');
        var regLine = regWrap.selectAll('.nv-regLine').data(function (d) {
          return [d];
        });
        var uncampledYScale = y.copy();
        uncampledYScale.clamp(false);
        regLine.enter().append('line').attr('class', 'nv-regLine').style('stroke-opacity', 0);
        regLine.filter(function (d) {
          return d.slope !== undefined && d.intercept !== undefined;
        }).watchTransition(renderWatch, 'scatterPlusLineChart: regline').attr('x1', x.range()[0]).attr('x2', x.range()[1]).attr('y1', function (d) {
          return uncampledYScale(x.domain()[0] * d.slope + d.intercept);
        }).attr('y2', function (d) {
          return uncampledYScale(x.domain()[1] * d.slope + d.intercept);
        }).style('stroke', function (d, i, j) {
          return color(d, j);
        }).style('stroke-opacity', function (d) {
          return d.disabled || typeof d.slope === 'undefined' || typeof d.intercept === 'undefined' ? 0 : 1;
        });
        regWrap.exit().remove();
        if (enableOutlineBubbleStyle) {
          wrap.select('.nv-scatter').classed('bubble', true);
          wrap.select('.nv-groups').classed('bubble', true);
        }
        if (showXAxis) {
          xAxis.height(margin.bottom - 3).scale(x)._ticks(Math.floor(availableWidth / 100)).tickSize(0).duration(duration);
          if (showVerticalGrid) {
            xAxis.tickSize(-availableHeight, 0);
          }
          if (showVerticalGrid) {
            xAxis.tickSize(-availableHeight, 0);
          }
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')').call(xAxis);
          if (useSubtleGrid) {
            g.select('.nv-x.nv-axis .domain').remove();
          }
          g.selectAll('.nv-x.nv-axis text.nv-axislabel').call(nv.utils.truncateText, availableWidth);
          if (!showGridLineBorders) {
            var xAxisTicks = scatterChartContainer.select('.nv-x .nv-axis').selectAll('.tick');
            xAxisTicks.filter(":nth-child(".concat(xAxisTicks.size(), ")")).select('line').style('stroke-opacity', 0);
            xAxisTicks.filter(":nth-child(".concat(1, ")")).select('line').style('stroke-opacity', 0);
          }
        } else {
          g.select('.nv-x.nv-axis').selectAll('*').remove();
        }
        if (showYAxis) {
          if (!useSubtleGrid) {
            yAxis.tickPadding(14);
          }
          yAxis.width(rightAlignYAxis ? margin.right : margin.left).scale(y)._ticks(Math.floor(availableHeight / 36)).tickSize(0, 0).duration(duration);
          if (showHorizontalGrid) {
            yAxis.tickSize(-availableWidth, 0);
          }
          g.select('.nv-y.nv-axis').call(yAxis);
          if (useSubtleGrid) {
            g.select('.nv-y.nv-axis .domain').remove();
          }
          if (validateIsFinite(wrapLabels)) {
            g.selectAll('.nv-y.nv-axis .tick text').call(nv.utils.wrapTicks, wrapLabels - leftPadding, maxLines);
          }
          g.selectAll('.nv-y.nv-axis text.nv-axislabel').call(nv.utils.truncateText, availableHeight);
          if (!showGridLineBorders) {
            var yAxisTicks = scatterChartContainer.select('.nv-y .nv-axis').selectAll('.tick');
            yAxisTicks.filter(":nth-child(".concat(yAxisTicks.size(), ")")).select('line').style('stroke-opacity', 0);
            yAxisTicks.filter(":nth-child(".concat(1, ")")).select('line').style('stroke-opacity', 0);
          }
        } else {
          g.select('.nv-y.nv-axis').selectAll('*').remove();
        }
        scatterChartContainer.selectAll('.nv-sectionLabels').remove();
        if (showSectionLabels) {
          scatterChartContainer.append('g').attr('class', 'nv-sectionLabels');
          var maxTextWidth = 0;
          g.selectAll('.nv-y.nv-axis .tick text').each(function () {
            if (this.getBBox().width > maxTextWidth) {
              maxTextWidth = this.getBBox().width;
            }
          });
          var sectionLabelsContainer = scatterChartContainer.select('.nv-sectionLabels');
          switch (sectionType) {
            case upgradedScatterChart_SECTION_TYPES.QUADRANTS:
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$ = sectionLabels[0]) !== null && _sectionLabels$ !== void 0 ? _sectionLabels$ : "".concat(upgradedScatterChart_QUADRANT_LABEL, " 1"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_RIGHT, nv.upgradedUtils.truncateText);
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$2 = sectionLabels[1]) !== null && _sectionLabels$2 !== void 0 ? _sectionLabels$2 : "".concat(upgradedScatterChart_QUADRANT_LABEL, " 2"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_LEFT, nv.upgradedUtils.truncateText);
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$3 = sectionLabels[2]) !== null && _sectionLabels$3 !== void 0 ? _sectionLabels$3 : "".concat(upgradedScatterChart_QUADRANT_LABEL, " 3"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.BOTTOM_LEFT, nv.upgradedUtils.truncateText);
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$4 = sectionLabels[3]) !== null && _sectionLabels$4 !== void 0 ? _sectionLabels$4 : "".concat(upgradedScatterChart_QUADRANT_LABEL, " 4"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.BOTTOM_RIGHT, nv.upgradedUtils.truncateText);
              break;
            case upgradedScatterChart_SECTION_TYPES.LEFT_RIGHT:
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$5 = sectionLabels[0]) !== null && _sectionLabels$5 !== void 0 ? _sectionLabels$5 : "".concat(upgradedScatterChart_SECTION_LABEL, " 1"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_LEFT, nv.upgradedUtils.truncateText);
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$6 = sectionLabels[1]) !== null && _sectionLabels$6 !== void 0 ? _sectionLabels$6 : "".concat(upgradedScatterChart_SECTION_LABEL, " 2"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_RIGHT, nv.upgradedUtils.truncateText);
              break;
            case upgradedScatterChart_SECTION_TYPES.TOP_BOTTOM:
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$7 = sectionLabels[0]) !== null && _sectionLabels$7 !== void 0 ? _sectionLabels$7 : "".concat(upgradedScatterChart_SECTION_LABEL, " 1"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_RIGHT, nv.upgradedUtils.truncateText);
              upgradedScatterChart_createSectionLabel(sectionLabelsContainer, maxTextWidth, (_sectionLabels$8 = sectionLabels[1]) !== null && _sectionLabels$8 !== void 0 ? _sectionLabels$8 : "".concat(upgradedScatterChart_SECTION_LABEL, " 2"), scatter.height(), scatter.width(), upgradedScatterChart_SECTION_LABEL_LOCATIONS.BOTTOM_RIGHT, nv.upgradedUtils.truncateText);
              break;
          }
        }
        if (showDistX) {
          distX.getData(scatter.x()).scale(x).width(availableWidth).color(data.map(function (d, i) {
            return d.color || color(d, i);
          }).filter(function (d, i) {
            return !data[i].disabled;
          }));
          gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionX');
          g.select('.nv-distributionX').attr('transform', 'translate(0,' + y.range()[0] + ')').datum(data.filter(function (d) {
            return !d.disabled;
          })).call(distX);
        }
        if (showDistY) {
          distY.getData(scatter.y()).scale(y).width(availableHeight).color(data.map(function (d, i) {
            return d.color || color(d, i);
          }).filter(function (d, i) {
            return !data[i].disabled;
          }));
          gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionY');
          g.select('.nv-distributionY').attr('transform', 'translate(' + (rightAlignYAxis ? availableWidth : -distY.size()) + ',0)').datum(data.filter(function (d) {
            return !d.disabled;
          })).call(distY);
        }
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined') {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          chart.update();
        });
        var indexCache = {
          seriesIndex: null,
          pointIndex: null
        };
        function mouseOutReaction(evt) {
          if (evt) {
            indexCache.seriesIndex = evt.seriesIndex;
            indexCache.pointIndex = evt.pointIndex;
          }
          tooltip.hidden(true);
          container.select('.nv-chart-' + scatter.id() + ' .nv-series-' + indexCache.seriesIndex + ' .nv-distx-' + indexCache.pointIndex).attr('y1', 0);
          container.select('.nv-chart-' + scatter.id() + ' .nv-series-' + indexCache.seriesIndex + ' .nv-disty-' + indexCache.pointIndex).attr('x2', distY.size());
        }
        function mouseOverReaction(evt) {
          var overlappingDataPoints = upgradedScatterChart_getOverlappingDataPoints(evt.point.id);
          evt.overlappingDataPoints = overlappingDataPoints;
          container.select('.nv-series-' + evt.seriesIndex + ' .nv-distx-' + evt.pointIndex).attr('y1', evt.relativePos[1] - availableHeight);
          container.select('.nv-series-' + evt.seriesIndex + ' .nv-disty-' + evt.pointIndex).attr('x2', evt.relativePos[0] + distX.size());
          tooltip.data(evt).position(function () {
            return evt.pos;
          }).hidden(false);
          indexCache.seriesIndex = evt.seriesIndex;
          indexCache.pointIndex = evt.pointIndex;
        }
        function onTouchStart() {
          if (!tooltip.hidden()) {
            mouseOutReaction();
          }
        }
        scatter.dispatch.on('elementMouseout.tooltip', mouseOutReaction);
        scatter.dispatch.on('elementMouseover.tooltip', mouseOverReaction);
        d3.select(document.body).on('touchstart', onTouchStart);
        scatter.dispatch.on('elementClick', chart.dispatch.elementClick);
      });
      renderWatch.renderEnd('scatter with line immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.scatter = scatter;
    chart.legend = legend;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.distX = distX;
    chart.distY = distY;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      container: {
        get: function get() {
          return container;
        },
        set: function set(_) {
          container = _;
        }
      },
      showDistX: {
        get: function get() {
          return showDistX;
        },
        set: function set(_) {
          showDistX = _;
        }
      },
      showDistY: {
        get: function get() {
          return showDistY;
        },
        set: function set(_) {
          showDistY = _;
        }
      },
      showVerticalGrid: {
        get: function get() {
          return showVerticalGrid;
        },
        set: function set(_) {
          showVerticalGrid = _;
        }
      },
      showHorizontalGrid: {
        get: function get() {
          return showHorizontalGrid;
        },
        set: function set(_) {
          showHorizontalGrid = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      useSubtleGrid: {
        get: function get() {
          return useSubtleGrid;
        },
        set: function set(_) {
          useSubtleGrid = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = _;
        }
      },
      enableOutlineBubbleStyle: {
        get: function get() {
          return enableOutlineBubbleStyle;
        },
        set: function set(_) {
          enableOutlineBubbleStyle = _;
        }
      },
      showGridLineBorders: {
        get: function get() {
          return showGridLineBorders;
        },
        set: function set(_) {
          showGridLineBorders = _;
        }
      },
      showSectionLabels: {
        get: function get() {
          return showSectionLabels;
        },
        set: function set(_) {
          showSectionLabels = _;
        }
      },
      referenceLines: {
        get: function get() {
          return referenceLines;
        },
        set: function set(_) {
          referenceLines = _;
        }
      },
      sectionLabels: {
        get: function get() {
          return sectionLabels;
        },
        set: function set(_) {
          sectionLabels = _;
        }
      },
      sectionType: {
        get: function get() {
          return sectionType;
        },
        set: function set(_) {
          sectionType = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(_ ? 'right' : 'left');
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          legend.color(color);
          distX.color(color);
          distY.color(color);
        }
      },
      labelLocation: {
        get: function get() {
          return valueLabelLocation;
        },
        set: function set(_) {
          valueLabelLocation = _;
        }
      }
    });
    nv.utils.inheritOptions(chart, scatter);
    nv.utils.initOptions(chart);
    return chart;
  };
};
function upgradedScatterChart_createSectionLabel(sectionLabelContainer, maxTextWidth, title, height, width, location, truncateFunction) {
  var quadrant = sectionLabelContainer.append('g');
  var sectionLabelBackground = quadrant.append('rect').attr('class', 'nv-sectionLabel').attr('rx', upgradedScatterChart_BORDER_RADIUS).attr('ry', upgradedScatterChart_BORDER_RADIUS);
  var sectionLabel = quadrant.append('text').text(title).call(truncateFunction, width / 4);
  var sectionLabelWidth = sectionLabel.node().getBBox().width + upgradedScatterChart_SECTION_LABEL_HORIZONTAL_PADDING * upgradedScatterChart_TOTAL_HORIZONTAL_PADDING_MULTIPLIER;
  var sectionLabelHeight = sectionLabel.node().getBBox().height + upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING * upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER;
  var transformX, transformY;
  switch (location) {
    case upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_RIGHT:
      transformX = width - sectionLabelWidth + upgradedScatterChart_SECTION_LABEL_HORIZONTAL_PADDING;
      transformY = sectionLabelHeight - upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING * upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
    case upgradedScatterChart_SECTION_LABEL_LOCATIONS.TOP_LEFT:
      transformX = maxTextWidth + upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING + upgradedScatterChart_AXIS_LABEL_PADDING;
      transformY = sectionLabelHeight - upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING * upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
    case upgradedScatterChart_SECTION_LABEL_LOCATIONS.BOTTOM_RIGHT:
      transformX = width - sectionLabelWidth + upgradedScatterChart_SECTION_LABEL_HORIZONTAL_PADDING;
      transformY = height - upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING * upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
    case upgradedScatterChart_SECTION_LABEL_LOCATIONS.BOTTOM_LEFT:
      transformX = maxTextWidth + upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING + upgradedScatterChart_AXIS_LABEL_PADDING;
      transformY = height - upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING * upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER;
      break;
  }
  quadrant.style('transform', "translate(".concat(transformX, "px, ").concat(transformY, "px)"));
  sectionLabelBackground.attr('height', sectionLabelHeight).attr('width', sectionLabelWidth).style('transform', "translate(-".concat(upgradedScatterChart_SECTION_LABEL_HORIZONTAL_PADDING, "px, -").concat(sectionLabelHeight - upgradedScatterChart_SECTION_LABEL_VERTICAL_PADDING * upgradedScatterChart_TOTAL_VERTICAL_PADDING_MULTIPLIER, "px)"));
}
function upgradedScatterChart_getOverlappingDataPoints(dataPointId) {
  var dataPoints = d3.selectAll('.nv-point').filter(function (dataPoint) {
    return dataPoint[0].id !== dataPointId;
  });
  var hoveredDataPoint = d3.select('.nv-point.hover');
  var hoveredDataPointRadius = hoveredDataPoint.node().getBoundingClientRect().width / 2;
  var overlappingDataPoints = [hoveredDataPoint.data()[0]];
  dataPoints.each(function (dataPoint) {
    var dataPointElement = d3.select(this);
    var dataPointRadius = dataPointElement.node().getBoundingClientRect().width / 2;
    var dx = hoveredDataPoint.node().getBoundingClientRect().x - dataPointElement.node().getBoundingClientRect().x;
    var dy = hoveredDataPoint.node().getBoundingClientRect().y - dataPointElement.node().getBoundingClientRect().y;
    var distance = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
    if (distance <= hoveredDataPointRadius + dataPointRadius) {
      overlappingDataPoints.push(dataPoint);
    }
  });
  return overlappingDataPoints;
}
;// ./src/js/nv/models/quadrantChart.js
var Y_AXIS_TITLE_DISTANCE_WITH_AXIS_LABELS = 45;
var Y_AXIS_TITLE_DISTANCE_WITH_NO_AXIS_LABELS = 30;
var TICK_PADDING = 33;
var BORDER_COLOR = '#C2C3C5';
var BORDER_WIDTH = '1px';
var quadrantChart_BORDER_RADIUS = 5;
var AxisLabelType = {
  Numeric: 'numeric',
  Descriptive: 'descriptive',
  Off: 'off'
};
var quadrantChart = function quadrantChart(nv) {
  nv.models.quadrantChart = function () {
    var scatterChart = nv.models.scatterChart(),
      xAxis = scatterChart.xAxis,
      yAxis = scatterChart.yAxis,
      legend = scatterChart.legend,
      distX = scatterChart.distX,
      distY = scatterChart.distY,
      tooltip = scatterChart.tooltip,
      dispatch = scatterChart.dispatch;
    var container = null;
    var axisLabelType;
    var secondaryXAxisLabel;
    var secondaryYAxisLabel;
    var scatterWidth;
    var scatterHeight;
    function chart(selection) {
      selection.each(function (data) {
        container = d3.select(this);
        nv.utils.initSVG(container);
        chart.update = function () {
          container.call(chart);
        };
        chart.container = this;
        var wrap = container.selectAll('g.nv-wrap.nv-quadrantChart').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', "nvd3 nv-wrap nv-quadrantChart nv-chart-".concat(scatterChart.id()));
        var gEnter = wrapEnter.append('g');
        gEnter.append('g').attr('class', 'nv-scatterChartWrap');
        if (axisLabelType === AxisLabelType.Descriptive || axisLabelType === AxisLabelType.Off) {
          xAxis.tickFormat(function () {
            return '';
          });
          yAxis.tickFormat(function () {
            return '';
          });
        }
        yAxis.tickPadding(TICK_PADDING);
        if (axisLabelType === AxisLabelType.Numeric || axisLabelType === AxisLabelType.Descriptive) {
          yAxis.axisLabelDistance(Y_AXIS_TITLE_DISTANCE_WITH_AXIS_LABELS);
        } else {
          yAxis.axisLabelDistance(Y_AXIS_TITLE_DISTANCE_WITH_NO_AXIS_LABELS);
        }
        if (secondaryXAxisLabel) {
          xAxis.secondaryAxisLabel(secondaryXAxisLabel);
        }
        if (secondaryYAxisLabel) {
          yAxis.secondaryAxisLabel(secondaryYAxisLabel);
        }
        wrap.select('.nv-scatterChartWrap').call(scatterChart);
        var scatterChartContainer = wrap.select('.nv-scatterChart g');
        scatterChartContainer.selectAll('.nv-chartBorder').remove();
        scatterChartContainer.append('g').attr('class', 'nv-chartBorder');
        scatterChartContainer.select('.nv-chartBorder').append('mask').attr('id', 'border-mask');
        var mask = scatterChartContainer.select('#border-mask');
        scatterWidth = scatterChart.scatter.width();
        scatterHeight = scatterChart.scatter.height();
        mask.append('rect').attr('x', 0).attr('y', 0).attr('width', scatterWidth).attr('height', scatterHeight).attr('fill', 'white');
        mask.append('path').attr('d', generateBorderPathData([0, 0], [scatterWidth, 0], [scatterWidth, scatterHeight], [0, scatterHeight])).attr('fill', 'black');
        scatterChartContainer.select('.nv-chartBorder').append('rect').attr('x', 0).attr('y', 0).attr('width', scatterWidth).attr('height', scatterHeight).attr('fill', 'white').attr('mask', 'url(#border-mask)');
        scatterChartContainer.select('.nv-chartBorder').append('path').attr('d', generateBorderPathData([0, 0], [scatterWidth, 0], [scatterWidth, scatterHeight], [0, scatterHeight])).attr('stroke', BORDER_COLOR).attr('stroke-width', BORDER_WIDTH).attr('fill', 'none');
        scatterChartContainer.selectAll('.nv-quadrantBorders').remove();
        scatterChartContainer.append('g').attr('class', 'nv-quadrantBorders');
        scatterChartContainer.select('.nv-quadrantBorders').append('line').attr('x1', 0).attr('y1', scatterHeight / 2).attr('x2', scatterWidth).attr('y2', scatterHeight / 2).style('stroke', BORDER_COLOR).style('stroke-width', BORDER_WIDTH);
        scatterChartContainer.select('.nv-quadrantBorders').append('line').attr('x1', scatterWidth / 2).attr('y1', 0).attr('x2', scatterWidth / 2).attr('y2', scatterHeight).style('stroke', BORDER_COLOR).style('stroke-width', BORDER_WIDTH);
        var scatterWrap = scatterChartContainer.select('.nv-scatterWrap');
        scatterWrap.moveToFront();
        var axisTitles = container.selectAll('.nv-axislabel');
        axisTitles.style('fill', '#515559').style('font-size', '14px').style('font-family', '\'72\',\'Helvetica Neue\',\'Helvetica\',\'Arial\',\'sans-serif\'');
        xAxis._ticks(Math.floor(scatterWidth / 50));
        var ytickCount = Math.floor(scatterHeight / 18);
        yAxis._ticks(ytickCount);
        var tickLabels = scatterChartContainer.selectAll('.nvd3.nv-scatterChart.subtle-grid .nv-y .nv-axis .tick text');
        tickLabels.style('transform', 'none');
        var dataPoints = wrap.selectAll('g.data-points text');
        dataPoints.style('font-size', '12px');
      });
      return chart;
    }
    chart.scatterChart = scatterChart;
    chart.legend = legend;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.distX = distX;
    chart.distY = distY;
    chart.tooltip = tooltip;
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      axisLabelType: {
        get: function get() {
          return axisLabelType;
        },
        set: function set(_) {
          axisLabelType = _;
        }
      },
      secondaryXAxisLabel: {
        get: function get() {
          return secondaryXAxisLabel;
        },
        set: function set(_) {
          secondaryXAxisLabel = _;
        }
      },
      secondaryYAxisLabel: {
        get: function get() {
          return secondaryYAxisLabel;
        },
        set: function set(_) {
          secondaryYAxisLabel = _;
        }
      }
    });
    nv.utils.inheritOptions(chart, scatterChart);
    nv.utils.initOptions(chart);
    return chart;
  };
};
function generateBorderPathData(topLeft, topRight, bottomRight, bottomLeft) {
  var commands = ["M ".concat(topLeft[0], " ").concat(topLeft[1] + quadrantChart_BORDER_RADIUS), "A ".concat(quadrantChart_BORDER_RADIUS, " ").concat(quadrantChart_BORDER_RADIUS, " 0 0 1 ").concat(topLeft[0] + quadrantChart_BORDER_RADIUS, " ").concat(topLeft[1]), "L ".concat(topRight[0] - quadrantChart_BORDER_RADIUS, " ").concat(topRight[1]), "A ".concat(quadrantChart_BORDER_RADIUS, " ").concat(quadrantChart_BORDER_RADIUS, " 0 0 1 ").concat(topRight[0], " ").concat(topRight[1] + quadrantChart_BORDER_RADIUS), "L ".concat(bottomRight[0], " ").concat(bottomRight[1] - quadrantChart_BORDER_RADIUS), "A ".concat(quadrantChart_BORDER_RADIUS, " ").concat(quadrantChart_BORDER_RADIUS, " 0 0 1 ").concat(bottomRight[0] - quadrantChart_BORDER_RADIUS, " ").concat(bottomRight[1]), "L ".concat(bottomLeft[0] + quadrantChart_BORDER_RADIUS, " ").concat(bottomLeft[1]), "A ".concat(quadrantChart_BORDER_RADIUS, " ").concat(quadrantChart_BORDER_RADIUS, " 0 0 1 ").concat(bottomLeft[0], " ").concat(bottomLeft[1] - quadrantChart_BORDER_RADIUS), 'Z'];
  return commands.join(' ');
}
;// ./src/js/nv/models/sparkline.js
var sparkline = function sparkline(nv) {
  nv.models.sparkline = function () {
    var margin = {
        top: 2,
        right: 0,
        bottom: 2,
        left: 0
      },
      width = 400,
      height = 32,
      container = null,
      animate = true,
      x = d3.scale.linear(),
      y = d3.scale.linear(),
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      color = nv.utils.getColor(['#000']),
      xDomain,
      yDomain,
      xRange,
      yRange,
      dispatch = d3.dispatch('renderEnd');
    var renderWatch = nv.utils.renderWatch(dispatch);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = d3.select(this);
        nv.utils.initSVG(container);
        x.domain(xDomain || d3.extent(data, getX)).range(xRange || [0, availableWidth]);
        y.domain(yDomain || d3.extent(data, getY)).range(yRange || [availableHeight, 0]);
        var wrap = container.selectAll('g.nv-wrap.nv-sparkline').data([data]);
        wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sparkline');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var paths = wrap.selectAll('path').data(function (d) {
          return [d];
        });
        paths.enter().append('path');
        paths.exit().remove();
        paths.style('stroke', function (d, i) {
          return d.color || color(d, i);
        }).attr('d', d3.svg.line().x(function (d, i) {
          return x(getX(d, i));
        }).y(function (d, i) {
          return y(getY(d, i));
        }));
        var points = wrap.selectAll('circle.nv-point').data(function (data) {
          var yValues = data.map(function (d, i) {
            return getY(d, i);
          });
          function pointIndex(index) {
            if (index !== -1) {
              var result = data[index];
              result.pointIndex = index;
              return result;
            } else {
              return null;
            }
          }
          var maxPoint = pointIndex(yValues.lastIndexOf(y.domain()[1])),
            minPoint = pointIndex(yValues.indexOf(y.domain()[0])),
            currentPoint = pointIndex(yValues.length - 1);
          return [minPoint, maxPoint, currentPoint].filter(function (d) {
            return d !== null;
          });
        });
        points.enter().append('circle');
        points.exit().remove();
        points.attr('cx', function (d) {
          return x(getX(d, d.pointIndex));
        }).attr('cy', function (d) {
          return y(getY(d, d.pointIndex));
        }).attr('r', 2).attr('class', function (d) {
          return getX(d, d.pointIndex) === x.domain()[1] ? 'nv-point nv-currentValue' : getY(d, d.pointIndex) === y.domain()[0] ? 'nv-point nv-minValue' : 'nv-point nv-maxValue';
        });
      });
      renderWatch.renderEnd('sparkline immediate');
      return chart;
    }
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      xDomain: {
        get: function get() {
          return xDomain;
        },
        set: function set(_) {
          xDomain = _;
        }
      },
      yDomain: {
        get: function get() {
          return yDomain;
        },
        set: function set(_) {
          yDomain = _;
        }
      },
      xRange: {
        get: function get() {
          return xRange;
        },
        set: function set(_) {
          xRange = _;
        }
      },
      yRange: {
        get: function get() {
          return yRange;
        },
        set: function set(_) {
          yRange = _;
        }
      },
      xScale: {
        get: function get() {
          return x;
        },
        set: function set(_) {
          x = _;
        }
      },
      yScale: {
        get: function get() {
          return y;
        },
        set: function set(_) {
          y = _;
        }
      },
      animate: {
        get: function get() {
          return animate;
        },
        set: function set(_) {
          animate = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = d3.functor(_);
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = d3.functor(_);
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      }
    });
    chart.dispatch = dispatch;
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/sparklinePlus.js
var sparklinePlus = function sparklinePlus(nv) {
  nv.models.sparklinePlus = function () {
    var sparkline = nv.models.sparkline();
    var margin = {
        top: 15,
        right: 100,
        bottom: 10,
        left: 50
      },
      width = null,
      height = null,
      x,
      y,
      index = [],
      paused = false,
      xTickFormat = d3.format(',r'),
      yTickFormat = d3.format(',.2f'),
      showLastValue = true,
      alignValue = true,
      rightAlignValue = false,
      noData = null,
      dispatch = d3.dispatch('renderEnd');
    var renderWatch = nv.utils.renderWatch(dispatch);
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(sparkline);
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          container.call(chart);
        };
        chart.container = this;
        if (!data || !data.length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        var currentValue = sparkline.y()(data[data.length - 1], data.length - 1);
        x = sparkline.xScale();
        y = sparkline.yScale();
        var wrap = container.selectAll('g.nv-wrap.nv-sparklineplus').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sparklineplus');
        var gEnter = wrapEnter.append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-sparklineWrap');
        gEnter.append('g').attr('class', 'nv-valueWrap');
        gEnter.append('g').attr('class', 'nv-hoverArea');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        var sparklineWrap = g.select('.nv-sparklineWrap');
        sparkline.width(availableWidth).height(availableHeight);
        sparklineWrap.call(sparkline);
        if (showLastValue) {
          var valueWrap = g.select('.nv-valueWrap');
          var value = valueWrap.selectAll('.nv-currentValue').data([currentValue]);
          value.enter().append('text').attr('class', 'nv-currentValue').attr('dx', rightAlignValue ? -8 : 8).attr('dy', '.9em').style('text-anchor', rightAlignValue ? 'end' : 'start');
          value.attr('x', availableWidth + (rightAlignValue ? margin.right : 0)).attr('y', alignValue ? function (d) {
            return y(d);
          } : 0).style('fill', sparkline.color()(data[data.length - 1], data.length - 1)).text(yTickFormat(currentValue));
        }
        gEnter.select('.nv-hoverArea').append('rect').on('mousemove', sparklineHover).on('click', function () {
          paused = !paused;
        }).on('mouseout', function () {
          index = [];
          updateValueLine();
        });
        g.select('.nv-hoverArea rect').attr('transform', function () {
          return 'translate(' + -margin.left + ',' + -margin.top + ')';
        }).attr('width', availableWidth + margin.left + margin.right).attr('height', availableHeight + margin.top);
        function updateValueLine() {
          if (paused) {
            return;
          }
          var hoverValue = g.selectAll('.nv-hoverValue').data(index);
          var hoverEnter = hoverValue.enter().append('g').attr('class', 'nv-hoverValue').style('stroke-opacity', 0).style('fill-opacity', 0);
          hoverValue.exit().transition().duration(250).style('stroke-opacity', 0).style('fill-opacity', 0).remove();
          hoverValue.attr('transform', function (d) {
            return 'translate(' + x(sparkline.x()(data[d], d)) + ',0)';
          }).transition().duration(250).style('stroke-opacity', 1).style('fill-opacity', 1);
          if (!index.length) {
            return;
          }
          hoverEnter.append('line').attr('x1', 0).attr('y1', -margin.top).attr('x2', 0).attr('y2', availableHeight);
          hoverEnter.append('text').attr('class', 'nv-xValue').attr('x', -6).attr('y', -margin.top).attr('text-anchor', 'end').attr('dy', '.9em');
          g.select('.nv-hoverValue .nv-xValue').text(xTickFormat(sparkline.x()(data[index[0]], index[0])));
          hoverEnter.append('text').attr('class', 'nv-yValue').attr('x', 6).attr('y', -margin.top).attr('text-anchor', 'start').attr('dy', '.9em');
          g.select('.nv-hoverValue .nv-yValue').text(yTickFormat(sparkline.y()(data[index[0]], index[0])));
        }
        function sparklineHover() {
          if (paused) {
            return;
          }
          var pos = d3.mouse(this)[0] - margin.left;
          function getClosestIndex(data, x) {
            var distance = Math.abs(sparkline.x()(data[0], 0) - x);
            var closestIndex = 0;
            for (var i = 0; i < data.length; i++) {
              if (Math.abs(sparkline.x()(data[i], i) - x) < distance) {
                distance = Math.abs(sparkline.x()(data[i], i) - x);
                closestIndex = i;
              }
            }
            return closestIndex;
          }
          index = [getClosestIndex(data, Math.round(x.invert(pos)))];
          updateValueLine();
        }
      });
      renderWatch.renderEnd('sparklinePlus immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.sparkline = sparkline;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      xTickFormat: {
        get: function get() {
          return xTickFormat;
        },
        set: function set(_) {
          xTickFormat = _;
        }
      },
      yTickFormat: {
        get: function get() {
          return yTickFormat;
        },
        set: function set(_) {
          yTickFormat = _;
        }
      },
      showLastValue: {
        get: function get() {
          return showLastValue;
        },
        set: function set(_) {
          showLastValue = _;
        }
      },
      alignValue: {
        get: function get() {
          return alignValue;
        },
        set: function set(_) {
          alignValue = _;
        }
      },
      rightAlignValue: {
        get: function get() {
          return rightAlignValue;
        },
        set: function set(_) {
          rightAlignValue = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      }
    });
    nv.utils.inheritOptions(chart, sparkline);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/stackedArea.js







var stackedArea = function stackedArea(nv) {
  nv.models.stackedArea = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = 960,
      height = 500,
      strokeWidth = 2,
      color = nv.upgradedUtils.defaultColor(),
      id = Math.floor(Math.random() * 100000),
      container = null,
      getX = function getX(d) {
        return d.x;
      },
      getY = function getY(d) {
        return d.y;
      },
      defined = function defined(d, i) {
        return !isNaN(getY(d, i)) && getY(d, i) !== null;
      },
      style = 'stack',
      offset = 'zero',
      order = 'default',
      curve = curve_linear,
      clipEdge = false,
      x,
      y,
      scatter = nv.models.upgradedScatter(),
      duration = 250,
      dispatch = src_dispatch('areaClick', 'areaMouseover', 'areaMouseout', 'renderEnd', 'elementClick', 'elementMouseover', 'elementMouseout'),
      pointSize = strokeWidth * 20,
      showValues = false,
      valueFormat = format(',.2f'),
      valuePadding = 5,
      pointRange = [pointSize, pointSize];
    scatter.pointRange(pointRange).pointDomain(pointRange).pointActive(function (d) {
      return !(d.notActive || d.y === null || d.y === undefined);
    });
    var renderWatch = nv.upgradedUtils.renderWatch(dispatch, duration);
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(scatter);
      selection.each(function (data) {
        var availableWidth = width - margin.left - margin.right,
          availableHeight = height - margin.top - margin.bottom;
        container = src_select(this);
        nv.upgradedUtils.initSVG(container);
        x = scatter.xScale();
        y = scatter.yScale();
        var dataRaw = data;
        data.forEach(function (aseries, i) {
          aseries.seriesIndex = i;
          aseries.values = aseries.values.map(function (d, j) {
            d.index = j;
            d.seriesIndex = i;
            return d;
          });
        });
        var dataFiltered = data.filter(function (series) {
          return !series.disabled;
        });
        data = stackLayout().order(order).offset(offset).values(function (d) {
          return d.values;
        }).x(getX).y(getY).out(function (d, y0, y) {
          d.display = {
            y: y,
            y0: y0
          };
        })(dataFiltered);
        var wrap = container.selectAll('g.nv-wrap.nv-stackedarea').data([data]);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-stackedarea');
        var defsEnter = wrapEnter.append('defs');
        var gEnter = wrapEnter.append('g');
        var patternContainer = gEnter.append('defs').node();
        var g = gEnter.merge(wrap).select('g');
        var wrapMergeSelection = wrapEnter.merge(wrap);
        var gMergeSelection = gEnter.merge(g);
        gEnter.append('g').attr('class', 'nv-lineWrap');
        gEnter.append('g').attr('class', 'nv-areaWrap');
        gEnter.append('g').attr('class', 'nv-scatterWrap');
        wrapMergeSelection.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (scatter.forceY().length === 0) {
          scatter.forceY().push(0);
        }
        scatter.width(availableWidth).height(availableHeight).x(getX).y(function (d) {
          if (d.display !== undefined) {
            return d.display.y + d.display.y0;
          }
        }).forceY([0]).color(data.map(function (d) {
          d.color = d.color || color(d, d.seriesIndex);
          return d.color;
        }));
        var scatterWrap = gMergeSelection.select('.nv-scatterWrap').datum(data);
        scatterWrap.call(scatter);
        defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
        wrapMergeSelection.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
        gMergeSelection.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
        var area = d3_shape_src_area().defined(defined).x(function (d, i) {
          return x(getX(d, i));
        }).y0(function (d) {
          return y(d.display.y0);
        }).y1(function (d) {
          return y(d.display.y + d.display.y0);
        }).curve(curve);
        var zeroArea = d3_shape_src_area().defined(defined).x(function (d, i) {
          return x(getX(d, i));
        }).y0(function (d) {
          return y(d.display.y0);
        }).y1(function (d) {
          return y(d.display.y0);
        });
        var path = gMergeSelection.select('.nv-areaWrap').selectAll('path.nv-area').data(function (d) {
          return d;
        });
        var pathMergeSelection = path.enter().append('path').attr('class', function (d, i) {
          return 'nv-area nv-area-' + i;
        }).attr('d', function (d) {
          return zeroArea(d.values, d.seriesIndex);
        }).merge(path);
        pathMergeSelection.on('mouseover', function (event, d) {
          src_select(this).classed('hover', true);
          dispatch.call('areaMouseover', this, {
            point: d,
            series: d.key,
            pos: [event.pageX, event.pageY],
            seriesIndex: d.seriesIndex
          });
        }).on('mouseout', function (event, d) {
          src_select(this).classed('hover', false);
          dispatch.call('areaMouseout', this, {
            point: d,
            series: d.key,
            pos: [event.pageX, event.pageY],
            seriesIndex: d.seriesIndex
          });
        }).on('click', function (event, d) {
          src_select(this).classed('hover', false);
          dispatch.call('areaClick', this, {
            point: d,
            series: d.key,
            pos: [event.pageX, event.pageY],
            seriesIndex: d.seriesIndex
          });
        });
        path.exit().remove();
        pathMergeSelection.style('fill', function (d) {
          var parentNode = pathMergeSelection.node().parentNode.parentNode;
          var parentNodeChildren = parentNode.childNodes;
          var parentNodeFirstChild = parentNodeChildren[0];
          if (parentNodeChildren && parentNodeFirstChild.nodeName === 'defs') {
            patternContainer = parentNodeFirstChild;
          } else {
            patternContainer = parentNode.prepend('defs');
          }
          var defaultColorFill = d.color || color(d, d.seriesIndex);
          return nv.utils.patternService.getDataFill(patternContainer, d, defaultColorFill);
        }).style('stroke', function (d) {
          return d.color || color(d, d.seriesIndex);
        });
        pathMergeSelection.watchTransition(renderWatch, 'stackedArea path').attr('d', function (d, i) {
          return area(d.values, i);
        });
        var line = src_line().curve(curve).defined(defined).x(function (d, i) {
          return nv.upgradedUtils.NaNtoZero(x(getX(d, i)));
        }).y(function (d) {
          return nv.upgradedUtils.NaNtoZero(y(d.display.y + d.display.y0));
        });
        var linePaths = gMergeSelection.select('.nv-lineWrap').selectAll('path.nv-line').data(function (d) {
          return d;
        });
        var linePathsMergeSelection = linePaths.enter().append('path').attr('class', 'nv-line').style('stroke', function (d) {
          return d.color || color(d, d.seriesIndex);
        }).style('stroke-width', function (d) {
          return d.strokeWidth || strokeWidth;
        }).merge(linePaths);
        linePaths.exit().remove();
        linePathsMergeSelection.attr('d', function (d, i) {
          return line(d.values, i);
        });
        if (showValues) {
          var dataPoints = gMergeSelection.selectAll('text.data-points').data(function (d) {
            return d;
          });
          var dataPointsMergeSelection = dataPoints.enter().append('text').attr('class', 'data-points').attr('x', function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return nv.upgradedUtils.NaNtoZero(x(getX(point, position))) + valuePadding;
          }).attr('y', function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return nv.upgradedUtils.NaNtoZero(y(point.display.y + point.display.y0)) + 3;
          }).text(function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return valueFormat(getY(point, position));
          }).merge(dataPoints);
          dataPoints.exit().remove();
          dataPointsMergeSelection.watchTransition(renderWatch, 'stackedArea path').attr('x', function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return nv.upgradedUtils.NaNtoZero(x(getX(point, position))) + valuePadding;
          }).attr('y', function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return nv.upgradedUtils.NaNtoZero(y(point.display.y + point.display.y0)) + 3;
          }).text(function (d) {
            var position = d.values.length - 1,
              point = d.values[position];
            return valueFormat(getY(point, position));
          });
        } else {
          gMergeSelection.selectAll('text.data-points').remove();
        }
        scatter.dispatch.on('elementMouseover.area', function (e) {
          gMergeSelection.select('.nv-chart-' + id + ' .nv-area-' + e.seriesIndex).classed('hover', true);
        });
        scatter.dispatch.on('elementMouseout.area', function (e) {
          gMergeSelection.select('.nv-chart-' + id + ' .nv-area-' + e.seriesIndex).classed('hover', false);
        });
        chart.d3_stackedOffset_stackPercent = function (stackData) {
          var n = stackData.length,
            m = stackData[0].length,
            i,
            j,
            o,
            y0 = [];
          for (j = 0; j < m; ++j) {
            for (i = 0, o = 0; i < dataRaw.length; i++) {
              o += getY(dataRaw[i].values[j]);
            }
            if (o) {
              for (i = 0; i < n; i++) {
                stackData[i][j][1] /= o;
              }
            } else {
              for (i = 0; i < n; i++) {
                stackData[i][j][1] = 0;
              }
            }
          }
          for (j = 0; j < m; ++j) {
            y0[j] = 0;
          }
          return y0;
        };
      });
      renderWatch.renderEnd('stackedArea immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.scatter = scatter;
    scatter.dispatch.on('elementClick', function () {
      dispatch.apply('elementClick', this, arguments);
    });
    scatter.dispatch.on('elementMouseover', function () {
      dispatch.apply('elementMouseover', this, arguments);
    });
    scatter.dispatch.on('elementMouseout', function () {
      dispatch.apply('elementMouseout', this, arguments);
    });
    chart.curve = function (_) {
      if (!arguments.length) {
        return curve;
      }
      curve = _;
      return chart;
    };
    chart.duration = function (_) {
      if (!arguments.length) {
        return duration;
      }
      duration = _;
      renderWatch.reset(duration);
      scatter.duration(duration);
      return chart;
    };
    chart.dispatch = dispatch;
    chart.scatter = scatter;
    chart.options = nv.upgradedUtils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      defined: {
        get: function get() {
          return defined;
        },
        set: function set(_) {
          defined = _;
        }
      },
      clipEdge: {
        get: function get() {
          return clipEdge;
        },
        set: function set(_) {
          clipEdge = _;
        }
      },
      offset: {
        get: function get() {
          return offset;
        },
        set: function set(_) {
          offset = _;
        }
      },
      order: {
        get: function get() {
          return order;
        },
        set: function set(_) {
          order = _;
        }
      },
      curve: {
        get: function get() {
          return curve;
        },
        set: function set(_) {
          curve = _;
        }
      },
      pointSize: {
        get: function get() {
          return pointSize;
        },
        set: function set(_) {
          pointSize = _;
        }
      },
      showValues: {
        get: function get() {
          return showValues;
        },
        set: function set(_) {
          showValues = _;
        }
      },
      valueFormat: {
        get: function get() {
          return valueFormat;
        },
        set: function set(_) {
          valueFormat = _;
        }
      },
      x: {
        get: function get() {
          return getX;
        },
        set: function set(_) {
          getX = nv.upgradedUtils.functor(_);
        }
      },
      y: {
        get: function get() {
          return getY;
        },
        set: function set(_) {
          getY = nv.upgradedUtils.functor(_);
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.upgradedUtils.getColor(_);
        }
      },
      style: {
        get: function get() {
          return style;
        },
        set: function set(_) {
          style = _;
          switch (style) {
            case 'stack':
              chart.offset('zero');
              chart.order('default');
              break;
            case 'stream':
              chart.offset('wiggle');
              chart.order('inside-out');
              break;
            case 'stream-center':
              chart.offset('silhouette');
              chart.order('inside-out');
              break;
            case 'expand':
              chart.offset('expand');
              chart.order('default');
              break;
            case 'stack_percent':
              chart.offset(chart.d3_stackedOffset_stackPercent);
              chart.order('default');
              break;
          }
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          scatter.duration(duration);
        }
      }
    });
    nv.upgradedUtils.inheritOptions(chart, scatter);
    nv.upgradedUtils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/stackedAreaChart.js


var stackedAreaChart = function stackedAreaChart(nv) {
  nv.models.stackedAreaChart = function () {
    var stacked = nv.models.stackedArea(),
      xAxis = nv.models.axis(),
      yAxis = nv.models.axis(),
      legend = nv.models.legend(),
      controls = nv.models.legend(),
      tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 25,
        bottom: 50,
        left: 60
      },
      width = null,
      height = null,
      color = nv.utils.defaultColor(),
      showControls = true,
      showLegend = true,
      showXAxis = true,
      showYAxis = true,
      rightAlignYAxis = false,
      useRegionInteraction = false,
      showTotalInTooltip = true,
      totalLabel = 'TOTAL',
      x,
      y,
      state = nv.utils.state(),
      defaultState = null,
      noData = null,
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd'),
      controlWidth = 250,
      controlOptions = ['Stacked', 'Stream', 'Expanded'],
      controlLabels = {},
      duration = 250,
      wrapLabels = false,
      disableAreaClick = false;
    state.style = stacked.style();
    xAxis.orient('bottom').tickPadding(7);
    yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickFormat(d3.format(',.1f'));
    tooltip.headerFormatter(function (d, i) {
      return xAxis.tickFormat()(d, i);
    }).valueFormatter(function (d, i) {
      return yAxis.tickFormat()(d, i);
    });
    var oldYTickFormat = null;
    controls.updateState(false);
    var renderWatch = nv.utils.renderWatch(dispatch);
    var stateGetter = function stateGetter(data) {
      return function () {
        return {
          active: data.map(function (d) {
            return !d.disabled;
          }),
          style: stacked.style()
        };
      };
    };
    var stateSetter = function stateSetter(data) {
      return function (state) {
        if (state.active !== undefined) {
          data.forEach(function (series, i) {
            series.disabled = !state.active[i];
          });
        }
      };
    };
    var percentFormatter = d3.format('%');
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(stacked);
      if (showXAxis) {
        renderWatch.models(xAxis);
      }
      if (showYAxis) {
        renderWatch.models(yAxis);
      }
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          container.transition().duration(duration).call(chart);
        };
        chart.container = this;
        state.setter(stateSetter(data), chart.update).getter(stateGetter(data)).update();
        state.disabled = data.map(function (d) {
          return !!d.disabled;
        });
        if (!defaultState) {
          var key;
          defaultState = {};
          for (key in state) {
            if (state[key] instanceof Array) {
              defaultState[key] = state[key].slice(0);
            } else {
              defaultState[key] = state[key];
            }
          }
        }
        if (!data || !data.length || !data.filter(function (d) {
          return d.values.length;
        }).length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        x = stacked.xScale();
        y = stacked.yScale();
        var wrap = container.selectAll('g.nv-wrap.nv-stackedAreaChart').data([data]);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-stackedAreaChart').append('g');
        var g = wrap.select('g');
        gEnter.append('rect').style('opacity', 0);
        gEnter.append('g').attr('class', 'nv-x nv-axis');
        gEnter.append('g').attr('class', 'nv-y nv-axis');
        gEnter.append('g').attr('class', 'nv-stackedWrap');
        gEnter.append('g').attr('class', 'nv-legendWrap');
        gEnter.append('g').attr('class', 'nv-controlsWrap');
        g.select('rect').attr('width', availableWidth).attr('height', availableHeight);
        if (showLegend) {
          var legendWidth = showControls ? availableWidth - controlWidth : availableWidth;
          legend.width(legendWidth);
          g.select('.nv-legendWrap').datum(data).call(legend);
          if (margin.top !== legend.height()) {
            margin.top = legend.height();
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          g.select('.nv-legendWrap').attr('transform', 'translate(' + (availableWidth - legendWidth) + ',' + -margin.top + ')');
        }
        if (showControls) {
          var controlsData = [{
            key: controlLabels.stacked || 'Stacked',
            metaKey: 'Stacked',
            disabled: stacked.style() !== 'stack',
            style: 'stack'
          }, {
            key: controlLabels.stream || 'Stream',
            metaKey: 'Stream',
            disabled: stacked.style() !== 'stream',
            style: 'stream'
          }, {
            key: controlLabels.expanded || 'Expanded',
            metaKey: 'Expanded',
            disabled: stacked.style() !== 'expand',
            style: 'expand'
          }, {
            key: controlLabels.stack_percent || 'Stack %',
            metaKey: 'Stack_Percent',
            disabled: stacked.style() !== 'stack_percent',
            style: 'stack_percent'
          }];
          controlWidth = controlOptions.length / 3 * 260;
          controlsData = controlsData.filter(function (d) {
            return controlOptions.indexOf(d.metaKey) !== -1;
          });
          controls.width(controlWidth).color(['#444', '#444', '#444']);
          g.select('.nv-controlsWrap').datum(controlsData).call(controls);
          if (margin.top !== Math.max(controls.height(), legend.height())) {
            margin.top = Math.max(controls.height(), legend.height());
            availableHeight = nv.utils.availableHeight(height, container, margin);
          }
          g.select('.nv-controlsWrap').attr('transform', 'translate(0,' + -margin.top + ')');
        }
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        if (rightAlignYAxis) {
          g.select('.nv-y.nv-axis').attr('transform', 'translate(' + availableWidth + ',0)');
        }
        stacked.width(availableWidth).height(availableHeight);
        var stackedWrap = g.select('.nv-stackedWrap').datum(data);
        stackedWrap.transition().call(stacked);
        if (showXAxis) {
          xAxis.scale(x)._ticks(nv.utils.calcTicksX(availableWidth / 100, data)).tickSize(-availableHeight, 0);
          g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + availableHeight + ')');
          if (stacked.padData()) {
            xAxis.placeLabelAt(availableWidth / 2);
          } else {
            xAxis.placeLabelAt(null);
          }
          g.select('.nv-x.nv-axis').transition().duration(0).call(xAxis);
          if (wrapLabels) {
            g.select('.nv-x.nv-axis').selectAll('.tick text').call(nv.utils.wrapTicks, availableWidth / data[0].values.length, 2);
          }
        } else {
          g.select('.nv-x.nv-axis').remove();
        }
        if (showYAxis) {
          var ticks;
          if (stacked.offset() === 'wiggle') {
            ticks = 0;
          } else {
            ticks = nv.utils.calcTicksY(availableHeight / 36, data);
          }
          yAxis.scale(y)._ticks(ticks).tickSize(-availableWidth, 0);
          if (stacked.style() === 'expand' || stacked.style() === 'stack_percent') {
            var currentFormat = yAxis.tickFormat();
            if (!oldYTickFormat || currentFormat !== percentFormatter) {
              oldYTickFormat = currentFormat;
            }
            yAxis.tickFormat(percentFormatter);
          } else {
            if (oldYTickFormat) {
              yAxis.tickFormat(oldYTickFormat);
              oldYTickFormat = null;
            }
          }
          g.select('.nv-y.nv-axis').transition().duration(0).call(yAxis);
        } else {
          g.select('.nv-y.nv-axis').remove();
        }
        if (!disableAreaClick) {
          stacked.dispatch.on('areaClick.toggle', function (e) {
            if (data.filter(function (d) {
              return !d.disabled;
            }).length === 1) {
              data.forEach(function (d) {
                d.disabled = false;
              });
            } else {
              data.forEach(function (d, i) {
                d.disabled = i !== e.seriesIndex;
              });
            }
            state.disabled = data.map(function (d) {
              return !!d.disabled;
            });
            dispatch.stateChange(state);
            chart.update();
          });
        }
        legend.dispatch.on('stateChange', function (newState) {
          for (var key in newState) {
            state[key] = newState[key];
          }
          dispatch.stateChange(state);
          chart.update();
        });
        controls.dispatch.on('legendClick', function (d) {
          if (!d.disabled) {
            return;
          }
          controlsData = controlsData.map(function (s) {
            s.disabled = true;
            return s;
          });
          d.disabled = false;
          stacked.style(d.style);
          state.style = stacked.style();
          dispatch.stateChange(state);
          chart.update();
        });
        dispatch.on('changeState', function (e) {
          if (typeof e.disabled !== 'undefined' && data.length === e.disabled.length) {
            data.forEach(function (series, i) {
              series.disabled = e.disabled[i];
            });
            state.disabled = e.disabled;
          }
          if (typeof e.style !== 'undefined') {
            stacked.style(e.style);
          }
          chart.update();
        });
      });
      renderWatch.renderEnd('stacked Area chart immediate');
      return chart;
    }
    stacked.dispatch.on('elementMouseover.tooltip', function (evt) {
      evt.point.x = stacked.x()(evt.point, evt.pointIndex);
      evt.point.y = stacked.y()(evt.point, evt.pointIndex);
      tooltip.data(evt).position(function () {
        return evt.pos;
      }).hidden(false);
    });
    stacked.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    chart.dispatch = dispatch;
    chart.stacked = stacked;
    chart.legend = legend;
    chart.controls = controls;
    chart.xAxis = xAxis;
    chart.yAxis = yAxis;
    chart.tooltip = tooltip;
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      showLegend: {
        get: function get() {
          return showLegend;
        },
        set: function set(_) {
          showLegend = _;
        }
      },
      showXAxis: {
        get: function get() {
          return showXAxis;
        },
        set: function set(_) {
          showXAxis = _;
        }
      },
      showYAxis: {
        get: function get() {
          return showYAxis;
        },
        set: function set(_) {
          showYAxis = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      showControls: {
        get: function get() {
          return showControls;
        },
        set: function set(_) {
          showControls = _;
        }
      },
      controlLabels: {
        get: function get() {
          return controlLabels;
        },
        set: function set(_) {
          controlLabels = _;
        }
      },
      controlOptions: {
        get: function get() {
          return controlOptions;
        },
        set: function set(_) {
          controlOptions = _;
        }
      },
      showTotalInTooltip: {
        get: function get() {
          return showTotalInTooltip;
        },
        set: function set(_) {
          showTotalInTooltip = _;
        }
      },
      totalLabel: {
        get: function get() {
          return totalLabel;
        },
        set: function set(_) {
          totalLabel = _;
        }
      },
      wrapLabels: {
        get: function get() {
          return wrapLabels;
        },
        set: function set(_) {
          wrapLabels = !!_;
        }
      },
      disableAreaClick: {
        get: function get() {
          return disableAreaClick;
        },
        set: function set(_) {
          disableAreaClick = !!_;
        }
      },
      useRegionInteraction: {
        get: function get() {
          return useRegionInteraction;
        },
        set: function set(_) {
          useRegionInteraction = _;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          stacked.duration(duration);
          xAxis.duration(duration);
          yAxis.duration(duration);
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
          legend.color(color);
          stacked.color(color);
        }
      },
      rightAlignYAxis: {
        get: function get() {
          return rightAlignYAxis;
        },
        set: function set(_) {
          rightAlignYAxis = _;
          yAxis.orient(rightAlignYAxis ? 'right' : 'left');
        }
      }
    });
    nv.utils.inheritOptions(chart, stacked);
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/sunburst.js


var sunburst = function sunburst(nv) {
  nv.models.sunburst = function () {
    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = null,
      height = null,
      mode = 'count',
      modes = {
        count: function count() {
          return 1;
        },
        size: function size(d) {
          return d.size;
        }
      },
      id = Math.floor(Math.random() * 10000),
      container = null,
      color = nv.utils.defaultColor(),
      groupColorByParent = true,
      duration = 500,
      dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMousemove', 'elementMouseover', 'elementMouseout', 'renderEnd');
    var x = d3.scale.linear().range([0, 2 * Math.PI]);
    var y = d3.scale.sqrt();
    var partition = d3.layout.partition().sort(null).value(function () {
      return 1;
    });
    var arc = d3.svg.arc().startAngle(function (d) {
      return Math.max(0, Math.min(2 * Math.PI, x(d.x)));
    }).endAngle(function (d) {
      return Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
    }).innerRadius(function (d) {
      return Math.max(0, y(d.y));
    }).outerRadius(function (d) {
      return Math.max(0, y(d.y + d.dy));
    });
    var node, prevNode;
    var rootNode;
    var renderWatch = nv.utils.renderWatch(dispatch);
    function chart(selection) {
      renderWatch.reset();
      selection.each(function (data) {
        container = d3.select(this);
        var availableWidth = nv.utils.availableWidth(width, container, margin);
        var availableHeight = nv.utils.availableHeight(height, container, margin);
        var radius = Math.min(availableWidth, availableHeight) / 2;
        var path;
        nv.utils.initSVG(container);
        var wrap = container.selectAll('.nv-wrap.nv-sunburst').data(data);
        var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sunburst nv-chart-' + id);
        var g = wrapEnter.selectAll('nv-sunburst');
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        wrap.attr('transform', 'translate(' + availableWidth / 2 + ',' + availableHeight / 2 + ')');
        container.on('click', function (d, i) {
          dispatch.chartClick({
            data: d,
            index: i,
            pos: d3.event,
            id: id
          });
        });
        y.range([0, radius]);
        node = node || data;
        rootNode = data[0];
        partition.value(modes[mode] || modes.count);
        path = g.data(partition.nodes).enter().append('path').attr('d', arc).style('fill', function (d) {
          if (d.color) {
            return d.color;
          } else if (groupColorByParent) {
            return color((d.children ? d : d.parent).name);
          } else {
            return color(d.name);
          }
        }).style('stroke', '#FFF').on('click', function (d) {
          if (prevNode !== node && node !== d) {
            prevNode = node;
          }
          node = d;
          path.transition().duration(duration).attrTween('d', arcTweenZoom(d));
        }).each(stash).on('dblclick', function (d) {
          if (prevNode.parent === d) {
            path.transition().duration(duration).attrTween('d', arcTweenZoom(rootNode));
          }
        }).each(stash).on('mouseover', function (d) {
          d3.select(this).classed('hover', true).style('opacity', 0.8);
          dispatch.elementMouseover({
            data: d,
            color: d3.select(this).style('fill')
          });
        }).on('mouseout', function (d) {
          d3.select(this).classed('hover', false).style('opacity', 1);
          dispatch.elementMouseout({
            data: d
          });
        }).on('mousemove', function (d) {
          dispatch.elementMousemove({
            data: d
          });
        });
        function stash(d) {
          d.x0 = d.x;
          d.dx0 = d.dx;
        }
        function arcTweenZoom(d) {
          var xd = d3.interpolate(x.domain(), [d.x, d.x + d.dx]),
            yd = d3.interpolate(y.domain(), [d.y, 1]),
            yr = d3.interpolate(y.range(), [d.y ? 20 : 0, radius]);
          return function (d, i) {
            return i ? function () {
              return arc(d);
            } : function (t) {
              x.domain(xd(t));
              y.domain(yd(t)).range(yr(t));
              return arc(d);
            };
          };
        }
      });
      renderWatch.renderEnd('sunburst immediate');
      return chart;
    }
    chart.dispatch = dispatch;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      width: {
        get: function get() {
          return width;
        },
        set: function set(_) {
          width = _;
        }
      },
      height: {
        get: function get() {
          return height;
        },
        set: function set(_) {
          height = _;
        }
      },
      mode: {
        get: function get() {
          return mode;
        },
        set: function set(_) {
          mode = _;
        }
      },
      id: {
        get: function get() {
          return id;
        },
        set: function set(_) {
          id = _;
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
        }
      },
      groupColorByParent: {
        get: function get() {
          return groupColorByParent;
        },
        set: function set(_) {
          groupColorByParent = !!_;
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = nv.utils.getColor(_);
        }
      }
    });
    nv.utils.initOptions(chart);
    return chart;
  };
};
;// ./src/js/nv/models/sunburstChart.js

var sunburstChart = function sunburstChart(nv) {
  nv.models.sunburstChart = function () {
    var sunburst = nv.models.sunburst();
    var tooltip = nv.models.tooltip();
    var margin = {
        top: 30,
        right: 20,
        bottom: 20,
        left: 20
      },
      width = null,
      height = null,
      color = nv.utils.defaultColor(),
      defaultState = null,
      noData = null,
      duration = 250,
      dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd');
    tooltip.duration(0);
    var renderWatch = nv.utils.renderWatch(dispatch);
    tooltip.headerEnabled(false).valueFormatter(function (d) {
      return d;
    });
    function chart(selection) {
      renderWatch.reset();
      renderWatch.models(sunburst);
      selection.each(function (data) {
        var container = d3.select(this);
        nv.utils.initSVG(container);
        var availableWidth = nv.utils.availableWidth(width, container, margin),
          availableHeight = nv.utils.availableHeight(height, container, margin);
        chart.update = function () {
          if (duration === 0) {
            container.call(chart);
          } else {
            container.transition().duration(duration).call(chart);
          }
        };
        chart.container = this;
        if (!data || !data.length) {
          nv.utils.noData(chart, container);
          return chart;
        } else {
          container.selectAll('.nv-noData').remove();
        }
        var wrap = container.selectAll('g.nv-wrap.nv-sunburstChart').data(data);
        var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sunburstChart').append('g');
        var g = wrap.select('g');
        gEnter.append('g').attr('class', 'nv-sunburstWrap');
        wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        sunburst.width(availableWidth).height(availableHeight);
        var sunWrap = g.select('.nv-sunburstWrap').datum(data);
        d3.transition(sunWrap).call(sunburst);
      });
      renderWatch.renderEnd('sunburstChart immediate');
      return chart;
    }
    sunburst.dispatch.on('elementMouseover.tooltip', function (evt) {
      evt.series = {
        key: evt.data.name,
        value: evt.data.size,
        color: evt.color
      };
      tooltip.data(evt).hidden(false);
    });
    sunburst.dispatch.on('elementMouseout.tooltip', function () {
      tooltip.hidden(true);
    });
    sunburst.dispatch.on('elementMousemove.tooltip', function () {
      tooltip();
    });
    chart.dispatch = dispatch;
    chart.sunburst = sunburst;
    chart.tooltip = tooltip;
    chart.options = nv.utils.optionsFunc.bind(chart);
    chart._options = Object.create({}, {
      noData: {
        get: function get() {
          return noData;
        },
        set: function set(_) {
          noData = _;
        }
      },
      defaultState: {
        get: function get() {
          return defaultState;
        },
        set: function set(_) {
          defaultState = _;
        }
      },
      color: {
        get: function get() {
          return color;
        },
        set: function set(_) {
          color = _;
          sunburst.color(color);
        }
      },
      duration: {
        get: function get() {
          return duration;
        },
        set: function set(_) {
          duration = _;
          renderWatch.reset(duration);
          sunburst.duration(duration);
        }
      },
      margin: {
        get: function get() {
          return margin;
        },
        set: function set(_) {
          margin.top = _.top !== undefined ? _.top : margin.top;
          margin.right = _.right !== undefined ? _.right : margin.right;
          margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
          margin.left = _.left !== undefined ? _.left : margin.left;
        }
      }
    });
    nv.utils.inheritOptions(chart, sunburst);
    nv.utils.initOptions(chart);
    return chart;
  };
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__(1430);
;// ./src/js/utils.js
function utils_typeof(o) { "@babel/helpers - typeof"; return utils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, utils_typeof(o); }








function utils_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function utils_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, utils_toPropertyKey(o.key), o); } }
function utils_createClass(e, r, t) { return r && utils_defineProperties(e.prototype, r), t && utils_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function utils_defineProperty(e, r, t) { return (r = utils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function utils_toPropertyKey(t) { var i = utils_toPrimitive(t, "string"); return "symbol" == utils_typeof(i) ? i : i + ""; }
function utils_toPrimitive(t, r) { if ("object" != utils_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != utils_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var shouldStartWith = function shouldStartWith(term, selector) {
  return (term['0'] === selector ? '' : selector) + term;
};
var extractFontSize = function extractFontSize(fontSize) {
  return Number(fontSize.replace(/[^-\d.]/g, ''));
};
var renderStates = {
  START: 'Started',
  WAIT: 'Waiting',
  COMPLETE: 'Completed'
};
var wrapId = function wrapId(id) {
  return shouldStartWith(id, '#');
};
var exposeConfig = function exposeConfig(object, config) {
  external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(config, function (value, key) {
    if (!object.hasOwnProperty(key)) {
      object[key] = function (val) {
        if (arguments.length > 0) {
          config[key] = val;
          return object;
        } else {
          return config[key];
        }
      };
    }
  });
};
var utils_createElementIfAbsent = function createElementIfAbsent(container, elementClasses) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'g';
  var classesToSelect = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(elementClasses) ? elementClasses.join('.') : elementClasses;
  var classesToApply = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(elementClasses) ? elementClasses.join(' ') : elementClasses;
  if (container.select(".".concat(classesToSelect)).empty()) {
    container.append(element).attr('class', classesToApply);
  }
  return container.select(".".concat(classesToSelect));
};
var estimateMaxTextDimensions = function estimateMaxTextDimensions(width, height, value, cache, upperBound, lowerBound) {
  var estimatedFontSize = Math.min(estimateFontSize(width, height, value), upperBound),
    dimensions = {
      width: estimateWidthFromSize(estimatedFontSize, value),
      height: estimatedFontSize
    },
    textElement,
    svgElement,
    bBoxDimensions;
  if (!partialSvgSupport() && cache && cache.empty && !cache.empty()) {
    svgElement = utils_createElementIfAbsent(cache, 'svg-inner', 'g');
    svgElement.attr('width', width).attr('height', height);
    textElement = utils_createElementIfAbsent(svgElement, 'text-test-cache', 'text');
    textElement.style('font-size', estimatedFontSize + 'px').attr('transform', 'scale(1,1)').text(value);
    bBoxDimensions = textElement.node().getBBox();
    estimatedFontSize = Math.min(estimatedFontSize * (width / bBoxDimensions.width), estimatedFontSize * (height / bBoxDimensions.height));
    estimatedFontSize = Math.min(upperBound, estimatedFontSize);
    textElement.style('font-size', estimatedFontSize);
    bBoxDimensions = textElement.node().getBBox();
    dimensions.width = bBoxDimensions.width;
    dimensions.height = estimatedFontSize;
    cache.select('text').text('');
  }
  dimensions.fontSize = Math.max(lowerBound, Math.min(estimatedFontSize, upperBound));
  return dimensions;
};
var validFontWeight = function validFontWeight(fontWeight) {
  return !!(fontWeight && Constants.FONT_WEIGHTS[fontWeight.toString()]);
};
var getLineHeight = function getLineHeight(fontSize, padding) {
  return fontSize + padding;
};
var thresholdColor = function thresholdColor(threshold, value) {
  return d3.scale.threshold().domain(_.map(threshold, function (entry) {
    return entry.val;
  })).range(_.map(threshold, function (entry) {
    return entry.color;
  }))(value);
};
var gammaAdjustedNormalizedColor = function gammaAdjustedNormalizedColor(color) {
  var rgbColor = external_d3_default().rgb(color);
  return {
    r: Math.pow(rgbColor.r / 255, 2.2),
    g: Math.pow(rgbColor.g / 255, 2.2),
    b: Math.pow(rgbColor.b / 255, 2.2)
  };
};
var getColorLuminance = function getColorLuminance(color) {
  var rgbColor = gammaAdjustedNormalizedColor(color);
  return rgbColor.r * 0.2126 + rgbColor.g * 0.7151 + rgbColor.b * 0.07121;
};
var isDarkColor = function isDarkColor(color) {
  var luminence = getColorLuminance(color);
  return luminence < 0.179;
};
var getContrastingColor = function getContrastingColor(color) {
  var c = d3.rgb(color),
    yiq = (c.r * 299 + c.g * 587 + c.b * 114) / 1000;
  return yiq >= 128 ? '#000000' : '#ffffff';
};
var utils_inherit = function inherit(protoProps, staticProps) {
  var parent = this,
    child;
  if (protoProps && external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().has(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function child() {
      return parent.apply(this, arguments);
    };
  }
  Object.assign(child, parent, staticProps);
  child.prototype = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().create(parent.prototype, protoProps);
  child.prototype.constructor = child;
  child.__super__ = parent.prototype;
  return child;
};
var RenderLifeCycle = function () {
  function RenderLifeCycle() {
    var _this = this;
    utils_classCallCheck(this, RenderLifeCycle);
    utils_defineProperty(this, "_dispatch", external_d3_default().dispatch('renderEnd'));
    utils_defineProperty(this, "start", function () {
      _this.state = renderStates.START;
      _this.eventCount = 0;
    });
    utils_defineProperty(this, "watch", function (transition) {
      _this._watch(transition);
    });
    utils_defineProperty(this, "createWatcherWithCallback", function (onTransitionEnd) {
      return function (transition) {
        _this._watch(transition, onTransitionEnd);
      };
    });
    utils_defineProperty(this, "_watch", function (transition, onTransitionEnd) {
      var self = _this;
      if (_this.state !== renderStates.START) {
        throw new Error('Cannot add watcher before lifeCycle is started.[Call lifeCycle.start()]');
      }
      transition.each(function () {
        self.eventCount += 1;
      }).each('end', function () {
        if (--self.eventCount === 0) {
          self.renderComplete();
        }
        if (onTransitionEnd && typeof onTransitionEnd === 'function') {
          onTransitionEnd.apply(this, arguments);
        }
      });
    });
    utils_defineProperty(this, "dispatchOnCompletion", function () {
      _this.state = renderStates.WAIT;
      _this.renderComplete();
    });
    utils_defineProperty(this, "renderComplete", function () {
      if (_this.state === renderStates.WAIT && _this.eventCount === 0) {
        _this.state = renderStates.COMPLETE;
        _this.dispatch.renderEnd();
      }
    });
  }
  return utils_createClass(RenderLifeCycle, [{
    key: "dispatch",
    get: function get() {
      return this._dispatch;
    }
  }]);
}();
var wordWrap = function wordWrap(text, length) {
  text.each(function () {
    var textElement = external_d3_default().select(this),
      fontSize = extractFontSize(text.style('font-size')),
      textString = textElement.text(),
      textLength;
    try {
      textLength = textElement.node().getComputedTextLength();
      if (textLength > length) {
        textString = textString.substr(0, Math.floor(textString.length / textLength * length - 3)) + '...';
        textElement.text(textString);
      }
    } catch (_unused) {
      textElement.text(truncate(textString, length, fontSize));
    }
  });
};
var truncate = function truncate(str, length, fontSize) {
  var maxLetters = length / ((fontSize || constants_Constants.FONT_SIZE) * 0.7);
  return str.length > maxLetters ? str.substring(0, maxLetters - 3) + '...' : str;
};
var partialSvgSupport = function partialSvgSupport() {
  var ua = window.navigator.userAgent;
  if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {
    return true;
  } else {
    return false;
  }
};
var estimateFontSize = function estimateFontSize(width, height, value) {
  return _.isUndefined(value) ? 0 : Math.min(height, width / (('' + value).length * 0.6));
};
var estimateWidthFromSize = function estimateWidthFromSize(fontSize, value) {
  if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isUndefined(value)) {
    return 0;
  } else {
    var valueArray = value.toString().split('');
    return valueArray.reduce(function (width, char) {
      var multiplier = constants_Constants.CHAR_WIDTH_PROPORTIONS[char] || constants_Constants.DEFAULT_FONT_SIZE_PROPORTION;
      return width += fontSize * multiplier;
    }, 0);
  }
};
var utils_noop = function noop() {};
var isFunction = function isFunction(obj) {
  return typeof obj === 'function' || false;
};
var contains = function contains(array, obj) {
  return array.indexOf && array.indexOf(obj) !== -1 || false;
};
var formatPixels = function formatPixels(string) {
  return string + 'px';
};
var hash = function hash(string) {
  var hash = 0;
  for (var i = 0, len = string.length; i < len; i++) {
    var char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash && hash;
  }
  return hash;
};
var createSVGFromDirections = function createSVGFromDirections(directions) {
  var svg = directions.reduce(function (result, command) {
    var lineCommand = [];
    switch (command.type) {
      case constants_Constants.SVG_PATH_MOVE_COMMAND:
      case constants_Constants.SVG_PATH_LINE_COMMAND:
        lineCommand = [command.type, command.x, command.y];
        break;
      case constants_Constants.SVG_PATH_ARC_COMMAND:
        lineCommand = [command.type, command.rx, command.ry, command.xAxisRotation, command.largeArcFlag, command.sweepFlag, command.x, command.y];
        break;
      case constants_Constants.SVG_PATH_CLOSE_COMMAND:
        lineCommand = [command.type];
        break;
      case constants_Constants.SVG_PATH_BEZIER_COMMAND:
        lineCommand = [command.type, command.x1, command.y1, command.x, command.y];
        break;
    }
    return result + lineCommand.join(' ') + ' ';
  }, '');
  return svg;
};
var createTrianglePointer = function createTrianglePointer(offsetX, offsetY, base, height) {
  var triangleSVG = createSVGFromDirections([{
    type: constants_Constants.SVG_PATH_MOVE_COMMAND,
    x: -base / 2 + offsetX,
    y: offsetY
  }, {
    type: constants_Constants.SVG_PATH_LINE_COMMAND,
    x: offsetX,
    y: offsetY - height
  }, {
    type: constants_Constants.SVG_PATH_LINE_COMMAND,
    x: base / 2 + offsetX,
    y: offsetY
  }, {
    type: constants_Constants.SVG_PATH_CLOSE_COMMAND
  }]);
  return triangleSVG;
};
var createHalfCircleArc = function createHalfCircleArc(radius) {
  var arcSVG = createSVGFromDirections([{
    type: constants_Constants.SVG_PATH_MOVE_COMMAND,
    x: -radius,
    y: 0
  }, {
    type: constants_Constants.SVG_PATH_ARC_COMMAND,
    rx: radius,
    ry: radius,
    xAxisRotation: 0,
    largeArcFlag: 0,
    sweepFlag: 1,
    x: radius,
    y: 0
  }]);
  return arcSVG;
};
;// ./src/js/nv/chartHelpers/chartDimensions.js




var GROUP_INNER_PADDING_RATIO = 4;
var MIN_INNER_PADDING = 2;
var MAX_BAR_WIDTH = 16;
var ICON_WIDTH = 10;
var chartDimensions = function chartDimensions(nv) {
  function generateMultiChartLayout(availableWidth, axisCount, barCount, originalValueWidth, stacked) {
    var valueWidth = originalValueWidth;
    var barWidth = MAX_BAR_WIDTH;
    var innerPadding = getInnerPadding(barWidth, barCount, valueWidth);
    var groupWidth = getGroupWidth(barWidth, innerPadding, barCount);
    var groupPadding = getGroupPadding(availableWidth, axisCount, groupWidth);
    var requiredGroupPadding = getRequiredGroupPadding(innerPadding, barCount);
    while (barWidth > 1 && groupPadding < requiredGroupPadding) {
      barWidth--;
      if (valueWidth > barWidth) {
        valueWidth = 0;
        barWidth = MAX_BAR_WIDTH;
      }
      innerPadding = getInnerPadding(barWidth, barCount, valueWidth);
      groupWidth = getGroupWidth(barWidth, innerPadding, barCount);
      groupPadding = getGroupPadding(availableWidth, axisCount, groupWidth);
      requiredGroupPadding = getRequiredGroupPadding(innerPadding, barCount);
    }
    var step = groupWidth + groupPadding;
    var outerPadding = groupPadding / 2;
    var hideValues = stacked ? originalValueWidth > groupPadding + innerPadding - constants_Constants.BAR_VALUE_PADDING * 3 : originalValueWidth !== valueWidth;
    return {
      hideValues: hideValues,
      barWidth: barWidth,
      groupWidth: groupWidth,
      columnWidth: step,
      innerPaddingWidth: innerPadding,
      groupPaddingWidth: groupPadding,
      groupPaddingRatio: groupPadding / step,
      outerPaddingWidth: outerPadding,
      outerPaddingRatio: outerPadding / step,
      xRange: [0, availableWidth]
    };
  }
  function getInnerPadding(barWidth, barCount, valueWidth) {
    if (barCount <= 1) {
      return 0;
    }
    return getValuePadding(barWidth, valueWidth);
  }
  function getValuePadding(barWidth, valueWidth) {
    return valueWidth ? Math.max(0, valueWidth - barWidth) + constants_Constants.BAR_VALUE_PADDING : MIN_INNER_PADDING;
  }
  function getGroupWidth(barWidth, innerPadding, barCount) {
    return barWidth * barCount + innerPadding * (barCount - 1);
  }
  function getGroupPadding(availableWidth, axisCount, groupWidth) {
    var groupSpace = groupWidth * axisCount;
    var groupPadding = (availableWidth - groupSpace) / axisCount;
    return Math.max(Math.floor(groupPadding), 0);
  }
  function getRequiredGroupPadding(innerPadding, barCount, barWidth, valueWidth) {
    if (barCount <= 1) {
      return getValuePadding(barWidth, valueWidth);
    }
    return innerPadding * GROUP_INNER_PADDING_RATIO;
  }
  function getChartDimensions(availableWidth, data, numberOfDataGroups, stacked, dataBars1, dataBars2, valueWidth) {
    var barCount = (dataBars1 && dataBars1.length || 0) + (dataBars2 && dataBars2.length || 0);
    var barsPerGroup = stacked || data.length === 1 ? 1 : barCount;
    return generateMultiChartLayout(availableWidth, numberOfDataGroups, barsPerGroup, valueWidth, stacked);
  }
  function getTextValueWidthInfo(data, formatter, getY) {
    return data.reduce(function (sizeData, _ref) {
      var values = _ref.values;
      return sizeData.concat(values.map(function (d, i) {
        var valueText = formatter(getY(d, i), d);
        var iconWidth = d.icon || d.customIcon ? ICON_WIDTH : 0;
        var width = estimateWidthFromSize(constants_Constants.FONT_SIZE, valueText) + iconWidth;
        return {
          valueText: valueText,
          iconWidth: iconWidth,
          width: width
        };
      }));
    }, []);
  }
  nv.chartHelpers.getMaxValueWidth = function (dataBars1, dataBars2, valueFormat1, valueFormat2, getY) {
    if (!dataBars1.length && !dataBars2.length) {
      return 0;
    }
    var valueWidthInfo = getTextValueWidthInfo(dataBars1, valueFormat1, getY).concat(getTextValueWidthInfo(dataBars2, valueFormat2, getY));
    var _valueWidthInfo$reduc = valueWidthInfo.reduce(function (max, current) {
        return max.width > current.width ? max : current;
      }),
      width = _valueWidthInfo$reduc.width;
    return width;
  };
  nv.chartHelpers.getHorizontalChartDimensions = function (availableHeight, data, numberOfDataGroups, stacked, dataBars1, dataBars2, showValues) {
    var textHeight = showValues ? constants_Constants.FONT_SIZE : 0;
    return getChartDimensions(availableHeight, data, numberOfDataGroups, stacked, dataBars1, dataBars2, textHeight);
  };
  nv.chartHelpers.getChartDimensions = function (availableWidth, data, numberOfDataGroups, stacked, dataBars1, dataBars2, showValues, valueFormat1, valueFormat2, getY, container) {
    var valueWidth = showValues ? nv.chartHelpers.getMaxValueWidth(dataBars1, dataBars2, valueFormat1, valueFormat2, getY, container) : 0;
    return getChartDimensions(availableWidth, data, numberOfDataGroups, stacked, dataBars1, dataBars2, valueWidth);
  };
  nv.chartHelpers.getBarPosition = function (x, barWidth, innerPaddingWidth, d, data, padBefore, padAfter) {
    padBefore = padBefore || 0;
    padAfter = padAfter || 0;
    var pseudoPosition = d.series + padBefore;
    var pseudoLength = padBefore + padAfter + data.length;
    var offsetFromCenter = pseudoPosition - (pseudoLength - 1) / 2;
    var xStart = offsetFromCenter * (innerPaddingWidth + barWidth);
    var paddingOffset = (x.rangeBand() - barWidth) / 2;
    return Math.round(xStart + paddingOffset);
  };
  nv.chartHelpers.getStackedBarPosition = function (x, barWidth) {
    return Math.round((x.rangeBand() - barWidth) / 2);
  };
  nv.chartHelpers.upgradedGetBarPosition = function (x, barWidth, innerPaddingWidth, d, data, padBefore, padAfter) {
    padBefore = padBefore || 0;
    padAfter = padAfter || 0;
    var pseudoPosition = d.series + padBefore;
    var pseudoLength = padBefore + padAfter + data.length;
    var offsetFromCenter = pseudoPosition - (pseudoLength - 1) / 2;
    var xStart = offsetFromCenter * (innerPaddingWidth + barWidth);
    var paddingOffset = (x.bandwidth() - barWidth) / 2;
    return Math.round(xStart + paddingOffset);
  };
  nv.chartHelpers.upgradedGetStackedBarPosition = function (x, barWidth) {
    return Math.round((x.bandwidth() - barWidth) / 2);
  };
};
;// ./src/js/nv/tooltip_interaction.js






function tooltip_interaction_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = tooltip_interaction_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function tooltip_interaction_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return tooltip_interaction_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? tooltip_interaction_arrayLikeToArray(r, a) : void 0; } }
function tooltip_interaction_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var tooltipInteraction = function tooltipInteraction() {
  document.addEventListener('touchmove', _.debounce(onScroll, 300, {
    leading: true
  }), false);
  document.addEventListener('scroll', _.debounce(onScroll, 300, {
    leading: true
  }), false);
  function onScroll() {
    var elements = document.getElementsByClassName('nvtooltip');
    var _iterator = tooltip_interaction_createForOfIteratorHelper(elements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        element.style.opacity = 0;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
;// ./src/js/nv/index.js











































var nv_nv = {};
core(nv_nv);
dom(nv_nv);
utils(nv_nv);
upgradedUtils(nv_nv);
tooltip(nv_nv);
upgradedTooltip(nv_nv);
patternService(nv_nv);
axis(nv_nv);
upgradedAxis(nv_nv);
boxPlot(nv_nv);
boxPlotChart(nv_nv);
bullet(nv_nv);
bulletChart(nv_nv);
cumulativeLineChart(nv_nv);
discreteBar(nv_nv);
discreteBarChart(nv_nv);
distribution(nv_nv);
historicalBar(nv_nv);
historicalBarChart(nv_nv);
legend(nv_nv);
upgradedLegend(nv_nv);
line(nv_nv);
lineChart(nv_nv);
multiBar(nv_nv);
multiBarChart(nv_nv);
multiBarHorizontal(nv_nv);
multiBarHorizontalChart(nv_nv);
multiChart(nv_nv);
pie(nv_nv);
pieChart(nv_nv);
scatter(nv_nv);
upgradedScatter(nv_nv);
scatterChart(nv_nv);
upgradedScatterChart(nv_nv);
quadrantChart(nv_nv);
sparkline(nv_nv);
sparklinePlus(nv_nv);
stackedArea(nv_nv);
stackedAreaChart(nv_nv);
sunburst(nv_nv);
sunburstChart(nv_nv);
chartDimensions(nv_nv);
tooltipInteraction(nv_nv);
/* harmony default export */ var js_nv = (nv_nv);
;// ./src/js/viz/nvd3/utils/utils.js












var DIGITS_REGEX = /[0-9]/g;
var utils_TICK_PADDING = 4;
var DEFAULT_LINE_HEIGHT = constants_Constants.FONT_SIZE + 3;
var calculateMarginHorizontal = function calculateMarginHorizontal(options) {
  var margin = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  if (options.hasXAxis) {
    margin.left += options.maxXValueSize || 100;
    options.hasXAxisLabel && (margin.left += 25);
  }
  if (options.hasYAxis) {
    margin.bottom += (options.lineHeight || DEFAULT_LINE_HEIGHT) + utils_TICK_PADDING;
    options.hasYAxisLabel && (margin.bottom += 25);
  }
  return margin;
};
var calculateMarginVertical = function calculateMarginVertical(options) {
  var margin = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  var _options$lineCount = options.lineCount,
    lineCount = _options$lineCount === void 0 ? 2 : _options$lineCount,
    _options$lineHeight = options.lineHeight,
    labelSize = _options$lineHeight === void 0 ? DEFAULT_LINE_HEIGHT : _options$lineHeight,
    _options$maxYAxisValu = options.maxYAxisValueSize,
    maxYAxisValueSize = _options$maxYAxisValu === void 0 ? 40 : _options$maxYAxisValu,
    _options$hasYAxis = options.hasYAxis,
    hasYAxis = _options$hasYAxis === void 0 ? false : _options$hasYAxis,
    _options$xAxisTickLef = options.xAxisTickLeftPadding,
    xAxisTickLeftPadding = _options$xAxisTickLef === void 0 ? 0 : _options$xAxisTickLef,
    _options$hasYAxisLabe = options.hasYAxisLabel,
    hasYAxisLabel = _options$hasYAxisLabe === void 0 ? false : _options$hasYAxisLabe,
    _options$yAxisLabelPa = options.yAxisLabelPadding,
    yAxisLabelPadding = _options$yAxisLabelPa === void 0 ? 0 : _options$yAxisLabelPa,
    _options$hasYAxis2 = options.hasYAxis2,
    hasYAxis2 = _options$hasYAxis2 === void 0 ? false : _options$hasYAxis2,
    _options$maxYAxis2Val = options.maxYAxis2ValueSize,
    maxYAxis2ValueSize = _options$maxYAxis2Val === void 0 ? 0 : _options$maxYAxis2Val,
    _options$hasYAxis2Lab = options.hasYAxis2Label,
    hasYAxis2Label = _options$hasYAxis2Lab === void 0 ? false : _options$hasYAxis2Lab,
    _options$hasXAxis = options.hasXAxis,
    hasXAxis = _options$hasXAxis === void 0 ? false : _options$hasXAxis,
    _options$hasXAxisLabe = options.hasXAxisLabel,
    hasXAxisLabel = _options$hasXAxisLabe === void 0 ? false : _options$hasXAxisLabe,
    _options$xAxisLabelPa = options.xAxisLabelPadding,
    xAxisLabelPadding = _options$xAxisLabelPa === void 0 ? 0 : _options$xAxisLabelPa,
    _options$dataLabelOve = options.dataLabelOverflow,
    dataLabelOverflow = _options$dataLabelOve === void 0 ? 0 : _options$dataLabelOve,
    _options$splitYAxes = options.splitYAxes,
    splitYAxes = _options$splitYAxes === void 0 ? false : _options$splitYAxes;
  var maxLeftYValueSize = Math.max(maxYAxisValueSize, splitYAxes ? maxYAxis2ValueSize : 0);
  var yLabelPadding = labelSize + 2 + yAxisLabelPadding;
  margin.leftLabel = hasYAxis ? Math.max(maxLeftYValueSize, xAxisTickLeftPadding) : xAxisTickLeftPadding;
  margin.left += margin.leftLabel;
  margin.left += hasYAxisLabel ? yLabelPadding : 0;
  if (hasYAxis2 && !splitYAxes) {
    var yAxisTickLabelPadding = maxYAxis2ValueSize * 2;
    margin.right += yAxisTickLabelPadding;
    margin.right += hasYAxis2Label ? yLabelPadding : 0;
    margin.rightLabel = yAxisTickLabelPadding;
  }
  if (hasXAxis) {
    margin.bottom += lineCount * labelSize + 10 + 4;
  }
  if (hasXAxisLabel) {
    margin.bottom += labelSize;
    margin.bottom += xAxisLabelPadding;
  }
  if (dataLabelOverflow) {
    margin.right = Math.max(margin.right, dataLabelOverflow);
  }
  return margin;
};
var mergeMargin = function mergeMargin(margin1, margin2) {
  var keys = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().union(external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().keys(margin1), external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().keys(margin2)),
    margin = {};
  external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(keys, function (key) {
    margin[key] = (margin1[key] || 0) + (margin2[key] || 0);
  });
  return margin;
};
var roundMargin = function roundMargin(margin) {
  return Object.keys(margin).reduce(function (roundedMargin, prop) {
    roundedMargin[prop] = Math.round(margin[prop]);
    return roundedMargin;
  }, {});
};
var utils_calculateMargin = function calculateMargin(margin, options) {
  var horizontalChart = options.horizontalChart;
  if (horizontalChart) {
    margin = mergeMargin(margin, calculateMarginHorizontal(options));
  } else {
    margin = mergeMargin(margin, calculateMarginVertical(options));
  }
  if (!margin.left && options.hasYAxis) {
    margin.left = 10;
  }
  if (!margin.bottom && options.hasXAxis) {
    margin.bottom = 10;
  }
  return roundMargin(margin);
};
var attachRenderEndCallback = function attachRenderEndCallback(chart, callback) {
  chart && chart.dispatch && chart.dispatch.on('renderEnd', callback || (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).noop);
};
var approximateTextLength = function approximateTextLength(value, fontSize) {
  var specialChars,
    otherCharsCount,
    specialCharsCount,
    wCount = 0;
  value = '' + value;
  specialChars = value.match(/\.|,/g);
  specialCharsCount = specialChars ? specialChars.length : 0;
  otherCharsCount = value.length - specialCharsCount;
  if (value.indexOf('w') !== -1 || value.indexOf('W') !== -1) {
    wCount = value.match(/w|W/g) ? value.match(/w|W/g).length : 0;
    otherCharsCount -= wCount;
  }
  fontSize || (fontSize = Constants.FONT_SIZE);
  return Math.ceil(otherCharsCount * 0.67 * fontSize + specialCharsCount * fontSize * 0.25 + wCount * fontSize);
};
var getMaxYValue = function getMaxYValue(formatTick, data) {
  var maxAlias = (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).maxBy || (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).max;
  var maxYValue = '' + formatTick(maxAlias(data, function (point) {
    if (point.y === undefined) {
      return 0;
    }
    return ('' + formatTick(point.y)).length;
  }).y);
  return maxYValue.replace(DIGITS_REGEX, '9');
};
var getMaxY1AxisLength = function getMaxY1AxisLength(data, formatTick, container) {
  var y1AxisFontSize = getY1FontSize(container);
  var maxYValue = getMaxYValue(formatTick, data);
  return utils_getTextLength(maxYValue, y1AxisFontSize, container);
};
var getMaxY2AxisLength = function getMaxY2AxisLength(data, formatTick, container) {
  var y2AxisFontSize = getY2FontSize(container);
  var maxYValue = getMaxYValue(formatTick, data);
  return utils_getTextLength(maxYValue, y2AxisFontSize, container);
};
var getY1FontSize = function getY1FontSize(container) {
  var selectionClass = '.nv-y1 text';
  return getYFontSize(container, selectionClass);
};
var getY2FontSize = function getY2FontSize(container) {
  var selectionClass = '.nv-y2 text';
  return getYFontSize(container, selectionClass);
};
var getYFontSize = function getYFontSize(container, selectionClass) {
  if (container) {
    var d3SelectionContainer = container.select(selectionClass);
    if (!d3SelectionContainer.empty()) {
      return parseFloat(d3SelectionContainer.style('font-size'));
    }
  }
  return undefined;
};
var utils_getTextLength = function getTextLength(value, fontSize, container, noCorrection) {
  var element = utils_createElementIfAbsent(container, 'experiment-cache-container', 'text');
  element.text(value).style('font-size', fontSize ? "".concat(fontSize, "px") : null);
  var textLength = element.node().getComputedTextLength() + (noCorrection ? 0 : getTextLengthCorrection(container));
  element.text('').style('font-size', null);
  return textLength;
};
var getWrappedTextLength = function getWrappedTextLength(value, fontSize, container, maxWidth, maxLines) {
  var element = createElementIfAbsent(container, 'experiment-cache-container', 'text');
  element.text(value).style('font-size', fontSize ? fontSize + 'px' : null).call(nv.utils.wrapTicks, maxWidth, maxLines || 2);
  var textLength = element.node().getBBox().width;
  element.text('').style('font-size', null);
  return textLength;
};
var SPECIAL_FONTS = ['georgia', 'verdana'];
var DEFAULT_SPACING = 2;
var EXTRA_SPACING = 6;
function getTextLengthCorrection(container) {
  var fontFamily = container.style('font-family') || '';
  var currentFont = fontFamily.split(', ')[0] || '';
  currentFont = currentFont.toLowerCase();
  if (SPECIAL_FONTS.includes(currentFont)) {
    return EXTRA_SPACING;
  }
  return DEFAULT_SPACING;
}
var getTextHeight = function getTextHeight(value, fontSize, container) {
  if (partialSvgSupport()) {
    return (fontSize || constants_Constants.FONT_SIZE) + 2;
  }
  var element = utils_createElementIfAbsent(container, 'experiment-cache-container', 'text'),
    height;
  element.text(value).style('font-size', fontSize ? fontSize + 'px' : null);
  height = element.node().getBBox().height + 1;
  element.text('').style('font-size', null);
  return height;
};
var countNonDecimalDigits = function countNonDecimalDigits(number) {
  return number.toString().split('.')[0].length || 1;
};
var countDecimalDigits = function countDecimalDigits(number) {
  if (Math.floor(number) === number) {
    return 0;
  }
  return number.toString().split('.')[1].length || 0;
};
;// ./src/js/viz/nvd3/utils/x_axis_labels/compute_label_dimensions.js


var computeLabelDimensions = function computeLabelDimensions(labels, fontSize, container) {
  return labels.map(function (label) {
    var labelLength = utils_getTextLength(label, fontSize, container);
    var words = label.split(/\s+/);
    var wordLengths = words.map(function (word) {
      return utils_getTextLength(word, fontSize, container);
    });
    return {
      labelLength: labelLength,
      wordLengths: wordLengths,
      label: label
    };
  });
};
;// ./src/js/viz/nvd3/utils/x_axis_labels/generate_estimated_layout.js







function generate_estimated_layout_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = generate_estimated_layout_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function generate_estimated_layout_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return generate_estimated_layout_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? generate_estimated_layout_arrayLikeToArray(r, a) : void 0; } }
function generate_estimated_layout_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var generateEstimatedLayout = function generateEstimatedLayout(labelDimensions, maxSpacePerLine, maxLineCount, whiteSpaceSize) {
  var completelyRenderedLabelCount = 0;
  var minimumLabelPercentage = 1;
  var requiredLineCount = 1;
  var maxLineSpaceUsed = 0;
  labelDimensions.forEach(function (labelDimension) {
    var wordLayout = generateWordLayout(labelDimension, maxSpacePerLine, maxLineCount, whiteSpaceSize);
    if (wordLayout.renderedWordCount === labelDimension.wordLengths.length) {
      completelyRenderedLabelCount += 1;
    }
    requiredLineCount = Math.max(wordLayout.linesUsed, requiredLineCount);
    minimumLabelPercentage = Math.min(minimumLabelPercentage, wordLayout.renderedWordCount / labelDimension.wordLengths.length);
    maxLineSpaceUsed = Math.max(wordLayout.maxLineSpaceUsed, maxLineSpaceUsed);
  });
  return {
    requiredLineCount: requiredLineCount,
    minimumLabelPercentage: minimumLabelPercentage,
    completeRatio: completelyRenderedLabelCount / labelDimensions.length,
    maxLineSpaceUsed: maxLineSpaceUsed
  };
};
var generateWordLayout = function generateWordLayout(labelDimension, maxSpacePerLine, maxLineCount, whiteSpaceSize) {
  if (labelDimension.labelLength < maxSpacePerLine) {
    return {
      renderedWordCount: labelDimension.wordLengths.length,
      linesUsed: 1,
      maxLineSpaceUsed: labelDimension.labelLength
    };
  }
  var renderedWordCount = 0;
  var maxLineSpaceUsed = 0;
  var linesUsed = 1;
  var lineLength = 0;
  var _iterator = generate_estimated_layout_createForOfIteratorHelper(labelDimension.wordLengths),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var wordLength = _step.value;
      if (wordLength > maxSpacePerLine) {
        break;
      }
      if (getLineLengthWithNewWord(lineLength, wordLength, whiteSpaceSize) > maxSpacePerLine) {
        maxLineSpaceUsed = Math.max(maxLineSpaceUsed, lineLength);
        if (reachedMaxLineCount(linesUsed, maxLineCount)) {
          break;
        }
        linesUsed += 1;
        lineLength = 0;
      }
      lineLength = getLineLengthWithNewWord(lineLength, wordLength, whiteSpaceSize);
      renderedWordCount += 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    renderedWordCount: renderedWordCount,
    maxLineSpaceUsed: maxLineSpaceUsed,
    linesUsed: linesUsed
  };
};
var reachedMaxLineCount = function reachedMaxLineCount(linesUsed, maxLineCount) {
  return linesUsed >= maxLineCount;
};
var getLineLengthWithNewWord = function getLineLengthWithNewWord(lineLength, wordLength, whiteSpaceSize) {
  return lineLength + wordLength + (lineLength !== 0 ? whiteSpaceSize : 0);
};
;// ./src/js/viz/nvd3/utils/x_axis_labels/label_layout_generator.js




var NINETY_DEG = 90;
var MAX_LABEL_HEIGHT_PERCENTAGE = 0.3;
var HORIZONTAL_PCT_THRESHOLD = 0.8;
var WHITE_SPACE = ' ';
function labelLayoutGenerator(container, fontSize, availableHeight, availableWidth, labels, leftMarginSpace, specifiedAngleDegrees) {
  var labelDimensions = computeLabelDimensions(labels, fontSize, container);
  var rotateDegrees = specifiedAngleDegrees || NINETY_DEG;
  var rotateRadians = rotateDegrees * (Math.PI / 180);
  var maxHeight = Math.floor(availableHeight * MAX_LABEL_HEIGHT_PERCENTAGE);
  var lineHeight = getTextHeight(findNonEmptyLabel(labels), fontSize, container);
  var whiteSpaceSize = utils_getTextLength(WHITE_SPACE, fontSize, container);
  var straightMaxWidth = availableWidth;
  var straightLineCount = Math.floor(maxHeight / lineHeight);
  var straightLayout = generateEstimatedLayout(labelDimensions, straightMaxWidth, straightLineCount, whiteSpaceSize);
  var straightResult = generateResultForStraightLayout(straightLayout, lineHeight, availableWidth);
  if (specifiedAngleDegrees === 0 || straightLayout.completeRatio > HORIZONTAL_PCT_THRESHOLD) {
    return straightResult;
  }
  if (rotateDegrees === NINETY_DEG) {
    var verticalMaxLine = Math.max(1, Math.floor(availableWidth / lineHeight));
    var verticalLayout = generateEstimatedLayout(labelDimensions, maxHeight, verticalMaxLine, whiteSpaceSize);
    var verticalResult = generateResultForVerticalLayout(verticalLayout, maxHeight, lineHeight);
    return verticalLayout.completeRatio > straightLayout.completeRatio ? verticalResult : straightResult;
  }
  var angledMaxWidth = getAngledSpacePerLabel(maxHeight, availableWidth, lineHeight, leftMarginSpace || 0, rotateRadians);
  var angledLineCount = Math.floor(availableWidth / lineHeight);
  var angledLayout = generateEstimatedLayout(labelDimensions, angledMaxWidth, angledLineCount, whiteSpaceSize);
  var angledResult = generateResultForAngledLayout(angledLayout, angledMaxWidth, rotateDegrees, rotateRadians);
  return angledLayout.completeRatio > straightLayout.completeRatio ? angledResult : straightResult;
}
var getAngledSpacePerLabel = function getAngledSpacePerLabel(maxHeight, spacePerLabel, lineHeight, leftMarginSpace, rotateRadians) {
  if (spacePerLabel < lineHeight) {
    return 0;
  }
  var horizontalSpacing = spacePerLabel + leftMarginSpace;
  return Math.min(Math.floor(maxHeight / Math.sin(rotateRadians)), Math.floor(horizontalSpacing / Math.cos(rotateRadians)));
};
var generateResultForStraightLayout = function generateResultForStraightLayout(straightLabelLayout, lineHeight, spacePerLabel) {
  return {
    maxWidth: spacePerLabel,
    maxHeight: straightLabelLayout.requiredLineCount * lineHeight,
    maxLineSpaceUsed: spacePerLabel,
    lineCount: straightLabelLayout.requiredLineCount,
    angle: 0
  };
};
var generateResultForAngledLayout = function generateResultForAngledLayout(angledLabelLayout, angledSpacePerLabel, rotateDegrees, rotateRadians) {
  return {
    maxHeight: Math.ceil(angledLabelLayout.maxLineSpaceUsed * Math.sin(rotateRadians)) + 1,
    maxWidth: Math.ceil(angledLabelLayout.maxLineSpaceUsed * Math.cos(rotateRadians)) + 1,
    maxLineSpaceUsed: angledLabelLayout.maxLineSpaceUsed,
    lineCount: angledLabelLayout.requiredLineCount,
    angle: -1 * rotateDegrees
  };
};
var generateResultForVerticalLayout = function generateResultForVerticalLayout(verticalLayout, maxHeight, lineHeight) {
  var maxHeightUsed = Math.min(verticalLayout.maxLineSpaceUsed, maxHeight);
  return {
    maxWidth: verticalLayout.requiredLineCount * lineHeight,
    maxHeight: maxHeightUsed,
    maxLineSpaceUsed: maxHeightUsed,
    lineCount: verticalLayout.requiredLineCount,
    angle: -NINETY_DEG
  };
};
var findNonEmptyLabel = function findNonEmptyLabel(labels) {
  return labels.find(function (label) {
    return label && label.trim() !== '';
  }) || '';
};
;// ./src/js/viz/nvd3/utils/index.js


;// ./src/js/viz/nvd3/layouts/chart_layout.js








var LEGEND_PADDING = 16;
var ChartLayout = function ChartLayout() {
  this.initialize.apply(this, arguments);
  return this;
};
ChartLayout.extend = utils_inherit;
Object.assign(ChartLayout.prototype, {
  initialize: function initialize() {
    this._hostedRegions = {};
  },
  regions: ['legend', 'yAxis', 'xAxis', 'chart', 'referenceLines', 'quadrantColors', 'quadrantLabels', 'axisLabels'],
  margin: {
    top: 0,
    right: 16,
    bottom: 16,
    left: 16
  },
  _regionToContainer: {
    legend: '.dq-legend-container',
    xAxis: '.dq-xAxis-container',
    yAxis: '.dq-yAxis-container',
    chart: '.dq-chart-container',
    referenceLines: '.dq-reference-line-container',
    quadrantColors: '.dq-quadrant-color-container',
    quadrantLabels: '.dq-quadrant-label-container',
    axisLabels: '.dq-axis-labels-container'
  },
  attachCallback: function attachCallback(postRender) {
    var callbackCount = 0,
      callbackAggregator = function callbackAggregator() {
        callbackCount--;
        if (callbackCount === 0) {
          postRender();
        }
      };
    external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(this._hostedRegions, function (element, key) {
      if (key === 'chart') {
        callbackCount += 1;
        attachRenderEndCallback(element.component, callbackAggregator);
      } else if (element && element.component && element.component.lifeCycle) {
        callbackCount += 1;
        element.component.lifeCycle.dispatch.on('renderEnd', callbackAggregator);
      }
    });
  },
  _hostedRegions: null,
  renderHostedComponents: function renderHostedComponents(options) {
    var containerDimensions = options.containerDimensions,
      container = options.container,
      postRender = options.postRender,
      animationDuration = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isNumber(options.animationDuration) ? options.animationDuration : constants_Constants.ANIMATION_DURATION;
    this.container = container;
    this.calculateDimensions(containerDimensions, options.margin);
    if (postRender) {
      this.attachCallback(postRender);
    }
    if (this._hostedRegions.xAxis || this._hostedRegions.yAxis) {
      this.arrangeAndDrawAxis(container);
    }
    if (this._hostedRegions.chart) {
      var chartContainerId = this._regionToContainer.chart;
      if (container.select(chartContainerId).empty()) {
        container.append('g').attr('class', 'dq-chart-container');
      }
    }
    if (this._hostedRegions.legend) {
      this.arrangeAndDrawLegend(container, animationDuration);
    }
    if (this._hostedRegions.chart) {
      this.arrangeAndDrawChart(container);
    }
    if (this._hostedRegions.referenceLines) {
      this.arrangeAndDrawReference(container);
    }
    if (this._hostedRegions.quadrantColors) {
      this.arrangeAndDrawQuadrantColors(container);
    }
    if (this._hostedRegions.quadrantLabels) {
      this.arrangeAndDrawQuadrantLabels(container);
    }
    if (this._hostedRegions.axisLabels) {
      this.arrangeAndDrawAxisLabels(container);
    }
  },
  arrangeAndDrawLegend: function arrangeAndDrawLegend(container, animationDuration) {
    var legend = this._hostedRegions.legend.component,
      data = this._hostedRegions.legend.data,
      margin = this.margin,
      legendX = margin.left,
      legendY = margin.top,
      legendContainerId = this._regionToContainer.legend,
      legendDistance = legend.distance(),
      legendHeight,
      legendWidth,
      self = this;
    legend.width(this.availableWidth - margin.left - margin.right).height(this.availableHeight);
    switch (legend.position()) {
      case 'top':
      case 'bottom':
        legend.orientation('horizontal');
        break;
      case 'right':
        legend.orientation('vertical');
    }
    if (container.select(legendContainerId).empty()) {
      container.append('g').classed('dq-legend-container', true);
    }
    container.selectAll(legendContainerId).datum(data).call(legend);
    switch (legend.position()) {
      case 'top':
        legendHeight = legend.height() + legendDistance;
        this.availableHeight -= legendHeight;
        this.chartY += legendHeight;
        break;
      case 'bottom':
        legendHeight = legend.height() + legendDistance;
        this.availableHeight -= legendHeight;
        legendY = this.availableHeight + this.margin.top + legendDistance;
        break;
      case 'right':
        legendWidth = legend.width() + legendDistance;
        legendX = this.availableWidth - legendWidth + LEGEND_PADDING;
        this.availableWidth -= legendWidth;
    }
    legend.dispatch.on('legendClick', function () {
      self.arrangeAndDrawChart(container);
    });
    return container.selectAll(legendContainerId).transition().duration(animationDuration).attr('transform', 'translate(' + legendX + ', ' + legendY + ')');
  },
  arrangeAndDrawReference: function arrangeAndDrawReference(container) {
    var chart = this._hostedRegions.chart.component,
      referenceLines = this._hostedRegions.referenceLines.component,
      data = this._hostedRegions.referenceLines.data,
      chartContainerId = this._regionToContainer.chart,
      referenceLineContainerId = this._regionToContainer.referenceLines,
      chartMargin = chart.margin(),
      width = this.availableWidth - chartMargin.left - chartMargin.right,
      height = this.availableHeight - chartMargin.top - chartMargin.bottom,
      currentX = this.chartX + chartMargin.left,
      currentY = this.chartY + chartMargin.top;
    if (container.select(referenceLineContainerId).empty()) {
      container.insert('g', chartContainerId).attr('class', 'dq-reference-line-container');
    }
    referenceLines.width(width).height(height);
    return container.selectAll(referenceLineContainerId).datum(data).attr('transform', 'translate(' + currentX + ',' + currentY + ')').call(referenceLines);
  },
  arrangeAndDrawQuadrantColors: function arrangeAndDrawQuadrantColors(container) {
    var chart = this._hostedRegions.chart.component,
      quadrantColors = this._hostedRegions.quadrantColors.component,
      data = this._hostedRegions.quadrantColors.data,
      chartContainerId = this._regionToContainer.chart,
      quadrantColorsContainerId = this._regionToContainer.quadrantColors,
      chartMargin = chart.margin(),
      width = this.availableWidth - chartMargin.left - chartMargin.right,
      height = this.availableHeight - chartMargin.top - chartMargin.bottom,
      currentX = this.chartX + chartMargin.left,
      currentY = this.chartY + chartMargin.top;
    if (container.select(quadrantColorsContainerId).empty()) {
      container.insert('g', chartContainerId).attr('class', 'dq-quadrant-color-container');
    }
    quadrantColors.width(width).height(height);
    return container.selectAll(quadrantColorsContainerId).datum(data).attr('transform', 'translate(' + currentX + ',' + currentY + ')').call(quadrantColors);
  },
  arrangeAndDrawQuadrantLabels: function arrangeAndDrawQuadrantLabels(container) {
    var chart = this._hostedRegions.chart.component,
      quadrantLabels = this._hostedRegions.quadrantLabels.component,
      data = this._hostedRegions.quadrantLabels.data,
      chartContainerId = this._regionToContainer.chart,
      quadrantLabelsContainerId = this._regionToContainer.quadrantLabels,
      chartMargin = chart.margin(),
      width = this.availableWidth - chartMargin.left - chartMargin.right,
      height = this.availableHeight - chartMargin.top - chartMargin.bottom,
      currentX = this.chartX + chartMargin.left,
      currentY = this.chartY + chartMargin.top;
    if (container.select(quadrantLabelsContainerId).empty()) {
      container.insert('g', chartContainerId).attr('class', 'dq-quadrant-label-container');
    }
    quadrantLabels.width(width).height(height);
    return container.selectAll(quadrantLabelsContainerId).datum(data).attr('transform', 'translate(' + currentX + ',' + currentY + ')').call(quadrantLabels);
  },
  arrangeAndDrawAxisLabels: function arrangeAndDrawAxisLabels(container) {
    var chart = this._hostedRegions.chart.component;
    var axisLabels = this._hostedRegions.axisLabels.component;
    var data = this._hostedRegions.axisLabels.data;
    var chartContainerId = this._regionToContainer.chart;
    var axisLabelsContainerId = this._regionToContainer.axisLabels;
    var chartMargin = chart.margin();
    var width = this.availableWidth - chartMargin.left - chartMargin.right;
    var height = this.availableHeight - chartMargin.top - chartMargin.bottom;
    var currentX = this.chartX + chartMargin.left;
    var currentY = this.chartY + chartMargin.top;
    if (container.select(axisLabelsContainerId).empty()) {
      container.insert('g', chartContainerId).attr('class', 'dq-axis-labels-container');
    }
    axisLabels.width(width).height(height);
    return container.selectAll(axisLabelsContainerId).datum(data).attr('transform', 'translate(' + currentX + ',' + currentY + ')').call(axisLabels);
  },
  arrangeAndDrawChart: function arrangeAndDrawChart(container) {
    var chart = this._hostedRegions.chart.component,
      data = this._hostedRegions.chart.data,
      chartContainerId = this._regionToContainer.chart;
    chart.width(this.availableWidth).height(this.availableHeight);
    if (container.select(chartContainerId).empty()) {
      container.append('g').attr('class', 'dq-chart-container');
    }
    return container.selectAll(chartContainerId).datum(data).attr('transform', 'translate(' + this.chartX + ', ' + this.chartY + ')').call(chart);
  },
  host: function host(region, component, data) {
    if (!this.regions.includes(region)) {
      console.log(region + ' is not a valid region.');
    } else {
      this._hostedRegions[region] = {
        component: component,
        data: data
      };
    }
  },
  remove: function remove(region) {
    var component = this._hostedRegions[region],
      componentContainer;
    if (component && this.container) {
      componentContainer = this.container.select(this._regionToContainer[region]);
      component.remove && component.remove();
      if (!componentContainer.empty()) {
        componentContainer.remove();
      }
    }
    this._hostedRegions[region] = null;
  },
  calculateDimensions: function calculateDimensions(containerDimensions, margin) {
    this.margin = Object.assign({}, this.margin, margin || {});
    this.availableHeight = this.height = containerDimensions.height - this.margin.top - this.margin.bottom;
    this.chartY = this.margin.top;
    this.availableWidth = this.width = containerDimensions.width;
    this.chartX = 0;
  }
});
;// ./src/js/viz/nvd3/charts/upgraded_nv_core.js





var UpgradedNvCore = function UpgradedNvCore() {
  this.initialize.apply(this, arguments);
};
UpgradedNvCore.extend = utils_inherit;
Object.assign(UpgradedNvCore.prototype, {
  initialize: function initialize(options) {
    if (options.containerId) {
      this.parentContainerId = options.containerId;
    }
    this.clearContainer();
    this.wrapContainer();
    this.wrapRender();
    this.wrapResize();
    return this;
  },
  clearContainer: function clearContainer() {
    var parentContainer = this.getParentContainer();
    if (this.parentContainerId && !parentContainer.empty()) {
      parentContainer.html('');
    }
  },
  wrapContainer: function wrapContainer() {
    var parentContainer = this.getParentContainer();
    if (!this.parentContainerId) {
      return false;
    }
    if (this.containerId && !this.getContainer().empty()) {
      return false;
    }
    if (!this.containerId) {
      this.containerId = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().uniqueId('NvD3Chart');
    }
    parentContainer.append('svg').attr('id', this.containerId).classed('dq', true).classed((less_default()).dq, true);
    return true;
  },
  wrapRender: function wrapRender() {
    var renderFn = this.render;
    this.render = function () {
      if (this.getParentContainer().empty()) {
        return;
      }
      this.wrapContainer();
      this.resizeContainer();
      renderFn.apply(this, arguments);
    };
  },
  wrapResize: function wrapResize() {
    var resizeFn = this.resize;
    this.resize = function () {
      if (this.getParentContainer().empty()) {
        return;
      }
      this.wrapContainer();
      resizeFn.apply(this, arguments);
    };
  },
  setContainerDimensions: function setContainerDimensions(width, height) {
    var svgContainer = this.getContainer();
    if (svgContainer) {
      svgContainer.attr('width', width).attr('height', height);
    }
  },
  resizeContainer: function resizeContainer() {
    var parentContainer = this.getParentContainer(),
      containerDimensions;
    if (parentContainer.empty()) {
      return;
    }
    this.setContainerDimensions(1, 1);
    containerDimensions = this.getContainerDimensions();
    this.setContainerDimensions(containerDimensions.width, containerDimensions.height);
  },
  getParentContainer: function getParentContainer() {
    return src_select(wrapId(this.parentContainerId));
  },
  getContainer: function getContainer() {
    return src_select(wrapId(this.parentContainerId)).select(wrapId(this.containerId));
  },
  getContainerDimensions: function getContainerDimensions() {
    var parentContainer = src_select(wrapId(this.parentContainerId)),
      width = 0,
      height = 0;
    if (!parentContainer.empty()) {
      width = parseInt(parentContainer.node().clientWidth, 10), height = parseInt(parentContainer.node().clientHeight, 10);
    }
    return {
      width: width,
      height: height
    };
  },
  remove: function remove() {
    var container = this.getContainer();
    container && container.remove();
  },
  addTooltip: function addTooltip() {
    var _this = this;
    var tooltipModel = this.chart && this.chart.tooltip;
    if (!tooltipModel) {
      return;
    }
    var showTooltip = !!(this._showTooltip && this.tooltip);
    var tooltipContent = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(this.tooltip) ? this.tooltip : function () {
      return _this.tooltip;
    };
    var gravity = this._tooltipGravity;
    tooltipModel.enabled(showTooltip);
    tooltipModel.contentGenerator(tooltipContent);
    tooltipModel.gravity(gravity);
  }
});

;// ./src/js/viz/nvd3/utils/upgraded_utils.js


var upgraded_utils_getWrappedTextLength = function getWrappedTextLength(value, fontSize, container, maxWidth, maxLines) {
  var element = utils_createElementIfAbsent(container, 'experiment-cache-container', 'text');
  element.text(value).style('font-size', fontSize ? fontSize + 'px' : null).call(js_nv.upgradedUtils.wrapTicks, maxWidth, maxLines || 2);
  var textLength = element.node().getBBox().width;
  element.text('').style('font-size', null);
  return textLength;
};
;// ./node_modules/d3-selection/src/selectAll.js



/* harmony default export */ function src_selectAll(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : src_array(selector)], root);
}

;// ./src/js/viz/components/upgraded_legend.js








function upgraded_legend_slicedToArray(r, e) { return upgraded_legend_arrayWithHoles(r) || upgraded_legend_iterableToArrayLimit(r, e) || upgraded_legend_unsupportedIterableToArray(r, e) || upgraded_legend_nonIterableRest(); }
function upgraded_legend_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function upgraded_legend_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return upgraded_legend_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? upgraded_legend_arrayLikeToArray(r, a) : void 0; } }
function upgraded_legend_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function upgraded_legend_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function upgraded_legend_arrayWithHoles(r) { if (Array.isArray(r)) return r; }








var DEFAULT_LEGEND_MAX_KEY_LENGTH = 20;
var getFontSize = function getFontSize(textNode) {
  if (textNode.style) {
    return parseInt(textNode.style('font-size').replace('px', ''), 10);
  }
  return 12;
};
var setupLegendContainer = function setupLegendContainer(container) {
  var legendContainer = container.select('g.dq-legend');
  if (legendContainer.empty()) {
    container.append('g').attr('class', 'dq-legend').append('g');
  }
  return container.select('g.dq-legend g');
};
var setupLegendTitle = function setupLegendTitle(container, config) {
  container.select('g.dq-legend g');
  container.append('g').attr('class', 'dq-legend-title').append('text').text(config.title);
  return container.select('g.dq-legend g');
};
var getActiveCount = function getActiveCount(data) {
  var count = 0;
  _.forEach(data, function (entry) {
    entry.disabled || count++;
  });
  return count;
};
var generateElementSize = function generateElementSize(legendElements, config) {
  var sizeList = [];
  legendElements.each(function (data, index) {
    var textElement = src_select(this).select('text');
    var fontSize = getFontSize(textElement);
    var height = fontSize + config.perElementSpacing;
    var width = config.iconDimensions + config.iconBorderWidth + config.innerPadding;
    try {
      width += textElement.node().getComputedTextLength();
    } catch (_unused) {
      width += textElement.text().length * fontSize * 0.6;
    }
    sizeList.push([config.getId(data, index), width, height]);
  });
  return sizeList;
};
var generateTitleSize = function generateTitleSize() {
  var textElement = src_select('.dq-legend-title').select('text');
  var fontSize = getFontSize(textElement);
  var width = 0;
  try {
    width += textElement.node().getComputedTextLength();
  } catch (_unused2) {
    width += textElement.text().length * fontSize * 0.6;
  }
  return [width, fontSize];
};
var generateLayout = function generateLayout(legendElements, config) {
  var elementSize = generateElementSize(legendElements, config);
  var _ref = config.title ? generateTitleSize() : [0, 0],
    _ref2 = upgraded_legend_slicedToArray(_ref, 2),
    titleWidth = _ref2[0],
    titleHeight = _ref2[1];
  var curX = 0;
  var curY = titleHeight;
  var layout = {};
  var legendWidth = 0;
  var legendHeight = 0;
  var rowHeight = 0;
  var rowWidth = 0;
  var containerX = 0;
  var containerY = 0;
  if (config.orientation === 'horizontal') {
    _.forEach(elementSize, function (element) {
      var key = element[0],
        width = element[1],
        height = element[2];
      if (curX + width > config.width) {
        var rowHeightWithPadding = rowHeight + config.innerPadding;
        legendWidth = legendWidth > curX ? legendWidth : curX;
        curX = 0;
        curY += rowHeightWithPadding;
        legendHeight += rowHeightWithPadding;
      }
      layout[key] = 'translate(' + curX + ', ' + curY + ')';
      curX += width + config.padding;
      rowHeight = rowHeight > height ? rowHeight : height;
    });
    legendHeight += rowHeight;
    var curWidth = curX - config.padding;
    legendWidth = legendWidth > curWidth ? legendWidth : curWidth;
    containerY = 0;
    config.height = legendHeight;
  } else {
    _.forEach(elementSize, function (element) {
      var key = element[0],
        width = element[1],
        height = element[2];
      if (curY + height > config.height) {
        var rowWidthWithPadding = rowWidth + config.padding;
        curY = 0;
        curX += rowWidthWithPadding;
        legendWidth += rowWidthWithPadding;
      }
      layout[key] = 'translate(' + curX + ', ' + curY + ')';
      curY += height;
      rowWidth = rowWidth > width ? rowWidth : width;
      legendHeight = legendHeight > curY ? legendHeight : curY;
      curY += config.innerPadding;
    });
    legendWidth += rowWidth;
    containerY = (config.height - legendHeight) / 2;
    config.width = Math.max(legendWidth, titleWidth);
  }
  if (config.alignment === 'left') {
    containerX = 0;
  } else if (config.alignment === 'center') {
    containerX = (config.width - legendWidth) / 2;
  } else {
    containerX = config.width - legendWidth;
  }
  layout.containerTranslation = 'translate(' + containerX + ', ' + containerY + ')';
  return layout;
};
var calculateAutomatedKeyLength = function calculateAutomatedKeyLength(config, elementCount) {
  var allowedRows = 0;
  var requiredElementsPerRow = 0;
  var requiredElementsPerCol = 0;
  var suggestedMaxKeyLength = 0;
  var CHAR_WIDTH = constants_Constants.CHAR_WIDTH;
  if (config.orientation === 'horizontal') {
    var limitHeight = config.automatedMaxKeyLengthLegendHeight || 0.25;
    allowedRows = Math.floor(config.height * limitHeight / CHAR_WIDTH);
    requiredElementsPerRow = Math.ceil(elementCount / allowedRows);
    suggestedMaxKeyLength = Math.floor(config.width / CHAR_WIDTH / requiredElementsPerRow);
  } else {
    var limitWidth = config.automatedMaxKeyLengthLegendWidth || 0.15;
    requiredElementsPerCol = Math.ceil(elementCount / Math.ceil(config.height / CHAR_WIDTH));
    suggestedMaxKeyLength = Math.floor(Math.floor(config.width * limitWidth) / (requiredElementsPerCol * CHAR_WIDTH));
  }
  return suggestedMaxKeyLength;
};
var addLegendIcon = function addLegendIcon(data, group, iconDimensions, borderWidth) {
  var verticalOffset = borderWidth / 2;
  var legendShape = getLegendIconShape(data);
  var radius = Math.floor(iconDimensions / 2);
  switch (legendShape) {
    case constants_Constants.LEGEND_SHAPES.RECTANGLE:
      return group.append('rect').attr('class', 'dq-legend-icon rectangle').attr('width', iconDimensions).attr('height', iconDimensions).attr('stroke-width', borderWidth).attr('y', verticalOffset);
    case constants_Constants.LEGEND_SHAPES.LINE:
      return group.append('line').attr('class', 'dq-legend-icon line').attr('x2', iconDimensions).attr('x1', 0).attr('y2', 0 + verticalOffset).attr('y1', iconDimensions).attr('stroke-width', 2);
    case constants_Constants.LEGEND_SHAPES.SQUARE:
      return group.append('rect').attr('class', 'dq-legend-icon roundedSquare').attr('width', iconDimensions).attr('height', iconDimensions).attr('rx', 2).attr('ry', 2).attr('stroke-width', borderWidth).attr('y', verticalOffset);
    case constants_Constants.LEGEND_SHAPES.CIRCLE:
    default:
      return group.append('circle').attr('class', 'dq-legend-icon circle').attr('r', radius).attr('cx', radius).attr('cy', radius + verticalOffset).attr('stroke-width', borderWidth);
  }
};
var generateLegendIcons = function generateLegendIcons(selection, iconDimensions, iconBorderWidth) {
  selection.each(function (data) {
    var group = src_select(this);
    return addLegendIcon(data, group, iconDimensions, iconBorderWidth);
  });
};
var updateLegendIcons = function updateLegendIcons(selection, iconDimensions, iconBorderWidth) {
  selection.each(function (data) {
    var group = src_select(this),
      element = group.select('.dq-legend-icon'),
      tagName = element.node().tagName;
    if (tagName !== data.legendShape || !data.legendShape && tagName !== 'rect') {
      element.remove();
      addLegendIcon(data, group, iconDimensions, iconBorderWidth);
    }
  });
};
var getLegendIconShape = function getLegendIconShape(data) {
  if (data.type === constants_Constants.DATA_TYPES.LINE) {
    return constants_Constants.LEGEND_SHAPES.CIRCLE;
  } else if (data.type === constants_Constants.DATA_TYPES.BAR) {
    return constants_Constants.LEGEND_SHAPES.SQUARE;
  } else if (data.legendShape === constants_Constants.LEGEND_SHAPES.LINE) {
    return constants_Constants.LEGEND_SHAPES.LINE;
  }
  return constants_Constants.LEGEND_SHAPES.SQUARE;
};
var upgradedDqLegend = function upgradedDqLegend() {
  var config = {
      orientation: 'horizontal',
      alignment: 'left',
      maxKeyLength: DEFAULT_LEGEND_MAX_KEY_LENGTH,
      animationDuration: constants_Constants.ANIMATION_DURATION,
      position: 'bottom',
      innerPadding: 8,
      padding: 16,
      iconDimensions: 10,
      iconBorderWidth: 0,
      distance: 16,
      automatedMaxKeyLength: true,
      automatedMaxKeyLengthLegendWidth: false,
      automatedMaxKeyLengthLegendHeight: false,
      width: 800,
      height: 500,
      getKey: function getKey(d) {
        return d.key;
      },
      getId: function getId(d, index) {
        return index;
      },
      clickDisabled: false,
      colorScheme: ordinal(category10),
      perElementSpacing: 3,
      title: null
    },
    dispatch = src_dispatch('legendClick', 'stateChange', 'ariaLabelChange');
  var updateActiveLegendItems = function updateActiveLegendItems() {
    var activeLegendItems = src_selectAll('.dq-legend-element').nodes().filter(function (element) {
      return element.getAttribute('aria-pressed') === 'true';
    });
    if (activeLegendItems.length === 1) {
      src_select('.dq-legend-element').attr('aria-disabled', true).attr('aria-label', function (d) {
        return config.getKey(d) + ' ' + translationService.translate('DQ.LegendCannotBeToggled');
      });
    } else {
      activeLegendItems.forEach(function (item) {
        return item.removeAttribute('aria-disabled');
      });
    }
  };
  var _legend = function legend(selection) {
    selection.each(function (data) {
      var container = src_select(this);
      var legendContainer = setupLegendContainer(container);
      var patternContainer = legendContainer.append('defs').node();
      var legendElements = legendContainer.selectAll('.dq-legend-element').data(data);
      var newEntries;
      var layout = {};
      var iconColor = function iconColor(d, i) {
        return d.color || config.colorScheme(d, i);
      };
      var suggestedMaxKeyLength;
      if (config.automatedMaxKeyLength) {
        suggestedMaxKeyLength = Math.max(config.maxKeyLength, calculateAutomatedKeyLength(config, data.length));
      } else {
        suggestedMaxKeyLength = config.maxKeyLength;
      }
      var getTruncatedText = function getTruncatedText(d) {
        var text = config.getKey(d);
        if (text.length > suggestedMaxKeyLength && suggestedMaxKeyLength !== 0) {
          text = text.substring(0, suggestedMaxKeyLength - 3);
          text += '...';
        }
        return text;
      };
      if (config.title) {
        setupLegendTitle(legendContainer, config);
      }
      newEntries = legendElements.enter().append('g').attr('class', 'dq-legend-element');
      newEntries.call(generateLegendIcons, config.iconDimensions, config.iconBorderWidth);
      newEntries.append('text').attr('text-anchor', 'start').attr('class', 'dq-legend-text').attr('x', config.iconDimensions + config.innerPadding).attr('y', config.iconDimensions);
      var legendElementsMergeSelection = newEntries.merge(legendElements);
      legendElements.exit().remove();
      legendElementsMergeSelection.call(updateLegendIcons, config.iconDimensions, config.iconBorderWidth);
      legendContainer.attr('role', 'group').attr('aria-label', translationService.translate('DQ.LegendGroupAriaLabel')).selectAll('.dq-legend-element').selectAll('.dq-legend-icon').attr('stroke', iconColor).attr('fill', iconColor);
      legendContainer.selectAll('.dq-legend-element').attr('tabindex', '0').attr('role', 'button').attr('aria-pressed', 'true').attr('aria-label', function (d) {
        return config.getKey(d) + ' ' + translationService.translate('DQ.LegendToggleOn');
      });
      legendContainer.selectAll('.dq-legend-element').selectAll('.dq-legend-text').text(getTruncatedText);
      legendElementsMergeSelection.each(function (d, i) {
        d.index = i;
        var textElement = src_select(this).select('text');
        var iconElement = src_select(this).select('.dq-legend-icon');
        var defaultColorFill = iconColor(d, i);
        var text = getTruncatedText(d, i);
        textElement.text(text);
        iconElement.attr('fill', defaultColorFill).attr('stroke', defaultColorFill);
        if (d.pattern && d.color) {
          iconElement.attr('fill', js_nv.utils.patternService.getDataFill(patternContainer, d, defaultColorFill)).attr('stroke-width', '1px');
        }
      });
      updateActiveLegendItems();
      layout = generateLayout(legendElementsMergeSelection, config);
      legendElementsMergeSelection.each(function (data, index) {
        src_select(this).classed('disabled', !!data.disabled).classed('click-disabled', !!config.clickDisabled).transition().duration(config.animationDuration).attr('transform', layout[config.getId(data, index)]);
      });
      legendContainer.attr('transform', layout.containerTranslation);
      if (!config.clickDisabled) {
        var handleClick = function handleClick(d, i, element) {
          if (!d.disabled && getActiveCount(data) === 1) {
            return;
          }
          d.disabled = !d.disabled;
          dispatch.call('stateChange', this, {
            disabled: data.map(function (d) {
              return !!d.disabled;
            })
          });
          dispatch.call('legendClick', this, d, i);
          dispatch.call('ariaLabelChange', this, d, i);
          element.classed('disabled', !!d.disabled);
          element.attr('aria-pressed', !d.disabled);
          updateActiveLegendItems();
          element.attr('aria-label', function (d) {
            var ariaString = ' ' + translationService.translate('DQ.LegendToggleOff');
            if (!d.disabled) {
              ariaString = ' ' + translationService.translate('DQ.LegendToggleOn');
            }
            return config.getKey(d) + ariaString;
          });
        };
        legendElementsMergeSelection.on('click', function (event, d) {
          var element = src_select(this);
          handleClick(d, d.index, element);
        });
        legendElementsMergeSelection.on('keydown', function (event, d) {
          if (event.key === 'Enter') {
            var element = src_select(this);
            handleClick(d, d.index, element);
          }
        });
        legendElementsMergeSelection.on('keyup', function (event, d) {
          if (event.key === ' ') {
            var element = src_select(this);
            handleClick(d, d.index, element);
          }
        });
      }
    });
    return _legend;
  };
  exposeConfig(_legend, config);
  _legend.dispatch = dispatch;
  return _legend;
};
;// ./node_modules/d3-scale/src/threshold.js



function threshold_threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x != null && x <= x ? range[d3_array_src_bisect(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold_threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

;// ./src/js/upgraded_utils.js
function upgraded_utils_typeof(o) { "@babel/helpers - typeof"; return upgraded_utils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, upgraded_utils_typeof(o); }








function upgraded_utils_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function upgraded_utils_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, upgraded_utils_toPropertyKey(o.key), o); } }
function upgraded_utils_createClass(e, r, t) { return r && upgraded_utils_defineProperties(e.prototype, r), t && upgraded_utils_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function upgraded_utils_defineProperty(e, r, t) { return (r = upgraded_utils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function upgraded_utils_toPropertyKey(t) { var i = upgraded_utils_toPrimitive(t, "string"); return "symbol" == upgraded_utils_typeof(i) ? i : i + ""; }
function upgraded_utils_toPrimitive(t, r) { if ("object" != upgraded_utils_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != upgraded_utils_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var upgraded_utils_shouldStartWith = function shouldStartWith(term, selector) {
  return (term['0'] === selector ? '' : selector) + term;
};
var upgraded_utils_extractFontSize = function extractFontSize(fontSize) {
  return Number(fontSize.replace(/[^-\d.]/g, ''));
};
var upgraded_utils_renderStates = {
  START: 'Started',
  WAIT: 'Waiting',
  COMPLETE: 'Completed'
};
var upgraded_utils_wrapId = function wrapId(id) {
  return upgraded_utils_shouldStartWith(id, '#');
};
var upgraded_utils_exposeConfig = function exposeConfig(object, config) {
  external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(config, function (value, key) {
    if (!object.hasOwnProperty(key)) {
      object[key] = function (val) {
        if (arguments.length > 0) {
          config[key] = val;
          return object;
        } else {
          return config[key];
        }
      };
    }
  });
};
var upgraded_utils_createElementIfAbsent = function createElementIfAbsent(container, elementClasses) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'g';
  var classesToSelect = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(elementClasses) ? elementClasses.join('.') : elementClasses;
  var classesToApply = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(elementClasses) ? elementClasses.join(' ') : elementClasses;
  if (container.select(".".concat(classesToSelect)).empty()) {
    container.append(element).attr('class', classesToApply);
  }
  return container.select(".".concat(classesToSelect));
};
var upgraded_utils_estimateMaxTextDimensions = function estimateMaxTextDimensions(width, height, value, cache, upperBound, lowerBound) {
  var estimatedFontSize = Math.min(upgraded_utils_estimateFontSize(width, height, value), upperBound),
    dimensions = {
      width: upgraded_utils_estimateWidthFromSize(estimatedFontSize, value),
      height: estimatedFontSize
    },
    textElement,
    svgElement,
    bBoxDimensions;
  if (!upgraded_utils_partialSvgSupport() && cache && cache.empty && !cache.empty()) {
    svgElement = upgraded_utils_createElementIfAbsent(cache, 'svg-inner', 'g');
    svgElement.attr('width', width).attr('height', height);
    textElement = upgraded_utils_createElementIfAbsent(svgElement, 'text-test-cache', 'text');
    textElement.style('font-size', estimatedFontSize + 'px').attr('transform', 'scale(1,1)').text(value);
    bBoxDimensions = textElement.node().getBBox();
    estimatedFontSize = Math.min(estimatedFontSize * (width / bBoxDimensions.width), estimatedFontSize * (height / bBoxDimensions.height));
    estimatedFontSize = Math.min(upperBound, estimatedFontSize);
    textElement.style('font-size', estimatedFontSize);
    bBoxDimensions = textElement.node().getBBox();
    dimensions.width = bBoxDimensions.width;
    dimensions.height = estimatedFontSize;
    cache.select('text').text('');
  }
  dimensions.fontSize = Math.max(lowerBound, Math.min(estimatedFontSize, upperBound));
  return dimensions;
};
var upgraded_utils_validFontWeight = function validFontWeight(fontWeight) {
  return !!(fontWeight && constants_Constants.FONT_WEIGHTS[fontWeight.toString()]);
};
var upgraded_utils_getLineHeight = function getLineHeight(fontSize, padding) {
  return fontSize + padding;
};
var upgraded_utils_thresholdColor = function thresholdColor(threshold, value) {
  return threshold_threshold().domain(threshold.map(function (_ref) {
    var val = _ref.val;
    return val;
  })).range(threshold.map(function (_ref2) {
    var color = _ref2.color;
    return color;
  }))(value);
};
var upgraded_utils_gammaAdjustedNormalizedColor = function gammaAdjustedNormalizedColor(color) {
  var rgbColor = color_rgb(color);
  var rgbAdjustmentExponent = 2.2;
  var maxRgbValue = 255;
  return {
    r: Math.pow(rgbColor.r / maxRgbValue, rgbAdjustmentExponent),
    g: Math.pow(rgbColor.g / maxRgbValue, rgbAdjustmentExponent),
    b: Math.pow(rgbColor.b / maxRgbValue, rgbAdjustmentExponent)
  };
};
var upgraded_utils_getColorLuminance = function getColorLuminance(color) {
  var rgbColor = upgraded_utils_gammaAdjustedNormalizedColor(color);
  var rMultiplier = 0.2126;
  var gMultiplier = 0.7151;
  var bMultiplier = 0.07121;
  return rgbColor.r * rMultiplier + rgbColor.g * gMultiplier + rgbColor.b * bMultiplier;
};
var upgraded_utils_isDarkColor = function isDarkColor(color) {
  var luminence = upgraded_utils_getColorLuminance(color);
  return luminence < 0.179;
};
var upgraded_utils_getContrastingColor = function getContrastingColor(color) {
  var colorRgbValue = color_rgb(color);
  var yiqColorContrast = (colorRgbValue.r * 299 + colorRgbValue.g * 587 + colorRgbValue.b * 114) / 1000;
  return yiqColorContrast >= 128 ? '#000000' : '#ffffff';
};
var upgraded_utils_inherit = function inherit(protoProps, staticProps) {
  var parent = this,
    child;
  if (protoProps && _.has(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function child() {
      return parent.apply(this, arguments);
    };
  }
  Object.assign(child, parent, staticProps);
  child.prototype = _.create(parent.prototype, protoProps);
  child.prototype.constructor = child;
  child.__super__ = parent.prototype;
  return child;
};
var upgraded_utils_RenderLifeCycle = function () {
  function RenderLifeCycle() {
    var _this = this;
    upgraded_utils_classCallCheck(this, RenderLifeCycle);
    upgraded_utils_defineProperty(this, "_dispatch", src_dispatch('renderEnd'));
    upgraded_utils_defineProperty(this, "start", function () {
      _this.state = upgraded_utils_renderStates.START;
      _this.eventCount = 0;
    });
    upgraded_utils_defineProperty(this, "watch", function (transition) {
      _this._watch(transition);
    });
    upgraded_utils_defineProperty(this, "createWatcherWithCallback", function (onTransitionEnd) {
      return function (transition) {
        _this._watch(transition, onTransitionEnd);
      };
    });
    upgraded_utils_defineProperty(this, "_watch", function (transition, onTransitionEnd) {
      var self = _this;
      if (_this.state !== upgraded_utils_renderStates.START) {
        throw new Error('Cannot add watcher before lifeCycle is started.[Call lifeCycle.start()]');
      }
      transition.each(function () {
        self.eventCount += 1;
      }).on('end', function () {
        if (--self.eventCount === 0) {
          self.renderComplete();
        }
        if (onTransitionEnd && typeof onTransitionEnd === 'function') {
          onTransitionEnd.apply(this, arguments);
        }
      });
    });
    upgraded_utils_defineProperty(this, "dispatchOnCompletion", function () {
      _this.state = upgraded_utils_renderStates.WAIT;
      _this.renderComplete();
    });
    upgraded_utils_defineProperty(this, "renderComplete", function () {
      if (_this.state === upgraded_utils_renderStates.WAIT && _this.eventCount === 0) {
        _this.state = upgraded_utils_renderStates.COMPLETE;
        _this.dispatch.call('renderEnd');
      }
    });
  }
  return upgraded_utils_createClass(RenderLifeCycle, [{
    key: "dispatch",
    get: function get() {
      return this._dispatch;
    }
  }]);
}();
var upgraded_utils_wordWrap = function wordWrap(text, length) {
  text.each(function () {
    var textElement = src_select(this),
      fontSize = upgraded_utils_extractFontSize(text.style('font-size')),
      textString = textElement.text(),
      textLength;
    try {
      textLength = textElement.node().getComputedTextLength();
      if (textLength > length) {
        textString = textString.substr(0, Math.floor(textString.length / textLength * length - 3)) + '...';
        textElement.text(textString);
      }
    } catch (_unused) {
      textElement.text(upgraded_utils_truncate(textString, length, fontSize));
    }
  });
};
var upgraded_utils_truncate = function truncate(str, length, fontSize) {
  var maxLetters = length / ((fontSize || constants_Constants.FONT_SIZE) * 0.7);
  return str.length > maxLetters ? str.substring(0, maxLetters - 3) + '...' : str;
};
var upgraded_utils_partialSvgSupport = function partialSvgSupport() {
  var ua = window.navigator.userAgent;
  if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {
    return true;
  } else {
    return false;
  }
};
var upgraded_utils_estimateFontSize = function estimateFontSize(width, height, value) {
  return external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isUndefined(value) ? 0 : Math.min(height, width / (('' + value).length * 0.6));
};
var upgraded_utils_estimateWidthFromSize = function estimateWidthFromSize(fontSize, value) {
  if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isUndefined(value)) {
    return 0;
  } else {
    var valueArray = value.toString().split('');
    return valueArray.reduce(function (width, char) {
      var multiplier = constants_Constants.CHAR_WIDTH_PROPORTIONS[char] || constants_Constants.DEFAULT_FONT_SIZE_PROPORTION;
      return width += fontSize * multiplier;
    }, 0);
  }
};
var upgraded_utils_noop = function noop() {};
var upgraded_utils_isFunction = function isFunction(obj) {
  return typeof obj === 'function' || false;
};
var upgraded_utils_contains = function contains(array, obj) {
  return array.indexOf && array.indexOf(obj) !== -1 || false;
};
var upgraded_utils_formatPixels = function formatPixels(string) {
  return string + 'px';
};
var upgraded_utils_hash = function hash(string) {
  var hash = 0;
  for (var i = 0, len = string.length; i < len; i++) {
    var char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash && hash;
  }
  return hash;
};
var upgraded_utils_createSVGFromDirections = function createSVGFromDirections(directions) {
  var svg = directions.reduce(function (result, command) {
    var lineCommand = [];
    switch (command.type) {
      case Constants.SVG_PATH_MOVE_COMMAND:
      case Constants.SVG_PATH_LINE_COMMAND:
        lineCommand = [command.type, command.x, command.y];
        break;
      case Constants.SVG_PATH_ARC_COMMAND:
        lineCommand = [command.type, command.rx, command.ry, command.xAxisRotation, command.largeArcFlag, command.sweepFlag, command.x, command.y];
        break;
      case Constants.SVG_PATH_CLOSE_COMMAND:
        lineCommand = [command.type];
        break;
      case Constants.SVG_PATH_BEZIER_COMMAND:
        lineCommand = [command.type, command.x1, command.y1, command.x, command.y];
        break;
    }
    return result + lineCommand.join(' ') + ' ';
  }, '');
  return svg;
};
var upgraded_utils_createTrianglePointer = function createTrianglePointer(offsetX, offsetY, base, height) {
  var triangleSVG = upgraded_utils_createSVGFromDirections([{
    type: Constants.SVG_PATH_MOVE_COMMAND,
    x: -base / 2 + offsetX,
    y: offsetY
  }, {
    type: Constants.SVG_PATH_LINE_COMMAND,
    x: offsetX,
    y: offsetY - height
  }, {
    type: Constants.SVG_PATH_LINE_COMMAND,
    x: base / 2 + offsetX,
    y: offsetY
  }, {
    type: Constants.SVG_PATH_CLOSE_COMMAND
  }]);
  return triangleSVG;
};
var upgraded_utils_createHalfCircleArc = function createHalfCircleArc(radius) {
  var arcSVG = upgraded_utils_createSVGFromDirections([{
    type: Constants.SVG_PATH_MOVE_COMMAND,
    x: -radius,
    y: 0
  }, {
    type: Constants.SVG_PATH_ARC_COMMAND,
    rx: radius,
    ry: radius,
    xAxisRotation: 0,
    largeArcFlag: 0,
    sweepFlag: 1,
    x: radius,
    y: 0
  }]);
  return arcSVG;
};
;// ./src/js/viz/components/upgraded_reference_line.js




var upgradedDqReferenceLine = function upgradedDqReferenceLine() {
  var config = {
      width: 400,
      height: 400,
      xScale: null,
      yScale: null,
      getX: function getX(d) {
        return d.x;
      },
      getY: function getY(d) {
        return d.y;
      },
      colorScheme: ordinal(category10),
      animationDuration: 200,
      getKey: function getKey(d) {
        return d.key;
      }
    },
    lifeCycle = new upgraded_utils_RenderLifeCycle();
  var referenceLine = function referenceLine(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var container = src_select(this),
        refLines,
        xScale = config.xScale.copy(),
        yScale = config.yScale.copy();
      var linesData = calculateLines(data, config, xScale, yScale);
      container.selectAll('.dq-reference-lines').data([data]).append('g').classed('dq-reference-lines', true);
      refLines = container.selectAll('.reference-line').data(data);
      var refLinesEnterSelection = refLines.enter().append('line').classed('reference-line', true);
      refLines.exit().remove();
      refLinesEnterSelection.merge(refLines).data(linesData).classed('vertical-reference-line', function (d) {
        return getVerticalReferenceLine(d);
      }).classed('horizontal-reference-line', function (d) {
        return getHorizontalReferenceLine(d);
      }).transition().duration(config.animationDuration).attr('x1', function (d) {
        return getX1(d);
      }).attr('y1', function (d) {
        return getY1(d);
      }).attr('x2', function (d) {
        return getX2(d);
      }).attr('y2', function (d) {
        return getY2(d);
      }).attr('stroke', function (d, i) {
        return getStroke(d, i, config);
      }).attr('stroke-linecap', function (d) {
        return getStrokeLinecap(d);
      }).attr('stroke-dasharray', function (d) {
        return getStrokeDasharray(d);
      }).attr('stroke-width', function (d) {
        return getStrokeWidth(d);
      }).call(lifeCycle.watch);
      lifeCycle.dispatchOnCompletion();
    });
  };
  upgraded_utils_exposeConfig(referenceLine, config);
  referenceLine.lifeCycle = lifeCycle;
  return referenceLine;
};
function calculateLines(data, config, xScale, yScale) {
  xScale.clamp && xScale.clamp(true);
  yScale.clamp && yScale.clamp(true);
  data.map(function (d) {
    var val = config.getX(d),
      position;
    if (val !== undefined) {
      position = xScale(val);
      d.x1 = _.isNumber(position) ? position : 0;
      d.x2 = d.x1;
      d.y1 = 0;
      d.y2 = config.height;
    } else {
      position = yScale(config.getY(d));
      d.x1 = 0;
      d.x2 = config.width;
      d.y1 = _.isNumber(position) ? position : 0;
      d.y2 = d.y1;
    }
  });
  return data;
}
function getVerticalReferenceLine(d) {
  return d.x1 === d.x2;
}
function getHorizontalReferenceLine(d) {
  return d.y1 === d.y2;
}
function getX1(d) {
  return d.x1;
}
function getX2(d) {
  return d.x2;
}
function getY1(d) {
  return d.y1;
}
function getY2(d) {
  return d.y2;
}
function getStroke(d, i, config) {
  return d.color || config.colorScheme(i);
}
function getStrokeWidth(d) {
  return d.width || '1px';
}
function getStrokeDasharray(d) {
  return d.dasharray || 'none';
}
function getStrokeLinecap(d) {
  return d.linecap || 'round';
}
;// ./src/js/color_scheme/upgraded_base_color_scheme.js



var upgraded_base_color_scheme_colors = ['#1E88E5', '#00ACC1', '#43A047', '#C0CA33', '#FB8C00', '#E53935', '#8E24AA', '#3949AB', '#039BE5', '#00897B', '#7CB342', '#7CB342', '#FDD835', '#FFB300', '#F4511E', '#5E35B1'];
var upgradedBaseColorScheme = function upgradedBaseColorScheme(field) {
  var color_scale = ordinal().range(upgraded_base_color_scheme_colors);
  return function (d, i) {
    var key;
    key = i === undefined ? d : i;
    if (field) {
      if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(field)) {
        key = field(d);
      } else if (d[field]) {
        key = d[field];
      }
    }
    return d.color || color_scale(key);
  };
};
var upgradedD3ColorScheme = function upgradedD3ColorScheme() {
  var color_scale = d3ScaleOrdinal(d3SchemeCategory10);
  return function (d, i) {
    return d.color || color_scale(i);
  };
};
;// ./src/js/viz/config/point_range_config.js
var PointRangeConfig = {
  setPointRange: function setPointRange(min, max) {
    if (arguments.length === 0) {
      this._pointRange = undefined;
    } else {
      this._pointRange = [min, max];
    }
    return this;
  }
};
;// ./src/js/viz/config/legend_config.js
var LegendConfig = {
  _prevLegendPosition: 'bottom',
  _legendPosition: 'bottom',
  _shouldShowLegend: true,
  _legendAlignment: 'left',
  _legendDistance: 24,
  _legendTitle: null,
  showLegend: function showLegend(val) {
    this._shouldShowLegend = !!val;
    return this;
  },
  alignLegend: function alignLegend(val) {
    this._legendAlignment = val;
    return this;
  },
  setLegendPosition: function setLegendPosition(position) {
    this._prevLegendPosition = this._legendPosition;
    this._legendPosition = position;
    return this;
  },
  setLegendDistance: function setLegendDistance(dist) {
    dist = parseInt(dist, 10);
    if (!isNaN(dist)) {
      this._legendDistance = dist;
    }
    return this;
  },
  setMaxKeyLength: function setMaxKeyLength(maxKeyLength) {
    this._maxKeyLength = maxKeyLength;
    return this;
  },
  setAutoMaxLength: function setAutoMaxLength(bool) {
    this._automatedMaxKeyLength = bool;
    return this;
  },
  setLegendTitle: function setLegendTitle(legendTitle) {
    this._legendTitle = legendTitle;
    return this;
  }
};
;// ./src/js/viz/config/data_config.js
var DataConfig = {
  _pendingDataUpdate: false,
  getData: function getData() {
    return this.data;
  },
  setData: function setData(data) {
    this.data = _.cloneDeep(data);
    this._pendingDataUpdate = true;
    return this;
  }
};
;// ./src/js/viz/config/reference_line_config.js
var ReferenceLineConfig = {
  getReferenceLines: function getReferenceLines() {
    return this.referenceLines;
  },
  setReferenceLines: function setReferenceLines(data) {
    this.referenceLines = _.cloneDeep(data);
    return this;
  }
};
;// ./src/js/viz/config/color_scheme_config.js
var ColorSchemeConfig = {
  setColorScheme: function setColorScheme(colorScheme) {
    this.colorScheme = colorScheme;
    return this;
  }
};
;// ./src/js/tooltip/dark_dialog.js



var nvToolTipGenerator = js_nv.models.tooltip()._options.contentGenerator;
var createCustomDiv = function createCustomDiv(customClassName, customId) {
  var div = document.createElement('div');
  if (customClassName) {
    div.className = customClassName;
  }
  if (customId) {
    div.id = customId;
  }
  return div;
};
var wrapWithDarkDialog = function wrapWithDarkDialog(contentGenerator) {
  return function () {
    var div = createCustomDiv('dark-dialog');
    div.innerHTML = contentGenerator.apply(void 0, arguments);
    return purify(window).sanitize(div, {
      RETURN_DOM: true,
      ALLOWED_TAGS: constants_Constants.ALLOWED_TAGS,
      ALLOWED_ATTR: constants_Constants.ALLOWED_ATTR
    }).outerHTML;
  };
};
var darkDialog = wrapWithDarkDialog(nvToolTipGenerator);
var nvTooltip = function nvTooltip() {
  return js_nv.models.tooltip();
};
;// ./src/js/viz/config/tooltip_config.js

var TooltipConfig = {
  tooltip: darkDialog,
  _showTooltip: true,
  _tooltipGravity: 'w',
  setTooltip: function setTooltip(tooltip) {
    this.tooltip = tooltip;
    return this;
  },
  showTooltip: function showTooltip(_showTooltip) {
    this._showTooltip = !!_showTooltip;
    return this;
  }
};
;// ./src/js/viz/config/animation_config.js
var AnimationConfig = {
  _animationDuration: 200,
  disableAnimation: function disableAnimation(val) {
    if (arguments.length === 0 || !!val) {
      this._animationDuration = 0;
    }
    return this;
  },
  setAnimationDuration: function setAnimationDuration(val) {
    if (arguments.length !== 0 || !!val) {
      this._animationDuration = val;
    }
    return this;
  }
};
;// ./src/js/viz/config/interaction_config.js
var InteractionConfig = {
  _disableInteraction: false,
  _disableLegendInteraction: false,
  _useRegionInteraction: false,
  disableInteraction: function disableInteraction(val) {
    this._disableInteraction = !!val;
    return this;
  },
  disableLegendInteraction: function disableLegendInteraction(val) {
    this._disableLegendInteraction = !!val;
    return this;
  },
  useRegionInteraction: function useRegionInteraction(val) {
    this._useRegionInteraction = !!val;
    return this;
  },
  shouldDisableLegendClick: function shouldDisableLegendClick() {
    return this._disableInteraction || this._disableLegendInteraction;
  }
};
;// ./src/js/viz/config/margin_config.js
var MarginConfig = {
  _margin: {
    top: 0,
    right: 16,
    bottom: 16,
    left: 16
  },
  setMargin: function setMargin(margin) {
    var props = ['top', 'right', 'bottom', 'left'];
    var curMargin = this._margin;
    this._margin = _.reduce(props, function (newMargin, prop) {
      var val = parseFloat(margin[prop], 10);
      newMargin[prop] = isNaN(val) ? curMargin[prop] : val;
      return newMargin;
    }, {});
    return this;
  }
};
;// ./src/js/viz/config/base_chart_config.js









var BaseChartConfig = Object.assign({}, MarginConfig, LegendConfig, DataConfig, ReferenceLineConfig, ColorSchemeConfig, TooltipConfig, AnimationConfig, InteractionConfig);
;// ./src/js/viz/config/data_value_config.js
var DataValueConfig = {
  _showDataValue: false,
  _showDataValueType: null,
  showDataValue: function showDataValue(val) {
    this._showDataValue = val;
    return this;
  },
  showDataValueType: function showDataValueType(val) {
    this._showDataValueType = val;
    return this;
  }
};
;// ./src/js/viz/config/axis_config.js
var AxisConfig = {
  _YAxisMin: undefined,
  _YAxisMax: undefined,
  _XAxisMin: undefined,
  _XAxisMax: undefined,
  _showYAxis: true,
  _showXAxis: true,
  _tickFormat: undefined,
  _xTickValues: undefined,
  _yTickValues: undefined,
  _xTickCount: undefined,
  _yTickCount: undefined,
  _xTickFormat: undefined,
  _yTickFormat: undefined,
  _rotateAxisAngle: 0,
  _axisMin: undefined,
  _axisMax: undefined,
  _showHorizontalGrid: true,
  _showVerticalGrid: false,
  _showInfiniteHorizontalGrid: false,
  _showInfiniteVerticalGrid: false,
  _useDynamicFontSize: false,
  _showGridLineBorders: true,
  _enableAutoAxisScaling: false,
  useDynamicFontSize: function useDynamicFontSize(val) {
    this._useDynamicFontSize = val === true;
    return this;
  },
  setXAxisMin: function setXAxisMin(val) {
    val = parseFloat(val);
    this._XaxisMin = _.isNaN(val) ? undefined : val;
    return this;
  },
  setXAxisMax: function setXAxisMax(val) {
    val = parseFloat(val);
    this._XaxisMax = _.isNaN(val) ? undefined : val;
    return this;
  },
  setYAxisMin: function setYAxisMin(val) {
    val = parseFloat(val);
    this._YaxisMin = _.isNaN(val) ? undefined : val;
    return this;
  },
  setYAxisMax: function setYAxisMax(val) {
    val = parseFloat(val);
    this._YaxisMax = _.isNaN(val) ? undefined : val;
    return this;
  },
  setAxisMin: function setAxisMin(val) {
    val = parseFloat(val, 10);
    this._axisMin = _.isNaN(val) ? undefined : val;
    return this;
  },
  setAxisMax: function setAxisMax(val) {
    val = parseFloat(val, 10);
    this._axisMax = _.isNaN(val) ? undefined : val;
    return this;
  },
  setXAxisLabel: function setXAxisLabel(label) {
    this.xAxisLabel = label;
    return this;
  },
  setSecondaryYAxisLabel: function setSecondaryYAxisLabel(label) {
    this.secondaryYAxisLabel = label;
    return this;
  },
  setSecondaryXAxisLabel: function setSecondaryXAxisLabel(label) {
    this.secondaryXAxisLabel = label;
    return this;
  },
  setYAxisLabel: function setYAxisLabel(label) {
    this.yAxisLabel = label;
    return this;
  },
  showXAxis: function showXAxis(show) {
    this._showXAxis = !!show;
    return this;
  },
  showYAxis: function showYAxis(show) {
    this._showYAxis = !!show;
    return this;
  },
  rotateXAxis: function rotateXAxis(rotateAxis) {
    this._rotateAxisAngle = rotateAxis ? -80 : 0;
    return this;
  },
  setTickFormat: function setTickFormat(format) {
    this._tickFormat = format;
    return this;
  },
  setXAxisTickFormat: function setXAxisTickFormat(format) {
    this._xTickFormat = format;
    return this;
  },
  setYAxisTickFormat: function setYAxisTickFormat(format) {
    this._yTickFormat = format;
    return this;
  },
  setXTicks: function setXTicks(count, format) {
    this._xTickCount = count;
    this._xTickFormat = format;
    return this;
  },
  setYTicks: function setYTicks(count, format) {
    this._yTickCount = count;
    this._yTickFormat = format;
    return this;
  },
  setXTickValues: function setXTickValues(values) {
    this._xTickValues = values;
    return this;
  },
  setYTickValues: function setYTickValues(values) {
    this._yTickValues = values;
    return this;
  },
  hideVerticalGrid: function hideVerticalGrid(val) {
    return this.showVerticalGrid(!val);
  },
  hideHorizontalGrid: function hideHorizontalGrid(val) {
    return this.showHorizontalGrid(!val);
  },
  showVerticalGrid: function showVerticalGrid(val) {
    this._showVerticalGrid = !!val;
    return this;
  },
  showHorizontalGrid: function showHorizontalGrid(val) {
    this._showHorizontalGrid = !!val;
    return this;
  },
  showGrid: function showGrid(val) {
    this.showHorizontalGrid(val);
    this.showVerticalGrid(val);
    return this;
  },
  hideGrid: function hideGrid(val) {
    return this.showGrid(!val);
  },
  showInfiniteGrid: function showInfiniteGrid(val) {
    this.showInfiniteHorizontalGrid(val);
    this.showInfiniteVerticalGrid(val);
    return this;
  },
  showInfiniteHorizontalGrid: function showInfiniteHorizontalGrid(val) {
    this._showInfiniteHorizontalGrid = !!val;
    return this.showHorizontalGrid(val);
  },
  showInfiniteVerticalGrid: function showInfiniteVerticalGrid(val) {
    this._showInfiniteVerticalGrid = !!val;
    return this.showVerticalGrid(val);
  },
  showGridLineBorders: function showGridLineBorders(val) {
    this._showGridLineBorders = !!val;
    return this;
  },
  enableAutoAxisScaling: function enableAutoAxisScaling(enable) {
    this._enableAutoAxisScaling = !!enable;
    return this;
  }
};
;// ./src/js/viz/config/axis_chart_config.js




var AxisChartConfig = Object.assign({}, BaseChartConfig, DataValueConfig, AxisConfig);
;// ./src/js/viz/config/secondary_axis_config.js
var SecondaryAxisConfig = {
  _showYAxis2: true,
  _splitYAxes: false,
  _yAxis2TickFormat: null,
  _yAxis2Min: undefined,
  _yAxis2Max: undefined,
  setYAxis2TickFormat: function setYAxis2TickFormat(format) {
    this._yAxis2TickFormat = format;
    return this;
  },
  setYAxis2Min: function setYAxis2Min(val) {
    val = parseFloat(val, 10);
    this._yAxis2Min = _.isNaN(val) ? undefined : val;
    return this;
  },
  setYAxis2Max: function setYAxis2Max(val) {
    val = parseFloat(val, 10);
    this._yAxis2Max = _.isNaN(val) ? undefined : val;
    return this;
  },
  setYAxis2Label: function setYAxis2Label(label) {
    this.yAxis2Label = label;
    return this;
  },
  showYAxis2: function showYAxis2(show) {
    this._showYAxis2 = !!show;
    return this;
  },
  splitYAxes: function splitYAxes(_) {
    this._splitYAxes = !!_;
    return this;
  }
};
;// ./src/js/viz/config/dual_axis_chart_config.js



var DualAxisChartConfig = Object.assign({}, AxisChartConfig, SecondaryAxisConfig);
;// ./src/js/viz/config/event_config.js
var VALID_EVENT_TYPES = {
  ELEMENT_CLICK: 'elementClick',
  LEGEND_CLICK: 'legendClick',
  STATE_CHANGE: 'stateChange',
  ARIA_LABEL_CHANGE: 'ariaLabelChange'
};
var EventConfig = {
  registerForEvent: function registerForEvent(event, handler) {
    var isValidEvent = _.some(VALID_EVENT_TYPES, function (validEvent) {
      return event === validEvent;
    });
    if (isValidEvent && _.isFunction(handler)) {
      this._eventHandlers = this._eventHandlers || {};
      this._eventHandlers[event] = handler;
      if (event === VALID_EVENT_TYPES.ELEMENT_CLICK) {
        this.getContainer().classed('clickable', true);
      }
    }
    return this;
  },
  clearAllEvents: function clearAllEvents() {
    this._eventHandlers = {};
    this.getContainer().classed('clickable', false);
  },
  getValidEventTypes: function getValidEventTypes() {
    return _.cloneDeep(VALID_EVENT_TYPES);
  }
};
;// ./src/js/viz/config/data_cube_multi_chart_config.js
var transformDataCube = function transformDataCube(dataCube) {
  var transformedData = dataCube.map(function (series) {
    return {
      key: series.label,
      values: series.value.map(function (dataPt) {
        return {
          x: dataPt.label,
          y: dataPt.value
        };
      })
    };
  });
  return transformedData;
};
var DataCubeMultiChartConfig = {
  setDataCube: function setDataCube(dataCube) {
    return this.setData(transformDataCube(dataCube));
  }
};
;// ./src/js/viz/config/view_config/multi_chart_config.js


var MultiChartViewDefaults = {
  showVerticalGrid: true,
  showHorizontalGrid: true,
  showXAxis: true,
  showYAxis: true,
  minYAxis: null,
  maxYAxis: null,
  XAxisLabel: null,
  YAxisLabel: null,
  showLegend: true,
  showDataValues: false,
  legendPosition: 'bottom'
};
function addPropsToData(data, prop, valueList) {
  data.forEach(function (datum, index) {
    datum[prop] = valueList[index % valueList.length];
  });
}
var MultiChartViewConfig = {
  setViewConfig: function setViewConfig(viewConfig) {
    var mergedOptions = Object.assign({}, MultiChartViewDefaults, viewConfig);
    this.hideVerticalGrid(!mergedOptions.showVerticalGrid).hideHorizontalGrid(!mergedOptions.showHorizontalGrid).showXAxis(mergedOptions.showXAxis).showYAxis(mergedOptions.showYAxis).setAxisMin(mergedOptions.minYAxis).setAxisMax(mergedOptions.maxYAxis).setXAxisLabel(mergedOptions.XAxisLabel).setYAxisLabel(mergedOptions.YAxisLabel).showLegend(mergedOptions.showLegend).showDataValue(mergedOptions.showDataValues).setLegendPosition(mergedOptions.legendPosition);
    if (this.data && this.data.length > 0) {
      if (mergedOptions.colors) {
        addPropsToData(this.data, 'color', mergedOptions.colors);
      }
      if (mergedOptions.legendShapes) {
        addPropsToData(this.data, 'legendShape', mergedOptions.legendShapes);
      }
      if (mergedOptions.seriesTypes) {
        addPropsToData(this.data, 'type', mergedOptions.seriesTypes);
      }
    }
    return this;
  }
};
;// ./src/js/viz/config/view_config/date_axis_config.js
var DateAxisConfig = {
  useDateAxis: function useDateAxis(dateAxisGroupBy) {
    this.dateAxisGroupBy = dateAxisGroupBy;
    return this;
  }
};
;// ./src/js/viz/config/view_config/widget_as_filter_config.js
var WidgetAsFilterConfig = {
  setWidgetAsFilter: function setWidgetAsFilter(widgetAsFilter) {
    this._widgetAsFilter = widgetAsFilter;
    return this;
  }
};
;// ./src/js/viz/nvd3/charts/multi_chart.js










function multi_chart_toConsumableArray(r) { return multi_chart_arrayWithoutHoles(r) || multi_chart_iterableToArray(r) || multi_chart_unsupportedIterableToArray(r) || multi_chart_nonIterableSpread(); }
function multi_chart_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function multi_chart_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return multi_chart_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? multi_chart_arrayLikeToArray(r, a) : void 0; } }
function multi_chart_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function multi_chart_arrayWithoutHoles(r) { if (Array.isArray(r)) return multi_chart_arrayLikeToArray(r); }
function multi_chart_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




















var multi_chart_AXIS_LABEL_DISTANCE = constants_Constants.AXIS_LABEL_DISTANCE;
var MARGIN_OFFSET = {
  TOP: 8,
  BOTTOM: -8,
  LEFT: -1,
  RIGHT: 0
};
var AXIS_LABEL_OFFSET = {
  LEFT: 6,
  RIGHT: 12
};
function getNumDigitsAfterDecimal(dataRange) {
  dataRange = Number(format('.1r')(dataRange));
  var significantFigures = 1;
  if (dataRange < 1) {
    return Math.max(significantFigures, countDecimalDigits(dataRange)) + 1;
  } else if (dataRange < 10) {
    return 2;
  } else {
    return 0;
  }
}
var MultiChart = UpgradedNvCore.extend(DualAxisChartConfig).extend(PointRangeConfig).extend(EventConfig).extend(DataCubeMultiChartConfig).extend(WidgetAsFilterConfig).extend(MultiChartViewConfig).extend(DateAxisConfig).extend({
  initialize: function initialize() {
    this.colorScheme = upgradedBaseColorScheme();
    this.layout = new ChartLayout();
    this._showYAxis2 = true;
    return UpgradedNvCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(callback) {
    if (this._pendingDataUpdate) {
      this.processData();
    }
    this.configureChartComponents();
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      container: this.getContainer(),
      animationDuration: this._animationDuration,
      postRender: callback,
      margin: this._margin
    });
    return this;
  },
  configureChartComponents: function configureChartComponents() {
    var dataProperties = this.getDataProperties();
    this.createChart(dataProperties);
    this.createReferenceLines(dataProperties);
    this.createLegend();
  },
  createChart: function createChart(dataProperties) {
    var self = this;
    this.chart = this.chart || js_nv.models.multiChart();
    this.chart.showLegend(false).stacked(this.stacked).curve(this.spline ? monotoneX : curve_linear).duration(this._animationDuration).disableInteraction(this._disableInteraction).useRegionInteraction(this._useRegionInteraction).defaultType(this.chartType).color(this.colorScheme).dashed(this.dashed).showValues(this._showDataValue).dataSizedVerticalGrids(!!this.dataSizedVerticalGrids).showVerticalGrid(!!this._showVerticalGrid).showHorizontalGrid(!!this._showHorizontalGrid).widgetAsFilter(!!this._widgetAsFilter).dynamicXAxis(true).labelLayoutGenerator(_.partial(labelLayoutGenerator, this.getContainer(), this._useDynamicFontSize ? null : constants_Constants.FONT_SIZE)).referenceLines(this.getReferenceLines());
    _.forEach(this._eventHandlers, function (handler, event) {
      self.chart.dispatch.on(event, handler);
    });
    this.configureAxis(dataProperties);
    this.configureMargins(dataProperties);
    this.addTooltip();
    this.layout.host('chart', this.chart, this.getData());
  },
  configureAxis: function configureAxis(dataProperties) {
    var self = this;
    this.chart.padData(true).wrapLabels(true).showYAxis(!!this._showYAxis && dataProperties.hasLeftAxis).showYAxis2(!!this._showYAxis2 && dataProperties.hasRightAxis && !!this._showYAxis).showXAxis(!!this._showXAxis).splitYAxes(!!this._splitYAxes).dateAxisGroupBy(this.dateAxisGroupBy);
    this.chart.xAxis.axisLabel(this.xAxisLabel);
    this.chart.x(function (d, i) {
      return i;
    });
    this.chart.xAxis.showMaxMin(false);
    if (this.dateAxisGroupBy) {
      this.chart.xAxis.tickFormat(function () {
        return dq_locale_locale.months[8] ? dq_locale_locale.months[8] : 'September';
      });
    } else {
      this.chart.xAxis.tickFormat(function (d) {
        return self._labels[d];
      });
    }
    if (dataProperties.hasRightAxis && !!this.yAxis2Label) {
      this.chart.yAxis2.axisLabel(this.yAxis2Label);
    }
    this.chart.yDomainMin(this._axisMin);
    this.chart.yDomainMax(this._axisMax);
    this.chart.yDomain2Min(this._yAxis2Min);
    this.chart.yDomain2Max(this._yAxis2Max);
    if (_.isFunction(this._tickFormat)) {
      this.chart.yAxis1.tickFormat(this._tickFormat);
    }
    if (_.isFunction(this._yAxis2TickFormat)) {
      this.chart.yAxis2.tickFormat(this._yAxis2TickFormat);
    } else if (_.isFunction(this._tickFormat)) {
      this.chart.yAxis2.tickFormat(this._tickFormat);
    }
    if (dataProperties.maxYLeftValueSize) {
      this.chart.yAxis1.axisLabelDistance(Math.max(this._splitYAxes ? dataProperties.maxYRightValueSize : 0, dataProperties.maxYLeftValueSize) + AXIS_LABEL_OFFSET.LEFT);
    }
    if (dataProperties.maxYRightValueSize) {
      this.chart.yAxis2.axisLabelDistance(Math.max(this._splitYAxes ? dataProperties.maxYLeftValueSize : 0, dataProperties.maxYRightValueSize) + (this._splitYAxes ? AXIS_LABEL_OFFSET.LEFT : AXIS_LABEL_OFFSET.RIGHT));
    }
    if (dataProperties.hasLeftAxis && !!this.yAxisLabel) {
      this.chart.yAxis1.axisLabel(this.yAxisLabel);
      this.chart.yAxis1.axisLabelDistance(multi_chart_AXIS_LABEL_DISTANCE + 6);
    }
    if (dataProperties.lineCount) {
      this.chart.xAxis.axisLabelDistance(dataProperties.lineCount * (constants_Constants.FONT_SIZE + 3));
    } else {
      this.chart.xAxis.axisLabelDistance(10);
    }
    if (this._showInfiniteHorizontalGrid) {
      this.getContainer().classed('infinite-horizontal-grid', true);
    }
    if (this._lineLabelLocation !== constants_Constants.LINE_LABEL_PLACEMENT.LEGEND) {
      this.chart.maxLineLabelWidth(this.getMaxLineLabelWidth());
      this.chart.showLineLabels(this._lineLabelLocation);
    } else {
      this.chart.showLineLabels(false);
    }
    if (dataProperties.dataLabelOverflow) {
      this.chart.horizontalGridExtension({
        right: dataProperties.dataLabelOverflow
      });
    }
  },
  configureMargins: function configureMargins(dataProperties) {
    this.chart.margin(this.calculateMargin(dataProperties));
  },
  calculateMargin: function calculateMargin(dataProperties) {
    var margin = {
      left: MARGIN_OFFSET.LEFT,
      right: MARGIN_OFFSET.RIGHT,
      top: MARGIN_OFFSET.TOP,
      bottom: MARGIN_OFFSET.BOTTOM
    };
    if (this._margin) {
      var _margin = this._margin;
      margin.left += _margin.left || 0;
      margin.right += _margin.right || 0;
    }
    return utils_calculateMargin(margin, {
      hasXAxis: false,
      hasYAxis: !!this._showYAxis && dataProperties.hasLeftAxis,
      hasXAxisLabel: !!this.xAxisLabel,
      hasYAxisLabel: !!this.yAxisLabel,
      hasYAxis2: !!this._showYAxis2 && dataProperties.hasRightAxis && !this._splitYAxes,
      hasLegend: !!this._shouldShowLegend,
      hasYAxis2Label: !!this.yAxis2Label && !this._splitYAxes,
      maxYAxisValueSize: dataProperties.maxYLeftValueSize,
      maxYAxis2ValueSize: dataProperties.maxYRightValueSize,
      dataLabelOverflow: dataProperties.dataLabelOverflow,
      splitYAxes: !!this._splitYAxes,
      lineCount: dataProperties.lineCount,
      lineHeight: getTextHeight('dq', null, this.getContainer()),
      xAxisLabelPadding: this.xAxisLabel ? multi_chart_AXIS_LABEL_DISTANCE : 0,
      yAxisLabelPadding: this.yAxisLabel ? multi_chart_AXIS_LABEL_DISTANCE : 0,
      xAxisTickLeftPadding: upgradedGetDateAxisMargin(this.dateAxisGroupBy)
    });
  },
  createReferenceLines: function createReferenceLines(dataProperties) {
    var referenceLine;
    if (!this.getReferenceLines()) {
      this.layout.remove('referenceLines');
    } else {
      referenceLine = upgradedDqReferenceLine();
      referenceLine.xScale(this.chart.xScale());
      if (dataProperties.hasLeftAxis) {
        referenceLine.yScale(this.chart.yScale());
      } else {
        referenceLine.yScale(this.chart.yScale2());
      }
      this.layout.host('referenceLines', referenceLine, this.getReferenceLines());
    }
  },
  createLegend: function createLegend() {
    this.legend = upgradedDqLegend();
    this.legend.colorScheme(this.colorScheme).position(this._legendPosition).alignment(this._legendAlignment).distance(this._legendDistance);
    var legendData = this.getLegendData();
    if (this._shouldShowLegend) {
      this.layout.host('legend', this.legend, legendData);
    } else {
      this.layout.remove('legend');
    }
    if (this.shouldDisableLegendClick()) {
      this.legend.clickDisabled(true).animationDuration(0);
    }
  },
  getLegendData: function getLegendData() {
    var _this$getData;
    var data = (_this$getData = this.getData()) !== null && _this$getData !== void 0 ? _this$getData : [];
    var seriesData = data.filter(function (_ref) {
      var key = _ref.key;
      return !_.isNil(key);
    });
    if (this.stacked) {
      seriesData.reverse();
    }
    var referenceLines = this.getReferenceLines() || [];
    var referenceLineData = referenceLines.filter(function (_ref2) {
      var hideLegend = _ref2.hideLegend,
        key = _ref2.key;
      return !hideLegend && !_.isNil(key);
    }).map(function (_ref3) {
      var color = _ref3.color,
        key = _ref3.key;
      return {
        legendShape: 'line',
        color: color,
        key: key
      };
    });
    return [].concat(multi_chart_toConsumableArray(seriesData), multi_chart_toConsumableArray(referenceLineData));
  },
  processData: function processData() {
    if (this.getData()) {
      this.handleNonNumericX();
    }
  },
  handleNonNumericX: function handleNonNumericX() {
    var labels = {},
      data = this.getData();
    _.forEach(data, function (series) {
      _.forEach(series.values, function (d, i) {
        labels[i] = _.isUndefined(d.label) ? d.x : d.label || '';
      });
    });
    this._labels = labels;
  },
  getDataProperties: function getDataProperties() {
    var properties = {
      types: [],
      hasLeftAxis: false,
      hasRightAxis: false,
      dataLabelOverflow: 0,
      maxYLeftValueSize: 0,
      maxYRightValueSize: 0,
      yAxis1: {
        minValue: undefined,
        maxValue: undefined
      },
      yAxis2: {
        minValue: undefined,
        maxValue: undefined
      }
    };
    var data = this.getData();
    data.forEach(function (series) {
      if (series.yAxis === 1) {
        properties.hasLeftAxis = true;
        series.values.forEach(function (value) {
          if (value.y < properties.yAxis1.minValue || !_.isNumber(properties.yAxis1.minValue)) {
            properties.yAxis1.minValue = value.y;
          }
          if (value.y > properties.yAxis1.maxValue || !_.isNumber(properties.yAxis1.maxValue)) {
            properties.yAxis1.maxValue = value.y;
          }
        });
      }
      if (series.yAxis === 2) {
        properties.hasRightAxis = true;
        series.values.forEach(function (value) {
          if (value.y < properties.yAxis2.minValue || !_.isNumber(properties.yAxis2.minValue)) {
            properties.yAxis2.minValue = value.y;
          }
          if (value.y > properties.yAxis2.maxValue || !_.isNumber(properties.yAxis2.maxValue)) {
            properties.yAxis2.maxValue = value.y;
          }
        });
      }
    });
    if (!_.isFunction(this._tickFormat) && properties.yAxis1.minValue !== undefined && properties.yAxis1.maxValue !== undefined) {
      var tickRange = properties.yAxis1.maxValue - properties.yAxis1.minValue;
      this.setTickFormat(format('.' + getNumDigitsAfterDecimal(tickRange) + 'f'));
    }
    if (!_.isFunction(this._yAxis2TickFormat) && properties.yAxis2.minValue !== undefined && properties.yAxis2.maxValue !== undefined) {
      var _tickRange = properties.yAxis2.maxValue - properties.yAxis2.minValue;
      this.setYAxis2TickFormat(format('.' + getNumDigitsAfterDecimal(_tickRange) + 'f'));
    }
    var formatTickLeft = _.isFunction(this._tickFormat) ? this._tickFormat : _.identity;
    var formatTickRight = _.isFunction(this._yAxis2TickFormat) ? this._yAxis2TickFormat : formatTickLeft,
      self = this;
    _.forEach(data, function (entry) {
      var isRightAxis = entry.yAxis === 2,
        isLeftAxis = entry.yAxis === 1 || !entry.yAxis,
        formatTick = isRightAxis ? formatTickRight : formatTickLeft;
      if (isLeftAxis) {
        properties.hasLeftAxis = true;
        var axisRange = entry.values.concat([{
          y: self._axisMin
        }, {
          y: self._axisMax
        }]);
        properties.maxYLeftValueSize = Math.max(properties.maxYLeftValueSize, getMaxY1AxisLength(axisRange, formatTick, self.getContainer()));
      }
      if (isRightAxis) {
        properties.hasRightAxis = true;
        properties.maxYRightValueSize = Math.max(properties.maxYRightValueSize, getMaxY2AxisLength(entry.values, formatTick, self.getContainer()));
      }
    });
    if (this.stacked || this.chartType === 'area') {
      if (properties.maxYLeftValueSize) {
        properties.maxYLeftValueSize += constants_Constants.FONT_SIZE;
      }
      if (properties.maxYRightValueSize) {
        properties.maxYRightValueSize += constants_Constants.FONT_SIZE;
      }
    }
    properties.dataLabelOverflow = this.calculateDataLabelOverflow(properties.maxYLeftValueSize, properties.maxYRightValueSize);
    return properties;
  },
  calculateDataLabelOverflow: function calculateDataLabelOverflow(maxYLeftValueSize, maxYRightValueSize) {
    var showLastDataValue = this._showDataValue === 'last';
    var showRightLineLabels = this._lineLabelLocation === constants_Constants.LINE_LABEL_PLACEMENT.RIGHT;
    var showAllDataValues = this._showDataValue === 'all';
    if (!showLastDataValue && !showRightLineLabels) {
      return 0;
    }
    var containerWidth = this.getContainerDimensions().width;
    var data = this.getData();
    var xLabelCount = data.reduce(function (maxCount, _ref4) {
      var values = _ref4.values;
      return Math.max(maxCount, values.length);
    }, 0);
    var xTickWidth = containerWidth / (xLabelCount + 1);
    var lastDataValueWidth = 0;
    if (showLastDataValue) {
      lastDataValueWidth = Math.max(maxYLeftValueSize, maxYRightValueSize);
    } else if (showAllDataValues) {
      lastDataValueWidth = Math.max(maxYLeftValueSize, maxYRightValueSize) / 2;
    }
    var rightLineLabelWidth = 0;
    if (showRightLineLabels) {
      var labelPadding = constants_Constants.LINE_LABEL_PADDING_X * 2 + constants_Constants.LINE_LABEL_MARGIN;
      var allowedWidth = this.getMaxLineLabelWidth() - labelPadding;
      var fontSize = constants_Constants.FONT_SIZE;
      var container = this.getContainer();
      rightLineLabelWidth = data.map(function (_ref5) {
        var key = _ref5.key;
        return upgraded_utils_getWrappedTextLength(key, fontSize, container, allowedWidth);
      }).reduce(function (max, width) {
        return Math.max(max, width);
      }, 0) + labelPadding;
    }
    return Math.max(0, Math.ceil(lastDataValueWidth + rightLineLabelWidth - xTickWidth / 2));
  },
  getMaxLineLabelWidth: function getMaxLineLabelWidth() {
    var containerWidth = this.getContainerDimensions().width;
    var pct = constants_Constants.LINE_LABEL_MAX_PCT;
    if (this._lineLabelLocation === constants_Constants.LINE_LABEL_PLACEMENT.RIGHT) {
      pct = constants_Constants.RIGHT_LINE_LABEL_WIDTHS.find(function (_ref6) {
        var THRESHOLD = _ref6.THRESHOLD;
        return containerWidth >= THRESHOLD;
      }).MAX_PERCENTAGE;
    }
    return pct * containerWidth;
  },
  resize: function resize() {
    var prop;
    if (this.chart) {
      this.resizeContainer();
      prop = this.getDataProperties();
      this.chart.lineCount(prop.lineCount);
      this.configureAxis(prop);
      this.configureMargins(prop);
      this.layout.renderHostedComponents({
        containerDimensions: this.getContainerDimensions(),
        container: this.getContainer(),
        margin: this._margin
      });
    }
  }
}, {
  Name: 'MultiChart',
  Dimensions: '2'
});
;// ./src/js/viz/config/view_config/bar_chart_config.js


var BarChartViewDefaults = {
  isStacked: false
};
var BarChartViewConfig = {
  setViewConfig: function setViewConfig(viewConfig) {
    var mergedOptions = Object.assign({}, BarChartViewDefaults, viewConfig);
    MultiChartViewConfig.setViewConfig.call(this, mergedOptions);
    this.isStacked(mergedOptions.isStacked);
    return this;
  }
};
;// ./src/js/viz/nvd3/charts/bar_chart.js


var BarChart = MultiChart.extend({
  initialize: function initialize() {
    this.chartType = 'bar';
    return MultiChart.prototype.initialize.apply(this, arguments);
  },
  isStacked: function isStacked(val) {
    this.stacked = !!val;
    return this;
  }
}, {
  Name: 'BarChart',
  DataDimensions: '2'
}).extend(BarChartViewConfig);
;// ./src/js/viz/nvd3/charts/horizontal_bar_chart.js









function horizontal_bar_chart_toConsumableArray(r) { return horizontal_bar_chart_arrayWithoutHoles(r) || horizontal_bar_chart_iterableToArray(r) || horizontal_bar_chart_unsupportedIterableToArray(r) || horizontal_bar_chart_nonIterableSpread(); }
function horizontal_bar_chart_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function horizontal_bar_chart_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return horizontal_bar_chart_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? horizontal_bar_chart_arrayLikeToArray(r, a) : void 0; } }
function horizontal_bar_chart_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function horizontal_bar_chart_arrayWithoutHoles(r) { if (Array.isArray(r)) return horizontal_bar_chart_arrayLikeToArray(r); }
function horizontal_bar_chart_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }













var HorizontalBarChartConfig = Object.assign({}, AxisChartConfig, {
  _stacked: false,
  _tooltipGravity: 's',
  isStacked: function isStacked(stacked) {
    this._stacked = !!stacked;
    return this;
  }
});
var getReferenceLineLegendData = function getReferenceLineLegendData(referenceLines) {
  var legendData = [];
  _.forEach(referenceLines, function (line) {
    if (!line.hideLegend) {
      legendData.push({
        legendShape: 'line',
        color: line.color,
        key: line.key
      });
    }
  });
  return legendData;
};
var HorizontalBarChart = UpgradedNvCore.extend(HorizontalBarChartConfig).extend(EventConfig).extend(DataCubeMultiChartConfig).extend(BarChartViewConfig).extend(WidgetAsFilterConfig).extend({
  initialize: function initialize() {
    this.colorScheme = upgradedBaseColorScheme();
    this.layout = new ChartLayout();
    return UpgradedNvCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(callback) {
    this.wrapContainer();
    this._pendingDataUpdate && this.processData();
    this.configureComponents();
    attachRenderEndCallback(this.chart, callback);
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      container: this.getContainer(),
      margin: this._margin
    });
    return this;
  },
  configureComponents: function configureComponents() {
    this.createAndConfigChart();
    this.createAndConfigLegend();
    var dataProperties = {
      hasLeftAxis: true
    };
    this.createReferenceLines(dataProperties);
  },
  createAndConfigChart: function createAndConfigChart() {
    var maxXValueSize = this.getXAxisSize();
    var self = this;
    if (!this.chart) {
      this.chart = js_nv.models.multiBarHorizontalChart();
    }
    this.chart.showControls(false).duration(this._animationDuration).stacked(!!this._stacked).showLegend(false).color(this.colorScheme).disableInteraction(this._disableInteraction).useRegionInteraction(this._useRegionInteraction).wrapLabels(true).showVerticalGrid(!!this._showVerticalGrid).valuePadding(this.valuePadding).widgetAsFilter(!!this._widgetAsFilter).showValues(!!this._showDataValue);
    this.addTooltip();
    this.layout.host('chart', this.chart, this.data);
    this.setAxisConfig(maxXValueSize);
    this.setMargins(maxXValueSize);
    _.forEach(this._eventHandlers, function (handler, event) {
      self.chart.dispatch.on(event, handler);
    });
  },
  setAxisConfig: function setAxisConfig(maxXValueSize) {
    var self = this;
    this.chart.wrapLabels(true);
    this.chart.xAxis.axisLabelDistance(maxXValueSize + 14);
    this.chart.yAxis.axisLabelDistance(6);
    this.chart.showYAxis(!!this._showYAxis);
    this.chart.showXAxis(!!this._showXAxis);
    this.chart.xAxis.axisLabel(this.xAxisLabel);
    this.chart.yAxis.rotateLabels(this._rotateAxisAngle);
    this.chart.yAxis.axisLabel(this.yAxisLabel);
    this.chart.x(function (d, i) {
      return i !== null && i !== void 0 ? i : d.x;
    });
    if (!this.stacked) {
      this.chart.yDomainMin(this._axisMin);
    }
    if (!this.stacked) {
      this.chart.yDomainMax(this._axisMax);
    }
    this.chart.xAxis.tickFormat(function (d) {
      return self.labels[d];
    });
    if (_.isFunction(this._tickFormat)) {
      this.chart.yAxis.tickFormat(this._tickFormat);
    }
  },
  resetState: function resetState() {
    this._pendingDataUpdate = false;
  },
  createAndConfigLegend: function createAndConfigLegend() {
    this.legend = upgradedDqLegend();
    this.legend.colorScheme(this.colorScheme).position(this._legendPosition).alignment(this._legendAlignment).distance(this._legendDistance);
    var legendData = this.getLegendData();
    if (this._shouldShowLegend) {
      this.layout.host('legend', this.legend, legendData);
    } else {
      this.layout.remove('legend', this.legend);
    }
  },
  getLegendData: function getLegendData() {
    var _this$getData;
    var data = (_this$getData = this.getData()) !== null && _this$getData !== void 0 ? _this$getData : [];
    var seriesData = data.filter(function (_ref) {
      var key = _ref.key;
      return !_.isNil(key);
    });
    var referenceLines = this.getReferenceLines() || [];
    var referenceLineData = referenceLines.filter(function (_ref2) {
      var hideLegend = _ref2.hideLegend,
        key = _ref2.key;
      return !hideLegend && !_.isNil(key);
    }).map(function (_ref3) {
      var color = _ref3.color,
        key = _ref3.key;
      return {
        legendShape: 'line',
        color: color,
        key: key
      };
    });
    return [].concat(horizontal_bar_chart_toConsumableArray(seriesData), horizontal_bar_chart_toConsumableArray(referenceLineData));
  },
  createReferenceLines: function createReferenceLines(dataProperties) {
    var referenceLine;
    if (!this.getReferenceLines()) {
      this.layout.remove('referenceLines');
    } else {
      referenceLine = upgradedDqReferenceLine();
      referenceLine.yScale(this.chart.xScale());
      if (dataProperties.hasLeftAxis) {
        referenceLine.xScale(this.chart.yScale());
      } else {
        referenceLine.xScale(this.chart.yScale2());
      }
      this.layout.host('referenceLines', referenceLine, this.getReferenceLines());
    }
  },
  setMargins: function setMargins(maxXValueSize) {
    var margin = {
      left: 0,
      right: 10,
      top: 10,
      bottom: 0
    };
    if (this._margin) {
      var _margin = this._margin;
      margin.left += _margin.left || 0;
      margin.right += _margin.right || 0;
    }
    margin = utils_calculateMargin(margin, {
      hasXAxis: !!this._showXAxis,
      hasYAxis: !!this._showYAxis,
      hasXAxisLabel: !!this.xAxisLabel,
      hasYAxisLabel: !!this.yAxisLabel,
      maxXValueSize: maxXValueSize,
      horizontalChart: true
    });
    this.chart.margin(margin);
  },
  processData: function processData() {
    if (this.data) {
      this.extractDataProperties();
    }
  },
  extractDataProperties: function extractDataProperties() {
    var formatFunction = this._tickFormat || _.identity;
    var svgContainer = this.getContainer();
    var labels = {};
    this.data.forEach(function (series) {
      series.values.forEach(function (_ref4, i) {
        var label = _ref4.label,
          x = _ref4.x;
        labels[i] = label !== null && label !== void 0 ? label : x;
      });
    });
    this.labels = labels;
    this.valuePadding = 0;
    if (this._showDataValue && !this._stacked) {
      this.valuePadding = this.data.reduce(function (max, _ref5) {
        var values = _ref5.values;
        return values.reduce(function (maxYValue, _ref6) {
          var y = _ref6.y,
            icon = _ref6.icon;
          var textWidth = utils_getTextLength(formatFunction(y), null, svgContainer);
          var iconWidth = icon ? constants_Constants.BAR_ICON_WIDTH : 0;
          return Math.max(maxYValue, textWidth + iconWidth);
        }, max);
      }, 0);
    }
  },
  getXAxisSize: function getXAxisSize() {
    var maxXValueSize = 0,
      width = this.getContainerDimensions().width,
      svgContainer = this.getContainer();
    _.forEach(this.labels, function (text) {
      maxXValueSize = Math.max(maxXValueSize, utils_getTextLength(text, null, svgContainer) || 0);
    });
    return Math.min(maxXValueSize, width * 0.3);
  },
  resize: function resize() {
    var maxXValueSize;
    if (this.chart) {
      this.resizeContainer();
      maxXValueSize = this.getXAxisSize();
      this.setAxisConfig(maxXValueSize);
      this.setMargins(maxXValueSize);
      this.layout.renderHostedComponents({
        containerDimensions: this.getContainerDimensions(),
        container: this.getContainer(),
        margin: this._margin
      });
    }
  }
}, {
  Name: 'BarChart',
  DataDimensions: '2'
});
;// ./src/js/viz/config/view_config/line_chart_config.js


var LineChartViewDefaults = {
  isSpline: false,
  isDashed: false
};
var LineChartViewConfig = {
  setViewConfig: function setViewConfig(viewConfig) {
    var mergedOptions = Object.assign({}, LineChartViewDefaults, viewConfig);
    MultiChartViewConfig.setViewConfig.call(this, mergedOptions);
    this.isSpline(mergedOptions.isSpline);
    this.isDashed(mergedOptions.isDashed);
    return this;
  }
};
;// ./src/js/viz/nvd3/charts/line_chart.js



var LineChart = MultiChart.extend({
  initialize: function initialize() {
    this.chartType = 'line';
    this.spline = false;
    return MultiChart.prototype.initialize.apply(this, arguments);
  },
  isSpline: function isSpline(val) {
    this.spline = !!val;
    return this;
  },
  isDashed: function isDashed(val) {
    this.dashed = !!val;
    return this;
  },
  setDataSizedGridLines: function setDataSizedGridLines(val) {
    this.dataSizedVerticalGrids = !!val;
    return this;
  },
  setLineLabelPosition: function setLineLabelPosition(labelPosition) {
    this._lineLabelLocation = labelPosition;
    this._shouldShowLegend = labelPosition === constants_Constants.LINE_LABEL_PLACEMENT.LEGEND;
    return this;
  }
}, {
  Name: 'LineChart',
  DataDimensions: '2'
}).extend(LineChartViewConfig);
;// ./src/js/viz/nvd3/charts/area_chart.js


var AreaChart = MultiChart.extend({
  initialize: function initialize() {
    this.chartType = 'area';
    return MultiChart.prototype.initialize.apply(this, arguments);
  }
}, {
  Name: 'AreaChart',
  DataDimensions: '2'
}).extend(MultiChartViewConfig);
;// ./src/js/viz/nvd3/charts/nv_core.js





var NvCore = function NvCore() {
  this.initialize.apply(this, arguments);
};
NvCore.extend = utils_inherit;
Object.assign(NvCore.prototype, {
  initialize: function initialize(options) {
    if (options.containerId) {
      this.parentContainerId = options.containerId;
    }
    this.clearContainer();
    this.wrapContainer();
    this.wrapRender();
    this.wrapResize();
    return this;
  },
  clearContainer: function clearContainer() {
    var parentContainer = this.getParentContainer();
    if (this.parentContainerId && !parentContainer.empty()) {
      parentContainer.html('');
    }
  },
  wrapContainer: function wrapContainer() {
    var parentContainer = this.getParentContainer();
    if (!this.parentContainerId) {
      return false;
    }
    if (this.containerId && !this.getContainer().empty()) {
      return false;
    }
    if (!this.containerId) {
      this.containerId = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().uniqueId('NvD3Chart');
    }
    parentContainer.append('svg').attr('id', this.containerId).classed('dq', true).classed((less_default()).dq, true);
    return true;
  },
  wrapRender: function wrapRender() {
    var renderFn = this.render;
    this.render = function () {
      if (this.getParentContainer().empty()) {
        return;
      }
      this.wrapContainer();
      this.resizeContainer();
      renderFn.apply(this, arguments);
    };
  },
  wrapResize: function wrapResize() {
    var resizeFn = this.resize;
    this.resize = function () {
      if (this.getParentContainer().empty()) {
        return;
      }
      this.wrapContainer();
      resizeFn.apply(this, arguments);
    };
  },
  setContainerDimensions: function setContainerDimensions(width, height) {
    var svgContainer = this.getContainer();
    if (svgContainer) {
      svgContainer.attr('width', width).attr('height', height);
    }
  },
  resizeContainer: function resizeContainer() {
    var parentContainer = this.getParentContainer(),
      containerDimensions;
    if (parentContainer.empty()) {
      return;
    }
    this.setContainerDimensions(1, 1);
    containerDimensions = this.getContainerDimensions();
    this.setContainerDimensions(containerDimensions.width, containerDimensions.height);
  },
  getParentContainer: function getParentContainer() {
    return external_d3_default().select(wrapId(this.parentContainerId));
  },
  getContainer: function getContainer() {
    return external_d3_default().select(wrapId(this.parentContainerId)).select(wrapId(this.containerId));
  },
  getContainerDimensions: function getContainerDimensions() {
    var parentContainer = external_d3_default().select(wrapId(this.parentContainerId)),
      width = 0,
      height = 0;
    if (!parentContainer.empty()) {
      width = parseInt(parentContainer.style('width'), 10), height = parseInt(parentContainer.style('height'), 10);
    }
    return {
      width: width,
      height: height
    };
  },
  remove: function remove() {
    var container = this.getContainer();
    container && container.remove();
  },
  addTooltip: function addTooltip() {
    var _this = this;
    var tooltipModel = this.chart && this.chart.tooltip;
    if (!tooltipModel) {
      return;
    }
    var showTooltip = !!(this._showTooltip && this.tooltip);
    var tooltipContent = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(this.tooltip) ? this.tooltip : function () {
      return _this.tooltip;
    };
    var gravity = this._tooltipGravity;
    tooltipModel.enabled(showTooltip);
    tooltipModel.contentGenerator(tooltipContent);
    tooltipModel.gravity(gravity);
  }
});

;// ./src/js/viz/components/legend.js








function legend_slicedToArray(r, e) { return legend_arrayWithHoles(r) || legend_iterableToArrayLimit(r, e) || legend_unsupportedIterableToArray(r, e) || legend_nonIterableRest(); }
function legend_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function legend_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return legend_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? legend_arrayLikeToArray(r, a) : void 0; } }
function legend_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function legend_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function legend_arrayWithHoles(r) { if (Array.isArray(r)) return r; }





var legend_DEFAULT_LEGEND_MAX_KEY_LENGTH = 20;
var legend_getFontSize = function getFontSize(textNode) {
  if (textNode.style) {
    return parseInt(textNode.style('font-size').replace('px', ''), 10);
  }
  return 12;
};
var legend_setupLegendContainer = function setupLegendContainer(container) {
  var legendContainer = container.select('g.dq-legend');
  if (legendContainer.empty()) {
    container.append('g').attr('class', 'dq-legend').append('g');
  }
  return container.select('g.dq-legend g');
};
var legend_setupLegendTitle = function setupLegendTitle(container, config) {
  container.select('g.dq-legend g');
  container.append('g').attr('class', 'dq-legend-title').append('text').text(config.title);
  return container.select('g.dq-legend g');
};
var legend_getActiveCount = function getActiveCount(data) {
  var count = 0;
  _.forEach(data, function (entry) {
    entry.disabled || count++;
  });
  return count;
};
var legend_generateElementSize = function generateElementSize(legendElements, config) {
  var sizeList = [];
  legendElements.each(function (data, index) {
    var textElement = external_d3_default().select(this).select('text');
    var fontSize = legend_getFontSize(textElement);
    var height = fontSize + config.perElementSpacing;
    var width = config.iconDimensions + config.iconBorderWidth + config.innerPadding;
    try {
      width += textElement.node().getComputedTextLength();
    } catch (_unused) {
      width += textElement.text().length * fontSize * 0.6;
    }
    sizeList.push([config.getId(data, index), width, height]);
  });
  return sizeList;
};
var legend_generateTitleSize = function generateTitleSize() {
  var textElement = external_d3_default().select('.dq-legend-title').select('text');
  var fontSize = legend_getFontSize(textElement);
  var width = 0;
  try {
    width += textElement.node().getComputedTextLength();
  } catch (_unused2) {
    width += textElement.text().length * fontSize * 0.6;
  }
  return [width, fontSize];
};
var legend_generateLayout = function generateLayout(legendElements, config) {
  var elementSize = legend_generateElementSize(legendElements, config);
  var _ref = config.title ? legend_generateTitleSize() : [0, 0],
    _ref2 = legend_slicedToArray(_ref, 2),
    titleWidth = _ref2[0],
    titleHeight = _ref2[1];
  var curX = 0;
  var curY = titleHeight;
  var layout = {};
  var legendWidth = 0;
  var legendHeight = 0;
  var rowHeight = 0;
  var rowWidth = 0;
  var containerX = 0;
  var containerY = 0;
  if (config.orientation === 'horizontal') {
    _.forEach(elementSize, function (element) {
      var key = element[0],
        width = element[1],
        height = element[2];
      if (curX + width > config.width) {
        var rowHeightWithPadding = rowHeight + config.innerPadding;
        legendWidth = legendWidth > curX ? legendWidth : curX;
        curX = 0;
        curY += rowHeightWithPadding;
        legendHeight += rowHeightWithPadding;
      }
      layout[key] = 'translate(' + curX + ', ' + curY + ')';
      curX += width + config.padding;
      rowHeight = rowHeight > height ? rowHeight : height;
    });
    legendHeight += rowHeight;
    var curWidth = curX - config.padding;
    legendWidth = legendWidth > curWidth ? legendWidth : curWidth;
    containerY = 0;
    config.height = legendHeight;
  } else {
    _.forEach(elementSize, function (element) {
      var key = element[0],
        width = element[1],
        height = element[2];
      if (curY + height > config.height) {
        var rowWidthWithPadding = rowWidth + config.padding;
        curY = 0;
        curX += rowWidthWithPadding;
        legendWidth += rowWidthWithPadding;
      }
      layout[key] = 'translate(' + curX + ', ' + curY + ')';
      curY += height;
      rowWidth = rowWidth > width ? rowWidth : width;
      legendHeight = legendHeight > curY ? legendHeight : curY;
      curY += config.innerPadding;
    });
    legendWidth += rowWidth;
    containerY = (config.height - legendHeight) / 2;
    config.width = Math.max(legendWidth, titleWidth);
  }
  if (config.alignment === 'left') {
    containerX = 0;
  } else if (config.alignment === 'center') {
    containerX = (config.width - legendWidth) / 2;
  } else {
    containerX = config.width - legendWidth;
  }
  layout.containerTranslation = 'translate(' + containerX + ', ' + containerY + ')';
  return layout;
};
var legend_calculateAutomatedKeyLength = function calculateAutomatedKeyLength(config, elementCount) {
  var allowedRows = 0;
  var requiredElementsPerRow = 0;
  var requiredElementsPerCol = 0;
  var suggestedMaxKeyLength = 0;
  var CHAR_WIDTH = constants_Constants.CHAR_WIDTH;
  if (config.orientation === 'horizontal') {
    var limitHeight = config.automatedMaxKeyLengthLegendHeight || 0.25;
    allowedRows = Math.floor(config.height * limitHeight / CHAR_WIDTH);
    requiredElementsPerRow = Math.ceil(elementCount / allowedRows);
    suggestedMaxKeyLength = Math.floor(config.width / CHAR_WIDTH / requiredElementsPerRow);
  } else {
    var limitWidth = config.automatedMaxKeyLengthLegendWidth || 0.15;
    requiredElementsPerCol = Math.ceil(elementCount / Math.ceil(config.height / CHAR_WIDTH));
    suggestedMaxKeyLength = Math.floor(Math.floor(config.width * limitWidth) / (requiredElementsPerCol * CHAR_WIDTH));
  }
  return suggestedMaxKeyLength;
};
var legend_addLegendIcon = function addLegendIcon(data, group, iconDimensions, borderWidth) {
  var verticalOffset = borderWidth / 2;
  var legendShape = legend_getLegendIconShape(data);
  var radius = Math.floor(iconDimensions / 2);
  switch (legendShape) {
    case constants_Constants.LEGEND_SHAPES.RECTANGLE:
      return group.append('rect').attr('class', 'dq-legend-icon rectangle').attr('width', iconDimensions).attr('height', iconDimensions).attr('stroke-width', borderWidth).attr('y', verticalOffset);
    case constants_Constants.LEGEND_SHAPES.LINE:
      return group.append('line').attr('class', 'dq-legend-icon line').attr('x2', iconDimensions).attr('x1', 0).attr('y2', 0 + verticalOffset).attr('y1', iconDimensions).attr('stroke-width', 2);
    case constants_Constants.LEGEND_SHAPES.SQUARE:
      return group.append('rect').attr('class', 'dq-legend-icon roundedSquare').attr('width', iconDimensions).attr('height', iconDimensions).attr('rx', 2).attr('ry', 2).attr('stroke-width', borderWidth).attr('y', verticalOffset);
    case constants_Constants.LEGEND_SHAPES.CIRCLE:
    default:
      return group.append('circle').attr('class', 'dq-legend-icon circle').attr('r', radius).attr('cx', radius).attr('cy', radius + verticalOffset).attr('stroke-width', borderWidth);
  }
};
var legend_generateLegendIcons = function generateLegendIcons(selection, iconDimensions, iconBorderWidth) {
  selection.each(function (data) {
    var group = external_d3_default().select(this);
    return legend_addLegendIcon(data, group, iconDimensions, iconBorderWidth);
  });
};
var legend_updateLegendIcons = function updateLegendIcons(selection, iconDimensions, iconBorderWidth) {
  selection.each(function (data) {
    var group = external_d3_default().select(this),
      element = group.select('.dq-legend-icon'),
      tagName = element.node().tagName;
    if (tagName !== data.legendShape || !data.legendShape && tagName !== 'rect') {
      element.remove();
      legend_addLegendIcon(data, group, iconDimensions, iconBorderWidth);
    }
  });
};
var legend_getLegendIconShape = function getLegendIconShape(data) {
  if (data.type === constants_Constants.DATA_TYPES.LINE) {
    return constants_Constants.LEGEND_SHAPES.CIRCLE;
  } else if (data.type === constants_Constants.DATA_TYPES.BAR) {
    return constants_Constants.LEGEND_SHAPES.SQUARE;
  } else if (data.legendShape === constants_Constants.LEGEND_SHAPES.LINE) {
    return constants_Constants.LEGEND_SHAPES.LINE;
  }
  return constants_Constants.LEGEND_SHAPES.SQUARE;
};
var dqLegend = function dqLegend() {
  var config = {
      orientation: 'horizontal',
      alignment: 'left',
      maxKeyLength: legend_DEFAULT_LEGEND_MAX_KEY_LENGTH,
      animationDuration: constants_Constants.ANIMATION_DURATION,
      position: 'bottom',
      innerPadding: 8,
      padding: 16,
      iconDimensions: 10,
      iconBorderWidth: 0,
      distance: 16,
      automatedMaxKeyLength: true,
      automatedMaxKeyLengthLegendWidth: false,
      automatedMaxKeyLengthLegendHeight: false,
      width: 800,
      height: 500,
      getKey: function getKey(d) {
        return d.key;
      },
      getId: function getId(d, index) {
        return index;
      },
      clickDisabled: false,
      colorScheme: external_d3_default().scale.category10(),
      perElementSpacing: 3,
      title: null
    },
    dispatch = external_d3_default().dispatch('legendClick', 'stateChange', 'ariaLabelChange');
  var updateActiveLegendItems = function updateActiveLegendItems() {
    var activeLegendItems = external_d3_default().selectAll('.dq-legend-element')[0].filter(function (element) {
      return element.getAttribute('aria-pressed') === 'true';
    });
    if (activeLegendItems.length === 1) {
      external_d3_default().select('.dq-legend-element').attr('aria-disabled', true).attr('aria-label', function (d) {
        return config.getKey(d) + ' ' + translationService.translate('DQ.LegendCannotBeToggled');
      });
    } else {
      activeLegendItems.forEach(function (item) {
        return item.removeAttribute('aria-disabled');
      });
    }
  };
  var _legend = function legend(selection) {
    selection.each(function (data) {
      var container = external_d3_default().select(this);
      var legendContainer = legend_setupLegendContainer(container);
      var patternContainer = legendContainer.append('defs').node();
      var legendElements = legendContainer.selectAll('.dq-legend-element').data(data);
      var newEntries;
      var layout = {};
      var iconColor = function iconColor(d, i) {
        return d.color || config.colorScheme(d, i);
      };
      var suggestedMaxKeyLength;
      if (config.automatedMaxKeyLength) {
        suggestedMaxKeyLength = Math.max(config.maxKeyLength, legend_calculateAutomatedKeyLength(config, data.length));
      } else {
        suggestedMaxKeyLength = config.maxKeyLength;
      }
      var getTruncatedText = function getTruncatedText(d) {
        var text = config.getKey(d);
        if (text.length > suggestedMaxKeyLength && suggestedMaxKeyLength !== 0) {
          text = text.substring(0, suggestedMaxKeyLength - 3);
          text += '...';
        }
        return text;
      };
      if (config.title) {
        legend_setupLegendTitle(legendContainer, config);
      }
      newEntries = legendElements.enter().append('g').attr('class', 'dq-legend-element');
      newEntries.call(legend_generateLegendIcons, config.iconDimensions, config.iconBorderWidth);
      newEntries.append('text').attr('text-anchor', 'start').attr('class', 'dq-legend-text').attr('x', config.iconDimensions + config.innerPadding).attr('y', config.iconDimensions);
      legendElements.exit().remove();
      legendElements.call(legend_updateLegendIcons, config.iconDimensions, config.iconBorderWidth);
      legendContainer.attr('role', 'group').attr('aria-label', translationService.translate('DQ.LegendGroupAriaLabel')).selectAll('.dq-legend-element').selectAll('.dq-legend-icon').attr('stroke', iconColor).attr('fill', iconColor);
      legendContainer.selectAll('.dq-legend-element').attr('tabindex', '0').attr('role', 'button').attr('aria-pressed', 'true').attr('aria-label', function (d) {
        return config.getKey(d) + ' ' + translationService.translate('DQ.LegendToggleOn');
      });
      legendContainer.selectAll('.dq-legend-element').selectAll('.dq-legend-text').text(getTruncatedText);
      legendElements.each(function (d, i) {
        var textElement = external_d3_default().select(this).select('text');
        var iconElement = external_d3_default().select(this).select('.dq-legend-icon');
        var defaultColorFill = iconColor(d, i);
        var text = getTruncatedText(d, i);
        textElement.text(text);
        iconElement.attr('fill', defaultColorFill).attr('stroke', defaultColorFill);
        if (d.pattern && d.color) {
          iconElement.attr('fill', js_nv.utils.patternService.getDataFill(patternContainer, d, defaultColorFill)).attr('stroke-width', '1px');
        }
      });
      updateActiveLegendItems();
      layout = legend_generateLayout(legendElements, config);
      legendElements.each(function (data, index) {
        external_d3_default().select(this).classed('disabled', !!data.disabled).classed('click-disabled', !!config.clickDisabled).transition().duration(config.animationDuration).attr('transform', layout[config.getId(data, index)]);
      });
      legendContainer.attr('transform', layout.containerTranslation);
      if (!config.clickDisabled) {
        var handleClick = function handleClick(d, i, element) {
          if (!d.disabled && legend_getActiveCount(data) === 1) {
            return;
          }
          d.disabled = !d.disabled;
          dispatch.stateChange({
            disabled: data.map(function (d) {
              return !!d.disabled;
            })
          });
          dispatch.legendClick(d, i);
          dispatch.ariaLabelChange(d, i);
          element.classed('disabled', !!d.disabled);
          element.attr('aria-pressed', !d.disabled);
          updateActiveLegendItems();
          element.attr('aria-label', function (d) {
            var ariaString = ' ' + translationService.translate('DQ.LegendToggleOff');
            if (!d.disabled) {
              ariaString = ' ' + translationService.translate('DQ.LegendToggleOn');
            }
            return config.getKey(d) + ariaString;
          });
        };
        legendElements.on('click', function (d, i) {
          var element = external_d3_default().select(this);
          handleClick(d, i, element);
        });
        legendElements.on('keydown', function (d, i) {
          if ((external_d3_default()).event.key === 'Enter') {
            var element = external_d3_default().select(this);
            handleClick(d, i, element);
          }
        });
        legendElements.on('keyup', function (d, i) {
          if ((external_d3_default()).event.key === ' ') {
            var element = external_d3_default().select(this);
            handleClick(d, i, element);
          }
        });
      }
    });
    return _legend;
  };
  exposeConfig(_legend, config);
  _legend.dispatch = dispatch;
  return _legend;
};
;// ./src/js/viz/components/reference_line.js


var dqReferenceLine = function dqReferenceLine() {
  var config = {
      width: 400,
      height: 400,
      xScale: null,
      yScale: null,
      getX: function getX(d) {
        return d.x;
      },
      getY: function getY(d) {
        return d.y;
      },
      colorScheme: external_d3_default().scale.category20(),
      animationDuration: 200,
      getKey: function getKey(d) {
        return d.key;
      }
    },
    lifeCycle = new RenderLifeCycle();
  var referenceLine = function referenceLine(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var container = external_d3_default().select(this),
        refLines,
        xScale = config.xScale.copy(),
        yScale = config.yScale.copy();
      var linesData = reference_line_calculateLines(data, config, xScale, yScale);
      container.selectAll('.dq-reference-lines').data([data]).append('g').classed('dq-reference-lines', true);
      refLines = container.selectAll('.reference-line').data(data);
      refLines.enter().append('line').classed('reference-line', true);
      refLines.exit().remove();
      refLines.data(linesData).classed('vertical-reference-line', function (d) {
        return reference_line_getVerticalReferenceLine(d);
      }).classed('horizontal-reference-line', function (d) {
        return reference_line_getHorizontalReferenceLine(d);
      }).transition().duration(config.animationDuration).attr('x1', function (d) {
        return reference_line_getX1(d);
      }).attr('y1', function (d) {
        return reference_line_getY1(d);
      }).attr('x2', function (d) {
        return reference_line_getX2(d);
      }).attr('y2', function (d) {
        return reference_line_getY2(d);
      }).attr('stroke', function (d, i) {
        return reference_line_getStroke(d, i, config);
      }).attr('stroke-linecap', function (d) {
        return reference_line_getStrokeLinecap(d);
      }).attr('stroke-dasharray', function (d) {
        return reference_line_getStrokeDasharray(d);
      }).attr('stroke-width', function (d) {
        return reference_line_getStrokeWidth(d);
      }).call(lifeCycle.watch);
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(referenceLine, config);
  referenceLine.lifeCycle = lifeCycle;
  return referenceLine;
};
function reference_line_calculateLines(data, config, xScale, yScale) {
  xScale.clamp && xScale.clamp(true);
  yScale.clamp && yScale.clamp(true);
  data.map(function (d) {
    var val = config.getX(d),
      position;
    if (val !== undefined) {
      position = xScale(val);
      d.x1 = _.isNumber(position) ? position : 0;
      d.x2 = d.x1;
      d.y1 = 0;
      d.y2 = config.height;
    } else {
      position = yScale(config.getY(d));
      d.x1 = 0;
      d.x2 = config.width;
      d.y1 = _.isNumber(position) ? position : 0;
      d.y2 = d.y1;
    }
  });
  return data;
}
function reference_line_getVerticalReferenceLine(d) {
  return d.x1 === d.x2;
}
function reference_line_getHorizontalReferenceLine(d) {
  return d.y1 === d.y2;
}
function reference_line_getX1(d) {
  return d.x1;
}
function reference_line_getX2(d) {
  return d.x2;
}
function reference_line_getY1(d) {
  return d.y1;
}
function reference_line_getY2(d) {
  return d.y2;
}
function reference_line_getStroke(d, i, config) {
  return d.color || config.colorScheme(i);
}
function reference_line_getStrokeWidth(d) {
  return d.width || '1px';
}
function reference_line_getStrokeDasharray(d) {
  return d.dasharray || 'none';
}
function reference_line_getStrokeLinecap(d) {
  return d.linecap || 'round';
}
;// ./src/js/color_scheme/base_color_scheme.js


var base_color_scheme_colors = ['#1E88E5', '#00ACC1', '#43A047', '#C0CA33', '#FB8C00', '#E53935', '#8E24AA', '#3949AB', '#039BE5', '#00897B', '#7CB342', '#7CB342', '#FDD835', '#FFB300', '#F4511E', '#5E35B1'];
var baseColorScheme = function baseColorScheme(field) {
  var color_scale = external_d3_default().scale.ordinal().range(base_color_scheme_colors);
  return function (d, i) {
    var key;
    key = i === undefined ? d : i;
    if (field) {
      if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(field)) {
        key = field(d);
      } else if (d[field]) {
        key = d[field];
      }
    }
    return d.color || color_scale(key);
  };
};
var d3ColorScheme = function d3ColorScheme() {
  var color_scale = external_d3_default().scale.category10();
  return function (d, i) {
    return d.color || color_scale(i);
  };
};
;// ./src/js/viz/config/background_image_config.js

var BackgroundImageConfig = {
  _backgroundImageUrl: null,
  _backgroundImagePosition: null,
  BACKGROUND_IMAGE_POSITIONS: js_nv.constants.BACKGROUND_IMAGE_POSITIONS,
  setBackgroundImageUrl: function setBackgroundImageUrl(val) {
    this._backgroundImageUrl = val;
    return this;
  },
  setBackgroundImagePosition: function setBackgroundImagePosition(val) {
    this._backgroundImagePosition = val;
    return this;
  }
};
;// ./src/js/viz/nvd3/charts/scatter_plot.js


















var scatter_plot_AXIS_LABEL_DISTANCE = constants_Constants.AXIS_LABEL_DISTANCE;
var CHART_DEFAULT_MARGIN = 20;
var SIGNIFICANT_FIGURES = 1;
var DECIMAL_THRESHOLD = 1;
var SINGLE_DIGIT_THRESHOLD = 10;
var DECIMAL_DIGITS_FOR_SMALL_NUMBERS = 1;
var DECIMAL_DIGITS_FOR_SINGLE_DIGIT = 2;
var DECIMAL_DIGITS_FOR_LARGE_NUMBERS = 0;
function scatter_plot_getNumDigitsAfterDecimal(dataRange) {
  dataRange = Number(d3.format('.1r')(dataRange));
  if (dataRange < DECIMAL_THRESHOLD) {
    return Math.max(SIGNIFICANT_FIGURES, countDecimalDigits(dataRange)) + DECIMAL_DIGITS_FOR_SMALL_NUMBERS;
  } else if (dataRange < SINGLE_DIGIT_THRESHOLD) {
    return DECIMAL_DIGITS_FOR_SINGLE_DIGIT;
  } else {
    return DECIMAL_DIGITS_FOR_LARGE_NUMBERS;
  }
}
var ScatterPlotConfig = Object.assign({}, AxisChartConfig, PointRangeConfig, EventConfig, BackgroundImageConfig, AnimationConfig, {
  _interpolator: 'linear',
  _tooltipGravity: 'n',
  _sizeLabel: 'size',
  _sectionLabels: [],
  _sectionType: 'none',
  _xValueFormat: d3.format('.1f'),
  _yValueFormat: d3.format('.1f'),
  _enableOutlineBubbleStyle: false,
  _showSectionLabels: false,
  _isNumberOfResponsesShownInTooltip: false,
  _labelLocation: null,
  _staticPointSize: null,
  setSizeLabel: function setSizeLabel(label) {
    this._sizeLabel = label;
    return this;
  },
  setXValueFormat: function setXValueFormat(format) {
    this._xValueFormat = format;
    return this;
  },
  setYValueFormat: function setYValueFormat(format) {
    this._yValueFormat = format;
    return this;
  },
  enableOutlineBubbleStyle: function enableOutlineBubbleStyle(enable) {
    this._enableOutlineBubbleStyle = enable;
    return this;
  },
  isNumberOfResponsesShownInTooltip: function isNumberOfResponsesShownInTooltip(show) {
    this._isNumberOfResponsesShownInTooltip = show;
    return this;
  },
  showSectionLabels: function showSectionLabels(show) {
    this._showSectionLabels = !!show;
    return this;
  },
  setSectionLabels: function setSectionLabels(labels) {
    this._sectionLabels = labels;
    return this;
  },
  setSectionType: function setSectionType(type) {
    this._sectionType = type;
    return this;
  },
  setLabelLocation: function setLabelLocation(labelLocation) {
    this._labelLocation = labelLocation;
    return this;
  },
  setStaticPointSize: function setStaticPointSize(size) {
    this._staticPointSize = size;
    return this;
  }
});
var ScatterPlot = NvCore.extend(ScatterPlotConfig).extend({
  initialize: function initialize() {
    this.colorScheme = baseColorScheme();
    this.layout = new ChartLayout();
    return NvCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(callback) {
    this.configureChartComponents();
    attachRenderEndCallback(this.chart, callback);
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      container: this.getContainer(),
      margin: this._margin,
      maxLabelWidth: this.maxLabelWidth,
      animationDuration: this._animationDuration
    });
    return this;
  },
  configureChartComponents: function configureChartComponents() {
    var prop = this.getDataProperties();
    this.createAndConfigChart(prop);
    this.createAndConfigLegend();
    this.createReferenceLines();
  },
  createReferenceLines: function createReferenceLines() {
    var referenceLine;
    if (!this.getReferenceLines()) {
      this.layout.remove('referenceLines');
    } else {
      referenceLine = dqReferenceLine();
      referenceLine.animationDuration(this._animationDuration).xScale(this.chart.xScale()).yScale(this.chart.yScale());
      this.layout.host('referenceLines', referenceLine, this.getReferenceLines());
    }
  },
  maxLabelWidth: 220,
  createAndConfigChart: function createAndConfigChart(properties) {
    var self = this;
    this.chart || (this.chart = js_nv.models.scatterChart());
    this.chart.showLegend(false);
    this.chart.color(this.colorScheme);
    this.chart.showValues && this.chart.showValues(!!this._showDataValue);
    this.chart.showValuesType(this._showDataValueType);
    this.chart.backgroundImageUrl(this._backgroundImageUrl);
    this.chart.xAxisLabel(this.xAxisLabel);
    this.chart.yAxisLabel(this.yAxisLabel);
    this.chart.sizeLabel(this._sizeLabel);
    this.chart.xValueFormat(this._xValueFormat);
    this.chart.yValueFormat(this._yValueFormat);
    this.chart.backgroundImagePosition(this._backgroundImagePosition);
    this.chart.pointRange(this._pointRange || [100, 300]);
    this.chart.clipEdge(this._shouldFilterData || false);
    this.chart.duration(this._animationDuration);
    this.chart.enableOutlineBubbleStyle(this._enableOutlineBubbleStyle);
    this.chart.isNumberOfResponsesShownInTooltip(this._isNumberOfResponsesShownInTooltip);
    this.chart.showGridLineBorders(this._showGridLineBorders);
    this.chart.referenceLines(this.getReferenceLines());
    this.chart.labelLocation(this._labelLocation);
    if (this.chart.labelPlacementFunction) {
      this.chart.labelPlacementFunction(findPositionedLocations);
    }
    this.chart.useSubtleGrid(true);
    this.chart.staticPointSize(this._staticPointSize);
    this.addTooltip();
    this.layout.host('chart', this.chart, this.data);
    this.setAxisConfig(properties);
    this.setChartMargin(properties);
    this.setSectionLabelsConfig();
    this.chart.wrapLabels(this.maxLabelWidth);
    _.forEach(this._eventHandlers, function (handler, event) {
      if (self.chart.dispatch.hasOwnProperty(event)) {
        self.chart.dispatch.on(event, handler);
      }
    });
  },
  createAndConfigLegend: function createAndConfigLegend() {
    var self = this;
    this.legend = dqLegend();
    this.legend.animationDuration(this._animationDuration).colorScheme(this.colorScheme).position(this._legendPosition).distance(this._legendDistance);
    if (this._shouldShowLegend) {
      this.layout.host('legend', this.legend, this.data);
      _.forEach(this._eventHandlers, function (handler, event) {
        if (self.legend.dispatch.hasOwnProperty(event)) {
          self.legend.dispatch.on(event, handler);
        }
      });
    } else {
      this.layout.remove('legend');
    }
  },
  setAxisConfig: function setAxisConfig(prop) {
    this.chart.showYAxis(!!this._showYAxis).showXAxis(!!this._showXAxis).showHorizontalGrid(!!this._showHorizontalGrid).showVerticalGrid(!!this._showVerticalGrid).enableAutoAxisScaling(this._enableAutoAxisScaling);
    if (this._showInfiniteHorizontalGrid) {
      this.getContainer().classed('infinite-horizontal-grid', true);
    }
    this.chart.xAxis.axisLabel(this.xAxisLabel);
    this.chart.yAxis.axisLabel(this.yAxisLabel);
    this.chart.xAxis.axisLabelDistance(22);
    if (!!this._showXAxis && this.xAxisLabel) {
      this.chart.xAxis.axisLabelDistance(prop.lineHeight);
      if (this.chart.useSubtleGrid()) {
        this.chart.xAxis.axisLabelDistance(scatter_plot_AXIS_LABEL_DISTANCE);
      }
    }
    if (!!this._showYAxis && this.yAxisLabel) {
      var nvd3DefaultTickPadding = 14;
      var leftPadding = 8;
      var axisLabelDistance = prop.maxYLeftValueSize + nvd3DefaultTickPadding + leftPadding;
      if (this.chart.useSubtleGrid()) {
        axisLabelDistance = scatter_plot_AXIS_LABEL_DISTANCE;
      }
      this.chart.yAxis.axisLabelDistance(axisLabelDistance);
    }
    if (this._XaxisMin !== undefined || this._enableAutoAxisScaling) {
      this.chart.xDomainMin(this._XaxisMin);
    }
    if (this._XaxisMax !== undefined || this._enableAutoAxisScaling) {
      this.chart.xDomainMax(this._XaxisMax);
    }
    if (this._YaxisMin !== undefined || this._enableAutoAxisScaling) {
      this.chart.yDomainMin(this._YaxisMin);
    }
    if (this._YaxisMax !== undefined || this._enableAutoAxisScaling) {
      this.chart.yDomainMax(this._YaxisMax);
    }
    if (_.isFunction(this._xTickFormat)) {
      this.chart.xAxis.tickFormat(this._xTickFormat);
    }
    if (_.isFunction(this._yTickFormat)) {
      this.chart.yAxis.tickFormat(this._yTickFormat);
    }
    if (this._xTickCount !== undefined && _.isFunction(this._xTickFormat)) {
      this.chart.xAxis.ticks(this._xTickCount, this._xTickFormat);
    }
    if (this._yTickCount !== undefined && _.isFunction(this._yTickFormat)) {
      this.chart.yAxis.ticks(this._yTickCount, this._yTickFormat);
    }
    if (_.isArray(this._xTickValues) && this._xTickValues.every(_.isFinite)) {
      this.chart.xAxis.tickValues(this._xTickValues);
    }
    if (_.isArray(this._yTickValues) && this._yTickValues.every(_.isFinite)) {
      this.chart.yAxis.tickValues(this._yTickValues);
    }
  },
  setSectionLabelsConfig: function setSectionLabelsConfig() {
    this.chart.showSectionLabels(this._showSectionLabels);
    this.chart.sectionType(this._sectionType);
    this.chart.sectionLabels(this._sectionLabels);
  },
  filterDataByAxisRanges: function filterDataByAxisRanges(shouldFilter) {
    this._shouldFilterData = shouldFilter;
    return this;
  },
  setChartMargin: function setChartMargin(prop) {
    var margin = {
      left: 0,
      right: CHART_DEFAULT_MARGIN,
      top: CHART_DEFAULT_MARGIN,
      bottom: 0
    };
    margin.left = this._showYAxis ? 0 : CHART_DEFAULT_MARGIN;
    margin.bottom = this._showXAxis ? 0 : CHART_DEFAULT_MARGIN;
    if (this._margin) {
      var _margin = this._margin;
      margin.left += _margin.left || 0;
      margin.right += _margin.right || 0;
    }
    var options = {
      hasXAxis: !!this._showXAxis,
      hasYAxis: !!this._showYAxis,
      hasXAxisLabel: !!this.xAxisLabel,
      hasYAxisLabel: !!this.yAxisLabel,
      maxYAxisValueSize: prop.maxYLeftValueSize + 8,
      lineCount: 1,
      lineHeight: prop.lineHeight
    };
    if (this.chart.useSubtleGrid()) {
      options.hasYAxisLabel = !!this.yAxisLabel && !!this._showYAxis;
      options.hasXAxisLabel = !!this.xAxisLabel && !!this._showXAxis;
      options.maxYAxisValueSize = CHART_DEFAULT_MARGIN;
      options.xAxisLabelPadding = !!this._showXAxis && this.xAxisLabel ? scatter_plot_AXIS_LABEL_DISTANCE : 0;
      options.yAxisLabelPadding = !!this._showYAxis && this.yAxisLabel ? scatter_plot_AXIS_LABEL_DISTANCE : 0;
    }
    margin = utils_calculateMargin(margin, options);
    if (!!this.xAxisLabel && !!this._showXAxis) {
      margin.bottom -= 4;
    }
    this.chart.margin(margin);
  },
  resize: function resize() {
    var prop;
    if (this.chart) {
      this.resizeContainer();
      prop = this.getDataProperties();
      this.setAxisConfig(prop);
      this.setChartMargin(prop);
      this.layout.renderHostedComponents({
        containerDimensions: this.getContainerDimensions(),
        container: this.getContainer(),
        margin: this._margin,
        maxLabelWidth: this.maxLabelWidth,
        animationDuration: this._animationDuration
      });
    }
  },
  getDataProperties: function getDataProperties() {
    var properties = {
        maxYLeftValueSize: 0,
        lineHeight: getTextHeight('dq', null, this.getContainer()),
        xAxis: {
          minValue: undefined,
          maxValue: undefined
        },
        yAxis: {
          minValue: undefined,
          maxValue: undefined
        }
      },
      data = this.getData();
    var flattenedValues = data.map(function (series) {
      return series.values;
    }).flat();
    flattenedValues.forEach(function (value) {
      var yNumberValue = Number(value.y);
      var xNumberValue = Number(value.x);
      if (yNumberValue < properties.yAxis.minValue || !_.isNumber(properties.yAxis.minValue)) {
        properties.yAxis.minValue = yNumberValue;
      }
      if (yNumberValue > properties.yAxis.maxValue || !_.isNumber(properties.yAxis.maxValue)) {
        properties.yAxis.maxValue = yNumberValue;
      }
      if (xNumberValue < properties.xAxis.minValue || !_.isNumber(properties.xAxis.minValue)) {
        properties.xAxis.minValue = xNumberValue;
      }
      if (xNumberValue > properties.xAxis.maxValue || !_.isNumber(properties.xAxis.maxValue)) {
        properties.xAxis.maxValue = xNumberValue;
      }
    });
    if (!_.isFunction(this._xTickFormat) && properties.xAxis.minValue !== undefined && properties.xAxis.maxValue !== undefined) {
      var tickXRange = properties.xAxis.maxValue - properties.xAxis.minValue;
      this.setXAxisTickFormat(d3.format('.' + scatter_plot_getNumDigitsAfterDecimal(tickXRange) + 'f'));
    }
    if (!_.isFunction(this._yTickFormat) && properties.yAxis.minValue !== undefined && properties.yAxis.maxValue !== undefined) {
      var tickYRange = properties.yAxis.maxValue - properties.yAxis.minValue;
      this.setYAxisTickFormat(d3.format('.' + scatter_plot_getNumDigitsAfterDecimal(tickYRange) + 'f'));
    }
    var formatTickY = _.isFunction(this._yTickFormat) ? this._yTickFormat : _.identity;
    var self = this;
    _.forEach(data, function (entry) {
      properties.maxYLeftValueSize = Math.max(properties.maxYLeftValueSize, getMaxY1AxisLength(entry.values.concat([{
        y: self._YaxisMin
      }, {
        y: self._YaxisMax
      }]), formatTickY, self.getContainer()));
    });
    return properties;
  }
}, {
  Name: 'ScatterPlot',
  DataDimensions: '2'
});
;// ./src/js/viz/components/quadrant_colors.js


var dqQuadrantColors = function dqQuadrantColors() {
  var config = {
    width: 400,
    height: 400,
    leftPadding: 10,
    topPadding: 20,
    bottomPadding: 10
  };
  var lifeCycle = new RenderLifeCycle();
  var quadrantColors = function quadrantColors(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var width = config.width,
        height = config.height;
      var container = external_d3_default().select(this);
      var quadrantColorPositions = [{
        id: 'topLeft',
        x: 0,
        y: 0
      }, {
        id: 'bottomLeft',
        x: 0,
        y: height / 2
      }, {
        id: 'bottomRight',
        x: width / 2,
        y: height / 2
      }, {
        id: 'topRight',
        x: width / 2,
        y: 0
      }];
      container.selectAll('.dq-quadrant-colors').data([data]).append('g').classed('dq-quadrant-colors', true);
      var quadrantColors = container.selectAll('.quadrant-color').data(data);
      quadrantColors.enter().append('g').classed('quadrant-color', true);
      quadrantColors.exit().remove();
      quadrantColors.data(data).append('rect').attr('x', function (d, i) {
        return quadrantColorPositions[i].x;
      }).attr('y', function (d, i) {
        return quadrantColorPositions[i].y;
      }).attr('height', height / 2).attr('width', width / 2).attr('fill', function (d) {
        return d;
      });
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(quadrantColors, config);
  quadrantColors.lifeCycle = lifeCycle;
  return quadrantColors;
};
;// ./src/js/viz/components/quadrant_labels.js



var dqQuadrantLabels = function dqQuadrantLabels() {
  var config = {
    width: 400,
    height: 400,
    leftPadding: 10,
    topPadding: 20,
    bottomPadding: 10
  };
  var lifeCycle = new RenderLifeCycle();
  var quadrantLabels = function quadrantLabels(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var width = config.width,
        height = config.height,
        leftPadding = config.leftPadding,
        topPadding = config.topPadding,
        bottomPadding = config.bottomPadding;
      var container = external_d3_default().select(this),
        quadrantLabelPositions = [{
          id: 'topLeft',
          x: leftPadding,
          y: topPadding
        }, {
          id: 'bottomLeft',
          x: leftPadding,
          y: height - bottomPadding
        }, {
          id: 'bottomRight',
          x: width / 2 + leftPadding,
          y: height - bottomPadding
        }, {
          id: 'topRight',
          x: width / 2 + leftPadding,
          y: topPadding
        }];
      container.selectAll('.dq-quadrant-labels').data([data]).append('g').classed('dq-quadrant-labels', true);
      var quadrantLabels = container.selectAll('.quadrant-label').data(data);
      quadrantLabels.enter().append('text').classed('quadrant-label', true);
      quadrantLabels.exit().remove();
      var maxLabelWidth = width / 2 - 2 * leftPadding;
      var lineHeight = '-1.1em';
      quadrantLabels.data(data).text(function (d) {
        return d;
      }).attr('x', function (d, i) {
        return quadrantLabelPositions[i].x;
      }).attr('y', function (d, i) {
        return quadrantLabelPositions[i].y;
      }).attr('dy', function (d, i) {
        var bboxWidth = this.getBBox().width;
        var isBottomLabel = quadrantLabelPositions[i].id === 'bottomLeft' || quadrantLabelPositions[i].id === 'bottomRight';
        if (bboxWidth > maxLabelWidth && isBottomLabel) {
          return lineHeight;
        }
        return 0;
      }).call(js_nv.utils.wrapTicks, maxLabelWidth, 2);
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(quadrantLabels, config);
  quadrantLabels.lifeCycle = lifeCycle;
  return quadrantLabels;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__(5369);
;// ./src/js/viz/components/axis_labels.js




var dqAxisLabels = function dqAxisLabels() {
  var config = {
    width: 400,
    height: 400
  };
  var X_AXIS_VERTICAL_PADDING = 20;
  var Y_AXIS_VERTICAL_PADDING = 10;
  var PADDING_BETWEEN_LABELS = 20;
  var DQ_AXIS_LABELS_CLASS = 'dq-axis-labels';
  var AXIS_LABELS_CLASS = 'axis-label';
  var X_AXIS_LABEL_CLASS = 'x-axis-label';
  var Y_AXIS_LABEL_CLASS = 'y-axis-label';
  var lifeCycle = new RenderLifeCycle();
  var axisLabels = function axisLabels(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var height = config.height,
        width = config.width;
      var container = external_d3_default().select(this),
        axisLabelPositions = [{
          axis: 'x',
          x: 0,
          y: height + X_AXIS_VERTICAL_PADDING,
          textAnchor: 'start'
        }, {
          axis: 'x',
          x: width / 2,
          y: height + X_AXIS_VERTICAL_PADDING,
          textAnchor: 'middle'
        }, {
          axis: 'x',
          x: width,
          y: height + X_AXIS_VERTICAL_PADDING,
          textAnchor: 'end'
        }, {
          axis: 'y',
          x: -Y_AXIS_VERTICAL_PADDING,
          y: height,
          textAnchor: 'start'
        }, {
          axis: 'y',
          x: -Y_AXIS_VERTICAL_PADDING,
          y: height / 2,
          textAnchor: 'middle'
        }, {
          axis: 'y',
          x: -Y_AXIS_VERTICAL_PADDING,
          y: 0,
          textAnchor: 'end'
        }];
      container.selectAll(".".concat(DQ_AXIS_LABELS_CLASS)).data([data]).append('g').classed("".concat(DQ_AXIS_LABELS_CLASS), true);
      var axisLabels = container.selectAll(".".concat(AXIS_LABELS_CLASS)).data(data);
      axisLabels.enter().append('text').classed("".concat(AXIS_LABELS_CLASS), true);
      axisLabels.exit().remove();
      axisLabels.data(data).text(function (d) {
        return getLabel(d);
      }).attr('transform', function (d) {
        return getTransform(d);
      }).attr('x', function (d) {
        return getX(d, axisLabelPositions);
      }).attr('y', function (d) {
        return getY(d, axisLabelPositions);
      }).attr('text-anchor', function (d) {
        return getTextAnchor(d, axisLabelPositions);
      }).classed(X_AXIS_LABEL_CLASS, function (d) {
        return isXAxisLabel(d);
      }).classed(Y_AXIS_LABEL_CLASS, function (d) {
        return isYAxisLabel(d);
      });
      var xData = filterAxisLabels(data, 'x');
      if (xData.length) {
        var xAxisLabels = container.selectAll(".".concat(X_AXIS_LABEL_CLASS));
        xAxisLabels.call(js_nv.utils.truncateText, width / xData.length - PADDING_BETWEEN_LABELS);
      }
      var yData = filterAxisLabels(data, 'y');
      if (yData.length) {
        var yAxisLabels = container.selectAll(".".concat(Y_AXIS_LABEL_CLASS)).data(data);
        yAxisLabels.call(js_nv.utils.truncateText, height / yData.length - PADDING_BETWEEN_LABELS);
      }
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(axisLabels, config);
  axisLabels.lifeCycle = lifeCycle;
  return axisLabels;
};
function getIndex(axisLabelPositions, d) {
  return axisLabelPositions.findIndex(function (axisLabel) {
    return axisLabel.axis === d.axis && axisLabel.textAnchor === d.position;
  });
}
function filterAxisLabels(data, axis) {
  return data.filter(function (axisLabel) {
    return axisLabel.axis === axis;
  });
}
function getLabel(d) {
  return d.label;
}
function getTransform(d) {
  return d.axis === 'y' ? 'rotate(-90)' : '';
}
function getX(d, axisLabelPositions) {
  var index = getIndex(axisLabelPositions, d);
  return d.axis === 'x' ? axisLabelPositions[index].x : -axisLabelPositions[index].y;
}
function getY(d, axisLabelPositions) {
  var index = getIndex(axisLabelPositions, d);
  return d.axis === 'x' ? axisLabelPositions[index].y : axisLabelPositions[index].x;
}
function getTextAnchor(d, axisLabelPositions) {
  var index = getIndex(axisLabelPositions, d);
  return axisLabelPositions[index].textAnchor;
}
function isXAxisLabel(d) {
  return d.axis === 'x';
}
function isYAxisLabel(d) {
  return d.axis === 'y';
}
;// ./src/js/viz/config/quadrant_colors_config.js
var QuadrantColorsConfig = {
  getQuadrantColors: function getQuadrantColors() {
    return this.quadrantColors;
  },
  setQuadrantColors: function setQuadrantColors(data) {
    this.quadrantColors = _.cloneDeep(data);
    return this;
  }
};
;// ./src/js/viz/config/quadrant_labels_config.js
var QuadrantLabelsConfig = {
  getQuadrantLabels: function getQuadrantLabels() {
    return this.quadrantLabels;
  },
  setQuadrantLabels: function setQuadrantLabels(data) {
    this.quadrantLabels = _.cloneDeep(data);
    return this;
  }
};
;// ./src/js/viz/config/axis_labels_config.js
var AxisLabelsConfig = {
  getAxisLabelType: function getAxisLabelType() {
    return this.axisLabelType;
  },
  setAxisLabelType: function setAxisLabelType(data) {
    this.axisLabelType = _.cloneDeep(data);
    return this;
  },
  getAxisLabels: function getAxisLabels() {
    return this.axisLabels;
  },
  setAxisLabels: function setAxisLabels(data) {
    this.axisLabels = _.cloneDeep(data);
    return this;
  }
};
;// ./src/js/viz/nvd3/charts/quadrant_chart.js









var QuadrantChartConfig = Object.assign({}, ScatterPlotConfig, QuadrantColorsConfig, QuadrantLabelsConfig, AxisLabelsConfig);
var DESCRIPTIVE = 'descriptive';
var QuadrantChart = ScatterPlot.extend({
  initialize: function initialize() {
    this.chart = js_nv.models.quadrantChart();
    return ScatterPlot.prototype.initialize.apply(this, arguments);
  },
  createAndConfigChart: function createAndConfigChart(properties) {
    this.chart || (this.chart = js_nv.models.quadrantChart());
    this.chart.axisLabelType(this.getAxisLabelType());
    this.chart.secondaryXAxisLabel(this.secondaryXAxisLabel);
    this.chart.secondaryYAxisLabel(this.secondaryYAxisLabel);
    return ScatterPlot.prototype.createAndConfigChart.apply(this, [properties]);
  },
  createQuadrantColors: function createQuadrantColors() {
    if (!this.getQuadrantColors()) {
      this.layout.remove('quadrantColors');
    } else {
      var quadrantColors = dqQuadrantColors();
      this.layout.host('quadrantColors', quadrantColors, this.getQuadrantColors());
    }
  },
  createQuadrantLabels: function createQuadrantLabels() {
    if (!this.getQuadrantLabels()) {
      this.layout.remove('quadrantLabels');
    } else {
      var quadrantLabels = dqQuadrantLabels();
      this.layout.host('quadrantLabels', quadrantLabels, this.getQuadrantLabels());
    }
  },
  createAxisLabels: function createAxisLabels() {
    if (!this.getAxisLabels() || this.getAxisLabelType() !== DESCRIPTIVE) {
      this.layout.remove('axisLabels');
    } else {
      var axisLabels = dqAxisLabels();
      this.layout.host('axisLabels', axisLabels, this.getAxisLabels());
    }
  },
  configureChartComponents: function configureChartComponents() {
    var prop = this.getDataProperties();
    this.createAndConfigChart(prop);
    this.createAndConfigLegend();
    this.createReferenceLines();
    this.createQuadrantColors();
    this.createQuadrantLabels();
    this.createAxisLabels();
  }
}, {
  Name: 'QuadrantChart',
  DataDimensions: '2'
}).extend(QuadrantChartConfig);
;// ./src/js/viz/config/range_line_config.js
var RangeLineConfig = {
  _rangeLineAnimationDuration: 1000,
  _strokeWidth: 1,
  getRangeLineData: function getRangeLineData() {
    return this._rangeLinesData;
  },
  setRangeLineData: function setRangeLineData(data) {
    this._rangeLinesData = _.cloneDeep(data);
    return this;
  },
  setRangeLineColor: function setRangeLineColor(color) {
    this._lineColor = color;
    return this;
  },
  setRangeColor: function setRangeColor(color) {
    this._rangeColor = color;
    return this;
  },
  setRangeLineStrokeWidth: function setRangeLineStrokeWidth(width) {
    if (_.isFinite(width)) {
      this._strokeWidth = width;
    } else {
      console.error('You cannot set RangeLine Stroke Width to a non finite value');
    }
    return this;
  },
  setRangeLineAnimationDuration: function setRangeLineAnimationDuration(duration) {
    if (_.isFinite(duration)) {
      this._rangeLineAnimationDuration = duration;
    } else {
      console.error('You cannot set RangeLine Animation Duration to a non finite value');
    }
    return this;
  }
};
;// ./src/js/viz/components/range_line.js



var DEFAULT_ORDER = 0;
var DEFAULT_RANGE_ORDER = DEFAULT_ORDER + 1;
var ORDER = 'order';
var dqRangeLine = function dqRangeLine() {
  var config = {
      width: 400,
      height: 400,
      xScale: null,
      yScale: null,
      getX: function getX(d) {
        return d.x;
      },
      getY: function getY(d) {
        return d.y;
      },
      colorScheme: external_d3_default().scale.category20(),
      lineColor: 'grey',
      rangeColor: 'black',
      strokeWidth: 1,
      strokeRangeLineCap: 'square',
      strokeRangeCap: 'round',
      strokeRangeLineOpacity: 1,
      strokeRangeOpacity: 1,
      animationDuration: 1000,
      getKey: function getKey(d) {
        return d.key;
      }
    },
    lifeCycle = new RenderLifeCycle();
  var rangeLine = function rangeLine(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var container = external_d3_default().select(this),
        xScale = config.xScale.copy(),
        yScale = config.yScale.copy();
      var rLines;
      var rangeLineData = range_line_calculateLines(data, xScale, yScale, config);
      container.selectAll('.dq-range-line').data([rangeLineData]).append('g').classed('dq-range-line', true);
      rLines = container.selectAll('.range-line').data(rangeLineData);
      rLines.enter().append('line').attr('x1', function (d) {
        return d.x1;
      }).attr('y1', function (d) {
        return d.y1;
      }).attr('x2', function (d) {
        return d.x1;
      }).attr('y2', function (d) {
        return d.y1;
      }).attr('stroke', function (d, i) {
        return d.color || config.colorScheme(i);
      }).attr('stroke-width', function (d) {
        return external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(d.strokeWidth) ? d.strokeWidth : config.strokeWidth;
      }).attr('stroke-linecap', function (d) {
        return d.linecap;
      }).attr('fill-opacity', function (d) {
        return d.opacity;
      }).classed('range-line', true);
      rLines.exit().remove();
      rLines.transition().duration(config.animationDuration).ease('linear').attr('x1', function (d) {
        return d.x1;
      }).attr('y1', function (d) {
        return d.y1;
      }).attr('x2', function (d) {
        return d.x2;
      }).attr('y2', function (d) {
        return d.y2;
      }).call(lifeCycle.watch);
    });
    lifeCycle.dispatchOnCompletion();
  };
  exposeConfig(rangeLine, config);
  rangeLine.lifeCycle = lifeCycle;
  return rangeLine;
};
function range_line_calculateLines(data, xScale, yScale, config) {
  xScale.clamp && xScale.clamp(true);
  yScale.clamp && yScale.clamp(true);
  var rangeData = [];
  data.map(function (d) {
    if (isVerticalLineData(config.getX(d), config.getY(d))) {
      calculateVerticalLines(d, xScale, yScale, rangeData, config);
    } else {
      calculateHorizontalLines(d, xScale, yScale, rangeData, config);
    }
  });
  data = data.concat(rangeData);
  data = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().sortBy(data, ORDER);
  return data;
}
var isVerticalLineData = function isVerticalLineData(x, y) {
  if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(x) && !external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(y)) {
    return true;
  }
  return false;
};
var calculateVerticalLines = function calculateVerticalLines(d, xScale, yScale, rangeData, config) {
  var position = getValidPosition(xScale, config.getX(d));
  formatVerticalLineData(d, position, config);
  var rd = generateVerticalRangeData(d, position, yScale, config);
  if (rd) {
    rangeData.push(rd);
  }
};
var calculateHorizontalLines = function calculateHorizontalLines(d, xScale, yScale, rangeData, config) {
  var position = getValidPosition(yScale, config.getY(d));
  formatHorizontalLineData(d, position, config);
  var rd = generateHorizontalRangeData(d, position, xScale, config);
  if (rd) {
    rangeData.push(rd);
  }
};
function formatVerticalLineData(d, position, config) {
  configureLineData(d, config.lineColor, config.strokeRangeLineCap, config.strokeRangeLineOpacity);
  if (d.truncateStrokeWidth) {
    var strokeWidth = d.strokeWidth || config.strokeWidth;
    var halfStrokeWidth = strokeWidth / 2;
    positionLine(d, position, position, halfStrokeWidth, config.height - halfStrokeWidth);
  } else {
    positionLine(d, position, position, 0, config.height);
  }
}
function formatHorizontalLineData(d, position, config) {
  configureLineData(d, config.lineColor, config.strokeRangeLineCap, config.strokeRangeLineOpacity);
  if (d.truncateStrokeWidth) {
    var strokeWidth = d.strokeWidth || config.strokeWidth;
    var halfStrokeWidth = strokeWidth / 2;
    positionLine(d, halfStrokeWidth, config.width - halfStrokeWidth, position, position);
  } else {
    positionLine(d, 0, config.width, position, position);
  }
}
function configureLineData(d, lineColor, strokeRangeLineCap, strokeRangeLineOpacity) {
  d.color = d.color || lineColor;
  d.linecap = d.linecap || strokeRangeLineCap;
  d.opacity = d.strokeRangeLineOpacity || strokeRangeLineOpacity;
  d.order = d.order || DEFAULT_ORDER;
}
function generateVerticalRangeData(d, position, yScale, config) {
  if (hasValidRangeData(d)) {
    var order = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(d.rangeOrder) ? d.rangeOrder : d.order + 1;
    var rd = createAndConfigureRangeData(config.rangeColor, config.strokeRangeCap, config.strokeRangeOpacity, order);
    var yMin = getValidPosition(yScale, d.min);
    var yMax = getValidPosition(yScale, d.max);
    positionLine(rd, position, position, yMin, yMax);
    return rd;
  }
  return undefined;
}
function generateHorizontalRangeData(d, position, xScale, config) {
  if (hasValidRangeData(d)) {
    var order = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(d.rangeOrder) ? d.rangeOrder : d.order + 1;
    var rd = createAndConfigureRangeData(config.rangeColor, config.strokeRangeCap, config.strokeRangeOpacity, order);
    var xMin = getValidPosition(xScale, d.min);
    var xMax = getValidPosition(xScale, d.max);
    positionLine(rd, xMin, xMax, position, position);
    return rd;
  }
  return undefined;
}
var hasValidRangeData = function hasValidRangeData(d) {
  var validRangeData = d && external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(d.min) && external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(d.max);
  return validRangeData;
};
function positionLine(d, x1, x2, y1, y2) {
  d.x1 = x1;
  d.x2 = x2;
  d.y1 = y1;
  d.y2 = y2;
}
function createAndConfigureRangeData(rangeColor, strokeRangeCap, strokeRangeOpacity) {
  var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_RANGE_ORDER;
  var rd = {
    color: rangeColor,
    linecap: strokeRangeCap,
    opacity: strokeRangeOpacity,
    order: order
  };
  return rd;
}
var getValidPosition = function getValidPosition(scale, input) {
  var output = scale(input);
  if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(output)) {
    return output;
  }
  console.log('Scale did not find a valid #');
  return 0;
};
;// ./src/js/viz/nvd3/layouts/breakout_chart_layout.js




var BreakoutChartLayout = ChartLayout.extend({
  regions: ['yAxis', 'xAxis', 'chart', 'rangeLine'],
  _regionToContainer: {
    xAxis: '.dq-xAxis-container',
    yAxis: '.dq-yAxis-container',
    rangeLine: 'dq-range-line-container',
    chart: '.dq-chart-container'
  },
  renderHostedComponents: function renderHostedComponents(options) {
    var containerDimensions = options.containerDimensions,
      container = options.container,
      postRender = options.postRender;
    this.container = container;
    this.calculateDimensions(containerDimensions, options.margin);
    var rangeLineLayout = this.generateRangeLinesLayout(options.maxLabelWidth);
    if (postRender) {
      this.attachCallback(postRender);
    }
    utils_createElementIfAbsent(container, this._regionToContainer.rangeLine);
    if (this._hostedRegions.xAxis || this._hostedRegions.yAxis) {
      this.arrangeAndDrawAxis(container);
    }
    if (this._hostedRegions.chart) {
      this.arrangeAndDrawChart(container);
    }
    if (this._hostedRegions.rangeLine) {
      this.arrangeAndDrawRangeLines(rangeLineLayout, container);
    }
  },
  arrangeAndDrawRangeLines: function arrangeAndDrawRangeLines(layout, container) {
    var hostedElement = this._hostedRegions.rangeLine,
      rangeLine,
      data,
      rangeLineContainer = utils_createElementIfAbsent(container, this._regionToContainer.rangeLine);
    if (hostedElement) {
      rangeLine = hostedElement.component;
      data = hostedElement.data;
      rangeLine.height(layout.height);
      rangeLine.width(layout.width);
      rangeLineContainer.datum(data).attr('transform', 'translate(' + layout.horizontalTranslation + ',' + layout.verticalTranslation + ')').call(rangeLine);
    }
    return rangeLineContainer;
  },
  generateRangeLinesLayout: function generateRangeLinesLayout(maxLabelWidth) {
    var chart = this._hostedRegions.chart.component;
    var chartMargin = chart.margin();
    if (chartMargin.left > maxLabelWidth) {
      chartMargin.left = maxLabelWidth;
    }
    var width = this.availableWidth - chartMargin.left - chartMargin.right,
      height = this.availableHeight - chartMargin.top - chartMargin.bottom;
    return {
      width: width,
      height: height,
      verticalTranslation: chartMargin.top,
      horizontalTranslation: chartMargin.left
    };
  },
  host: function host(region, component, data) {
    if (!this.regions.includes(region)) {
      console.log(region + ' is not a valid region.');
    } else {
      this._hostedRegions[region] = {
        component: component,
        data: data
      };
    }
  },
  remove: function remove(region) {
    var component = this._hostedRegions[region],
      componentContainer;
    if (component && this.container) {
      componentContainer = this.container.select(this._regionToContainer[region]);
      component.remove && component.remove();
      if (!componentContainer.empty()) {
        componentContainer.remove();
      }
    }
    this._hostedRegions[region] = null;
  }
}, {});
;// ./src/js/viz/nvd3/charts/breakout_chart.js










var BreakoutChart = ScatterPlot.extend(RangeLineConfig).extend({
  initialize: function initialize() {
    this.colorScheme = baseColorScheme();
    this.layout = new BreakoutChartLayout();
    return NvCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(callback) {
    this.wrapContainer();
    this.configureChartComponents();
    attachRenderEndCallback(this.chart, callback);
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      container: this.getContainer(),
      margin: this._margin,
      maxLabelWidth: this.maxLabelWidth
    });
  },
  configureChartComponents: function configureChartComponents() {
    var prop = this.getDataProperties();
    this.createAndConfigChart(prop);
    this.createAndConfigRangeLines();
  },
  createAndConfigChart: function createAndConfigChart(properties) {
    var self = this;
    this.chart || (this.chart = js_nv.models.scatterChart());
    this.chart.showLegend(false);
    this.chart.color(this.colorScheme);
    this.chart.showValues && this.chart.showValues(!!this._showDataValue);
    this.chart.backgroundImageUrl(this._backgroundImageUrl);
    this.chart.backgroundImagePosition(this._backgroundImagePosition);
    this.chart.pointRange(this._pointRange || [100, 300]);
    this.chart.clipEdge(this._shouldFilterData || false);
    if (this.chart.labelPlacementFunction) {
      this.chart.labelPlacementFunction(findPositionedLocations);
    }
    this.addTooltip();
    this.layout.host('chart', this.chart, this.data);
    this.setAxisConfig(properties);
    this.setChartMargin(properties);
    this.chart.wrapLabels(this.maxLabelWidth);
    _.forEach(this._eventHandlers, function (handler, event) {
      if (self.chart.dispatch.hasOwnProperty(event)) {
        self.chart.dispatch.on(event, handler);
      }
    });
  },
  createAndConfigRangeLines: function createAndConfigRangeLines() {
    var rangeLine;
    var rangeLineData = this.getRangeLineData();
    if (!rangeLineData) {
      this.layout.remove('rangeLine');
    } else {
      rangeLine = dqRangeLine();
      rangeLine.xScale(this.chart.xScale()).yScale(this.chart.yScale()).lineColor(this._lineColor).rangeColor(this._rangeColor).strokeWidth(this._strokeWidth).animationDuration(this._rangeLineAnimationDuration);
      this.layout.host('rangeLine', rangeLine, rangeLineData);
    }
  }
}, {
  Name: 'BreakoutChart',
  DataDimensions: '2'
});
;// ./src/js/viz/nvd3/charts/box_plot_chart.js







var MAX_BOX_WIDTH_PX = 75;
var Y_AXIS_LABEL_DISTANCE = 45;
var MARGINS_PX = {
  TOP: 10,
  RIGHT: 0,
  BOTTOM: 0,
  LEFT: 0
};
var LEGEND_MAX_SIZE_PERCENT = 0.5;
var BoxPlot = NvCore.extend(AxisChartConfig).extend({
  initialize: function initialize() {
    this.colorScheme = baseColorScheme();
    this.layout = new ChartLayout();
    return NvCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRenderCallback) {
    this.configureChartComponents();
    attachRenderEndCallback(this.chart, postRenderCallback);
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      container: this.getContainer()
    });
    return this;
  },
  configureChartComponents: function configureChartComponents() {
    this.createAndConfigChart();
    this.createAndConfigLegend();
  },
  createAndConfigChart: function createAndConfigChart() {
    this.chart || (this.chart = js_nv.models.boxPlotChart());
    this.chart.color(this.colorScheme);
    this.chart.x(function (d) {
      return d.label;
    });
    this.chart.maxBoxWidth(MAX_BOX_WIDTH_PX);
    this.layout.host('chart', this.chart, this.data);
    this.setAxisConfig();
    this.configureMargins();
    this.setOutliersConfig();
    this.addTooltip();
  },
  createAndConfigLegend: function createAndConfigLegend() {
    this.legend = dqLegend();
    this.legend.colorScheme(this.colorScheme).position(this._legendPosition).automatedMaxKeyLengthLegendWidth(LEGEND_MAX_SIZE_PERCENT);
    if (this._shouldShowLegend) {
      this.layout.host('legend', this.legend, this.data);
    } else {
      this.layout.remove('legend');
    }
  },
  setAxisConfig: function setAxisConfig() {
    this.chart.showYAxis(!!this._showYAxis);
    this.chart.showXAxis(!!this._showXAxis);
    this.chart.xAxis.axisLabel(this.xAxisLabel);
    this.chart.yAxis.axisLabel(this.yAxisLabel);
    if (this._showYAxis && this.yAxisLabel) {
      this.chart.yAxis.axisLabelDistance(this.getDataProperties().maxYAxisValueSize + Y_AXIS_LABEL_DISTANCE);
    }
    if (this._axisMin !== undefined && this._axisMin !== null && this._axisMax !== undefined && this._axisMax !== null) {
      this.chart.yDomain([this._axisMin, this._axisMax]);
    }
  },
  setOutliersConfig: function setOutliersConfig() {
    this.chart.outlierValue(function (d) {
      return d.value;
    });
    this.chart.outlierLabel(function (d) {
      return d.value;
    });
    this.chart.outlierColor(function (d) {
      return d.color;
    });
  },
  resize: function resize() {
    if (this.chart) {
      this.resizeContainer();
      this.setAxisConfig();
      this.configureMargins();
      this.layout.renderHostedComponents({
        containerDimensions: this.getContainerDimensions(),
        container: this.getContainer()
      });
    }
  },
  configureMargins: function configureMargins() {
    this.chart.margin(this.calculateMargin(this.getDataProperties()));
  },
  calculateMargin: function calculateMargin(properties) {
    var margin = {
      left: MARGINS_PX.LEFT,
      right: MARGINS_PX.RIGHT,
      top: MARGINS_PX.TOP,
      bottom: MARGINS_PX.BOTTOM
    };
    return utils_calculateMargin(margin, {
      hasXAxis: !!this._showXAxis,
      hasYAxis: !!this._showYAxis,
      hasXAxisLabel: !!this.xAxisLabel,
      hasYAxisLabel: !!this.yAxisLabel,
      hasLegend: !!this._shouldShowLegend,
      lineHeight: this.getLineHeight(),
      maxYAxisValueSize: properties.maxYAxisValueSize + Y_AXIS_LABEL_DISTANCE
    });
  },
  getLineHeight: function getLineHeight() {
    return getTextHeight('dq', null, this.getContainer());
  },
  getDataProperties: function getDataProperties() {
    var upperYAxisValueLength = this.getTextLength(this._axisMax);
    var lowerYAxisValueLength = this.getTextLength(this._axisMin);
    return {
      maxYAxisValueSize: Math.max(upperYAxisValueLength, lowerYAxisValueLength)
    };
  },
  getTextLength: function getTextLength(text) {
    return utils_getTextLength(text, null, this.getContainer());
  }
}, {
  Name: 'BoxPlot',
  DataDimensions: '2'
});
;// ./src/js/viz/nvd3/index.js









;// ./src/js/viz/d3/components/gauge.js



var getAngle = function getAngle(ratio) {
  return (ratio * 180 - 90) * Math.PI / 180;
};
var getAvailableHeight = function getAvailableHeight(config) {
  return Math.max(0, config.height - config.margins.top - config.margins.bottom);
};
var getAvailableWidth = function getAvailableWidth(config) {
  return Math.max(0, config.width - config.margins.left - config.margins.right);
};
var generateRadiusDimension = function generateRadiusDimension(config) {
  var maxWidth = getAvailableWidth(config) - 2 * config.dataPointFontSize - config.textPadding;
  var maxHeight = getAvailableHeight(config) - config.dataPointFontSize - config.labelFontSize - config.textPadding;
  var radius = Math.min(maxWidth / 2, maxHeight);
  if (config.maxRadius) {
    radius = Math.min(radius, config.maxRadius);
  }
  var dataArcWidth = Math.min(config.dataArcWidth, 8 * radius / 75);
  return {
    dataArc: {
      innerRadius: radius - dataArcWidth,
      outerRadius: radius
    },
    arrow: {
      height: dataArcWidth
    }
  };
};
var getTextPosition = function getTextPosition(data, config, radiusDimensions) {
  var endLabels = radiusDimensions.dataArc.innerRadius + (radiusDimensions.dataArc.outerRadius - radiusDimensions.dataArc.innerRadius) / 2;
  var valueTranslation = radiusDimensions.dataArc.innerRadius / 5;
  var labelTranslation = config.labelFontSize - 2;
  return {
    label: 'translate(0, ' + labelTranslation + ')',
    value: 'translate(0, ' + -valueTranslation + ')',
    minValue: 'translate(-' + endLabels + ', ' + labelTranslation + ')',
    maxValue: 'translate(' + endLabels + ', ' + labelTranslation + ')'
  };
};
var maximizeValueFontSize = function maximizeValueFontSize(data, radiusDimensions, config) {
  var maxValueLength = _.max(_.map([data.value, data.minValue || 0, data.maxValue], function (term) {
      return (config.valueFormat(term) + '').length;
    })),
    fontRadius = radiusDimensions.dataArc.innerRadius,
    maxValueFontSize = config.maxValueFontSize * radiusDimensions.dataArc.innerRadius / 150;
  return Math.min(Math.min(Math.floor(fontRadius * 2 / (maxValueLength * 0.7)), maxValueFontSize), Math.min(Math.floor(fontRadius - 24), maxValueFontSize));
};
var TRIANGLE_BASE_HEIGHT_RATIO = 0.866;
var createGaugeArrow = function createGaugeArrow(offsetX, offsetY, height) {
  var baseLength = height / TRIANGLE_BASE_HEIGHT_RATIO,
    triangleSVG = createTrianglePointer(offsetX, offsetY, baseLength, height);
  return {
    SVG: triangleSVG,
    width: baseLength,
    height: height
  };
};
var boundValue = function boundValue(data) {
  return data.value > data.maxValue ? data.maxValue : data.value < data.minValue ? data.minValue : data.value;
};
var Gauge = function Gauge() {
  var config = {
      width: 400,
      height: 400,
      dataArcWidth: 16,
      textPadding: 10,
      animationDuration: 400,
      emptyRingColor: '#000000',
      emptyRingOpacity: '0.05',
      colorScheme: external_d3_default().scale.category10(),
      valueFormat: function valueFormat(d) {
        return d;
      },
      valueColor: undefined,
      labelColor: '#737373',
      minMaxColor: '#737373',
      labelFontSize: 16,
      dataPointFontSize: 12,
      valueFontSize: 16,
      maxValueFontSize: 64,
      rangeFormat: function rangeFormat(rangeValue) {
        return rangeValue;
      },
      automaticFontResize: false,
      showRangeArc: false,
      disableInteraction: false,
      maxRadius: undefined,
      margins: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }
    },
    getColor = function getColor(data) {
      if (data.value >= data.maxValue) {
        return data.rangeConfig[data.rangeConfig.length - 1].color;
      }
      return external_d3_default().scale.threshold().domain(_.map(data.rangeConfig, function (entry) {
        return entry.value;
      })).range(_.map(data.rangeConfig, function (entry) {
        return entry.color;
      }))(data.value);
    },
    lifeCycle = new RenderLifeCycle();
  var gauge = function gauge(selection) {
    lifeCycle.start();
    config.valueFormat || (config.valueFormat = _.identity);
    selection.each(function (data) {
      var container = external_d3_default().select(this),
        gaugeContainer = container.selectAll('.gauge'),
        rangeRim = gaugeContainer.selectAll('.range-rim'),
        labelContainer = gaugeContainer.selectAll('.data-labels'),
        arrowContainer = gaugeContainer.selectAll('.data-arrow'),
        arcGenerator = external_d3_default().svg.arc(),
        radiusDimensions = generateRadiusDimension(config),
        valueFontSize = config.automaticFontResize ? maximizeValueFontSize(data, radiusDimensions, config) : config.valueFontSize,
        textPositions = getTextPosition(data, config, radiusDimensions),
        minValue = data.minValue || 0,
        maxValue = data.maxValue,
        dataArcSize = maxValue - minValue,
        startAngle = getAngle(0),
        rangeRimPaths,
        labelSelection,
        valueSelection,
        minValueSelection,
        maxValueSelection,
        midValueSelection,
        textCurveDefinition = container.selectAll('defs').selectAll('path');
      data.rangeConfig = _.filter(data.rangeConfig, function (threshold) {
        return threshold.value > minValue && threshold.value <= maxValue;
      });
      if (container.selectAll('.gauge').empty()) {
        container.append('g').attr('class', 'gauge');
        gaugeContainer = container.selectAll('.gauge');
        rangeRim = gaugeContainer.append('g').attr('class', 'range-rim');
        labelContainer = gaugeContainer.append('g').attr('class', 'data-labels');
        arrowContainer = gaugeContainer.append('g').attr('class', 'data-arrow');
        arrowContainer.append('path').attr('transform', 'rotate(-90 0 0)');
        var textCurveId = 'textPathCurve_' + container.attr('id');
        textCurveDefinition = container.append('defs').append('path').attr('class', 'text-curve-definition').attr('id', textCurveId);
      }
      textCurveDefinition.attr('d', createHalfCircleArc(radiusDimensions.dataArc.outerRadius + 3));
      var verticalMargins = config.margins.bottom + config.margins.top;
      var widgetSize = radiusDimensions.dataArc.outerRadius + config.labelFontSize;
      gaugeContainer.attr('transform', "translate(".concat(config.width / 2, ",").concat(config.height / 2 - verticalMargins + widgetSize / 2, ")"));
      if (data.rangeConfig.length) {
        rangeRimPaths = rangeRim.selectAll('path').data(data.rangeConfig);
        rangeRimPaths.enter().append('path');
        rangeRimPaths.exit().remove();
        var padding = Math.min(2 / radiusDimensions.dataArc.outerRadius, 0.005 * Math.PI);
        rangeRimPaths.attr('fill', function (d) {
          return d.color;
        }).attr('d', function (d) {
          var endAngle = getAngle((d.value - minValue) / dataArcSize),
            paddedEndAngle = endAngle - padding,
            paddedStartAngle = startAngle + padding,
            arc = arcGenerator({
              innerRadius: radiusDimensions.dataArc.innerRadius,
              outerRadius: radiusDimensions.dataArc.outerRadius,
              startAngle: startAngle > -(Math.PI / 2) ? paddedStartAngle : startAngle,
              endAngle: endAngle < Math.PI / 2 ? paddedEndAngle : endAngle
            });
          startAngle = endAngle;
          return arc;
        });
      }
      var arrowTranslation = radiusDimensions.dataArc.innerRadius - radiusDimensions.arrow.height,
        arrowDimension = createGaugeArrow(0, -arrowTranslation, radiusDimensions.arrow.height),
        arrowRotation = -90 + (boundValue(data) - minValue) / dataArcSize * 180;
      arrowContainer.selectAll('path').attr('width', arrowDimension.width).attr('height', arrowDimension.height).style('fill', getColor(data)).attr('fill', getColor(data)).attr('d', arrowDimension.SVG).transition().duration(config.animationDuration).attr('transform', 'rotate(' + arrowRotation + ' 0 0)').call(lifeCycle.watch);
      labelSelection = labelContainer.selectAll('.label').data([data.label]);
      labelSelection.enter().append('text').attr('class', 'label');
      labelSelection.exit().transition().duration(config.animationDuration).remove().call(lifeCycle.watch);
      labelSelection.style('fill', config.labelColor).style('font-size', config.labelFontSize + 'px').style('font-weight', 400).text(function (d) {
        return d;
      }).call(wordWrap, radiusDimensions.dataArc.innerRadius * 2 - 2 * radiusDimensions.arrow.height);
      labelSelection.transition().duration(config.animationDuration).attr('transform', textPositions.label);
      valueSelection = labelContainer.selectAll('.value').data([data.value]);
      valueSelection.enter().append('text').attr('class', 'value');
      valueSelection.style('fill', config.valueColor).style('font-size', valueFontSize + 'px').style('font-weight', 300).text(function (d) {
        return config.valueFormat(d);
      });
      valueSelection.transition().duration(config.animationDuration).attr('transform', textPositions.value).call(lifeCycle.watch);
      minValueSelection = labelContainer.selectAll('.minValue').data([data.minValue]);
      minValueSelection.enter().append('text').attr('class', 'minValue');
      minValueSelection.style('fill', config.minMaxColor).text(function (rangeValue) {
        return config.rangeFormat(rangeValue);
      }).style('font-size', config.dataPointFontSize + 'px').style('font-weight', 400);
      minValueSelection.transition().duration(config.animationDuration).attr('transform', textPositions.minValue).call(lifeCycle.watch);
      maxValueSelection = labelContainer.selectAll('.maxValue').data([data.maxValue]);
      maxValueSelection.enter().append('text').attr('class', 'maxValue');
      maxValueSelection.style('fill', config.minMaxColor).text(function (rangeValue) {
        return config.rangeFormat(rangeValue);
      }).style('font-size', config.dataPointFontSize + 'px').style('font-weight', 400);
      maxValueSelection.transition().duration(config.animationDuration).attr('transform', textPositions.maxValue).call(lifeCycle.watch);
      midValueSelection = labelContainer.selectAll('.midValue').data(data.rangeConfig.slice(0, data.rangeConfig.length - 1));
      midValueSelection.enter().append('text').attr('class', 'midValue').attr('text-anchor', 'middle').style('opacity', 0);
      midValueSelection.selectAll('textPath').remove();
      midValueSelection.append('textPath').attr('xlink:href', '#' + textCurveDefinition.attr('id')).attr('startOffset', '50%').text(function (rangeObject) {
        return config.rangeFormat(rangeObject.value);
      });
      midValueSelection.exit().remove();
      midValueSelection.transition('midValueTransition').duration(config.animationDuration).attr('transform', function (d) {
        var rotation = -90 + (d.value - data.minValue) / (data.maxValue - data.minValue) * 180;
        return "rotate(".concat(rotation, " 0 0)");
      }).each('end.midValueTransition', function () {
        var midValueSelection = labelContainer.selectAll('text.midValue');
        (midValueSelection[0] || []).reverse();
        var previousNode = null;
        midValueSelection.each(function () {
          var currentSelection = external_d3_default().select(this);
          if (previousNode) {
            var currentBoundingRect = this.getBoundingClientRect();
            var previousBoundingRect = previousNode.getBoundingClientRect();
            currentBoundingRect.x = currentBoundingRect.left;
            currentBoundingRect.y = currentBoundingRect.top;
            previousBoundingRect.x = previousBoundingRect.left;
            previousBoundingRect.y = previousBoundingRect.top;
            if (isColliding(currentBoundingRect, previousBoundingRect)) {
              currentSelection.style('opacity', 0);
            } else {
              currentSelection.style('opacity', 1);
              previousNode = this;
            }
          } else {
            external_d3_default().select(this).style('opacity', 1);
            previousNode = this;
          }
        });
      }).call(lifeCycle.watch);
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(gauge, config);
  gauge.lifeCycle = lifeCycle.dispatch;
  return gauge;
};
;// ./src/js/viz/d3/charts/core.js





function Core() {
  this.initialize.apply(this, arguments);
  return this;
}
Core.extend = utils_inherit;
var core_DEFAULT_SIZE = 400;
var BASE = 10;
Object.assign(Core.prototype, {
  initialize: function initialize(options) {
    if (!options.containerId) {
      throw new Error('ContainerId not specified');
    } else {
      this.parentContainerId = options.containerId;
      this.clearContainer();
      this.wrapContainer();
    }
  },
  wrapContainer: function wrapContainer() {
    var parentContainer;
    if (!this.parentContainerId) {
      return false;
    }
    if (this.hasContainer()) {
      this.resizeContainer();
      return false;
    }
    parentContainer = this.getParentContainer();
    this.containerId || (this.containerId = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().uniqueId('DqChart'));
    parentContainer.append('svg').attr('id', this.containerId).classed('dq', true).classed((less_default()).dq, true);
    this.resizeContainer();
    return true;
  },
  hasContainer: function hasContainer() {
    return !!(this.containerId && !this.getParentContainer().select(wrapId(this.containerId)).empty());
  },
  setContainerSize: function setContainerSize(width, height) {
    var container = this.getContainer();
    if (!container.empty()) {
      container.attr('width', width).attr('height', height);
    }
  },
  resizeContainer: function resizeContainer() {
    this.setContainerSize(1, 1);
    this.setContainerSize(this.getContainerWidth(), this.getContainerHeight());
    return this;
  },
  clearContainer: function clearContainer() {
    var parentContainer = this.getParentContainer();
    if (!parentContainer.empty()) {
      parentContainer.html('');
    }
    return this;
  },
  getParentContainer: function getParentContainer() {
    return external_d3_default().select(wrapId(this.parentContainerId));
  },
  getContainer: function getContainer() {
    return external_d3_default().select(wrapId(this.parentContainerId)).select(wrapId(this.containerId));
  },
  getContainerWidth: function getContainerWidth() {
    var parentContainer = this.getParentContainer();
    return parentContainer.empty() ? 0 : parseInt(parentContainer.style('width'), BASE) || core_DEFAULT_SIZE;
  },
  getContainerHeight: function getContainerHeight() {
    var parentContainer = this.getParentContainer();
    return parentContainer.empty() ? 0 : parseInt(parentContainer.style('height'), BASE) || core_DEFAULT_SIZE;
  },
  getContainerDimensions: function getContainerDimensions() {
    return {
      width: this.getContainerWidth(),
      height: this.getContainerHeight()
    };
  },
  getChartContainerDimensions: function getChartContainerDimensions() {
    return {
      width: this.getChartContainerWidth(),
      height: this.getChartContainerHeight()
    };
  },
  getChartContainerWidth: function getChartContainerWidth() {
    var chartContainer = this.getContainer();
    return chartContainer.empty() ? 0 : parseInt(chartContainer.style('width'), BASE) || core_DEFAULT_SIZE;
  },
  getChartContainerHeight: function getChartContainerHeight() {
    var chartContainer = this.getContainer();
    return chartContainer.empty() ? 0 : parseInt(chartContainer.style('height'), BASE) || core_DEFAULT_SIZE;
  },
  resize: function resize() {
    this.resizeContainer();
    this.render();
  },
  remove: function remove() {
    var container = this.getParentContainer();
    container && container.remove && container.remove();
  }
});
;// ./src/js/viz/d3/charts/gauge_chart.js





var GaugeChart = Core.extend(MarginConfig).extend(AnimationConfig).extend({
  _animationDuration: 400,
  render: function render(postRender) {
    if (this.nextAnimationTime === undefined) {
      this.nextAnimationTime = this._animationDuration;
    }
    var mergedData, container;
    this.wrapContainer();
    container = this.getContainer();
    this.createGauge();
    mergedData = Object.assign({}, this.data, {
      rangeConfig: this.rangeConfig
    });
    this.gauge.animationDuration(this.nextAnimationTime);
    container.datum(mergedData).call(this.gauge);
    this.gauge.lifeCycle.on('renderEnd', function () {
      postRender && postRender();
    });
    this.nextAnimationTime = this._animationDuration;
    return this;
  },
  createGauge: function createGauge() {
    this.gauge || (this.gauge = Gauge());
    this.gauge.width(this.getContainerWidth()).height(this.getContainerHeight());
    this.gauge.valueFormat(this.valueFormat).disableInteraction(this._disableInteraction).automaticFontResize(!this.fontSize).valueFontSize(this.fontSize).valueColor('#222222').maxRadius(300).margins(this._margin);
    if (this.rangeFormat) {
      this.gauge.rangeFormat(this.rangeFormat);
    }
  },
  setData: function setData(data) {
    this.data = data;
    return this;
  },
  setRangeConfig: function setRangeConfig(rangeConfig) {
    this.rangeConfig = rangeConfig;
    return this;
  },
  setValueFormat: function setValueFormat(f) {
    this.valueFormat = f;
    return this;
  },
  setRangeFormat: function setRangeFormat(rangeFormat) {
    this.rangeFormat = rangeFormat;
    return this;
  },
  disableNextAnimation: function disableNextAnimation() {
    this.nextAnimationTime = 0;
    return this;
  },
  setFontSize: function setFontSize(fontSize) {
    if (_.isNumber(fontSize) && fontSize > 0) {
      this.fontSize = fontSize;
    } else {
      this.fontSize = undefined;
    }
    return this;
  },
  disableInteraction: function disableInteraction(val) {
    this._disableInteraction = !!val;
    return this;
  },
  resize: function resize() {
    if (this.gauge) {
      this.disableNextAnimation();
      Core.prototype.resize.apply(this, arguments);
    }
  }
}, {
  Name: 'Gauge',
  DataDimensions: '1'
});
;// ./src/js/viz/d3/charts/upgraded_core.js





function UpgradedCore() {
  this.initialize.apply(this, arguments);
  return this;
}
UpgradedCore.extend = utils_inherit;
var upgraded_core_DEFAULT_SIZE = 400;
var upgraded_core_BASE = 10;
Object.assign(UpgradedCore.prototype, {
  initialize: function initialize(options) {
    if (!options.containerId) {
      throw new Error('ContainerId not specified');
    } else {
      this.parentContainerId = options.containerId;
      this.clearContainer();
      this.wrapContainer();
    }
  },
  wrapContainer: function wrapContainer() {
    var parentContainer;
    if (!this.parentContainerId) {
      return false;
    }
    if (this.hasContainer()) {
      this.resizeContainer();
      return false;
    }
    parentContainer = this.getParentContainer();
    this.containerId || (this.containerId = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().uniqueId('DqChart'));
    parentContainer.append('svg').attr('id', this.containerId).classed('dq', true).classed((less_default()).dq, true);
    this.resizeContainer();
    return true;
  },
  hasContainer: function hasContainer() {
    return !!(this.containerId && !this.getParentContainer().select(wrapId(this.containerId)).empty());
  },
  setContainerSize: function setContainerSize(width, height) {
    var container = this.getContainer();
    if (!container.empty()) {
      container.attr('width', width).attr('height', height);
    }
  },
  resizeContainer: function resizeContainer() {
    this.setContainerSize(1, 1);
    this.setContainerSize(this.getContainerWidth(), this.getContainerHeight());
    return this;
  },
  clearContainer: function clearContainer() {
    var parentContainer = this.getParentContainer();
    if (!parentContainer.empty()) {
      parentContainer.html('');
    }
    return this;
  },
  getParentContainer: function getParentContainer() {
    return src_select(wrapId(this.parentContainerId));
  },
  getContainer: function getContainer() {
    return src_select(wrapId(this.parentContainerId)).select(wrapId(this.containerId));
  },
  getContainerWidth: function getContainerWidth() {
    var parentContainer = this.getParentContainer();
    return parentContainer.empty() ? 0 : parseInt(parentContainer.node().clientWidth, upgraded_core_BASE) || upgraded_core_DEFAULT_SIZE;
  },
  getContainerHeight: function getContainerHeight() {
    var parentContainer = this.getParentContainer();
    return parentContainer.empty() ? 0 : parseInt(parentContainer.node().clientHeight, upgraded_core_BASE) || upgraded_core_DEFAULT_SIZE;
  },
  getContainerDimensions: function getContainerDimensions() {
    return {
      width: this.getContainerWidth(),
      height: this.getContainerHeight()
    };
  },
  getChartContainerDimensions: function getChartContainerDimensions() {
    return {
      width: this.getChartContainerWidth(),
      height: this.getChartContainerHeight()
    };
  },
  getChartContainerWidth: function getChartContainerWidth() {
    var chartContainer = this.getContainer();
    return chartContainer.empty() ? 0 : parseInt(chartContainer.node().clientWidth, upgraded_core_BASE) || upgraded_core_DEFAULT_SIZE;
  },
  getChartContainerHeight: function getChartContainerHeight() {
    var chartContainer = this.getContainer();
    return chartContainer.empty() ? 0 : parseInt(chartContainer.node().clientHeight, upgraded_core_BASE) || upgraded_core_DEFAULT_SIZE;
  },
  resize: function resize() {
    this.resizeContainer();
    this.render();
  },
  remove: function remove() {
    var container = this.getParentContainer();
    container && container.remove && container.remove();
  }
});
;// ./src/js/tooltip/upgraded_dark_dialog.js



var upgraded_dark_dialog_nvToolTipGenerator = js_nv.models.upgradedTooltip()._options.contentGenerator;
var upgraded_dark_dialog_createCustomDiv = function createCustomDiv(customClassName, customId) {
  var div = document.createElement('div');
  if (customClassName) {
    div.className = customClassName;
  }
  if (customId) {
    div.id = customId;
  }
  return div;
};
var upgradedWrapWithDarkDialog = function upgradedWrapWithDarkDialog(contentGenerator) {
  return function () {
    var div = upgraded_dark_dialog_createCustomDiv('dark-dialog');
    div.innerHTML = contentGenerator.apply(void 0, arguments);
    return purify(window).sanitize(div, {
      RETURN_DOM: true,
      ALLOWED_TAGS: constants_Constants.ALLOWED_TAGS,
      ALLOWED_ATTR: constants_Constants.ALLOWED_ATTR
    }).outerHTML;
  };
};
var upgradedDarkDialog = upgradedWrapWithDarkDialog(upgraded_dark_dialog_nvToolTipGenerator);
var upgradedNvTooltip = function upgradedNvTooltip() {
  return js_nv.models.upgradedTooltip();
};
;// ./node_modules/d3-shape/src/arc.js




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(math_max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = src_constant(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = src_path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : src_constant(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : src_constant(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : src_constant(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : src_constant(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : src_constant(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : src_constant(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : src_constant(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

;// ./node_modules/d3-shape/src/curve/radial.js


var curveRadialLinear = curveRadial(curve_linear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

;// ./node_modules/d3-shape/src/lineRadial.js



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ function src_lineRadial() {
  return lineRadial(src_line().curve(curveRadialLinear));
}

;// ./src/js/viz/d3/components/round_gauge.js











function round_gauge_typeof(o) { "@babel/helpers - typeof"; return round_gauge_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, round_gauge_typeof(o); }
function round_gauge_toConsumableArray(r) { return round_gauge_arrayWithoutHoles(r) || round_gauge_iterableToArray(r) || round_gauge_unsupportedIterableToArray(r) || round_gauge_nonIterableSpread(); }
function round_gauge_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function round_gauge_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function round_gauge_arrayWithoutHoles(r) { if (Array.isArray(r)) return round_gauge_arrayLikeToArray(r); }
function round_gauge_slicedToArray(r, e) { return round_gauge_arrayWithHoles(r) || round_gauge_iterableToArrayLimit(r, e) || round_gauge_unsupportedIterableToArray(r, e) || round_gauge_nonIterableRest(); }
function round_gauge_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function round_gauge_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return round_gauge_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? round_gauge_arrayLikeToArray(r, a) : void 0; } }
function round_gauge_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function round_gauge_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function round_gauge_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function round_gauge_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function round_gauge_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? round_gauge_ownKeys(Object(t), !0).forEach(function (r) { round_gauge_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : round_gauge_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function round_gauge_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function round_gauge_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, round_gauge_toPropertyKey(o.key), o); } }
function round_gauge_createClass(e, r, t) { return r && round_gauge_defineProperties(e.prototype, r), t && round_gauge_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function round_gauge_defineProperty(e, r, t) { return (r = round_gauge_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function round_gauge_toPropertyKey(t) { var i = round_gauge_toPrimitive(t, "string"); return "symbol" == round_gauge_typeof(i) ? i : i + ""; }
function round_gauge_toPrimitive(t, r) { if ("object" != round_gauge_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != round_gauge_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var GaugeConstants = {
  smallBreakpointPx: 300,
  largeBreakpointPx: 400,
  smallBreakpointInnerRadius: 92,
  smallBreakpointOuterRadius: 100,
  midBreakpointInnerRadius: 140,
  midBreakpointOuterRadius: 150,
  defaultInnerRadius: 188,
  defaultOuterRadius: 200,
  defaultMarkerPaddingPx: 1.25,
  arcMin: -172 * (Math.PI / 180),
  arcMax: -(-172 * (Math.PI / 180)),
  start: 'start',
  middle: 'middle',
  end: 'end',
  baselineHanging: '0.74em',
  baselineCentral: '0.34em',
  baselineMiddle: '0.27em',
  baselineDefault: '0em',
  visible: 'visible',
  hidden: 'hidden',
  noFill: 'none',
  white: '#fff',
  strokeColor: '#fff',
  squareCap: 'square',
  allEvents: 'all',
  containerArcClass: 'round-gauge',
  backgroundArcClass: 'round-gauge-background-arc',
  dataArcClass: 'round-gauge-data-arc',
  numberLabelClass: 'round-gauge-number',
  thresholdTickClass: 'round-gauge-threshold-tick',
  fieldLabelClass: 'round-gauge-field-label',
  thresholdLabelClass: 'round-gauge-threshold-label',
  gaugeFillArcClass: 'round-gauge-fill-arc',
  gaugeRingMarkerClass: 'round-gauge-ring-marker',
  gaugeChartAreaClass: 'round-gauge-chart-area',
  maskArcClass: 'round-gauge-arc-mask'
};
var EVENTS = constants_Constants.INTERACTION_EVENTS;
var AngularPositions = {
  dueNorth: 'north',
  dueEast: 'east',
  dueSouth: 'south',
  dueWest: 'west',
  firstQuadrant: 'firstQuadrant',
  secondQuadrant: 'secondQuadrant',
  thirdQuadrant: 'thirdQuadrant',
  fourthQuadrant: 'fourthQuadrant'
};
var defaultComponentConfig = {
  width: 400,
  height: 400,
  animationDuration: 400,
  emptyRingColor: '#E5E5E5',
  fieldLabelFontSize: 14,
  labelPadding: 4,
  maxFontSize: 72,
  maxLineHeight: 1.2,
  margins: {
    top: 20,
    bottom: 16,
    left: 0,
    right: 0
  },
  showStaticThresholds: false,
  showThresholdLabels: true,
  thresholdLabelFontSize: 14,
  thresholdLabelFormat: function thresholdLabelFormat(val) {
    return val;
  },
  thresholdTickWidth: 2,
  valueFormat: function valueFormat(val) {
    return val;
  }
};
var RoundGauge = function () {
  function RoundGauge() {
    var _this = this;
    round_gauge_classCallCheck(this, RoundGauge);
    round_gauge_defineProperty(this, "_componentConfig", round_gauge_objectSpread({}, defaultComponentConfig));
    round_gauge_defineProperty(this, "_renderLifeCycle", new upgraded_utils_RenderLifeCycle());
    round_gauge_defineProperty(this, "_maskId", _.uniqueId('mask'));
    round_gauge_defineProperty(this, "_tooltip", upgradedNvTooltip());
    round_gauge_defineProperty(this, "_scrollActionHandler", undefined);
    round_gauge_defineProperty(this, "render", function (selection) {
      _this._renderLifeCycle.start();
      _this._configureTooltip();
      selection.each(_this._renderSelection());
      _this._renderLifeCycle.dispatchOnCompletion();
    });
    round_gauge_defineProperty(this, "_configureTooltip", function () {
      _this._tooltip.contentGenerator(upgradedDarkDialog);
      _this._tooltip.hideDelay(0);
    });
    round_gauge_defineProperty(this, "_renderSelection", function () {
      var roundGaugeConfig = _this._componentConfig;
      var renderLifeCycle = _this._renderLifeCycle;
      var gaugeDataMaskId = _this._maskId;
      var tooltipComponent = _this._tooltip;
      var setGlobalScrollHandler = _this.setGlobalScrollHandler.bind(_this);
      return function (data) {
        var container = src_select(this);
        var arcScale = linear_linear().domain([data.minValue, data.maxValue]).range([GaugeConstants.arcMin, GaugeConstants.arcMax]);
        var _data$rangeConfig$sli = data.rangeConfig.slice(-1),
          _data$rangeConfig$sli2 = round_gauge_slicedToArray(_data$rangeConfig$sli, 1),
          maxThreshold = _data$rangeConfig$sli2[0];
        var colorScale = threshold_threshold().domain(data.rangeConfig.map(function (range) {
          return range.value;
        })).range([].concat(round_gauge_toConsumableArray(data.rangeConfig.map(function (range) {
          return range.color;
        })), [maxThreshold.color]));
        var _getRadii = getRadii(),
          innerRadius = _getRadii.innerRadius,
          outerRadius = _getRadii.outerRadius;
        var dataArc = arc().innerRadius(innerRadius).outerRadius(outerRadius).cornerRadius(outerRadius - innerRadius).startAngle(GaugeConstants.arcMin);
        var arcG = container.selectAll('g').data([data]);
        arcG.exit().remove();
        var arcGMergeSelection = arcG.enter().append('g').attr('class', GaugeConstants.containerArcClass).merge(arcG);
        var margins = roundGaugeConfig.margins,
          width = roundGaugeConfig.width,
          height = roundGaugeConfig.height;
        var minChartOuterDiameter = 2 * GaugeConstants.smallBreakpointOuterRadius;
        var minChartWidth = minChartOuterDiameter + margins.left + margins.right;
        var minChartHeight = minChartOuterDiameter + margins.top + margins.bottom;
        var chartScaleFactor = uniformScaleFactor(width, height, minChartWidth, minChartHeight);
        var renderWidth = width - margins.left - margins.right;
        var renderHeight = height - margins.top - margins.bottom;
        var translateX = minChartWidth > width ? chartScaleFactor * (margins.left + outerRadius) : margins.left + renderWidth / 2;
        var translateY = minChartHeight > height ? chartScaleFactor * (margins.top + outerRadius) : margins.top + renderHeight / 2;
        arcGMergeSelection.attr('transform', function () {
          return "".concat(translateTransform(translateX, translateY), " ").concat(uniformScaleTransform(chartScaleFactor));
        });
        var chartAreaSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.gaugeChartAreaClass)).data([data]);
        chartAreaSelection.exit().remove();
        var chartAreaMergeSelection = chartAreaSelection.enter().append('circle').classed(GaugeConstants.gaugeChartAreaClass, true).merge(chartAreaSelection);
        chartAreaMergeSelection.attr('r', outerRadius).attr('fill', GaugeConstants.noFill).attr('pointer-events', GaugeConstants.allEvents);
        var backgroundArcSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.backgroundArcClass)).data([{
          endAngle: GaugeConstants.arcMax
        }]);
        backgroundArcSelection.exit().remove();
        var backgroundArcMergeSelection = backgroundArcSelection.enter().append('path').attr('class', GaugeConstants.backgroundArcClass).merge(backgroundArcSelection);
        backgroundArcMergeSelection.attr('d', dataArc).attr('fill', roundGaugeConfig.emptyRingColor).attr('visibility', roundGaugeConfig.showStaticThresholds ? GaugeConstants.hidden : GaugeConstants.visible);
        var dataArcSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.dataArcClass)).data([{
          endAngle: arcScale(getClampedDataValue())
        }]);
        dataArcSelection.exit().remove();
        var dataArcMergeSelection = dataArcSelection.enter().append('path').attr('class', GaugeConstants.dataArcClass).style('fill', colorScale(data.value)).attr('visibility', roundGaugeConfig.showStaticThresholds ? GaugeConstants.hidden : GaugeConstants.visible).each(function () {
          this._current = {
            endAngle: GaugeConstants.arcMin
          };
        }).merge(dataArcSelection);
        dataArcMergeSelection.transition().duration(roundGaugeConfig.animationDuration).style('fill', colorScale(data.value)).attrTween('d', dataArcInterpolationFn).call(renderLifeCycle.createWatcherWithCallback(function eachEnd(d) {
          this._current = d;
        }));
        var gaugeArcMaskId = "gauge-arc-".concat(gaugeDataMaskId);
        var boundMaskData = [{
          endAngle: GaugeConstants.arcMax
        }];
        var gaugeArcMaskSelection = arcGMergeSelection.selectAll("#".concat(gaugeArcMaskId)).data(boundMaskData);
        gaugeArcMaskSelection.exit().remove();
        var gaugeArcMaskMergeSelection = gaugeArcMaskSelection.enter().append('mask').attr('id', gaugeArcMaskId).merge(gaugeArcMaskSelection);
        var maskSelection = gaugeArcMaskMergeSelection.selectAll(round_gauge_selector(GaugeConstants.maskArcClass)).data(boundMaskData);
        maskSelection.exit().remove();
        var maskMergeSelection = maskSelection.enter().append('path').classed(GaugeConstants.maskArcClass, true).merge(maskSelection);
        maskMergeSelection.attr('d', dataArc).attr('fill', GaugeConstants.white);
        var gaugeFillArcSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.gaugeFillArcClass)).data(getFillArcData(data));
        gaugeFillArcSelection.exit().remove();
        var gaugeFillArcMergeSelection = gaugeFillArcSelection.enter().append('path').classed(GaugeConstants.gaugeFillArcClass, true).attr('visibility', roundGaugeConfig.showStaticThresholds ? GaugeConstants.visible : GaugeConstants.hidden).merge(gaugeFillArcSelection);
        var fillArcPath = arc().innerRadius(innerRadius).outerRadius(outerRadius);
        gaugeFillArcMergeSelection.attr('fill', function (d) {
          return d.color;
        }).attr('mask', "url(#".concat(gaugeArcMaskId, ")")).attr('d', fillArcPath);
        var gaugeNumberSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.numberLabelClass)).data([data.value]);
        gaugeNumberSelection.exit().remove();
        var gaugeNumberMergeSelection = gaugeNumberSelection.enter().append('text').attr('class', GaugeConstants.numberLabelClass).merge(gaugeNumberSelection);
        gaugeNumberMergeSelection.style('line-height', roundGaugeConfig.maxLineHeight).style('font-size', "".concat(roundGaugeConfig.maxFontSize, "px")).attr('dy', GaugeConstants.baselineCentral).attr('text-anchor', GaugeConstants.middle).text(function (d) {
          return roundGaugeConfig.valueFormat(d);
        }).attr('transform', function () {
          return uniformRadialScaleTransform(innerRadius, this);
        });
        var thresholdTickBoundData = data.rangeConfig.slice(0, -1);
        var gaugeThresholdTickSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.thresholdTickClass)).data(thresholdTickBoundData);
        gaugeThresholdTickSelection.exit().remove();
        var gaugeThresholdTickMergeSelection = gaugeThresholdTickSelection.enter().append('path').attr('class', GaugeConstants.thresholdTickClass).each(function (d) {
          this._current = d;
        }).merge(gaugeThresholdTickSelection);
        var radialLineGenerator = src_lineRadial().angle(function (d) {
          return arcScale(d);
        }).radius(function (_, i) {
          return i % 2 ? outerRadius : innerRadius;
        });
        gaugeThresholdTickMergeSelection.attr('d', function (d) {
          return radialLineGenerator([d.value, d.value]);
        }).attr('fill', GaugeConstants.noFill).attr('stroke', GaugeConstants.strokeColor).attr('stroke-linecap', GaugeConstants.squareCap).attr('stroke-width', roundGaugeConfig.thresholdTickWidth);
        gaugeThresholdTickMergeSelection.transition().duration(roundGaugeConfig.animationDuration).attrTween('d', thresholdLineInterpolationFn).call(renderLifeCycle.createWatcherWithCallback(function transitionEnd(d) {
          this._current = d;
        }));
        var fieldLabelSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.fieldLabelClass)).data([data.label]);
        fieldLabelSelection.exit().remove();
        var fieldLabelMergeSelection = fieldLabelSelection.enter().append('text').attr('class', GaugeConstants.fieldLabelClass).merge(fieldLabelSelection);
        fieldLabelMergeSelection.attr('font-size', "".concat(roundGaugeConfig.fieldLabelFontSize, "px")).attr('line-height', roundGaugeConfig.maxLineHeight).attr('text-anchor', GaugeConstants.middle).attr('dy', GaugeConstants.baselineHanging).attr('transform', translateTransform(0, calculateLabelOffset())).text(function (d) {
          return d;
        }).call(upgraded_utils_wordWrap, calculateLabelWidth());
        var thresholdLabelSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.thresholdLabelClass)).data([{
          value: data.minValue
        }].concat(round_gauge_toConsumableArray(data.rangeConfig)));
        thresholdLabelSelection.exit().remove();
        var thresholdLabelMergeSelection = thresholdLabelSelection.enter().append('text').attr('class', GaugeConstants.thresholdLabelClass).each(function (d) {
          this._current = d;
        }).merge(thresholdLabelSelection);
        thresholdLabelMergeSelection.attr('font-size', "".concat(roundGaugeConfig.thresholdLabelFontSize, "px")).attr('line-height', roundGaugeConfig.maxLineHeight).attr('text-anchor', function (d) {
          return getThresholdLabelAttributes(arcScale(d.value)).textAnchor;
        }).attr('transform', function (d) {
          var _getThresholdLabelPos = getThresholdLabelPosition(d.value, outerRadius, roundGaugeConfig, arcScale),
            x = _getThresholdLabelPos.x,
            y = _getThresholdLabelPos.y;
          return translateTransform(x, y);
        }).attr('dy', function (d) {
          return getThresholdLabelAttributes(arcScale(d.value)).dominantBaseline;
        }).text(function (d) {
          return roundGaugeConfig.thresholdLabelFormat(d.value);
        }).attr('visibility', getThresholdLabelVisibilityFunction());
        thresholdLabelMergeSelection.transition().duration(roundGaugeConfig.animationDuration).attrTween('transform', thresholdLabelInterpolationFn).call(renderLifeCycle.createWatcherWithCallback(function onTransitionEnd(d) {
          this._current = d;
        }));
        var gaugeRingMarkerSelection = arcGMergeSelection.selectAll(round_gauge_selector(GaugeConstants.gaugeRingMarkerClass)).data([getClampedDataValue()]);
        gaugeRingMarkerSelection.exit().remove();
        var gaugeRingMarkerMergeSelection = gaugeRingMarkerSelection.enter().append('circle').classed(GaugeConstants.gaugeRingMarkerClass, true).attr('visibility', roundGaugeConfig.showStaticThresholds ? GaugeConstants.visible : GaugeConstants.hidden).each(function () {
          this._current = data.minValue;
        }).merge(gaugeRingMarkerSelection);
        var ringMarkerRadialPosition = (outerRadius + innerRadius) / 2;
        var ringMarkerRadius = (outerRadius - innerRadius) / 2 + GaugeConstants.defaultMarkerPaddingPx;
        gaugeRingMarkerMergeSelection.attr('r', ringMarkerRadius).attr('fill', function (val) {
          return colorScale(val);
        }).attr('stroke', GaugeConstants.strokeColor).attr('stroke-width', 2 * GaugeConstants.defaultMarkerPaddingPx);
        gaugeRingMarkerMergeSelection.transition().duration(roundGaugeConfig.animationDuration).attrTween('cx', gaugeRingMarkerCxInterpolationFn).attrTween('cy', gaugeRingMarkerCyInterpolationFn).call(renderLifeCycle.createWatcherWithCallback(function onTransitionEnd(d) {
          this._current = d;
        }));
        arcGMergeSelection.on(EVENTS.touchStart, toggleStaticThresholdsView).on(EVENTS.mouseEnter, showStaticThresholdsView).on(EVENTS.mouseLeave, hideStaticThresholdsView).on(EVENTS.mouseMove, updateTooltipPosition);
        setGlobalScrollHandler(hideStaticThresholdsView);
        var isShowingStaticThresholdsView = false;
        function toggleStaticThresholdsView() {
          if (isShowingStaticThresholdsView) {
            hideStaticThresholdsView();
          } else {
            showStaticThresholdsView();
          }
        }
        function showStaticThresholdsView() {
          showTooltip();
          setVisibility(thresholdLabelMergeSelection, getThresholdLabelVisibilityFunction(true));
          if (roundGaugeConfig.showStaticThresholds) {
            return;
          }
          gaugeRingMarkerMergeSelection.call(setVisibility);
          gaugeFillArcMergeSelection.call(setVisible);
          dataArcMergeSelection.call(setHidden);
          backgroundArcMergeSelection.call(setHidden);
          isShowingStaticThresholdsView = true;
        }
        function hideStaticThresholdsView() {
          hideTooltip();
          setVisibility(thresholdLabelMergeSelection, getThresholdLabelVisibilityFunction());
          if (roundGaugeConfig.showStaticThresholds) {
            return;
          }
          backgroundArcMergeSelection.call(setVisible);
          dataArcMergeSelection.call(setVisible);
          gaugeFillArcMergeSelection.call(setHidden);
          gaugeRingMarkerMergeSelection.call(setHidden);
          isShowingStaticThresholdsView = false;
        }
        function setVisible(selection) {
          setVisibility(selection, GaugeConstants.visible);
        }
        function setHidden(selection) {
          setVisibility(selection, GaugeConstants.hidden);
        }
        function setVisibility(selection, value) {
          selection.attr('visibility', value);
        }
        function showTooltip() {
          var tooltipData = generateTooltipData(data);
          tooltipComponent.data(tooltipData).duration(0).hidden(false);
        }
        function hideTooltip() {
          tooltipComponent.hidden(true);
        }
        function updateTooltipPosition() {
          tooltipComponent();
        }
        function getClampedDataValue() {
          return Math.min(Math.max(data.value, data.minValue), data.maxValue);
        }
        function gaugeRingMarkerCxInterpolationFn(d) {
          var interpolate = value(this._current, d);
          return function (t) {
            return ringMarkerRadialPosition * Math.sin(arcScale(interpolate(t)));
          };
        }
        function gaugeRingMarkerCyInterpolationFn(d) {
          var interpolate = value(this._current, d);
          return function (t) {
            return ringMarkerRadialPosition * -Math.cos(arcScale(interpolate(t)));
          };
        }
        function getThresholdLabelVisibilityFunction(forceVisibility) {
          return function getThresholdLabelVisibility(d, i) {
            if (!(roundGaugeConfig.showThresholdLabels || forceVisibility) || isClipped(this, container)) {
              return GaugeConstants.hidden;
            }
            var thresholdLabelNodes = thresholdLabelMergeSelection.nodes();
            var finalThresholdLabelIndex = thresholdLabelNodes.length - 1;
            var finalThresholdNode = thresholdLabelNodes[finalThresholdLabelIndex];
            if (i === 0 || i === finalThresholdLabelIndex) {
              return GaugeConstants.visible;
            }
            if (nodesAreOverlapping(this, finalThresholdNode)) {
              return GaugeConstants.hidden;
            }
            for (var nodeIndex = i - 1; nodeIndex >= 0; nodeIndex--) {
              var comparisonNode = src_select(thresholdLabelNodes[nodeIndex]);
              if (comparisonNode.attr('visibility') === GaugeConstants.visible) {
                return nodesAreOverlapping(this, comparisonNode.node()) ? GaugeConstants.hidden : GaugeConstants.visible;
              }
            }
            return GaugeConstants.visible;
          };
        }
        function thresholdLabelInterpolationFn(d) {
          var interpolate = value(this._current.value, d.value);
          return function (t) {
            var _getThresholdLabelPos2 = getThresholdLabelPosition(interpolate(t), outerRadius, roundGaugeConfig, arcScale),
              x = _getThresholdLabelPos2.x,
              y = _getThresholdLabelPos2.y;
            return translateTransform(x, y);
          };
        }
        function calculateLabelOffset() {
          return roundGaugeConfig.maxFontSize / 2;
        }
        function calculateLabelWidth() {
          var fieldLabelFontSize = roundGaugeConfig.fieldLabelFontSize,
            maxLineHeight = roundGaugeConfig.maxLineHeight;
          var gaugeNumberOffset = calculateLabelOffset();
          var innerRadiusSquared = Math.pow(innerRadius, 2);
          var fieldLabelHeight = maxLineHeight * fieldLabelFontSize;
          var labelPositionSquared = Math.pow(gaugeNumberOffset + fieldLabelHeight, 2);
          return 2 * Math.sqrt(innerRadiusSquared - labelPositionSquared);
        }
        function thresholdLineInterpolationFn(d) {
          var interpolate = value(this._current.value, d.value);
          return function (t) {
            var value = interpolate(t);
            return radialLineGenerator([value, value]);
          };
        }
        function dataArcInterpolationFn(d, i) {
          var interpolate = value(this._current.endAngle, d.endAngle);
          return function (t) {
            return dataArc({
              endAngle: interpolate(t)
            }, i);
          };
        }
        function getRadii() {
          var width = roundGaugeConfig.width,
            height = roundGaugeConfig.height,
            _roundGaugeConfig$mar = roundGaugeConfig.margins,
            top = _roundGaugeConfig$mar.top,
            right = _roundGaugeConfig$mar.right,
            bottom = _roundGaugeConfig$mar.bottom,
            left = _roundGaugeConfig$mar.left;
          var widthInMargins = width - left - right;
          var heightInMargins = height - top - bottom;
          var smallestDimension = Math.min(widthInMargins, heightInMargins);
          if (smallestDimension < GaugeConstants.smallBreakpointPx) {
            return {
              innerRadius: GaugeConstants.smallBreakpointInnerRadius,
              outerRadius: GaugeConstants.smallBreakpointOuterRadius
            };
          }
          if (smallestDimension < GaugeConstants.largeBreakpointPx) {
            return {
              innerRadius: GaugeConstants.midBreakpointInnerRadius,
              outerRadius: GaugeConstants.midBreakpointOuterRadius
            };
          }
          return {
            innerRadius: GaugeConstants.defaultInnerRadius,
            outerRadius: GaugeConstants.defaultOuterRadius
          };
        }
        function getFillArcData(chartData) {
          var lowerBoundThreshold = chartData.minValue;
          return chartData.rangeConfig.map(function (range) {
            var arcRange = {
              startAngle: arcScale(lowerBoundThreshold),
              endAngle: arcScale(range.value),
              color: range.color
            };
            lowerBoundThreshold = range.value;
            return arcRange;
          });
        }
      };
    });
  }
  return round_gauge_createClass(RoundGauge, [{
    key: "lifeCycle",
    get: function get() {
      return this._renderLifeCycle.dispatch;
    }
  }, {
    key: "setGlobalScrollHandler",
    value: function setGlobalScrollHandler(scrollActionHandler) {
      if (this._scrollActionHandler) {
        document.removeEventListener(EVENTS.touchMove, this._scrollActionHandler);
      }
      this._scrollActionHandler = scrollActionHandler;
      document.addEventListener(EVENTS.touchMove, this._scrollActionHandler);
    }
  }, {
    key: "width",
    value: function width(_width) {
      this._componentConfig.width = _width;
      return this;
    }
  }, {
    key: "height",
    value: function height(_height) {
      this._componentConfig.height = _height;
      return this;
    }
  }, {
    key: "animationDuration",
    value: function animationDuration(duration) {
      this._componentConfig.animationDuration = duration;
      return this;
    }
  }, {
    key: "emptyRingColor",
    value: function emptyRingColor(color) {
      this._componentConfig.emptyRingColor = color;
      return this;
    }
  }, {
    key: "fieldLabelFontSize",
    value: function fieldLabelFontSize(fontSize) {
      this._componentConfig.fieldLabelFontSize = fontSize;
      return this;
    }
  }, {
    key: "labelPadding",
    value: function labelPadding(padAmount) {
      this._componentConfig.labelPadding = padAmount;
      return this;
    }
  }, {
    key: "margins",
    value: function margins(_margins) {
      this._componentConfig.margins = round_gauge_objectSpread(round_gauge_objectSpread({}, this._componentConfig.margins), _margins);
      return this;
    }
  }, {
    key: "showStaticThresholds",
    value: function showStaticThresholds(shouldShow) {
      this._componentConfig.showStaticThresholds = shouldShow;
      return this;
    }
  }, {
    key: "showThresholdLabels",
    value: function showThresholdLabels(isEnabled) {
      this._componentConfig.showThresholdLabels = isEnabled;
      return this;
    }
  }, {
    key: "thresholdLabelFontSize",
    value: function thresholdLabelFontSize(fontSize) {
      this._componentConfig.thresholdLabelFontSize = fontSize;
      return this;
    }
  }, {
    key: "thresholdLabelFormat",
    value: function thresholdLabelFormat(formatFunction) {
      this._componentConfig.thresholdLabelFormat = formatFunction;
      return this;
    }
  }, {
    key: "thresholdTickWidth",
    value: function thresholdTickWidth(tickWidth) {
      this._componentConfig.thresholdTickWidth = tickWidth;
      return this;
    }
  }, {
    key: "valueFormat",
    value: function valueFormat(formatFunction) {
      this._componentConfig.valueFormat = formatFunction;
      return this;
    }
  }]);
}();
function translateTransform(x, y) {
  return "translate(".concat(x, ", ").concat(y, ")");
}
function uniformScaleTransform(scaleFactor) {
  return "scale(".concat(scaleFactor, ", ").concat(scaleFactor, ")");
}
function uniformScaleFactor(containerWidth, containerHeight, chartWidth, chartHeight) {
  var widthScaleFactor = Math.min(containerWidth / chartWidth, 1);
  var heightScaleFactor = Math.min(containerHeight / chartHeight, 1);
  return Math.min(widthScaleFactor, heightScaleFactor);
}
function uniformRadialScaleTransform(innerRadius, textSelection) {
  var _textSelection$getBBo = textSelection.getBBox(),
    height = _textSelection$getBBo.height,
    width = _textSelection$getBBo.width;
  var textRadius = Math.sqrt(Math.pow(height, 2) + Math.pow(width, 2)) / 2;
  if (textRadius < innerRadius) {
    return 'scale(1, 1)';
  }
  var scaleFactor = innerRadius / textRadius;
  return "scale(".concat(scaleFactor, ", ").concat(scaleFactor, ")");
}
function round_gauge_selector(className) {
  return ".".concat(className);
}
function getThresholdLabelAttributes(value) {
  var dueNorth = AngularPositions.dueNorth,
    dueEast = AngularPositions.dueEast,
    dueSouth = AngularPositions.dueSouth,
    dueWest = AngularPositions.dueWest,
    firstQuadrant = AngularPositions.firstQuadrant,
    secondQuadrant = AngularPositions.secondQuadrant,
    thirdQuadrant = AngularPositions.thirdQuadrant,
    fourthQuadrant = AngularPositions.fourthQuadrant;
  var middle = GaugeConstants.middle,
    start = GaugeConstants.start,
    end = GaugeConstants.end,
    baselineDefault = GaugeConstants.baselineDefault,
    baselineCentral = GaugeConstants.baselineCentral,
    baselineHanging = GaugeConstants.baselineHanging;
  switch (getRelativeAngularPosition(value)) {
    case dueNorth:
      return {
        textAnchor: middle,
        dominantBaseline: baselineDefault
      };
    case dueEast:
      return {
        textAnchor: start,
        dominantBaseline: baselineCentral
      };
    case dueSouth:
      return {
        textAnchor: middle,
        dominantBaseline: baselineHanging
      };
    case dueWest:
      return {
        textAnchor: end,
        dominantBaseline: baselineCentral
      };
    case firstQuadrant:
      return {
        textAnchor: start,
        dominantBaseline: baselineDefault
      };
    case secondQuadrant:
      return {
        textAnchor: start,
        dominantBaseline: baselineHanging
      };
    case thirdQuadrant:
      return {
        textAnchor: end,
        dominantBaseline: baselineHanging
      };
    case fourthQuadrant:
      return {
        textAnchor: end,
        dominantBaseline: baselineDefault
      };
    default:
      return {
        textAnchor: start,
        dominantBaseline: baselineDefault
      };
  }
}
function getRelativeAngularPosition(angle) {
  var roundedAngle = roundAngle(angle);
  if (roundedAngle === 0 || roundedAngle === roundAngle(2 * Math.PI)) {
    return AngularPositions.dueNorth;
  }
  if (roundedAngle === roundAngle(Math.PI / 2)) {
    return AngularPositions.dueEast;
  }
  if (roundedAngle === roundAngle(Math.PI)) {
    return AngularPositions.dueSouth;
  }
  if (roundedAngle === roundAngle(-Math.PI / 2)) {
    return AngularPositions.dueWest;
  }
  if (roundedAngle < -Math.PI / 2) {
    return AngularPositions.thirdQuadrant;
  }
  if (roundedAngle < 0) {
    return AngularPositions.fourthQuadrant;
  }
  if (roundedAngle < Math.PI / 2) {
    return AngularPositions.firstQuadrant;
  }
  if (roundedAngle < Math.PI) {
    return AngularPositions.secondQuadrant;
  }
  return AngularPositions.dueNorth;
}
function roundAngle(angle) {
  var precision = 4;
  var angleString = "".concat(angle, "e").concat(precision);
  return Number("".concat(Math.round(angleString), "e-").concat(precision));
}
function nodesAreOverlapping(firstNode, secondNode) {
  var _firstNode$getBoundin = firstNode.getBoundingClientRect(),
    top = _firstNode$getBoundin.top,
    right = _firstNode$getBoundin.right,
    bottom = _firstNode$getBoundin.bottom,
    left = _firstNode$getBoundin.left;
  var _secondNode$getBoundi = secondNode.getBoundingClientRect(),
    secondTop = _secondNode$getBoundi.top,
    secondRight = _secondNode$getBoundi.right,
    secondBottom = _secondNode$getBoundi.bottom,
    secondLeft = _secondNode$getBoundi.left;
  var collidesVertically = secondTop >= top && secondTop <= bottom || secondBottom >= top && secondBottom <= bottom;
  var collidesHorizontally = secondRight <= right && secondRight >= left || secondLeft <= right && secondLeft >= left;
  return collidesVertically && collidesHorizontally;
}
function isClipped(element, container) {
  var containerNode = container.node();
  var _containerNode$getBou = containerNode.getBoundingClientRect(),
    parentTop = _containerNode$getBou.top,
    parentRight = _containerNode$getBou.right,
    parentBottom = _containerNode$getBou.bottom,
    parentLeft = _containerNode$getBou.left;
  var _element$getBoundingC = element.getBoundingClientRect(),
    top = _element$getBoundingC.top,
    right = _element$getBoundingC.right,
    bottom = _element$getBoundingC.bottom,
    left = _element$getBoundingC.left;
  return top < parentTop || right > parentRight || bottom > parentBottom || left < parentLeft;
}
function generateTooltipData(data) {
  var series = data.rangeConfig.map(function (range) {
    return {
      color: range.color,
      key: range.label
    };
  });
  return {
    series: series,
    value: data.label
  };
}
function getThresholdLabelPosition(thresholdValue, outerRadius, roundGaugeConfig, arcScale) {
  var labelRadius = outerRadius + roundGaugeConfig.labelPadding;
  return {
    x: labelRadius * Math.sin(arcScale(thresholdValue)),
    y: labelRadius * -Math.cos(arcScale(thresholdValue))
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.anchor.js
var es6_string_anchor = __webpack_require__(7360);
;// ./src/js/viz/d3/components/comparisons.js
function comparisons_typeof(o) { "@babel/helpers - typeof"; return comparisons_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, comparisons_typeof(o); }











function comparisons_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function comparisons_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? comparisons_ownKeys(Object(t), !0).forEach(function (r) { comparisons_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : comparisons_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function comparisons_defineProperty(e, r, t) { return (r = comparisons_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function comparisons_toPropertyKey(t) { var i = comparisons_toPrimitive(t, "string"); return "symbol" == comparisons_typeof(i) ? i : i + ""; }
function comparisons_toPrimitive(t, r) { if ("object" != comparisons_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != comparisons_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var HIDE_TOOLTIP_KEY = 'Escape';
var comparisons_createSVGFromDirections = function createSVGFromDirections(direction) {
  var SVG = '';
  direction.forEach(function (command) {
    switch (command.type) {
      case constants_Constants.SVG_COMMAND_TYPES.MOVE:
        SVG += 'M' + command.position.join(',') + ' ';
        break;
      case constants_Constants.SVG_COMMAND_TYPES.DRAW:
        SVG += 'L' + command.position.join(',') + ' ';
        break;
      case constants_Constants.SVG_COMMAND_TYPES.CLOSE:
        SVG += 'Z';
        break;
    }
  });
  return SVG;
};
var createArrow = function createArrow(width, height, direction, heightMultiplier) {
  var dimensionSize = Math.min(width / 4, height);
  var triangleSVG = comparisons_createSVGFromDirections([{
    type: constants_Constants.SVG_COMMAND_TYPES.MOVE,
    position: [-dimensionSize, 0]
  }, {
    type: constants_Constants.SVG_COMMAND_TYPES.DRAW,
    position: [0, dimensionSize * heightMultiplier * (direction === constants_Constants.POSITIVE_DIRECTION ? -1 : 1)]
  }, {
    type: constants_Constants.SVG_COMMAND_TYPES.DRAW,
    position: [dimensionSize, 0]
  }, {
    type: constants_Constants.SVG_COMMAND_TYPES.CLOSE
  }]);
  return {
    SVG: triangleSVG,
    width: dimensionSize * 2,
    height: dimensionSize * heightMultiplier
  };
};
var calculateMaxComparisonTextWidth = function calculateMaxComparisonTextWidth(comparisons, formatFunctions, fontSize, dataValues) {
  var maxComparisonTextWidth = comparisons.reduce(function (maxTextWidth, comparison, index) {
    var formatFunction = formatFunctions[index];
    var formattedData = formatFunction(dataValues[index]);
    var comparisonLineContent = formattedData + comparison.label;
    var estimatedComparisonTextWidth = upgraded_utils_estimateWidthFromSize(fontSize, comparisonLineContent);
    if (!comparison.direction) {
      return Math.max(maxTextWidth, estimatedComparisonTextWidth * constants_Constants.TEXT_WIDTH_PROPORTION - constants_Constants.DEFAULT_FONT_SIZE_PROPORTION * fontSize);
    }
    return Math.max(maxTextWidth, estimatedComparisonTextWidth * constants_Constants.TEXT_WIDTH_PROPORTION);
  }, 0);
  return maxComparisonTextWidth;
};
var getHorizontalOffset = function getHorizontalOffset(position, contentWidth, textWidth) {
  if (position === constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.LEFT) {
    return 0;
  }
  var centerOffset = (contentWidth - Math.min(textWidth, contentWidth)) / 2;
  return centerOffset;
};
var isValidArrowDirection = function isValidArrowDirection(arrowDirection) {
  var POSSIBLE_DIRECTIONS = [constants_Constants.POSITIVE_DIRECTION, constants_Constants.NEGATIVE_DIRECTION];
  return POSSIBLE_DIRECTIONS.includes(arrowDirection);
};
var ComparisonsLayout = function ComparisonsLayout() {
  var config = {
    width: 0,
    height: 0,
    value: undefined,
    label: undefined,
    arrowDirection: null,
    experimentCacheContainer: null,
    maxFontSize: 50000,
    minFontSize: 0,
    fontSize: null,
    position: 0,
    previousWrappedLines: 0,
    arrowDimension: null,
    numberDimension: null,
    labelDimension: null,
    align: null,
    verticalAlign: null,
    alignToArrow: false,
    alignNumberAndLabel: false,
    maxComparisonTextWidth: null
  };
  var PLACEHOLDER_TEXT = '00.00';
  var normalizeValue = function normalizeValue() {
    return PLACEHOLDER_TEXT;
  };
  var calculate = function calculate() {
    var alignToArrow = config.alignToArrow || isValidArrowDirection(config.arrowDirection);
    var arrowNumberPadding = getArrowPadding();
    var numberDimension;
    var arrowDimension;
    var labelDimension;
    config.numberDimension = {};
    config.arrowDimension = {};
    config.labelDimension = {};
    numberDimension = upgraded_utils_estimateMaxTextDimensions(config.width * (alignToArrow ? 0.7 : 1), config.height * 0.5, config.value, config.experimentCacheContainer, Math.min(config.maxFontSize, upgraded_utils_estimateFontSize(config.width * (alignToArrow ? 0.7 : 1), config.height * 0.5, normalizeValue(config.value))), config.minFontSize);
    var numberHorizontalOffset = 0;
    var numberFontSize = config.fontSize || numberDimension.fontSize;
    var comparisonHorizontalOffset = config.maxComparisonTextWidth ? getHorizontalOffset(config.align, config.width, config.maxComparisonTextWidth) : 0;
    var numberLineHeight = upgraded_utils_getLineHeight(numberFontSize, constants_Constants.COMPARISON_HEIGHT_PADDING);
    var linePostion = config.position + config.previousWrappedLines * constants_Constants.NUMBER_COMPARISON_WRAPPED_LINE_MULTIPLIER;
    var numberDimensionCommon = {
      anchor: constants_Constants.ANCHOR_POSITIONS.START,
      fontSize: numberFontSize
    };
    if (alignToArrow) {
      arrowDimension = getArrowDimension(numberLineHeight);
      numberHorizontalOffset = arrowDimension.width + arrowNumberPadding;
      var arrowHorizontalOffset = arrowDimension.width / 2;
      var availableArrowHeight = config.alignNumberAndLabel ? config.fontSize : numberDimension.height;
      var upArrowPositionMultiplier = config.alignNumberAndLabel ? constants_Constants.ARROW_POSITIONING_MULTIPLIERS.INLINE.UP : constants_Constants.ARROW_POSITIONING_MULTIPLIERS.DEFAULT.UP;
      var downArrowPositionMultiplier = config.alignNumberAndLabel ? constants_Constants.ARROW_POSITIONING_MULTIPLIERS.INLINE.DOWN : constants_Constants.ARROW_POSITIONING_MULTIPLIERS.DEFAULT.DOWN;
      var arrowHeightOffsetMultiplier = config.arrowDirection === constants_Constants.NEGATIVE_DIRECTION ? downArrowPositionMultiplier : upArrowPositionMultiplier;
      config.arrowDimension = {
        width: arrowDimension.width,
        height: arrowDimension.height,
        translateX: comparisonHorizontalOffset + arrowHorizontalOffset,
        translateY: availableArrowHeight * arrowHeightOffsetMultiplier + numberLineHeight * linePostion,
        SVG: arrowDimension.SVG
      };
      config.numberDimension = comparisons_objectSpread(comparisons_objectSpread({}, numberDimensionCommon), {}, {
        translateX: comparisonHorizontalOffset + numberHorizontalOffset,
        translateY: numberLineHeight * linePostion
      });
    } else {
      var numberVerticalOffset;
      if (config.verticalAlign === constants_Constants.VERTICAL_CHART_ALIGNMENTS.MIDDLE) {
        numberVerticalOffset = 0;
      } else if (config.verticalAlign === constants_Constants.VERTICAL_CHART_ALIGNMENTS.TOP) {
        numberVerticalOffset = numberDimension.height / 2;
      }
      numberVerticalOffset += numberLineHeight * linePostion;
      config.numberDimension = comparisons_objectSpread(comparisons_objectSpread({}, numberDimensionCommon), {}, {
        translateX: comparisonHorizontalOffset + numberHorizontalOffset,
        translateY: numberVerticalOffset
      });
    }
    labelDimension = upgraded_utils_estimateMaxTextDimensions(config.width, config.height * 0.5, config.label, config.experimentCacheContainer, numberDimension.fontSize, 0);
    var labelFontSize = config.fontSize || labelDimension.fontSize;
    var labelLineHeight = upgraded_utils_getLineHeight(labelFontSize, constants_Constants.COMPARISON_HEIGHT_PADDING);
    var labelHorizontalOffset = comparisonHorizontalOffset;
    var labelVerticalOffset = numberDimension.height;
    if (config.alignNumberAndLabel) {
      var leftContent = alignToArrow ? config.arrowDimension.width + arrowNumberPadding : 0;
      labelHorizontalOffset += leftContent + upgraded_utils_estimateWidthFromSize(numberFontSize, config.value + ' ');
      labelVerticalOffset = labelLineHeight * linePostion;
    }
    config.labelDimension = {
      translateX: labelHorizontalOffset,
      translateY: labelVerticalOffset,
      fontSize: labelFontSize
    };
  };
  var getArrowPadding = function getArrowPadding() {
    return config.alignNumberAndLabel ? constants_Constants.ARROW_NUMBER_PADDING.INLINE : constants_Constants.ARROW_NUMBER_PADDING.DEFAULT;
  };
  var getArrowDimension = function getArrowDimension(numberHeight) {
    var arrowHeightMultiplier = 1.75;
    var width = config.width * 0.3;
    var height = numberHeight || constants_Constants.DEFAULT_COMPARISON_ARROW_DIMENSION_SIZE;
    if (config.alignNumberAndLabel) {
      arrowHeightMultiplier = 1.5;
      width = height = constants_Constants.DEFAULT_COMPARISON_ARROW_DIMENSION_SIZE;
    }
    return createArrow(height, width, config.arrowDirection, arrowHeightMultiplier);
  };
  var layout = {
    calculate: calculate
  };
  upgraded_utils_exposeConfig(layout, config);
  return layout;
};
var Comparisons = function Comparisons() {
  var config = {
    comparisons: [],
    width: 0,
    height: 0,
    numberColor: constants_Constants.BLACK,
    labelColor: null,
    numberFontWeight: null,
    formatFunctions: [],
    animationDuration: 400,
    maxFontSize: 5000000,
    minFontSize: 0,
    fontSize: null,
    align: constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.CENTER,
    verticalAlign: constants_Constants.VERTICAL_CHART_ALIGNMENTS.MIDDLE,
    usedFontSize: null,
    alignNumberAndLabel: false,
    matchNumberAndLabel: false
  };
  var comparisonsLayout = ComparisonsLayout();
  var lifeCycle = new upgraded_utils_RenderLifeCycle();
  var dispatch = src_dispatch('elementClick');
  var comparisonsViz = function comparisonsViz(selection) {
    if (!config.alignNumberAndLabel && config.comparisons.length > 1) {
      console.error('Multiple comparisons are not supported if the number and label are not aligned on one line.');
      return;
    }
    lifeCycle.start();
    var hasArrowIcon = !!config.comparisons.find(function (_ref) {
      var direction = _ref.direction;
      return isValidArrowDirection(direction);
    });
    var wrappedLines = 0;
    selection.each(function (datum) {
      var _this = this;
      var maxComparisonTextWidth = calculateMaxComparisonTextWidth(config.comparisons, config.formatFunctions, config.fontSize, datum);
      config.comparisons.forEach(function (comparison, index) {
        var COMPARISON_INSTANCE_CLASS = 'comparison';
        var COMPARISON_CONTAINER_CLASS = 'comparison-container';
        var COMPARISON_BACKGROUND_CLASS = 'comparison-background';
        var NUMBER_CLASS = 'number-container';
        var LABEL_CLASS = 'label-container';
        var ARROW_CLASS = 'arrow-container';
        var EXPERIMENT_CLASS = 'experiment-container';
        var formatFunction = config.formatFunctions[index] || function (value) {
          return value;
        };
        var data = datum[index];
        var container = src_select(_this);
        var comparisonUniqueClass = COMPARISON_INSTANCE_CLASS + index;
        var comparisonContainer = upgraded_utils_createElementIfAbsent(container, [COMPARISON_CONTAINER_CLASS, comparisonUniqueClass]);
        var numberContainer = upgraded_utils_createElementIfAbsent(comparisonContainer, [NUMBER_CLASS, comparisonUniqueClass]);
        var labelContainer = upgraded_utils_createElementIfAbsent(comparisonContainer, [LABEL_CLASS, comparisonUniqueClass]);
        var arrowContainer = upgraded_utils_createElementIfAbsent(comparisonContainer, [ARROW_CLASS, comparisonUniqueClass]);
        var experimentContainer = upgraded_utils_createElementIfAbsent(comparisonContainer, [EXPERIMENT_CLASS, comparisonUniqueClass]);
        var textContainer = numberContainer.selectAll('text');
        var comparisonBackground = upgraded_utils_createElementIfAbsent(container, [COMPARISON_BACKGROUND_CLASS, comparisonUniqueClass], 'rect');
        comparisonsLayout.width(config.width).height(config.height).fontSize(config.fontSize).maxFontSize(config.maxFontSize).minFontSize(config.minFontSize).value(formatFunction(data)).label(comparison.label).align(config.align).verticalAlign(config.verticalAlign).arrowDirection(comparison.direction).position(index).previousWrappedLines(wrappedLines).alignNumberAndLabel(config.alignNumberAndLabel).experimentCacheContainer(experimentContainer).alignToArrow(hasArrowIcon).maxComparisonTextWidth(maxComparisonTextWidth).calculate();
        if (config.matchNumberAndLabel && comparisonsLayout.labelDimension()) {
          comparisonsLayout.maxFontSize(Math.min(comparisonsLayout.numberDimension().fontSize, comparisonsLayout.labelDimension().fontSize)).calculate();
        }
        textContainer = textContainer.data([data]);
        var textContainerMergeSelection = textContainer.enter().append('text').style('font-size', '0px').style('opacity', 0).merge(textContainer);
        if (upgraded_utils_validFontWeight(config.numberFontWeight)) {
          textContainerMergeSelection.style('font-weight', config.numberFontWeight);
        }
        var numberDimension = comparisonsLayout.numberDimension();
        var numberX = numberDimension.translateX;
        var numberY = numberDimension.translateY;
        var numberFontSize = numberDimension.fontSize;
        var baselineTextBeforeEdge = '1em';
        textContainerMergeSelection.style('opacity', 1).attr('fill', config.numberColor).style('fill', config.numberColor).style('font-size', "".concat(numberFontSize, "px")).attr('transform', "translate(".concat(numberX, ", ").concat(numberY, ") scale(1, 1)")).attr('text-anchor', numberDimension.anchor).attr('dy', baselineTextBeforeEdge).attr('click', function (d, i) {
          dispatch.call('elementClick', this, {
            data: d,
            index: i,
            color: src_select(this).style('fill'),
            event: event,
            element: this
          });
        }).text(formatFunction(data));
        var labelContainerEnterSelection = labelContainer.selectAll('text').data([comparison.label]).enter().append('text').attr('text-anchor', constants_Constants.ANCHOR_POSITIONS.START).attr('dy', baselineTextBeforeEdge);
        var labelColor = config.labelColor || config.numberColor;
        var labelDimension = comparisonsLayout.labelDimension();
        var labelX = config.alignNumberAndLabel ? numberX + js_nv.upgradedUtils.getTextWidth(textContainerMergeSelection) + upgraded_utils_estimateWidthFromSize(numberFontSize, ' ') : labelDimension.translateX;
        var labelY = labelDimension.translateY;
        var labelContainerText = labelContainerEnterSelection.merge(labelContainer).attr('text-anchor', constants_Constants.ANCHOR_POSITIONS.START).attr('transform', "translate(".concat(labelX, ", ").concat(labelY, "), scale(1, 1)")).style('font-size', "".concat(labelDimension.fontSize, "px")).style('fill', labelColor).attr('fill', labelColor).text(comparison.label);
        if (config.alignNumberAndLabel) {
          var firstLineWidth = config.width - labelX;
          var nextLineWidth = config.width - numberX;
          var nextLineOffset = numberX - labelX;
          labelContainerText.call(js_nv.upgradedUtils.wrapTicks, firstLineWidth, constants_Constants.NUMBER_COMPARISON_WRAPPED_LINES, constants_Constants.NUMBER_COMPARISON_TEXT_ANGLE, nextLineWidth, nextLineOffset);
          wrappedLines += Math.max(0, labelContainerText.selectAll('tspan').size() - 1);
        }
        if (comparison.direction) {
          var arrowContainerEnterSelection = arrowContainer.selectAll('path').data([data]).enter().append('path');
          var arrowColor = comparison.color || config.numberColor;
          var arrowDimension = comparisonsLayout.arrowDimension();
          arrowContainerEnterSelection.merge(arrowContainer).attr('width', arrowDimension.width).attr('height', arrowDimension.height).attr('transform', "translate(".concat(arrowDimension.translateX, ", ").concat(arrowDimension.translateY, ")")).style('fill', arrowColor).attr('fill', arrowColor).attr('d', arrowDimension.SVG);
        } else {
          arrowContainer.remove();
        }
        var currentComparisonSvgBoundingBox = comparisonContainer.node().getBBox();
        comparisonBackground.attr('x', currentComparisonSvgBoundingBox.x).attr('y', currentComparisonSvgBoundingBox.y).attr('width', currentComparisonSvgBoundingBox.width).attr('height', currentComparisonSvgBoundingBox.height).attr('opacity', 0);
        if (_.isFunction(comparison.tooltip)) {
          var showTooltip = function showTooltip() {
            if (tooltip.hidden() && comparison.onTooltipShow) {
              comparison.onTooltipShow();
            }
            var allComparisonsDomBoundingBox = container.node().getBoundingClientRect();
            var currentComparisonDomBoundingBox = comparisonContainer.node().getBoundingClientRect();
            var tooltipPosition = {
              left: allComparisonsDomBoundingBox.left + allComparisonsDomBoundingBox.width / 2,
              top: currentComparisonDomBoundingBox.bottom
            };
            tooltip.position(function () {
              return tooltipPosition;
            }).hidden(false);
          };
          var hideTooltip = function hideTooltip() {
            if (!tooltip.hidden() && comparison.onTooltipHide) {
              comparison.onTooltipHide();
            }
            tooltip.hidden(true);
          };
          var tooltip = upgradedNvTooltip().gravity('n').distance(constants_Constants.TOOLTIP_DISTANCE).data({
            series: {}
          }).contentGenerator(upgradedWrapWithDarkDialog(comparison.tooltip));
          comparisonBackground.attr('class', 'focusable-comparison').on('mouseover', function () {
            showTooltip();
            if (_.isFunction(comparison.onMouseOver)) {
              comparison.onMouseOver();
            }
          }).on('mouseout', function () {
            hideTooltip();
            if (_.isFunction(comparison.onMouseOut)) {
              comparison.onMouseOut();
            }
          }).on('focus', showTooltip).on('blur', hideTooltip).on('keydown', function (event) {
            if (event.key === HIDE_TOOLTIP_KEY) {
              hideTooltip();
            }
          }).attr('tabIndex', 0).attr('focusable', true);
        }
        config.usedFontSize = comparisonsLayout.numberDimension().fontSize;
      }, this);
    });
    lifeCycle.dispatchOnCompletion();
  };
  upgraded_utils_exposeConfig(comparisonsViz, config);
  comparisonsViz.lifeCycle = lifeCycle.dispatch;
  comparisonsViz.dispatch = dispatch;
  return comparisonsViz;
};
;// ./src/js/viz/config/comparisons_config.js







function comparisons_config_typeof(o) { "@babel/helpers - typeof"; return comparisons_config_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, comparisons_config_typeof(o); }
function comparisons_config_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function comparisons_config_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? comparisons_config_ownKeys(Object(t), !0).forEach(function (r) { comparisons_config_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : comparisons_config_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function comparisons_config_defineProperty(e, r, t) { return (r = comparisons_config_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function comparisons_config_toPropertyKey(t) { var i = comparisons_config_toPrimitive(t, "string"); return "symbol" == comparisons_config_typeof(i) ? i : i + ""; }
function comparisons_config_toPrimitive(t, r) { if ("object" != comparisons_config_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != comparisons_config_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var COMPARISONS = 'comparisons';
var ComparisonConfig = {
  alignComparisonsLeft: function alignComparisonsLeft() {
    this.comparisonAlignment = constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.LEFT;
    return this;
  },
  createComparisonRegionInfo: function createComparisonRegionInfo(data) {
    var _this = this;
    if (!this.comparisons || !this.comparisons.length) {
      return;
    }
    var comparisons = this.comparisons.map(function (comparison) {
      return _this.getComparisonSettings(comparison, data);
    }).filter(function (comparisonSettings) {
      return !!comparisonSettings;
    });
    var formatFunctions = comparisons.map(function (_ref) {
      var direction = _ref.direction,
        formatFunction = _ref.formatFunction;
      return _this.getComparisonFormatFunction(direction, formatFunction);
    });
    var comparisonValues = comparisons.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    });
    var comparisonElement = Comparisons();
    comparisonElement.numberColor(constants_Constants.NUMBER_DEFAULT).labelColor(constants_Constants.LABEL_GRAY).formatFunctions(formatFunctions).numberFontWeight(constants_Constants.BOLD_FONT_WEIGHT).fontSize(this.comparisonFontSize || constants_Constants.COMPARISON_FONT_SIZE).align(this.comparisonAlignment || constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.CENTER).comparisons(comparisons).alignNumberAndLabel(true);
    return {
      elementClass: COMPARISONS,
      component: comparisonElement,
      data: comparisonValues
    };
  },
  getComparisonFormatFunction: function getComparisonFormatFunction(direction, formatFunction) {
    var func = formatFunction || this.comparisonFormatFunction || this.formatFunction || function (value) {
      return value;
    };
    if (direction && this.includeDifferenceIdentifier) {
      var identifier = direction === constants_Constants.POSITIVE_DIRECTION ? '+' : '-';
      return function (value) {
        return identifier + func(value);
      };
    } else {
      return func;
    }
  },
  getComparisonSettings: function getComparisonSettings(comparison, data) {
    if (!comparison || data === undefined || data === null || comparison.value === undefined) {
      return undefined;
    }
    if (comparison.value === null) {
      return comparisons_config_objectSpread(comparisons_config_objectSpread({}, comparison), {}, {
        color: this.getTrendColor()
      });
    }
    var difference = data - comparison.value;
    var color = this.getTrendColor(difference);
    var direction = this.getDifference(difference);
    return comparisons_config_objectSpread(comparisons_config_objectSpread({}, comparison), {}, {
      value: Math.abs(difference),
      color: color,
      direction: direction
    });
  },
  getDifference: function getDifference(difference) {
    return difference && (difference > 0 ? constants_Constants.POSITIVE_DIRECTION : constants_Constants.NEGATIVE_DIRECTION);
  },
  getTrendColor: function getTrendColor(difference) {
    if (difference > 0) {
      return this.increaseColor || constants_Constants.POSITIVE_GREEN;
    }
    if (difference < 0) {
      return this.decreaseColor || constants_Constants.NEGATIVE_RED;
    }
    return this.noChangeColor || constants_Constants.DULL_GREY;
  },
  setIncreaseColor: function setIncreaseColor(val) {
    this.increaseColor = val;
    return this;
  },
  setDecreaseColor: function setDecreaseColor(val) {
    this.decreaseColor = val;
    return this;
  },
  setNoChangeColor: function setNoChangeColor(val) {
    this.noChangeColor = val;
    return this;
  },
  setComparisonFormatFunction: function setComparisonFormatFunction(formatFunction) {
    this.comparisonFormatFunction = formatFunction;
    return this;
  },
  setComparisons: function setComparisons(comparisons) {
    this.comparisons = comparisons;
    return this;
  },
  setComparisonFontSize: function setComparisonFontSize(size) {
    this.comparisonFontSize = size;
    return this;
  },
  shouldIncludeDifferenceIdentifier: function shouldIncludeDifferenceIdentifier(shouldInclude) {
    this.includeDifferenceIdentifier = shouldInclude;
    return this;
  }
};
;// ./src/js/viz/d3/layouts/multi_component_layout.js


var renderEndEvent = 'renderEnd';
var MultiComponentLayout = {
  getHostedRegions: function getHostedRegions() {
    return [];
  },
  getHostedRegionsWithRenderEnds: function getHostedRegionsWithRenderEnds(postRender) {
    var updateCount = 0;
    var hostedRegions = this.getHostedRegions();
    _.forEach(hostedRegions, function (regionInfo) {
      var _regionInfo$component;
      if (regionInfo !== null && regionInfo !== void 0 && (_regionInfo$component = regionInfo.component) !== null && _regionInfo$component !== void 0 && _regionInfo$component.lifeCycle) {
        updateCount += 1;
        regionInfo.component.lifeCycle.on(renderEndEvent, function () {
          updateCount -= 1;
          !updateCount && _.isFunction(postRender) && postRender();
        });
      }
    });
    return hostedRegions;
  },
  renderHostedRegions: function renderHostedRegions(container, options) {
    var _this = this;
    var hostedRegionsWithRenderEnd = this.getHostedRegionsWithRenderEnds(options.postRender);
    hostedRegionsWithRenderEnd.forEach(function (regionInfo) {
      _this.renderComponentWithLayout(regionInfo, options, container);
    });
  },
  renderComponentWithLayout: function renderComponentWithLayout(regionInfo, options, container) {
    if (!regionInfo || !options || !container) {
      return;
    }
    var offsets = regionInfo.offsets,
      component = regionInfo.component,
      data = regionInfo.data,
      elementClass = regionInfo.elementClass,
      render = regionInfo.render;
    var width = options.width * (offsets.width ? offsets.width : 1);
    var height = options.height * (offsets.height ? offsets.height : 1);
    var x = offsets.x ? offsets.x * options.width : 0;
    var y = offsets.y ? offsets.y * options.height : 0;
    component.width(width).height(height);
    if (elementClass === 'gauge') {
      container.datum(data).call(render);
    } else {
      var element = utils_createElementIfAbsent(container, elementClass);
      element.attr('transform', "translate(".concat(x, ", ").concat(y, ")"));
      element.datum(data).call(component);
    }
  }
};
;// ./src/js/viz/d3/charts/dynamic_gauge_chart.js







function dynamic_gauge_chart_typeof(o) { "@babel/helpers - typeof"; return dynamic_gauge_chart_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, dynamic_gauge_chart_typeof(o); }
function dynamic_gauge_chart_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function dynamic_gauge_chart_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? dynamic_gauge_chart_ownKeys(Object(t), !0).forEach(function (r) { dynamic_gauge_chart_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dynamic_gauge_chart_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function dynamic_gauge_chart_defineProperty(e, r, t) { return (r = dynamic_gauge_chart_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function dynamic_gauge_chart_toPropertyKey(t) { var i = dynamic_gauge_chart_toPrimitive(t, "string"); return "symbol" == dynamic_gauge_chart_typeof(i) ? i : i + ""; }
function dynamic_gauge_chart_toPrimitive(t, r) { if ("object" != dynamic_gauge_chart_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != dynamic_gauge_chart_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var GaugeConfig = {
  setData: function setData(data) {
    this.data = data;
    return this;
  },
  setFieldLabelFontSize: function setFieldLabelFontSize(fontSize) {
    this.fieldLabelFontSize = fontSize;
    return this;
  },
  setFormatFunction: function setFormatFunction(formatFunction) {
    this.formatFunction = formatFunction;
    return this;
  },
  setRangeConfig: function setRangeConfig(rangeConfig) {
    this.rangeConfig = rangeConfig;
    return this;
  },
  setLabelPadding: function setLabelPadding(padLength) {
    this.labelPadding = padLength;
    return this;
  },
  setThresholdLabelFormat: function setThresholdLabelFormat(formatFunction) {
    this.thresholdLabelFormat = formatFunction;
    return this;
  },
  setShowStaticThresholds: function setShowStaticThresholds(shouldShow) {
    this.showStaticThresholds = shouldShow;
    return this;
  },
  setShowThresholdLabels: function setShowThresholdLabels(shouldShow) {
    this.showThresholdLabels = shouldShow;
    return this;
  },
  setValueFormat: function setValueFormat(formatFunction) {
    this.valueFormat = formatFunction;
    return this;
  },
  setThresholdLabelFontSize: function setThresholdLabelFontSize(fontSize) {
    this.thresholdLabelFontSize = fontSize;
    return this;
  },
  setThresholdTickWidth: function setThresholdTickWidth(width) {
    this.thresholdTickWidth = width;
    return this;
  }
};
var DynamicGaugeChart = UpgradedCore.extend(GaugeConfig).extend(MultiComponentLayout).extend(MarginConfig).extend(AnimationConfig).extend(ComparisonConfig).extend({
  render: function render(postRender) {
    this.wrapContainer();
    this.renderHostedRegions(this.getContainer(), {
      width: this.getContainerWidth(),
      height: this.getContainerHeight(),
      postRender: postRender
    });
    return this;
  },
  getHostedRegions: function getHostedRegions() {
    var gaugeRegion = this._createGaugeRegionInfo();
    var regions = [gaugeRegion];
    var comparisonRegionInfo = this.createComparisonRegionInfo(this.data ? this.data.value : null);
    if (comparisonRegionInfo) {
      gaugeRegion.offsets.height = 0.7;
      regions.push(dynamic_gauge_chart_objectSpread(dynamic_gauge_chart_objectSpread({}, comparisonRegionInfo), {}, {
        offsets: {
          y: 0.7,
          width: 1,
          height: 0.3
        }
      }));
    }
    return regions;
  },
  _createGaugeRegionInfo: function _createGaugeRegionInfo() {
    var chart = this._getChart();
    this._configureChart();
    var mergedData = dynamic_gauge_chart_objectSpread(dynamic_gauge_chart_objectSpread({}, this.data), {}, {
      rangeConfig: this.rangeConfig
    });
    return {
      elementClass: 'gauge',
      component: chart,
      data: mergedData,
      render: chart.render,
      offsets: {
        width: 1,
        height: 1
      }
    };
  },
  _getChart: function _getChart() {
    if (!this.chart) {
      this._createGauge();
    }
    return this.chart;
  },
  _createGauge: function _createGauge() {
    this.chart = new RoundGauge();
  },
  _configureChart: function _configureChart() {
    this.chart.margins(this._margin).animationDuration(this._animationDuration);
    if (this.valueFormat) {
      this.chart.valueFormat(this.valueFormat);
    }
    if (this.thresholdTickWidth !== undefined) {
      this.chart.thresholdTickWidth(this.thresholdTickWidth);
    }
    if (this.fieldLabelFontSize !== undefined) {
      this.chart.fieldLabelFontSize(this.fieldLabelFontSize);
    }
    if (this.thresholdLabelFormat) {
      this.chart.thresholdLabelFormat(this.thresholdLabelFormat);
    }
    if (this.showThresholdLabels !== undefined) {
      this.chart.showThresholdLabels(this.showThresholdLabels);
    }
    if (this.labelPadding !== undefined) {
      this.chart.labelPadding(this.labelPadding);
    }
    if (this.thresholdLabelFontSize !== undefined) {
      this.chart.thresholdLabelFontSize(this.thresholdLabelFontSize);
    }
    if (this.showStaticThresholds !== undefined) {
      this.chart.showStaticThresholds(this.showStaticThresholds);
    }
  },
  _margin: {
    top: 20,
    bottom: 20,
    left: 30,
    right: 30
  },
  resize: function resize() {
    if (this.chart) {
      UpgradedCore.prototype.resize.apply(this, arguments);
    }
  }
}, {
  Name: 'DynamicGauge',
  DataDimensions: '1'
});
;// ./src/js/viz/d3/components/number_viz.js







var NumberLayout = function NumberLayout() {
  var config = {
      width: 0,
      height: 0,
      value: undefined,
      experimentCacheContainer: null,
      maxFontSize: 50000,
      minFontSize: 0,
      usedHeight: 0,
      usedWidth: 0,
      numberDimension: null,
      align: null,
      verticalAlign: null
    },
    PLACEHOLDER_TEXT = '00.00',
    normalizeValue = function normalizeValue() {
      return PLACEHOLDER_TEXT;
    },
    calculate = function calculate() {
      config.numberDimension = {};
      var numberDimension = upgraded_utils_estimateMaxTextDimensions(config.width, config.height, config.value, config.experimentCacheContainer, Math.min(config.maxFontSize, upgraded_utils_estimateFontSize(config.width, config.height, normalizeValue(config.value))), config.minFontSize);
      config.usedHeight = 0.8 * numberDimension.height;
      config.usedWidth = constants_Constants.TEXT_WIDTH_PROPORTION * numberDimension.width;
      var numberHorizontalOffset;
      var numberVerticalOffset;
      if (config.verticalAlign === constants_Constants.VERTICAL_CHART_ALIGNMENTS.MIDDLE) {
        numberVerticalOffset = config.height / 2;
      } else if (config.verticalAlign === constants_Constants.VERTICAL_CHART_ALIGNMENTS.TOP) {
        numberVerticalOffset = constants_Constants.TOP_PADDING + numberDimension.height / 2;
      }
      if (config.align === constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.CENTER) {
        numberHorizontalOffset = config.width / 2;
      } else if (config.align === constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.LEFT) {
        numberHorizontalOffset = 0;
      }
      config.numberDimension = {
        anchor: config.align === constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.LEFT ? constants_Constants.ANCHOR_POSITIONS.START : constants_Constants.ANCHOR_POSITIONS.MIDDLE,
        translate: "translate(".concat(numberHorizontalOffset, ",").concat(numberVerticalOffset, ")"),
        fontSize: numberDimension.fontSize
      };
    },
    layout = {
      calculate: calculate
    };
  upgraded_utils_exposeConfig(layout, config);
  return layout;
};
var NumberViz = function NumberViz() {
  var config = {
      width: 0,
      height: 0,
      numberColor: constants_Constants.BLACK,
      formatFunction: (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).identity,
      animationDuration: 400,
      maxFontSize: 5000000,
      minFontSize: 0,
      numberFontWeight: null,
      align: constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.CENTER,
      verticalAlign: constants_Constants.VERTICAL_CHART_ALIGNMENTS.MIDDLE,
      usedWidth: null,
      usedHeight: null,
      usedFontSize: null
    },
    numberLayout = NumberLayout(),
    lifeCycle = new upgraded_utils_RenderLifeCycle(),
    dispatch = src_dispatch('elementClick');
  var numberViz = function numberViz(selection) {
    var _config$formatFunctio;
    lifeCycle.start();
    config.formatFunction = (_config$formatFunctio = config.formatFunction) !== null && _config$formatFunctio !== void 0 ? _config$formatFunctio : (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).identity;
    selection.each(function (data) {
      var NUMBER_CLASS = 'number-container';
      var EXPERIMENT_CLASS = 'experiment-container';
      var container = src_select(this),
        numberContainer = upgraded_utils_createElementIfAbsent(container, NUMBER_CLASS),
        experimentContainer = upgraded_utils_createElementIfAbsent(container, EXPERIMENT_CLASS),
        textContainer = numberContainer.selectAll('text'),
        startValue = textContainer.data() && textContainer.data()[0] || 0;
      numberLayout.width(config.width).height(config.height).maxFontSize(config.maxFontSize).minFontSize(config.minFontSize).value(config.formatFunction(data)).align(config.align).verticalAlign(config.verticalAlign).experimentCacheContainer(experimentContainer).calculate();
      textContainer = textContainer.data([data]);
      var textContainerEnter = textContainer.enter().append('text').style('font-size', '0px').style('opacity', 0).text(config.formatFunction(startValue));
      if (upgraded_utils_validFontWeight(config.numberFontWeight)) {
        textContainerEnter.merge(textContainer).style('font-weight', config.numberFontWeight);
      }
      var baselineMiddle = '0.27em';
      textContainerEnter.merge(textContainer).style('opacity', 1).attr('fill', config.numberColor).style('fill', config.numberColor).style('font-size', numberLayout.numberDimension().fontSize + 'px').attr('transform', numberLayout.numberDimension().translate + ' scale(1, 1)').attr('text-anchor', numberLayout.numberDimension().anchor).attr('dy', baselineMiddle).on('click', function (d, i) {
        dispatchOnClick(dispatch, this, d, i, event);
      }).transition().duration(config.animationDuration).tween('number', function (data) {
        return tweenTextUpdate(data, startValue, config, this);
      }).call(lifeCycle.watch);
      config.usedWidth = numberLayout.usedWidth();
      config.usedHeight = numberLayout.usedHeight();
      config.usedFontSize = numberLayout.numberDimension().fontSize;
    });
    lifeCycle.dispatchOnCompletion();
  };
  upgraded_utils_exposeConfig(numberViz, config);
  numberViz.lifeCycle = lifeCycle.dispatch;
  numberViz.dispatch = dispatch;
  return numberViz;
};
function dispatchOnClick(dispatch, element, d, i, event) {
  dispatch.call('elementClick', element, {
    data: d,
    index: i,
    color: src_select(element).style('fill'),
    event: event,
    element: element
  });
}
function tweenTextUpdate(data, startValue, config, element) {
  var valueInterpolator = src_number(startValue, data);
  return function (t) {
    element.textContent = config.formatFunction(valueInterpolator(t));
  };
}
;// ./src/js/viz/components/line.js








var Line = function Line() {
  var config = {
    xScale: null,
    yScale: null,
    getX: function getX(d) {
      return d.x;
    },
    getY: function getY(d) {
      return d.y;
    },
    width: 400,
    height: 400,
    interpolate: monotoneX,
    colorScheme: ordinal(category10),
    getKey: function getKey(d) {
      return d.key;
    }
  };
  var line = function line(selection) {
    selection.each(function (data) {
      var container = src_select(this),
        lineContainer,
        lineGenerator,
        lines,
        xValues,
        yValues,
        xScale = config.xScale,
        yScale = config.yScale;
      var containerMergeSelection = container.selectAll('.dq-line').data([data]).enter().append('g').attr('class', 'dq-line').merge(container);
      lineContainer = containerMergeSelection.selectAll('.dq-line');
      if (!xScale) {
        xValues = getXValues(data, config);
        xScale = linear_linear().domain(src_extent(xValues)).range([0, config.width]);
      }
      if (!yScale) {
        yValues = getYValues(data, config);
        yScale = linear_linear().domain(src_extent(yValues)).range([config.height, 0]);
      }
      lineGenerator = src_line().curve(config.interpolate).x(function (d, i) {
        return getXLineGenerator(d, i, xScale, config);
      }).y(function (d, i) {
        return getYLineGenerator(d, i, yScale, config);
      });
      lines = lineContainer.selectAll('path').data(data.filter(function (d) {
        return !d.disabled;
      }));
      var linesMergeSelection = lines.enter().append('path');
      lines.exit().remove();
      linesMergeSelection.style('stroke', function (d) {
        return line_getStroke(d, config);
      }).attr('d', function (d) {
        return getLineGenerator(d, lineGenerator);
      });
    });
  };
  exposeConfig(line, config);
  return line;
};
function line_getStroke(d, config) {
  return d.color || config.colorScheme(config.getKey(d));
}
function getLineGenerator(d, lineGenerator) {
  return lineGenerator(d.values);
}
function getXValues(data, config) {
  var xValues = data.map(function (series) {
    return series.values.map(function (entry, index) {
      return config.getX(entry, index);
    });
  });
  return merge(xValues);
}
function getYValues(data, config) {
  var yValues = data.map(function (series) {
    return series.values.map(function (entry, index) {
      return config.getY(entry, index);
    });
  });
  return merge(yValues);
}
function getXLineGenerator(d, i, xScale, config) {
  return xScale(config.getX(d, i));
}
function getYLineGenerator(d, i, yScale, config) {
  return yScale(config.getY(d, i));
}
;// ./src/js/viz/components/background.js


var Background = function Background() {
  var config = {
      width: 0,
      height: 0
    },
    lifeCycle = new upgraded_utils_RenderLifeCycle();
  var background = function background(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var container = src_select(this),
        rectangleContainer = upgraded_utils_createElementIfAbsent(container, 'background', 'rect');
      rectangleContainer.attr('width', config.width).attr('height', config.height).style('fill', data || 'none');
    });
    lifeCycle.dispatchOnCompletion();
  };
  upgraded_utils_exposeConfig(background, config);
  background.lifeCycle = lifeCycle.dispatch;
  return background;
};
;// ./src/js/viz/d3/charts/number_chart.js














var TREND_NUMBER_INDEX = 0;
var NUMBER_COMPONENT_INDEX = 1;
var NUMBER_CONTAINER_CLASS = 'number-container';
var BACKGROUND = 'background';
var number_chart_COMPARISONS = 'comparisons';
var NUMBER_CHART = 'number';
var TREND_LINE = 'trendLine';
var TREND_NUMBER = 'trendNumber';
var AUXILIARY_REGIONS = [TREND_NUMBER, number_chart_COMPARISONS];
var FULL_REGION_RATIO = 1;
var NUMBER_REGION_RATIO = 0.85;
var AUXILIARY_COMPONENT_RATIO = 0.15;
var NumberConfig = {
  setBackgroundColor: function setBackgroundColor(val) {
    this.backgroundColor = val;
    return this;
  },
  setTrend: function setTrend(trend, trendLabel) {
    this.trend = trend;
    this.trendLabel = trendLabel;
    return this;
  },
  setNumberColor: function setNumberColor(numberColor) {
    this.numberColor = numberColor;
    return this;
  },
  setFormatFunction: function setFormatFunction(formatFunction) {
    this.formatFunction = formatFunction;
    return this;
  },
  setTrendFormatFunction: function setTrendFormatFunction(formatFunction) {
    this.trendFormatFunction = formatFunction;
    return this;
  },
  setValue: function setValue(val) {
    this.val = val;
    return this;
  },
  alignNumberLeft: function alignNumberLeft() {
    this.numberAlignment = constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.LEFT;
    return this;
  },
  alignTop: function alignTop() {
    this.verticalAlignment = constants_Constants.VERTICAL_CHART_ALIGNMENTS.TOP;
    return this;
  },
  alignTrendLeft: function alignTrendLeft() {
    this.trendAlignment = constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.LEFT;
    return this;
  },
  setMaxNumberSize: function setMaxNumberSize(size) {
    this.maxNumberSize = size;
    return this;
  },
  setMinNumberSize: function setMinNumberSize(size) {
    this.minNumberSize = size;
    return this;
  },
  setNumberFontWeight: function setNumberFontWeight(weight) {
    this.numberFontWeight = weight;
    return this;
  }
};
var NumberChart = UpgradedCore.extend(NumberConfig).extend(MultiComponentLayout).extend(ComparisonConfig).extend(EventConfig).extend({
  initialize: function initialize() {
    return UpgradedCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.renderHostedRegions(this.getContainer(), {
      width: this.getContainerWidth(),
      height: this.getContainerHeight(),
      postRender: postRender
    });
    return this;
  },
  renderHostedRegions: function renderHostedRegions(container, options) {
    var _this = this;
    this.clearComparisonsFromContainer(container);
    var hostedRegionsWithRenderEnd = this.getHostedRegionsWithRenderEnds(options.postRender);
    var numberComponent = hostedRegionsWithRenderEnd[NUMBER_COMPONENT_INDEX].component;
    hostedRegionsWithRenderEnd.forEach(function (regionInfo) {
      if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().includes(AUXILIARY_REGIONS, regionInfo.elementClass)) {
        _this.addAuxiliaryOffsets(regionInfo, numberComponent, options, container);
      }
      _this.renderComponentWithLayout(regionInfo, options, container);
    });
  },
  getHostedRegions: function getHostedRegions() {
    var backgroundRegion = this.createBackgroundRegionInfo();
    var numberRegion = this.createNumberRegionInfo();
    var regions = [backgroundRegion, numberRegion];
    var trendRegion = this.createTrendRegionInfo();
    var comparisonRegion = this.createComparisonRegionInfo(this.val);
    if (trendRegion) {
      numberRegion.offsets.height = NUMBER_REGION_RATIO;
      regions.push(trendRegion);
    } else if (comparisonRegion) {
      numberRegion.offsets.height = NUMBER_REGION_RATIO;
      regions.push(comparisonRegion);
    }
    return regions;
  },
  clearComparisonsFromContainer: function clearComparisonsFromContainer(container) {
    container.selectAll('.comparisons').remove();
  },
  createBackgroundRegionInfo: function createBackgroundRegionInfo() {
    return {
      elementClass: BACKGROUND,
      component: Background(),
      data: this.getBackgroundColor(),
      offsets: {
        width: FULL_REGION_RATIO,
        height: FULL_REGION_RATIO
      }
    };
  },
  createNumberRegionInfo: function createNumberRegionInfo() {
    var numberViz = NumberViz();
    numberViz.numberColor(this.getNumberColor()).formatFunction(this.formatFunction).align(this.numberAlignment || constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.CENTER).verticalAlign(this.verticalAlignment || constants_Constants.VERTICAL_CHART_ALIGNMENTS.MIDDLE).numberFontWeight(this.numberFontWeight);
    if (this.validMaxAndMinSizes()) {
      this.configureMaxNumberSize(numberViz);
      this.configureMinNumberSize(numberViz);
    } else {
      console.error('Max number size must be greater than min number size');
    }
    external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(this._eventHandlers, function (handler, event) {
      numberViz.dispatch.on(event, handler);
    });
    return {
      elementClass: NUMBER_CHART,
      component: numberViz,
      data: this.val || '',
      offsets: {
        width: FULL_REGION_RATIO,
        height: FULL_REGION_RATIO
      }
    };
  },
  validMaxAndMinSizes: function validMaxAndMinSizes() {
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(this.maxNumberSize) && external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(this.minNumberSize)) {
      return this.maxNumberSize >= this.minNumberSize;
    }
    return true;
  },
  configureMaxNumberSize: function configureMaxNumberSize(numberViz) {
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(this.maxNumberSize)) {
      numberViz.maxFontSize(this.maxNumberSize);
    }
  },
  configureMinNumberSize: function configureMinNumberSize(numberViz) {
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFinite(this.minNumberSize)) {
      numberViz.minFontSize(this.minNumberSize);
    }
  },
  createTrendRegionInfo: function createTrendRegionInfo() {
    var trend = this.getTrend(),
      trendElement;
    if (!trend) {
      return;
    }
    if (trend.isNumber) {
      trendElement = Comparisons();
      trendElement.comparisons([trend]).numberColor(trend.color).formatFunctions([this.trendFormatFunction || this.formatFunction || function (value) {
        return value;
      }]).matchNumberAndLabel(!trend.value).align(this.trendAlignment || constants_Constants.HORIZONTAL_CHART_ALIGNMENTS.CENTER);
      return {
        elementClass: TREND_NUMBER,
        component: trendElement,
        data: [trend.value]
      };
    } else {
      trendElement = Line();
      trendElement.colorScheme(function () {
        return trend.color;
      }).getX(function (d, i) {
        return i;
      }).getY(function (d) {
        return d;
      });
      return {
        elementClass: TREND_LINE,
        component: trendElement,
        data: [{
          values: trend.val
        }],
        offsets: {
          width: FULL_REGION_RATIO,
          height: AUXILIARY_COMPONENT_RATIO,
          y: NUMBER_REGION_RATIO
        }
      };
    }
  },
  getTrendColor: function getTrendColor(difference) {
    if (difference > 0) {
      return this.increaseColor || constants_Constants.POSITIVE_GREEN;
    }
    if (difference < 0) {
      return this.decreaseColor || constants_Constants.NEGATIVE_RED;
    }
    return this.noChangeColor || constants_Constants.DULL_GREY;
  },
  getTrend: function getTrend() {
    if (!this.trend || this.val === null || this.val === undefined) {
      return;
    }
    if (this.trend.length === 1) {
      var trendValue = this.trend[TREND_NUMBER_INDEX];
      if (trendValue === null) {
        return {
          isNumber: true,
          value: null,
          label: this.trendLabel,
          color: this.getTrendColor()
        };
      }
      var difference = this.val - trendValue,
        color = this.getTrendColor(difference),
        direction = difference && (difference > 0 ? constants_Constants.POSITIVE_DIRECTION : constants_Constants.NEGATIVE_DIRECTION);
      return {
        isNumber: true,
        value: Math.abs(difference),
        label: this.trendLabel,
        color: color,
        direction: direction
      };
    } else if (this.trend.length > 1) {
      this.trend.push(this.val);
      return {
        isLine: true,
        color: constants_Constants.POSITIVE_GREEN,
        val: this.trend
      };
    }
  },
  getBackgroundColor: function getBackgroundColor() {
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isString(this.backgroundColor)) {
      return this.backgroundColor;
    } else if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(this.backgroundColor)) {
      return upgraded_utils_thresholdColor(this.backgroundColor, this.val);
    } else if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(this.backgroundColor)) {
      return this.backgroundColor();
    }
  },
  getNumberColor: function getNumberColor() {
    var color = constants_Constants.BLACK;
    if (this.numberColor === 'auto') {
      color = upgraded_utils_getColorLuminance(this.getBackgroundColor() || constants_Constants.WHITE) > 0.5 ? constants_Constants.BLACK : constants_Constants.WHITE;
    } else if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isString(this.numberColor)) {
      color = this.numberColor;
    } else if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(this.numberColor)) {
      color = upgraded_utils_thresholdColor(this.numberColor, this.val);
    } else if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(this.numberColor)) {
      color = this.numberColor();
    }
    return color;
  },
  getTrendNumberOffsets: function getTrendNumberOffsets(numberComponent, trendComponent, options, container) {
    var numberHeight = this.getNumberHeight(numberComponent, options);
    var verticalOffset = (numberHeight + numberComponent.usedHeight()) / 2;
    var numberTextElement = container.select(".".concat(NUMBER_CONTAINER_CLASS)).select('text');
    var availableTrendHeight = options.height + (options.numberHeight - numberComponent.usedHeight()) / 2;
    var estimatedTrendFontSize = this.getEstimatedFontSize(availableTrendHeight, numberComponent.usedFontSize());
    var trendLabel = trendComponent.comparisons()[TREND_NUMBER_INDEX].label;
    var estimatedTrendTextWidth = this.getEstimatedTextWidth(upgraded_utils_estimateWidthFromSize(estimatedTrendFontSize, trendLabel));
    if (this.trendLengthExceedsNumberLength(options, numberComponent, trendLabel, estimatedTrendTextWidth)) {
      var numberHorizontalOffset = getHorizontalOffset(numberComponent.align(), options.width, estimatedTrendTextWidth);
      var trendHorizontalOffset = getHorizontalOffset(trendComponent.align(), options.width, estimatedTrendTextWidth);
      var numberVerticalOffset = numberHeight / 2;
      numberTextElement.attr('text-anchor', 'start');
      numberTextElement.attr('transform', "translate(".concat(numberHorizontalOffset, ",").concat(numberVerticalOffset, ") scale(1,1)"));
      trendComponent.maxFontSize(numberComponent.usedFontSize());
      return {
        width: estimatedTrendTextWidth / options.containerWidth,
        height: availableTrendHeight / options.containerHeight,
        x: trendHorizontalOffset / options.containerWidth,
        y: verticalOffset / options.containerHeight
      };
    } else {
      var _trendHorizontalOffset = getHorizontalOffset(trendComponent.align(), options.numberWidth, numberComponent.usedWidth());
      return {
        width: numberComponent.usedWidth() / options.containerWidth,
        height: availableTrendHeight / options.containerHeight,
        x: _trendHorizontalOffset / options.containerWidth,
        y: verticalOffset / options.containerHeight
      };
    }
  },
  getComparisonOffsets: function getComparisonOffsets(numberComponent, comparisonComponent, options) {
    var numberHeight = this.getNumberHeight(numberComponent, options);
    var numberVerticalOffset = numberHeight / 2;
    var COMPARISON_HEIGHT_PADDING = 6;
    var comparisonLineHeight = upgraded_utils_getLineHeight(comparisonComponent.fontSize(), COMPARISON_HEIGHT_PADDING);
    var comparisonVerticalOffset = numberVerticalOffset + numberComponent.usedFontSize() / 2 + comparisonLineHeight / 2;
    return {
      width: FULL_REGION_RATIO,
      height: (options.containerHeight - numberHeight) / options.containerHeight,
      y: comparisonVerticalOffset / options.containerHeight
    };
  },
  addAuxiliaryOffsets: function addAuxiliaryOffsets(regionInfo, numberComponent, options, container) {
    var offsetOptions = {
      width: options.width,
      height: options.height * AUXILIARY_COMPONENT_RATIO,
      numberWidth: options.width,
      numberHeight: options.height * NUMBER_REGION_RATIO,
      containerWidth: options.width,
      containerHeight: options.height
    };
    if (regionInfo.elementClass === TREND_NUMBER) {
      regionInfo.offsets = this.getTrendNumberOffsets(numberComponent, regionInfo.component, offsetOptions, container);
    } else if (regionInfo.elementClass === number_chart_COMPARISONS) {
      regionInfo.offsets = this.getComparisonOffsets(numberComponent, regionInfo.component, offsetOptions);
    }
  },
  getNumberHeight: function getNumberHeight(component, options) {
    if (component.verticalAlign() === constants_Constants.VERTICAL_CHART_ALIGNMENTS.TOP) {
      return constants_Constants.TOP_PADDING * 2 + component.usedFontSize();
    }
    return options.numberHeight;
  },
  trendLengthExceedsNumberLength: function trendLengthExceedsNumberLength(options, numberComponent, trendLabel, estimatedTrendTextWidth) {
    return options.width * 0.7 > numberComponent.usedWidth() && numberComponent.usedWidth() < 150 && trendLabel && estimatedTrendTextWidth > numberComponent.usedWidth();
  },
  getEstimatedFontSize: function getEstimatedFontSize(availableHeight, fontSize) {
    return Math.min(availableHeight * 0.45, fontSize - 4);
  },
  getEstimatedTextWidth: function getEstimatedTextWidth(contentWidth) {
    return Math.min(contentWidth, 150);
  }
}, {
  Name: 'Number',
  DataDimensions: '1'
});
;// ./node_modules/d3-shape/src/descending.js
/* harmony default export */ function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

;// ./node_modules/d3-shape/src/identity.js
/* harmony default export */ function d3_shape_src_identity(d) {
  return d;
}

;// ./node_modules/d3-shape/src/pie.js






/* harmony default export */ function src_pie() {
  var value = d3_shape_src_identity,
      sortValues = descending,
      sort = null,
      startAngle = src_constant(0),
      endAngle = src_constant(tau),
      padAngle = src_constant(0);

  function pie(data) {
    var i,
        n = (data = d3_shape_src_array(data)).length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : src_constant(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : src_constant(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : src_constant(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : src_constant(+_), pie) : padAngle;
  };

  return pie;
}

;// ./src/js/viz/d3/components/pie.js










function pie_slicedToArray(r, e) { return pie_arrayWithHoles(r) || pie_iterableToArrayLimit(r, e) || pie_unsupportedIterableToArray(r, e) || pie_nonIterableRest(); }
function pie_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pie_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function pie_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function pie_toConsumableArray(r) { return pie_arrayWithoutHoles(r) || pie_iterableToArray(r) || pie_unsupportedIterableToArray(r) || pie_nonIterableSpread(); }
function pie_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pie_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return pie_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? pie_arrayLikeToArray(r, a) : void 0; } }
function pie_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function pie_arrayWithoutHoles(r) { if (Array.isArray(r)) return pie_arrayLikeToArray(r); }
function pie_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }











var PIE_CONTAINER = 'pieContainer';
var SLICE_CONTAINER = 'sliceContainer';
var LABEL_CONTAINER = 'labelContainer';
var LINE_CONTAINER = 'lineContainer';
var LABEL_ARC_CONTAINER = 'labelArcContainer';
var REMOVE_LABEL = 'Remove';
var PATTERN_CONTAINER = 'root-defs';
var OTHER_LABEL = 'Other';
var MOUSE_OVER_SIZE = 5;
var LINE_LABEL_SPACE = 5;
var BORDER_SIZE = 1;
var SINGLE_LABEL_HEIGHT = 16;
var VIZ_PADDING = 24;
var CHART_STEMLINE_PADDING = 2;
var MINIMUM_TRUNCATED_LABEL_SIZE = 30;
var OTHER_GROUP_ANGLE_OFFSET = 0.015;
var LabelLocations = {
  LEFT: 'left',
  RIGHT: 'right'
};
var Pie = function Pie() {
  var config = {
      width: 400,
      height: 400,
      isDonut: false,
      widgetAsFilter: false,
      donutType: 'fixed',
      donutRatio: 0,
      donutWidth: 16,
      animationDuration: 400,
      colorScheme: ordinal(category10),
      disableInteraction: false,
      showLabels: true,
      labelsOutside: true,
      strokeWidth: BORDER_SIZE,
      getKey: function getKey(d, i) {
        return d.data && d.data.label ? d.data.label + i : i;
      },
      getLabel: function getLabel() {
        return '';
      },
      getNumericalValue: null,
      getPercent: null,
      dataPointSelected: null,
      generateTooltip: function generateTooltip(evt) {
        var d = evt.d || {};
        if (d.tooltip) {
          return d.tooltip;
        }
        return '<div class="dark-dialog">' + (d.properties || {}).name + '</div>';
      },
      tooltip: upgradedNvTooltip(),
      allowTruncatedLabels: false
    },
    lifeCycle = new upgraded_utils_RenderLifeCycle(),
    pieLayout = src_pie().sort(null).value(function (d) {
      return d.disabled ? 0 : Math.abs(d.value);
    }),
    dispatch = src_dispatch('elementClick', 'elementMouseover', 'elementMouseout');
  var _pie = function pie(selection) {
    lifeCycle.start();
    if (config.tooltip && _.isFunction(config.generateTooltip)) {
      config.tooltip.contentGenerator(config.generateTooltip);
    }
    selection.each(function (data) {
      var container = src_select(this),
        pieContainer = upgraded_utils_createElementIfAbsent(container, PIE_CONTAINER),
        patternContainer = upgraded_utils_createElementIfAbsent(pieContainer, PATTERN_CONTAINER, 'defs').node(),
        sliceContainer = upgraded_utils_createElementIfAbsent(pieContainer, SLICE_CONTAINER),
        labelContainer = upgraded_utils_createElementIfAbsent(pieContainer, LABEL_CONTAINER),
        lineContainer = upgraded_utils_createElementIfAbsent(pieContainer, LINE_CONTAINER),
        labelArcContainer = upgraded_utils_createElementIfAbsent(pieContainer, LABEL_ARC_CONTAINER),
        layout = coreLayout(config, data),
        standardArcs = arc().outerRadius(function (arc) {
          return decreasePatternRadius(arc, layout.outerRadius);
        }).innerRadius(function (arc) {
          return increasePatternRadius(arc, layout.innerRadius);
        }),
        mouseOverArcs = arc().outerRadius(function (arc) {
          return decreasePatternRadius(arc, layout.outerRadius);
        }).innerRadius(function (arc) {
          return increasePatternRadius(arc, layout.innerRadius);
        }),
        lines,
        labelArc,
        arcs,
        labels,
        labelText,
        pieData;
      _pie.layout = layout;
      pieContainer.attr('width', config.width).attr('height', config.height).attr('transform', getContainerTransform(config.width, config.height)).classed('interactive', !config.disableInteraction);
      var arcData = [];
      data.forEach(function (segment) {
        return segment.otherGroupedSegments ? arcData.push.apply(arcData, pie_toConsumableArray(segment.otherGroupedSegments)) : arcData.push(segment);
      });
      arcs = sliceContainer.selectAll('path.arc').data(pieLayout(arcData), _.partial(wrapData, config.getKey));
      var hideHighlightDataPoint = function hideHighlightDataPoint(className) {
        container.selectAll(".".concat(className)).classed(className, false);
      };
      var highlightSelectedDataPoint = function highlightSelectedDataPoint() {
        hideHighlightDataPoint('selected');
        var selectedSlice = sliceContainer.selectAll('path.arc').filter(function (d) {
          var _d$data, _config$dataPointSele;
          return ((_d$data = d.data) === null || _d$data === void 0 ? void 0 : _d$data.id) === ((_config$dataPointSele = config.dataPointSelected.data) === null || _config$dataPointSele === void 0 ? void 0 : _config$dataPointSele.id);
        });
        if (!selectedSlice.empty()) {
          sliceContainer.classed('selected', true);
          selectedSlice.classed('selected', true);
        }
      };
      var shouldAdjustArclineAngleForOtherGroups = function shouldAdjustArclineAngleForOtherGroups(arcsData) {
        var otherGroupedSegments = arcsData.filter(function (arc) {
          return arc.otherGroupedSegments;
        });
        if (otherGroupedSegments.length < 2) {
          return false;
        }
        var firstSegmentIsGrouped = !!otherGroupedSegments[0].otherGroupedSegments;
        var lastSegmentIsGrouped = !!otherGroupedSegments[otherGroupedSegments.length - 1].otherGroupedSegments;
        return firstSegmentIsGrouped && lastSegmentIsGrouped;
      };
      if (!config.widgetAsFilter) {
        config.dataPointSelected = undefined;
      }
      if (config.dataPointSelected && config.widgetAsFilter) {
        highlightSelectedDataPoint();
      } else {
        hideHighlightDataPoint('selected');
      }
      var arcsEnter = arcs.enter().append('path').attr('class', 'arc').attr('fill', _.partial(getArcColor, config.colorScheme, patternContainer)).style('stroke', function (arc, index) {
        if (arc.data.pattern) {
          return arc.data.color || config.colorScheme(arc.data, index);
        }
        return 'white';
      }).style('stroke-width', config.strokeWidth + 'px');
      arcs.exit().transition().duration(config.animationDuration).attrTween('d', _.partial(tweenExitPie, layout)).remove();
      arcsEnter.merge(arcs).transition().duration(config.animationDuration).attr('fill', _.partial(getArcColor, config.colorScheme, patternContainer)).attrTween('d', _.partial(tweenPie, layout)).call(lifeCycle.watch);
      if (!config.disableInteraction) {
        arcsEnter.merge(arcs).on('mouseover', function (event, d) {
          var _d$data$otherGroupedP;
          if (this && !src_select(this).transition) {
            src_select(this).transition().duration(50).attr('d', function (d) {
              return mouseOverArcs(d);
            });
          }
          if (_.isArray((_d$data$otherGroupedP = d.data.otherGroupedParentSegment) === null || _d$data$otherGroupedP === void 0 ? void 0 : _d$data$otherGroupedP.otherGroupedSegments)) {
            var indexesInGroupMap = {};
            _.forEach(d.data.otherGroupedParentSegment.otherGroupedSegments, function (segment) {
              indexesInGroupMap[segment._index] = true;
            });
            pieContainer.selectAll('.arc').filter(function (d) {
              return indexesInGroupMap[d.data._index];
            }).classed('group-hover', true);
          }
          var tooltipData = {
            series: {
              key: d.data && d.data.label,
              value: d.data && d.data.value,
              color: d.data.color
            },
            index: d.data.id,
            data: d.data,
            color: d.data.color
          };
          config.tooltip.data(tooltipData).duration(0).hidden(false);
          dispatch.call('elementMouseover', this, {
            data: d.data,
            index: d.data.id,
            color: d.data.color
          });
        }).on('mouseout', function (event, d) {
          hideHighlightDataPoint('group-hover');
          if (this && !src_select(this).transition) {
            src_select(this).transition().duration(50).attr('d', function (d) {
              return standardArcs(d);
            });
          }
          config.tooltip.hidden(true);
          dispatch.call('elementMouseout', this, {
            data: d.data,
            index: d.data.id,
            color: d.data.color
          });
        }).on('click', function (event, d) {
          var _config$dataPointSele2, _config$dataPointSele3, _d$data2;
          var isSameDataPoint = config.dataPointSelected && ((_config$dataPointSele2 = config.dataPointSelected) === null || _config$dataPointSele2 === void 0 ? void 0 : (_config$dataPointSele3 = _config$dataPointSele2.data) === null || _config$dataPointSele3 === void 0 ? void 0 : _config$dataPointSele3.id) === ((_d$data2 = d.data) === null || _d$data2 === void 0 ? void 0 : _d$data2.id);
          if (config.widgetAsFilter && !isSameDataPoint) {
            config.dataPointSelected = d;
          } else {
            config.dataPointSelected = undefined;
          }
          dispatch.call('elementClick', this, {
            data: d.data,
            index: d.data.id,
            color: d.data.color
          });
        }).on('mousemove', function () {
          config.tooltip();
        });
      }
      if (config.showLabels) {
        pieData = pieLayout(data).filter(disabledDataFilter);
        labels = labelContainer.selectAll('text.labels').data(pieData, _.partial(wrapData, config.getKey));
        labelText = labelContainer.selectAll('tspan');
        var labelsEnter = labels.enter().append('text').attr('class', 'labels smart-labels');
        if (labelsFit(data, config, layout.outerRadius)) {
          if (disabledDataFilter) {
            labelText.remove();
            var maxMainWidth = calculateAllowedMainLabelSize(data, config, layout.outerRadius);
            if (config.allowTruncatedLabels) {
              labelsEnter.merge(labels).append('tspan', ':first-child').attr('class', _.partial(getMainLabelStyles, config.getNumericalValue, config.getPercent)).style('opacity', 0).html(_.partial(filteredLabel, config.getLabel)).call(js_nv.upgradedUtils.truncateText, maxMainWidth);
            } else {
              labelsEnter.merge(labels).append('tspan', ':first-child').attr('class', _.partial(getMainLabelStyles, config.getNumericalValue, config.getPercent)).style('opacity', 0).html(_.partial(filteredLabel, config.getLabel));
            }
            labelsEnter.merge(labels).append('tspan', ':first-child').attr('class', _.partial(getNumericalLabelStyles, config.getNumericalValue, config.getPercent)).style('opacity', 0).html(_.partial(filteredNumericalLabel, config.getNumericalValue, config.getPercent, config.getLabel));
            labels.exit().remove();
            labelsEnter.merge(labels).classed('light-label-color', _.partial(hasLightLabelColor, config, patternContainer)).each(overlapReductionLayout(config, layout));
          }
          labelText = labelContainer.selectAll('tspan');
          var labelOffset = layout.outerRadius + VIZ_PADDING;
          var labelCounts = getNumberOfLabels(pieData, config, layout);
          var labelPositions = getLabelPositions(pieData, config, layout, labelCounts, config.getKey);
          if (!config.labelsOutside) {
            lineContainer.remove();
            labelText.style('opacity', 1);
            labelsEnter.merge(labels).transition().duration(config.animationDuration).attrTween('transform', _.partial(tweenLabels, labelOffset, labelPositions, config.getKey)).style('text-anchor', 'middle').style('text-shadow', function (arc) {
              if (arc.data.pattern) {
                return js_nv.utils.makeBorder('#ffffff', 2);
              }
            }).style('opacity', 1).call(lifeCycle.watch);
          } else {
            labelText.style('opacity', 1);
            labelsEnter.merge(labels).transition().duration(config.animationDuration).attrTween('transform', _.partial(tweenLabels, labelOffset, labelPositions, config.getKey)).styleTween('text-anchor', tweenOuterLabelStyle).attr('dy', '0.35em').call(lifeCycle.watch);
            lines = lineContainer.selectAll('polyline.labelLines').data(pieData, _.partial(wrapData, config.getKey));
            var linesEnter = lines.enter().append('polyline').attr('class', 'labelLines').style('opacity', 0);
            linesEnter.merge(lines).transition().duration(config.animationDuration).style('opacity', 1).attrTween('points', _.partial(tweenLabelLines, layout, labelPositions, config.getKey)).call(lifeCycle.watch);
            var arcLineData = pieData.filter(function (d) {
              return d.data.otherGroupedSegments;
            });
            labelArc = labelArcContainer.selectAll('path.arc').data(arcLineData, _.partial(wrapData, config.getKey));
            if (labelPositions.get(OTHER_LABEL) !== REMOVE_LABEL) {
              var needToAdjustArcline = shouldAdjustArclineAngleForOtherGroups(data);
              var labelArcEnter = labelArc.enter().append('path').attr('class', 'arc');
              labelArcEnter.merge(labelArc).transition().duration(config.animationDuration).attr('class', 'arc').attr('d', function (d, index) {
                var adjustStartAngle = needToAdjustArcline && index === 0 ? OTHER_GROUP_ANGLE_OFFSET : 0;
                var adjustEndAngle = needToAdjustArcline && index === arcLineData.length - 1 ? OTHER_GROUP_ANGLE_OFFSET : 0;
                return arc().innerRadius(layout.outerRadius + BORDER_SIZE).outerRadius(layout.outerRadius + CHART_STEMLINE_PADDING).startAngle(d.startAngle + adjustStartAngle).endAngle(d.endAngle - adjustEndAngle)();
              }).attr('fill', 'black').call(lifeCycle.watch);
            }
            lines.exit().remove();
            labelArc.exit().remove();
          }
        } else {
          lineContainer.remove();
          labelContainer.remove();
          labelArcContainer.remove();
        }
      } else {
        lineContainer.remove();
        labelContainer.remove();
      }
    });
    lifeCycle.dispatchOnCompletion();
  };
  _pie.dispatch = dispatch;
  upgraded_utils_exposeConfig(_pie, config);
  _pie.lifeCycle = lifeCycle.dispatch;
  return _pie;
};
function getContainerTransform(width, height) {
  return 'translate(' + width / 2 + ', ' + height / 2 + ')';
}
function disabledDataFilter(d) {
  return !d.data.disabled;
}
function getArcColor(fallbackColorScheme, patternContainer, dataPoint, index) {
  var defaultColorFill = dataPoint.color || fallbackColorScheme(dataPoint.data, index);
  return js_nv.utils.patternService.getDataFill(patternContainer, dataPoint.data, defaultColorFill);
}
function hasLightLabelColor(config, patternContainer, dataPoint, index) {
  var arcColor = getArcColor(config.colorScheme, patternContainer, dataPoint, index);
  return !dataPoint.data.pattern && !config.labelsOutside && upgraded_utils_isDarkColor(arcColor);
}
function filteredLabel(getLabel, d, i) {
  return getLabel(d, i);
}
function filteredNumericalLabel(getNumericalValue, getPercent, getLabel, d, i) {
  var numLabel = getLabel(d, i) ? ' ' : '';
  numLabel = getPercent && getPercent(d) ? "".concat(numLabel).concat(getPercent(d), " ") : numLabel;
  numLabel = getNumericalValue && getNumericalValue(d) ? "".concat(numLabel, "(").concat(getNumericalValue(d), ")") : numLabel;
  return numLabel;
}
function getMainLabelStyles(getNumericalValue, getPercent) {
  return getNumericalValue || getPercent ? 'main-label' : '';
}
function getNumericalLabelStyles(getNumericalValue, getPercent) {
  return getNumericalValue || getPercent ? 'numerical-label' : '';
}
function wrapData(func, d, i) {
  return func(d.data, i);
}
function tweenExitPie(layout) {
  var arcGenerator = arc(),
    startPosition = this._current || {
      startAngle: 0,
      endAngle: 0,
      innerRadius: layout.innerRadius,
      outerRadius: layout.outerRadius
    },
    interpolator = value(startPosition, {
      startAngle: Math.PI * 2,
      endAngle: Math.PI * 2,
      innerRadius: layout.innerRadius,
      outerRadius: layout.outerRadius
    });
  return function (t) {
    return arcGenerator(interpolator(t));
  };
}
function midAngle(d) {
  return d.startAngle + (d.endAngle - d.startAngle) / 2;
}
function cartesianToPolar(point) {
  return {
    radius: Math.sqrt(point[0] * point[0] + point[1] * point[1]),
    theta: Math.atan2(point[1], point[0])
  };
}
function polarToCartesian(polar) {
  return [polar.radius * Math.cos(polar.theta), polar.radius * Math.sin(polar.theta)];
}
function degreeToRadianAt90(deg) {
  deg += 90;
  deg %= 360;
  deg -= 180;
  return deg * Math.PI / 180;
}
function radianToDegreeAt90(rad) {
  var deg = rad / Math.PI * 180;
  deg += 450;
  deg %= 360;
  return deg;
}
function tweenLabels(labelOffset, labelYCoordinates, getKey, d, i) {
  var arcValues = cartesianToPolar([d.x, d.y]),
    startPosition = this._current || {
      deg: radianToDegreeAt90(-(Math.PI / 2)),
      radius: arcValues.radius
    },
    interpolator = value(startPosition, {
      deg: radianToDegreeAt90(arcValues.theta),
      radius: arcValues.radius
    });
  this._current = interpolator(1);
  if (labelYCoordinates.get(getKey(d, i)) === REMOVE_LABEL) {
    this.remove();
  }
  return function (t) {
    var currentPosition = interpolator(t);
    currentPosition.theta = degreeToRadianAt90(currentPosition.deg);
    var currentPositionCartesian = polarToCartesian(currentPosition);
    currentPositionCartesian[0] = currentPositionCartesian[0] > 0 ? labelOffset : labelOffset * -1;
    currentPositionCartesian[1] = labelYCoordinates.get(getKey(d, i));
    return 'translate(' + currentPositionCartesian + ')';
  };
}
function decreasePatternRadius(arc, radius) {
  if (arc.data.pattern) {
    return radius - BORDER_SIZE;
  }
  return radius;
}
function increasePatternRadius(arc, radius) {
  if (arc.data.pattern) {
    return radius + BORDER_SIZE;
  }
  return radius;
}
function tweenPie(layout, d) {
  var arcGenerator = arc();
  var startPosition = this._current || {
    startAngle: 0,
    endAngle: 0,
    innerRadius: increasePatternRadius(d, layout.innerRadius),
    outerRadius: decreasePatternRadius(d, layout.outerRadius)
  };
  var interpolator = value(startPosition, _.merge(d, {
    innerRadius: increasePatternRadius(d, layout.innerRadius),
    outerRadius: decreasePatternRadius(d, layout.outerRadius)
  }));
  this._current = interpolator(1);
  return function (t) {
    return arcGenerator(interpolator(t));
  };
}
function tweenOuterLabelStyle(d) {
  var arcValues = cartesianToPolar([d.x, d.y]),
    startAngle = this._styleCurrent || radianToDegreeAt90(-(Math.PI / 2)),
    endAngle = radianToDegreeAt90(arcValues.theta),
    interpolator = value(startAngle, endAngle);
  this._styleCurrent = interpolator(1);
  return function (t) {
    return interpolator(t) > 180 ? 'end' : 'start';
  };
}
function tweenLabelLines(layout, labelYCoordinates, getKey, d, i) {
  var labelOffset = layout.outerRadius + VIZ_PADDING;
  if (labelYCoordinates[getKey(d, i)] === REMOVE_LABEL) {
    return;
  }
  var lineArcGenerator = arc(),
    arcStartPosition = this._arcCurrent || {
      startAngle: 0,
      endAngle: 0,
      innerRadius: layout.labelInnerRadius,
      outerRadius: layout.labelOuterRadius
    },
    arcInterpolator = value(arcStartPosition, _.merge(d, {
      innerRadius: layout.labelInnerRadius,
      outerRadius: layout.labelOuterRadius
    })),
    arcValues = cartesianToPolar([d.x, d.y]),
    labelStartPosition = this._labelCurrent || {
      deg: radianToDegreeAt90(-(Math.PI / 2)),
      radius: arcValues.radius
    },
    labelInterpolator = value(labelStartPosition, {
      deg: radianToDegreeAt90(arcValues.theta),
      radius: arcValues.radius
    }),
    pieArc = arc().innerRadius(layout.outerRadius).outerRadius(layout.outerRadius + CHART_STEMLINE_PADDING);
  this._arcCurrent = arcInterpolator(1);
  this._labelCurrent = labelInterpolator(1);
  return function (t) {
    var d2 = arcInterpolator(t);
    var labelPosition = labelInterpolator(t);
    var spacing = (labelPosition.deg > 180 ? 1 : -1) * LINE_LABEL_SPACE;
    labelPosition.theta = degreeToRadianAt90(labelPosition.deg);
    labelPosition = polarToCartesian(labelPosition);
    labelPosition[0] = labelPosition[0] > 0 ? labelOffset : labelOffset * -1;
    labelPosition[0] = labelPosition[0] + spacing;
    labelPosition[1] = labelYCoordinates.get(getKey(d, i));
    var stemlineCorner = lineArcGenerator.centroid(d2);
    stemlineCorner[1] = labelPosition[1];
    var piePoint = pieArc.centroid(d2);
    if (Math.abs(labelPosition[1]) < Math.abs(piePoint[1]) || Math.abs(stemlineCorner[0]) > Math.abs(labelPosition[0])) {
      return [piePoint, labelPosition];
    } else {
      return [piePoint, stemlineCorner, labelPosition];
    }
  };
}
function getNumberOfLabels(data, config, layout) {
  var numberOfLeftLabels = 0;
  var numberOfRightLabels = 0;
  var labelArcGenerator = arc().innerRadius(layout.labelInnerRadius).outerRadius(layout.labelOuterRadius);
  function getExpectedPosition(d) {
    var pos = labelArcGenerator.centroid(d);
    if (config.labelsOutside) {
      pos[0] = layout.labelInnerRadius * (midAngle(d) < Math.PI ? 1 : -1);
    }
    return pos;
  }
  _.map(data, function (d) {
    var pos = getExpectedPosition(d);
    if (pos[0] > 0) {
      numberOfRightLabels++;
    } else {
      numberOfLeftLabels++;
    }
  });
  return {
    numberOfLeftLabels: numberOfLeftLabels,
    numberOfRightLabels: numberOfRightLabels
  };
}
function getLabelPositions(data, config, layout, labelCounts, getKey) {
  var numberOfLabelsPerColumn = Math.floor(config.height / SINGLE_LABEL_HEIGHT);
  var remainingLeftLabels = Math.min(labelCounts.numberOfLeftLabels, numberOfLabelsPerColumn);
  var remainingRightLabels = Math.min(labelCounts.numberOfRightLabels, numberOfLabelsPerColumn);
  var leftOccupiedYPositions = Array.apply(null, Array(numberOfLabelsPerColumn)).map(function () {
    return false;
  });
  var rightOccupiedYPositions = Array.apply(null, Array(numberOfLabelsPerColumn)).map(function () {
    return false;
  });
  var labelYPositions = new Map();
  var labelArcGenerator = arc().innerRadius(layout.labelInnerRadius).outerRadius(layout.labelOuterRadius);
  function getExpectedPosition(d) {
    var pos = labelArcGenerator.centroid(d);
    if (config.labelsOutside) {
      pos[0] = layout.labelInnerRadius * (midAngle(d) < Math.PI ? 1 : -1);
    }
    return pos;
  }
  var minLabelYPosition = -SINGLE_LABEL_HEIGHT * Math.floor(numberOfLabelsPerColumn / 2);
  var maxLabelYPosition = minLabelYPosition + SINGLE_LABEL_HEIGHT * (numberOfLabelsPerColumn - 1);
  function getNearestAllocatedLabelYPosition(point) {
    if (point[1] > 0) {
      return Math.min(maxLabelYPosition, Math.max(minLabelYPosition, Math.ceil(point[1] / SINGLE_LABEL_HEIGHT) * SINGLE_LABEL_HEIGHT));
    } else {
      return Math.min(maxLabelYPosition, Math.max(minLabelYPosition, Math.floor(point[1] / SINGLE_LABEL_HEIGHT) * SINGLE_LABEL_HEIGHT));
    }
  }
  function getNearestYLabelPositionNumber(point) {
    if (point[1] > 0) {
      return Math.min(numberOfLabelsPerColumn - 1, Math.max(0, Math.floor(numberOfLabelsPerColumn / 2) + Math.ceil(point[1] / SINGLE_LABEL_HEIGHT)));
    } else {
      return Math.min(numberOfLabelsPerColumn - 1, Math.max(0, Math.floor(numberOfLabelsPerColumn / 2) + Math.floor(point[1] / SINGLE_LABEL_HEIGHT)));
    }
  }
  function assignLabelPosition(labelXLocation, d, index, initialPosition) {
    var isLeft = labelXLocation === LabelLocations.LEFT;
    var pointPosition = getNearestAllocatedLabelYPosition(initialPosition);
    var positionNumber = getNearestYLabelPositionNumber(initialPosition);
    var remainingLabels = isLeft ? remainingLeftLabels : remainingRightLabels;
    var occupiedYPositions = isLeft ? leftOccupiedYPositions : rightOccupiedYPositions;
    remainingLabels--;
    if (remainingLabels < 0) {
      pointPosition = REMOVE_LABEL;
    } else {
      var moreLabelsThanSlotsRemaining = isLeft ? remainingLabels > positionNumber : remainingLabels > numberOfLabelsPerColumn - positionNumber;
      if (moreLabelsThanSlotsRemaining) {
        positionNumber = isLeft ? remainingLabels + 1 : Math.max(0, numberOfLabelsPerColumn - remainingLabels);
        pointPosition = SINGLE_LABEL_HEIGHT * (positionNumber - Math.floor(numberOfLabelsPerColumn / 2));
      }
      while (occupiedYPositions[positionNumber]) {
        var noMoreLabelSlots = isLeft ? positionNumber === 0 : positionNumber === numberOfLabelsPerColumn - 1;
        if (noMoreLabelSlots) {
          pointPosition = REMOVE_LABEL;
          break;
        } else {
          pointPosition = isLeft ? pointPosition - SINGLE_LABEL_HEIGHT : pointPosition + SINGLE_LABEL_HEIGHT;
          positionNumber = isLeft ? positionNumber - 1 : positionNumber + 1;
        }
      }
    }
    if (pointPosition !== REMOVE_LABEL) {
      occupiedYPositions[positionNumber] = true;
      pointPosition += SINGLE_LABEL_HEIGHT / 2;
    }
    labelYPositions.set(getKey(d, index), pointPosition);
    return [remainingLabels, occupiedYPositions];
  }
  data.forEach(function (d, index) {
    var initialPosition = getExpectedPosition(d);
    if (initialPosition[0] > 0) {
      var _assignLabelPosition = assignLabelPosition(LabelLocations.RIGHT, d, index, initialPosition);
      var _assignLabelPosition2 = pie_slicedToArray(_assignLabelPosition, 2);
      remainingRightLabels = _assignLabelPosition2[0];
      rightOccupiedYPositions = _assignLabelPosition2[1];
    } else {
      var _assignLabelPosition3 = assignLabelPosition(LabelLocations.LEFT, d, index, initialPosition);
      var _assignLabelPosition4 = pie_slicedToArray(_assignLabelPosition3, 2);
      remainingLeftLabels = _assignLabelPosition4[0];
      leftOccupiedYPositions = _assignLabelPosition4[1];
    }
  });
  return labelYPositions;
}
var MIN_LABEL_ARC_RATIO = 0.3;
var MAX_LABEL_ARC_RATIO = 0.7;
var MIN_GAP_RATIO = 0.05;
var MAX_GAP_RATIO = 0.5;
var SUGGESTED_GAP_SIZE = 30;
function boundRange(val, min, max) {
  return Math.min(Math.max(val, min), max);
}
function normalizeByDecimalPlaces(val, decimalPlaces) {
  var powerOfTen = Math.pow(10, decimalPlaces);
  return Math.floor(val * powerOfTen) / powerOfTen;
}
function normalizeToOneDecimal(val) {
  return normalizeByDecimalPlaces(val, 1);
}
function calculateApproxMainLabelSize(data, getLabel) {
  return normalizeToOneDecimal(_.max(_.map(data, function (d, i) {
    return upgraded_utils_estimateWidthFromSize(12, filteredLabel(getLabel, {
      data: d
    }, i));
  })));
}
function calculateMaxNumericalLabelSize(data, getNumericalValue, getPercent, getLabel) {
  return normalizeToOneDecimal(_.max(_.map(data, function (d, i) {
    return upgraded_utils_estimateWidthFromSize(12, filteredNumericalLabel(getNumericalValue, getPercent, getLabel, {
      data: d
    }, i));
  })));
}
function calculateAllowedMainLabelSize(data, config, outerRadius) {
  var maxNumericalLabelSize = calculateMaxNumericalLabelSize(data, config.getNumericalValue, config.getPercent, config.getLabel);
  var totalSize = maxNumericalLabelSize + VIZ_PADDING + outerRadius + LINE_LABEL_SPACE;
  return config.width / 2 - totalSize;
}
function getMaxLabelSize(data, config) {
  return Math.min(calculateApproxMainLabelSize(data, config.getLabel), MINIMUM_TRUNCATED_LABEL_SIZE) + calculateMaxNumericalLabelSize(data, config.getNumericalValue, config.getPercent, config.getLabel);
}
function labelsFit(data, config, outerRadius) {
  var totalSize = getMaxLabelSize(data, config) + VIZ_PADDING + outerRadius + LINE_LABEL_SPACE;
  return config.width / 2 > totalSize;
}
function extractGapRatio(boundingSpace, arcRadius) {
  var computedGapSize = Math.min(SUGGESTED_GAP_SIZE, arcRadius * 0.05),
    boundingGapCondition = normalizeByDecimalPlaces((boundingSpace + computedGapSize) / boundingSpace, 2) - 1;
  return boundRange(boundingGapCondition, MIN_GAP_RATIO, MAX_GAP_RATIO);
}
function extractGapAndArcRatio(config, outerRadius, approxLabelSize) {
  var spaceAvailableForLabel = Math.max(config.width / 2 - outerRadius, 0),
    spaceNeededForLabel = approxLabelSize,
    extraSpaceNeededForLabel = Math.max(approxLabelSize - spaceAvailableForLabel, 0),
    labelGapRatio,
    labelArcRatio;
  if (spaceAvailableForLabel > spaceNeededForLabel) {
    return {
      labelArcRatio: MIN_LABEL_ARC_RATIO,
      labelGapRatio: extractGapRatio(config.height / 2, outerRadius) + 1
    };
  }
  labelGapRatio = extractGapRatio(extraSpaceNeededForLabel, outerRadius) + 1;
  labelArcRatio = boundRange(normalizeToOneDecimal(extraSpaceNeededForLabel * labelGapRatio / outerRadius), MIN_LABEL_ARC_RATIO, MAX_LABEL_ARC_RATIO);
  return {
    labelArcRatio: labelArcRatio,
    labelGapRatio: labelGapRatio
  };
}
function coreLayout(config, data) {
  var layout = {},
    outerRadius = Math.min(config.width, config.height) / 2,
    innerRadius = calculateDonutRadius(config, outerRadius),
    approxLabelSize,
    ratio;
  if (!config.disableInteraction) {
    outerRadius -= MOUSE_OVER_SIZE;
  }
  if (!config.showLabels || !config.labelsOutside) {
    return {
      outerRadius: outerRadius,
      innerRadius: calculateDonutRadius(config, outerRadius),
      labelOuterRadius: outerRadius,
      labelInnerRadius: innerRadius
    };
  }
  if (config.showLabels && config.labelsOutside) {
    var minRadius = outerRadius * MIN_LABEL_ARC_RATIO;
    var approxMainLabelSize = calculateApproxMainLabelSize(data, config.getLabel);
    var approxNumLabelSize = calculateMaxNumericalLabelSize(data, config.getNumericalValue, config.getPercent, config.getLabel);
    if (labelsFit(data, config, minRadius)) {
      approxLabelSize = config.allowTruncatedLabels ? Math.min(approxMainLabelSize, calculateAllowedMainLabelSize(data, config, minRadius)) + approxNumLabelSize : calculateApproxMainLabelSize(data, config.getLabel);
      approxLabelSize += VIZ_PADDING + LINE_LABEL_SPACE;
      ratio = extractGapAndArcRatio(config, outerRadius, approxLabelSize);
    } else {
      ratio = {
        labelArcRatio: 0,
        labelGapRatio: 0
      };
    }
    var newOuterRadius = outerRadius * (1 - ratio.labelArcRatio);
    layout = {
      outerRadius: newOuterRadius,
      innerRadius: calculateDonutRadius(config, newOuterRadius),
      labelOuterRadius: outerRadius * (1 - ratio.labelArcRatio / ratio.labelGapRatio),
      labelInnerRadius: outerRadius * (1 - ratio.labelArcRatio / ratio.labelGapRatio)
    };
  }
  return layout;
}
function calculateDonutRadius(config, outerRadius) {
  if (!config.isDonut) {
    return 0;
  }
  if (config.donutType === 'fixed') {
    return Math.max(0, outerRadius - config.donutWidth);
  } else {
    return outerRadius * config.donutRatio;
  }
}
function overlapReductionLayout(config, layout) {
  var pointQuadTree = quadtree().x(function (d) {
      return d.x;
    }).y(function (d) {
      return d.y;
    }).extent([[-config.width / 2, -config.height / 2], [config.width / 2, config.height / 2]]).addAll([]),
    labelArcGenerator = arc().innerRadius(layout.labelInnerRadius).outerRadius(layout.labelOuterRadius);
  function getCurrentBoxPositions(node, x, y) {
    var dimensions = node.getBBox();
    if (!config.labelsOutside) {
      return {
        x1: x - dimensions.width / 2,
        y1: y - dimensions.height,
        x2: x + dimensions.width / 2,
        y2: y,
        height: dimensions.height
      };
    } else {
      if (x < 0) {
        return {
          x1: x - dimensions.width,
          y1: y - dimensions.height / 2,
          x2: x,
          y2: y + dimensions.height / 2,
          height: dimensions.height
        };
      } else {
        return {
          x1: x,
          y1: y - dimensions.height / 2,
          x2: x + dimensions.width,
          y2: y + dimensions.height / 2,
          height: dimensions.height
        };
      }
    }
  }
  function getExpectedPoistionPosition(d) {
    var pos = labelArcGenerator.centroid(d);
    if (config.labelsOutside) {
      pos[0] = layout.labelInnerRadius * (midAngle(d) < Math.PI ? 1 : -1);
    }
    return pos;
  }
  return function (d) {
    var point = getExpectedPoistionPosition(d),
      labelBox = getCurrentBoxPositions(this, point[0], point[1], d),
      horizontalConflict,
      verticalConflict,
      conflicts = [];
    pointQuadTree.visit(function (node, x1, y1, x2, y2) {
      var actualPoint;
      if (x1 > labelBox.x2 || x2 < labelBox.x1 || y1 > labelBox.y2 || y2 < labelBox.y1) {
        return false;
      }
      actualPoint = node.point;
      if (actualPoint) {
        horizontalConflict = actualPoint.box.x1 <= labelBox.x1 && labelBox.x1 <= actualPoint.box.x2 || actualPoint.box.x1 <= labelBox.x2 && labelBox.x2 <= actualPoint.box.x2;
        verticalConflict = actualPoint.box.y1 <= labelBox.y1 && labelBox.y1 <= actualPoint.box.y2 || actualPoint.box.y1 <= labelBox.y2 && labelBox.y2 <= actualPoint.box.y2;
        if (horizontalConflict && verticalConflict) {
          conflicts.push(actualPoint);
        }
      }
    });
    if (conflicts.length) {
      point[1] = Math.max(min_min(conflicts, function (d) {
        return d.box.y1;
      }) - 5, -config.height / 2 + labelBox.height);
      labelBox.y1 = labelBox.y1 - (labelBox.y2 - point[1]);
      labelBox.y2 = point[1];
    }
    _.merge(d, {
      x: point[0],
      y: point[1],
      box: {
        x1: labelBox.x1,
        y1: labelBox.y1,
        x2: labelBox.x2,
        y2: labelBox.y2
      }
    });
    pointQuadTree.add(d);
  };
}
;// ./src/js/viz/config/upgraded_tooltip_config.js

var UpgradedTooltipConfig = {
  tooltip: upgradedDarkDialog,
  _showTooltip: true,
  _tooltipGravity: 'w',
  setTooltip: function setTooltip(tooltip) {
    this.tooltip = tooltip;
    return this;
  },
  showTooltip: function showTooltip(_showTooltip) {
    this._showTooltip = !!_showTooltip;
    return this;
  }
};
;// ./src/js/viz/config/upgraded_base_chart_config.js









var UpgradedBaseChartConfig = Object.assign({}, MarginConfig, LegendConfig, DataConfig, ReferenceLineConfig, ColorSchemeConfig, UpgradedTooltipConfig, AnimationConfig, InteractionConfig);
;// ./src/js/viz/d3/charts/pie_chart.js












var DEFAULT_DONUT_FIXED_WIDTH = 16;
var DEFAULT_DONUT_RATIO = 0.5;
var FIXED_WIDTH_DONUT_TYPE = 'fixed';
var DYNAMIC_DONUT_TYPE = 'dynamic';
var STROKE_WIDTH = 2;
var PieChartConfig = Object.assign({}, UpgradedBaseChartConfig, EventConfig, {
  _isDonut: false,
  _donutType: FIXED_WIDTH_DONUT_TYPE,
  _donutRatio: DEFAULT_DONUT_RATIO,
  _donutWidth: DEFAULT_DONUT_FIXED_WIDTH,
  _labelsOutside: false,
  _chartLabel: defaultLabelFunction,
  _chartLabelPercent: null,
  _chartLabelValue: null,
  _otherGroupingThreshold: 0,
  _otherGroupingLabel: '',
  setOtherGroupingParameters: function setOtherGroupingParameters(otherGroupingThreshold, otherGroupingLabel) {
    this._otherGroupingThreshold = otherGroupingThreshold;
    this._otherGroupingLabel = otherGroupingLabel;
    return this;
  },
  setSort: function setSort() {
    return this;
  },
  setLabelsShowPercent: function setLabelsShowPercent(percentFormatter) {
    if (percentFormatter && _.isFunction(percentFormatter)) {
      this._chartLabelPercent = function (percent) {
        return percentFormatter(percent);
      };
    }
    return this;
  },
  setLabelsShowNumericalValue: function setLabelsShowNumericalValue(valueFormatter) {
    if (valueFormatter && _.isFunction(valueFormatter)) {
      this._chartLabelValue = function (value) {
        return valueFormatter(value);
      };
    }
    return this;
  },
  setChartLabel: function setChartLabel(chartLabel, outside) {
    if (chartLabel) {
      if (_.isFunction(chartLabel)) {
        this._chartLabel = chartLabel;
      } else if (typeof chartLabel === 'string') {
        this._chartLabel = selectedLabelFunction(chartLabel);
      } else {
        this._chartLabel = defaultLabelFunction;
      }
    }
    this._labelsOutside = !!outside;
    return this;
  },
  setDonut: function setDonut(enabled, optType, optValue) {
    this._isDonut = !!enabled;
    this._donutType = optType === DYNAMIC_DONUT_TYPE ? DYNAMIC_DONUT_TYPE : FIXED_WIDTH_DONUT_TYPE;
    if (this._donutType === DYNAMIC_DONUT_TYPE) {
      this._donutRatio = optValue || DEFAULT_DONUT_RATIO;
    } else {
      this._donutWidth = optValue || DEFAULT_DONUT_FIXED_WIDTH;
    }
    return this;
  }
});
var PieChart = UpgradedCore.extend(PieChartConfig).extend(WidgetAsFilterConfig).extend({
  initialize: function initialize() {
    this.colorScheme = upgradedBaseColorScheme('label');
    this.layout = new ChartLayout();
    return UpgradedCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.createAndConfigurePie();
    this.createAndConfigureLegend();
    if (postRender) {
      this.pie.lifeCycle.on('renderEnd', postRender);
    }
    this.layout.renderHostedComponents({
      containerDimensions: this.getChartContainerDimensions(),
      animationDuration: this._animationDuration,
      container: this.getContainer(),
      margin: this._margin
    });
    return this;
  },
  createAndConfigurePie: function createAndConfigurePie() {
    this.pie || (this.pie = Pie());
    var currContainer = this.getContainer();
    this.pie.width(currContainer.attr('width')).height(currContainer.attr('height')).isDonut(this._isDonut).donutType(this._donutType).labelsOutside(this._labelsOutside).animationDuration(this._animationDuration).disableInteraction(this._disableInteraction).widgetAsFilter(!!this._widgetAsFilter).allowTruncatedLabels(true).strokeWidth(STROKE_WIDTH);
    if (this._isDonut && this._donutType === FIXED_WIDTH_DONUT_TYPE) {
      this.pie.donutWidth(this._donutWidth);
    } else if (this._isDonut && this._donutType === DYNAMIC_DONUT_TYPE) {
      this.pie.donutRatio(this._donutRatio);
    }
    if (this._chartLabel) {
      this.pie.getLabel(this._chartLabel).getNumericalValue(this._chartLabelValue).getPercent(this._chartLabelPercent);
      this.pie.showLabels(true);
    } else {
      this.pie.showLabels(false);
    }
    this.addTooltip();
    this.configureEventListeners(this.pie);
    this.colorScheme && this.pie.colorScheme(this.colorScheme);
    this.layout.host('chart', this.pie, processData(this.getData(), this._otherGroupingThreshold, this._otherGroupingLabel));
    return this.pie;
  },
  createAndConfigureLegend: function createAndConfigureLegend() {
    this.legend = this.legend || upgradedDqLegend();
    this.legend.colorScheme(this.colorScheme).position(this._legendPosition).animationDuration(this._animationDuration).clickDisabled(this.shouldDisableLegendClick()).getKey(function (d) {
      return d.label;
    });
    if (this._automatedMaxKeyLength === false) {
      this.legend.automatedMaxKeyLength(this._automatedMaxKeyLength).maxKeyLength(this._maxKeyLength);
    }
    if (this._shouldShowLegend) {
      this.layout.host('legend', this.legend, this.getData());
      if (this._legendTitle) {
        this.legend.title(this._legendTitle);
      }
    } else {
      this.layout.remove('legend');
    }
  },
  configureEventListeners: function configureEventListeners(pie) {
    _.forEach(this._eventHandlers, function (handler, event) {
      pie.dispatch.on(event, handler);
    });
  },
  resize: function resize() {
    if (this.pie) {
      this.resizeContainer();
      this.layout.renderHostedComponents({
        containerDimensions: this.getChartContainerDimensions(),
        animationDuration: this._animationDuration,
        container: this.getContainer(),
        margin: this._margin
      });
    }
  },
  addTooltip: function addTooltip() {
    var self = this;
    this.pie.tooltip().enabled(true);
    if (this.tooltip) {
      if (_.isFunction(this.tooltip)) {
        this.pie.generateTooltip(this.tooltip);
      } else {
        this.pie.generateTooltip(function () {
          return self.tooltip;
        });
      }
    } else {
      this.pie.tooltip().enabled(false);
    }
  }
}, {
  Name: 'PieChart',
  DataDimensions: '1'
});
function defaultLabelFunction() {
  return '';
}
function selectedLabelFunction(input) {
  if (input === constants_Constants.SHOW_LABEL) {
    return function (d) {
      return d.data && d.data.label;
    };
  }
  if (input === constants_Constants.SHOW_VALUE) {
    return function (d) {
      return d.data && d.data.value;
    };
  }
  if (input === constants_Constants.SHOW_PERCENT) {
    return function (d) {
      return d.data && format('%')(d.data.pct);
    };
  }
  return defaultLabelFunction;
}
function absoluteSum(data, property) {
  return data.reduce(function (num, entry) {
    return Math.abs(entry[property]) + num;
  }, 0);
}
function isInvalidPieSegmentValue(_ref) {
  var value = _ref.value;
  return value === null || value === undefined || value === 0;
}
function processData(data, otherGroupingThreshold, otherGroupingLabel) {
  if (!data) {
    return [];
  }
  var absoluteTotalValue = absoluteSum(data, 'value');
  if (_.every(data, isInvalidPieSegmentValue) || absoluteTotalValue === 0) {
    return [];
  }
  var processedData = [];
  var index = 0;
  data.forEach(function (d, index) {
    data[index]._index = index;
  });
  var _loop = function _loop() {
      data[index].pct = Math.abs(data[index].value) / absoluteTotalValue;
      groupedSegments = [];
      while (index < data.length && data[index].pct <= otherGroupingThreshold) {
        groupedSegments.push(data[index]);
        if (++index < data.length) {
          data[index].pct = Math.abs(data[index].value) / absoluteTotalValue;
        }
      }
      if (groupedSegments.length === 0) {
        processedData.push(data[index++]);
      } else if (groupedSegments.length === 1) {
        data[index - 1].pct = Math.abs(data[index - 1].value) / absoluteTotalValue;
        processedData.push(data[index - 1]);
      } else {
        var otherSegmentLabel = groupedSegments.length < data.length ? otherGroupingLabel : '';
        var otherSegment = {
          pct: absoluteSum(groupedSegments, 'pct'),
          value: absoluteSum(groupedSegments, 'value'),
          color: groupedSegments[0].color,
          label: otherSegmentLabel,
          otherGroupedSegments: groupedSegments
        };
        processedData.push(otherSegment);
        var otherGroupedParentSegment = _.cloneDeep(otherSegment);
        _.forEach(groupedSegments, function (segment) {
          segment.otherGroupedParentSegment = otherGroupedParentSegment;
        });
      }
    },
    groupedSegments;
  while (index < data.length) {
    _loop();
  }
  return processedData;
}
;// ./src/js/viz/d3/components/label.js



var Label = function Label() {
  var config = {
    width: 400,
    height: 400,
    animationDuration: 400,
    color: constants_Constants.BLACK,
    size: 24,
    weight: 400
  };
  var lifeCycle = new upgraded_utils_RenderLifeCycle();
  var label = function label(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var container = src_select(this);
      var labelContainer = upgraded_utils_createElementIfAbsent(container, label_LABEL_CONTAINER, 'text');
      labelContainer.style('fill', config.color).style('text-anchor', 'middle').style('font-size', upgraded_utils_formatPixels(config.size)).style('font-weight', config.weight).text(data);
    });
    lifeCycle.dispatchOnCompletion();
  };
  upgraded_utils_exposeConfig(label, config);
  label.lifeCycle = lifeCycle.dispatch;
  return label;
};
var label_LABEL_CONTAINER = 'label';
;// ./src/js/viz/d3/components/percent.js


var Percent = function Percent() {
  var config = {
    size: 24,
    color: '#A4A4A4',
    weight: 300
  };
  var lifeCycle = new upgraded_utils_RenderLifeCycle();
  var percent = function percent(selection) {
    lifeCycle.start();
    selection.each(function (data) {
      var container = src_select(this);
      var percentContainer = upgraded_utils_createElementIfAbsent(container, PERCENT_CONTAINER, 'text');
      percentContainer.style('fill', config.color).style('font-size', upgraded_utils_formatPixels(config.size)).style('font-weight', config.weight).text(data);
    });
    lifeCycle.dispatchOnCompletion();
  };
  upgraded_utils_exposeConfig(percent, config);
  percent.lifeCycle = lifeCycle.dispatch;
  return percent;
};
var PERCENT_CONTAINER = 'percent';
;// ./src/js/viz/d3/layouts/base_layout.js







var BaseLayout = function BaseLayout() {
  this.initialize.apply(this, arguments);
  return this;
};
BaseLayout.extend = utils_inherit;
Object.assign(BaseLayout.prototype, {
  initialize: function initialize() {
    this._hostedRegions = {};
  },
  regions: [],
  _regionToContainer: null,
  attachCallback: function attachCallback(postRender) {
    var callbackCount = 0,
      callbackAggregator = function callbackAggregator() {
        callbackCount--;
        if (callbackCount === 0) {
          postRender();
        }
      };
    external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(this._hostedRegions, function (element, key) {
      if (key === 'chart') {
        callbackCount += 1;
        attachRenderEndCallback(element.component, callbackAggregator);
      } else if (element && element.component && element.component.lifeCycle) {
        callbackCount += 1;
        element.component.lifeCycle.dispatch.on('renderEnd', callbackAggregator);
      }
    });
  },
  host: function host(region, component, data) {
    if (!this.regions.includes(region)) {
      console.log(region + ' is not a valid region.');
    } else {
      this._hostedRegions[region] = {
        component: component,
        data: data
      };
    }
  },
  remove: function remove(region) {
    var component = this._hostedRegions[region],
      componentContainer;
    if (component && this.container) {
      componentContainer = this.container.select(this._regionToContainer[region]);
      component.remove && component.remove();
      if (!componentContainer.empty()) {
        componentContainer.remove();
      }
    }
    this._hostedRegions[region] = null;
  }
});
;// ./src/js/viz/d3/layouts/round_layout.js


var RoundLayout = BaseLayout.extend({
  regions: ['pie', 'label', 'percent'],
  _regionToContainer: {
    pie: 'dq-pie',
    label: 'dq-label',
    percent: 'dq-percent'
  },
  renderHostedComponents: function renderHostedComponents(options) {
    var hostedElement = this._hostedRegions.pie;
    if (!hostedElement) {
      return;
    }
    var component = hostedElement.component,
      data = hostedElement.data;
    this.arrangeAndDrawPie(component, data, options.container);
    var pieLayout = component.layout;
    var labelLayout = this.generateLabelLayout(options.containerDimensions, pieLayout, options.labelSize);
    var labelContainer = this.arrangeAndDrawLabel(labelLayout, options.container);
    var percentLayout = this.generatePercentLayout(options.containerDimensions, pieLayout, labelLayout, labelContainer, options.percentSize);
    this.arrangeAndDrawPercent(percentLayout, options.container);
  },
  arrangeAndDrawPie: function arrangeAndDrawPie(pie, data, container) {
    var pieContainer = upgraded_utils_createElementIfAbsent(container, this._regionToContainer.pie);
    pieContainer.datum(data).call(pie);
  },
  arrangeAndDrawLabel: function arrangeAndDrawLabel(layout, container) {
    var hostedElement = this._hostedRegions.label;
    var labelContainer = upgraded_utils_createElementIfAbsent(container, this._regionToContainer.label);
    if (hostedElement) {
      var component = hostedElement.component,
        data = hostedElement.data;
      component.size(layout.size);
      labelContainer.datum(data).call(component).attr('transform', 'translate(' + layout.horizontalTranslation + ',' + layout.verticalTranslation + ')');
    }
    return labelContainer;
  },
  arrangeAndDrawPercent: function arrangeAndDrawPercent(layout, container) {
    var hostedElement = this._hostedRegions.percent;
    var percentContainer = upgraded_utils_createElementIfAbsent(container, this._regionToContainer.percent);
    if (hostedElement) {
      var percent = hostedElement.component;
      var data = hostedElement.data;
      percent.size(layout.size);
      percentContainer.attr('transform', 'translate(' + layout.horizontalTranslation + ',' + layout.verticalTranslation + ')').datum(data).call(percent);
    } else {
      percentContainer.remove();
    }
  },
  generateLabelLayout: function generateLabelLayout(containerDimensions, pieLayout, labelSizeOverride) {
    var fontSizeToFontHeightRatio = 1.35;
    var labelRatio = 0.25;
    var labelSize = this.getLabelSize(labelSizeOverride, pieLayout, labelRatio);
    var actualFontHeight = labelSize / fontSizeToFontHeightRatio;
    var labelVerticalTranslation = containerDimensions.height / 2 + actualFontHeight / 2;
    var labelHorizontalTranslation = containerDimensions.width / 2;
    return {
      size: labelSize,
      verticalTranslation: labelVerticalTranslation,
      horizontalTranslation: labelHorizontalTranslation
    };
  },
  generatePercentLayout: function generatePercentLayout(containerDimensions, pieLayout, labelLayout, labelContainer, percentSize) {
    var labelContainerElement = labelContainer.node();
    var widthOfLabel = labelContainerElement && labelContainerElement.getBBox().width;
    var percentHorizontalTranslation = containerDimensions.width / 2 + widthOfLabel / 2;
    var labelRatio = 0.125;
    return {
      size: this.getLabelSize(percentSize, pieLayout, labelRatio),
      verticalTranslation: labelLayout.verticalTranslation,
      horizontalTranslation: percentHorizontalTranslation
    };
  },
  getLabelSize: function getLabelSize(labelSizeOverride, pieLayout, labelRatio) {
    if (labelSizeOverride) {
      return labelSizeOverride;
    }
    var diameter = pieLayout.outerRadius * 2;
    return diameter * labelRatio;
  }
});
;// ./src/js/viz/d3/charts/round_chart.js











var RoundChartConfig = Object.assign({}, AnimationConfig, ColorSchemeConfig, InteractionConfig, {
  enableDataPointLabels: false,
  dataPointLabelGenerator: function dataPointLabelGenerator() {
    return '';
  },
  enableCenterLabel: false,
  setLabel: function setLabel(label, labelColor, labelSize, labelWeight) {
    this.label = label;
    this.labelColor = labelColor;
    this.labelSize = labelSize;
    this.labelWeight = labelWeight;
    return this;
  },
  showDataPointLabels: function showDataPointLabels(doShowDataPointLabels) {
    this.enableDataPointLabels = !!doShowDataPointLabels;
    if (this.enableDataPointLabels) {
      this.dataPointLabelGenerator = function (dataItem) {
        return "".concat(dataItem.data.label, ": ").concat(dataItem.data.value);
      };
    } else {
      this.dataPointLabelGenerator = function () {
        return '';
      };
    }
    return this;
  },
  setData: function setData(data) {
    var self = this;
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isArray(data)) {
      self.data = data.map(function (dataSegment, index) {
        var value;
        if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isNumber(dataSegment.value)) {
          value = dataSegment.value;
        }
        return {
          value: value,
          label: dataSegment.label,
          pattern: dataSegment.pattern,
          color: dataSegment.color || self.colorScheme(index),
          key: dataSegment.key || ''
        };
      });
    } else {
      self.data = [];
    }
    return self;
  },
  showLabel: function showLabel(val) {
    this.enableCenterLabel = !!val;
    return this;
  },
  showPercentage: function showPercentage(val, size) {
    this.displayPercentage = !!val;
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isNumber(size)) {
      this.percentSize = size;
    }
    return this;
  },
  setDonutRatio: function setDonutRatio(ratio) {
    if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isNumber(ratio) && ratio >= 0 && ratio <= 1) {
      this.donutRatio = ratio;
    } else {
      this.donutRatio = round_chart_DEFAULT_DONUT_RATIO;
    }
    return this;
  }
});
var round_chart_DEFAULT_DONUT_RATIO = 0.84;
var LABEL = 'label';
var PIE = 'pie';
var PERCENT = 'percent';
var PERCENT_SIGN = '%';
var DONUT_TYPE = 'dynamic';
var RoundChart = UpgradedCore.extend(RoundChartConfig).extend({
  initialize: function initialize() {
    this.colorScheme = upgradedBaseColorScheme(LABEL);
    this.layout = new RoundLayout();
    return UpgradedCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.createAndConfigurePie(postRender);
    this.createAndConfigureLabel();
    this.createAndConfigurePercent();
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      animationDuration: this._animationDuration,
      container: this.getContainer(),
      pieRatio: this.donutRatio,
      labelSize: this.labelSize,
      percentSize: this.percentSize
    });
  },
  createAndConfigurePie: function createAndConfigurePie(postRender) {
    this.pie || (this.pie = Pie());
    this.pie.width(this.getContainerWidth()).height(this.getContainerHeight()).isDonut(true).donutType(DONUT_TYPE).donutRatio(this.donutRatio).showLabels(this.enableDataPointLabels).getLabel(this.dataPointLabelGenerator).disableInteraction(true).animationDuration(this._animationDuration);
    if (postRender) {
      this.pie.lifeCycle.on('renderEnd', postRender);
    }
    this.colorScheme && this.pie.colorScheme(this.colorScheme);
    this.layout.host(PIE, this.pie, this.data);
  },
  createAndConfigureLabel: function createAndConfigureLabel() {
    this.labelViz || (this.labelViz = Label());
    this.labelViz.width(this.getContainerWidth()).height(this.getContainerHeight());
    this.labelColor && this.labelViz.color(this.labelColor);
    this.labelSize && this.labelViz.size(this.labelSize);
    this.labelWeight && this.labelViz.weight(this.labelWeight);
    if (this.enableCenterLabel) {
      this.layout.host(LABEL, this.labelViz, this.getLabel());
    } else {
      this.layout.remove(LABEL);
    }
  },
  createAndConfigurePercent: function createAndConfigurePercent() {
    this.percentViz || (this.percentViz = Percent());
    this.percentViz && this.percentViz.size(this.percentSize);
    if (this.displayPercentage) {
      this.layout.host(PERCENT, this.percentViz, PERCENT_SIGN);
    } else {
      this.layout.remove(PERCENT);
    }
  },
  getLabel: function getLabel() {
    return this.label || this.value + '/' + (this.remainingValue + this.value);
  }
});
;// ./src/js/viz/d3/components/breakdownbar.js









var BAR_CONTAINER = 'bar-container';
var BAR = 'bar';
var BAR_SECTION = 'bar-section';
var BAR_LABEL = 'bar-label';
var MAIN_LABEL = 'main-label';
var NUMERICAL_LABEL = 'numerical-label';
var LEGEND_CONTAINER = 'legend-container';
var BAR_WIDTH_STYLES = {
  FIXED: 'fixed',
  RESPONSIVE: 'responsive',
  RESPONSIVE_FULL: 'responsive-full'
};
var ORIENTATIONS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
var breakdownbar_KEYS = constants_Constants.KEYS;
var FIXED_BAR_HEIGHT = 20;
var LABEL_SIZE = 12;
var LABEL_SPACING = 8;
var RESPONSIVE_BAR_HEIGHT = 2 / 3;
var BreakdownBar = function BreakdownBar() {
  var config = {
    animationDuration: constants_Constants.ANIMATION_DURATION,
    disableInteraction: false,
    orientation: ORIENTATIONS.HORIZONTAL,
    generateTooltip: function generateTooltip(evt) {
      var d = evt.d || {};
      return '<div class="dark-dialog">' + d.label + '</div>';
    },
    labelFormat: function labelFormat(d) {
      return d.label;
    },
    getChartLabel: null,
    getNumericalValue: null,
    getPercent: null,
    legend: true,
    tooltip: true,
    barWidthStyle: BAR_WIDTH_STYLES.FIXED,
    width: constants_Constants.DEFAULT_DIMENSIONS.WIDTH,
    height: constants_Constants.DEFAULT_DIMENSIONS.HEIGHT
  };
  var tooltip = upgradedNvTooltip();
  var legendContainer;
  var barContainer;
  var initialTooltipPosition = tooltip.position();
  var lifeCycle = new upgraded_utils_RenderLifeCycle();
  var dispatch = src_dispatch('elementClick');
  var prevOrientation = config.orientation;
  var breakdownBar = function breakdownBar(selection) {
    lifeCycle.start();
    var isHorizontal = config.orientation === ORIENTATIONS.HORIZONTAL;
    var barSectionResizingAttribute = isHorizontal ? 'width' : 'height';
    if (tooltip && external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(config.generateTooltip)) {
      tooltip.contentGenerator(config.generateTooltip);
    }
    selection.each(function (data) {
      var container = src_select(this);
      container.style('width', '100%').style('height', '100%').classed('interactive', !config.disableInteraction);
      barContainer = container.selectAll('.' + BAR_CONTAINER);
      var bar = upgraded_utils_createElementIfAbsent(barContainer, BAR, 'div');
      var clearHighlight = function clearHighlight() {
        container.selectAll(".".concat(BAR_SECTION)).style('opacity', 1);
      };
      bar.attr('tabindex', '0').attr('role', 'group').on('keydown', handleBarKeyDown).on('mouseout', clearHighlight).on('blur', clearHighlight);
      function handleBarKeyDown() {
        var pressedKey = event.key;
        var bars = container.selectAll('.' + BAR_SECTION).nodes();
        if (pressedKey === breakdownbar_KEYS.ENTER || pressedKey === breakdownbar_KEYS.ARROW_RIGHT || pressedKey === breakdownbar_KEYS.ARROW_DOWN) {
          focusSection(bars, 0);
        } else if (pressedKey === breakdownbar_KEYS.ARROW_LEFT || pressedKey === breakdownbar_KEYS.ARROW_UP) {
          focusSection(bars, bars.length - 1);
        }
      }
      updateBarStyling(bar, config);
      if (config.legend) {
        legendContainer = container.selectAll('.' + LEGEND_CONTAINER);
        if (!legendContainer.attr('height')) {
          legendContainer.style('visibility', 'hidden');
          legendContainer.attr('height', 0);
        }
      } else {
        barContainer.style('height', '100%');
      }
      var d3BarSections = bar.selectAll(".".concat(BAR_SECTION)).data(data);
      var d3BarSectionExitSelections = d3BarSections.exit();
      d3BarSectionExitSelections.selectAll(".".concat(BAR_LABEL)).style('visibility', 'hidden');
      d3BarSectionExitSelections.remove();
      var d3BarSectionsMergeSelection = d3BarSections.enter().append('div').classed(BAR_SECTION, true).merge(d3BarSections);
      d3BarSectionsMergeSelection.append('div').classed(BAR_LABEL, true);
      d3BarSectionsMergeSelection.attr('tabindex', '-1').attr('aria-label', getSegmentAriaLabel).on('keydown', handleSegmentKeyDown).on('keyup', function (event, d) {
        if (event.key === breakdownbar_KEYS.SPACE) {
          dispatch.call('elementClick', this, d);
        }
      });
      function focusSection(elements, index) {
        if (index >= 0 && index < elements.length) {
          elements[index].focus();
        }
      }
      function highlightSegment(segment) {
        d3BarSectionsMergeSelection.style('opacity', 0.25);
        segment.style('opacity', 1);
      }
      function handleSegmentKeyDown(event, d) {
        var i = d.index;
        event.stopPropagation();
        var pressedKey = event.key;
        switch (pressedKey) {
          case breakdownbar_KEYS.ARROW_DOWN:
          case breakdownbar_KEYS.ARROW_RIGHT:
            focusSection(d3BarSectionsMergeSelection.nodes(), i + 1);
            break;
          case breakdownbar_KEYS.ARROW_UP:
          case breakdownbar_KEYS.ARROW_LEFT:
            focusSection(d3BarSectionsMergeSelection.nodes(), i - 1);
            break;
          case breakdownbar_KEYS.ENTER:
            dispatch.call('elementClick', this, d);
            break;
          case breakdownbar_KEYS.SPACE:
            event.preventDefault();
            break;
        }
      }
      d3BarSectionsMergeSelection.style('background-color', function (d) {
        return d.color;
      });
      d3BarSectionsMergeSelection.style('box-sizing', 'border-box');
      d3BarSectionsMergeSelection.classed('dark-fill', function (d) {
        return upgraded_utils_getContrastingColor(d.color) === '#ffffff';
      });
      if (config.orientation === ORIENTATIONS.HORIZONTAL) {
        d3BarSectionsMergeSelection.style('height', '100%');
      } else {
        d3BarSectionsMergeSelection.style('width', '100%');
      }
      var d3LabelSections = d3BarSectionsMergeSelection.select('.' + BAR_LABEL);
      var labelsText = d3BarSectionsMergeSelection.selectAll('tspan');
      function getNumericalLabel(d, i) {
        var percent = config.getPercent ? config.getPercent(d, i) : '';
        var numericalValue = config.getNumericalValue ? config.getNumericalValue(d, i) : '';
        if (numericalValue) {
          numericalValue = " (".concat(numericalValue, ")");
        }
        return " ".concat(percent).concat(numericalValue);
      }
      d3LabelSections.style('visibility', 'hidden');
      if (config.getChartLabel) {
        labelsText.remove();
        d3LabelSections.append('tspan').attr('class', MAIN_LABEL).text(config.getChartLabel);
        if (config.getPercent || config.getNumericalValue) {
          d3LabelSections.append('tspan').attr('class', NUMERICAL_LABEL).text(getNumericalLabel);
        }
      } else {
        d3LabelSections.text(config.labelFormat);
      }
      var shouldStartFromZero = prevOrientation !== config.orientation;
      prevOrientation = config.orientation;
      var endTransitionPositionLegend = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().once(function () {
        if (config.legend && legendContainer) {
          var bbox = legendContainer.node().getBBox();
          legendContainer.style('visibility', 'visible');
          legendContainer.attr('height', bbox.height);
          updateBarStyling(bar, config);
        }
      });
      var labelsWillFitAboveBar = false;
      if (config.orientation === ORIENTATIONS.HORIZONTAL) {
        if (config.barWidthStyle === BAR_WIDTH_STYLES.FIXED) {
          labelsWillFitAboveBar = config.height > FIXED_BAR_HEIGHT + 2 * (LABEL_SIZE + LABEL_SPACING);
        } else if (config.barWidthStyle === BAR_WIDTH_STYLES.RESPONSIVE) {
          labelsWillFitAboveBar = config.height / 3 >= 2 * (LABEL_SIZE + LABEL_SPACING);
        }
      } else {
        labelsWillFitAboveBar = true;
      }
      d3BarSectionsMergeSelection.transition('sizeTransitions').duration(config.animationDuration).styleTween(barSectionResizingAttribute, function (d) {
        var containerSize = config[barSectionResizingAttribute];
        var currentBarSize = containerSize * d.barWidth / 100;
        var currentSize = this.dataset.size;
        if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isNaN(parseFloat(currentSize))) {
          currentSize = 0;
        }
        return string(shouldStartFromZero ? '0px' : "".concat(currentSize, "px"), "".concat(currentBarSize, "px"));
      }).on('end.sizeTransitions', function (d) {
        var barSection = src_select(this);
        barSection.attr('data-size', d.barWidth);
        var barLabel = barSection.select(".".concat(BAR_LABEL));
        var barSectionNode = barSection.node();
        var barLabelNode = barLabel.node();
        if (barSectionNode && barLabelNode) {
          var barSectionRect = barSectionNode.getBoundingClientRect();
          var barLabelRect = barLabelNode.getBoundingClientRect();
          var isNotOverflowing = config.orientation === ORIENTATIONS.HORIZONTAL ? barLabelRect.width <= barSectionRect.width : barLabelRect.height <= barSectionRect.height;
          if (isNotOverflowing && labelsWillFitAboveBar || isNotOverflowing && config.barWidthStyle === BAR_WIDTH_STYLES.RESPONSIVE_FULL) {
            barLabel.style('visibility', 'visible');
          }
          if (config.orientation === ORIENTATIONS.HORIZONTAL) {
            var translateValue = 0;
            if (config.barWidthStyle === BAR_WIDTH_STYLES.RESPONSIVE) {
              translateValue = config.height * RESPONSIVE_BAR_HEIGHT * 1 / 2 + LABEL_SIZE + LABEL_SPACING;
            } else if (config.barWidthStyle === BAR_WIDTH_STYLES.FIXED) {
              translateValue = FIXED_BAR_HEIGHT + LABEL_SPACING + 1 / 2 * LABEL_SIZE;
            }
            barLabel.style('transform', "translate(-50%, -".concat(translateValue, "px)"));
          } else {
            barLabel.style('transform', 'translateY(-50%)');
          }
        }
        endTransitionPositionLegend();
      }).call(lifeCycle.watch);
      if (!config.disableInteraction) {
        var gravity = function gravity() {
          return isHorizontal ? constants_Constants.GRAVITY.SOUTH : constants_Constants.GRAVITY.EAST;
        };
        d3BarSectionsMergeSelection.on('mousemove', function () {
          tooltip();
        }).on('mouseover', function (event, d) {
          highlightSegment(src_select(this));
          var evt = {
            d: d,
            series: [{
              key: d.label
            }]
          };
          if (config.tooltip) {
            tooltip.position(initialTooltipPosition).duration(0).data(evt).gravity(gravity()).hidden(false);
          }
        }).on('mouseout', function () {
          tooltip.hidden(true);
        }).on('focus', function (event, d) {
          highlightSegment(src_select(this));
          var evt = {
            d: d,
            series: [{
              key: d.label
            }]
          };
          if (config.tooltip) {
            var segment = src_select(this);
            tooltip.position(function () {
              return getSegmentCenter(segment, config.orientation, config.barWidthStyle !== BAR_WIDTH_STYLES.FIXED);
            }).duration(0).data(evt).gravity(gravity()).hidden(false);
          }
        }).on('blur', function () {
          tooltip.hidden(true);
          clearHighlight();
        });
        d3BarSectionsMergeSelection.on('click', function (event, d) {
          dispatch.call('elementClick', this, d);
        });
      }
      lifeCycle.dispatchOnCompletion();
    });
  };
  function updateBarStyling(bar, config) {
    bar.classed('horizontal', config.orientation === ORIENTATIONS.HORIZONTAL);
    bar.classed('vertical', config.orientation === ORIENTATIONS.VERTICAL);
    external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(BAR_WIDTH_STYLES, function (val) {
      bar.classed(val, config.barWidthStyle === val);
    });
  }
  upgraded_utils_exposeConfig(breakdownBar, config);
  breakdownBar.dispatch = dispatch;
  breakdownBar.lifeCycle = lifeCycle.dispatch;
  return breakdownBar;
};
function getSegmentCenter(segment, orientation, isResponsive) {
  var segmentRect = segment.node().getBoundingClientRect();
  return {
    left: isResponsive && orientation === ORIENTATIONS.VERTICAL ? segmentRect.x : segmentRect.x + segmentRect.width / 2,
    top: isResponsive && orientation === ORIENTATIONS.HORIZONTAL ? segmentRect.y : segmentRect.y + segmentRect.height / 2
  };
}
function getSegmentAriaLabel(segmentData) {
  var ariaLabel = [];
  if (segmentData.label) {
    ariaLabel.push(segmentData.label);
  }
  if (segmentData.percentage || segmentData.percentage === 0 || segmentData.pct || segmentData.pct === 0) {
    var _segmentData$percenta;
    var percentage = (_segmentData$percenta = segmentData.percentage) !== null && _segmentData$percenta !== void 0 ? _segmentData$percenta : segmentData.pct;
    ariaLabel.push(translationService.translate('DQ.PercentageLabel', {
      percentage: percentage
    }));
  }
  if (segmentData.value || segmentData.value === 0) {
    ariaLabel.push(segmentData.value);
  }
  switch (ariaLabel.length) {
    case 1:
      return ariaLabel[0];
    case 2:
      return translationService.translate('DQ.TwoItemList', {
        first: ariaLabel[0],
        second: ariaLabel[1]
      });
    case 3:
      return translationService.translate('DQ.ThreeItemList', {
        first: ariaLabel[0],
        second: ariaLabel[1],
        third: ariaLabel[2]
      });
    default:
      return '';
  }
}
;// ./src/js/tooltip/standard_tooltip.js


function createWrapper() {
  var div = document.createElement('div');
  div.className = 'dark-dialog';
  return div;
}
var standardTooltip = function standardTooltip(label, value, color) {
  var tooltip = createWrapper();
  tooltip.innerHTML = "\n\t\t<table>\n\t\t\t<tbody>\n\t\t\t\t<tr>\n\t\t\t\t\t<td class=\"legend-color-guide\">\n\t\t\t\t\t\t<div style=\"background-color:".concat(color || '', "\"></div\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"key\">").concat(label || '', "</td>\n\t\t\t\t\t<td class=\"value\">").concat(value || '', "</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t").trim();
  return purify(window).sanitize(tooltip, {
    RETURN_DOM: true,
    ALLOWED_ATTR: constants_Constants.ALLOWED_ATTR,
    ALLOWED_TAGS: constants_Constants.ALLOWED_TAGS
  });
};
;// ./src/js/viz/d3/charts/breakdownbar_chart.js














var ALLOWED_ORIENTATIONS = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
var LEGEND_POSITIONS = constants_Constants.LEGEND_POSITIONS;
var breakdownbar_chart_LEGEND_PADDING = 16;
var LEGEND_MAX_KEY_WIDTH = 0.8;
var LEGEND_MAX_KEY_HEIGHT = 0.5;
function isLegendBeforeBar(legendPosition) {
  return legendPosition === LEGEND_POSITIONS.LEFT || legendPosition === LEGEND_POSITIONS.TOP;
}
function isLegendOnSide(legendPosition) {
  return legendPosition === LEGEND_POSITIONS.LEFT || legendPosition === LEGEND_POSITIONS.RIGHT;
}
var BreakdownBarConfig = Object.assign({}, BaseChartConfig, EventConfig, TooltipConfig, {
  _chartLabel: null,
  _chartLabelValue: null,
  _chartLabelPercent: null,
  tooltip: function tooltip(evt) {
    var _evt$d = evt.d,
      d = _evt$d === void 0 ? {} : _evt$d;
    var color = d.color,
      label = d.label,
      percentageLabel = d.percentageLabel,
      value = d.value;
    var labelExtension = getTooltipLabelExtension(percentageLabel, value);
    return standardTooltip(label, labelExtension, color).outerHTML;
  },
  _orientation: 'horizontal',
  _barWidthStyle: 'fixed',
  setOrientation: function setOrientation(orientation) {
    if (ALLOWED_ORIENTATIONS[orientation]) {
      this._orientation = orientation;
    }
    return this;
  },
  setBarWidthStyle: function setBarWidthStyle(style) {
    if (style) {
      this._barWidthStyle = style;
    }
    return this;
  },
  setChartLabel: function setChartLabel(chartLabel) {
    if (typeof chartLabel === 'function') {
      this._chartLabel = chartLabel;
    }
    return this;
  },
  setLabelShowNumericalValue: function setLabelShowNumericalValue(valueFormatter) {
    if (typeof valueFormatter === 'function') {
      this._chartLabelValue = valueFormatter;
    }
    return this;
  },
  setLabelShowPercent: function setLabelShowPercent(percentFormatter) {
    if (typeof percentFormatter === 'function') {
      this._chartLabelPercent = percentFormatter;
    }
    return this;
  },
  _labelFormat: (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).identity,
  setLabelFormat: function setLabelFormat(labelFormat) {
    if (typeof labelFormat === 'function') {
      this._labelFormat = labelFormat;
    }
    return this;
  },
  legendLabelFormat: function legendLabelFormat(d) {
    return d.label;
  },
  setLegendLabelFormat: function setLegendLabelFormat(legendLabelFormat) {
    if (typeof legendLabelFormat === 'function') {
      this.legendLabelFormat = legendLabelFormat;
    }
    return this;
  }
});
var BreakdownBarChart = UpgradedCore.extend(BreakdownBarConfig).extend({
  wrapContainer: function wrapContainer() {
    var isInitalRender = this._prevLegendPosition === undefined;
    var previousRenderIsLegendBeforeBar = isLegendBeforeBar(this._prevLegendPosition);
    var currentRenderIsLegendBeforeBar = isLegendBeforeBar(this._legendPosition);
    var chartContainers = this.getParentContainer().select('.dq');
    if (!this.hasContainer() && chartContainers.empty()) {
      isInitalRender = true;
      this.containerId = this.containerId || external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().uniqueId('DqChart');
      this.getParentContainer().append('div').attr('id', this.containerId).classed('dq', true).classed((less_default()).dq, true);
    }
    var container = this.getContainer();
    var needsToRerender = isInitalRender || previousRenderIsLegendBeforeBar !== currentRenderIsLegendBeforeBar;
    if (needsToRerender && currentRenderIsLegendBeforeBar) {
      container.html('');
      upgraded_utils_createElementIfAbsent(container, LEGEND_CONTAINER, 'svg');
      upgraded_utils_createElementIfAbsent(container, BAR_CONTAINER, 'div');
    } else if (needsToRerender) {
      container.html('');
      upgraded_utils_createElementIfAbsent(container, BAR_CONTAINER, 'div');
      upgraded_utils_createElementIfAbsent(container, LEGEND_CONTAINER, 'svg');
    }
    container.classed('disable-animation', this._animationDuration === 0);
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.getContainer().selectAll(".".concat(BAR_CONTAINER)).style('display', 'none');
    this.getContainer().selectAll(".".concat(LEGEND_CONTAINER)).style('display', 'none');
    var layout = {
      availableWidth: this.getContainerWidth(),
      availableHeight: this.getContainerHeight()
    };
    this.createAndConfigureLegend(layout);
    this.createAndConfigureChart(layout);
    this.configureEventListeners();
    if (postRender) {
      this.bar.lifeCycle.on('renderEnd', postRender);
    }
    return this;
  },
  createAndConfigureChart: function createAndConfigureChart(layout) {
    this.bar = this.bar || BreakdownBar();
    var isSide = isLegendOnSide(this._legendPosition);
    this.bar.width(layout.availableWidth).height(layout.availableHeight).generateTooltip(this.tooltip).tooltip(this._showTooltip).disableInteraction(this._disableInteraction).animationDuration(this._animationDuration).labelFormat(this._labelFormat).legend(this._shouldShowLegend).orientation(this._orientation).barWidthStyle(this._barWidthStyle);
    if (this._chartLabel) {
      this.bar.getChartLabel(this._chartLabel).getNumericalValue(this._chartLabelValue).getPercent(this._chartLabelPercent);
    }
    this.ignoredData = [];
    this.getContainer().datum(breakdownbar_chart_processData(this.getData())).call(this.bar);
    this.getContainer().selectAll(".".concat(BAR_CONTAINER)).style('height', "".concat(layout.availableHeight, "px")).style('width', "".concat(layout.availableWidth, "px")).style('display', isSide ? 'inline-block' : 'block');
  },
  createAndConfigureLegend: function createAndConfigureLegend(layout) {
    var _this = this;
    var legendContainer = this.getContainer().selectAll(".".concat(LEGEND_CONTAINER)).style('display', '');
    if (!this._shouldShowLegend) {
      legendContainer.classed('disabled', true);
      return;
    }
    this.legend = this.legend || upgradedDqLegend();
    var isSide = isLegendOnSide(this._legendPosition);
    this.legend.orientation(isSide ? ALLOWED_ORIENTATIONS.vertical : ALLOWED_ORIENTATIONS.horizontal).clickDisabled(this.shouldDisableLegendClick()).animationDuration(this._animationDuration).width(layout.availableWidth).height(layout.availableHeight).automatedMaxKeyLengthLegendWidth(LEGEND_MAX_KEY_WIDTH).automatedMaxKeyLengthLegendHeight(LEGEND_MAX_KEY_HEIGHT).getKey(this.legendLabelFormat).alignment(this._legendAlignment);
    this.legend.dispatch.on('legendClick', function (d) {
      if (d.disabled && !external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().find(_this.ignoredData, {
        label: d.label
      })) {
        _this.ignoredData.push(d);
      } else {
        external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().remove(_this.ignoredData, {
          label: d.label
        });
      }
      var filteredData = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().filter(_this.getData(), function (datum) {
        return !external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().find(_this.ignoredData, {
          label: datum.label
        });
      });
      _this.getContainer().datum(breakdownbar_chart_processData(filteredData)).call(_this.bar);
    });
    legendContainer.classed('disabled', false).style('margin-bottom', this._legendPosition === LEGEND_POSITIONS.TOP ? "".concat(breakdownbar_chart_LEGEND_PADDING, "px") : '0px').style('margin-right', this._legendPosition === LEGEND_POSITIONS.LEFT ? "".concat(breakdownbar_chart_LEGEND_PADDING, "px") : '0px').style('margin-top', this._legendPosition === LEGEND_POSITIONS.BOTTOM ? "".concat(breakdownbar_chart_LEGEND_PADDING, "px") : '0px').style('margin-left', this._legendPosition === LEGEND_POSITIONS.RIGHT ? "".concat(breakdownbar_chart_LEGEND_PADDING, "px") : '0px').style('width', "".concat(layout.availableWidth, "px")).style('height', "".concat(layout.availableHeight, "px")).datum(breakdownbar_chart_processData(this.getData())).call(this.legend);
    layout.availableWidth -= isSide ? this.legend.width() + breakdownbar_chart_LEGEND_PADDING : 0;
    layout.availableHeight -= isSide ? 0 : this.legend.height() + breakdownbar_chart_LEGEND_PADDING;
    legendContainer.style(isSide ? 'width' : 'height', this.legend[isSide ? 'width' : 'height']() + 'px');
  },
  configureEventListeners: function configureEventListeners() {
    if (this._disableInteraction) {
      this.clearAllEvents();
      return;
    }
    var self = this;
    external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(this._eventHandlers, function (handler, event) {
      self.bar.dispatch.on(event, handler);
    });
  }
});
function breakdownbar_chart_processData(data) {
  var sum = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().reduce(data, function (accum, entry) {
    return accum + entry.value;
  }, 0);
  var sumOfPercentages = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().reduce(data, function (accum, entry) {
    if (entry.percentage) {
      return accum + entry.percentage;
    }
    return accum;
  }, 0);
  external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().forEach(data, function (entry) {
    entry.legendShape = 'circle';
    if (entry.percentage === undefined || entry.percentage === null) {
      entry.percentage = sum ? entry.value / sum * 100 : 0;
      entry.barWidth = entry.percentage;
    } else {
      if (sumOfPercentages && sumOfPercentages > 100) {
        entry.barWidth = entry.percentage / sumOfPercentages * 100;
      } else {
        entry.barWidth = entry.percentage;
      }
    }
  });
  return data;
}
function getTooltipLabelExtension(percentageLabel, value) {
  return [percentageLabel, value].filter(function (val) {
    return val !== undefined;
  }).join(' ');
}
;// ./src/js/viz/d3/maps/usa/topology.js
var topology = {
  type: 'Topology',
  transform: {
    scale: [0.03514630243024302, 0.005240860686068607],
    translate: [-178.123152, 18.948267]
  },
  objects: {
    usa: {
      type: 'GeometryCollection',
      geometries: [{
        type: 'Polygon',
        id: 'AL',
        arcs: [[0, 1, 2, 3, 4]],
        properties: {
          name: 'Alabama'
        }
      }, {
        type: 'MultiPolygon',
        id: 'AK',
        arcs: [[[5]], [[6]], [[7]], [[8]], [[9]], [[10]], [[11]], [[12]], [[13]], [[14]], [[15]], [[16]], [[17]], [[18]], [[19]], [[20]], [[21]], [[22]], [[23]], [[24]], [[25]], [[26]], [[27]], [[28]], [[29]], [[30]], [[31]], [[32]], [[33]], [[34]], [[35]], [[36]], [[37]], [[38]], [[39]], [[40]], [[41]], [[42]], [[43]]],
        properties: {
          name: 'Alaska'
        }
      }, {
        type: 'Polygon',
        id: 'AZ',
        arcs: [[44, 45, 46, 47, 48]],
        properties: {
          name: 'Arizona'
        }
      }, {
        type: 'Polygon',
        id: 'AR',
        arcs: [[49, 50, 51, 52, 53, 54]],
        properties: {
          name: 'Arkansas'
        }
      }, {
        type: 'Polygon',
        id: 'CA',
        arcs: [[55, -47, 56, 57]],
        properties: {
          name: 'California'
        }
      }, {
        type: 'Polygon',
        id: 'CO',
        arcs: [[58, 59, 60, 61, 62, 63]],
        properties: {
          name: 'Colorado'
        }
      }, {
        type: 'Polygon',
        id: 'CT',
        arcs: [[64, 65, 66, 67]],
        properties: {
          name: 'Connecticut'
        }
      }, {
        type: 'Polygon',
        id: 'DE',
        arcs: [[68, 69, 70, 71]],
        properties: {
          name: 'Delaware'
        }
      }, {
        type: 'Polygon',
        id: 'DC',
        arcs: [[72, 73]],
        properties: {
          name: 'District of Columbia'
        }
      }, {
        type: 'Polygon',
        id: 'FL',
        arcs: [[74, 75, -2]],
        properties: {
          name: 'Florida'
        }
      }, {
        type: 'Polygon',
        id: 'GA',
        arcs: [[76, 77, -75, -1, 78, 79]],
        properties: {
          name: 'Georgia'
        }
      }, {
        type: 'MultiPolygon',
        id: 'HI',
        arcs: [[[80]], [[81]], [[82]], [[83]], [[84]]],
        properties: {
          name: 'Hawaii'
        }
      }, {
        type: 'Polygon',
        id: 'ID',
        arcs: [[85, 86, 87, 88, 89, 90, 91]],
        properties: {
          name: 'Idaho'
        }
      }, {
        type: 'Polygon',
        id: 'IL',
        arcs: [[92, 93, 94, 95, 96, 97]],
        properties: {
          name: 'Illinois'
        }
      }, {
        type: 'Polygon',
        id: 'IN',
        arcs: [[98, 99, -95, 100, 101]],
        properties: {
          name: 'Indiana'
        }
      }, {
        type: 'Polygon',
        id: 'IA',
        arcs: [[102, -98, 103, 104, 105, 106]],
        properties: {
          name: 'Iowa'
        }
      }, {
        type: 'Polygon',
        id: 'KS',
        arcs: [[107, 108, -60, 109]],
        properties: {
          name: 'Kansas'
        }
      }, {
        type: 'Polygon',
        id: 'KY',
        arcs: [[110, 111, 112, 113, -96, -100, 114]],
        properties: {
          name: 'Kentucky'
        }
      }, {
        type: 'Polygon',
        id: 'LA',
        arcs: [[115, 116, 117, -52]],
        properties: {
          name: 'Louisiana'
        }
      }, {
        type: 'Polygon',
        id: 'ME',
        arcs: [[118, 119]],
        properties: {
          name: 'Maine'
        }
      }, {
        type: 'MultiPolygon',
        id: 'MD',
        arcs: [[[120]], [[-71, 121, 122, 123, 124, -74, 125, 126, 127]]],
        properties: {
          name: 'Maryland'
        }
      }, {
        type: 'Polygon',
        id: 'MA',
        arcs: [[128, 129, 130, 131, -68, 132, 133, 134]],
        properties: {
          name: 'Massachusetts'
        }
      }, {
        type: 'MultiPolygon',
        id: 'MI',
        arcs: [[[-102, 135, 136]], [[137]], [[138, 139]], [[140]]],
        properties: {
          name: 'Michigan'
        }
      }, {
        type: 'Polygon',
        id: 'MN',
        arcs: [[-107, 141, 142, 143, 144]],
        properties: {
          name: 'Minnesota'
        }
      }, {
        type: 'Polygon',
        id: 'MS',
        arcs: [[-4, 145, -116, -51, 146]],
        properties: {
          name: 'Mississippi'
        }
      }, {
        type: 'Polygon',
        id: 'MO',
        arcs: [[-97, -114, 147, -55, 148, -108, 149, -104]],
        properties: {
          name: 'Missouri'
        }
      }, {
        type: 'Polygon',
        id: 'MT',
        arcs: [[150, 151, -92, 152, 153]],
        properties: {
          name: 'Montana'
        }
      }, {
        type: 'Polygon',
        id: 'NE',
        arcs: [[-105, -150, -110, -59, 154, 155]],
        properties: {
          name: 'Nebraska'
        }
      }, {
        type: 'Polygon',
        id: 'NV',
        arcs: [[156, -48, -56, 157, -88]],
        properties: {
          name: 'Nevada'
        }
      }, {
        type: 'Polygon',
        id: 'NH',
        arcs: [[-135, 158, 159, -120, 160]],
        properties: {
          name: 'New Hampshire'
        }
      }, {
        type: 'Polygon',
        id: 'NJ',
        arcs: [[161, -69, 162, 163]],
        properties: {
          name: 'New Jersey'
        }
      }, {
        type: 'Polygon',
        id: 'NM',
        arcs: [[164, 165, 166, -45, -62]],
        properties: {
          name: 'New Mexico'
        }
      }, {
        type: 'Polygon',
        id: 'NY',
        arcs: [[-133, -67, 167, -164, 168, 169, 170]],
        properties: {
          name: 'New York'
        }
      }, {
        type: 'Polygon',
        id: 'NC',
        arcs: [[171, 172, -80, 173, 174]],
        properties: {
          name: 'North Carolina'
        }
      }, {
        type: 'Polygon',
        id: 'ND',
        arcs: [[175, -154, 176, -143]],
        properties: {
          name: 'North Dakota'
        }
      }, {
        type: 'Polygon',
        id: 'OH',
        arcs: [[177, -115, -99, -137, 178, 179]],
        properties: {
          name: 'Ohio'
        }
      }, {
        type: 'Polygon',
        id: 'OK',
        arcs: [[-149, -54, 180, -165, -61, -109]],
        properties: {
          name: 'Oklahoma'
        }
      }, {
        type: 'Polygon',
        id: 'OR',
        arcs: [[-89, -158, -58, 181, 182]],
        properties: {
          name: 'Oregon'
        }
      }, {
        type: 'Polygon',
        id: 'PA',
        arcs: [[-163, -72, -128, 183, -180, 184, -169]],
        properties: {
          name: 'Pennsylvania'
        }
      }, {
        type: 'MultiPolygon',
        id: 'RI',
        arcs: [[[185, -130]], [[186, -65, -132]]],
        properties: {
          name: 'Rhode Island'
        }
      }, {
        type: 'Polygon',
        id: 'SC',
        arcs: [[187, -77, -173]],
        properties: {
          name: 'South Carolina'
        }
      }, {
        type: 'Polygon',
        id: 'SD',
        arcs: [[-142, -106, -156, 188, -151, -176]],
        properties: {
          name: 'South Dakota'
        }
      }, {
        type: 'Polygon',
        id: 'TN',
        arcs: [[189, -174, -79, -5, -147, -50, -148, -113]],
        properties: {
          name: 'Tennessee'
        }
      }, {
        type: 'Polygon',
        id: 'TX',
        arcs: [[-53, -118, 190, -166, -181]],
        properties: {
          name: 'Texas'
        }
      }, {
        type: 'Polygon',
        id: 'UT',
        arcs: [[191, -63, -49, -157, -87]],
        properties: {
          name: 'Utah'
        }
      }, {
        type: 'Polygon',
        id: 'VT',
        arcs: [[-134, -171, 192, -159]],
        properties: {
          name: 'Vermont'
        }
      }, {
        type: 'MultiPolygon',
        id: 'VA',
        arcs: [[[193, -123]], [[120]], [[-126, -73, -125, 194, -175, -190, -112, 195]]],
        properties: {
          name: 'Virginia'
        }
      }, {
        type: 'MultiPolygon',
        id: 'WA',
        arcs: [[[-183, 196, -90]], [[197]], [[198]]],
        properties: {
          name: 'Washington'
        }
      }, {
        type: 'Polygon',
        id: 'WV',
        arcs: [[-184, -127, -196, -111, -178]],
        properties: {
          name: 'West Virginia'
        }
      }, {
        type: 'Polygon',
        id: 'WI',
        arcs: [[199, -93, -103, -145, 200, -140]],
        properties: {
          name: 'Wisconsin'
        }
      }, {
        type: 'Polygon',
        id: 'WY',
        arcs: [[-189, -155, -64, -192, -86, -152]],
        properties: {
          name: 'Wyoming'
        }
      }]
    }
  },
  arcs: [[[2632, 3060], [5, -164], [7, -242], [4, -53], [3, -30], [-2, -19], [4, -11], [-5, -25], [0, -24], [-2, -32], [2, -57], [-2, -51], [3, -52]], [[2649, 2300], [-14, -1], [-59, 0], [-1, -25], [6, -37], [-1, -31], [2, -16], [-4, -28]], [[2578, 2162], [-4, -6], [-7, 31], [-1, 47], [-2, 6], [-3, -36], [-1, -34], [-7, 9]], [[2553, 2179], [-2, 291], [6, 363], [4, 209], [-3, 20]], [[2558, 3062], [24, 1], [50, -3]], [[1324, 6901], [1, 32], [6, -19], [-1, -32], [-8, 4], [2, 15]], [[1317, 6960], [5, -23], [-3, -33], [-2, 11], [0, 45]], [[1285, 7153], [6, 5], [3, -8], [-1, -28], [-6, -6], [-5, 17], [3, 20]], [[1267, 7137], [12, -7], [3, -36], [13, -41], [4, -25], [0, -21], [3, -4], [1, -27], [5, -27], [0, -25], [3, 8], [2, -19], [1, -74], [-3, -17], [-7, 3], [-3, 38], [-2, -3], [-6, 28], [-2, -10], [-5, 10], [1, -28], [5, 7], [3, -10], [-2, -39], [-5, 4], [-9, 49], [-2, 25], [1, 26], [-7, -2], [0, 20], [5, 2], [5, 18], [-2, 31], [-6, 7], [-1, 50], [-2, 25], [-4, -18], [-2, 28], [4, 14], [-3, 32], [2, 8]], [[1263, 6985], [5, -12], [4, 15], [4, -7], [-4, -28], [-6, 8], [-3, 24]], [[1258, 7247], [-4, 19], [5, 13], [15, -18], [7, 1], [5, -36], [9, -29], [-1, -22], [-5, -11], [-6, 5], [-5, -14], [-6, 9], [-7, -9], [-1, 45], [0, 30], [-5, 1], [-1, 16]], [[1252, 7162], [-4, 14], [-4, 32], [0, 24], [3, 11], [4, -11], [0, 20], [12, -35], [1, -33], [-4, -5], [-3, -37], [3, -11], [-3, -43], [-5, 9], [0, -27], [-3, 13], [-2, 54], [5, 25]], [[1207, 7331], [8, 38], [3, -16], [7, -13], [6, -2], [0, -30], [6, -99], [0, -85], [-1, -22], [-4, 13], [-10, 84], [-7, 25], [3, 20], [-3, 48], [-8, 39]], [[1235, 7494], [10, -15], [5, 2], [0, -14], [8, -52], [-5, 8], [-2, -18], [6, -27], [2, -48], [-6, -13], [-2, -16], [-10, -35], [-3, 1], [-1, 37], [2, 22], [-1, 32], [-3, 40], [0, 21], [-2, 51], [-4, 22], [-1, 38], [7, -36]], [[1203, 7324], [4, 0], [4, -35], [-2, -24], [-6, -5], [0, 38], [0, 26]], [[1207, 7331], [-5, 7], [-3, 26], [-6, 18], [-5, 37], [-6, 17], [1, 30], [4, 10], [1, 26], [3, -11], [8, -1], [6, 17], [8, -23], [-5, -26], [2, -9], [4, 28], [10, -9], [5, -21], [-3, -38], [3, -3], [3, -50], [-7, -7], [-14, 41], [0, -42], [-4, -17]], [[883, 7871], [-12, -48], [-1, -19], [-9, -12], [2, 29], [10, 30], [7, 34], [3, -14]], [[870, 7943], [-2, -39], [-4, -41], [-6, 14], [5, 47], [7, 19]], [[863, 9788], [3, -8], [15, -9], [8, 5], [10, 0], [12, -7], [7, 4], [7, -15], [12, -18], [16, -4], [5, 10], [11, 6], [4, 14], [12, 2], [0, -9], [7, 5], [15, -15], [9, -24], [10, -11], [2, -11], [8, -2], [8, -18], [1, -11], [5, 9], [6, -7], [0, -1783], [13, -16], [2, 17], [14, -24], [8, 30], [18, 4], [-3, -52], [4, -17], [10, -17], [2, -27], [29, -101], [4, -63], [6, 17], [12, 31], [7, 1], [3, 23], [0, 34], [5, 0], [1, 31], [9, 7], [13, 26], [13, -45], [-1, -27], [3, -27], [7, -7], [10, -40], [-1, -12], [4, -22], [12, -25], [19, -110], [3, -29], [6, -29], [8, -65], [9, -55], [-3, -23], [9, -9], [-2, -33], [7, -14], [1, -38], [7, 2], [14, -40], [9, -7], [5, -19], [4, -5], [1, -19], [9, -5], [3, -23], [-4, -43], [1, -36], [4, -58], [-4, -15], [-6, -53], [-10, -39], [-3, 20], [-4, -6], [-3, 39], [1, 17], [-3, 20], [7, 21], [-2, 7], [-7, -26], [-3, 17], [-4, -10], [-12, 42], [4, 46], [-8, -15], [0, -23], [-6, 17], [-1, 22], [4, 24], [-1, 24], [-6, -19], [-6, 42], [-3, -8], [-2, 36], [5, 23], [6, 0], [-2, 28], [3, 36], [-5, -1], [-9, 32], [-6, 37], [-15, 27], [0, 77], [-4, 9], [1, 31], [-5, 9], [-8, 42], [-2, 22], [-12, 7], [-14, 56], [-6, 132], [-3, -30], [1, -27], [6, -53], [-1, -8], [3, -43], [0, -28], [-6, 6], [-4, 31], [-6, 6], [-8, -9], [0, 45], [-5, 38], [-5, -12], [-17, 40], [-2, -11], [10, -13], [7, -31], [3, -1], [1, -25], [4, -30], [-10, -16], [-5, 10], [0, -26], [-8, 20], [-2, 14], [-5, 0], [-13, 38], [-10, 33], [-1, 20], [-5, 30], [-14, 21], [-9, 21], [-14, 26], [-9, 24], [1, 26], [2, -9], [3, 17], [-3, 38], [4, 21], [-2, 9], [-7, -40], [-14, -26], [-18, 10], [-14, 24], [-1, 18], [-7, -4], [-7, 14], [-17, 12], [-9, 1], [-21, -10], [-8, -7], [-10, 27], [-12, 12], [-3, 17], [-2, 28], [-8, -2], [-3, -25], [-15, 34], [-2, 14], [-15, -27], [-7, -32], [-3, 30], [3, 17], [4, -5], [14, 22], [-2, 17], [-6, -8], [-3, 22], [-6, 3], [-6, 55], [-3, -13], [-8, -8], [-3, 8], [-3, -18], [-11, 6], [-1, -20], [-7, -5], [-3, 7], [2, 36], [-3, -1], [-5, -38], [7, -12], [1, -27], [4, -30], [-3, -31], [-5, 10], [-2, -15], [6, -7], [3, -41], [-8, -9], [-4, 9], [-7, -12], [-3, 10], [-9, -2], [0, 16], [-4, -10], [-3, -20], [-3, 18], [-5, -25], [2, -12], [-6, -15], [-6, -2], [-3, -20], [-6, -17], [-4, 6], [-5, -21], [-4, 1], [-8, -43], [-9, -3], [-3, 14], [-5, -23], [-11, 17], [2, 33], [8, 11], [4, -2], [2, 13], [8, 25], [0, 21], [-11, -28], [-9, 16], [-1, 12], [5, 48], [8, 34], [1, 29], [2, 5], [1, 30], [-4, 34], [10, 12], [19, 48], [4, -19], [6, -5], [9, 20], [-10, 26], [-4, 20], [-7, -2], [-5, 9], [-2, -8], [-9, -14], [-4, -26], [-9, -6], [-9, -30], [-1, -20], [-7, -11], [-2, -22], [-5, -13], [-2, -39], [-10, -25], [5, -20], [-4, -29], [-9, -5], [-1, -38], [-8, -13], [-3, 15], [-4, -29], [-5, -1], [1, -21], [-11, -13], [-2, -57], [12, -3], [10, -16], [3, -19], [-4, -30], [-7, -19], [-6, -1], [0, -17], [-4, -6], [1, -21], [-4, -31], [-9, -29], [-5, 0], [-5, -11], [-5, 2], [-4, -11], [2, -16], [-7, -8], [-2, -23], [-5, 14], [-5, -45], [-9, 4], [1, -24], [-6, 6], [-3, -11], [0, -32], [-6, -50], [-10, -6], [-7, -23], [-2, -13], [-5, 18], [-8, -48], [-2, 13], [-5, -4], [-1, -27], [-5, -10], [-6, 4], [-4, -27], [8, -9], [-9, -60], [-25, -20], [-6, -54], [-2, 12], [1, 33], [-5, 6], [-6, -13], [-1, -14], [-10, -22], [-4, -25], [-1, 18], [-2, -21], [-6, 14], [-10, -33], [-8, 2], [1, 25], [-4, 24], [-3, -20], [1, -21], [-11, -64], [-3, 16], [-1, -24], [-8, 4], [-1, 38], [-4, 8], [-2, -14], [4, -16], [-2, -27], [-5, -13], [-5, 29], [-5, 2], [-1, -11], [5, -17], [-9, -27], [6, -7], [0, -13], [-5, 9], [-7, -25], [-15, 1], [-7, -16], [0, -13], [-8, -15], [-6, 6], [-2, 35], [6, 12], [4, 43], [6, 1], [13, 28], [10, 1], [4, -27], [3, 20], [-1, 23], [6, 10], [7, 0], [8, 50], [10, 45], [12, 40], [15, 18], [6, -9], [6, 12], [1, -17], [-3, -19], [4, -14], [1, 23], [7, 2], [2, -15], [5, -5], [0, 18], [-8, 15], [0, 11], [5, 49], [6, 28], [9, 27], [15, 24], [10, 35], [5, -13], [4, 5], [-1, 22], [1, 21], [8, 44], [11, 28], [8, 38], [0, 21], [7, 148], [11, 40], [-1, 31], [-27, -45], [-8, 6], [-2, 18], [-5, 9], [-1, 21], [-4, -10], [-3, -32], [5, -41], [-6, -18], [-5, 7], [-9, 64], [-6, 33], [-4, 0], [-2, -24], [-3, -4], [-4, 19], [-5, 4], [-2, 32], [-16, -37], [-13, -26], [-1, -14], [-11, -22], [-6, 20], [5, 23], [-1, 54], [-4, 57], [7, 24], [-6, 49], [-5, 27], [-4, 39], [-6, 17], [-2, -34], [-7, -8], [-12, -22], [-14, -9], [-7, 2], [-7, 12], [-1, 30], [-5, 9], [-9, 42], [-8, 8], [-8, 46], [6, 21], [1, 39], [-5, -8], [0, 24], [2, 19], [-6, 18], [0, -19], [-7, 8], [-1, 32], [-6, 4], [-3, 22], [0, 27], [-5, -12], [-1, 26], [7, 6], [-6, 30], [10, 2], [0, 35], [2, 24], [18, 77], [4, 23], [3, -5], [-2, 33], [7, 55], [6, 22], [11, 9], [8, -9], [12, -33], [8, 4], [11, 32], [11, 49], [6, 6], [1, -13], [13, 0], [12, 10], [11, 52], [0, 12], [-5, 48], [-1, 28], [-8, 31], [-3, 26], [8, -7], [8, 22], [0, 20], [-10, 39], [-8, -30], [-7, 5], [-6, -17], [-8, -4], [-2, -11], [-9, -17], [-2, -28], [-5, -12], [-2, 34], [-5, 7], [-4, -26], [-2, 12], [-10, 19], [-20, -1], [-14, -21], [-6, -3], [-11, 13], [-22, 14], [-6, 12], [-3, 19], [2, 26], [-8, 22], [2, 24], [5, 12], [-2, 31], [-8, 0], [-6, 8], [-13, 6], [-7, 16], [-10, 16], [-1, 19], [16, 27], [20, 43], [15, 27], [8, -15], [8, -3], [2, 21], [-5, 3], [-1, 18], [20, 29], [22, 22], [12, 2], [7, -7], [-4, -32], [2, -22], [-3, -15], [4, -26], [8, 5], [10, -5], [11, 6], [4, -10], [7, -2], [7, 10], [8, -11], [9, 42], [5, 2], [5, -8], [2, 24], [-12, 11], [-11, -9], [1, 31], [-8, 34], [-10, 10], [-2, 30], [7, 8], [9, -31], [-1, -24], [4, -18], [10, -22], [2, 23], [-11, 30], [5, 54], [-4, 10], [-11, -12], [-11, 3], [-2, 10], [-6, -10], [-24, 23], [0, 24], [-7, 54], [-6, 19], [-9, 17], [-19, 46], [-9, 18], [-8, 4], [-13, 31], [-12, 18], [-1, 6], [9, 10], [4, 29], [1, 59], [25, -4], [31, 13], [8, 11], [12, 29], [12, 45], [3, 45], [5, 38], [10, 33], [5, 24], [13, 38], [2, -10], [11, -3], [16, 20], [10, 21], [24, 64], [9, 4], [1, -10], [9, 7], [9, -2], [18, 9], [17, 28], [17, 58], [7, 13], [2, -10], [26, -24], [2, -17], [-9, -22], [-4, -1], [0, -29], [14, 9], [0, 16], [6, 14], [2, -8], [5, 33], [13, -30], [-2, -23], [8, -6], [5, -14], [7, 22], [13, 1], [7, 7], [18, -7], [10, -8], [-5, -45], [17, -12], [2, -11], [16, -20], [1, 9], [12, 13], [11, -1], [0, -11], [7, -1], [7, 15], [11, 2], [9, -6], [11, -16], [5, 3], [7, -22], [4, 9], [7, -7], [5, -13]], [[717, 7456], [-1, -8], [-9, 13], [7, 49], [6, 4], [4, 45], [5, -40], [4, 14], [8, -22], [0, -31], [-11, -4], [-5, -13], [-8, -7]], [[688, 7363], [8, 25], [-8, 6], [0, 22], [6, 14], [5, -10], [0, -22], [3, 15], [0, 32], [5, -15], [1, 21], [5, -12], [5, 0], [5, 11], [7, -20], [0, -55], [9, 4], [-6, -37], [-11, 15], [4, -24], [-3, -20], [-6, 10], [0, -38], [-8, -10], [-3, -16], [-5, 15], [-6, -40], [-4, -4], [-5, -18], [-2, 43], [-6, -23], [-1, 13], [-6, 14], [0, 39], [-6, 15], [4, 45], [11, 28], [7, -2], [1, -21]], [[671, 7185], [-6, -39], [-2, 6], [8, 33]], [[640, 7055], [4, -2], [-1, -40], [-8, 6], [-1, 13], [6, 23]], [[519, 6933], [-2, -41], [-9, -33], [5, 51], [2, -5], [4, 28]], [[501, 6947], [5, 0], [0, -20], [-5, -23], [-5, 15], [-3, -14], [-2, 35], [2, 12], [8, -5]], [[451, 6875], [1, -16], [-3, -11], [-3, 18], [5, 9]], [[447, 8527], [-4, -19], [-2, 16], [6, 3]], [[436, 6781], [6, -7], [-1, -16], [-5, 1], [0, 22]], [[358, 6745], [2, -22], [-5, -10], [-1, 23], [4, 9]], [[352, 6718], [-8, -21], [-2, 14], [3, 19], [7, -12]], [[335, 7902], [6, 7], [2, -14], [5, 3], [6, -12], [1, -54], [-3, -18], [-7, -11], [-2, -18], [-11, 20], [-5, -1], [-10, 28], [-4, 0], [-6, 15], [-3, 25], [4, 7], [10, -7], [5, 20], [5, 2], [3, 14], [4, -6]], [[334, 6690], [5, -14], [-10, -36], [1, -6], [12, 26], [0, -15], [-5, -17], [-8, -12], [-1, -18], [-8, -18], [-7, -1], [-5, -18], [-9, -16], [-5, 17], [9, 20], [3, -3], [8, 16], [-2, 19], [4, 20], [6, -9], [1, 12], [-7, 4], [-4, 14], [4, 23], [11, 13], [2, -26], [5, 25]], [[266, 6527], [10, 37], [1, 16], [4, 17], [7, 9], [3, -10], [1, -25], [-12, -27], [-6, -40], [-6, -13], [-2, 36]], [[238, 6477], [2, -19], [-8, -1], [-1, 13], [7, 7]], [[227, 7303], [-4, -18], [-1, 18], [5, 0]], [[212, 6440], [2, -18], [-5, -13], [-1, 19], [4, 12]], [[182, 8542], [22, -28], [13, 24], [6, -2], [5, -14], [2, -23], [11, -12], [4, -12], [15, -5], [8, -8], [-4, -28], [-7, 6], [-8, -5], [-4, -13], [-4, -28], [-5, 26], [-6, 18], [-6, 2], [-3, 20], [-15, 25], [-6, 1], [-11, -22], [-7, 11], [-4, 23], [4, 44]], [[162, 6381], [0, -22], [-5, -4], [1, 19], [4, 7]], [[128, 6335], [4, -8], [10, 1], [1, -7], [-13, -9], [-2, 23]], [[108, 6360], [0, 19], [4, 7], [6, -19], [-2, -17], [-4, 1], [1, -20], [-5, -2], [-12, -21], [-6, 6], [2, 15], [7, -2], [9, 33]], [[47, 6279], [5, 3], [0, -24], [-6, 3], [-8, -28], [-4, 37], [4, 1], [0, 29], [5, 1], [0, -21], [4, -1]], [[28, 6296], [3, -9], [-2, -32], [-5, -10], [0, 20], [4, 31]], [[0, 6291], [5, -1], [4, -23], [-4, -27], [-5, 51]], [[9993, 6496], [6, -13], [0, -19], [-11, -12], [-8, 31], [0, 15], [13, -2]], [[1966, 3444], [-1, -1081]], [[1965, 2363], [-57, 0], [-34, 71], [-73, 150], [3, 43]], [[1804, 2627], [6, 8], [1, 16], [-1, 36], [-4, 1], [-2, 71], [6, 27], [0, 28], [-1, 45], [4, 34], [4, 12], [4, 25], [-6, 27], [-4, 51], [-5, 31], [0, 24]], [[1806, 3063], [2, 26], [0, 36], [-3, 36], [-2, 112], [11, 7], [3, -23], [3, 1], [3, 33], [0, 153]], [[1823, 3444], [101, 2], [42, -2]], [[2515, 3253], [-1, -35], [-4, -11], [-1, -29], [-5, -31], [0, -46], [-3, -34], [-3, -5]], [[2498, 3062], [2, -17], [-4, -14], [-2, -33], [-3, -8], [0, -38], [-5, -10], [0, -13], [-6, -31], [2, -21], [-5, -30], [-5, -59], [5, -25], [-2, -16], [1, -39], [-2, -26]], [[2474, 2682], [-69, 3], [-13, 0]], [[2392, 2685], [0, 101], [-4, 8], [-5, -9], [-3, 18]], [[2380, 2803], [1, 335], [-5, 211]], [[2376, 3349], [4, 0], [123, -1], [2, -36], [-4, -23], [-4, -36], [18, 0]], [[1654, 4398], [0, -331], [0, -241], [36, -171], [35, -169], [27, -137], [20, -101], [34, -185]], [[1804, 2627], [-38, -18], [-30, -16], [-4, 25], [0, 40], [-2, 47], [-4, 33], [-9, 46], [-12, 43], [-2, -12], [-4, 8], [1, 18], [-5, 39], [-7, -8], [-12, 28], [-2, 23], [-8, 28], [-9, -1], [-7, 13], [-10, -6], [-5, 26], [1, 53], [-1, 8], [1, 38], [-8, 28], [0, 39], [-3, 2], [-4, 33], [-4, 8], [-1, 20], [-11, 79], [-5, 23], [-1, 61], [2, -5], [2, 37], [-4, 33], [-5, -4], [-7, 30], [-2, 24], [0, 23], [-3, 31], [0, 50], [5, 0], [-2, 70], [-2, -7], [-1, -35], [-5, -7], [-7, 26], [-1, 45], [-4, 35], [-6, 22], [-3, 25], [-9, 50], [2, 14], [-4, 64], [2, 35], [-3, 54], [-7, 52], [-7, 29], [-2, 35], [7, 83], [2, 29], [-2, 22], [3, 57], [-2, 52], [-3, 13], [1, 42]], [[1534, 4399], [28, 1], [24, 1], [38, -3], [30, 0]], [[2107, 4208], [57, 0], [0, -191]], [[2164, 4017], [1, -574]], [[2165, 3443], [-28, 1]], [[2137, 3444], [-38, -1], [-72, 0], [-15, 1], [-46, 0]], [[1966, 3444], [0, 223], [-1, 21], [0, 162], [0, 357]], [[1965, 4207], [32, 1], [63, -1], [47, 1]], [[3025, 4400], [0, -113], [-2, -18]], [[3023, 4269], [-2, 3], [-12, -14], [-15, 4], [-7, -26], [-7, -9], [-8, -22]], [[2972, 4205], [-2, 22], [7, 21], [-2, 16], [2, 144]], [[2977, 4408], [12, -2], [36, -3], [0, -3]], [[2922, 3980], [-2, -23]], [[2920, 3957], [-3, -13], [0, -30], [5, -29], [1, -47], [6, -49], [3, -2], [1, -66]], [[2933, 3721], [-19, 2], [-2, 241]], [[2912, 3964], [5, 21], [5, -5]], [[2876, 3786], [-2, 27]], [[2874, 3813], [2, 12], [4, -19], [-4, -20]], [[2649, 2300], [4, -55], [39, -13], [37, -14], [1, -41], [4, 1], [1, 39], [-1, 35], [2, 15], [7, -16], [8, -7]], [[2751, 2244], [1, -83], [4, -93], [8, -122], [13, -131], [-2, -9], [1, -61], [5, -68], [8, -137], [2, -42], [0, -44], [-3, -158], [-3, -3], [-3, -49], [1, -16], [-5, -36], [-2, 9], [-6, -15], [-9, -8], [-2, 20], [1, 29], [-7, 85], [-5, 15], [-4, -11], [-3, 47], [-1, 38], [-6, 43], [-2, 28], [1, 41], [-3, 8], [1, -24], [-3, -7], [-9, 104], [-4, 26], [9, 76], [-6, -4], [-4, -24], [-3, 38], [5, 104], [1, 87], [-4, 21], [-1, 28], [-5, 6], [-7, 46], [-5, 19], [0, 28], [-4, 11], [-3, 31], [-11, 42], [-9, -10], [0, -29], [-3, 5], [-12, -35], [-12, -9], [0, 21], [-3, 25], [-15, 57], [-10, 24], [-10, 6], [-8, -4], [-17, -18]], [[2703, 3063], [-6, -41], [0, -20], [9, -40], [3, 3], [5, -42], [1, -22], [4, -40], [7, -24], [3, -35], [8, -33], [0, -22], [5, -35], [7, -29], [2, -32], [1, -40], [3, -14], [5, -51], [0, -33], [7, -16]], [[2767, 2497], [-7, -65], [-2, -34], [-3, -29], [0, -30], [-3, -14], [-1, -81]], [[2632, 3060], [37, 1]], [[2669, 3061], [20, -1], [14, 3]], [[640, 0], [-7, 17], [-1, 16], [1, 43], [-5, 73], [4, 24], [2, 34], [-2, 22], [1, 23], [8, -27], [9, -20], [5, -29], [0, -26], [8, -40], [-5, -34], [-8, -15], [-7, -25], [-3, -36]], [[613, 397], [3, -26], [4, 11], [9, -30], [-1, -27], [-9, -14], [-2, 6], [-1, 33], [-5, 7], [-1, 19], [3, 21]], [[602, 432], [-3, -20], [-7, 0], [2, 22], [8, -2]], [[574, 525], [3, -45], [-2, -26], [-6, -5], [-4, 54], [4, 1], [5, 21]], [[531, 626], [3, -2], [2, -20], [-1, -28], [-4, -18], [-9, 22], [1, 31], [8, 15]], [[1908, 4871], [0, -472]], [[1908, 4399], [-31, -1], [-54, 0]], [[1823, 4398], [-85, 1]], [[1738, 4399], [0, 349], [4, 62], [-2, 16], [-6, 3], [-2, 26], [6, 68], [3, 6], [3, 29], [-1, 17], [4, 23], [1, 34], [6, 56], [-2, 26], [-7, 14], [-4, 32]], [[1741, 5160], [0, 34], [-3, 33], [0, 16], [0, 255], [0, 236]], [[1738, 5734], [28, 0]], [[1766, 5734], [0, -195], [9, -54], [1, -52], [5, -23], [6, -8], [0, -14], [11, -51], [1, -21], [8, -20], [0, -12], [8, 1], [-4, -71], [-1, -45], [3, -29], [-5, -21], [2, -20], [-1, -21], [6, -20], [7, 26], [3, 21], [5, -19], [-1, -15], [3, -37], [5, -39], [3, -13], [0, -37], [3, -16], [6, -2], [4, -61], [3, -11], [3, 18], [9, -1], [7, 17], [3, -10], [7, 9], [2, -11], [5, 8], [7, 39], [4, -33], [5, -20]], [[2489, 4496], [53, -3], [28, 0]], [[2570, 4493], [-1, -37], [4, -43], [5, -70]], [[2578, 4343], [0, -450], [-3, -35], [3, -40], [1, -34], [-4, -27], [-1, -25], [-5, -41], [-3, -3], [0, -24], [-2, -9], [-1, -45], [0, -13]], [[2563, 3597], [-3, -27], [2, -34], [-11, -17], [-1, -20], [2, -25], [-3, -16], [-11, 29], [-3, -2], [-4, -33], [1, -11]], [[2532, 3441], [-5, 2], [-6, 55], [2, 12], [-2, 37], [0, 29], [-9, 41], [-3, -4], [-3, 25], [-9, 38], [0, 31], [5, 49], [-1, 18], [3, 23], [-4, 13], [-6, 9], [-3, -18], [-3, 11], [-1, 63], [-10, 41], [-9, 49], [-3, 58], [-1, 39], [3, 27]], [[2467, 4089], [0, 35], [8, 21], [1, 29], [4, 19], [0, 33], [-4, 27], [2, 34], [11, 9], [9, 24], [0, 29], [4, 13], [1, 37], [0, 24], [-7, 18], [-1, 20], [-6, 35]], [[2655, 4340], [0, -228], [0, -266]], [[2655, 3846], [-2, -9], [2, -52], [-5, -1], [-5, -18], [-8, 9], [1, -38], [-5, -16], [-2, -24], [-5, -9], [-3, -48], [-3, -13], [-6, 18], [-1, 22], [-7, -24], [1, -21], [-7, -7], [-1, 19], [-8, -19], [-2, -20], [-7, 28], [-4, -6], [-2, 13], [-3, -13], [-7, -2], [-3, -18]], [[2578, 4343], [3, -12], [8, 0], [9, 22]], [[2598, 4353], [23, 0], [34, 0], [0, -13]], [[2473, 4685], [0, -28], [4, -19], [-3, -23], [1, -43], [2, -30], [10, -22], [2, -24]], [[2467, 4089], [-3, 7], [-6, 38], [-3, -1], [-40, -5], [-39, -2], [-33, 3]], [[2343, 4129], [-3, 25], [2, 49], [-3, 43], [0, 48], [-5, 17], [-1, 26], [2, 23], [-2, 33], [-4, 13], [-5, 86]], [[2324, 4492], [-5, 41], [2, 29], [1, 37], [2, 14], [-3, 19], [1, 33], [-2, 16], [4, 4]], [[2324, 4685], [144, 0], [5, 0]], [[2356, 4017], [3, -18], [9, -14], [-6, -56], [4, -18], [4, -45], [6, -10], [0, -412]], [[2376, 3444], [-156, 0], [-55, -1]], [[2164, 4017], [5, 0], [187, 0]], [[2718, 3716], [-1, -57], [4, -37], [4, -28], [2, -22], [5, -22], [4, -3]], [[2736, 3547], [-11, -51], [-11, -29], [0, -14], [-4, -13], [0, -16], [-6, -8], [-1, -21], [-16, -27]], [[2687, 3368], [0, -3], [-24, 2], [-22, 6], [-5, -2], [-32, 8], [-36, -5], [-6, 9], [1, -35], [-36, 2], [-3, -2]], [[2524, 3348], [1, 24], [5, -8], [2, 77]], [[2655, 3846], [11, 0], [5, -40], [1, -17], [9, -7], [6, -26], [5, 13], [10, -14], [4, 19], [4, 6], [1, -32], [3, -6], [4, -26]], [[2474, 2682], [3, -22], [-2, -9], [-1, -38], [5, -24], [0, -57], [-3, -44], [-7, -27], [-2, -43], [-2, 4], [-1, -70], [-3, -2], [2, -37], [-2, -14], [54, 0], [-3, -63], [4, -41], [1, -32], [4, -20]], [[2521, 2143], [-9, -26], [0, -19], [7, -12], [3, 30], [6, -30], [-1, -24], [-3, -11], [-7, 10], [1, -18], [-2, -27], [5, -24], [9, -7], [3, -29], [3, -4], [-5, -32], [-5, 6], [-4, 33], [-10, 18], [0, 33], [-6, -11], [1, -27], [-3, -25], [-3, -4], [-3, 28], [-7, 1], [-2, -29], [-4, -9], [-5, 18], [-4, 2], [-3, 47], [-7, 21], [-2, -3], [-3, 40], [-7, -5], [0, 24], [-8, -23], [1, -18], [-5, -17], [-9, 8], [-10, 27], [-7, 11], [-16, -9], [-2, -8]], [[2398, 2049], [-2, 19], [6, 68], [-2, 37], [2, 20], [-1, 26], [3, 19], [3, 50], [0, 40], [-8, 78], [0, 41], [-7, 42], [0, 196]], [[3046, 5029], [12, 26], [-2, 13], [5, 30], [4, 13], [-1, 12], [5, 18], [-1, 33], [2, 50], [5, 17], [1, 53], [22, 147], [6, -7], [0, -35], [4, -13], [9, 21], [6, 0], [4, 14], [8, -31], [4, -25], [1, -214], [-1, -51], [10, -14], [-2, -22], [3, -21], [-2, -18], [4, -30], [5, 7], [5, -68], [-6, -31], [-3, 12], [-3, -21], [-4, 5], [0, -18], [-6, 2], [-8, -40], [-2, 28], [-3, 2], [1, -30], [-6, -15], [-2, 24], [-3, -12], [-7, 0], [0, 28], [-5, -6], [1, -20], [-4, -42], [1, -12], [-6, -23], [-5, 9], [-3, -24], [-4, -3], [-4, -20], [-4, 4], [-1, 21], [-7, -34], [2, -21], [-5, -7], [0, -18], [-5, -22], [-5, -50]], [[3056, 4600], [-3, 14], [0, 19], [-4, 22], [-2, 250], [-1, 124]], [[2904, 3626], [2, 0], [-1, 0], [-1, 0]], [[2933, 3721], [-6, -80]], [[2927, 3641], [-4, -3], [-8, -12]], [[2915, 3626], [-6, -8], [0, 31], [-2, 13], [3, 13], [-4, 32], [-2, -14], [-6, 3], [-2, 35], [2, 0], [0, 45], [2, 18], [-2, 60], [3, 36], [5, 6], [0, 37], [-3, -5], [0, -18], [-8, -25], [-2, -21], [0, -56], [-3, -26], [1, -44], [4, -30], [-1, -23], [3, -23], [-2, -16], [-6, 30], [-10, 15], [-2, 29], [-6, -16], [-2, 23], [5, 29]], [[2874, 3756], [2, 30]], [[2874, 3813], [-4, 18], [-6, 10], [0, 28], [-3, 15], [-4, 4]], [[2857, 3888], [-4, 53], [-4, 0], [-5, 18], [-3, -15], [-5, 1], [-1, -21], [-8, 14], [-6, -28], [-3, 6], [-6, -33], [-6, -17], [1, 98]], [[2807, 3964], [105, 0]], [[3053, 4565], [1, -34], [-1, -27], [-5, -25], [0, -29], [6, -4], [4, -31], [0, -24], [3, -6], [0, -22], [8, -19], [9, 18], [-2, -26], [-13, -23], [-5, -1], [-3, 18], [-5, -6], [0, -13], [-5, -9]], [[3045, 4302], [-3, 35]], [[3042, 4337], [0, 6]], [[3042, 4343], [-3, 14], [-2, 45], [-4, 0], [-8, -2]], [[2977, 4408], [0, 7], [6, 126]], [[2983, 4541], [23, -3]], [[3006, 4538], [34, -7], [3, 18], [7, 19], [3, -3]], [[2598, 4353], [5, 25], [4, 43], [4, 26], [3, 36], [1, 52], [0, 57], [-9, 111], [3, 42], [-2, 50], [6, 51], [2, 43], [-1, 23], [5, 9], [0, 31], [8, 9], [5, 34], [0, -69], [3, -3], [3, 35], [1, 58], [2, 15], [8, 9], [-3, 41], [5, 35], [7, 2], [7, -22], [7, -3], [3, -28], [6, -2], [9, -25], [3, 1], [4, -41], [-3, -21], [3, -29], [2, -32], [-2, -71], [-6, -18], [-1, -37], [-7, -12], [-4, -44], [2, -17], [6, -15], [6, 24], [6, 49], [10, 19], [5, -15], [3, -27], [3, -80], [0, -39], [3, -48], [-3, -69], [-4, -11], [-1, 25], [-3, -7], [-3, -58], [-6, -21], [-2, -44], [-7, -37], [0, -16]], [[2694, 4347], [-39, -7]], [[2635, 5110], [1, -23], [-4, -4], [1, 33], [2, -6]], [[2496, 5270], [11, 20], [5, 23], [12, 9], [8, 29], [4, 1], [3, 20], [9, 28], [4, 24], [7, 15], [6, -13], [-11, -59], [-2, -19], [0, -36], [5, 27], [10, -4], [8, -19], [7, -52], [3, -10], [7, 9], [2, -12], [7, -6], [16, 44], [8, 4], [10, -2], [7, 15], [6, 1], [1, -54], [5, -7], [6, 8], [2, -12], [4, 16], [8, 5], [1, -67], [3, -28], [6, -8], [1, 19], [5, 0], [3, -20], [-3, -14], [-15, 12], [-8, -8], [-8, 23], [-2, -21], [1, -18], [-4, 4], [-5, 27], [-9, 15], [-5, 1], [-4, -25], [-8, -6], [-8, 5], [-3, -10], [-1, -21], [-9, -18], [1, 25], [-4, 5], [-2, -26], [-6, -1], [-3, -11], [-5, -45], [-8, -58], [1, -5]], [[2576, 4989], [-4, 20], [2, 27], [-7, 4], [3, 26], [0, 34], [-5, 23], [-4, 24], [-12, 19], [-4, -7], [-12, 29], [-29, 38], [-3, 33], [-5, 11]], [[2541, 5539], [-7, -24], [-4, -3], [1, 19], [18, 45], [-4, -31], [-4, -6]], [[2324, 4685], [0, 343], [-7, 22], [-5, 36], [8, 41], [1, 22]], [[2321, 5149], [-1, 76], [-4, 20], [-2, 42], [0, 51], [-1, 8], [-1, 123], [-5, 65], [-3, 36], [0, 77], [1, 27], [-3, 60]], [[2302, 5734], [59, 0], [0, 73], [5, -2], [4, -14], [4, -100], [3, -11], [9, -3], [1, -10], [11, -4], [1, -21], [10, 5], [0, 9], [7, 10], [6, -4], [8, -16], [2, -19], [4, 2], [4, -43], [2, 18], [7, 8], [1, -18], [9, -12], [0, -17], [4, -14], [8, 8], [5, 18], [8, 12], [2, -28], [5, 6], [6, -6], [6, 4], [8, -24], [7, 4], [0, -10], [-10, -24], [-13, -19], [-9, -20], [-12, -49], [-5, -31], [-8, -34], [-13, -46], [2, -16]], [[2450, 5296], [-2, 9], [-6, -16], [0, -113], [-2, -11], [-8, -16], [-6, -41], [-1, -27], [3, -2], [4, -24], [-3, -29], [0, -33], [-2, -70], [8, -34], [6, -3], [3, -21], [8, -21], [2, -25], [8, -33], [5, -7], [5, -42], [-1, -30], [2, -22]], [[2553, 2179], [-3, -8], [-7, 4], [-3, 12], [-7, -8], [-9, -22], [-3, -14]], [[2498, 3062], [53, 0], [7, 0]], [[2524, 3348], [-2, 0], [-2, 0], [1, -47], [-6, -48]], [[2376, 3349], [0, 95]], [[2356, 4017], [-7, 50], [-6, 62]], [[2108, 5151], [0, -181], [-1, 0]], [[2107, 4970], [-53, 1], [-90, 0], [-56, 0], [0, -100]], [[1766, 5734], [130, -1], [58, 1], [154, 0]], [[2108, 5734], [0, -217], [0, -366]], [[2107, 4208], [0, 382]], [[2107, 4590], [21, 0], [49, -1], [88, 0], [1, -10], [15, -34], [4, 19], [4, -4], [13, 0], [15, -36], [2, -27], [5, -5]], [[1823, 4398], [0, -954]], [[1654, 4398], [37, -1], [47, 2]], [[3006, 4538], [-2, 14], [0, 28], [3, 11], [-1, 27], [3, 81], [5, 37], [2, 43], [3, 16], [-1, 47], [10, 17], [5, 33], [-3, 31], [4, 32], [0, 18]], [[3034, 4973], [4, 49], [6, -5], [2, 12]], [[3056, 4600], [-3, -35]], [[2962, 4152], [-5, -13], [-2, -29], [8, -14], [0, -22], [-3, -103], [-9, -76], [-6, -22], [-5, -48], [-3, 31], [-8, 16], [-10, 42], [-1, 28], [0, 4], [2, 11]], [[2922, 3980], [8, 15], [0, 15], [9, 31], [2, 17], [-9, 39], [0, 24], [-3, 6], [-1, 22], [5, 33], [-3, 20], [7, 40], [2, 21], [4, 13]], [[2943, 4276], [13, -41], [9, -28], [-3, -55]], [[2137, 3444], [0, -95]], [[2137, 3349], [-1, 0], [0, -474], [0, -193], [0, -192], [-101, 0], [-1, -18], [3, -22]], [[2037, 2450], [-48, 0], [0, -87], [-24, 0]], [[2972, 4205], [13, -15], [2, 11], [10, 0], [6, 6], [8, 31], [1, -22], [5, -10], [-11, -28], [-22, -42], [-9, -8], [-6, 2], [-5, -9], [-2, 31]], [[2943, 4276], [-2, 14], [-4, 1], [-5, 32], [1, 29], [-4, 22], [-2, -2], [-3, 27], [-125, 0], [0, 48], [0, 3]], [[2799, 4450], [17, 54], [3, 26], [5, 18], [-2, 32], [-2, 7], [-2, 52], [17, 22], [15, -1], [6, -5], [6, -21], [4, 8], [12, -1], [8, 14], [8, 34], [5, 1], [0, 52], [3, 31], [-7, 21], [2, 24], [11, 32], [4, 28], [14, 64], [13, 32], [19, -5], [23, 4]], [[2981, 4973], [1, -39], [-2, -36], [3, -34], [-1, -37], [-3, -39], [2, -52], [-1, -16], [4, -31], [-1, -132], [0, -16]], [[2909, 3359], [4, -77], [-8, 8], [-1, -10], [-10, -11], [-1, -11], [-7, -3], [0, -13], [8, 9], [1, -8], [9, 9], [3, -18], [5, 8], [2, -46], [-2, -22], [-3, -2], [-8, -47], [-9, -2], [-2, -33], [4, -32], [4, -6], [-6, -54], [-6, 7], [-9, -6], [-6, -11], [-10, -37], [-7, -48], [-4, -60], [-6, 13], [-11, -12]], [[2833, 2844], [-32, 181], [-32, 4], [1, 21], [-5, 33], [-3, -12], [0, 20], [-35, 10], [-8, -8], [-6, -17], [-10, -13]], [[2669, 3061], [1, 45], [5, 4], [3, 31], [7, 29], [7, 1], [7, 29], [8, 10], [6, 43], [4, 13], [1, -19], [11, 37], [5, -8], [4, 36], [5, 9], [1, 45]], [[2744, 3366], [20, -5], [19, -3], [23, -1], [103, 2]], [[2321, 5149], [-213, 2]], [[2108, 5734], [194, 0]], [[2777, 4138], [-4, -10], [2, -21], [0, -29], [-4, -46], [-3, -70], [-11, -62], [-3, -8], [-4, 12], [-3, -27], [-3, 1], [-4, -36], [1, -22], [-3, -18], [-4, 29], [-5, -46], [1, -29], [-3, -11], [-1, -25], [-8, -4]], [[2694, 4347], [11, -26], [3, -15], [3, 14], [6, -30], [4, -9], [14, 25], [7, -6], [9, 36], [12, 34], [14, 24]], [[2777, 4394], [0, -256]], [[2380, 2803], [-11, 21], [-3, 22], [-7, 18], [-2, -16], [-8, 1], [-1, 10], [-7, -19], [-3, 11], [-6, -10], [-5, -29], [-2, 17], [-6, 14], [-7, 0], [-2, 21], [-7, -42], [-2, 24], [-3, -8], [-3, 16], [-7, 15], [-5, -25], [-2, 26], [-4, 3], [-2, 21], [-6, 8], [-3, -18], [-3, 16], [-5, -2], [-6, 17], [-6, -2], [-2, 36], [-9, 2], [-4, -6], [-6, 37], [-2, -3], [0, 370], [-52, 0], [-34, 0]], [[1534, 4399], [-4, 22], [-2, 61], [0, 43], [-4, 33], [3, 32], [2, 51], [4, 54], [2, 48], [3, 162], [0, 22], [3, 71], [1, 99], [-2, 54], [1, 32], [12, 29]], [[1553, 5212], [5, -22], [4, 5], [3, 2], [6, -20], [3, -23], [1, -57], [15, -21], [12, 30], [8, 3], [9, -10], [1, -13], [16, 27], [3, -9], [9, 5], [7, 19], [12, 17], [12, 4], [4, 12], [58, -1]], [[2807, 3964], [-30, 0], [0, 174]], [[2777, 4394], [5, 11], [17, 45]], [[3045, 4302], [-6, -4], [3, 39]], [[3042, 4343], [-4, 3], [-3, -28], [-1, -40], [-11, -9]], [[2833, 2844], [-5, -10], [-6, -31], [-6, -49], [-1, -40], [-5, -31], [-6, 0], [-2, -23], [-6, -25], [-4, -28], [-6, -11], [-6, -29], [-1, -14], [-6, -16], [-6, -40]], [[2107, 4590], [0, 380]], [[2687, 3368], [57, -2]], [[2398, 2049], [-5, -1], [-14, -26], [-6, 15], [-1, 31], [-3, -22], [-3, 5], [-1, -27], [3, -11], [0, -36], [-5, -37], [-9, -47], [-17, -51], [-2, 9], [-5, -13], [0, 12], [-7, -9], [-3, 24], [-2, -5], [7, -49], [-5, -16], [-5, 10], [-1, -35], [-7, -35], [-6, -66], [-4, -69], [-3, 5], [-1, -25], [3, 6], [-2, -50], [-2, -2], [0, -28], [3, -16], [1, -57], [3, -20], [0, -37], [3, -32], [-9, -20], [-3, 25], [-7, 10], [-9, -3], [-8, 32], [-5, 3], [-5, 25], [-6, 8], [-4, 24], [-2, 58], [-5, 34], [0, 30], [-2, 31], [1, 27], [-4, 30], [-3, 4], [-5, 27], [-1, 34], [-5, 32], [-6, 26], [-3, 57], [-2, 16], [-4, 46], [-1, 38], [-4, 27], [-6, 24], [-1, 16], [-6, 15], [-4, 42], [-13, 9], [-7, -2], [-7, 15], [-1, -20], [-7, -6], [-5, -40], [-3, -64], [-2, -1], [-4, -37], [-5, -1], [-7, 29], [-17, 47], [-4, 25], [-6, 24], [-5, 54], [-1, 49], [-4, 40], [-2, 35], [-3, 22], [-11, 32], [-6, 44], [-4, 15], [-6, 38], [-7, 20], [-5, 50], [-4, 11]], [[1908, 4399], [0, -192], [57, 0]], [[2981, 4973], [30, -2], [23, 2]], [[2927, 3641], [-4, -32], [-3, -12], [-3, -44], [-6, -71], [-5, -15], [-1, 27], [2, 58], [8, 74]], [[2874, 3756], [-4, -8], [-2, -28], [1, -19], [8, 6], [1, -31], [10, -12], [3, -24], [8, -26], [-4, -54], [4, -41], [-4, -20], [-1, -24], [4, -15], [-4, -23], [-6, 30], [-1, -10], [5, -22], [14, -5], [3, -71]], [[2736, 3547], [-1, -16], [4, -32], [5, -16], [4, 1], [5, 25], [4, -20], [7, 11], [13, 36], [1, -11], [5, 17], [0, 34], [4, 30], [5, 29], [2, 34], [6, 36], [2, 44], [5, -27], [4, -8], [3, 16], [6, 68], [4, -17], [13, 77], [2, 57], [15, -64], [3, 37]], [[1553, 5212], [-5, 7], [-4, -12], [-6, 17], [1, 26], [4, 14], [-6, 40], [-4, 103], [-2, 14], [-3, 73], [-6, 28], [-2, 56], [3, 38], [6, -18], [11, -24], [8, 1], [8, -9], [8, 9], [3, -16], [7, 1], [5, -42], [3, 3], [1, -56], [2, -52], [3, 6], [-3, 43], [1, 43], [4, 44], [-3, 18], [-1, 31], [-3, 35], [2, 25], [-2, 29], [-5, 4], [-4, 22], [1, 21], [163, 0]], [[1576, 5602], [4, 9], [0, -39], [-5, 15], [1, 15]], [[1568, 5655], [3, 25], [4, -30], [-1, -27], [-7, 8], [1, 24]], [[2576, 4989], [-1, -23], [-6, -4], [-4, -44], [-2, -30], [3, -6], [5, 20], [4, 38], [6, 15], [5, 48], [6, 10], [-1, -25], [-4, -23], [-8, -79], [-2, -44], [0, -32], [-3, -10], [-2, -43], [1, -37], [-3, -24], [-3, -59], [0, -47], [4, -42], [-1, -55]], [[2450, 5296], [6, -2], [20, 33], [8, 17], [2, -13], [-4, -25], [9, -33], [5, -3]]]
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__(7762);
;// ./node_modules/topojson-client/src/reverse.js
/* harmony default export */ function reverse(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
}

;// ./node_modules/topojson-client/src/identity.js
/* harmony default export */ function topojson_client_src_identity(x) {
  return x;
}

;// ./node_modules/topojson-client/src/transform.js


/* harmony default export */ function transform(transform) {
  if (transform == null) return topojson_client_src_identity;
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2, n = input.length, output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
}

;// ./node_modules/topojson-client/src/feature.js



/* harmony default export */ function feature(topology, o) {
  if (typeof o === "string") o = topology.objects[o];
  return o.type === "GeometryCollection"
      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature_feature(topology, o); })}
      : feature_feature(topology, o);
}

function feature_feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = feature_object(topology, o);
  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
}

function feature_object(topology, o) {
  var transformPoint = transform(topology.transform),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) reverse(points, n);
  }

  function point(p) {
    return transformPoint(p);
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type, coordinates;
    switch (type) {
      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
      case "Point": coordinates = point(o.coordinates); break;
      case "MultiPoint": coordinates = o.coordinates.map(point); break;
      case "LineString": coordinates = line(o.arcs); break;
      case "MultiLineString": coordinates = o.arcs.map(line); break;
      case "Polygon": coordinates = polygon(o.arcs); break;
      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
      default: return null;
    }
    return {type: type, coordinates: coordinates};
  }

  return geometry(o);
}

;// ./src/js/viz/d3/components/map_viz.js








var MapViz = function MapViz() {
  var config = {
    width: 400,
    height: 400,
    scale: 600,
    animationDuration: 200,
    projection: external_d3_default().geo.albersUsa(),
    topology: {},
    object: {},
    fill: {
      color: '#8cc63e',
      opacity: 1
    },
    stroke: {
      color: '#fdfdfd',
      width: 1,
      opacity: 1
    },
    hover: {
      fill: {
        color: '#ffffff',
        opacity: 0.7
      },
      stroke: {
        color: '#ffffff',
        width: 3,
        opacity: 1
      }
    },
    labels: {
      font: {
        size: '10px',
        color: '#000000'
      }
    },
    getLabelFormat: function getLabelFormat(d, center) {
      return {
        x: center[0],
        y: center[1]
      };
    },
    generateTooltip: function generateTooltip(evt) {
      var d = evt.d || {};
      if (d.tooltip) {
        return d.tooltip;
      }
      return '<div class="dark-dialog">' + (d.properties || {}).name + '</div>';
    },
    tooltip: nvTooltip()
  };
  var lifeCycle = new RenderLifeCycle();
  var mapViz = function mapViz(selection) {
    lifeCycle.start();
    if (config.tooltip && external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(config.generateTooltip)) {
      config.tooltip.contentGenerator(config.generateTooltip);
    }
    selection.each(function (data) {
      var container = external_d3_default().select(this),
        mapContainer = utils_createElementIfAbsent(container, 'map-container', 'g');
      config.projection.scale(config.scale).translate([config.width / 2, config.height / 2]);
      var pathGenerator = external_d3_default().geo.path().projection(config.projection);
      mapContainer.selectAll('path').data(feature(config.topology, config.object).features).enter().append('path').attr('class', 'topology');
      var paths = mapContainer.selectAll('path');
      paths.attr('d', pathGenerator).each(function (d) {
        Object.assign(d, data[d.id] || {});
      }).attr('id', function (d) {
        return d.id;
      }).style('fill', function (d) {
        d.color = d.color || config.fill.color;
        return d.color;
      }).style('fill-opacity', config.fill.opacity).style('stroke', config.stroke.color).style('stroke-width', config.stroke.width).style('stroke-opacity', config.stroke.opacity);
      paths.on('mouseover', function (d) {
        var element = external_d3_default().select(this);
        element.style('fill-opacity', config.hover.fill.opacity).style('stroke', config.hover.stroke.color).style('stroke-width', config.hover.stroke.width).style('stroke-opacity', config.hover.stroke.opacity);
        if (config.tooltip) {
          var evt = {
            d: d || {},
            series: [{
              key: d.id
            }],
            color: d.color
          };
          config.tooltip.data(evt).duration(0).hidden(false);
        }
      });
      paths.on('mousemove', function () {
        config.tooltip();
      });
      paths.on('mouseout', function () {
        var element = external_d3_default().select(this);
        element.style('fill-opacity', config.fill.opacity).style('stroke', config.stroke.color).style('stroke-width', config.stroke.width).style('stroke-opacity', config.stroke.opacity);
        if (config.tooltip) {
          config.tooltip.hidden(true);
        }
      });
      paths.each(function (d) {
        var labelContainer = utils_createElementIfAbsent(mapContainer, 'labelContainer-' + d.id, 'g');
        var labelText = utils_createElementIfAbsent(labelContainer, 'labelText', 'text');
        var labelLine = utils_createElementIfAbsent(labelContainer, 'labelLine', 'line');
        var center = pathGenerator.centroid(d);
        var labelFormat = {
          x: center[0],
          y: center[1]
        };
        if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isFunction(config.getLabelFormat)) {
          var dimensions = {
            width: config.width,
            height: config.height
          };
          labelFormat = config.getLabelFormat(d, center, config.projection, dimensions) || {};
        }
        labelFormat.text = d.label;
        if (external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().isUndefined(labelFormat.text) || labelFormat.text === '' || isNaN(labelFormat.x) || isNaN(labelFormat.y)) {
          labelContainer.remove();
          return;
        }
        labelText.attr('x', labelFormat.x).attr('y', labelFormat.y).style('font-size', config.labels.font.size).style('fill', labelFormat.fontColor || d.fontColor || config.labels.font.color).text(labelFormat.text);
        if (labelFormat.line && !isNaN(labelFormat.line.x1) && !isNaN(labelFormat.line.y1)) {
          labelLine.attr('x1', labelFormat.line.x1).attr('y1', labelFormat.line.y1).attr('x2', center[0]).attr('y2', center[1]).style('stroke', labelFormat.fontColor || d.fontColor || config.labels.font.color).style('stroke-width', 1);
        } else {
          labelLine.remove();
        }
      });
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(mapViz, config);
  mapViz.lifeCycle = lifeCycle.dispatch;
  return mapViz;
};
;// ./src/js/viz/d3/maps/base_map.js





var LEGEND_POSTIONS = {
  OFF: 'OFF',
  TOP: 'TOP',
  RIGHT: 'RIGHT',
  BOTTOM: 'BOTTOM'
};
var DEFAULT_FILL_COLOR = '#8cc63e';
var DEFAULT_FILL_OPACITY = 1;
var DEFAULT_ANIMATION_TIME = 200;
var MAP_CONTAINER_ID = '.map-container';
var BaseMap = Core.extend({
  legendPosition: LEGEND_POSTIONS.BOTTOM,
  nextAnimationTime: DEFAULT_ANIMATION_TIME,
  render: function render(postRender) {
    this.wrapContainer();
    this.availableWidth = this.getContainerWidth();
    this.availableHeight = this.getContainerHeight();
    this.chartX = 0;
    this.chartY = 0;
    var container = this.getContainer();
    this.renderLegend();
    this.createMapViz();
    this.mapViz.animationDuration(this.nextAnimationTime);
    this.mapViz.lifeCycle.on('renderEnd', function () {
      postRender && postRender();
    });
    container.datum(this.data).call(this.mapViz);
    container.selectAll(MAP_CONTAINER_ID).attr('transform', 'translate(' + this.chartX + ', ' + this.chartY + ')');
    this.nextAnimationTime = DEFAULT_ANIMATION_TIME;
    return this;
  },
  renderLegend: function renderLegend() {
    var container = this.getContainer();
    this.createLegend();
    var legendContainer = utils_createElementIfAbsent(container, 'dq-legend-container', 'g');
    if (this.legendPosition === LEGEND_POSTIONS.OFF) {
      legendContainer.remove();
      return;
    }
    switch (this.legendPosition) {
      case LEGEND_POSTIONS.TOP:
        this.legend.orientation('horizontal');
        break;
      case LEGEND_POSTIONS.BOTTOM:
        this.legend.orientation('horizontal');
        break;
      case LEGEND_POSTIONS.RIGHT:
        this.legend.orientation('vertical');
        break;
    }
    legendContainer.datum(this.legendData || this.data).call(this.legend);
    var legendX = 0;
    var legendY = 0;
    var legendWidth = this.legend.width();
    var legendHeight = this.legend.height();
    switch (this.legendPosition) {
      case LEGEND_POSTIONS.TOP:
        this.chartY = legendHeight;
        this.availableHeight -= legendHeight;
        break;
      case LEGEND_POSTIONS.BOTTOM:
        legendY = this.availableHeight - legendHeight;
        this.availableHeight -= legendHeight;
        break;
      case LEGEND_POSTIONS.RIGHT:
        legendX = this.availableWidth - legendWidth;
        this.availableWidth -= legendWidth;
        break;
    }
    return legendContainer.transition().attr('transform', 'translate(' + legendX + ', ' + legendY + ')');
  },
  createLegend: function createLegend() {
    this.legend || (this.legend = dqLegend());
    this.legend.width(this.availableWidth).height(this.availableHeight).clickDisabled(true);
  },
  createMapViz: function createMapViz() {
    this.mapViz || (this.mapViz = MapViz());
    this.mapViz.width(this.availableWidth).height(this.availableHeight).fill({
      color: this.fillColor || DEFAULT_FILL_COLOR,
      opacity: DEFAULT_FILL_OPACITY
    });
    this.configureMapViz(this.mapViz);
  },
  configureMapViz: function configureMapViz() {},
  setData: function setData(data) {
    this.data = data;
    return this;
  },
  setLegendData: function setLegendData(legendData) {
    this.legendData = legendData;
    return this;
  },
  setLegendPosition: function setLegendPosition(legendPosition) {
    if (!LEGEND_POSTIONS[legendPosition]) {
      return this;
    }
    this.legendPosition = legendPosition;
    return this;
  },
  setFillColor: function setFillColor(fillColor) {
    this.fillColor = fillColor;
    return this;
  },
  setScale: function setScale(scale) {
    this.scale = scale;
    return this;
  },
  disableNextAnimation: function disableNextAnimation() {
    this.nextAnimationTime = 0;
  },
  getLocations: function getLocations() {
    return [];
  },
  resize: function resize() {
    if (this.mapViz) {
      this.disableNextAnimation();
      Core.prototype.resize.apply(this, arguments);
    }
  }
});
;// ./src/js/viz/d3/maps/usa/usa_map.js





var DEFAULT_GEO_SCALE = 1285;
var DEFAULT_GEO_WIDTH = 960;
var DEFAULT_GEO_HEIGHT = 600;
var LABEL_FONT_SIZE = 10;
var LABEL_FONT_COLOR = '#000000';
var SMALL_LABEL_PADDING = 20;
var SMALL_STATES = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD'];
var HIDDEN_STATES = ['DC'];
var X_OFFSET = -7.5;
var Y_OFFSET = 5;
function getLabelFormat(d, center, projection, dimensions) {
  var key = d.id;
  if (HIDDEN_STATES.indexOf(key) > -1) {
    return {};
  }
  var smallStateIndex = SMALL_STATES.indexOf(key);
  if (smallStateIndex > -1) {
    var smallStateLabelFormat = getSmallStateLabelFormat(key, smallStateIndex, projection, dimensions);
    if (smallStateLabelFormat) {
      return smallStateLabelFormat;
    }
  }
  return {
    x: center[0] + X_OFFSET,
    y: center[1] + Y_OFFSET
  };
}
function getSmallStateLabelFormat(key, smallStateIndex, projection, dimensions) {
  var labelStartCoodinates = projection([-67.707617, 42.722131]);
  var x = labelStartCoodinates[0];
  var y = labelStartCoodinates[1] + smallStateIndex * (2 + (LABEL_FONT_SIZE || 12));
  if (x < dimensions.width - SMALL_LABEL_PADDING && y < dimensions.height - SMALL_LABEL_PADDING) {
    return {
      x: x,
      y: y,
      fontColor: LABEL_FONT_COLOR,
      line: {
        x1: x - 3,
        y1: y - 5
      }
    };
  }
}
var UsaMap = BaseMap.extend({
  projection: external_d3_default().geo.albersUsa(),
  configureMapViz: function configureMapViz(mapViz) {
    var adjustedWidth = DEFAULT_GEO_SCALE / DEFAULT_GEO_WIDTH * this.availableWidth;
    var adjustedHeight = DEFAULT_GEO_SCALE / DEFAULT_GEO_HEIGHT * this.availableHeight;
    var scale = this.scale || external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().min([adjustedWidth, adjustedHeight]);
    mapViz.projection(this.projection).topology(topology).object(topology.objects.usa).getLabelFormat(getLabelFormat).labels({
      font: {
        size: '' + LABEL_FONT_SIZE + 'px',
        color: LABEL_FONT_COLOR
      }
    }).scale(scale);
  },
  getLocations: function getLocations() {
    this.locations = this.locations || external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().map(topology.objects.usa.geometries, function (geo) {
      return {
        id: geo.id,
        name: geo.properties.name
      };
    });
    return this.locations;
  }
}, {
  Name: 'UsaMap',
  DataDimensions: '1'
});
;// ./src/js/viz/d3/maps/world/topology.js
var topology_topology = {
  type: 'Topology',
  objects: {
    world: {
      type: 'GeometryCollection',
      geometries: [{
        type: 'Polygon',
        properties: {
          name: 'Afghanistan'
        },
        id: 'AFG',
        arcs: [[0, 1, 2, 3, 4, 5]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Angola'
        },
        id: 'AGO',
        arcs: [[[6, 7, 8, 9]], [[10, 11, 12]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Albania'
        },
        id: 'ALB',
        arcs: [[13, 14, 15, 16, 17]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'United Arab Emirates'
        },
        id: 'ARE',
        arcs: [[18, 19, 20, 21, 22]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Argentina'
        },
        id: 'ARG',
        arcs: [[[23, 24]], [[25, 26, 27, 28, 29, 30]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Armenia'
        },
        id: 'ARM',
        arcs: [[31, 32, 33, 34, 35]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Antarctica'
        },
        id: 'ATA',
        arcs: [[[36]], [[37]], [[38]], [[39]], [[40]], [[41]], [[42]], [[43]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'French Southern and Antarctic Lands'
        },
        id: 'ATF',
        arcs: [[44]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Australia'
        },
        id: 'AUS',
        arcs: [[[45]], [[46]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Austria'
        },
        id: 'AUT',
        arcs: [[47, 48, 49, 50, 51, 52, 53]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Azerbaijan'
        },
        id: 'AZE',
        arcs: [[[54, -35]], [[55, 56, -33, 57, 58]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Burundi'
        },
        id: 'BDI',
        arcs: [[59, 60, 61]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Belgium'
        },
        id: 'BEL',
        arcs: [[62, 63, 64, 65, 66]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Benin'
        },
        id: 'BEN',
        arcs: [[67, 68, 69, 70, 71]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Burkina Faso'
        },
        id: 'BFA',
        arcs: [[72, 73, 74, -70, 75, 76]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Bangladesh'
        },
        id: 'BGD',
        arcs: [[77, 78, 79]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Bulgaria'
        },
        id: 'BGR',
        arcs: [[80, 81, 82, 83, 84, 85]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'The Bahamas'
        },
        id: 'BHS',
        arcs: [[[86]], [[87]], [[88]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Bosnia and Herzegovina'
        },
        id: 'BIH',
        arcs: [[89, 90, 91]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Belarus'
        },
        id: 'BLR',
        arcs: [[92, 93, 94, 95, 96]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Belize'
        },
        id: 'BLZ',
        arcs: [[97, 98, 99]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Bolivia'
        },
        id: 'BOL',
        arcs: [[100, 101, 102, 103, -31]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Brazil'
        },
        id: 'BRA',
        arcs: [[-27, 104, -103, 105, 106, 107, 108, 109, 110, 111, 112]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Brunei'
        },
        id: 'BRN',
        arcs: [[113, 114]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Bhutan'
        },
        id: 'BTN',
        arcs: [[115, 116]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Botswana'
        },
        id: 'BWA',
        arcs: [[117, 118, 119, 120]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Central African Republic'
        },
        id: 'CAF',
        arcs: [[121, 122, 123, 124, 125, 126, 127]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Canada'
        },
        id: 'CAN',
        arcs: [[[128]], [[129]], [[130]], [[131]], [[132]], [[133]], [[134]], [[135]], [[136]], [[137]], [[138, 139, 140, 141]], [[142]], [[143]], [[144]], [[145]], [[146]], [[147]], [[148]], [[149]], [[150]], [[151]], [[152]], [[153]], [[154]], [[155]], [[156]], [[157]], [[158]], [[159]], [[160]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Switzerland'
        },
        id: 'CHE',
        arcs: [[-51, 161, 162, 163]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Chile'
        },
        id: 'CHL',
        arcs: [[[-24, 164]], [[-30, 165, 166, -101]]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'China'
        },
        id: 'CHN',
        arcs: [[[167]], [[168, 169, 170, 171, 172, 173, -117, 174, 175, 176, 177, -4, 178, 179, 180, 181, 182, 183]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Ivory Coast'
        },
        id: 'CIV',
        arcs: [[184, 185, 186, 187, -73, 188]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Cameroon'
        },
        id: 'CMR',
        arcs: [[189, 190, 191, 192, 193, 194, -128, 195]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Democratic Republic of the Congo'
        },
        id: 'COD',
        arcs: [[196, 197, -60, 198, 199, -10, 200, -13, 201, -126, 202]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Republic of the Congo'
        },
        id: 'COG',
        arcs: [[-12, 203, 204, -196, -127, -202]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Colombia'
        },
        id: 'COL',
        arcs: [[205, 206, 207, 208, 209, -107, 210]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Costa Rica'
        },
        id: 'CRI',
        arcs: [[211, 212, 213, 214]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Cuba'
        },
        id: 'CUB',
        arcs: [[215]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Northern Cyprus'
        },
        id: 'northern_cyprus',
        arcs: [[216, 217]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Cyprus'
        },
        id: 'CYP',
        arcs: [[218, -218]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Czech Republic'
        },
        id: 'CZE',
        arcs: [[-53, 219, 220, 221]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Germany'
        },
        id: 'DEU',
        arcs: [[222, 223, -220, -52, -164, 224, 225, -64, 226, 227, 228]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Djibouti'
        },
        id: 'DJI',
        arcs: [[229, 230, 231, 232]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Denmark'
        },
        id: 'DNK',
        arcs: [[[233]], [[-229, 234]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Dominican Republic'
        },
        id: 'DOM',
        arcs: [[235, 236]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Algeria'
        },
        id: 'DZA',
        arcs: [[237, 238, 239, 240, 241, 242, 243, 244]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Ecuador'
        },
        id: 'ECU',
        arcs: [[245, -206, 246]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Egypt'
        },
        id: 'EGY',
        arcs: [[247, 248, 249, 250, 251]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Eritrea'
        },
        id: 'ERI',
        arcs: [[252, 253, 254, -233]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Spain'
        },
        id: 'ESP',
        arcs: [[255, 256, 257, 258]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Estonia'
        },
        id: 'EST',
        arcs: [[259, 260, 261]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Ethiopia'
        },
        id: 'ETH',
        arcs: [[-232, 262, 263, 264, 265, 266, 267, -253]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Finland'
        },
        id: 'FIN',
        arcs: [[268, 269, 270, 271]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Fiji'
        },
        id: 'FJI',
        arcs: [[[272]], [[273, 274]], [[275, -275]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Falkland Islands'
        },
        id: 'FLK',
        arcs: [[276]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'France'
        },
        id: 'FRA',
        arcs: [[[277]], [[278, -225, -163, 279, 280, -257, 281, -66]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'French Guiana'
        },
        id: 'GUF',
        arcs: [[282, 283, 284, 285, -111]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Gabon'
        },
        id: 'GAB',
        arcs: [[286, 287, -190, -205]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'United Kingdom'
        },
        id: 'GBR',
        arcs: [[[288, 289]], [[290]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Georgia'
        },
        id: 'GEO',
        arcs: [[291, 292, -58, -32, 293]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Ghana'
        },
        id: 'GHA',
        arcs: [[294, -189, -77, 295]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Guinea'
        },
        id: 'GIN',
        arcs: [[296, 297, 298, 299, 300, 301, -187]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Gambia'
        },
        id: 'GMB',
        arcs: [[302, 303]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Guinea Bissau'
        },
        id: 'GNB',
        arcs: [[304, 305, -300]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Equatorial Guinea'
        },
        id: 'GNQ',
        arcs: [[306, -191, -288]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Greece'
        },
        id: 'GRC',
        arcs: [[[307]], [[308, -15, 309, -84, 310]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Greenland'
        },
        id: 'GRL',
        arcs: [[311]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Guatemala'
        },
        id: 'GTM',
        arcs: [[312, 313, -100, 314, 315, 316]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Guyana'
        },
        id: 'GUY',
        arcs: [[317, 318, -109, 319]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Honduras'
        },
        id: 'HND',
        arcs: [[320, 321, -316, 322, 323]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Croatia'
        },
        id: 'HRV',
        arcs: [[324, -92, 325, 326, 327, 328]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Haiti'
        },
        id: 'HTI',
        arcs: [[-237, 329]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Hungary'
        },
        id: 'HUN',
        arcs: [[-48, 330, 331, 332, 333, -329, 334]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Indonesia'
        },
        id: 'IDN',
        arcs: [[[335]], [[336, 337]], [[338]], [[339]], [[340]], [[341]], [[342]], [[343]], [[344, 345]], [[346]], [[347]], [[348, 349]], [[350]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'India'
        },
        id: 'IND',
        arcs: [[-177, 351, -175, -116, -174, 352, -80, 353, 354]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Ireland'
        },
        id: 'IRL',
        arcs: [[355, -289]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Iran'
        },
        id: 'IRN',
        arcs: [[356, -6, 357, 358, 359, 360, -55, -34, -57, 361]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Iraq'
        },
        id: 'IRQ',
        arcs: [[362, 363, 364, 365, 366, 367, -360]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Iceland'
        },
        id: 'ISL',
        arcs: [[368]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Israel'
        },
        id: 'ISR',
        arcs: [[369, 370, 371, -252, 372, 373, 374]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Italy'
        },
        id: 'ITA',
        arcs: [[[375]], [[376]], [[377, 378, -280, -162, -50]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Jamaica'
        },
        id: 'JAM',
        arcs: [[379]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Jordan'
        },
        id: 'JOR',
        arcs: [[-370, 380, -366, 381, 382, -372, 383]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Japan'
        },
        id: 'JPN',
        arcs: [[[384]], [[385]], [[386]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Kazakhstan'
        },
        id: 'KAZ',
        arcs: [[387, 388, 389, 390, -181, 391]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Kenya'
        },
        id: 'KEN',
        arcs: [[392, 393, 394, 395, -265, 396]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Kyrgyzstan'
        },
        id: 'KGZ',
        arcs: [[-392, -180, 397, 398]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Cambodia'
        },
        id: 'KHM',
        arcs: [[399, 400, 401, 402]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'South Korea'
        },
        id: 'KOR',
        arcs: [[403, 404]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Kosovo'
        },
        id: 'XXK',
        arcs: [[-18, 405, 406, 407]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Kuwait'
        },
        id: 'KWT',
        arcs: [[408, 409, -364]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Laos'
        },
        id: 'LAO',
        arcs: [[410, 411, -172, 412, -401]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Lebanon'
        },
        id: 'LBN',
        arcs: [[-374, 413, 414]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Liberia'
        },
        id: 'LBR',
        arcs: [[415, 416, -297, -186]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Libya'
        },
        id: 'LBY',
        arcs: [[417, -245, 418, 419, -250, 420, 421]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Sri Lanka'
        },
        id: 'LKA',
        arcs: [[422]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Lesotho'
        },
        id: 'LSO',
        arcs: [[423]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Lithuania'
        },
        id: 'LTU',
        arcs: [[424, 425, 426, -93, 427]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Luxembourg'
        },
        id: 'LUX',
        arcs: [[-226, -279, -65]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Latvia'
        },
        id: 'LVA',
        arcs: [[428, -262, 429, -94, -427]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Morocco'
        },
        id: 'MAR',
        arcs: [[-242, 430, 431]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Moldova'
        },
        id: 'MDA',
        arcs: [[432, 433]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Madagascar'
        },
        id: 'MDG',
        arcs: [[434]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Mexico'
        },
        id: 'MEX',
        arcs: [[435, -98, -314, 436, 437]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Macedonia'
        },
        id: 'MKD',
        arcs: [[-408, 438, -85, -310, -14]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Mali'
        },
        id: 'MLI',
        arcs: [[439, -239, 440, -74, -188, -302, 441]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Myanmar'
        },
        id: 'MMR',
        arcs: [[442, -78, -353, -173, -412, 443]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Montenegro'
        },
        id: 'MNE',
        arcs: [[444, -326, -91, 445, -406, -17]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Mongolia'
        },
        id: 'MNG',
        arcs: [[446, -183]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Mozambique'
        },
        id: 'MOZ',
        arcs: [[447, 448, 449, 450, 451, 452, 453, 454]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Mauritania'
        },
        id: 'MRT',
        arcs: [[455, 456, 457, -240, -440]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Malawi'
        },
        id: 'MWI',
        arcs: [[-455, 458, 459]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Malaysia'
        },
        id: 'MYS',
        arcs: [[[460, 461]], [[-349, 462, -115, 463]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Namibia'
        },
        id: 'NAM',
        arcs: [[464, -8, 465, -119, 466]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'New Caledonia'
        },
        id: 'NCL',
        arcs: [[467]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Niger'
        },
        id: 'NER',
        arcs: [[-75, -441, -238, -418, 468, -194, 469, -71]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Nigeria'
        },
        id: 'NGA',
        arcs: [[470, -72, -470, -193]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Nicaragua'
        },
        id: 'NIC',
        arcs: [[471, -324, 472, -213]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Netherlands'
        },
        id: 'NLD',
        arcs: [[-227, -63, 473]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Norway'
        },
        id: 'NOR',
        arcs: [[[474, -272, 475, 476]], [[477]], [[478]], [[479]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Nepal'
        },
        id: 'NPL',
        arcs: [[-352, -176]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'New Zealand'
        },
        id: 'NZL',
        arcs: [[[480]], [[481]]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Oman'
        },
        id: 'OMN',
        arcs: [[[482, 483, -22, 484]], [[-20, 485]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Pakistan'
        },
        id: 'PAK',
        arcs: [[-178, -355, 486, -358, -5]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Panama'
        },
        id: 'PAN',
        arcs: [[487, -215, 488, -208]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Peru'
        },
        id: 'PER',
        arcs: [[-167, 489, -247, -211, -106, -102]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Philippines'
        },
        id: 'PHL',
        arcs: [[[490]], [[491]], [[492]], [[493]], [[494]], [[495]], [[496]]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Papua New Guinea'
        },
        id: 'PNG',
        arcs: [[[497]], [[498]], [[-345, 499]], [[500]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Poland'
        },
        id: 'POL',
        arcs: [[-224, 501, 502, -428, -97, 503, 504, -221]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Puerto Rico'
        },
        id: 'PRI',
        arcs: [[505]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'North Korea'
        },
        id: 'PRK',
        arcs: [[506, 507, -405, 508, -169]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Portugal'
        },
        id: 'PRT',
        arcs: [[-259, 509]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Paraguay'
        },
        id: 'PRY',
        arcs: [[-104, -105, -26]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Qatar'
        },
        id: 'QAT',
        arcs: [[510, 511]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Romania'
        },
        id: 'ROU',
        arcs: [[512, -434, 513, 514, -81, 515, -333]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Russia'
        },
        id: 'RUS',
        arcs: [[[516]], [[-503, 517, -425]], [[518, 519]], [[520]], [[521]], [[522]], [[523]], [[524]], [[525]], [[526, -507, -184, -447, -182, -391, 527, -59, -293, 528, 529, -95, -430, -261, 530, -269, -475, 531, -520]], [[532]], [[533]], [[534]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Rwanda'
        },
        id: 'RWA',
        arcs: [[535, -61, -198, 536]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Western Sahara'
        },
        id: 'ESH',
        arcs: [[-241, -458, 537, -431]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Saudi Arabia'
        },
        id: 'SAU',
        arcs: [[538, -382, -365, -410, 539, -512, 540, -23, -484, 541]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Sudan'
        },
        id: 'SDN',
        arcs: [[542, 543, -123, 544, -421, -249, 545, -254, -268, 546]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'South Sudan'
        },
        id: 'SSD',
        arcs: [[547, -266, -396, 548, -203, -125, 549, -543]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Senegal'
        },
        id: 'SEN',
        arcs: [[550, -456, -442, -301, -306, 551, -304]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Solomon Islands'
        },
        id: 'SLB',
        arcs: [[[552]], [[553]], [[554]], [[555]], [[556]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Sierra Leone'
        },
        id: 'SLE',
        arcs: [[557, -298, -417]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'El Salvador'
        },
        id: 'SLV',
        arcs: [[558, -317, -322]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Somaliland'
        },
        id: 'somaliland',
        arcs: [[-263, -231, 559, 560]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Somalia'
        },
        id: 'SOM',
        arcs: [[-397, -264, -561, 561]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Republic of Serbia'
        },
        id: 'SRB',
        arcs: [[-86, -439, -407, -446, -90, -325, -334, -516]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Suriname'
        },
        id: 'SUR',
        arcs: [[562, -285, 563, -283, -110, -319]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Slovakia'
        },
        id: 'SVK',
        arcs: [[-505, 564, -331, -54, -222]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Slovenia'
        },
        id: 'SVN',
        arcs: [[-49, -335, -328, 565, -378]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Sweden'
        },
        id: 'SWE',
        arcs: [[-476, -271, 566]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Swaziland'
        },
        id: 'SWZ',
        arcs: [[567, -451]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Syria'
        },
        id: 'SYR',
        arcs: [[-381, -375, -415, 568, 569, -367]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Chad'
        },
        id: 'TCD',
        arcs: [[-469, -422, -545, -122, -195]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Togo'
        },
        id: 'TGO',
        arcs: [[570, -296, -76, -69]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Thailand'
        },
        id: 'THA',
        arcs: [[571, -462, 572, -444, -411, -400]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Tajikistan'
        },
        id: 'TJK',
        arcs: [[-398, -179, -3, 573]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Turkmenistan'
        },
        id: 'TKM',
        arcs: [[-357, 574, -389, 575, -1]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'East Timor'
        },
        id: 'TLS',
        arcs: [[576, -337]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Trinidad and Tobago'
        },
        id: 'TTO',
        arcs: [[577]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Tunisia'
        },
        id: 'TUN',
        arcs: [[-244, 578, -419]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Turkey'
        },
        id: 'TUR',
        arcs: [[[-294, -36, -361, -368, -570, 579]], [[-311, -83, 580]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Taiwan'
        },
        id: 'TWN',
        arcs: [[581]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'United Republic of Tanzania'
        },
        id: 'TZA',
        arcs: [[-394, 582, -448, -460, 583, -199, -62, -536, 584]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Uganda'
        },
        id: 'UGA',
        arcs: [[-537, -197, -549, -395, -585]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Ukraine'
        },
        id: 'UKR',
        arcs: [[-530, 585, -514, -433, -513, -332, -565, -504, -96]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Uruguay'
        },
        id: 'URY',
        arcs: [[-113, 586, -28]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'United States'
        },
        id: 'USA',
        arcs: [[[587]], [[588]], [[589]], [[590]], [[591]], [[592, -438, 593, -139]], [[594]], [[595]], [[596]], [[-141, 597]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Uzbekistan'
        },
        id: 'UZB',
        arcs: [[-576, -388, -399, -574, -2]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Venezuela'
        },
        id: 'VEN',
        arcs: [[598, -320, -108, -210]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Vietnam'
        },
        id: 'VNM',
        arcs: [[599, -402, -413, -171]]
      }, {
        type: 'MultiPolygon',
        properties: {
          name: 'Vanuatu'
        },
        id: 'VUT',
        arcs: [[[600]], [[601]]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'West Bank'
        },
        id: 'PSE',
        arcs: [[-384, -371]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Yemen'
        },
        id: 'YEM',
        arcs: [[602, -542, -483]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'South Africa'
        },
        id: 'ZAF',
        arcs: [[-467, -118, 603, -452, -568, -450, 604], [-424]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Zambia'
        },
        id: 'ZMB',
        arcs: [[-459, -454, 605, -120, -466, -7, -200, -584]]
      }, {
        type: 'Polygon',
        properties: {
          name: 'Zimbabwe'
        },
        id: 'ZWE',
        arcs: [[-604, -121, -606, -453]]
      }]
    }
  },
  arcs: [[[6700, 7164], [28, -23], [21, 8], [6, 27], [22, 9], [15, 18], [6, 47], [23, 11], [5, 21], [13, -15], [8, -2]], [[6847, 7265], [16, -1], [20, -12]], [[6883, 7252], [9, -7], [20, 19], [9, -12], [9, 27], [17, -1], [4, 9], [3, 24], [12, 20], [15, -13], [-3, -18], [9, -3], [-3, -50], [11, -19], [10, 12], [12, 6], [17, 27], [19, -5], [29, 0]], [[7082, 7268], [5, -17]], [[7087, 7251], [-16, -6], [-14, -11], [-32, -7], [-30, -13], [-16, -25], [6, -25], [4, -30], [-14, -25], [1, -22], [-8, -22], [-26, 2], [11, -39], [-18, -15], [-12, -35], [2, -36], [-11, -16], [-10, 5], [-22, -8], [-3, -16], [-20, 0], [-16, -34], [-1, -50], [-36, -24], [-19, 5], [-6, -13], [-16, 7], [-28, -8], [-47, 30]], [[6690, 6820], [25, 53], [-2, 38], [-21, 10], [-2, 38], [-9, 47], [12, 32], [-12, 9], [7, 43], [12, 74]], [[5664, 4412], [3, -18], [-4, -29], [5, -28], [-4, -22], [3, -20], [-58, 1], [-2, -188], [19, -49], [18, -37]], [[5644, 4022], [-51, -24], [-67, 9], [-19, 28], [-113, -3], [-4, -4], [-17, 27], [-18, 2], [-16, -10], [-14, -12]], [[5325, 4035], [-2, 38], [4, 51], [9, 55], [2, 25], [9, 53], [6, 24], [16, 39], [9, 26], [3, 44], [-1, 34], [-9, 21], [-7, 36], [-7, 35], [2, 12], [8, 24], [-8, 57], [-6, 39], [-14, 38], [3, 11]], [[5342, 4697], [11, 8], [8, -1], [10, 7], [82, -1], [7, -44], [8, -35], [6, -19], [11, -31], [18, 5], [9, 8], [16, -8], [4, 14], [7, 35], [17, 2], [2, 10], [14, 1], [-3, -22], [34, 1], [1, -37], [5, -23], [-4, -36], [2, -36], [9, -22], [-1, -70], [7, 5], [12, -1], [17, 8], [13, -3]], [[5338, 4715], [-8, 45]], [[5330, 4760], [12, 25], [8, 10], [10, -20]], [[5360, 4775], [-10, -12], [-4, -16], [-1, -25], [-7, -7]], [[5571, 7530], [-3, -20], [4, -25], [11, -15]], [[5583, 7470], [0, -15], [-9, -9], [-2, -19], [-13, -29]], [[5559, 7398], [-5, 5], [0, 13], [-15, 19], [-3, 29], [2, 40], [4, 18], [-4, 10]], [[5538, 7532], [-2, 18], [12, 29], [1, -11], [8, 6]], [[5557, 7574], [6, -16], [7, -6], [1, -22]], [[6432, 6490], [5, 3], [1, -16], [22, 9], [23, -2], [17, -1], [19, 39], [20, 38], [18, 37]], [[6557, 6597], [5, -20]], [[6562, 6577], [4, -47]], [[6566, 6530], [-14, 0], [-3, -39], [5, -8], [-12, -12], [0, -24], [-8, -24], [-1, -24]], [[6533, 6399], [-6, -12], [-83, 29], [-11, 60], [-1, 14]], [[3140, 1814], [-17, 2], [-30, 0], [0, 132]], [[3093, 1948], [11, -27], [14, -45], [36, -35], [39, -15], [-13, -30], [-26, -2], [-14, 20]], [[3258, 3743], [51, -96], [23, -9], [34, -44], [29, -23], [4, -26], [-28, -90], [28, -16], [32, -9], [22, 10], [25, 45], [4, 52]], [[3482, 3537], [14, 11], [14, -34], [-1, -47], [-23, -33], [-19, -24], [-31, -57], [-37, -81]], [[3399, 3272], [-7, -47], [-7, -61], [0, -58], [-6, -14], [-2, -38]], [[3377, 3054], [-2, -31], [35, -50], [-4, -41], [18, -26], [-2, -29], [-26, -75], [-42, -32], [-55, -12], [-31, 6], [6, -36], [-6, -44], [5, -30], [-16, -20], [-29, -8], [-26, 21], [-11, -15], [4, -59], [18, -18], [16, 19], [8, -31], [-26, -18], [-22, -37], [-4, -59], [-7, -32], [-26, 0], [-22, -31], [-8, -44], [28, -43], [26, -12], [-9, -53], [-33, -33], [-18, -70], [-25, -23], [-12, -28], [9, -61], [19, -34], [-12, 3]], [[3095, 1968], [-26, 9], [-67, 8], [-11, 34], [0, 45], [-18, -4], [-10, 21], [-3, 63], [22, 26], [9, 37], [-4, 30], [15, 51], [10, 78], [-3, 35], [12, 11], [-3, 22], [-13, 12], [10, 25], [-13, 22], [-6, 68], [11, 12], [-5, 72], [7, 61], [7, 52], [17, 22], [-9, 58], [0, 54], [21, 38], [-1, 50], [16, 57], [0, 55], [-7, 11], [-13, 102], [17, 60], [-2, 58], [10, 53], [18, 56], [20, 36], [-9, 24], [6, 19], [-1, 98], [30, 29], [10, 62], [-3, 14]], [[3136, 3714], [23, 54], [36, -15], [16, -42], [11, 47], [32, -2], [4, -13]], [[6210, 7485], [39, 9]], [[6249, 7494], [5, -15], [11, -10], [-6, -15], [15, -21], [-8, -18], [12, -16], [13, -10], [0, -41]], [[6291, 7348], [-10, -2]], [[6281, 7346], [-11, 34], [0, 10], [-12, -1], [-9, 16], [-5, -1]], [[6244, 7404], [-11, 17], [-21, 15], [3, 28], [-5, 21]], [[3345, 329], [-8, -30], [-8, -27], [-59, 8], [-62, -3], [-34, 20], [0, 2], [-16, 17], [63, -2], [60, -6], [20, 24], [15, 21], [29, -24]], [[577, 361], [-53, -8], [-36, 21], [-17, 21], [-1, 3], [-18, 16], [17, 22], [52, -9], [28, -18], [21, -21], [7, -27]], [[3745, 447], [35, -26], [12, -36], [3, -25], [1, -30], [-43, -19], [-45, -15], [-52, -14], [-59, -11], [-65, 3], [-37, 20], [5, 24], [59, 16], [24, 20], [18, 26], [12, 22], [17, 20], [18, 25], [14, 0], [41, 12], [42, -12]], [[1633, 715], [36, -9], [33, 10], [-16, -20], [-26, -15], [-39, 4], [-27, 21], [6, 20], [33, -11]], [[1512, 716], [43, -23], [-17, 3], [-36, 5], [-38, 17], [20, 12], [28, -14]], [[2250, 808], [31, -8], [30, 7], [17, -34], [-22, 5], [-34, -2], [-34, 2], [-38, -4], [-28, 12], [-15, 24], [18, 11], [35, -8], [40, -5]], [[3098, 866], [4, -27], [-5, -23], [-8, -22], [-33, -8], [-31, -12], [-36, 1], [14, 24], [-33, -9], [-31, -8], [-21, 18], [-2, 24], [30, 23], [20, 7], [32, -2], [8, 30], [1, 22], [0, 47], [16, 28], [25, 9], [15, -22], [6, -22], [12, -26], [10, -26], [7, -26]], [[3371, 1268], [-11, -13], [-21, 9], [-23, -6], [-19, -14], [-20, -15], [-14, -17], [-4, -23], [2, -22], [13, -20], [-19, -14], [-26, -4], [-15, -20], [-17, -19], [-17, -25], [-4, -22], [9, -24], [15, -19], [23, -14], [21, -18], [12, -23], [6, -22], [8, -24], [13, -19], [8, -22], [4, -55], [8, -22], [2, -23], [9, -23], [-4, -31], [-15, -24], [-17, -20], [-37, -8], [-12, -21], [-17, -20], [-42, -22], [-37, -9], [-35, -13], [-37, -13], [-22, -24], [-45, -2], [-49, 2], [-44, -4], [-47, 0], [9, -24], [42, -10], [31, -16], [18, -21], [-31, -19], [-48, 6], [-40, -15], [-2, -24], [-1, -23], [33, -20], [6, -22], [35, -22], [59, -9], [50, -16], [40, -19], [50, -18], [70, -10], [68, -16], [47, -17], [52, -20], [27, -28], [13, -22], [34, 21], [46, 17], [48, 19], [58, 15], [49, 16], [69, 1], [68, -8], [56, -14], [18, 26], [39, 17], [70, 1], [55, 13], [52, 13], [58, 8], [62, 10], [43, 15], [-20, 21], [-12, 21], [0, 22], [-54, -2], [-57, -10], [-54, 0], [-8, 22], [4, 44], [12, 13], [40, 14], [47, 14], [34, 17], [33, 18], [25, 23], [38, 10], [38, 8], [19, 5], [43, 2], [41, 8], [34, 12], [34, 14], [30, 14], [39, 18], [24, 20], [26, 17], [9, 24], [-30, 13], [10, 25], [18, 18], [29, 12], [31, 14], [28, 18], [22, 23], [13, 28], [21, 16], [33, -3], [13, -20], [34, -2], [1, 22], [14, 23], [30, -6], [7, -22], [33, -3], [36, 10], [35, 7], [31, -3], [12, -25], [31, 20], [28, 10], [31, 9], [31, 8], [29, 14], [31, 9], [24, 13], [17, 20], [20, -15], [29, 8], [20, -27], [16, -21], [32, 11], [12, 24], [28, 16], [37, -4], [11, -22], [22, 22], [30, 7], [33, 3], [29, -2], [31, -7], [30, -3], [13, -20], [18, -17], [31, 10], [32, 3], [32, 0], [31, 1], [28, 8], [29, 7], [25, 16], [26, 11], [28, 5], [21, 17], [15, 32], [16, 20], [29, -10], [11, -21], [24, -13], [29, 4], [19, -21], [21, -15], [28, 14], [10, 26], [25, 10], [29, 20], [27, 8], [33, 11], [22, 13], [22, 14], [22, 13], [26, -7], [25, 21], [18, 16], [26, -1], [23, 14], [6, 21], [23, 16], [23, 11], [28, 10], [25, 4], [25, -3], [26, -6], [22, -16], [3, -26], [24, -19], [17, -17], [33, -7], [19, -16], [23, -16], [26, -3], [23, 11], [24, 24], [26, -12], [27, -7], [26, -7], [27, -5], [28, 0], [23, -61], [-1, -15], [-4, -27], [-26, -15], [-22, -22], [4, -23], [31, 1], [-4, -23], [-14, -22], [-13, -24], [21, -19], [32, -6], [32, 11], [15, 23], [10, 22], [15, 18], [17, 18], [7, 21], [15, 29], [18, 5], [31, 3], [28, 7], [28, 9], [14, 23], [8, 22], [19, 22], [27, 15], [23, 12], [16, 19], [15, 11], [21, 9], [27, -6], [25, 6], [28, 7], [30, -4], [20, 17], [14, 39], [11, -16], [13, -28], [23, -12], [27, -4], [26, 7], [29, -5], [26, -1], [17, 6], [24, -4], [21, -12], [25, 8], [30, 0], [25, 8], [29, -8], [19, 19], [14, 20], [19, 16], [35, 44], [18, -8], [21, -16], [18, -21], [36, -36], [27, -1], [25, 0], [30, 7], [30, 8], [23, 16], [19, 18], [31, 2], [21, 13], [22, -12], [14, -18], [19, -19], [31, 2], [19, -15], [33, -15], [35, -5], [29, 4], [21, 19], [19, 18], [25, 5], [25, -8], [29, -6], [26, 9], [25, 0], [24, -6], [26, -5], [25, 10], [30, 9], [28, 3], [32, 0], [25, 5], [25, 5], [8, 29], [1, 24], [17, -16], [5, -27], [10, -24], [11, -20], [23, -10], [32, 4], [36, 1], [25, 3], [37, 0], [26, 1], [36, -2], [31, -5], [20, -18], [-5, -22], [18, -18], [30, -13], [31, -15], [35, -11], [38, -9], [28, -9], [32, -2], [18, 20], [24, -16], [21, -19], [25, -13], [34, -6], [32, -7], [13, -23], [32, -14], [21, -21], [31, -9], [32, 1], [30, -4], [33, 1], [34, -4], [31, -8], [28, -14], [29, -12], [20, -17], [-3, -23], [-15, -21], [-13, -27], [-9, -21], [-14, -24], [-36, -9], [-16, -21], [-36, -13], [-13, -23], [-19, -22], [-20, -18], [-11, -25], [-7, -22], [-3, -26], [0, -22], [16, -23], [6, -22], [13, -21], [52, -8], [11, -26], [-50, -9], [-43, -13], [-52, -2], [-24, -34], [-5, -27], [-12, -22], [-14, -22], [37, -20], [14, -24], [24, -22], [33, -20], [39, -19], [42, -18], [64, -19], [14, -29], [80, -12], [5, -5], [21, -17], [77, 15], [63, -19], [48, -14], [-9997, -1], [24, 35], [50, -19], [3, 2], [30, 19], [4, 0], [3, -1], [40, -25], [35, 25], [7, 3], [81, 11], [27, -14], [13, -7], [41, -20], [79, -15], [63, -18], [107, -14], [80, 16], [118, -11], [67, -19], [73, 17], [78, 17], [6, 27], [-110, 3], [-89, 14], [-24, 23], [-74, 12], [5, 27], [10, 24], [10, 22], [-5, 25], [-46, 16], [-22, 21], [-43, 18], [68, -3], [64, 9], [40, -20], [50, 18], [45, 22], [23, 19], [-10, 25], [-36, 16], [-41, 17], [-57, 4], [-50, 8], [-54, 6], [-18, 22], [-36, 18], [-21, 21], [-9, 67], [14, -6], [25, -18], [45, 6], [44, 8], [23, -26], [44, 6], [37, 13], [35, 16], [32, 20], [41, 5], [-1, 22], [-9, 22], [8, 21], [36, 11], [16, -20], [42, 12], [32, 15], [40, 1], [38, 6], [37, 13], [30, 13], [34, 13], [22, -4], [19, -4], [41, 8], [37, -10], [38, 1], [37, 8], [37, -6], [41, -6], [39, 3], [40, -2], [42, -1], [38, 3], [28, 17], [34, 9], [35, -13], [33, 11], [30, 21], [18, -19], [9, -21], [18, -19], [29, 17], [33, -22], [38, -7], [32, -16], [39, 3], [36, 11], [41, -3], [38, -8], [38, -10], [15, 25], [-18, 20], [-14, 21], [-36, 5], [-15, 22], [-6, 22], [-10, 43], [21, -8], [36, -3], [36, 3], [33, -9], [28, -17], [12, -21], [38, -4], [36, 9], [38, 11], [34, 7], [28, -14], [37, 5], [24, 45], [23, -27], [32, -10], [34, 6], [23, -23], [37, -3], [33, -7], [34, -12], [21, 22], [11, 20], [28, -23], [38, 6], [28, -13], [19, -19], [37, 5], [29, 13], [29, 15], [33, 8], [39, 7], [36, 8], [27, 13], [16, 19], [7, 25], [-3, 24], [-9, 24], [-10, 23], [-9, 23], [-7, 21], [-1, 23], [2, 23], [13, 22], [11, 24], [5, 23], [-6, 26], [-3, 23], [14, 27], [15, 17], [18, 22], [19, 19], [22, 17], [11, 25], [15, 17], [18, 15], [26, 3], [18, 19], [19, 11], [23, 7], [20, 15], [16, 19], [22, 7], [16, -15], [-10, -20], [-29, -17]], [[6914, 2185], [18, -19], [26, -7], [1, -11], [-7, -27], [-43, -4], [-1, 31], [4, 25], [2, 12]], [[9038, 2648], [27, -21], [15, 8], [22, 12], [16, -4], [2, -70], [-9, -21], [-3, -47], [-10, 16], [-19, -41], [-6, 3], [-17, 2], [-17, 50], [-4, 39], [-16, 52], [1, 27], [18, -5]], [[8987, 4244], [10, -46], [18, 22], [9, -25], [13, -23], [-3, -26], [6, -51], [5, -29], [7, -7], [7, -51], [-3, -30], [9, -40], [31, -31], [19, -28], [19, -26], [-4, -14], [16, -37], [11, -64], [11, 13], [11, -26], [7, 9], [5, -63], [19, -36], [13, -22], [22, -48], [8, -48], [1, -33], [-2, -37], [13, -50], [-2, -52], [-5, -28], [-7, -52], [1, -34], [-6, -43], [-12, -53], [-21, -29], [-10, -46], [-9, -29], [-8, -51], [-11, -30], [-7, -44], [-4, -41], [2, -18], [-16, -21], [-31, -2], [-26, -24], [-13, -23], [-17, -26], [-23, 27], [-17, 10], [5, 31], [-15, -11], [-25, -43], [-24, 16], [-15, 9], [-16, 4], [-27, 17], [-18, 37], [-5, 45], [-7, 30], [-13, 24], [-27, 7], [9, 28], [-7, 44], [-13, -41], [-25, -11], [14, 33], [5, 34], [10, 29], [-2, 44], [-22, -50], [-18, -21], [-10, -47], [-22, 25], [1, 31], [-18, 43], [-14, 22], [5, 14], [-36, 35], [-19, 2], [-27, 29], [-50, -6], [-36, -21], [-31, -20], [-27, 4], [-29, -30], [-24, -14], [-6, -31], [-10, -24], [-23, -1], [-18, -5], [-24, 10], [-20, -6], [-19, -3], [-17, -31], [-8, 2], [-14, -16], [-13, -19], [-21, 2], [-18, 0], [-30, 38], [-15, 11], [1, 34], [14, 8], [4, 14], [-1, 21], [4, 41], [-3, 35], [-15, 60], [-4, 33], [1, 34], [-11, 38], [-1, 18], [-12, 23], [-4, 47], [-16, 46], [-4, 26], [13, -26], [-10, 55], [14, -17], [8, -23], [0, 30], [-14, 47], [-3, 18], [-6, 18], [3, 34], [6, 15], [4, 29], [-3, 35], [11, 42], [2, -45], [12, 41], [22, 20], [14, 25], [21, 22], [13, 4], [7, -7], [22, 22], [17, 6], [4, 13], [8, 6], [15, -2], [29, 18], [15, 26], [7, 31], [17, 30], [1, 24], [1, 32], [19, 50], [12, -51], [12, 12], [-10, 28], [9, 29], [12, -13], [3, 45], [15, 29], [7, 23], [14, 10], [0, 17], [13, -7], [0, 15], [12, 8], [14, 8], [20, -27], [16, -35], [17, 0], [18, -6], [-6, 33], [13, 47], [13, 15], [-5, 15], [12, 34], [17, 21], [14, -7], [24, 11], [-1, 30], [-20, 19], [15, 9], [18, -15], [15, -24], [23, -15], [8, 6], [17, -18], [17, 17], [10, -5], [7, 11], [12, -29], [-7, -32], [-11, -24], [-9, -2], [3, -23], [-8, -30], [-10, -29], [2, -17], [22, -32], [21, -19], [15, -20], [20, -35], [8, 0], [14, -15], [4, -19], [27, -20], [18, 20], [6, 32], [5, 26], [4, 33], [8, 47], [-4, 28], [2, 17], [-3, 34], [4, 45], [5, 12], [-4, 20], [7, 31], [5, 32], [1, 17], [10, 22], [8, -29], [2, -37], [7, -7], [1, -25], [10, -30], [2, -33], [-1, -22]], [[5471, 7900], [-2, -24], [-16, 0], [6, -13], [-9, -38]], [[5450, 7825], [-6, -10], [-24, -1], [-14, -13], [-23, 4]], [[5383, 7805], [-40, 15], [-6, 21], [-27, -10], [-4, -12], [-16, 9]], [[5290, 7828], [-15, 1], [-12, 11], [4, 15], [-1, 10]], [[5266, 7865], [8, 3], [14, -16], [4, 16], [25, -3], [20, 11], [13, -2], [9, -12], [2, 10], [-4, 38], [10, 8], [10, 27]], [[5377, 7945], [21, -19], [15, 24], [10, 5], [22, -18], [13, 3], [13, -12]], [[5471, 7928], [-3, -7], [3, -21]], [[6281, 7346], [-19, 8], [-14, 27], [-4, 23]], [[6349, 7527], [15, -31], [14, -42], [13, -2], [8, -16], [-23, -5], [-5, -46], [-4, -21], [-11, -13], [1, -30]], [[6357, 7321], [-7, -3], [-17, 31], [10, 30], [-9, 17], [-10, -4], [-33, -44]], [[6249, 7494], [6, 10], [21, -17], [15, -4], [4, 7], [-14, 32], [7, 9]], [[6288, 7531], [8, -2], [19, -36], [13, -4], [4, 15], [17, 23]], [[5814, 4792], [-1, 71], [-7, 27]], [[5806, 4890], [17, -5], [8, 34], [15, -4]], [[5846, 4915], [1, -23], [6, -14], [1, -19], [-7, -12], [-11, -31], [-10, -22], [-12, -2]], [[5092, 8091], [20, -5], [26, 12], [17, -25], [16, -14]], [[5171, 8059], [-4, -40]], [[5167, 8019], [-7, -2], [-3, -33]], [[5157, 7984], [-24, 26], [-14, -4], [-20, 28], [-13, 23], [-13, 1], [-4, 21]], [[5069, 8079], [23, 12]], [[5074, 5427], [-23, -7]], [[5051, 5420], [-7, 41], [2, 136], [-6, 12], [-1, 29], [-10, 21], [-8, 17], [3, 31]], [[5024, 5707], [10, 7], [6, 26], [13, 5], [6, 18]], [[5059, 5763], [10, 17], [10, 0], [21, -34]], [[5100, 5746], [-1, -19], [6, -35], [-6, -24], [3, -16], [-13, -37], [-9, -18], [-5, -37], [1, -38], [-2, -95]], [[4921, 5627], [-19, 15], [-13, -2], [-10, -15], [-12, 13], [-5, 19], [-13, 13]], [[4849, 5670], [-1, 34], [7, 26], [-1, 20], [23, 48], [4, 41], [7, 14], [14, -8], [11, 12], [4, 16], [22, 26], [5, 19], [26, 24], [15, 9], [7, -12], [18, 0]], [[5010, 5939], [-2, -28], [3, -27], [16, -39], [1, -28], [32, -14], [-1, -40]], [[5024, 5707], [-24, 1]], [[5000, 5708], [-13, 5], [-9, -9], [-12, 4], [-48, -3], [-1, -33], [4, -45]], [[7573, 6360], [0, -43], [-10, 9], [2, -47]], [[7565, 6279], [-8, 30], [-1, 31], [-6, 28], [-11, 34], [-26, 3], [3, -25], [-9, -32], [-12, 12], [-4, -11], [-8, 6], [-11, 5]], [[7472, 6360], [-4, 49], [-10, 45], [5, 35], [-17, 16], [6, 22], [18, 22], [-20, 31], [9, 40], [22, -26], [14, -3], [2, -41], [26, -8], [26, 1], [16, -10], [-13, -50], [-12, -3], [-9, -34], [16, -31], [4, 38], [8, 0], [14, -93]], [[5629, 7671], [8, -25], [11, 5], [21, -9], [41, -4], [13, 16], [33, 13], [20, -21], [17, -6]], [[5793, 7640], [-15, -25], [-10, -42], [9, -34]], [[5777, 7539], [-24, 8], [-28, -18]], [[5725, 7529], [0, -30], [-26, -5], [-19, 20], [-22, -16], [-21, 2]], [[5637, 7500], [-2, 39], [-14, 19]], [[5621, 7558], [5, 8], [-3, 7], [4, 19], [11, 18], [-14, 26], [-2, 21], [7, 14]], [[2846, 6461], [-7, -3], [-7, 34], [-10, 17], [6, 38], [8, -3], [10, -49], [0, -34]], [[2838, 6628], [-30, -10], [-2, 22], [13, 5], [18, -2], [1, -15]], [[2861, 6628], [-5, -42], [-5, 8], [0, 31], [-12, 23], [0, 7], [22, -27]], [[5527, 7708], [10, 0], [-7, -26], [14, -23], [-4, -28], [-7, -2]], [[5533, 7629], [-5, -6], [-9, -13], [-4, -33]], [[5515, 7577], [-25, 23], [-10, 24], [-11, 13], [-12, 22], [-6, 19], [-14, 27], [6, 25], [10, -14], [6, 12], [13, 2], [24, -10], [19, 1], [12, -13]], [[5652, 8242], [27, 0], [30, 22], [6, 34], [23, 19], [-3, 26]], [[5735, 8343], [17, 10], [30, 23]], [[5782, 8376], [29, -15], [4, -15], [15, 7], [27, -14], [3, -27], [-6, -16], [17, -39], [12, -11], [-2, -11], [19, -10], [8, -16], [-11, -13], [-23, 2], [-5, -5], [7, -20], [6, -37]], [[5882, 8136], [-23, -4], [-9, -13], [-2, -30], [-11, 6], [-25, -3], [-7, 14], [-11, -10], [-10, 8], [-22, 1], [-31, 15], [-28, 4], [-22, -1], [-15, -16], [-13, -2]], [[5653, 8105], [-1, 26], [-8, 27], [17, 12], [0, 24], [-8, 22], [-1, 26]], [[2524, 6110], [-1, 8], [4, 3], [5, -7], [10, 36], [5, 0]], [[2547, 6150], [0, -8], [5, -1], [0, -16], [-5, -25], [3, -9], [-3, -21], [2, -6], [-4, -30], [-5, -16], [-5, -1], [-6, -21]], [[2529, 5996], [-8, 0], [2, 67], [1, 47]], [[3136, 3714], [-20, -8], [-11, 82], [-15, 66], [9, 57], [-15, 25], [-4, 43], [-13, 40]], [[3067, 4019], [17, 64], [-12, 49], [7, 20], [-5, 22], [10, 30], [1, 50], [1, 41], [6, 20], [-24, 96]], [[3068, 4411], [21, -5], [14, 1], [6, 18], [25, 24], [14, 22], [37, 10], [-3, -44], [3, -23], [-2, -40], [30, -53], [31, -9], [11, -23], [19, -11], [11, -17], [18, 0], [16, -17], [1, -34], [6, -18], [0, -25], [-8, -1], [11, -69], [53, -2], [-4, -35], [3, -23], [15, -16], [6, -37], [-4, -47], [-8, -26], [3, -33], [-9, -12]], [[3384, 3866], [-1, 18], [-25, 30], [-26, 1], [-49, -17], [-13, -52], [-1, -32], [-11, -71]], [[3482, 3537], [6, 34], [3, 35], [1, 32], [-10, 11], [-11, -9], [-10, 2], [-4, 23], [-2, 54], [-5, 18], [-19, 16], [-11, -12], [-30, 11], [2, 81], [-8, 33]], [[3068, 4411], [-15, -11], [-13, 7], [2, 90], [-23, -35], [-24, 2], [-11, 31], [-18, 4], [5, 25], [-15, 36], [-11, 53], [7, 11], [0, 25], [17, 17], [-3, 32], [7, 20], [2, 28], [32, 40], [22, 11], [4, 9], [25, -2]], [[3058, 4804], [13, 162], [0, 25], [-4, 34], [-12, 22], [0, 42], [15, 10], [6, -6], [1, 23], [-16, 6], [-1, 37], [54, -2], [10, 21], [7, -19], [6, -35], [5, 8]], [[3142, 5132], [15, -32], [22, 4], [5, 18], [21, 14], [11, 10], [4, 25], [19, 17], [-1, 12], [-24, 5], [-3, 37], [1, 40], [-13, 15], [5, 6], [21, -8], [22, -15], [8, 14], [20, 9], [31, 23], [10, 22], [-3, 17]], [[3313, 5365], [14, 2], [7, -13], [-4, -26], [9, -9], [7, -28], [-8, -20], [-4, -51], [7, -30], [2, -27], [17, -28], [14, -3], [3, 12], [8, 3], [13, 10], [9, 16], [15, -5], [7, 2]], [[3429, 5170], [15, -5], [3, 12], [-5, 12], [3, 17], [11, -5], [13, 6], [16, -13]], [[3485, 5194], [12, -12], [9, 16], [6, -3], [4, -16], [13, 4], [11, 22], [8, 44], [17, 54]], [[3565, 5303], [9, 3], [7, -33], [16, -103], [14, -10], [1, -41], [-21, -48], [9, -18], [49, -9], [1, -60], [21, 39], [35, -21], [46, -36], [14, -35], [-5, -32], [33, 18], [54, -32], [41, 3], [41, -49], [36, -66], [21, -17], [24, -3], [10, -18], [9, -76], [5, -35], [-11, -98], [-14, -39], [-39, -82], [-18, -67], [-21, -51], [-7, -1], [-7, -43], [2, -111], [-8, -91], [-3, -39], [-9, -23], [-5, -79], [-28, -77], [-5, -61], [-22, -26], [-7, -35], [-30, 0], [-44, -23], [-19, -26], [-31, -18], [-33, -47], [-23, -58], [-5, -44], [5, -33], [-5, -60], [-6, -28], [-20, -33], [-31, -104], [-24, -47], [-19, -27], [-13, -57], [-18, -33]], [[3517, 3063], [-8, 33], [13, 28], [-16, 40], [-22, 33], [-29, 38], [-10, -2], [-28, 46], [-18, -7]], [[8172, 5325], [11, 22], [23, 32]], [[8206, 5379], [-1, -29], [-2, -37], [-13, 1], [-6, -20], [-12, 31]], [[7546, 6698], [12, -19], [-2, -36], [-23, -2], [-23, 4], [-18, -9], [-25, 22], [-1, 12]], [[7466, 6670], [19, 44], [15, 15], [20, -14], [14, -1], [12, -16]], [[5817, 3752], [-39, -43], [-25, -44], [-10, -40], [-8, -22], [-15, -4], [-5, -29], [-3, -18], [-17, -14], [-23, 3], [-13, 17], [-12, 7], [-14, -14], [-6, -28], [-14, -18], [-13, -26], [-20, -6], [-6, 20], [2, 36], [-16, 56], [-8, 9]], [[5552, 3594], [0, 173], [27, 2], [1, 210], [21, 2], [43, 21], [10, -24], [18, 23], [9, 0], [15, 13]], [[5696, 4014], [5, -4]], [[5701, 4010], [11, -48], [5, -10], [9, -34], [32, -65], [12, -7], [0, -20], [8, -38], [21, -9], [18, -27]], [[5424, 5496], [23, 4], [5, 16], [5, -2], [7, -13], [34, 23], [12, 23], [15, 20], [-3, 21], [8, 6], [27, -4], [26, 27], [20, 65], [14, 24], [18, 10]], [[5635, 5716], [3, -26], [16, -36], [0, -25], [-5, -24], [2, -18], [10, -18]], [[5661, 5569], [21, -25]], [[5682, 5544], [15, -24], [0, -19], [19, -31], [12, -26], [7, -35], [20, -24], [5, -18]], [[5760, 5367], [-9, -7], [-18, 2], [-21, 6], [-10, -5], [-5, -14], [-9, -2], [-10, 12], [-31, -29], [-13, 6], [-4, -5], [-8, -35], [-21, 11], [-20, 6], [-18, 22], [-23, 20], [-15, -19], [-10, -30], [-3, -41]], [[5512, 5265], [-18, 3], [-19, 10], [-16, -32], [-15, -55]], [[5444, 5191], [-3, 18], [-1, 27], [-13, 19], [-10, 30], [-2, 21], [-13, 31], [2, 18], [-3, 25], [2, 45], [7, 11], [14, 60]], [[3231, 7808], [20, -8], [26, 1], [-14, -24], [-10, -4], [-35, 25], [-7, 20], [10, 18], [10, -28]], [[3283, 7958], [-14, -1], [-36, 19], [-26, 28], [10, 5], [37, -15], [28, -25], [1, -11]], [[1569, 7923], [-14, -8], [-46, 27], [-8, 21], [-25, 21], [-5, 16], [-28, 11], [-11, 32], [2, 14], [30, -13], [17, -9], [26, -6], [9, -21], [14, -28], [28, -24], [11, -33]], [[3440, 8052], [-18, -52], [18, 20], [19, -12], [-10, -21], [25, -16], [12, 14], [28, -18], [-8, -43], [19, 10], [4, -32], [8, -36], [-11, -52], [-13, -2], [-18, 11], [6, 48], [-8, 8], [-32, -52], [-17, 2], [20, 28], [-27, 14], [-30, -3], [-54, 2], [-4, 17], [17, 21], [-12, 16], [24, 36], [28, 94], [18, 33], [24, 21], [13, -3], [-6, -16], [-15, -37]], [[1313, 8250], [27, 5], [-8, -67], [24, -48], [-11, 0], [-17, 27], [-10, 27], [-14, 19], [-5, 26], [1, 19], [13, -8]], [[2798, 8730], [-11, -31], [-12, 5], [-8, 17], [2, 4], [10, 18], [12, -1], [7, -12]], [[2725, 8762], [-33, -32], [-19, 1], [-6, 16], [20, 27], [38, 0], [0, -12]], [[2634, 8936], [5, -26], [15, 9], [16, -15], [30, -20], [32, -19], [2, -28], [21, 5], [20, -20], [-25, -18], [-43, 14], [-16, 26], [-27, -31], [-40, -31], [-9, 35], [-38, -6], [24, 30], [4, 46], [9, 54], [20, -5]], [[2892, 9024], [-31, -3], [-7, 29], [12, 34], [26, 8], [21, -17], [1, -25], [-4, -8], [-18, -18]], [[2343, 9140], [-17, -21], [-38, 18], [-22, -6], [-38, 26], [24, 19], [19, 25], [30, -16], [17, -11], [8, -11], [17, -23]], [[3135, 7724], [-18, 33], [0, 81], [-13, 17], [-18, -10], [-10, 16], [-21, -45], [-8, -46], [-10, -27], [-12, -9], [-9, -3], [-3, -15], [-51, 0], [-42, 0], [-12, -11], [-30, -42], [-3, -5], [-9, -23], [-26, 0], [-27, 0], [-12, -10], [4, -11], [2, -18], [0, -6], [-36, -30], [-29, -9], [-32, -31], [-7, 0], [-10, 9], [-3, 8], [1, 6], [6, 21], [13, 33], [8, 35], [-5, 51], [-6, 53], [-29, 28], [3, 11], [-4, 7], [-8, 0], [-5, 9], [-2, 14], [-5, -6], [-7, 2], [1, 6], [-6, 6], [-3, 15], [-21, 19], [-23, 20], [-27, 23], [-26, 21], [-25, -17], [-9, 0], [-34, 15], [-23, -8], [-27, 19], [-28, 9], [-19, 4], [-9, 10], [-5, 32], [-9, 0], [-1, -23], [-57, 0], [-95, 0], [-94, 0], [-84, 0], [-83, 0], [-82, 0], [-85, 0], [-27, 0], [-82, 0], [-79, 0]], [[1588, 7952], [-4, 0], [-54, 58], [-20, 26], [-50, 24], [-15, 53], [3, 36], [-35, 25], [-5, 48], [-34, 43], [0, 30]], [[1374, 8295], [15, 29], [0, 37], [-48, 37], [-28, 68], [-17, 42], [-26, 27], [-19, 24], [-14, 31], [-28, -20], [-27, -33], [-25, 39], [-19, 26], [-27, 16], [-28, 2], [0, 337], [1, 219]], [[1084, 9176], [51, -14], [44, -29], [29, -5], [24, 24], [34, 19], [41, -7], [42, 26], [45, 14], [20, -24], [20, 14], [6, 27], [20, -6], [47, -53], [37, 40], [3, -45], [34, 10], [11, 17], [34, -3], [42, -25], [65, -22], [38, -10], [28, 4], [37, -30], [-39, -29], [50, -13], [75, 7], [24, 11], [29, -36], [31, 30], [-29, 25], [18, 20], [34, 3], [22, 6], [23, -14], [28, -32], [31, 5], [49, -27], [43, 9], [40, -1], [-3, 37], [25, 10], [43, -20], [0, -56], [17, 47], [23, -1], [12, 59], [-30, 36], [-32, 24], [2, 65], [33, 43], [37, -9], [28, -26], [38, -67], [-25, -29], [52, -12], [-1, -60], [38, 46], [33, -38], [-9, -44], [27, -40], [29, 43], [21, 51], [1, 65], [40, -5], [41, -8], [37, -30], [2, -29], [-21, -31], [20, -32], [-4, -29], [-54, -41], [-39, -9], [-29, 18], [-8, -30], [-27, -50], [-8, -26], [-32, -40], [-40, -4], [-22, -25], [-2, -38], [-32, -7], [-34, -48], [-30, -67], [-11, -46], [-1, -69], [40, -10], [13, -55], [13, -45], [39, 12], [51, -26], [28, -22], [20, -28], [35, -17], [29, -24], [46, -4], [30, -6], [-4, -51], [8, -59], [21, -66], [41, -56], [21, 19], [15, 61], [-14, 93], [-20, 31], [45, 28], [31, 41], [16, 41], [-3, 40], [-19, 50], [-33, 44], [32, 62], [-12, 54], [-9, 92], [19, 14], [48, -16], [29, -6], [23, 15], [25, -20], [35, -34], [8, -23], [50, -4], [-1, -50], [9, -74], [25, -10], [21, -35], [40, 33], [26, 65], [19, 28], [21, -53], [36, -75], [31, -71], [-11, -37], [37, -33], [25, -34], [44, -15], [18, -19], [11, -50], [22, -8], [11, -22], [2, -67], [-20, -22], [-20, -21], [-46, -21], [-35, -48], [-47, -10], [-59, 13], [-42, 0], [-29, -4], [-23, -43], [-35, -26], [-40, -78], [-32, -54], [23, 9], [45, 78], [58, 49], [42, 6], [24, -29], [-26, -40], [9, -63], [9, -45], [36, -29], [46, 8], [28, 67], [2, -43], [17, -22], [-34, -38], [-61, -36], [-28, -23], [-31, -43], [-21, 4], [-1, 50], [48, 49], [-44, -2], [-31, -7]], [[1829, 9377], [-14, -27], [61, 17], [39, -29], [31, 30], [26, -20], [23, -58], [14, 25], [-20, 60], [24, 9], [28, -9], [31, -24], [17, -58], [9, -41], [47, -30], [50, -28], [-3, -26], [-46, -4], [18, -23], [-9, -22], [-51, 9], [-48, 16], [-32, -3], [-52, -20], [-70, -9], [-50, -6], [-15, 28], [-38, 16], [-24, -6], [-35, 47], [19, 6], [43, 10], [39, -3], [36, 11], [-54, 13], [-59, -4], [-39, 1], [-15, 22], [64, 23], [-42, -1], [-49, 16], [23, 44], [20, 24], [74, 36], [29, -12]], [[2097, 9395], [-24, -39], [-44, 41], [10, 9], [37, 2], [21, -13]], [[2879, 9376], [3, -16], [-30, 2], [-30, 1], [-30, -8], [-8, 3], [-31, 32], [1, 21], [14, 4], [63, -6], [48, -33]], [[2595, 9379], [22, -36], [26, 47], [70, 24], [48, -61], [-4, -38], [55, 17], [26, 23], [62, -30], [38, -28], [3, -25], [52, 13], [29, -38], [67, -23], [24, -24], [26, -55], [-51, -28], [66, -38], [44, -13], [40, -55], [44, -3], [-9, -42], [-49, -69], [-34, 26], [-44, 57], [-36, -8], [-3, -34], [29, -34], [38, -27], [11, -16], [18, -58], [-9, -43], [-35, 16], [-70, 47], [39, -51], [29, -35], [5, -21], [-76, 24], [-59, 34], [-34, 29], [10, 17], [-42, 30], [-40, 29], [0, -18], [-80, -9], [-23, 20], [18, 44], [52, 1], [57, 7], [-9, 21], [10, 30], [36, 57], [-8, 27], [-11, 20], [-42, 29], [-57, 20], [18, 15], [-29, 36], [-25, 4], [-22, 20], [-14, -18], [-51, -7], [-101, 13], [-59, 17], [-45, 9], [-23, 21], [29, 27], [-39, 0], [-9, 60], [21, 53], [29, 24], [72, 16], [-21, -39]], [[2212, 9420], [33, -12], [50, 7], [7, -17], [-26, -28], [42, -26], [-5, -53], [-45, -23], [-27, 5], [-19, 23], [-69, 45], [0, 19], [57, -7], [-31, 38], [33, 29]], [[2411, 9357], [-30, -45], [-32, 3], [-17, 52], [1, 29], [14, 25], [28, 16], [58, -2], [53, -14], [-42, -53], [-33, -11]], [[1654, 9275], [-73, -29], [-15, 26], [-64, 31], [12, 25], [19, 43], [24, 39], [-27, 36], [94, 10], [39, -13], [71, -3], [27, -17], [30, -25], [-35, -15], [-68, -41], [-34, -42], [0, -25]], [[2399, 9487], [-15, -23], [-40, 5], [-34, 15], [15, 27], [40, 16], [24, -21], [10, -19]], [[2264, 9590], [21, -27], [1, -31], [-13, -44], [-46, -6], [-30, 10], [1, 34], [-45, -4], [-2, 45], [30, -2], [41, 21], [40, -4], [2, 8]], [[1994, 9559], [11, -21], [25, 10], [29, -2], [5, -29], [-17, -28], [-94, -10], [-70, -25], [-43, -2], [-3, 20], [57, 26], [-125, -7], [-39, 10], [38, 58], [26, 17], [78, -20], [50, -35], [48, -5], [-40, 57], [26, 21], [29, -7], [9, -28]], [[2370, 9612], [30, -19], [55, 0], [24, -19], [-6, -22], [32, -14], [17, -14], [38, -2], [40, -5], [44, 13], [57, 5], [45, -5], [30, -22], [6, -24], [-17, -16], [-42, -13], [-35, 8], [-80, -10], [-57, -1], [-45, 8], [-74, 19], [-9, 32], [-4, 29], [-27, 26], [-58, 7], [-32, 19], [10, 24], [58, -4]], [[1772, 9645], [-4, -46], [-21, -20], [-26, -3], [-52, -26], [-44, -9], [-38, 13], [47, 44], [57, 39], [43, -1], [38, 9]], [[2393, 9637], [-13, -2], [-52, 4], [-7, 17], [56, -1], [19, -11], [-3, -7]], [[1939, 9648], [-52, -17], [-41, 19], [23, 19], [40, 6], [39, -10], [-9, -17]], [[1954, 9701], [-34, -11], [-46, 0], [0, 8], [29, 18], [14, -3], [37, -12]], [[2338, 9669], [-41, -12], [-23, 13], [-12, 23], [-2, 24], [36, -2], [16, -4], [33, -21], [-7, -21]], [[2220, 9685], [11, -25], [-45, 7], [-46, 19], [-62, 2], [27, 18], [-34, 14], [-2, 22], [55, -8], [75, -21], [21, -28]], [[2583, 9764], [33, -20], [-38, -17], [-51, -45], [-50, -4], [-57, 8], [-30, 24], [0, 21], [22, 16], [-50, 0], [-31, 19], [-18, 27], [20, 26], [19, 18], [28, 4], [-12, 14], [65, 3], [35, -32], [47, -12], [46, -11], [22, -39]], [[3097, 9967], [74, -4], [60, -8], [51, -16], [-2, -16], [-67, -25], [-68, -12], [-25, -14], [61, 1], [-66, -36], [-45, -17], [-48, -48], [-57, -10], [-18, -12], [-84, -6], [39, -8], [-20, -10], [23, -29], [-26, -21], [-43, -16], [-13, -24], [-39, -17], [4, -14], [48, 3], [0, -15], [-74, -35], [-73, 16], [-81, -9], [-42, 7], [-52, 3], [-4, 29], [52, 13], [-14, 43], [17, 4], [74, -26], [-38, 38], [-45, 11], [23, 23], [49, 14], [8, 21], [-39, 23], [-12, 31], [76, -3], [22, -6], [43, 21], [-62, 7], [-98, -4], [-49, 20], [-23, 24], [-32, 17], [-6, 21], [41, 11], [32, 2], [55, 9], [41, 22], [34, -3], [30, -16], [21, 32], [37, 9], [50, 7], [85, 2], [14, -6], [81, 10], [60, -4], [60, -4]], [[5290, 7828], [-3, -24], [-12, -10], [-20, 7], [-6, -24], [-14, -2], [-5, 10], [-15, -20], [-13, -3], [-12, 13]], [[5190, 7775], [-10, 25], [-13, -9], [0, 27], [21, 33], [-1, 15], [12, -5], [8, 10]], [[5207, 7871], [24, -1], [5, 13], [30, -18]], [[3140, 1814], [-10, -24], [-23, -18], [-14, 2], [-16, 5], [-21, 18], [-29, 8], [-35, 33], [-28, 32], [-38, 66], [23, -12], [39, -40], [36, -21], [15, 27], [9, 41], [25, 24], [20, -7]], [[3095, 1968], [-25, 0], [-13, -14], [-25, -22], [-5, -55], [-11, -1], [-32, 19], [-32, 41], [-34, 34], [-9, 37], [8, 35], [-14, 39], [-4, 101], [12, 57], [30, 45], [-43, 18], [27, 52], [9, 98], [31, -21], [15, 123], [-19, 15], [-9, -73], [-17, 8], [9, 84], [9, 110], [13, 40], [-8, 58], [-2, 66], [11, 2], [17, 96], [20, 94], [11, 88], [-6, 89], [8, 49], [-3, 72], [16, 73], [5, 114], [9, 123], [9, 132], [-2, 96], [-6, 84]], [[3045, 3974], [14, 15], [8, 30]], [[8064, 6161], [-24, -28], [-23, 18], [0, 51], [13, 26], [31, 17], [16, -1], [6, -23], [-12, -26], [-7, -34]], [[8628, 7562], [-18, 35], [-11, -33], [-43, -26], [4, -31], [-24, 2], [-13, 19], [-19, -42], [-30, -32], [-23, -38]], [[8451, 7416], [-39, -17], [-20, -27], [-30, -17], [15, 28], [-6, 23], [22, 40], [-15, 30], [-24, -20], [-32, -41], [-17, -39], [-27, -2], [-14, -28], [15, -40], [22, -10], [1, -26], [22, -17], [31, 42], [25, -23], [18, -2], [4, -31], [-39, -16], [-13, -32], [-27, -30], [-14, -41], [30, -33], [11, -58], [17, -54], [18, -45], [0, -44], [-17, -16], [6, -32], [17, -18], [-5, -48], [-7, -47], [-15, -5], [-21, -64], [-22, -78], [-26, -70], [-38, -55], [-39, -50], [-31, -6], [-17, -27], [-10, 20], [-15, -30], [-39, -29], [-29, -9], [-10, -63], [-15, -3], [-8, 43], [7, 22], [-37, 19], [-13, -9]], [[8001, 6331], [-28, 15], [-14, 24], [5, 34], [-26, 11], [-13, 22], [-24, -31], [-27, -7], [-22, 0], [-15, -14]], [[7837, 6385], [-14, -9], [4, -68], [-15, 2], [-2, 14]], [[7810, 6324], [-1, 24], [-20, -17], [-12, 11], [-21, 22], [8, 49], [-18, 12], [-6, 54], [-30, -10], [4, 70], [26, 50], [1, 48], [-1, 46], [-12, 14], [-9, 35], [-16, -5]], [[7703, 6727], [-30, 9], [9, 25], [-13, 36], [-20, -24], [-23, 14], [-32, -37], [-25, -44], [-23, -8]], [[7466, 6670], [-2, 47], [-17, -13]], [[7447, 6704], [-32, 6], [-32, 14], [-22, 26], [-22, 11], [-9, 29], [-16, 8], [-28, 39], [-22, 18], [-12, -14]], [[7252, 6841], [-38, 41], [-28, 37], [-7, 65], [20, -7], [1, 30], [-12, 30], [3, 48], [-30, 69]], [[7161, 7154], [-45, 24], [-8, 46], [-21, 27]], [[7082, 7268], [-4, 34], [1, 23], [-17, 13], [-9, -6], [-7, 55]], [[7046, 7387], [8, 13], [-4, 14], [26, 28], [20, 12], [29, -8], [11, 38], [35, 7], [10, 23], [44, 32], [4, 13]], [[7229, 7559], [-2, 34], [19, 15], [-25, 103], [55, 24], [14, 13], [20, 106], [55, -20], [15, 27], [2, 59], [23, 6], [21, 39]], [[7426, 7965], [11, 5]], [[7437, 7970], [7, -41], [23, -32], [40, -22], [19, -47], [-10, -70], [10, -25], [33, -10], [37, -8], [33, -37], [18, -7], [12, -54], [17, -35], [30, 1], [58, -13], [36, 8], [28, -9], [41, -36], [34, 0], [12, -18], [32, 32], [45, 20], [42, 2], [32, 21], [20, 32], [20, 20], [-5, 19], [-9, 23], [15, 38], [15, -5], [29, -12], [28, 31], [42, 23], [20, 39], [20, 17], [40, 8], [22, -7], [3, 21], [-25, 41], [-22, 19], [-22, -22], [-27, 10], [-16, -8], [-7, 24], [20, 59], [13, 45]], [[8240, 8005], [34, -23], [39, 38], [-1, 26], [26, 62], [15, 19], [0, 33], [-16, 14], [23, 29], [35, 11], [37, 2], [41, -18], [25, -22], [17, -59], [10, -26], [10, -36], [10, -58], [49, -19], [32, -42], [12, -55], [42, 0], [24, 23], [46, 17], [-15, -53], [-11, -21], [-9, -65], [-19, -58], [-33, 11], [-24, -21], [7, -51], [-4, -69], [-14, -2], [0, -30]], [[4920, 5353], [-12, -1], [-20, 12], [-18, -1], [-33, -10], [-19, -18], [-27, -21], [-6, 1]], [[4785, 5315], [2, 49], [3, 7], [-1, 24], [-12, 24], [-8, 4], [-8, 17], [6, 26], [-3, 28], [1, 18]], [[4765, 5512], [5, 0], [1, 25], [-2, 12], [3, 8], [10, 7], [-7, 47], [-6, 25], [2, 20], [5, 4]], [[4776, 5660], [4, 6], [8, -9], [21, -1], [5, 18], [5, -1], [8, 6], [4, -25], [7, 7], [11, 9]], [[4921, 5627], [7, -84], [-11, -50], [-8, -66], [12, -51], [-1, -23]], [[5363, 5191], [-4, 4], [-16, -8], [-17, 8], [-13, -4]], [[5313, 5191], [-45, 1]], [[5268, 5192], [4, 47], [-11, 39], [-13, 10], [-6, 27], [-7, 8], [1, 16]], [[5236, 5339], [7, 42], [13, 57], [8, 1], [17, 34], [10, 1], [16, -24], [19, 20], [2, 25], [7, 23], [4, 30], [15, 25], [5, 41], [6, 13], [4, 31], [7, 37], [24, 46], [1, 20], [3, 10], [-11, 24]], [[5393, 5795], [1, 19], [8, 3]], [[5402, 5817], [11, -38], [2, -39], [-1, -39], [15, -54], [-15, 1], [-8, -4], [-13, 6], [-6, -28], [16, -35], [13, -10], [3, -24], [9, -41], [-4, -16]], [[5444, 5191], [-2, -31], [-22, 14], [-22, 15], [-35, 2]], [[5856, 5265], [-2, -69], [11, -8], [-9, -21], [-10, -16], [-11, -31], [-6, -27], [-1, -48], [-7, -22], [0, -45]], [[5821, 4978], [-8, -16], [-1, -35], [-4, -5], [-2, -32]], [[5814, 4792], [5, -55], [-2, -30], [5, -35], [16, -33], [15, -74]], [[5853, 4565], [-11, 6], [-37, -10], [-7, -7], [-8, -38], [6, -26], [-5, -70], [-3, -59], [7, -11], [19, -23], [8, 11], [2, -64], [-21, 1], [-11, 32], [-10, 25], [-22, 9], [-6, 31], [-17, -19], [-22, 8], [-10, 27], [-17, 6], [-13, -2], [-2, 19], [-9, 1]], [[5342, 4697], [-4, 18]], [[5360, 4775], [8, -6], [9, 23], [15, -1], [2, -17], [11, -10], [16, 37], [16, 29], [7, 19], [-1, 48], [12, 58], [13, 30], [18, 29], [3, 18], [1, 22], [5, 21], [-2, 33], [4, 52], [5, 37], [8, 32], [2, 36]], [[5760, 5367], [17, -49], [12, -7], [8, 10], [12, -4], [16, 12], [6, -25], [25, -39]], [[5330, 4760], [-22, 62]], [[5308, 4822], [21, 33], [-11, 39], [10, 15], [19, 7], [2, 26], [15, -28], [24, -2], [9, 27], [3, 40], [-3, 46], [-13, 35], [12, 68], [-7, 12], [-21, -5], [-7, 31], [2, 25]], [[2906, 5049], [-12, 14], [-14, 19], [-7, -9], [-24, 8], [-7, 25], [-5, -1], [-28, 34]], [[2809, 5139], [-3, 18], [10, 5], [-1, 29], [6, 22], [14, 4], [12, 37], [10, 31], [-10, 14], [5, 34], [-6, 54], [6, 16], [-4, 50], [-12, 31]], [[2836, 5484], [4, 29], [9, -4], [5, 17], [-6, 35], [3, 9]], [[2851, 5570], [14, -2], [21, 41], [12, 6], [0, 20], [5, 50], [16, 27], [17, 1], [3, 13], [21, -5], [22, 30], [11, 13], [14, 28], [9, -3], [8, -16], [-6, -20]], [[3018, 5753], [-18, -10], [-7, -29], [-10, -17], [-8, -22], [-4, -42], [-8, -35], [15, -4], [3, -27], [6, -13], [3, -24], [-4, -22], [1, -12], [7, -5], [7, -20], [36, 5], [16, -7], [19, -51], [11, 6], [20, -3], [16, 7], [10, -10], [-5, -32], [-6, -20], [-2, -42], [5, -40], [8, -17], [1, -13], [-14, -30], [10, -13], [8, -21], [8, -58]], [[3058, 4804], [-14, 31], [-8, 1], [18, 61], [-21, 27], [-17, -5], [-10, 10], [-15, -15], [-21, 7], [-16, 62], [-13, 15], [-9, 28], [-19, 28], [-7, -5]], [[2695, 5543], [-15, 14], [-6, 12], [4, 10], [-1, 13], [-8, 14], [-11, 12], [-10, 8], [-1, 17], [-8, 10], [2, -17], [-5, -14], [-7, 17], [-9, 5], [-4, 12], [1, 18], [3, 19], [-8, 8], [7, 12]], [[2619, 5713], [4, 7], [18, -15], [7, 7], [9, -5], [4, -12], [8, -4], [7, 13]], [[2676, 5704], [7, -32], [11, -24], [13, -25]], [[2707, 5623], [-11, -6], [0, -23], [6, -9], [-4, -7], [1, -11], [-2, -12], [-2, -12]], [[2715, 6427], [23, -4], [22, 0], [26, -21], [11, -21], [26, 6], [10, -13], [24, -37], [17, -27], [9, 1], [17, -12], [-2, -17], [20, -2], [21, -24], [-3, -14], [-19, -7], [-18, -3], [-19, 4], [-40, -5], [18, 32], [-11, 16], [-18, 4], [-9, 17], [-7, 33], [-16, -2], [-26, 16], [-8, 12], [-36, 10], [-10, 11], [11, 15], [-28, 3], [-20, -31], [-11, -1], [-4, -14], [-14, -7], [-12, 6], [15, 18], [6, 22], [13, 13], [14, 11], [21, 6], [7, 6]], [[5909, 7133], [2, 1], [4, 14], [20, -1], [25, 18], [-19, -25], [2, -11]], [[5943, 7129], [-3, 2], [-5, -5], [-4, 1], [-2, -2], [0, 6], [-2, 4], [-6, 0], [-7, -5], [-5, 3]], [[5943, 7129], [1, -5], [-28, -24], [-14, 8], [-7, 23], [14, 2]], [[5377, 7945], [-16, 25], [-14, 15], [-3, 25], [-5, 17], [21, 13], [10, 15], [20, 11], [7, 11], [7, -6], [13, 6]], [[5417, 8077], [13, -19], [21, -5], [-2, -17], [15, -12], [4, 15], [19, -6], [3, -19], [20, -3], [13, -29]], [[5523, 7982], [-8, 0], [-4, -11], [-7, -3], [-2, -13], [-5, -3], [-1, -5], [-9, -7], [-12, 1], [-4, -13]], [[5275, 8306], [1, -23], [28, -14], [-1, -21], [29, 11], [15, 16], [32, -23], [13, -19]], [[5392, 8233], [6, -30], [-8, -16], [11, -21], [6, -31], [-2, -21], [12, -37]], [[5207, 7871], [3, 42], [14, 40], [-40, 11], [-13, 16]], [[5171, 7980], [2, 26], [-6, 13]], [[5171, 8059], [-5, 62], [17, 0], [7, 22], [6, 54], [-5, 20]], [[5191, 8217], [6, 13], [23, 3], [5, -13], [19, 29], [-6, 22], [-2, 34]], [[5236, 8305], [21, -8], [18, 9]], [[6196, 5808], [7, -19], [-1, -24], [-16, -14], [12, -16]], [[6198, 5735], [-10, -32]], [[6188, 5703], [-7, 11], [-6, -5], [-16, 1], [0, 18], [-2, 17], [9, 27], [10, 26]], [[6176, 5798], [12, -5], [8, 15]], [[5352, 8343], [-17, -48], [-29, 33], [-4, 25], [41, 19], [9, -29]], [[5236, 8305], [-11, 32], [-1, 61], [5, 16], [8, 17], [24, 4], [10, 16], [22, 17], [-1, -30], [-8, -20], [4, -16], [15, -9], [-7, -22], [-8, 6], [-20, -42], [7, -29]], [[3008, 6222], [3, 10], [22, 0], [16, -15], [8, 1], [5, -21], [15, 1], [-1, -17], [12, -2], [14, -22], [-10, -24], [-14, 13], [-12, -3], [-9, 3], [-5, -11], [-11, -3], [-4, 14], [-10, -8], [-11, -41], [-7, 10], [-1, 17]], [[3008, 6124], [0, 16], [-7, 17], [7, 10], [2, 23], [-2, 32]], [[5333, 6444], [-95, -112], [-81, -117], [-39, -26]], [[5118, 6189], [-31, -6], [0, 38], [-13, 10], [-17, 16], [-7, 28], [-94, 129], [-93, 129]], [[4863, 6533], [-105, 143]], [[4758, 6676], [1, 11], [0, 4]], [[4759, 6691], [0, 70], [44, 44], [28, 9], [23, 16], [11, 29], [32, 24], [1, 44], [16, 5], [13, 22], [36, 9], [5, 23], [-7, 13], [-10, 62], [-1, 36], [-11, 38]], [[4939, 7135], [27, 32], [30, 11], [17, 24], [27, 18], [47, 11], [46, 4], [14, -8], [26, 23], [30, 0], [11, -13], [19, 3]], [[5233, 7240], [-5, -30], [4, -56], [-6, -49], [-18, -33], [3, -45], [23, -35], [0, -14], [17, -24], [12, -106]], [[5263, 6848], [9, -52], [1, -28], [-5, -48], [2, -27], [-3, -32], [2, -37], [-11, -25], [17, -43], [1, -25], [10, -33], [13, 11], [22, -28], [12, -37]], [[2769, 4856], [15, 45], [-6, 25], [-11, -27], [-16, 26], [5, 16], [-4, 54], [9, 9], [5, 37], [11, 38], [-2, 24], [15, 13], [19, 23]], [[2906, 5049], [4, -45], [-9, -39], [-30, -62], [-33, -23], [-17, -51], [-6, -40], [-15, -24], [-12, 29], [-11, 7], [-12, -5], [-1, 22], [8, 14], [-3, 24]], [[5969, 6800], [-7, -23], [-6, -45], [-8, -31], [-6, -10], [-10, 19], [-12, 26], [-20, 85], [-3, -5], [12, -63], [17, -59], [21, -92], [10, -32], [9, -34], [25, -65], [-6, -10], [1, -39], [33, -53], [4, -12]], [[6023, 6357], [-110, 0], [-107, 0], [-112, 0]], [[5694, 6357], [0, 218], [0, 210], [-8, 47], [7, 37], [-5, 25], [10, 29]], [[5698, 6923], [37, 0], [27, -15], [28, -18], [13, -9], [21, 19], [11, 17], [25, 5], [20, -8], [7, -29], [7, 19], [22, -14], [22, -3], [13, 15]], [[5951, 6902], [18, -102]], [[6176, 5798], [-10, 20], [-11, 34], [-12, 19], [-8, 21], [-24, 23], [-19, 1], [-7, 12], [-16, -14], [-17, 27], [-8, -44], [-33, 13]], [[6011, 5910], [-3, 23], [12, 87], [3, 39], [9, 18], [20, 10], [14, 34]], [[6066, 6121], [16, -69], [8, -54], [15, -29], [38, -55], [16, -34], [15, -34], [8, -20], [14, -18]], [[4749, 7532], [1, 42], [-11, 25], [39, 43], [34, -11], [37, 1], [30, -10], [23, 3], [45, -2]], [[4947, 7623], [11, -23], [51, -27], [10, 13], [31, -27], [32, 8]], [[5082, 7567], [2, -35], [-26, -39], [-36, -12], [-2, -20], [-18, -33], [-10, -48], [11, -34], [-16, -26], [-6, -39], [-21, -11], [-20, -46], [-35, -1], [-27, 1], [-17, -21], [-11, -22], [-13, 5], [-11, 20], [-8, 34], [-26, 9]], [[4792, 7249], [-2, 20], [10, 22], [4, 16], [-9, 17], [7, 39], [-11, 36], [12, 5], [1, 27], [5, 9], [0, 46], [13, 16], [-8, 30], [-16, 2], [-5, -8], [-16, 0], [-7, 29], [-11, -8], [-10, -15]], [[5675, 8472], [3, 35], [-10, -8], [-18, 21], [-2, 34], [35, 17], [35, 8], [30, -10], [29, 2]], [[5777, 8571], [4, -10], [-20, -34], [8, -55], [-12, -19]], [[5757, 8453], [-22, 0], [-24, 22], [-13, 7], [-23, -10]], [[6188, 5703], [-6, -21], [10, -32], [10, -29], [11, -21], [90, -70], [24, 0]], [[6327, 5530], [-79, -177], [-36, -3], [-25, -41], [-17, -1], [-8, -19]], [[6162, 5289], [-19, 0], [-11, 20], [-26, -25], [-8, -24], [-18, 4], [-6, 7], [-7, -1], [-9, 0], [-35, 50], [-19, 0], [-10, 20], [0, 33], [-14, 10]], [[5980, 5383], [-17, 64], [-12, 14], [-5, 23], [-14, 29], [-17, 4], [9, 34], [15, 2], [4, 18]], [[5943, 5571], [0, 53]], [[5943, 5624], [8, 62], [13, 16], [3, 24], [12, 45], [17, 30], [11, 58], [4, 51]], [[5794, 9138], [-4, -42], [42, -39], [-26, -45], [33, -67], [-19, -51], [25, -43], [-11, -39], [41, -40], [-11, -31], [-25, -34], [-60, -75]], [[5779, 8632], [-50, -5], [-49, -21], [-45, -13], [-16, 32], [-27, 20], [6, 58], [-14, 53], [14, 35], [25, 37], [63, 64], [19, 12], [-3, 25], [-39, 28]], [[5663, 8957], [-9, 23], [-1, 91], [-43, 40], [-37, 29]], [[5573, 9140], [17, 16], [30, -32], [37, 3], [30, -14], [26, 26], [14, 44], [43, 20], [35, -24], [-11, -41]], [[9954, 4033], [9, -17], [-4, -31], [-17, -8], [-16, 7], [-2, 26], [10, 21], [13, -8], [7, 10]], [[0, 4079], [9981, -14], [-17, -13], [-4, 23], [14, 12], [9, 3], [-9983, 18]], [[0, 4108], [0, -29]], [[0, 4108], [6, 3], [-4, -28], [-2, -4]], [[3300, 1994], [33, 36], [24, -15], [16, 24], [22, -27], [-8, -21], [-37, -17], [-13, 20], [-23, -26], [-14, 26]], [[5265, 7548], [-9, -46], [-13, 12], [-6, 40], [5, 22], [18, 22], [5, -50]], [[5157, 7984], [6, -6], [8, 2]], [[5190, 7775], [-2, -17], [9, -22], [-10, -18], [7, -46], [15, -8], [-3, -25]], [[5206, 7639], [-25, -34], [-55, 16], [-40, -19], [-4, -35]], [[4947, 7623], [14, 35], [5, 118], [-28, 62], [-21, 30], [-42, 23], [-3, 43], [36, 12], [47, -15], [-9, 67], [26, -25], [65, 46], [8, 48], [24, 12]], [[3485, 5194], [7, 25], [3, 27]], [[3495, 5246], [4, 26], [-10, 34]], [[3489, 5306], [-3, 41], [15, 51]], [[3501, 5398], [9, -7], [21, -14], [29, -50], [5, -24]], [[5308, 4822], [-29, 60], [-18, 49], [-17, 61], [1, 19], [6, 19], [7, 43], [5, 44]], [[5263, 5117], [10, 4], [40, -1], [0, 71]], [[4827, 8240], [-21, 12], [-17, -1], [6, 32], [-6, 32]], [[4789, 8315], [23, 2], [30, -37], [-15, -40]], [[4916, 8521], [-30, -63], [29, 8], [30, -1], [-7, -48], [-25, -53], [29, -4], [2, -6], [25, -69], [19, -10], [17, -67], [8, -24], [33, -11], [-3, -38], [-14, -17], [11, -30], [-25, -31], [-37, 0], [-48, -16], [-13, 12], [-18, -28], [-26, 7], [-19, -23], [-15, 12], [41, 62], [25, 13], [-1, 0], [-43, 9], [-8, 24], [29, 18], [-15, 32], [5, 39], [42, -6], [4, 35], [-19, 36], [0, 1], [-34, 10], [-7, 16], [10, 27], [-9, 16], [-15, -28], [-1, 57], [-14, 30], [10, 61], [21, 48], [23, -4], [33, 4]], [[6154, 7511], [4, 26], [-7, 40], [-16, 22], [-16, 6], [-10, 19]], [[6109, 7624], [4, 6], [23, -10], [41, -9], [38, -28], [5, -11], [17, 9], [25, -13], [9, -24], [17, -13]], [[6210, 7485], [-27, 29], [-29, -3]], [[5029, 5408], [-44, -35], [-15, -20], [-25, -17], [-25, 17]], [[5000, 5708], [-2, -18], [12, -30], [0, -43], [2, -47], [7, -21], [-6, -54], [2, -29], [8, -37], [6, -21]], [[4765, 5512], [-8, 1], [-5, -24], [-8, 1], [-6, 12], [2, 24], [-11, 36], [-8, -7], [-6, -1]], [[4715, 5554], [-7, -3], [0, 21], [-4, 16], [0, 17], [-6, 25], [-7, 21], [-23, 0], [-6, -11], [-8, -1], [-4, -13], [-4, -17], [-14, -26]], [[4632, 5583], [-13, 35], [-10, 24], [-8, 7], [-6, 12], [-4, 26], [-4, 13], [-8, 10]], [[4579, 5710], [13, 29], [8, -2], [7, 10], [6, 0], [5, 8], [-3, 20], [3, 6], [1, 20]], [[4619, 5801], [13, -1], [20, -14], [6, 1], [3, 7], [15, -5], [4, 4]], [[4680, 5793], [1, -22], [5, 0], [7, 8], [5, -2], [7, -15], [12, -5], [8, 13], [9, 8], [6, 8], [6, -1], [6, -13], [3, -17], [12, -24], [-6, -16], [-1, -19], [6, 6], [3, -7], [-1, -17], [8, -18]], [[4532, 5834], [3, 27]], [[4535, 5861], [31, 1], [6, 14], [9, 1], [11, -14], [8, -1], [9, 10], [6, -17], [-12, -13], [-12, 1], [-12, 13], [-10, -14], [-5, -1], [-7, -8], [-25, 1]], [[4579, 5710], [-15, 24], [-11, 4], [-7, 17], [1, 9], [-9, 13], [-2, 12]], [[4536, 5789], [15, 10], [9, -2], [8, 7], [51, -3]], [[5263, 5117], [-5, 9], [10, 66]], [[5658, 7167], [15, -20], [22, 3], [20, -4], [0, -10], [15, 7], [-4, -18], [-40, -5], [1, 10], [-34, 12], [5, 25]], [[5723, 7469], [-17, 2], [-14, 6], [-34, -16], [19, -33], [-14, -10], [-15, 0], [-15, 31], [-5, -13], [6, -36], [14, -27], [-10, -13], [15, -27], [14, -18], [0, -33], [-25, 16], [8, -30], [-18, -7], [11, -52], [-19, -1], [-23, 26], [-10, 47], [-5, 40], [-11, 27], [-14, 34], [-2, 16]], [[5583, 7470], [18, 6], [11, 13], [15, -2], [5, 11], [5, 2]], [[5725, 7529], [13, -16], [-8, -37], [-7, -7]], [[3701, 9939], [93, 35], [97, -2], [36, 21], [98, 6], [222, -7], [174, -47], [-52, -23], [-106, -3], [-150, -5], [14, -11], [99, 7], [83, -21], [54, 18], [23, -21], [-30, -34], [71, 22], [135, 23], [83, -12], [15, -25], [-113, -42], [-16, -14], [-88, -10], [64, -3], [-32, -43], [-23, -38], [1, -66], [33, -38], [-43, -3], [-46, -19], [52, -31], [6, -50], [-30, -6], [36, -50], [-61, -5], [32, -24], [-9, -20], [-39, -10], [-39, 0], [35, -40], [0, -26], [-55, 24], [-14, -15], [37, -15], [37, -36], [10, -48], [-49, -11], [-22, 22], [-34, 34], [10, -40], [-33, -31], [73, -2], [39, -3], [-75, -52], [-75, -46], [-81, -21], [-31, 0], [-29, -23], [-38, -62], [-60, -42], [-19, -2], [-37, -15], [-40, -13], [-24, -37], [0, -41], [-15, -39], [-45, -47], [11, -47], [-12, -48], [-14, -58], [-39, -4], [-41, 49], [-56, 0], [-27, 32], [-18, 58], [-49, 73], [-14, 39], [-3, 53], [-39, 54], [10, 44], [-18, 21], [27, 69], [42, 22], [11, 25], [6, 46], [-32, -21], [-15, -9], [-25, -8], [-34, 19], [-2, 40], [11, 31], [25, 1], [57, -15], [-48, 37], [-24, 20], [-28, -8], [-23, 15], [31, 55], [-17, 22], [-22, 41], [-34, 62], [-35, 23], [0, 25], [-74, 34], [-59, 5], [-74, -3], [-68, -4], [-32, 19], [-49, 37], [73, 19], [56, 3], [-119, 15], [-62, 24], [3, 23], [106, 28], [101, 29], [11, 21], [-75, 22], [24, 23], [97, 41], [40, 7], [-12, 26], [66, 16], [86, 9], [85, 1], [30, -19], [74, 33], [66, -22], [39, -5], [58, -19], [-66, 32], [4, 25]], [[2497, 5869], [-14, 10], [-17, 1], [-13, 12], [-15, 24]], [[2438, 5916], [1, 18], [3, 13], [-4, 12], [13, 48], [36, 0], [1, 20], [-5, 4], [-3, 12], [-10, 14], [-11, 20], [13, 0], [0, 33], [26, 0], [26, 0]], [[2529, 5996], [10, -11], [2, 9], [8, -7]], [[2549, 5987], [-13, -23], [-13, -16], [-2, -12], [2, -11], [-5, -15]], [[2518, 5910], [-7, -4], [2, -7], [-6, -6], [-9, -15], [-1, -9]], [[3340, 5552], [18, -22], [17, -38], [1, -31], [10, -1], [15, -29], [11, -21]], [[3412, 5410], [-4, -53], [-17, -15], [1, -14], [-5, -31], [13, -42], [9, -1], [3, -33], [17, -51]], [[3313, 5365], [-19, 45], [7, 16], [0, 27], [17, 10], [7, 11], [-10, 22], [3, 21], [22, 35]], [[2574, 5825], [-5, 18], [-8, 5]], [[2561, 5848], [2, 24], [-4, 6], [-6, 4], [-12, -7], [-1, 8], [-8, 10], [-6, 12], [-8, 5]], [[2549, 5987], [3, -3], [6, 11], [8, 1], [3, -5], [4, 3], [13, -6], [13, 2], [9, 6], [3, 7], [9, -3], [6, -4], [8, 1], [5, 5], [13, -8], [4, -1], [9, -11], [8, -13], [10, -9], [7, -17]], [[2690, 5943], [-9, 2], [-4, -8], [-10, -8], [-7, 0], [-6, -8], [-6, 3], [-4, 9], [-3, -2], [-4, -14], [-3, 1], [0, -12], [-10, -17], [-5, -7], [-3, -7], [-8, 12], [-6, -16], [-6, 1], [-6, -2], [0, -29], [-4, 0], [-3, -14], [-9, -2]], [[5522, 7770], [7, -23], [9, -17], [-11, -22]], [[5515, 7577], [-3, -10]], [[5512, 7567], [-26, 22], [-16, 21], [-26, 18], [-23, 43], [6, 5], [-13, 25], [-1, 19], [-17, 10], [-9, -26], [-8, 20], [0, 21], [1, 1]], [[5380, 7746], [20, -2], [5, 9], [9, -9], [11, -1], [0, 16], [10, 6], [2, 24], [23, 16]], [[5460, 7805], [8, -7], [21, -26], [23, -11], [10, 9]], [[3008, 6124], [-19, 10], [-13, -5], [-17, 5], [-13, -11], [-15, 18], [3, 19], [25, -8], [21, -5], [10, 13], [-12, 26], [0, 23], [-18, 9], [7, 16], [17, -3], [24, -9]], [[5471, 7900], [14, -15], [10, -6], [24, 7], [2, 12], [11, 2], [14, 9], [3, -4], [13, 8], [6, 13], [9, 4], [30, -18], [6, 6]], [[5613, 7918], [15, -16], [2, -16]], [[5630, 7886], [-17, -12], [-13, -40], [-17, -40], [-22, -11]], [[5561, 7783], [-17, 2], [-22, -15]], [[5460, 7805], [-6, 20], [-4, 0]], [[8352, 4453], [-11, -2], [-37, 42], [26, 11], [14, -18], [10, -17], [-2, -16]], [[8471, 4532], [2, -11], [1, -18]], [[8474, 4503], [-18, -45], [-24, -13], [-3, 8], [2, 20], [12, 36], [28, 23]], [[8274, 4579], [10, -16], [17, 5], [7, -25], [-32, -12], [-19, -8], [-15, 1], [10, 34], [15, 0], [7, 21]], [[8413, 4579], [-4, -32], [-42, -17], [-37, 7], [0, 22], [22, 12], [18, -18], [18, 5], [25, 21]], [[8017, 4657], [53, -6], [6, 25], [51, -29], [10, -38], [42, -11], [34, -35], [-31, -23], [-31, 24], [-25, -1], [-29, 4], [-26, 11], [-32, 22], [-21, 6], [-11, -7], [-51, 24], [-5, 25], [-25, 5], [19, 56], [34, -3], [22, -23], [12, -5], [4, -21]], [[8741, 4690], [-14, -40], [-3, 45], [5, 21], [6, 20], [7, -17], [-1, -29]], [[8534, 4853], [-11, -19], [-19, 10], [-5, 26], [28, 3], [7, -20]], [[8623, 4875], [10, -45], [-23, 24], [-23, 5], [-16, -4], [-19, 2], [6, 33], [35, 2], [30, -17]], [[8916, 4904], [0, -193], [1, -192]], [[8917, 4519], [-25, 48], [-28, 12], [-7, -17], [-35, -1], [12, 48], [17, 16], [-7, 64], [-14, 50], [-53, 50], [-23, 5], [-42, 54], [-8, -28], [-11, -5], [-6, 21], [0, 26], [-21, 29], [29, 21], [20, -1], [-2, 16], [-41, 0], [-11, 35], [-25, 11], [-11, 29], [37, 14], [14, 20], [45, -25], [4, -22], [8, -95], [29, -35], [23, 62], [32, 36], [25, 0], [23, -21], [21, -21], [30, -11]], [[8478, 5141], [-22, -58], [-21, -12], [-27, 12], [-46, -3], [-24, -8], [-4, -45], [24, -53], [15, 27], [52, 20], [-2, -27], [-12, 9], [-12, -35], [-25, -23], [27, -76], [-5, -20], [25, -68], [-1, -39], [-14, -17], [-11, 20], [13, 49], [-27, -23], [-7, 16], [3, 23], [-20, 35], [3, 57], [-19, -18], [2, -69], [1, -84], [-17, -9], [-12, 18], [8, 54], [-4, 57], [-12, 1], [-9, 40], [12, 39], [4, 47], [14, 89], [5, 24], [24, 44], [22, -18], [35, -8], [32, 3], [27, 43], [5, -14]], [[8574, 5124], [-2, -51], [-14, 6], [-4, -36], [11, -32], [-8, -7], [-11, 38], [-8, 75], [6, 47], [9, 22], [2, -32], [16, -5], [3, -25]], [[8045, 5176], [5, -39], [19, -34], [18, 12], [18, -4], [16, 30], [13, 5], [26, -17], [23, 13], [14, 82], [11, 21], [10, 67], [32, 0], [24, -10]], [[8274, 5302], [-16, -53], [20, -56], [-5, -28], [32, -54], [-33, -7], [-10, -40], [2, -54], [-27, -40], [-1, -59], [-10, -91], [-5, 21], [-31, -26], [-11, 36], [-20, 3], [-14, 19], [-33, -21], [-10, 29], [-18, -4], [-23, 7], [-4, 79], [-14, 17], [-13, 50], [-4, 52], [3, 55], [16, 39]], [[7939, 4712], [-31, -1], [-24, 49], [-35, 48], [-12, 36], [-21, 48], [-14, 44], [-21, 83], [-24, 49], [-9, 51], [-10, 46], [-25, 37], [-14, 51], [-21, 33], [-29, 65], [-3, 30], [18, -2], [43, -12], [25, -57], [21, -40], [16, -25], [26, -63], [28, -1], [23, -41], [16, -49], [22, -27], [-12, -49], [16, -20], [10, -2], [5, -41], [10, -33], [20, -5], [14, -37], [-7, -74], [-1, -91]], [[7252, 6841], [-17, -27], [-11, -55], [27, -23], [26, -29], [36, -33], [38, -8], [16, -30], [22, -5], [33, -14], [23, 1], [4, 23], [-4, 38], [2, 25]], [[7703, 6727], [2, -22], [-10, -11], [2, -36], [-19, 10], [-36, -41], [0, -33], [-15, -50], [-1, -29], [-13, -48], [-21, 13], [-1, -61], [-7, -20], [3, -25], [-14, -14]], [[7472, 6360], [-4, -21], [-19, 1], [-34, -13], [2, -44], [-15, -35], [-40, -40], [-31, -69], [-21, -38], [-28, -38], [0, -27], [-13, -15], [-26, -21], [-12, -3], [-9, -45], [6, -77], [1, -49], [-11, -56], [0, -101], [-15, -2], [-12, -46], [8, -19], [-25, -17], [-10, -40], [-11, -17], [-26, 55], [-13, 83], [-11, 60], [-9, 28], [-15, 56], [-7, 74], [-5, 37], [-25, 81], [-12, 115], [-8, 75], [0, 72], [-5, 55], [-41, -35], [-19, 7], [-36, 71], [13, 22], [-8, 23], [-33, 50]], [[6893, 6457], [19, 40], [61, -1], [-6, 51], [-15, 30], [-4, 46], [-18, 26], [31, 62], [32, -4], [29, 61], [18, 60], [27, 60], [-1, 42], [24, 34], [-23, 29], [-9, 40], [-10, 52], [14, 25], [42, -14], [31, 9], [26, 49]], [[4827, 8240], [5, -42], [-21, -53], [-49, -35], [-40, 9], [23, 62], [-15, 60], [38, 46], [21, 28]], [[6497, 7255], [25, 12], [19, 33], [19, -1], [12, 11], [20, -6], [31, -30], [22, -6], [31, -53], [21, -2], [3, -49]], [[6690, 6820], [14, -31], [11, -36], [27, -26], [1, -52], [13, -10], [2, -27], [-40, -30], [-10, -69]], [[6708, 6539], [-53, 18], [-30, 13], [-31, 8], [-12, 73], [-13, 10], [-22, -11], [-28, -28], [-34, 20], [-28, 45], [-27, 17], [-18, 56], [-21, 79], [-15, -10], [-17, 20], [-11, -24]], [[6348, 6825], [-15, 32], [0, 31], [-9, 0], [5, 43], [-15, 45], [-34, 32], [-19, 56], [6, 46], [14, 21], [-2, 34], [-18, 18], [-18, 70]], [[6243, 7253], [-15, 48], [5, 18], [-8, 68], [19, 17]], [[6357, 7321], [9, -43], [26, -13], [20, -29], [39, -10], [44, 15], [2, 14]], [[6348, 6825], [-16, 3]], [[6332, 6828], [-19, 5], [-20, -56]], [[6293, 6777], [-52, 4], [-78, 119], [-41, 41], [-34, 16]], [[6088, 6957], [-11, 72]], [[6077, 7029], [61, 62], [11, 71], [-3, 43], [16, 15], [14, 37]], [[6176, 7257], [12, 9], [32, -8], [10, -15], [13, 10]], [[4597, 8984], [-7, -39], [31, -40], [-36, -45], [-80, -41], [-24, -10], [-36, 8], [-78, 19], [28, 26], [-61, 29], [49, 12], [-1, 17], [-58, 14], [19, 38], [42, 9], [43, -40], [42, 32], [35, -17], [45, 32], [47, -4]], [[5992, 6990], [-5, -19]], [[5987, 6971], [-10, 8], [-6, -39], [7, -7], [-7, -8], [-1, -15], [13, 8]], [[5983, 6918], [0, -23], [-14, -95]], [[5951, 6902], [8, 19], [-2, 4], [8, 27], [5, 45], [4, 15], [1, 0]], [[5975, 7012], [9, 0], [3, 11], [7, 0]], [[5994, 7023], [1, -24], [-4, -9], [1, 0]], [[5431, 7316], [-10, -46], [4, -19], [-6, -30], [-21, 22], [-14, 7], [-39, 30], [4, 30], [32, -6], [28, 7], [22, 5]], [[5255, 7492], [17, -42], [-4, -78], [-13, 4], [-11, -20], [-10, 16], [-2, 71], [-6, 34], [15, -3], [14, 18]], [[5383, 7805], [-3, -29], [7, -25]], [[5387, 7751], [-22, 8], [-23, -20], [1, -30], [-3, -17], [9, -30], [26, -29], [14, -49], [31, -48], [22, 0], [7, -13], [-8, -11], [25, -22], [20, -18], [24, -30], [3, -11], [-5, -22], [-16, 28], [-24, 10], [-12, -39], [20, -21], [-3, -31], [-11, -4], [-15, -50], [-12, -5], [0, 18], [6, 32], [6, 12], [-11, 35], [-8, 29], [-12, 8], [-8, 25], [-18, 11], [-12, 24], [-21, 4], [-21, 26], [-26, 39], [-19, 34], [-8, 58], [-14, 7], [-23, 20], [-12, -8], [-16, -28], [-12, -4]], [[2845, 6150], [19, -5], [14, -15], [5, -16], [-19, -1], [-9, -10], [-15, 10], [-16, 21], [3, 14], [12, 4], [6, -2]], [[5992, 6990], [31, -24], [54, 63]], [[6088, 6957], [-5, -8], [-56, -30], [28, -59], [-9, -10], [-5, -20], [-21, -8], [-7, -21], [-12, -19], [-31, 10]], [[5970, 6792], [-1, 8]], [[5983, 6918], [4, 17], [0, 36]], [[8739, 7075], [4, -20], [-16, -36], [-11, 19], [-15, -14], [-7, -34], [-18, 16], [0, 28], [15, 36], [16, -7], [12, 25], [20, -13]], [[8915, 7252], [-10, -47], [4, -30], [-14, -42], [-35, -27], [-49, -4], [-40, -67], [-19, 22], [-1, 44], [-48, -13], [-33, -27], [-32, -2], [28, -43], [-19, -101], [-18, -24], [-13, 23], [7, 53], [-18, 17], [-11, 41], [26, 18], [15, 37], [28, 30], [20, 41], [55, 17], [30, -12], [29, 105], [19, -28], [40, 59], [16, 23], [18, 72], [-5, 67], [11, 37], [30, 11], [15, -82], [-1, -48], [-25, -59], [0, -61]], [[8997, 7667], [19, -12], [20, 25], [6, -67], [-41, -16], [-25, -59], [-43, 41], [-15, -65], [-31, -1], [-4, 59], [14, 46], [29, 3], [8, 82], [9, 46], [32, -62], [22, -20]], [[6970, 7554], [-15, -10], [-37, -42], [-12, -42], [-11, 0], [-7, 28], [-36, 2], [-5, 48], [-14, 0], [2, 60], [-33, 43], [-48, -5], [-32, -8], [-27, 53], [-22, 22], [-43, 43], [-6, 5], [-71, -35], [1, -218]], [[6554, 7498], [-14, -3], [-20, 46], [-18, 17], [-32, -12], [-12, -20]], [[6458, 7526], [-2, 14], [7, 25], [-5, 21], [-32, 20], [-13, 53], [-15, 15], [-1, 19], [27, -6], [1, 44], [23, 9], [25, -9], [5, 58], [-5, 36], [-28, -2], [-24, 14], [-32, -26], [-26, -12]], [[6363, 7799], [-14, 9], [3, 31], [-18, 39], [-20, -2], [-24, 40], [16, 45], [-8, 12], [22, 65], [29, -34], [3, 43], [58, 64], [43, 2], [61, -41], [33, -24], [30, 25], [44, 1], [35, -30], [8, 17], [39, -2], [7, 28], [-45, 40], [27, 29], [-5, 16], [26, 15], [-20, 41], [13, 20], [104, 21], [13, 14], [70, 22], [25, 24], [50, -12], [9, -61], [29, 14], [35, -20], [-2, -32], [27, 3], [69, 56], [-10, -19], [35, -46], [62, -150], [15, 31], [39, -34], [39, 16], [16, -11], [13, -34], [20, -12], [11, -25], [36, 8], [15, -36]], [[7229, 7559], [-17, 9], [-14, 21], [-42, 6], [-46, 2], [-10, -6], [-39, 24], [-16, -12], [-4, -35], [-46, 21], [-18, -9], [-7, -26]], [[6155, 4958], [-20, -24], [-7, -24], [-10, -4], [-4, -42], [-9, -24], [-5, -39], [-12, -20]], [[6088, 4781], [-40, 59], [-1, 35], [-101, 120], [-5, 6]], [[5941, 5001], [0, 63], [8, 24], [14, 39], [10, 43], [-13, 68], [-3, 30], [-13, 41]], [[5944, 5309], [17, 35], [19, 39]], [[6162, 5289], [-24, -67], [0, -215], [17, -49]], [[7046, 7387], [-53, -9], [-34, 19], [-30, -4], [3, 34], [30, -10], [10, 18]], [[6972, 7435], [21, -6], [36, 43], [-33, 31], [-20, -15], [-21, 22], [24, 39], [-9, 5]], [[7849, 5777], [-7, 72], [18, 49], [36, 11], [26, -8]], [[7922, 5901], [23, -23], [12, 40], [25, -21]], [[7982, 5897], [6, -40], [-3, -71], [-47, -45], [13, -36], [-30, -4], [-24, -24]], [[7897, 5677], [-23, 9], [-11, 30], [-14, 61]], [[8564, 7339], [24, -70], [7, -38], [0, -68], [-10, -33], [-25, -11], [-22, -25], [-25, -5], [-3, 32], [5, 45], [-13, 61], [21, 10], [-19, 51]], [[8504, 7288], [2, 5], [12, -2], [11, 27], [20, 2], [11, 4], [4, 15]], [[5557, 7574], [5, 13]], [[5562, 7587], [7, 4], [4, 20], [5, 3], [4, -8], [5, -4], [3, -10], [5, -2], [5, -11], [4, 0], [-3, -14], [-3, -7], [1, -5]], [[5599, 7553], [-6, -2], [-17, -9], [-1, -12], [-4, 0]], [[6332, 6828], [6, -26], [-3, -13], [9, -45]], [[6344, 6744], [-19, -1], [-7, 28], [-25, 6]], [[7922, 5901], [9, 26], [1, 50], [-22, 52], [-2, 58], [-21, 48], [-21, 4], [-6, -20], [-16, -2], [-8, 10], [-30, -35], [0, 53], [7, 62], [-19, 3], [-2, 36], [-12, 18]], [[7780, 6264], [6, 21], [24, 39]], [[7837, 6385], [17, -47], [12, -54], [34, 0], [11, -52], [-18, -15], [-8, -21], [34, -36], [23, -70], [17, -52], [21, -41], [7, -41], [-5, -59]], [[5975, 7012], [10, 49], [14, 41], [0, 2]], [[5999, 7104], [13, -3], [4, -23], [-15, -22], [-7, -33]], [[4785, 5315], [-7, 0], [-29, 28], [-25, 45], [-24, 32], [-18, 38]], [[4682, 5458], [6, 19], [2, 17], [12, 33], [13, 27]], [[5412, 6408], [-20, -22], [-15, 33], [-44, 25]], [[5263, 6848], [13, 14], [3, 25], [-3, 24], [19, 23], [8, 19], [14, 17], [2, 45]], [[5319, 7015], [32, -20], [12, 5], [23, -10], [37, -26], [13, -53], [25, -11], [39, -25], [30, -29], [13, 15], [13, 27], [-6, 45], [9, 29], [20, 28], [19, 8], [37, -12], [10, -27], [10, 0], [9, -10], [28, -7], [6, -19]], [[5694, 6357], [0, -118], [-32, 0], [0, -25]], [[5662, 6214], [-111, 113], [-111, 113], [-28, -32]], [[7271, 5502], [-4, -62], [-12, -16], [-24, -14], [-13, 47], [-5, 85], [13, 96], [19, -33], [13, -42], [13, -61]], [[5804, 3347], [10, -18], [-9, -29], [-4, -19], [-16, -9], [-5, -19], [-10, -6], [-21, 46], [15, 37], [15, 23], [13, 12], [12, -18]], [[5631, 8267], [-2, 15], [3, 16], [-13, 10], [-29, 10]], [[5590, 8318], [-6, 50]], [[5584, 8368], [32, 18], [47, -4], [27, 6], [4, -12], [15, -4], [26, -29]], [[5652, 8242], [-7, 19], [-14, 6]], [[5584, 8368], [1, 44], [14, 37], [26, 20], [22, -44], [22, 1], [6, 46]], [[5757, 8453], [14, -14], [2, -28], [9, -35]], [[4759, 6691], [-4, 0], [0, -31], [-17, -2], [-9, -14], [-13, 0], [-10, 8], [-23, -6], [-9, -46], [-9, -5], [-13, -74], [-38, -64], [-9, -81], [-12, -27], [-3, -21], [-63, -5]], [[4527, 6323], [1, 27], [11, 17], [9, 30], [-2, 20], [10, 42], [15, 38], [9, 9], [8, 35], [0, 31], [10, 37], [19, 21], [18, 60], [0, 1], [14, 23], [26, 6], [22, 41], [14, 16], [23, 49], [-7, 73], [10, 51], [4, 31], [18, 40], [28, 27], [21, 25], [18, 61], [9, 36], [20, 0], [17, -25], [26, 4], [29, -13], [12, -1]], [[5739, 7906], [6, 9], [19, 6], [20, -19], [12, -2], [12, -16], [-2, -20], [11, -9], [4, -25], [9, -15], [-2, -9], [5, -6], [-7, -4], [-16, 1], [-3, 9], [-6, -5], [2, -11], [-7, -19], [-5, -20], [-7, -6]], [[5784, 7745], [-5, 27], [3, 25], [-1, 26], [-16, 35], [-9, 25], [-9, 17], [-8, 6]], [[6376, 4321], [7, -25], [7, -39], [4, -71], [7, -28], [-2, -28], [-5, -18], [-10, 35], [-5, -18], [5, -43], [-2, -25], [-8, -14], [-1, -50], [-11, -69], [-14, -81], [-17, -112], [-11, -82], [-12, -69], [-23, -14], [-24, -25], [-16, 15], [-22, 21], [-8, 31], [-2, 53], [-10, 47], [-2, 42], [5, 43], [13, 10], [0, 20], [13, 45], [2, 37], [-6, 28], [-5, 38], [-2, 54], [9, 33], [4, 38], [14, 2], [15, 12], [11, 10], [12, 1], [16, 34], [23, 36], [8, 30], [-4, 25], [12, -7], [15, 41], [1, 36], [9, 26], [10, -25]], [[2301, 6586], [-10, -52], [-5, -43], [-2, -79], [-3, -29], [5, -32], [9, -29], [5, -45], [19, -44], [6, -34], [11, -29], [29, -16], [12, -25], [24, 17], [21, 6], [21, 11], [18, 10], [17, 24], [7, 34], [2, 50], [5, 17], [19, 16], [29, 13], [25, -2], [17, 5], [6, -12], [-1, -29], [-15, -35], [-6, -36], [5, -10], [-4, -26], [-7, -46], [-7, 15], [-6, -1]], [[2438, 5916], [-32, 64], [-14, 19], [-23, 16], [-15, -5], [-22, -22], [-14, -6], [-20, 16], [-21, 11], [-26, 27], [-21, 8], [-31, 28], [-23, 28], [-7, 16], [-16, 3], [-28, 19], [-12, 27], [-30, 34], [-14, 37], [-6, 29], [9, 5], [-3, 17], [7, 16], [0, 20], [-10, 27], [-2, 23], [-9, 30], [-25, 59], [-28, 46], [-13, 37], [-24, 24], [-5, 14], [4, 37], [-14, 13], [-17, 29], [-7, 41], [-14, 5], [-17, 31], [-13, 29], [-1, 19], [-15, 44], [-10, 45], [1, 23], [-20, 23], [-10, -2], [-15, 16], [-5, -24], [5, -28], [2, -45], [10, -24], [21, -41], [4, -14], [4, -4], [4, -20], [5, 1], [6, -38], [8, -15], [6, -21], [17, -30], [10, -55], [8, -26], [8, -28], [1, -31], [13, -2], [12, -27], [10, -26], [-1, -11], [-12, -21], [-5, 0], [-7, 36], [-18, 33], [-20, 29], [-14, 15], [1, 43], [-5, 32], [-13, 19], [-19, 26], [-4, -8], [-7, 16], [-17, 14], [-16, 34], [2, 5], [11, -4], [11, 22], [1, 27], [-22, 42], [-16, 17], [-10, 36], [-11, 39], [-12, 47], [-12, 54]], [[1746, 6980], [32, 4], [35, 7], [-2, -12], [41, -29], [64, -41], [55, 0], [22, 0], [0, 24], [48, 0], [10, -20], [15, -19], [16, -26], [9, -31], [7, -32], [15, -18], [23, -18], [17, 47], [23, 1], [19, -24], [14, -40], [10, -35], [16, -34], [6, -41], [8, -28], [22, -18], [20, -13], [10, 2]], [[5599, 7553], [9, 4], [13, 1]], [[4661, 5921], [10, 11], [4, 35], [9, 1], [20, -16], [15, 11], [11, -4], [4, 13], [112, 1], [6, 42], [-5, 7], [-13, 255], [-14, 255], [43, 1]], [[5118, 6189], [0, -136], [-15, -39], [-2, -37], [-25, -9], [-38, -5], [-10, -21], [-18, -3]], [[4680, 5793], [1, 18], [-2, 23], [-11, 16], [-5, 34], [-2, 37]], [[7737, 5644], [-3, 44], [9, 45], [-10, 35], [3, 65], [-12, 30], [-9, 71], [-5, 75], [-12, 49], [-18, -30], [-32, -42], [-15, 5], [-17, 14], [9, 73], [-6, 56], [-21, 68], [3, 21], [-16, 7], [-20, 49]], [[7780, 6264], [-16, -14], [-16, -26], [-20, -2], [-12, -64], [-12, -11], [14, -52], [17, -43], [12, -39], [-11, -51], [-9, -11], [6, -30], [19, -47], [3, -33], [0, -27], [11, -54], [-16, -55], [-13, -61]], [[5538, 7532], [-6, 4], [-8, 19], [-12, 12]], [[5533, 7629], [8, -10], [4, -9], [9, -6], [10, -12], [-2, -5]], [[7437, 7970], [29, 10], [53, 51], [42, 28], [24, -18], [29, -1], [19, -28], [28, -2], [40, -15], [27, 41], [-11, 35], [28, 61], [31, -24], [26, -7], [32, -15], [6, -44], [39, -25], [26, 11], [36, 7], [27, -7], [28, -29], [16, -30], [26, 1], [35, -10], [26, 15], [36, 9], [41, 42], [17, -6], [14, -20], [33, 5]], [[5959, 4377], [21, 5], [34, -17], [7, 8], [19, 1], [10, 18], [17, -1], [30, 23], [22, 34]], [[6119, 4448], [5, -26], [-1, -59], [3, -52], [1, -92], [5, -29], [-8, -43], [-11, -41], [-18, -36], [-25, -23], [-31, -28], [-32, -64], [-10, -11], [-20, -42], [-11, -13], [-3, -42], [14, -45], [5, -35], [0, -17], [5, 3], [-1, -58], [-4, -28], [6, -10], [-4, -25], [-11, -21], [-23, -20], [-34, -32], [-12, -21], [3, -25], [7, -4], [-3, -31]], [[5911, 3478], [-21, 0]], [[5890, 3478], [-2, 26], [-4, 27]], [[5884, 3531], [-3, 21], [5, 66], [-7, 42], [-13, 83]], [[5866, 3743], [29, 67], [7, 43], [5, 5], [3, 35], [-5, 17], [1, 44], [6, 41], [0, 75], [-15, 19], [-13, 4], [-6, 15], [-13, 12], [-23, -1], [-2, 22]], [[5840, 4141], [-2, 42], [84, 49]], [[5922, 4232], [16, -28], [8, 5], [11, -15], [1, -23], [-6, -28], [2, -42], [19, -36], [8, 41], [12, 12], [-2, 76], [-12, 43], [-10, 19], [-10, -1], [-7, 77], [7, 45]], [[4661, 5921], [-18, 41], [-17, 43], [-18, 16], [-13, 17], [-16, -1], [-13, -12], [-14, 5], [-10, -19]], [[4542, 6011], [-2, 32], [8, 29], [3, 55], [-3, 59], [-3, 29], [2, 30], [-7, 28], [-14, 25]], [[4526, 6298], [6, 20], [108, -1], [-5, 86], [7, 30], [26, 5], [-1, 152], [91, -4], [0, 90]], [[5922, 4232], [-15, 15], [9, 55], [9, 21], [-6, 49], [6, 48], [5, 16], [-7, 50], [-14, 26]], [[5909, 4512], [28, -11], [5, -16], [10, -28], [7, -80]], [[7836, 5425], [7, -5], [16, -36], [12, -40], [2, -39], [-3, -27], [2, -21], [2, -35], [10, -16], [11, -52], [-1, -20], [-19, -4], [-27, 44], [-32, 47], [-4, 30], [-16, 39], [-4, 49], [-10, 32], [4, 43], [-7, 25]], [[7779, 5439], [5, 11], [23, -26], [2, -30], [18, 7], [9, 24]], [[8045, 5176], [21, -20], [21, 11], [6, 50], [12, 11], [33, 13], [20, 47], [14, 37]], [[8206, 5379], [22, 41], [14, 47], [11, 0], [14, -30], [1, -26], [19, -16], [23, -18], [-2, -23], [-19, -3], [5, -29], [-20, -20]], [[5453, 3369], [-20, 45], [-11, 43], [-6, 58], [-7, 42], [-9, 91], [-1, 71], [-3, 32], [-11, 25], [-15, 48], [-14, 71], [-6, 37], [-23, 58], [-2, 45]], [[5644, 4022], [23, 14], [18, -4], [11, -13], [0, -5]], [[5552, 3594], [0, -218], [-25, -30], [-15, -4], [-17, 11], [-13, 4], [-4, 25], [-11, 17], [-14, -30]], [[9604, 3812], [23, -36], [14, -28], [-10, -14], [-16, 16], [-19, 27], [-18, 31], [-19, 42], [-4, 20], [12, -1], [16, -20], [12, -20], [9, -17]], [[5412, 6408], [7, -92], [10, -15], [1, -19], [11, -20], [-6, -25], [-11, -120], [-1, -77], [-35, -56], [-12, -78], [11, -22], [0, -38], [18, -1], [-3, -28]], [[5393, 5795], [-5, -1], [-19, 64], [-6, 3], [-22, -33], [-21, 17], [-15, 3], [-8, -8], [-17, 2], [-16, -25], [-14, -2], [-34, 31], [-13, -15], [-14, 1], [-10, 23], [-28, 22], [-30, -7], [-7, -13], [-4, -34], [-8, -24], [-2, -53]], [[5236, 5339], [-29, -21], [-11, 3], [-10, -13], [-23, 1], [-15, 37], [-9, 43], [-19, 39], [-21, -1], [-25, 0]], [[2619, 5713], [-10, 18], [-13, 24], [-6, 20], [-12, 19], [-13, 26], [3, 9], [4, -9], [2, 5]], [[2690, 5943], [-2, -5], [-2, -13], [3, -22], [-6, -20], [-3, -24], [-1, -26], [1, -15], [1, -27], [-4, -6], [-3, -25], [2, -15], [-6, -16], [2, -16], [4, -9]], [[5092, 8091], [14, 16], [24, 87], [38, 25], [23, -2]], [[5863, 9167], [-47, -24], [-22, -5]], [[5573, 9140], [-17, -2], [-4, -39], [-53, 9], [-7, -33], [-27, 1], [-18, -42], [-28, -66], [-43, -83], [10, -20], [-10, -24], [-27, 1], [-18, -55], [2, -79], [17, -29], [-9, -70], [-23, -40], [-12, -34]], [[5306, 8535], [-19, 36], [-55, -69], [-37, -13], [-38, 30], [-10, 63], [-9, 137], [26, 38], [73, 49], [55, 61], [51, 82], [66, 115], [47, 44], [76, 74], [61, 26], [46, -3], [42, 49], [51, -3], [50, 12], [87, -43], [-36, -16], [30, -37]], [[5686, 9657], [-62, -24], [-49, 13], [19, 16], [-16, 19], [57, 11], [11, -22], [40, -13]], [[5506, 9766], [92, -44], [-70, -23], [-15, -44], [-25, -11], [-13, -49], [-34, -2], [-59, 36], [25, 21], [-42, 17], [-54, 50], [-21, 46], [75, 21], [16, -20], [39, 0], [11, 21], [40, 2], [35, -21]], [[5706, 9808], [55, -21], [-41, -32], [-81, -7], [-82, 10], [-5, 16], [-40, 1], [-30, 27], [86, 17], [40, -14], [28, 17], [70, -14]], [[9805, 2640], [6, -24], [20, 24], [8, -25], [0, -25], [-10, -27], [-18, -44], [-14, -24], [10, -28], [-22, -1], [-23, -22], [-8, -39], [-16, -60], [-21, -26], [-14, -17], [-26, 1], [-18, 20], [-30, 4], [-5, 22], [15, 43], [35, 59], [18, 11], [20, 22], [24, 31], [16, 31], [13, 44], [10, 15], [5, 33], [19, 27], [6, -25]], [[9849, 2922], [20, -63], [1, 41], [13, -16], [4, -45], [22, -19], [19, -5], [16, 22], [14, -6], [-7, -53], [-8, -34], [-22, 1], [-7, -18], [3, -25], [-4, -11], [-11, -32], [-14, -41], [-21, -23], [-5, 15], [-12, 9], [16, 48], [-9, 33], [-30, 23], [1, 22], [20, 20], [5, 46], [-1, 38], [-12, 40], [1, 10], [-13, 25], [-22, 52], [-12, 42], [11, 4], [15, -33], [21, -15], [8, -52]], [[6475, 6041], [-9, 41], [-22, 98]], [[6444, 6180], [83, 59], [19, 118], [-13, 42]], [[6566, 6530], [12, -40], [16, -22], [20, -8], [17, -10], [12, -34], [8, -20], [10, -7], [0, -13], [-10, -36], [-5, -16], [-12, -19], [-10, -41], [-13, 3], [-5, -14], [-5, -30], [4, -39], [-3, -7], [-13, 0], [-17, -22], [-3, -29], [-6, -12], [-18, 0], [-10, -15], [0, -24], [-14, -16], [-15, 5], [-19, -19], [-12, -4]], [[6557, 6597], [8, 20], [3, -5], [-2, -25], [-4, -10]], [[6893, 6457], [-20, 15], [-9, 43], [-21, 45], [-51, -12], [-45, -1], [-39, -8]], [[2836, 5484], [-9, 17], [-6, 32], [7, 16], [-7, 4], [-5, 20], [-14, 16], [-12, -4], [-6, -20], [-11, -15], [-6, -2], [-3, -13], [13, -32], [-7, -7], [-4, -9], [-13, -3], [-5, 35], [-4, -10], [-9, 4], [-5, 24], [-12, 3], [-7, 7], [-12, 0], [-1, -13], [-3, 9]], [[2707, 5623], [10, -22], [-1, -12], [11, -3], [3, 5], [8, -14], [13, 4], [12, 15], [17, 12], [9, 17], [16, -3], [-1, -6], [15, -2], [12, -10], [10, -18], [10, -16]], [[3045, 3974], [-28, 33], [-2, 25], [-55, 59], [-50, 65], [-22, 36], [-11, 49], [4, 17], [-23, 77], [-28, 109], [-26, 118], [-11, 27], [-9, 43], [-21, 39], [-20, 24], [9, 26], [-14, 57], [9, 41], [22, 37]], [[8510, 5555], [2, -40], [2, -33], [-9, -54], [-11, 60], [-13, -30], [9, -43], [-8, -28], [-32, 35], [-8, 42], [8, 28], [-17, 28], [-9, -24], [-13, 2], [-21, -33], [-4, 17], [11, 50], [17, 17], [15, 22], [10, -27], [21, 17], [5, 26], [19, 1], [-1, 46], [22, -28], [3, -30], [2, -21]], [[8443, 5665], [-10, -20], [-9, -37], [-8, -17], [-17, 40], [5, 16], [7, 17], [3, 36], [16, 4], [-5, -40], [21, 57], [-3, -56]], [[8291, 5608], [-37, -56], [14, 41], [20, 37], [16, 41], [15, 58], [5, -48], [-18, -33], [-15, -40]], [[8385, 5760], [16, -18], [18, 0], [0, -25], [-13, -25], [-18, -18], [-1, 28], [2, 30], [-4, 28]], [[8485, 5776], [8, -66], [-21, 16], [0, -20], [7, -37], [-13, -13], [-1, 42], [-9, 3], [-4, 36], [16, -5], [0, 22], [-17, 45], [27, -1], [7, -22]], [[8375, 5830], [-7, -51], [-12, 29], [-15, 45], [24, -2], [10, -21]], [[8369, 6151], [17, -17], [9, 15], [2, -15], [-4, -24], [9, -43], [-7, -49], [-16, -19], [-5, -48], [7, -47], [14, -7], [13, 7], [34, -32], [-2, -32], [9, -15], [-3, -27], [-22, 29], [-10, 31], [-7, -22], [-18, 36], [-25, -9], [-14, 13], [1, 25], [9, 15], [-8, 13], [-4, -21], [-14, 34], [-4, 26], [-1, 56], [11, -19], [3, 92], [9, 54], [17, 0]], [[9329, 4655], [-8, -6], [-12, 22], [-12, 38], [-6, 45], [4, 6], [3, -18], [8, -13], [14, -38], [13, -20], [-4, -16]], [[9221, 4734], [-15, -5], [-4, -17], [-15, -14], [-15, -14], [-14, 0], [-23, 18], [-16, 16], [2, 18], [25, -8], [15, 4], [5, 29], [4, 1], [2, -31], [16, 4], [8, 20], [16, 21], [-4, 35], [17, 1], [6, -9], [-1, -33], [-9, -36]], [[8916, 4904], [48, -41], [51, -34], [19, -30], [16, -30], [4, -34], [46, -37], [7, -31], [-25, -7], [6, -39], [25, -39], [18, -62], [15, 2], [-1, -27], [22, -10], [-9, -11], [30, -25], [-3, -17], [-18, -4], [-7, 16], [-24, 6], [-28, 9], [-22, 38], [-16, 32], [-14, 52], [-36, 26], [-24, -17], [-17, -20], [4, -43], [-22, -20], [-16, 9], [-28, 3]], [[9253, 4792], [-9, -16], [-5, 35], [-6, 23], [-13, 19], [-16, 25], [-20, 18], [8, 14], [15, -17], [9, -13], [12, -14], [11, -25], [11, -19], [3, -30]], [[5392, 8233], [19, 18], [43, 27], [35, 20], [28, -10], [2, -14], [27, -1]], [[5546, 8273], [34, -7], [51, 1]], [[5653, 8105], [14, -52], [-3, -17], [-14, -6], [-25, -50], [7, -26], [-6, 3]], [[5626, 7957], [-26, 23], [-20, -8], [-13, 6], [-17, -13], [-14, 21], [-11, -8], [-2, 4]], [[3159, 6151], [14, -5], [5, -12], [-7, -15], [-21, 1], [-17, -2], [-1, 25], [4, 9], [23, -1]], [[8628, 7562], [4, -10]], [[8632, 7552], [-11, 3], [-12, -20], [-8, -20], [1, -42], [-14, -13], [-5, -11], [-11, -17], [-18, -10], [-12, -16], [-1, -25], [-3, -7], [11, -9], [15, -26]], [[8504, 7288], [-13, 11], [-4, -11], [-8, -5], [-1, 11], [-7, 5], [-8, 10], [8, 26], [7, 7], [-3, 11], [7, 31], [-2, 10], [-16, 7], [-13, 15]], [[4792, 7249], [-11, -15], [-14, 8], [-15, -6], [5, 46], [-3, 36], [-12, 6], [-7, 22], [2, 39], [11, 21], [2, 24], [6, 36], [-1, 25], [-5, 21], [-1, 20]], [[6411, 6520], [-2, 43], [7, 31], [8, 6], [8, -18], [1, -35], [-6, -35]], [[6427, 6512], [-8, -4], [-8, 12]], [[5630, 7886], [12, 13], [17, -7], [18, 0], [13, -14], [10, 9], [20, 5], [7, 14], [12, 0]], [[5784, 7745], [12, -11], [13, 9], [13, -10]], [[5822, 7733], [0, -15], [-13, -13], [-9, 6], [-7, -71]], [[5629, 7671], [-5, 10], [6, 10], [-7, 7], [-8, -13], [-17, 17], [-2, 25], [-17, 14], [-3, 18], [-15, 24]], [[8989, 8056], [28, -105], [-41, 19], [-17, -85], [27, -61], [-1, -41], [-21, 36], [-18, -46], [-5, 50], [3, 57], [-3, 64], [6, 45], [2, 79], [-17, 58], [3, 80], [25, 28], [-11, 27], [13, 8], [7, -39], [10, -57], [-1, -58], [11, -59]], [[5546, 8273], [6, 26], [38, 19]], [[0, 9132], [68, -45], [73, -59], [-3, -37], [19, -15], [-6, 43], [75, -8], [55, -56], [-28, -26], [-46, -6], [0, -57], [-11, -13], [-26, 2], [-22, 21], [-36, 17], [-7, 26], [-28, 9], [-31, -7], [-16, 20], [6, 22], [-33, -14], [13, -28], [-16, -25]], [[0, 8896], [0, 236]], [[0, 9282], [9999, -40], [-30, -3], [-5, 19], [-9964, 24]], [[0, 9282], [4, 3], [23, 0], [40, -17], [-2, -8], [-29, -14], [-36, -4], [0, 40]], [[8988, 9383], [-42, -1], [-57, 7], [-5, 3], [27, 23], [34, 6], [40, -23], [3, -15]], [[9186, 9493], [-32, -23], [-44, 5], [-52, 23], [7, 20], [51, -9], [70, -16]], [[9029, 9522], [-22, -44], [-102, 1], [-46, -14], [-55, 39], [15, 40], [37, 11], [73, -2], [100, -31]], [[6598, 9235], [-17, -5], [-91, 8], [-7, 26], [-50, 16], [-4, 32], [28, 13], [-1, 32], [55, 50], [-25, 7], [66, 52], [-7, 27], [62, 31], [91, 38], [93, 11], [48, 22], [54, 8], [19, -23], [-19, -19], [-98, -29], [-85, -28], [-86, -57], [-42, -57], [-43, -57], [5, -49], [54, -49]], [[0, 8896], [9963, -26], [-36, 4], [25, -31], [17, -49], [13, -16], [3, -24], [-7, -16], [-52, 13], [-78, -44], [-25, -7], [-42, -42], [-40, -36], [-11, -27], [-39, 41], [-73, -46], [-12, 22], [-27, -26], [-37, 8], [-9, -38], [-33, -58], [1, -24], [31, -13], [-4, -86], [-25, -2], [-12, -49], [11, -26], [-48, -30], [-10, -67], [-41, -15], [-9, -60], [-40, -55], [-10, 41], [-12, 86], [-15, 131], [13, 82], [23, 35], [2, 28], [43, 13], [50, 75], [47, 60], [50, 48], [23, 83], [-34, -5], [-17, -49], [-70, -65], [-23, 73], [-72, -20], [-69, -99], [23, -36], [-62, -16], [-43, -6], [2, 43], [-43, 9], [-35, -29], [-85, 10], [-91, -18], [-90, -115], [-106, -139], [43, -8], [14, -37], [27, -13], [18, 30], [30, -4], [40, -65], [1, -50], [-21, -59], [-3, -71], [-12, -94], [-42, -86], [-9, -41], [-38, -69], [-38, -68], [-18, -35], [-37, -34], [-17, -1], [-17, 29], [-38, -44], [-4, -19]], [[6363, 7799], [-12, -35], [-27, -10], [-28, -61], [25, -56], [-2, -40], [30, -70]], [[6109, 7624], [-35, 49], [-32, 23], [-24, 34], [20, 10], [23, 49], [-15, 24], [41, 24], [-1, 13], [-25, -10]], [[6061, 7840], [1, 26], [14, 17], [27, 4], [5, 20], [-7, 33], [12, 30], [-1, 18], [-41, 19], [-16, -1], [-17, 28], [-21, -9], [-35, 20], [0, 12], [-10, 26], [-22, 3], [-2, 18], [7, 12], [-18, 33], [-29, -5], [-8, 3], [-7, -14], [-11, 3]], [[5777, 8571], [31, 33], [-29, 28]], [[5863, 9167], [29, 20], [46, -35], [76, -14], [105, -67], [21, -28], [2, -40], [-31, -31], [-45, -15], [-124, 44], [-21, -7], [45, -43], [2, -28], [2, -60], [36, -18], [22, -15], [3, 28], [-17, 26], [18, 22], [67, -37], [24, 15], [-19, 43], [65, 58], [25, -4], [26, -20], [16, 40], [-23, 35], [14, 36], [-21, 36], [78, -18], [16, -34], [-35, -7], [0, -33], [22, -20], [43, 13], [7, 38], [58, 28], [97, 50], [20, -3], [-27, -35], [35, -7], [19, 21], [52, 1], [42, 25], [31, -36], [32, 39], [-29, 35], [14, 19], [82, -18], [39, -18], [100, -68], [19, 31], [-28, 31], [-1, 13], [-34, 6], [10, 28], [-15, 46], [-1, 19], [51, 53], [18, 54], [21, 11], [74, -15], [5, -33], [-26, -48], [17, -19], [9, -41], [-6, -81], [31, -36], [-12, -40], [-55, -84], [32, -8], [11, 21], [31, 15], [7, 29], [24, 29], [-16, 33], [13, 39], [-31, 5], [-6, 33], [22, 59], [-36, 48], [50, 40], [-7, 42], [14, 2], [15, -33], [-11, -57], [29, -11], [-12, 43], [46, 23], [58, 3], [51, -34], [-25, 49], [-2, 63], [48, 12], [67, -2], [60, 7], [-23, 31], [33, 39], [31, 2], [54, 29], [74, 8], [9, 16], [73, 6], [23, -14], [62, 32], [51, -1], [8, 25], [26, 25], [66, 25], [48, -19], [-38, -15], [63, -9], [7, -29], [25, 14], [82, -1], [62, -29], [23, -22], [-7, -30], [-31, -18], [-73, -33], [-21, -17], [35, -8], [41, -15], [25, 11], [14, -38], [12, 15], [44, 10], [90, -10], [6, -28], [116, -9], [2, 46], [59, -11], [44, 1], [45, -32], [13, -37], [-17, -25], [35, -47], [44, -24], [27, 62], [44, -26], [48, 16], [53, -18], [21, 16], [45, -8], [-20, 55], [37, 25], [251, -38], [24, -35], [72, -45], [112, 11], [56, -10], [23, -24], [-4, -44], [35, -16], [37, 12], [49, 1], [52, -11], [53, 6], [49, -52], [34, 19], [-23, 37], [13, 27], [88, -17], [58, 4], [80, -29], [-9960, -25]], [[7918, 9684], [-157, -23], [51, 77], [23, 7], [21, -4], [70, -33], [-8, -24]], [[6420, 9816], [-37, -8], [-25, -4], [-4, -10], [-33, -10], [-30, 14], [16, 19], [-62, 2], [54, 10], [43, 1], [5, -16], [16, 14], [26, 10], [42, -13], [-11, -9]], [[7775, 9718], [-60, -8], [-78, 17], [-46, 23], [-21, 42], [-38, 12], [72, 40], [60, 14], [54, -30], [64, -57], [-7, -53]], [[5844, 4990], [11, -33], [-1, -35], [-8, -7]], [[5821, 4978], [7, -6], [16, 18]], [[4526, 6298], [1, 25]], [[6188, 6023], [-4, 26], [-8, 17], [-2, 24], [-15, 21], [-15, 50], [-7, 48], [-20, 40], [-12, 10], [-18, 56], [-4, 41], [2, 35], [-16, 66], [-13, 23], [-15, 12], [-10, 34], [2, 13], [-8, 31], [-8, 13], [-11, 44], [-17, 48], [-14, 40], [-14, 0], [5, 33], [1, 20], [3, 24]], [[6344, 6744], [11, -51], [14, -13], [5, -21], [18, -25], [2, -24], [-3, -20], [4, -20], [8, -16], [4, -20], [4, -14]], [[6427, 6512], [5, -22]], [[6444, 6180], [-80, -23], [-26, -26], [-20, -62], [-13, -10], [-7, 20], [-11, -3], [-27, 6], [-5, 5], [-32, -1], [-7, -5], [-12, 15], [-7, -29], [3, -25], [-12, -19]], [[5943, 5617], [-4, 1], [0, 29], [-3, 20], [-14, 24], [-4, 42], [4, 44], [-13, 4], [-2, -13], [-17, -3], [7, -17], [2, -36], [-15, -32], [-14, -43], [-14, -6], [-23, 34], [-11, -12], [-3, -17], [-14, -11], [-1, -12], [-28, 0], [-3, 12], [-20, 2], [-10, -10], [-8, 5], [-14, 34], [-5, 17], [-20, -9], [-8, -27], [-7, -53], [-10, -11], [-8, -6]], [[5663, 5567], [-2, 2]], [[5635, 5716], [0, 14], [-10, 17], [-1, 35], [-5, 23], [-10, -4], [3, 22], [7, 25], [-3, 24], [9, 18], [-6, 14], [7, 36], [13, 44], [24, -4], [-1, 234]], [[6023, 6357], [9, -58], [-6, -10], [4, -61], [11, -71], [10, -14], [15, -22]], [[5943, 5624], [0, -7]], [[5943, 5617], [0, -46]], [[5944, 5309], [-17, -28], [-20, 1], [-22, -14], [-18, 13], [-11, -16]], [[5682, 5544], [-19, 23]], [[4535, 5861], [-11, 46], [-14, 21], [12, 11], [14, 41], [6, 31]], [[4536, 5789], [-4, 45]], [[9502, 4438], [8, -20], [-19, 0], [-11, 37], [17, -15], [5, -2]], [[9467, 4474], [-11, -1], [-17, 6], [-5, 9], [1, 23], [19, -9], [9, -12], [4, -16]], [[9490, 4490], [-4, -11], [-21, 52], [-5, 35], [9, 0], [10, -47], [11, -29]], [[9440, 4565], [1, -12], [-22, 25], [-15, 21], [-10, 20], [4, 6], [13, -14], [23, -27], [6, -19]], [[9375, 4623], [-5, -3], [-13, 14], [-11, 24], [1, 10], [17, -25], [11, -20]], [[4682, 5458], [-8, 5], [-20, 24], [-14, 31], [-5, 22], [-3, 43]], [[2561, 5848], [-3, -14], [-16, 1], [-10, 6], [-12, 12], [-15, 3], [-8, 13]], [[6198, 5735], [9, -11], [5, -25], [13, -24], [14, -1], [26, 16], [30, 7], [25, 18], [13, 4], [10, 11], [16, 2]], [[6359, 5732], [0, -1], [0, -25], [0, -59], [0, -31], [-13, -36], [-19, -50]], [[6359, 5732], [9, 1], [13, 9], [14, 6], [14, 20], [10, 0], [1, -16], [-3, -35], [0, -31], [-6, -21], [-7, -64], [-14, -66], [-17, -75], [-24, -87], [-23, -66], [-33, -81], [-28, -48], [-42, -58], [-25, -45], [-31, -72], [-6, -31], [-6, -14]], [[3412, 5410], [34, -11], [2, 10], [23, 4], [30, -15]], [[3489, 5306], [10, -35], [-4, -25]], [[5626, 7957], [-8, -15], [-5, -24]], [[5380, 7746], [7, 5]], [[5663, 8957], [-47, -17], [-27, -41], [4, -36], [-44, -48], [-54, -50], [-20, -84], [20, -41], [26, -33], [-25, -67], [-29, -14], [-11, -99], [-15, -55], [-34, 6], [-16, -47], [-32, -3], [-9, 56], [-23, 67], [-21, 84]], [[5890, 3478], [-5, -26], [-17, -6], [-16, 32], [0, 20], [7, 22], [3, 17], [8, 5], [14, -11]], [[5999, 7104], [-2, 45], [7, 25]], [[6004, 7174], [7, 13], [7, 13], [2, 33], [9, -12], [31, 17], [14, -12], [23, 1], [32, 22], [15, -1], [32, 9]], [[5051, 5420], [-22, -12]], [[7849, 5777], [-25, 28], [-24, -2], [4, 47], [-24, 0], [-2, -65], [-15, -87], [-10, -52], [2, -43], [18, -2], [12, -53], [5, -52], [15, -33], [17, -7], [14, -31]], [[7779, 5439], [-11, 23], [-4, 29], [-15, 34], [-14, 28], [-4, -35], [-5, 33], [3, 37], [8, 56]], [[6883, 7252], [16, 60], [-6, 44], [-20, 14], [7, 26], [23, -3], [13, 33], [9, 38], [37, 13], [-6, -27], [4, -17], [12, 2]], [[6497, 7255], [-5, 42], [4, 62], [-22, 20], [8, 40], [-19, 4], [6, 49], [26, -14], [25, 19], [-20, 35], [-8, 34], [-23, -15], [-3, -43], [-8, 38]], [[6554, 7498], [31, 1], [-4, 29], [24, 21], [23, 34], [37, -31], [3, -47], [11, -12], [30, 2], [9, -10], [14, -61], [32, -41], [18, -28], [29, -29], [37, -25], [-1, -36]], [[8471, 4532], [3, 14], [24, 13], [19, 2], [9, 8], [10, -8], [-10, -16], [-29, -25], [-23, -17]], [[3286, 5693], [16, 8], [6, -2], [-1, -44], [-23, -7], [-5, 6], [8, 16], [-1, 23]], [[5233, 7240], [31, 24], [19, -7], [-1, -30], [24, 22], [2, -12], [-14, -29], [0, -27], [9, -15], [-3, -51], [-19, -29], [6, -33], [14, -1], [7, -28], [11, -9]], [[6004, 7174], [-11, 27], [11, 22], [-17, -5], [-23, 13], [-19, -34], [-43, -6], [-22, 31], [-30, 2], [-6, -24], [-20, -7], [-26, 31], [-31, -1], [-16, 59], [-21, 33], [14, 46], [-18, 28], [31, 56], [43, 3], [12, 45], [53, -8], [33, 38], [32, 17], [46, 1], [49, -42], [40, -22], [32, 9], [24, -6], [33, 31]], [[5777, 7539], [3, -23], [25, -19], [-5, -14], [-33, -3], [-12, -19], [-23, -31], [-9, 27], [0, 12]], [[8382, 6499], [-17, -95], [-12, -49], [-14, 50], [-4, 44], [17, 58], [22, 45], [13, -18], [-5, -35]], [[6088, 4781], [-12, -73], [1, -33], [18, -22], [1, -15], [-8, -36], [2, -18], [-2, -28], [10, -37], [11, -58], [10, -13]], [[5909, 4512], [-15, 18], [-18, 10], [-11, 10], [-12, 15]], [[5844, 4990], [10, 8], [31, -1], [56, 4]], [[6061, 7840], [-22, -5], [-18, -19], [-26, -3], [-24, -22], [1, -37], [14, -14], [28, 4], [-5, -21], [-31, -11], [-37, -34], [-16, 12], [6, 28], [-30, 17], [5, 12], [26, 19], [-8, 14], [-43, 15], [-2, 22], [-25, -8], [-11, -32], [-21, -44]], [[3517, 3063], [-12, -38], [-31, -32], [-21, 11], [-15, -6], [-26, 25], [-18, -1], [-17, 32]], [[679, 6185], [-4, -10], [-7, 8], [1, 17], [-4, 21], [1, 7], [5, 10], [-2, 11], [1, 6], [3, -1], [10, -10], [5, -5], [5, -8], [7, -21], [-1, -3], [-11, -13], [-9, -9]], [[664, 6277], [-9, -4], [-5, 12], [-3, 5], [0, 4], [3, 5], [9, -6], [8, -9], [-3, -7]], [[646, 6309], [-1, -7], [-15, 2], [2, 7], [14, -2]], [[621, 6317], [-2, -3], [-2, 1], [-9, 2], [-4, 13], [-1, 2], [7, 8], [3, -3], [8, -20]], [[574, 6356], [-4, -6], [-9, 11], [1, 4], [5, 6], [6, -1], [1, -14]], [[3135, 7724], [5, -19], [-30, -29], [-29, -20], [-29, -18], [-15, -35], [-4, -13], [-1, -31], [10, -32], [11, -1], [-3, 21], [8, -13], [-2, -17], [-19, -9], [-13, 1], [-20, -10], [-12, -3], [-17, -3], [-23, -17], [41, 11], [8, -11], [-39, -18], [-17, 0], [0, 7], [-8, -16], [8, -3], [-6, -43], [-20, -45], [-2, 15], [-6, 3], [-9, 15], [5, -32], [7, -10], [1, -23], [-9, -23], [-16, -47], [-2, 3], [8, 40], [-14, 22], [-3, 49], [-5, -25], [5, -38], [-18, 10], [19, -19], [1, -57], [8, -4], [3, -20], [4, -59], [-17, -44], [-29, -18], [-18, -34], [-14, -4], [-14, -22], [-4, -20], [-31, -38], [-16, -28], [-13, -35], [-4, -42], [5, -41], [9, -51], [13, -41], [0, -26], [13, -69], [-1, -39], [-1, -23], [-7, -36], [-8, -8], [-14, 7], [-4, 26], [-11, 14], [-15, 51], [-13, 45], [-4, 23], [6, 39], [-8, 33], [-22, 49], [-10, 9], [-28, -27], [-5, 3], [-14, 28], [-17, 14], [-32, -7], [-24, 7], [-21, -5], [-12, -9], [5, -15], [0, -24], [5, -12], [-5, -8], [-10, 9], [-11, -11], [-20, 2], [-20, 31], [-25, -8], [-20, 14], [-17, -4], [-24, -14], [-25, -44], [-27, -25], [-16, -28], [-6, -27], [0, -41], [1, -28], [5, -20]], [[1746, 6980], [-4, 30], [-18, 34], [-13, 7], [-3, 17], [-16, 3], [-10, 16], [-26, 6], [-7, 9], [-3, 32], [-27, 60], [-23, 82], [1, 14], [-13, 19], [-21, 50], [-4, 48], [-15, 32], [6, 49], [-1, 51], [-8, 45], [10, 56], [4, 53], [3, 54], [-5, 79], [-9, 51], [-8, 27], [4, 12], [40, -20], [15, -56], [7, 15], [-5, 49], [-9, 48]], [[750, 8432], [-28, -23], [-14, 15], [-4, 28], [25, 21], [15, 9], [18, -4], [12, -18], [-24, -28]], [[401, 8597], [-18, -9], [-18, 11], [-17, 16], [28, 10], [22, -6], [3, -22]], [[230, 8826], [17, -12], [17, 6], [23, -15], [27, -8], [-2, -7], [-21, -12], [-21, 13], [-11, 11], [-24, -4], [-7, 5], [2, 23]], [[1374, 8295], [-15, 22], [-25, 19], [-8, 52], [-36, 47], [-15, 56], [-26, 4], [-44, 2], [-33, 17], [-57, 61], [-27, 11], [-49, 21], [-38, -5], [-55, 27], [-33, 25], [-30, -12], [5, -41], [-15, -4], [-32, -12], [-25, -20], [-30, -13], [-4, 35], [12, 58], [30, 18], [-8, 15], [-35, -33], [-19, -39], [-40, -42], [20, -29], [-26, -42], [-30, -25], [-28, -18], [-7, -26], [-43, -31], [-9, -28], [-32, -25], [-20, 5], [-25, -17], [-29, -20], [-23, -20], [-47, -16], [-5, 9], [31, 28], [27, 18], [29, 33], [35, 6], [14, 25], [38, 35], [6, 12], [21, 21], [5, 44], [14, 35], [-32, -18], [-9, 11], [-15, -22], [-18, 30], [-8, -21], [-10, 29], [-28, -23], [-17, 0], [-3, 35], [5, 21], [-17, 22], [-37, -12], [-23, 28], [-19, 14], [0, 34], [-22, 25], [11, 34], [23, 33], [10, 30], [22, 4], [19, -9], [23, 28], [20, -5], [21, 19], [-5, 27], [-16, 10], [21, 23], [-17, -1], [-30, -13], [-8, -13], [-22, 13], [-39, -6], [-41, 14], [-12, 24], [-35, 34], [39, 25], [62, 29], [23, 0], [-4, -30], [59, 2], [-23, 37], [-34, 23], [-20, 29], [-26, 25], [-38, 19], [15, 31], [49, 2], [35, 27], [7, 29], [28, 28], [28, 6], [52, 27], [26, -4], [42, 31], [42, -12], [21, -27], [12, 11], [47, -3], [-2, -14], [43, -10], [28, 6], [59, -18], [53, -6], [21, -8], [37, 10], [42, -18], [31, -8]], [[3018, 5753], [-1, -14], [-16, -7], [9, -26], [0, -31], [-12, -35], [10, -47], [12, 4], [6, 43], [-8, 21], [-2, 45], [35, 24], [-4, 27], [10, 19], [10, -41], [19, -1], [18, -33], [1, -20], [25, 0], [30, 6], [16, -27], [21, -7], [16, 18], [0, 15], [34, 4], [34, 1], [-24, -18], [10, -28], [22, -4], [21, -29], [4, -48], [15, 2], [11, -14]], [[8001, 6331], [-37, -51], [-24, -56], [-6, -41], [22, -62], [25, -77], [26, -37], [17, -47], [12, -109], [-3, -104], [-24, -39], [-31, -38], [-23, -49], [-35, -55], [-10, 37], [8, 40], [-21, 34]], [[9661, 4085], [-9, -8], [-9, 26], [1, 16], [17, -34]], [[9641, 4175], [4, -47], [-7, 7], [-6, -3], [-4, 16], [0, 45], [13, -18]], [[6475, 6041], [-21, -16], [-5, -26], [-1, -20], [-27, -25], [-45, -28], [-24, -41], [-13, -3], [-8, 3], [-16, -25], [-18, -11], [-23, -3], [-7, -3], [-6, -16], [-8, -4], [-4, -15], [-14, 1], [-9, -8], [-19, 3], [-7, 35], [1, 32], [-5, 17], [-5, 44], [-8, 24], [5, 3], [-2, 27], [3, 12], [-1, 25]], [[5817, 3752], [11, 0], [14, -10], [9, 7], [15, -6]], [[5911, 3478], [-7, -43], [-3, -49], [-7, -27], [-19, -30], [-5, -8], [-12, -30], [-8, -31], [-16, -42], [-31, -61], [-20, -36], [-21, -26], [-29, -23], [-14, -3], [-3, -17], [-17, 9], [-14, -11], [-30, 11], [-17, -7], [-12, 3], [-28, -23], [-24, -10], [-17, -22], [-13, -1], [-11, 21], [-10, 1], [-12, 26], [-1, -8], [-4, 16], [0, 34], [-9, 40], [9, 11], [0, 45], [-19, 55], [-14, 50], [0, 1], [-20, 76]], [[5840, 4141], [-21, -8], [-15, -23], [-4, -21], [-10, -4], [-24, -49], [-15, -38], [-10, -2], [-9, 7], [-31, 7]]],
  transform: {
    scale: [0.036003600360036005, 0.016927109510951093],
    translate: [-180, -85.609038]
  }
};
;// ./src/js/viz/d3/maps/world/world_map.js





var world_map_DEFAULT_GEO_SCALE = 150;
var world_map_DEFAULT_GEO_WIDTH = 960;
var world_map_DEFAULT_GEO_HEIGHT = 960;
var DEFAULT_PRECISION = 0.1;
var WorldMap = BaseMap.extend({
  projection: external_d3_default().geo.mercator().precision(DEFAULT_PRECISION),
  configureMapViz: function configureMapViz(mapViz) {
    var adjustedWidth = world_map_DEFAULT_GEO_SCALE / world_map_DEFAULT_GEO_WIDTH * this.availableWidth;
    var adjustedHeight = world_map_DEFAULT_GEO_SCALE / world_map_DEFAULT_GEO_HEIGHT * this.availableHeight;
    var scale = this.scale || external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().min([adjustedWidth, adjustedHeight]);
    mapViz.projection(this.projection).topology(topology_topology).object(topology_topology.objects.world).getLabelFormat((external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default()).noop).scale(scale);
  },
  getLocations: function getLocations() {
    this.locations = this.locations || external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().map(topology_topology.objects.world.geometries, function (geo) {
      return {
        id: geo.id,
        name: geo.properties.name
      };
    });
    return this.locations;
  }
}, {
  Name: 'WorldMap',
  DataDimensions: '1'
});
;// ./src/js/viz/d3/components/funnel.js








function funnel_slicedToArray(r, e) { return funnel_arrayWithHoles(r) || funnel_iterableToArrayLimit(r, e) || funnel_unsupportedIterableToArray(r, e) || funnel_nonIterableRest(); }
function funnel_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function funnel_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return funnel_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? funnel_arrayLikeToArray(r, a) : void 0; } }
function funnel_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function funnel_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function funnel_arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var Funnel = function Funnel() {
  var config = {
    width: 400,
    height: 400,
    colorScheme: external_d3_default().scale.category10(),
    disableInteraction: false,
    showDataValue: true,
    labelPadding: 2.5,
    valueFormat: '.1%',
    generateTooltip: function generateTooltip(evt) {
      var d = evt.d || {};
      if (d.tooltip) {
        return d.tooltip;
      }
      return '<div class="dark-dialog">' + (d.properties || {}).name + '</div>';
    },
    tooltip: true,
    shouldUseRatios: true,
    ratioColor: constants_Constants.NUMBER_DEFAULT,
    positiveDropoffColor: constants_Constants.NUMBER_DEFAULT,
    negativeDropoffColor: constants_Constants.NUMBER_DEFAULT,
    infinityColor: 'black',
    arrowColor: '#a6a6a6',
    arrowWidth: 5,
    arrowHeight: 6,
    arrowPadding: 5,
    arrowInsertion: 10,
    minBlockHeight: 40,
    widthToHeightRatio: 1.5
  };
  var lifeCycle = new RenderLifeCycle();
  var tooltip = nvTooltip();
  var dispatch = external_d3_default().dispatch('elementClick', 'elementMouseover', 'elementMouseout');
  var funnel = function funnel(selection) {
    lifeCycle.start();
    if (funnel_isFunction(config.generateTooltip)) {
      tooltip.contentGenerator(config.generateTooltip);
    }
    var baseFormatter = external_d3_default().format(config.valueFormat);
    var formatValue = function formatValue(value, customFormatter) {
      var formatter = funnel_isFunction(customFormatter) ? customFormatter : baseFormatter;
      return formatter(value);
    };
    selection.each(function (data) {
      var _this = this;
      var _data = funnel_slicedToArray(data, 2),
        primaryData = _data[0],
        annotationData = _data[1];
      var container = external_d3_default().select(this),
        funnelContainer = utils_createElementIfAbsent(container, FUNNEL_CONTAINER),
        blocksContainer = utils_createElementIfAbsent(funnelContainer, BLOCK_CONTAINER),
        labelContainer = utils_createElementIfAbsent(funnelContainer, funnel_LABEL_CONTAINER),
        valueContainer = utils_createElementIfAbsent(funnelContainer, VALUE_CONTAINER),
        arrowContainer = utils_createElementIfAbsent(funnelContainer, ARROW_CONTAINER),
        deltaContainer = utils_createElementIfAbsent(funnelContainer, DELTA_CONTAINER),
        annotationContainer = utils_createElementIfAbsent(funnelContainer, ANNOTATION_CONTAINER);
      var calculatedChartWidth = config.width;
      if (annotationData && annotationData.values.length) {
        var _annotationData$value = funnel_slicedToArray(annotationData.values, 1),
          topAnnotationsValue = _annotationData$value[0];
        var annotationsPadding = estimateWidthFromSize(constants_Constants.FONT_SIZE, formatValue(topAnnotationsValue.y, topAnnotationsValue.format));
        calculatedChartWidth -= 2 * annotationsPadding;
      }
      var _getChartDimensions = getChartDimensions(calculatedChartWidth, config.height, config.minBlockHeight * primaryData.values.length, config.widthToHeightRatio),
        chartWidth = _getChartDimensions.chartWidth,
        chartHeight = _getChartDimensions.chartHeight;
      funnelContainer.attr('width', chartWidth).attr('height', chartHeight).attr('transform', funnel_getContainerTransform(config.width, config.height, chartWidth, chartHeight)).classed('interactive', !config.disableInteraction);
      var paths = blocksContainer.selectAll('path').data(primaryData.values);
      paths.enter().append('path').attr('fill', function (d, i) {
        return getBlockColor(config.colorScheme, d, i);
      });
      paths.exit().remove();
      paths.attr('fill', function (d, i) {
        return getBlockColor(config.colorScheme, d, i);
      }).attr('d', function (d, i) {
        return createBlockPath(chartWidth, chartHeight, primaryData.values.length, i);
      });
      if (annotationData) {
        var annotations = annotationContainer.selectAll('text').data(annotationData.values);
        annotations.enter().append('text').attr('class', 'text smart-labels sign').style('opacity', 0);
        annotations.exit().remove();
        annotations.text(function (d) {
          if (d.y > 0) {
            return '+\t';
          } else if (d.y < 0) {
            return '-\t';
          }
          return '\t\t';
        }).style('fill', function (d) {
          return d.y >= 0 ? '#007BD0' : '#EC4E2B';
        }).style('font-weight', 600);
        annotations.append('tspan').attr('class', 'text smart-labels value').text(function (d) {
          return formatValue(d.y * (d.y >= 0 ? 1 : -1), d.format);
        }).style('font-weight', 'normal');
        annotations.style('text-anchor', 'middle').style('opacity', 1).attr('transform', function (d, i) {
          var bounded = getAnnotationTransformation.bind(_this);
          return bounded(chartWidth, chartHeight, annotationData.values.length, i);
        });
      } else {
        annotationContainer.remove();
      }
      var labels = labelContainer.selectAll('text').data(primaryData.values);
      labels.enter().append('text').attr('class', 'labels smart-labels').style('opacity', 0);
      labels.exit().remove();
      labels.text(function (d) {
        return d.label;
      }).each(function (d, i) {
        var labelPadding = config.arrowInsertion + config.arrowPadding;
        var bounded = checkLabelWidth.bind(this);
        bounded(chartWidth, chartHeight, primaryData.values.length, labelPadding, i);
      }).classed('light-label-color', function (d, i) {
        return funnel_hasLightLabelColor(config.colorScheme, d, i);
      });
      labels.style('text-anchor', 'middle').style('opacity', 1).style('font-weight', 'bold').attr('transform', function (d, i) {
        var bounded = getLabelTransform.bind(this);
        return bounded(chartWidth, chartHeight, primaryData.values.length, config.labelPadding, i);
      });
      var interactiveContainers = [paths, labels];
      if (config.showDataValue) {
        var values = valueContainer.selectAll('text').data(primaryData.values);
        interactiveContainers.push(values);
        values.enter().append('text').attr('class', 'labels smart-labels').style('opacity', 0);
        values.exit().remove();
        values.text(function (d) {
          return formatValue(d.y, d.format);
        }).classed('light-label-color', function (d, i) {
          return funnel_hasLightLabelColor(config.colorScheme, d, i);
        });
        values.style('text-anchor', 'middle').style('opacity', 1).style('font-weight', 'bold').attr('transform', function (d, i) {
          var bounded = getValueTransform.bind(this);
          return bounded(chartWidth, chartHeight, primaryData.values.length, config.labelPadding, i);
        });
      } else {
        valueContainer.remove();
      }
      if (!config.disableInteraction) {
        interactiveContainers.forEach(function (interactiveContainer) {
          var colors = [];
          paths.each(function () {
            colors.push(external_d3_default().select(this).style('fill'));
          });
          interactiveContainer.on('mouseover', function (d, i) {
            var keyValue = d.label;
            var tooltipData = {
              series: {
                key: keyValue,
                value: formatValue(d.y, d.format),
                color: colors[i]
              },
              index: i,
              data: d.y,
              color: colors[i]
            };
            tooltip.data(tooltipData).hidden(!config.tooltip);
            dispatch.elementMouseover({
              data: formatValue(d.y, d.format),
              index: i,
              color: colors[i]
            });
          }).on('mouseout', function (d, i) {
            tooltip.hidden(true);
            dispatch.elementMouseout({
              data: formatValue(d.y, d.format),
              index: i,
              color: colors[i]
            });
          }).on('mousemove', function () {
            tooltip();
          });
        });
      }
      var deltaValues = calculateDeltas(primaryData.values, config);
      var arrows = arrowContainer.selectAll('path').data(deltaValues);
      arrows.enter().append('path').attr('fill', 'none').attr('stroke', config.arrowColor).attr('stroke-width', 2.5);
      arrows.exit().remove();
      arrows.attr('d', function (d, i) {
        return createArrowPath(chartWidth, chartHeight, primaryData.values.length, config, i);
      });
      var deltas = deltaContainer.selectAll('text').data(deltaValues);
      deltas.enter().append('text').attr('class', 'labels smart-labels').style('opacity', 0);
      deltas.exit().remove();
      deltas.text(function (d) {
        return d.value;
      }).style('fill', function (d) {
        return d.color;
      });
      deltas.style('text-anchor', 'end').style('opacity', 1).attr('transform', function (d, i) {
        return getDeltaTransform(chartWidth, chartHeight, primaryData.values.length, i);
      });
    });
    lifeCycle.dispatchOnCompletion();
  };
  funnel.dispatch = dispatch;
  exposeConfig(funnel, config);
  funnel.lifeCycle = lifeCycle.dispatch;
  return funnel;
};
var FUNNEL_CONTAINER = 'funnelContainer';
var BLOCK_CONTAINER = 'blockContainer';
var funnel_LABEL_CONTAINER = 'labelContainer';
var VALUE_CONTAINER = 'valueContainer';
var ARROW_CONTAINER = 'arrowContainer';
var DELTA_CONTAINER = 'deltaContainer';
var ANNOTATION_CONTAINER = 'annotationContainer';
function checkLabelWidth(width, height, blocks, paddingLeft, i) {
  var dx = getFunnelSlope(width, height, blocks).dx;
  var availableLeftWidth = width / 2 - dx * (i + 0.25) - paddingLeft;
  var self = external_d3_default().select(this);
  var textLength = self.node().getComputedTextLength(),
    text = self.text();
  while (textLength / 2 > availableLeftWidth) {
    if (text.length > 1) {
      text = text.slice(0, -1);
    } else {
      break;
    }
    self.text(text + ' ...');
    textLength = self.node().getComputedTextLength();
  }
}
function getChartDimensions(availableWidth, availableHeight, minHeight, widthToHeightRatio) {
  availableWidth = Math.max(availableWidth, minHeight * widthToHeightRatio);
  availableHeight = Math.max(availableHeight, minHeight);
  var height = availableHeight;
  var width = Math.min(availableWidth, widthToHeightRatio * height);
  height = width / widthToHeightRatio;
  return {
    chartWidth: width,
    chartHeight: height
  };
}
function getFunnelSlope(width, height, blocks) {
  return {
    dx: width / (blocks * 2),
    dy: height / blocks
  };
}
function formatTransform(x, y) {
  return 'translate(' + x + ', ' + y + ')';
}
function funnel_getContainerTransform(availableWidth, availableHeight, width, height) {
  var x = availableWidth / 2 - width / 2;
  var y = availableHeight / 2 - height / 2;
  return formatTransform(x, y);
}
function getLabelTransform(width, height, blocks, padding, i) {
  var dy = getFunnelSlope(width, height, blocks).dy;
  var textHeight = this.getBBox().height;
  var x = width / 2;
  var y = i * dy + textHeight + padding;
  return formatTransform(x, y);
}
function getValueTransform(width, height, blocks, padding, i) {
  var dy = getFunnelSlope(width, height, blocks).dy;
  var textHeight = this.getBBox().height;
  var x = width / 2;
  var y = i * dy + 2 * (textHeight + padding);
  return formatTransform(x, y);
}
function getBlockColor(fallbackColorScheme, dataPoint, i) {
  return dataPoint.color || fallbackColorScheme(dataPoint, i);
}
function funnel_hasLightLabelColor(colorScheme, dataPoint, i) {
  var blockColor = getBlockColor(colorScheme, dataPoint, i);
  return isDarkColor(blockColor);
}
function createBlockPath(width, height, blocks, i) {
  var _getFunnelSlope = getFunnelSlope(width, height, blocks),
    dx = _getFunnelSlope.dx,
    dy = _getFunnelSlope.dy;
  var directions = [];
  directions.push({
    type: constants_Constants.SVG_PATH_MOVE_COMMAND,
    x: i * dx,
    y: i * dy
  });
  directions.push({
    type: constants_Constants.SVG_PATH_LINE_COMMAND,
    x: width - i * dx,
    y: i * dy
  });
  directions.push({
    type: constants_Constants.SVG_PATH_LINE_COMMAND,
    x: width - (i + 1) * dx,
    y: (i + 1) * dy
  });
  if (i !== blocks - 1) {
    directions.push({
      type: constants_Constants.SVG_PATH_LINE_COMMAND,
      x: (i + 1) * dx,
      y: (i + 1) * dy
    });
  }
  directions.push({
    type: constants_Constants.SVG_PATH_CLOSE_COMMAND
  });
  return createSVGFromDirections(directions);
}
function calculateDeltas(values, config) {
  var deltas = [];
  for (var i = 0; i < values.length - 1; i++) {
    var deltaValue = void 0,
      delta = void 0,
      color = void 0;
    if (values[i].y === 0) {
      delta = 'N/A';
      color = config.shouldUseRatios ? config.ratioColor : config.infinityColor;
    } else {
      if (config.shouldUseRatios) {
        deltaValue = Math.round(values[i + 1].y / values[i].y * 100);
      } else {
        deltaValue = Math.round((values[i + 1].y - values[i].y) / values[i].y * 100);
      }
      if (!config.shouldUseRatios && deltaValue > 0) {
        delta = "+".concat(deltaValue, "%");
        color = config.positiveDropoffColor;
      } else {
        delta = "".concat(deltaValue, "%");
        color = config.shouldUseRatios ? config.ratioColor : config.negativeDropoffColor;
      }
    }
    deltas.push({
      value: delta,
      color: color
    });
  }
  return deltas;
}
function createArrowPath(width, height, blocks, config, i) {
  var _getFunnelSlope2 = getFunnelSlope(width, height, blocks),
    dx = _getFunnelSlope2.dx,
    dy = _getFunnelSlope2.dy;
  var directions = [];
  var start = {
    x: (i + 0.75) * dx,
    y: (i + 0.75) * dy
  };
  directions.push({
    type: constants_Constants.SVG_PATH_MOVE_COMMAND,
    x: start.x,
    y: start.y
  });
  var control = {
    x: (i + 0.75) * dx,
    y: (i + 1.25) * dy
  };
  var end = {
    x: (i + 1.25) * dx + config.arrowInsertion,
    y: (i + 1.25) * dy
  };
  directions.push({
    type: constants_Constants.SVG_PATH_BEZIER_COMMAND,
    x: end.x,
    y: end.y,
    x1: control.x,
    y1: control.y
  });
  directions.push({
    type: constants_Constants.SVG_PATH_MOVE_COMMAND,
    x: end.x - config.arrowWidth,
    y: end.y - config.arrowHeight / 2
  });
  directions.push({
    type: constants_Constants.SVG_PATH_LINE_COMMAND,
    x: end.x,
    y: end.y
  });
  directions.push({
    type: constants_Constants.SVG_PATH_LINE_COMMAND,
    x: end.x - config.arrowWidth,
    y: end.y + config.arrowHeight / 2
  });
  return createSVGFromDirections(directions);
}
function getDeltaTransform(width, height, blocks, i) {
  var _getFunnelSlope3 = getFunnelSlope(width, height, blocks),
    dx = _getFunnelSlope3.dx,
    dy = _getFunnelSlope3.dy;
  var x = (i + 0.75) * dx;
  var y = (i + 1.25) * dy;
  return formatTransform(x, y);
}
function getAnnotationTransformation(width, height, blocks, i) {
  var _getFunnelSlope4 = getFunnelSlope(width, height, blocks),
    dx = _getFunnelSlope4.dx,
    dy = _getFunnelSlope4.dy;
  var x = i * -dx + width;
  var y = i * dy + height / (blocks * 1.75);
  return formatTransform(x, y);
}
function funnel_isFunction(input) {
  return typeof input === 'function';
}
;// ./src/js/viz/d3/charts/funnel_chart.js












var FunnelChartConfig = Object.assign({}, MarginConfig, ColorSchemeConfig, TooltipConfig, EventConfig, InteractionConfig, {
  _shouldUseRatios: true,
  _showDataValues: true,
  _valueFormat: '.1%',
  setValueFormat: function setValueFormat(format) {
    this._valueFormat = format;
    return this;
  },
  shouldUseRatios: function shouldUseRatios(use) {
    this._shouldUseRatios = use;
    return this;
  },
  shouldShowDataValues: function shouldShowDataValues(show) {
    this._showDataValues = show;
    return this;
  },
  setData: function setData(data) {
    var hasValidData = data && data[0] && data[0].values && data[0].values.length > 0;
    this.data = hasValidData ? _.cloneDeep(data) : undefined;
    return this;
  }
});
var FunnelChart = Core.extend(FunnelChartConfig).extend({
  initialize: function initialize() {
    this.colorScheme = baseColorScheme();
    this.layout = new ChartLayout();
    return Core.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.createAndConfigureFunnel();
    if (typeof postRender === 'function') {
      this.funnel.lifeCycle.on('renderEnd', postRender);
    }
    this.layout.renderHostedComponents({
      containerDimensions: this.getContainerDimensions(),
      container: this.getContainer(),
      margin: this._margin
    });
    return this;
  },
  createAndConfigureFunnel: function createAndConfigureFunnel() {
    if (!this.funnel) {
      this.funnel = Funnel();
    }
    this.funnel.width(this.getContainerWidth()).height(this.getContainerHeight()).generateTooltip(this.tooltip).tooltip(this._showTooltip).showDataValue(this._showDataValues).shouldUseRatios(this._shouldUseRatios).disableInteraction(this._disableInteraction).valueFormat(this._valueFormat);
    this.configureEventListeners();
    if (typeof this.colorScheme === 'function') {
      this.funnel.colorScheme(this.colorScheme);
    }
    this.layout.host('chart', this.funnel, this.data);
    return this.funnel;
  },
  configureEventListeners: function configureEventListeners() {
    for (var event in this._eventHandlers) {
      if (this.funnel.dispatch.hasOwnProperty(event)) {
        this.funnel.dispatch.on(event, this._eventHandlers[event]);
      }
    }
  }
}, {
  Name: 'FunnelChart',
  DataDimensions: '2'
});
;// ./src/js/viz/d3/components/radar.js





var RADAR_CONTAINER = 'radar';
var AXIS_WRAPPER = 'axisWrapper';
var RADAR_WRAPPER = 'radarWrapper';
var RADAR_AREA = 'radarArea';
var RADAR_CIRCLE = 'radarCircle';
var RADAR_CIRCLE_WRAPPER = 'radarCircleWrapper';
var GRID_CIRCLE = 'gridCircle';
var AXIS_LABEL = 'axisLabel';
var AXIS = 'axis';
var GRID_COLOR = '#CDCDCD';
var GRID_TEXT_COLOR = '#737373';
var DOT_RADIUS = 4;
var ON_HOVER_RADAR_AREA_OPACITY = 0.7;
var WRAPPER_LABEL_RADIUS_FACTOR = 0.6;
function removeAllElements(container, elementClass) {
  container.selectAll(".".concat(elementClass)).remove();
}
function radar_getContainerTransform(width, height) {
  return "translate(".concat(width / 2, ", ").concat(height / 2, ")");
}
var Radar = function Radar() {
  var config = {
    width: 400,
    height: 400,
    seriesLabel: [],
    colorScheme: external_d3_default().scale.category10(),
    animationDuration: 400,
    axisMin: 0,
    axisMax: 10,
    gridCircleMargin: 2,
    valueFormat: '',
    radarAreaOpacity: 0.2,
    strokeWidth: 2,
    axisFactor: 1.02,
    labelFactor: 1.25,
    labelFactorVertical: 0.95,
    labelFactorHorizontal: 1.05,
    angleFactor: Math.PI / 50,
    disableInteraction: false,
    generateTooltip: function generateTooltip(evt) {
      var d = evt.d || {};
      if (d.tooltip) {
        return d.tooltip;
      }
      return "<div class=\"dark-dialog\">".concat((d.properties || {}).name, "</div>");
    },
    tooltip: nvTooltip()
  };
  var lifeCycle = new RenderLifeCycle();
  var radar = function radar(selection) {
    lifeCycle.start();
    if (config.tooltip && _.isFunction(config.generateTooltip)) {
      config.tooltip.contentGenerator(config.generateTooltip);
    }
    selection.each(function (data) {
      var container = external_d3_default().select(this);
      var radarContainer = utils_createElementIfAbsent(container, RADAR_CONTAINER);
      var size = Math.min(config.width, config.height);
      var allAxis = (data[0] || []).map(function (i) {
        return i.axis;
      });
      var total = allAxis.length;
      var radius = size / (2 * Math.max(config.labelFactor, config.axisFactor));
      var valueFormatFunction = external_d3_default().format(config.valueFormat);
      var angleSlice = Math.PI * 2 / total;
      var radiusScale = external_d3_default().scale.linear().domain([config.axisMin, config.axisMax]).range([0, radius]);
      if (!radarContainer.empty()) {
        removeAllElements(radarContainer, AXIS_WRAPPER);
        removeAllElements(radarContainer, RADAR_WRAPPER);
        removeAllElements(radarContainer, RADAR_CIRCLE_WRAPPER);
      }
      radarContainer.attr('width', size).attr('height', size).attr('transform', radar_getContainerTransform(config.width, config.height));
      var axisCirclesGrid = utils_createElementIfAbsent(radarContainer, AXIS_WRAPPER);
      var legendRange = external_d3_default().range(config.gridCircleMargin, config.axisMax + config.gridCircleMargin, config.gridCircleMargin);
      axisCirclesGrid.selectAll(".".concat(GRID_CIRCLE)).data(legendRange).enter().append('circle').attr('class', GRID_CIRCLE).attr('r', function (d) {
        return d * radius / config.axisMax;
      }).style('fill', 'none').style('stroke', GRID_COLOR);
      axisCirclesGrid.selectAll(".".concat(AXIS_LABEL)).data(legendRange).enter().append('text').attr('class', AXIS_LABEL).attr('x', 4).attr('y', function (d) {
        return -d * radius / config.axisMax;
      }).attr('dy', '0.4em').style('font-size', '10px').attr('fill', GRID_TEXT_COLOR).text(function (d) {
        return valueFormatFunction(d);
      });
      var axis = axisCirclesGrid.selectAll(".".concat(AXIS)).data(allAxis).enter().append('g').attr('class', AXIS);
      axis.append('line').attr('x1', 0).attr('y1', 0).attr('x2', function (d, i) {
        return radiusScale(config.axisMax) * config.axisFactor * Math.cos(angleSlice * i - Math.PI / 2);
      }).attr('y2', function (d, i) {
        return radiusScale(config.axisMax) * config.axisFactor * Math.sin(angleSlice * i - Math.PI / 2);
      }).attr('class', 'axisLine').style('fill', GRID_COLOR).style('stroke', GRID_COLOR).style('stroke-width', '1px');
      axis.append('text').attr('class', 'legend').style('font-size', '11px').attr('text-anchor', 'middle').attr('dy', '0.35em').attr('x', function (d, i) {
        var cosinus = Math.cos(angleSlice * i - Math.PI / 2);
        var labelFactor = config.labelFactor;
        if (Math.abs(Math.abs(cosinus) - 1) < config.angleFactor) {
          labelFactor = config.labelFactor * config.labelFactorHorizontal;
        }
        return radiusScale(config.axisMax) * labelFactor * cosinus;
      }).attr('y', function (d, i) {
        var sinus = Math.sin(angleSlice * i - Math.PI / 2);
        var labelFactor = config.labelFactor;
        if (Math.abs(Math.abs(sinus) - 1) < config.angleFactor) {
          labelFactor = config.labelFactor * config.labelFactorVertical;
        }
        return radiusScale(config.axisMax) * labelFactor * sinus;
      }).text(function (d) {
        return d;
      }).call(js_nv.utils.wrapTicks, radius * WRAPPER_LABEL_RADIUS_FACTOR, 2);
      var radarLine = external_d3_default().svg.line.radial().interpolate('cardinal-closed').radius(function (d) {
        return radiusScale(d.value);
      }).angle(function (d, i) {
        return i * angleSlice;
      });
      var radarWrapper = radarContainer.selectAll(".".concat(RADAR_WRAPPER)).data(data).enter().append('g').attr('class', RADAR_WRAPPER);
      var radarArea = radarWrapper.append('path').attr('class', RADAR_AREA).attr('d', function (d) {
        return radarLine(d);
      }).style('stroke-width', "".concat(config.strokeWidth, "px")).style('stroke', function (d, i) {
        return config.colorScheme(config.seriesLabel[i], i);
      }).style('fill', function (d, i) {
        return config.colorScheme(config.seriesLabel[i], i);
      }).style('fill-opacity', config.radarAreaOpacity);
      var radarDot = radarWrapper.selectAll(".".concat(RADAR_CIRCLE)).data(function (d) {
        return d;
      }).enter().append('circle').attr('class', RADAR_CIRCLE).attr('r', DOT_RADIUS).attr('cx', function (d, i) {
        return radiusScale(d.value) * Math.cos(angleSlice * i - Math.PI / 2);
      }).attr('cy', function (d, i) {
        return radiusScale(d.value) * Math.sin(angleSlice * i - Math.PI / 2);
      }).style('fill', function (d, i, j) {
        return config.colorScheme(config.seriesLabel[j], j);
      });
      if (!config.disableInteraction) {
        radarArea.on('mouseover', function () {
          external_d3_default().selectAll(".".concat(RADAR_AREA)).transition().duration(config.animationDuration).style('fill-opacity', 0.1);
          external_d3_default().select(this).transition().duration(config.animationDuration).style('fill-opacity', ON_HOVER_RADAR_AREA_OPACITY);
        }).on('mouseout', function () {
          external_d3_default().selectAll(".".concat(RADAR_AREA)).transition().duration(config.animationDuration).style('fill-opacity', config.radarAreaOpacity);
        });
        radarDot.on('mouseover', function (d, i, j) {
          var tooltipData = {
            series: {
              key: config.seriesLabel[j].label,
              value: d.value,
              color: external_d3_default().select(this).style('fill')
            }
          };
          config.tooltip.data(tooltipData).duration(config.animationDuration).hidden(false);
        }).on('mouseout', function () {
          config.tooltip.hidden(true);
        });
      }
      lifeCycle.dispatchOnCompletion();
    });
  };
  exposeConfig(radar, config);
  radar.lifeCycle = lifeCycle.dispatch;
  return radar;
};
;// ./src/js/viz/d3/charts/radar_chart.js







var RadarConfig = Object.assign({}, AxisChartConfig, {
  setSeriesLabel: function setSeriesLabel(seriesLabel) {
    this.seriesLabel = seriesLabel;
    return this;
  },
  setValueFormat: function setValueFormat(valueFormat) {
    this.valueFormat = valueFormat;
    return this;
  },
  setGridCircleMargin: function setGridCircleMargin(gridCircleMargin) {
    this.gridCircleMargin = gridCircleMargin;
    return this;
  },
  setRadarAreaOpacity: function setRadarAreaOpacity(radarAreaOpacity) {
    this.radarAreaOpacity = radarAreaOpacity;
    return this;
  }
});
var RadarChart = Core.extend(RadarConfig).extend({
  initialize: function initialize() {
    this.colorScheme = d3ColorScheme();
    this.layout = new ChartLayout();
    return Core.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.createAndConfigureRadar();
    this.createAndConfigureLegend();
    if (postRender) {
      this.radar.lifeCycle.on('renderEnd', postRender);
    }
    this.layout.renderHostedComponents({
      containerDimensions: this.getChartContainerDimensions(),
      animationDuration: this._animationDuration,
      container: this.getContainer()
    });
    return this;
  },
  createAndConfigureRadar: function createAndConfigureRadar() {
    this.radar || (this.radar = Radar());
    this.radar.axisMin(this._axisMin).axisMax(this._axisMax).gridCircleMargin(this.gridCircleMargin).valueFormat(this.valueFormat).seriesLabel(this.seriesLabel).disableInteraction(this._disableInteraction);
    if (_.isNumber(this.radarAreaOpacity)) {
      this.radar.radarAreaOpacity(this.radarAreaOpacity);
    }
    if (_.isNumber(this._animationDuration)) {
      this.radar.animationDuration(this._animationDuration);
    }
    this.addTooltip();
    this.colorScheme && this.radar.colorScheme(this.colorScheme);
    this.layout.host('chart', this.radar, this.getData());
    return this.radar;
  },
  createAndConfigureLegend: function createAndConfigureLegend() {
    this.legend = this.legend || dqLegend();
    this.legend.colorScheme(this.colorScheme).position(this._legendPosition).animationDuration(this._animationDuration).clickDisabled(this._disableInteraction).getKey(function (d) {
      return d.label;
    });
    if (this._shouldShowLegend) {
      this.layout.host('legend', this.legend, this.seriesLabel);
    } else {
      this.layout.remove('legend');
    }
  },
  addTooltip: function addTooltip() {
    var _this = this;
    this.radar.tooltip().enabled(this._showTooltip);
    if (this.tooltip) {
      if (_.isFunction(this.tooltip)) {
        this.radar.generateTooltip(this.tooltip);
      } else {
        this.radar.generateTooltip(function () {
          return _this.tooltip;
        });
      }
    } else {
      this.radar.tooltip().enabled(false);
    }
  },
  resize: function resize() {
    if (this.radar) {
      Core.prototype.resize.apply(this, arguments);
    }
  }
}, {
  Name: 'Radar',
  DataDimensions: '1'
});
;// ./src/js/viz/d3/components/word_cloud_viz.js















function word_cloud_viz_typeof(o) { "@babel/helpers - typeof"; return word_cloud_viz_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, word_cloud_viz_typeof(o); }
function word_cloud_viz_toConsumableArray(r) { return word_cloud_viz_arrayWithoutHoles(r) || word_cloud_viz_iterableToArray(r) || word_cloud_viz_unsupportedIterableToArray(r) || word_cloud_viz_nonIterableSpread(); }
function word_cloud_viz_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function word_cloud_viz_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function word_cloud_viz_arrayWithoutHoles(r) { if (Array.isArray(r)) return word_cloud_viz_arrayLikeToArray(r); }
function word_cloud_viz_slicedToArray(r, e) { return word_cloud_viz_arrayWithHoles(r) || word_cloud_viz_iterableToArrayLimit(r, e) || word_cloud_viz_unsupportedIterableToArray(r, e) || word_cloud_viz_nonIterableRest(); }
function word_cloud_viz_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function word_cloud_viz_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return word_cloud_viz_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? word_cloud_viz_arrayLikeToArray(r, a) : void 0; } }
function word_cloud_viz_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function word_cloud_viz_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function word_cloud_viz_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function word_cloud_viz_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function word_cloud_viz_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? word_cloud_viz_ownKeys(Object(t), !0).forEach(function (r) { word_cloud_viz_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : word_cloud_viz_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function word_cloud_viz_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function word_cloud_viz_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, word_cloud_viz_toPropertyKey(o.key), o); } }
function word_cloud_viz_createClass(e, r, t) { return r && word_cloud_viz_defineProperties(e.prototype, r), t && word_cloud_viz_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function word_cloud_viz_defineProperty(e, r, t) { return (r = word_cloud_viz_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function word_cloud_viz_toPropertyKey(t) { var i = word_cloud_viz_toPrimitive(t, "string"); return "symbol" == word_cloud_viz_typeof(i) ? i : i + ""; }
function word_cloud_viz_toPrimitive(t, r) { if ("object" != word_cloud_viz_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != word_cloud_viz_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var ANIMATION_DURATION = constants_Constants.ANIMATION_DURATION,
  DEFAULT_BLUE = constants_Constants.DEFAULT_BLUE,
  NUMBER_DEFAULT = constants_Constants.NUMBER_DEFAULT,
  TIER_FONT_SIZE = constants_Constants.TIER_FONT_SIZE,
  TIER_PADDING = constants_Constants.TIER_PADDING,
  WORD_CLOUD_LAYOUT = constants_Constants.WORD_CLOUD_LAYOUT,
  WHITE = constants_Constants.WHITE,
  TABLET_WIDTH_BREAKPOINT = constants_Constants.TABLET_WIDTH_BREAKPOINT;
var INCREMENT = 10;
var JITTER_SCALE = 25;
var FALLBACK_FONT = 'sans-serif';
var MAX_STROKE_WIDTH = 6;
var word_cloud_viz_defaultComponentConfig = {
  width: 400,
  height: 400,
  animationDuration: ANIMATION_DURATION,
  containerColor: DEFAULT_BLUE,
  wordColor: NUMBER_DEFAULT,
  highlightedWords: [],
  fontFamily: 'Arial',
  rotation: 'flat',
  padding: 4,
  margins: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20
  },
  cloudLayout: WORD_CLOUD_LAYOUT.CENTER_OUT,
  tooltip: js_nv.models.upgradedTooltip()
};
var WordCloudViz = function () {
  function WordCloudViz() {
    var _this = this;
    word_cloud_viz_classCallCheck(this, WordCloudViz);
    word_cloud_viz_defineProperty(this, "_componentConfig", word_cloud_viz_objectSpread({}, word_cloud_viz_defaultComponentConfig));
    word_cloud_viz_defineProperty(this, "_renderLifeCycle", new upgraded_utils_RenderLifeCycle());
    word_cloud_viz_defineProperty(this, "render", function (selection) {
      _this._renderLifeCycle.start();
      selection.each(_this._renderSelection());
      _this._renderLifeCycle.dispatchOnCompletion();
    });
    word_cloud_viz_defineProperty(this, "_renderSelection", function () {
      var wordCloudConfig = _this._componentConfig;
      return function (data) {
        var container = src_select(this);
        var wordContainer = upgraded_utils_createElementIfAbsent(container, 'word-cloud');
        var wordGroups;
        var placedWords = [];
        var width = wordCloudConfig.width,
          height = wordCloudConfig.height,
          containerColor = wordCloudConfig.containerColor,
          wordColor = wordCloudConfig.wordColor,
          animationDuration = wordCloudConfig.animationDuration,
          margins = wordCloudConfig.margins,
          padding = wordCloudConfig.padding,
          fontFamily = wordCloudConfig.fontFamily,
          onWordClick = wordCloudConfig.onWordClick,
          highlightedWords = wordCloudConfig.highlightedWords,
          cloudLayout = wordCloudConfig.cloudLayout,
          tooltip = wordCloudConfig.tooltip;
        var fonts = "'".concat(fontFamily, "', ").concat(FALLBACK_FONT);
        var top = margins.top,
          bottom = margins.bottom,
          left = margins.left,
          right = margins.right;
        var _getMinMaxCounts = getMinMaxCounts(data),
          _getMinMaxCounts2 = word_cloud_viz_slicedToArray(_getMinMaxCounts, 2),
          minCount = _getMinMaxCounts2[0],
          maxCount = _getMinMaxCounts2[1];
        drawCloud(data);
        function generateCloudLayout(data, width, height) {
          if (!data.length) {
            return;
          }
          var words = data.slice().sort(function (a, b) {
            return b.size - a.size;
          });
          var bounds = {
            xMin: -width / 2 + left,
            xMax: width / 2 - right,
            yMin: -height / 2 + top,
            yMax: height / 2 - bottom
          };
          placedWords = [];
          for (var i = 0; i < words.length; i++) {
            if (!placeWord(words[i], bounds, jitter(words[i].text))) {
              break;
            }
          }
          function placeWord(word, bounds, jitter) {
            var availableWidth = bounds.xMax - bounds.xMin;
            var availableHeight = bounds.yMax - bounds.yMin;
            var placingFunction = cloudLayout === WORD_CLOUD_LAYOUT.CENTER_OUT ? generateArchimedeanSpiral([availableWidth, availableHeight]) : generateTopDownRows([availableWidth, availableHeight]);
            if (cloudLayout === WORD_CLOUD_LAYOUT.CENTER_OUT) {
              updateWordPosition(word, 0, 0);
            } else {
              updateWordPosition(word, -(availableWidth / 2), -(availableHeight / 2));
            }
            var startX = word.x + (jitter[0] || 0);
            var startY = word.y + (jitter[1] || 0);
            var maxDelta = Math.sqrt(Math.pow(availableWidth, 2) + Math.pow(availableHeight, 2));
            var increment = 5;
            var t = 0;
            var dxdy = placingFunction(t);
            var dx;
            var dy;
            while (dxdy) {
              dx = Math.floor(dxdy[0]);
              dy = Math.floor(dxdy[1]);
              if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) {
                break;
              }
              updateWordPosition(word, startX + dx, startY + dy);
              if (isInRectBounds(word, bounds)) {
                var colliding = false;
                for (var _i = 0; _i < placedWords.length; _i++) {
                  if (isColliding(word, placedWords[_i])) {
                    colliding = true;
                    break;
                  }
                }
                if (colliding) {
                  t += increment;
                  dxdy = placingFunction(t);
                  continue;
                }
                placedWords.push(word);
                return true;
              }
              t += increment;
              dxdy = placingFunction(t);
            }
            return false;
          }
          function isColliding(rect1, rect2) {
            return !(rect1.x0 >= rect2.x1 + padding || rect2.x0 >= rect1.x1 + padding || rect1.y0 >= rect2.y1 + padding || rect2.y0 >= rect1.y1 + padding);
          }
          function isInRectBounds(word, bounds) {
            return word.x0 > bounds.xMin && word.x1 < bounds.xMax && word.y0 > bounds.yMin && word.y1 < bounds.yMax;
          }
          function updateWordPosition(word, x, y) {
            var halfWidth = word.width / 2;
            var halfHeight = word.height / 2;
            word.x = x;
            word.y = y;
            word.x0 = word.x - halfWidth;
            word.x1 = word.x + halfWidth;
            word.y0 = word.y - halfHeight;
            word.y1 = word.y + halfHeight;
          }
        }
        function drawCloud(words) {
          var removeLargestTier = width <= TABLET_WIDTH_BREAKPOINT;
          wordGroups = wordContainer.selectAll('g.word-group').data(words, function (d) {
            return d.text;
          });
          var wordGroupsEnter = wordGroups.enter().append('g').attr('class', 'word-group');
          wordGroups.exit().remove();
          wordGroupsEnter.append('text').text(function (d) {
            return d.text.toLowerCase();
          });
          wordGroupsEnter.merge(wordGroups).select('text').style('font-size', function (d) {
            return getFontSizeForSelectedData(d, minCount, maxCount);
          }).style('font-family', fonts).each(function (d) {
            d.textBbox = this.getBBox();
            d.tier = getTier(d.size, minCount, maxCount, removeLargestTier);
          });
          wordGroupsEnter.append('rect');
          wordGroupsEnter.merge(wordGroups).select('rect').attr('width', function (d) {
            return getWidthForSelectedData(d, minCount, maxCount);
          }).attr('height', function (d) {
            return getHeightForSelectedData(d, minCount, maxCount);
          });
          wordContainer.selectAll('.word-group').remove();
          generateCloudLayout(words, width, height);
          wordGroups = wordContainer.selectAll('g.word-group').data(placedWords, function (d) {
            return d.text;
          });
          wordGroupsEnter = wordGroups.enter().append('g').attr('class', 'word-group');
          wordGroups.exit().remove();
          wordGroupsEnter.merge(wordGroups).on('mouseover', function (event, d) {
            var element = src_select(this);
            element.select('text').transition().duration(animationDuration).style('fill', WHITE).style('cursor', 'default');
            element.select('rect').transition().duration(animationDuration).style('fill-opacity', 1).style('cursor', 'default');
            tooltip.dataValidator(function (d) {
              return d.text && d.size;
            }).data(d).hidden(false).gravity('s');
            tooltip();
          }).on('mousemove', function (event, d) {
            tooltip.dataValidator(function (d) {
              return d.text && d.size;
            }).data(d);
            tooltip();
          }).on('mouseout', function () {
            var element = src_select(this);
            element.select('text').transition().duration(animationDuration).style('fill', wordColor);
            element.select('rect').transition().duration(animationDuration).style('fill-opacity', function (d) {
              return getOpacity(d.tier);
            });
            tooltip.hidden(true);
          }).on('click', function (event, d) {
            if (onWordClick) {
              onWordClick(d.text);
            }
          });
          wordGroupsEnter.merge(wordGroups).append('rect').attr('width', function (d) {
            return d.width;
          }).attr('height', function (d) {
            return d.height;
          }).attr('rx', function (d) {
            return getPadding(d.size, minCount, maxCount).bottom;
          }).attr('class', function (d) {
            return "tier".concat(d.tier);
          }).style('fill-opacity', function (d) {
            return getOpacity(d.tier);
          }).style('fill', containerColor).attr('stroke', containerColor).attr('stroke-opacity', 1).attr('stroke-width', function (d) {
            return word_cloud_viz_getStrokeWidth(highlightedWords, d);
          });
          wordGroupsEnter.merge(wordGroups).append('text').attr('class', function (d) {
            return "tier".concat(d.tier);
          }).style('font-size', function (d) {
            return word_cloud_viz_getFontSize(d.size, minCount, maxCount);
          }).style('font-family', fonts).style('fill', wordColor).text(function (d) {
            return d.text.toLowerCase();
          }).attr('dominant-baseline', 'central').attr('text-anchor', 'middle').attr('transform', function (d) {
            return "translate(".concat(d.width / 2, ", ").concat(d.height / 2, ")");
          });
          wordGroupsEnter.merge(wordGroups).transition().duration(animationDuration).attr('transform', function (d) {
            return "translate(".concat(d.x0, ", ").concat(d.y0, ")");
          });
          wordGroupsEnter.merge(wordGroups).on('click', function () {
            if (onWordClick) {
              onWordClick(this.__data__.text);
            }
          });
          container.transition().duration(wordCloudConfig.animationDuration / 2).attr('viewBox', [-width / 2, -height / 2, width, height]);
        }
      };
    });
  }
  return word_cloud_viz_createClass(WordCloudViz, [{
    key: "lifeCycle",
    get: function get() {
      return this._renderLifeCycle.dispatch;
    }
  }, {
    key: "width",
    value: function width(_width) {
      this._componentConfig.width = _width;
      return this;
    }
  }, {
    key: "height",
    value: function height(_height) {
      this._componentConfig.height = _height;
      return this;
    }
  }, {
    key: "animationDuration",
    value: function animationDuration(duration) {
      this._componentConfig.animationDuration = duration;
      return this;
    }
  }, {
    key: "containerColor",
    value: function containerColor(color) {
      this._componentConfig.containerColor = color;
      return this;
    }
  }, {
    key: "wordColor",
    value: function wordColor(color) {
      this._componentConfig.wordColor = color;
      return this;
    }
  }, {
    key: "fontFamily",
    value: function fontFamily(_fontFamily) {
      this._componentConfig.fontFamily = _fontFamily;
      return this;
    }
  }, {
    key: "rotation",
    value: function rotation(_rotation) {
      this._componentConfig.rotation = _rotation;
      return this;
    }
  }, {
    key: "padding",
    value: function padding(_padding) {
      this._componentConfig.padding = _padding;
      return this;
    }
  }, {
    key: "onWordClick",
    value: function onWordClick(_onWordClick) {
      this._componentConfig.onWordClick = _onWordClick;
      return this;
    }
  }, {
    key: "highlightedWords",
    value: function highlightedWords(_highlightedWords) {
      this._componentConfig.highlightedWords = _highlightedWords;
      return this;
    }
  }, {
    key: "cloudLayout",
    value: function cloudLayout(_cloudLayout) {
      this._componentConfig.cloudLayout = _cloudLayout;
      return this;
    }
  }, {
    key: "enableTooltip",
    value: function enableTooltip(isEnabled, tooltipGenerator) {
      this._componentConfig.tooltip.enabled(isEnabled);
      if (_.isFunction(tooltipGenerator)) {
        this._componentConfig.tooltip.contentGenerator(tooltipGenerator);
      }
      return this;
    }
  }]);
}();
function word_cloud_viz_getStrokeWidth(highlightedWords, currentWord) {
  return (highlightedWords.includes(currentWord.text) ? MAX_STROKE_WIDTH - currentWord.tier : 0) + 'px';
}
function getMinMaxCounts(wordData) {
  var sizes = wordData.map(function (_ref) {
    var size = _ref.size;
    return size;
  });
  var min = Math.min.apply(Math, word_cloud_viz_toConsumableArray(sizes));
  var max = Math.max.apply(Math, word_cloud_viz_toConsumableArray(sizes));
  return [min, max];
}
function getTier(wordCount, minCount, maxCount, removeLargestTier) {
  var proportion = getNormalizedValue(wordCount, minCount, maxCount);
  if (removeLargestTier) {
    if (proportion <= 0.25) {
      return 5;
    } else if (proportion <= 0.5) {
      return 4;
    } else if (proportion <= 0.75) {
      return 3;
    } else if (proportion <= 1) {
      return 2;
    }
  }
  if (proportion <= 0.2) {
    return 5;
  } else if (proportion <= 0.4) {
    return 4;
  } else if (proportion <= 0.6) {
    return 3;
  } else if (proportion <= 0.8) {
    return 2;
  } else if (proportion <= 1) {
    return 1;
  }
}
function getNormalizedValue(value, min, max) {
  return Math.max(value - min, 0) / Math.max(max - min, 1);
}
function getOpacity(tier) {
  return 0.5 - 0.1 * (tier - 1);
}
function word_cloud_viz_getFontSize(wordCount, minCount, maxCount) {
  return TIER_FONT_SIZE[getTier(wordCount, minCount, maxCount)];
}
function getPadding(wordCount, minCount, maxCount) {
  return TIER_PADDING[getTier(wordCount, minCount, maxCount)];
}
function jitter(text) {
  var reversedText = text.split('').reverse().join('');
  return [Math.floor(getRandomNumber(text) * (2 * JITTER_SCALE) - JITTER_SCALE), Math.floor(getRandomNumber(reversedText) * (2 * JITTER_SCALE) - JITTER_SCALE)];
}
function getRandomNumber(text) {
  var hash = 0;
  var textIterator;
  for (textIterator = 0; textIterator < text.length && textIterator < 10; textIterator++) {
    hash = (hash << 5) - hash + text.charCodeAt(textIterator);
    hash = hash && hash;
  }
  return Math.abs(hash % 11) / 10;
}
function generateArchimedeanSpiral(size) {
  var e = size[0] / size[1];
  return function (t) {
    t *= .1;
    return [e * t * Math.cos(t), t * Math.sin(t)];
  };
}
function generateTopDownRows(size) {
  return function (t) {
    return [t % size[0], Math.floor(t / size[0]) * INCREMENT];
  };
}
function getFontSizeForSelectedData(d, minCount, maxCount) {
  d.fontSize = word_cloud_viz_getFontSize(d.size, minCount, maxCount);
  return d.fontSize;
}
function getHeightForSelectedData(d, minCount, maxCount) {
  var padding = getPadding(d.size, minCount, maxCount);
  d.height = d.textBbox.height + padding.top + padding.bottom;
  return d.height;
}
function getWidthForSelectedData(d, minCount, maxCount) {
  d.width = d.textBbox.width + 2 * getPadding(d.size, minCount, maxCount).horizontal;
  return d.width;
}
;// ./src/js/viz/d3/charts/word_cloud.js




var WordCloudConfig = {
  setContainerColor: function setContainerColor(containerColor) {
    this.containerColor = containerColor;
    return this;
  },
  setWordColor: function setWordColor(wordColor) {
    this.wordColor = wordColor;
    return this;
  },
  setPadding: function setPadding(padding) {
    this.padding = padding;
    return this;
  },
  setFontFamily: function setFontFamily(fontFamily) {
    this.fontFamily = fontFamily;
    return this;
  },
  setRotation: function setRotation(rotation) {
    this.rotation = rotation;
    return this;
  },
  setOnClickFunction: function setOnClickFunction(onWordClick) {
    this.onWordClick = onWordClick;
    return this;
  },
  setHighlightedWords: function setHighlightedWords(highlightedWords) {
    this.highlightedWords = highlightedWords;
    return this;
  },
  setCloudLayout: function setCloudLayout(cloudLayout) {
    this.cloudLayout = cloudLayout;
    return this;
  }
};
var WordCloud = UpgradedCore.extend(WordCloudConfig).extend(UpgradedBaseChartConfig).extend({
  initialize: function initialize() {
    this.layout = new ChartLayout();
    return UpgradedCore.prototype.initialize.apply(this, arguments);
  },
  render: function render(postRender) {
    this.wrapContainer();
    var container = this.getContainer();
    this._getChart();
    this._configureChart();
    container.datum(this.data).call(this.chart.render);
    if (postRender) {
      this.chart.lifeCycle.on('renderEnd', postRender);
    }
    return this;
  },
  _getChart: function _getChart() {
    if (!this.chart) {
      this._createWordCloud();
    }
    return this.chart;
  },
  _createWordCloud: function _createWordCloud() {
    this.chart = new WordCloudViz();
  },
  _configureChart: function _configureChart() {
    this.chart.width(this.getContainerWidth()).height(this.getContainerHeight()).animationDuration(this._animationDuration).enableTooltip(this._showTooltip, this.tooltip);
    if (this.containerColor) {
      this.chart.containerColor(this.containerColor);
    }
    if (this.wordColor) {
      this.chart.wordColor(this.wordColor);
    }
    if (this.padding) {
      this.chart.padding(this.padding);
    }
    if (this.fontFamily) {
      this.chart.fontFamily(this.fontFamily);
    }
    if (this.rotation) {
      this.chart.rotation(this.rotation);
    }
    if (this.onWordClick) {
      this.chart.onWordClick(this.onWordClick);
    }
    if (this.highlightedWords) {
      this.chart.highlightedWords(this.highlightedWords);
    }
    if (this.cloudLayout) {
      this.chart.cloudLayout(this.cloudLayout);
    }
  },
  resize: function resize() {
    if (this.chart) {
      UpgradedCore.prototype.resize.apply(this, arguments);
    }
  }
}, {
  Name: 'WordCloud',
  DataDimensions: '1'
});
;// ./src/js/viz/charts/map-view/constants.js
var COLOR_RANGES = {
  min: 10,
  thresholds: [{
    value: 0,
    color: '#229954',
    label: '< 0'
  }, {
    value: 25,
    color: '#CB4335',
    label: '0 - 25'
  }, {
    value: 50,
    color: '#1951B3',
    label: '25 - 50'
  }, {
    value: 50,
    color: '#470975',
    label: '> 50'
  }],
  noData: {
    color: '#89919a',
    label: 'No Data'
  }
};
var HOVER_OPACITY = 0.9;
var OPACITY_TRANSITION_DURATION = 300;
var MapConstants = {
  DEFAULT_RANGES: {
    colorRanges: [{
      max: 10,
      color: '#229954',
      opacity: 0.5,
      label: 'less than 10'
    }, {
      min: 10,
      max: 20,
      color: '#CB4335',
      opacity: 0.5,
      label: '10 to 20'
    }, {
      min: 20,
      max: 30,
      color: '#1951B3',
      opacity: 0.5,
      label: '20 to 30'
    }, {
      min: 30,
      max: 40,
      color: '#D4D63A',
      opacity: 0.5,
      label: '30 to 40'
    }, {
      min: 50,
      color: '#470975',
      opacity: 0.5,
      label: 'greater than 50'
    }],
    noData: {
      color: '#CFCFC4',
      opacity: 0.5,
      label: 'no data'
    }
  },
  DEFAULT_OPACITY: 0.5,
  MAP_STYLES: {
    'default': 'mapbox://styles/mapbox/light-v11',
    'street': 'mapbox://styles/mapbox/streets-v12',
    'satellite': 'mapbox://styles/mapbox/satellite-v9'
  },
  LAYER_TYPES: {
    FILL: 'fill',
    CIRCLE: 'circle'
  },
  GEO_JSON_DATA_TYPES: {
    POINT: 'Point',
    POLYGON: 'Polygon'
  },
  CIRCLE_PAINT: {
    'circle-color': ['get', 'color'],
    'circle-radius': ['get', 'radius'],
    'circle-stroke-width': ['get', 'strokeWidth'],
    'circle-stroke-color': ['get', 'color'],
    'circle-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], HOVER_OPACITY, ['get', 'opacity']],
    'circle-opacity-transition': {
      duration: OPACITY_TRANSITION_DURATION
    }
  },
  FILL_PAINT: {
    'fill-color': ['get', 'color'],
    'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], HOVER_OPACITY, ['get', 'opacity']],
    'fill-opacity-transition': {
      duration: OPACITY_TRANSITION_DURATION
    },
    'fill-outline-color': ['get', 'color']
  }
};
var MAP_CONTAINER = 'map-container';
var constants_LEGEND_CONTAINER = 'legend-container';
var MAPBOX_STYLES = 'mapbox-styles';
var LEGEND_LOCATIONS = {
  RIGHT: 'right',
  BOTTOM: 'bottom',
  INSIDE_RIGHT: 'inside-right',
  INSIDE_BOTTOM: 'inside-bottom',
  NONE: 'none'
};
var MAP_DATA_TYPES = {
  Points: 'points',
  States: 'states',
  Countries: 'countries',
  Polygons: 'polygons'
};
var defaultFallbackWarning = 'Falling back to default value';
var USA_ABBR_MAPBOX_IDS = {
  'AL': {
    'name': 'Alabama',
    'id': 70377
  },
  'AK': {
    'name': 'Alaska',
    'id': 135913
  },
  'AZ': {
    'name': 'Arizona',
    'id': 201449
  },
  'AR': {
    'name': 'Arkansas',
    'id': 266985
  },
  'CA': {
    'name': 'California',
    'id': 332521
  },
  'CO': {
    'name': 'Colorado',
    'id': 398057
  },
  'CT': {
    'name': 'Connecticut',
    'id': 463593
  },
  'DE': {
    'name': 'Delaware',
    'id': 529129
  },
  'DC': {
    'name': 'District of Columbia',
    'id': 594665
  },
  'FL': {
    'name': 'Florida',
    'id': 660201
  },
  'GA': {
    'name': 'Georgia',
    'id': 725737
  },
  'HI': {
    'name': 'Hawaii',
    'id': 791273
  },
  'ID': {
    'name': 'Idaho',
    'id': 856809
  },
  'IL': {
    'name': 'Illinois',
    'id': 922345
  },
  'IN': {
    'name': 'Indiana',
    'id': 987881
  },
  'IA': {
    'name': 'Iowa',
    'id': 1053417
  },
  'KS': {
    'name': 'Kansas',
    'id': 1118953
  },
  'KY': {
    'name': 'Kentucky',
    'id': 1184489
  },
  'LA': {
    'name': 'Louisiana',
    'id': 1250025
  },
  'ME': {
    'name': 'Maine',
    'id': 1315561
  },
  'MD': {
    'name': 'Maryland',
    'id': 1381097
  },
  'MA': {
    'name': 'Massachusetts',
    'id': 1446633
  },
  'MI': {
    'name': 'Michigan',
    'id': 1512169
  },
  'MN': {
    'name': 'Minnesota',
    'id': 1577705
  },
  'MS': {
    'name': 'Mississippi',
    'id': 1643241
  },
  'MO': {
    'name': 'Missouri',
    'id': 1708777
  },
  'MT': {
    'name': 'Montana',
    'id': 1774313
  },
  'NE': {
    'name': 'Nebraska',
    'id': 1839849
  },
  'NV': {
    'name': 'Nevada',
    'id': 1905385
  },
  'NH': {
    'name': 'New Hampshire',
    'id': 1970921
  },
  'NJ': {
    'name': 'New Jersey',
    'id': 2036457
  },
  'NM': {
    'name': 'New Mexico',
    'id': 2101993
  },
  'NY': {
    'name': 'New York',
    'id': 2167529
  },
  'NC': {
    'name': 'North Carolina',
    'id': 2233065
  },
  'ND': {
    'name': 'North Dakota',
    'id': 2298601
  },
  'OH': {
    'name': 'Ohio',
    'id': 2364137
  },
  'OK': {
    'name': 'Oklahoma',
    'id': 2429673
  },
  'OR': {
    'name': 'Oregon',
    'id': 2495209
  },
  'PA': {
    'name': 'Pennsylvania',
    'id': 2560745
  },
  'RI': {
    'name': 'Rhode Island',
    'id': 2626281
  },
  'SC': {
    'name': 'South Carolina',
    'id': 2691817
  },
  'SD': {
    'name': 'South Dakota',
    'id': 2757353
  },
  'TN': {
    'name': 'Tennessee',
    'id': 2822889
  },
  'TX': {
    'name': 'Texas',
    'id': 2888425
  },
  'UT': {
    'name': 'Utah',
    'id': 2953961
  },
  'VT': {
    'name': 'Vermont',
    'id': 3019497
  },
  'VA': {
    'name': 'Virginia',
    'id': 3085033
  },
  'WA': {
    'name': 'Washington',
    'id': 3150569
  },
  'WV': {
    'name': 'West Virginia',
    'id': 3216105
  },
  'WI': {
    'name': 'Wisconsin',
    'id': 3281641
  },
  'WY': {
    'name': 'Wyoming',
    'id': 3347177
  }
};
var USA_MAPBOX_IDS = {
  'Alabama': {
    'name': 'Alabama',
    'id': 70377
  },
  'Alaska': {
    'name': 'Alaska',
    'id': 135913
  },
  'Arizona': {
    'name': 'Arizona',
    'id': 201449
  },
  'Arkansas': {
    'name': 'Arkansas',
    'id': 266985
  },
  'California': {
    'name': 'California',
    'id': 332521
  },
  'Colorado': {
    'name': 'Colorado',
    'id': 398057
  },
  'Connecticut': {
    'name': 'Connecticut',
    'id': 463593
  },
  'Delaware': {
    'name': 'Delaware',
    'id': 529129
  },
  'District of Columbia': {
    'name': 'District of Columbia',
    'id': 594665
  },
  'Florida': {
    'name': 'Florida',
    'id': 660201
  },
  'Georgia': {
    'name': 'Georgia',
    'id': 725737
  },
  'Hawaii': {
    'name': 'Hawaii',
    'id': 791273
  },
  'Idaho': {
    'name': 'Idaho',
    'id': 856809
  },
  'Illinois': {
    'name': 'Illinois',
    'id': 922345
  },
  'Indiana': {
    'name': 'Indiana',
    'id': 987881
  },
  'Iowa': {
    'name': 'Iowa',
    'id': 1053417
  },
  'Kansas': {
    'name': 'Kansas',
    'id': 1118953
  },
  'Kentucky': {
    'name': 'Kentucky',
    'id': 1184489
  },
  'Louisiana': {
    'name': 'Louisiana',
    'id': 1250025
  },
  'Maine': {
    'name': 'Maine',
    'id': 1315561
  },
  'Maryland': {
    'name': 'Maryland',
    'id': 1381097
  },
  'Massachusetts': {
    'name': 'Massachusetts',
    'id': 1446633
  },
  'Michigan': {
    'name': 'Michigan',
    'id': 1512169
  },
  'Minnesota': {
    'name': 'Minnesota',
    'id': 1577705
  },
  'Mississippi': {
    'name': 'Mississippi',
    'id': 1643241
  },
  'Missouri': {
    'name': 'Missouri',
    'id': 1708777
  },
  'Montana': {
    'name': 'Montana',
    'id': 1774313
  },
  'Nebraska': {
    'name': 'Nebraska',
    'id': 1839849
  },
  'Nevada': {
    'name': 'Nevada',
    'id': 1905385
  },
  'New Hampshire': {
    'name': 'New Hampshire',
    'id': 1970921
  },
  'New Jersey': {
    'name': 'New Jersey',
    'id': 2036457
  },
  'New Mexico': {
    'name': 'New Mexico',
    'id': 2101993
  },
  'New York': {
    'name': 'New York',
    'id': 2167529
  },
  'North Carolina': {
    'name': 'North Carolina',
    'id': 2233065
  },
  'North Dakota': {
    'name': 'North Dakota',
    'id': 2298601
  },
  'Ohio': {
    'name': 'Ohio',
    'id': 2364137
  },
  'Oklahoma': {
    'name': 'Oklahoma',
    'id': 2429673
  },
  'Oregon': {
    'name': 'Oregon',
    'id': 2495209
  },
  'Pennsylvania': {
    'name': 'Pennsylvania',
    'id': 2560745
  },
  'Rhode Island': {
    'name': 'Rhode Island',
    'id': 2626281
  },
  'South Carolina': {
    'name': 'South Carolina',
    'id': 2691817
  },
  'South Dakota': {
    'name': 'South Dakota',
    'id': 2757353
  },
  'Tennessee': {
    'name': 'Tennessee',
    'id': 2822889
  },
  'Texas': {
    'name': 'Texas',
    'id': 2888425
  },
  'Utah': {
    'name': 'Utah',
    'id': 2953961
  },
  'Vermont': {
    'name': 'Vermont',
    'id': 3019497
  },
  'Virginia': {
    'name': 'Virginia',
    'id': 3085033
  },
  'Washington': {
    'name': 'Washington',
    'id': 3150569
  },
  'West Virginia': {
    'name': 'West Virginia',
    'id': 3216105
  },
  'Wisconsin': {
    'name': 'Wisconsin',
    'id': 3281641
  },
  'Wyoming': {
    'name': 'Wyoming',
    'id': 3347177
  }
};
// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.js
var mapbox_gl = __webpack_require__(842);
var mapbox_gl_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl);
;// ./src/js/viz/charts/map-view/recenterButton.js



function recenterButton_typeof(o) { "@babel/helpers - typeof"; return recenterButton_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, recenterButton_typeof(o); }
function recenterButton_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function recenterButton_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, recenterButton_toPropertyKey(o.key), o); } }
function recenterButton_createClass(e, r, t) { return r && recenterButton_defineProperties(e.prototype, r), t && recenterButton_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function recenterButton_toPropertyKey(t) { var i = recenterButton_toPrimitive(t, "string"); return "symbol" == recenterButton_typeof(i) ? i : i + ""; }
function recenterButton_toPrimitive(t, r) { if ("object" != recenterButton_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != recenterButton_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var RecenterButton = function () {
  function RecenterButton(zoom, center, mapId) {
    recenterButton_classCallCheck(this, RecenterButton);
    this.zoom = zoom;
    this.center = center;
    this.mapId = mapId;
  }
  return recenterButton_createClass(RecenterButton, [{
    key: "onAdd",
    value: function onAdd(map) {
      var _this = this;
      var homeButton = src_select("#".concat(this.mapId)).append('div').classed('mapboxgl-ctrl mapbox-ctrl-group home-button-container', true);
      homeButton.on('contextmenu', function (e) {
        return e.preventDefault();
      }).append('button').on('click', function () {
        return map.flyTo({
          center: _this.center,
          zoom: _this.zoom,
          speed: 1,
          curve: 1
        });
      }).classed('home-button', true).append('svg').attr('focusable', false).attr('viewBox', '0 0 24 24').attr('aria-hidden', true).attr('style', 'font-size: 20px;').append('path').attr('d', "M12 6.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 1 0 0-6.5zM10.25 9.5a1.75 1.75 0 1\n\t\t\t\t1 3.5 0 1.75 1.75 0 1 1-3.5 0zM12 2.75c-3.758 0-6.75 3.171-6.75 7.013 0 2.917 1.482 5.758\n\t\t\t\t2.952 7.817a20.63 20.63 0 0 0 2.119 2.526l.812.739a3.2 3.2 0 0 0 .332.235 1.43 1.43 0 0 0\n\t\t\t\t.189.096c.058.024.186.072.347.072s.289-.048.347-.072a1.43 1.43 0 0 0 .189-.096 3.2 3.2 0 0\n\t\t\t\t0 .332-.235 9.79 9.79 0 0 0 .812-.739A20.81 20.81 0 0 0 15.8 17.58c1.47-2.059 2.952-4.9\n\t\t\t\t2.952-7.817 0-3.843-2.992-7.013-6.75-7.013zM6.75 9.763C6.75 6.688 9.131 4.25 12 4.25s5.25\n\t\t\t\t2.438 5.25 5.513c0 2.451-1.268 4.978-2.673 6.946a19.12 19.12 0 0 1-1.96 2.339l-.617.571a9.06\n\t\t\t\t9.06 0 0 1-.617-.571 19.13 19.13 0 0 1-1.96-2.339C8.018 14.742 6.75 12.214 6.75 9.763z");
      return homeButton.node();
    }
  }]);
}();
// EXTERNAL MODULE: ./node_modules/country-to-iso/lib/cjs/index.js
var cjs = __webpack_require__(5324);
;// ./src/js/viz/charts/map-view/map-view-viz.js












function map_view_viz_typeof(o) { "@babel/helpers - typeof"; return map_view_viz_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, map_view_viz_typeof(o); }
function map_view_viz_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = map_view_viz_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function map_view_viz_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return map_view_viz_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? map_view_viz_arrayLikeToArray(r, a) : void 0; } }
function map_view_viz_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function map_view_viz_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function map_view_viz_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? map_view_viz_ownKeys(Object(t), !0).forEach(function (r) { map_view_viz_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : map_view_viz_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function map_view_viz_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function map_view_viz_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, map_view_viz_toPropertyKey(o.key), o); } }
function map_view_viz_createClass(e, r, t) { return r && map_view_viz_defineProperties(e.prototype, r), t && map_view_viz_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function map_view_viz_defineProperty(e, r, t) { return (r = map_view_viz_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function map_view_viz_toPropertyKey(t) { var i = map_view_viz_toPrimitive(t, "string"); return "symbol" == map_view_viz_typeof(i) ? i : i + ""; }
function map_view_viz_toPrimitive(t, r) { if ("object" != map_view_viz_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != map_view_viz_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var defaultConfig = {
  width: 400,
  height: 400,
  mapCenter: [-101.64, 40.76],
  mapZoom: 5,
  colorRanges: COLOR_RANGES,
  mapStyle: MapConstants.MAP_STYLES.default,
  tooltip: js_nv.models.tooltip(),
  mapDataType: MAP_DATA_TYPES.Points,
  showHoverState: true
};
var WORLD_DATA_JOIN_KEY = 'iso_3166_1';
var COUNTRIES_SOURCE_NAME = 'countries';
var COUNTRIES_SOURCE_LAYER = 'boundaries_admin_0';
var USA_MAP_SOURCE = 'admin_1';
var USA_MAP_SOURCE_LAYER = 'boundaries_admin_1';
var ADM1_REGIONS_URL = 'mapbox://mapbox.boundaries-adm1-v3';
var WORLDVIEW_FILTER = ['any', ['==', 'all', ['get', 'worldview']], ['in', 'US', ['get', 'worldview']]];
var TRANSPARENT = 'transparent';
var MAP_CONTROL_LOCATION = 'top-left';
var MapViewViz = function () {
  function MapViewViz() {
    var _this = this;
    map_view_viz_classCallCheck(this, MapViewViz);
    map_view_viz_defineProperty(this, "_componentConfig", map_view_viz_objectSpread({}, defaultConfig));
    map_view_viz_defineProperty(this, "_renderLifeCycle", new RenderLifeCycle());
    map_view_viz_defineProperty(this, "render", function (selection) {
      _this._renderLifeCycle.start();
      selection.each(_this._renderSelection());
      _this._renderLifeCycle.dispatchOnCompletion();
    });
    map_view_viz_defineProperty(this, "_renderSelection", function () {
      var mapViewConfig = this._componentConfig;
      return function (data) {
        var _this2 = this;
        var mapId = _.uniqueId('map-view');
        var container = src_select(this);
        var mapContainer = utils_createElementIfAbsent(container, MAP_CONTAINER, 'div');
        this.mapId = mapId;
        mapViewConfig.mapId = mapId;
        mapContainer.append('div').attr('id', mapId);
        this.map = drawInitialMap(mapViewConfig);
        mapViewConfig.map = this.map;
        this.map.dragRotate.disable();
        this.map.touchZoomRotate.disableRotation();
        addMapControls(this.map, mapViewConfig, mapId);
        this.map.on('load', function () {
          addDataLayer(_this2.map, data, mapId, mapViewConfig);
        });
      };
    });
  }
  return map_view_viz_createClass(MapViewViz, [{
    key: "lifeCycle",
    get: function get() {
      return this._renderLifeCycle.dispatch;
    }
  }, {
    key: "componentConfig",
    get: function get() {
      return this._componentConfig;
    }
  }, {
    key: "width",
    value: function width(_width) {
      this._componentConfig.width = _width;
      return this;
    }
  }, {
    key: "height",
    value: function height(_height) {
      this._componentConfig.height = _height;
      return this;
    }
  }, {
    key: "mapCenter",
    value: function mapCenter(_mapCenter) {
      this._componentConfig.mapCenter = _mapCenter;
    }
  }, {
    key: "mapZoom",
    value: function mapZoom(_mapZoom) {
      this._componentConfig.mapZoom = _mapZoom;
    }
  }, {
    key: "defaultLocation",
    value: function defaultLocation(_defaultLocation) {
      this._componentConfig.defaultLocation = _defaultLocation;
    }
  }, {
    key: "opacity",
    value: function opacity(_opacity) {
      this._componentConfig.opacity = _opacity;
    }
  }, {
    key: "colorRanges",
    value: function colorRanges(ranges) {
      this._componentConfig.colorRanges = ranges;
    }
  }, {
    key: "accessToken",
    value: function accessToken(_accessToken) {
      this._componentConfig.accessToken = _accessToken;
    }
  }, {
    key: "mapStyle",
    value: function mapStyle(_mapStyle) {
      this._componentConfig.mapStyle = _mapStyle;
    }
  }, {
    key: "enableTooltip",
    value: function enableTooltip(isEnabled, tooltipGenerator) {
      this._componentConfig.tooltip.enabled(isEnabled);
      if (_.isFunction(tooltipGenerator)) {
        this._componentConfig.tooltip.contentGenerator(tooltipGenerator);
      } else {
        this._componentConfig.tooltip.enabled(false);
      }
      return this;
    }
  }, {
    key: "locationChangeHandler",
    value: function locationChangeHandler(_locationChangeHandler) {
      this._componentConfig.locationChangeHandler = _locationChangeHandler;
    }
  }, {
    key: "mapClickHandler",
    value: function mapClickHandler(_mapClickHandler) {
      this._componentConfig.mapClickHandler = _mapClickHandler;
    }
  }, {
    key: "mapDataType",
    value: function mapDataType(_mapDataType) {
      this._componentConfig.mapDataType = _mapDataType;
    }
  }, {
    key: "showHoverState",
    value: function showHoverState(_showHoverState) {
      this._componentConfig.showHoverState = _showHoverState;
    }
  }]);
}();
function addDataLayer(map, layerData, layerId, config) {
  var layers = map.getStyle().layers;
  var isDuplicate = _.find(layers, function (layer) {
    return layer.id === layerId;
  });
  if (isDuplicate) {
    return;
  }
  var isUsingTileset = false;
  switch (config.mapDataType) {
    case MAP_DATA_TYPES.Points:
      if (isCorrectDataType(layerData, MapConstants.GEO_JSON_DATA_TYPES.POINT)) {
        addGeoJsonDataLayer(map, layerData, layerId, MapConstants.LAYER_TYPES.CIRCLE, MapConstants.CIRCLE_PAINT, config.showHoverState);
      }
      break;
    case MAP_DATA_TYPES.Polygons:
      if (isCorrectDataType(layerData, MapConstants.GEO_JSON_DATA_TYPES.POLYGON)) {
        addGeoJsonDataLayer(map, layerData, layerId, MapConstants.LAYER_TYPES.FILL, MapConstants.FILL_PAINT, config.showHoverState);
      }
      break;
    case MAP_DATA_TYPES.Countries:
      isUsingTileset = true;
      addWorldDataLayer(map, layerData, layerId, config.showHoverState);
      break;
    case MAP_DATA_TYPES.States:
      isUsingTileset = true;
      addUSStatesDataLayer(map, layerData, layerId, config.showHoverState);
      break;
    default:
      return;
  }
  if (config.tooltip.enabled()) {
    map.on('mouseover', layerId, function (e) {
      buildTooltip(isUsingTileset, e, config.tooltip);
    });
    map.on('mousemove', layerId, function (e) {
      buildTooltip(isUsingTileset, e, config.tooltip);
    });
    map.on('mouseout', layerId, function () {
      config.tooltip.hidden(true);
    });
    if (config.locationChangeHandler) {
      map.on('zoomend', function () {
        onMapLocationChange(map, config);
      });
      map.on('dragend', function () {
        onMapLocationChange(map, config);
      });
    }
    map.on('click', layerId, function (e) {
      handleLocationClick(isUsingTileset, e, config.mapClickHandler);
    });
  }
}
function isCorrectDataType(data, expectedType) {
  return data && data.features && data.features.length ? data.features[0].geometry.type === expectedType : false;
}
var onMapLocationChange = function onMapLocationChange(map, config) {
  var _map$getCenter = map.getCenter(),
    lng = _map$getCenter.lng,
    lat = _map$getCenter.lat;
  var zoom = map.getZoom();
  config.locationChangeHandler({
    coordinates: [lng, lat],
    zoom: zoom
  });
};
function drawInitialMap(config) {
  (mapbox_gl_default()).accessToken = config.accessToken;
  return new (mapbox_gl_default()).Map({
    container: config.mapId,
    style: config.mapStyle,
    center: config.mapCenter,
    zoom: config.mapZoom
  });
}
function handleLocationClick(isUsingTileset, evt, onClickHandler) {
  var _evt$features$, _evt$features$$state, _evt$features$$state$, _evt$features$2, _evt$features$2$prope;
  if (!evt) {
    return;
  }
  var locationId = isUsingTileset ? (_evt$features$ = evt.features[0]) === null || _evt$features$ === void 0 ? void 0 : (_evt$features$$state = _evt$features$.state) === null || _evt$features$$state === void 0 ? void 0 : (_evt$features$$state$ = _evt$features$$state.locationProperties) === null || _evt$features$$state$ === void 0 ? void 0 : _evt$features$$state$.locationId : (_evt$features$2 = evt.features[0]) === null || _evt$features$2 === void 0 ? void 0 : (_evt$features$2$prope = _evt$features$2.properties) === null || _evt$features$2$prope === void 0 ? void 0 : _evt$features$2$prope.locationId;
  if (locationId) {
    onClickHandler(locationId);
  }
}
function buildTooltip(isUsingTileset, evt, tooltip) {
  var _evt$features$3, _evt$features$3$state, _evt$features$4;
  var tooltipData = isUsingTileset ? (_evt$features$3 = evt.features[0]) === null || _evt$features$3 === void 0 ? void 0 : (_evt$features$3$state = _evt$features$3.state) === null || _evt$features$3$state === void 0 ? void 0 : _evt$features$3$state.locationProperties : (_evt$features$4 = evt.features[0]) === null || _evt$features$4 === void 0 ? void 0 : _evt$features$4.properties;
  if (!tooltipData) {
    return;
  }
  tooltip.dataValidator(function (d) {
    return d;
  }).data(tooltipData).gravity('s').position(function () {
    return {
      left: evt.originalEvent.clientX,
      top: evt.originalEvent.clientY
    };
  }).hidden(false);
  tooltip();
}
function addMapControls(map, config) {
  map.addControl(new (mapbox_gl_default()).NavigationControl({
    showCompass: false
  }), MAP_CONTROL_LOCATION);
  map.addControl(new RecenterButton(config.defaultLocation.zoom, config.defaultLocation.coordinates, config.mapId), MAP_CONTROL_LOCATION);
}
function addUSStatesDataLayer(map, data, layerId, showHoverState) {
  map.addSource(USA_MAP_SOURCE, {
    type: 'vector',
    url: ADM1_REGIONS_URL
  });
  var matchExpression = ['match', ['id']];
  var opacity;
  var _iterator = map_view_viz_createForOfIteratorHelper(data),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var location = _step.value;
      var color = location.properties.color;
      var locationData = location.locationName.length === 2 ? USA_ABBR_MAPBOX_IDS[location.locationName] : USA_MAPBOX_IDS[location.locationName];
      if (!locationData) {
        continue;
      }
      matchExpression.push(locationData.id, color);
      if (!opacity) {
        opacity = location.properties.opacity;
      }
      map.setFeatureState({
        source: USA_MAP_SOURCE,
        sourceLayer: USA_MAP_SOURCE_LAYER,
        id: locationData.id
      }, {
        locationProperties: map_view_viz_objectSpread(map_view_viz_objectSpread({}, location.properties), {}, {
          locationName: location.locationName
        })
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  matchExpression.push(TRANSPARENT);
  if (!opacity) {
    opacity = 0.5;
  }
  map.addLayer({
    id: layerId,
    type: 'fill',
    source: USA_MAP_SOURCE,
    'source-layer': USA_MAP_SOURCE_LAYER,
    paint: {
      'fill-color': matchExpression,
      'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], HOVER_OPACITY, opacity],
      'fill-opacity-transition': {
        duration: OPACITY_TRANSITION_DURATION
      },
      'fill-outline-color': matchExpression
    },
    filter: WORLDVIEW_FILTER
  });
  if (showHoverState) {
    configureHoverState(map, layerId);
  }
}
function addWorldDataLayer(map, data, layerId, showHoverState) {
  map.addSource(COUNTRIES_SOURCE_NAME, {
    type: 'vector',
    url: 'mapbox://mapbox.boundaries-adm0-v4',
    promoteId: WORLD_DATA_JOIN_KEY
  });
  var matchExpression = ['match', ['get', WORLD_DATA_JOIN_KEY]];
  var opacity;
  var _iterator2 = map_view_viz_createForOfIteratorHelper(data),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var location = _step2.value;
      var color = location.properties.color;
      location.nameAbbr = (0,cjs/* countryToAlpha2 */.o8)(location.locationName);
      if (!location.nameAbbr) {
        continue;
      }
      matchExpression.push(location.nameAbbr, color);
      if (!opacity) {
        opacity = location.properties.opacity;
      }
      map.setFeatureState({
        source: COUNTRIES_SOURCE_NAME,
        sourceLayer: COUNTRIES_SOURCE_LAYER,
        id: location.nameAbbr
      }, {
        locationProperties: map_view_viz_objectSpread(map_view_viz_objectSpread({}, location.properties), {}, {
          locationName: location.locationName
        })
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  matchExpression.push(TRANSPARENT);
  map.addLayer({
    'id': layerId,
    'type': 'fill',
    'source': COUNTRIES_SOURCE_NAME,
    'source-layer': COUNTRIES_SOURCE_LAYER,
    'paint': {
      'fill-color': matchExpression,
      'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], HOVER_OPACITY, opacity],
      'fill-opacity-transition': {
        duration: OPACITY_TRANSITION_DURATION
      },
      'fill-outline-color': matchExpression
    },
    'filter': WORLDVIEW_FILTER
  });
  if (showHoverState) {
    configureHoverState(map, layerId);
  }
}
function addGeoJsonDataLayer(map, layerData, layerId, layerType, layerStyle, showHoverState) {
  map.addSource(layerId, {
    type: 'geojson',
    data: layerData,
    generateId: true
  });
  map.addLayer({
    id: layerId,
    type: layerType,
    source: layerId,
    paint: layerStyle
  });
  if (showHoverState) {
    configureHoverState(map, layerId);
  }
}
function removeFeatureHoverState(map, feature) {
  if (feature.id !== null) {
    map.setFeatureState(feature, {
      hover: false
    });
  }
  feature.id = null;
}
function setFeatureHoverState(map, feature) {
  map.setFeatureState(feature, {
    hover: true
  });
}
function configureHoverState(map, layerId) {
  var hoveredFeature = {
    id: null,
    source: layerId
  };
  map.on('mousemove', layerId, function (event) {
    event.features.forEach(function (feature) {
      var _feature$state, _feature$state$locati;
      if (feature.properties.isHoverable || (_feature$state = feature.state) !== null && _feature$state !== void 0 && (_feature$state$locati = _feature$state.locationProperties) !== null && _feature$state$locati !== void 0 && _feature$state$locati.isHoverable) {
        removeFeatureHoverState(map, hoveredFeature);
        setFeatureHoverState(map, feature);
        hoveredFeature = feature;
      }
    });
  });
  map.on('mouseleave', layerId, function () {
    removeFeatureHoverState(map, hoveredFeature);
  });
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__(7594);
;// ./src/js/viz/charts/map-view/map-view-config.js






var MapViewConfig = {
  setColorRanges: function setColorRanges(ranges) {
    this.colorRanges = ranges;
    return this;
  },
  setLegendDataFormatter: function setLegendDataFormatter(legendDataFormatter) {
    if (_.isFunction(legendDataFormatter)) {
      this.legendDataFormatter = legendDataFormatter;
    } else {
      console.warn("The legendDataFormatter must be a function. ".concat(defaultFallbackWarning));
    }
    return this;
  },
  setMapCenter: function setMapCenter(mapCenter) {
    if (mapCenter.length && mapCenter.length === 2) {
      this.mapCenter = mapCenter;
    } else {
      console.warn("The mapCenter is not correctly formatted, should be [lng, lat]. ".concat(defaultFallbackWarning));
    }
    return this;
  },
  setMapZoom: function setMapZoom(zoom) {
    if (typeof zoom === 'number' && zoom >= 0 && zoom <= 22) {
      this.mapZoom = zoom;
    } else {
      console.warn("The mapZoom should be a number between 0 and 22. ".concat(defaultFallbackWarning));
    }
    return this;
  },
  setDefaultLocation: function setDefaultLocation(defaultLocation) {
    this.defaultLocation = defaultLocation;
    return this;
  },
  setAccessToken: function setAccessToken(accessToken) {
    this.accessToken = accessToken;
    return this;
  },
  setMapStyle: function setMapStyle(mapStyle) {
    this.mapStyle = mapStyle;
    return this;
  },
  setOpacity: function setOpacity(opacity) {
    if (typeof opacity === 'number' && opacity >= 0 && opacity <= 1) {
      this.opacity = opacity;
    } else {
      console.warn("The opacity should be a number between 0 and 1. ".concat(defaultFallbackWarning));
    }
    return this;
  },
  setLocationChangeHandler: function setLocationChangeHandler(locationChangeHandler) {
    if (_.isFunction(locationChangeHandler)) {
      this.locationChangeHandler = locationChangeHandler;
    } else {
      console.warn('The locationChangeHandler must be a function');
    }
    return this;
  },
  setMapClickHandler: function setMapClickHandler(mapClickHandler) {
    if (_.isFunction(mapClickHandler)) {
      this.mapClickHandler = mapClickHandler;
    }
    return this;
  },
  setMapDataType: function setMapDataType(dataType) {
    if (!_.includes(Object.values(MAP_DATA_TYPES), dataType)) {
      this.mapDataType = MAP_DATA_TYPES.Countries;
    } else {
      this.mapDataType = dataType;
    }
    return this;
  },
  showHoverState: function showHoverState(_showHoverState) {
    this.showHoverState = _showHoverState;
    return this;
  },
  runAsTest: function runAsTest() {
    console.warn('This is a test render of the chart. The map visualization will not load');
    this.isTest = true;
    return this;
  }
};
;// ./src/js/viz/charts/map-view/map-view.js










var map_view_LEGEND_PADDING = 16;
var LEGEND_INSIDE_PADDING = 10;
var MAPBOX_LOGO_HEIGHT = 40;
var LEGEND_HEIGHT_SPACING = 9.5;
var map_view_TOTAL_HORIZONTAL_PADDING_MULTIPLIER = 2;
var map_view_TOTAL_VERTICAL_PADDING_MULTIPLIER = 2;
var MapView = UpgradedCore.extend(MapViewConfig).extend(BaseChartConfig).extend({
  initialize: function initialize() {
    return UpgradedCore.prototype.initialize.apply(this, arguments, true);
  },
  addMapboxStyles: function addMapboxStyles() {
    if (!document.getElementsByClassName(MAPBOX_STYLES).length) {
      var head = document.getElementsByTagName('head')[0];
      var link = document.createElement('link');
      link.classList.add(MAPBOX_STYLES);
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.css';
      head.appendChild(link);
    }
  },
  wrapContainer: function wrapContainer() {
    this.addMapboxStyles();
    if (!this.hasContainer()) {
      this.containerId = this.containerId || _.uniqueId('DqChart');
      this.getParentContainer().append('div').attr('id', this.containerId).classed('dq', true).classed((less_default()).dq, true).classed((less_default()).dqMap, true);
    }
    var container = this.getContainer();
    container.html('');
    container.style('white-space', 'nowrap');
    upgraded_utils_createElementIfAbsent(container, MAP_CONTAINER, 'div');
    upgraded_utils_createElementIfAbsent(container, constants_LEGEND_CONTAINER, 'svg');
  },
  render: function render(postRender) {
    this.wrapContainer();
    this.getContainer().selectAll(".".concat(MAP_CONTAINER)).style('display', 'none');
    this.getContainer().selectAll(".".concat(constants_LEGEND_CONTAINER)).style('display', 'none');
    var chartDimensions = {
      availableWidth: this.getContainerWidth(),
      availableHeight: this.getContainerHeight()
    };
    this.createMapView();
    this.createAndConfigureLegend(chartDimensions);
    if (!this.isTest) {
      this.createAndConfigureChart(chartDimensions);
    } else {
      this.createMapContainer(chartDimensions);
      this.getContainer().selectAll(".".concat(MAP_CONTAINER)).style('background-color', '#9BD3DD');
    }
    if (postRender) {
      this.chart.lifeCycle.on('renderEnd', postRender);
    }
    return this;
  },
  setLegendPosition: function setLegendPosition(position) {
    this._prevLegendPosition = this._legendPosition;
    switch (position) {
      case LEGEND_LOCATIONS.BOTTOM:
      case LEGEND_LOCATIONS.INSIDE_BOTTOM:
        this._legendPosition = position;
        this._relativeLegendPosition = LEGEND_LOCATIONS.BOTTOM;
        break;
      case LEGEND_LOCATIONS.RIGHT:
      case LEGEND_LOCATIONS.INSIDE_RIGHT:
        this._legendPosition = position;
        this._relativeLegendPosition = LEGEND_LOCATIONS.RIGHT;
        break;
      default:
        console.warn("Not a valid legend position. ".concat(defaultFallbackWarning));
        this._legendPosition = LEGEND_LOCATIONS.INSIDE_BOTTOM;
        this._relativeLegendPosition = LEGEND_LOCATIONS.BOTTOM;
        break;
    }
    return this;
  },
  createMapView: function createMapView() {
    this.chart = this.chart || new MapViewViz();
  },
  getMap: function getMap() {
    return this.chart ? this.chart.getMap() : null;
  },
  createAndConfigureChart: function createAndConfigureChart(dimensions) {
    this.chart.width(dimensions.availableWidth).height(dimensions.availableHeight).enableTooltip(this._showTooltip, this.tooltip);
    if (this.accessToken) {
      this.chart.accessToken(this.accessToken);
    } else {
      console.warn('No access token provided. Will run map as test');
      this.isTest = true;
      this.render();
      return;
    }
    if (this.colorRanges) {
      this.chart.colorRanges(this.colorRanges);
    }
    if (this.mapZoom) {
      this.chart.mapZoom(this.mapZoom);
    }
    if (this.mapCenter) {
      this.chart.mapCenter(this.mapCenter);
    }
    if (this.defaultLocation) {
      this.chart.defaultLocation(this.defaultLocation);
    }
    if (this.opacity) {
      this.chart.opacity(this.opacity);
    }
    if (this.mainMetric) {
      this.chart.mainMetric(this.mainMetric);
    }
    if (this.mapStyle) {
      this.chart.mapStyle(this.mapStyle);
    }
    if (this.locationChangeHandler) {
      this.chart.locationChangeHandler(this.locationChangeHandler);
    }
    if (this.mapClickHandler) {
      this.chart.mapClickHandler(this.mapClickHandler);
    }
    if (this.mapDataType) {
      this.chart.mapDataType(this.mapDataType);
    }
    if (this.showHoverState) {
      this.chart.showHoverState(this.showHoverState);
    }
    this.createMapContainer(dimensions);
    this.getContainer().datum(this.data).call(this.chart.render);
  },
  createMapContainer: function createMapContainer(dimensions) {
    this.getContainer().selectAll(".".concat(MAP_CONTAINER)).style('height', "".concat(dimensions.availableHeight, "px")).style('width', "".concat(dimensions.availableWidth, "px")).style('display', this._legendPosition === constants_Constants.LEGEND_POSITIONS.RIGHT ? 'inline-block' : 'block');
  },
  createAndConfigureLegend: function createAndConfigureLegend(dimensions) {
    var legendContainer = this.getContainer().selectAll(".".concat(constants_LEGEND_CONTAINER)).style('display', '');
    var position = this._legendPosition;
    var isLegendOnSide = this._relativeLegendPosition === LEGEND_LOCATIONS.RIGHT;
    if (!this._shouldShowLegend || this._legendPosition === LEGEND_LOCATIONS.NONE) {
      legendContainer.classed('disabled', true);
      return;
    }
    this.legend = this.legend || upgradedDqLegend();
    var legendData = this.legendDataFormatter ? this.legendDataFormatter(this.colorRanges) : this.createLegendData();
    this.legend.clickDisabled(true).animationDuration(this._animationDuration).orientation(isLegendOnSide ? 'vertical' : 'horizontal').width(this._legendPosition === LEGEND_LOCATIONS.INSIDE_BOTTOM ? dimensions.availableWidth - 4 * LEGEND_INSIDE_PADDING : dimensions.availableWidth).height(dimensions.availableHeight).getKey(function (d) {
      return d.label;
    }).alignment(this._legendAlignment).position(this._relativeLegendPosition).maxKeyLength(30);
    legendContainer.classed('disabled', false).style('margin', getLegendMarginStyle(position, this._legendTitle)).style('width', this._legendPosition === LEGEND_LOCATIONS.INSIDE_BOTTOM ? "".concat(dimensions.availableWidth - 4 * LEGEND_INSIDE_PADDING, "px") : "".concat(dimensions.availableWidth)).style('height', "".concat(dimensions.availableHeight, "px")).datum(legendData).call(this.legend);
    var legendDimensions = {
      height: this.legend.height(),
      width: this.legend.width()
    };
    if (isLegendOnSide) {
      legendContainer.style('width', "".concat(legendDimensions.width, "px"));
    } else {
      legendContainer.style('height', "".concat(legendDimensions.height, "px"));
    }
    if (this._legendPosition === LEGEND_LOCATIONS.INSIDE_BOTTOM) {
      var yTranslate = -(legendDimensions.height + map_view_TOTAL_VERTICAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING + MAPBOX_LOGO_HEIGHT);
      var legendTranslate = "translate(".concat(LEGEND_INSIDE_PADDING, "px, ").concat(yTranslate, "px)");
      var calculatedWidth = map_view_TOTAL_HORIZONTAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING;
      var scaleRatio = dimensions.availableWidth / this.getContainer().node().getBoundingClientRect().width;
      legendContainer.select('.dq-legend').select('g').selectAll('.dq-legend-element').each(function () {
        calculatedWidth += d3.select(this).node().getBoundingClientRect().width * scaleRatio;
        calculatedWidth += map_view_LEGEND_PADDING;
      });
      calculatedWidth -= map_view_LEGEND_PADDING;
      legendContainer.style('position', 'relative').style('transform', legendTranslate);
      legendContainer.style('width', calculatedWidth > dimensions.availableWidth - map_view_TOTAL_HORIZONTAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING ? dimensions.availableWidth - map_view_TOTAL_HORIZONTAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING : calculatedWidth).style('height', legendDimensions.height + map_view_TOTAL_VERTICAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING).classed('legend-container-inside', true);
    } else if (this._legendPosition === LEGEND_LOCATIONS.INSIDE_RIGHT) {
      var _scaleRatio = dimensions.availableHeight / this.getContainer().node().getBoundingClientRect().height;
      var legendLineHeight = legendContainer.select('.dq-legend').node().getBoundingClientRect().height * _scaleRatio;
      var calculatedLegendHeight = legendData.length * (legendLineHeight + LEGEND_HEIGHT_SPACING) - LEGEND_HEIGHT_SPACING + map_view_TOTAL_VERTICAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING;
      var xTranslate = dimensions.availableWidth - legendDimensions.width - 3 * LEGEND_INSIDE_PADDING;
      var _yTranslate = -(calculatedLegendHeight + MAPBOX_LOGO_HEIGHT);
      var _legendTranslate = "translate(".concat(xTranslate, "px, ").concat(_yTranslate, "px)");
      legendContainer.select('.dq-legend').select('g').style('transform', 'translate(0)');
      legendContainer.classed('legend-container-inside', true).style('height', calculatedLegendHeight).style('width', legendDimensions.width + map_view_TOTAL_HORIZONTAL_PADDING_MULTIPLIER * LEGEND_INSIDE_PADDING).style('position', 'relative').style('transform', _legendTranslate);
    }
    updateAvailableDimensions(dimensions, position, legendDimensions, this._legendTitle);
  },
  createLegendData: function createLegendData() {
    var legendData = [];
    _.forEach(this.colorRanges.colorRanges, function (range) {
      legendData.push({
        color: range.color,
        label: range.label,
        legendShape: constants_Constants.LEGEND_SHAPES.SQUARE
      });
    });
    if (this.colorRanges.noData) {
      legendData.push({
        color: this.colorRanges.noData.color,
        label: this.colorRanges.noData.label,
        legendShape: constants_Constants.LEGEND_SHAPES.SQUARE
      });
    }
    return legendData;
  },
  resize: function resize() {
    if (this.chart) {
      UpgradedCore.prototype.resize.apply(this, arguments);
    }
  }
}, {
  Name: 'MapView',
  DataDimensions: '2'
});
function updateAvailableDimensions(dimensions, legendPosition, legendDimensions) {
  if (legendPosition === constants_Constants.LEGEND_POSITIONS.RIGHT) {
    dimensions.availableWidth -= legendDimensions.width + map_view_LEGEND_PADDING;
  } else if (legendPosition === constants_Constants.LEGEND_POSITIONS.BOTTOM) {
    dimensions.availableHeight -= legendDimensions.height + map_view_LEGEND_PADDING;
  }
}
function getLegendMarginStyle(position) {
  switch (position) {
    case constants_Constants.LEGEND_POSITIONS.BOTTOM:
      return "".concat(map_view_LEGEND_PADDING, "px 0 0 0");
    case constants_Constants.LEGEND_POSITIONS.RIGHT:
      return "0 0 0 ".concat(map_view_LEGEND_PADDING, "px");
    default:
      return 0;
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__(2586);
;// ./src/js/viz/config/core_base_chart_config.ts
function core_base_chart_config_typeof(o) { "@babel/helpers - typeof"; return core_base_chart_config_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, core_base_chart_config_typeof(o); }






function core_base_chart_config_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, core_base_chart_config_toPropertyKey(o.key), o); } }
function core_base_chart_config_createClass(e, r, t) { return r && core_base_chart_config_defineProperties(e.prototype, r), t && core_base_chart_config_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function core_base_chart_config_toPropertyKey(t) { var i = core_base_chart_config_toPrimitive(t, "string"); return "symbol" == core_base_chart_config_typeof(i) ? i : i + ""; }
function core_base_chart_config_toPrimitive(t, r) { if ("object" != core_base_chart_config_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != core_base_chart_config_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function core_base_chart_config_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = core_base_chart_config_getPrototypeOf(o), core_base_chart_config_possibleConstructorReturn(t, core_base_chart_config_isNativeReflectConstruct() ? Reflect.construct(o, e || [], core_base_chart_config_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function core_base_chart_config_possibleConstructorReturn(t, e) { if (e && ("object" == core_base_chart_config_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return core_base_chart_config_assertThisInitialized(t); }
function core_base_chart_config_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function core_base_chart_config_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (core_base_chart_config_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function core_base_chart_config_getPrototypeOf(t) { return core_base_chart_config_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, core_base_chart_config_getPrototypeOf(t); }
function core_base_chart_config_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && core_base_chart_config_setPrototypeOf(t, e); }
function core_base_chart_config_setPrototypeOf(t, e) { return core_base_chart_config_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, core_base_chart_config_setPrototypeOf(t, e); }




function withMarginConfig(Base) {
  return function (_Base) {
    function _class() {
      var _this;
      core_base_chart_config_classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class, [].concat(args));
      Object.assign(_this, MarginConfig);
      return _this;
    }
    core_base_chart_config_inherits(_class, _Base);
    return core_base_chart_config_createClass(_class);
  }(Base);
}
function withLegendConfig(Base) {
  return function (_Base2) {
    function _class2() {
      var _this2;
      core_base_chart_config_classCallCheck(this, _class2);
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this2 = _callSuper(this, _class2, [].concat(args));
      Object.assign(_this2, LegendConfig);
      return _this2;
    }
    core_base_chart_config_inherits(_class2, _Base2);
    return core_base_chart_config_createClass(_class2);
  }(Base);
}
function withDataConfig(Base) {
  return function (_Base3) {
    function _class3() {
      var _this3;
      core_base_chart_config_classCallCheck(this, _class3);
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      _this3 = _callSuper(this, _class3, [].concat(args));
      Object.assign(_this3, DataConfig);
      return _this3;
    }
    core_base_chart_config_inherits(_class3, _Base3);
    return core_base_chart_config_createClass(_class3);
  }(Base);
}
function withCoreConfig(Base) {
  return function (_Base4) {
    function _class4() {
      var _this4;
      core_base_chart_config_classCallCheck(this, _class4);
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      _this4 = _callSuper(this, _class4, [].concat(args));
      Object.assign(_this4, UpgradedCore.prototype);
      return _this4;
    }
    core_base_chart_config_inherits(_class4, _Base4);
    return core_base_chart_config_createClass(_class4);
  }(Base);
}
var CoreBaseChartConfig = [withMarginConfig, withLegendConfig, withDataConfig, withCoreConfig].reduce(function (acc, mixin) {
  return mixin(acc);
}, core_base_chart_config_createClass(function _class5() {
  core_base_chart_config_classCallCheck(this, _class5);
}));
;// ./src/js/viz/charts/star-rating/star-types.ts
var StarTypes = function (StarTypes) {
  StarTypes["FILLED"] = "filled";
  StarTypes["EMPTY"] = "empty";
  StarTypes["HALF"] = "half";
  return StarTypes;
}({});
var RatingAlignment = function (RatingAlignment) {
  RatingAlignment["LEFT"] = "left";
  RatingAlignment["RIGHT"] = "right";
  RatingAlignment["CENTER"] = "center";
  return RatingAlignment;
}({});
;// ./src/js/viz/charts/star-rating/constants.ts

var FILLED_STAR = 'M12 2C12.6059 2 13.1523 2.36452 13.385 2.92395L15.4137 7.80149L20.6794 8.22364C21.2833 8.27206 21.7989 8.67908 21.9861 9.25532C22.1733 9.83156 21.9955 10.4639 21.5353 10.858L17.5234 14.2947L18.7491 19.4331C18.8897 20.0225 18.6619 20.6385 18.1717 20.9947C17.6816 21.3508 17.0253 21.3771 16.5082 21.0613L12 18.3077L7.49182 21.0613C6.97474 21.3771 6.31844 21.3508 5.82826 20.9947C5.33808 20.6385 5.11029 20.0225 5.25087 19.4331L6.47658 14.2947L2.46466 10.858C2.00451 10.4639 1.82668 9.83156 2.01391 9.25532C2.20114 8.67908 2.71667 8.27206 3.32063 8.22364L8.58634 7.80149L10.615 2.92395C10.8477 2.36452 11.3941 2 12 2Z';
var HALF_STAR = 'M13.385 2.92395C13.1523 2.36452 12.6059 2 12 2C11.3941 2 10.8477 2.36452 10.615 2.92395L8.58634 7.80149L3.32063 8.22364C2.71667 8.27206 2.20114 8.67908 2.01391 9.25532C1.82668 9.83156 2.00451 10.4639 2.46466 10.858L6.47658 14.2947L5.25087 19.4331C5.11029 20.0225 5.33808 20.6385 5.82826 20.9947C6.31844 21.3508 6.97474 21.3771 7.49182 21.0613L12 18.3077L16.5082 21.0613C17.0253 21.3771 17.6816 21.3508 18.1717 20.9947C18.6619 20.6385 18.8897 20.0225 18.7491 19.4331L17.5234 14.2947L21.5353 10.858C21.9955 10.4639 22.1733 9.83156 21.9861 9.25532C21.7989 8.67908 21.2833 8.27206 20.6794 8.22364L15.4137 7.80149L13.385 2.92395ZM12 16.55L17.2901 19.7812L15.8518 13.7515L20.5595 9.71885L14.3805 9.22348L12 3.5V16.55Z';
var EMPTY_STAR = 'M12 2C12.6059 2 13.1523 2.36452 13.385 2.92395L15.4137 7.80149L20.6794 8.22364C21.2833 8.27206 21.7989 8.67908 21.9861 9.25532C22.1733 9.83156 21.9955 10.4639 21.5353 10.858L17.5234 14.2947L18.7491 19.4331C18.8897 20.0225 18.6619 20.6385 18.1717 20.9947C17.6816 21.3508 17.0253 21.3771 16.5082 21.0613L12 18.3077L7.49182 21.0613C6.97474 21.3771 6.31844 21.3508 5.82826 20.9947C5.33808 20.6385 5.11029 20.0225 5.25087 19.4331L6.47658 14.2947L2.46466 10.858C2.00451 10.4639 1.82668 9.83156 2.01391 9.25532C2.20114 8.67908 2.71667 8.27206 3.32063 8.22364L8.58634 7.80149L10.615 2.92395C10.8477 2.36452 11.3941 2 12 2ZM9.61947 9.22348L3.4405 9.71885L8.14822 13.7515L6.70994 19.7812L12 16.55L17.2901 19.7812L15.8518 13.7515L20.5595 9.71885L14.3805 9.22348L12 3.5L9.61947 9.22348Z';
var STAR_SIZE = 24;
var STAR_COLOR = '#006FD3';
var TEXT_COLOR = '#32363A';
var DEFAULT_STAR_CONFIG = {
  showBreakdown: false,
  starColor: STAR_COLOR,
  breakdownColor: STAR_COLOR,
  textColor: TEXT_COLOR,
  showCounts: false,
  showPercentages: false,
  showBreakdownBelowRating: false,
  showTotalResponseCount: true,
  ratingAlignment: RatingAlignment.CENTER,
  maxStarValue: 5
};
;// ./src/js/viz/charts/star-rating/star-rating-viz.ts












function star_rating_viz_typeof(o) { "@babel/helpers - typeof"; return star_rating_viz_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, star_rating_viz_typeof(o); }
function star_rating_viz_toConsumableArray(r) { return star_rating_viz_arrayWithoutHoles(r) || star_rating_viz_iterableToArray(r) || star_rating_viz_unsupportedIterableToArray(r) || star_rating_viz_nonIterableSpread(); }
function star_rating_viz_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function star_rating_viz_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return star_rating_viz_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? star_rating_viz_arrayLikeToArray(r, a) : void 0; } }
function star_rating_viz_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function star_rating_viz_arrayWithoutHoles(r) { if (Array.isArray(r)) return star_rating_viz_arrayLikeToArray(r); }
function star_rating_viz_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function star_rating_viz_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function star_rating_viz_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? star_rating_viz_ownKeys(Object(t), !0).forEach(function (r) { star_rating_viz_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : star_rating_viz_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function star_rating_viz_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function star_rating_viz_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, star_rating_viz_toPropertyKey(o.key), o); } }
function star_rating_viz_createClass(e, r, t) { return r && star_rating_viz_defineProperties(e.prototype, r), t && star_rating_viz_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function star_rating_viz_defineProperty(e, r, t) { return (r = star_rating_viz_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function star_rating_viz_toPropertyKey(t) { var i = star_rating_viz_toPrimitive(t, "string"); return "symbol" == star_rating_viz_typeof(i) ? i : i + ""; }
function star_rating_viz_toPrimitive(t, r) { if ("object" != star_rating_viz_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != star_rating_viz_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var BREAKDOWN_BAR_SPACE = 20;
var BREAKDOWN_BAR_HEIGHT = 4;
var BREAKDOWN_BAR_MARGIN = 15;
var GRAY_COLOR = '#dddddd';
var star_rating_viz_ANIMATION_DURATION = 250;
var STAR_TEXT_SIZE = 48;
var SMALL_TEXT_YTRANSLATE = 6;
var TEXT_HORIZONTAL_SPACING = 16;
var TEXT_HORIZONTAL_SPACING_SMALL = 8;
var TOP_MARGIN = 16;
var BREAKDOWN_SPACING_HORIZONTAL = 25;
var MIN_BREAKDOWN_BAR_LENGTH = 20;
var ROUNDING_OFFSET = 4;
var BREAKDOWN_SPACING_VERTICAL = 34;
var RESPONSE_COUNT_SPACING_VERTICAL = 48;
var StarRatingVisualization = function () {
  function StarRatingVisualization(configuration) {
    var _this = this;
    star_rating_viz_classCallCheck(this, StarRatingVisualization);
    star_rating_viz_defineProperty(this, "_configuration", void 0);
    star_rating_viz_defineProperty(this, "_renderLifeCycle", void 0);
    star_rating_viz_defineProperty(this, "_height", void 0);
    star_rating_viz_defineProperty(this, "_width", void 0);
    star_rating_viz_defineProperty(this, "render", function (selection) {
      _this._renderLifeCycle.start();
      selection.each(_this.renderSelection());
      _this._renderLifeCycle.dispatchOnCompletion();
    });
    if (configuration) {
      this._configuration = configuration;
    } else {
      this._configuration = star_rating_viz_objectSpread({}, DEFAULT_STAR_CONFIG);
    }
    this._renderLifeCycle = new RenderLifeCycle();
  }
  return star_rating_viz_createClass(StarRatingVisualization, [{
    key: "configuration",
    get: function get() {
      return this._configuration;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(width) {
      this._width = width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(height) {
      this._height = height;
    }
  }, {
    key: "renderSelection",
    value: function renderSelection() {
      var configuration = this._configuration;
      var height = this._height;
      var width = this._width;
      return function (data) {
        var container = src_select(this);
        var starContainer = utils_createElementIfAbsent(container, 'star-rating-parent');
        var ratingContainer = renderRating(starContainer, data, height, width, configuration);
        var breakdownContainer;
        var ratingContainerDimensions = ratingContainer.node().getBBox();
        var ratingContainerXTranslate = calculateRatingContainerXTranslate(ratingContainerDimensions.width, configuration.ratingAlignment, width);
        var ratingContainerVerticalOffset = 0;
        var _calculateBreakdownBa = calculateBreakdownBarDimensions(height, width, ratingContainerDimensions.height, ratingContainerDimensions.width, !configuration.showBreakdownBelowRating),
          availableHeight = _calculateBreakdownBa.availableHeight,
          availableWidth = _calculateBreakdownBa.availableWidth;
        if (configuration.showBreakdown) {
          breakdownContainer = renderBreakdownBars(starContainer, data, availableHeight, availableWidth, configuration);
          var breakdownContainerDimensions = breakdownContainer.node().getBBox();
          var breakdownXTranslate = calculateBreakdownContainerXTranslate(ratingContainerDimensions.width, configuration.ratingAlignment, configuration.showBreakdownBelowRating);
          var breakdownYTranslate = calculateBreakdownContainerYTranslate(ratingContainerDimensions.height, !configuration.showBreakdownBelowRating);
          var breakdownContainerVerticalOffset = 0;
          if (!configuration.showBreakdownBelowRating) {
            if (ratingContainerDimensions.height > breakdownContainerDimensions.height) {
              breakdownContainerVerticalOffset = (ratingContainerDimensions.height - breakdownContainerDimensions.height) / 2;
            } else {
              ratingContainerVerticalOffset = (breakdownContainerDimensions.height - ratingContainerDimensions.height) / 2;
            }
          }
          breakdownContainer.attr('transform', "translate(".concat(breakdownXTranslate, ", ").concat(breakdownYTranslate + breakdownContainerVerticalOffset, ")"));
        }
        ratingContainer.attr('transform', "translate(".concat(ratingContainerXTranslate, ", ").concat(STAR_TEXT_SIZE + ratingContainerVerticalOffset + TOP_MARGIN, ")"));
        var parentContainerDimensions = starContainer.node().getBBox();
        starContainer.attr('transform', "translate(0, ".concat((height - parentContainerDimensions.height) / 2, ")"));
      };
    }
  }]);
}();
function calculateRatingContainerXTranslate(ratingContainerWidth, alignment, containerWidth) {
  switch (alignment) {
    case RatingAlignment.LEFT:
      return 0;
    case RatingAlignment.CENTER:
      return containerWidth / 2 - ratingContainerWidth / 2 - ROUNDING_OFFSET;
    case RatingAlignment.RIGHT:
      return containerWidth - ratingContainerWidth - ROUNDING_OFFSET;
    default:
      return 0;
  }
}
function calculateBreakdownContainerYTranslate(ratingContainerHeight, showInline) {
  if (showInline) {
    return BREAKDOWN_SPACING_VERTICAL;
  }
  return ratingContainerHeight + BREAKDOWN_SPACING_VERTICAL;
}
function calculateBreakdownContainerXTranslate(ratingContainerWidth, alignment, showBreakdownBelowRating) {
  if (showBreakdownBelowRating) {
    return 0;
  }
  switch (alignment) {
    case RatingAlignment.LEFT:
      return ratingContainerWidth + BREAKDOWN_SPACING_HORIZONTAL;
    case RatingAlignment.RIGHT:
      return 0;
    case RatingAlignment.CENTER:
    default:
      return 0;
  }
}
function calculateBreakdownBarDimensions(containerHeight, containerWidth, ratingHeight, ratingWidth, showInline) {
  var availableHeight = 0;
  var availableWidth = 0;
  if (showInline) {
    availableHeight = containerHeight;
    availableWidth = containerWidth - ratingWidth - BREAKDOWN_SPACING_HORIZONTAL;
  } else {
    availableWidth = containerWidth;
    availableHeight = containerHeight - ratingHeight - BREAKDOWN_SPACING_VERTICAL;
  }
  return {
    availableHeight: availableHeight,
    availableWidth: availableWidth
  };
}
function renderRating(container, data, height, width, configuration) {
  var starShapeData = getStarShapes(data.rating, configuration.maxStarValue);
  var ratingContainer = container.append('g').classed('star-rating-container', true);
  var rating = ratingContainer.append('g').classed('rating-value', true).append('text').text(data.rating).attr('fill', configuration.textColor).style('font-size', "".concat(STAR_TEXT_SIZE, "px"));
  var starContainer = ratingContainer.append('g').classed('star-container', true).attr('width', "".concat(width, "px")).attr('height', STAR_SIZE);
  var starWrap = starContainer.selectAll('svg.star').data(starShapeData);
  starWrap.enter().append('g').attr('class', 'star').attr('height', STAR_SIZE).attr('width', STAR_SIZE).attr('transform', function (d, i) {
    return "translate(".concat(i * STAR_SIZE, ", ").concat(STAR_SIZE, ")");
  }).append('path').attr('fill-rule', 'evenodd').attr('clip-rule', 'evenodd').attr('fill', configuration.starColor).attr('d', function (d) {
    return getStarPath(d);
  });
  var ratingContainerContentWidth = ratingContainer.node().getBBox().width;
  if (configuration.showTotalResponseCount) {
    var responseCountContainer = ratingContainer.append('g').attr('class', 'total-responses').append('text').text(getTotalResponseLabel(data.responseCount)).style('font-size', '14px');
    var responseCountContainerWidth = responseCountContainer.node().getBBox().width;
    responseCountContainer.attr('transform', "translate(".concat((ratingContainerContentWidth - responseCountContainerWidth) / 2, ", ").concat(STAR_SIZE + RESPONSE_COUNT_SPACING_VERTICAL, ")"));
  }
  var ratingLabelWidth = rating.node().getBBox().width;
  rating.attr('transform', "translate(".concat((ratingContainerContentWidth - ratingLabelWidth) / 2, ", 0)"));
  var starContainerWidth = starContainer.node().getBBox().width;
  starContainer.attr('transform', "translate(".concat((ratingContainerContentWidth - starContainerWidth) / 2, ", 0)"));
  return ratingContainer;
}
function renderBreakdownBars(container, data, height, width, configuration) {
  var breakdownBarsContainer = container.append('g').classed('breakdown-bars-container', true);
  var processedData = processStarData(data.stars, data.responseCount);
  var breakdownBarsEnter = breakdownBarsContainer.selectAll('.breakdown-bar').data(processedData).enter().append('g').attr('transform', function (d, i) {
    return "translate(0, ".concat(i * BREAKDOWN_BAR_SPACE, ")");
  });
  breakdownBarsEnter.append('g').attr('class', 'breakdown-bar-star-label').append('text').text(function (d) {
    return "".concat(d.value, " stars");
  });
  var maxStarWidth = getMaxWidthFromSelection(breakdownBarsContainer.selectAll('.breakdown-bar-star-label')) + TEXT_HORIZONTAL_SPACING;
  var maxLabelWidth = 0;
  var maxPercentWidth = 0;
  if (configuration.showCounts) {
    breakdownBarsEnter.append('g').attr('class', 'breakdown-bar-response-count').append('text').text(function (d) {
      return getResponseCountLabel(d, configuration.showCounts && configuration.showPercentages);
    });
    maxLabelWidth = getMaxWidthFromSelection(breakdownBarsContainer.selectAll('.breakdown-bar-response-count'));
  }
  if (configuration.showPercentages) {
    breakdownBarsEnter.append('g').attr('class', 'breakdown-bar-percent').append('text').text(function (d) {
      return getPercentLabel(d);
    });
    maxPercentWidth = getMaxWidthFromSelection(breakdownBarsContainer.selectAll('.breakdown-bar-percent')) + TEXT_HORIZONTAL_SPACING_SMALL;
  }
  var breakdownBarAvailableWidth = width - 2 * BREAKDOWN_BAR_MARGIN - maxLabelWidth - maxStarWidth - maxPercentWidth;
  var showBreakdownBars = breakdownBarAvailableWidth > MIN_BREAKDOWN_BAR_LENGTH;
  var hideLabels = !showBreakdownBars;
  if (!showBreakdownBars) {
    if (breakdownBarAvailableWidth + maxLabelWidth + maxPercentWidth > MIN_BREAKDOWN_BAR_LENGTH) {
      breakdownBarAvailableWidth = width - 2 * BREAKDOWN_BAR_MARGIN - maxStarWidth;
      showBreakdownBars = true;
    } else {
      breakdownBarAvailableWidth = 0;
      showBreakdownBars = false;
    }
  }
  breakdownBarsEnter.append('rect').attr('width', breakdownBarAvailableWidth).attr('height', BREAKDOWN_BAR_HEIGHT).attr('rx', 2).attr('fill', GRAY_COLOR).attr('transform', "translate(".concat(maxStarWidth, ", 0)"));
  breakdownBarsEnter.append('rect').attr('height', BREAKDOWN_BAR_HEIGHT).attr('rx', 2).attr('fill', configuration.breakdownColor).attr('transform', "translate(".concat(maxStarWidth, ", 0)")).transition().duration(star_rating_viz_ANIMATION_DURATION).attr('width', function (d) {
    return breakdownBarAvailableWidth * d.percent;
  });
  breakdownBarsEnter.selectAll('.breakdown-bar-star-label').attr('transform', "translate(0, ".concat(SMALL_TEXT_YTRANSLATE, ")"));
  if (hideLabels) {
    breakdownBarsEnter.selectAll('.breakdown-bar-response-count').attr('style', 'display: none');
    breakdownBarsEnter.selectAll('.breakdown-bar-percent').attr('style', 'display: none');
  }
  if (breakdownBarAvailableWidth === 0) {
    breakdownBarsEnter.selectAll('.breakdown-bar-star-label').attr('style', 'display: none');
  }
  breakdownBarsEnter.selectAll('.breakdown-bar-response-count').attr('transform', "translate(".concat(maxStarWidth + breakdownBarAvailableWidth + maxPercentWidth + TEXT_HORIZONTAL_SPACING, ", ").concat(SMALL_TEXT_YTRANSLATE, ")"));
  breakdownBarsEnter.selectAll('.breakdown-bar-percent').attr('transform', "translate(".concat(maxStarWidth + breakdownBarAvailableWidth + TEXT_HORIZONTAL_SPACING, ", ").concat(SMALL_TEXT_YTRANSLATE, ")"));
  return breakdownBarsContainer;
}
function getTotalResponseLabel(responseCount) {
  return "".concat(responseCount, " Responses");
}
function getResponseCountLabel(data, includeBrackets) {
  if (includeBrackets) {
    return "(".concat(data.responseCount, ")");
  }
  return "".concat(data.responseCount);
}
function getPercentLabel(data) {
  var _data$percentString;
  return (_data$percentString = data.percentString) !== null && _data$percentString !== void 0 ? _data$percentString : "".concat((data.percent * 100).toFixed(2), "%");
}
function getMaxWidthFromSelection(selection) {
  var maxWidth = 0;
  selection && selection.each(function () {
    var width = this.getBBox().width;
    if (width > maxWidth) {
      maxWidth = width;
    }
  });
  return maxWidth;
}
function getStarShapes(rating, numStars) {
  var starCount = numStars;
  var ratingNumerical = parseFloat(rating);
  if (ratingNumerical > numStars) {
    var difference = Math.ceil(ratingNumerical - numStars);
    starCount = numStars + difference;
  }
  var includeHalfStar = ratingNumerical % 1 >= 0.5;
  var fullStars = Math.floor(ratingNumerical);
  var emptyStars = starCount - fullStars - (includeHalfStar ? 1 : 0);
  var stars = [];
  stars.push.apply(stars, star_rating_viz_toConsumableArray(Array(fullStars).fill(StarTypes.FILLED)));
  if (includeHalfStar) {
    stars.push(StarTypes.HALF);
  }
  stars.push.apply(stars, star_rating_viz_toConsumableArray(Array(emptyStars).fill(StarTypes.EMPTY)));
  return stars;
}
function processStarData(data, totalResponses) {
  var processedData = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().map(data, function (star) {
    var percent = star.responseCount / totalResponses;
    return {
      value: star.value,
      percent: percent,
      percentString: star.percent,
      responseCount: star.responseCount
    };
  });
  return external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().sortBy(processedData, 'value').reverse();
}
function getStarPath(starType) {
  switch (starType) {
    case StarTypes.FILLED:
      return FILLED_STAR;
    case StarTypes.HALF:
      return HALF_STAR;
    case StarTypes.EMPTY:
      return EMPTY_STAR;
    default:
      return '';
  }
}
;// ./src/js/viz/charts/star-rating/star-rating.ts









function star_rating_typeof(o) { "@babel/helpers - typeof"; return star_rating_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, star_rating_typeof(o); }
function star_rating_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function star_rating_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? star_rating_ownKeys(Object(t), !0).forEach(function (r) { star_rating_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : star_rating_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function star_rating_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function star_rating_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, star_rating_toPropertyKey(o.key), o); } }
function star_rating_createClass(e, r, t) { return r && star_rating_defineProperties(e.prototype, r), t && star_rating_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function star_rating_callSuper(t, o, e) { return o = star_rating_getPrototypeOf(o), star_rating_possibleConstructorReturn(t, star_rating_isNativeReflectConstruct() ? Reflect.construct(o, e || [], star_rating_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function star_rating_possibleConstructorReturn(t, e) { if (e && ("object" == star_rating_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return star_rating_assertThisInitialized(t); }
function star_rating_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function star_rating_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (star_rating_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function star_rating_getPrototypeOf(t) { return star_rating_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, star_rating_getPrototypeOf(t); }
function star_rating_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && star_rating_setPrototypeOf(t, e); }
function star_rating_setPrototypeOf(t, e) { return star_rating_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, star_rating_setPrototypeOf(t, e); }
function star_rating_defineProperty(e, r, t) { return (r = star_rating_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function star_rating_toPropertyKey(t) { var i = star_rating_toPrimitive(t, "string"); return "symbol" == star_rating_typeof(i) ? i : i + ""; }
function star_rating_toPrimitive(t, r) { if ("object" != star_rating_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != star_rating_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var StarRating = function (_CoreBaseChartConfig) {
  function StarRating(args) {
    var _this;
    star_rating_classCallCheck(this, StarRating);
    _this = star_rating_callSuper(this, StarRating);
    star_rating_defineProperty(_this, "_chart", void 0);
    star_rating_defineProperty(_this, "_containerId", void 0);
    star_rating_defineProperty(_this, "_configuration", void 0);
    _this._containerId = args.containerId;
    UpgradedCore.call(_this, args);
    _this._configuration = star_rating_objectSpread({}, DEFAULT_STAR_CONFIG);
    return _this;
  }
  star_rating_inherits(StarRating, _CoreBaseChartConfig);
  return star_rating_createClass(StarRating, [{
    key: "configuration",
    get: function get() {
      return this._configuration;
    }
  }, {
    key: "render",
    value: function render() {
      var container = this.getContainer();
      if (container) {
        container.html('');
      }
      this._chart = new StarRatingVisualization(this._configuration);
      this.createChartContainer();
      this.getContainer().datum(this.data).call(this._chart.render);
    }
  }, {
    key: "createChartContainer",
    value: function createChartContainer() {
      if (!this.hasContainer()) {
        this._containerId = this._containerId || external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().uniqueId('DqChart');
      }
      this._chart.height = this.getChartContainerHeight();
      this._chart.width = this.getChartContainerWidth();
    }
  }, {
    key: "showTotalResponseCount",
    value: function showTotalResponseCount(_showTotalResponseCount) {
      this._configuration.showTotalResponseCount = _showTotalResponseCount;
      return this;
    }
  }, {
    key: "showCounts",
    value: function showCounts(_showCounts) {
      this._configuration.showCounts = _showCounts;
      return this;
    }
  }, {
    key: "showPercentages",
    value: function showPercentages(_showPercentages) {
      this._configuration.showPercentages = _showPercentages;
      return this;
    }
  }, {
    key: "showBreakdownBelowRating",
    value: function showBreakdownBelowRating(_showBreakdownBelowRating) {
      this._configuration.showBreakdownBelowRating = _showBreakdownBelowRating;
      return this;
    }
  }, {
    key: "ratingAlignment",
    value: function ratingAlignment(alignment) {
      this._configuration.ratingAlignment = alignment;
      return this;
    }
  }, {
    key: "showBreakdown",
    value: function showBreakdown(_showBreakdown) {
      this._configuration.showBreakdown = _showBreakdown;
      return this;
    }
  }, {
    key: "starColor",
    value: function starColor(color) {
      this._configuration.starColor = color;
      return this;
    }
  }, {
    key: "maxStarValue",
    value: function maxStarValue(_maxStarValue) {
      this._configuration.maxStarValue = _maxStarValue;
      return this;
    }
  }, {
    key: "breakdownColor",
    value: function breakdownColor(color) {
      this._configuration.breakdownColor = color;
      return this;
    }
  }, {
    key: "textColor",
    value: function textColor(color) {
      this._configuration.textColor = color;
      return this;
    }
  }, {
    key: "setConfiguration",
    value: function setConfiguration(configuration) {
      this._configuration = external_commonjs_lodash_commonjs2_lodash_amd_lodash_root_default().merge(this._configuration, configuration);
      return this;
    }
  }]);
}(CoreBaseChartConfig);
;// ./src/js/viz/d3/index.js













;// ./src/js/config.js





var Chart = {
  PieChart: PieChart,
  ScatterPlot: ScatterPlot,
  QuadrantChart: QuadrantChart,
  BarChart: BarChart,
  HorizontalBarChart: HorizontalBarChart,
  LineChart: LineChart,
  AreaChart: AreaChart,
  GaugeChart: GaugeChart,
  DynamicGaugeChart: DynamicGaugeChart,
  NumberChart: NumberChart,
  RoundChart: RoundChart,
  BreakdownBarChart: BreakdownBarChart,
  BreakoutChart: BreakoutChart,
  MultiChart: MultiChart,
  FunnelChart: FunnelChart,
  BoxPlotChart: BoxPlot,
  RadarChart: RadarChart,
  WordCloud: WordCloud,
  MapView: MapView,
  StarRating: StarRating
};
var Maps = {
  UsaMap: UsaMap,
  WorldMap: WorldMap
};
var config_tooltip = {
  DarkDialog: darkDialog
};
var ColorScheme = {
  generator: baseColorScheme,
  colors: base_color_scheme_colors
};
var Settings = {
  setLocale: setLocale
};
;// ./package.json
var package_namespaceObject = {"rE":"19.1.7"};
;// ./src/js/index.ts


}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=dq.js.map